import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { App } from './app';
import { placement } from './ads/placements';
import { getInterstitialAdAsync, getRewardedVideoAsync } from './ads/ads';
import { updateAsync, shareAsync } from './social/social';
import { Store } from "./store/Store";
import { getEnv } from "./envs";

var entryPointData = null;
var fbv = 0;
var FTUEEVENTS = [];
var app;

// export function startGame() {
//   initGame();
//   window.eventTrack('DEBUG_Complete_1');

// }

// window.onload = function () {
//   startGame();
// };
var game = new Phaser.Game(1920, 1080, Phaser.CANVAS); //new Phaser.Game(screen.CANVAS_WIDTH, screen.CANVAS_HEIGHT, Phaser.CANVAS);
window.game = game;

game.setUserDataAndLog = async function (d) {
  if ((FTUE < 151 && all_level[5] > 0) || FTUE >= 151 || FTUE == 35 || dreset == 1 || saveon == 1) {
    await app.store.setData(d);
    saveon = 0;
  }
};

window.eventTrack = function (eventName, n, param) {
  var e = 0;
  if (FTUEEVENTS.indexOf(eventName) == -1 && eventName.includes('FTUE') && xmas == 0) {
    FTUEEVENTS.push(eventName);
    dreset = 1;
    game.setUserDataAndLog({ FTUEEVENTS: JSON.stringify(FTUEEVENTS) });
    dreset = 0;
    console.log('eventTrack:', eventName, n, param);
  } else if (!eventName.includes('FTUE')) {
    console.log('eventTrack:', eventName, n, param);
  }
};

game.setCurrentEvent = function () {
  if (xmas == 1) {
    current_event = 'xmas';
  } else if (baloon == 1) {
    current_event = 'balloon';
  } else if (sunflowerDate != 0) {
    current_event = 'sunflower';
  } else if (magicbeanDate != 0) {
    current_event = 'magicbean';
  } else {
    current_event = 0;
  }
}

var saveon = 0;

game.saveDataAll = function () {
  console.log('FTUE', FTUE, all_level[5], dreset, is_map);
  if (is_map == 0) { saveon = 1; }
  game.setUserDataAndLog({
    free_prebooster1: free_prebooster1,
    free_prebooster2: free_prebooster2,
    free_prebooster3: free_prebooster3,
    weekday_offers: weekday_offers,
    JQKA_offers: JQKA_offers,
    mis_n: mis_n,
    mis_coins: mis_coins,
    misDate: String(misDate),
    playadDate: String(playadDate),
    playad_col: playad_col,
    xmas_level: xmas_level,
    xmas_ticket: xmas_ticket,
    retriesIteration: retriesIteration,
    offer_mas: JSON.stringify(offer_mas),
    OfferDate: String(OfferDate),
    lifetime: String(lifetime),
    fff: fff,
    friend_invite: friend_invite,
    complete_task_i: complete_task_i,
    shop_free: shop_free,
    FTUE: FTUE,
    FTUEEVENTS: JSON.stringify(FTUEEVENTS),
    first_start: first_start,
    free_cardback: free_cardback,
    free_five: free_five,
    free_joker: free_joker,
    free_booster_spec: free_booster_spec,
    free_three: free_three,
    booster_tnt_col: booster_tnt_col,
    booster_eye_col: booster_eye_col,
    booster_shuffle_col: booster_shuffle_col,
    booster_timestop_col: booster_timestop_col,
    mission_number: JSON.stringify(mission_number),
    mission_task: JSON.stringify(mission_task),
    mission_stars_end: mission_stars_end,
    mission_day_end: mission_day_end,
    day_prize: JSON.stringify(day_prize),
    map_tiled_st: JSON.stringify(map_tiled_st),
    dialog_mas: JSON.stringify(dialog_mas),
    dailyday_prize: JSON.stringify(dailyday_prize),
    dailyday: dailyday,
    dailyday_new: String(dailyday_new),
    dailyday_current: dailyday_current,
    special_object: JSON.stringify(special_object),
    all_friends_invite: JSON.stringify(all_friends_invite),
    friends_invite: JSON.stringify(friends_invite),
    level_star: JSON.stringify(all_level),
    currencies: coins,
    keys: keys,
    lifes: String(lifes),
    life_time: String(LifeDate),
    unlimited_lifesDate: String(unlimited_lifesDate),
    unlimited_lifesDate_old: unlimited_lifesDate_old,
    FriendPrizeDate: String(FriendPrizeDate),
    ReferralDate: ReferralDate,
    shop_time: String(ShopDate),
    key_mission_time: String(KeyMissionDate),
    KeyMissionPrize: KeyMissionPrize,
    gift_mas: JSON.stringify(gift_mas),
    GiftDate: String(GiftDate),
    baloonDate: String(baloonDate),
    baloonDate_new: String(baloonDate_new),
    sunflowerDate: String(sunflowerDate),
    xmasDate: String(xmasDate),
    sunflowerDate_new: String(sunflowerDate_new),
    sunflowerStage: sunflowerStage,
    numFriendsInvited: numFriendsInvited,
    magicbeanStage: magicbeanStage,
    magicbeanDate: String(magicbeanDate),
    magicbeanDate_new: String(magicbeanDate_new),
    backcards: JSON.stringify(backcards),
    backcards_select: backcards_select,
    all_chests: JSON.stringify(all_chests),
    map_n: map_n,
    wheel_num: wheel_num,
    wheel_ads: wheel_ads,
    baloonlevel: baloonlevel,
    wheel_max: wheel_max,
    wheel_time: String(WheelDate),
    wheelshopDate: String(wheelshopDate),
    wheeladsDate: String(wheeladsDate),
    missions: JSON.stringify(missions),
    new_options: JSON.stringify(new_options),
    message_id: JSON.stringify(message_id),
    suitcase_add: suitcase_add,
    all_stars: all_stars,
    last_position: JSON.stringify(last_position),
    first_helper: first_helper,
    botopt: botopt,
    weekday_offersDate: weekday_offersDate,
  });
};

var userData = 0;
game.fetchAndLogUserData = async function () {
  window.Store = Store;

  await app.store.init();
  var json = app.store.restoreJson('data');
  if (json == 0) return; // can't restore since no data available to restore

  /* RESTORE VALUES */
  mis_n = Store.LoadValue(json['mis_n'], 0);
  //mis_n = fbv == 1 ? restoreData(userData.mis_n, 0, 0) : restoreValue('mis_n', 0);

  mis_coins = Store.LoadValue(json['mis_coins'], 0);
  //mis_coins = fbv == 1 ? restoreData(userData.mis_coins, 0, 0) : restoreValue('mis_coins', 0);

  xmas_level = Store.LoadValue(json['xmas_level'], 0);
  //xmas_level = fbv == 1 ? restoreData(userData.xmas_level, 0, 0) : restoreValue('xmas_level', 0);

  xmas_ticket = Store.LoadValue(json['xmas_ticket'], 15);
  //xmas_ticket = fbv == 1 ? restoreData(userData.xmas_ticket, 0, 15) : restoreValue('xmas_ticket', 15);

  retriesIteration = Store.LoadValue(json['retriesIteration'], 0);
  //retriesIteration = fbv == 1 ? restoreData(userData.retriesIteration, 0, 0) : restoreValue('retriesIteration', 0);

  fff = Store.LoadValue(json['fff'], 0);
  //fff = fbv == 1 ? restoreData(userData.fff, 0, 0) : restoreValue('fff', 0);

  shop_free = Store.LoadValue(json['shop_free'], 1);
  //shop_free = fbv == 1 ? restoreData(userData.shop_free, 0, 1) : restoreValue('shop_free', 1);

  wheel_max = Store.LoadValue(json['wheel_max'], 3);
  //wheel_max = fbv == 1 ? restoreData(userData.wheel_max, 0, 3) : restoreValue('wheel_max', 3);

  wheel_num = Store.LoadValue(json['wheel_num'], 1);
  //wheel_num = fbv == 1 ? restoreData(userData.wheel_num, 0, 1) : restoreValue('wheel_num', 1);

  wheel_ads = Store.LoadValue(json['wheel_ads'], 0);
  //wheel_ads = fbv == 1 ? restoreData(userData.wheel_ads, 0, 0) : restoreValue('wheel_ads', 0);

  coins = Store.LoadValue(json['currencies'], 1000);
  //coins = fbv == 1 ? restoreData(userData.currencies, 0, 1000) : restoreValue('currencies', 1000);

  baloonlevel = Store.LoadValue(json['baloonlevel'], 1);
  //baloonlevel = fbv == 1 ? restoreData(userData.baloonlevel, 0, 1) : restoreValue('baloonlevel', 1);

  dailyday = Store.LoadValue(json['dailyday'], 0);
  //dailyday = fbv == 1 ? restoreData(userData.dailyday, 0, 0) : restoreValue('dailyday', 0);

  dailyday_new = Store.LoadValue(json['dailyday_new'], 0);
  //dailyday_new = fbv == 1 ? restoreData(userData.dailyday_new, 0, 0) : restoreValue('dailyday_new', 0);

  dailyday_current = Store.LoadValue(json['dailyday_current'], 0);
  //dailyday_current = fbv == 1 ? restoreData(userData.dailyday_current, 0, 0) : restoreValue('dailyday_current', 0);

  friend_invite = Store.LoadValue(json['friend_invite'], 0);
  //friend_invite = fbv == 1 ? restoreData(userData.friend_invite, 0, 0) : restoreValue('friend_invite', 0);

  playad_col = Store.LoadValue(json['playad_col'], 0);
  //playad_col = fbv == 1 ? restoreData(userData.playad_col, 0, 0) : restoreValue('playad_col', 0);

  all_stars = Store.LoadValue(json['all_stars'], 0);
  //all_stars = fbv == 1 ? restoreData(userData.all_stars, 0, 0) : restoreValue('all_stars', 0);

  sunflowerStage = Store.LoadValue(json['sunflowerStage'], 0);
  //sunflowerStage = fbv == 1 ? restoreData(userData.sunflowerStage, 0, 0) : restoreValue('sunflowerStage', 0);

  magicbeanStage = Store.LoadValue(json['magicbeanStage'], 0);
  //magicbeanStage = fbv == 1 ? restoreData(userData.magicbeanStage, 0, 0) : restoreValue('magicbeanStage', 0);

  numFriendsInvited = Store.LoadValue(json['numFriendsInvited'], 0);
  //numFriendsInvited = fbv == 1 ? restoreData(userData.numFriendsInvited, 0, 0) : restoreValue('numFriendsInvited', 0);

  mission_day_end = Store.LoadValue(json['mission_day_end'], 0);
  //mission_day_end = fbv == 1 ? restoreData(userData.mission_day_end, 0, 0) : restoreValue('mission_day_end', 0);

  mission_stars_end = Store.LoadValue(json['mission_stars_end'], 0);
  //mission_stars_end = fbv == 1 ? restoreData(userData.mission_stars_end, 0, 0) : restoreValue('mission_stars_end', 0);

  free_joker = Store.LoadValue(json['free_joker'], 3);
  //free_joker = fbv == 1 ? restoreData(userData.free_joker, 0, 3) : restoreValue('free_joker', 3);

  free_five = Store.LoadValue(json['free_five'], -1);
  //free_five = fbv == 1 ? restoreData(userData.free_five, 0, -1) : restoreValue('free_five', -1);

  free_booster_spec = Store.LoadValue(json['free_booster_spec'], -4);
  //free_booster_spec = fbv == 1 ? restoreData(userData.free_booster_spec, 0, -4) : restoreValue('free_booster_spec', -4);

  free_cardback = Store.LoadValue(json['free_cardback'], 0);
  //free_cardback = fbv == 1 ? restoreData(userData.free_cardback, 0, 0) : restoreValue('free_cardback', 0);

  free_prebooster1 = Store.LoadValue(json['free_prebooster1'], -9999);
  //free_prebooster1 = fbv == 1 ? restoreData(userData.free_prebooster1, 0, -9999) : restoreValue('free_prebooster1', -9999);

  free_prebooster2 = Store.LoadValue(json['free_prebooster2'], -9999);
  //free_prebooster2 = fbv == 1 ? restoreData(userData.free_prebooster2, 0, -9999) : restoreValue('free_prebooster2', -9999);

  free_prebooster3 = Store.LoadValue(json['free_prebooster3'], -9999);
  //free_prebooster3 = fbv == 1 ? restoreData(userData.free_prebooster3, 0, -9999) : restoreValue('free_prebooster3', -9999);

  booster_tnt_col = Store.LoadValue(json['booster_tnt_col'], 0);
  //booster_tnt_col = fbv == 1 ? restoreData(userData.booster_tnt_col, 0, 0) : restoreValue('booster_tnt_col', 0);

  booster_eye_col = Store.LoadValue(json['booster_eye_col'], 0);
  //booster_eye_col = fbv == 1 ? restoreData(userData.booster_eye_col, 0, 0) : restoreValue('booster_eye_col', 0);

  booster_shuffle_col = Store.LoadValue(json['booster_shuffle_col'], 0);
  //booster_shuffle_col = fbv == 1 ? restoreData(userData.booster_shuffle_col, 0, 0) : restoreValue('booster_shuffle_col', 0);

  suitcase_add = Store.LoadValue(json['suitcase_add'], 0);
  //suitcase_add = fbv == 1 ? restoreData(userData.suitcase_add, 0, 0) : restoreValue('suitcase_add', 0);

  keys = Number(Store.LoadValue(json['keys'], 0));
  //keys = fbv == 1 ? restoreData(userData.keys, 0, 0) : restoreValue('keys', 0);

  backcards_select = Store.LoadValue(json['backcards_select'], 'backcard_1.png');
  // backcards_select =
  //   fbv == 1
  //     ? restoreData(userData.backcards_select, 3, 'backcard_1.png')
  //     : restoreValue('backcards_select', 'backcard_1.png');

  KeyMissionPrize = Store.LoadValue(json['KeyMissionPrize'], 0);
  //KeyMissionPrize = fbv == 1 ? restoreData(userData.KeyMissionPrize, 0, 0) : restoreValue('KeyMissionPrize', 0);

  lifes = Number(Store.LoadValue(json['lifes'], 5));
  //lifes = fbv == 1 ? restoreData(userData.lifes, 0, 5) : restoreValue('lifes', 5);

  map_n = Store.LoadValue(json['map_n'], 1);
  //map_n = fbv == 1 ? restoreData(userData.map_n, 0, 1) : restoreValue('map_n', 1);

  first_start = Store.LoadValue(json['first_start'], 1);
  //first_start = fbv == 1 ? restoreData(userData.first_start, 0, 1) : restoreValue('first_start', 1);

  weekday_offers = Store.LoadValue(json['weekday_offers'], -1);
  //weekday_offers = fbv == 1 ? restoreData(userData.weekday_offers, 0, -1) : restoreValue('weekday_offers', -1);

  JQKA_offers = Store.LoadValue(json['JQKA_offers'], 0);
  //JQKA_offers = fbv == 1 ? restoreData(userData.JQKA_offers, 0, 0) : restoreValue('JQKA_offers', 0);

  FTUE = Store.LoadValue(json['FTUE'], 0);
  //FTUE = fbv == 1 ? restoreData(userData.FTUE, 0, 0) : restoreValue('FTUE', 0);

  shortcut = Store.LoadValue(json['shortcut'], 0);
  //shortcut = fbv == 1 ? restoreData(userData.shortcut, 0, 0) : restoreValue('shortcut', 0);

  music_on = Store.LoadValue(json['music_on'], 1);
  //music_on = fbv == 1 ? restoreData(userData.music_on, 0, 1) : restoreValue('music_on', 1);

  sound_on = Store.LoadValue(json['sound_on'], 1);
  //sound_on = fbv == 1 ? restoreData(userData.sound_on, 0, 1) : restoreValue('sound_on', 1);

  first_helper = Store.LoadValue(json['first_helper'], 1);
  //first_helper = fbv == 1 ? restoreData(userData.first_helper, 0, 1) : restoreValue('first_helper', 1);

  botopt = Store.LoadValue(json['botopt'], 1);
  //botopt = fbv == 1 ? restoreData(userData.botopt, 0, 1) : restoreValue('botopt', 1);

  complete_task_i = Store.LoadValue(json['complete_task_i'], -1);
  //complete_task_i = fbv == 1 ? restoreData(userData.complete_task_i, 0, -1) : restoreValue('complete_task_i', -1);

  starter_kit = Store.LoadValue(json['starter_kit'], 0);
  //starter_kit = fbv == 1 ? restoreData(userData.starter_kit, 0, 0) : restoreValue('starter_kit', 0);

  bought = Store.LoadValue(json['bought'], 0);
  //bought = fbv == 1 ? restoreData(userData.bought, 0, 0) : restoreValue('bought', 0);


  /* RESTORE DATES */
  FriendPrizeDate = Store.ValueToString(json['FriendPrizeDate']);
  // FriendPrizeDate = fbv == 1 ? restoreData(userData.FriendPrizeDate, 2, 0) : restoreDate('FriendPrizeDate');

  ReferralDate = Store.ValueToString(json['ReferralDate']);
  // ReferralDate = fbv == 1 ? restoreData(userData.ReferralDate, 2, 0) : restoreDate('ReferralDate');

  xmasDate = Store.ValueToString(json['xmasDate']);
  // xmasDate = fbv == 1 ? restoreData(userData.xmasDate, 2, 0) : restoreDate('xmasDate');

  ShopDate = Store.ValueToString(json['shop_time']);
  // ShopDate = fbv == 1 ? restoreData(userData.shop_time, 2, 0) : restoreDate('shop_time');

  misDate = Store.ValueToString(json['misDate']);
  // misDate = fbv == 1 ? restoreData(userData.misDate, 2, 0) : restoreDate('misDate');

  OfferDate = Store.ValueToString(json['OfferDate']);
  // OfferDate = fbv == 1 ? restoreData(userData.OfferDate, 2, 0) : restoreDate('OfferDate');

  lifetime = Store.ValueToString(json['lifetime']);
  // lifetime = fbv == 1 ? restoreData(userData.lifetime, 2, 0) : restoreDate('lifetime');

  playadDate = Store.ValueToString(json['playadDate']);
  //playadDate = fbv == 1 ? restoreData(userData.playadDate, 2, 0) : restoreDate('playadDate');

  weekday_offersDate = Store.ValueToString(json['weekday_offersDate']);
  // weekday_offersDate = fbv == 1 ? restoreData(userData.weekday_offersDate, 2, 0) : restoreDate('weekday_offersDate');

  KeyMissionDate = Store.ValueToString(json['key_mission_time']);
  // KeyMissionDate = fbv == 1 ? restoreData(userData.key_mission_time, 2, 0) : restoreDate('key_mission_time');

  GiftDate = Store.ValueToString(json['GiftDate']);
  // GiftDate = fbv == 1 ? restoreData(userData.GiftDate, 2, 0) : restoreDate('GiftDate');

  baloonDate = Store.ValueToString(json['baloonDate']);
  // baloonDate = fbv == 1 ? restoreData(userData.baloonDate, 2, 0) : restoreDate('baloonDate');

  sunflowerDate = Store.ValueToString(json['sunflowerDate']);
  // sunflowerDate = fbv == 1 ? restoreData(userData.sunflowerDate, 2, 0) : restoreDate('sunflowerDate');

  sunflowerDate_new = Store.ValueToString(json['sunflowerDate_new']);
  // sunflowerDate_new = fbv == 1 ? restoreData(userData.sunflowerDate_new, 2, 0) : restoreDate('sunflowerDate_new');

  magicbeanDate = Store.ValueToString(json['magicbeanDate']);
  // magicbeanDate = fbv == 1 ? restoreData(userData.magicbeanDate, 2, 0) : restoreDate('magicbeanDate');

  magicbeanDate_new = Store.ValueToString(json['magicbeanDate_new']);
  // magicbeanDate_new = fbv == 1 ? restoreData(userData.magicbeanDate_new, 2, 0) : restoreDate('magicbeanDate_new');

  baloonDate_new = Store.ValueToString(json['baloonDate_new']);
  // baloonDate_new = fbv == 1 ? restoreData(userData.baloonDate_new, 2, 0) : restoreDate('baloonDate_new');

  LifeDate = Store.ValueToString(json['life_time']);
  // LifeDate = fbv == 1 ? restoreData(userData.life_time, 2, 0) : restoreDate('life_time');

  unlimited_lifesDate = Store.ValueToString(json['unlimited_lifesDate']);
  // unlimited_lifesDate = fbv == 1 ? restoreData(userData.unlimited_lifesDate, 2, 0) : restoreDate('unlimited_lifesDate');

  unlimited_lifesDate_old = Store.ValueToString(json['unlimited_lifesDate_old']);
  // unlimited_lifesDate_old = fbv == 1 ? restoreData(userData.unlimited_lifesDate_old, 0, 0) : restoreDate('unlimited_lifesDate_old');

  WheelDate = Store.ValueToString(json['wheel_time']);
  // WheelDate = fbv == 1 ? restoreData(userData.wheel_time, 2, 0) : restoreDate('wheel_time');

  wheelshopDate = Store.ValueToString(json['wheelshopDate']);
  // wheelshopDate = fbv == 1 ? restoreData(userData.wheelshopDate, 2, 0) : restoreDate('wheelshopDate');


  /* RESTORE OBJECTS */
  dialog_mas = Store.JsonToObject(json['dialog_mas'], []);
  // dialog_mas = fbv == 1 ? restoreData(userData.dialog_mas, 1, []) : restoreJson('dialog_mas', []);

  dailyday_prize = Store.JsonToObject(json['dailyday_prize'], [0, 0, 0, 0, 0, 0, 0]);
  // dailyday_prize =
  //   fbv == 1
  //     ? restoreData(userData.dailyday_prize, 1, [0, 0, 0, 0, 0, 0, 0])
  //     : restoreJson('dailyday_prize', [0, 0, 0, 0, 0, 0, 0]);

  offer_mas = Store.JsonToObject(json['offer_mas'], []);
  // offer_mas = fbv == 1 ? restoreData(userData.offer_mas, 1, []) : restoreJson('offer_mas', []);

  mission_number = Store.JsonToObject(json['mission_number'], []);
  // mission_number = fbv == 1 ? restoreData(userData.mission_number, 1, []) : restoreJson('mission_number', []);

  helpers_id = Store.JsonToObject(json['helpers_id'], []);
  // helpers_id = fbv == 1 ? restoreData(userData.helpers_id, 1, []) : restoreJson('helpers_id', []);

  helpers_time = Store.JsonToObject(json['helpers_time'], []);
  // helpers_time = fbv == 1 ? restoreData(userData.helpers_time, 1, []) : restoreJson('helpers_time', []);

  for (var i = 0; i < helpers_time.length; i++)
    helpers_time[i] = Store.ValueToString(helpers_time[i]);

  all_friends_invite = Store.JsonToObject(json['all_friends_invite'], []);
  // all_friends_invite =
  //   fbv == 1 ? restoreData(userData.all_friends_invite, 1, []) : restoreJson('all_friends_invite', []);

  friends_invite = Store.JsonToObject(json['friends_invite'], []);
  // friends_invite = fbv == 1 ? restoreData(userData.friends_invite, 1, []) : restoreJson('friends_invite', []);

  special_object = Store.JsonToObject(json['special_object'], []);
  // special_object = fbv == 1 ? restoreData(userData.special_object, 1, []) : restoreJson('special_object', []);

  day_prize = Store.JsonToObject(json['day_prize'], [0, 0, 0, 0, 0, 0]);
  // day_prize =
  //   fbv == 1 ? restoreData(userData.day_prize, 1, [0, 0, 0, 0, 0, 0]) : restoreJson('day_prize', [0, 0, 0, 0, 0, 0]);

  mission_task = Store.JsonToObject(json['mission_task'], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  // mission_task =
  //   fbv == 1
  //     ? restoreData(userData.mission_task, 1, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
  //     : restoreJson('mission_task', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

  backcards = Store.JsonToObject(json['backcards'], [2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  // backcards =
  //   fbv == 1
  //     ? restoreData(userData.backcards, 1, [2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
  //     : restoreJson('backcards',           [2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

  missions = Store.JsonToObject(json['missions'], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  // missions =
  //   fbv == 1
  //     ? restoreData(userData.missions, 1, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
  //     : restoreJson('missions', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

  message_id = Store.JsonToObject(json['message_id'], []);
  // message_id = fbv == 1 ? restoreData(userData.message_id, 1, []) : restoreJson('message_id', []);

  new_options = Store.JsonToObject(json['new_options'], []);
  // new_options = fbv == 1 ? restoreData(userData.new_options, 1, []) : restoreJson('new_options', []);

  all_level = Store.JsonToObject(json['level_star'], []);
  // all_level = fbv == 1 ? restoreData(userData.level_star, 1, []) : restoreJson('level_star', []);

  all_chests = Store.JsonToObject(json['all_chests'], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  // all_chests = fbv == 1
  //     ? restoreData(userData.all_chests, 1, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
  //     : restoreJson('all_chests', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

  map_tiled_st = Store.JsonToObject(json['map_tiled_st'], []);
  // map_tiled_st = fbv == 1 ? restoreData(userData.map_tiled_st, 1, []) : restoreJson('map_tiled_st', []);

  gift_mas = Store.JsonToObject(json['gift_mas'], []);
  // gift_mas = fbv == 1 ? restoreData(userData.gift_mas, 1, []) : restoreJson('gift_mas', []);

  last_position = Store.JsonToObject(json['last_position'], [1010, 1800]);
  // last_position = fbv == 1 ? restoreData(userData.last_position, 1, [1010, 1800]) : restoreJson('last_position', [1010, 1800]);

  FTUEEVENTS = Store.JsonToObject(json['FTUEEVENTS'], []);
  // FTUEEVENTS = fbv == 1 ? restoreData(userData.FTUEEVENTS, 1, []) : restoreJson('FTUEEVENTS', []);

  //app.xPromo = new XPromo({ game });
  //app.xPromo.init();

  // app.ddna = new Ddna({
  //   game,
  //   store: app.store,
  //   transactions: app.transactions,
  //   getTimeUntilFirstUserInteractionPossible: () => timeUntilFirstUserInteractionPossible,
  //   getLevelContext: () => {
  //     if (is_map === 0) {
  //       return {
  //         levelNumber: level,
  //         cardsLeft: cards_deck_col - 1 - deck_n,
  //       };
  //     }
  //     return null;
  //   },
  // });

  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  function restoreData(key, type, edata) {
    let val = 0;
    if (typeof key !== 'undefined') {
      if (type == 0) {
        if (typeof key === 'object' && key !== null) {
          val = edata;
        } else if (!isNaN(key)) {
          val = Number(key);
        } else {
          val = edata;
        }
      } else if (type == 1) {
        val = JSON.parse(key);
      } else if (type == 2) {
        if (key != 0 && key != '0' && key != '-1' && key != '-2' && isValidDate(new Date(key))) {
          val = new Date(key);
        } else {
          val = edata;
        }
      } else val = key;
    } else {
      val = edata;
    }
    return val;
  }
};

function initGame() {
  app = new App();

  game.music = 0;
  game.username = '';
  game.canvas.id = 'game_canvas';
  game.state.add('Boot', boot);
  game.state.add('Preload', preload);
  game.state.add('Game', games);
  game.state.add('Screeng', screeng);
  game.state.add('Map', map);
  game.state.start('Boot');
  window.eventTrack('DEBUG_Complete_2');
}

var boot = function (game) { };
boot.prototype = {
  preload: function () { },
  create: function () {
    game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
    game.scale.fullScreenScaleMode = Phaser.ScaleManager.SHOW_ALL;
    game.scale.pageAlignHorizontally = true;
    game.scale.pageAlignVertically = true;
    game.stage.smoothed = true;
    game.scale.forceOrientation(true, true);
    game.resizeGame = function () {
      game.scale.setGameSize(1920, 1080);
      if (is_map == 0) {
        game.world.setBounds(Math.floor(game.width - 1280) * -0.5, 0, 1920, 1080);
      } else {
        game.world.setBounds(Math.floor(game.width - 1920) * -0.5, 0, 1920, 4320);
      }
    };
    game.state.start('Preload');
    window.eventTrack('DEBUG_Complete_3');
  },
};

var hole_safe = 0;
var weekday_offersDate = 0;
var weekday_offers = -1;
var JQKA_offers = 0;
var from_map = 0;
var streak_combo = 0;
var mission_loser = 0;
var coin_missions_completed = 0;
var coin_missions_shown = 6;
var mission_skip_success = 0;
var mission_skip_fail = 0;
var black_sprite2 = 0;
var misDate_timer_text = 0;
var mis_n = 0;
var mis_coins = 0;
var misDate = 0;
var playadDate = 0;
var playad_col = 0;
var gver = "v" + getEnv().version;
var leaves_group = 0;
var xmas_level_go = 0;
var xmas_level_win = 0;
var level_end_check = 0;
var level_end_check2 = 0;
var xmas_level = 0;
var xmas_ticket = 15;
var xmas_ticket_text = 0;
var xmas = 0;
var xmasDate = 0;
var numFriendsInvited = 0;
var retriesIteration = 0;
var ddd = 0;
var current_event = 0;
var missioncompleted = 0;
var update_controll = 0;
var map_stop = 0;
var level_max = 648;
var level = -1;
var baloonlevel = 1;
var baloonlevel_max = 20;
var baloonDate = 0;
var baloonDate_new = 0;
var sunflowerStage = 0;
var sunflowerDate = 0;
var sunflowerDate_new = 0;
var magicbeanStage = 0;
var magicbeanDate = 0;
var magicbeanDate_new = 0;
var shop = 0;
var CurrentUserId = 0;
var CurrentUserAvatar = '';
var CurrentUserName = '';
var CurrentContext = 0;
var cheat = 0;
var loading_text = 0;
var shortcut = 0;
var bought = 0;
var bought_f = 0;
var levels_played = 0;
var replayed = 0;
var pre_helper = 0;
var consumed_5Cards = 0;
var consumed_5Cards_x2 = 0;
var consumed_5Cards_x3 = 0;
var consumed_5cards_all = 0;
var consumed_joker = 0;
var consumed_TNT = 0;
var consumed_Shuffle = 0;
var consumed_backbutton = 0;
var consumed_3Helpercards = 0;
var result = 0;
var moves_used = 0;
var UI_Coins_BG = 0;
var Safe_Icon = 0;
var log = 0;
var offer_mas = [];
var loading_black = 0;
var loading_black_sprite = 0;
var lifetime = 0;
var unlimited_energy_h = 0;
var last_position = [1010, 1800];
var free_prebooster1 = -9999;
var free_prebooster1_select = 0;
var free_prebooster2 = -9999;
var free_prebooster2_select = 0;
var free_prebooster3 = -9999;
var free_prebooster3_select = 0;
var free_joker = 3;
var free_booster_spec = -4;
var free_cardback = 0;
var free_three = 0;
var free_five = -1;
var booster_tnt_col = 0;
var booster_eye_col = 0;
var booster_shuffle_col = 0;
var booster_timestop_col = 0;
var is_map = 0;
var all_level = [];
var all_level_col = 0;
var coins = 2000;
var keys = 0;
var keys_max = 20;
var first_start = 1;
var lifes = 5;
var max_lifes = 5;
var unlimited_lifesDate = 0;
var unlimited_lifesDate_old = 0;
var max_max_lifes = 10;
var LifeDate = 0;
var ShopDate = 0;
var ReferralDate = 0;
var OfferDate = 0;
var FriendPrizeDate = 0;
var shop_free = 1;
var shoptimer = 12;
var KeyMissionDate = 0;
var KeyMissionPrize = 0;
var gift_mas = [];
var GiftDate = 0;
var friends_invite = [];
var all_friends_invite = [];
var backcards = [
  2,
  2,
  2,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
var backcards_col = 42;
var backcards_select_old = 'backcard_1.png';
var backcards_select = 'backcard_1.png';
var sound_on = 1;
var music_on = 1;
var music = 0;
var ambient = 0;
var all_chests = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var map_n = 1;
var user_avatar = 0;
var dreset = 0;
var wheel_num = 1;
var wheel_ads = 0;
var wheel_max = 3;
var WheelDate = 0;
var wheelshopDate = 0;
var wheeladsDate = 0;
var missions = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var message_id = [];
var FTUE = 0;
var level_finish = 0;
var noSocial = 0;
var suitcase_add = 0;
var context_friends = [];
var helpers_id = [];
var helpers_time = [];
var special_object = [];
var angl_mas = [];
var angl_mas2 = [];
var load_com = -1;
var complete_task_i = -1;
var friendpassed_best = 0;
var first_helper = 1;
var starter_kit = 0;
var friend_invite = 0;
var fff = 0;
var array222 = 0;
var wheel_free = 0;
var wheel_ad = 0;
var wheel_cash = 0;
var botopt = 0;
var all_prize_mas = [0, 0, 0, 0, 0, 0, 0];
var UI_top_group = 0;
var UI_right_group = 0;
var UI_bottom_group = 0;
var UI_left_group = 0;
var source_chest = '';
var package_id_chest = 0;
var cursors;
var black = 0;
var follow = 0;
var time_life = 30;
var time_wheel = 24;
var time_prize = 24;
var missions_tab_open = 0;
var complete_level_spec = -1;
var complete_task_spec = -1;
var missions_tab_icon = 0;
var bright_area = 0;
var prize_wheel_arrow = 0;
var frinds_avatar1 = 0;
var node_mas = [];
var button_click = 0;
var wheel_icon_text = 0;
var wheel_icon_text2 = 0;
var zooming = false;
var all_stars = 0;
var buildstart = 0;
var dialog_mas = [];
var mission_task = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var mission_number = [];
var mission_day_end = 0;
var mission_stars_end = 0;
var day_prize = [0, 0, 0, 0, 0, 0];
var win_status = 0;
var context_name = 0;
var context_avatar = 0;
var context_id = 0;
var avatar_check_context = 0;
var objects_group = 0;
var worldScale = 1;
var worldwidth = 0;
var worldheight = 0;
var mapSizeX = 3100;
var mapSizeY = 1700;
var prevScale = {};
var nextScale = {};
var zoompoint = {};
var distance = 0;
var olddistance = 0;
var distancedelta = 0;
var easing = 0.1;
var black_sprite = 0;
var friend_avatar = 0;
var worldScale = 1;
var mapSizeMax = mapSizeX;
var mapSizeCurrent = mapSizeMax;
var popup = 0;
var animation = 0;
var UI_right_controll = 0;
var user_point = 0;
var leader_group = 0;
var popup_group = 0;
var effects_group = 0;
var farm_group = 0;
var currentindex = 0;
var map_move = 0;
var missions_tab_back2 = 0;
var key_mission_timer_text = 0;
var wheel_num_text = 0;
var wheel_icon_label = 0;
var missions_tab_back = 0;
var lifes_panel_plus = 0;
var map_tiled_st = [];
var rrr = 0;
var w = 0;
var itm_a = [];
var level_button = 0;
var prize_button = 0;
var build_button = 0;
var text_level_button = 0;
var invitereward_button = 0;
var furniture_button = 0;
var offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
var loading_complete = 0;
var new_options = [];
var fx = 0;
var baloon = 0;
var baloon_stage = 0;
var payments_catalog = [];
var dailyday = 0;
var dailyday_prize = [0, 0, 0, 0, 0, 0, 0];
var dailyday_old = 0;
var dailyday_new = 0;
var dailyday_current = 0;
var dialog_check = 0;
var lifetime_day = 0;
var timeUntilFirstUserInteractionPossible = 0;
var buch_rnd = 1;

var preload = function (game) { };

preload.prototype = {
  preload: function () {
    function res_load() {
      game.load.audio('music1', 'resource/audio/music_map_forest.mp3');
      game.load.atlasJSONHash('intro_atlas', 'resource/intro/intro.png', 'resource/intro/intro.json');
      game.load.image('logo_ja', 'resource/intro/logo_ja.png');
      game.load.image('back_loading', 'resource/intro/intro_back.jpg');
      game.load.json('lang', 'resource/json/lang.json');
      game.load.audio('ambient1', 'resource/audio/Forest_Ingame_Sound.mp3');
    }
    window.eventTrack('DEBUG_Complete_4');
    res_load();
    game.load.start();

    game.load.onFileComplete.add(function (progress, cacheKey, success, totalLoaded, totalFiles) {
      if (load_com == -1) {
        if (success == false) {
          console.log('LOAD FALSE');
          game.load.removeAll();
          res_load();
        }
        sdkHandler.trigger('loading.update', { progressPercentage: progress });

        if (progress === 100) {
          sdkHandler.trigger('loading.completed', {
            callback: function (error, user) {
              if (error) {
                console.log("SG loading.completed error: ", error)
              } else window.sgUser = user;
            }
          }, this);
        }
      }
    }, this);

    window.eventTrack('DEBUG_Complete_5');
    is_map = 0;
    Phaser.GAMES[0].canvas.addEventListener('click', function () {
      try {
        Phaser.GAMES[0].sound.context.resume();
      } catch (e) { }
    });
  },

  create: async function () {
    window.eventTrack('DEBUG_Complete_6');
    function restoreStringifiedJson(key, callback) {
      sdkHandler.trigger('restore', {
        key: key,
        callback: function (error, data) {
          if (error) {
            callback(error, data);
          } else {
            var actualData = typeof data === 'object' && data ? data.value : data;
            callback(error, actualData);
          }
        },
      });
    }

    function restoreDate(k) {
      var cb = 0;
      sdkHandler.trigger(
        'restore',
        {
          key: k,
          callback: function (error, value) {
            if (error) {
              cb = 0;
            } else {
              if (value != null && value != '0' && value !== 'NaN') {
                cb = new Date(value);
              } else {
                cb = 0;
              }
            }
          },
        },
        this,
      );
      return cb;
    }

    function restoreJson(k, d) {
      var cb = 0;
      restoreStringifiedJson(k, function (error, value) {
        if (error) {
        } else {
          if (value != null) {
            cb = JSON.parse(value);
          }
        }
      });
      return cb;
    }

    function restoreValue(k, d) {
      var cb = 0;
      sdkHandler.trigger(
        'restore',
        {
          key: k,
          callback: function (error, value) {
            if (error) {
              cb = d;
            } else {
              if (value != null) {
                cb = Number(value);
              }
              if (value !== 'NaN') {
              } else {
                cb = d;
              }
            }
          },
        },
        this,
      );
      return cb;
    }

    window.eventTrack('DEBUG_Complete_7');
    await game.fetchAndLogUserData();
    window.eventTrack('DEBUG_Complete_8');

    window.eventTrack('DEBUG_Complete_9');
    window.lang = sgSettings.config.env.locale;
    window.eventTrack('DEBUG_Complete_10');
    if (
      window.lang != 'en' &&
      window.lang != 'fr' &&
      window.lang != 'pt' &&
      window.lang != 'de' &&
      window.lang != 'es' &&
      window.lang != 'it' &&
      window.lang != 'ja'
    ) {
      window.lang = 'en';
    }
    window.eventTrack('DEBUG_Complete_11');
    window.eventTrack('DEBUG_Complete_12');
  },
};

var screeng = function (game) { };

screeng.prototype = {
  preload: function () {
    var rnd_text = [
      game.cache.getJSON('lang')['t241'][0][window.lang],
      game.cache.getJSON('lang')['t242'][0][window.lang],
      game.cache.getJSON('lang')['t243'][0][window.lang],
      game.cache.getJSON('lang')['t244'][0][window.lang],
      game.cache.getJSON('lang')['t245'][0][window.lang],
      game.cache.getJSON('lang')['t246'][0][window.lang],
      game.cache.getJSON('lang')['t247'][0][window.lang],
    ];
    game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'back_loading');
    game.background.anchor.setTo(0.5);
    let w_back = game.world.width / game.background.width;
    let h_back = game.world.height / game.background.height;
    if (w_back > 1) game.background.scale.setTo(w_back);
    if (game.world.height / game.background.height > 1)
      game.background.scale.setTo(game.background.scale.x - 1 + h_back);
    function leaves_angle(obj, t, n1, n2) {
      game.add
        .tween(obj)
        .to({ angle: n1 }, t, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          game.add
            .tween(item)
            .to({ angle: n2 }, t, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              leaves_angle(item, t, n1, n2);
            });
        });
    }
    var intro_group = game.add.group();
    var bush_back_center = game.add.sprite(
      game.world.centerX,
      game.world.height,
      'intro_atlas',
      'bush-back-center.png',
    );
    bush_back_center.anchor.setTo(0.5, 1);
    bush_back_center.scale.setTo(2);
    intro_group.add(bush_back_center);
    var bush_back_left = game.add.sprite(0, game.world.height, 'intro_atlas', 'bush-back-left.png');
    bush_back_left.anchor.setTo(0, 1);
    bush_back_left.scale.setTo(2);
    intro_group.add(bush_back_left);
    bush_back_left.fixedToCamera = true;
    leaves_angle(bush_back_left, 4000, '+2', '-2');
    var bush_back_right = game.add.sprite(game.world.width, game.world.height, 'intro_atlas', 'bush-back-right.png');
    bush_back_right.anchor.setTo(1, 1);
    bush_back_right.scale.setTo(2);
    intro_group.add(bush_back_right);
    bush_back_right.fixedToCamera = true;
    leaves_angle(bush_back_right, 4000, '-2', '+2');
    var flowers_back_1 = game.add.sprite(
      game.world.centerX + 220,
      game.world.height,
      'intro_atlas',
      'flowers-back-1.png',
    );
    flowers_back_1.anchor.setTo(0.5, 1);
    flowers_back_1.scale.setTo(2);
    intro_group.add(flowers_back_1);
    leaves_angle(flowers_back_1, 3500, '-1', '+1');
    var bush_middle_centert = game.add.sprite(
      game.world.centerX,
      game.world.height,
      'intro_atlas',
      'bush-middle-centert.png',
    );
    bush_middle_centert.anchor.setTo(0.5, 1);
    bush_middle_centert.scale.setTo(2);
    intro_group.add(bush_middle_centert);
    var tree1_leaves_right = game.add.sprite(
      game.world.centerX + 950,
      game.world.centerY - 220,
      'intro_atlas',
      'tree-leaves-right-coner.png',
    );
    tree1_leaves_right.anchor.setTo(0.5);
    tree1_leaves_right.scale.setTo(2);
    intro_group.add(tree1_leaves_right);
    leaves_angle(tree1_leaves_right, 3000, '+2', '+2');
    var tree1_wood_right = game.add.sprite(
      game.world.centerX + 950,
      game.world.centerY - 220 + 580,
      'intro_atlas',
      'tree-right-coner.png',
    );
    tree1_wood_right.anchor.setTo(0.5, 1);
    tree1_wood_right.scale.setTo(2);
    intro_group.add(tree1_wood_right);
    var tree_leaves_leftt_coner = game.add.sprite(
      game.world.centerX - 770,
      game.world.centerY - 300,
      'intro_atlas',
      'tree-leaves-leftt-coner.png',
    );
    tree_leaves_leftt_coner.anchor.setTo(0.5);
    tree_leaves_leftt_coner.scale.setTo(2);
    intro_group.add(tree_leaves_leftt_coner);
    leaves_angle(tree_leaves_leftt_coner, 3000, '+2', '+2');
    var tree_leftt_coner = game.add.sprite(
      game.world.centerX - 770,
      game.world.centerY - 300 + 592,
      'intro_atlas',
      'tree-leftt-coner.png',
    );
    tree_leftt_coner.anchor.setTo(0.5, 1);
    tree_leftt_coner.scale.setTo(2);
    intro_group.add(tree_leftt_coner);
    var bush_middle_left = game.add.sprite(
      game.world.centerX - 680,
      game.world.centerY + 332,
      'intro_atlas',
      'bush-middle-left.png',
    );
    bush_middle_left.anchor.setTo(0.5);
    bush_middle_left.scale.setTo(2);
    intro_group.add(bush_middle_left);
    var flowers_middle = game.add.sprite(
      game.world.centerX - 920,
      game.world.centerY + 312,
      'intro_atlas',
      'flowers-middle.png',
    );
    flowers_middle.anchor.setTo(0.5);
    flowers_middle.scale.setTo(2);
    intro_group.add(flowers_middle);
    leaves_angle(flowers_middle, 3500, '-1', '+1');
    var flowers_back_2 = game.add.sprite(
      game.world.centerX - 520,
      game.world.centerY + 322,
      'intro_atlas',
      'flowers-back-2.png',
    );
    flowers_back_2.anchor.setTo(0.5);
    flowers_back_2.scale.setTo(2);
    intro_group.add(flowers_back_2);
    leaves_angle(flowers_back_2, 3500, '+1', '-1');
    var tree_leaves_right_coner = game.add.sprite(
      game.world.centerX + 450,
      game.world.centerY - 230,
      'intro_atlas',
      'tree1-leaves-right.png',
    );
    tree_leaves_right_coner.anchor.setTo(0.5);
    tree_leaves_right_coner.scale.setTo(2);
    intro_group.add(tree_leaves_right_coner);
    leaves_angle(tree_leaves_right_coner, 3000, '-2', '+2');
    var tree_right_coner = game.add.sprite(
      game.world.centerX + 450,
      game.world.centerY - 230 + 720,
      'intro_atlas',
      'tree1-wood-right.png',
    );
    tree_right_coner.anchor.setTo(0.5, 1);
    tree_right_coner.scale.setTo(2);
    intro_group.add(tree_right_coner);
    var tree_leaves_front = game.add.sprite(
      game.world.centerX - 250,
      game.world.height - 728,
      'intro_atlas',
      'tree-leaves-front.png',
    );
    tree_leaves_front.anchor.setTo(0.5);
    tree_leaves_front.scale.setTo(2);
    intro_group.add(tree_leaves_front);
    leaves_angle(tree_leaves_front, 3000, '-2', '+2');
    var tree_wood_front = game.add.sprite(
      game.world.centerX - 250,
      game.world.height + 100,
      'intro_atlas',
      'tree-wood-front.png',
    );
    tree_wood_front.anchor.setTo(0.5, 1);
    tree_wood_front.scale.setTo(2);
    intro_group.add(tree_wood_front);
    var bush_front_left = game.add.sprite(0, game.world.height, 'intro_atlas', 'bush-front-left.png');
    bush_front_left.anchor.setTo(0, 1);
    bush_front_left.scale.setTo(2);
    intro_group.add(bush_front_left);
    bush_front_left.fixedToCamera = true;
    leaves_angle(bush_front_left, 2500, '+1', '-1');
    var bush_front_right = game.add.sprite(game.world.width, game.world.height, 'intro_atlas', 'bush-front-rightt.png');
    bush_front_right.anchor.setTo(1, 1);
    bush_front_right.scale.setTo(2);
    intro_group.add(bush_front_right);
    bush_front_right.fixedToCamera = true;
    leaves_angle(bush_front_right, 2500, '-1', '+1');
    var flowers_front_1 = game.add.sprite(
      game.world.centerX + 620,
      game.world.centerY + 450,
      'intro_atlas',
      'flowers-front-1.png',
    );
    flowers_front_1.anchor.setTo(0.5);
    flowers_front_1.scale.setTo(2);
    intro_group.add(flowers_front_1);
    leaves_angle(flowers_front_1, 1500, '-1', '+1');
    var bumblebee_body = game.add.sprite(
      game.world.centerX + 620,
      game.world.centerY + 220,
      'intro_atlas',
      'bumblebee-body.png',
    );
    bumblebee_body.anchor.setTo(0.5);
    bumblebee_body.scale.setTo(-2, 2);
    intro_group.add(bumblebee_body);
    bumblebee_move_f(bumblebee_body, 0);
    var bumblebee_wings = game.add.sprite(0, -6, 'intro_atlas', 'bumblebee-wings.png');
    bumblebee_wings.anchor.setTo(0.5, 1);
    bumblebee_body.addChild(bumblebee_wings);
    bumblebee_wings_f(bumblebee_wings);
    var bumblebee_body = game.add.sprite(
      game.world.centerX - 860,
      game.world.centerY + 210,
      'intro_atlas',
      'bumblebee-body.png',
    );
    bumblebee_body.anchor.setTo(0.5);
    bumblebee_body.scale.setTo(1.5);
    intro_group.add(bumblebee_body);
    bumblebee_move_f(bumblebee_body, 400);
    var bumblebee_wings = game.add.sprite(0, -6, 'intro_atlas', 'bumblebee-wings.png');
    bumblebee_wings.anchor.setTo(0.5, 1);
    bumblebee_body.addChild(bumblebee_wings);
    bumblebee_wings_f(bumblebee_wings);
    var logo = game.add.sprite(game.world.centerX, game.world.centerY - 200, 'intro_atlas', 'logo.png');
    if (lang === "ja") logo.loadTexture('logo_ja');
    logo.anchor.setTo(0.5);
    logo.scale.setTo(2);
    intro_group.add(logo);
    function bumblebee_wings_f(item) {
      game.add
        .tween(item)
        .to({ alpha: 0 }, 40, Phaser.Easing.Linear.None, true)
        .onComplete.add(function () {
          game.add
            .tween(item)
            .to({ alpha: 1 }, 40, Phaser.Easing.Linear.None, true)
            .onComplete.add(function () {
              bumblebee_wings_f(item);
            });
        });
    }
    function bumblebee_move_f(item, p) {
      game.add
        .tween(item)
        .to({ y: '-50' }, 1000, Phaser.Easing.Sinusoidal.InOut, true, p)
        .onComplete.add(function () {
          game.add
            .tween(item)
            .to({ y: '+50' }, 1000, Phaser.Easing.Sinusoidal.InOut, true)
            .onComplete.add(function () {
              bumblebee_move_f(item, 0);
            });
        });
    }
    var body_load = game.add.sprite(game.world.centerX, game.world.centerY + 230, 'intro_atlas', 'body-load.png');
    body_load.scale.setTo(2);
    body_load.anchor.setTo(0.5);
    var loading_s = game.add.sprite(game.world.centerX - 310, game.world.centerY + 230, 'intro_atlas', 'load.png');
    loading_s.scale.setTo(2);
    loading_s.anchor.setTo(0, 0.5);
    loading_s.w = loading_s.width;
    loading_s.width = 0;
    var n = game.rnd.integerInRange(0, 6);
    var rndtext = 0;
    rndtext = game.add.text(game.world.centerX, game.world.centerY + 300, rnd_text[n], {
      font: '32px RussoOne',
      fill: '#fff',
      align: 'center',
    });
    rndtext.anchor.setTo(0.5);
    rndtext.stroke = '#4C7724';
    rndtext.strokeThickness = 4;
    load_com = 0;
    game.load.onFileComplete.add(function (progress, cacheKey, success, totalLoaded, totalFiles) {
      if (load_com == 0) {
        loading_s.width = progress * (loading_s.w / 100);
        if (success == false) {
          game.load.removeAll();
          res_load();
        }
      }
    }, this);
    game.time.events.repeat(3500, 100, function () {
      try {
        n += 1;
        if (n >= rnd_text.length) {
          n = 0;
        }
        if (rndtext != 0) {
          rndtext.setText(rnd_text[n]);
        }
      } catch (e) { }
    });
    window.eventTrack('DEBUG_Complete_13');
    function res_load() {
      game.load.atlasJSONHash('farm_obj_atlas', 'resource/farm_obj.png', 'resource/farm_obj.json', 1);
      game.load.atlasJSONHash('char_atlas', 'resource/char_atlas.png', 'resource/char_atlas.json', 1);
      game.load.atlasJSONHash('game_ui_atlas', 'resource/game_ui.png', 'resource/game_ui.json', 1);
      game.load.atlasJSONHash('game_atlas', 'resource/game.png', 'resource/game.json', 1);
      game.load.atlasJSONHash('game5_atlas', 'resource/game5.png', 'resource/game5.json', 1);
      game.load.atlasJSONHash('loading_atlas', 'resource/loading.png', 'resource/loading.json', 1);
      game.load.atlasJSONHash('game_window_atlas', 'resource/game_window.png', 'resource/game_window.json', 1);
      game.load.atlasJSONHash('game_window2_atlas', 'resource/game_window2.png', 'resource/game_window2.json', 1);
      game.load.image('Fog_Low_Opacity', 'resource/Fog_Low_Opacity.png', 1);
      if ((xmasDate != 0 && xmasDate != -1) || cheat == 1) {
        game.load.atlasJSONHash('xmas_atlas', 'resource/xmas.png', 'resource/xmas.json', 1);
        game.load.atlasJSONHash('xmas_map_atlas', 'resource/xmas_map_atlas.png', 'resource/xmas_map_atlas.json', 1);
        game.load.json('halloween_map', 'resource/json/halloween_map.json', 1);
      }
      if (sunflowerDate != 0 || cheat == 1) {
        game.load.atlasJSONHash('sunflower_atlas', 'resource/sunflower_atlas.png', 'resource/sunflower_atlas.json', 1);
      }
      if (magicbeanDate != 0 || cheat == 1) {
        game.load.atlasJSONHash('magicbean_atlas', 'resource/magicbean_atlas.png', 'resource/magicbean_atlas.json', 1);
      }
      if (baloonDate != 0 || cheat == 1) {
        game.load.atlasJSONHash('baloon_atlas', 'resource/baloon_asset.png', 'resource/baloon_asset.json', 1);
      }
      if (OfferDate != 0 || cheat == 1) {
        game.load.atlasJSONHash('special_sales_atlas', 'resource/special_sales.png', 'resource/special_sales.json');
      }
      if (all_level[0] > 0 || map_n > 1 || cheat == 1) {
        game.load.atlasJSONHash('farm_obj_c_atlas', 'resource/farm_obj_c.png', 'resource/farm_obj_c.json', 1);
        game.load.image('Green_Background', 'resource/Green_Background.jpg', 1);
        game.load.atlasJSONHash('build_icon_atlas', 'resource/build_icon.png', 'resource/build_icon.json', 1);
        game.load.atlasJSONHash(
          'unlimited_energy_atlas',
          'resource/unlimited_energy.png',
          'resource/unlimited_energy.json',
          1,
        );
      }
      if (entryPointData != null || all_level[0] > 0 || map_n > 1 || cheat == 1) {
        game.load.atlasJSONHash(
          'message_atlas',
          'resource/message/message_atlas.png',
          'resource/message/message_atlas.json',
          1,
        );
      }
      if (map_n == 14 || cheat == 1) {
        game.load.atlasJSONHash('day14_pic_atlas', 'resource/day14_pic.png', 'resource/day14_pic.json', 1);
      }
      if (map_n == 16 || map_n == 17 || cheat == 1) {
        game.load.atlasJSONHash('day_16_atlas', 'resource/day_16_atlas.png', 'resource/day_16_atlas.json', 1);
      }
      if (map_n == 17 || cheat == 1) {
        game.load.atlasJSONHash('day17_atlas', 'resource/day17_atlas.png', 'resource/day17_atlas.json', 1);
      }
      if (map_n == 17 || cheat == 1) {
        game.load.atlasJSONHash('day17_2_atlas', 'resource/day17_2_atlas.png', 'resource/day17_2_atlas.json', 1);
      }
      if (map_n >= 2 || cheat == 1) {
        game.load.image('background_young_rose_gift', 'resource/background_young_rose_gift.jpg', 1);
      }
      game.load.image('field', 'resource/field.png', 1);
      game.load.image('field2', 'resource/SnowGround_full.jpg', 1);
      game.load.image('message_invite_mask', 'resource/message/message_invite_mask.png', 1);
      game.load.json('missions_json', 'resource/json/missions.json', 1);
      game.load.json('map', 'resource/json/map.json', 1);
      game.load.json('dialog', 'resource/json/dialog.json', 1);
      game.load.image(
        'particle',
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAACXBIWXMAAAsSAAALEgHS3X78AAAAG0lEQVR42mP4DwUMRDDoKzCqYPAqGDVgRBgAAHTt/C7AKLBeAAAAAElFTkSuQmCC',
      );
      game.load.json('buildings', 'resource/json/buildings.json', 1);
      game.load.audiosprite('sfx', 'resource/audio/all_sounds.mp3', 'resource/audio/sounds.json');
    }
    res_load();
    game.load.start();
  },
  create: function () {
    load_com = 1;
    effects_group = game.add.group();
    Phaser.GAMES[0].canvas.addEventListener('click', function () {
      try {
        Phaser.GAMES[0].sound.context.resume();
      } catch (e) { }
    });
    is_map = 0;
    game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'back_loading');
    game.background.anchor.setTo(0.5);
    let w_back = game.world.width / game.background.width;
    let h_back = game.world.height / game.background.height;
    if (w_back > 1) game.background.scale.setTo(w_back);
    if (game.world.height / game.background.height > 1)
      game.background.scale.setTo(game.background.scale.x - 1 + h_back);
    function getAndroidVersion(ua) {
      var ua = ua || navigator.userAgent;
      var match = ua.match(/Android\s([0-9\.]*)/);
      return match ? match[1] : false;
    }
    let isIOS =
      (/iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
      !window.MSStream;
    if (isIOS || parseInt(getAndroidVersion(), 10) == 5 || fbv == 0) {
      shop = 0;
    } else {
      shop = 1;
    }
    game.load.crossOrigin = true;
    if (fbv == 1) {
      game.load.image('user_avatar', CurrentUserAvatar, 1);
    }
    game.load.start();
    var intro_group = game.add.group();
    var cloud_1 = game.add.sprite(game.world.centerX + 350, 100, 'intro_atlas', 'cloud-1.png');
    cloud_1.anchor.setTo(0.5);
    cloud_1.scale.setTo(2);
    intro_group.add(cloud_1);
    game.add.tween(cloud_1).to({ x: '+800' }, 100000, Phaser.Easing.Linear.None, true);
    var cloud_2 = game.add.sprite(game.world.centerX - 400, 140, 'intro_atlas', 'cloud-2.png');
    cloud_2.anchor.setTo(0.5);
    cloud_2.scale.setTo(2);
    intro_group.add(cloud_2);
    game.add.tween(cloud_2).to({ x: '+1500' }, 100000, Phaser.Easing.Linear.None, true);
    var cloud_3 = game.add.sprite(game.world.centerX, 80, 'intro_atlas', 'cloud-3.png');
    cloud_3.anchor.setTo(0.5);
    cloud_3.scale.setTo(2);
    intro_group.add(cloud_3);
    game.add.tween(cloud_3).to({ x: '+500' }, 100000, Phaser.Easing.Linear.None, true);
    var bush_back_center = game.add.sprite(
      game.world.centerX,
      game.world.height,
      'intro_atlas',
      'bush-back-center.png',
    );
    bush_back_center.anchor.setTo(0.5, 1);
    bush_back_center.scale.setTo(2);
    intro_group.add(bush_back_center);
    var bush_back_left = game.add.sprite(0, game.world.height, 'intro_atlas', 'bush-back-left.png');
    bush_back_left.anchor.setTo(0, 1);
    bush_back_left.scale.setTo(2);
    intro_group.add(bush_back_left);
    bush_back_left.fixedToCamera = true;
    var bush_back_right = game.add.sprite(game.world.width, game.world.height, 'intro_atlas', 'bush-back-right.png');
    bush_back_right.anchor.setTo(1, 1);
    bush_back_right.scale.setTo(2);
    intro_group.add(bush_back_right);
    bush_back_right.fixedToCamera = true;
    var flowers_back_1 = game.add.sprite(
      game.world.centerX + 220,
      game.world.height,
      'intro_atlas',
      'flowers-back-1.png',
    );
    flowers_back_1.anchor.setTo(0.5, 1);
    flowers_back_1.scale.setTo(2);
    intro_group.add(flowers_back_1);
    var bush_middle_centert = game.add.sprite(
      game.world.centerX,
      game.world.height,
      'intro_atlas',
      'bush-middle-centert.png',
    );
    bush_middle_centert.anchor.setTo(0.5, 1);
    bush_middle_centert.scale.setTo(2);
    intro_group.add(bush_middle_centert);
    var tree1_leaves_right = game.add.sprite(
      game.world.centerX + 950,
      game.world.centerY - 220,
      'intro_atlas',
      'tree-leaves-right-coner.png',
    );
    tree1_leaves_right.anchor.setTo(0.5);
    tree1_leaves_right.scale.setTo(2);
    intro_group.add(tree1_leaves_right);
    var tree1_wood_right = game.add.sprite(0, 290, 'intro_atlas', 'tree-right-coner.png');
    tree1_wood_right.anchor.setTo(0.5, 1);
    tree1_leaves_right.addChild(tree1_wood_right);
    var tree_leaves_leftt_coner = game.add.sprite(
      game.world.centerX - 770,
      game.world.centerY - 300,
      'intro_atlas',
      'tree-leaves-leftt-coner.png',
    );
    tree_leaves_leftt_coner.anchor.setTo(0.5);
    tree_leaves_leftt_coner.scale.setTo(2);
    intro_group.add(tree_leaves_leftt_coner);
    var tree_leftt_coner = game.add.sprite(0, 296, 'intro_atlas', 'tree-leftt-coner.png');
    tree_leftt_coner.anchor.setTo(0.5, 1);
    tree_leaves_leftt_coner.addChild(tree_leftt_coner);
    var bush_middle_left = game.add.sprite(
      game.world.centerX - 680,
      game.world.centerY + 332,
      'intro_atlas',
      'bush-middle-left.png',
    );
    bush_middle_left.anchor.setTo(0.5);
    bush_middle_left.scale.setTo(2);
    intro_group.add(bush_middle_left);
    var flowers_middle = game.add.sprite(
      game.world.centerX - 920,
      game.world.centerY + 312,
      'intro_atlas',
      'flowers-middle.png',
    );
    flowers_middle.anchor.setTo(0.5);
    flowers_middle.scale.setTo(2);
    intro_group.add(flowers_middle);
    var flowers_back_2 = game.add.sprite(
      game.world.centerX - 520,
      game.world.centerY + 322,
      'intro_atlas',
      'flowers-back-2.png',
    );
    flowers_back_2.anchor.setTo(0.5);
    flowers_back_2.scale.setTo(2);
    intro_group.add(flowers_back_2);
    var tree_leaves_right_coner = game.add.sprite(
      game.world.centerX + 450,
      game.world.centerY - 230,
      'intro_atlas',
      'tree1-leaves-right.png',
    );
    tree_leaves_right_coner.anchor.setTo(0.5);
    tree_leaves_right_coner.scale.setTo(2);
    intro_group.add(tree_leaves_right_coner);
    leaves_angle(tree_leaves_right_coner, 3000, '-2', '+2');
    var tree_right_coner = game.add.sprite(
      game.world.centerX + 450,
      game.world.centerY - 230 + 720,
      'intro_atlas',
      'tree1-wood-right.png',
    );
    tree_right_coner.anchor.setTo(0.5, 1);
    tree_right_coner.scale.setTo(2);
    intro_group.add(tree_right_coner);
    var tree_leaves_front = game.add.sprite(
      game.world.centerX - 250,
      game.world.height - 728,
      'intro_atlas',
      'tree-leaves-front.png',
    );
    tree_leaves_front.anchor.setTo(0.5);
    tree_leaves_front.scale.setTo(2);
    intro_group.add(tree_leaves_front);
    leaves_angle(tree_leaves_front, 3000, '+2', '-2');
    var tree_wood_front = game.add.sprite(
      game.world.centerX - 250,
      game.world.height + 100,
      'intro_atlas',
      'tree-wood-front.png',
    );
    tree_wood_front.anchor.setTo(0.5, 1);
    tree_wood_front.scale.setTo(2);
    intro_group.add(tree_wood_front);
    var bush_left_corner = game.add.sprite(-250, game.world.height + 200, 'intro_atlas', 'bush-left-corner.png');
    bush_left_corner.anchor.setTo(0, 1);
    bush_left_corner.scale.setTo(2);
    intro_group.add(bush_left_corner);
    bush_left_corner.fixedToCamera = true;
    leaves_angle(bush_left_corner, 2000, '+1', '-1');
    var bush_right_corner = game.add.sprite(
      game.world.width + 200,
      game.world.height + 200,
      'intro_atlas',
      'bush-right-corner.png',
    );
    bush_right_corner.anchor.setTo(1, 1);
    bush_right_corner.scale.setTo(2);
    intro_group.add(bush_right_corner);
    bush_right_corner.fixedToCamera = true;
    leaves_angle(bush_right_corner, 2000, '-1', '+1');
    var girl = game.add.sprite(game.world.centerX - 430, game.world.height + 600, 'intro_atlas', 'Presenting.png');
    girl.anchor.setTo(0.5, 1);
    girl.scale.setTo(-2.2, 2.2);
    intro_group.add(girl);
    var bush_front_left = game.add.sprite(0, game.world.height, 'intro_atlas', 'bush-front-left.png');
    bush_front_left.anchor.setTo(0, 1);
    bush_front_left.scale.setTo(2);
    intro_group.add(bush_front_left);
    bush_front_left.fixedToCamera = true;
    var bush_front_right = game.add.sprite(game.world.width, game.world.height, 'intro_atlas', 'bush-front-rightt.png');
    bush_front_right.anchor.setTo(1, 1);
    bush_front_right.scale.setTo(2);
    intro_group.add(bush_front_right);
    bush_front_right.fixedToCamera = true;
    var flowers_front_1 = game.add.sprite(
      game.world.centerX + 620,
      game.world.centerY + 450,
      'intro_atlas',
      'flowers-front-1.png',
    );
    flowers_front_1.anchor.setTo(0.5);
    flowers_front_1.scale.setTo(2);
    intro_group.add(flowers_front_1);
    var bumblebee_body = game.add.sprite(
      game.world.centerX + 620,
      game.world.centerY + 220,
      'intro_atlas',
      'bumblebee-body.png',
    );
    bumblebee_body.anchor.setTo(0.5);
    bumblebee_body.scale.setTo(-2, 2);
    intro_group.add(bumblebee_body);
    var bumblebee_wings = game.add.sprite(0, -6, 'intro_atlas', 'bumblebee-wings.png');
    bumblebee_wings.anchor.setTo(0.5, 1);
    bumblebee_body.addChild(bumblebee_wings);
    var bumblebee_body2 = game.add.sprite(
      game.world.centerX - 860,
      game.world.centerY + 210,
      'intro_atlas',
      'bumblebee-body.png',
    );
    bumblebee_body2.anchor.setTo(0.5);
    bumblebee_body2.scale.setTo(1.5);
    intro_group.add(bumblebee_body2);
    var bumblebee_wings2 = game.add.sprite(0, -6, 'intro_atlas', 'bumblebee-wings.png');
    bumblebee_wings2.anchor.setTo(0.5, 1);
    bumblebee_body2.addChild(bumblebee_wings2);
    var bush_back = game.add.sprite(game.world.centerX - 1030, game.world.height + 200, 'intro_atlas', 'example.png');
    bush_back.anchor.setTo(0.5, 1);
    bush_back.scale.setTo(2);
    intro_group.add(bush_back);
    leaves_angle(bush_back, 2000, '+1', '-1');
    var grass2 = game.add.sprite(game.world.centerX - 1130, game.world.height + 200, 'intro_atlas', 'grass2.png');
    grass2.anchor.setTo(0.5, 1);
    grass2.scale.setTo(2);
    intro_group.add(grass2);
    leaves_angle(grass2, 1500, '-1', '+1');
    var flowers2 = game.add.sprite(10, -70, 'intro_atlas', 'flowers2.png');
    flowers2.anchor.setTo(0.5, 1);
    grass2.addChild(flowers2);
    var details2 = game.add.sprite(10, -70, 'intro_atlas', 'details2.png');
    details2.anchor.setTo(0.5, 1);
    grass2.addChild(details2);
    var bush_back2 = game.add.sprite(game.world.centerX + 1030, game.world.height + 200, 'intro_atlas', 'example2.png');
    bush_back2.anchor.setTo(0.5, 1);
    bush_back2.scale.setTo(2);
    intro_group.add(bush_back2);
    leaves_angle(bush_back2, 2000, '-1', '+1');
    var grass = game.add.sprite(game.world.centerX + 1130, game.world.height + 200, 'intro_atlas', 'grass.png');
    grass.anchor.setTo(0.5, 1);
    grass.scale.setTo(2);
    intro_group.add(grass);
    leaves_angle(grass, 1500, '+1', '-1');
    var flowers = game.add.sprite(-13, -100, 'intro_atlas', 'flowers.png');
    flowers.anchor.setTo(0.5, 1);
    grass.addChild(flowers);
    var details = game.add.sprite(-13, -100, 'intro_atlas', 'details.png');
    details.anchor.setTo(0.5, 1);
    grass.addChild(details);
    var flowers_blue = game.add.sprite(
      game.world.centerX - 1130,
      game.world.height + 150,
      'intro_atlas',
      'flowers-blue.png',
    );
    flowers_blue.anchor.setTo(0.5, 1);
    flowers_blue.scale.setTo(2);
    intro_group.add(flowers_blue);
    var grass_blue_left = game.add.sprite(
      game.world.centerX - 1130,
      game.world.height + 150,
      'intro_atlas',
      'grass-blue-left.png',
    );
    grass_blue_left.anchor.setTo(0.5, 1);
    grass_blue_left.scale.setTo(2);
    intro_group.add(grass_blue_left);
    leaves_angle(grass_blue_left, 2500, '+2', '-2');
    var flowers_blue_right = game.add.sprite(
      game.world.centerX + 1130,
      game.world.height + 150,
      'intro_atlas',
      'flowers-blue-right.png',
    );
    flowers_blue_right.anchor.setTo(0.5, 1);
    flowers_blue_right.scale.setTo(2);
    intro_group.add(flowers_blue_right);
    var grass_blue_right = game.add.sprite(
      game.world.centerX + 1130,
      game.world.height + 150,
      'intro_atlas',
      'grass-blue-right.png',
    );
    grass_blue_right.anchor.setTo(0.5, 1);
    grass_blue_right.scale.setTo(2);
    intro_group.add(grass_blue_right);
    leaves_angle(grass_blue_right, 2500, '-2', '+2');
    var grass_blue_front = game.add.sprite(
      game.world.centerX,
      game.world.height + 150,
      'intro_atlas',
      'grass-blur-front.png',
    );
    grass_blue_front.anchor.setTo(0.5, 1);
    grass_blue_front.scale.setTo(2);
    intro_group.add(grass_blue_front);
    leaves_angle(grass_blue_front, 3000, '+1', '-1');
    function leaves_angle(obj, t, n1, n2) {
      game.add
        .tween(obj)
        .to({ angle: n1 }, t, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          game.add
            .tween(item)
            .to({ angle: n2 }, t, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              leaves_angle(item, t, n1, n2);
            });
        });
    }
    var logo = game.add.sprite(game.world.centerX, game.world.centerY - 200, 'intro_atlas', 'logo.png');
    if (lang === "ja") logo.loadTexture('logo_ja');
    logo.anchor.setTo(0.5);
    logo.scale.setTo(2);
    intro_group.add(logo);
    bumblebee_wings_f(bumblebee_wings);
    bumblebee_wings_f(bumblebee_wings2);
    bumblebee_body.scale.setTo(-2, 2);
    game.add
      .tween(bumblebee_body)
      .to({ x: '-1300', y: '-170' }, 1500, Phaser.Easing.Linear.None, true)
      .onComplete.add(function () {
        bumblebee_move_f(bumblebee_body, 0);
      });
    bumblebee_body2.scale.setTo(1.5, 1.5);
    game.add
      .tween(bumblebee_body2)
      .to({ x: '+1200', y: '+100' }, 1900, Phaser.Easing.Linear.None, true)
      .onComplete.add(function () {
        bumblebee_move_f(bumblebee_body2);
      });
    game.add.tween(game.background.scale).to({ x: '+0.05', y: '+0.05' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(intro_group.scale).to({ x: 1.05, y: 1.05 }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_back_center).to({ y: '+500' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_middle_centert).to({ y: '+50' }, 800, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_back_left.cameraOffset).to({ x: '-1000' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_middle_left).to({ x: '-1000' }, 800, Phaser.Easing.Linear.None, true);
    game.add.tween(flowers_middle).to({ x: '-1000' }, 800, Phaser.Easing.Linear.None, true);
    game.add.tween(flowers_back_2).to({ x: '-1000' }, 600, Phaser.Easing.Linear.None, true);
    game.add.tween(tree_leaves_front).to({ x: '-800', y: '-170' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(tree_wood_front).to({ x: '-800', y: '-170' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_front_left.cameraOffset).to({ x: '-1000' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(tree_leaves_leftt_coner).to({ x: '-1000' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_back_right.cameraOffset).to({ x: '+1000' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(tree1_leaves_right).to({ x: '+1000' }, 800, Phaser.Easing.Linear.None, true);
    game.add.tween(flowers_back_1).to({ x: '+1000', y: '+500' }, 600, Phaser.Easing.Linear.None, true);
    game.add.tween(tree_leaves_right_coner).to({ x: '+500', y: '-170' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(tree_right_coner).to({ x: '+500', y: '-170' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_front_right.cameraOffset).to({ x: '+1000' }, 600, Phaser.Easing.Linear.None, true);
    game.add.tween(flowers_front_1).to({ x: '+1000' }, 500, Phaser.Easing.Linear.None, true);
    game.add.tween(logo.scale).to({ x: '-0.4', y: '-0.4' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(logo).to({ y: '-100' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_left_corner.cameraOffset).to({ x: '+220', y: '-240' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_right_corner.cameraOffset).to({ x: '-220', y: '-240' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_back).to({ x: '+500', y: '-240' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(grass2).to({ x: '+300', y: '-240' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(flowers_blue).to({ x: '+290', y: '-190' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(grass_blue_left).to({ x: '+380', y: '-190' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(bush_back2).to({ x: '-500', y: '-240' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(grass).to({ x: '-300', y: '-240' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(flowers_blue_right).to({ x: '-290', y: '-190' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(grass_blue_right).to({ x: '-380', y: '-190' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(grass_blue_front).to({ y: '-190' }, 1000, Phaser.Easing.Linear.None, true);
    game.add.tween(girl).to({ y: '-750' }, 1000, Phaser.Easing.Linear.None, true, 1000);
    function bumblebee_wings_f(item) {
      game.add
        .tween(item)
        .to({ alpha: 0 }, 40, Phaser.Easing.Linear.None, true)
        .onComplete.add(function () {
          game.add
            .tween(item)
            .to({ alpha: 1 }, 40, Phaser.Easing.Linear.None, true)
            .onComplete.add(function () {
              bumblebee_wings_f(item);
            });
        });
    }
    function bumblebee_move_f(item, p) {
      game.add
        .tween(item)
        .to({ y: '-50' }, 1000, Phaser.Easing.Sinusoidal.InOut, true, p)
        .onComplete.add(function () {
          game.add
            .tween(item)
            .to({ y: '+50' }, 1000, Phaser.Easing.Sinusoidal.InOut, true)
            .onComplete.add(function () {
              bumblebee_move_f(item, 0);
            });
        });
    }
    game.add
      .tween(logo)
      .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 1000)
      .onComplete.add(function () {
        if (0 == 1) {
          var Intro1 = game.add.sprite(game.world.centerX, game.world.centerY, 'Intro1');
          Intro1.anchor.setTo(0.5);
          Intro1.alpha = 0;
          if (game.world.width / Intro1.width > 1) Intro1.scale.setTo(game.world.width / Intro1.width);
          else if (game.world.height / Intro1.height > 1) Intro1.scale.setTo(game.world.height / Intro1.height);
          var black_sprite = game.add.sprite(0, 0, 'message_invite_mask');
          black_sprite.alpha = 0;
          black_sprite.width = game.world.width;
          black_sprite.height = game.world.height;
          black_sprite.anchor.setTo(0);
          black_sprite.fixedToCamera = true;
          game.add
            .tween(black_sprite)
            .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              Intro1.alpha = 1;
              game.add.tween(Intro1.scale).to({ x: '+0.1', y: '+0.1' }, 5000, Phaser.Easing.Linear.None, true);
              var black_text = game.add.sprite(0, game.world.height, 'message_invite_mask');
              black_text.width = game.world.width;
              black_text.height = 160;
              black_text.anchor.setTo(0);
              black_text.fixedToCamera = true;
              var button_skip = game.add.sprite(
                game.camera.width - 200,
                game.camera.height - 80,
                'game_window_atlas',
                'Skip_Button.png',
              );
              button_skip.inputEnabled = true;
              button_skip.fixedToCamera = true;
              button_skip.input.useHandCursor = true;
              button_skip.events.onInputUp.add(function () {
                if (fbv == 1 && FTUE == 0) {
                  window.eventTrack('FTUE_1_3_IntroSequenceCompleted');
                }
                game.world.removeAll(true);
                game.state.start('Map');
              });
              var black_text_text = game.add.text(100, game.world.height - 140, '', {
                font: '30px RussoOne',
                fill: '#fff',
                align: 'left',
                wordWrap: true,
                wordWrapWidth: game.world.width - 500,
              });
              black_text_text.fixedToCamera = true;
              var introtext = game.cache.getJSON('lang')['t248'][0][window.lang];
              var introtext_write = '';
              var i = 0;
              game.add
                .tween(black_text.cameraOffset)
                .to({ y: '-160' }, 200, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.time.events.repeat(20, introtext.length, function () {
                    black_text_text.setText(introtext_write);
                    introtext_write += introtext[i];
                    i++;
                  });
                });
              game.world.bringToTop(black_sprite);
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 4000)
                    .onComplete.add(function (item) {
                      Intro1.destroy();
                      black_text.cameraOffset.y += 160;
                      black_text_text.setText('');
                      var Intro3 = game.add.sprite(game.world.centerX, game.world.centerY, 'Intro3');
                      Intro3.anchor.setTo(0.5);
                      if (game.world.width / Intro3.width > 1) Intro3.scale.setTo(game.world.width / Intro3.width);
                      else if (game.world.height / Intro3.height > 1)
                        Intro3.scale.setTo(game.world.height / Intro3.height);
                      game.world.bringToTop(black_sprite);
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          var Intro_letter_seperated = game.add.sprite(
                            game.world.centerX,
                            game.world.centerY + 1080,
                            'Intro_letter_seperated',
                          );
                          Intro_letter_seperated.anchor.setTo(0.5);
                          var button_skip = game.add.sprite(
                            game.camera.width - 200,
                            game.camera.height + 80,
                            'game_window_atlas',
                            'Skip_Button.png',
                          );
                          button_skip.inputEnabled = true;
                          button_skip.fixedToCamera = true;
                          button_skip.input.useHandCursor = true;
                          button_skip.events.onInputUp.add(function () {
                            if (fbv == 1 && FTUE == 0) {
                              window.eventTrack('FTUE_1_3_IntroSequenceCompleted');
                            }
                            game.world.removeAll(true);
                            game.state.start('Map');
                          });
                          game.world.bringToTop(black_text);
                          game.world.bringToTop(black_text_text);
                          game.world.bringToTop(button_skip);
                          introtext = game.cache.getJSON('lang')['t249'][0][window.lang];
                          introtext_write = '';
                          i = 0;
                          game.add
                            .tween(button_skip.cameraOffset)
                            .to({ y: '-160' }, 200, Phaser.Easing.Linear.None, true);
                          game.add
                            .tween(black_text.cameraOffset)
                            .to({ y: '-160' }, 200, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function (item) {
                              game.time.events.repeat(20, introtext.length, function () {
                                black_text_text.setText(introtext_write);
                                introtext_write += introtext[i];
                                i++;
                              });
                            });
                          game.add
                            .tween(Intro_letter_seperated)
                            .to({ y: '-1080' }, 1000, Phaser.Easing.Linear.None, true, 2000)
                            .onComplete.add(function (item) {
                              game.add
                                .tween(Intro_letter_seperated)
                                .to({ y: '+1080' }, 1000, Phaser.Easing.Linear.None, true, 2000)
                                .onComplete.add(function (item) {
                                  game.add
                                    .tween(Intro3.scale)
                                    .to({ x: '+0.3', y: '+0.3' }, 2000, Phaser.Easing.Linear.None, true);
                                  game.camera.onFadeComplete.add(function () {
                                    if (popup != 111) {
                                      if (fbv == 1 && FTUE == 0) {
                                        window.eventTrack('FTUE_1_3_IntroSequenceCompleted');
                                      }
                                      game.world.removeAll(true);
                                      game.state.start('Map');
                                    }
                                  }, this);
                                  game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                                    game.camera.fade(0xffffff, 1000);
                                  });
                                });
                            });
                        });
                    });
                });
            });
        } else {
          game.camera.onFadeComplete.add(function () {
            if (popup != 111) {
              game.world.removeAll(true);
              game.state.start('Map');
            }
          }, this);
          game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
            game.camera.fade(0xffffff, 1000);
          });
        }
      });
    ////////Сheats////////
    window.cheaton = function () {
      cheat = 1;
      clearInterval(timerId5);
      game.world.removeAll(true);
      game.state.start('Boot');
    };
    window.mission_complete = function () {
      if (cheat == 1) {
        for (var j = 0; j < 24; j += 4) {
          missions[j + 2] = missions[j + 1];
        }
      }
    }
    window.coins_complete = function () {
      if (cheat == 1) {
        keys = Number(mis_coins);
      }
    }
    window.xmas_reset = function () {
      if (xmas == 1) {
        xmas = 1;
        worldScale = 0.8;
        last_position = [1800 * worldScale, 1600 * worldScale];
        from_map = 2;
        game.world.removeAll(true);
        xmas_ticket = 15;
        xmas_level = 0;
        dialog_mas = [];
        game.state.start('Map');
      }
      else {
        xmas_ticket = 15;
        xmas_level = 0;
        dialog_mas = [];
        game.state.start('Map');
      }
    }
    window.setticket = function (n) {
      if (cheat == 1) {
        xmas_ticket = n;
        if (xmas == 1 && xmas_ticket_text != 0) {
          xmas_ticket_text.setText(xmas_ticket);
        }
      }
    }
    window.getalleventprize = function (n) {
      if (cheat == 1) {
        if (n == 1) {
          mission_number.push("170");
          special_object.push(Number("17011"));
          map_tiled_st.push({ i: Number(170), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(170)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 170, num: old_item });

          var old_item = [8];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(15)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(8);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 15, num: old_item });

          var old_item = [8];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(55)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(8);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 55, num: old_item });

          mission_number.push("171");
          special_object.push(Number("17111"));
          map_tiled_st.push({ i: Number(171), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(171)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 171, num: old_item });

          mission_number.push("515");
          special_object.push(Number("51511"));
          map_tiled_st.push({ i: Number(515), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(515)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 515, num: old_item });

          var old_item = [7];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(39)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(7);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 39, num: old_item });

          var old_item = [7];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(16)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(7);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 16, num: old_item });

          var old_item = [8];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(29)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(8);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 29, num: old_item });

          var old_item = [7];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(11)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(7);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 11, num: old_item });

          mission_number.push("172");
          special_object.push(Number("17211"));
          map_tiled_st.push({ i: Number(172), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(172)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 172, num: old_item });

          var old_item = [7];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(53)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(7);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 53, num: old_item });
          var old_item = [7];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(109)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(7);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 109, num: old_item });
          var old_item = [7];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(58)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(7);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 58, num: old_item });

          mission_number.push("173");
          special_object.push(Number("17311"));
          map_tiled_st.push({ i: Number(173), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(173)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 173, num: old_item });

          var old_item = [6];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(106)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(6);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 106, num: old_item });

          mission_number.push("461");
          special_object.push(Number("46111"));
          map_tiled_st.push({ i: Number(461), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(461)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 461, num: old_item });

          var old_item = [7];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(7)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(7);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 7, num: old_item });

          if (mission_number.indexOf("145") == -1) {
            mission_number.push("145");
            special_object.push(Number("14511"));
            map_tiled_st.push({ i: Number(145), s: Number(1) });
          }
          var old_item = [3];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(145)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(3);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 145, num: old_item });

          mission_number.push("174");
          special_object.push(Number("17411"));
          map_tiled_st.push({ i: Number(174), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(174)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 174, num: old_item });

          var old_item = [3];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(32)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(3);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 32, num: old_item });

        } else {
          mission_number.push("143");
          special_object.push(Number("14311"));
          map_tiled_st.push({ i: Number(143), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(143)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 143, num: old_item });

          mission_number.push("144");
          special_object.push(Number("14411"));
          map_tiled_st.push({ i: Number(144), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(144)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 144, num: old_item });

          mission_number.push("146");
          special_object.push(Number("14611"));
          map_tiled_st.push({ i: Number(146), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(146)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 146, num: old_item });

          mission_number.push("148");
          special_object.push(Number("14811"));
          map_tiled_st.push({ i: Number(148), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(148)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 148, num: old_item });

          mission_number.push("147");
          special_object.push(Number("14711"));
          map_tiled_st.push({ i: Number(147), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(147)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 147, num: old_item });

          mission_number.push("147");
          special_object.push(Number("14711"));
          map_tiled_st.push({ i: Number(147), s: Number(1) });
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(147)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 147, num: old_item });

          if (mission_number.indexOf("145") == -1) {
            mission_number.push("145");
            special_object.push(Number("14511"));
            map_tiled_st.push({ i: Number(145), s: Number(1) });
          }
          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(145)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 145, num: old_item });

          var old_item = [6];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(53)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(6);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 53, num: old_item });
          var old_item = [6];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(109)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(6);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 109, num: old_item });

          var old_item = [7];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(29)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(7);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 29, num: old_item });

          var old_item = [6];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(7)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(6);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 7, num: old_item });

          var old_item = [6];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(11)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(6);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 11, num: old_item });

          var old_item = [6];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(9)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(6);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 9, num: old_item });

          var old_item = [2];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(32)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(2);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 32, num: old_item });

          var old_item = [6];
          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(16)) }));
          if (typeof new_options[tp] !== 'undefined') {
            old_item = new_options[tp]['num'];
            old_item.push(6);
            new_options.splice(tp, 1);
          }
          new_options.push({ type: 16, num: old_item });
        }
        game.setUserDataAndLog({ mission_number: JSON.stringify(mission_number), special_object: JSON.stringify(special_object), map_tiled_st: JSON.stringify(map_tiled_st), new_options: JSON.stringify(new_options) });
        game.world.removeAll(true);
        game.state.start('Map');
      }
    }
    window.setFTUE = function (f) {
      if (cheat == 1) {
        FTUE = f;
        game.setUserDataAndLog({ FTUE: FTUE });
      }
    };
    window.ftueoff = function (n) {
      if (cheat == 1) {
        FTUE = 153;
        game.setUserDataAndLog({ FTUE: FTUE });
        game.world.removeAll(true);
        game.state.start('Map');
      }
    };
    window.logon = function (n) {
      if (cheat == 1) {
        log = 1;
      }
    };
    window.datareset = function () {
      weekday_offers = -1;
      JQKA_offers = 0;
      xmas_ticket = 15;
      xmas_level = 0;
      retriesIteration = 0;
      dreset = 1;
      helpersclear();
      free_joker = 3;
      free_five = -1;
      free_booster_spec = -4;
      free_cardback = 3;
      free_three = 0;
      free_prebooster1 = -9999;
      free_prebooster2 = -9999;
      free_prebooster3 = -9999;
      booster_tnt_col = 0;
      booster_eye_col = 0;
      booster_shuffle_col = 0;
      booster_timestop_col = 0;
      mission_number = [];
      mission_task = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      mission_day_end = 0;
      mission_stars_end = 0;
      day_prize = [0, 0, 0, 0, 0, 0];
      map_tiled_st = [];
      dialog_mas = [];
      new_options = [];
      dailyday_prize = [0, 0, 0, 0, 0, 0, 0];
      dailyday = 0;
      dailyday_new = 0;
      dailyday_current = 0;
      offer_mas = [];
      special_object = [];
      friends_invite = [];
      all_friends_invite = [];
      friend_invite = 0;
      all_level = [];
      coins = 1000;
      keys = 0;
      lifes = 5;
      LifeDate = 0;
      unlimited_lifesDate = 0;
      unlimited_lifesDate_old = 0;
      ShopDate = 0;
      ReferralDate = 0;
      OfferDate = 0;
      lifetime = 0;
      FriendPrizeDate = 0;
      shop_free = 1;
      KeyMissionDate = 0;
      KeyMissionPrize = 0;
      gift_mas = [];
      GiftDate = 0;
      baloonDate = 0;
      baloonDate_new = 0;
      sunflowerDate = 0;
      xmasDate = 0;
      sunflowerStage = 0;
      magicbeanStage = 0;
      numFriendsInvited = 0;
      sunflowerDate_new = 0;
      magicbeanDate = 0;
      magicbeanDate_new = 0;
      backcards = [
        2,
        2,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
      ];
      backcards_select = 'backcard_1.png';
      all_chests = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      map_n = 1;
      wheel_num = 1;
      wheel_ads = 0;
      baloonlevel = 1;
      wheel_max = 3;
      WheelDate = 0;
      wheelshopDate = 0;
      wheeladsDate = 0;
      missions = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      FTUE = 0;
      suitcase_add = 0;
      all_stars = 0;
      last_position = [1010, 1800];
      first_start = 1;
      first_helper = 1;
      botopt = 0;
      complete_task_i = -1;
      starter_kit = 0;
      bought = 0;
      fff = 0;
      FTUEEVENTS = [];
      game.saveDataAll();
    };
    ////////Сheats end////////

    function helpersclear() {
      helpers_id = [];
      helpers_time = [];
      game.setUserDataAndLog({ helpers_id: JSON.stringify(helpers_id), helpers_time: JSON.stringify(helpers_time) });
    }
    if (fbv == 1 && FTUE == 0) {
      window.eventTrack('FTUE_1_1_SdkInit');
    }
    if (fbv == 1 && FTUE == 0) {
      window.eventTrack('FTUE_1_2_LoadingCompleted');
    }
    if (FTUE <= 3 && (mission_number.length > 0 || map_tiled_st.length > 0)) {
      datareset();
    }
    last_position = [2000 * worldScale, 1100 * worldScale];
  },
};


var map = function (game) { };
map.prototype = {
  preload: function () {
    game.stage.backgroundColor = '#000';
  },
  create: function () {

    var newDate = new Date();
    if (weekday_offers != -1 && weekday_offers != newDate.getDay()) { weekday_offers = -1; game.setUserDataAndLog({ weekday_offers: weekday_offers }); }
    var old_new_options = new_options;

    window.old_new_options = function () {
      new_options = old_new_options;
      game.setUserDataAndLog({ new_options: JSON.stringify(new_options) });
    }

    if (mission_number.indexOf('110') != -1) {
      var opt1_type = 53;
      var old_item = [1, 2, 3, 4, 5];
      var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(53)) }));
      if (typeof new_options[tp] !== 'undefined') {
        opt1_type = new_options[tp]['type'];
        old_item = new_options[tp]['num'];
        old_item.push(1, 2, 3, 4, 5);
        new_options.splice(tp, 1);
      }
      new_options.push({ type: opt1_type, num: old_item });

      var opt1_type = 109;
      var old_item = [1, 2, 3, 4, 5];
      var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(109)) }));
      if (typeof new_options[tp] !== 'undefined') {
        opt1_type = new_options[tp]['type'];
        old_item = new_options[tp]['num'];
        old_item.push(1, 2, 3, 4, 5);
        old_item = old_item.filter(function (item, pos) { return old_item.indexOf(item) == pos });
        new_options.splice(tp, 1);
      }
      new_options.push({ type: opt1_type, num: old_item });
    }

    for (var i = 0; i < new_options.length; i++) {
      var opt1_type = new_options[i]['type'];
      var opt1_num = new_options[i]['num'];
      var new_arr = [];

      var nol = new_options.length;

      for (var j = 0; j < nol; j++) {
        var tp = new_options.findIndex(function (e) { return Number(Math.abs(e['type'])) == Math.abs(opt1_type) });
        if (typeof new_options[tp] !== 'undefined') {
          new_arr = opt1_num.concat(new_options[tp]['num']);
          new_arr = new_arr.filter(function (item, pos) { return new_arr.indexOf(item) == pos });
          new_options.splice(tp, 1);
        }
      }
      new_options.push({ type: opt1_type, num: new_arr });
    }


    is_map = 1;
    if ((all_level[0] == 0 || typeof all_level[0] == 'undefined') && coins < 1000) { coins = 1000; game.setUserDataAndLog({ currencies: coins }); }
    var lasso = 0;
    var waterpump = 0;
    leaves_group = game.add.group();
    if (backcards_select == 'Back_Cards_xmas.png') { backcards_select = backcards_select_old; }
    var object_outline1 = 0;
    var object_outline2 = 0;
    var coins_panel = 0;
    var life_panel = 0;
    var stars_panel = 0;
    var text_coins_panel = 0;
    var text_life_panel = 0;
    var text_stars_panel = 0;
    var star_icon = 0;
    var text_lifes = 0;
    var life_text_timer = 0;
    var life_line = 0;
    var get_coins_plus_button = 0;
    var life_icon = 0;
    if (lifetime == 0) {
      lifetime =
        ddd == 0
          ? new Date()
          : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
      game.setUserDataAndLog({ lifetime: String(lifetime) });
    }
    let currentDate = Date.parse(new Date());
    let days = (currentDate - Date.parse(lifetime)) / 86400000;
    lifetime_day = Math.round(days);
    if (timeUntilFirstUserInteractionPossible == 0) {
      timeUntilFirstUserInteractionPossible = Date.now() - window.CODE_STARTED_AT;
      console.log('timeUntilFirstUserInteractionPossible: ', timeUntilFirstUserInteractionPossible);
      console.log('lifetime_day: ', lifetime_day);
      console.log('gameVersion: ', gver);
      window.eventTrack('timeUntilFirstUserInteractionPossible', 1, { value: timeUntilFirstUserInteractionPossible });
      window.eventTrack('session_start', 1, {
        user_type: bought,
        lifetime: lifetime_day,
        highest_lvl: all_level.lastIndexOf(3) + 2,
        coins: coins,
        booster1: free_joker,
        booster2: free_cardback,
        booster3: booster_tnt_col,
        booster4: booster_shuffle_col,
        booster5: booster_eye_col,
        mission_completed: missioncompleted,
      });

      console.log('shop', shop);
    }
    if (lifetime_day == 0 && free_five == -1) {
      free_five = -3;
      game.setUserDataAndLog({ free_five: free_five });
    }
    window.dailybonus_r = function (n) {
      if (cheat == 1) {
        var tomorrow =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        tomorrow.setDate(tomorrow.getDate());
        dailyday_new = tomorrow.getDate();
        game.setUserDataAndLog({ dailyday: dailyday, dailyday_new: String(dailyday_new) });
      }
    };
    window.dailybonus = function (n) {
      if (cheat == 1) {
        dailyday = n;
        dailyday_create(dailyday_new);
        dailyday++;
        if (dailyday > 7) {
          dailyday = 1;
        }
        dailyday *= -1;
        var tomorrow =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        tomorrow.setDate(tomorrow.getDate() + 1);
        dailyday_new = tomorrow.getDate();
        game.setUserDataAndLog({ dailyday: dailyday, dailyday_new: String(dailyday_new) });
      }
    };
    window.event_reduce_time = function (t, m) {
      if (cheat == 1) {
        if (t == 1) {
          if (baloonDate != 0) {
            baloonDate.setMinutes(baloonDate.getMinutes() - m);
            game.setUserDataAndLog({ baloonDate: String(baloonDate) });
          }
        } else if (t == 2) {
          if (sunflowerDate != 0) {
            sunflowerDate.setMinutes(sunflowerDate.getMinutes() - m);
            game.setUserDataAndLog({ sunflowerDate: String(sunflowerDate) });
          }
        } else if (t == 3) {
          if (magicbeanDate != 0) {
            magicbeanDate.setMinutes(magicbeanDate.getMinutes() - m);
            game.setUserDataAndLog({ magicbeanDate: String(magicbeanDate) });
          }
        } else if (t == 4) {
          if (misDate != 0) {
            misDate.setMinutes(misDate.getMinutes() - m);
            game.setUserDataAndLog({ misDate: String(misDate) });
          }
        }
      }
    };
    window.fake_date = function (d) {
      if (cheat == 1) {
        ddd = d;
      }
    };
    if (all_level[4] > 0 && dailyday == 0) {
      dailyday = -1;
    }
    baloon_stage = 0;
    offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
    dailyday_old = 0;
    if (dailyday < 0) {
      dailyday *= -1;
    }
    var dailyday_prize_col = [0, 0, 0, 0, 0, 0, 0];
    var dailyday_prize_current = [0, 0, 0, 0, 0, 0, 0];
    buch_rnd = game.rnd.integerInRange(1, 4);
    function dailyday_create(nnn) {
      if (fbv == 1) {
        window.eventTrack('FTUE_10_5_DailyRew_shown');
      }
      dailyday_prize_current = [0, 0, 0, 0, 0, 0, 0];
      dailyday_prize_col = [0, 0, 0, 0, 0, 0, 0];
      if (dailyday == 1) {
        dailyday_prize[0] = get_random_change([0, 1, 3]);
        dailyday_prize[1] = get_random_change([0, 1, 4]);
        dailyday_prize[2] = get_random_change([0, 1, 3, 4]);
        if (all_level[46] > 0) {
          dailyday_prize[3] = get_random_change([0, 3, 4, 6, 7]);
        } else if (all_level[41] > 0) {
          dailyday_prize[3] = get_random_change([0, 3, 4, 7]);
        } else {
          dailyday_prize[3] = get_random_change([0, 3, 4]);
        }
        if (all_level[46] > 0) {
          dailyday_prize[4] = get_random_change([0, 1, 6, 7]);
        } else if (all_level[41] > 0) {
          dailyday_prize[4] = get_random_change([0, 1, 7]);
        } else {
          dailyday_prize[4] = get_random_change([0, 1]);
        }
        if (all_level[46] > 0) {
          dailyday_prize[5] = get_random_change([0, 2, 6, 7]);
        } else if (all_level[41] > 0) {
          dailyday_prize[5] = get_random_change([0, 2, 7]);
        } else {
          dailyday_prize[5] = get_random_change([0, 2]);
        }
        if (all_level[27] > 0) {
          dailyday_prize[6] = 5;
        } else {
          dailyday_prize[6] = 0;
        }
        game.setUserDataAndLog({ dailyday_prize: JSON.stringify(dailyday_prize) });
      }
      if (dailyday_prize[0] == 0) {
        dailyday_prize_col[0] = 150;
      } else {
        dailyday_prize_col[0] = 1;
      }
      if (dailyday_prize[1] == 0) {
        dailyday_prize_col[1] = 200;
      } else if (dailyday_prize[1] == 1) {
        dailyday_prize_col[1] = 2;
      } else {
        dailyday_prize_col[1] = 1;
      }
      if (dailyday_prize[2] == 0) {
        dailyday_prize_col[2] = 300;
      } else if (dailyday_prize[2] == 1) {
        dailyday_prize_col[2] = 3;
      } else {
        dailyday_prize_col[2] = 2;
      }
      if (dailyday_prize[3] == 0) {
        dailyday_prize_col[3] = 400;
      } else if (dailyday_prize[3] == 3 || dailyday_prize[3] == 4) {
        dailyday_prize_col[3] = 3;
      } else {
        dailyday_prize_col[3] = 1;
      }
      if (dailyday_prize[4] == 0) {
        dailyday_prize_col[4] = 500;
      } else if (dailyday_prize[4] == 1) {
        dailyday_prize_col[4] = 5;
      } else {
        dailyday_prize_col[4] = 2;
      }
      if (dailyday_prize[5] == 0) {
        dailyday_prize_col[5] = 600;
      } else if (dailyday_prize[5] == 2) {
        dailyday_prize_col[5] = 1;
      } else {
        dailyday_prize_col[5] = 3;
      }
      if (dailyday_prize[6] == 0) {
        dailyday_prize_col[6] = 700;
      } else {
        dailyday_prize_col[6] = 1;
      }
      popup_group.y = 0;
      popup_group.y += game.camera.height;
      popup = 1;
      blackf();
      var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
      popup_group.add(popup_back);
      popup_back.fixedToCamera = true;
      var Pop_Up_Background = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Calendar_BG.png');
      Pop_Up_Background.scale.setTo(2);
      Pop_Up_Background.anchor.setTo(0.5);
      popup_back.addChild(Pop_Up_Background);
      var dailyday_title_text = game.add.text(0, -432, game.cache.getJSON('lang')['DailyBonus'][0][window.lang], {
        font: '52px RussoOne',
        fill: '#793129',
        align: 'center',
      });
      dailyday_title_text.anchor.setTo(0.5);
      popup_back.addChild(dailyday_title_text);
      var dailyday_title_text = game.add.text(0, -440, game.cache.getJSON('lang')['DailyBonus'][0][window.lang], {
        font: '52px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      dailyday_title_text.anchor.setTo(0.5);
      dailyday_title_text.stroke = '#97453C';
      dailyday_title_text.strokeThickness = 4;
      dailyday_title_text.setShadow(0, -4, 'rgba(182,98,34,1)', 0);
      popup_back.addChild(dailyday_title_text);
      var dailyday_title_text = game.add.text(0, -340, game.cache.getJSON('lang')['DailyBonustext'][0][window.lang], {
        font: '22px RussoOne',
        fill: '#8C3B32',
        align: 'center',
      });
      dailyday_title_text.anchor.setTo(0.5);
      popup_back.addChild(dailyday_title_text);
      var Image = game.add.sprite(-310, 0, 'daily_bonus_atlas', 'Image.png');
      Image.scale.setTo(2);
      Image.anchor.setTo(0.5);
      popup_back.addChild(Image);
      for (var d = 1; d <= 7; d++) {
        if (d < 4) var Day_parent = game.add.sprite(0 + (d - 1) * 194, -204, '');
        else if (d < 7) var Day_parent = game.add.sprite(0 + (d - 4) * 194, -204 + 202, '');
        else var Day_parent = game.add.sprite(0 + 194, -204 + 404, '');
        Day_parent.anchor.setTo(0.5);
        popup_back.addChild(Day_parent);
        if (d > dailyday) {
          var Day_Button = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Day' + d + '_Button.png');
          Day_Button.scale.setTo(1.7);
          Day_Button.anchor.setTo(0.5);
          Day_parent.addChild(Day_Button);
          if (window.lang == 'it')
            var Day_Button_text = game.add.text(0, 0, game.cache.getJSON('lang')['t278'][0][window.lang] + '\n' + d, {
              font: '40px RussoOne',
              fill: '#fff',
              align: 'center',
            });
          else
            var Day_Button_text = game.add.text(0, 0, game.cache.getJSON('lang')['t278'][0][window.lang] + '\n' + d, {
              font: '46px RussoOne',
              fill: '#fff',
              align: 'center',
            });
          Day_Button_text.anchor.setTo(0.5);
          Day_Button_text.stroke = '#0D6A96';
          Day_Button_text.strokeThickness = 4;
          Day_Button_text.lineHeight = 0;
          Day_Button_text.setShadow(0, 4, 'rgba(0,0,0,0.2)', 1);
          Day_parent.addChild(Day_Button_text);
        } else if (d < dailyday) {
          let spr = 'List_Coin.png';
          let atlas = 'game_window2_atlas';
          let scl = 1.8;
          if (dailyday_prize[d - 1] == 1) {
            spr = 'List_Energy.png';
          } else if (dailyday_prize[d - 1] == 2) {
            spr = 'List_Joker.png';
          } else if (dailyday_prize[d - 1] == 3) {
            spr = 'List_Cards.png';
          } else if (dailyday_prize[d - 1] == 4) {
            spr = 'List_Card_Back.png';
          } else if (dailyday_prize[d - 1] == 5) {
            spr = 'tnt_booster.png';
            atlas = 'game_atlas';
            scl = 1;
          } else if (dailyday_prize[d - 1] == 6) {
            spr = 'shuffle_booster.png';
            atlas = 'game_atlas';
            scl = 1;
          } else if (dailyday_prize[d - 1] == 7) {
            spr = 'bullseye_booster.png';
            atlas = 'game_atlas';
            scl = 1;
          }
          if (d < 4) var Background_Day_Prize = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Background_Day_Prize.png');
          else if (d < 7)
            var Background_Day_Prize = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Background_Day_Prize.png');
          else var Background_Day_Prize = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Big_Background_Day_Prize.png');
          Background_Day_Prize.scale.setTo(2);
          Background_Day_Prize.anchor.setTo(0.5);
          Day_parent.addChild(Background_Day_Prize);
          var prize_1 = game.add.sprite(0, -26, atlas, spr);
          prize_1.anchor.setTo(0.5);
          prize_1.scale.setTo(scl);
          prize_1.iii = i;
          prize_1.alpha = 0.6;
          Day_parent.addChild(prize_1);
          var prize_1_text = game.add.text(0, 60, 'x' + dailyday_prize_col[d - 1], {
            font: '40px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          prize_1_text.anchor.setTo(0.5);
          prize_1_text.stroke = '#0D6A96';
          prize_1_text.strokeThickness = 4;
          prize_1_text.lineHeight = 0;
          prize_1_text.alpha = 0.6;
          prize_1_text.setShadow(0, 4, 'rgba(0,0,0,0.2)', 1);
          Day_parent.addChild(prize_1_text);
          var Green_Check = game.add.sprite(70, -70, 'game_ui_atlas', 'Green_Check.png');
          Green_Check.anchor.setTo(0.5);
          Green_Check.scale.setTo(0.5);
          Day_parent.addChild(Green_Check);
        }
        if (d == dailyday) {
          if (dailyday_prize[d - 1] == 0) {
            dailyday_prize_current[0] = dailyday_prize_col[d - 1];
          } else if (dailyday_prize[d - 1] == 1) {
            dailyday_prize_current[1] = dailyday_prize_col[d - 1];
          } else if (dailyday_prize[d - 1] == 2) {
            dailyday_prize_current[2] = dailyday_prize_col[d - 1];
          } else if (dailyday_prize[d - 1] == 3) {
            dailyday_prize_current[3] = dailyday_prize_col[d - 1];
          } else if (dailyday_prize[d - 1] == 4) {
            dailyday_prize_current[4] = dailyday_prize_col[d - 1];
          } else if (dailyday_prize[d - 1] == 5) {
            dailyday_prize_current[5] = dailyday_prize_col[d - 1];
          } else if (dailyday_prize[d - 1] == 6) {
            dailyday_prize_current[6] = dailyday_prize_col[d - 1];
          } else if (dailyday_prize[d - 1] == 7) {
            dailyday_prize_current[7] = dailyday_prize_col[d - 1];
          }
          console.log('dailyday_prize_current_s ', dailyday_prize_current);
        }
      }
      if (dailyday < 4) var Day_parent = game.add.sprite(0 + (dailyday - 1) * 194, -204, '');
      else if (dailyday < 7) var Day_parent = game.add.sprite(0 + (dailyday - 4) * 194, -204 + 202, '');
      else var Day_parent = game.add.sprite(0 + 194, -204 + 404, '');
      Day_parent.anchor.setTo(0.5);
      popup_back.addChild(Day_parent);
      let spr = 'List_Coin.png';
      let atlas = 'game_window2_atlas';
      let scl = 1.8;
      if (dailyday_prize[dailyday - 1] == 1) {
        spr = 'List_Energy.png';
      } else if (dailyday_prize[dailyday - 1] == 2) {
        spr = 'List_Joker.png';
      } else if (dailyday_prize[dailyday - 1] == 3) {
        spr = 'List_Cards.png';
      } else if (dailyday_prize[dailyday - 1] == 4) {
        spr = 'List_Card_Back.png';
      } else if (dailyday_prize[dailyday - 1] == 5) {
        spr = 'tnt_booster.png';
        atlas = 'game_atlas';
        scl = 1;
      } else if (dailyday_prize[dailyday - 1] == 6) {
        spr = 'shuffle_booster.png';
        atlas = 'game_atlas';
        scl = 1;
      } else if (dailyday_prize[dailyday - 1] == 7) {
        spr = 'bullseye_booster.png';
        atlas = 'game_atlas';
        scl = 1;
      }
      if (dailyday < 4)
        var Background_Day_Prize = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Background_Day_Prize.png');
      else if (dailyday < 7)
        var Background_Day_Prize = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Background_Day_Prize.png');
      else var Background_Day_Prize = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Big_Background_Day_Prize.png');
      Background_Day_Prize.scale.setTo(2);
      Background_Day_Prize.anchor.setTo(0.5);
      Day_parent.addChild(Background_Day_Prize);
      var Shine = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Shine.png');
      Shine.anchor.setTo(0.5);
      Shine.scale.setTo(1.7);
      Day_parent.addChild(Shine);
      rotate_tween(Shine);
      var prize_1 = game.add.sprite(0, -26, atlas, spr);
      prize_1.anchor.setTo(0.5);
      prize_1.scale.setTo(scl);
      Day_parent.addChild(prize_1);
      var prize_1_text = game.add.text(0, 60, 'x' + dailyday_prize_col[dailyday - 1], {
        font: '40px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      prize_1_text.anchor.setTo(0.5);
      prize_1_text.stroke = '#0D6A96';
      prize_1_text.strokeThickness = 4;
      prize_1_text.lineHeight = 0;
      prize_1_text.setShadow(0, 4, 'rgba(0,0,0,0.2)', 1);
      Day_parent.addChild(prize_1_text);
      var Day_Button = game.add.sprite(0, 0, 'daily_bonus_atlas', 'Day' + dailyday + '_Button.png');
      Day_Button.scale.setTo(1.7);
      Day_Button.anchor.setTo(0.5);
      Day_parent.addChild(Day_Button);
      var Day_Button_text = game.add.text(0, 0, game.cache.getJSON('lang')['t278'][0][window.lang] + '\n' + dailyday, {
        font: '46px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      Day_Button_text.anchor.setTo(0.5);
      Day_Button_text.stroke = '#0D6A96';
      Day_Button_text.strokeThickness = 4;
      Day_Button_text.lineHeight = 0;
      Day_Button_text.setShadow(0, 4, 'rgba(0,0,0,0.2)', 1);
      Day_parent.addChild(Day_Button_text);
      if (dailyday == 7) {
        emitter_c = game.add.emitter(0, 0, 50);
        emitter_c.makeParticles('particle');
        emitter_c.setRotation(0, 360, 500);
        emitter_c.explode = true;
        emitter_c.width = game.camera.width;
        emitter_c.bringToTop = true;
        emitter_c.minParticleSpeed.set(0, 100);
        emitter_c.maxParticleSpeed.set(0, 200);
        emitter_c.gravity = 100;
        emitter_c.x = game.camera.x + game.camera.width / 2;
        emitter_c.y = game.camera.y;
        emitter_c.start(false, 6000, 100);
        emitter_c.blendMode = 0;
        emitter_c.setAlpha(1, 0, 5000);
        emitter_c.setScale(0.1, 1.4, 0.1, 1.4);
        emitter_c.maxParticleScale = 1.4;
        emitter_c.minParticleScale = 0.4;
        emitter_c.forEach(function (particle) {
          var a = game.rnd.integerInRange(1, 5);
          if (a == 1) particle.tint = 0xffff00;
          else if (a == 2) particle.tint = 0xff0000;
          else if (a == 3) particle.tint = 0x00ff00;
          else if (a == 4) particle.tint = 0x0000ff;
          else if (a == 5) particle.tint = 0x00ffff;
        });
      }
      game.add
        .tween(Day_Button)
        .to({ angle: '+5' }, 50, Phaser.Easing.Linear.None, true, 1000)
        .onComplete.add(function (item) {
          game.add.tween(Day_Button).to({ angle: '-10' }, 50, Phaser.Easing.Linear.None, true, 0, 6).yoyo(true, 0);
          game.add.tween(Day_Button).to({ alpha: 0 }, 1000, Phaser.Easing.Exponential.Out, true, 600);
          game.add.tween(Day_Button.scale).to({ x: '+2', y: '+2' }, 1000, Phaser.Easing.Exponential.Out, true, 600);
          game.add.tween(Day_Button_text).to({ alpha: 0 }, 1000, Phaser.Easing.Exponential.Out, true, 600);
          game.add
            .tween(Day_Button_text.scale)
            .to({ x: '+2', y: '+2' }, 1000, Phaser.Easing.Exponential.Out, true, 600);
          add_shines(prize_1, -1, 1);
          add_shines(prize_1, -1, 1);
          game.add
            .tween(prize_1.scale)
            .to({ x: '+0.2', y: '+0.2' }, 200, Phaser.Easing.Linear.None, true, 900, 0)
            .yoyo(true, 0);
          game.add
            .tween(prize_1_text.scale)
            .to({ x: '+0.2', y: '+0.2' }, 200, Phaser.Easing.Linear.None, true, 1100, 0)
            .yoyo(true, 0);
          var Green_Check = game.add.sprite(70, -70, 'game_ui_atlas', 'Green_Check.png');
          Green_Check.alpha = 0;
          Green_Check.anchor.setTo(0.5);
          Green_Check.scale.setTo(4);
          Day_parent.addChild(Green_Check);
          game.add.tween(Green_Check).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 1500);
          game.add.tween(Green_Check.scale).to({ x: 0.5, y: 0.5 }, 800, Phaser.Easing.Bounce.Out, true, 1500);
        });
      game.add
        .tween(popup_group)
        .to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true)
        .onComplete.add(function (item) {
          if (fbv == 1) {
            window.eventTrack('FTUE_10_6_DailyRew_revealReward');
          }
          var button_green = draw_rect(0, 410, 408, 135, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
          draw_rect_shadow(0, 0, 374, 102, '#000', '#000', 0, 0, button_green, 500);
          draw_rect(0, 0, 374, 102, '#7ED12B', '#7ED12B', 0, 0, button_green, 0, 500, 0);
          draw_rect(0, 0, 370, 100, '#C2F33F', '#51C001', 0, 1, button_green, 0, 500, 0);
          button_animation_f(button_green, 1);
          button_green.scale.setTo(0);
          button_green.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              if (FTUE_Arrow != 0) {
                FTUE_Arrow.destroy();
              }
              if (fbv == 1) {
                window.eventTrack('FTUE_10_8_DailyRew_claim_clicked');
              }
              if (emitter_c != 0) {
                emitter_c.destroy();
                emitter_c = 0;
              }
              popup = 2;
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (itm) {
                  itm.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function () {
                  missions_tab_open = 0;
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                  if (fbv == 1) {
                    window.eventTrack('FTUE_10_9Reward_screen_shown');
                  }
                  console.log('dailyday_prize_current ', dailyday_prize_current);

                  chest_open_window(
                    game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                    dailyday_prize_current,
                    51.5,
                    void 0,
                    {
                      //gameArea: DdnaGameArea.Map,
                      gameArea: null,
                      actionType: null,
                      //actionType: DdnaTransactionActionType.DailyGift,
                    },
                  );
                  source_chest = 'daily bonus';
                  package_id_chest = 0;
                });
            }
          }, this);
          popup_back.addChild(button_green);
          var button_green_text = game.add.text(0, 0, game.cache.getJSON('lang')['Claim'][0][window.lang], {
            font: '50px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          button_green_text.anchor.setTo(0.5);
          button_green_text.stroke = '#47740D';
          button_green_text.strokeThickness = 4;
          button_green_text.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
          button_green.addChild(button_green_text);
          game.add
            .tween(button_green.scale)
            .to({ x: 1, y: 1 }, 500, Phaser.Easing.Exponential.Out, true, 1000)
            .onComplete.add(function () {
              if (FTUE < 151 && nnn == 0) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_10_7_DailyRew_show_arrow');
                }
                if (sound_on == 1) {
                  play_sound('hint_with_arrow');
                }
                FTUE_Arrow = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 + 348,
                  'game_atlas',
                  'FTUE_Arrow.png',
                );
                FTUE_Arrow.angle = 180;
                FTUE_Arrow.anchor.setTo(0.5, 1.6);
                FTUE_Arrow.fixedToCamera = true;
                game.add
                  .tween(FTUE_Arrow.anchor)
                  .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                  .yoyo(true, 200);
                effects_group.add(FTUE_Arrow);
                game.world.bringToTop(effects_group);
              }
            });
        });
    }
    var balloon_timer_2 = 0;
    function balloon_popup() {
      popup_group.y = 0;
      popup_group.y += game.camera.height;
      popup = 1;
      blackf();
      var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
      popup_group.add(popup_back);
      popup_back2 = game.add.sprite(0, 0, 'baloon_atlas', 'Pop_Up_Background.png');
      popup_back2.scale.setTo(2);
      popup_back2.anchor.setTo(0.5);
      popup_back.addChild(popup_back2);
      popup_back.fixedToCamera = true;
      var Main_Excited = game.add.sprite(-230, popup_back2.height / 4, 'char_atlas', 'Main_Excited.png');
      Main_Excited.scale.setTo(1.2);
      Main_Excited.anchor.setTo(0.5, 1);
      popup_back2.addChild(Main_Excited);
      var Pop_Up_Background = game.add.sprite(0, 0, 'baloon_atlas', 'Pop_Up_Frame.png');
      Pop_Up_Background.scale.setTo(0.98);
      Pop_Up_Background.anchor.setTo(0.5);
      popup_back2.addChild(Pop_Up_Background);
      var Balloon = game.add.sprite(-90, -120, 'baloon_atlas', 'Balloon.png');
      Balloon.scale.setTo(0.7);
      Balloon.anchor.setTo(0.5);
      popup_back2.addChild(Balloon);
      var Explanations_Background = game.add.sprite(
        popup_back2.width / 8 + 10,
        -10,
        'baloon_atlas',
        'Explanations_Background.png',
      );
      Explanations_Background.anchor.setTo(0.5);
      popup_back2.addChild(Explanations_Background);
      var button_green = draw_rect(0, 390, 408, 135, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
      draw_rect_shadow(0, 0, 374, 102, '#000', '#000', 0, 0, button_green, 500);
      draw_rect(0, 0, 374, 102, '#7ED12B', '#7ED12B', 0, 0, button_green, 0, 500, 0);
      draw_rect(0, 0, 370, 100, '#C2F33F', '#51C001', 0, 1, button_green, 0, 500, 0);
      button_green.scale.setTo(0.9);
      button_animation_f(button_green, 0.9);
      button_green.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup != 2) {
          popup = 2;
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (itm) {
              itm.destroy();
            });
          game.add
            .tween(popup_group)
            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function () {
              missions_tab_open = 0;
              balloon_timer_2 = 0;
              popup_group.removeAll(true);
              popup = 0;
              popup_group.y -= game.camera.height;
              entryPointData_function();
            });
        }
      }, this);
      popup_back.addChild(button_green);
      var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['Continue'][0][window.lang], {
        font: '48px RussoOne',
        fill: '#fff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 260,
      });
      text_button_green.anchor.setTo(0.5);
      text_button_green.lineSpacing = -10;
      text_button_green.stroke = '#457310';
      text_button_green.strokeThickness = 5;
      text_button_green.setShadow(0, 5, 'rgba(69,115,16,0.7)', 1);
      button_green.addChild(text_button_green);
      var text_popup_title = game.add.text(
        popup_back2.width / 4 + 5,
        -300,
        game.cache.getJSON('lang')['t494'][0][window.lang],
        { font: '54px RussoOne', fill: '#fff', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5);
      popup_back.addChild(text_popup_title);
      text_popup_title.stroke = '#0D6A96';
      text_popup_title.strokeThickness = 4;
      text_popup_title.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
      var text_popup_title = game.add.text(
        popup_back2.width / 4 + 5,
        -210,
        game.cache.getJSON('lang')['t495'][0][window.lang],
        { font: '32px RussoOne', fill: '#8B3B32', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5);
      popup_back.addChild(text_popup_title);
      var Balloon_Explanations_Background = game.add.sprite(
        popup_back2.width / 8 + 10,
        20,
        'baloon_atlas',
        'Balloon_Explanations_Background.png',
      );
      Balloon_Explanations_Background.anchor.setTo(0.5);
      popup_back2.addChild(Balloon_Explanations_Background);
      var Explanations_Illustration = game.add.sprite(
        popup_back2.width / 8 + 10,
        20,
        'baloon_atlas',
        'Explanations_Illustration.png',
      );
      Explanations_Illustration.anchor.setTo(0.5);
      popup_back2.addChild(Explanations_Illustration);
      var graphics = game.add.graphics(popup_back2.width / 4 - 135, 310);
      graphics.beginFill(0x000000);
      graphics.alpha = 0.7;
      graphics.drawRoundedRect(0, 0, 270, 60, 80);
      popup_back.addChild(graphics);
      balloon_timer_2 = game.add.text(popup_back2.width / 4 + 5, 342, '00:00:00', {
        font: '40px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      balloon_timer_2.anchor.setTo(0.5);
      popup_back.addChild(balloon_timer_2);
      game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true);
    }
    var Balloon_Map_Icon = 0;
    var balloon_timer_text = 0;
    function baloon_create(n) {
      if (Balloon_Map_Icon == 0) {
        if (n == 1) {
          baloonDate_new = 0;
          baloonDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          baloonDate.setHours(baloonDate.getHours() + 48);
          game.setUserDataAndLog({ baloonDate: String(baloonDate), baloonDate_new: String(baloonDate_new) });
        }
        Balloon_Map_Icon = game.add.sprite(game.camera.width / 2 - 815, (xmasDate != 0 && xmasDate != -1) ? 470 : 280, 'baloon_atlas', 'Balloon_Map_Icon.png');
        Balloon_Map_Icon.anchor.setTo(0.5);
        Balloon_Map_Icon.scale.setTo(0);
        Balloon_Map_Icon.events.onInputUp.add(function (item) {
          btnup(item);
          if (update_controll == 0) {
            if (Number(lifes) > 0) {
              baloon = 1;
              get_popup();
            } else {
              baloon = 1;
              get_message(1);
            }
          }
        });
        Balloon_Map_Icon.fixedToCamera = true;
        UI_left_group.add(Balloon_Map_Icon);

        var graphics = game.add.graphics(-70, 60);
        graphics.beginFill(0x000000);
        graphics.alpha = 0.5;
        graphics.drawRoundedRect(0, 0, 140, 40, 100);
        Balloon_Map_Icon.addChild(graphics);
        balloon_timer_text = game.add.text(0, 82, '00:00:00', {
          font: '24px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        balloon_timer_text.anchor.setTo(0.5);
        Balloon_Map_Icon.addChild(balloon_timer_text);
        var Balloon_Map_Icon_level = game.add.text(0, -40, 'LV ' + baloonlevel, {
          font: '28px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        Balloon_Map_Icon_level.stroke = '#005F85';
        Balloon_Map_Icon_level.strokeThickness = 4;
        Balloon_Map_Icon_level.anchor.setTo(0.5);
        Balloon_Map_Icon.addChild(Balloon_Map_Icon_level);
        button_animation_f(Balloon_Map_Icon, 1);
        game.add.tween(Balloon_Map_Icon.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true);
      }
      if (n == 1) {
        balloon_popup();
      }
    }
    var sunflower_timer_2 = 0;
    var sunflower_timer = 0;
    var Bean_Icon = 0;
    function sunflower_create(n) {
      if (Bean_Icon == 0) {
        if (n == 1) {
          sunflowerStage = 0;
          sunflowerDate_new = 0;
          sunflowerDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          sunflowerDate.setHours(sunflowerDate.getHours() + 18);
          game.setUserDataAndLog({
            sunflowerDate: String(sunflowerDate),
            sunflowerDate_new: String(sunflowerDate_new),
            sunflowerStage: sunflowerStage,
          });
        }
        var prize_n = 1;
        var sunflowerStage_old = sunflowerStage;
        var sunflowerStage_max = 2;
        if (sunflowerStage >= 2) {
          sunflowerStage_max = 6;
          sunflowerStage_old = sunflowerStage - 2;
          prize_n = 2;
        }
        if (sunflowerStage >= 8) {
          sunflowerStage_max = 12;
          sunflowerStage_old = sunflowerStage - 8;
          prize_n = 3;
        }
        Bean_Icon = game.add.sprite(
          game.camera.width / 2 - 815,
          (xmasDate != 0 && xmasDate != -1) ? 470 : 280,
          'sunflower_atlas',
          'Bean_Icon.png',
        );
        Bean_Icon.anchor.setTo(0.5);
        Bean_Icon.scale.setTo(1);
        Bean_Icon.fixedToCamera = true;
        UI_left_group.add(Bean_Icon);
        button_animation_f(Bean_Icon, 1);
        Bean_Icon.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup == 0 && animation == 0) {
            popup = 2;
            sunflower_popup();
          }
        });
        var Sunflower_Prize = game.add.sprite(0, 75, 'sunflower_atlas', 'Sunflower_Prize_' + prize_n + '.png');
        Sunflower_Prize.anchor.setTo(0.5, 1);
        Bean_Icon.addChild(Sunflower_Prize);

        var Progress_Event_Icons = game.add.sprite(0, 2, 'sunflower_atlas', 'Progress_Event_Icons.png');
        Progress_Event_Icons.anchor.setTo(0.5);
        Bean_Icon.addChild(Progress_Event_Icons);

        var stage_text = game.add.text(0, 46, sunflowerStage_old + '/' + sunflowerStage_max, { font: '24px RussoOne', fill: '#fff', align: 'center' });
        stage_text.anchor.setTo(0.5);
        stage_text.stroke = '#005F85';
        stage_text.strokeThickness = 2;
        stage_text.setShadow(0, 2, 'rgba(0,95,133,0.9)', 0);
        Bean_Icon.addChild(stage_text);

        var graphics = game.add.graphics(-70, 60);
        graphics.beginFill(0x000000);
        graphics.alpha = 0.5;
        graphics.drawRoundedRect(0, 0, 140, 40, 100);
        Bean_Icon.addChild(graphics);
        sunflower_timer = game.add.text(0, 82, '00:00:00', { font: '24px RussoOne', fill: '#fff', align: 'center' });
        sunflower_timer.anchor.setTo(0.5);
        Bean_Icon.addChild(sunflower_timer);
        if (!level_button.children[1] && sunflowerDate != 0) {
          var sunflower_small = game.add.sprite(40, -60, 'sunflower_atlas', 'Bean_Icon.png');
          sunflower_small.anchor.setTo(0.5);
          var Sunflower_Prize = game.add.sprite(0, 75, 'sunflower_atlas', 'Sunflower_Prize_' + prize_n + '.png');
          Sunflower_Prize.anchor.setTo(0.5, 1);
          sunflower_small.addChild(Sunflower_Prize);
          sunflower_small.scale.setTo(0.5);
          level_button.addChild(sunflower_small);
        }
      }
      if (n == 1) {
        sunflower_popup();
      }
    }
    function sunflower_popup() {
      popup_group.y = 0;
      popup_group.y += game.camera.height;
      popup = 1;
      blackf();
      var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
      popup_group.add(popup_back);
      popup_back2 = game.add.sprite(0, 0, 'sunflower_atlas', 'Pop_Up_Background.png');
      popup_back2.scale.setTo(2);
      popup_back2.anchor.setTo(0.5);
      popup_back.addChild(popup_back2);
      popup_back.fixedToCamera = true;
      var Balloon = game.add.sprite(-70, popup_back2.height / 4, 'sunflower_atlas', 'Sunflower.png');
      Balloon.scale.setTo(1);
      Balloon.anchor.setTo(0.5, 1);
      popup_back2.addChild(Balloon);
      var Main_Excited = game.add.sprite(-215, popup_back2.height / 4, 'char_atlas', 'Mrs_Evergreen_excited.png');
      Main_Excited.scale.setTo(-1.4, 1.4);
      Main_Excited.anchor.setTo(0.5, 1);
      popup_back2.addChild(Main_Excited);
      var Pop_Up_Background = game.add.sprite(0, 0, 'sunflower_atlas', 'Pop_Up_Frame.png');
      Pop_Up_Background.scale.setTo(1);
      Pop_Up_Background.anchor.setTo(0.5);
      popup_back2.addChild(Pop_Up_Background);
      var Explanations_Background = game.add.sprite(
        popup_back2.width / 8 + 10,
        -10,
        'sunflower_atlas',
        'Explanations_Background.png',
      );
      Explanations_Background.anchor.setTo(0.5);
      popup_back2.addChild(Explanations_Background);
      var button_green = draw_rect(0, 390, 408, 135, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
      draw_rect_shadow(0, 0, 374, 102, '#000', '#000', 0, 0, button_green, 500);
      draw_rect(0, 0, 374, 102, '#7ED12B', '#7ED12B', 0, 0, button_green, 0, 500, 0);
      draw_rect(0, 0, 370, 100, '#C2F33F', '#51C001', 0, 1, button_green, 0, 500, 0);
      button_green.scale.setTo(0.9);
      button_animation_f(button_green, 0.9);
      button_green.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup != 2) {
          popup = 2;
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (itm) {
              itm.destroy();
            });
          game.add
            .tween(popup_group)
            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function () {
              missions_tab_open = 0;
              sunflower_timer_2 = 0;
              popup_group.removeAll(true);
              popup = 0;
              popup_group.y -= game.camera.height;
              entryPointData_function();
            });
        }
      }, this);
      popup_back.addChild(button_green);
      var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['Continue'][0][window.lang], {
        font: '48px RussoOne',
        fill: '#fff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 260,
      });
      text_button_green.anchor.setTo(0.5);
      text_button_green.lineSpacing = -10;
      text_button_green.stroke = '#457310';
      text_button_green.strokeThickness = 5;
      text_button_green.setShadow(0, 5, 'rgba(69,115,16,0.7)', 1);
      button_green.addChild(text_button_green);
      var text_popup_title = game.add.text(
        popup_back2.width / 4 + 20,
        -320,
        game.cache.getJSON('lang')['t492'][0][window.lang],
        { font: '46px RussoOne', fill: '#fff', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5);
      popup_back.addChild(text_popup_title);
      text_popup_title.stroke = '#0D6A96';
      text_popup_title.strokeThickness = 4;
      text_popup_title.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
      var text_popup_title = game.add.text(
        popup_back2.width / 4 + 20,
        -210,
        game.cache.getJSON('lang')['t493'][0][window.lang],
        { font: '32px RussoOne', fill: '#8B3B32', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5);
      popup_back.addChild(text_popup_title);
      var Balloon_Explanations_Background = game.add.sprite(
        popup_back2.width / 8 + 10,
        20,
        'sunflower_atlas',
        'Sun_Explanations_Background.png',
      );
      Balloon_Explanations_Background.anchor.setTo(0.5);
      popup_back2.addChild(Balloon_Explanations_Background);
      var Explanations_Illustration = game.add.sprite(
        popup_back2.width / 8 - 10,
        40,
        'sunflower_atlas',
        'Sunflower_Size.png',
      );
      Explanations_Illustration.anchor.setTo(0.5);
      popup_back2.addChild(Explanations_Illustration);
      var Gift_1 = game.add.sprite(popup_back2.width / 4 + 145, 120, 'sunflower_atlas', 'Gift_1.png');
      Gift_1.anchor.setTo(0.5);
      popup_back.addChild(Gift_1);
      var Gift_2 = game.add.sprite(popup_back2.width / 4 + 145, 20, 'sunflower_atlas', 'Gift_2.png');
      Gift_2.anchor.setTo(0.5);
      popup_back.addChild(Gift_2);
      var Gift_3 = game.add.sprite(popup_back2.width / 4 + 145, -80, 'sunflower_atlas', 'Gift_3.png');
      Gift_3.anchor.setTo(0.5);
      popup_back.addChild(Gift_3);
      var graphics = game.add.graphics(popup_back2.width / 4 - 135 + 15, 310);
      graphics.beginFill(0x000000);
      graphics.alpha = 0.7;
      graphics.drawRoundedRect(0, 0, 270, 60, 80);
      popup_back.addChild(graphics);
      sunflower_timer_2 = game.add.text(popup_back2.width / 4 + 15, 342, '00:00:00', {
        font: '40px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      sunflower_timer_2.anchor.setTo(0.5);
      popup_back.addChild(sunflower_timer_2);
      sunflowertimer();
      game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true);
    }
    var xmas_Icon = 0;
    var xmas_timer = 0;
    function xmas_create(n) {
      if (xmas_Icon == 0) {
        if (n == 1) {
          xmasDate = new Date('2021-01-02');
          game.setUserDataAndLog({ xmasDate: String(xmasDate) });
        }
        xmas_Icon = game.add.sprite(
          game.camera.width / 2 - 815,
          280,
          'xmas_atlas',
          'MENU131.png',
        );
        xmas_Icon.anchor.setTo(0.5);
        xmas_Icon.fixedToCamera = true;
        UI_left_group.add(xmas_Icon);
        button_animation_f(xmas_Icon, 1);
        xmas_Icon.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup == 0 && animation == 0) {
            popup = 2;
            xmas = 1;
            from_map = 1;
            if (n == 1 || xmas == 1) {
              buch_rnd = 5;
            }
            else {
              if (buch_rnd == 5) { buch_rnd = game.rnd.integerInRange(1, 4); }
            }
            animation = 1;
            var graphics = game.add.graphics(0, 0);
            if (n == 0 && xmas == 0) {
              graphics.beginFill(0x386217);
            } else {
              graphics.beginFill(0x74ADBA);
            }
            graphics.alpha = 0;
            graphics.drawRect(0, 0, game.camera.width, game.camera.height);
            graphics.fixedToCamera = true;
            game.add.tween(graphics).to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true);
            buch_create(game.camera.width / 2 + 150, -1000, -2.2, -2.2, '0', '+900', 45, 800, 0xffffff, buch_rnd);
            buch_create(
              game.camera.width / 2 - 150,
              game.camera.height + 1000,
              2.2,
              2.2,
              '0',
              '-900',
              45,
              800,
              0xffffff,
              buch_rnd,
            );
            var graphics = game.add.graphics(0, 0);
            if (n == 0 && xmas == 0) {
              graphics.beginFill(0x386217);
            } else {
              graphics.beginFill(0x74ADBA);
            }
            graphics.alpha = 0;
            graphics.drawRect(0, 0, game.camera.width, game.camera.height);
            graphics.fixedToCamera = true;
            game.add.tween(graphics).to({ alpha: 0.5 }, 800, Phaser.Easing.Linear.None, true);
            buch_create(
              game.camera.width + 1000,
              game.camera.height + 1000,
              2.2,
              2.2,
              '-1000',
              '-1000',
              0,
              0,
              0xffffff,
              buch_rnd,
            );
            buch_create(-1000, -1000, -2.2, 2.2, '+1000', '+1000', 90, 0, 0xffffff, buch_rnd);
            buch_create(game.camera.width + 1000, -1000, 2.2, -2.2, '-1000', '+1000', 0, 400, 0xffffff, buch_rnd);
            buch_create(-1000, game.camera.height + 1000, -2.2, -2.2, '+1000', '-1000', -90, 400, 0xffffff, buch_rnd);
            if (sound_on == 1) {
              play_sound('leaves');
            }

            game.time.events.add(2500, function () {
              for (var m = 0; m < angl_mas.length; m++) {
                angl_mas2[m] = angl_mas[m].angle;
              }
              worldScale = 0.8;
              follow.x = 1800 * worldScale;
              follow.y = 1600 * worldScale;
              last_position = [1800 * worldScale, 1600 * worldScale];
              game.world.removeAll(true);
              game.state.start('Map');
            });
          }
        });
        var graphics = game.add.graphics(-70, 60);
        graphics.beginFill(0x000000);
        graphics.alpha = 0.5;
        graphics.drawRoundedRect(0, 0, 140, 40, 100);
        xmas_Icon.addChild(graphics);
        xmas_timer = game.add.text(0, 82, '00:00:00', { font: '24px RussoOne', fill: '#fff', align: 'center' });
        xmas_timer.anchor.setTo(0.5);
        xmas_Icon.addChild(xmas_timer);
      }
      /*if (n == 1) {
        magicbean_popup();
      }*/
    }

    function xmas_popup() {
      popup_group.y = 0;
      popup_group.y += game.camera.height;
      popup = 1;
      blackf();
      var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
      popup_group.add(popup_back);
      popup_back2 = game.add.sprite(0, 0, 'xmas_atlas', 'Pop_Up_Background.png');
      popup_back2.scale.setTo(4);
      popup_back2.anchor.setTo(0.5);
      popup_back.addChild(popup_back2);
      popup_back.fixedToCamera = true;
      var Main_Excited = game.add.sprite(-480, 369, 'char_atlas', 'Main_Presenting_h.png');
      Main_Excited.scale.setTo(2.8);
      Main_Excited.anchor.setTo(0.5, 1);
      popup_back.addChild(Main_Excited);
      var Explanations_Background = game.add.sprite(
        240,
        -10,
        'xmas_atlas',
        'Info_Background.png',
      );
      Explanations_Background.scale.setTo(4);
      Explanations_Background.anchor.setTo(0.5);
      popup_back.addChild(Explanations_Background);

      var button_green = draw_rect(0, 390, 408, 135, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
      draw_rect_shadow(0, 0, 374, 102, '#000', '#000', 0, 0, button_green, 500);
      draw_rect(0, 0, 374, 102, '#7ED12B', '#7ED12B', 0, 0, button_green, 0, 500, 0);
      draw_rect(0, 0, 370, 100, '#C2F33F', '#51C001', 0, 1, button_green, 0, 500, 0);
      button_green.scale.setTo(0.9);
      button_animation_f(button_green, 0.9);
      button_green.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup != 2) {
          popup = 2;
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (itm) {
              itm.destroy();
            });
          game.add
            .tween(popup_group)
            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function () {
              missions_tab_open = 0;
              popup_group.removeAll(true);
              popup = 0;
              popup_group.y -= game.camera.height;
            });
        }
      }, this);
      popup_back.addChild(button_green);
      var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['Continue'][0][window.lang], {
        font: '48px RussoOne',
        fill: '#fff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 260,
      });
      text_button_green.anchor.setTo(0.5);
      text_button_green.lineSpacing = -10;
      text_button_green.stroke = '#457310';
      text_button_green.strokeThickness = 5;
      text_button_green.setShadow(0, 5, 'rgba(69,115,16,0.7)', 1);
      button_green.addChild(text_button_green);

      var text_popup_title = game.add.text(
        250,
        -270,
        game.cache.getJSON('lang')['t502'][0][window.lang],
        { font: '52px RussoOne', fill: '#fff', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5);
      popup_back.addChild(text_popup_title);
      text_popup_title.stroke = '#FA6597';
      text_popup_title.strokeThickness = 8;
      text_popup_title.setShadow(0, 5, 'rgba(154,52,27,1)', 2);

      var Reach_Milestone_Pic = game.add.sprite(
        250,
        0,
        'xmas_atlas',
        'Reach_Milestone_Pic.png',
      );
      Reach_Milestone_Pic.anchor.setTo(0.5);
      popup_back.addChild(Reach_Milestone_Pic);

      var text_popup_title = game.add.text(
        250,
        150,
        game.cache.getJSON('lang')['t504'][0][window.lang],
        { font: '26px RussoOne', fill: '#941A00', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5, 0);
      text_popup_title.lineSpacing = -10;
      popup_back.addChild(text_popup_title);

      var Complete_Level_Pic = game.add.sprite(
        -60,
        0,
        'xmas_atlas',
        'Complete_Level_Pic.png',
      );
      Complete_Level_Pic.anchor.setTo(0.5);
      popup_back.addChild(Complete_Level_Pic);

      var text_popup_title = game.add.text(
        -60,
        150,
        game.cache.getJSON('lang')['t503'][0][window.lang],
        { font: '26px RussoOne', fill: '#941A00', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5, 0);
      text_popup_title.lineSpacing = -10;
      popup_back.addChild(text_popup_title);

      var Arrow = game.add.sprite(
        100,
        0,
        'xmas_atlas',
        'Arrow.png',
      );
      Arrow.anchor.setTo(0.5);
      popup_back.addChild(Arrow);

      var Earn_Deco_Pic = game.add.sprite(
        560,
        0,
        'xmas_atlas',
        'Earn_Deco_Pic.png',
      );
      Earn_Deco_Pic.anchor.setTo(0.5);
      popup_back.addChild(Earn_Deco_Pic);

      var text_popup_title = game.add.text(
        560,
        150,
        game.cache.getJSON('lang')['t505'][0][window.lang],
        { font: '26px RussoOne', fill: '#941A00', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5, 0);
      text_popup_title.lineSpacing = -10;
      popup_back.addChild(text_popup_title);

      var Arrow = game.add.sprite(
        400,
        0,
        'xmas_atlas',
        'Arrow.png',
      );
      Arrow.anchor.setTo(0.5);
      popup_back.addChild(Arrow);

      game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true);
    }

    var magicbean_timer_2 = 0;
    var magicbean_timer = 0;
    var MagicBean_Icon = 0;
    function magicbean_create(n) {
      if (MagicBean_Icon == 0) {
        if (n == 1) {
          magicbeanStage = 0;
          magicbeanDate_new = 0;
          magicbeanDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          magicbeanDate.setHours(magicbeanDate.getHours() + 18);
          game.setUserDataAndLog({
            magicbeanDate: String(magicbeanDate),
            magicbeanDate_new: String(magicbeanDate_new),
          });
        }
        var prize_n = 0;
        var magicbeanStage_max = 2;
        if (magicbeanStage >= 2) {
          magicbeanStage_max = 6;
          prize_n = 1;
        }
        if (magicbeanStage >= 6) {
          magicbeanStage_max = 12;
          prize_n = 2;
        }
        if (magicbeanStage >= 12) {
          magicbeanStage_max = 20;
          prize_n = 3;
        }
        if (magicbeanStage >= 20) {
          magicbeanStage_max = 20;
          prize_n = 4;
        }
        MagicBean_Icon = game.add.sprite(
          game.camera.width / 2 - 815,
          (xmasDate != 0 && xmasDate != -1) ? 470 : 280,
          'magicbean_atlas',
          'Bean_Icon.png',
        ); //470
        MagicBean_Icon.anchor.setTo(0.5);
        MagicBean_Icon.fixedToCamera = true;
        UI_left_group.add(MagicBean_Icon);
        button_animation_f(MagicBean_Icon, 1);
        MagicBean_Icon.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup == 0 && animation == 0) {
            popup = 2;
            magicbean_popup();
          }
        });
        var MagicBean_Prize = game.add.sprite(0, 70, 'magicbean_atlas', 'Bean_Prize_' + prize_n + '.png');
        MagicBean_Prize.anchor.setTo(0.5, 1);
        MagicBean_Icon.addChild(MagicBean_Prize);

        var Progress_Event_Icons = game.add.sprite(0, 2, 'magicbean_atlas', 'Progress_Event_Icons.png');
        Progress_Event_Icons.anchor.setTo(0.5);
        MagicBean_Icon.addChild(Progress_Event_Icons);

        var stage_text = game.add.text(0, 46, magicbeanStage + '/' + magicbeanStage_max, { font: '24px RussoOne', fill: '#fff', align: 'center' });
        stage_text.anchor.setTo(0.5);
        stage_text.stroke = '#005F85';
        stage_text.strokeThickness = 2;
        stage_text.setShadow(0, 2, 'rgba(0,95,133,0.9)', 0);
        MagicBean_Icon.addChild(stage_text);

        var graphics = game.add.graphics(-70, 60);
        graphics.beginFill(0x000000);
        graphics.alpha = 0.5;
        graphics.drawRoundedRect(0, 0, 140, 40, 100);
        MagicBean_Icon.addChild(graphics);
        magicbean_timer = game.add.text(0, 82, '00:00:00', { font: '24px RussoOne', fill: '#fff', align: 'center' });
        magicbean_timer.anchor.setTo(0.5);
        MagicBean_Icon.addChild(magicbean_timer);
        if (!level_button.children[1] && magicbeanDate != 0) {
          var Icon_Level_Button = game.add.sprite(40, -60, 'magicbean_atlas', 'Icon_Level_Button.png');
          Icon_Level_Button.anchor.setTo(0.5);
          level_button.addChild(Icon_Level_Button);
        }
      }
      if (n == 1) {
        magicbean_popup();
      }
    }
    function magicbean_popup() {
      popup_group.y = 0;
      popup_group.y += game.camera.height;
      popup = 1;
      blackf();
      var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
      popup_group.add(popup_back);
      popup_back2 = game.add.sprite(0, 0, 'magicbean_atlas', 'Pop_Up_Background.png');
      popup_back2.scale.setTo(2);
      popup_back2.anchor.setTo(0.5);
      popup_back.addChild(popup_back2);
      popup_back.fixedToCamera = true;
      var Main_Excited = game.add.sprite(-180, popup_back2.height / 4, 'magicbean_atlas', 'Character.png');
      Main_Excited.scale.setTo(1);
      Main_Excited.anchor.setTo(0.5, 1);
      popup_back2.addChild(Main_Excited);
      var Pop_Up_Background = game.add.sprite(0, 0, 'magicbean_atlas', 'Pop_Up_Frame.png');
      Pop_Up_Background.scale.setTo(1);
      Pop_Up_Background.anchor.setTo(0.5);
      popup_back2.addChild(Pop_Up_Background);
      var Explanations_Background = game.add.sprite(
        popup_back2.width / 8 + 10,
        -10,
        'magicbean_atlas',
        'Explanations_Background.png',
      );
      Explanations_Background.anchor.setTo(0.5);
      popup_back2.addChild(Explanations_Background);
      var button_green = draw_rect(0, 390, 408, 135, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
      draw_rect_shadow(0, 0, 374, 102, '#000', '#000', 0, 0, button_green, 500);
      draw_rect(0, 0, 374, 102, '#7ED12B', '#7ED12B', 0, 0, button_green, 0, 500, 0);
      draw_rect(0, 0, 370, 100, '#C2F33F', '#51C001', 0, 1, button_green, 0, 500, 0);
      button_green.scale.setTo(0.9);
      button_animation_f(button_green, 0.9);
      button_green.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup != 2) {
          popup = 2;
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (itm) {
              itm.destroy();
            });
          game.add
            .tween(popup_group)
            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function () {
              missions_tab_open = 0;
              magicbean_timer_2 = 0;
              popup_group.removeAll(true);
              popup = 0;
              popup_group.y -= game.camera.height;
              entryPointData_function();
            });
        }
      }, this);
      popup_back.addChild(button_green);
      var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['Continue'][0][window.lang], {
        font: '48px RussoOne',
        fill: '#fff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 260,
      });
      text_button_green.anchor.setTo(0.5);
      text_button_green.lineSpacing = -10;
      text_button_green.stroke = '#457310';
      text_button_green.strokeThickness = 5;
      text_button_green.setShadow(0, 5, 'rgba(69,115,16,0.7)', 1);
      button_green.addChild(text_button_green);
      var text_popup_title = game.add.text(
        popup_back2.width / 4 + 20,
        -320,
        game.cache.getJSON('lang')['t496'][0][window.lang],
        { font: '46px RussoOne', fill: '#fff', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5);
      popup_back.addChild(text_popup_title);
      text_popup_title.stroke = '#0D6A96';
      text_popup_title.strokeThickness = 4;
      text_popup_title.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
      var text_popup_title = game.add.text(
        popup_back2.width / 4 + 20,
        -200,
        game.cache.getJSON('lang')['t497'][0][window.lang],
        { font: '32px RussoOne', fill: '#8B3B32', align: 'center' },
      );
      text_popup_title.anchor.setTo(0.5);
      popup_back.addChild(text_popup_title);
      var Balloon_Explanations_Background = game.add.sprite(
        popup_back2.width / 8 + 10,
        20,
        'magicbean_atlas',
        'Beans_Explanations_Background.png',
      );
      Balloon_Explanations_Background.anchor.setTo(0.5);
      popup_back2.addChild(Balloon_Explanations_Background);
      var Explanations_Illustration = game.add.sprite(
        popup_back2.width / 8 + 10,
        40,
        'magicbean_atlas',
        'Plant_Progress.png',
      );
      Explanations_Illustration.anchor.setTo(0.5);
      popup_back2.addChild(Explanations_Illustration);
      var Gift_1 = game.add.sprite(popup_back2.width / 4 - 150, 20, 'magicbean_atlas', 'Prize_1.png');
      Gift_1.anchor.setTo(0.5);
      popup_back.addChild(Gift_1);
      var Gift_2 = game.add.sprite(popup_back2.width / 4 - 40, -20, 'magicbean_atlas', 'Prize_2.png');
      Gift_2.anchor.setTo(0.5);
      popup_back.addChild(Gift_2);
      var Gift_3 = game.add.sprite(popup_back2.width / 4 + 70, -60, 'magicbean_atlas', 'Prize_3.png');
      Gift_3.anchor.setTo(0.5);
      popup_back.addChild(Gift_3);
      var Gift_4 = game.add.sprite(popup_back2.width / 4 + 180, -100, 'magicbean_atlas', 'Prize_4.png');
      Gift_4.anchor.setTo(0.5);
      popup_back.addChild(Gift_4);
      var graphics = game.add.graphics(popup_back2.width / 4 - 135 + 15, 310);
      graphics.beginFill(0x000000);
      graphics.alpha = 0.7;
      graphics.drawRoundedRect(0, 0, 270, 60, 80);
      popup_back.addChild(graphics);
      magicbean_timer_2 = game.add.text(popup_back2.width / 4 + 15, 342, '00:00:00', {
        font: '40px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      magicbean_timer_2.anchor.setTo(0.5);
      popup_back.addChild(magicbean_timer_2);
      magicbeantimer();
      game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true);
    }

    fx = game.add.audioSprite('sfx');
    fx.allowMultiple = true;
    game.input.maxPointers = 1;
    if (day_prize.length < 5) {
      day_prize.push(0);
    }
    loading_complete = 1;
    pre_helper = 0;
    consumed_5Cards = 0;
    consumed_5Cards_x2 = 0;
    consumed_5Cards_x3 = 0;
    consumed_5cards_all = 0;
    consumed_joker = 0;
    consumed_TNT = 0;
    consumed_Shuffle = 0;
    consumed_backbutton = 0;
    consumed_3Helpercards = 0;
    result = 0;
    moves_used = 0;
    popup = 0;
    missions_tab_open = 0;
    animation = 0;
    dreset = 0;
    map_stop = 0;
    function res_load() {

      if (game.cache.checkImageKey('mayor_reward_atlas') != true) {
        game.load.atlasJSONHash(
          'mayor_reward_atlas',
          'resource/mayor_reward.png',
          'resource/mayor_reward.json',
          1,
        );
      }

      if (game.cache.checkImageKey('ingame_atlas') != true) {
        game.load.atlasJSONHash('ingame_atlas', 'resource/ingame.png', 'resource/ingame.json', 1);
      }
      if (game.cache.checkImageKey('photo_atlas') != true) {
        game.load.atlasJSONHash('photo_atlas', 'resource/photo_atlas.png', 'resource/photo_atlas.json');
      }
      if (game.cache.checkSoundKey('gameplay_music') != true) {
        game.load.audio('gameplay_music', 'resource/audio/gameplay_music.mp3', 1);
      }
    }
    res_load();
    game.load.start();
    game.load.onFileComplete.add(function (progress, cacheKey, success, totalLoaded, totalFiles) {
      if (load_com == 1 && is_map == 1) {
        if (success == false) {
          game.load.removeAll();
          res_load();
        }
      }
    }, this);
    window.play_sound = function (snd) {
      fx.play(snd);
    };
    window.balloon_on = function () {
      if (cheat == 1) {
        if (baloonlevel <= baloonlevel_max) {

          magicbeanStage = 0;
          magicbeanDate = 0;
          magicbeanDate_new =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          magicbeanDate_new.setHours(magicbeanDate_new.getHours() + 144);
          if (MagicBean_Icon != 0) {
            MagicBean_Icon.destroy();
            sunflower_timer = 0;
            magicbean_timer_2 = 0;
            magicbean_timer = 0;
            MagicBean_Icon = 0;
            level_button.children[1].destroy();
          }
          game.setUserDataAndLog({
            magicbeanDate: String(magicbeanDate),
            magicbeanDate_new: String(magicbeanDate_new),
            magicbeanStage: magicbeanStage,
          });

          sunflowerDate = 0;
          sunflowerDate_new =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          sunflowerDate_new.setHours(sunflowerDate_new.getHours() + 120);
          if (Bean_Icon != 0) {
            Bean_Icon.destroy();
            sunflower_timer = 0;
            sunflower_timer_2 = 0;
            sunflower_timer = 0;
            Bean_Icon = 0;
            level_button.children[1].destroy();
          }
          game.setUserDataAndLog({ sunflowerDate: String(sunflowerDate), sunflowerDate_new: String(sunflowerDate_new) });

          baloon_create(1);
        }
      }
    };
    window.sunflower_on = function () {
      if (cheat == 1) {

        baloonDate = 0;
        baloonDate_new =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        baloonDate_new.setHours(baloonDate_new.getHours() + 168);
        if (Balloon_Map_Icon != 0) {
          Balloon_Map_Icon.destroy();
          balloon_timer_text = 0;
          Balloon_Map_Icon = 0;
        }
        game.setUserDataAndLog({ baloonDate: String(baloonDate), baloonDate_new: String(baloonDate_new) });

        magicbeanStage = 0;
        magicbeanDate = 0;
        magicbeanDate_new =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        magicbeanDate_new.setHours(magicbeanDate_new.getHours() + 144);
        if (MagicBean_Icon != 0) {
          MagicBean_Icon.destroy();
          sunflower_timer = 0;
          magicbean_timer_2 = 0;
          magicbean_timer = 0;
          MagicBean_Icon = 0;
          level_button.children[1].destroy();
        }
        game.setUserDataAndLog({
          magicbeanDate: String(magicbeanDate),
          magicbeanDate_new: String(magicbeanDate_new),
          magicbeanStage: magicbeanStage,
        });
        sunflower_create(1);
      }
    };
    window.magicbean_on = function () {
      if (cheat == 1) {

        baloonDate = 0;
        baloonDate_new =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        baloonDate_new.setHours(baloonDate_new.getHours() + 168);
        if (Balloon_Map_Icon != 0) {
          Balloon_Map_Icon.destroy();
          balloon_timer_text = 0;
          Balloon_Map_Icon = 0;
        }
        game.setUserDataAndLog({ baloonDate: String(baloonDate), baloonDate_new: String(baloonDate_new) });

        sunflowerDate = 0;
        sunflowerDate_new =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        sunflowerDate_new.setHours(sunflowerDate_new.getHours() + 120);
        if (Bean_Icon != 0) {
          Bean_Icon.destroy();
          sunflower_timer = 0;
          sunflower_timer_2 = 0;
          sunflower_timer = 0;
          Bean_Icon = 0;
          level_button.children[1].destroy();
        }
        game.setUserDataAndLog({ sunflowerDate: String(sunflowerDate), sunflowerDate_new: String(sunflowerDate_new) });
        magicbean_create(1);
      }
    };
    window.specialoffers = function (n) {
      if (cheat == 1) {

        if (offer_icon != 0) {
          offer_icon.destroy();
          offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
        }
        offer_mas = [];

        if (n == 0) first_buyer_window(15, 15);
        else if (n == 1)
          special_sales_packages(1, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack2'][0][window.lang], 16);
        else if (n == 2)
          special_sales_packages(2, 'Carls_Package_Frame', game.cache.getJSON('lang')['pack1'][0][window.lang], 19);
        else if (n == 3)
          special_sales_packages(
            3,
            'Good_Day_Package_Mock_Up',
            game.cache.getJSON('lang')['pack3'][0][window.lang],
            25,
          );
        else if (n == 4)
          special_sales_packages(4, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack4'][0][window.lang], 20);
        /*else if (n == 5)
          special_sales_packages(
            5,
            'Random_booster_package_Frame',
            game.cache.getJSON('lang')['pack5'][0][window.lang],
            46,
          );*/
        else if (n == 6)
          special_sales_packages(6, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 21);
        else if (n == 7)
          special_sales_packages(8, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 31);
        /*else if (n == 8)
          special_sales_packages(9, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 41);
        else if (n == 9)
          special_sales_packages(10, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 51);
        else if (n == 10)
          special_sales_packages(11, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 61);*/
        else if (n == 11)
          special_sales_packages(7, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack8'][0][window.lang], 45);
        /*else if (n == 12)
          special_sales_packages(12, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack7'][0][window.lang], 35);*/
        else if (n == 13)
          special_sales_packages(13, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack9'][0][window.lang], 36);
      }
    };
    window.buysuccess = function () {
      animation = 100;
    };
    window.setstars = function (n) {
      if (cheat == 1) {
        all_stars += n;
        text_stars_panel.setText(all_stars);
      }
    };
    window.setcoins = function (n) {
      if (cheat == 1) {
        coins += n;
        text_coins_panel.setText(coins);
      }
    };
    window.setlang = function (n) {
      if (cheat == 1) {
        window.lang = n;
        game.world.removeAll(true);
        game.state.start('Map');
      }
    };
    window.setunlimenergyh = function (n) {
      if (cheat == 1) {
        unlimited_energy_h = n;
      }
    };
    window.nextday = function (d) {
      if (cheat == 1) {
        complete_task_i = -1;
        if (d == -1) {
          for (var j = 0; j < day_tasks.length; j++) {
            if (mission_number.indexOf(day_tasks[j]['type']) != -1)
              mission_number.splice(mission_number.indexOf(day_tasks[j]['type']), 1);
            if (
              day_tasks[j]['type'] == 7 ||
              day_tasks[j]['type'] == 6 ||
              day_tasks[j]['type'] == 14 ||
              day_tasks[j]['type'] == 4 ||
              day_tasks[j]['type'] == 5 ||
              day_tasks[j]['type'] == 9 ||
              day_tasks[j]['type'] == 8 ||
              day_tasks[j]['type'] == 10 ||
              day_tasks[j]['type'] == 12 ||
              day_tasks[j]['type'] == 15 ||
              day_tasks[j]['type'] == 16 ||
              day_tasks[j]['type'] == 29 ||
              day_tasks[j]['type'] == 30 ||
              day_tasks[j]['type'] == 31 ||
              day_tasks[j]['type'] == 11 ||
              day_tasks[j]['type'] == 34 ||
              day_tasks[j]['type'] == 35 ||
              day_tasks[j]['type'] == 39 ||
              day_tasks[j]['type'] == 40 ||
              day_tasks[j]['type'] == 33 ||
              day_tasks[j]['type'] == 55 ||
              day_tasks[j]['type'] == 47 ||
              day_tasks[j]['type'] == 27 ||
              day_tasks[j]['type'] == 58 ||
              day_tasks[j]['type'] == 61 ||
              day_tasks[j]['type'] == 63 ||
              day_tasks[j]['type'] == 28 ||
              day_tasks[j]['type'] == 59 ||
              day_tasks[j]['type'] == 57 ||
              day_tasks[j]['type'] == 75 ||
              day_tasks[j]['type'] == 49 ||
              day_tasks[j]['type'] == 109 ||
              day_tasks[j]['type'] == 184 ||
              day_tasks[j]['type'] == 116 ||
              day_tasks[j]['type'] == 117 ||
              day_tasks[j]['type'] == 119 ||
              day_tasks[j]['type'] == 53 ||
              day_tasks[j]['type'] == 51 ||
              day_tasks[j]['type'] == 92 ||
              day_tasks[j]['type'] == 99 ||
              day_tasks[j]['type'] == 91 ||
              day_tasks[j]['type'] == 106 ||
              day_tasks[j]['type'] == 24 ||
              day_tasks[j]['type'] == 96 ||
              day_tasks[j]['type'] == 95 ||
              day_tasks[j]['type'] == 431 ||
              day_tasks[j]['type'] == 43 ||
              day_tasks[j]['type'] == 541 ||
              day_tasks[j]['type'] == 54 ||
              day_tasks[j]['type'] == 72 ||
              day_tasks[j]['type'] == 130 ||
              day_tasks[j]['type'] == 128 ||
              day_tasks[j]['type'] == 129 ||
              day_tasks[j]['type'] == 149 ||
              day_tasks[j]['type'] == 140 ||
              day_tasks[j]['type'] == 141
            ) {
              if (
                map_tiled_st.findIndex(function (e) {
                  return Number(e['i']) == Number(day_tasks[j]['type']);
                }) != -1
              ) {
                map_tiled_st.splice(
                  map_tiled_st.findIndex(function (e) {
                    return Number(e['i']) == Number(day_tasks[j]['type']);
                  }),
                  1,
                );
              }
              for (var i = 1; i <= 7; i++) {
                if (special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 0)) != -1)
                  special_object.splice(special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 0)), 1);
                if (special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 1)) != -1)
                  special_object.splice(special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 1)), 1);
                if (special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 2)) != -1)
                  special_object.splice(special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 2)), 1);
              }
              objects_group.children.forEach(function (child_item) {
                if (child_item.type == day_tasks[j]['type']) {
                  child_item.inputEnabled = false;
                }
              });
            }
          }
          mission_stars_end = 0;
          mission_day_end_old = 0;
          day_prize = [0, 0, 0, 0, 0, 0];
          mission_task = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          map_n -= 1;
          day_tasks = [];
          all_day_build = Number(game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0]['builds']);
          for (var i = 0; i < all_day_build; i++) {
            let type = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['type'];
            let sprite = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['icon'];
            let atlas = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['atlas'];
            let preDialog = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0][
              'preDialog'
            ];
            let ifComplete = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0][
              'ifComplete'
            ];
            let stars = Number(
              game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['stars'],
            );
            let texts = game.cache.getJSON('lang')[
              game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['text']
            ][0][window.lang];
            let dial = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['Dialog'];
            day_tasks.push({
              type: type,
              sprite: sprite,
              atlas: atlas,
              preDialog: preDialog,
              ifComplete: ifComplete,
              stars: stars,
              text: texts,
              dialog: dial,
            });
          }
          for (var j = 0; j < day_tasks.length; j++) {
            if (mission_number.indexOf(day_tasks[j]['type']) != -1)
              mission_number.splice(mission_number.indexOf(day_tasks[j]['type']), 1);
            if (
              day_tasks[j]['type'] == 7 ||
              day_tasks[j]['type'] == 6 ||
              day_tasks[j]['type'] == 14 ||
              day_tasks[j]['type'] == 4 ||
              day_tasks[j]['type'] == 5 ||
              day_tasks[j]['type'] == 9 ||
              day_tasks[j]['type'] == 8 ||
              day_tasks[j]['type'] == 10 ||
              day_tasks[j]['type'] == 12 ||
              day_tasks[j]['type'] == 15 ||
              day_tasks[j]['type'] == 16 ||
              day_tasks[j]['type'] == 29 ||
              day_tasks[j]['type'] == 30 ||
              day_tasks[j]['type'] == 31 ||
              day_tasks[j]['type'] == 11 ||
              day_tasks[j]['type'] == 34 ||
              day_tasks[j]['type'] == 35 ||
              day_tasks[j]['type'] == 39 ||
              day_tasks[j]['type'] == 40 ||
              day_tasks[j]['type'] == 33 ||
              day_tasks[j]['type'] == 55 ||
              day_tasks[j]['type'] == 47 ||
              day_tasks[j]['type'] == 27 ||
              day_tasks[j]['type'] == 58 ||
              day_tasks[j]['type'] == 61 ||
              day_tasks[j]['type'] == 63 ||
              day_tasks[j]['type'] == 28 ||
              day_tasks[j]['type'] == 59 ||
              day_tasks[j]['type'] == 57 ||
              day_tasks[j]['type'] == 75 ||
              day_tasks[j]['type'] == 49 ||
              day_tasks[j]['type'] == 109 ||
              day_tasks[j]['type'] == 184 ||
              day_tasks[j]['type'] == 116 ||
              day_tasks[j]['type'] == 117 ||
              day_tasks[j]['type'] == 119 ||
              day_tasks[j]['type'] == 53 ||
              day_tasks[j]['type'] == 51 ||
              day_tasks[j]['type'] == 92 ||
              day_tasks[j]['type'] == 99 ||
              day_tasks[j]['type'] == 91 ||
              day_tasks[j]['type'] == 106 ||
              day_tasks[j]['type'] == 24 ||
              day_tasks[j]['type'] == 96 ||
              day_tasks[j]['type'] == 95 ||
              day_tasks[j]['type'] == 431 ||
              day_tasks[j]['type'] == 43 ||
              day_tasks[j]['type'] == 541 ||
              day_tasks[j]['type'] == 54 ||
              day_tasks[j]['type'] == 72 ||
              day_tasks[j]['type'] == 130 ||
              day_tasks[j]['type'] == 128 ||
              day_tasks[j]['type'] == 129 ||
              day_tasks[j]['type'] == 140 ||
              day_tasks[j]['type'] == 141
            ) {
              if (
                map_tiled_st.findIndex(function (e) {
                  return Number(e['i']) == Number(day_tasks[j]['type']);
                }) != -1
              ) {
                map_tiled_st.splice(
                  map_tiled_st.findIndex(function (e) {
                    return Number(e['i']) == Number(day_tasks[j]['type']);
                  }),
                  1,
                );
              }
              for (var i = 1; i <= 7; i++) {
                if (special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 0)) != -1)
                  special_object.splice(special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 0)), 1);
                if (special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 1)) != -1)
                  special_object.splice(special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 1)), 1);
                if (special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 2)) != -1)
                  special_object.splice(special_object.indexOf(Number(day_tasks[j]['type'] + '' + i + '' + 2)), 1);
              }
              objects_group.children.forEach(function (child_item) {
                if (child_item.type == day_tasks[j]['type']) {
                  child_item.inputEnabled = false;
                }
              });
            }
          }
          game.setUserDataAndLog({
            complete_task_i: complete_task_i,
            day_prize: JSON.stringify(day_prize),
            mission_stars_end: mission_stars_end,
            mission_task: JSON.stringify(mission_task),
            mission_number: JSON.stringify(mission_number),
            mission_day_end: mission_day_end,
            map_n: map_n,
            special_object: JSON.stringify(special_object),
            map_tiled_st: JSON.stringify(map_tiled_st),
          });
          clearInterval(timerId5);
          game.world.removeAll(true);
          game.state.start('Map');
        } else {
          for (var j = 0; j < day_tasks.length; j++) {
            mission_number.push(day_tasks[j]['type']);
            if (
              day_tasks[j]['type'] == 7 ||
              day_tasks[j]['type'] == 6 ||
              day_tasks[j]['type'] == 14 ||
              day_tasks[j]['type'] == 4 ||
              day_tasks[j]['type'] == 5 ||
              day_tasks[j]['type'] == 9 ||
              day_tasks[j]['type'] == 8 ||
              day_tasks[j]['type'] == 10 ||
              day_tasks[j]['type'] == 12 ||
              day_tasks[j]['type'] == 15 ||
              day_tasks[j]['type'] == 16 ||
              day_tasks[j]['type'] == 29 ||
              day_tasks[j]['type'] == 30 ||
              day_tasks[j]['type'] == 31 ||
              day_tasks[j]['type'] == 11 ||
              day_tasks[j]['type'] == 34 ||
              day_tasks[j]['type'] == 35 ||
              day_tasks[j]['type'] == 39 ||
              day_tasks[j]['type'] == 40 ||
              day_tasks[j]['type'] == 33 ||
              day_tasks[j]['type'] == 55 ||
              day_tasks[j]['type'] == 47 ||
              day_tasks[j]['type'] == 27 ||
              day_tasks[j]['type'] == 58 ||
              day_tasks[j]['type'] == 61 ||
              day_tasks[j]['type'] == 63 ||
              day_tasks[j]['type'] == 28 ||
              day_tasks[j]['type'] == 59 ||
              day_tasks[j]['type'] == 57 ||
              day_tasks[j]['type'] == 75 ||
              day_tasks[j]['type'] == 49 ||
              day_tasks[j]['type'] == 109 ||
              day_tasks[j]['type'] == 184 ||
              day_tasks[j]['type'] == 116 ||
              day_tasks[j]['type'] == 117 ||
              day_tasks[j]['type'] == 119 ||
              day_tasks[j]['type'] == 53 ||
              day_tasks[j]['type'] == 51 ||
              day_tasks[j]['type'] == 92 ||
              day_tasks[j]['type'] == 99 ||
              day_tasks[j]['type'] == 91 ||
              day_tasks[j]['type'] == 106 ||
              day_tasks[j]['type'] == 24 ||
              day_tasks[j]['type'] == 96 ||
              day_tasks[j]['type'] == 95 ||
              day_tasks[j]['type'] == 431 ||
              day_tasks[j]['type'] == 43 ||
              day_tasks[j]['type'] == 541 ||
              day_tasks[j]['type'] == 54 ||
              day_tasks[j]['type'] == 72 ||
              day_tasks[j]['type'] == 130 ||
              day_tasks[j]['type'] == 128 ||
              day_tasks[j]['type'] == 129 ||
              day_tasks[j]['type'] == 140 ||
              day_tasks[j]['type'] == 141
            ) {
              map_tiled_st.push({ i: Number(day_tasks[j]['type']), s: 1 });
              if (
                special_object.indexOf(Number(day_tasks[j]['type'] + '' + 1 + '' + 0)) == -1 &&
                special_object.indexOf(Number(day_tasks[j]['type'] + '' + 1 + '' + 1)) == -1 &&
                special_object.indexOf(Number(day_tasks[j]['type'] + '' + 1 + '' + 2)) == -1
              ) {
                for (var i = 1; i <= 7; i++) {
                  var tp = new_options.findIndex(function (e) {
                    return Number(Math.abs(e['type'])) == day_tasks[j]['type'];
                  });
                  if (
                    ((Number(
                      game.cache.getJSON('buildings')['Special'][0]['Special' + day_tasks[j]['type']][0][
                      's' + i + 'ifTask'
                      ],
                    ) > 0 &&
                      typeof new_options[tp] !== 'undefined' &&
                      new_options[tp]['num'].indexOf(i) != -1) ||
                      Number(
                        game.cache.getJSON('buildings')['Special'][0]['Special' + day_tasks[j]['type']][0][
                        's' + i + 'ifTask'
                        ],
                      ) == 0) &&
                    Number(
                      game.cache.getJSON('buildings')['Special'][0]['Special' + day_tasks[j]['type']][0]['s' + i],
                    ) != -1
                  ) {
                    if (
                      Number(
                        game.cache.getJSON('buildings')['Special'][0]['Special' + day_tasks[j]['type']][0]['s' + i],
                      ) > 0
                    )
                      special_object.push(Number(day_tasks[j]['type'] + '' + i + '' + 0));
                    else special_object.push(Number(day_tasks[j]['type'] + '' + i + '' + 2));
                  }
                }
              }
              objects_group.children.forEach(function (child_item) {
                if (child_item.type == day_tasks[j]['type']) {
                  child_item.inputEnabled = true;
                  child_item.input.pixelPerfectClick = true;
                  child_item.input.priorityID = child_item.depth;
                }
              });
            }
          }
          mission_stars_end = 0;
          mission_day_end_old = 0;
          day_prize = [0, 0, 0, 0, 0, 0];
          mission_task = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          map_n += 1;
          game.setUserDataAndLog({
            complete_task_i: complete_task_i,
            day_prize: JSON.stringify(day_prize),
            mission_stars_end: mission_stars_end,
            mission_task: JSON.stringify(mission_task),
            mission_number: JSON.stringify(mission_number),
            mission_day_end: mission_day_end,
            map_n: map_n,
            special_object: JSON.stringify(special_object),
            map_tiled_st: JSON.stringify(map_tiled_st),
          });
          clearInterval(timerId5);
          game.world.removeAll(true);
          game.state.start('Map');
        }
      }
    };
    window.setwheel = function (n) {
      if (cheat == 1) {
        wheel_num += n;
      }
    };
    window.getvariables = function () {
      console.log('free_five', free_five);
      console.log('free_prebooster1', free_prebooster1);
      console.log('free_prebooster2', free_prebooster2);
      console.log('free_prebooster3', free_prebooster3);
      console.log('act1_array', act1_array);
      console.log('all_friends_invite', all_friends_invite);
      console.log('all_chests', all_chests);
      console.log('all_stars', all_stars);
      console.log('booster_tnt_col', booster_tnt_col);
      console.log('booster_eye_col', booster_eye_col);
      console.log('booster_shuffle_col', booster_shuffle_col);
      console.log('booster_timestop_col', booster_timestop_col);
      console.log('dailyday', dailyday);
      console.log('dailyday_new', dailyday_new);
      console.log('dailyday_prize', dailyday_prize);
      console.log('new_options', new_options);
      console.log('free_joker', free_joker);
      console.log('free_booster_spec', free_booster_spec);
      console.log('free_cardback', free_cardback);
      console.log('free_three', free_three);
      console.log('mission_number', mission_number);
      console.log('mission_task', mission_task);
      console.log('mission_day_end', mission_day_end);
      console.log('mission_stars_end', mission_stars_end);
      console.log('day_prize', day_prize);
      console.log('offer_mas', offer_mas);
      console.log('map_tiled_st', map_tiled_st);
      console.log('dialog_mas', dialog_mas);
      console.log('special_object', special_object);
      console.log('friends_invite', friends_invite);
      console.log('friend_invite', friend_invite);
      console.log('all_level', all_level);
      console.log('coins', coins);
      console.log('keys', keys);
      console.log('lifes', lifes);
      console.log('LifeDate', LifeDate);
      console.log('unlimited_lifesDate', unlimited_lifesDate);
      console.log('unlimited_lifesDate_old', unlimited_lifesDate_old);
      console.log('ShopDate', ShopDate);
      console.log('ReferralDate', ReferralDate);
      console.log('OfferDate', OfferDate);
      console.log('lifetime', lifetime);
      console.log('FriendPrizeDate', FriendPrizeDate);
      console.log('shop_free', shop_free);
      console.log('KeyMissionDate', KeyMissionDate);
      console.log('KeyMissionPrize', KeyMissionPrize);
      console.log('gift_mas', gift_mas);
      console.log('GiftDate', GiftDate);
      console.log('baloonDate', baloonDate);
      console.log('baloonDate_new', baloonDate_new);
      console.log('sunflowerStage', sunflowerStage);
      console.log('sunflowerDate', sunflowerDate);
      console.log('sunflowerDate_new', sunflowerDate_new);
      console.log('magicbeanDate', magicbeanDate);
      console.log('magicbeanDate_new', magicbeanDate_new);
      console.log('magicbeanStage', magicbeanStage);
      console.log('backcards', backcards);
      console.log('backcards_select', backcards_select);
      console.log('map_n', map_n);
      console.log('wheel_num', wheel_num);
      console.log('wheel_ads', wheel_ads);
      console.log('WheelDate', WheelDate);
      console.log('wheelshopDate', wheelshopDate);
      console.log('wheeladsDate', wheeladsDate);
      console.log('missions', missions);
      console.log('message_id', message_id);
      console.log('FTUE', FTUE);
      console.log('suitcase_add', suitcase_add);
      console.log('last_position', last_position);
      console.log('first_start', first_start);
      console.log('first_helper', first_helper);
      console.log('botopt', botopt);
      console.log('complete_task_i', complete_task_i);
    };
    window.setballoonlevel = function (n) {
      if (cheat == 1) {
        baloonlevel = n;
        game.setUserDataAndLog({ baloonlevel: baloonlevel });
        clearInterval(timerId5);
        game.world.removeAll(true);
        game.state.start('Map');
      }
    };
    window.setshop = function (n) {
      if (cheat == 1) {
        shop = n;
      }
    };
    window.setlevel = function (n) {
      if (cheat == 1) {
        for (var i = 0; i < n - 2; i++) {
          all_level[i] = 3;
        }
        for (var i = n - 2; i < all_level.length; i++) {
          all_level[i] = 0;
        }
        all_level[n - 2] = 300;
        all_stars += 1;
        clearInterval(timerId5);
        // updateAndLogScore('completedLevels', 'default', all_level.length);
        game.setUserDataAndLog({ level_star: JSON.stringify(all_level) });
        game.world.removeAll(true);
        game.state.start('Map');
      }
    };
    window.setmaxlevel = function (n) {
      if (cheat == 1) {
        level_max = n;
      }
    };
    window.setxmaslevel = function (n) {
      if (cheat == 1) {
        xmas_level = n;
      }
    };
    window.setenergy = function (n) {
      if (cheat == 1) {
        lifes = Number(lifes) + Number(n);
        text_lifes.setText(lifes);
        game.setUserDataAndLog({ lifes: String(lifes) });
        if (Number(lifes) >= Number(max_lifes)) {
          LifeDate = 0;
          game.setUserDataAndLog({ life_time: String(LifeDate) });
          if (lifes_panel_plus != 0) {
            lifes_panel_plus.destroy();
            lifes_panel_plus = 0;
          }
        } else if (Number(lifes) < Number(max_lifes)) {
          if (LifeDate == 0) {
            LifeDate =
              ddd == 0
                ? new Date()
                : new Date(
                  ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                );
            LifeDate.setMinutes(LifeDate.getMinutes() + time_life);
            game.setUserDataAndLog({ life_time: String(LifeDate) });
            lifes_panel_plus = game.add.sprite(16, 40, 'game_ui_atlas', 'Get_Energy_Button.png');
            lifes_panel_plus.anchor.setTo(0.5);
            button_animation_f(lifes_panel_plus, 1);
            lifes_panel_plus.events.onInputUp.add(function (item) {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              btnup(item);
              get_message(1);
            });
            life_panel.addChild(lifes_panel_plus);
            var get_energy_thunder_icon = game.add.sprite(78, -4, 'game_ui_atlas', 'Get_Energy_Thunder_Icon.png');
            get_energy_thunder_icon.anchor.setTo(0.5);
            lifes_panel_plus.addChild(get_energy_thunder_icon);
            var get_energy_thunder_text = game.add.text(-25, -1, game.cache.getJSON('lang')['t284'][0][window.lang], {
              font: '22px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            get_energy_thunder_text.lineSpacing = -10;
            get_energy_thunder_text.anchor.setTo(0.5);
            get_energy_thunder_text.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
            lifes_panel_plus.addChild(get_energy_thunder_text);
          }
          lifetextChange();
        }
      }
    };
    window.setboosters = function (b, n) {
      if (cheat == 1) {
        if (b == 1) {
          free_cardback += n;
        } else if (b == 2) {
          free_joker += n;
        } else if (b == 3) {
          free_three += n;
        } else if (b == 4) {
          booster_tnt_col += n;
        } else if (b == 5) {
          booster_eye_col += n;
        } else if (b == 6) {
          booster_shuffle_col += n;
        }
        game.setUserDataAndLog({
          free_cardback: free_cardback,
          free_joker: free_joker,
          free_three: free_three,
          booster_tnt_col: booster_tnt_col,
          booster_eye_col: booster_eye_col,
          booster_shuffle_col: booster_shuffle_col,
          booster_timestop_col: booster_timestop_col,
        });
      }
    };
    window.setlevelFTUE = function (f, n) {
      FTUE = f;
      all_level[n - 2] = 3;
    };
    window.cheaton = function () {
      cheat = 1;
      clearInterval(timerId5);
      game.world.removeAll(true);
      game.state.start('Boot');
    };
    function f_w_a() {
      if (FTUE_Arrow != 0) {
        FTUE_Arrow.destroy();
        FTUE_Arrow = 0;
      }
      if (w != 0) {
        w.destroy();
        w = 0;
      }
    }
    console.log('info: ', all_level.lastIndexOf(3) + 2, FTUE);
    if (FTUE < 153 && all_level.lastIndexOf(3) + 2 == 6 && FTUE == 20) {
      FTUE = 18;
    }
    function FTUE_process() {
      if (FTUE == 0) {
        animation = 1;
        game.add
          .tween(follow)
          .to({ x: 2400 * worldScale, y: 1000 * worldScale }, 2000, Phaser.Easing.Linear.None, true, 500)
          .onComplete.add(function () {
            animation = 0;
            first_start = 0;
            game.setUserDataAndLog({ first_start: first_start });
            last_position = [2400 * worldScale, 1000 * worldScale];
            game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
            if (fbv == 1) {
              game.setUserDataAndLog({ FTUEEVENTS: window.eventTrack('FTUE_1_4_FirstDialogueCompleted') });
            }
            dialog_window(3, 0);
          });
        FTUE += 1;
      } else if (FTUE == 1) {
        animation = 1;
        game.add
          .tween(follow)
          .to({ x: 1400 * worldScale, y: 1100 * worldScale }, 2000, Phaser.Easing.Linear.None, true, 500)
          .onComplete.add(function () {
            animation = 0;
            last_position = [1400 * worldScale, 1100 * worldScale];
            game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
            if (fbv == 1) {
              window.eventTrack('FTUE_1_4_SecondDialogueCompleted');
            }
            dialog_window(7, 0);
          });
        FTUE += 1;
      } else if (FTUE == 2) {
        level = 1;
        new_life();
        popup = 2;
        FTUE += 1;
      } else if (FTUE == 3) {
        if (fbv == 1) {
          window.eventTrack('FTUE_3_2_FirstDialogueCompleted');
        }
        dialog_window(4, 0);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.graphics(stars_panel.world.x, stars_panel.world.y);
        FTUE_Arrow.lineStyle(8, 0xffff00);
        FTUE_Arrow.drawCircle(15, 0, 130);
        game.add
          .tween(FTUE_Arrow.scale)
          .to({ x: 1.1, y: 1.1 }, 400, Phaser.Easing.Linear.None, true, 0, -1)
          .yoyo(true, 100);
        FTUE += 1;
        game.world.bringToTop(UI_top_group);
        game.world.bringToTop(FTUE_Arrow);
      } else if (FTUE == 4) {
        if (fbv == 1) {
          window.eventTrack('FTUE_3_2_SecondDialogueCompleted');
        }
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t309'][0][window.lang],
          game.camera.width / 2 + 90,
          game.camera.height - 140,
        );
        animation = 0;
        UI_bottom_group.removeAll(true);
        UI_bottom_group_create(0, 2, 0, 0, w);
        indicator_system(0);
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(build_button.x, build_button.y, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        FTUE += 1;
      } else if (FTUE == 5) {
        if (fbv == 1) {
          window.eventTrack('FTUE_3_3_TaskButtonClicked');
        }
        UI_bottom_group.removeAll(true);

        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t310'][0][window.lang],
          game.camera.width / 2,
          200);

        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }

        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 220,
          'game_atlas',
          'FTUE_Arrow.png',
        );

        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.angle = 180;
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 6) {
        if (fbv == 1) {
          window.eventTrack('FTUE_3_4_BenchButtonClicked');
        }
        f_w_a();
        game.world.bringToTop(UI_top_group);
        FTUE += 1;
      } else if (FTUE == 7) {
        if (fbv == 1) {
          window.eventTrack('FTUE_3_7_ThirdDialogueCompleted');
        }
        animation = 1;
        game.add
          .tween(follow)
          .to({ x: 2400 * worldScale, y: 1000 * worldScale }, 2000, Phaser.Easing.Linear.None, true, 500)
          .onComplete.add(function () {
            last_position = [2400 * worldScale, 1000 * worldScale];
            game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
            blackf();
            w = ftue_window(
              'Main_Presenting.png',
              game.cache.getJSON('lang')['t311'][0][window.lang],
              game.camera.width / 2,
              game.camera.height - 140,
            );
            animation = 0;
            UI_bottom_group.removeAll(true);
            UI_bottom_group_create(2, 0, 0, 0, w);
            indicator_system(0);
            game.world.bringToTop(UI_bottom_group);
            if (sound_on == 1) {
              play_sound('hint_with_arrow');
            }
            FTUE_Arrow = game.add.sprite(level_button.x, level_button.y, 'game_atlas', 'FTUE_Arrow.png');
            FTUE_Arrow.anchor.setTo(0.5, 1.6);
            FTUE_Arrow.fixedToCamera = true;
            game.add
              .tween(FTUE_Arrow.anchor)
              .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
              .yoyo(true, 200);
            FTUE += 1;
          });
      } else if (FTUE == 8) {
        if (fbv == 1) {
          window.eventTrack('FTUE_5_2_FirstDialogueCompleted');
        }
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t339'][0][window.lang],
          game.camera.width / 2 + 90,
          game.camera.height - 140,
        );
        animation = 0;
        UI_bottom_group.removeAll(true);
        UI_bottom_group_create(0, 2, 0, 0, w);
        indicator_system(0);
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(build_button.x, build_button.y, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        FTUE += 2;
      } else if (FTUE == 9 || FTUE == 13 || FTUE == 19) {
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t342'][0][window.lang],
          game.camera.width / 2 + 90,
          game.camera.height - 140,
        );
        animation = 0;
        UI_bottom_group.removeAll(true);
        UI_bottom_group_create(0, 2, 0, 0, 0);
        indicator_system(0);
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(build_button.x, build_button.y, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        FTUE += 1;
      } else if (FTUE == 10 || FTUE == 14 || FTUE == 20 || (FTUE == 26 && all_level[4] > 0)) {
        UI_bottom_group.removeAll(true);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 220,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.angle = 180;
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 11 || FTUE == 15 || FTUE == 21 || FTUE == 38) {
        f_w_a();
        FTUE += 1;
        if (FTUE == 39) {
          game.setUserDataAndLog({ FTUE: FTUE });
        }
      } else if (FTUE == 12 || FTUE == 17) {
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t343'][0][window.lang],
          game.camera.width / 2,
          game.camera.height - 140,
        );
        animation = 0;
        UI_bottom_group.removeAll(true);
        UI_bottom_group_create(2, 0, 0, 0, w);
        indicator_system(0);
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(level_button.x, level_button.y, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        FTUE += 1;
      } else if (FTUE == 16) {
        FTUE += 1;
      } else if (FTUE == 18) {
        if (fbv == 1) {
          window.eventTrack('FTUE_9_2_FirstDialogueCompleted');
        }
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t340'][0][window.lang],
          game.camera.width / 2 + 90,
          game.camera.height - 140,
        );
        animation = 0;
        UI_bottom_group.removeAll(true);
        UI_bottom_group_create(0, 2, 0, 0, w);
        indicator_system(0);
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(build_button.x, build_button.y, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        FTUE += 2;
      } else if (FTUE == 22) {
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t343'][0][window.lang],
          game.camera.width / 2,
          game.camera.height - 140,
        );
        animation = 0;
        UI_bottom_group.removeAll(true);
        UI_bottom_group_create(2, 0, 0, 0, w);
        indicator_system(0);
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(level_button.x, level_button.y, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        FTUE += 1;
      } else if (FTUE == 23) {
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t342'][0][window.lang],
          game.camera.width / 2 + 90,
          game.camera.height - 140,
        );
        animation = 0;
        UI_bottom_group.removeAll(true);
        UI_bottom_group_create(0, 2, 0, 0, 0);
        indicator_system(0);
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(build_button.x, build_button.y, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        FTUE += 3;
      } else if (FTUE == 24) {
      } else if (FTUE == 25 && all_level[4] > 0) {
      } else if (FTUE == 27 || FTUE == 34) {
        f_w_a();
        FTUE = 35;
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(0, 0, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        level_button.addChild(FTUE_Arrow);
        game.saveDataAll();
      } else if (FTUE == 28) {
        if (fbv == 1) {
          window.eventTrack('FTUE_11_4_CompleteSubtasksConfirmed');
        }
        mission_create(0);
        for (var j = 0; j < 12; j += 4) {
          missions[j + 2] = missions[j + 1];
        }
        f_w_a();
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t312'][0][window.lang],
          game.camera.width / 2 + 80,
          game.camera.height - 140,
        );
        animation = 0;
        UI_bottom_group.removeAll(true);
        UI_bottom_group_create(0, 2, 0, 0, w);
        indicator_system(0);
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(build_button.x, build_button.y, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        FTUE += 1;
      } else if (FTUE == 29) {
        game.add.tween(effects_group).to({ alpha: 1 }, 100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          if (sound_on == 1) {
            play_sound('hint_with_arrow');
          }
          FTUE_Arrow = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 + 420,
            'game_atlas',
            'FTUE_Arrow.png',
          );
          FTUE_Arrow.anchor.setTo(0.5, 1.6);
          FTUE_Arrow.fixedToCamera = true;
          game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
          effects_group.add(FTUE_Arrow);
          game.world.bringToTop(effects_group);
        });
        FTUE += 1;
      } else if (FTUE == 30) {
        if (fbv == 1) {
          window.eventTrack('FTUE_11_5_A_SubtasksButtonClicked');
        }
        f_w_a();
        game.world.bringToTop(black_sprite);
        game.world.bringToTop(backcard_group);
        game.world.bringToTop(UI_top_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2 - 180,
          game.camera.height / 2 - 100,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.scale.setTo(0.8, -0.8);
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 31) {
        f_w_a();
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2 - 180 + 430,
          game.camera.height / 2 - 100,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.scale.setTo(0.8, -0.8);
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 32) {
        f_w_a();
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2 - 180 + 430 * 2,
          game.camera.height / 2 - 100,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.scale.setTo(0.8, -0.8);
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE = 50;
      } else if (FTUE == 33) {
        f_w_a();
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2 - 745,
          game.camera.height - 120,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.angle = 90;
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 35 && all_level[6] > 0) {
        if (fbv == 1) {
          window.eventTrack('FTUE_13_1Wheel_icon_shown');
        }
        UI_right_create();
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t313'][0][window.lang],
          game.camera.width / 2,
          game.camera.height - 140,
        );
        animation = 0;
        game.world.bringToTop(UI_right_group);
        button_setting.alpha = 0;
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(game.camera.width - 140, 250, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.angle = 270;
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 36) {
        f_w_a();
        FTUE += 1;
      } else if (FTUE == 37) {
        animation = 0;
        popup = 1;
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2 + 220,
          game.camera.height / 2 + 405,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.angle = 90;
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 39 && all_level[7] > 0) {
        if (fbv == 1) {
          window.eventTrack('FTUE_14_1_First_dialog_shown');
        }
        popup = 1;
        FTUE += 1;
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t314'][0][window.lang],
          game.camera.width / 2,
          game.camera.height / 2,
        );
        animation = 1;
        UI_bottom_group.removeAll(true);
        UI_bottom_group_create(0, 0, 0, 1, w);
        indicator_system(0);
        game.world.bringToTop(UI_bottom_group);
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(furniture_button.x, furniture_button.y, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
      } else if (FTUE == 40) {
        popup = 1;
        f_w_a();
        game.add.tween(black_sprite).to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true);
        animation = 1;
        FTUE = 41.1;
        game.add
          .tween(follow)
          .to({ x: 1400 * worldScale, y: 1100 * worldScale }, 1000, Phaser.Easing.Linear.None, true, 500)
          .onComplete.add(function () {
            last_position = [1400 * worldScale, 1100 * worldScale];
            w = ftue_window(
              'Main_Presenting.png',
              game.cache.getJSON('lang')['t315'][0][window.lang],
              game.camera.width / 2,
              230,
            );
            let obj = 0;
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 7) {
                obj = child_item;
                return true;
              }
            });
            if (sound_on == 1) {
              play_sound('hint_with_arrow');
            }
            FTUE_Arrow = game.add.sprite(obj.x, obj.y, 'game_atlas', 'FTUE_Arrow.png');
            FTUE_Arrow.anchor.setTo(0.5, 1.6);
            game.add
              .tween(FTUE_Arrow.anchor)
              .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
              .yoyo(true, 200);
            animation = 0;
          });
      } else if (FTUE == 41.1 && all_level[8] > 0 && shop == 1) {
        if (fbv == 1) {
          window.eventTrack('FTUE_15_1First_dialog_shown');
        }
        shop_free = 1;
        FTUE = 41.2;
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t424'][0][window.lang],
          game.camera.width / 2,
          game.camera.height / 2,
        );
        animation = 0;
        game.world.bringToTop(UI_top_group);
        life_panel.alpha = 0;
        stars_panel.alpha = 0;
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(game.camera.width / 2 - 330, 72, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.scale.setTo(1, -1);
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
      } else if (FTUE == 41.2 && shop == 1) {
        FTUE = 41.3;
        f_w_a();
      } else if (FTUE == 41.4 && shop == 1) {
        if (fbv == 1) {
          window.eventTrack('FTUE_15_6Comeback_info_shown');
        }
        FTUE = 41.5;
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t425'][0][window.lang],
          game.camera.width / 2,
          game.camera.height / 2 + 250,
        );
        effects_group.add(w);
        game.world.bringToTop(effects_group);
        animation = 0;
      } else if (FTUE == 41.5 || (FTUE == 41.1 && all_level[8] > 0 && shop == 0)) {

        FTUE = 41;
        f_w_a();
        game.setUserDataAndLog({ FTUE: FTUE });
      } else if (FTUE == 41 && all_level[9] > 0) {
        // skip directly to FTUE 47 to ignore the friendlist
        FTUE = 47;
        update_controll = 0;
        animation = 0;

        // if (fbv == 1) {
        //   window.eventTrack('FTUE_16_1_First_dialog_shown');
        // }
        // blackf();
        // w = ftue_window(
        //   'Main_Presenting.png',
        //   game.cache.getJSON('lang')['t316'][0][window.lang],
        //   game.camera.width / 2,
        //   game.camera.height / 2,
        // );
        // UI_bottom_group.removeAll(true);
        // UI_bottom_group_create(0, 0, 2, 0, w);
        // indicator_system(0);
        // game.world.bringToTop(UI_bottom_group);
        // if (sound_on == 1) {
        //   play_sound('hint_with_arrow');
        // }
        // FTUE_Arrow = game.add.sprite(invitereward_button.x, invitereward_button.y, 'game_atlas', 'FTUE_Arrow.png');
        // FTUE_Arrow.anchor.setTo(0.5, 1.6);
        // FTUE_Arrow.fixedToCamera = true;
        // game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
      } else if (FTUE == 42) {
        f_w_a();
        FTUE += 1;
      } else if (FTUE == 43) {
        if (fbv == 1) {
          window.eventTrack('FTUE_16_3_Display_of_text_and_arrow');
        }
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t317'][0][window.lang],
          game.camera.width / 2 + 140,
          230,
        );
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2 - 470 + (0 / 2) * 235 + 90,
          game.camera.height / 2 - 30,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.angle = -90;
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 44) {
        f_w_a();
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2 - 470 + (0 / 2) * 235 + 50,
          game.camera.height / 2 + 258,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.angle = 180;
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 45) {
        if (fbv == 1) {
          window.eventTrack('FTUE_16_6_Second_dialog_shown');
        }
        let p = 0;
        f_w_a();
        if (fbv == 1) {
          w = ftue_window(
            'Main_Presenting.png',
            game.cache.getJSON('lang')['t318'][0][window.lang],
            game.camera.width / 2 + 140,
            game.camera.height - 140,
          );
          backcard_group.children.forEach(function (item) {
            item.children.forEach(function (item) {
              if (p == 0 && item.frameName == 'Add_Friend.png') {
                if (item.i < 10) {
                  if (sound_on == 1) {
                    play_sound('hint_with_arrow');
                  }
                  if (item.i % 2 == 0)
                    FTUE_Arrow = game.add.sprite(
                      game.camera.width / 2 - 470 + (item.i / 2) * 235 + 20,
                      game.camera.height / 2 - 80,
                      'game_atlas',
                      'FTUE_Arrow.png',
                    );
                  else
                    FTUE_Arrow = game.add.sprite(
                      game.camera.width / 2 - 470 + ((item.i - 1) / 2) * 235 + 20,
                      game.camera.height / 2 + 244,
                      'game_atlas',
                      'FTUE_Arrow.png',
                    );
                  FTUE_Arrow.angle = 90;
                  FTUE_Arrow.anchor.setTo(0.5, 1.6);
                  FTUE_Arrow.fixedToCamera = true;
                  game.add
                    .tween(FTUE_Arrow.anchor)
                    .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                    .yoyo(true, 200);
                  effects_group.add(FTUE_Arrow);
                  game.world.bringToTop(effects_group);
                } else {
                  let iii = item.i;
                  animation = 1;
                  game.add
                    .tween(backcard_group.cameraOffset)
                    .to({ x: '-' + 235 * Math.ceil((iii - 9) / 2) }, 500, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      if (sound_on == 1) {
                        play_sound('hint_with_arrow');
                      }
                      if (iii % 2 == 0)
                        FTUE_Arrow = game.add.sprite(
                          game.camera.width / 2 - 470 + (iii / 2) * 235 - 235 * Math.ceil((iii - 9) / 2) + 20,
                          game.camera.height / 2 - 80,
                          'game_atlas',
                          'FTUE_Arrow.png',
                        );
                      else
                        FTUE_Arrow = game.add.sprite(
                          game.camera.width / 2 - 470 + ((iii - 1) / 2) * 235 - 235 * Math.ceil((iii - 9) / 2) + 20,
                          game.camera.height / 2 + 244,
                          'game_atlas',
                          'FTUE_Arrow.png',
                        );
                      FTUE_Arrow.angle = 90;
                      FTUE_Arrow.anchor.setTo(0.5, 1.6);
                      FTUE_Arrow.fixedToCamera = true;
                      game.add
                        .tween(FTUE_Arrow.anchor)
                        .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                        .yoyo(true, 200);
                      effects_group.add(FTUE_Arrow);
                      game.world.bringToTop(effects_group);
                      animation = 0;
                    });
                }
                p = 1;
              }
            });
          });
        }
        if (fbv == 1) {
          FTUE += 1;
        } else {
          FTUE += 2;
        }
        game.setUserDataAndLog({ FTUE: FTUE });
      } else if (FTUE == 46) {
        f_w_a();
        FTUE = 151;
        game.setUserDataAndLog({ FTUE: FTUE });
      } else if (FTUE == 50) {
        f_w_a();
        game.world.bringToTop(UI_bottom_group);
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t319'][0][window.lang],
          game.camera.width / 2,
          230,
        );
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2 + 200,
          game.camera.height / 2 + 420,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.angle = 90;
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 51) {
        if (fbv == 1) {
          window.eventTrack('FTUE_11_8_UnlockablesButtonClicked');
        }
        f_w_a();
        game.world.bringToTop(UI_bottom_group);
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t320'][0][window.lang],
          game.camera.width / 2,
          230,
        );
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(
          game.camera.width / 2 - 705,
          game.camera.height / 2 + 162,
          'game_atlas',
          'FTUE_Arrow.png',
        );
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
      } else if (FTUE == 52) {
        if (fbv == 1) {
          window.eventTrack('FTUE_11_9_CardbackDesignClicked');
        }
        f_w_a();
        game.world.bringToTop(UI_bottom_group);
        FTUE = 33;
        FTUE_process();
      } else if (FTUE == 151 && fbv == 1 && all_level[10] > 0) {
        if (fbv == 1) {
          window.eventTrack('FTUE_17_1First_dialog_shown');
        }
        blackf();
        w = ftue_window(
          'Main_Presenting.png',
          game.cache.getJSON('lang')['t341'][0][window.lang],
          game.camera.width / 2,
          game.camera.height - 140,
        );
        animation = 0;
        game.world.bringToTop(UI_right_group);
        button_setting.alpha = 0;
        wheel_icon.alpha = 0;
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow = game.add.sprite(game.camera.width - 140, 560, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow.anchor.setTo(0.5, 1.6);
        FTUE_Arrow.angle = 270;
        FTUE_Arrow.fixedToCamera = true;
        game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        effects_group.add(FTUE_Arrow);
        game.world.bringToTop(effects_group);
        FTUE += 1;
        game.setUserDataAndLog({ FTUE: FTUE });
      }
    }

    var FTUE_Arrow_2 = 0;
    game.time.events.loop(3000, function () {
      if (
        FTUE_Arrow_2 == 0 &&
        ((level_button.n >= 6 && level_button.n <= 8) || xmas == 1) &&
        popup == 0 &&
        animation == 0 &&
        game_tap == 0
      ) {
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow_2 = game.add.sprite(0, 0, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow_2.anchor.setTo(0.5, 1.6);
        game.add.tween(FTUE_Arrow_2.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        level_button.addChild(FTUE_Arrow_2);
      } else if (
        FTUE_Arrow_2 == 0 &&
        level_button.n >= 6 &&
        level_button.n <= 10 &&
        popup == 0 &&
        animation == 0 &&
        game_tap == 0 &&
        all_stars > 2
      ) {
        if (sound_on == 1) {
          play_sound('hint_with_arrow');
        }
        FTUE_Arrow_2 = game.add.sprite(10, 0, 'game_atlas', 'FTUE_Arrow.png');
        FTUE_Arrow_2.anchor.setTo(0.5, 1.6);
        FTUE_Arrow_2.angle = 35;
        game.add.tween(FTUE_Arrow_2.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        build_button.addChild(FTUE_Arrow_2);
      }
      if (FTUE_Arrow_2 == -1) {
        FTUE_Arrow_2 = 0;
      }
    });
    game.input.onDown.add(function () {
      console.log('x', game.camera.x + game.input.activePointer.x, 'y', game.camera.y + game.input.activePointer.y);
      if (FTUE_Arrow_2 != 0 && FTUE_Arrow_2 != -1) {
        FTUE_Arrow_2.destroy();
        FTUE_Arrow_2 = -1;
      }
    });

    // async function updateAndLogScore(ln, id, s) {
    //   if (fbv == 1) {
    //     //await postScore({ leaderboardName: ln, instanceId: id, score: s });
    //   }
    // }

    async function fetchAndLogScore(_id, _name) {
      return [];
    }
    function castPlayerToUser(player) {
      return {
        id: player.getID(),
        name: player.getName(),
        avatarUrl: player.getPhoto(),
      };
    }
    function levelscomplete(n) {
      for (var i = 0; i < 60 * map_n; i++) {
        if (i < n - 1) {
          all_level[i] = 3;
        } else {
          all_level[i] = 0;
          break;
        }
      }
      game.setUserDataAndLog({ level_star: JSON.stringify(all_level) });
      popup = 4;
      clearInterval(timerId5);
      game.world.removeAll(true);
      game.state.start('Map');
    }
    window.helpersclear = function () {
      if (cheat == 1) {
        helpers_id = [];
        helpers_time = [];
        game.setUserDataAndLog({ helpers_id: JSON.stringify(helpers_id), helpers_time: JSON.stringify(helpers_time) });
        popup = 4;
        clearInterval(timerId5);
        game.world.removeAll(true);
        game.state.start('Map');
      }
    };
    leader_group = game.add.group();
    popup_group = game.add.group();
    effects_group = game.add.group();
    farm_group = game.add.group();
    if (all_level.length == 0) {
      all_level[0] = 0;
    }
    if (frinds_avatar1 != 0) {
      clearInterval(frinds_avatar1);
      frinds_avatar1 = 0;
    }
    if (xmas == 0) {
      shop_timer();
      balloon_timer();
      life_timer();
    }
    //misDate_timer();
    friends_timer();
    weekday_offers_timer();
    var timerId5 = setInterval(function () {
      if ((all_level.lastIndexOf(3) + 2 >= 20 && xmasDate == 0) || (xmasDate != 0 && xmasDate != -1)) {
        xmastimer();
      }
      if (xmas == 0) {
        friends_timer()
        misDate_timer();
        playadDate_timer();
        keymission_timer();
        shop_timer();
        rewarded_referral_timer();
        friend_prize_timer();
        if (shop == 1) {
          wheelshop_timer();
        }
        wheelads_timer();
        wheel_timer();
        offer_timer();
        life_timer();
        weekday_offers_timer();
        if ((all_level.lastIndexOf(3) + 2 >= 50 && baloonDate == 0) || baloonDate != 0) {
          balloon_timer();
        }
        if ((all_level.lastIndexOf(3) + 2 >= 15 && sunflowerDate == 0) || sunflowerDate != 0) {
          sunflowertimer();
        }
        if ((all_level.lastIndexOf(3) + 2 >= 35 && magicbeanDate == 0) || magicbeanDate != 0) {
          magicbeantimer();
        }
      }
    }, 1000);
    function gameTracking(string, ftuen) { }
    friend_avatar = 0;
    popup = 0;
    game.world.setBounds(0, 0, 3400, 1700);
    worldwidth = game.camera.width;
    worldheight = game.camera.height;
    var currentBounds = new Phaser.Rectangle(0, 0, mapSizeX * 2, mapSizeY * 2);
    game.camera.bounds = currentBounds;
    game.camera.focusOnXY(mapSizeX / 2, mapSizeY / 2);
    game.input.mouseWheel.callback = function (event) {
      if (popup == 0 && missions_tab_open == 0 && animation == 0 && w == 0 && FTUE != 40) {
        var wheelDelt = game.input.mouseWheel;
        if (wheelDelt.delta < 0) {
          mapSizeCurrent -= 400;
          mapSizeCurrent = Phaser.Math.clamp(mapSizeCurrent, worldwidth, mapSizeMax);
        } else {
          mapSizeCurrent += 400;
          mapSizeCurrent = Phaser.Math.clamp(mapSizeCurrent, worldwidth, mapSizeMax);
        }
        worldScale = mapSizeCurrent / mapSizeMax;
      } else if (missions_tab_open == 2 || (missions_tab_open == 1 && (FTUE < 40 || FTUE > 46))) {
        let g = backcard_group;
        let s = 1635;
        if (missions_tab_open == 1) s = 1135;
        if (game.input.mouseWheel.delta < 0 && g.cameraOffset.x - 8 > -(g.width - s)) {
          map_move = 1;
          g.cameraOffset.x -= 32;
          setTimeout(function () {
            map_x = tap_x;
          }, 500);
        } else if (game.input.mouseWheel.delta > 0 && g.cameraOffset.x + 8 <= 26) {
          map_move = 1;
          g.cameraOffset.x += 32;
          setTimeout(function () {
            map_x = tap_x;
          }, 500);
        }
      } else if (missions_tab_open == 3 && backcard_group_c.width / 360 > 5) {
        let g = backcard_group_c;
        let s = 1920 - 180;
        if (game.input.mouseWheel.delta < 0 && g.x - 8 > -(g.width - s)) {
          g.x -= 32;
          map_move = 1;
          setTimeout(function () {
            map_x = tap_x;
          }, 500);
        } else if (game.input.mouseWheel.delta > 0 && g.x + 8 <= 26) {
          g.x += 32;
          map_move = 1;
          setTimeout(function () {
            map_x = tap_x;
          }, 500);
        }
      } else if (missions_tab_open == 10) {
        let g = leader_group;
        let s = 324;
        if (
          game.input.activePointer.x > toplist_back.x - game.camera.x - toplist_back.width / 2 + 10 &&
          game.input.activePointer.x < toplist_back.x - game.camera.x + toplist_back.width / 2 - 40 &&
          game.input.activePointer.y > toplist_back.y - game.camera.y - toplist_back.height / 2 &&
          game.input.activePointer.y < toplist_back.y - game.camera.y + toplist_back.height / 2
        ) {
          if (game.input.mouseWheel.delta < 0 && g.y - 8 > -(g.hhh * 108 - s)) {
            map_move = 1;
            g.y -= 32;
            setTimeout(function () {
              map_y = tap_y;
            }, 500);
          } else if (game.input.mouseWheel.delta > 0 && g.y + 8 <= 0) {
            map_move = 1;
            g.y += 32;
            setTimeout(function () {
              map_y = tap_y;
            }, 500);
          }
        }
      }
    };
    objects_group = game.add.group();
    var map_tiled_l2 = [];
    var line_n = 0;
    var ni = 0;
    var nj = 0;
    var tile = 0;
    UI_top_group = game.add.group();
    UI_left_group = game.add.group();
    UI_bottom_group = game.add.group();
    UI_right_group = game.add.group();
    var special_stage = 0;
    var backcard_mask = game.add.graphics(0, 0);
    backcard_mask.beginFill(0xffffff);
    backcard_mask.drawRect(game.camera.width / 2 - 830, game.camera.height / 2 - 540, 1660, 1080);
    backcard_mask.fixedToCamera = true;
    backcard_mask.alpha = 0;
    var backcard_mask2 = game.add.graphics(0, 0);
    backcard_mask2.beginFill(0xffffff);
    backcard_mask2.drawRect(game.camera.width / 2 - 580, game.camera.height / 2 - 540, 1160, 1080);
    backcard_mask2.fixedToCamera = true;
    backcard_mask2.alpha = 0;
    var backcard_group = game.add.group();
    backcard_group.fixedToCamera = true;
    backcard_group.mask = backcard_mask;
    var mission_group = game.add.group();
    mission_group.fixedToCamera = true;
    function cartesianToIsometric(cartPt) {
      var tempPt = new Phaser.Point();
      tempPt.x = cartPt.x - cartPt.y;
      tempPt.y = (cartPt.x + cartPt.y) / 2;
      return tempPt;
    }

    if (xmas == 0) {
      var jj = 0;
      for (var i = 0; i < 5; i++) {
        jj = 0;
        for (var j = 0; j < 10; j++) {
          if ((j % 2 != 0 && i < 4) || j % 2 == 0) {
            if (j % 2 == 0) tile = game.add.sprite(i * 1200 - 600, jj * 600 - 300, 'field');
            else {
              tile = game.add.sprite(i * 1200, jj * 600, 'field');
              jj++;
            }
            tile.scale.setTo(2.2);
            tile.depth = -1;
            objects_group.add(tile);
          }
        }
      }
    }
    else {
      tile = game.add.sprite(0, 0, 'field2');
      tile.scale.setTo(2.6, 3);
      tile.depth = -1;
      objects_group.add(tile);
    }
    line_n = 0;
    ni = 0;
    nj = 0;
    var act1_array = [];
    var depth_border = 0.001;
    if (xmas == 0) {
      for (i = 0; i <= 654; i++) {
        let xxx = game.cache.getJSON('map')['object' + i][0]['x'];
        let yyy = game.cache.getJSON('map')['object' + i][0]['y'];
        let zzz = game.cache.getJSON('map')['object' + i][0]['z'];
        let sprite = game.cache.getJSON('map')['object' + i][0]['sprite'];
        let type = game.cache.getJSON('map')['object' + i][0]['type'];
        let act = game.cache.getJSON('map')['object' + i][0]['act'];
        let atlas = game.cache.getJSON('map')['object' + i][0]['atlas'];
        let change = game.cache.getJSON('map')['object' + i][0]['change'];
        let change_x = game.cache.getJSON('map')['object' + i][0]['change_x'];
        let change_y = game.cache.getJSON('map')['object' + i][0]['change_y'];
        if (atlas == 0) {
          atlas = 'farm_obj_atlas';
        } else {
          atlas = 'farm_obj_c_atlas';
        }
        if (type == 103 && mission_number.indexOf(type) != -1) {
          sprite = 'stoune2';
          type = 104;
          act = 2;
          atlas = 'farm_obj_c_atlas';
          change = 'stoune3';
          change_x = Number(xxx);
          change_y = Number(yyy);
        }
        if (type == 104 && mission_number.indexOf('104') != -1) {
          sprite = 'stoune3';
          type = 105;
          act = 2;
          atlas = 'farm_obj_c_atlas';
          change = 'stoune4';
          change_x = Number(xxx);
          change_y = Number(yyy);
        }
        if (type == 105 && mission_number.indexOf('105') != -1) {
          sprite = 'stoune4';
          type = 106;
          act = 2;
          atlas = 'farm_obj_c_atlas';
          change = 'stoune_statue_1';
          change_x = Number(xxx);
          change_y = Number(yyy);
        }
        if (type == 106 && mission_number.indexOf('106') != -1) {
          sprite = 'stoune_statue_1';
        }

        if (type == 46 && mission_number.indexOf('461') != -1 && sprite == 'flowers_purple_1') {
          if (map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(461) }) != -1) {
            let sss = map_tiled_st[map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(461) })]['s'];
            sprite = 'flowers_purple_' + sss;
          } else {
            sprite = 'flowers_purple_1';
          }

          if (map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(461) }) != -1) {
            let sss = map_tiled_st[map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(461) })]['s'];
            change = 'flowers_purple_' + sss;
          } else {
            change = 'flowers_purple_1';
          }

          xxx = Number(xxx) + 50;
          yyy = Number(yyy) - 50;
        }

        if (type == 50 && mission_number.indexOf('50') != -1) {
          sprite = 'tree';
          type = 51;
          act = 2;
          atlas = 'farm_obj_c_atlas';

          if (map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(515) }) != -1) {
            let sss = map_tiled_st[map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(515) })]['s'];
            change = 'e_tree_' + sss;
          } else {
            change = 'e_tree_1';
          }

          //change = 'e_tree_1';
          change_x = Number(xxx) + 80;
          change_y = Number(yyy) - 50;
        }
        if (type == 51 && mission_number.indexOf('51') != -1 && sprite == 'tree') {

          if (map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(515) }) != -1) {
            let sss = map_tiled_st[map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(515) })]['s'];
            sprite = 'e_tree_' + sss;
          } else {
            sprite = 'e_tree_1';
          }

          if (map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(515) }) != -1) {
            let sss = map_tiled_st[map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(515) })]['s'];
            change = 'e_tree_' + sss;
          } else {
            change = 'e_tree_1';
          }

          xxx = Number(xxx) + 80;
          yyy = Number(yyy) - 50;
        }
        if (act == 2 && mission_number.indexOf(type) != -1) {
          if (type != 71 && type != 87 && type != 166) {
            atlas = 'farm_obj_c_atlas';
          } else {
            atlas = 'farm_obj_atlas';
          }
          sprite = change;
          xxx = change_x;
          yyy = change_y;
        } else if (act == 2 && mission_number.indexOf(type) == -1) {
          act1_array.push({
            type: type,
            xxx: xxx,
            yyy: yyy,
            zzz: zzz,
            sprite: sprite,
            act: act,
            atlas: atlas,
            change: change,
            change_x: change_x,
            change_y: change_y,
            iii: i,
          });
        }
        if ((mission_number.indexOf('11') == -1 && type == '62') || type != '62')
          if (
            (mission_number.indexOf('19') == -1 && sprite == 'car_broken_details_1') ||
            (mission_number.indexOf('20') == -1 && sprite == 'car_broken_details_2') ||
            (sprite != 'car_broken_details_1' && sprite != 'car_broken_details_2')
          )
            if (
              (mission_number.indexOf(type) == -1 && act != 1) ||
              (act == 1 && mission_number.indexOf(type) != -1) ||
              (act == 2 && mission_number.indexOf(type) != -1)
            ) {
              if (sprite == 'Fog_Low_Opacity') {
                tile = game.add.sprite(Number(xxx) * 1.2, Number(yyy) * 1.2 + 320 - 16, sprite);
                let x1 = game.rnd.integerInRange(-80, 80);
                if (x1 < 0) {
                  x1 = '-' + Math.abs(x1);
                } else {
                  x1 = '+' + x1;
                }
                let y1 = game.rnd.integerInRange(-80, 80);
                if (y1 < 0) {
                  y1 = '-' + Math.abs(y1);
                } else {
                  y1 = '+' + y1;
                }
                tile.scale.setTo(game.rnd.realInRange(1.2, 1.5));
                game.add
                  .tween(tile)
                  .to({ x: x1, y: y1 }, game.rnd.integerInRange(4000, 6000), Phaser.Easing.Linear.None, true, 0, -1)
                  .yoyo(true, 100);
                game.add
                  .tween(tile.scale)
                  .to(
                    { x: String(0.1 * game.rnd.integerInRange(1, 4)), y: String(0.1 * game.rnd.integerInRange(1, 4)) },
                    game.rnd.integerInRange(4000, 6000),
                    Phaser.Easing.Linear.None,
                    true,
                    0,
                    -1,
                  )
                  .yoyo(true, 100);
              } else {
                tile = game.add.sprite(Number(xxx) * 1.2, Number(yyy) * 1.2 + 320 - 16, atlas, sprite + '.png');
                tile.scale.setTo(2.9);
              }
              tile.anchor.setTo(0.5);
              tile.depth = -1 * zzz;
              if (
                tile.frameName == 'border_1.png' ||
                tile.frameName == 'border_2.png' ||
                tile.frameName == 'borderL_1.png' ||
                tile.frameName == 'borderL_2.png' ||
                tile.frameName == 'borderL_3.png' ||
                tile.frameName == 'borderL_4.png' ||
                tile.frameName == 'borderL_5.png' ||
                tile.frameName == 'borderR_1.png' ||
                tile.frameName == 'borderR_2.png' ||
                tile.frameName == 'borderR_3.png' ||
                tile.frameName == 'borderR_4.png' ||
                tile.frameName == 'borderR_5.png'
              ) {
                tile.depth += depth_border;
                depth_border += 0.001;
              }

              if (tile.frameName == 'a_tree_1.png' || tile.frameName == 'a_tree_2.png' || tile.frameName == 'a_tree_3.png' || tile.frameName == 'a_tree_4.png' || tile.frameName == 'a_tree_5.png' || tile.frameName == 'tree2_broken.png') {
                tile.depth += 0.001;
              }

              if (tile.frameName == 'xmas_tree_2.png') {
                tile.depth -= 0.001;
              }

              tile.type = type;
              tile.act = act;
              tile.ni = i;
              objects_group.add(tile);
              if (
                tile.frameName == 'road_broken.png' ||
                tile.frameName == 'road_broken_corner.png' ||
                tile.frameName == 'road_broken_corner_2.png'
              ) {
                tile.scale.setTo(3);
              }
              if (
                map_tiled_st.findIndex(function (e) {
                  return Number(e['i']) == Number(type);
                }) != -1 &&
                tile.frameName != 'window_k.png' &&
                tile.frameName != 'window_l.png' &&
                tile.frameName != 'window_m.png'
              ) {
                if (
                  (tile.type != 4 &&
                    tile.type != -4 &&
                    tile.type != 6 &&
                    tile.type != -6 &&
                    tile.frameName != 'e_tree_1.png' && tile.frameName != 'e_tree_2.png' &&
                    tile.type != 128 &&
                    tile.type != -128 &&
                    tile.type != 140) ||
                  (tile.type == 140 && mission_number.indexOf('1043') != -1)
                ) {
                  let index = map_tiled_st.findIndex(function (e) {
                    return Number(e['i']) == Number(type);
                  });
                  tile.inputEnabled = true;
                  tile.input.pixelPerfectClick = true;
                  if (tile.type == 7 || tile.type == -7 || tile.type == 10 || tile.type == -10) {
                    tile.input.pixelPerfectClick = false;
                  }
                  if (tile.type == 140 && mission_number.indexOf('1043') != -1) {
                    tile.loadTexture('farm_obj_c_atlas', 'DogHouse1.png');
                  }
                  let numEl = parseInt(tile.frameName.match(/\d(?=\D*$)/));
                  let sprite_name = tile.frameName.replace(numEl + '.png', '');
                  if (numEl != 5 && numEl != 6 && numEl != 7)
                    tile.loadTexture('farm_obj_c_atlas', sprite_name + map_tiled_st[index]['s'] + '.png');
                  if (
                    Number(
                      game.cache.getJSON('buildings')['Special'][0]['Special' + type][0][
                      'x' + map_tiled_st[index]['s']
                      ],
                    ) != 0 ||
                    Number(
                      game.cache.getJSON('buildings')['Special'][0]['Special' + type][0][
                      'y' + map_tiled_st[index]['s']
                      ],
                    ) != 0
                  ) {
                    tile.x += Number(
                      game.cache.getJSON('buildings')['Special'][0]['Special' + type][0][
                      'x' + map_tiled_st[index]['s']
                      ],
                    );
                    tile.y += Number(
                      game.cache.getJSON('buildings')['Special'][0]['Special' + type][0][
                      'y' + map_tiled_st[index]['s']
                      ],
                    );
                  }
                } else if (tile.type == 4 || tile.type == -4) {
                  let index = map_tiled_st.findIndex(function (e) {
                    return Number(e['i']) == Number(type);
                  });
                  let numEl = parseInt(tile.frameName.match(/\d(?=\D*$)/));
                  let sprite_name = tile.frameName.replace(numEl + '.png', '');
                  tile.inputEnabled = true;
                  tile.input.pixelPerfectClick = true;
                  tile.loadTexture('farm_obj_c_atlas', sprite_name + '0.png');
                  if (map_tiled_st[index]['s'] == 1) tile.tint = 0xffd25e;
                  else if (map_tiled_st[index]['s'] == 2) tile.tint = 0x71c1c9;
                  else if (map_tiled_st[index]['s'] == 3) tile.tint = 0xffb990;
                  else if (map_tiled_st[index]['s'] == 4) tile.tint = 0x808080;
                  else if (map_tiled_st[index]['s'] == 5) tile.tint = 0xff00ff;
                  else if (map_tiled_st[index]['s'] == 6) tile.tint = 0x993300;
                  var house = game.add.sprite(0, 0, 'farm_obj_c_atlas', sprite_name + '1.png');
                  house.anchor.setTo(0.5);
                  tile.addChild(house);
                } else if (tile.type == 6 || tile.type == -6) {
                  let index = map_tiled_st.findIndex(function (e) {
                    return Number(e['i']) == Number(type);
                  });
                  let numEl = parseInt(tile.frameName.match(/\d(?=\D*$)/));
                  let sprite_name = tile.frameName.replace(numEl + '.png', '');
                  tile.inputEnabled = true;
                  tile.input.pixelPerfectClick = true;
                  tile.loadTexture('farm_obj_c_atlas', sprite_name + '1.png');
                  if (map_tiled_st[index]['s'] == 1) tile.tint = 0xca8b5c;
                  else if (map_tiled_st[index]['s'] == 2) tile.tint = 0x58431c;
                  else if (map_tiled_st[index]['s'] == 3) tile.tint = 0x197760;
                  else if (map_tiled_st[index]['s'] == 4) tile.tint = 0x7f6fac;
                  else if (map_tiled_st[index]['s'] == 5) tile.tint = 0x3060a1;
                  else if (map_tiled_st[index]['s'] == 6) tile.tint = 0xaf3636;
                  var house = game.add.sprite(0, 0, 'farm_obj_c_atlas', sprite_name + '2.png');
                  house.anchor.setTo(0.5);
                  tile.addChild(house);
                } else if (tile.type == 128 || tile.type == -128) {
                  let index = map_tiled_st.findIndex(function (e) {
                    return Number(e['i']) == Number(type);
                  });
                  let numEl = parseInt(tile.frameName.match(/\d(?=\D*$)/));
                  tile.inputEnabled = true;
                  tile.input.pixelPerfectClick = true;
                  if (map_tiled_st[index]['s'] == 1) tile.tint = 0x889699;
                  else if (map_tiled_st[index]['s'] == 2) tile.tint = 0xa49a7c;
                  else if (map_tiled_st[index]['s'] == 3) tile.tint = 0x6c5364;
                  else if (map_tiled_st[index]['s'] == 4) tile.tint = 0x287e92;
                  else if (map_tiled_st[index]['s'] == 5) tile.tint = 0x8f320e;
                }
              }
              /*if (mission_number.indexOf(type) != -1 && type == '16') {
                var mail_flag = game.add.sprite(0, 0, 'farm_obj_c_atlas', 'mail_flag_emty.png');
                mail_flag.anchor.setTo(0, 0.5);
                mail_flag.depth = 10;
                tile.addChild(mail_flag);
                let index = map_tiled_st.findIndex(function (e) {
                  return Number(e['i']) == Number(type);
                });
                if (index)
                  if (typeof map_tiled_st[index] !== 'undefined')
                    if (typeof map_tiled_st[index]['s'] !== 'undefined') {
                      if (Number(map_tiled_st[index]['s']) == 1) {
                        mail_flag.x = 0;
                        mail_flag.y = -14;
                      } else if (Number(map_tiled_st[index]['s']) == 2) {
                        mail_flag.x = -7;
                        mail_flag.y = -10;
                      } else if (Number(map_tiled_st[index]['s']) == 3) {
                        mail_flag.x = -5;
                        mail_flag.y = -5;
                      } else if (Number(map_tiled_st[index]['s']) == 4) {
                        mail_flag.x = -7;
                        mail_flag.y = -10;
                      } else if (Number(map_tiled_st[index]['s']) == 5) {
                        mail_flag.x = -7;
                        mail_flag.y = -10;
                      }
                    }
              }*/
            } else {
              if (act == 1 && mission_number.indexOf(type) == -1)
                act1_array.push({
                  type: type,
                  xxx: xxx,
                  yyy: yyy,
                  zzz: zzz,
                  sprite: sprite,
                  act: act,
                  atlas: atlas,
                  change: change,
                  change_x: change_x,
                  change_y: change_y,
                  iii: i,
                });
            }
        if (
          Math.abs(tile.type) == 54 &&
          (tile.frameName == 'border_1.png' ||
            tile.frameName == 'border_2.png' ||
            tile.frameName == 'borderL_1.png' ||
            tile.frameName == 'borderL_2.png' ||
            tile.frameName == 'borderL_3.png' ||
            tile.frameName == 'borderL_4.png' ||
            tile.frameName == 'borderL_5.png' ||
            tile.frameName == 'borderR_1.png' ||
            tile.frameName == 'borderR_2.png' ||
            tile.frameName == 'borderR_3.png' ||
            tile.frameName == 'borderR_4.png' ||
            tile.frameName == 'borderR_5.png') &&
          mission_number.indexOf(type) != -1
        ) {
          tile.type = 541;
        }
        if (
          Math.abs(tile.type) == 43 &&
          (tile.frameName == 'border_1.png' ||
            tile.frameName == 'border_2.png' ||
            tile.frameName == 'borderL_1.png' ||
            tile.frameName == 'borderL_2.png' ||
            tile.frameName == 'borderL_3.png' ||
            tile.frameName == 'borderL_4.png' ||
            tile.frameName == 'borderL_5.png' ||
            tile.frameName == 'borderR_1.png' ||
            tile.frameName == 'borderR_2.png' ||
            tile.frameName == 'borderR_3.png' ||
            tile.frameName == 'borderR_4.png' ||
            tile.frameName == 'borderR_5.png') &&
          mission_number.indexOf(type) != -1
        ) {
          tile.type = 431;
        }
        if (tile.frameName == 'many_leaves.png' && mission_number.indexOf(type) != -1) {
          tile.scale.setTo(1.6);
          tile.type = 84;
          tile.act = 0;
        }
        if (
          (tile.type == 82 && mission_number.indexOf(type) == -1 && map_n != 10) ||
          (tile.type == 90 && mission_number.indexOf(type) == -1 && map_n < 10) ||
          (tile.type == 90 && mission_number.indexOf('84') == -1)
        ) {
          tile.alpha = 0;
        }
        if (tile.type == 81 && mission_number.indexOf(type) == -1 && map_n != 10) {
          tile.alpha = 0;
        }
        if (tile.frameName == 'swamp_water.png') {
          var swamp_water = game.add.sprite(0, 0, 'farm_obj_atlas', 'swamp_water.png');
          swamp_water.anchor.setTo(0.5);
          tile.addChild(swamp_water);
          scale_tween(swamp_water, 1500, 0.015, 0.015, -1);
        }
        if (tile.type == 81 && mission_number.indexOf(type) != -1) {
          tile.type = 82;
          tile.act = 0;
        }
        if (tile.type == 152 && mission_number.indexOf(type) != -1) {
          tile.type = 185;
          tile.act = 0;
        }
        if (tile.type == 153 && mission_number.indexOf(type) != -1) {
          tile.type = 185;
          tile.act = 0;
        }
        if (
          tile.type == 43 &&
          (tile.frameName == 'walkway_broken_1.png' ||
            tile.frameName == 'walkway_1.png' ||
            tile.frameName == 'walkway_2.png' ||
            tile.frameName == 'walkway_3.png' ||
            tile.frameName == 'walkway_4.png' ||
            tile.frameName == 'walkway_5.png' ||
            tile.frameName == 'walkway_6.png')
        ) {
          tile.scale.setTo(tile.scale.x / 2);
          tile.x += 100;
          tile.y += 50;
        }
        if (tile.type == 127) {
          var doghead = game.add.sprite(0, -10, 'farm_obj_c_atlas', 'Head1.png');
          doghead.anchor.setTo(0.5);
          tile.addChild(doghead);
          doghead.animations.add(
            'doghead',
            [
              'Head1.png',
              'Head2.png',
              'Head3.png',
              'Head4.png',
              'Head5.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
            ],
            6,
            true,
          );
          doghead.animations.play('doghead');
          var DogSleeping = game.add.sprite(-12, 8, 'farm_obj_c_atlas', 'DogSleeping.png');
          DogSleeping.anchor.setTo(0, 1);
          DogSleeping.alpha = 0;
          tile.addChild(DogSleeping);
          var DogSleepingZ = game.add.sprite(20, -24, 'farm_obj_c_atlas', 'DogSleepingZ.png');
          DogSleepingZ.anchor.setTo(1, 1);
          DogSleepingZ.scale.setTo(0);
          DogSleepingZ.alpha = 1;
          DogSleeping.addChild(DogSleepingZ);
          game.add.tween(DogSleepingZ.scale).to({ x: 1, y: 1 }, 1500, Phaser.Easing.Linear.None, true, 0, -1).loop(true);
          game.add.tween(DogSleepingZ).to({ alpha: 0 }, 1500, Phaser.Easing.Cubic.In, true, 0, -1).loop(true);
          scale_tween(DogSleeping, 1500, 0.05, 0.05, -1);
          dog_sleep(doghead, DogSleeping);
        }
        if (tile.frameName == 'rat.png' && map_n >= 10 && tile.alpha == 1) {
          let rnd1 = game.rnd.integerInRange(100, 200) * 10;
          let rnd2 = game.rnd.integerInRange(100, 300) * 10;
          rat_walk(tile, 200, rnd1, rnd2);
        }
        if (tile.frameName == 'Cloth_1.png') {
          tile.animations.add(
            'Cloth',
            ['Cloth_1.png', 'Cloth_2.png', 'Cloth_3.png', 'Cloth_4.png', 'Cloth_5.png', 'Cloth_6.png'],
            10,
            true,
          );
          tile.animations.play('Cloth');
        }
        if (tile.type == 50 && mission_number.indexOf(type) != -1) {
          tile.type = 51;
          tile.act = 2;
          let change_s = 0;
          if (map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(515) }) != -1) {
            let sss = map_tiled_st[map_tiled_st.findIndex(function (e) { return Number(e['i']) == Number(515) })]['s'];
            change_s = 'e_tree_' + sss;
          } else {
            change_s = 'e_tree_1';
          }

          act1_array.push({
            type: '51',
            xxx: String(tile.x / 1.2),
            yyy: String(tile.y / 1.2 - 320 + 16),
            zzz: String(-tile.depth),
            sprite: 'tree',
            act: '2',
            atlas: 'farm_obj_c_atlas',
            change: change_s,
            change_x: String((tile.x + 20) / 1.2),
            change_y: String((tile.y + 60) / 1.2 - 320 + 16 + 33),
            iii: i,
          });
        }
        if (tile.type == 51 && mission_number.indexOf('1032') != -1 && tile.y > 800 && tile.y < 900) {
          tile.loadTexture('farm_obj_atlas', 'tree2_broken.png');
          tile.type = 115;
          tile.act = 0;
          for (var n = 0; n < 10; n++) {
            var bug = game.add.sprite(
              game.rnd.integerInRange(-20, 20),
              game.rnd.integerInRange(-20, 20),
              'message_invite_mask',
            );
            bug.anchor.setTo(0.5);
            bug.scale.setTo(0.03);
            tile.addChild(bug);
            bug_anim(bug);
          }
          function bug_anim(obj) {
            var sx = game.rnd.integerInRange(10, 30);
            var spmx = game.rnd.integerInRange(0, 1);
            if (spmx == 0) {
              spmx = '-';
            } else {
              spmx = '+';
            }
            var sy = game.rnd.integerInRange(10, 30);
            var spmy = game.rnd.integerInRange(0, 1);
            if (spmy == 0) {
              spmy = '-';
            } else {
              spmy = '+';
            }
            let tween = game.add
              .tween(obj)
              .to({ x: spmx + sx, y: spmy + sy }, game.rnd.integerInRange(400, 700), Phaser.Easing.Linear.None, true)
              .yoyo(true, 100);
            tween.onComplete.add(function () {
              bug_anim(obj);
            });
          }
        }
        if (tile.type == 115 && mission_number.indexOf('115') != -1 && tile.y > 800 && tile.y < 900) {
          tile.destroy();
        }
        if (tile.frameName == 'oil.png' && dialog_mas.indexOf(12) == -1) {
          tile.alpha = 0;
          tile.scale.setTo(0);
        }
        if (tile.frameName == 'car_broken_details_1.png' && mission_number.indexOf(type) != -1) {
          tile.type = 19;
          tile.act = 0;
        } else if (tile.frameName == 'car_broken_details_2.png' && mission_number.indexOf(type) != -1) {
          tile.type = 20;
          tile.act = 0;
        }
        if (tile.type == 62 && mission_number.indexOf(type) != -1) {
          tile.type = 11;
          tile.act = 0;
        }
        if (tile.type == 111 && mission_number.indexOf(type) != -1) {
          tile.type = 131;
          tile.act = 0;
        }
        if (tile.type == 61 && mission_number.indexOf('125') != -1 && tile.x > 1000 && tile.x < 1200) {
          tile.destroy();
        }
        if (tile.type == 132 && mission_number.indexOf(type) != -1 && mission_number.indexOf('133') == -1) {
          tile.type = 133;
          tile.act = 0;
        } else if (tile.type == 132 && mission_number.indexOf(type) != -1 && mission_number.indexOf('133') != -1) {
          tile.destroy();
        }

        if (tile.type == 158 && mission_number.indexOf('1049') != -1) {
          tile.loadTexture('farm_obj_atlas', 'Pagoda_state_2.png');
          tile.type = 159;
          tile.act = 0;
        } if (tile.type == 159 && mission_number.indexOf('1050') != -1) {
          tile.loadTexture('farm_obj_atlas', 'Pagoda_state_3.png');
          tile.type = 160;
          tile.act = 0;
        } if (tile.type == 160 && mission_number.indexOf('1051') != -1) {
          tile.destroy();
        }
        if (tile.type == 145 || tile.type == 174 || tile.type == 170 || tile.type == 171 || tile.type == 172 || tile.type == 173 || tile.type == 32) {
          tile.inputEnabled = true;
        }
        if (tile.frameName == 'flowers_purple_1.png' || tile.frameName == 'flowers_purple_2.png') {
          tile.type = 461;
          tile.inputEnabled = true;
        }
        if (tile.frameName == 'e_tree_1.png' || tile.frameName == 'e_tree_2.png') {
          tile.type = 515;
          tile.inputEnabled = true;
        }
        if ((tile.type == 163 || tile.type == 161) && mission_number.indexOf('1060') != -1) {
          tile.destroy();
        }
        if (tile.type == 164 && mission_number.indexOf('1060') != -1) {
          if (hole_safe == 0) {
            hole_safe = game.add.sprite(7, 65, 'farm_obj_atlas', 'hole_safe.png');
            hole_safe.anchor.setTo(0.5);
            tile.addChild(hole_safe);
          }
        }
        if (tile.type == 186 && mission_number.indexOf('186') != -1) {
          tile.loadTexture('build_icon_atlas', 'clear_water.png');
          scale_tween(tile, 2500, 0.05, 0.05, -1);
        }
        if (tile.type == 183 && mission_number.indexOf('1063') != -1) {
          tile.loadTexture('farm_obj_c_atlas', 'Safe_Engraved.png');
        }
        if (tile.type == 183 && mission_number.indexOf('1069') != -1) {
          tile.loadTexture('farm_obj_c_atlas', 'Safe_Open.png');
        }
        if (tile.type == 154 && tile.frameName == 'leaves3.png') {
          tile.alpha = 0.5;
        }
        if (tile.type == 165 && tile.frameName == 'fundament_1.png' && mission_number.indexOf('166') != -1) {
          tile.destroy();
        }
        if (tile.type == 164 && mission_number.indexOf('183') != -1) {
          if (typeof tile.children[0] !== 'undefined') { tile.children[0].destroy(); }
        }
        if (tile.type == 165 && tile.frameName == 'fundament_1.png' && mission_number.indexOf('166') == -1 && mission_number.indexOf(type) != -1) {
          tile.type = 166;
          tile.act = 0;
        }
        if (tile.frameName == 'xmas_tree_2.png') {
          var obj_des = 0;
          objects_group.children.forEach(function (child_item) {
            if ((child_item.type == 51 || child_item.type == -51 || child_item.frameName == 'tree2_broken.png') && child_item.frameName != 'tree.png') {
              if (obj_des == 0) { obj_des = child_item; }
              if (child_item.x > obj_des.x) { obj_des = child_item; }
            }
          });
          obj_des.alpha = 0;
        }
        if (tile.type == 165 && tile.frameName == 'fundament_2_L.png' && mission_number.indexOf('166') != -1) {
          tile.loadTexture('farm_obj_atlas', 'fundament_3_L.png');
        }
        if (tile.type == 165 && tile.frameName == 'fundament_2_L.png' && mission_number.indexOf('166') == -1 && mission_number.indexOf(type) != -1) {
          tile.type = 166;
          tile.act = 2;
          act1_array.push({
            type: '166',
            xxx: String(tile.x / 1.2),
            yyy: String(tile.y / 1.2 - 320 + 16),
            zzz: String(-tile.depth),
            sprite: 'fundament_2_L',
            act: '2',
            atlas: 'farm_obj_atlas',
            change: 'fundament_3_L',
            change_x: String(tile.x / 1.2),
            change_y: String(tile.y / 1.2 - 320 + 16),
            iii: i,
          });
        }
        if (tile.type == 165 && tile.frameName == 'fundament_2_R.png' && mission_number.indexOf('166') != -1) {
          tile.loadTexture('farm_obj_atlas', 'fundament_3_R.png');
        }
        if (tile.type == 165 && tile.frameName == 'fundament_2_R.png' && mission_number.indexOf('166') == -1 && mission_number.indexOf(type) != -1) {
          tile.type = 166;
          tile.act = 2;
          act1_array.push({
            type: '166',
            xxx: String(tile.x / 1.2),
            yyy: String(tile.y / 1.2 - 320 + 16),
            zzz: String(-tile.depth),
            sprite: 'fundament_2_R',
            act: '2',
            atlas: 'farm_obj_atlas',
            change: 'fundament_3_R',
            change_x: String(tile.x / 1.2),
            change_y: String(tile.y / 1.2 - 320 + 16),
            iii: i,
          });
        }
        if (tile.type == 165 && mission_number.indexOf('149') != -1) {
          tile.destroy();
        }
        if (tile.type == 133 && mission_number.indexOf('140') != -1) {
          tile.destroy();
        } else if (tile.type == 133 && mission_number.indexOf('1048') != -1) {
          tile.loadTexture('farm_obj_c_atlas', 'whiteDoghouse.png');
          tile.type = 140;
          tile.act = 0;
        } else if (tile.type == 133 && mission_number.indexOf('1047') != -1) {
          tile.loadTexture('farm_obj_c_atlas', 'DoghouseUncompleted.png');
        } else if (tile.type == 133 && mission_number.indexOf('1046') != -1) {
          tile.loadTexture('farm_obj_c_atlas', 'wood5.png');
        } else if (tile.type == 133 && mission_number.indexOf('1040') != -1) {
          tile.loadTexture('farm_obj_c_atlas', 'OpenedBox.png');
        }
        if (tile.type == 134 && mission_number.indexOf('133') != -1) {
          tile.alpha = 0;
        }
        if (tile.type == 131 && mission_number.indexOf('131') != -1) {
          tile.alpha = 0;
        }
        if (tile.type == 73 && mission_number.indexOf(type) != -1) {
          tile.type = 74;
          tile.act = 0;
        }
        if (tile.type == 120 && mission_number.indexOf('107') == -1) {
          tile.alpha = 0;
        }
        if (tile.type == 121 && mission_number.indexOf('108') == -1) {
          tile.alpha = 0;
        }
        if ((tile.type == 120 || tile.type == 121) && mission_number.indexOf('111') != -1) {
          tile.alpha = 0;
        }
        if (tile.type == 161 && mission_number.indexOf('1058') != -1 && mission_number.indexOf('152') == -1) {
          waterpump = game.add.sprite(2040 * worldScale, 1260 * worldScale, 'farm_obj_c_atlas', 'waterpump.png');
          waterpump.anchor.setTo(0.5);
          waterpump.scale.setTo(2.9);
          objects_group.add(waterpump);
        }
        if (tile.type == 161 && mission_number.indexOf('1055') != -1 && mission_number.indexOf('1058') == -1) {
          lasso = game.add.sprite(tile.x - 26, tile.y - 214, 'day_16_atlas', 'Pre-comp 3_00072.png');
          lasso.anchor.setTo(0.5);
          lasso.scale.setTo(2);
          objects_group.add(lasso);
        }
        if (tile.type == 33 && mission_number.indexOf(tile.type) != -1) {
          var chimney_smoke = game.add.sprite(tile.x, tile.y, 'farm_obj_c_atlas', 'Chimney_Smoke_1.png');
          chimney_smoke.scale.setTo(2.9);
          chimney_smoke.anchor.setTo(0.65);
          chimney_smoke.depth = 100;
          objects_group.add(chimney_smoke);
          chimney_smoke.animations.add(
            'chimney_smoke',
            [
              'Chimney_Smoke_1.png',
              'Chimney_Smoke_2.png',
              'Chimney_Smoke_3.png',
              'Chimney_Smoke_4.png',
              'Chimney_Smoke_5.png',
            ],
            10,
            true,
          );
          chimney_smoke.animations.play('chimney_smoke');
        }
        if (tile.type == 48) {
          tile.scale.setTo(1);
          var wing2_s = game.add.sprite(0, 0, 'farm_obj_c_atlas', 'wing2_s.png');
          wing2_s.anchor.setTo(0.5);
          tile.addChild(wing2_s);
          game.add
            .tween(tile)
            .to({ x: '+0', y: '-20' }, game.rnd.integerInRange(1000, 2000), Phaser.Easing.Linear.None, true, 0, -1)
            .yoyo(true, 100);
          game.add.tween(wing2_s).to({ alpha: 0 }, 100, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 10);
        }
        if (
          (tile.type == 35 && mission_number.indexOf('39') != -1) ||
          (tile.type == 82 && mission_number.indexOf('82') != -1) ||
          (tile.type == 84 && mission_number.indexOf('84') != -1) ||
          (tile.type == 74 && mission_number.indexOf('74') != -1) ||
          (tile.type == 185 && mission_number.indexOf('185') != -1)
        ) {
          tile.destroy(true);
        }
        if (tile.type == 39 && mission_number.indexOf('39') != -1) {
          var index = special_object.indexOf('3910');
          if (index !== -1) {
            special_object[index] = 3911;
          }
          let numEl = parseInt(tile.frameName.match(/\d(?=\D*$)/));
          if (numEl != 7) {
            var fountane_full = game.add.sprite(tile.x, tile.y, 'farm_obj_c_atlas', 'ff' + numEl + '_0.png');
            fountane_full.scale.setTo(2.9);
            fountane_full.anchor.setTo(0.5);
            fountane_full.depth = tile.depth;
            objects_group.add(fountane_full);
            fountane_full.animations.add(
              'fountane_full',
              [
                'ff' + numEl + '_0.png',
                'ff' + numEl + '_1.png',
                'ff' + numEl + '_2.png',
                'ff' + numEl + '_3.png',
                'ff' + numEl + '_4.png',
              ],
              6,
              true,
            );
            fountane_full.animations.play('fountane_full');
          } else {
            var fountane_full = game.add.sprite(tile.x, tile.y, 'farm_obj_c_atlas', 'fountane_full_' + numEl + '.png');
            fountane_full.scale.setTo(2.9);
            fountane_full.anchor.setTo(0.5);
            fountane_full.depth = tile.depth;
            objects_group.add(fountane_full);
          }
          tile.fount = fountane_full;
        }
        if (map_n >= 9 && tile.type == 999990) {
          tile.destroy();
        }
        if (tile.type == 142 && mission_number.indexOf('142') != -1) {
          tile.destroy();
        }
        if (map_n >= 12 && tile.type == 102) {
          if (tile.frameName == 'RoseYoung.png') {
            tile.loadTexture('farm_obj_c_atlas', 'RoseSmall.png');
            tile.y -= 60;
          }
        }
        if (map_n >= 13 && tile.type == 102 && mission_number.indexOf('1028') != -1) {
          if (tile.frameName == 'RoseSmall.png') {
            tile.loadTexture('farm_obj_c_atlas', 'RoseMedium.png');
            tile.y -= 90;
          }
        }
        if (map_n >= 14 && tile.type == 102 && mission_number.indexOf('1030') != -1) {
          if (tile.frameName == 'RoseMedium.png') {
            tile.loadTexture('farm_obj_c_atlas', 'RoseFully.png');
            tile.y -= 90;
          }
        }
      }
    } else {
      for (i = 0; i <= 121; i++) {
        let xxx = game.cache.getJSON('halloween_map')['object' + i][0]['x'];
        let yyy = game.cache.getJSON('halloween_map')['object' + i][0]['y'];
        let zzz = game.cache.getJSON('halloween_map')['object' + i][0]['z'];
        let sprite = game.cache.getJSON('halloween_map')['object' + i][0]['sprite'];
        let type = game.cache.getJSON('halloween_map')['object' + i][0]['type'];
        let act = game.cache.getJSON('halloween_map')['object' + i][0]['act'];
        let atlas = game.cache.getJSON('halloween_map')['object' + i][0]['atlas'];
        let change = game.cache.getJSON('halloween_map')['object' + i][0]['change'];
        let change_x = game.cache.getJSON('halloween_map')['object' + i][0]['change_x'];
        let change_y = game.cache.getJSON('halloween_map')['object' + i][0]['change_y'];
        if (atlas == 0) {
          atlas = 'xmas_map_atlas';
        } else {
          atlas = 'xmas_map_atlas';
        }

        tile = game.add.sprite(Number(xxx) * 1.2, Number(yyy) * 1.2 + 320 - 16, atlas, sprite + '.png');
        tile.scale.setTo(1.44);
        tile.anchor.setTo(0.5);
        tile.depth = -1 * zzz;
        tile.type = type;
        tile.act = act;
        tile.ni = i;
        objects_group.add(tile);

        if (tile.frameName == "bonfire.png") {
          var bonfire = game.add.sprite(0, 0, 'xmas_map_atlas', 'flame_1.png');
          bonfire.anchor.setTo(0.5, 1);
          bonfire.animations.add(
            'bonfire',
            ['flame_1.png', 'flame_2.png', 'flame_3.png', 'flame_4.png', 'flame_5.png', 'flame_6.png', 'flame_7.png'],
            10,
            true,
          );
          bonfire.animations.play('bonfire');
          tile.addChild(bonfire);
        }

        if (tile.act == 1) {
          tile.alpha = 0;
        }

        if (xmas_level >= 1 && tile.type == 20211) {
          tile.alpha = 1;
        }
        if (xmas_level >= 1 && tile.type == 20211 && tile.act == 0) {
          tile.alpha = 0;
        }
        if (xmas_level >= 5 && tile.type == 20212) {
          tile.alpha = 1;
        }
        if (xmas_level >= 11 && tile.type == 20213) {
          tile.alpha = 1;
        }
        if (xmas_level >= 18 && tile.type == 20214) {
          tile.alpha = 1;
        }
        if (xmas_level >= 24 && tile.type == 20215) {
          tile.alpha = 1;
        }
        if (xmas_level >= 31 && tile.type == 20216) {
          tile.alpha = 1;
        }
        if (xmas_level >= 38 && tile.type == 20217) {
          tile.alpha = 1;
        }
        if (xmas_level >= 45 && tile.type == 20218) {
          tile.alpha = 1;
        }
      }
      objects_group.sort('depth', Phaser.Group.SORT_ASCENDING);

      if (xmas_level >= 45)
        tile = game.add.sprite(0, 0, 'xmas_atlas', 'xmas_darck_8.png');
      else if (xmas_level >= 38)
        tile = game.add.sprite(0, 0, 'xmas_atlas', 'xmas_darck_7.png');
      else if (xmas_level >= 31)
        tile = game.add.sprite(0, 0, 'xmas_atlas', 'xmas_darck_6.png');
      else if (xmas_level >= 24)
        tile = game.add.sprite(0, 0, 'xmas_atlas', 'xmas_darck_5.png');
      else if (xmas_level >= 18)
        tile = game.add.sprite(0, 0, 'xmas_atlas', 'xmas_darck_4.png');
      else if (xmas_level >= 11)
        tile = game.add.sprite(0, 0, 'xmas_atlas', 'xmas_darck_3.png');
      else if (xmas_level >= 5)
        tile = game.add.sprite(0, 0, 'xmas_atlas', 'xmas_darck_2.png');
      else if (xmas_level >= 1)
        tile = game.add.sprite(0, 0, 'xmas_atlas', 'xmas_darck_1.png');
      else
        tile = game.add.sprite(0, 0, 'xmas_atlas', 'xmas_darck_0.png');
      tile.type = 999999999;
      tile.scale.setTo(14.4);
      objects_group.add(tile);
      scale_tween(tile, 500, 0.02, 0.02, -1);

      objects_group.children.forEach(function (child_item) {

        if (xmas_level >= 5 && child_item.frameName == 'chimney.png') {
          var chimney_smoke = game.add.sprite(child_item.x, child_item.y, 'farm_obj_c_atlas', 'Chimney_Smoke_1.png');
          chimney_smoke.scale.setTo(2.9);
          chimney_smoke.anchor.setTo(0.65);
          chimney_smoke.depth = 100;
          objects_group.add(chimney_smoke);
          chimney_smoke.animations.add(
            'chimney_smoke',
            [
              'Chimney_Smoke_1.png',
              'Chimney_Smoke_2.png',
              'Chimney_Smoke_3.png',
              'Chimney_Smoke_4.png',
              'Chimney_Smoke_5.png',
            ],
            10,
            true,
          );
          chimney_smoke.animations.play('chimney_smoke');
        }
      });
    }

    var f_water = 0;
    if (mission_number.indexOf('39') == -1)
      if (mission_number.indexOf('1002') != -1 || mission_number.indexOf('1003') != -1) {
        var f_obj = 0;
        objects_group.children.forEach(function (child_item) {
          if (child_item.type == 35 || child_item.type == -35) {
            f_obj = child_item;
            return true;
          }
        });
        let f_sprite = [];
        if (mission_number.indexOf('1003') != -1) f_sprite = ['Water_1.png', 'Water_2.png', 'Water_3.png'];
        else f_sprite = ['Drops_1.png', 'Drops_2.png'];
        f_water = game.add.sprite(f_obj.x, f_obj.y - 110, 'farm_obj_atlas', f_sprite[0]);
        f_water.scale.setTo(2.9);
        f_water.anchor.setTo(0.5, 1);
        f_water.depth = 100;
        f_water.t = 'water';
        objects_group.add(f_water);
        f_water.animations.add('f_water', f_sprite, 8, true);
        f_water.animations.play('f_water');
      }
    objects_group.sort('depth', Phaser.Group.SORT_ASCENDING);

    //new_options = [];
    //new_options.push({ type: 7, num: [6] });

    function indicator_anim(obj, s) {
      if (typeof obj !== 'undefined') {
        obj.scale.setTo(s);
        game.add.tween(obj.scale).to({ x: '-0.2', y: '+0.2' }, 400, Phaser.Easing.Bounce.Out, true, 3000);
        game.add
          .tween(obj)
          .to({ y: '-20' }, 400, Phaser.Easing.Exponential.Out, true, 3000)
          .onComplete.add(function () {
            game.add.tween(obj.scale).to({ x: '+0.2', y: '-0.2' }, 400, Phaser.Easing.Bounce.Out, true);
            game.add
              .tween(obj)
              .to({ y: '+20' }, 400, Phaser.Easing.Elastic.Out, true)
              .onComplete.add(function () {
                indicator_anim(obj, s);
              });
          });
      }
    }
    function indicator_system(i3, tasks_menu_button, events_menu_button, cards_menu_button) {
      if (xmas == 0) {
        let indicator_1 = 0;
        let indicator_2 = 0;
        let indicator_3 = 0;
        let indicator_4 = 0;
        let indicator_5 = 0;
        let indicator_6 = 0;
        if (shop_free == 1) {
          indicator_6 = 1;
        }
        if (
          complete_level_spec == 2 ||
          complete_task_spec == 0 ||
          new_options.findIndex(function (e) {
            return Number(e['type']) > 0;
          }) != -1
        ) {
          indicator_5 = 1;
        }
        if (gift_mas.length != all_friends && all_friends != 0) {
          indicator_4 = 1;
        }
        for (var j = 1; j < backcards.length; j++) {
          if (backcards[j] == 1) indicator_3 = 1;
        }
        for (var j = 0; j < missions.length; j += 4) {
          if ((missions[j + 2] >= missions[j + 1] && missions[j] != 0 && missions[j] != -100))
            indicator_2 = 1;
        }
        for (var j = 0; j < day_tasks.length; j++) {
          if (mission_task[j] != 1) {
            if (typeof complete_task_i === 'undefined' || isNaN(complete_task_i)) {
              complete_task_i = -1;
            }
            if (
              day_tasks[j]['ifComplete'] == '0' ||
              (day_tasks[j]['ifComplete'] != '0' && contains(mission_number, day_tasks[j]['ifComplete'].split(',')))
            )
              if (day_tasks[j]['preDialog'] == '0' || dialog_mas.indexOf(-day_tasks[j]['preDialog']) != -1)
                if (complete_task_i != -1 && day_tasks[complete_task_i]) {
                  for (i = 0; i < all_day_build; i++)
                    if (
                      contains(mission_number, day_tasks[i]['ifComplete'].split(',')) &&
                      contains(day_tasks[i]['ifComplete'].split(','), [day_tasks[complete_task_i]['type']])
                    ) {
                      indicator_1 = 1;
                    }
                }
          }
        }
        UI_bottom_group.children.forEach(function (child_item) {
          child_item.children.forEach(function (child_item) {
            if (
              (child_item.type == 1 && indicator_1 == 0) ||
              (child_item.type == 2 && indicator_2 == 0) ||
              (child_item.type == 5 && indicator_5 == 0) ||
              (child_item.type == 3 && indicator_3 == 0) ||
              (child_item.type == 4 && indicator_1 == 0 && indicator_2 == 0 && indicator_3 == 0)
            ) {
              child_item.destroy();
            }
          });
        });
        if (indicator_6 == 0 && get_coins_plus_button != 0) {
          if (get_coins_plus_button.children[0]) get_coins_plus_button.children[0].destroy();
          if (prize_button != 0) if (prize_button.children[1]) prize_button.children[1].destroy();
        }
        if (indicator_6 == 1 && get_coins_plus_button != 0 && shop == 1) {
          if (!get_coins_plus_button.children[0]) {
            var indicator = game.add.sprite(
              get_coins_plus_button.width / 2 - 20,
              -get_coins_plus_button.height / 2 + 20,
              'game_ui_atlas',
              'Friends_Notification.png',
            );
            indicator.anchor.setTo(0.5);
            indicator.scale.setTo(0);
            indicator.type = 6;
            get_coins_plus_button.addChild(indicator);
            game.add.tween(indicator.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true);
            indicator_anim(indicator, 1);
          }
        }
        if (indicator_6 == 1 && prize_button != 0 && shop == 1) {
          if (!prize_button.children[1]) {
            var indicator = game.add.sprite(
              prize_button.width / 2 - 20,
              -prize_button.height / 2 + 20,
              'game_ui_atlas',
              'Friends_Notification.png',
            );
            indicator.anchor.setTo(0.5);
            indicator.scale.setTo(0);
            indicator.type = 6;
            prize_button.addChild(indicator);
            game.add.tween(indicator.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true);
            indicator_anim(indicator, 1);
          }
        }
        if (indicator_4 == 1) {
          if (typeof invitereward_button !== 'undefined') {
            if (!invitereward_button.children[0]) {
              var indicator = game.add.sprite(
                invitereward_button.width / 2 - 20,
                -invitereward_button.height / 2 + 20,
                'game_ui_atlas',
                'Friends_Notification.png',
              );
              indicator.anchor.setTo(0.5);
              indicator.scale.setTo(0);
              indicator.type = 4;
              invitereward_button.addChild(indicator);
              game.add.tween(indicator.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true);
              indicator_anim(indicator, 1);
            }
          }
        }
        if (indicator_5 == 1) {
          if (typeof furniture_button !== 'undefined') {
            if (!furniture_button.children[0]) {
              var indicator = game.add.sprite(
                furniture_button.width / 2 - 20,
                -furniture_button.height / 2 + 20,
                'game_ui_atlas',
                'Friends_Notification.png',
              );
              indicator.anchor.setTo(0.5);
              indicator.scale.setTo(0);
              indicator.type = 5;
              furniture_button.addChild(indicator);
              game.add.tween(indicator.scale).to({ x: 1, y: 1 }, 800, Phaser.Easing.Bounce.Out, true);
              indicator_anim(indicator, 1);
            }
          }
        }
        if (indicator_3 == 1 || indicator_2 == 1 || indicator_1 == 1) {
          if (typeof build_button !== 'undefined') {
            if (!build_button.children[0]) {
              var indicator = game.add.sprite(
                build_button.width / 2 - 20,
                -build_button.height / 2 + 20,
                'game_ui_atlas',
                'Friends_Notification.png',
              );
              indicator.anchor.setTo(0.5);
              indicator.scale.setTo(0);
              indicator.type = 4;
              build_button.addChild(indicator);
              game.add.tween(indicator.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true);
              indicator_anim(indicator, 1);
            }
          }
          if (typeof tasks_menu_button !== 'undefined' && indicator_1 == 1) {
            if (!tasks_menu_button.children[0]) {
              var indicator = game.add.sprite(
                tasks_menu_button.width / 2 - 20,
                -tasks_menu_button.height / 2 + 20,
                'game_ui_atlas',
                'Friends_Notification.png',
              );
              indicator.anchor.setTo(0.5);
              indicator.scale.setTo(0);
              indicator.type = 1;
              tasks_menu_button.addChild(indicator);
              game.add.tween(indicator.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true);
              indicator_anim(indicator, 1);
            }
          }
          if (typeof events_menu_button !== 'undefined' && indicator_2 == 1) {
            if (!events_menu_button.children[0]) {
              var indicator = game.add.sprite(
                events_menu_button.width / 2 - 20,
                -events_menu_button.height / 2 + 20,
                'game_ui_atlas',
                'Friends_Notification.png',
              );
              indicator.anchor.setTo(0.5);
              indicator.scale.setTo(0);
              indicator.type = 2;
              events_menu_button.addChild(indicator);
              game.add.tween(indicator.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true);
              indicator_anim(indicator, 1);
            }
          }
          if (typeof cards_menu_button !== 'undefined' && indicator_3 == 1) {
            if (!cards_menu_button.children[0]) {
              var indicator = game.add.sprite(
                cards_menu_button.width / 2 - 20,
                -cards_menu_button.height / 2 + 20,
                'game_ui_atlas',
                'Friends_Notification.png',
              );
              indicator.anchor.setTo(0.5);
              indicator.scale.setTo(0);
              indicator.type = 3;
              cards_menu_button.addChild(indicator);
              game.add.tween(indicator.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true);
              indicator_anim(indicator, 1);
            }
          }
        }
      }
    }
    function rat_walk(obj, move, speed, pause) {
      game.time.events.add(pause, function () {
        obj.scale.x *= -1;
        game.add
          .tween(obj.scale)
          .to({ x: '-0.05', y: '-0.05' }, (speed + pause) / 10 / 2, Phaser.Easing.Linear.None, true, 0, 6)
          .yoyo(true, 0);
        game.add
          .tween(obj)
          .to({ angle: '+4' }, speed / 10 / 2, Phaser.Easing.Linear.None, true, 0, 6)
          .yoyo(true, 0);
      });
      game.add
        .tween(obj)
        .to({ x: '+' + move }, speed, Phaser.Easing.Linear.None, true, pause)
        .onComplete.add(function () {
          game.time.events.add(pause, function () {
            obj.scale.x *= -1;
            game.add
              .tween(obj.scale)
              .to({ x: '+0.05', y: '-0.05' }, (speed + pause) / 10 / 2, Phaser.Easing.Linear.None, true, 0, 6)
              .yoyo(true, 0);
            game.add
              .tween(obj)
              .to({ angle: '-4' }, speed / 10 / 2, Phaser.Easing.Linear.None, true, 0, 6)
              .yoyo(true, 0);
          });
          game.add
            .tween(obj)
            .to({ x: '-' + move }, speed, Phaser.Easing.Linear.None, true, pause)
            .onComplete.add(function () {
              rat_walk(obj, move, speed, pause);
            });
        });
    }
    window.add_shines = function (obj, t, p) {
      if (obj.spark == 1) {
        return true;
      }
      if ((typeof obj != 'undefined' && obj.alpha > 0) || p == 1) {
        if (typeof obj.spark1 != 'undefined' && p != 1) {
          var ttt = t;
          let tm = game.rnd.integerInRange(500, 1000);
          let scl = game.rnd.realInRange(0.5, 1);
          let spd = 600;
          if (ttt > 0) {
            tm = game.rnd.integerInRange(100, 500);
            scl = game.rnd.realInRange(0.2, 0.8);
            spd = game.rnd.integerInRange(100, 300);
            ttt -= 1;
          }
          obj.spark1.x = game.rnd.integerInRange(obj.world.x - obj.width / 2, obj.world.x + obj.width / 2);
          obj.spark1.y = game.rnd.integerInRange(obj.world.y - obj.height / 2, obj.world.y + obj.height / 2);
          obj.spark1.scale.setTo(0);
          obj.spark1.alpha = 0;
          let tween = game.add
            .tween(obj.spark1)
            .to({ alpha: 1 }, spd, Phaser.Easing.Linear.None, true, tm)
            .yoyo(true, 200);
          game.add
            .tween(obj.spark1.scale)
            .to({ x: scl, y: scl }, spd, Phaser.Easing.Linear.None, true, tm)
            .yoyo(true, 200);
          tween.onComplete.add(function (item) {
            if (ttt > 0 || ttt == -1) {
              add_shines(obj, ttt, p);
            }
          });
        } else {
          var ttt = t;
          let tm = game.rnd.integerInRange(500, 1000);
          let scl = game.rnd.realInRange(0.5, 1);
          let spd = 600;
          if (ttt > 0) {
            tm = game.rnd.integerInRange(100, 500);
            scl = game.rnd.realInRange(0.2, 0.8);
            spd = game.rnd.integerInRange(100, 300);
            ttt -= 1;
          }
          let shines1 = 0;
          if (p == 1)
            shines1 = game.add.sprite(
              game.rnd.integerInRange(-obj.width / 2, obj.width / 2),
              game.rnd.integerInRange(-obj.height / 2, obj.height / 2),
              'game_window2_atlas',
              'Shines.png',
            );
          else
            shines1 = game.add.sprite(
              game.rnd.integerInRange(obj.world.x - obj.width / 2, obj.world.x + obj.width / 2),
              game.rnd.integerInRange(obj.world.y - obj.height / 2, obj.world.y + obj.height / 2),
              'game_window2_atlas',
              'Shines.png',
            );
          shines1.anchor.setTo(0.5);
          shines1.scale.setTo(0);
          shines1.alpha = 0;
          let tween = game.add
            .tween(shines1)
            .to({ alpha: 1 }, spd, Phaser.Easing.Linear.None, true, tm)
            .yoyo(true, 200);
          game.add
            .tween(shines1.scale)
            .to({ x: scl, y: scl }, spd, Phaser.Easing.Linear.None, true, tm)
            .yoyo(true, 200);
          rotate_tween(shines1);
          tween.onComplete.add(function (item) {
            if (p == 1) {
              item.destroy();
            }
            if (ttt > 0 || ttt == -1) {
              add_shines(obj, ttt, p);
            }
          });
          if (p == 1) {
            obj.addChild(shines1);
          } else {
            obj.spark1 = shines1;
          }
        }
      }
    };
    window.chest_open_window = function (
      title,
      array,
      t,
      n, //coins,energy,joker,freecards,undomove,tnt,suffle,eye,magnifier,ticket,ultimate,newdeck,+5,pre+5,Windmill,preJoker,TUBA
      ddnaTransactionProps,
    ) {
      // changed so this opens up when the booster is pressed
      if ((popup == 0 && missions_tab_open == 0) || t == 52) {
        if (fbv == 1 && FTUE == 41.4) {
          window.eventTrack('FTUE_15_4Reward_popup_shown');
        }
        if (sound_on == 1) {
          play_sound('receiving_gift');
        }
        itm_a = [];
        animation = 1;
        missions_tab_open = t;
        popup_group.y = 0;
        popup = 1;
        if (t != 51.6) {
          blackf();
        } else {
          game.world.bringToTop(black_sprite);
        }
        var width = 0;
        arc_text(
          title,
          '100px',
          0,
          0,
          game.camera.width / 2,
          game.camera.height / 2 - 320,
          -8,
          1,
          0,
          0,
          50,
          popup_group,
        );
        var shine = game.add.sprite(game.camera.width / 2, game.camera.height / 2, 'game_ui_atlas', 'Shine.png');
        shine.anchor.setTo(0.5, 0.52);
        shine.scale.setTo(0);
        shine.alpha = 0.3;
        popup_group.add(shine);
        shine.fixedToCamera = true;
        game.add.tween(shine.scale).to({ x: 4, y: 4 }, 1000, Phaser.Easing.Exponential.Out, true);
        rotate_tween(shine);
        if (missions_tab_open != 51.51) var prizes = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
        else {
          var prizes = game.add.sprite(game.camera.width / 2, game.camera.height / 2 - 140, '');
          var Big_Chest = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 + 190,
            'baloon_atlas',
            'Big_Chest.png',
          );
          Big_Chest.anchor.setTo(0.5);
          popup_group.add(Big_Chest);
          Big_Chest.fixedToCamera = true;
        }
        popup_group.add(prizes);
        prizes.fixedToCamera = true;
        var lf = 0;
        /*if (array[1] > 0 && !n) {
            if (Number(lifes) < Number(max_max_lifes))
            {
              if ((lifes+Number(array[1])) > max_max_lifes) {
                lf = (lifes+Number(array[1]))-max_max_lifes;
              }
            }
            else
            {
              lf = Number(array[1]);
            }
            array[1] = Number(array[1])-lf;
          }*/

        for (var i = 0; i < array.length; i++) {
          if (array[i] > 0 && i == 11 && backcards[backcards.length - 1] == 1) {
            array[i] = 0;
          }
        }

        var i_n = 0;
        game.setCurrentEvent();
        for (var i = 0; i < array.length; i++) {
          if (array[i] > 0) {
            let spr = 'List_Coin.png';
            let atlas = 'game_window2_atlas';
            let scl = 2;
            if (i == 0) {
              if (lf != 0) {
                array[i] = Number(array[i]) + lf * 50;
              }
              if (missions_tab_open != 51.51) {
                coins += Number(array[i]);
                window.eventTrack('coins_in', Number(array[i]), {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: Number(array[i]),
                  source: source_chest,
                  package_id: package_id_chest,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                // save collected coins
                game.setUserDataAndLog({ currencies: coins });
              }
            } else if (i == 1) {
              if (missions_tab_open != 51.51) {
                lifes = Number(lifes) + Number(array[i]);
              }
              spr = 'List_Energy.png';
            } else if (i == 2) {
              if (missions_tab_open != 51.51) {
                window.eventTrack('booster_in', Number(array[i]), {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: Number(array[i]),
                  source: 'Joker',
                  item_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                free_joker += Number(array[i]);
                if (is_map == 0) {
                  joker_stat();
                }
              }
              spr = 'List_Joker.png';
            } else if (i == 3) {
              if (missions_tab_open != 51.51) {
                free_three += Number(array[i]);
              }
              spr = 'List_Cards.png';
            } else if (i == 4) {
              if (missions_tab_open != 51.51) {
                window.eventTrack('booster_in', Number(array[i]), {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: Number(array[i]),
                  source: 'UndoMove',
                  item_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                free_cardback += Number(array[i]);
              }
              spr = 'List_Card_Back.png';
            } else if (i == 5) {
              if (missions_tab_open != 51.51) {
                window.eventTrack('booster_in', Number(array[i]), {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: Number(array[i]),
                  source: 'TNT',
                  item_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                booster_tnt_col += Number(array[i]);
              }
              spr = 'tnt_booster.png';
              atlas = 'game_atlas';
              scl = 1;
            } else if (i == 6) {
              if (missions_tab_open != 51.51) {
                window.eventTrack('booster_in', Number(array[i]), {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: Number(array[i]),
                  source: 'Shuffle',
                  item_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                booster_shuffle_col += Number(array[i]);
              }
              spr = 'shuffle_booster.png';
              atlas = 'game_atlas';
              scl = 1;
            } else if (i == 7) {
              if (missions_tab_open != 51.51) {
                window.eventTrack('booster_in', Number(array[i]), {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: Number(array[i]),
                  source: 'Bullseye',
                  item_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                booster_eye_col += Number(array[i]);
              }
              spr = 'bullseye_booster.png';
              atlas = 'game_atlas';
              scl = 1;
            } else if (i == 8) {
              if (missions_tab_open != 51.51) {
                window.eventTrack('booster_in', Number(array[i]), {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: Number(array[i]),
                  source: 'Magnifier',
                  item_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                if (free_booster_spec < 0) free_booster_spec -= Number(array[i]); else free_booster_spec += Number(array[i]);
                if (is_map == 0) {
                  special_stat();
                }
              }
              spr = 'Magnifier_Booster.png';
              atlas = 'game_atlas';
              scl = 1;
            } else if (i == 9) {
              xmas_ticket += Number(array[i]);
              spr = 'Ticket.png';
              atlas = 'xmas_atlas';
              scl = 1;
            } else if (i == 10) {
              if (missions_tab_open != 51.51) {
                if (unlimited_lifesDate == 0) {
                  unlimited_lifesDate =
                    ddd == 0
                      ? new Date()
                      : new Date(
                        ddd +
                        ' ' +
                        new Date().getHours() +
                        ':' +
                        new Date().getMinutes() +
                        ':' +
                        new Date().getSeconds(),
                      );
                }
                unlimited_lifesDate.setMinutes(unlimited_lifesDate.getMinutes() + Number(array[i]));
                if (Number(lifes) < Number(max_lifes)) {
                  lifes = Number(max_lifes);
                }
                if (text_lifes != 0 && typeof text_lifes !== 'undefined') text_lifes.setText(lifes);
                LifeDate = 0;
                game.setUserDataAndLog({
                  lifes: String(lifes),
                  life_time: String(LifeDate),
                  unlimited_lifesDate: String(unlimited_lifesDate),
                });
                lifetextChange();
                if (lifes_panel_plus != 0) {
                  lifes_panel_plus.destroy();
                  lifes_panel_plus = 0;
                }
                if (bought == 0) {
                  bought_f = 1;
                }
              }
              spr = 'Energy.png';
              scl = 0.9;
              atlas = 'unlimited_energy_atlas'
            } else if (i == 11) {

              if (Number(array[i]) == 1) {
                for (var iii = 1; iii <= backcards.length; iii++) {
                  if (backcards[iii - 1] == 0 && iii > 3) {
                    spr = 'backcard_' + iii + '.png';
                    backcards[iii - 1] = 1;
                    break;
                  }
                }
              }
              else {
                backcards.push(1);
                spr = 'backcard_' + backcards.length + '.png';
                array[i] = 1;
              }

              scl = 0.5;
              atlas = 'game5_atlas';
            } else if (i == 12) {
              atlas = 'game5_atlas';
              spr = '5_Cards.png';
              scl = 0.9;
              if (free_five >= 0) { free_five += Number(array[i]); } else { free_five -= Number(array[i]); }
            } else if (i == 13) {
              atlas = 'game_window_atlas';
              spr = '+5_Cards.png';
              scl = 0.9;
              free_prebooster1 += Number(array[i]);
            } else if (i == 14) {
              atlas = 'game_window_atlas';
              spr = 'Windmill.png';
              scl = 0.9;
              free_prebooster2 += Number(array[i]);
            } else if (i == 15) {
              atlas = 'game_window_atlas';
              spr = 'Joker.png';
              scl = 0.9;
              free_prebooster3 += Number(array[i]);
            } else if (i == 16) {
              atlas = 'build_icon_atlas';
              spr = 'tube_closed.png';
              scl = 0.9;
            }
            var prize_Rays = game.add.sprite(width, 0, 'game_window2_atlas', 'Rays.png');
            prize_Rays.anchor.setTo(0.5);
            prize_Rays.scale.setTo(0);
            prizes.addChild(prize_Rays);
            game.add.tween(prize_Rays.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, i_n * 200);
            rotate_tween(prize_Rays);
            var prize_Shiny_Ellipse = game.add.sprite(width, 0, 'game_window2_atlas', 'Shiny_Ellipse.png');
            prize_Shiny_Ellipse.anchor.setTo(0.5);
            prize_Shiny_Ellipse.alpha = 0;
            prizes.addChild(prize_Shiny_Ellipse);
            game.add
              .tween(prize_Shiny_Ellipse)
              .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, i_n * 200)
              .onComplete.add(function (item) {
                add_shines(item, -1, 1);
                add_shines(item, -1, 1);
              });
            var prize_1 = game.add.sprite(width, 0, atlas, spr);
            prize_1.anchor.setTo(0.5);
            prize_1.scale.setTo(0);
            prize_1.iii = i;
            prizes.addChild(prize_1);
            game.add.tween(prize_1.scale).to({ x: scl, y: scl }, 500, Phaser.Easing.Bounce.Out, true, i_n * 200);
            itm_a.push(prize_1);
            var prize_1_text = game.add.text(width, 150, atlas == 'unlimited_energy_atlas' && array[i] <= 100 ? array[i] + ' min' : atlas == 'unlimited_energy_atlas' && array[i] > 100 ? array[i] / 60 + ' h' : array[i], {
              font: '36px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            prize_1_text.anchor.setTo(0.5);
            prize_1_text.scale.setTo(0);
            game.add.tween(prize_1_text.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, i_n * 200);
            prizes.addChild(prize_1_text);
            game.setUserDataAndLog({
              currencies: coins,
              lifes: lifes,
              free_joker: free_joker,
              free_three: free_three,
              free_cardback: free_cardback,
              free_booster_spec: free_booster_spec,
              booster_eye_col: booster_eye_col,
              booster_tnt_col: booster_tnt_col,
              booster_shuffle_col: booster_shuffle_col,
              xmas_ticket: xmas_ticket,
              backcards: JSON.stringify(backcards),
              day_prize: JSON.stringify(day_prize),
              free_five: free_five,
              free_prebooster1: free_prebooster1,
              free_prebooster2: free_prebooster2,
              free_prebooster3: free_prebooster3,
            });
            width += prize_Shiny_Ellipse.width + 70;
            i_n++;
          } else {
            itm_a.push(0);
          }
        }
        prizes.cameraOffset.x -= width / 2 - 140;

        if (game.device.desktop)
          var tap_text = game.add.text(
            game.camera.width / 2,
            1470,
            game.cache.getJSON('lang')['t460'][0][window.lang],
            { font: '56px RussoOne', fill: '#fff', align: 'center' },
          );
        else
          var tap_text = game.add.text(
            game.camera.width / 2,
            1470,
            game.cache.getJSON('lang')['t250'][0][window.lang],
            { font: '56px RussoOne', fill: '#fff', align: 'center' },
          );
        tap_text.anchor.setTo(0.5);
        popup_group.add(tap_text);
        tap_text.fixedToCamera = true;
        scale_tween(tap_text, 500, 0.1, 0.1, -1);
        game.add
          .tween(tap_text.cameraOffset)
          .to({ y: '-500' }, 1000, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            animation = 0;
            array222 = array;
          });
        if (missions_tab_open == 51.7) {
          tap_text.alpha = 0;
        }

      }
    };
    try {
      game.sound.context.resume();
    } catch (e) { }
    if (ambient != 0) {
      ambient.destroy();
    }
    ambient = game.add.audio('ambient1', 1, false);
    ambient.play();
    if (sound_on == 0) {
      ambient.pause();
    }
    game.time.events.loop(
      30000,
      function () {
        ambient.play();
        if (sound_on == 0 || loading_text != 0) {
          ambient.pause();
        }
      },
      this,
    );
    if (music != 0) {
      music.destroy();
    }
    music = game.add.audio('music1', 1, true);
    music.volume = 0.2;
    music.play();
    if (music_on == 0) {
      music.pause();
    }
    var cursors = game.input.keyboard.createCursorKeys();
    game.camera.y = game.world.height;
    var all_stars_cardback = 0;
    all_level_col = 0;
    var start_point = 0;
    var stargate_star = 0;
    var stargate_coins = 0;
    var stargate_time = 0;
    var coins_text = coins;
    var user_point_shadow = 0;
    var ix = 0;
    var nl = -1;
    var check_l = 0;
    follow = game.add.sprite(last_position[0], last_position[1], '');
    follow.anchor.setTo(0.5);
    follow.alpha = 0;
    game.camera.focusOnXY(follow.x, follow.y);
    game.camera.follow(follow);
    setTimeout(function () {
      game.camera.follow(follow, Phaser.Camera.FOLLOW_LOCKON, 0.2, 0.2);
    }, 100);
    function div(a, b) {
      return (a - (a % b)) / b;
    }
    var game_tap = 0;
    var tap_y = 0;
    var tap_x = 0;
    var map_x = -1;
    var map_y = -1;
    var special_build = 0;
    game.input.onDown.add(function () {
      if (FTUE == 52) {
        FTUE_process();

      }
      if (FTUE > 30 && special_build == 0) {
        map_move = 0;
        game_tap = 1;
        tap_y = game.input.activePointer.y;
        tap_x = game.input.activePointer.x;
        map_x = game.input.activePointer.x;
        map_y = game.input.activePointer.y;
        clearInterval(map_scroll);
      }
      if (missions_tab_open >= 50 && missions_tab_open <= 53 && (animation == 0 || animation == -1) && array222 != 0) {
        reward_animation();
        game.add
          .tween(black_sprite)
          .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
          .onComplete.add(function (item) {
            if (fbv == 1 && FTUE < 150) {
              window.eventTrack('FTUE_10_9_2_user_clicked');
            }
            if (fbv == 1 && (FTUE == 41.4 || FTUE == 41.5)) {
              window.eventTrack('FTUE_15_5Reward_popup_clicked');
            }
            item.destroy();
          });
        if (missions_tab_open != 53) {
          if (special_stage != 0) {
            bottom_button(0, 0, 0, UI_bottom_group, -1, 1);
          }
        }
        var mto = missions_tab_open;
        missions_tab_open = 0;
        game.add
          .tween(popup_group)
          .to({ alpha: 0 }, 1000, Phaser.Easing.Quadratic.Out, true)
          .onComplete.add(function (item) {
            popup_group.removeAll(true);
            level_end_check = 0;
            if (mto != 51.6) {
              popup = 0;
              animation = 0;
            }
            popup_group.alpha = 1;
            popup_group.y -= game.camera.height;
            array222 = 0;
            if (mto != 52) {
              if (mto == 53) {
                mto = 0;
                shop_window(
                  0,
                  0,
                  0,
                  [
                    { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                    { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                    { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                    { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                    {
                      4: {
                        id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                        packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                        price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                        reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                      },
                    },
                  ],
                  [
                    {
                      0: {
                        type: 'Coins_Pack_1.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '1 000',
                        id: 'coin_package_001',
                        packname: '1,000 Coins',
                        price: '0.99 $',
                        atlas: 'game_window_atlas',
                        reward: [1000],
                      },
                    },
                    {
                      1: {
                        type: 'Coins_Pack_2.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '6 000',
                        id: 'coin_package_02',
                        packname: '6,000 Coins',
                        price: '4.99 $',
                        atlas: 'game_window_atlas',
                        reward: [6000],
                      },
                    },
                    {
                      2: {
                        type: 'Coins_Pack_3.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '13 000',
                        id: 'coin_package_003',
                        packname: '13,000 Coins',
                        price: '9.99 $',
                        atlas: 'game_window_atlas',
                        reward: [13000],
                      },
                    },
                    {
                      3: {
                        type: 'Coins_Pack_4.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '20 000',
                        id: 'coin_package_004',
                        packname: '20,000 Coins',
                        price: '14.99 $',
                        atlas: 'game_window_atlas',
                        reward: [20000],
                      },
                    },
                  ],
                );
              }
              if (mto == 50) {
                mto = 0;
                friends_window();
              }
              if (mto == 51.5) {
                entryPointData_function();
              }
              if (mto == 51.77) {
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 300, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item2) {
                    item2.destroy();
                  });
                game.add.tween(backcard_group).to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(UI_bottom_group)
                  .to({ y: '+400' }, 200, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item2) {
                    friends_group.removeAll(true);
                    backcard_group.removeAll(true); mission_group.removeAll(true);
                    backcard_group.alpha = 1;
                    item2.removeAll(true);
                    UI_bottom_group_create(1, 1, 1, 1, 0);
                    item2.y = 400;
                    game.add
                      .tween(item2)
                      .to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function () {
                        popup = 0;
                        animation = 0;
                        dialog_window(286, 0);
                      });
                  });
              }
              if (mto == 51.6) {
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 300, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item2) {
                    item2.destroy();
                  });
                game.add.tween(backcard_group).to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(UI_bottom_group)
                  .to({ y: '+400' }, 200, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item2) {
                    friends_group.removeAll(true);
                    backcard_group.removeAll(true); mission_group.removeAll(true);
                    backcard_group.alpha = 1;
                    item2.removeAll(true);
                    UI_bottom_group_create(1, 1, 1, 1, 0);
                    item2.y = 400;
                    game.add
                      .tween(item2)
                      .to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function () {
                        popup = 1;
                        animation = 1;
                        build_action(task_iii, 10);
                      });
                  });
              }
            } else {
              popup = 0;
              mto = 0;
              transition(game.cache.getJSON('lang')['t349'][0][window.lang]);
            }
            if (mto != 53) {
              mto = 0;
              if (special_stage != 0) {
                build_special_object(special_stage, 1);
              }
            } else {
              mto = 0;
            }
          });
      }
    }, this);
    function reward_animation() {
      for (var i = 0; i < array222.length; i++) {
        if (array222[i] > 0 && itm_a[i] != 0) {
          if (i == 0) {
            var x1 = itm_a[i].world.x;
            var y1 = itm_a[i].world.y;
            var col = array222[i];
            var coins_text = coins - col;
            text_coins_panel.setText(coins_text);
            var var_coins = 0;
            if (sound_on == 1) {
              play_sound('coins_add');
            }
            game.time.events.repeat(
              100,
              10,
              function () {
                var get_coin = game.add.sprite(
                  x1 + game.rnd.integerInRange(-10, 10),
                  y1 + game.rnd.integerInRange(-10, 10),
                  'game_window2_atlas',
                  'List_Coin.png',
                );
                get_coin.anchor.setTo(0.5);
                get_coin.scale.setTo(0);
                get_coin.alpha = 0;
                effects_group.add(get_coin);
                game.world.bringToTop(effects_group);
                game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                var tween = game.add
                  .tween(get_coin)
                  .to(
                    {
                      x: text_coins_panel.world.x,
                      y: text_coins_panel.world.y,
                    },
                    600,
                    Phaser.Easing.Linear.None,
                    true,
                  );
                tween.onComplete.add(function (item) {
                  item.destroy();
                  var_coins += col / 10;
                  text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                });
                var star_emitter = game.add.emitter(x1, y1, 100);
                star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                star_emitter.setAlpha(1, 0, 800);
                star_emitter.setScale(3, 0, 3, 0, 800);
                star_emitter.start(false, 1000, 10);
                star_emitter.bringToTop = true;
                game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  star_emitter.destroy();
                });
                tween.onUpdateCallback(function () {
                  star_emitter.x = get_coin.x;
                  star_emitter.y = get_coin.y;
                }, this);
              },
              this,
            );
          }
          if (i == 9) {
            var x2 = itm_a[i].world.x;
            var y2 = itm_a[i].world.y;
            var col2 = Number(array222[i]);
            var ticket_text = xmas_ticket - col2;
            xmas_ticket_text.setText(ticket_text);
            var var_ticket = 0;
            game.time.events.repeat(
              100,
              col2,
              function () {
                var get_lifes = game.add.sprite(
                  x2 + game.rnd.integerInRange(-10, 10),
                  y2 + game.rnd.integerInRange(-10, 10),
                  'xmas_atlas',
                  'Ticket.png',
                );
                get_lifes.anchor.setTo(0.5);
                get_lifes.scale.setTo(0);
                get_lifes.alpha = 0;
                effects_group.add(get_lifes);
                game.world.bringToTop(effects_group);
                game.add.tween(get_lifes).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                game.add.tween(get_lifes.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                var tween = game.add
                  .tween(get_lifes)
                  .to(
                    { x: xmas_ticket_text.world.x, y: xmas_ticket_text.world.y },
                    600,
                    Phaser.Easing.Linear.None,
                    true,
                  );
                tween.onComplete.add(function (item) {
                  item.destroy();
                  var_ticket += 1;
                  xmas_ticket_text.setText(Math.ceil(ticket_text + var_ticket));
                });
                var star_emitter = game.add.emitter(x2, y2, 100);
                star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                star_emitter.setAlpha(1, 0, 800);
                star_emitter.setScale(3, 0, 3, 0, 800);
                star_emitter.start(false, 1000, 10);
                star_emitter.bringToTop = true;
                game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  star_emitter.destroy();
                });
                tween.onUpdateCallback(function () {
                  star_emitter.x = get_lifes.x;
                  star_emitter.y = get_lifes.y;
                }, this);
              },
              this,
            );
          }
          if (i == 1 && xmas == 0) {
            var x2 = itm_a[i].world.x;
            var y2 = itm_a[i].world.y;
            var col2 = Number(array222[i]);
            var lifes_text = String(Number(lifes) - Number(col2));
            text_lifes.setText(lifes_text);
            var var_lifes = 0;
            if (Number(lifes) >= Number(max_lifes)) {
              LifeDate = 0;
              lifetextChange();
              if (lifes_panel_plus != 0) {
                lifes_panel_plus.destroy();
                lifes_panel_plus = 0;
              }
            }
            game.time.events.repeat(
              100,
              col2,
              function () {
                var get_lifes = game.add.sprite(
                  x2 + game.rnd.integerInRange(-10, 10),
                  y2 + game.rnd.integerInRange(-10, 10),
                  'game_window2_atlas',
                  'List_Energy.png',
                );
                get_lifes.anchor.setTo(0.5);
                get_lifes.scale.setTo(0);
                get_lifes.alpha = 0;
                effects_group.add(get_lifes);
                game.world.bringToTop(effects_group);
                game.add.tween(get_lifes).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                game.add.tween(get_lifes.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                var tween = game.add
                  .tween(get_lifes)
                  .to({ x: text_lifes.world.x, y: text_lifes.world.y }, 600, Phaser.Easing.Linear.None, true);
                tween.onComplete.add(function (item) {
                  item.destroy();
                  var_lifes += 1;
                  text_lifes.setText(Math.ceil(Number(lifes_text) + Number(var_lifes)));
                });
                var star_emitter = game.add.emitter(x2, y2, 100);
                star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                star_emitter.setAlpha(1, 0, 800);
                star_emitter.setScale(3, 0, 3, 0, 800);
                star_emitter.start(false, 1000, 10);
                star_emitter.bringToTop = true;
                game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  star_emitter.destroy();
                });
                tween.onUpdateCallback(function () {
                  star_emitter.x = get_lifes.x;
                  star_emitter.y = get_lifes.y;
                }, this);
              },
              this,
            );
          }
          if (i == 2 && xmas == 0) {
            var x3 = itm_a[i].world.x;
            var y3 = itm_a[i].world.y;
            var col3 = array222[i];
            game.time.events.repeat(
              100,
              col3,
              function () {
                var get_coin = game.add.sprite(
                  x3 + game.rnd.integerInRange(-10, 10),
                  y3 + game.rnd.integerInRange(-10, 10),
                  'game_window2_atlas',
                  'List_Joker.png',
                );
                get_coin.anchor.setTo(0.5);
                get_coin.scale.setTo(0);
                get_coin.alpha = 0;
                effects_group.add(get_coin);
                game.world.bringToTop(effects_group);
                game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                var tween = game.add
                  .tween(get_coin)
                  .to({ x: level_button.world.x, y: level_button.world.y }, 600, Phaser.Easing.Linear.None, true);
                tween.onComplete.add(function (item) {
                  item.destroy();
                });
                var star_emitter = game.add.emitter(x1, y1, 100);
                star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                star_emitter.setAlpha(1, 0, 800);
                star_emitter.setScale(3, 0, 3, 0, 800);
                star_emitter.start(false, 1000, 10);
                star_emitter.bringToTop = true;
                game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  star_emitter.destroy();
                });
                tween.onUpdateCallback(function () {
                  star_emitter.x = get_coin.x;
                  star_emitter.y = get_coin.y;
                }, this);
              },
              this,
            );
          }
          if (i == 3 && xmas == 0) {
            var x4 = itm_a[i].world.x;
            var y4 = itm_a[i].world.y;
            var col4 = array222[i];
            game.time.events.repeat(
              100,
              col4,
              function () {
                var get_coin = game.add.sprite(
                  x4 + game.rnd.integerInRange(-10, 10),
                  y4 + game.rnd.integerInRange(-10, 10),
                  'game_window2_atlas',
                  'List_Cards.png',
                );
                get_coin.anchor.setTo(0.5);
                get_coin.scale.setTo(0);
                get_coin.alpha = 0;
                effects_group.add(get_coin);
                game.world.bringToTop(effects_group);
                game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                var tween = game.add
                  .tween(get_coin)
                  .to({ x: level_button.world.x, y: level_button.world.y }, 600, Phaser.Easing.Linear.None, true);
                tween.onComplete.add(function (item) {
                  item.destroy();
                });
                var star_emitter = game.add.emitter(x1, y1, 100);
                star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                star_emitter.setAlpha(1, 0, 800);
                star_emitter.setScale(3, 0, 3, 0, 800);
                star_emitter.start(false, 1000, 10);
                star_emitter.bringToTop = true;
                game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  star_emitter.destroy();
                });
                tween.onUpdateCallback(function () {
                  star_emitter.x = get_coin.x;
                  star_emitter.y = get_coin.y;
                }, this);
              },
              this,
            );
          }
          if (i == 4 && xmas == 0) {
            var x5 = itm_a[i].world.x;
            var y5 = itm_a[i].world.y;
            var col5 = array222[i];
            game.time.events.repeat(
              100,
              col5,
              function () {
                var get_coin = game.add.sprite(
                  x5 + game.rnd.integerInRange(-10, 10),
                  y5 + game.rnd.integerInRange(-10, 10),
                  'game_window2_atlas',
                  'List_Card_Back.png',
                );
                get_coin.anchor.setTo(0.5);
                get_coin.scale.setTo(0);
                get_coin.alpha = 0;
                effects_group.add(get_coin);
                game.world.bringToTop(effects_group);
                game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                var tween = game.add
                  .tween(get_coin)
                  .to({ x: level_button.world.x, y: level_button.world.y }, 600, Phaser.Easing.Linear.None, true);
                tween.onComplete.add(function (item) {
                  item.destroy();
                });
                var star_emitter = game.add.emitter(x1, y1, 100);
                star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                star_emitter.setAlpha(1, 0, 800);
                star_emitter.setScale(3, 0, 3, 0, 800);
                star_emitter.start(false, 1000, 10);
                star_emitter.bringToTop = true;
                game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  star_emitter.destroy();
                });
                tween.onUpdateCallback(function () {
                  star_emitter.x = get_coin.x;
                  star_emitter.y = get_coin.y;
                }, this);
              },
              this,
            );
          }
        }
      }
    }
    function level_select(item) {
      if (map_move == 0) {
        if (popup == 0 && animation == 0 && missions_tab_open == 0) {
          level = item.n;
          get_popup();
        }
      }
    }
    function tap_move() {
      if (game_tap == 1 && animation == 0 && map_stop == 0) {
        if (missions_tab_open != 0) {
          if (missions_tab_open == 2 || (missions_tab_open == 1 && (FTUE < 40 || FTUE > 46))) {
            let g = backcard_group;
            let s = 1635;
            if (missions_tab_open == 1) s = 1135;
            if (game.input.activePointer.x < tap_x - 8 && g.cameraOffset.x - 8 > -(g.width - s)) {
              map_move = 1;
              g.cameraOffset.x -= 32;
              tap_x = game.input.activePointer.x;
              setTimeout(function () {
                map_x = tap_x;
              }, 500);
            } else if (game.input.activePointer.x > tap_x + 8 && g.cameraOffset.x + 8 <= 26) {
              map_move = 1;
              g.cameraOffset.x += 32;
              tap_x = game.input.activePointer.x;
              setTimeout(function () {
                map_x = tap_x;
              }, 500);
            }
          } else if (missions_tab_open == 3 && backcard_group_c.width / 360 > 5) {
            let g = backcard_group_c;
            let s = 1920 - 180;
            if (game.input.activePointer.x < tap_x - 8 && g.x - 8 > -(g.width - s)) {
              tap_x = game.input.activePointer.x;
              g.x -= 32;
              map_move = 1;
              setTimeout(function () {
                map_x = tap_x;
              }, 500);
            } else if (game.input.activePointer.x > tap_x + 8 && g.x + 8 <= 26) {
              tap_x = game.input.activePointer.x;
              g.x += 32;
              map_move = 1;
              setTimeout(function () {
                map_x = tap_x;
              }, 500);
            }
          } else if (missions_tab_open == 10) {
            let g = leader_group;
            let s = 324;
            if (
              game.input.activePointer.x > toplist_back.x - game.camera.x - toplist_back.width / 2 + 10 &&
              game.input.activePointer.x < toplist_back.x - game.camera.x + toplist_back.width / 2 - 40 &&
              game.input.activePointer.y > toplist_back.y - game.camera.y - toplist_back.height / 2 &&
              game.input.activePointer.y < toplist_back.y - game.camera.y + toplist_back.height / 2
            ) {
              if (game.input.activePointer.y < tap_y - 8 && g.y - 8 > -(g.hhh * 108 - s)) {
                map_move = 1;
                g.y -= 32;
                tap_y = game.input.activePointer.y;
                setTimeout(function () {
                  map_y = tap_y;
                }, 500);
              } else if (game.input.activePointer.y > tap_y + 8 && g.y + 8 <= 32) {
                map_move = 1;
                g.y += 32;
                tap_y = game.input.activePointer.y;
                setTimeout(function () {
                  map_y = tap_y;
                }, 500);
              }
            }
          }
        } else if (missions_tab_open == 0 && popup == 0 && zooming == false) {
          if (game.input.activePointer.y > tap_y + 2) {
            follow.y -= game.input.activePointer.y - tap_y;
            tap_y = game.input.activePointer.y;
            map_move = 1;
            setTimeout(function () {
              map_y = tap_y;
            }, 200);
          } else if (game.input.activePointer.y < tap_y - 2) {
            follow.y += tap_y - game.input.activePointer.y;
            tap_y = game.input.activePointer.y;
            map_move = 1;
            setTimeout(function () {
              map_y = tap_y;
            }, 200);
          }
          if (game.input.activePointer.x > tap_x + 2) {
            follow.x -= game.input.activePointer.x - tap_x;
            tap_x = game.input.activePointer.x;
            map_move = 1;
            setTimeout(function () {
              map_x = tap_x;
            }, 200);
          } else if (game.input.activePointer.x < tap_x - 2) {
            follow.x += tap_x - game.input.activePointer.x;
            tap_x = game.input.activePointer.x;
            map_move = 1;
            setTimeout(function () {
              map_x = tap_x;
            }, 200);
          }
          if (follow.y < game.camera.height / 2) {
            follow.y = game.camera.height / 2;
          }
          if (follow.y > game.world.height - game.camera.height / 2) {
            follow.y = game.world.height - game.camera.height / 2;
          }
          if (follow.x < game.camera.width / 2) {
            follow.x = game.camera.width / 2;
          }
          if (follow.x > game.world.width - game.camera.width / 2) {
            follow.x = game.world.width - game.camera.width / 2;
          }
        }
      }
    }
    var map_scroll = 0;
    function MapStop() {
      map_stop = 0;
      if (game_tap == 1) {
        if (missions_tab_open != 0) {
          var scr = (map_x - game.input.activePointer.x) * 2;
          var n = Math.abs(scr / 100);
          map_scroll = setInterval(function () {
            if (missions_tab_open == 2 || (missions_tab_open == 1 && (FTUE < 40 || FTUE > 46))) {
              let g = backcard_group;
              let s = 1635;
              if (missions_tab_open == 1) s = 1135;
              if (scr < 0) {
                g.cameraOffset.x += n;
                scr += n;
              }
              if (scr > 0) {
                g.cameraOffset.x -= n;
                scr -= n;
              }
              if (g.cameraOffset.x <= -(g.width - s)) {
                g.cameraOffset.x = -(g.width - s);
                clearInterval(map_scroll);
              } else if (g.cameraOffset.x >= 0) {
                g.cameraOffset.x = 0;
                clearInterval(map_scroll);
              }
            } else if (missions_tab_open == 3 && backcard_group_c.width / 360 > 5) {
              let g = backcard_group_c;
              let s = 1920 - 180;
              if (scr < 0) {
                g.x += n;
                scr += n;
              }
              if (scr > 0) {
                g.x -= n;
                scr -= n;
              }
              if (g.x <= -(g.width - s)) {
                g.x = -(g.width - s);
                clearInterval(map_scroll);
              } else if (g.x >= 0) {
                g.x = 0;
                clearInterval(map_scroll);
              }
            } else if (missions_tab_open == 10) {
              scr = 0;
              let g = leader_group;
              let s = 324;
              if (scr < 0) {
                g.y += n;
                scr += n;
              }
              if (scr > 0) {
                g.y -= n;
                scr -= n;
              }
              if (g.y <= -(g.hhh * 108 - s)) {
                g.y = -(g.hhh * 108 - s);
                clearInterval(map_scroll);
              } else if (g.y >= 0) {
                g.y = 0;
                clearInterval(map_scroll);
              }
            }
            if (n > 1) {
              n -= 0.02;
            } else {
              clearInterval(map_scroll);
            }
          }, 1);
          map_x = -1;
          map_y = -1;
          tap_x = -1;
          tap_y = -1;
        }
      }
      game_tap = 0;
    }
    function blackf() {
      black_sprite = game.add.sprite(0, 0, 'message_invite_mask');
      black_sprite.alpha = 0;
      black_sprite.inputEnabled = true;
      black_sprite.width = game.camera.width;
      black_sprite.height = game.camera.height;
      game.add
        .tween(black_sprite)
        .to({ alpha: 0.8 }, 500, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) { });
      black_sprite.fixedToCamera = true;
    }
    game.camera.onFadeComplete.add(function () {
      if (is_map == 1) {
        if (popup != 111) {
          if ((popup != 4 && level != -1) || baloon != 0) {
            clearInterval(timerId5);
            game.world.removeAll(true);
            game.state.start('Game');
          } else {
            game.setUserDataAndLog({ map_n: map_n });
            clearInterval(timerId5);
            game.world.removeAll(true);
            game.state.start('Map');
          }
        } else {
        }
      }
    }, this);
    function sAge(i, ii) {
      if (i['score'] > ii['score']) return -1;
      else if (i['score'] < ii['score']) return 1;
      else return 0;
    }
    function instruction_popup(item) {
      if (popup == 0 && missions_tab_open == 0) {
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        blackf();
        var popup_back = windows_f(game.cache.getJSON('lang')['t328'][0][window.lang], 1);
        var receive_text = game.add.text(0, 220, game.cache.getJSON('lang')['t251'][0][window.lang], {
          font: '26px RussoOne',
          fill: '#8C3B32',
          align: 'center',
        });
        receive_text.anchor.setTo(0.5);
        popup_back.addChild(receive_text);
        var text_complete = game.add.text(5, -40, game.cache.getJSON('lang')['t252'][0][window.lang], {
          font: '62px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        text_complete.anchor.setTo(0.5);
        text_complete.angle = 5;
        text_complete.stroke = '#0D6A96';
        text_complete.strokeThickness = 4;
        text_complete.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
        popup_back.addChild(text_complete);
        var Play_Button = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 300,
          'game_window_atlas',
          'Play_Button.png',
        );
        Play_Button.anchor.setTo(0.5);
        popup_group.add(Play_Button);
        Play_Button.fixedToCamera = true;
        button_animation_f(Play_Button, 1);
        Play_Button.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup != 2) {
            if (sound_on == 1) {
              play_sound('button_press');
            }
            if (Number(lifes) > 0) {
              context_name = 0;
              new_life(item);
              popup = 2;
              if (buildstart == 1 && FTUE > 150) {
                buildstart = 2;
              }
            } else {
              buy_energy_level = 1;
              popup = 2;
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  missions_tab_open = 0;
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                  get_message(1);
                });
            }
          }
        }, this);
        var Play_Button_text = game.add.text(0, 0, game.cache.getJSON('lang')['t253'][0][window.lang], {
          font: '38px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        Play_Button_text.anchor.setTo(0.5);
        Play_Button_text.stroke = '#3C6C05';
        Play_Button_text.strokeThickness = 4;
        Play_Button_text.setShadow(0, 2, 'rgba(60,108,5,1)', 0);
        Play_Button.addChild(Play_Button_text);
        game.add
          .tween(popup_group)
          .to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function (item) { });
      }
    }
    function leaves_angle(obj, t, n1, n2) {
      game.add
        .tween(obj)
        .to({ angle: n1 }, t, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          game.add
            .tween(item)
            .to({ angle: n2 }, t, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              leaves_angle(item, t, n1, n2);
            });
        });
    }
    angl_mas = [];
    angl_mas2 = [];
    for (var m = 0; m < angl_mas.length; m++) {
      angl_mas2[m] = angl_mas[m].angle;
    }
    function buch_create(xxx, yyy, sssx, sssy, tx, ty, r, p, c, rnd) {
      var leaves_back = game.add.sprite(xxx, yyy, '');
      leaves_back.anchor.setTo(0.75);
      leaves_back.fixedToCamera = true;
      leaves_back.scale.setTo(sssx, sssy);
      leaves_back.angle = r;
      var leaves3 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-3.png');
      leaves3.anchor.setTo(0.75);
      leaves_back.addChild(leaves3);
      leaves3.tint = c;
      var leaves2 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-2.png');
      leaves2.anchor.setTo(0.75);
      leaves_back.addChild(leaves2);
      leaves2.tint = c;
      var leaves1 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-1.png');
      leaves1.anchor.setTo(0.75);
      leaves_back.addChild(leaves1);
      leaves1.tint = c;
      var flowers = game.add.sprite(0, 0, 'loading_atlas', 'flowers' + rnd + '-1.png');
      flowers.anchor.setTo(0.75);
      leaves2.addChild(flowers);
      flowers.tint = c;
      if (angl_mas.length == 0) {
        angl_mas.push(leaves3);
        angl_mas.push(leaves2);
        angl_mas.push(leaves1);
      }
      leaves_angle(leaves3, 3000, '+2', '-2');
      leaves_angle(leaves2, 2000, '+1', '-1');
      leaves_angle(leaves1, 1000, '+0.5', '-0.5');
      game.add.tween(leaves_back.cameraOffset).to({ x: tx, y: ty }, 800, Phaser.Easing.Exponential.Out, true, p);
    }
    function play_level(n) {
      if (n == 1 || xmas == 1) {
        buch_rnd = 5;
      }
      else {
        if (buch_rnd == 5) { buch_rnd = game.rnd.integerInRange(1, 4); }
      }
      animation = 1;
      var graphics = game.add.graphics(0, 0);
      if (n == 0 && xmas == 0) {
        graphics.beginFill(0x386217);
      } else {
        graphics.beginFill(0x74ADBA);
      }
      graphics.alpha = 0;
      graphics.drawRect(0, 0, game.camera.width, game.camera.height);
      graphics.fixedToCamera = true;
      game.add.tween(graphics).to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true);
      buch_create(game.camera.width / 2 + 150, -1000, -2.2, -2.2, '0', '+900', 45, 800, 0xffffff, buch_rnd);
      buch_create(
        game.camera.width / 2 - 150,
        game.camera.height + 1000,
        2.2,
        2.2,
        '0',
        '-900',
        45,
        800,
        0xffffff,
        buch_rnd,
      );
      var graphics = game.add.graphics(0, 0);
      if (n == 0 && xmas == 0) {
        graphics.beginFill(0x386217);
      } else {
        graphics.beginFill(0x74ADBA);
      }
      graphics.alpha = 0;
      graphics.drawRect(0, 0, game.camera.width, game.camera.height);
      graphics.fixedToCamera = true;
      game.add.tween(graphics).to({ alpha: 0.5 }, 800, Phaser.Easing.Linear.None, true);
      buch_create(
        game.camera.width + 1000,
        game.camera.height + 1000,
        2.2,
        2.2,
        '-1000',
        '-1000',
        0,
        0,
        0xffffff,
        buch_rnd,
      );
      buch_create(-1000, -1000, -2.2, 2.2, '+1000', '+1000', 90, 0, 0xffffff, buch_rnd);
      buch_create(game.camera.width + 1000, -1000, 2.2, -2.2, '-1000', '+1000', 0, 400, 0xffffff, buch_rnd);
      buch_create(-1000, game.camera.height + 1000, -2.2, -2.2, '+1000', '-1000', -90, 400, 0xffffff, buch_rnd);
      if (sound_on == 1) {
        play_sound('leaves');
      }

      game.time.events.add(2500, function () {
        for (var m = 0; m < angl_mas.length; m++) {
          angl_mas2[m] = angl_mas[m].angle;
        }
        clearInterval(timerId5);
        game.world.removeAll(true);
        if (n == 1) { xmas_level_go = 1; game.state.start('Map'); } else game.state.start('Game');
      });
    }
    var popupclose = 1;
    var nnn = 0;
    var black_c = 1;
    var toplist_back = 0;
    var playad = game.rnd.integerInRange(1, 100) < 25 ? 1 : 0;
    var playadf = game.rnd.integerInRange(1, 100) < 25 ? 1 : 0;
    var old_contextname = 0;
    var old_contextavatar = 0;
    var old_context = 0;
    var close_ad = 0;

    function get_popup() {
      if (level_max < level_button.n && baloon == 0 && xmas == 0) {
        if (popup == 0 && missions_tab_open == 0) {
          popup_group.y = 0;
          popup_group.y += game.camera.height;
          popup = 1;
          blackf();
          var popup_back = windows_f(game.cache.getJSON('lang')['t329'][0][window.lang], 5);
          var no_task_text = game.add.text(0, 220, game.cache.getJSON('lang')['t254'][0][window.lang], {
            font: '26px RussoOne',
            fill: '#8C3B32',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 800,
          });
          no_task_text.anchor.setTo(0.5);
          popup_back.addChild(no_task_text);
          var green_button = game.add.sprite(0, 300, 'game_window_atlas', 'Big_Kit_Button.png');
          green_button.anchor.setTo(0.5);
          button_animation_f(green_button, 1);
          green_button.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              friend_avatar = 0;
              popup = 2;
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                });
            }
          });
          popup_back.addChild(green_button);
          var green_button_text = game.add.text(0, 0, 'OK', { font: '38px RussoOne', fill: '#fff', align: 'center' });
          green_button_text.anchor.setTo(0.5);
          green_button_text.stroke = '#457310';
          green_button_text.strokeThickness = 2;
          green_button_text.setShadow(0, 3, 'rgba(69,115,16,0.7)', 1);
          green_button.addChild(green_button_text);
          game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true);
        }
      } else if (popup == 0 && missions_tab_open == 0) {
        animation = 1;
        // commented out since otherwise no popup will open
        // TODO check if this can be commented out 
        //missions_tab_open = 10;
        popupclose = 0;
        leader_group.x = 0;
        leader_group.y = 0;
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        if (FTUE > 27 || black_c == 0) {
          blackf();
        }
        if (FTUE > 24) {
          black_c = 0;
        }
        if (noSocial == 0 && xmas == 0) {
          toplist_back = game.add.sprite(
            game.camera.x + game.camera.width / 2,
            game.camera.y + game.camera.height / 2,
            'game_window_atlas',
            'Top_List_Border.png',
          );

          if (game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1) {
            toplist_back.tint = 0xFF797A;
          }
          else if (game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(level_button.n)) != -1) {
            toplist_back.tint = 0xD285FF;
          }
          else {
            toplist_back.tint = 0x47C9E5;
          }

          toplist_back.anchor.setTo(0.5);
          popup_group.add(toplist_back);
          var graphics = game.add.graphics(0, 0);
          graphics.beginFill(0xf8edd4);
          graphics.alpha = 1;
          graphics.drawRoundedRect(-200, -265, 404, 265 + 157 + 108, 20);
          toplist_back.addChild(graphics);
          var top_list_header = game.add.sprite(0, -218, 'game_window_atlas', 'Top_List_Header.png');
          top_list_header.anchor.setTo(0.5);
          toplist_back.addChild(top_list_header);
          var toplist_back_text = game.add.text(0, 0, game.cache.getJSON('lang')['TopList'][0][window.lang], {
            font: '30px RussoOne',
            fill: '#945F3F',
            align: 'center',
          });
          toplist_back_text.setShadow(0, 4, 'rgba(255,255,255,1)', 0);
          toplist_back_text.anchor.setTo(0.5);
          top_list_header.addChild(toplist_back_text);
          popup_group.add(leader_group);
          var leader_mask = game.add.graphics(0, 0);
          leader_mask.beginFill(0xffffff);
          leader_mask.drawRect(-190, -170, 394, 330);
          toplist_back.addChild(leader_mask);
          leader_group.mask = leader_mask;
          try {
            if (is_map == 1) {
              leader_group.removeAll(true);
            }
            fetchAndLogScore('default', 'completedLevels').then(function (leaderboard) {
              if (is_map == 1) {
                if (leaderboard)
                  if (typeof leaderboard[0] !== 'undefined') {
                    if (leaderboard.length < 2) {
                      leaderboard.push({
                        rank: 1,
                        score: 150,
                        user: {
                          id: '0',
                          handle: game.cache.getJSON('lang')['t344'][0][window.lang],
                          isCurrentUser: false,
                          playerId: '-1',
                          avatarUrl: '',
                        },
                      });
                      leaderboard.push({
                        rank: 1,
                        score: 10,
                        user: { id: '0', handle: 'Egor', isCurrentUser: false, playerId: '-1', avatarUrl: '' },
                      });
                      leaderboard.push({
                        rank: 1,
                        score: 5,
                        user: { id: '0', handle: 'Carl', isCurrentUser: false, playerId: '-1', avatarUrl: '' },
                      });
                    } else if (leaderboard.length < 3) {
                      leaderboard.push({
                        rank: 1,
                        score: 10,
                        user: { id: '0', handle: 'Egor', isCurrentUser: false, playerId: '-1', avatarUrl: '' },
                      });
                      leaderboard.push({
                        rank: 1,
                        score: 5,
                        user: { id: '0', handle: 'Carl', isCurrentUser: false, playerId: '-1', avatarUrl: '' },
                      });
                    } else if (leaderboard.length < 4) {
                      leaderboard.push({
                        rank: 1,
                        score: 5,
                        user: { id: '0', handle: 'Carl', isCurrentUser: false, playerId: '-1', avatarUrl: '' },
                      });
                    }
                    leaderboard.sort(sAge);
                    currentindex = leaderboard.findIndex(function (e) {
                      return e['user']['isCurrentUser'] == true;
                    });
                    var col = leaderboard.length;
                    leader_group.hhh = col;
                    if (currentindex != 0) friendpassed_best = leaderboard[currentindex - 1]['score'];
                    try {
                      for (var i = 0; i < col; i++) {
                        if (leaderboard[i]['user']['isCurrentUser'] == true) {
                          if (game.cache.checkImageKey('leader_avatar' + i) == true) {
                            game.load.removeImage('leader_avatar' + i);
                          }
                          game.load.crossOrigin = true;
                          //game.load.image('leader_avatar' + i, FBInstant.player.getPhoto(), 1);
                        } else if (leaderboard[i]['user']['id'] != '0') {
                          if (game.cache.checkImageKey('leader_avatar' + i) == true) {
                            game.load.removeImage('leader_avatar' + i);
                          }
                          game.load.crossOrigin = true;
                          game.load.image('leader_avatar' + i, leaderboard[i]['user']['avatarUrl'], 1);
                        }
                      }
                      game.load.start();
                    } catch (err) {
                      //console.log('Error detected '+err.name);
                    }
                    for (var i = 0; i < col; i++) {
                      try {
                        if (is_map == 1) {
                          var mask = game.add.graphics(0, 0);
                          mask.beginFill(0xffffff);
                          mask.drawCircle(
                            game.camera.x + game.camera.width / 2 - 60,
                            game.camera.y + game.camera.height / 2 - 116 + i * 108,
                            80,
                          );
                          leader_group.add(mask);
                          if (i % 2 == 0) {
                            var graphics = game.add.graphics(0, 0);
                            graphics.beginFill(0xfbf8f0);
                            graphics.alpha = 0.9;
                            graphics.drawRect(
                              game.camera.x + game.camera.width / 2 - 190,
                              game.camera.y + game.camera.height / 2 - 170 + i * 108,
                              394,
                              108,
                            );
                            leader_group.add(graphics);
                          } else {
                            var graphics = game.add.graphics(0, 0);
                            graphics.beginFill(0xf8edd4);
                            graphics.alpha = 0.9;
                            graphics.drawRect(
                              game.camera.x + game.camera.width / 2 - 190,
                              game.camera.y + game.camera.height / 2 - 170 + i * 108,
                              394,
                              108,
                            );
                            leader_group.add(graphics);
                          }
                          var Score_Frame = game.add.sprite(
                            game.camera.x + game.camera.width / 2 + 28,
                            game.camera.y + game.camera.height / 2 - 100 + i * 108,
                            'game_window_atlas',
                            'Score_Frame.png',
                          );
                          Score_Frame.anchor.setTo(0, 0.5);
                          var Mini_Star = game.add.sprite(0, 0, 'game_window_atlas', 'Mini_Star.png');
                          Mini_Star.anchor.setTo(0.5);
                          Score_Frame.addChild(Mini_Star);
                          var Mini_Podium = game.add.sprite(
                            game.camera.x + game.camera.width / 2 - 145,
                            game.camera.y + game.camera.height / 2 - 90 + i * 108,
                            'game_window_atlas',
                            'Mini_Podium.png',
                          );
                          Mini_Podium.anchor.setTo(0.5);
                          if (i == 0)
                            var Number_One_Shine = game.add.sprite(
                              game.camera.x + game.camera.width / 2 - 145,
                              game.camera.y + game.camera.height / 2 - 110 + i * 108,
                              'game_window_atlas',
                              'Number_One_Shine.png',
                            );
                          else
                            var Number_One_Shine = game.add.sprite(
                              game.camera.x + game.camera.width / 2 - 145,
                              game.camera.y + game.camera.height / 2 - 110 + i * 108,
                              'game_window_atlas',
                              'Number_Two_Three_Shine.png',
                            );
                          Number_One_Shine.anchor.setTo(0.5);
                          var Mini_Podium_text = game.add.text(
                            game.camera.x + game.camera.width / 2 - 145,
                            game.camera.y + game.camera.height / 2 - 82 + i * 108,
                            i + 1,
                            { font: '46px RussoOne', fill: '#1275A0', align: 'left' },
                          );
                          Mini_Podium_text.anchor.setTo(0.5, 1);
                          Mini_Podium_text.stroke = '#fff';
                          Mini_Podium_text.strokeThickness = 4;
                          if (leaderboard[i]['user']['isCurrentUser'] == true)
                            var leader_name_text = game.add.text(
                              game.camera.x + game.camera.width / 2 + 10,
                              game.camera.y + game.camera.height / 2 - 156 + i * 108,
                              CurrentUserName,
                              { font: '28px RussoOne', fill: '#fff', align: 'left' },
                            );
                          else
                            var leader_name_text = game.add.text(
                              game.camera.x + game.camera.width / 2 + 10,
                              game.camera.y + game.camera.height / 2 - 156 + i * 108,
                              leaderboard[i]['user']['handle'],
                              { font: '28px RussoOne', fill: '#fff', align: 'left' },
                            );
                          leader_name_text.stroke = '#C27E54';
                          leader_name_text.strokeThickness = 4;
                          var leader_score_text = game.add.text(36, 3, leaderboard[i]['score'], {
                            font: '18px RussoOne',
                            fill: '#fff',
                            align: 'center',
                          });
                          leader_score_text.anchor.setTo(0.5);
                          Score_Frame.addChild(leader_score_text);
                          if (leaderboard[i]['user']['id'] != '0')
                            var leader_avatar = game.add.image(
                              game.camera.x + game.camera.width / 2 - 60,
                              game.camera.y + game.camera.height / 2 - 116 + i * 108,
                              'game_atlas',
                              'no_avatar.png',
                            );
                          else {
                            if (leaderboard[i]['user']['handle'] == game.cache.getJSON('lang')['t344'][0][window.lang])
                              var leader_avatar = game.add.image(
                                game.camera.x + game.camera.width / 2 - 60,
                                game.camera.y + game.camera.height / 2 - 116 + i * 108,
                                'char_atlas',
                                'Main_Neutral.png',
                              );
                            else if (leaderboard[i]['user']['handle'] == 'Egor')
                              var leader_avatar = game.add.image(
                                game.camera.x + game.camera.width / 2 - 60,
                                game.camera.y + game.camera.height / 2 - 116 + i * 108,
                                'char_atlas',
                                'Evil_Main.png',
                              );
                            else
                              var leader_avatar = game.add.image(
                                game.camera.x + game.camera.width / 2 - 60,
                                game.camera.y + game.camera.height / 2 - 116 + i * 108,
                                'char_atlas',
                                'Lover_Guy_Main.png',
                              );
                          }
                          leader_avatar.anchor.setTo(0.5);
                          leader_avatar.width = leader_avatar.height = 90;
                          leader_avatar.mask = mask;
                          leader_avatar.t = 'ava';
                          leader_avatar.i = i;
                          var Top_List_Friend_Frame = game.add.image(
                            game.camera.x + game.camera.width / 2 - 60,
                            game.camera.y + game.camera.height / 2 - 116 + i * 108,
                            'game_window_atlas',
                            'Top_List_Friend_Frame.png',
                          );
                          Top_List_Friend_Frame.anchor.setTo(0.5);
                          leader_group.add(leader_name_text);
                          leader_group.add(leader_avatar);
                          leader_group.add(Top_List_Friend_Frame);
                          leader_group.add(Mini_Podium);
                          leader_group.add(Number_One_Shine);
                          leader_group.add(Mini_Podium_text);
                          leader_group.add(Score_Frame);
                        }
                      } catch (err) { }
                    }
                  }
                if (is_map == 1) {
                  var i = 0;
                  game.time.events.repeat(100, col, function () {
                    try {
                      if (game.cache.checkImageKey('leader_avatar' + i) == true) {
                        leader_group.children.forEach(function (child_item) {
                          if (child_item.i == i && child_item.t == 'ava') {
                            child_item.loadTexture('leader_avatar' + i);
                            child_item.width = child_item.height = 90;
                            return true;
                          }
                        });
                      }
                    } catch (err) { }
                    i++;
                  });
                }
              }
            });
          } catch (err) { }
        }
        // if (fbv == 1 && xmas == 0) {
        //   var New_Friend = game.add.sprite(-120, 211, 'game_window_atlas', 'New_Friend.png');
        //   New_Friend.anchor.setTo(0.5);
        //   toplist_back.addChild(New_Friend);
        //   var Invite_Friend_Button = game.add.sprite(60, 211, 'game_window_atlas', 'Invite_Friend_Button.png');
        //   Invite_Friend_Button.anchor.setTo(0.5);
        //   button_animation_f(Invite_Friend_Button, 1);
        //   Invite_Friend_Button.events.onInputUp.add(function (item) {
        //     btnup(item);
        //     if (popup != 2) {
        //       popup = 2;
        //       if (level_button.n == 3) {
        //         if (fbv == 1) {
        //           window.eventTrack('FTUE_5_6_B_FacebookPopupInviteSent');
        //         }
        //       } else if (level_button.n == 4) {
        //         if (fbv == 1) {
        //           window.eventTrack('FTUE_7_6_C_FacebookPopupInviteSent');
        //         }
        //       } else if (level_button.n == 5) {
        //         if (fbv == 1) {
        //           window.eventTrack('FTUE_9_10_C_FacebookPopupInviteSent');
        //         }
        //       }
        //       let group = game.add.group();
        //       group.y = -344;
        //       var r_image = get_random_change([
        //         'HELP_ME.jpg',
        //         'ENJOY_YOUR_GARDEN.jpg',
        //         'FIX_YOUR_HOUSE_AND_GARDEN.jpg',
        //       ]);
        //       var r_txt = get_random_change(['PlayWithMe1', 'PlayWithMe2']);
        //       var message_invite = game.add.sprite(668 / 2, 344 / 2, 'message_atlas', r_image);
        //       message_invite.scale.setTo(2);
        //       message_invite.anchor.setTo(0.5);
        //       group.add(message_invite);
        //       group.inputEnabled = false;
        //       group.y = 0;
        //       let group2 = game.add.group();
        //       group2.addChild(group);
        //       var renderTexture = game.make.renderTexture(668, 344);
        //       renderTexture.render(group2);
        //       group2.destroy();
        //       var mID =
        //         ddd == 0
        //           ? new Date()
        //           : new Date(
        //             ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
        //           );
        //       loading();

        //       // FBInstant.context
        //       //   .chooseAsync({
        //       //     filters: ['NEW_PLAYERS_ONLY'],
        //       //     minSize: 3,
        //       //   })
        //       //   .then(function () {
        //       //     numFriendsInvited += 1;
        //       //     first_start = -1;
        //       //     game.setUserDataAndLog({ first_start: first_start, numFriendsInvited: numFriendsInvited });
        //       //     updateAsync(
        //       //       {
        //       //         action: 'CUSTOM',
        //       //         image: renderTexture.getBase64(),
        //       //         text: game.cache.getJSON('lang')[r_txt][0][window.lang],
        //       //         template: 'play_turn',
        //       //         data: {
        //       //           userId: CurrentUserId,
        //       //           messageId: mID.getTime(),
        //       //           data: 'SetNewFriend',
        //       //           bonus: 0,
        //       //         },
        //       //         strategy: 'IMMEDIATE',
        //       //         notification: 'NO_PUSH',
        //       //       },
        //       //       {
        //       //         actionLevel: null,
        //       //         targetUserID: null,
        //       //         socialActionType: DdnaSocialActionType.InviteFriend,
        //       //         socialRewardType: DdnaSocialRewardType.No,
        //       //       },
        //       //     );
        //       //     if (loading_black_sprite != 0) {
        //       //       loading_black_sprite.destroy();
        //       //       loading_black_sprite = 0;
        //       //     }
        //       //     if (loading_text != 0 && loading_text != 1) {
        //       //       loading_text.destroy();
        //       //       loading_text = 0;
        //       //     }
        //       //     popup = 1;
        //       //   })
        //       //   .catch(function (error) {
        //       //     if (loading_black_sprite != 0) {
        //       //       loading_black_sprite.destroy();
        //       //       loading_black_sprite = 0;
        //       //     }
        //       //     if (loading_text != 0 && loading_text != 1) {
        //       //       loading_text.destroy();
        //       //       loading_text = 0;
        //       //     }
        //       //     popup = 1;
        //       //   });
        //     }
        //   });
        //   toplist_back.addChild(Invite_Friend_Button);
        //   var Invite_Friend_Button_text = game.add.text(0, -4, game.cache.getJSON('lang')['t255'][0][window.lang], {
        //     font: '22px RussoOne',
        //     fill: '#fff',
        //     align: 'center',
        //   });
        //   Invite_Friend_Button_text.anchor.setTo(0.5);
        //   Invite_Friend_Button_text.stroke = '#3C6C05';
        //   Invite_Friend_Button_text.strokeThickness = 4;
        //   Invite_Friend_Button_text.setShadow(0, 2, 'rgba(60,108,5,1)', 0);
        //   Invite_Friend_Button.addChild(Invite_Friend_Button_text);
        // }
        if (xmas == 1) {
          var popup_back = windows_f(
            game.cache.getJSON('lang')['Level'][0][window.lang] + ' ' + String(xmas_level + 1),
            666,
          );
        } else if (baloon != 1) {
          var popup_back = windows_f(
            game.cache.getJSON('lang')[game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? 'SuperHardLevel' : game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? 'HardLevel' : 'Level'][0][window.lang] + ' ' + String(all_level.lastIndexOf(3) + 2),
          );
        }
        else
          var popup_back = windows_f(
            game.cache.getJSON('lang')['BalloonChallenge'][0][window.lang] + ' ' + baloonlevel,
            6,
          );
        if (game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1 || game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(level_button.n)) != -1) {
          let Reward_Tag = game.add.sprite(-400, -360, 'game_window_atlas', 'Reward_Tag.png');
          Reward_Tag.anchor.setTo(0.5);
          popup_back.addChild(Reward_Tag);
          let Reward_Tag_text = game.add.text(10, -54, game.cache.getJSON('lang')['Reward2'][0][window.lang], {
            font: '32px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          Reward_Tag_text.anchor.setTo(0.5);
          Reward_Tag_text.angle = -9;
          Reward_Tag_text.stroke = '#0D6A96';
          Reward_Tag_text.strokeThickness = 4;
          Reward_Tag_text.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
          Reward_Tag.addChild(Reward_Tag_text);
          let price_icon = game.add.sprite(-35, 18, 'game_ui_atlas', 'Coin_Icon.png');
          price_icon.scale.setTo(0.5);
          price_icon.anchor.setTo(0.5);
          Reward_Tag.addChild(price_icon);
          Reward_Tag_text = game.add.text(45, 10, game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? '200' : '100', {
            font: '48px RussoOne',
            fill: '#0D6A96',
            align: 'center',
          });
          Reward_Tag_text.anchor.setTo(0.5);
          Reward_Tag_text.angle = -9;
          Reward_Tag.addChild(Reward_Tag_text);
        }
        if (baloon != 1) {

          var Booster_Background_Shape = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2,
            'game_window_atlas',
            'Booster_Background_Shape.png',
          );
          Booster_Background_Shape.anchor.setTo(0.5);
          Booster_Background_Shape.scale.setTo(2);
          popup_group.add(Booster_Background_Shape);
          Booster_Background_Shape.fixedToCamera = true;

          var Info_Button = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 - 170,
            'game_window_atlas',
            'Info_Button.png',
          );
          Info_Button.anchor.setTo(0.5);
          popup_group.add(Info_Button);
          Info_Button.fixedToCamera = true;
          button_animation_f(Info_Button, 1);
          Info_Button.click = 0;

          Info_Button.events.onInputUp.add(function (item) {
            btnup(item);
            if (animation == 0) {
              if (item.click == 0) {
                animation = 1;
                item.click = 1;
                game.add.tween(free_prebooster1_info).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 300);
                if (typeof free_prebooster1_text !== 'undefined') { game.add.tween(free_prebooster1_text.cameraOffset).to({ y: '-90' }, 500, Phaser.Easing.Linear.None, true); }
                game.add.tween(free_prebooster2_info).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 300);
                if (typeof free_prebooster2_text !== 'undefined') { game.add.tween(free_prebooster2_text.cameraOffset).to({ y: '-90' }, 500, Phaser.Easing.Linear.None, true); }
                game.add.tween(free_prebooster3_info).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 300);
                if (typeof free_prebooster3_text !== 'undefined') { game.add.tween(free_prebooster3_text.cameraOffset).to({ y: '-90' }, 500, Phaser.Easing.Linear.None, true); }
                game.add.tween(item.cameraOffset).to({ y: '-70' }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(Info_Button_text.cameraOffset).to({ y: '-70' }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(result_stars1.cameraOffset).to({ y: '-90' }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(result_stars2.cameraOffset).to({ y: '-90' }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(result_stars3.cameraOffset).to({ y: '-90' }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                  animation = 0;
                });
              } else {
                animation = 1;
                item.click = 0;
                game.add.tween(free_prebooster1_info).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                if (typeof free_prebooster1_text !== 'undefined') { game.add.tween(free_prebooster1_text.cameraOffset).to({ y: '+90' }, 500, Phaser.Easing.Linear.None, true); }
                game.add.tween(free_prebooster2_info).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                if (typeof free_prebooster2_text !== 'undefined') { game.add.tween(free_prebooster2_text.cameraOffset).to({ y: '+90' }, 500, Phaser.Easing.Linear.None, true); }
                game.add.tween(free_prebooster3_info).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                if (typeof free_prebooster3_text !== 'undefined') { game.add.tween(free_prebooster3_text.cameraOffset).to({ y: '+90' }, 500, Phaser.Easing.Linear.None, true); }
                game.add.tween(item.cameraOffset).to({ y: '+70' }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(Info_Button_text.cameraOffset).to({ y: '+70' }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(result_stars1.cameraOffset).to({ y: '+90' }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(result_stars2.cameraOffset).to({ y: '+90' }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(result_stars3.cameraOffset).to({ y: '+90' }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                  animation = 0;
                });
              }
            }
          });

          var Info_Button_text = game.add.text(game.camera.width / 2 + 50, game.camera.height / 2 - 170, 'Select Power Ups:', {
            font: '40px RussoOne',
            fill: '#147AA4',
            align: 'left'
          });

          Info_Button_text.anchor.setTo(0, 0.5);
          popup_group.add(Info_Button_text);
          Info_Button_text.fixedToCamera = true;

          Info_Button.cameraOffset.x -= (Info_Button.width / 2 + Info_Button_text.width) / 2;
          Info_Button_text.cameraOffset.x -= (Info_Button.width / 2 + Info_Button_text.width) / 2;

          if (level_button.n > 12 && free_prebooster1 == -9999) { free_prebooster1 = 0; }
          if (level_button.n > 20 && free_prebooster2 == -9999) { free_prebooster2 = 0; }
          if (level_button.n > 30 && free_prebooster3 == -9999) { free_prebooster3 = 0; }

          var result_stars1 = game.add.sprite(
            game.camera.width / 2 - 260,
            game.camera.height / 2 - 20,
            'game_window_atlas',
            (level_button.n > 12 || free_prebooster1 > 0) ? '+5_Cards.png' : '+5_Cards_BW.png',
          );
          result_stars1.anchor.setTo(0.5);
          popup_group.add(result_stars1);
          result_stars1.fixedToCamera = true;
          if (level_button.n > 12 || free_prebooster1 > 0) { button_animation_f(result_stars1, 1); }

          result_stars1.events.onInputUp.add(function (item) {
            btnup(item);
            if (animation == 0 || FTUE_Arrow != 0) {
              if (FTUE_Arrow != 0) { animation = 0; }
              f_w_a();
              if (free_prebooster1_select == 0) {
                if (level_button.n == 12 || free_prebooster1 > 0) {
                  if (level_button.n >= 12) {
                    free_prebooster1_select = 1;
                  }
                  item.children[0].alpha = 1;
                } else {


                  animation = 1;
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });

                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup = 0;
                      animation = 0;
                      popup_group.y -= game.camera.height;
                      if (shop == 1) {
                        shop_window(
                          1,
                          0,
                          600,
                          [
                            { 0: { type: '+5_Cards.png', col: '15x', atlas: 'game_window_atlas' } },
                            { 1: { type: 'Big_Kit_List_Coin.png', col: '1 000', atlas: 'game_window_atlas' } },
                            { 2: { type: 'Big_Kit_List_Card_Back.png', col: '3x', atlas: 'game_window_atlas' } },
                            { 3: { type: 0, col: 0, atlas: 'game_window2_atlas' } },
                            {
                              4: {
                                id: 'pre_lvl_5cards_x15',
                                packname: '+5 Cards Package',
                                price: '7.99 $',
                                reward: [1000, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 15],
                              },
                            },
                          ],
                          [
                            {
                              0: {
                                type: '+5_Cards.png',
                                sprite: '+5_Cards.png',
                                col: '3x',
                                id: 'pre_lvl_5cards_x3',
                                packname: '3x +5 Cards',
                                price: '1.99 $',
                                atlas: 'game_window_atlas',
                                reward: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3],
                              },
                            },
                            {
                              1: {
                                type: '+5_Cards.png',
                                sprite: '+5_Cards.png',
                                col: '5x',
                                id: 'pre_lvl_5cards_x5',
                                packname: '5x +5 Cards',
                                price: '2.99 $',
                                atlas: 'game_window_atlas',
                                reward: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5],
                              },
                            },
                            {
                              2: {
                                type: '+5_Cards.png',
                                sprite: '+5_Cards.png',
                                col: '8x',
                                id: 'pre_lvl_5cards_x8',
                                packname: '8x +5 Cards',
                                price: '3.99 $',
                                atlas: 'game_window_atlas',
                                reward: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8],
                              },
                            },
                            { 3: { type: 0, sprite: 0, col: 0, id: 0, packname: 0, price: 0, atlas: 'game_atlas' } },
                          ],
                        );
                      } else {
                        if (coins >= 1500) {
                          coins -= 1500;
                          text_coins_panel.setText(coins);
                          chest_open_window(
                            game.cache.getJSON('lang')['Reward!'][0][window.lang],
                            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3],
                            51,
                            1,
                            {
                              //gameArea: DdnaGameArea.Map,
                              gameArea: null,
                              actionType: null,
                              //actionType: DdnaTransactionActionType.RealMoneyPurchase,
                              productId: 0,
                            },
                          );
                        }
                        else {
                          get_message(2);
                        }
                      }
                    });


                }
              }
              else {
                free_prebooster1_select = 0;
                item.children[0].alpha = 0;
              }
            }
          });



          var free_prebooster1_info = game.add.text(game.camera.width / 2 - 260, game.camera.height / 2 + 30, 'Adds +5 more cards to your card deck.', {
            font: '24px RussoOne',
            fill: '#147AA3',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 220,
          });

          free_prebooster1_info.anchor.setTo(0.5, 0);
          free_prebooster1_info.lineSpacing = -10;
          free_prebooster1_info.stroke = '#fff';
          free_prebooster1_info.strokeThickness = 4;
          popup_group.add(free_prebooster1_info);
          free_prebooster1_info.alpha = 0;
          free_prebooster1_info.fixedToCamera = true;

          if (free_prebooster1 > 0 && level_button.n > 12) {
            var free_prebooster1_text = game.add.text(game.camera.width / 2 - 260, game.camera.height / 2 + 97, 'x' + free_prebooster1, {
              font: '44px RussoOne',
              fill: '#fff',
              align: 'center'
            });
            free_prebooster1_text.anchor.setTo(0.5);
            free_prebooster1_text.stroke = '#360909';
            free_prebooster1_text.strokeThickness = 4;
            popup_group.add(free_prebooster1_text);
            free_prebooster1_text.fixedToCamera = true;
          } else if (level_button.n > 12) {
            if (shop == 0) {
              var free_prebooster1_text = game.add.text(game.camera.width / 2 - 260, game.camera.height / 2 + 97, 1500, {
                font: '42px RussoOne',
                fill: '#fff',
                align: 'center'
              });
              free_prebooster1_text.anchor.setTo(0.5);
              free_prebooster1_text.stroke = '#360909';
              free_prebooster1_text.strokeThickness = 4;
              popup_group.add(free_prebooster1_text);
              free_prebooster1_text.fixedToCamera = true;
            }

            var Plus_Button = game.add.sprite(
              60,
              60,
              'game_ui_atlas',
              'Get_Coins_Plus_Button.png',
            );
            Plus_Button.anchor.setTo(0.5);
            result_stars1.addChild(Plus_Button);

          } else if (level_button.n < 12) {
            var free_prebooster1_text = game.add.text(game.camera.width / 2 - 260, game.camera.height / 2 + 97, 'LEVEL 12', {
              font: '34px RussoOne',
              fill: '#C6C6C6',
              align: 'center'
            });
            free_prebooster1_text.alpha = 0.8;
            free_prebooster1_text.anchor.setTo(0.5);
            free_prebooster1_text.stroke = '#757474';
            free_prebooster1_text.strokeThickness = 4;
            popup_group.add(free_prebooster1_text);
            free_prebooster1_text.fixedToCamera = true;
          }

          var Check_Icon = game.add.sprite(60, 60,
            'game_window_atlas',
            'Check_Icon.png',
          );
          Check_Icon.alpha = 0;
          Check_Icon.anchor.setTo(0.5);
          result_stars1.addChild(Check_Icon);

          if (level_button.n < 12 || free_prebooster1 == -9999) {
            var Lock = game.add.sprite(60, 60,
              'game_window_atlas',
              'Lock.png',
            );
            Lock.anchor.setTo(0.5);
            result_stars1.addChild(Lock);

            if (level_button.n == 12 && free_prebooster1 == -9999) {
              animation = 1;
              game.add.tween(result_stars1.scale).to({ x: 0, y: 1.1 }, 200, Phaser.Easing.Linear.None, true, 2200).onComplete.add(function (item) {
                result_stars1.loadTexture('game_window_atlas', '+5_Cards.png');
                game.add.tween(result_stars1.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                  free_prebooster1 = 3;
                  game.setUserDataAndLog({ free_prebooster1: free_prebooster1 });
                  button_animation_f(result_stars1, 1);

                  if (fbv == 1) {
                    w = ftue_window(
                      'Main_Presenting.png',
                      'Congratulations - you can now start any next level with +5 cards! Activate it to try for free!',
                      game.camera.width / 2,
                      230,
                    );
                    effects_group.add(w);
                  }
                  if (sound_on == 1) {
                    play_sound('hint_with_arrow');
                  }
                  FTUE_Arrow = game.add.sprite(
                    game.camera.width / 2 - 260,
                    game.camera.height / 2 + 10,
                    'game_atlas',
                    'FTUE_Arrow.png',
                  );
                  FTUE_Arrow.angle = 180;
                  FTUE_Arrow.anchor.setTo(0.5, 1.6);
                  FTUE_Arrow.fixedToCamera = true;
                  game.add
                    .tween(FTUE_Arrow.anchor)
                    .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                    .yoyo(true, 200);
                  effects_group.add(FTUE_Arrow);
                  game.world.bringToTop(effects_group);
                });
              });
              game.add.tween(Lock).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 1200).onComplete.add(function (item) {
                item.destroy();
              });
              game.add.tween(Lock.scale).to({ x: 2, y: 2 }, 800, Phaser.Easing.Linear.None, true, 1200);
            }

          }

          ////////////////////////////////////////////////

          var result_stars2 = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 - 20,
            'game_window_atlas',
            (level_button.n > 20 || free_prebooster2 > 0) ? 'Windmill.png' : 'Windmill_BW.png',
          );
          result_stars2.anchor.setTo(0.5);
          popup_group.add(result_stars2);
          result_stars2.fixedToCamera = true;
          if (level_button.n > 20 || free_prebooster2 > 0) { button_animation_f(result_stars2, 1); }
          result_stars2.events.onInputUp.add(function (item) {
            btnup(item);
            if (animation == 0 || FTUE_Arrow != 0) {
              if (FTUE_Arrow != 0) { animation = 0; }
              f_w_a();
              if (free_prebooster2_select == 0) {
                if (level_button.n == 20 || free_prebooster2 > 0) {
                  if (level_button.n >= 20) {
                    free_prebooster2_select = 1;
                  }
                  item.children[0].alpha = 1;
                } else {


                  animation = 1;
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup = 0;
                      animation = 0;
                      popup_group.y -= game.camera.height;
                      if (shop == 1) {
                        shop_window(
                          1,
                          0,
                          600,
                          [
                            { 0: { type: 'Windmill.png', col: '15x', atlas: 'game_window_atlas' } },
                            { 1: { type: 'Big_Kit_List_Coin.png', col: '1 000', atlas: 'game_window_atlas' } },
                            { 2: { type: 'Big_Kit_List_Card_Back.png', col: '3x', atlas: 'game_window_atlas' } },
                            { 3: { type: 0, col: 0, atlas: 'game_window2_atlas' } },
                            {
                              4: {
                                id: 'pre_lvl_remove3cards_x15',
                                packname: 'Windmill Package',
                                price: '7.99 $',
                                reward: [1000, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15],
                              },
                            },
                          ],
                          [
                            {
                              0: {
                                type: 'Windmill.png',
                                sprite: 'Windmill.png',
                                col: '3x',
                                id: 'pre_lvl_remove3cards_x3',
                                packname: '3x Windmill',
                                price: '1.99 $',
                                atlas: 'game_window_atlas',
                                reward: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3],
                              },
                            },
                            {
                              1: {
                                type: 'Windmill.png',
                                sprite: 'Windmill.png',
                                col: '5x',
                                id: 'pre_lvl_remove3cards_x5',
                                packname: '5x Windmill',
                                price: '2.99 $',
                                atlas: 'game_window_atlas',
                                reward: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5],
                              },
                            },
                            {
                              2: {
                                type: 'Windmill.png',
                                sprite: 'Windmill.png',
                                col: '8x',
                                id: 'pre_lvl_remove3cards_x8',
                                packname: '8x Windmill',
                                price: '3.99 $',
                                atlas: 'game_window_atlas',
                                reward: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8],
                              },
                            },
                            { 3: { type: 0, sprite: 0, col: 0, id: 0, packname: 0, price: 0, atlas: 'game_atlas' } },
                          ],
                        );
                      } else {
                        if (coins >= 1800) {
                          coins -= 1800;
                          chest_open_window(
                            game.cache.getJSON('lang')['Reward!'][0][window.lang],
                            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3],
                            51,
                            1,
                            {
                              //gameArea: DdnaGameArea.Map,
                              gameArea: null,
                              actionType: null,
                              //actionType: DdnaTransactionActionType.RealMoneyPurchase,
                              productId: 0,
                            },
                          );
                        }
                        else {
                          get_message(2);
                        }
                      }
                    });


                }
              }
              else {
                free_prebooster2_select = 0;
                item.children[0].alpha = 0;
              }
            }
          });

          var free_prebooster2_info = game.add.text(game.camera.width / 2, game.camera.height / 2 + 30, 'Clears up to 3 playable cards on the playfield.', {
            font: '24px RussoOne',
            fill: '#147AA3',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 220,
          });
          free_prebooster2_info.anchor.setTo(0.5, 0);
          free_prebooster2_info.lineSpacing = -10;
          free_prebooster2_info.stroke = '#fff';
          free_prebooster2_info.strokeThickness = 4;
          popup_group.add(free_prebooster2_info);
          free_prebooster2_info.alpha = 0;
          free_prebooster2_info.fixedToCamera = true;

          if (free_prebooster2 > 0 && level_button.n > 20) {
            var free_prebooster2_text = game.add.text(game.camera.width / 2, game.camera.height / 2 + 97, 'x' + free_prebooster2, {
              font: '44px RussoOne',
              fill: '#fff',
              align: 'center'
            });
            free_prebooster2_text.anchor.setTo(0.5);
            free_prebooster2_text.stroke = '#360909';
            free_prebooster2_text.strokeThickness = 4;
            popup_group.add(free_prebooster2_text);
            free_prebooster2_text.fixedToCamera = true;
          } else if (level_button.n > 20) {
            if (shop == 0) {
              var free_prebooster2_text = game.add.text(game.camera.width / 2, game.camera.height / 2 + 97, 1800, {
                font: '42px RussoOne',
                fill: '#fff',
                align: 'center'
              });
              free_prebooster2_text.anchor.setTo(0.5);
              free_prebooster2_text.stroke = '#360909';
              free_prebooster2_text.strokeThickness = 4;
              popup_group.add(free_prebooster2_text);
              free_prebooster2_text.fixedToCamera = true;
            }

            var Plus_Button = game.add.sprite(
              60,
              60,
              'game_ui_atlas',
              'Get_Coins_Plus_Button.png',
            );
            Plus_Button.anchor.setTo(0.5);
            result_stars2.addChild(Plus_Button);
          } else if (level_button.n < 20) {
            var free_prebooster2_text = game.add.text(game.camera.width / 2, game.camera.height / 2 + 97, 'LEVEL 20', {
              font: '34px RussoOne',
              fill: '#C6C6C6',
              align: 'center'
            });
            free_prebooster2_text.alpha = 0.8;
            free_prebooster2_text.anchor.setTo(0.5);
            free_prebooster2_text.stroke = '#757474';
            free_prebooster2_text.strokeThickness = 4;
            popup_group.add(free_prebooster2_text);
            free_prebooster2_text.fixedToCamera = true;
          }

          var Check_Icon = game.add.sprite(60, 60,
            'game_window_atlas',
            'Check_Icon.png',
          );
          Check_Icon.alpha = 0;
          Check_Icon.anchor.setTo(0.5);
          result_stars2.addChild(Check_Icon);

          if (level_button.n < 20 || free_prebooster2 == -9999) {
            var Lock = game.add.sprite(60, 60,
              'game_window_atlas',
              'Lock.png',
            );
            Lock.anchor.setTo(0.5);
            result_stars2.addChild(Lock);

            if (level_button.n == 20 && free_prebooster2 == -9999) {
              animation = 1;
              game.add.tween(result_stars2.scale).to({ x: 0, y: 1.1 }, 200, Phaser.Easing.Linear.None, true, 2200).onComplete.add(function (item) {
                result_stars2.loadTexture('game_window_atlas', 'Windmill.png');
                game.add.tween(result_stars2.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                  free_prebooster2 = 3;
                  game.setUserDataAndLog({ free_prebooster2: free_prebooster2 });
                  button_animation_f(result_stars2, 1);

                  if (fbv == 1) {
                    w = ftue_window(
                      'Main_Presenting.png',
                      'Awesome - you can now remove up to 3 visible cards in the next level! Activate it to try for free!',
                      game.camera.width / 2,
                      230,
                    );
                    effects_group.add(w);
                  }
                  if (sound_on == 1) {
                    play_sound('hint_with_arrow');
                  }
                  FTUE_Arrow = game.add.sprite(
                    game.camera.width / 2,
                    game.camera.height / 2 + 10,
                    'game_atlas',
                    'FTUE_Arrow.png',
                  );
                  FTUE_Arrow.angle = 180;
                  FTUE_Arrow.anchor.setTo(0.5, 1.6);
                  FTUE_Arrow.fixedToCamera = true;
                  game.add
                    .tween(FTUE_Arrow.anchor)
                    .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                    .yoyo(true, 200);
                  effects_group.add(FTUE_Arrow);
                  game.world.bringToTop(effects_group);
                });
              });
              game.add.tween(Lock).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 1200).onComplete.add(function (item) {
                item.destroy();
              });
              game.add.tween(Lock.scale).to({ x: 2, y: 2 }, 800, Phaser.Easing.Linear.None, true, 1200);
            }
          }

          //////////////////////////////////////////////

          var result_stars3 = game.add.sprite(
            game.camera.width / 2 + 260,
            game.camera.height / 2 - 20,
            'game_window_atlas',
            (level_button.n > 30 || free_prebooster3 > 0) ? 'Joker.png' : 'Joker_BW.png',
          );
          result_stars3.anchor.setTo(0.5);
          popup_group.add(result_stars3);
          result_stars3.fixedToCamera = true;
          if (level_button.n > 30 || free_prebooster3 > 0) { button_animation_f(result_stars3, 1); }
          result_stars3.events.onInputUp.add(function (item) {
            btnup(item);
            if (animation == 0 || FTUE_Arrow != 0) {
              if (FTUE_Arrow != 0) { animation = 0; }
              f_w_a();
              if (free_prebooster3_select == 0) {
                if (level_button.n == 30 || free_prebooster3 > 0) {
                  if (level_button.n >= 30) {
                    free_prebooster3_select = 1;
                  }
                  item.children[0].alpha = 1;
                } else {

                  animation = 1;
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup = 0;
                      animation = 0;
                      popup_group.y -= game.camera.height;

                      if (shop == 1) {
                        shop_window(
                          1,
                          0,
                          600,
                          [
                            { 0: { type: 'Joker.png', col: '10x', atlas: 'game_window_atlas' } },
                            { 1: { type: 'Big_Kit_List_Coin.png', col: '1 000', atlas: 'game_window_atlas' } },
                            { 2: { type: 'Big_Kit_List_Card_Back.png', col: '3x', atlas: 'game_window_atlas' } },
                            { 3: { type: 0, col: 0, atlas: 'game_window2_atlas' } },
                            {
                              4: {
                                id: 'pre_lvl_3joker_x10',
                                packname: 'Joker Package',
                                price: '7.99 $',
                                reward: [1000, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10],
                              },
                            },
                          ],
                          [
                            {
                              0: {
                                type: 'Joker.png',
                                sprite: 'Joker.png',
                                col: '3x',
                                id: 'pre_lvl_3joker_x3',
                                packname: '3x Joker',
                                price: '2.99 $',
                                atlas: 'game_window_atlas',
                                reward: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3],
                              },
                            },
                            {
                              1: {
                                type: 'Joker.png',
                                sprite: 'Joker.png',
                                col: '5x',
                                id: 'pre_lvl_3joker_x5',
                                packname: '5x Joker',
                                price: '3.99 $',
                                atlas: 'game_window_atlas',
                                reward: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5],
                              },
                            },
                            {
                              2: {
                                type: 'Joker.png',
                                sprite: 'Joker.png',
                                col: '8x',
                                id: 'pre_lvl_3joker_x8',
                                packname: '8x Joker',
                                price: '5.99 $',
                                atlas: 'game_window_atlas',
                                reward: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8],
                              },
                            },
                            { 3: { type: 0, sprite: 0, col: 0, id: 0, packname: 0, price: 0, atlas: 'game_atlas' } },
                          ],
                        );

                      }
                      else {
                        if (coins >= 2400) {
                          coins -= 2400;
                          chest_open_window(
                            game.cache.getJSON('lang')['Reward!'][0][window.lang],
                            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3],
                            51,
                            1,
                            {
                              //gameArea: DdnaGameArea.Map,
                              gameArea: null,
                              actionType: null,
                              //actionType: DdnaTransactionActionType.RealMoneyPurchase,
                              productId: 0,
                            },
                          );
                        }
                        else {
                          get_message(2);
                        }
                      }
                    });

                }
              }
              else {
                free_prebooster3_select = 0;
                item.children[0].alpha = 0;
              }
            }
          });

          var free_prebooster3_info = game.add.text(game.camera.width / 2 + 260, game.camera.height / 2 + 30, 'Adds 3 Jokers to the playfield.', {
            font: '24px RussoOne',
            fill: '#147AA3',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 220,
          });
          free_prebooster3_info.anchor.setTo(0.5, 0);
          free_prebooster3_info.lineSpacing = -10;
          free_prebooster3_info.stroke = '#fff';
          free_prebooster3_info.strokeThickness = 4;
          popup_group.add(free_prebooster3_info);
          free_prebooster3_info.alpha = 0;
          free_prebooster3_info.fixedToCamera = true;

          if (free_prebooster3 > 0 && level_button.n > 30) {
            var free_prebooster3_text = game.add.text(game.camera.width / 2 + 260, game.camera.height / 2 + 97, 'x' + free_prebooster3, {
              font: '44px RussoOne',
              fill: '#fff',
              align: 'center'
            });
            free_prebooster3_text.anchor.setTo(0.5);
            free_prebooster3_text.stroke = '#360909';
            free_prebooster3_text.strokeThickness = 4;
            popup_group.add(free_prebooster3_text);
            free_prebooster3_text.fixedToCamera = true;
          } else if (level_button.n > 30) {

            if (shop == 0) {
              var free_prebooster3_text = game.add.text(game.camera.width / 2 + 260, game.camera.height / 2 + 97, 2400, {
                font: '42px RussoOne',
                fill: '#fff',
                align: 'center'
              });
              free_prebooster3_text.anchor.setTo(0.5);
              free_prebooster3_text.stroke = '#360909';
              free_prebooster3_text.strokeThickness = 4;
              popup_group.add(free_prebooster3_text);
              free_prebooster3_text.fixedToCamera = true;
            }

            var Plus_Button = game.add.sprite(
              60,
              60,
              'game_ui_atlas',
              'Get_Coins_Plus_Button.png',
            );
            Plus_Button.anchor.setTo(0.5);
            result_stars3.addChild(Plus_Button);
          } else if (level_button.n < 30) {
            var free_prebooster3_text = game.add.text(game.camera.width / 2 + 260, game.camera.height / 2 + 97, 'LEVEL 30', {
              font: '34px RussoOne',
              fill: '#C6C6C6',
              align: 'center'
            });
            free_prebooster3_text.alpha = 0.8;
            free_prebooster3_text.anchor.setTo(0.5);
            free_prebooster3_text.stroke = '#757474';
            free_prebooster3_text.strokeThickness = 4;
            popup_group.add(free_prebooster3_text);
            free_prebooster3_text.fixedToCamera = true;
          }

          var Check_Icon = game.add.sprite(60, 60,
            'game_window_atlas',
            'Check_Icon.png',
          );
          Check_Icon.alpha = 0;
          Check_Icon.anchor.setTo(0.5);
          result_stars3.addChild(Check_Icon);

          if (level_button.n < 30 || free_prebooster3 == -9999) {
            var Lock = game.add.sprite(60, 60,
              'game_window_atlas',
              'Lock.png',
            );
            Lock.anchor.setTo(0.5);
            result_stars3.addChild(Lock);

            if (level_button.n == 30 && free_prebooster3 == -9999) {
              animation = 1;
              game.add.tween(result_stars3.scale).to({ x: 0, y: 1.1 }, 200, Phaser.Easing.Linear.None, true, 2200).onComplete.add(function (item) {
                result_stars3.loadTexture('game_window_atlas', 'Joker.png');
                game.add.tween(result_stars3.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                  free_prebooster3 = 3;
                  game.setUserDataAndLog({ free_prebooster3: free_prebooster3 });
                  button_animation_f(result_stars3, 1);

                  if (fbv == 1) {
                    w = ftue_window(
                      'Main_Presenting.png',
                      'Amazing - you can now add 3 starting Jokers to the card deck! Activate it to try for free!',
                      game.camera.width / 2,
                      230,
                    );
                    effects_group.add(w);
                  }
                  if (sound_on == 1) {
                    play_sound('hint_with_arrow');
                  }
                  FTUE_Arrow = game.add.sprite(
                    game.camera.width / 2 + 260,
                    game.camera.height / 2 + 10,
                    'game_atlas',
                    'FTUE_Arrow.png',
                  );
                  FTUE_Arrow.angle = 180;
                  FTUE_Arrow.anchor.setTo(0.5, 1.6);
                  FTUE_Arrow.fixedToCamera = true;
                  game.add
                    .tween(FTUE_Arrow.anchor)
                    .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                    .yoyo(true, 200);
                  effects_group.add(FTUE_Arrow);
                  game.world.bringToTop(effects_group);
                });
              });
              game.add.tween(Lock).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 1200).onComplete.add(function (item) {
                item.destroy();
              });
              game.add.tween(Lock.scale).to({ x: 2, y: 2 }, 800, Phaser.Easing.Linear.None, true, 1200);
            }
          }


        }

        if (close_ad == 0) {
          if (context_name == 0 && context_id == 0 && playad_col < 3) { playadf = 1; }
          if (Number(lifes) <= 0 && playad_col < 3) { playad = 1; }
          if (playad == 1 && playadf == 1) { playadf = game.rnd.integerInRange(0, 1); if (playadf == 1) { playad = 0; } }
        } else {
          playad = 0;
          playadf = 0;
        }
        if (playad_col >= 3 || all_level.lastIndexOf(3) + 2 < 15 || unlimited_lifesDate != 0 || xmas == 1 || baloon == 1) {
          playad = 0;
          playadf = 0;
        }

        if (xmas == 1) {
          var button_green = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 + 270,
            'game_window_atlas',
            'Play_With_Friend_Button.png',
          );
          button_green.anchor.setTo(0.5);
          button_green.type = 1;
          button_animation_f(button_green, 1);
          button_green.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2 && animation == 0) {
              if (sound_on == 1) {
                play_sound('button_press');
              }

              if (xmas_ticket > Number(game.cache.getJSON('buildings')['XmasSetting'][0]['tickets'].split(',')[xmas_level])) {
                context_name = 0;
                new_life(item);
                popup = 2;

              } else {

                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    prize_wheel_arrow = 0;
                    popup_group.y -= game.camera.height;
                    xmas_shop_window();
                  });

              }

            }
          });
          popup_group.add(button_green);
          button_green.fixedToCamera = true;
          button_green.input.useHandCursor = true;

          var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['Play'][0][window.lang], {
            font: '50px RussoOne',
            fill: '#fff',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 220,
          });
          text_button_green.lineSpacing = -12;
          text_button_green.anchor.setTo(0, 0.5);
          button_green.addChild(text_button_green);
          text_button_green.stroke = '#3C6C05';
          text_button_green.strokeThickness = 4;
          text_button_green.setShadow(0, 2, 'rgba(60,108,5,1)', 0);

          var Ticket_icon = game.add.sprite(text_button_green.width + 10, 0, 'xmas_atlas', 'Ticket.png',);
          Ticket_icon.anchor.setTo(0, 0.5);
          Ticket_icon.scale.setTo(0.6);
          button_green.addChild(Ticket_icon);

          var text_button_green2 = game.add.text(text_button_green.width + 10 + Ticket_icon.width + 10, 0, game.cache.getJSON('buildings')['XmasSetting'][0]['tickets'].split(',')[xmas_level], {
            font: '50px RussoOne',
            fill: '#fff',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 220,
          });
          text_button_green2.lineSpacing = -12;
          text_button_green2.anchor.setTo(0, 0.5);
          button_green.addChild(text_button_green2);
          text_button_green2.stroke = '#3C6C05';
          text_button_green2.strokeThickness = 4;
          text_button_green2.setShadow(0, 2, 'rgba(60,108,5,1)', 0);

          text_button_green.x -= (text_button_green.width + 10 + Ticket_icon.width + 10 + text_button_green2.width) / 2;
          Ticket_icon.x -= (text_button_green.width + 10 + Ticket_icon.width + 10 + text_button_green2.width) / 2;
          text_button_green2.x -= (text_button_green.width + 10 + Ticket_icon.width + 10 + text_button_green2.width) / 2;
        }

        if (fbv == 1 && xmas == 0) {

          var button_green = game.add.sprite(
            game.camera.width / 2 + 180,
            game.camera.height / 2 + 270,
            'game_window_atlas',
            'Play_With_Friend_Button.png',
          );
          button_green.anchor.setTo(0.5);
          button_animation_f(button_green, 1);
          button_green.type = 1;
          button_green.ad = level_button.n > 3 ? playadf : 0;
          if (level_button.n > 3 && (playadf || playad)) {
            old_contextname = context_name;
            old_contextavatar = context_avatar;
            old_context = context_id;
            if (playadf) {
              context_name = 'Carl';
              context_id = 0;
              context_avatar = 0;
            }
          }


          button_green.events.onInputUp.add(function (item) {
            if (popup != 2 && animation == 0) {
              if (level_button.n == 2) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_3_9_PlayWithAliceButtonClicked');
                }
              } else if (level_button.n == 3) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_5_6_A_PlayWithAliceButtonClicked');
                }
              } else if (level_button.n == 4) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_7_6_A_PlayWithFriendButtonClicked');
                }
              } else if (level_button.n == 5) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_9_8_A_PlayWithFriendButtonClicked');
                }
              }
              if (sound_on == 1) {
                play_sound('button_press');
              }

              if (item.ad == 1) {
                popup = 2;
                loading();
                if (fbv == 1) {
                  console.log("%cThis should not happen!", "color:orange");

                  // var preloadedRewardedVideo = null;
                  // getRewardedVideoAsync(placement.Rewarded1, {
                  //   adContext: DdnaAdContext.RewardedInGame,
                  //   adGameArea: DdnaAdGameArea.Level,
                  //   adRewardType: TAdRewardType.No,
                  //   levelNumber: level,
                  // })
                  //   .then(function (rewarded) {
                  //     preloadedRewardedVideo = rewarded;
                  //     return preloadedRewardedVideo.loadAsync();
                  //   })
                  //   .then(function () {
                  //     console.log('Rewarded video preloaded');
                  //     if (music_on == 1) {
                  //       music.pause();
                  //     }
                  //     if (sound_on == 1) {
                  //       ambient.pause();
                  //     }
                  //     preloadedRewardedVideo
                  //       .showAsync()
                  //       .then(function () {
                  //         console.log('Rewarded video watched successfully');
                  //         game.add
                  //           .tween(black_sprite)
                  //           .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  //           .onComplete.add(function (item) {
                  //             item.destroy();
                  //           });
                  //         game.add
                  //           .tween(popup_group)
                  //           .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  //           .onComplete.add(function (item) {
                  //             popup_group.removeAll(true);
                  //             popup = 0;
                  //             prize_wheel_arrow = 0;
                  //             popup_group.y -= game.camera.height;
                  //           });
                  //         if (loading_black_sprite != 0) {
                  //           loading_black_sprite.destroy();
                  //           loading_black_sprite = 0;
                  //         }
                  //         if (loading_text != 0 && loading_text != 1) {
                  //           loading_text.destroy();
                  //           loading_text = 0;
                  //         }
                  //         loading_text = 1;
                  //         if (context_id == 0) { playad_col++; console.log('playad_col', playad_col); }
                  //         if (playad_col == 3 && playadDate == 0) {
                  //           playadDate = ddd == 0 ? new Date() : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
                  //           playadDate.setHours(playadDate.getHours() + 24);
                  //         }
                  //         game.setUserDataAndLog({
                  //           playad_col: playad_col,
                  //           playadDate: String(playadDate),
                  //         });
                  //         old_contextname = context_name;
                  //         old_contextavatar = context_avatar;
                  //         old_context = context_id;
                  //         context_name = 'Carl'; context_id = 0; context_avatar = 0;
                  //         new_life(item);
                  //         pre_helper = 1;
                  //         playadf = game.rnd.integerInRange(1, 100) < 20 ? 1 : 0;
                  //         popup = 2;
                  //         if (buildstart == 1) {
                  //           buildstart = 2;
                  //         }
                  //         if (music_on == 1) {
                  //           music.play();
                  //         }
                  //       })
                  //       .catch(function (e) {
                  //         console.error(e.message);
                  //         if (loading_black_sprite != 0) {
                  //           loading_black_sprite.destroy();
                  //           loading_black_sprite = 0;
                  //         }
                  //         if (loading_text != 0 && loading_text != 1) {
                  //           loading_text.destroy();
                  //           loading_text = 0;
                  //         }
                  //         loading_text = 1;
                  //         popup_group.removeAll(true);
                  //         popup = 0;
                  //         animation = 0;
                  //         console.log(old_contextname);
                  //         context_name = old_contextname;
                  //         context_avatar = old_contextavatar;
                  //         context_id = old_context;
                  //         missions_tab_open = 0;
                  //         update_controll = 0;
                  //         close_ad = 1;
                  //         black_sprite.destroy();
                  //         popup_group.y -= game.camera.height;
                  //         //no_ad(3, 0);
                  //         playadf = 0;
                  //         if (music_on == 1) {
                  //           music.play();
                  //         }
                  //       });
                  //   })
                  //   .catch(function (err) {
                  //     console.error('Rewarded video failed to preload: ' + err.message);
                  //     if (loading_black_sprite != 0) {
                  //       loading_black_sprite.destroy();
                  //       loading_black_sprite = 0;
                  //     }
                  //     if (loading_text != 0 && loading_text != 1) {
                  //       loading_text.destroy();
                  //       loading_text = 0;
                  //     }
                  //     loading_text = 1;
                  //     popup_group.removeAll(true);
                  //     popup = 0;
                  //     context_name = old_contextname;
                  //     context_avatar = old_contextavatar;
                  //     context_id = old_context;
                  //     close_ad = 1;
                  //     black_sprite.destroy();
                  //     popup_group.y -= game.camera.height;
                  //     no_ad(3, 0);
                  //     playadf = 0;
                  //   });
                } else {
                  console.log("%cThis should not happen!", "color:orange");
                  if (music_on == 1) music.pause();
                  if (sound_on == 1) ambient.pause();

                  sdkHandler.trigger(
                    'rewardedAd',
                    {
                      callback: function (success) {
                        if (music_on == 1) music.play();
                        if (sound_on == 1) ambient.play();

                        if (success) {
                          console.log('Rewarded video watched successfully 9');
                          game.add
                            .tween(black_sprite)
                            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                            .onComplete.add(function (item) {
                              item.destroy();
                            });
                          game.add
                            .tween(popup_group)
                            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                            .onComplete.add(function (item) {
                              popup_group.removeAll(true);
                              popup = 0;
                              prize_wheel_arrow = 0;
                              popup_group.y -= game.camera.height;
                            });
                          if (loading_black_sprite != 0) {
                            loading_black_sprite.destroy();
                            loading_black_sprite = 0;
                          }
                          if (loading_text != 0 && loading_text != 1) {
                            loading_text.destroy();
                            loading_text = 0;
                          }
                          loading_text = 1;
                          if (context_id == 0) { playad_col++; console.log('playad_col', playad_col); }
                          if (playad_col == 3 && playadDate == 0) {
                            playadDate = ddd == 0 ? new Date() : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
                            playadDate.setHours(playadDate.getHours() + 24);
                          }
                          game.setUserDataAndLog({
                            playad_col: playad_col,
                            playadDate: String(playadDate),
                          });
                          old_contextname = context_name;
                          old_contextavatar = context_avatar;
                          old_context = context_id;
                          context_name = 'Carl'; context_id = 0; context_avatar = 0;
                          new_life(item);
                          pre_helper = 1;
                          playadf = game.rnd.integerInRange(1, 100) < 20 ? 1 : 0;
                          popup = 2;
                          if (buildstart == 1) {
                            buildstart = 2;
                          }
                        } else {
                          console.error('Rewarded video failed to load 9');
                          if (loading_black_sprite != 0) {
                            loading_black_sprite.destroy();
                            loading_black_sprite = 0;
                          }
                          if (loading_text != 0 && loading_text != 1) {
                            loading_text.destroy();
                            loading_text = 0;
                          }
                          loading_text = 1;
                          popup_group.removeAll(true);
                          popup = 0;
                          context_name = old_contextname;
                          context_avatar = old_contextavatar;
                          context_id = old_context;
                          close_ad = 1;
                          black_sprite.destroy();
                          popup_group.y -= game.camera.height;
                          no_ad(3, 0);
                          playadf = 0;
                        }
                      },
                    },
                    this,
                  );
                }
              } else {
                if (context_id != 0) {
                  if (CurrentContext != context_id) {
                    //   FBInstant.context
                    // 	.createAsync(context_id)
                    // 	.then(function () {
                    // 	  CurrentContext = context_id;
                    // 	  if (level_button.n == 4) {
                    // 		if (fbv == 1) {
                    // 		  window.eventTrack('FTUE_7_6_A_FacebookPlayButtonClicked');
                    // 		}
                    // 	  } else if (level_button.n == 5) {
                    // 		if (fbv == 1) {
                    // 		  window.eventTrack('FTUE_9_8_A_FacebookPlayButtonClicked');
                    // 		}
                    // 	  }
                    // 		if (FTUE > 30)
                    // 		for (var i = 0; i < missions.length; i += 4) {
                    // 			if (missions[i] == -11) {
                    // 				if (missions[i + 2] < missions[i + 1]) {
                    // 				  missions[i + 2] += 1;
                    // 				}
                    // 			}
                    // 		}
                    // 	  new_life(item);
                    // 	  pre_helper = 1;
                    // 	  popup = 2;
                    // 	  if (buildstart == 1) {
                    // 		buildstart = 2;
                    // 	  }
                    // 	  var d =
                    // 		ddd == 0
                    // 		  ? new Date()
                    // 		  : new Date(
                    // 			  ddd +
                    // 				' ' +
                    // 				new Date().getHours() +
                    // 				':' +
                    // 				new Date().getMinutes() +
                    // 				':' +
                    // 				new Date().getSeconds(),
                    // 			);
                    // 	  d.setHours(d.getHours() + 24);
                    // 	  helpers_id.push(context_id);
                    // 	  helpers_time.push(d);
                    // 	  game.setUserDataAndLog({
                    // 		helpers_id: JSON.stringify(helpers_id),
                    // 		helpers_time: JSON.stringify(helpers_time),
                    // 	  });
                    // 	  let group = game.add.group();
                    // 	  group.y = -344;
                    // 	  var user_avatar = game.add.image(668 / 2 - 102, 344 / 2 + 20, 'game_atlas', 'no_avatar.png');
                    // 	  user_avatar.anchor.setTo(0.5);
                    // 	  user_avatar.width = user_avatar.height = 180;
                    // 	  user_avatar.angle = 6;
                    // 	  group.add(user_avatar);
                    // 	  if (context_avatar != 0 && game.cache.checkImageKey(context_avatar)) {
                    // 		user_avatar.loadTexture(context_avatar);
                    // 		user_avatar.width = user_avatar.height = 180;
                    // 	  }
                    // 	  var user_avatar = game.add.image(668 / 2 + 105, 344 / 2 + 20, 'game_atlas', 'no_avatar.png');
                    // 	  user_avatar.anchor.setTo(0.5);
                    // 	  user_avatar.width = user_avatar.height = 180;
                    // 	  user_avatar.angle = 2;
                    // 	  group.add(user_avatar);
                    // 	  if (game.cache.checkImageKey('c_user_avatar') == true) {
                    // 		user_avatar.loadTexture('c_user_avatar');
                    // 		user_avatar.width = user_avatar.height = 180;
                    // 	  }
                    // 	  var message_invite = game.add.sprite(
                    // 		668 / 2,
                    // 		344 / 2,
                    // 		'message_atlas',
                    // 		'Play_Level_With_Friend.png',
                    // 	  );
                    // 	  message_invite.scale.setTo(2);
                    // 	  message_invite.anchor.setTo(0.5);
                    // 	  group.add(message_invite);
                    // 	  group.inputEnabled = false;
                    // 	  group.y = 0;
                    // 	  let group2 = game.add.group();
                    // 	  group2.addChild(group);
                    // 	  var renderTexture = game.make.renderTexture(668, 344);
                    // 	  renderTexture.render(group2);
                    // 	  group2.destroy();
                    // 	  var mID =
                    // 		ddd == 0
                    // 		  ? new Date()
                    // 		  : new Date(
                    // 			  ddd +
                    // 				' ' +
                    // 				new Date().getHours() +
                    // 				':' +
                    // 				new Date().getMinutes() +
                    // 				':' +
                    // 				new Date().getSeconds(),
                    // 			);
                    // 	  updateAsync(
                    // 		{
                    // 		  action: 'CUSTOM',
                    // 		  image: renderTexture.getBase64(),
                    // 		  text: 'Thank you for helping me beating that level in Solitaire Garden!',
                    // 		  template: 'play_turn',
                    // 		  data: {
                    // 			userName: CurrentUserName,
                    // 			userId: CurrentUserId,
                    // 			messageId: mID.getTime(),
                    // 			data: 'Helper',
                    // 		  },
                    // 		  strategy: 'IMMEDIATE',
                    // 		  notification: 'NO_PUSH',
                    // 		},
                    // 		{
                    // 		  actionLevel: level_button.n,
                    // 		  targetUserID: CurrentContext,
                    // 		  socialActionType: DdnaSocialActionType.StartLevelRequest,
                    // 		  socialRewardType: DdnaSocialRewardType.Coins,
                    // 		},
                    // 	  );
                    // 	})
                    // 	.catch(function (error) {
                    // 	  if (loading_black_sprite != 0) {
                    // 		loading_black_sprite.destroy();
                    // 		loading_black_sprite = 0;
                    // 	  }
                    // 	  if (loading_text != 0 && loading_text != 1) {
                    // 		loading_text.destroy();
                    // 		loading_text = 0;
                    // 	  }
                    // 	  context_name = 0;
                    // 	  new_life(item);
                    // 	  popup = 2;
                    // 	});
                    // } else {
                    //   new_life(item);
                    //   pre_helper = 1;
                    //   popup = 2;
                    //   if (buildstart == 1) {
                    // 	buildstart = 2;
                    //   }
                    //   var d =
                    // 	ddd == 0
                    // 	  ? new Date()
                    // 	  : new Date(
                    // 		  ddd +
                    // 			' ' +
                    // 			new Date().getHours() +
                    // 			':' +
                    // 			new Date().getMinutes() +
                    // 			':' +
                    // 			new Date().getSeconds(),
                    // 		);
                    //   d.setHours(d.getHours() + 24);
                    //   helpers_id.push(context_id);
                    //   helpers_time.push(d);
                    //   game.setUserDataAndLog({
                    // 	helpers_id: JSON.stringify(helpers_id),
                    // 	helpers_time: JSON.stringify(helpers_time),
                    //   });
                  }
                } else {
                  if (context_name != 0) {
                    new_life(item);
                    pre_helper = 1;
                    popup = 2;
                    if (buildstart == 1) {
                      buildstart = 2;
                    }
                  } else {
                    loading();
                    // FBInstant.context
                    // .chooseAsync({
                    //   filters: ['NEW_PLAYERS_ONLY'],
                    //   minSize: 3,
                    // })
                    // .then(function () {
                    //   if (loading_black_sprite != 0) {
                    // 	loading_black_sprite.destroy();
                    // 	loading_black_sprite = 0;
                    //   }
                    //   if (loading_text != 0 && loading_text != 1) {
                    // 	loading_text.destroy();
                    // 	loading_text = 0;
                    //   }
                    //   first_start = -1;
                    //   numFriendsInvited += 1;
                    //   game.setUserDataAndLog({ first_start: first_start, numFriendsInvited: numFriendsInvited });
                    //   if (level_button.n == 4) {
                    // 	if (fbv == 1) {
                    // 	  window.eventTrack('FTUE_7_6_A_FacebookPopupPlayButtonClicked');
                    // 	}
                    //   } else if (level_button.n == 5) {
                    // 	if (fbv == 1) {
                    // 	  window.eventTrack('FTUE_9_8_A_FacebookPopupPlayButtonClicked');
                    // 	}
                    //   }
                    //   let group = game.add.group();
                    //   group.y = -344;
                    //   var user_avatar = game.add.image(668 / 2 - 102, 344 / 2 + 20, 'game_atlas', 'no_avatar.png');
                    //   user_avatar.anchor.setTo(0.5);
                    //   user_avatar.width = user_avatar.height = 180;
                    //   user_avatar.angle = 6;
                    //   group.add(user_avatar);
                    //   if (context_avatar != 0 && game.cache.checkImageKey(context_avatar)) {
                    // 	user_avatar.loadTexture(context_avatar);
                    // 	user_avatar.width = user_avatar.height = 180;
                    //   }
                    //   var user_avatar = game.add.image(668 / 2 + 105, 344 / 2 + 20, 'game_atlas', 'no_avatar.png');
                    //   user_avatar.anchor.setTo(0.5);
                    //   user_avatar.width = user_avatar.height = 180;
                    //   user_avatar.angle = 2;
                    //   group.add(user_avatar);
                    //   if (game.cache.checkImageKey('c_user_avatar') == true) {
                    // 	user_avatar.loadTexture('c_user_avatar');
                    // 	user_avatar.width = user_avatar.height = 180;
                    //   }
                    //   var message_invite = game.add.sprite(
                    // 	668 / 2,
                    // 	344 / 2,
                    // 	'message_atlas',
                    // 	'Play_Level_With_Friend.png',
                    //   );
                    //   message_invite.scale.setTo(2);
                    //   message_invite.anchor.setTo(0.5);
                    //   group.add(message_invite);
                    //   group.inputEnabled = false;
                    //   group.y = 0;
                    //   let group2 = game.add.group();
                    //   group2.addChild(group);
                    //   var renderTexture = game.make.renderTexture(668, 344);
                    //   renderTexture.render(group2);
                    //   group2.destroy();
                    //   var mID =
                    // 	ddd == 0
                    // 	  ? new Date()
                    // 	  : new Date(
                    // 		  ddd +
                    // 			' ' +
                    // 			new Date().getHours() +
                    // 			':' +
                    // 			new Date().getMinutes() +
                    // 			':' +
                    // 			new Date().getSeconds(),
                    // 		);
                    //   updateAsync(
                    // 	{
                    // 	  action: 'CUSTOM',
                    // 	  image: renderTexture.getBase64(),
                    // 	  text: 'Thank you for helping me beating that level in Solitaire Garden!',
                    // 	  template: 'play_turn',
                    // 	  data: {
                    // 		userId: CurrentUserId,
                    // 		messageId: mID.getTime(),
                    // 		data: 'SetNewFriend',
                    // 		bonus: 0,
                    // 	  },
                    // 	  strategy: 'IMMEDIATE',
                    // 	  notification: 'NO_PUSH',
                    // 	},
                    // 	{
                    // 	  actionLevel: level_button.n,
                    // 	  targetUserID: null,
                    // 	  socialActionType: DdnaSocialActionType.StartLevelRequest,
                    // 	  socialRewardType: DdnaSocialRewardType.No,
                    // 	},
                    //   );
                    //   new_life(item);
                    //   popup = 2;
                    //   if (buildstart == 1) {
                    // 	buildstart = 2;
                    //   }
                    // })
                    // .catch(function (error) {
                    //   if (loading_black_sprite != 0) {
                    // 	loading_black_sprite.destroy();
                    // 	loading_black_sprite = 0;
                    //   }
                    //   if (loading_text != 0 && loading_text != 1) {
                    // 	loading_text.destroy();
                    // 	loading_text = 0;
                    //   }
                    //   context_name = 0;
                    //   new_life(item);
                    //   popup = 2;
                    // });
                  }
                }

              }
            }
          }, this);
          popup_group.add(button_green);
          button_green.fixedToCamera = true;
          button_green.input.useHandCursor = true;
          //scale_tween(button_green, 500, 0.1, 0.1);
        }
        if (xmas == 0)
          if (all_level.lastIndexOf(3) + 2 > 3 || fbv == 0 || baloon == 1) {
            if (fbv == 0)
              var button_green_alone = game.add.sprite(
                game.camera.width / 2,
                game.camera.height / 2 + 270,
                'game_window_atlas',
                'Play_With_Friend_Button.png',
              );
            else
              var button_green_alone = game.add.sprite(
                game.camera.width / 2 - 210,
                game.camera.height / 2 + 270,
                'game_window_atlas',
                'Play_Alone_Button.png',
              );

            button_green_alone.anchor.setTo(0.5);
            button_green_alone.ad = level_button.n > 6 && !playadf ? playad : 0;
            button_animation_f(button_green_alone, 1);
            button_green_alone.events.onInputUp.add(function (item) {
              btnup(item);
              if (popup != 2 && animation == 0) {
                if (sound_on == 1) {
                  play_sound('button_press');
                }

                if (item.ad == 1) {
                  popup = 2;
                  loading();
                  if (fbv == 1) {
                    console.log("%cThis should not happen!", "color:orange");

                    //   var preloadedRewardedVideo = null;
                    //   getRewardedVideoAsync(placement.Rewarded1, {
                    //     adContext: DdnaAdContext.RewardedInGame,
                    //     adGameArea: DdnaAdGameArea.Level,
                    //     adRewardType: TAdRewardType.No,
                    //     levelNumber: level,
                    //   })
                    //     .then(function (rewarded) {
                    //       preloadedRewardedVideo = rewarded;
                    //       return preloadedRewardedVideo.loadAsync();
                    //     })
                    //     .then(function () {
                    //       console.log('Rewarded video preloaded');
                    //       if (music_on == 1) {
                    //         music.pause();
                    //       }
                    //       if (sound_on == 1) {
                    //         ambient.pause();
                    //       }
                    //       preloadedRewardedVideo
                    //         .showAsync()
                    //         .then(function () {
                    //           console.log('Rewarded video watched successfully');
                    //           game.add
                    //             .tween(black_sprite)
                    //             .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    //             .onComplete.add(function (item) {
                    //               item.destroy();
                    //             });
                    //           game.add
                    //             .tween(popup_group)
                    //             .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    //             .onComplete.add(function (item) {
                    //               popup_group.removeAll(true);
                    //               popup = 0;
                    //               prize_wheel_arrow = 0;
                    //               popup_group.y -= game.camera.height;
                    //             });
                    //           if (loading_black_sprite != 0) {
                    //             loading_black_sprite.destroy();
                    //             loading_black_sprite = 0;
                    //           }
                    //           if (loading_text != 0 && loading_text != 1) {
                    //             loading_text.destroy();
                    //             loading_text = 0;
                    //           }
                    //           loading_text = 1;
                    //           context_name = 0;
                    //           if (Number(lifes) <= 0) { playad_col++; console.log('playad_col', playad_col); }
                    //           if (playad_col == 3 && playadDate == 0) {
                    //             playadDate = ddd == 0 ? new Date() : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
                    //             playadDate.setHours(playadDate.getHours() + 24);
                    //           }
                    //           game.setUserDataAndLog({
                    //             playad_col: playad_col,
                    //             playadDate: String(playadDate),
                    //           });
                    //           new_life(item);
                    //           playad = game.rnd.integerInRange(1, 100) < 20 ? 1 : 0;
                    //           popup = 2;
                    //           if (buildstart == 1) {
                    //             buildstart = 2;
                    //           }
                    //           if (music_on == 1) {
                    //             music.play();
                    //           }
                    //         })
                    //         .catch(function (e) {
                    //           console.error(e.message);
                    //           if (loading_black_sprite != 0) {
                    //             loading_black_sprite.destroy();
                    //             loading_black_sprite = 0;
                    //           }
                    //           if (loading_text != 0 && loading_text != 1) {
                    //             loading_text.destroy();
                    //             loading_text = 0;
                    //           }
                    //           loading_text = 1;
                    //           popup_group.removeAll(true);
                    //           popup = 0;
                    //           animation = 0;
                    //           missions_tab_open = 0;
                    //           update_controll = 0;
                    //           close_ad = 1;
                    //           black_sprite.destroy();
                    //           popup_group.y -= game.camera.height;
                    //           //no_ad(3, 0);
                    //           playad = 0;
                    //           if (music_on == 1) {
                    //             music.play();
                    //           }
                    //         });
                    //     })
                    //     .catch(function (err) {
                    //       console.error('Rewarded video failed to preload: ' + err.message);
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       loading_text = 1;
                    //       popup_group.removeAll(true);
                    //       popup = 0;
                    //       close_ad = 1;
                    //       black_sprite.destroy();
                    //       popup_group.y -= game.camera.height;
                    //       no_ad(3, 0);
                    //       playad = 0;
                    //     });
                  } else {
                    if (music_on == 1) music.pause();
                    if (sound_on == 1) ambient.pause();

                    sdkHandler.trigger(
                      'rewardedAd',
                      {
                        callback: function (success) {
                          if (music_on == 1) music.play();
                          if (sound_on == 1) ambient.play();

                          if (success) {
                            console.log('Rewarded video watched successfully 1');
                            game.add
                              .tween(black_sprite)
                              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                              .onComplete.add(function (item) {
                                item.destroy();
                              });

                            game.add
                              .tween(popup_group)
                              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                              .onComplete.add(function (item) {
                                popup_group.removeAll(true);
                                popup = 0;
                                prize_wheel_arrow = 0;
                                popup_group.y -= game.camera.height;
                              });

                            if (loading_black_sprite != 0) {
                              loading_black_sprite.destroy();
                              loading_black_sprite = 0;
                            }
                            if (loading_text != 0 && loading_text != 1) {
                              loading_text.destroy();
                              loading_text = 0;
                            }
                            loading_text = 1;
                            context_name = 0;
                            if (Number(lifes) <= 0) { playad_col++; console.log('playad_col', playad_col); }
                            if (playad_col == 3 && playadDate == 0) {
                              playadDate = ddd == 0 ? new Date() : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
                              playadDate.setHours(playadDate.getHours() + 24);
                            }
                            game.setUserDataAndLog({
                              playad_col: playad_col,
                              playadDate: String(playadDate),
                            });
                            new_life(item);
                            playad = game.rnd.integerInRange(1, 100) < 20 ? 1 : 0;
                            popup = 2;
                            if (buildstart == 1) {
                              buildstart = 2;
                            }
                          } else {
                            console.error('Rewarded video failed to load 1');
                            if (loading_black_sprite != 0) {
                              loading_black_sprite.destroy();
                              loading_black_sprite = 0;
                            }
                            if (loading_text != 0 && loading_text != 1) {
                              loading_text.destroy();
                              loading_text = 0;
                            }
                            loading_text = 1;
                            popup_group.removeAll(true);
                            popup = 0;
                            close_ad = 1;
                            black_sprite.destroy();
                            popup_group.y -= game.camera.height;
                            no_ad(3, 0);
                            playad = 0;
                          }
                        },
                      },
                      this,
                    );
                  }

                } else {

                  if (Number(lifes) > 0) {
                    if (level_button.n == 4) {
                      if (fbv == 1) {
                        window.eventTrack('FTUE_7_6_B_PlayAloneButtonClicked');
                      }
                    } else if (level_button.n == 5) {
                      if (fbv == 1) {
                        window.eventTrack('FTUE_9_9_B_PlayAloneButtonClicked');
                      }
                    }
                    context_name = 0;
                    new_life(item);
                    popup = 2;
                    if (buildstart == 1) {
                      buildstart = 2;
                    }
                  } else if (popup != 2) {
                    buy_energy_level = 1;
                    popup = 2;
                    game.add
                      .tween(black_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(popup_group)
                      .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                      .onComplete.add(function (item) {
                        popup_group.removeAll(true);
                        popup = 0;
                        popup_group.y -= game.camera.height;
                        missions_tab_open = 0;
                        get_message(1);
                      });
                  }

                }
              }
            }, this);

            popup_group.add(button_green_alone);
            button_green_alone.fixedToCamera = true;
          } else {
            button_green.cameraOffset.x -= 180;
          }

        if (playad == 1) {
          var button_swap = game.add.sprite(130, -40, 'game_ui_atlas', 'Swap_Button.png');
          button_swap.anchor.setTo(0.5);
          button_animation_f(button_swap, 1);
          button_swap.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              item.destroy();
              popup = 2;
              playad = 0;
              button_green_alone.ad = 0;
              game.add.tween(button_green_alone.scale).to({ y: 0 }, 400, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                game.add.tween(button_green_alone.scale).to({ y: 1 }, 400, Phaser.Easing.Linear.None, true);
                button_green_alone.children[1].destroy();
                popup = 1;
                if (playad == 0) {
                  var text_button_green_alone = game.add.text(-120, 0, '-1', {
                    font: '30px RussoOne',
                    fill: '#fff',
                    align: 'center',
                  });
                  text_button_green_alone.anchor.setTo(0.5);
                  button_green_alone.addChild(text_button_green_alone);
                  text_button_green_alone.stroke = '#7C7C7C';
                  text_button_green_alone.strokeThickness = 4;
                  text_button_green_alone.setShadow(0, 2, 'rgba(124,124,124,1)', 0);
                  var get_lifes = game.add.sprite(-80, 0, 'game_ui_atlas', 'Thunder_Icon.png');
                  get_lifes.anchor.setTo(0.5);
                  get_lifes.scale.setTo(0.5);
                  button_green_alone.addChild(get_lifes);
                } else {
                  var get_lifes = game.add.sprite(-90, 0, 'game_atlas', 'ad_icon.png');
                  get_lifes.anchor.setTo(0.5);
                  button_green_alone.addChild(get_lifes);
                }
              });
            }
          });
          button_green_alone.addChild(button_swap);
        }

        var text_button_green = 0;
        if (playadf == 1) {
          var button_swap = game.add.sprite(170, -60, 'game_ui_atlas', 'Swap_Button.png');
          button_swap.anchor.setTo(0.5);
          button_animation_f(button_swap, 1);
          button_swap.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              item.destroy();
              popup = 2;
              playadf = 0;
              button_green.ad = 0;
              game.add.tween(button_green.scale).to({ y: 0 }, 400, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                game.add.tween(button_green.scale).to({ y: 1 }, 400, Phaser.Easing.Linear.None, true);
                //button_green.children[0].destroy();
                button_green.children[1].destroy();
                button_green.children[2].destroy();

                if (typeof text_button_green !== "undefined" && text_button_green != 0) text_button_green.destroy();

                context_name = old_contextname;
                context_avatar = old_contextavatar;
                context_id = old_context;
                popup = 1;
                if (context_name != 0 || context_id != 0) {
                  if (all_level.lastIndexOf(3) + 2 > 3 && fbv == 1 && !playadf) {
                    if (context_avatar != 0 && game.cache.checkImageKey(context_avatar))
                      friend_avatar = game.add.image(132, 0, context_avatar);
                    else friend_avatar = game.add.image(132, 0, 'game_atlas', 'no_avatar.png');
                  } else {
                    context_id = 0;
                    friend_avatar = game.add.sprite(132, 0, 'game_ui_atlas', 'lover_small.png');
                  }
                  var mask = game.add.graphics(0, 0);
                  mask.beginFill(0xffffff);
                  mask.drawCircle(132, 0, 80);
                  button_green.addChild(mask);
                  friend_avatar.anchor.setTo(0.5);
                  friend_avatar.width = friend_avatar.height = 90;
                  friend_avatar.mask = mask;
                  button_green.addChild(friend_avatar);
                  var Play_With_Friend_Button_Frame = game.add.sprite(
                    124,
                    0,
                    'game_window_atlas',
                    'Play_With_Friend_Button_Frame.png',
                  );
                  Play_With_Friend_Button_Frame.anchor.setTo(0.5);
                  button_green.addChild(Play_With_Friend_Button_Frame);
                }
                if (level_button.n > 3 && playadf) {
                  var get_lifes = game.add.sprite(-140, 0, 'game_atlas', 'ad_icon.png');
                  get_lifes.anchor.setTo(0.5);
                  button_green.addChild(get_lifes);
                }

                if (context_name != 0 || context_id != 0)
                  text_button_green = game.add.text(
                    -20,
                    0,
                    game.cache.getJSON('lang')['t256'][0][window.lang] + ' ' + context_name,
                    { font: '36px RussoOne', fill: '#fff', align: 'center', wordWrap: true, wordWrapWidth: 220 },
                  );
                else
                  text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t257'][0][window.lang], {
                    font: '40px RussoOne',
                    fill: '#fff',
                    align: 'center',
                  });
                text_button_green.anchor.setTo(0.5);
                text_button_green.lineSpacing = -10;
                text_button_green.stroke = '#3C6C05';
                text_button_green.strokeThickness = 4;
                text_button_green.setShadow(0, 2, 'rgba(60,108,5,1)', 0);
                button_green.addChild(text_button_green);
              });
            }

          });
          if (button_green) button_green.addChild(button_swap);
          else console.log("error button green does not exist!");
        }

        if (baloon == 1) {
          var text_result_goals = game.add.text(
            game.camera.width / 2 + 100,
            game.camera.height / 2 + 170,
            game.cache.getJSON('lang')['ClearAllWaves'][0][window.lang],
            { font: '22px RussoOne', fill: '#9D543D', align: 'center' },
          );
          text_result_goals.anchor.setTo(0.5);
          popup_group.add(text_result_goals);
          text_result_goals.alpha = 0;
          text_result_goals.fixedToCamera = true;
          game.add.tween(text_result_goals).to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true, 300);
          game.add.tween(text_result_goals.cameraOffset).to({ x: '-100' }, 1000, Phaser.Easing.Elastic.Out, true, 300);
        }
        friend_avatar = 0;
        if (fbv == 1 && xmas == 0) {
          if (context_name != 0 || context_id != 0) {
            if (all_level.lastIndexOf(3) + 2 > 3 && fbv == 1 && !playadf) {
              if (context_avatar != 0 && game.cache.checkImageKey(context_avatar))
                friend_avatar = game.add.image(132, 0, context_avatar);
              else friend_avatar = game.add.image(132, 0, 'game_atlas', 'no_avatar.png');
            } else {
              context_id = 0;
              friend_avatar = game.add.sprite(132, 0, 'game_ui_atlas', 'lover_small.png');
            }
            var mask = game.add.graphics(0, 0);
            mask.beginFill(0xffffff);
            mask.drawCircle(132, 0, 80);
            button_green.addChild(mask);
            friend_avatar.anchor.setTo(0.5);
            friend_avatar.width = friend_avatar.height = 90;
            friend_avatar.mask = mask;
            button_green.addChild(friend_avatar);
            var Play_With_Friend_Button_Frame = game.add.sprite(
              124,
              0,
              'game_window_atlas',
              'Play_With_Friend_Button_Frame.png',
            );
            Play_With_Friend_Button_Frame.anchor.setTo(0.5);
            button_green.addChild(Play_With_Friend_Button_Frame);
          }
          if (level_button.n > 3 && playadf) {
            var get_lifes = game.add.sprite(-140, 0, 'game_atlas', 'ad_icon.png');
            get_lifes.anchor.setTo(0.5);
            button_green.addChild(get_lifes);
          }

          if (context_name != 0 || context_id != 0)
            text_button_green = game.add.text(
              -20,
              0,
              game.cache.getJSON('lang')['t256'][0][window.lang] + ' ' + context_name,
              { font: '36px RussoOne', fill: '#fff', align: 'center', wordWrap: true, wordWrapWidth: 220 },
            );
          else
            text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t257'][0][window.lang], {
              font: '40px RussoOne',
              fill: '#fff',
              align: 'center',
            });
          text_button_green.anchor.setTo(0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#3C6C05';
          text_button_green.strokeThickness = 4;
          text_button_green.setShadow(0, 2, 'rgba(60,108,5,1)', 0);
          button_green.addChild(text_button_green);
        }
        if (xmas == 0)
          if (all_level.lastIndexOf(3) + 2 > 3 || fbv == 0 || baloon == 1) {
            if (fbv == 0) {
              if (level_button.n > 6) {
                var text_button_green_alone = game.add.text(45, 0, game.cache.getJSON('lang')['Play'][0][window.lang], {
                  font: '50px RussoOne',
                  fill: '#fff',
                  align: 'center',
                  wordWrap: true,
                  wordWrapWidth: 220,
                });
              }
              else {
                var text_button_green_alone = game.add.text(0, 0, game.cache.getJSON('lang')['Play'][0][window.lang], {
                  font: '60px RussoOne',
                  fill: '#fff',
                  align: 'center',
                  wordWrap: true,
                  wordWrapWidth: 220,
                });
              }
            } else {
              if (level_button.n > 6)
                var text_button_green_alone = game.add.text(35, 0, game.cache.getJSON('lang')['t258'][0][window.lang], {
                  font: '30px RussoOne',
                  fill: '#fff',
                  align: 'center',
                  wordWrap: true,
                  wordWrapWidth: 220,
                });
              else
                var text_button_green_alone = game.add.text(0, 0, game.cache.getJSON('lang')['t258'][0][window.lang], {
                  font: '30px RussoOne',
                  fill: '#fff',
                  align: 'center',
                  wordWrap: true,
                  wordWrapWidth: 220,
                });
            }
            text_button_green_alone.lineSpacing = -12;
            text_button_green_alone.anchor.setTo(0.5);
            button_green_alone.addChild(text_button_green_alone);
            text_button_green_alone.stroke = '#7C7C7C';
            text_button_green_alone.strokeThickness = 4;
            text_button_green_alone.setShadow(0, 2, 'rgba(124,124,124,1)', 0);
            if (level_button.n > 6) {
              if (playad == 0) {
                var text_button_green_alone = game.add.text(-120, 0, '-1', {
                  font: '30px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
                text_button_green_alone.anchor.setTo(0.5);
                button_green_alone.addChild(text_button_green_alone);
                text_button_green_alone.stroke = '#7C7C7C';
                text_button_green_alone.strokeThickness = 4;
                text_button_green_alone.setShadow(0, 2, 'rgba(124,124,124,1)', 0);
                var get_lifes = game.add.sprite(-80, 0, 'game_ui_atlas', 'Thunder_Icon.png');
                get_lifes.anchor.setTo(0.5);
                get_lifes.scale.setTo(0.5);
                button_green_alone.addChild(get_lifes);
              } else {
                var get_lifes = game.add.sprite(-90, 0, 'game_atlas', 'ad_icon.png');
                get_lifes.anchor.setTo(0.5);
                button_green_alone.addChild(get_lifes);
              }
            }
          }
        game.add
          .tween(popup_group)
          .to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function (item) {
            if (noSocial == 0 && xmas == 0) {
              toplist_back.x = popup_back.x;
              toplist_back.y = popup_back.y;
              leader_group.x = 0;
              leader_group.y = 0;
              if (fbv == 1) {
                game.add.tween(toplist_back).to({ x: '+654' }, 500, Phaser.Easing.Exponential.Out, true);
              }
              var leadertween = game.add
                .tween(leader_group)
                .to({ x: '+654' }, 500, Phaser.Easing.Exponential.Out, true);
              if (popupclose == 1) {
                leadertween.stop();
              }
              if (currentindex >= 3) leader_group.y = -108 * (currentindex - 2);
            }
            if (all_level[1] != 3 && baloon != 1) {
              if (fbv == 1) {
                w = ftue_window(
                  'Main_Presenting.png',
                  game.cache.getJSON('lang')['t321'][0][window.lang],
                  game.camera.width / 2,
                  230,
                );
                effects_group.add(w);
              }
              if (sound_on == 1) {
                play_sound('hint_with_arrow');
              }
              FTUE_Arrow = game.add.sprite(
                game.camera.width / 2,
                game.camera.height / 2 + 308,
                'game_atlas',
                'FTUE_Arrow.png',
              );
              FTUE_Arrow.angle = 180;
              FTUE_Arrow.anchor.setTo(0.5, 1.6);
              FTUE_Arrow.fixedToCamera = true;
              game.add
                .tween(FTUE_Arrow.anchor)
                .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                .yoyo(true, 200);
              effects_group.add(FTUE_Arrow);
              game.world.bringToTop(effects_group);
            } else if (all_level[2] != 3 && baloon != 1) {
              if (sound_on == 1) {
                play_sound('hint_with_arrow');
              }
              FTUE_Arrow = game.add.sprite(
                game.camera.width / 2,
                game.camera.height / 2 + 308,
                'game_atlas',
                'FTUE_Arrow.png',
              );
              FTUE_Arrow.angle = 180;
              FTUE_Arrow.anchor.setTo(0.5, 1.6);
              FTUE_Arrow.fixedToCamera = true;
              game.add
                .tween(FTUE_Arrow.anchor)
                .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                .yoyo(true, 200);
              effects_group.add(FTUE_Arrow);
              game.world.bringToTop(effects_group);
            } else if (all_level[3] != 3 && baloon != 1) {
              if (fbv == 1) {
                if (context_name != 0)
                  w = ftue_window(
                    'Main_Presenting.png',
                    game.cache.getJSON('lang')['t322'][0][window.lang],
                    game.camera.width / 2,
                    230,
                  );
                else
                  w = ftue_window(
                    'Main_Presenting.png',
                    game.cache.getJSON('lang')['t323'][0][window.lang],
                    game.camera.width / 2,
                    230,
                  );
                effects_group.add(w);
              }
              if (sound_on == 1) {
                play_sound('hint_with_arrow');
              }
              if (fbv == 1)
                FTUE_Arrow = game.add.sprite(
                  game.camera.width / 2 + 180,
                  game.camera.height / 2 + 308,
                  'game_atlas',
                  'FTUE_Arrow.png',
                );
              else
                FTUE_Arrow = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 + 308,
                  'game_atlas',
                  'FTUE_Arrow.png',
                );
              FTUE_Arrow.angle = 180;
              FTUE_Arrow.anchor.setTo(0.5, 1.6);
              FTUE_Arrow.fixedToCamera = true;
              game.add
                .tween(FTUE_Arrow.anchor)
                .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                .yoyo(true, 200);
              effects_group.add(FTUE_Arrow);
              game.world.bringToTop(effects_group);
            }
            if ((level_button.n == 12 && free_prebooster1 == -9999) || (level_button.n == 20 && free_prebooster2 == -9999) || (level_button.n == 30 && free_prebooster3 == -9999)) { animation = 1; } else { animation = 0; }
          });
        console.log(close_ad);
        close_ad = 0;
      }
    }

    function scorebeaten_popup() {
      if (popup == 0 && missions_tab_open == 0 && animation == 0) {
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        blackf();
        var popup_back = windows_f(game.cache.getJSON('lang')['t330'][0][window.lang], 3);
        var current_user = 0;
        var col = 5;
        var sdvig = 0;
        var i_start = 0;
        let n = ['One', 'Two', 'Three', 'Four', 'Five'];
        try {
          fetchAndLogScore('default', 'completedLevels').then(function (leaderboard) {
            if (is_map == 1) {
              if (leaderboard)
                if (typeof leaderboard[0] !== 'undefined') {
                  leaderboard.sort(sAge);
                  current_user = leaderboard.findIndex(function (e) {
                    return e['user']['isCurrentUser'] == true;
                  });
                  if (leaderboard.length < 5) {
                    col = leaderboard.length;
                    sdvig = ((5 - col) * 168) / 2;
                  }
                  if (current_user > 3) {
                    i_start = current_user - 3;
                    col += i_start;
                  }
                  try {
                    for (var i = i_start; i < col; i++) {
                      game.load.crossOrigin = true;
                      if (game.cache.checkImageKey('scorebeaten_avatar' + i) == true) {
                        game.load.removeImage('scorebeaten_avatar' + i);
                      }
                      // if (leaderboard[i]['user']['isCurrentUser'] == true)
                      //   game.load.image('scorebeaten_avatar' + i, FBInstant.player.getPhoto(), 1);
                      else game.load.image('scorebeaten_avatar' + i, leaderboard[i]['user']['avatarUrl'], 1);
                    }
                    game.load.start();
                  } catch (err) {
                    //console.log('Error detected '+err.name);
                  }
                  var nc = 0;
                  for (var i = i_start; i < col; i++) {
                    try {
                      if (is_map == 1) {
                        if (nc == 0)
                          var Background_Rays = game.add.sprite(
                            -336 + 168 * nc + sdvig,
                            -180,
                            'game_window2_atlas',
                            'One_Background_Rays.png',
                          );
                        else
                          var Background_Rays = game.add.sprite(
                            -336 + 168 * nc + sdvig,
                            -180,
                            'game_window2_atlas',
                            'Two_Three_Four_Five_Blue_Background_Rays.png',
                          );
                        Background_Rays.anchor.setTo(0.5);
                        Background_Rays.scale.setTo(0);
                        popup_back.addChild(Background_Rays);
                        rotate_tween(Background_Rays);
                        game.add
                          .tween(Background_Rays.scale)
                          .to({ x: 1, y: 1 }, 600, Phaser.Easing.Bounce.Out, true, nc * 50 + 300);
                        var place_num = game.add.sprite(
                          -336 + 168 * nc + sdvig,
                          -120,
                          'game_window2_atlas',
                          n[nc] + '.png',
                        );
                        place_num.anchor.setTo(0.5, 1);
                        place_num.scale.setTo(0);
                        popup_back.addChild(place_num);
                        game.add
                          .tween(place_num.scale)
                          .to({ x: 1, y: 1 }, 600, Phaser.Easing.Bounce.Out, true, nc * 50 + 200);
                        var user_avatar = game.add.image(-336 + 168 * nc + sdvig, 0, 'game_atlas', 'no_avatar.png');
                        user_avatar.w = user_avatar.width;
                        if (current_user != i) {
                          user_avatar.width = user_avatar.height = 130;
                        } else {
                          user_avatar.width = user_avatar.height = 140;
                          user_avatar.xxx = user_avatar.x;
                          user_avatar.x += 168;
                          game.add
                            .tween(user_avatar)
                            .to({ x: '-168' }, 900, Phaser.Easing.Exponential.Out, true, nc * 50 + 800);
                        }
                        if (current_user == i - 1) {
                          user_avatar.xxx = user_avatar.x;
                          user_avatar.x -= 168;
                          game.add
                            .tween(user_avatar)
                            .to({ x: '+168' }, 900, Phaser.Easing.Exponential.Out, true, i * 50 + 800);
                        }
                        user_avatar.s = user_avatar.width / user_avatar.w;
                        user_avatar.anchor.setTo(0.5);
                        user_avatar.t = 'ava';
                        user_avatar.i = i;
                        popup_back.addChild(user_avatar);
                        if (current_user != i)
                          var Friends_Frame = game.add.sprite(
                            -336 + 168 * nc + sdvig,
                            0,
                            'game_window2_atlas',
                            'Friends_Frame.png',
                          );
                        else {
                          var Friends_Frame = game.add.sprite(
                            -336 + 168 * nc + sdvig,
                            0,
                            'game_window2_atlas',
                            'Player_Frame.png',
                          );
                          Friends_Frame.xxx = user_avatar.x;
                          Friends_Frame.x += 168;
                          game.add
                            .tween(Friends_Frame)
                            .to({ x: '-168' }, 900, Phaser.Easing.Exponential.Out, true, nc * 50 + 800);
                        }
                        if (current_user == i - 1) {
                          Friends_Frame.xxx = user_avatar.x;
                          Friends_Frame.x -= 168;
                          game.add
                            .tween(Friends_Frame)
                            .to({ x: '+168' }, 900, Phaser.Easing.Exponential.Out, true, nc * 50 + 800);
                        }
                        Friends_Frame.anchor.setTo(0.5);
                        Friends_Frame.scale.setTo(0);
                        popup_back.addChild(Friends_Frame);
                        game.add
                          .tween(Friends_Frame.scale)
                          .to({ x: 1, y: 1 }, 600, Phaser.Easing.Bounce.Out, true, nc * 50 + 200);
                        if (current_user == i) {
                          var Green_Arrow = game.add.sprite(46, -40, 'game_window2_atlas', 'Green_Arrow.png');
                          Green_Arrow.anchor.setTo(0.5);
                          Green_Arrow.alpha = 0;
                          Friends_Frame.addChild(Green_Arrow);
                          game.add
                            .tween(Green_Arrow)
                            .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, nc * 50 + 1000);
                          game.add
                            .tween(Green_Arrow)
                            .to({ y: '-40' }, 600, Phaser.Easing.Exponential.Out, true, nc * 50 + 1000);
                        } else if (current_user == i - 1) {
                          var Red_Arrow = game.add.sprite(40, -120, 'game_window2_atlas', 'Red_Arrow.png');
                          Red_Arrow.anchor.setTo(0.5);
                          Red_Arrow.alpha = 0;
                          Friends_Frame.addChild(Red_Arrow);
                          game.add
                            .tween(Red_Arrow)
                            .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, nc * 50 + 1000);
                          game.add
                            .tween(Red_Arrow)
                            .to({ y: '+40' }, 600, Phaser.Easing.Exponential.Out, true, nc * 50 + 1000);
                        }
                        if (current_user != i)
                          var user_name = game.add.text(
                            -336 + 168 * nc + sdvig,
                            108,
                            leaderboard[i]['user']['handle'],
                            { font: '28px RussoOne', fill: '#0D6A96', align: 'center' },
                          );
                        else
                          var user_name = game.add.text(-336 + 168 * nc + sdvig, 108, CurrentUserName, {
                            font: '28px RussoOne',
                            fill: '#0D6A96',
                            align: 'center',
                          });
                        user_name.anchor.setTo(0.5);
                        user_name.stroke = '#fff';
                        user_name.strokeThickness = 4;
                        user_name.alpha = 0;
                        popup_back.addChild(user_name);
                        game.add.tween(user_name).to({ alpha: 1 }, 600, Phaser.Easing.Linear.None, true, nc * 50 + 200);
                        var Star_Number_Background = game.add.sprite(
                          -336 + 168 * nc + sdvig,
                          170,
                          'game_window2_atlas',
                          'Star_Number_Background.png',
                        );
                        Star_Number_Background.anchor.setTo(0.5);
                        Star_Number_Background.alpha = 0;
                        popup_back.addChild(Star_Number_Background);
                        game.add
                          .tween(Star_Number_Background)
                          .to({ alpha: 1 }, 600, Phaser.Easing.Linear.None, true, nc * 50 + 200);
                        var Star = game.add.sprite(-50, 0, 'game_window2_atlas', 'Star.png');
                        Star.anchor.setTo(0.5);
                        Star_Number_Background.addChild(Star);
                        var user_score = game.add.text(20, 2, leaderboard[i]['score'], {
                          font: '32px RussoOne',
                          fill: '#fff',
                          align: 'center',
                        });
                        user_score.anchor.setTo(0.5);
                        Star_Number_Background.addChild(user_score);
                      }
                    } catch (err) {
                      //console.log('Error detected '+err.name);
                    }
                    nc++;
                  }
                }
              var i = i_start;
              game.time.events.repeat(100, col, function () {
                try {
                  if (game.cache.checkImageKey('scorebeaten_avatar' + i) == true) {
                    popup_back.children.forEach(function (child_item) {
                      if (child_item.i == i && child_item.t == 'ava') {
                        child_item.loadTexture('scorebeaten_avatar' + i);
                        if (current_user != i) {
                          child_item.width = child_item.height = 130;
                        } else {
                          child_item.width = child_item.height = 140;
                        }
                      }
                    });
                  }
                } catch (err) { }
                i++;
              });
            }
          });
        } catch (err) {
          //console.log('Error detected '+err.name);
        }
        var button_continue = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 280,
          'game_window2_atlas',
          'Share_Button.png',
        );
        button_continue.anchor.setTo(0.5);
        button_animation_f(button_continue, 1);
        button_continue.events.onInputDown.add(function (item) {
          btnup(item);
          if (popup != 2) {
            popup = 2;
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                let group = game.add.group();
                group.y = -200;
                var user_avatar = game.add.image(300, 234, 'game_atlas', 'no_avatar.png');
                user_avatar.anchor.setTo(0.5);
                user_avatar.width = user_avatar.height = 128;
                user_avatar.angle = -6;
                group.add(user_avatar);
                if (game.cache.checkImageKey('c_user_avatar') == true) {
                  user_avatar.loadTexture('c_user_avatar');
                  user_avatar.width = user_avatar.height = 128;
                }
                var f1_avatar = game.add.image(167, 294, 'game_atlas', 'no_avatar.png');
                f1_avatar.anchor.setTo(0.5);
                f1_avatar.width = f1_avatar.height = 110;
                f1_avatar.angle = 9;
                group.add(f1_avatar);
                if (game.cache.checkImageKey('scorebeaten_avatar' + String(current_user + 1)) == true) {
                  f1_avatar.loadTexture('scorebeaten_avatar' + String(current_user + 1));
                  f1_avatar.width = f1_avatar.height = 110;
                }
                if (col - i_start >= 3) var f2_avatar = game.add.image(67, 290, 'game_atlas', 'no_avatar.png');
                else var f2_avatar = game.add.sprite(67, 290, 'game_ui_atlas', 'main_small.png');
                f2_avatar.anchor.setTo(0.5);
                f2_avatar.width = f2_avatar.height = 70;
                f2_avatar.angle = -21;
                group.add(f2_avatar);
                if (game.cache.checkImageKey('scorebeaten_avatar' + String(current_user + 2)) == true) {
                  f2_avatar.loadTexture('scorebeaten_avatar' + String(current_user + 2));
                  f2_avatar.width = f2_avatar.height = 70;
                }
                if (col - i_start >= 4) var f3_avatar = game.add.sprite(61, 212, 'game_atlas', 'no_avatar.png');
                else var f3_avatar = game.add.sprite(61, 212, 'game_ui_atlas', 'lover_small.png');
                f3_avatar.anchor.setTo(0.5);
                f3_avatar.width = f3_avatar.height = 50;
                f3_avatar.angle = -5;
                group.add(f3_avatar);
                if (game.cache.checkImageKey('scorebeaten_avatar' + String(current_user + 3)) == true) {
                  f3_avatar.loadTexture('scorebeaten_avatar' + String(current_user + 3));
                  f3_avatar.width = f3_avatar.height = 50;
                }
                if (col - i_start >= 5) var f4_avatar = game.add.image(158, 190, 'game_atlas', 'no_avatar.png');
                else var f4_avatar = game.add.sprite(158, 190, 'game_ui_atlas', 'evil_small.png');
                f4_avatar.anchor.setTo(0.5);
                f4_avatar.width = f4_avatar.height = 42;
                f4_avatar.angle = -6;
                group.add(f4_avatar);
                if (game.cache.checkImageKey('scorebeaten_avatar' + String(current_user + 4)) == true) {
                  f4_avatar.loadTexture('scorebeaten_avatar' + String(current_user + 4));
                  f4_avatar.width = f4_avatar.height = 42;
                }
                var message_invite = game.add.sprite(200, 200, 'ingame_atlas', 'Beat_your_Friend.png');
                message_invite.anchor.setTo(0.5);
                group.add(message_invite);
                group.inputEnabled = false;
                group.y = 0;
                let group2 = game.add.group();
                group2.addChild(group);
                var renderTexture = game.make.renderTexture(400, 400);
                renderTexture.render(group2);
                group2.destroy();
                loading();
                var r_text = game.cache.getJSON('lang')['PlayWithMe'][0][window.lang];
                r_text = r_text.replace('[x]', CurrentUserName);

                //   shareAsync(
                //     {
                //       intent: 'SHARE',
                //       image: renderTexture.getBase64(),
                //       text: r_text,
                //       data: {},
                //     },
                //     {
                //       actionLevel: null,
                //       targetUserID: null,
                //       socialActionType: DdnaSocialActionType.ScoreBeaten,
                //       socialRewardType: DdnaSocialRewardType.No,
                //     },
                //   )
                //     .then(function () {
                //       popup_group.removeAll(true);
                //       popup = 0;
                //       popup_group.y -= game.camera.height;
                //       if (loading_black_sprite != 0) {
                //         loading_black_sprite.destroy();
                //         loading_black_sprite = 0;
                //       }
                //       if (loading_text != 0 && loading_text != 1) {
                //         loading_text.destroy();
                //         loading_text = 0;
                //       }
                //     })
                //     .catch(function (error) {
                //       popup_group.removeAll(true);
                //       popup = 0;
                //       popup_group.y -= game.camera.height;
                //       if (loading_black_sprite != 0) {
                //         loading_black_sprite.destroy();
                //         loading_black_sprite = 0;
                //       }
                //       if (loading_text != 0 && loading_text != 1) {
                //         loading_text.destroy();
                //         loading_text = 0;
                //       }
                //     });

                popup_group.removeAll(true);
                popup = 0;
                popup_group.y -= game.camera.height;
                if (loading_black_sprite != 0) {
                  loading_black_sprite.destroy();
                  loading_black_sprite = 0;
                }
                if (loading_text != 0 && loading_text != 1) {
                  loading_text.destroy();
                  loading_text = 0;
                }

              });
          }
        }, this);
        popup_group.add(button_continue);
        button_continue.fixedToCamera = true;
        var button_continue_text = game.add.text(0, 0, game.cache.getJSON('lang')['t259'][0][window.lang], {
          font: '50px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        button_continue_text.anchor.setTo(0.5);
        button_continue_text.stroke = '#44730C';
        button_continue_text.strokeThickness = 4;
        button_continue_text.setShadow(0, 4, 'rgba(66,113,10,0.5)', 1);
        button_continue.addChild(button_continue_text);
        game.add
          .tween(popup_group)
          .to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function (item) { });
      }
    }
    var backcard_popup_open = 0;
    while (backcards.length < backcards_col) {
      backcards.push(0);
    }
    //backcards.push(1);
    function ok_message(type, col, title, text) {
      //1 - lives, 2 - coins
      if (popup == 0) {
        socialhub_tab_open(4);
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        blackf();
        var popup_back = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2,
          'game_atlas',
          'popup_back2.png',
        );
        popup_back.anchor.setTo(0.5);
        popup_group.add(popup_back);
        popup_back.fixedToCamera = true;
        if (type != 5) {
          var ui_lives_icon = 0;
          if (type == 1)
            ui_lives_icon = game.add.sprite(
              game.camera.width / 2,
              game.camera.height / 2 - 40,
              'game_atlas',
              'ui_lives_icon.png',
            );
          else if (type == 2)
            ui_lives_icon = game.add.sprite(
              game.camera.width / 2,
              game.camera.height / 2 - 40,
              'game_atlas',
              'ui_coins_icon.png',
            );
          else if (type == 3)
            ui_lives_icon = game.add.sprite(
              game.camera.width / 2,
              game.camera.height / 2 - 40,
              'game_atlas',
              'key_icon.png',
            );
          else if (type == 4) {
            for (i = 1; i <= backcards.length; i++) {
              if (backcards[i - 1] == 0 && i > 6) {
                sprite = 'backcard_' + i + '.png';
                backcards[i - 1] = 1;
                break;
              }
            }
            ui_lives_icon = game.add.sprite(game.camera.width / 2, game.camera.height / 2 - 40, 'game5_atlas', sprite);
            ui_lives_icon.scale.setTo(0.8);
            game.setUserDataAndLog({ backcards: JSON.stringify(backcards) });
          } else if (type == 10)
            ui_lives_icon = game.add.sprite(
              game.camera.width / 2,
              game.camera.height / 2 - 40,
              'game_atlas',
              'shuffle_booster.png',
            );
          else if (type == 20)
            ui_lives_icon = game.add.sprite(
              game.camera.width / 2,
              game.camera.height / 2 - 40,
              'game_atlas',
              'tnt_booster.png',
            );
          else if (type == 30)
            ui_lives_icon = game.add.sprite(
              game.camera.width / 2,
              game.camera.height / 2 - 40,
              'game_atlas',
              'Joker_Boost.png',
            );
          ui_lives_icon.anchor.setTo(0.5);
          popup_group.add(ui_lives_icon);
          ui_lives_icon.fixedToCamera = true;
        }
        var button_green = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 150,
          'game_atlas',
          'button_green.png',
        );
        button_green.anchor.setTo(0.5);
        button_green.scale.setTo(0.75);
        button_green.inputEnabled = true;
        button_green.scl = 0.75;
        button_green.events.onInputOver.add(btnover, this);
        button_green.events.onInputOut.add(btnout, this);
        button_green.events.onInputDown.add(btnclick, this);
        button_green.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup != 2) {
            if (type == 2 || type == 4) {
              coins_text = coins - col;
              text_coins_panel.setText(coins_text);
              var var_coins = 0;
              if (sound_on == 1) {
                play_sound('coins_add');
              }
              game.time.events.repeat(
                100,
                10,
                function () {
                  var get_coin = game.add.sprite(
                    popup_back.x + game.rnd.integerInRange(-50, 50),
                    popup_back.y + game.rnd.integerInRange(-50, 50),
                    'game_atlas',
                    'icon_coins.png',
                  );
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0);
                  get_coin.alpha = 0;
                  effects_group.add(get_coin);
                  game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(get_coin)
                    .to(
                      { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    )
                    .onComplete.add(function (item) {
                      item.destroy();
                      var_coins += col / 10;
                      text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                    });
                },
                this,
              );
            }
            if (type == 1 || col == 10000) {
              var col_n = 0;
              if (col == 10000) {
                col_n = 7;
              } else {
                col_n = col;
              }
              var lifes_text = String(Number(lifes) - Number(col_n));
              text_lifes.setText(lifes_text);
              var var_lifes = 0;
              if (Number(lifes) >= Number(max_lifes)) {
                LifeDate = 0;
                game.setUserDataAndLog({ life_time: String(LifeDate) });
                lifetextChange();
                if (lifes_panel_plus != 0) {
                  lifes_panel_plus.destroy();
                  lifes_panel_plus = 0;
                }
              }
              game.time.events.repeat(
                100,
                col_n,
                function () {
                  var get_lifes = game.add.sprite(
                    popup_back.x + game.rnd.integerInRange(-50, 50),
                    popup_back.y + game.rnd.integerInRange(-50, 50),
                    'game_atlas',
                    'ui_lives_icon.png',
                  );
                  get_lifes.anchor.setTo(0.5);
                  get_lifes.scale.setTo(0);
                  get_lifes.alpha = 0;
                  effects_group.add(get_lifes);
                  game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_lifes.scale).to({ x: 0.3, y: 0.3 }, 200, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(get_lifes)
                    .to({ x: text_lifes.x, y: text_lifes.y }, 600, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                      var_lifes = Number(var_lifes) + 1;
                      text_lifes.setText(Math.ceil(Number(lifes_text) + Number(var_lifes)));
                    });
                },
                this,
              );
            }
            if (col == 10000) {
              game.time.events.repeat(
                100,
                3,
                function () {
                  var get_lifes = game.add.sprite(
                    popup_back.x + game.rnd.integerInRange(-50, 50),
                    popup_back.y + game.rnd.integerInRange(-50, 50),
                    'game_atlas',
                    'joker.png',
                  );
                  get_lifes.anchor.setTo(0.5);
                  get_lifes.scale.setTo(0);
                  get_lifes.alpha = 0;
                  effects_group.add(get_lifes);
                  game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_lifes.scale).to({ x: 0.24, y: 0.24 }, 200, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(get_lifes)
                    .to({ x: user_point.x, y: user_point.y }, 600, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                },
                this,
              );
              game.time.events.repeat(
                100,
                3,
                function () {
                  var get_lifes = game.add.sprite(
                    popup_back.x + game.rnd.integerInRange(-50, 50),
                    popup_back.y + game.rnd.integerInRange(-50, 50),
                    'game_atlas',
                    'tnt_booster.png',
                  );
                  get_lifes.anchor.setTo(0.5);
                  get_lifes.scale.setTo(0);
                  get_lifes.alpha = 0;
                  effects_group.add(get_lifes);
                  game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_lifes.scale).to({ x: 0.24, y: 0.24 }, 200, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(get_lifes)
                    .to({ x: user_point.x, y: user_point.y }, 600, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                },
                this,
              );
            }
            if (type == 3) {
              game.time.events.repeat(
                100,
                col,
                function () {
                  var get_lifes = game.add.sprite(
                    popup_back.x + game.rnd.integerInRange(-50, 50),
                    popup_back.y + game.rnd.integerInRange(-50, 50),
                    'game_atlas',
                    'key_icon.png',
                  );
                  get_lifes.anchor.setTo(0.5);
                  get_lifes.scale.setTo(0);
                  get_lifes.alpha = 0;
                  effects_group.add(get_lifes);
                  game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_lifes.scale).to({ x: 0.5, y: 0.5 }, 200, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(get_lifes)
                    .to(
                      {
                        x: missions_tab_icon.x + missions_tab_icon.width / 2,
                        y: missions_tab_icon.y + missions_tab_icon.height / 2,
                      },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    )
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                },
                this,
              );
            }
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup = 0;
                popup_group.y -= game.camera.height;
              });
          }
        }, this);
        popup_group.add(button_green);
        button_green.fixedToCamera = true;
        var text_popup_title = game.add.text(game.camera.width / 2, game.camera.height / 2 - 160, title, {
          font: '34px RussoOne',
          fill: '#9D543D',
          align: 'center',
          wordWrap: true,
          wordWrapWidth: 520,
        });
        text_popup_title.lineSpacing = -10;
        text_popup_title.anchor.setTo(0.5);
        popup_group.add(text_popup_title);
        text_popup_title.fixedToCamera = true;
        var text_popup_text = 0;
        if (type != 5) {
          text_popup_text = game.add.text(game.camera.width / 2, game.camera.height / 2 + 70, text, {
            font: '26px RussoOne',
            fill: '#9D543D',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 450,
          });
        } else {
          text_popup_text = game.add.text(game.camera.width / 2, game.camera.height / 2, text, {
            font: '26px RussoOne',
            fill: '#9D543D',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 450,
          });
        }
        text_popup_text.anchor.setTo(0.5);
        popup_group.add(text_popup_text);
        text_popup_text.fixedToCamera = true;
        var text_button_green = game.add.text(0, 0, 'OK', { font: '34px RussoOne', fill: '#fff', align: 'center' });
        text_button_green.anchor.setTo(0.5);
        button_green.addChild(text_button_green);
        game.add
          .tween(popup_group)
          .to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function (item) { });
      }
    }
    if (unlimited_energy_h == 0) {
      unlimited_energy_h = get_random_change([1, 3, 12, 24, 48]);
    }
    var buy_energy_level = 0;
    function get_message(type) {
      //1 - lives, 2 - coins
      if (popup == 0 && missions_tab_open == 0 && animation == 0) {
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        blackf();
        console.log(unlimited_lifesDate, type);
        if (unlimited_lifesDate == 0 && type != 2) {
          var buttontimer = setInterval(function () {
            if (payments_catalog.length > 0) {
              clearInterval(buttontimer);
              var p_id = 0;
              var p_price = 0;
              if (bought == 0) {
                p_id = 'unlimited_energy_' + unlimited_energy_h + 'h_newbuyer';
              } else {
                p_id = 'unlimited_energy_' + unlimited_energy_h + 'h_buyer';
              }
              p_price =
                payments_catalog[
                payments_catalog.findIndex(function (e) {
                  return e['productID'] == p_id;
                })
                ]['price'];
              var unlimited_energy_block = game.add.sprite(game.camera.width / 2 + 700, game.camera.height / 2, '');
              unlimited_energy_block.anchor.setTo(0.5);
              unlimited_energy_block.fixedToCamera = true;
              popup_group.add(unlimited_energy_block);
              var unlimited_energy_back = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Banner_Background.png');
              unlimited_energy_back.anchor.setTo(0.5);
              unlimited_energy_back.scale.setTo(2);
              unlimited_energy_block.addChild(unlimited_energy_back);
              var unlimited_energy_text = game.add.text(
                0,
                -260,
                game.cache.getJSON('lang')['UnlimitedEnergy'][0][window.lang],
                { font: '40px RussoOne', fill: '#fff', align: 'center', wordWrap: true, wordWrapWidth: 200 },
              );
              unlimited_energy_text.anchor.setTo(0.5);
              unlimited_energy_text.lineSpacing = -10;
              unlimited_energy_text.stroke = '#0f6b97';
              unlimited_energy_text.strokeThickness = 4;
              unlimited_energy_text.setShadow(0, 4, 'rgba(15,107,151,0.7)', 1);
              unlimited_energy_block.addChild(unlimited_energy_text);
              var Energy_Background = game.add.sprite(0, 20, 'unlimited_energy_atlas', 'Energy_Background.png');
              Energy_Background.anchor.setTo(0.5);
              Energy_Background.scale.setTo(2);
              unlimited_energy_block.addChild(Energy_Background);
              var Infinity_Symbol = game.add.sprite(0, -10, 'unlimited_energy_atlas', 'Infinity_Symbol.png');
              Infinity_Symbol.anchor.setTo(0.5);
              Infinity_Symbol.scale.setTo(2);
              unlimited_energy_block.addChild(Infinity_Symbol);
              var Energy = game.add.sprite(0, -10, 'unlimited_energy_atlas', 'Energy.png');
              Energy.anchor.setTo(0.5);
              Energy.scale.setTo(2);
              unlimited_energy_block.addChild(Energy);
              var Time = game.add.sprite(0, 185, 'unlimited_energy_atlas', 'Time.png');
              Time.anchor.setTo(0.5);
              Time.scale.setTo(2);
              unlimited_energy_block.addChild(Time);
              var time_text = game.add.text(50, 185, unlimited_energy_h + 'h', {
                font: '60px RussoOne',
                fill: '#fff',
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 200,
              });
              time_text.anchor.setTo(0.5);
              time_text.lineSpacing = -10;
              time_text.stroke = '#0f6b97';
              time_text.strokeThickness = 4;
              time_text.setShadow(0, 4, 'rgba(15,107,151,0.7)', 1);
              unlimited_energy_block.addChild(time_text);
              var button_green = game.add.sprite(0, 310, 'game_window_atlas', 'Green_Button.png');
              button_green.anchor.setTo(0.5);
              button_green.scale.setTo(0.8);
              button_animation_f(button_green, 0.8);
              button_green.events.onInputUp.add(function (item) {
                btnup(item);
                if (popup != 2) {
                  popup = 2;
                  if (fbv == 1) {
                    window.eventTrack(p_id + '_initiated');
                    window.eventTrack('soga_purchase_initiated', 1, {
                      package_id: p_id,
                      value: p_price,
                      current_level: level_button.n,
                      conversion: 1 - bought,
                      user_type: bought,
                      lifetime: lifetime_day,
                      mission_completed: missioncompleted,
                    });
                  }
                  loading();
                  if (animation == 100) {
                    if (unlimited_lifesDate == 0) {
                      unlimited_lifesDate =
                        ddd == 0
                          ? new Date()
                          : new Date(
                            ddd +
                            ' ' +
                            new Date().getHours() +
                            ':' +
                            new Date().getMinutes() +
                            ':' +
                            new Date().getSeconds(),
                          );
                    }
                    unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() + unlimited_energy_h);
                    if (Number(lifes) < max_lifes) {
                      lifes = Number(max_lifes);
                    }
                    if (text_lifes != 0 && typeof text_lifes !== 'undefined') text_lifes.setText(lifes);
                    LifeDate = 0;
                    game.setUserDataAndLog({
                      lifes: String(lifes),
                      life_time: String(LifeDate),
                      unlimited_lifesDate: String(unlimited_lifesDate),
                    });
                    lifetextChange();
                    if (lifes_panel_plus != 0) {
                      lifes_panel_plus.destroy();
                      lifes_panel_plus = 0;
                    }
                    if (bought == 0) {
                      bought_f = 1;
                    }
                    if (fbv == 1) {
                      window.eventTrack(p_id + '_successfull');
                      window.eventTrack('soga_purchase_successfull', 1, {
                        package_id: p_id,
                        value: p_price,
                        current_level: level_button.n,
                        conversion: 1 - bought,
                        first_purchase: bought_f,
                        lifetime: lifetime_day,
                        highest_lvl: all_level.lastIndexOf(3) + 2,
                        mission_completed: missioncompleted,
                      });
                    }
                    if (loading_black_sprite != 0) {
                      loading_black_sprite.destroy();
                      loading_black_sprite = 0;
                    }
                    if (loading_text != 0 && loading_text != 1) {
                      loading_text.destroy();
                      loading_text = 0;
                    }
                    game.add
                      .tween(black_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(popup_group)
                      .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                      .onComplete.add(function (item) {
                        popup_group.removeAll(true);
                        popup = 0;
                        popup_group.y -= game.camera.height;
                        missions_tab_open = 0;
                        animation = 0;
                        bought = 1;
                        bought_f = 0;
                        game.setUserDataAndLog({ bought: bought });
                      });
                  }
                  // else
                  //   purchaseAsync(
                  //     {
                  //       productID: p_id,
                  //       developerPayload: 'Energy Boost',
                  //     },
                  //     //is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                  //     null,
                  //   )
                  //     .then(function (purchase) {
                  //       if (bought == 0) {
                  //         bought_f = 1;
                  //       }
                  //       window.eventTrack(p_id + '_successfull');
                  //       window.eventTrack('soga_purchase_successfull', 1, {
                  //         package_id: p_id,
                  //         value: p_price,
                  //         current_level: level_button.n,
                  //         conversion: 1 - bought,
                  //         first_purchase: bought_f,
                  //         lifetime: lifetime_day,
                  //         highest_lvl: all_level.lastIndexOf(3) + 2,
                  //         mission_completed: missioncompleted,
                  //       });
                  //       if (unlimited_lifesDate == 0) {
                  //         unlimited_lifesDate =
                  //           ddd == 0
                  //             ? new Date()
                  //             : new Date(
                  //               ddd +
                  //               ' ' +
                  //               new Date().getHours() +
                  //               ':' +
                  //               new Date().getMinutes() +
                  //               ':' +
                  //               new Date().getSeconds(),
                  //             );
                  //       }
                  //       unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() + unlimited_energy_h);
                  //       if (Number(lifes) < max_lifes) {
                  //         lifes = Number(max_lifes);
                  //       }
                  //       if (text_lifes != 0 && typeof text_lifes !== 'undefined') text_lifes.setText(lifes);
                  //       LifeDate = 0;
                  //       game.setUserDataAndLog({
                  //         lifes: String(lifes),
                  //         life_time: String(LifeDate),
                  //         unlimited_lifesDate: String(unlimited_lifesDate),
                  //       });
                  //       lifetextChange();
                  //       if (lifes_panel_plus != 0) {
                  //         lifes_panel_plus.destroy();
                  //         lifes_panel_plus = 0;
                  //       }
                  //       if (loading_black_sprite != 0) {
                  //         loading_black_sprite.destroy();
                  //         loading_black_sprite = 0;
                  //       }
                  //       if (loading_text != 0 && loading_text != 1) {
                  //         loading_text.destroy();
                  //         loading_text = 0;
                  //       }
                  //       game.add
                  //         .tween(black_sprite)
                  //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  //         .onComplete.add(function (item) {
                  //           item.destroy();
                  //         });
                  //       game.add
                  //         .tween(popup_group)
                  //         .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  //         .onComplete.add(function (item) {
                  //           popup_group.removeAll(true);
                  //           popup = 0;
                  //           popup_group.y -= game.camera.height;
                  //           missions_tab_open = 0;
                  //           bought = 1;
                  //           bought_f = 0;
                  //           game.setUserDataAndLog({ bought: bought });
                  //         });
                  //       // FBInstant.payments
                  //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                  //       //   .then(function () {})
                  //       //   .catch(function (error) {});
                  //     })
                  //     .catch(function (error) {
                  //       if (fbv == 1) {
                  //         window.eventTrack('soga_purchase_failed', 1, {
                  //           package_id: p_id,
                  //           value: p_price,
                  //           current_level: level_button.n,
                  //           conversion: 1 - bought,
                  //           user_type: bought,
                  //           lifetime: lifetime_day,
                  //           mission_completed: missioncompleted,
                  //         });
                  //       }
                  //       console.log(error);
                  //       if (loading_black_sprite != 0) {
                  //         loading_black_sprite.destroy();
                  //         loading_black_sprite = 0;
                  //       }
                  //       if (loading_text != 0 && loading_text != 1) {
                  //         loading_text.destroy();
                  //         loading_text = 0;
                  //       }
                  //       button_click = 0;
                  //       popup = 1;
                  //     });
                }
              });
              unlimited_energy_block.addChild(button_green);
              var text_button_green = game.add.text(0, 0, p_price, {
                font: '50px RussoOne',
                fill: '#fff',
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 210,
              });
              text_button_green.anchor.setTo(0.5);
              text_button_green.lineSpacing = -10;
              text_button_green.stroke = '#457310';
              text_button_green.strokeThickness = 4;
              text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
              button_green.addChild(text_button_green);
            }
          });
        }
        if (type == 2) {
          var popup_back = windows_f(game.cache.getJSON('lang')['t331'][0][window.lang], 2);
        } else {
          if (Number(lifes) <= 0) var popup_back = windows_f(game.cache.getJSON('lang')['t332'][0][window.lang], 2);
          else var popup_back = windows_f(game.cache.getJSON('lang')['t333'][0][window.lang], 2);
        }
        if (type == 2) {
          var ui_lives_icon_shine = game.add.sprite(0, -80, 'game_window_atlas', 'Ray_Behind_Energy.png');
          ui_lives_icon_shine.anchor.setTo(0.5);
          popup_back.addChild(ui_lives_icon_shine);
          var ui_lives_icon = game.add.sprite(0, -80, 'game_ui_atlas', 'Coin_Icon.png');
          ui_lives_icon.anchor.setTo(0.5);
          ui_lives_icon.scale.setTo(2);
          popup_back.addChild(ui_lives_icon);
          var ui_lives_icon_no = game.add.sprite(0, -66, 'game_window_atlas', 'No_Sign.png');
          ui_lives_icon_no.anchor.setTo(0.5);
          popup_back.addChild(ui_lives_icon_no);
        } else {
          var ui_lives_icon_shine = game.add.sprite(0, -80, 'game_window_atlas', 'Ray_Behind_Energy.png');
          ui_lives_icon_shine.anchor.setTo(0.5);
          popup_back.addChild(ui_lives_icon_shine);
          var ui_lives_icon = game.add.sprite(0, -80, 'game_ui_atlas', 'Thunder_Icon.png');
          ui_lives_icon.anchor.setTo(0.5);
          ui_lives_icon.scale.setTo(2);
          popup_back.addChild(ui_lives_icon);
          var ui_lives_icon_no = game.add.sprite(0, -80, 'game_window_atlas', 'No_Sign.png');
          ui_lives_icon_no.anchor.setTo(0.5);
          popup_back.addChild(ui_lives_icon_no);
        }
        var girl = game.add.sprite(-250, -60, 'char_atlas', 'Main_Scared.png');
        girl.anchor.setTo(0.5);
        girl.scale.setTo(1.5);
        popup_back.addChild(girl);
        if (type == 1) {
          var button_green = game.add.sprite(-200, 270, 'game_window_atlas', 'Green_Button.png');
          button_green.anchor.setTo(0.5);
          button_animation_f(button_green, 1);
          button_green.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              if (coins >= 200) {
                popup = 2;
                lifes = Number(lifes) + 1;
                if (Number(lifes) > Number(max_max_lifes)) {
                  lifes = Number(max_max_lifes);
                }
                coins -= 200;
                game.setCurrentEvent();
                window.eventTrack('coins_out', 200, {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: 200,
                  source: '1 energy',
                  item_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                text_coins_panel.setText(coins);
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    var col = 1;
                    var lifes_text = String(Number(lifes) - Number(col));
                    text_lifes.setText(lifes_text);
                    var var_lifes = 0;
                    if (Number(lifes) >= Number(max_lifes)) {
                      LifeDate = 0;
                      game.setUserDataAndLog({ life_time: String(LifeDate) });
                      lifetextChange();
                      if (lifes_panel_plus != 0) {
                        lifes_panel_plus.destroy();
                        lifes_panel_plus = 0;
                      }
                    }
                    game.time.events.repeat(
                      100,
                      col,
                      function () {
                        var get_lifes = game.add.sprite(
                          game.camera.x + game.camera.width / 2,
                          game.camera.y + game.camera.height / 2,
                          'game_ui_atlas',
                          'Thunder_Icon.png',
                        );
                        get_lifes.anchor.setTo(0.5);
                        get_lifes.scale.setTo(0);
                        get_lifes.alpha = 0;
                        effects_group.add(get_lifes);
                        game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                        game.add.tween(get_lifes.scale).to({ x: 0.5, y: 0.5 }, 400, Phaser.Easing.Linear.None, true);
                        game.add
                          .tween(get_lifes)
                          .to({ x: text_lifes.world.x, y: text_lifes.world.y }, 600, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            var_lifes = Number(var_lifes) + 1;
                            text_lifes.setText(Math.ceil(Number(lifes_text) + Number(var_lifes)));
                            if (Number(lifes) > 0) {
                              if (buy_energy_level == 1) {
                                context_name = 0;
                                buy_energy_level = 0;
                                level = level_button.n;
                                item.ad = 0;
                                new_life(item);
                                popup = 2;
                                if (buildstart == 1) {
                                  buildstart = 2;
                                }
                              } else {
                                get_popup();
                              }
                            }
                            item.destroy();
                          });
                      },
                      this,
                    );
                  });
              } else {
                popup = 2;
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    if (all_level[8] > 0 || FTUE > 150) {
                      if (shop == 1) {
                        shop_window(
                          0,
                          0,
                          0,
                          [
                            { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                            { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                            { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                            { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                            {
                              4: {
                                id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                                packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                                price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                                reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                              },
                            },
                          ],
                          [
                            {
                              0: {
                                type: 'Coins_Pack_1.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '1 000',
                                id: 'coin_package_001',
                                packname: '1,000 Coins',
                                price: '0.99 $',
                                atlas: 'game_window_atlas',
                                reward: [1000],
                              },
                            },
                            {
                              1: {
                                type: 'Coins_Pack_2.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '6 000',
                                id: 'coin_package_02',
                                packname: '6,000 Coins',
                                price: '4.99 $',
                                atlas: 'game_window_atlas',
                                reward: [6000],
                              },
                            },
                            {
                              2: {
                                type: 'Coins_Pack_3.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '13 000',
                                id: 'coin_package_003',
                                packname: '13,000 Coins',
                                price: '9.99 $',
                                atlas: 'game_window_atlas',
                                reward: [13000],
                              },
                            },
                            {
                              3: {
                                type: 'Coins_Pack_4.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '20 000',
                                id: 'coin_package_004',
                                packname: '20,000 Coins',
                                price: '14.99 $',
                                atlas: 'game_window_atlas',
                                reward: [20000],
                              },
                            },
                          ],
                        );
                      } else if (shop == 0) {
                        get_message(2);
                      }
                    }
                  });
              }
            }
          });
          popup_back.addChild(button_green);
          var icon_coins = game.add.sprite(-150, 0, 'game_ui_atlas', 'Thunder_Icon.png');
          icon_coins.anchor.setTo(0.5);
          icon_coins.scale.setTo(1.5);
          button_green.addChild(icon_coins);
          var text_button_green = game.add.text(-166, 0, '+1', {
            font: '44px RussoOne',
            fill: '#fff',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 210,
          });
          text_button_green.anchor.setTo(0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#457310';
          text_button_green.strokeThickness = 4;
          text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
          button_green.addChild(text_button_green);
          var icon_coins = game.add.sprite(-40, -4, 'game_ui_atlas', 'Coin_Icon.png');
          icon_coins.anchor.setTo(0.5);
          icon_coins.scale.setTo(0.6);
          button_green.addChild(icon_coins);
          var text_button_green = game.add.text(40, 0, '200', {
            font: '50px RussoOne',
            fill: '#fff',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 210,
          });
          text_button_green.anchor.setTo(0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#457310';
          text_button_green.strokeThickness = 4;
          text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
          button_green.addChild(text_button_green);
        }
        if (type == 2) var button_green = game.add.sprite(0, 270, 'game_window_atlas', 'Green_Button.png');
        else var button_green = game.add.sprite(200, 270, 'game_window_atlas', 'Green_Button.png');
        button_green.anchor.setTo(0.5);
        button_animation_f(button_green, 1);
        button_green.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup != 2) {
            if (sound_on == 1) {
              play_sound('button_press');
            }
            if (type == 2) {
              if (shop == 0) {
                popup = 2;
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    prize_wheel_arrow = 0;
                    popup_group.y -= game.camera.height;
                    wheel_window();
                  });
              } else if (popup != 2) {

                if (music_on == 1) music.pause();
                if (sound_on == 1) ambient.pause();

                sdkHandler.trigger(
                  'rewardedAd',
                  {
                    callback: function (success) {
                      if (music_on == 1) music.play();
                      if (sound_on == 1) ambient.play();

                      if (success) {
                        console.log('Rewarded video watched successfully 8');
                        game.add
                          .tween(black_sprite)
                          .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                          .onComplete.add(function (item) {
                            item.destroy();
                          });
                        game.add
                          .tween(popup_group)
                          .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                          .onComplete.add(function (item) {
                            popup_group.removeAll(true);
                            popup = 0;
                            prize_wheel_arrow = 0;
                            popup_group.y -= game.camera.height;
                          });
                        if (loading_black_sprite != 0) {
                          loading_black_sprite.destroy();
                          loading_black_sprite = 0;
                        }
                        if (loading_text != 0 && loading_text != 1) {
                          loading_text.destroy();
                          loading_text = 0;
                        }
                        loading_text = 1;
                        popup = 1;
                        coins += 100;
                        game.setCurrentEvent();
                        window.eventTrack('coins_in', 100, {
                          user_type: bought,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          amount: 100,
                          source: 'Rewarded video preloaded',
                          package_id: 0,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                        text_coins_panel.setText(coins);
                      } else {
                        console.error('Rewarded video failed to load 8');
                        if (loading_black_sprite != 0) {
                          loading_black_sprite.destroy();
                          loading_black_sprite = 0;
                        }
                        if (loading_text != 0 && loading_text != 1) {
                          loading_text.destroy();
                          loading_text = 0;
                        }
                        loading_text = 1;
                        popup_group.removeAll(true);
                        popup = 0;
                        black_sprite.destroy();
                        popup_group.y -= game.camera.height;
                        no_ad(3, 0);
                      }
                    },
                  },
                  this,
                );



                //   popup = 2;
                //   loading();
                //   var preloadedRewardedVideo = null;
                //   getRewardedVideoAsync(placement.Rewarded1, {
                //     adContext: DdnaAdContext.RewardedMap,
                //     adGameArea: DdnaAdGameArea.Map,
                //     adRewardType: TAdRewardType.No,
                //     levelNumber: null,
                //   })
                //     .then(function (rewarded) {
                //       preloadedRewardedVideo = rewarded;
                //       return preloadedRewardedVideo.loadAsync();
                //     })
                //     .then(function () {
                //       console.log('Rewarded video preloaded');
                //       if (music_on == 1) {
                //         music.pause();
                //       }
                //       if (sound_on == 1) {
                //         ambient.pause();
                //       }
                //       preloadedRewardedVideo
                //         .showAsync()
                //         .then(function () {
                //           console.log('Rewarded video watched successfully');
                //           game.add
                //             .tween(black_sprite)
                //             .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                //             .onComplete.add(function (item) {
                //               item.destroy();
                //             });
                //           game.add
                //             .tween(popup_group)
                //             .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                //             .onComplete.add(function (item) {
                //               popup_group.removeAll(true);
                //               popup = 0;
                //               prize_wheel_arrow = 0;
                //               popup_group.y -= game.camera.height;
                //             });
                //           if (loading_black_sprite != 0) {
                //             loading_black_sprite.destroy();
                //             loading_black_sprite = 0;
                //           }
                //           if (loading_text != 0 && loading_text != 1) {
                //             loading_text.destroy();
                //             loading_text = 0;
                //           }
                //           loading_text = 1;
                //           popup = 1;
                //           coins += 100;
                //           game.setCurrentEvent();
                //           window.eventTrack('coins_in', 100, {
                //             user_type: bought,
                //             lifetime: lifetime_day,
                //             highest_lvl: all_level.lastIndexOf(3) + 2,
                //             amount: 100,
                //             source: 'Rewarded video preloaded',
                //             package_id: 0,
                //             mission_completed: missioncompleted,
                //             c_event: current_event,
                //           });
                //           text_coins_panel.setText(coins);
                //           if (music_on == 1) {
                //             music.play();
                //           }
                //         })
                //         .catch(function (e) {
                //           console.error(e.message);
                //           if (loading_black_sprite != 0) {
                //             loading_black_sprite.destroy();
                //             loading_black_sprite = 0;
                //           }
                //           if (loading_text != 0 && loading_text != 1) {
                //             loading_text.destroy();
                //             loading_text = 0;
                //           }
                //           loading_text = 1;
                //           popup_group.removeAll(true);
                //           popup = 0;
                //           black_sprite.destroy();
                //           popup_group.y -= game.camera.height;
                //           no_ad(3, 0);
                //           if (music_on == 1) {
                //             music.play();
                //           }
                //         });
                //     })
                //     .catch(function (err) {
                //       console.error('Rewarded video failed to preload: ' + err.message);
                //       if (loading_black_sprite != 0) {
                //         loading_black_sprite.destroy();
                //         loading_black_sprite = 0;
                //       }
                //       if (loading_text != 0 && loading_text != 1) {
                //         loading_text.destroy();
                //         loading_text = 0;
                //       }
                //       loading_text = 1;
                //       popup_group.removeAll(true);
                //       popup = 0;
                //       black_sprite.destroy();
                //       popup_group.y -= game.camera.height;
                //       no_ad(3, 0);
                //     });
                //   popup = 2;
              }
            } else if (coins >= 800) {
              popup = 2;
              lifes = Number(lifes) + 5;
              if (Number(lifes) > Number(max_max_lifes)) {
                lifes = Number(max_max_lifes);
              }
              coins -= 800;
              game.setCurrentEvent();
              window.eventTrack('coins_out', 800, {
                user_type: bought,
                lifetime: lifetime_day,
                highest_lvl: all_level.lastIndexOf(3) + 2,
                amount: 800,
                source: '5 energy',
                item_id: 0,
                mission_completed: missioncompleted,
                c_event: current_event,
              });
              text_coins_panel.setText(coins);
              game.setUserDataAndLog({ lifes: String(lifes) });
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                  var col = 5;
                  var lifes_text = String(Number(lifes) - Number(col));
                  text_lifes.setText(lifes_text);
                  var var_lifes = 0;
                  if (Number(lifes) >= Number(max_lifes)) {
                    LifeDate = 0;
                    game.setUserDataAndLog({ life_time: String(LifeDate) });
                    lifetextChange();
                    if (lifes_panel_plus != 0) {
                      lifes_panel_plus.destroy();
                      lifes_panel_plus = 0;
                    }
                  }
                  game.time.events.repeat(
                    100,
                    col,
                    function () {
                      var get_lifes = game.add.sprite(
                        game.camera.x + game.camera.width / 2,
                        game.camera.y + game.camera.height / 2,
                        'game_ui_atlas',
                        'Thunder_Icon.png',
                      );
                      get_lifes.anchor.setTo(0.5);
                      get_lifes.scale.setTo(0);
                      get_lifes.alpha = 0;
                      effects_group.add(get_lifes);
                      game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                      game.add.tween(get_lifes.scale).to({ x: 0.5, y: 0.5 }, 400, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(get_lifes)
                        .to({ x: text_lifes.world.x, y: text_lifes.world.y }, 600, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          var_lifes = Number(var_lifes) + 1;
                          text_lifes.setText(Math.ceil(Number(lifes_text) + Number(var_lifes)));
                          if (Number(lifes) > 0) {
                            if (buy_energy_level == 1) {
                              context_name = 0;
                              buy_energy_level = 0;
                              level = level_button.n;
                              item.ad = 0;
                              new_life(item);
                              popup = 2;
                              if (buildstart == 1) {
                                buildstart = 2;
                              }
                            } else {
                              get_popup();
                            }
                          }
                          item.destroy();
                        });
                    },
                    this,
                  );
                });
            } else {
              popup = 2;
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                  if (all_level[8] > 0 || FTUE > 150) {
                    if (shop == 1) {
                      shop_window(
                        0,
                        0,
                        0,
                        [
                          { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                          { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                          { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                          { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                          {
                            4: {
                              id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                              packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                              price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                              reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                            },
                          },
                        ],
                        [
                          {
                            0: {
                              type: 'Coins_Pack_1.png',
                              sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                              col: '1 000',
                              id: 'coin_package_001',
                              packname: '1,000 Coins',
                              price: '0.99 $',
                              atlas: 'game_window_atlas',
                              reward: [1000],
                            },
                          },
                          {
                            1: {
                              type: 'Coins_Pack_2.png',
                              sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                              col: '6 000',
                              id: 'coin_package_02',
                              packname: '6,000 Coins',
                              price: '4.99 $',
                              atlas: 'game_window_atlas',
                              reward: [6000],
                            },
                          },
                          {
                            2: {
                              type: 'Coins_Pack_3.png',
                              sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                              col: '13 000',
                              id: 'coin_package_003',
                              packname: '13,000 Coins',
                              price: '9.99 $',
                              atlas: 'game_window_atlas',
                              reward: [13000],
                            },
                          },
                          {
                            3: {
                              type: 'Coins_Pack_4.png',
                              sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                              col: '20 000',
                              id: 'coin_package_004',
                              packname: '20,000 Coins',
                              price: '14.99 $',
                              atlas: 'game_window_atlas',
                              reward: [20000],
                            },
                          },
                        ],
                      );
                    } else if (shop == 0) {
                      get_message(2);
                    }
                  }
                });
            }
          }
        }, this);
        popup_back.addChild(button_green);
        if (type == 1) {
          var icon_coins = game.add.sprite(-150, 0, 'game_ui_atlas', 'Thunder_Icon.png');
          icon_coins.anchor.setTo(0.5);
          icon_coins.scale.setTo(1.5);
          button_green.addChild(icon_coins);
          var text_button_green = game.add.text(-166, 0, '+5', {
            font: '44px RussoOne',
            fill: '#fff',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 210,
          });
          text_button_green.anchor.setTo(0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#457310';
          text_button_green.strokeThickness = 4;
          text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
          button_green.addChild(text_button_green);
          var icon_coins = game.add.sprite(-40, -4, 'game_ui_atlas', 'Coin_Icon.png');
          icon_coins.anchor.setTo(0.5);
          icon_coins.scale.setTo(0.6);
          button_green.addChild(icon_coins);
          var text_button_green = game.add.text(40, 0, '800', {
            font: '50px RussoOne',
            fill: '#fff',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 210,
          });
          text_button_green.anchor.setTo(0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#457310';
          text_button_green.strokeThickness = 4;
          text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
          button_green.addChild(text_button_green);
        } else {
          if (shop == 0) {
            var icon_coins = game.add.sprite(-120, 0, 'game_ui_atlas', 'Wheel_Button_Free_Spin.png');
            icon_coins.anchor.setTo(0.5);
            icon_coins.scale.setTo(0.5);
            button_green.addChild(icon_coins);
            var text_button_green = game.add.text(30, 0, game.cache.getJSON('lang')['t260'][0][window.lang], {
              font: '45px RussoOne',
              fill: '#fff',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 260,
            });
          } else
            var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t261'][0][window.lang], {
              font: '50px RussoOne',
              fill: '#fff',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 260,
            });
          text_button_green.anchor.setTo(0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#457310';
          text_button_green.strokeThickness = 4;
          text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
          button_green.addChild(text_button_green);
        }
        game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
      }
    }
    function button_animation_f(item, s) {
      item.inputEnabled = true;
      item.scl = s;
      item.input.useHandCursor = true;
      item.events.onInputOver.add(btnover, this);
      item.events.onInputOut.add(btnout, this);
      item.events.onInputDown.add(btnclick, this);
    }

    var map_level = all_level.lastIndexOf(3) + 2;

    if (game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(map_level)) != -1 && !all_level[map_level - 1] && all_level[map_level - 2] > 0) {
      let group_Texture_1 = game.add.group();
      let popup_back2 = draw_rect(930 / 2, 646 / 2, 930, 646, '#FF7B7B', '#F73059', 0, 0, 0, 5, 40, 0);

      draw_rect_shadow(0, 0, 894, 614, '#000', '#000', 0, 0, popup_back2, 30);
      draw_rect(0, 0, 894, 614, '#FBF9F6', '#F7EED4', 0, 0, popup_back2, 0, 30, 0);
      group_Texture_1.add(popup_back2);
      group_Texture_1.inputEnabled = false;
      var renderTexture_2 = game.make.renderTexture(930, 646);
      renderTexture_2.render(group_Texture_1);
      group_Texture_1.destroy();
    } else if (game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(map_level)) != -1 && !all_level[map_level - 1] && all_level[map_level - 2] > 0) {
      let group_Texture_1 = game.add.group();
      let popup_back2 = draw_rect(930 / 2, 646 / 2, 930, 646, '#E2ABFF', '#D184FA', 0, 0, 0, 5, 40, 0);

      draw_rect_shadow(0, 0, 894, 614, '#000', '#000', 0, 0, popup_back2, 30);
      draw_rect(0, 0, 894, 614, '#FBF9F6', '#F7EED4', 0, 0, popup_back2, 0, 30, 0);
      group_Texture_1.add(popup_back2);
      group_Texture_1.inputEnabled = false;
      var renderTexture_2 = game.make.renderTexture(930, 646);
      renderTexture_2.render(group_Texture_1);
      group_Texture_1.destroy();
    }
    let group_Texture_1 = game.add.group();
    let popup_back2 = draw_rect(930 / 2, 646 / 2, 930, 646, '#FBF7E6', '#E6C077', 0, 0, 0, 5, 40, 0);

    draw_rect_shadow(0, 0, 894, 614, '#000', '#000', 0, 0, popup_back2, 30);
    draw_rect(0, 0, 894, 614, '#FBF9F6', '#F7EED4', 0, 0, popup_back2, 0, 30, 0);
    group_Texture_1.add(popup_back2);
    group_Texture_1.inputEnabled = false;
    var renderTexture_1 = game.make.renderTexture(930, 646);
    renderTexture_1.render(group_Texture_1);
    group_Texture_1.destroy();

    function windows_f(name, s, newitem) {

      if (s == 4) var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2 - 40, '');
      else var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');

      if (s == 4) {
        var popup_back2 = game.add.sprite(0, 0, renderTexture_1);
        popup_back2.anchor.setTo(0.5);
      }
      else if (s == 105) {
        var popup_back2 = game.add.sprite(0, 0, 'botsub_atlas', 'Pop_Up.png');
        popup_back2.anchor.setTo(0.5);
      }
      else {
        if (!s) {
          var popup_back2 = game.add.sprite(0, 0, renderTexture_1);
        }
        else {
          var popup_back2 = game.add.sprite(0, 0, renderTexture_1);
        }
        popup_back2.anchor.setTo(0.5);
        popup_back2.height = 790;
      }

      popup_back.addChild(popup_back2);
      if (s == 4) backcard_group.add(popup_back);
      else {
        popup_group.add(popup_back);
        popup_back.fixedToCamera = true;
      }
      if (s == 1) {
        var Pop_Up_Image = game.add.sprite(0, -50, 'game_window_atlas', 'Pop_Up_Image.png');
        Pop_Up_Image.scale.setTo(2);
        Pop_Up_Image.anchor.setTo(0.5);
        popup_back.addChild(Pop_Up_Image);
      } else if (s == 2) {
        var Pop_Up_Image = game.add.sprite(0, -90, 'game_window_atlas', 'Background.png');
        Pop_Up_Image.scale.setTo(2);
        Pop_Up_Image.anchor.setTo(0.5);
        popup_back.addChild(Pop_Up_Image);
      } else if (s == 3) {
        var Pop_Up_Image = game.add.sprite(0, 42, 'game_window2_atlas', 'Landscape_Background.png');
        Pop_Up_Image.anchor.setTo(0.5);
        Pop_Up_Image.scale.setTo(2);
        Pop_Up_Image.height += 60;
        popup_back.addChild(Pop_Up_Image);
      } else if (s == 4) {
        var Pop_Up_Image = game.add.sprite(0, -82, 'game_window_atlas', 'Garden_Background.png');
        Pop_Up_Image.scale.setTo(2, 1.8);
        Pop_Up_Image.anchor.setTo(0.5);
        popup_back.addChild(Pop_Up_Image);
        var Character = game.add.sprite(0, 165, 'game_window_atlas', 'Character.png');
        Character.anchor.setTo(0.5, 1);
        Character.alpha = 0;
        Character.scale.setTo(0);
        popup_back.addChild(Character);
        game.add.tween(Character).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 200);
        game.add.tween(Character.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Elastic.Out, true, 200);
      } else if (s == 5) {
        var Pop_Up_Image = game.add.sprite(0, -50, 'game_window_atlas', 'Garden_Background.png');
        Pop_Up_Image.scale.setTo(2);
        Pop_Up_Image.anchor.setTo(0.5);
        popup_back.addChild(Pop_Up_Image);
        var Character = game.add.sprite(0, 188, 'char_atlas', 'Main_Twinkling.png');
        Character.anchor.setTo(0.5, 1);
        Character.scale.setTo(0);
        popup_back.addChild(Character);
        game.add.tween(Character).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 500);
        game.add.tween(Character.scale).to({ x: 1.7, y: 1.7 }, 500, Phaser.Easing.Elastic.Out, true, 500);
      } else if (s == 6) {
        var Pop_Up_Image = game.add.sprite(0, -50, 'baloon_atlas', 'Image_Path.png');
        Pop_Up_Image.anchor.setTo(0.5);
        Pop_Up_Image.scale.setTo(2.2);
        popup_back.addChild(Pop_Up_Image);
      }
      if (s == 105) var pop_up_header = game.add.sprite(0, 68, 'game_window_atlas', 'Pop_Up_Header.png');
      else if (s == 666) var pop_up_header = game.add.sprite(0, -314, 'xmas_atlas', 'Xmas_Header.png');
      else if (s == 4) var pop_up_header = game.add.sprite(0, 60, 'game_window_atlas', 'Pop_Up_Header.png');
      else if (s == 6 || s == 7) var pop_up_header = game.add.sprite(-5, -364, 'baloon_atlas', 'Pup_Up_Header.png');
      else var pop_up_header = game.add.sprite(0, -4, 'game_window_atlas', 'Pop_Up_Header.png');

      // changes the pop_up_header color
      if (xmas != 1) { if (!s) { pop_up_header.tint = game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? 0xC10E31 : game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? 0x7E1EBF : 0x2BB5DC; } else { pop_up_header.tint = 0x2BB5DC; } }
      pop_up_header.anchor.setTo(0.5);
      pop_up_header.scale.setTo(2);
      popup_back.addChild(pop_up_header);

      if (s == 111) {
        var Pop_Up_Image = game.add.sprite(0, -40, newitem.image);
        Pop_Up_Image.scale.setTo(894 / Pop_Up_Image.width);
        Pop_Up_Image.anchor.setTo(0.5);
        popup_back.addChild(Pop_Up_Image);
      }

      if (s == 6) {
        var Balloon_1 = game.add.sprite(-320, -150, 'baloon_atlas', 'Balloon.png');
        Balloon_1.anchor.setTo(0.5);
        Balloon_1.alpha = 0;
        popup_back.addChild(Balloon_1);
        game.add.tween(Balloon_1.anchor).to({ y: '-0.1' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 0);
        Balloon_1_animation();
        function Balloon_1_animation() {
          game.add
            .tween(Balloon_1)
            .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add
                .tween(Balloon_1)
                .to({ x: '+695', y: '-140' }, 10000, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(item)
                    .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.x = -320;
                      item.y = -150;
                      item.scale.setTo(1);
                      Balloon_1_animation();
                    });
                });
              game.add.tween(Balloon_1.scale).to({ x: 0.5, y: 0.5 }, 10000, Phaser.Easing.Linear.None, true);
            });
        }
      }

      if (s == 7) {
        var Ribbon = game.add.sprite(0, -240, 'baloon_atlas', 'Ribbon.png');
        Ribbon.anchor.setTo(0.5);
        Ribbon.scale.setTo(2);
        popup_back.addChild(Ribbon);
      }

      let text_group = game.add.group();
      popup_back.addChild(text_group);
      let www = 0;
      let f_size = '48px';
      if (name && name.length > 32) {
        f_size = '28px';
      }
      if (name) {
        if (s != 7) {
          for (var i = 0; i < name.length; i++) {
            if (s == 105)
              var text_popup_title = game.add.text(www, -320 - 120 + 72, name[i], {
                font: f_size + ' RussoOne',
                fill: '#fff',
                align: 'left',
              });
            else if (s == 4)
              var text_popup_title = game.add.text(www, -320 - 120 + 64, name[i], {
                font: f_size + ' RussoOne',
                fill: '#fff',
                align: 'left',
              });
            else if (s == 6)
              var text_popup_title = game.add.text(www, -320 - 120 - 40, name[i], {
                font: f_size + ' RussoOne',
                fill: '#fff',
                align: 'left',
              });
            else if (s == 7)
              var text_popup_title = game.add.text(www, -320 - 70, name[i], {
                font: f_size + ' RussoOne',
                fill: '#fff',
                align: 'left',
              });
            else
              var text_popup_title = game.add.text(www, -320 - 120, name[i], {
                font: f_size + ' RussoOne',
                fill: '#fff',
                align: 'left',
              });
            text_popup_title.anchor.setTo(0, 0.5);
            text_group.add(text_popup_title);
            //text_popup_title.stroke = '#0D6A96';
            if (!s) { text_popup_title.stroke = game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? '#77000D' : game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? '#540D75' : '#0D6A96'; } else { text_popup_title.stroke = '#0D6A96'; }
            text_popup_title.strokeThickness = 4;
            //text_popup_title.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
            if (!s) { text_popup_title.setShadow(0, 4, game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? 'rgba(119,0,13,0.9)' : game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? 'rgba(84,13,117,0.9)' : 'rgba(13,106,150,0.9)', 0); } else { text_popup_title.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0); }
            www += text_popup_title.width - 4;
            text_popup_title.alpha = 0;
            game.add.tween(text_popup_title).to({ alpha: 1 }, 300, Phaser.Easing.Exponential.In, true, 50 * i);
            game.add.tween(text_popup_title).to({ y: '+120' }, 500, Phaser.Easing.Exponential.Out, true, 50 * i);
          }
        } else {
          arc_text(name, '48px', 0, 0, 0, -270, -5, 0, popup_back, 0, 20);
        }
      }
      text_group.x -= www / 2;
      if (s != 4)
        if (FTUE > 24 || s == 1 || s == 111 || s == 10 || s == 105) {
          if (s == 105)
            var popup_close = game.add.sprite(930 / 2 - 20, -646 / 2 + 30, 'game_window_atlas', 'Close_Button.png');
          else if (s == 4)
            var popup_close = game.add.sprite(930 / 2 - 20, -646 / 2 + 20, 'game_window_atlas', 'Close_Button.png');
          else var popup_close = game.add.sprite(930 / 2 - 20, -790 / 2 + 20, 'game_window_atlas', 'Close_Button.png');
          popup_close.anchor.setTo(0.5);
          if (!s) { popup_close.s = 222; } else { popup_close.s = s; }
          button_animation_f(popup_close, 1);
          popup_close.events.onInputUp.add(function (itm) {
            if (popup != 2 && animation == 0) {
              popup = 2;
              free_prebooster1_select = 0;
              free_prebooster2_select = 0;
              free_prebooster3_select = 0;
              if (emitter_c != 0) {
                emitter_c.destroy();
                emitter_c = 0;
              }
              buy_energy_level = 0;
              friend_avatar = 0;
              if (sound_on == 1) {
                play_sound('button_X');
              }
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              if (special_stage != 0 && itm.s == 2) {
                bottom_button(0, 0, 0, UI_bottom_group, -1, 1);
              }
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  baloon = 0;
                  baloon_stage = 0;
                  missions_tab_open = 0;
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                  if (special_stage != 0 && itm.s == 2) {
                    build_special_object(special_stage, 1);
                  }
                  if (itm.s == 6 || itm.s == 666 || itm.s == 222) {
                    close_ad = 1;
                    context_name = 0;
                    context_avatar = 0;
                    context_id = 0;
                    if (old_contextname != 0 && context_id == 0) {
                      context_name = old_contextname;
                      context_avatar = old_contextavatar;
                      context_id = old_context;
                    }
                  }
                  if (itm.s == 105) {
                    botopt = 1;
                    game.setUserDataAndLog({ botopt: botopt });
                    entryPointData_function();
                  }
                });
            }
          }, this);
          popup_back.addChild(popup_close);
        }
      return popup_back;
    }
    function restoreStringifiedJson(key, callback) {
      sdkHandler.trigger('restore', {
        key: key,
        callback: function (error, data) {
          if (error) {
            callback(error, data);
          } else {
            var actualData = typeof data === 'object' && data ? data.value : data;
            callback(error, actualData);
          }
        },
      });
    }
    function restoreDate(k) {
      var cb = 0;
      sdkHandler.trigger(
        'restore',
        {
          key: k,
          callback: function (error, value) {
            if (error) {
              cb = 0;
            } else {
              if (value != null && value != '0' && value !== 'NaN') {
                cb = new Date(value);
              } else {
                cb = 0;
              }
            }
          },
        },
        this,
      );
      return cb;
    }
    function restoreJson(k, d) {
      var cb = 0;
      restoreStringifiedJson(k, function (error, value) {
        if (error) {
        } else {
          if (value != null) {
            cb = JSON.parse(value);
          }
        }
      });
      return cb;
    }
    function restoreValue(k, d) {
      var cb = 0;
      sdkHandler.trigger(
        'restore',
        {
          key: k,
          callback: function (error, value) {
            if (error) {
              cb = d;
            } else {
              if (value != null) {
                cb = Number(value);
              }
              if (value !== 'NaN') {
              } else {
                cb = d;
              }
            }
          },
        },
        this,
      );
      return cb;
    }
    function reset_question() {
      if (sound_on == 1) {
        play_sound('button_press');
      }
      popup_group.y = 0;
      popup_group.y += game.camera.height;
      popup = 1;
      blackf();
      var popup_back = windows_f('Delete progress?', 2);
      var text_v = game.add.text(90, -100, game.cache.getJSON('lang')['t402'][0][window.lang], {
        font: '32px RussoOne',
        fill: '#fff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 400,
      });
      text_v.anchor.setTo(0.5);
      text_v.stroke = '#457310';
      text_v.strokeThickness = 4;
      text_v.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
      popup_back.addChild(text_v);
      var text_v = game.add.text(90, 30, game.cache.getJSON('lang')['t403'][0][window.lang], {
        font: '40px RussoOne',
        fill: '#fff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 400,
      });
      text_v.anchor.setTo(0.5);
      text_v.stroke = '#457310';
      text_v.strokeThickness = 4;
      text_v.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
      popup_back.addChild(text_v);
      var girl = game.add.sprite(-250, -60, 'char_atlas', 'Main_Scared.png');
      girl.anchor.setTo(0.5);
      girl.scale.setTo(1.5);
      popup_back.addChild(girl);
      var button_green = game.add.sprite(200, 270, 'game_window_atlas', 'Green_Button.png');
      button_green.anchor.setTo(0.5);
      button_animation_f(button_green, 1);
      button_green.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup != 2) {
          popup = 2;
          if (sound_on == 1) {
            play_sound('button_press');
          }
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item) {
              item.destroy();
            });
          game.add
            .tween(popup_group)
            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function (item) {
              popup_group.removeAll(true);
              popup = 0;
              popup_group.y -= game.camera.height;
            });
        }
      }, this);
      popup_back.addChild(button_green);
      var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t404'][0][window.lang], {
        font: '48px RussoOne',
        fill: '#fff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 260,
      });
      text_button_green.anchor.setTo(0.5);
      text_button_green.lineSpacing = -10;
      text_button_green.stroke = '#457310';
      text_button_green.strokeThickness = 4;
      text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
      button_green.addChild(text_button_green);
      game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
      var button_green = draw_rect(-200, 270, 408 * 0.9, 135 * 0.9, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
      draw_rect_shadow(0, 0, 374 * 0.9, 102 * 0.9, '#000', '#000', 0, 0, button_green, 500);
      draw_rect(0, 0, 374 * 0.9, 102 * 0.9, '#900108', '#900108', 0, 0, button_green, 0, 500, 0);
      draw_rect(0, 0, 370 * 0.9, 100 * 0.9, '#EE1C25', '#893631', 0, 1, button_green, 0, 500, 0);
      button_animation_f(button_green, 1);
      button_green.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup != 2) {
          if (sound_on == 1) {
            play_sound('button_press');
          }
          datareset();
          clearInterval(timerId5);
          game.world.removeAll(true);
          game.state.start('Map');
        }
      }, this);
      popup_back.addChild(button_green);
      var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t405'][0][window.lang], {
        font: '50px RussoOne',
        fill: '#fff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 260,
      });
      text_button_green.anchor.setTo(0.5);
      text_button_green.lineSpacing = -10;
      text_button_green.stroke = '#457310';
      text_button_green.strokeThickness = 4;
      text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
      button_green.addChild(text_button_green);
      game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
      game.add
        .tween(popup_group)
        .to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true)
        .onComplete.add(function (item) { });
    }
    function magicbean_giveup() {
      return true;
    }
    function baloon_giveup() {
      return true;
    }
    function setting_window() {
      if ((popup == 0 && missions_tab_open == 0 && animation == 0) || (is_map == 0 && popup == 0)) {
        if (sound_on == 1) {
          play_sound('button_press');
        }
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        blackf();
        var popup_back = windows_f(game.cache.getJSON('lang')['Settings'][0][window.lang], 10);
        var setting_border = draw_rect(-220, 20, 282, 492, '#A0814F', '#FFFFFF', 0, 0, 0, 0, 40, 0);
        draw_rect(0, 0, 276, 486, '#FFFFFF', '#A0814F', 0, 0, setting_border, 0, 40, 0);
        draw_rect(0, 0, 270, 480, '#EAD7B5', '#E2BE77', 0, 0, setting_border, 0, 30, 0);
        popup_back.addChild(setting_border);
        if (noSocial == 0) {
          var text_v = game.add.text(0, 308, gver, { font: '26px RussoOne', fill: '#9D543D', align: 'center' });
          text_v.anchor.setTo(0.5);
          popup_back.addChild(text_v);
          // var text_userid = game.add.text(
          //   0,
          //   340,
          //   game.cache.getJSON('lang')['t262'][0][window.lang] + ' ' + CurrentUserId,
          //   { font: '26px RussoOne', fill: '#9D543D', align: 'center' },
          // );
          // text_userid.anchor.setTo(0.5);
          // popup_back.addChild(text_userid);
        }
        var girl = game.add.sprite(180, 170, 'char_atlas', 'Main_Thinking.png');
        girl.anchor.setTo(0.5, 1);
        girl.scale.setTo(0);
        popup_back.addChild(girl);
        game.add.tween(girl.scale).to({ x: 1.5, y: 1.5 }, 800, Phaser.Easing.Elastic.Out, true, 300);
        if (is_map == 1) {
          var quit_level_button = draw_rect(180, 190, 408, 135, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
          draw_rect_shadow(0, 0, 374, 102, '#000', '#000', 0, 0, quit_level_button, 500);
          draw_rect(0, 0, 374, 102, '#900108', '#900108', 0, 0, quit_level_button, 0, 500, 0);
          draw_rect(0, 0, 370, 100, '#EE1C25', '#893631', 0, 1, quit_level_button, 0, 500, 0);
          popup_back.addChild(quit_level_button);
          button_animation_f(quit_level_button, 1);
          quit_level_button.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              popup = 2;
              if (sound_on == 1) {
                play_sound('button_press');
              }
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  missions_tab_open = 0;
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                  reset_question();
                });
            }
          });
          var quit_level_button_text = game.add.text(0, -2, game.cache.getJSON('lang')['t352'][0][window.lang], {
            font: '38px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          quit_level_button_text.anchor.setTo(0.5);
          quit_level_button.addChild(quit_level_button_text);
        } else {
          var quit_level_button = draw_rect(180, 190, 408, 135, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
          draw_rect_shadow(0, 0, 374, 102, '#000', '#000', 0, 0, quit_level_button, 500);
          draw_rect(0, 0, 374, 102, '#900108', '#900108', 0, 0, quit_level_button, 0, 500, 0);
          draw_rect(0, 0, 370, 100, '#EE1C25', '#893631', 0, 1, quit_level_button, 0, 500, 0);
          popup_back.addChild(quit_level_button);
          button_animation_f(quit_level_button, 1);
          quit_level_button.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              popup = 2;
              // app.ddna.missionTracker.trackMissionFail({
              //   stars: 0,
              //   levelScore: 0,
              // });
              if (baloon == 1) {
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    baloon_giveup();
                  });
              } else if (magicbeanDate != 0) {
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    magicbean_giveup();
                  });
              } else {
                if (magicbeanStage >= 6) {
                  magicbeanStage = 0;
                  //unlimited_lifesDate = 0;
                  unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() - unlimited_lifesDate_old);
                  LifeDate = 0;
                  game.setUserDataAndLog({
                    lifes: String(lifes),
                    life_time: String(LifeDate),
                    unlimited_lifesDate: String(unlimited_lifesDate),
                    magicbeanStage: magicbeanStage,
                  });
                }
                game.fetchAndLogUserData();
                replayed += 1;
                game.camera.fade(0xffffff, 1000);
              }
            }
          });
          var quit_level_button_text = game.add.text(0, -2, game.cache.getJSON('lang')['t305'][0][window.lang], {
            font: '32px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          quit_level_button_text.anchor.setTo(0.5);
          quit_level_button.addChild(quit_level_button_text);
        }
        if (music_on == 1) var button_music = game.add.sprite(-220, -120, 'game_window_atlas', 'Music_On.png');
        else var button_music = game.add.sprite(-220, -120, 'game_window_atlas', 'Music_Off.png');
        button_music.anchor.setTo(0.5);
        popup_back.addChild(button_music);
        button_animation_f(button_music, 1);
        button_music.events.onInputDown.add(function (item) {
          btnup(item);
          if (music_on == 1) {
            if (sound_on == 1) {
              play_sound('button_press');
            }
            item.loadTexture('game_window_atlas', 'Music_Off.png', false);
            music_on = 0;
            text_button_music.setText(game.cache.getJSON('lang')['MusicOff'][0][window.lang]);
            game.setUserDataAndLog({ music_on: music_on });
            music.pause();
          } else {
            if (sound_on == 1) {
              play_sound('button_press');
            }
            item.loadTexture('game_window_atlas', 'Music_On.png', false);
            music_on = 1;
            text_button_music.setText(game.cache.getJSON('lang')['MusicOn'][0][window.lang]);
            game.setUserDataAndLog({ music_on: music_on });
            music.play();
          }
        }, this);
        if (sound_on == 1) var button_sound = game.add.sprite(-220, 110, 'game_window_atlas', 'SFX_On.png');
        else var button_sound = game.add.sprite(-220, 110, 'game_window_atlas', 'SFX_Off.png');
        button_sound.anchor.setTo(0.5);
        popup_back.addChild(button_sound);
        button_sound.inputEnabled = true;
        button_animation_f(button_sound, 1);
        button_sound.events.onInputDown.add(function (item) {
          btnup(item);
          if (sound_on == 1) {
            if (sound_on == 1) {
              play_sound('button_press');
            }
            item.loadTexture('game_window_atlas', 'SFX_Off.png', false);
            sound_on = 0;
            text_button_sound.setText(game.cache.getJSON('lang')['SFXOff'][0][window.lang]);
            ambient.pause();
            game.setUserDataAndLog({ sound_on: sound_on });
          } else {
            item.loadTexture('game_window_atlas', 'SFX_On.png', false);
            sound_on = 1;
            text_button_sound.setText(game.cache.getJSON('lang')['SFXOn'][0][window.lang]);
            game.setUserDataAndLog({ sound_on: sound_on });
            if (sound_on == 1) {
              play_sound('button_press');
            }
          }
        }, this);
        var text_button_music = game.add.text(
          button_music.x,
          button_music.y + 120,
          game.cache.getJSON('lang')['MusicOn'][0][window.lang],
          { font: '26px RussoOne', fill: '#9D543D', align: 'center' },
        );
        text_button_music.anchor.setTo(0.5);
        popup_back.addChild(text_button_music);
        var text_button_sound = game.add.text(
          button_sound.x,
          button_sound.y + 120,
          game.cache.getJSON('lang')['SFXOn'][0][window.lang],
          { font: '26px RussoOne', fill: '#9D543D', align: 'center' },
        );
        text_button_sound.anchor.setTo(0.5);
        popup_back.addChild(text_button_sound);
        if (music_on == 0) {
          text_button_music.setText(game.cache.getJSON('lang')['MusicOff'][0][window.lang]);
        } else {
          text_button_music.setText(game.cache.getJSON('lang')['MusicOn'][0][window.lang]);
        }
        if (sound_on == 0) {
          text_button_sound.setText(game.cache.getJSON('lang')['SFXOff'][0][window.lang]);
        } else {
          text_button_sound.setText(game.cache.getJSON('lang')['SFXOn'][0][window.lang]);
        }
        game.add
          .tween(popup_group)
          .to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function (item) { });
      }
    }

    var d8 = [100, 10, 100, 50, 240, 20, 280, 200];

    // returns random indice based on the probabilities passed to the function
    // mostly d8 ^
    function go(m) {
      var sum = 1000;
      var p = Math.random() * sum;
      for (var i = 0; i < m.length; i++) {
        if (p > m[i]) {
          p -= m[i];
        } else {
          return i + 1;
        }
      }
    }

    function wheel_window(s) {
      if ((popup == 0 && missions_tab_open == 0 && animation == 0) || FTUE == 36) {
        if (sound_on == 1) {
          play_sound('button_press');
        }
        popup_group.y = 0;
        popup = 1;
        if (FTUE != 36) {
          blackf();
        } else {
          if (fbv == 1) {
            window.eventTrack('FTUE_13_3Wheel_spin_shown');
          }
        }
        FTUE_process();

        if (wheel_num > 0) {
        } else if (wheel_ads == 0 || shop == 0) {
          var PrizeX10_Ribbon = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 + 100 + 800,
            'game_window2_atlas',
            'PrizeX10_Ribbon.png',
          );
          PrizeX10_Ribbon.anchor.setTo(0.5);
          PrizeX10_Ribbon.scale.setTo(game.camera.width / PrizeX10_Ribbon.width);
          popup_group.add(PrizeX10_Ribbon);
          PrizeX10_Ribbon.fixedToCamera = true;
          game.add.tween(PrizeX10_Ribbon.cameraOffset).to({ y: '-800' }, 800, Phaser.Easing.Exponential.Out, true, 500);
          if (window.lang == 'fr')
            var PrizeX10_Ribbon_text = game.add.text(
              game.camera.width / 2 + 500,
              game.camera.height / 2 + 100,
              game.cache.getJSON('lang')['t380'][0][window.lang],
              { font: '40px RussoOne', fill: '#FFFAE2', align: 'center' },
            );
          else
            var PrizeX10_Ribbon_text = game.add.text(
              game.camera.width / 2 + 500,
              game.camera.height / 2 + 100,
              game.cache.getJSON('lang')['t380'][0][window.lang],
              { font: '60px RussoOne', fill: '#FFFAE2', align: 'center' },
            );
          PrizeX10_Ribbon_text.anchor.setTo(0.5);
          PrizeX10_Ribbon_text.setShadow(0, 8, 'rgba(0,0,0,0.7)', 1);
          PrizeX10_Ribbon_text.alpha = 0;
          popup_group.add(PrizeX10_Ribbon_text);
          PrizeX10_Ribbon_text.fixedToCamera = true;
          game.add.tween(PrizeX10_Ribbon_text).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 1300);
          var PrizeX10_Ribbon_text = game.add.text(
            game.camera.width / 2 + 510 + PrizeX10_Ribbon_text.width / 2,
            game.camera.height / 2 + 100,
            'X2',
            { font: '105px RussoOne', fill: '#FFFAE2', align: 'center' },
          );
          PrizeX10_Ribbon_text.anchor.setTo(0, 0.5);
          PrizeX10_Ribbon_text.setShadow(0, 8, 'rgba(0,0,0,0.7)', 1);
          PrizeX10_Ribbon_text.alpha = 0;
          popup_group.add(PrizeX10_Ribbon_text);
          PrizeX10_Ribbon_text.fixedToCamera = true;
          game.add.tween(PrizeX10_Ribbon_text).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 1300);
        } else {
          var PrizeX10_Ribbon = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 + 100 + 800,
            'game_window2_atlas',
            'PrizeX10_Ribbon.png',
          );
          PrizeX10_Ribbon.anchor.setTo(0.5);
          PrizeX10_Ribbon.scale.setTo(game.camera.width / PrizeX10_Ribbon.width);
          popup_group.add(PrizeX10_Ribbon);
          PrizeX10_Ribbon.fixedToCamera = true;
          game.add.tween(PrizeX10_Ribbon.cameraOffset).to({ y: '-800' }, 800, Phaser.Easing.Exponential.Out, true, 500);
          if (window.lang == 'fr')
            var PrizeX10_Ribbon_text = game.add.text(
              game.camera.width / 2 + 500,
              game.camera.height / 2 + 114,
              game.cache.getJSON('lang')['t380'][0][window.lang],
              { font: '36px RussoOne', fill: '#FFFAE2', align: 'center' },
            );
          else
            var PrizeX10_Ribbon_text = game.add.text(
              game.camera.width / 2 + 500,
              game.camera.height / 2 + 114,
              game.cache.getJSON('lang')['t380'][0][window.lang],
              { font: '60px RussoOne', fill: '#FFFAE2', align: 'center' },
            );
          PrizeX10_Ribbon_text.anchor.setTo(0.5);
          PrizeX10_Ribbon_text.setShadow(0, 8, 'rgba(0,0,0,0.7)', 1);
          PrizeX10_Ribbon_text.alpha = 0;
          popup_group.add(PrizeX10_Ribbon_text);
          PrizeX10_Ribbon_text.fixedToCamera = true;
          game.add.tween(PrizeX10_Ribbon_text).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 1300);
          if (window.lang == 'fr')
            var PrizeX10_Ribbon_text = game.add.text(
              game.camera.width / 2 + 510 + PrizeX10_Ribbon_text.width / 2,
              game.camera.height / 2 + 114,
              'X10',
              { font: '80px RussoOne', fill: '#FFFAE2', align: 'center' },
            );
          else
            var PrizeX10_Ribbon_text = game.add.text(
              game.camera.width / 2 + 510 + PrizeX10_Ribbon_text.width / 2,
              game.camera.height / 2 + 114,
              'X10',
              { font: '105px RussoOne', fill: '#FFFAE2', align: 'center' },
            );
          PrizeX10_Ribbon_text.anchor.setTo(0, 0.5);
          PrizeX10_Ribbon_text.setShadow(0, 8, 'rgba(0,0,0,0.7)', 1);
          PrizeX10_Ribbon_text.alpha = 0;
          popup_group.add(PrizeX10_Ribbon_text);
          PrizeX10_Ribbon_text.fixedToCamera = true;
          game.add.tween(PrizeX10_Ribbon_text).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 1300);
          if (window.lang == 'fr')
            var PrizeX10_Ribbon_text = game.add.text(
              PrizeX10_Ribbon_text.x + PrizeX10_Ribbon_text.width / 2 - 120,
              game.camera.height / 2 + 50,
              game.cache.getJSON('lang')['t381'][0][window.lang],
              { font: '34px RussoOne', fill: '#FFFAE2', align: 'center' },
            );
          else
            var PrizeX10_Ribbon_text = game.add.text(
              PrizeX10_Ribbon_text.x + PrizeX10_Ribbon_text.width / 2,
              game.camera.height / 2 + 50,
              game.cache.getJSON('lang')['t381'][0][window.lang],
              { font: '40px RussoOne', fill: '#FFFAE2', align: 'center' },
            );
          PrizeX10_Ribbon_text.anchor.setTo(0.5);
          PrizeX10_Ribbon_text.setShadow(0, 6, 'rgba(0,0,0,0.7)', 1);
          PrizeX10_Ribbon_text.alpha = 0;
          popup_group.add(PrizeX10_Ribbon_text);
          PrizeX10_Ribbon_text.fixedToCamera = true;
          game.add.tween(PrizeX10_Ribbon_text).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 1300);
        }
        var prize_wheel_icons = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 - 100,
          'game_window2_atlas',
          'Wheel_Background.png',
        );
        prize_wheel_icons.anchor.setTo(0.5);
        popup_group.add(prize_wheel_icons);
        prize_wheel_icons.fixedToCamera = true;
        prize_wheel_icons.alpha = 0;
        prize_wheel_icons.scale.setTo(2);
        game.add.tween(prize_wheel_icons).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 500);
        game.add.tween(prize_wheel_icons.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Exponential.Out, true, 500);
        var prize_wheel_i = game.add.sprite(0, -214, 'game_atlas', 'Joker_Boost.png');
        prize_wheel_i.anchor.setTo(0.5);
        prize_wheel_icons.addChild(prize_wheel_i);
        var prize_wheel_i = game.add.sprite(130, 122, 'game_window2_atlas', 'Cards_top.png');
        prize_wheel_i.anchor.setTo(0.5);
        prize_wheel_i.angle = 135;
        prize_wheel_icons.addChild(prize_wheel_i);
        var prize_wheel_i = game.add.sprite(-130, 122, 'game_window2_atlas', 'Cards_top.png');
        prize_wheel_i.anchor.setTo(0.5);
        prize_wheel_i.angle = -135;
        prize_wheel_icons.addChild(prize_wheel_i);
        var prize_wheel_i = game.add.sprite(-170, -180, 'game_window2_atlas', 'Medium_Coins.png');
        prize_wheel_i.anchor.setTo(0.5);
        prize_wheel_icons.addChild(prize_wheel_i);
        var prize_wheel_i = game.add.sprite(156, -160, 'game_window2_atlas', 'Low_Coins.png');
        prize_wheel_i.anchor.setTo(0.5);
        prize_wheel_icons.addChild(prize_wheel_i);
        var prize_wheel_i = game.add.sprite(-190, -5, 'game_window2_atlas', 'Two_Energies.png');
        prize_wheel_i.anchor.setTo(0.5);
        prize_wheel_icons.addChild(prize_wheel_i);
        var prize_wheel_i = game.add.sprite(220, -5, 'game_window2_atlas', 'Energy.png');
        prize_wheel_i.anchor.setTo(0.5);
        prize_wheel_icons.addChild(prize_wheel_i);
        var prize_wheel_i = game.add.sprite(-7, 210, 'game_window2_atlas', 'Lots_Of_Coins.png');
        prize_wheel_i.anchor.setTo(0.5);
        prize_wheel_icons.addChild(prize_wheel_i);
        if (wheel_num > 0) {
          prize_wheel_arrow = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 - 100,
            'game_window2_atlas',
            'Wheel_Arrow.png',
          );
          prize_wheel_arrow.anchor.setTo(0.35, 0.5);
          popup_group.add(prize_wheel_arrow);
          prize_wheel_arrow.fixedToCamera = true;
          prize_wheel_arrow.alpha = 0;
          prize_wheel_arrow.scale.setTo(2);
          game.add.tween(prize_wheel_arrow).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 500);
          game.add.tween(prize_wheel_arrow.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Exponential.Out, true, 500);
        } else if (wheel_ads == 0 || shop == 0) {
          prize_wheel_arrow = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 - 100,
            'game_window2_atlas',
            'Arrow2.png',
          );
          prize_wheel_arrow.anchor.setTo(0.35, 0.5);
          popup_group.add(prize_wheel_arrow);
          prize_wheel_arrow.fixedToCamera = true;
          prize_wheel_arrow.alpha = 0;
          prize_wheel_arrow.scale.setTo(4);
          game.add.tween(prize_wheel_arrow).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 500);
          game.add.tween(prize_wheel_arrow.scale).to({ x: 2, y: 2 }, 400, Phaser.Easing.Exponential.Out, true, 500);
        } else {
          prize_wheel_arrow = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 - 100,
            'game_window2_atlas',
            'Arrow3.png',
          );
          prize_wheel_arrow.anchor.setTo(0.35, 0.5);
          popup_group.add(prize_wheel_arrow);
          prize_wheel_arrow.fixedToCamera = true;
          prize_wheel_arrow.alpha = 0;
          prize_wheel_arrow.scale.setTo(4);
          game.add.tween(prize_wheel_arrow).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 500);
          game.add.tween(prize_wheel_arrow.scale).to({ x: 2, y: 2 }, 400, Phaser.Easing.Exponential.Out, true, 500);
        }
        if (wheel_num > 0) var Curtain_Left = game.add.sprite(-450, 0, 'game_window2_atlas', 'Curtain_Left.png');
        else if (wheel_ads == 0 || shop == 0)
          var Curtain_Left = game.add.sprite(-450, 0, 'game_window2_atlas', 'Curtain_Left2.png');
        else var Curtain_Left = game.add.sprite(-450, 0, 'game_window2_atlas', 'Curtain_Left3.png');
        popup_group.add(Curtain_Left);
        Curtain_Left.scale.setTo(2);
        Curtain_Left.fixedToCamera = true;
        game.add.tween(Curtain_Left.cameraOffset).to({ x: '+450' }, 800, Phaser.Easing.Exponential.Out, true, 500);
        var Curtain_Left2 = game.add.sprite(0, Curtain_Left.height, 'game_window2_atlas', Curtain_Left.frameName);
        Curtain_Left2.scale.setTo(1, -1);
        Curtain_Left.addChild(Curtain_Left2);
        if (wheel_num > 0)
          var Curtain_Right = game.add.sprite(game.camera.width + 450, 0, 'game_window2_atlas', 'Curtain_Left.png');
        else if (wheel_ads == 0 || shop == 0)
          var Curtain_Right = game.add.sprite(game.camera.width + 450, 0, 'game_window2_atlas', 'Curtain_Left2.png');
        else var Curtain_Right = game.add.sprite(game.camera.width + 450, 0, 'game_window2_atlas', 'Curtain_Left3.png');
        Curtain_Right.anchor.setTo(0, 0);
        Curtain_Right.scale.setTo(-2, 2);
        popup_group.add(Curtain_Right);
        Curtain_Right.fixedToCamera = true;
        game.add.tween(Curtain_Right.cameraOffset).to({ x: '-450' }, 800, Phaser.Easing.Exponential.Out, true, 500);
        var Curtain_Right2 = game.add.sprite(0, Curtain_Right.height, 'game_window2_atlas', Curtain_Right.frameName);
        Curtain_Right2.scale.setTo(1, -1);
        Curtain_Right.addChild(Curtain_Right2);
        if (wheel_num == 0) var girl = game.add.sprite(-450, game.camera.height, 'char_atlas', 'Main_Twinkling.png');
        else var girl = game.add.sprite(-450, game.camera.height, 'char_atlas', 'Main_Presenting.png');
        girl.anchor.setTo(0.5, 1);
        girl.scale.setTo(-2.4, 2.4);
        girl.angle -= 20;
        popup_group.add(girl);
        girl.fixedToCamera = true;
        game.add
          .tween(girl.cameraOffset)
          .to({ x: game.camera.width / 2 - 560 }, 800, Phaser.Easing.Exponential.In, true, 500);
        game.add.tween(girl).to({ angle: 0 }, 800, Phaser.Easing.Elastic.Out, true, 1200);
        var prize1_text = 0;
        if (wheel_num > 0)
          prize1_text = game.add.text(220, -220, '50', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else if (wheel_ads == 0 || shop == 0)
          prize1_text = game.add.text(220, -220, '100', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else prize1_text = game.add.text(220, -220, '250', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        prize1_text.angle = 45;
        prize_wheel_icons.addChild(prize1_text);
        if (wheel_num > 0)
          prize1_text = game.add.text(-220, -220, '75', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else if (wheel_ads == 0 || shop == 0)
          prize1_text = game.add.text(-220, -220, '150', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else prize1_text = game.add.text(-220, -220, '750', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.angle = -45;
        prize1_text.strokeThickness = 12;
        prize_wheel_icons.addChild(prize1_text);
        if (wheel_num > 0)
          prize1_text = game.add.text(-290, 0, '+2', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else if (wheel_ads == 0 || shop == 0)
          prize1_text = game.add.text(-290, 0, '+3', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else prize1_text = game.add.text(-290, 0, '+10', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        prize_wheel_icons.addChild(prize1_text);
        if (wheel_num > 0)
          prize1_text = game.add.text(290, 0, '+1', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else if (wheel_ads == 0 || shop == 0)
          prize1_text = game.add.text(290, 0, '+2', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else prize1_text = game.add.text(290, 0, '+5', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        prize_wheel_icons.addChild(prize1_text);
        if (wheel_num > 0)
          prize1_text = game.add.text(-190, 190, '+2', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else if (wheel_ads == 0 || shop == 0)
          prize1_text = game.add.text(-190, 190, '+3', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else prize1_text = game.add.text(-190, 190, '+5', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.angle = 45;
        prize1_text.strokeThickness = 12;
        prize_wheel_icons.addChild(prize1_text);
        if (wheel_num > 0)
          prize1_text = game.add.text(0, 290, '1000', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else if (wheel_ads == 0 || shop == 0)
          prize1_text = game.add.text(0, 290, '1500', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else prize1_text = game.add.text(0, 290, '10000', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        prize_wheel_icons.addChild(prize1_text);
        if (wheel_num > 0)
          prize1_text = game.add.text(190, 190, '+1', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else if (wheel_ads == 0 || shop == 0)
          prize1_text = game.add.text(190, 190, '+2', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else prize1_text = game.add.text(190, 190, '+3', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.angle = -45;
        prize1_text.strokeThickness = 12;
        prize_wheel_icons.addChild(prize1_text);
        if (wheel_num > 0)
          prize1_text = game.add.text(0, -310, '+1', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else if (wheel_ads == 0 || shop == 0)
          prize1_text = game.add.text(0, -310, '+2', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        else prize1_text = game.add.text(0, -310, '+3', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        prize_wheel_icons.addChild(prize1_text);
        function wheel_lightbulb_f(type) {
          var pause = 0;
          var speed = 800;
          if (type == 1) {
            speed = 400;
          }
          prize_wheel_icons.children.forEach(function (child_item) {
            if (child_item.n == 1) {
              if (type == 2) {
                pause = 225 * child_item.iii;
              }
              if (child_item.alpha == 0) {
                var tween = game.add
                  .tween(child_item.scale)
                  .to({ x: 1, y: 1 }, speed, Phaser.Easing.Quadratic.InOut, true, pause, -1)
                  .yoyo(true, speed / 2);
                var tween2 = game.add
                  .tween(child_item)
                  .to({ alpha: 0.9 }, speed, Phaser.Easing.Linear.None, true, pause, -1)
                  .yoyo(true, speed / 2);
                tween2.tw = tween;
              } else {
                var tween = game.add
                  .tween(child_item.scale)
                  .to({ x: 0.2, y: 0.2 }, speed, Phaser.Easing.Quadratic.InOut, true, pause, -1)
                  .yoyo(true, speed / 2);
                var tween2 = game.add
                  .tween(child_item)
                  .to({ alpha: 0 }, speed, Phaser.Easing.Linear.None, true, pause, -1)
                  .yoyo(true, speed / 2);
                tween2.tw = tween;
              }
              tween2.onUpdateCallback(function (item) {
                if (item.target.alpha < 0.05) {
                  if (popup == 3 && type == 2) {
                    item.stop();
                    item.tw.stop();
                    game.tweens.remove(item.tw);
                    game.tweens.remove(item);
                    item.target.destroy();
                  }
                }
              }, this);
            }
          });
        }
        bright_area = game.add.sprite(0, -5, 'game_window2_atlas', 'Wheel_Selected_Part.png');
        bright_area.anchor.setTo(0.05);
        bright_area.angle = -45;
        bright_area.alpha = 1;
        prize_wheel_icons.addChild(bright_area);
        function Wheel_Light_create(type) {
          for (var i = 0; i < 8; i++) {
            var f = (2 / 8) * i * Math.PI + 1.17;
            var xxx = 0 + 355 * Math.sin(f);
            var yyy = -5 + 355 * Math.cos(f);
            var Wheel_Light = game.add.sprite(xxx, yyy, 'game_window2_atlas', 'Wheel_Light.png');
            Wheel_Light.anchor.setTo(0.5);
            Wheel_Light.n = 1;
            Wheel_Light.iii = 8 - i;
            if (type == 1) {
              if (i % 2 == 0) {
                Wheel_Light.scale.setTo(1);
                Wheel_Light.alpha = 0.9;
              } else {
                Wheel_Light.scale.setTo(0.2);
                Wheel_Light.alpha = 0;
              }
            } else {
              Wheel_Light.scale.setTo(0.2);
              Wheel_Light.alpha = 0;
            }
            prize_wheel_icons.addChild(Wheel_Light);
            rotate_tween(Wheel_Light);
          }
          wheel_lightbulb_f(type);
        }
        Wheel_Light_create(2);
        if (FTUE > 38) {
          var popup_close = game.add.sprite(
            game.camera.width - 100 + 200,
            100,
            'game_window_atlas',
            'Close_Button.png',
          );
          popup_close.anchor.setTo(0.5);
          button_animation_f(popup_close, 1);
          popup_close.events.onInputUp.add(function () {
            if (popup != 2) {
              popup = 2;
              if (sound_on == 1) {
                play_sound('button_X');
              }
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add.tween(Curtain_Left.cameraOffset).to({ x: '-450' }, 500, Phaser.Easing.Quadratic.Out, true);
              game.add
                .tween(Curtain_Right.cameraOffset)
                .to({ x: '+450' }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  if (special_stage != 0) {
                    bottom_button(0, 0, 0, UI_bottom_group, -1, 1);
                  }
                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup = 0;
                      prize_wheel_arrow = 0;
                      popup_group.y -= game.camera.height;
                      if (special_stage != 0) {
                        build_special_object(special_stage, 1);
                      }
                    });
                });
            }
          }, this);
          popup_group.add(popup_close);
          popup_close.fixedToCamera = true;
          game.add.tween(popup_close.cameraOffset).to({ x: '-200' }, 500, Phaser.Easing.Quadratic.Out, true, 500);
        }
        function wheel_spin(item) {
          if (popup != 2 || FTUE == 38) {
            popup = 2;
            if (sound_on == 1) {
              play_sound('button_press');
            }
            if (FTUE > 30)
              for (var i = 0; i < missions.length; i += 4) {
                if (missions[i] == -16) {
                  if (missions[i + 2] < missions[i + 1]) {
                    missions[i + 2] += 1;
                  }
                }
              }
            if (FTUE > 150)
              game.add
                .tween(popup_close)
                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (itm) {
                  itm.destroy();
                });
            game.add
              .tween(item)
              .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (itm) {
                itm.destroy();
              });
            if (wheel_num > 0) {
              wheel_num -= 1;
              if (wheel_num_text != 0 && typeof wheel_num_text !== "undefined") { wheel_num_text.setText(wheel_num); }
              wheel_max = 3;
              //game.setUserDataAndLog({ wheel_num: wheel_num, wheel_max: wheel_max });
              if (wheel_max <= 0) {
                wheel_icon.alpha = 0;
                wheel_icon.children.forEach(function (child_item) {
                  child_item.inputEnabled = false;
                });
                if (friends_icon != 0) {
                  friends_icon.cameraOffset.y = 280;
                }
              }
              if (wheel_num <= 0) {
                if (wheel_num <= 0) {
                  wheel_icon_shine.alpha = 0;
                }
                wheel_icon_label.destroy();
                wheel_num_text.destroy();
                wheel_num_text = 0;
                if (wheel_ads == 0 || shop == 0) {
                  if (wheel_ad_icon != 0) {
                    wheel_ad_icon.destroy();
                    wheel_ad_icon = 0;
                  }
                  wheel_ad_icon = game.add.sprite(0, 0, 'game_atlas', 'ad_icon.png');
                  wheel_ad_icon.anchor.setTo(0.5);
                  wheel_icon.addChild(wheel_ad_icon);
                } else {
                  if (wheel_ad_icon != 0) {
                    wheel_ad_icon.destroy();
                    wheel_ad_icon = 0;
                  }
                  wheel_ad_icon = game.add.text(0, 0, '', { font: '36px RussoOne', fill: '#FFD75A', align: 'center' });
                  wheel_ad_icon.stroke = '#ffffff';
                  wheel_ad_icon.strokeThickness = 4;
                  wheel_ad_icon.setShadow(0, 3, 'rgba(0,0,0,1)', 1);
                  wheel_ad_icon.anchor.setTo(0.5);
                  wheel_icon.addChild(wheel_ad_icon);
                }
              }
              if (WheelDate == 0) {
                WheelDate =
                  ddd == 0
                    ? new Date()
                    : new Date(
                      ddd +
                      ' ' +
                      new Date().getHours() +
                      ':' +
                      new Date().getMinutes() +
                      ':' +
                      new Date().getSeconds(),
                    );
                WheelDate.setHours(WheelDate.getHours() + time_wheel);
                //game.setUserDataAndLog({ wheel_time: String(WheelDate) });
              }
            } else {
              if (wheel_ads == 0 || shop == 0) {
                if (wheel_ad_icon != 0) {
                  wheel_ad_icon.destroy();
                  wheel_ad_icon = 0;
                }
                wheel_ad_icon = game.add.sprite(0, 0, 'game_atlas', 'ad_icon.png');
                wheel_ad_icon.anchor.setTo(0.5);
                wheel_icon.addChild(wheel_ad_icon);
              } else {
                if (wheel_ad_icon != 0) {
                  wheel_ad_icon.destroy();
                  wheel_ad_icon = 0;
                }
                wheel_ad_icon = game.add.text(0, 0, '', { font: '36px RussoOne', fill: '#FFD75A', align: 'center' });
                wheel_ad_icon.stroke = '#ffffff';
                wheel_ad_icon.strokeThickness = 4;
                wheel_ad_icon.setShadow(0, 3, 'rgba(0,0,0,1)', 1);
                wheel_ad_icon.anchor.setTo(0.5);
                wheel_icon.addChild(wheel_ad_icon);
              }
            }
            if (fbv == 1) {
              game.setCurrentEvent();
              window.eventTrack('wheel_tracking', 1, {
                free_spins: wheel_free,
                video_spins: wheel_ad,
                cash_spins: wheel_cash,
                user_type: bought,
                lifetime: lifetime_day,
                mission_completed: missioncompleted,
                c_event: current_event,
              });
            }
            var rnd = go(d8);
            if (prize_wheel_arrow.angle == 0) var r = 2880 + rnd * 45 + game.rnd.integerInRange(-15, 15);
            game.add
              .tween(prize_wheel_arrow)
              .to({ angle: '+' + r }, 10000, Phaser.Easing.Cubic.InOut, true)
              .onComplete.add(function (item) {
                if (fbv == 1 && FTUE == 39) {
                  window.eventTrack('FTUE_13_4Wheel_spin_finished');
                }
                popup = 3;
                Wheel_Light_create(1);
                var prz = prize_wheel_arrow.angle;
                if (sound_on == 1) {
                  play_sound('PrizeWheel_Win_Song');
                }
                game.add
                  .tween(bright_area)
                  .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(bright_area)
                      .to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(bright_area)
                          .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            game.add
                              .tween(bright_area)
                              .to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true)
                              .onComplete.add(function (item) {
                                game.add
                                  .tween(bright_area)
                                  .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
                                  .onComplete.add(function (item) {
                                    game.add
                                      .tween(bright_area)
                                      .to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true)
                                      .onComplete.add(function (item) {
                                        game.add
                                          .tween(bright_area)
                                          .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
                                          .onComplete.add(function (item) { });
                                      });
                                  });
                              });
                          });
                      });
                    game.add.tween(girl).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
                    var girl_new = game.add.sprite(
                      game.camera.width / 2 - 610,
                      game.camera.height,
                      'char_atlas',
                      'Main_Excited.png',
                    );
                    girl_new.anchor.setTo(0.5, 1);
                    girl_new.scale.setTo(-2.4, 2.4);
                    girl_new.alpha = 0;
                    popup_group.add(girl_new);
                    girl_new.fixedToCamera = true;
                    game.add.tween(girl_new).to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true);
                    var button_green1 = game.add.sprite(
                      game.camera.width / 2,
                      game.camera.height / 2 + 400,
                      'game_window2_atlas',
                      'Free_Spin_Claim_Button.png',
                    );
                    button_green1.anchor.setTo(0.5);
                    button_green1.inputEnabled = true;
                    button_green1.alpha = 0;
                    button_green1.events.onInputUp.add(function (item) {
                      if (popup != 4) {
                        if (fbv == 1 && (FTUE == 38 || FTUE == 39)) {
                          window.eventTrack('FTUE_13_4Wheel_spin_claim_clicked');
                        }
                        popup = 4;
                        game.add
                          .tween(black_sprite)
                          .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                          .onComplete.add(function (item) {
                            item.destroy();
                          });
                        game.add
                          .tween(Curtain_Left.cameraOffset)
                          .to({ x: '-450' }, 500, Phaser.Easing.Quadratic.Out, true);
                        game.add
                          .tween(Curtain_Right.cameraOffset)
                          .to({ x: '+450' }, 500, Phaser.Easing.Quadratic.Out, true)
                          .onComplete.add(function (item) {
                            if (special_stage != 0) {
                              bottom_button(0, 0, 0, UI_bottom_group, -1, 1);
                            }
                            game.add
                              .tween(popup_group)
                              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                              .onComplete.add(function (item) {
                                prize_wheel_arrow = 0;
                                popup_group.removeAll(true);
                                if (FTUE > 150 && special_stage == 0) {
                                  popup = 1;
                                  game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                                    popup = 0;
                                    wheel_max = 3;
                                    if (wheel_max > 0) {
                                      wheel_window();
                                    }
                                  });
                                } else popup = 0;
                                popup_group.y -= game.camera.height;
                                if (special_stage != 0) {
                                  build_special_object(special_stage, 1);
                                }
                                var col = 0;
                                var p_text = 0;
                                if (rnd == 1) {
                                  if (wheel_ads == 0) {
                                    free_three += 1;
                                    col = -1;
                                  } else if (wheel_ads == 1) {
                                    free_three += 2;
                                    col = -2;
                                  } else {
                                    free_three += 3;
                                    col = -3;
                                  }
                                  p_text = game.cache.getJSON('lang')['WheelAddCards'][0][window.lang];
                                  p_text = p_text.replace('[x]', col * -1);
                                  message(p_text, prize_wheel_icons.x, prize_wheel_icons.y);
                                }
                                if (rnd == 7) {
                                  if (wheel_ads == 0) {
                                    coins += 50;
                                    col = 50;
                                  } else if (wheel_ads == 1) {
                                    coins += 100;
                                    col = 100;
                                  } else {
                                    coins += 250;
                                    col = 250;
                                  }
                                  game.setCurrentEvent();
                                  window.eventTrack('coins_in', col, {
                                    user_type: bought,
                                    lifetime: lifetime_day,
                                    highest_lvl: all_level.lastIndexOf(3) + 2,
                                    amount: col,
                                    source: 'wheel',
                                    package_id: 0,
                                    mission_completed: missioncompleted,
                                    c_event: current_event,
                                  });

                                  // save collected coins
                                  game.setUserDataAndLog({ currencies: coins });

                                  p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                                  p_text = p_text.replace('[x]', col);
                                  message(p_text, prize_wheel_icons.x, prize_wheel_icons.y);
                                }
                                if (rnd == 6) {
                                  if (wheel_ads == 0) {
                                    game.setCurrentEvent();
                                    window.eventTrack('booster_in', 1, {
                                      user_type: bought,
                                      lifetime: lifetime_day,
                                      highest_lvl: all_level.lastIndexOf(3) + 2,
                                      amount: 1,
                                      source: 'Joker',
                                      item_id: 0,
                                      mission_completed: missioncompleted,
                                      c_event: current_event,
                                    });
                                    free_joker += 1;
                                    col = -10;
                                  } else if (wheel_ads == 1) {
                                    game.setCurrentEvent();
                                    window.eventTrack('booster_in', 2, {
                                      user_type: bought,
                                      lifetime: lifetime_day,
                                      highest_lvl: all_level.lastIndexOf(3) + 2,
                                      amount: 2,
                                      source: 'Joker',
                                      item_id: 0,
                                      mission_completed: missioncompleted,
                                      c_event: current_event,
                                    });
                                    free_joker += 2;
                                    col = -20;
                                  } else {
                                    game.setCurrentEvent();
                                    window.eventTrack('booster_in', 3, {
                                      user_type: bought,
                                      lifetime: lifetime_day,
                                      highest_lvl: all_level.lastIndexOf(3) + 2,
                                      amount: 3,
                                      source: 'Joker',
                                      item_id: 0,
                                      mission_completed: missioncompleted,
                                      c_event: current_event,
                                    });
                                    free_joker += 3;
                                    col = -30;
                                  }
                                  p_text = game.cache.getJSON('lang')['WheelAddJoker'][0][window.lang];
                                  p_text = p_text.replace('[x]', col * -0.1);
                                  message(p_text, prize_wheel_icons.x, prize_wheel_icons.y);
                                }
                                if (rnd == 5) {
                                  if (wheel_ads == 0) {
                                    coins += 75;
                                    col = 75;
                                  } else if (wheel_ads == 1) {
                                    coins += 150;
                                    col = 150;
                                  } else {
                                    coins += 750;
                                    col = 750;
                                  }
                                  game.setCurrentEvent();
                                  window.eventTrack('coins_in', col, {
                                    user_type: bought,
                                    lifetime: lifetime_day,
                                    highest_lvl: all_level.lastIndexOf(3) + 2,
                                    amount: col,
                                    source: 'wheel',
                                    package_id: 0,
                                    mission_completed: missioncompleted,
                                    c_event: current_event,
                                  });

                                  // save collected coins
                                  game.setUserDataAndLog({ currencies: coins });

                                  p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                                  p_text = p_text.replace('[x]', col);
                                  message(p_text, prize_wheel_icons.x, prize_wheel_icons.y);
                                }
                                if (rnd == 8) {
                                  if (wheel_ads == 0) {
                                    lifes = Number(lifes) + 1;
                                    col = 1;
                                  } else if (wheel_ads == 1) {
                                    lifes = Number(lifes) + 2;
                                    col = 2;
                                  } else {
                                    lifes = Number(lifes) + 5;
                                    col = 5;
                                  }
                                  p_text = game.cache.getJSON('lang')['WheelAddLives'][0][window.lang];
                                  p_text = p_text.replace('[x]', col);
                                  message(p_text, prize_wheel_icons.x, prize_wheel_icons.y);
                                }

                                if (rnd == 2) {
                                  if (wheel_ads == 0) {
                                    coins += 1000;
                                    col = 1000;
                                  } else if (wheel_ads == 1) {
                                    coins += 1500;
                                    col = 1500;
                                  } else {
                                    coins += 10000;
                                    col = 10000;
                                  }
                                  game.setCurrentEvent();
                                  window.eventTrack('coins_in', col, {
                                    user_type: bought,
                                    lifetime: lifetime_day,
                                    highest_lvl: all_level.lastIndexOf(3) + 2,
                                    amount: col,
                                    source: 'wheel',
                                    package_id: 0,
                                    mission_completed: missioncompleted,
                                    c_event: current_event,
                                  });

                                  // save collected coins
                                  game.setUserDataAndLog({ currencies: coins });

                                  p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                                  p_text = p_text.replace('[x]', col);
                                  message(p_text, prize_wheel_icons.x, prize_wheel_icons.y);
                                }

                                if (rnd == 3) {
                                  if (wheel_ads == 0) {
                                    free_three += 2;
                                    col = -2;
                                  } else if (wheel_ads == 1) {
                                    free_three += 3;
                                    col = -3;
                                  } else {
                                    free_three += 5;
                                    col = -5;
                                  }
                                  p_text = game.cache.getJSON('lang')['WheelAddCards'][0][window.lang];
                                  p_text = p_text.replace('[x]', col * -1);
                                  message(p_text, prize_wheel_icons.x, prize_wheel_icons.y);
                                }

                                if (rnd == 4) {
                                  if (wheel_ads == 0) {
                                    lifes = Number(lifes) + 2;
                                    col = 2;
                                  } else if (wheel_ads == 1) {
                                    lifes = Number(lifes) + 3;
                                    col = 3;
                                  } else {
                                    lifes = Number(lifes) + 10;
                                    col = 10;
                                  }
                                  p_text = game.cache.getJSON('lang')['WheelAddLives'][0][window.lang];
                                  p_text = p_text.replace('[x]', col);
                                  message(p_text, prize_wheel_icons.x, prize_wheel_icons.y);
                                }
                                if (col > 10) {
                                  coins_text = coins - col;
                                  text_coins_panel.setText(coins_text);
                                  var var_coins = 0;
                                  if (sound_on == 1) {
                                    play_sound('coins_add');
                                  }
                                  game.time.events.repeat(
                                    100,
                                    10,
                                    function () {
                                      var get_coin = game.add.sprite(
                                        prize_wheel_icons.x + game.rnd.integerInRange(-50, 50),
                                        prize_wheel_icons.y + game.rnd.integerInRange(-50, 50),
                                        'game_ui_atlas',
                                        'Coin_Icon.png',
                                      );
                                      get_coin.anchor.setTo(0.5);
                                      get_coin.scale.setTo(0);
                                      get_coin.alpha = 0;
                                      effects_group.add(get_coin);
                                      game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(get_coin.scale)
                                        .to({ x: 0.5, y: 0.5 }, 400, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(get_coin)
                                        .to(
                                          { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                                          600,
                                          Phaser.Easing.Linear.None,
                                          true,
                                        )
                                        .onComplete.add(function (item) {
                                          item.destroy();
                                          var_coins += col / 10;
                                          text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                                        });
                                    },
                                    this,
                                  );
                                } else if (col > 0) {
                                  var lifes_text = String(Number(lifes) - Number(col));
                                  text_lifes.setText(lifes_text);
                                  var var_lifes = 0;
                                  game.time.events.repeat(
                                    100,
                                    col,
                                    function () {
                                      var get_lifes = game.add.sprite(
                                        prize_wheel_icons.x + game.rnd.integerInRange(-50, 50),
                                        prize_wheel_icons.y + game.rnd.integerInRange(-50, 50),
                                        'game_ui_atlas',
                                        'Thunder_Icon.png',
                                      );
                                      get_lifes.anchor.setTo(0.5);
                                      get_lifes.scale.setTo(0);
                                      get_lifes.alpha = 0;
                                      effects_group.add(get_lifes);
                                      game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(get_lifes.scale)
                                        .to({ x: 0.5, y: 0.5 }, 400, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(get_lifes)
                                        .to(
                                          { x: text_lifes.world.x, y: text_lifes.world.y },
                                          600,
                                          Phaser.Easing.Linear.None,
                                          true,
                                        )
                                        .onComplete.add(function (item) {
                                          item.destroy();
                                          var_lifes = Number(var_lifes) + 1;
                                          text_lifes.setText(Math.ceil(Number(lifes_text) + Number(var_lifes)));
                                        });
                                    },
                                    this,
                                  );
                                  //game.setUserDataAndLog({ lifes: String(lifes) });
                                } else if (col < 0 && col > -10) {
                                  col *= -1;
                                  game.time.events.repeat(
                                    100,
                                    col,
                                    function () {
                                      var get_lifes = game.add.sprite(
                                        prize_wheel_icons.x + game.rnd.integerInRange(-50, 50),
                                        prize_wheel_icons.y + game.rnd.integerInRange(-50, 50),
                                        'game_window_atlas',
                                        'Card_5.png',
                                      );
                                      get_lifes.anchor.setTo(0.5);
                                      get_lifes.scale.setTo(0);
                                      get_lifes.alpha = 0;
                                      effects_group.add(get_lifes);
                                      game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(get_lifes.scale)
                                        .to({ x: 2, y: 2 }, 400, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(get_lifes)
                                        .to(
                                          { x: level_button.world.x, y: level_button.world.y },
                                          600,
                                          Phaser.Easing.Linear.None,
                                          true,
                                        )
                                        .onComplete.add(function (item) {
                                          item.destroy();
                                        });
                                    },
                                    this,
                                  );
                                } else if (col <= -10) {
                                  col *= -0.1;
                                  game.time.events.repeat(
                                    100,
                                    col,
                                    function () {
                                      var get_lifes = game.add.sprite(
                                        prize_wheel_icons.x + game.rnd.integerInRange(-50, 50),
                                        prize_wheel_icons.y + game.rnd.integerInRange(-50, 50),
                                        'game_atlas',
                                        'Joker_Boost.png',
                                      );
                                      get_lifes.anchor.setTo(0.5);
                                      get_lifes.scale.setTo(0);
                                      get_lifes.alpha = 0;
                                      effects_group.add(get_lifes);
                                      game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(get_lifes.scale)
                                        .to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(get_lifes)
                                        .to(
                                          { x: level_button.world.x, y: level_button.world.y },
                                          600,
                                          Phaser.Easing.Linear.None,
                                          true,
                                        )
                                        .onComplete.add(function (item) {
                                          item.destroy();
                                        });
                                    },
                                    this,
                                  );
                                }

                                game.setUserDataAndLog({
                                  lifes: String(lifes),
                                  currencies: coins,
                                  free_three: free_three,
                                  free_joker: free_joker,
                                  wheel_ads: wheel_ads,
                                  bought: bought,
                                  wheeladsDate: String(wheeladsDate),
                                  wheel_time: String(WheelDate),
                                  wheel_num: wheel_num,
                                  wheel_max: wheel_max
                                });

                              });
                          });


                      }
                    });
                    popup_group.add(button_green1);
                    button_green1.fixedToCamera = true;
                    button_green1.input.useHandCursor = true;
                    scale_tween(button_green1, 500, 0.1, 0.1);
                    var button_green1_text = game.add.text(0, 2, game.cache.getJSON('lang')['Claim'][0][window.lang], {
                      font: '48px RussoOne',
                      fill: '#fff',
                      align: 'center',
                    });
                    button_green1_text.anchor.setTo(0.5);
                    button_green1_text.lineSpacing = -10;
                    button_green1_text.stroke = '#457310';
                    button_green1_text.strokeThickness = 4;
                    button_green1_text.setShadow(0, 3, 'rgba(69,115,16,0.7)', 1);
                    button_green1.addChild(button_green1_text);
                    game.add.tween(button_green1).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                  });
              });
          }
        }
        if ((wheel_num == 0 && wheel_ads == 0) || (wheel_num == 0 && shop == 0)) {
          var button_green1 = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 + 400 + 400,
            'game_window2_atlas',
            'Watch_Ad_Button.png',
          );
          button_green1.anchor.setTo(0.5);
          button_green1.inputEnabled = true;
          button_green1.events.onInputUp.add(function (item) {
            wheel_ads = 1;
            if (popup != 2) {
              popup = 2;
              loading();
              if (fbv == 1) {
                console.log("%cThis should not happen!", "color:orange");
                // var preloadedRewardedVideo = null;
                // getRewardedVideoAsync(placement.Rewarded1, {
                //   adContext: DdnaAdContext.RewardedMap,
                //   adGameArea: DdnaAdGameArea.Map,
                //   adRewardType: TAdRewardType.WheelSpin,
                //   levelNumber: null,
                // })
                //   .then(function (rewarded) {
                //     preloadedRewardedVideo = rewarded;
                //     return preloadedRewardedVideo.loadAsync();
                //   })
                //   .then(function () {
                //     console.log('Rewarded video preloaded');
                //     if (music_on == 1) {
                //       music.pause();
                //     }
                //     if (sound_on == 1) {
                //       ambient.pause();
                //     }
                //     preloadedRewardedVideo
                //       .showAsync()
                //       .then(function () {
                //         console.log('Rewarded video watched successfully');
                //         if (loading_black_sprite != 0) {
                //           loading_black_sprite.destroy();
                //           loading_black_sprite = 0;
                //         }
                //         if (loading_text != 0 && loading_text != 1) {
                //           loading_text.destroy();
                //           loading_text = 0;
                //         }
                //         loading_text = 1;
                //         popup = 1;
                //         wheel_ads = 1;
                //         wheel_ad += 1;
                //         wheel_spin(item);
                //         wheeladsDate =
                //           ddd == 0
                //             ? new Date()
                //             : new Date(
                //               ddd +
                //               ' ' +
                //               new Date().getHours() +
                //               ':' +
                //               new Date().getMinutes() +
                //               ':' +
                //               new Date().getSeconds(),
                //             );
                //         wheeladsDate.setHours(wheeladsDate.getHours() + 12);
                //         //game.setUserDataAndLog({ wheel_ads: wheel_ads, wheeladsDate: wheeladsDate });
                //         if (bought == 0) {
                //           wheelshopDate =
                //             ddd == 0
                //               ? new Date()
                //               : new Date(
                //                 ddd +
                //                 ' ' +
                //                 new Date().getHours() +
                //                 ':' +
                //                 new Date().getMinutes() +
                //                 ':' +
                //                 new Date().getSeconds(),
                //               );
                //           wheelshopDate.setMinutes(wheelshopDate.getMinutes() + 15);
                //           game.setUserDataAndLog({ wheelshopDate: wheelshopDate });
                //         } else {
                //           wheelshopDate =
                //             ddd == 0
                //               ? new Date()
                //               : new Date(
                //                 ddd +
                //                 ' ' +
                //                 new Date().getHours() +
                //                 ':' +
                //                 new Date().getMinutes() +
                //                 ':' +
                //                 new Date().getSeconds(),
                //               );
                //           wheelshopDate.setHours(wheelshopDate.getHours() + 72);
                //           game.setUserDataAndLog({ wheelshopDate: wheelshopDate });
                //         }
                //         if (music_on == 1) {
                //           music.play();
                //         }
                //       })
                //       .catch(function (e) {
                //         console.error(e.message);
                //         if (loading_black_sprite != 0) {
                //           loading_black_sprite.destroy();
                //           loading_black_sprite = 0;
                //         }
                //         if (loading_text != 0 && loading_text != 1) {
                //           loading_text.destroy();
                //           loading_text = 0;
                //         }
                //         loading_text = 1;
                //         popup_group.removeAll(true);
                //         popup = 0;
                //         black_sprite.destroy();
                //         popup_group.y -= game.camera.height;
                //         no_ad(3, 0);
                //         if (music_on == 1) {
                //           music.play();
                //         }
                //       });
                //   })
                //   .catch(function (err) {
                //     console.error('Rewarded video failed to preload: ' + err.message);
                //     if (loading_black_sprite != 0) {
                //       loading_black_sprite.destroy();
                //       loading_black_sprite = 0;
                //     }
                //     if (loading_text != 0 && loading_text != 1) {
                //       loading_text.destroy();
                //       loading_text = 0;
                //     }
                //     loading_text = 1;
                //     popup_group.removeAll(true);
                //     popup = 0;
                //     black_sprite.destroy();
                //     popup_group.y -= game.camera.height;
                //     no_ad(3, 0);
                //   });
              } else {
                if (music_on == 1) music.pause();
                if (sound_on == 1) ambient.pause();

                sdkHandler.trigger(
                  'rewardedAd',
                  {
                    callback: function (success) {
                      if (music_on == 1) music.play();
                      if (sound_on == 1) ambient.play();

                      if (success) {
                        console.log('Rewarded video watched successfully 2');
                        if (loading_black_sprite != 0) {
                          loading_black_sprite.destroy();
                          loading_black_sprite = 0;
                        }
                        if (loading_text != 0 && loading_text != 1) {
                          loading_text.destroy();
                          loading_text = 0;
                        }
                        loading_text = 1;
                        popup = 1;
                        wheel_spin(item);
                      } else {
                        console.error('Rewarded video failed to load 2');
                        if (loading_black_sprite != 0) {
                          loading_black_sprite.destroy();
                          loading_black_sprite = 0;
                        }
                        if (loading_text != 0 && loading_text != 1) {
                          loading_text.destroy();
                          loading_text = 0;
                        }

                        loading_text = 1;
                        popup_group.removeAll(true);
                        popup = 0;
                        black_sprite.destroy();
                        popup_group.y -= game.camera.height;
                        no_ad(3, 0);
                      }
                    },
                  },
                  this,
                );
              }
            }
          });
          popup_group.add(button_green1);
          button_green1.fixedToCamera = true;
          button_green1.input.useHandCursor = true;
          scale_tween(button_green1, 500, 0.1, 0.1);
          var button_green1_text = game.add.text(40, 2, game.cache.getJSON('lang')['WatchAd'][0][window.lang], {
            font: '48px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          button_green1_text.lineSpacing = -10;
          button_green1_text.stroke = '#457310';
          button_green1_text.strokeThickness = 4;
          button_green1_text.setShadow(0, 3, 'rgba(69,115,16,0.7)', 1);
          button_green1_text.anchor.setTo(0.5);
          button_green1.addChild(button_green1_text);
        } else if (wheel_num == 0 && wheel_ads >= 1 && shop == 1) {
          var wheel_sale = 0;
          if (wheel_icon_text2.text != '') {
            wheel_sale = 1;
          }
          var button_green1 = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 + 400 + 400,
            'game_window2_atlas',
            'Free_Spin_Claim_Button.png',
          );
          button_green1.anchor.setTo(0.5);
          button_green1.inputEnabled = true;
          button_green1.events.onInputUp.add(function (item) {
            if (popup != 2) {
              popup = 2;
              loading();
              if (wheel_sale == 0) {
                game.setCurrentEvent();
                if (fbv == 1) {
                  window.eventTrack('premium_spin_initiated');
                  window.eventTrack('soga_purchase_initiated', 1, {
                    package_id: 'premium_spin',
                    value: '1.99 $',
                    current_level: level_button.n,
                    conversion: 1 - bought,
                    user_type: bought,
                    lifetime: lifetime_day,
                    mission_completed: missioncompleted,
                    c_event: current_event,
                  });
                }
                if (animation == 100) {
                  if (bought == 0) {
                    bought_f = 1;
                  }
                  if (fbv == 1) {
                    window.eventTrack('premium_spin_successfull');
                    window.eventTrack('soga_purchase_successfull', 1, {
                      package_id: 'premium_spin',
                      value: '1.99 $',
                      current_level: level_button.n,
                      conversion: 1 - bought,
                      first_purchase: bought_f,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                  }
                  if (loading_black_sprite != 0) {
                    loading_black_sprite.destroy();
                    loading_black_sprite = 0;
                  }
                  if (loading_text != 0 && loading_text != 1) {
                    loading_text.destroy();
                    loading_text = 0;
                  }
                  loading_text = 1;
                  popup = 1;
                  wheel_ads = 2;
                  wheel_cash += 1;
                  wheel_spin(item);
                  bought = 1;
                  bought_f = 0;
                  //game.setUserDataAndLog({ wheel_ads: wheel_ads, bought: bought });
                }

                // else
                //   purchaseAsync(
                //     {
                //       productID: 'premium_spin',
                //       developerPayload: 'Premium spin',
                //     },
                //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                //   )
                //     .then(function (purchase) {
                //       if (bought == 0) {
                //         bought_f = 1;
                //       }
                //       if (fbv == 1) {
                //         game.setCurrentEvent();
                //         window.eventTrack('premium_spin_successfull');
                //         window.eventTrack('soga_purchase_successfull', 1, {
                //           package_id: 'premium_spin',
                //           value: '1.99 $',
                //           current_level: level_button.n,
                //           conversion: 1 - bought,
                //           first_purchase: bought_f,
                //           lifetime: lifetime_day,
                //           highest_lvl: all_level.lastIndexOf(3) + 2,
                //           mission_completed: missioncompleted,
                //           c_event: current_event,
                //         });
                //       }
                //       if (loading_black_sprite != 0) {
                //         loading_black_sprite.destroy();
                //         loading_black_sprite = 0;
                //       }
                //       if (loading_text != 0 && loading_text != 1) {
                //         loading_text.destroy();
                //         loading_text = 0;
                //       }
                //       loading_text = 1;
                //       popup = 1;
                //       wheel_ads = 2;
                //       wheel_cash += 1;
                //       wheel_spin(item);
                //       bought = 1;
                //       bought_f = 0;
                //       //game.setUserDataAndLog({ wheel_ads: wheel_ads, bought: bought });
                //       // FBInstant.payments
                //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                //       //   .then(function () {})
                //       //   .catch(function (error) {});
                //     })
                //     .catch(function (error) {
                //       if (fbv == 1) {
                //         game.setCurrentEvent();
                //         window.eventTrack('soga_purchase_failed', 1, {
                //           package_id: 'premium_spin',
                //           value: '1.99 $',
                //           current_level: level_button.n,
                //           conversion: 1 - bought,
                //           user_type: bought,
                //           lifetime: lifetime_day,
                //           mission_completed: missioncompleted,
                //           c_event: current_event,
                //         });
                //       }
                //       console.log(error);
                //       if (loading_black_sprite != 0) {
                //         loading_black_sprite.destroy();
                //         loading_black_sprite = 0;
                //       }
                //       if (loading_text != 0 && loading_text != 1) {
                //         loading_text.destroy();
                //         loading_text = 0;
                //       }
                //       popup = 1;
                //     });
              } else {
                if (fbv == 1) {
                  game.setCurrentEvent();
                  window.eventTrack('premium_spin_come_back_initiated');
                  window.eventTrack('soga_purchase_initiated', 1, {
                    package_id: 'premium_spin_come_back',
                    value: '0.99 $',
                    current_level: level_button.n,
                    conversion: 1 - bought,
                    user_type: bought,
                    lifetime: lifetime_day,
                    mission_completed: missioncompleted,
                    c_event: current_event,
                  });
                }
                if (animation == 100) {
                  if (bought == 0) {
                    bought_f = 1;
                  }
                  if (fbv == 1) {
                    game.setCurrentEvent();
                    window.eventTrack('premium_spin_come_back_successfull');
                    window.eventTrack('soga_purchase_successfull', 1, {
                      package_id: 'premium_spin_come_back',
                      value: '0.99 $',
                      current_level: level_button.n,
                      conversion: 1 - bought,
                      first_purchase: bought_f,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                  }
                  if (loading_black_sprite != 0) {
                    loading_black_sprite.destroy();
                    loading_black_sprite = 0;
                  }
                  if (loading_text != 0 && loading_text != 1) {
                    loading_text.destroy();
                    loading_text = 0;
                  }
                  loading_text = 1;
                  popup = 1;
                  wheel_ads = 2;
                  wheel_cash += 1;
                  wheel_spin(item);
                  bought = 1;
                  bought_f = 0;
                  //game.setUserDataAndLog({ wheel_ads: wheel_ads, bought: bought });
                }

                // else
                //   purchaseAsync(
                //     {
                //       productID: 'premium_spin_come_back',
                //       developerPayload: 'Premium spin',
                //     },
                //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                //   )
                //     .then(function (purchase) {
                //       if (bought == 0) {
                //         bought_f = 1;
                //       }
                //       if (fbv == 1) {
                //         game.setCurrentEvent();
                //         window.eventTrack('premium_spin_come_back_successfull');
                //         window.eventTrack('soga_purchase_successfull', 1, {
                //           package_id: 'premium_spin_come_back',
                //           value: '0.99 $',
                //           current_level: level_button.n,
                //           conversion: 1 - bought,
                //           first_purchase: bought_f,
                //           lifetime: lifetime_day,
                //           highest_lvl: all_level.lastIndexOf(3) + 2,
                //           mission_completed: missioncompleted,
                //           c_event: current_event,
                //         });
                //       }
                //       if (loading_black_sprite != 0) {
                //         loading_black_sprite.destroy();
                //         loading_black_sprite = 0;
                //       }
                //       if (loading_text != 0 && loading_text != 1) {
                //         loading_text.destroy();
                //         loading_text = 0;
                //       }
                //       loading_text = 1;
                //       popup = 1;
                //       wheel_ads = 2;
                //       wheel_cash += 1;
                //       wheel_spin(item);
                //       bought = 1;
                //       bought_f = 0;
                //       //game.setUserDataAndLog({ wheel_ads: wheel_ads, bought: bought });
                //       // FBInstant.payments
                //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                //       //   .then(function () {})
                //       //   .catch(function (error) {});
                //     })
                //     .catch(function (error) {
                //       if (fbv == 1) {
                //         game.setCurrentEvent();
                //         window.eventTrack('soga_purchase_failed', 1, {
                //           package_id: 'premium_spin_come_back',
                //           value: '0.99 $',
                //           current_level: level_button.n,
                //           conversion: 1 - bought,
                //           mission_completed: missioncompleted,
                //           c_event: current_event,
                //         });
                //       }
                //       console.log(error);
                //       if (loading_black_sprite != 0) {
                //         loading_black_sprite.destroy();
                //         loading_black_sprite = 0;
                //       }
                //       if (loading_text != 0 && loading_text != 1) {
                //         loading_text.destroy();
                //         loading_text = 0;
                //       }
                //       popup = 1;
                //     });
              }
            }
          }, this);
          popup_group.add(button_green1);
          button_green1.fixedToCamera = true;
          button_green1.input.useHandCursor = true;
          scale_tween(button_green1, 500, 0.1, 0.1);
          // FBInstant.payments.getCatalogAsync().then(function (catalog) {
          // payments_catalog = catalog;
          //       if (payments_catalog.length > 0) {
          //         if (wheel_sale == 0)
          //           var button_green1_text = game.add.text(
          //             0,
          //             2,
          //             payments_catalog[
          //               payments_catalog.findIndex(function (e) {
          //                 return e['productID'] == 'premium_spin';
          //               })
          //             ]['price'],
          //             { font: '48px RussoOne', fill: '#fff', align: 'center' },
          //           );
          //         else
          //           var button_green1_text = game.add.text(
          //             0,
          //             2,
          //             payments_catalog[
          //               payments_catalog.findIndex(function (e) {
          //                 return e['productID'] == 'premium_spin_come_back';
          //               })
          //             ]['price'],
          //             { font: '48px RussoOne', fill: '#fff', align: 'center' },
          //           );
          //         button_green1_text.lineSpacing = -10;
          //         button_green1_text.stroke = '#457310';
          //         button_green1_text.strokeThickness = 4;
          //         button_green1_text.setShadow(0, 3, 'rgba(69,115,16,0.7)', 1);
          //         button_green1_text.anchor.setTo(0.5);
          //         button_green1.addChild(button_green1_text);
          //       }
          // });
          /*var buttontimer = setInterval(function () {
            if (payments_catalog.length > 0) {
              clearInterval(buttontimer);
              if (wheel_sale == 0)
                var button_green1_text = game.add.text(
                  0,
                  2,
                  payments_catalog[
                    payments_catalog.findIndex(function (e) {
                      return e['productID'] == 'premium_spin';
                    })
                  ]['price'],
                  { font: '48px RussoOne', fill: '#fff', align: 'center' },
                );
              else
                var button_green1_text = game.add.text(
                  0,
                  2,
                  payments_catalog[
                    payments_catalog.findIndex(function (e) {
                      return e['productID'] == 'premium_spin_come_back';
                    })
                  ]['price'],
                  { font: '48px RussoOne', fill: '#fff', align: 'center' },
                );
              button_green1_text.lineSpacing = -10;
              button_green1_text.stroke = '#457310';
              button_green1_text.strokeThickness = 4;
              button_green1_text.setShadow(0, 3, 'rgba(69,115,16,0.7)', 1);
              button_green1_text.anchor.setTo(0.5);
              button_green1.addChild(button_green1_text);
            }
          }, 100);*/
        } else {
          var button_green1 = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 + 400 + 400,
            'game_window2_atlas',
            'Free_Spin_Claim_Button.png',
          );
          button_green1.anchor.setTo(0.5);
          button_green1.inputEnabled = true;
          button_green1.events.onInputUp.add(function (item) {
            if ((popup != 2 && wheel_num > 0) || FTUE == 38) {
              if (fbv == 1 && FTUE == 38) {
                window.eventTrack('FTUE_13_4Wheel_spin_clicked');
              }
              wheel_ads = 0;
              FTUE_process();
              wheel_free += 1;
              wheel_spin(item);
            }
          }, this);
          popup_group.add(button_green1);
          button_green1.fixedToCamera = true;
          button_green1.input.useHandCursor = true;
          scale_tween(button_green1, 500, 0.1, 0.1);
          var button_green1_text = game.add.text(0, 2, game.cache.getJSON('lang')['FreeSpin'][0][window.lang], {
            font: '48px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          button_green1_text.lineSpacing = -10;
          button_green1_text.stroke = '#457310';
          button_green1_text.strokeThickness = 4;
          button_green1_text.setShadow(0, 3, 'rgba(69,115,16,0.7)', 1);
          button_green1_text.anchor.setTo(0.5);
          button_green1.addChild(button_green1_text);
        }
        game.add.tween(button_green1.cameraOffset).to({ y: '-400' }, 800, Phaser.Easing.Exponential.Out, true, 1000);
        game.world.bringToTop(prize_wheel_icons);
        game.world.bringToTop(prize_wheel_arrow);
        game.add
          .tween(popup_group)
          .to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function (item) {
            FTUE_process();

            if (s) {
              button_green1.alpha = 0;
              wheel_spin(button_green1);
            }
          });
      }
    }
    function dog_sleep(obj, obj2) {
      if (obj.alpha == 1) {
        game.add.tween(effects_group).to({ alpha: 1 }, 60000, Phaser.Easing.Linear.None, true).onComplete.add(function () {
          obj.alpha = 0;
          obj2.alpha = 1;
          dog_sleep(obj, obj2);
        });
      }
      else {
        game.add.tween(effects_group).to({ alpha: 1 }, 60000, Phaser.Easing.Linear.None, true).onComplete.add(function () {
          obj.alpha = 1;
          obj2.alpha = 0;
          dog_sleep(obj, obj2);
        });
      }
    }
    function scale_tween(sprite, time, powerx, powery) {
      game.add
        .tween(sprite.scale)
        .to({ x: '+' + powerx, y: '+' + powery }, time, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          game.add
            .tween(sprite.scale)
            .to({ x: '-' + powerx, y: '-' + powery }, time, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              scale_tween(sprite, time, powerx, powery);
            });
        });
    }
    function scale_tween_wheel(sprite, time, powerx, powery) {
      game.add
        .tween(sprite.scale)
        .to({ x: '+' + powerx, y: '+' + powery }, time, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          game.add
            .tween(sprite.scale)
            .to({ x: '-' + powerx, y: '-' + powery }, time, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              if (wheel_num > 0) scale_tween_wheel(sprite, time, powerx, powery);
            });
        });
    }
    function new_life(item) {
      if (xmas == 1) {
        var minus_life = Number(game.cache.getJSON('buildings')['XmasSetting'][0]['tickets'].split(',')[xmas_level]);
        xmas_ticket -= minus_life;
        game.setUserDataAndLog({ xmas_ticket: String(xmas_ticket) });
        var get_lifes = game.add.sprite(
          xmas_ticket_text.world.x,
          xmas_ticket_text.world.y,
          'xmas_atlas',
          'Ticket.png',
        );
        get_lifes.w = get_lifes.width;
        get_lifes.anchor.setTo(0.5);
        get_lifes.scale.setTo(0);
        get_lifes.alpha = 0;
        effects_group.add(get_lifes);
        var get_lifes_text = game.add.text(-get_lifes.w, 0, '-' + minus_life, {
          font: '50px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        get_lifes_text.anchor.setTo(0.5);
        get_lifes_text.stroke = '#44730C';
        get_lifes_text.strokeThickness = 4;
        get_lifes_text.setShadow(0, 4, 'rgba(66,113,10,0.5)', 1);
        get_lifes.addChild(get_lifes_text);
        game.add.tween(get_lifes).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        game.add.tween(get_lifes.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
        var tween = game.add
          .tween(get_lifes)
          .to({ x: item.world.x, y: item.world.y }, 600, Phaser.Easing.Linear.None, true);
        tween.onComplete.add(function (item) {
          item.destroy();
          context_name = 0;
          play_level(0);
        });
        var star_emitter = game.add.emitter(item.world.x, item.world.y, 100);
        star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
        star_emitter.setAlpha(1, 0, 800);
        star_emitter.setScale(3, 0, 3, 0, 800);
        star_emitter.start(false, 1000, 10);
        star_emitter.bringToTop = true;
        game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          star_emitter.destroy();
        });
        tween.onUpdateCallback(function () {
          star_emitter.x = get_lifes.x;
          star_emitter.y = get_lifes.y;
        }, this);
      }
      else
        if (typeof item !== "undefined" && level_button.n > 6 && item.ad == 0) {
          if ((context_name != 0 && item.type == 1) || unlimited_lifesDate != 0) {
            //context_name = 0;
            play_level(0);
          } else {
            var minus_life = 1;
            if (Number(lifes) >= Number(minus_life)) {
              lifes = Number(lifes) - Number(minus_life);
              game.setUserDataAndLog({ lifes: String(lifes) });
              if (Number(lifes) < Number(max_lifes))
                if (LifeDate == 0) {
                  LifeDate =
                    ddd == 0
                      ? new Date()
                      : new Date(
                        ddd +
                        ' ' +
                        new Date().getHours() +
                        ':' +
                        new Date().getMinutes() +
                        ':' +
                        new Date().getSeconds(),
                      );
                  LifeDate.setMinutes(LifeDate.getMinutes() + time_life);
                  game.setUserDataAndLog({ life_time: String(LifeDate) });
                }
              var get_lifes = game.add.sprite(
                text_lifes.world.x,
                text_lifes.world.y,
                'game_ui_atlas',
                'Thunder_Icon.png',
              );
              get_lifes.w = get_lifes.width;
              get_lifes.anchor.setTo(0.5);
              get_lifes.scale.setTo(0);
              get_lifes.alpha = 0;
              effects_group.add(get_lifes);
              var get_lifes_text = game.add.text(-get_lifes.w, 0, '-' + minus_life, {
                font: '50px RussoOne',
                fill: '#fff',
                align: 'center',
              });
              get_lifes_text.anchor.setTo(0.5);
              get_lifes_text.stroke = '#44730C';
              get_lifes_text.strokeThickness = 4;
              get_lifes_text.setShadow(0, 4, 'rgba(66,113,10,0.5)', 1);
              get_lifes.addChild(get_lifes_text);
              game.add.tween(get_lifes).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
              game.add.tween(get_lifes.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
              var tween = game.add
                .tween(get_lifes)
                .to({ x: item.world.x, y: item.world.y }, 600, Phaser.Easing.Linear.None, true);
              tween.onComplete.add(function (item) {
                item.destroy();
                context_name = 0;
                play_level(0);
              });
              var star_emitter = game.add.emitter(item.world.x, item.world.y, 100);
              star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
              star_emitter.setAlpha(1, 0, 800);
              star_emitter.setScale(3, 0, 3, 0, 800);
              star_emitter.start(false, 1000, 10);
              star_emitter.bringToTop = true;
              game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                star_emitter.destroy();
              });
              tween.onUpdateCallback(function () {
                star_emitter.x = get_lifes.x;
                star_emitter.y = get_lifes.y;
              }, this);
            } else if (popup != 2) {
              popup = 2;
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                  missions_tab_open = 0;
                  get_message(1);
                });
            }
          }
        } else {
          //context_name = 0;
          play_level(0);
        }
    }

    function weekday_offers_timer() {
      if (weekday_offersDate != 0) {
        var NowDate = ddd == 0 ? new Date() : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
        var timeDiff = weekday_offersDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          if (starter_kit > 1) { starter_kit -= 1; }
          weekday_offersDate.setHours(weekday_offersDate.getHours() + 168);
          game.setUserDataAndLog({ weekday_offersDate: String(weekday_offersDate), starter_kit: starter_kit });
        } else {
          if (diffDay > 0) {
            diffHour += 24 * diffDay;
          }
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          var timer = diffHour + ':' + diffMin + ':' + diffSec;
          if (typeof weekdayofferstimer !== "undefined") {
            weekdayofferstimer.setText(timer);
          }
        }
      } else {
        if (starter_kit > 1) {
          weekday_offersDate = ddd == 0 ? new Date() : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
          weekday_offersDate.setHours(weekday_offersDate.getHours() + 168);
          game.setUserDataAndLog({ weekday_offersDate: String(weekday_offersDate) });
        }
      }
    }

    var stargate_timer_end = 0;
    if (KeyMissionDate == 0) {
      var date =
        ddd == 0
          ? new Date()
          : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
      var m =
        ddd == 0
          ? new Date()
          : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
      m.setDate(date.getDate() + 3 - date.getDay());
      m.setHours(12);
      m.setMinutes(0);
      m.setSeconds(0);
      KeyMissionDate = m;
      game.setUserDataAndLog({ key_mission_time: String(KeyMissionDate) });
    }
    function friends_timer() {
      for (var i = 0; i < helpers_time.length; i++) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = helpers_time[i].getTime() - NowDate.getTime();
        var diffHour = Math.floor(timeDiff / 1000 / 60 / 60);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          let iii = gift_mas.indexOf(helpers_id[i]);
          gift_mas.splice(iii, 1);
          helpers_time.splice(i, 1);
          helpers_id.splice(i, 1);
        } else {
          if (missions_tab_open == 1) {
            if (diffHour < 10) {
              diffHour = '0' + diffHour;
            }
            if (diffMin < 10) {
              diffMin = '0' + diffMin;
            }
            if (diffSec < 10) {
              diffSec = '0' + diffSec;
            }
            var timer = diffHour + ':' + diffMin + ':' + diffSec;
            backcard_group.children.forEach(function (child_item) {
              if (gift_mas.indexOf(helpers_id[i]) != -1)
                if (child_item.uid == helpers_id[i]) {
                  child_item.children.forEach(function (child_item2) {
                    if (child_item2.tp == 'timer') {
                      child_item2.setText(timer);
                    }
                  });
                }
            });
          }
        }
      }
    }
    function misDate_timer() {
      if (misDate != 0) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = misDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          coin_missions_completed = 0;
          coin_missions_shown = 6;
          mission_skip_success = 0;
          mission_skip_fail = 0;

          window.eventTrack('Coin_Mission_failed', 1, {
            required_coins: mis_coins,
            coin_missions_completed: coin_missions_completed,
            coin_missions_shown: coin_missions_shown,
            completion_rate: Math.round(Number(keys) / (Number(mis_coins) / 100)),
            mission_skip_success: mission_skip_success,
            mission_skip_fail: mission_skip_fail,
          });

          misDate = 0;
          keys = 0;
          mis_n = -1;
          game.setUserDataAndLog({ mis_n: mis_n, keys: keys, misDate: String(misDate), coin_missions_completed: coin_missions_completed, coin_missions_shown: coin_missions_shown, mission_skip_success: mission_skip_success, mission_skip_fail: mission_skip_fail });
          mission_create(0);
        } else {
          if (diffDay > 0) {
            diffHour += 24;
          }
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          var timer = diffHour + ':' + diffMin + ':' + diffSec;
          if (misDate_timer_text != 0 && typeof misDate_timer_text !== "undefined") {
            misDate_timer_text.setText(timer);
          }
        }
      }
    }
    function playadDate_timer() {
      if (playadDate != 0) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = playadDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          playadDate = 0;
          playad_col = 0;
          game.setUserDataAndLog({
            playad_col: playad_col,
            playadDate: String(playadDate),
          });
        }
      }
    }
    function balloon_timer() {
      if (baloonDate != 0) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = baloonDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          baloonDate = 0;
          baloonDate_new =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          baloonDate_new.setHours(baloonDate_new.getHours() + 168);
          if (Balloon_Map_Icon != 0) {
            Balloon_Map_Icon.destroy();
            balloon_timer_text = 0;
            Balloon_Map_Icon = 0;
          }
          game.setUserDataAndLog({ baloonDate: String(baloonDate), baloonDate_new: String(baloonDate_new) });
        } else {
          if (diffDay > 0) {
            diffHour += 24;
          }
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          if (balloon_timer_text != 0) {
            balloon_timer_text.setText(diffHour + ':' + diffMin + ':' + diffSec);
          }
          if (balloon_timer_2 != 0) {
            balloon_timer_2.setText(diffHour + ':' + diffMin + ':' + diffSec);
          }
        }
      } else if (baloonDate_new != 0) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = baloonDate_new.getTime() - NowDate.getTime();
        if (timeDiff <= 0) {
          baloonDate = 0;
          baloonDate_new = 0;
          game.setUserDataAndLog({
            baloonDate: String(baloonDate),
            baloonDate_new: String(baloonDate_new),
          });
        }
      }
    }
    function sunflowertimer() {
      if (sunflowerDate != 0) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = sunflowerDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          sunflowerStage = 1;
          sunflowerDate = 0;
          sunflowerDate_new =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          sunflowerDate_new.setHours(sunflowerDate_new.getHours() + 120);
          if (Bean_Icon != 0) {
            Bean_Icon.destroy();
            sunflower_timer = 0;
            sunflower_timer_2 = 0;
            sunflower_timer = 0;
            Bean_Icon = 0;
            level_button.children[1].destroy();
          }
          game.setUserDataAndLog({
            sunflowerDate: String(sunflowerDate),
            sunflowerDate_new: String(sunflowerDate_new),
          });
        } else {
          if (diffDay > 0) {
            diffHour += 24;
          }
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          if (sunflower_timer != 0) {
            sunflower_timer.setText(diffHour + ':' + diffMin + ':' + diffSec);
          }
          if (sunflower_timer_2 != 0) {
            sunflower_timer_2.setText(diffHour + ':' + diffMin + ':' + diffSec);
          }
        }
      } else if (sunflowerDate_new != 0) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = sunflowerDate_new.getTime() - NowDate.getTime();
        if (timeDiff <= 0) {
          sunflowerDate = 0;
          sunflowerDate_new = 0;
          game.setUserDataAndLog({
            sunflowerDate: String(sunflowerDate),
            sunflowerDate_new: String(sunflowerDate_new),
          });
        }
      }
    }
    function xmastimer() {
      if (xmasDate != 0 && xmasDate != -1) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = xmasDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          xmasDate = -1;
          if (xmas_Icon != 0) { if (typeof xmas_Icon !== "undefined") xmas_Icon.destroy(); }
          game.setUserDataAndLog({ xmasDate: String(xmasDate) });
        } else {
          if (diffDay > 0) {
            diffHour += 24 * diffDay;
          }
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          if (xmas_timer != 0) {
            xmas_timer.setText(diffHour + ':' + diffMin + ':' + diffSec);
          }
          /*if (magicbean_timer_2 != 0) {
            magicbean_timer_2.setText(diffHour + ':' + diffMin + ':' + diffSec);
          }*/
        }
      }
    }
    function magicbeantimer() {
      if (magicbeanDate != 0) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = magicbeanDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          if (unlimited_lifesDate != 0) {
            unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() - unlimited_lifesDate_old);
            game.setUserDataAndLog({
              unlimited_lifesDate: String(unlimited_lifesDate),
            });
          }
          magicbeanStage = 0;
          magicbeanDate = 0;
          magicbeanDate_new =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          magicbeanDate_new.setHours(magicbeanDate_new.getHours() + 144);
          if (MagicBean_Icon != 0) {
            MagicBean_Icon.destroy();
            sunflower_timer = 0;
            magicbean_timer_2 = 0;
            magicbean_timer = 0;
            MagicBean_Icon = 0;
            level_button.children[1].destroy();
          }
          game.setUserDataAndLog({
            magicbeanDate: String(magicbeanDate),
            magicbeanDate_new: String(magicbeanDate_new),
            magicbeanStage: magicbeanStage,
          });
        } else {
          if (diffDay > 0) {
            diffHour += 24;
          }
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          if (magicbean_timer != 0) {
            magicbean_timer.setText(diffHour + ':' + diffMin + ':' + diffSec);
          }
          if (magicbean_timer_2 != 0) {
            magicbean_timer_2.setText(diffHour + ':' + diffMin + ':' + diffSec);
          }
        }
      }
      else if (magicbeanDate_new != 0) {
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = magicbeanDate_new.getTime() - NowDate.getTime();
        if (timeDiff <= 0) {
          magicbeanDate = 0;
          magicbeanDate_new = 0;
          game.setUserDataAndLog({
            magicbeanDate: String(magicbeanDate),
            magicbeanDate_new: String(magicbeanDate_new),
          });
        }
      }
    }
    if (offer_mas[0] > 0 && OfferDate == 0) {
      if (offer_mas.length > 1) {
        for (var i = 1; i < offer_mas.length; i++) {
          if (offer_mas[i] > 0) offer_mas[i] *= -1;
        }
      }
      OfferDate =
        ddd == 0
          ? new Date()
          : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
      OfferDate.setMinutes(OfferDate.getMinutes() + game.rnd.integerInRange(15, 20));
      game.setUserDataAndLog({ OfferDate: String(OfferDate) });
    }
    if (OfferDate != 0) {
      var NowDate =
        ddd == 0
          ? new Date()
          : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
      var timeDiff = OfferDate.getTime() - NowDate.getTime();
      var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
      var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
      var diffSec = Math.floor((timeDiff / 1000) % 60);
      if (timeDiff <= 0) {
        OfferDate = 0;
        offer_mas.splice(0, 1);
        game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas), OfferDate: String(OfferDate) });
        if (offer_icon != 0) {
          if (offer_icon.inputEnabled == true) {
            offer_icon.inputEnabled = false;
            game.add
              .tween(offer_icon)
              .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
                offer_icon_timer = 0;
                item.destroy();
              });
          }
        }
      }
    }
    function offer_timer() {
      if (OfferDate != 0) {
        var timer = '';
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = OfferDate.getTime() - NowDate.getTime();
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          OfferDate = 0;
          offer_mas.splice(0, 1);
          game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas), OfferDate: String(OfferDate) });
          if (offer_icon != 0) {
            if (offer_icon.inputEnabled == true) {
              offer_icon.inputEnabled = false;
              game.add
                .tween(offer_icon)
                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
                  offer_icon_timer = 0;
                  item.destroy();
                });
            }
          }
        } else {
          if (offer_icon == 0) {
            offer_button();
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          timer = diffMin + ':' + diffSec;
          if (offer_icon != 0 && offer_icon_timer != 0) {
            offer_icon_timer.setText(timer);
          }
          if (special_timer != 0) {
            special_timer.setText(timer);
          }
        }
      }
    }
    function keymission_timer() {
      if (KeyMissionDate != 0) {
        var timer = '';
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = KeyMissionDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          keys = 0;
          var date =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          var m =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          m.setDate(date.getDate() + 11 - date.getDay());
          m.setHours(12);
          m.setMinutes(0);
          m.setSeconds(0);
          KeyMissionDate = m;
          game.setUserDataAndLog({ keys: String(keys), key_mission_time: String(KeyMissionDate) });
        } else {
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          timer = diffDay + ':' + diffHour + ':' + diffMin + ':' + diffSec;
          if (key_mission_timer_text != 0) {
            key_mission_timer_text.setText(timer);
          }
        }
      }
    }
    function shop_timer() {
      if (ShopDate != 0) {
        var timer = '';
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = ShopDate.getTime() - NowDate.getTime();
        if (timeDiff <= 0) {
          ShopDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          ShopDate.setHours(ShopDate.getHours() + shoptimer);
          shop_free = 1;
          game.setUserDataAndLog({ shop_free: shop_free, shop_time: String(ShopDate) });
        }
      }
    }
    function friend_prize_timer() {
      if (FriendPrizeDate != 0) {
        var timer = '';
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = FriendPrizeDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          FriendPrizeDate = 0;
          game.setUserDataAndLog({ FriendPrizeDate: String(FriendPrizeDate) });
          if (missions_tab_open == 1)
            if (friends_create_timer != 0) {
              friends_create_timer.setText('0/12');
            }
        } else {
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          timer = diffHour + ':' + diffMin + ':' + diffSec;
          if (missions_tab_open == 1)
            if (friends_create_timer != 0) {
              friends_create_timer.setText(timer);
            }
        }
      }
    }
    function rewarded_referral_timer() {
      if (ReferralDate != 0) {
        var timer = '';
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = ReferralDate.getTime() - NowDate.getTime();
        var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          if (fff < 3) {
            fff = 5;
          } else if (fff == 5) {
            fff = 3;
          } else {
            fff = 4;
          }
          ReferralDate = 0;
          game.setUserDataAndLog({ fff: fff, ReferralDate: String(ReferralDate) });
          if (friends_icon_timer != 0) {
            friends_icon_timer.setText('');
          }
        } else {
          if (fff == 3) {
            if (diffHour < 10) {
              diffHour = '0' + diffHour;
            }
            if (diffMin < 10) {
              diffMin = '0' + diffMin;
            }
            if (diffSec < 10) {
              diffSec = '0' + diffSec;
            }
            timer = diffHour + ':' + diffMin + ':' + diffSec;
            if (friends_icon_timer != 0) {
              friends_icon_timer.setText(timer);
            }
          }
        }
      }
    }
    function wheelads_timer() {
      if (wheeladsDate != 0 && FTUE > 40) {
        var timer = '';
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = wheeladsDate.getTime() - NowDate.getTime();
        var diffHour = Math.floor(timeDiff / 1000 / 60 / 60);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          wheel_ads = 0;
          game.setUserDataAndLog({ wheel_ads: wheel_ads });
          wheel_icon_text2.setText('');
          wheeladsDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          wheeladsDate.setHours(wheeladsDate.getHours() + 12);
          game.setUserDataAndLog({ wheeladsDate: wheeladsDate });
        }
      }
    }
    function wheelshop_timer() {
      if (wheelshopDate != 0 && FTUE > 40) {
        var timer = '';
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = wheelshopDate.getTime() - NowDate.getTime();
        var diffHour = Math.floor(timeDiff / 1000 / 60 / 60);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          if (wheel_icon_text2 != 0) {
            if (Wheel_Sale_Ribbon != 0) {
              Wheel_Sale_Ribbon.alpha = 0;
              Timer_BG.alpha = 0;
            }
            wheel_icon_text2.setText('');
          }
          wheelshopDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          wheelshopDate.setHours(wheelshopDate.getHours() + 72);
          game.setUserDataAndLog({ wheelshopDate: wheelshopDate });
        } else if (diffHour == 0 && diffMin <= 15) {
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          timer = diffMin + ':' + diffSec;
          if (wheel_num == 0 && wheel_icon_text2 != 0) {
            if (Wheel_Sale_Ribbon != 0) {
              Wheel_Sale_Ribbon.alpha = 1;
              Timer_BG.alpha = 1;
            }
            wheel_icon_text2.setText(timer);
          }
        }
      }
    }
    function wheel_timer() {
      if (WheelDate != 0 && FTUE > 40) {
        var timer = '';
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = WheelDate.getTime() - NowDate.getTime();
        var diffHour = Math.floor(timeDiff / 1000 / 60 / 60);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          if (wheel_icon_text2 != 0) {
            wheel_icon_text2.setText('');
          }
          wheel_num += 1;
          wheel_max = 3;
          wheeladsDate = 0;
          wheelshopDate = 0;
          wheel_ads = 0;
          game.setUserDataAndLog({
            wheel_num: wheel_num,
            wheel_max: wheel_max,
            wheeladsDate: String(wheeladsDate),
            wheel_ads: wheel_ads,
            wheelshopDate: String(wheelshopDate),
          });
          if (friends_icon != 0) {
            friends_icon.cameraOffset.y = 550;
          }
          if (wheel_num == 1) {
            wheel_icon.alpha = 1;
            wheel_icon.children.forEach(function (child_item) {
              child_item.inputEnabled = true;
            });
            if (wheel_num > 0) {
              wheel_icon_shine.alpha = 1;
            }
            if (wheel_ad_icon != 0) {
              wheel_ad_icon.destroy();
              wheel_ad_icon = 0;
            }
            wheel_icon_label = game.add.sprite(37, -37, 'game_atlas', 'wheel_icon_label.png');
            wheel_icon_label.anchor.setTo(0.5);
            wheel_icon.addChild(wheel_icon_label);
            wheel_num_text = game.add.text(0, 2, wheel_num, { font: '28px RussoOne', fill: '#fff', align: 'center' });
            wheel_num_text.anchor.setTo(0.5);
            wheel_icon_label.addChild(wheel_num_text);
            if (wheel_icon_text != 0) {
              wheel_icon_text.setText(game.cache.getJSON('lang')['FreeSpin2'][0][window.lang]);
              scale_tween_wheel(wheel_icon_text, 500, 0.2, 0.2);
              scale_tween_wheel(wheel_icon, 500, 0.04, 0.04);
            }
          }
          WheelDate = 0;
          game.setUserDataAndLog({ wheel_time: WheelDate });
        } else {
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          timer = diffHour + ':' + diffMin + ':' + diffSec;
          if (wheel_num == 0 && wheel_icon_text != 0) {
            wheel_icon_text.setText(timer);
          }
        }
      }
    }
    function life_timer() {
      if (unlimited_lifesDate == 0) {
        if (LifeDate != 0 && FTUE > 3) {
          var timer = '';
          var NowDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          var timeDiff = LifeDate.getTime() - NowDate.getTime();
          var diffMin = Math.floor(timeDiff / 1000 / 60);
          var diffSec = Math.floor((timeDiff / 1000) % 60);
          if (timeDiff <= 0) {
            if (timeDiff == 0) {
              lifes = Number(lifes) + 1;
            }
            else {
              lifes = Number(lifes) + Math.ceil(Math.ceil((timeDiff * -1) / 1000 / 60) / time_life);
            }
            if (Number(lifes) > Number(max_lifes)) {
              lifes = Number(max_lifes);
            }
            if (text_lifes != 0 && typeof text_lifes !== 'undefined') text_lifes.setText(lifes);
            if (Number(lifes) < Number(max_lifes)) {
              LifeDate =
                ddd == 0
                  ? new Date()
                  : new Date(
                    ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                  );
              var last_min = diffMin * -1 - Math.ceil(Math.ceil((timeDiff * -1) / 1000 / 60) / time_life) * time_life;
              last_min *= -1;
              if (last_min < 0) {
                last_min = 0;
              } else {
                last_min += 1;
              }
              LifeDate.setMinutes(LifeDate.getMinutes() + last_min);
              LifeDate.setSeconds(LifeDate.getSeconds() + diffSec * -1);
              game.setUserDataAndLog({ lifes: String(lifes), life_time: String(LifeDate) });
            } else {
              LifeDate = 0;
              game.setUserDataAndLog({ lifes: String(lifes), life_time: String(LifeDate) });
              lifetextChange();
              if (lifes_panel_plus != 0) {
                lifes_panel_plus.destroy();
                lifes_panel_plus = 0;
              }
            }
          } else {
            if (diffMin < 10) {
              diffMin = '0' + diffMin;
            }
            if (diffSec < 10) {
              diffSec = '0' + diffSec;
            }
            timer = diffMin + ':' + diffSec;
            lifetextChange(timer);
          }
        } else if (Number(lifes) < Number(max_lifes) && LifeDate == 0) {
          LifeDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          LifeDate.setMinutes(LifeDate.getMinutes() + time_life);
          game.setUserDataAndLog({ life_time: String(LifeDate) });
        }
      } else {
        var timer = '';
        var NowDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        var timeDiff = unlimited_lifesDate.getTime() - NowDate.getTime();
        var diffHour = Math.floor(timeDiff / 1000 / 60 / 60);
        var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
        var diffSec = Math.floor((timeDiff / 1000) % 60);
        if (timeDiff <= 0) {
          unlimited_lifesDate = 0;
          if (text_lifes != 0 && typeof text_lifes !== 'undefined') text_lifes.setText(lifes);
          LifeDate = 0;
          game.setUserDataAndLog({
            lifes: String(lifes),
            life_time: String(LifeDate),
            unlimited_lifesDate: String(unlimited_lifesDate),
          });
          lifetextChange();
          if (lifes_panel_plus != 0) {
            lifes_panel_plus.destroy();
            lifes_panel_plus = 0;
          }
        } else {
          if (diffHour < 10) {
            diffHour = '0' + diffHour;
          }
          if (diffMin < 10) {
            diffMin = '0' + diffMin;
          }
          if (diffSec < 10) {
            diffSec = '0' + diffSec;
          }
          timer = diffHour + ':' + diffMin + ':' + diffSec;
          lifetextChange(timer);
        }
      }
    }
    loading_black_sprite = 0;
    function loading() {
      loading_black_sprite = game.add.sprite(0, 0, '');
      loading_black_sprite.fixedToCamera = true;
      var loading_black_sprite2 = game.add.sprite(0, 0, 'message_invite_mask');
      loading_black_sprite2.alpha = 0;
      loading_black_sprite2.width = game.camera.width;
      loading_black_sprite2.height = game.camera.height;
      game.add.tween(loading_black_sprite2).to({ alpha: 0.8 }, 500, Phaser.Easing.Linear.None, true);
      loading_black_sprite.addChild(loading_black_sprite2);
      var loadingCard = game.add.sprite(
        game.camera.width / 2,
        game.camera.height / 2 - 100,
        'game_atlas',
        'cards_diamond12.png',
      );
      loadingCard.anchor.setTo(0, 1);
      loadingCard.scale.setTo(1);
      loadingCard.x -= loadingCard.width / 2;
      loading_black_sprite.addChild(loadingCard);
      game.add.tween(loadingCard).to({ angle: '-30' }, 500, Phaser.Easing.Cubic.In, true, 0, -1).yoyo(true, 500);
      var loadingCard = game.add.sprite(
        game.camera.width / 2,
        game.camera.height / 2 - 100,
        'game_atlas',
        'cards_cross13.png',
      );
      loadingCard.anchor.setTo(0, 1);
      loadingCard.scale.setTo(1);
      loadingCard.x -= loadingCard.width / 2;
      loading_black_sprite.addChild(loadingCard);
      game.add.tween(loadingCard).to({ angle: '-10' }, 500, Phaser.Easing.Cubic.In, true, 0, -1).yoyo(true, 500);
      var loadingCard = game.add.sprite(
        game.camera.width / 2,
        game.camera.height / 2 - 100,
        'game_atlas',
        'cards_heart1.png',
      );
      loadingCard.anchor.setTo(0, 1);
      loadingCard.scale.setTo(1);
      loadingCard.x -= loadingCard.width / 2;
      loading_black_sprite.addChild(loadingCard);
      game.add.tween(loadingCard).to({ angle: '+10' }, 500, Phaser.Easing.Cubic.In, true, 0, -1).yoyo(true, 500);
      loading_text = game.add.text(
        game.camera.width / 2,
        game.camera.height / 2,
        game.cache.getJSON('lang')['Loading'][0][window.lang],
        { font: '80px RussoOne', fill: '#fff', align: 'center' },
      );
      loading_text.anchor.setTo(0.5);
      loading_text.stroke = '#a5823d';
      loading_text.strokeThickness = 8;
      loading_text.fixedToCamera = true;
      var textl = 0;
      game.add
        .tween(loading_text)
        .to({ alpha: 1 }, 500, Phaser.Easing.Cubic.In, true, 0, -1)
        .onLoop.add(function (item) {
          if (textl < 3) {
            item.setText(item.text + '.');
            textl++;
          } else {
            item.setText(game.cache.getJSON('lang')['Loading'][0][window.lang]);
            textl = 0;
          }
        });
      game.world.bringToTop(loading_black_sprite);
      game.world.bringToTop(loading_text);
    }
    function new_friends(f_array, array, bonus) {
      if (isNaN(friend_invite) || typeof friend_invite === 'undefined') {
        friend_invite = 0;
      }
      popup_group.y = 0;
      popup = 1;
      blackf();
      friend_invite += f_array.length;
      game.setUserDataAndLog({ friend_invite: friend_invite });
      var new_friends_title = game.add.text(
        game.camera.width / 2,
        game.camera.height / 2 - 360,
        game.cache.getJSON('lang')['t406'][0][window.lang],
        { font: '64px RussoOne', fill: '#fff', align: 'center' },
      );
      new_friends_title.anchor.setTo(0.5);
      new_friends_title.stroke = '#1A6383';
      new_friends_title.strokeThickness = 4;
      new_friends_title.setShadow(0, 4, 'rgba(26,99,131,1)', 1);
      popup_group.add(new_friends_title);
      new_friends_title.fixedToCamera = true;
      let txt = game.cache.getJSON('lang')['t350'][0][window.lang];
      for (var i = 0; i < f_array.length; i++) {
        txt += f_array[i];
        if (i != f_array.length - 1) {
          txt += ', ';
        }
      }
      txt += game.cache.getJSON('lang')['t351'][0][window.lang];
      var new_friends_text = game.add.text(game.camera.width / 2, game.camera.height / 2 - 260, txt, {
        font: '42px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      new_friends_text.anchor.setTo(0.5);
      new_friends_text.stroke = '#000';
      new_friends_text.strokeThickness = 4;
      popup_group.add(new_friends_text);
      new_friends_text.fixedToCamera = true;
      var Background_Rays = game.add.sprite(
        game.camera.width / 2,
        game.camera.height / 2 - 50,
        'game_ui_atlas',
        'Shine.png',
      );
      Background_Rays.anchor.setTo(0.5);
      Background_Rays.scale.setTo(0.7);
      Background_Rays.alpha = 0.5;
      popup_group.add(Background_Rays);
      Background_Rays.fixedToCamera = true;
      var Card_Bottom_Left = game.add.sprite(
        game.camera.width / 2 - 240 + 200 - (f_array.length * 270) / 2 + 135,
        game.camera.height / 2 - 50 + 190 - 80,
        'game_window2_atlas',
        'Card_Bottom_Left.png',
      );
      Card_Bottom_Left.anchor.setTo(0.5, 1);
      Card_Bottom_Left.alpha = 0;
      popup_group.add(Card_Bottom_Left);
      Card_Bottom_Left.fixedToCamera = true;
      var Card_Middle_Left = game.add.sprite(
        game.camera.width / 2 + 20 - 240 + 200 - (f_array.length * 270) / 2 + 135,
        game.camera.height / 2 - 70 + 190 - 30,
        'game_window2_atlas',
        'Card_Middle_Left.png',
      );
      Card_Middle_Left.anchor.setTo(0.5, 1);
      Card_Middle_Left.alpha = 0;
      popup_group.add(Card_Middle_Left);
      Card_Middle_Left.fixedToCamera = true;
      var Card_Top_Left = game.add.sprite(
        game.camera.width / 2 + 60 - 240 + 200 - (f_array.length * 270) / 2 + 135,
        game.camera.height / 2 - 100 + 190,
        'game_window2_atlas',
        'Card_Top_Left.png',
      );
      Card_Top_Left.anchor.setTo(0.5, 1);
      Card_Top_Left.alpha = 0;
      popup_group.add(Card_Top_Left);
      Card_Top_Left.fixedToCamera = true;
      game.add.tween(Card_Bottom_Left).to({ alpha: 1 }, 500, Phaser.Easing.Quadratic.Out, true, 400);
      game.add.tween(Card_Middle_Left).to({ alpha: 1 }, 500, Phaser.Easing.Quadratic.Out, true, 200);
      game.add.tween(Card_Top_Left).to({ alpha: 1 }, 500, Phaser.Easing.Quadratic.Out, true);
      game.add
        .tween(Card_Bottom_Left.cameraOffset)
        .to({ x: '-200', y: '+80' }, 500, Phaser.Easing.Quadratic.Out, true, 400);
      game.add
        .tween(Card_Middle_Left.cameraOffset)
        .to({ x: '-200', y: '+30' }, 500, Phaser.Easing.Quadratic.Out, true, 200);
      game.add.tween(Card_Top_Left.cameraOffset).to({ x: '-200' }, 500, Phaser.Easing.Quadratic.Out, true);
      var Card_Bottom_Left = game.add.sprite(
        game.camera.width / 2 + 240 - 200 + (f_array.length * 270) / 2 - 135,
        game.camera.height / 2 - 50 + 190 - 80,
        'game_window2_atlas',
        'Card_Bottom_Left.png',
      );
      Card_Bottom_Left.anchor.setTo(0.5, 1);
      Card_Bottom_Left.scale.setTo(-1, 1);
      Card_Bottom_Left.alpha = 0;
      popup_group.add(Card_Bottom_Left);
      Card_Bottom_Left.fixedToCamera = true;
      var Card_Middle_Left = game.add.sprite(
        game.camera.width / 2 - 20 + 240 - 200 + (f_array.length * 270) / 2 - 135,
        game.camera.height / 2 - 70 + 190 - 30,
        'game_window2_atlas',
        'Card_Middle_Left.png',
      );
      Card_Middle_Left.anchor.setTo(0.5, 1);
      Card_Middle_Left.scale.setTo(-1, 1);
      Card_Middle_Left.alpha = 0;
      popup_group.add(Card_Middle_Left);
      Card_Middle_Left.fixedToCamera = true;
      var Card_Top_Left = game.add.sprite(
        game.camera.width / 2 - 60 + 240 - 200 + (f_array.length * 270) / 2 - 135,
        game.camera.height / 2 - 100 + 190,
        'game_window2_atlas',
        'Card_Top_Left.png',
      );
      Card_Top_Left.anchor.setTo(0.5, 1);
      Card_Top_Left.scale.setTo(-1, 1);
      Card_Top_Left.alpha = 0;
      popup_group.add(Card_Top_Left);
      Card_Top_Left.fixedToCamera = true;
      game.add.tween(Card_Bottom_Left).to({ alpha: 1 }, 500, Phaser.Easing.Quadratic.Out, true, 400);
      game.add.tween(Card_Middle_Left).to({ alpha: 1 }, 500, Phaser.Easing.Quadratic.Out, true, 200);
      game.add.tween(Card_Top_Left).to({ alpha: 1 }, 500, Phaser.Easing.Quadratic.Out, true);
      game.add
        .tween(Card_Bottom_Left.cameraOffset)
        .to({ x: '+200', y: '+80' }, 500, Phaser.Easing.Quadratic.Out, true, 400);
      game.add
        .tween(Card_Middle_Left.cameraOffset)
        .to({ x: '+200', y: '+30' }, 500, Phaser.Easing.Quadratic.Out, true, 200);
      game.add.tween(Card_Top_Left.cameraOffset).to({ x: '+200' }, 500, Phaser.Easing.Quadratic.Out, true);
      for (var i = 0; i < f_array.length; i++) {
        var Podium = game.add.sprite(
          game.camera.width / 2 + 270 * i - (f_array.length * 270) / 2 + 135,
          game.camera.height / 2 + 130,
          'game_window2_atlas',
          'Podium.png',
        );
        Podium.anchor.setTo(0.5);
        popup_group.add(Podium);
        Podium.fixedToCamera = true;
        var avatar = game.add.image(
          game.camera.width / 2 + 270 * i - (f_array.length * 270) / 2 + 135,
          game.camera.height / 2 - 50,
          'game_atlas',
          'no_avatar.png',
        );
        avatar.width = avatar.height = 230;
        avatar.anchor.setTo(0.5);
        popup_group.addChild(avatar);
        avatar.fixedToCamera = true;
        var Frame = game.add.sprite(
          game.camera.width / 2 + 270 * i - (f_array.length * 270) / 2 + 135,
          game.camera.height / 2 - 50,
          'game_window2_atlas',
          'Frame.png',
        );
        Frame.anchor.setTo(0.5);
        popup_group.add(Frame);
        Frame.fixedToCamera = true;
      }
      var new_friends_text = game.add.text(
        game.camera.width / 2,
        game.camera.height / 2 + 260,
        game.cache.getJSON('lang')['t266'][0][window.lang],
        { font: '32px RussoOne', fill: '#fff', align: 'center' },
      );
      new_friends_text.anchor.setTo(0.5);
      new_friends_text.stroke = '#000';
      new_friends_text.strokeThickness = 4;
      popup_group.add(new_friends_text);
      new_friends_text.fixedToCamera = true;
      var button_continue = game.add.sprite(
        game.camera.width / 2,
        game.camera.height / 2 + 380,
        'game_window2_atlas',
        'Share_Button.png',
      );
      button_continue.anchor.setTo(0.5);
      button_animation_f(button_continue, 1);
      button_continue.events.onInputDown.add(function (item) {
        btnup(item);
        if (popup != 2) {
          popup = 2;
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item) {
              item.destroy();
            });
          game.add
            .tween(popup_group)
            .to({ y: '+' + game.camera.height }, 550, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function (item) {
              popup_group.removeAll(true);
              popup = 0;
              popup_group.y -= game.camera.height;
              let all_frn = 0;
              var num_n = [];
              for (var i = 0; i < 10; i++) {
                if (all_chests.indexOf(0) <= i) {
                  all_frn = Number(
                    game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['friends'],
                  );
                  if (friend_invite >= all_frn) {
                    all_chests[all_chests.indexOf(0)] = 1;
                    game.setUserDataAndLog({ all_chests: JSON.stringify(all_chests) });
                    num_n = [];
                    if (
                      Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p1']) > 0
                    ) {
                      num_n.push(1);
                    }
                    if (
                      Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p2']) > 0
                    ) {
                      num_n.push(2);
                    }
                    if (
                      Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p3']) > 0
                    ) {
                      num_n.push(3);
                    }
                    if (
                      Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p4']) > 0
                    ) {
                      num_n.push(4);
                    }
                    if (
                      Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p5']) > 0
                    ) {
                      num_n.push(5);
                    }
                    for (var j = 1; j <= 5; j++) {
                      if (bonus == 1)
                        array[j - 1] =
                          Number(array[j - 1]) +
                          Number(
                            game.cache.getJSON('buildings')['FriendsReward'][0][
                            'Reward' + Number(all_chests.lastIndexOf(1) + 1)
                            ][0]['p' + j],
                          ) *
                          3;
                      else
                        array[j - 1] =
                          Number(array[j - 1]) +
                          Number(
                            game.cache.getJSON('buildings')['FriendsReward'][0][
                            'Reward' + Number(all_chests.lastIndexOf(1) + 1)
                            ][0]['p' + j],
                          );
                    }
                  } else {
                    break;
                  }
                  friend_invite -= Number(
                    game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['friends'],
                  );
                }
              }
              game.setUserDataAndLog({ friend_invite: friend_invite });
              if (num_n.length != 0) {
                if (FTUE > 30)
                  for (var i = 0; i < missions.length; i += 4) {
                    if (missions[i] == -22) {
                      if (missions[i + 2] < missions[i + 1]) {
                        missions[i + 2] += 1;
                      }
                    }
                  }
                chest_open_window(game.cache.getJSON('lang')['Reward!'][0][window.lang], array, 50, void 0, {
                  //gameArea: DdnaGameArea.Map,
                  //actionType: DdnaTransactionActionType.Social,
                  //socialActionType: DdnaSocialActionType.RewardedReferral,
                  socialActionType: null,
                  gameArea: null,
                  actionType: null,
                  socialSend: false,
                });
                source_chest = 'New friend';
                package_id_chest = 0;
              }
            });
        }
      }, this);
      popup_group.add(button_continue);
      button_continue.fixedToCamera = true;
      var button_continue_text = game.add.text(0, 0, game.cache.getJSON('lang')['Continue'][0][window.lang], {
        font: '50px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      button_continue_text.anchor.setTo(0.5);
      button_continue_text.stroke = '#44730C';
      button_continue_text.strokeThickness = 4;
      button_continue_text.setShadow(0, 4, 'rgba(66,113,10,0.5)', 1);
      button_continue.addChild(button_continue_text);
    }
    function friends_window() {
      if ((popup == 0 && animation == 0 && missions_tab_open == 0) || FTUE == 152) {
        animation = 1;
        missions_tab_open = 66;
        popup_group.y = 0;
        popup = 1;
        if (FTUE != 152) {
          blackf();
        } else {
          if (fbv == 1) {
            window.eventTrack('FTUE_17_2Friends_invite_is_opened');
          }
          FTUE += 1;
          FTUE_check = 3;
          game.setUserDataAndLog({ FTUE: FTUE });
        }
        f_w_a();
        var popup_close = game.add.sprite(game.camera.width + 100, 100, 'game_window_atlas', 'Close_Button.png');
        popup_close.anchor.setTo(0.5);
        button_animation_f(popup_close, 1);
        popup_close.events.onInputUp.add(function () {
          if (popup != 2) {
            if (fbv == 1 && FTUE_check == 3) {
              window.eventTrack('FTUE_17_4User_closed_friend_invite');
              FTUE_check = 0;
            }
            popup = 2;
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup = 0;
                missions_tab_open = 0;
                popup_group.y -= game.camera.height;
              });
          }
        }, this);
        popup_group.add(popup_close);
        popup_close.fixedToCamera = true;
        game.add.tween(popup_close.cameraOffset).to({ x: '-200' }, 500, Phaser.Easing.Exponential.Out, true);
        var text_popup_title = game.add.text(
          game.camera.width / 2,
          game.camera.height / 2 - 360,
          game.cache.getJSON('lang')['t267'][0][window.lang],
          { font: '64px RussoOne', fill: '#fff', align: 'center' },
        );
        text_popup_title.anchor.setTo(0.5);
        text_popup_title.stroke = '#1A6383';
        text_popup_title.strokeThickness = 4;
        text_popup_title.setShadow(0, 4, 'rgba(26,99,131,1)', 1);
        popup_group.add(text_popup_title);
        text_popup_title.alpha = 0;
        text_popup_title.fixedToCamera = true;
        game.add
          .tween(text_popup_title)
          .to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function () {
            animation = 0;
          });
        let shift = 0;
        var num_n = [];
        let col = 'One_Items_List_Background.png';
        for (var i = 0; i < 10; i++) {
          num_n = [];
          col = 'One_Items_List_Background.png';
          if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p1']) > 0) {
            num_n.push(1);
          }
          if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p2']) > 0) {
            num_n.push(2);
          }
          if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p3']) > 0) {
            num_n.push(3);
          }
          if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p4']) > 0) {
            num_n.push(4);
          }
          if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p5']) > 0) {
            num_n.push(5);
          }
          if (num_n.length == 1) {
            col = 'One_Items_List_Background.png';
          } else if (num_n.length == 2) {
            col = 'Two_Items_List_Background.png';
          } else if (num_n.length == 3) {
            col = 'Three_Items_List_Background.png';
          } else if (num_n.length == 4) {
            col = 'Four_Items_List_Background.png';
          }
          if (i == all_chests.indexOf(0)) {
            let shift2 = 0;
            let shift3 = 0;
            if (i == 0 || i == 9) {
              shift = 50;
            } else {
              shift = 100;
            }
            if (i != 0) {
              shift3 = 50;
            }
            {
              shift2 = all_chests.indexOf(0) * 340;
            }
            var Central_Offer_Background = game.add.sprite(
              game.camera.width / 2 - 700 + i * 340 - shift2 + shift3,
              game.camera.height / 2 + 10,
              'game_window2_atlas',
              'Central_Offer_Background.png',
            );
            Central_Offer_Background.anchor.setTo(0.5);
            Central_Offer_Background.scale.setTo(0);
            popup_group.add(Central_Offer_Background);
            Central_Offer_Background.fixedToCamera = true;
            if (i == 0 || i == 9) {
              shift = 50;
            } else {
              shift = 100;
            }
            game.add
              .tween(Central_Offer_Background.scale)
              .to({ x: 1, y: 1 }, 600, Phaser.Easing.Exponential.Out, true, i * 50);
            var icon_shine = game.add.sprite(0, -166, 'game_window2_atlas', 'Back_Rays.png');
            icon_shine.anchor.setTo(0.5);
            icon_shine.scale.setTo(0);
            Central_Offer_Background.addChild(icon_shine);
            game.add.tween(icon_shine.scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Bounce.Out, true, i * 50 + 200);
            var icon = game.add.sprite(0, -166, 'game_window2_atlas', 'Reward_Pack_' + Number(i + 1) + '.png');
            icon.anchor.setTo(0.5);
            icon.scale.setTo(0);
            Central_Offer_Background.addChild(icon);
            game.add.tween(icon.scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Bounce.Out, true, i * 50 + 200);
            var Items_List_Background = game.add.sprite(0, 60, 'game_window2_atlas', col);
            Items_List_Background.anchor.setTo(0.5);
            Central_Offer_Background.addChild(Items_List_Background);
            var How_Many_Friends_Background = game.add.sprite(
              0,
              230,
              'game_window2_atlas',
              'How_Many_Friends_Background.png',
            );
            How_Many_Friends_Background.anchor.setTo(0.5);
            Central_Offer_Background.addChild(How_Many_Friends_Background);
            var Friend_Frame = game.add.sprite(-124, 232, 'game_window2_atlas', 'Friend_Frame.png');
            Friend_Frame.anchor.setTo(0.5);
            Central_Offer_Background.addChild(Friend_Frame);
            var Friends_Plus_Button = game.add.sprite(-92, 210, 'game_window2_atlas', 'Friends_Plus_Button.png');
            Friends_Plus_Button.anchor.setTo(0.5);
            Central_Offer_Background.addChild(Friends_Plus_Button);
            var friend_num_text = game.add.text(
              20,
              228,
              friend_invite +
              '/' +
              game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['friends'],
              { font: '48px RussoOne', fill: '#fff', align: 'center' },
            );
            friend_num_text.anchor.setTo(0.5);
            friend_num_text.stroke = '#1A6383';
            friend_num_text.strokeThickness = 4;
            friend_num_text.setShadow(0, 4, 'rgba(26,99,131,1)', 1);
            Central_Offer_Background.addChild(friend_num_text);
            var Blue_Arrow = game.add.sprite(0, 260, 'game_window2_atlas', 'Blue_Arrow.png');
            Blue_Arrow.anchor.setTo(0.5);
            Blue_Arrow.alpha = 0;
            Central_Offer_Background.addChild(Blue_Arrow);
            game.add.tween(Blue_Arrow).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.Out, true, i * 50 + 500);
            game.add.tween(Blue_Arrow).to({ y: '+60' }, 600, Phaser.Easing.Bounce.Out, true, i * 50 + 500);
            var Big_Kit_Button = game.add.sprite(0, 1030, 'game_window_atlas', 'Big_Kit_Button.png');
            Big_Kit_Button.anchor.setTo(0.5);
            Big_Kit_Button.scale.setTo(1.4);
            Big_Kit_Button.alpha = 0;
            Big_Kit_Button.num_n = num_n;
            Big_Kit_Button.inputEnabled = true;
            Big_Kit_Button.events.onInputDown.add(function (item2) {
              if (popup != 2) {
                if (fbv == 1) {
                  window.eventTrack('Rewarded_invite_button_clicked', 1, { num: String(item2.num_n) });
                }
                if (fbv == 1 && FTUE_check == 3) {
                  window.eventTrack('FTUE_17_3User_clicked_on_InviteFriends');
                }
                popup = 2;
                var b = 0;
                if (fff == 3) {
                  b = 1;
                }
                let group = game.add.group();
                group.y = -344;
                var r_image = get_random_change(['RENOVATE.jpg', 'DECORATE.jpg']);
                var r_txt = get_random_change(['PlayWithMe3', 'PlayWithMe4']);
                var message_invite = game.add.sprite(668 / 2, 344 / 2, 'message_atlas', r_image);
                message_invite.scale.setTo(2);
                message_invite.anchor.setTo(0.5);
                group.add(message_invite);
                group.inputEnabled = false;
                group.y = 0;
                let group2 = game.add.group();
                group2.addChild(group);
                var renderTexture = game.make.renderTexture(668, 344);
                renderTexture.render(group2);
                group2.destroy();
                var mID =
                  ddd == 0
                    ? new Date()
                    : new Date(
                      ddd +
                      ' ' +
                      new Date().getHours() +
                      ':' +
                      new Date().getMinutes() +
                      ':' +
                      new Date().getSeconds(),
                    );
                loading();
                // FBInstant.context
                //   .chooseAsync({
                //     filters: ['NEW_PLAYERS_ONLY'],
                //     minSize: 3,
                //   })
                //   .then(function () {
                //     if (loading_black_sprite != 0) {
                //       loading_black_sprite.destroy();
                //       loading_black_sprite = 0;
                //     }
                //     if (loading_text != 0 && loading_text != 1) {
                //       loading_text.destroy();
                //       loading_text = 0;
                //     }
                //     popup = 1;
                //     first_start = -1;
                //     numFriendsInvited += 1;
                //     game.setUserDataAndLog({ first_start: first_start, numFriendsInvited: numFriendsInvited });
                //     updateAsync(
                //       {
                //         action: 'CUSTOM',
                //         image: renderTexture.getBase64(),
                //         text: game.cache.getJSON('lang')[r_txt][0][window.lang],
                //         template: 'play_turn',
                //         data: {
                //           userId: CurrentUserId,
                //           messageId: mID.getTime(),
                //           data: 'SetNewFriend',
                //           bonus: b,
                //         },
                //         strategy: 'IMMEDIATE',
                //         notification: 'NO_PUSH',
                //       },
                //       {
                //         actionLevel: null,
                //         targetUserID: null,
                //         socialActionType: DdnaSocialActionType.InviteFriend,
                //         socialRewardType: DdnaSocialRewardType.No,
                //       },
                //     );
                //   })
                //   .catch(function (error) {
                //     popup = 1;
                //     if (loading_black_sprite != 0) {
                //       loading_black_sprite.destroy();
                //       loading_black_sprite = 0;
                //     }
                //     if (loading_text != 0 && loading_text != 1) {
                //       loading_text.destroy();
                //       loading_text = 0;
                //     }
                //   });
              }
            });
            Central_Offer_Background.addChild(Big_Kit_Button);
            Big_Kit_Button.input.useHandCursor = true;
            scale_tween(Big_Kit_Button, 500, 0.1, 0.1);
            game.add.tween(Big_Kit_Button).to({ y: '-600' }, 600, Phaser.Easing.Exponential.Out, true, i * 50 + 500);
            game.add.tween(Big_Kit_Button).to({ alpha: 1 }, 100, Phaser.Easing.Exponential.Out, true, i * 50 + 500);
            var Big_Kit_Button_text = game.add.text(0, 0, game.cache.getJSON('lang')['t268'][0][window.lang], {
              font: '28px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            Big_Kit_Button_text.anchor.setTo(0.5);
            Big_Kit_Button_text.stroke = '#46730C';
            Big_Kit_Button_text.strokeThickness = 4;
            Big_Kit_Button_text.setShadow(0, 4, 'rgba(70,115,12,0.5)', 1);
            Big_Kit_Button.addChild(Big_Kit_Button_text);
          } else {
            let shift2 = 0;
            {
              shift2 = all_chests.indexOf(0) * 340;
            }
            var Small_Offer_Background = game.add.sprite(
              game.camera.width / 2 - 700 + i * 340 + shift - shift2,
              game.camera.height / 2 - 40,
              'game_window2_atlas',
              'Small_Offer_Background.png',
            );
            Small_Offer_Background.anchor.setTo(0.5);
            Small_Offer_Background.scale.setTo(0);
            popup_group.add(Small_Offer_Background);
            Small_Offer_Background.fixedToCamera = true;
            game.add
              .tween(Small_Offer_Background.scale)
              .to({ x: 1, y: 1 }, 600, Phaser.Easing.Exponential.Out, true, i * 50);
            var icon_shine = game.add.sprite(-6, -96, 'game_window2_atlas', 'Back_Rays.png');
            icon_shine.anchor.setTo(0.5);
            icon_shine.scale.setTo(0);
            Small_Offer_Background.addChild(icon_shine);
            game.add
              .tween(icon_shine.scale)
              .to({ x: 0.76, y: 0.76 }, 600, Phaser.Easing.Bounce.Out, true, i * 50 + 200);
            var icon = game.add.sprite(-6, -96, 'game_window2_atlas', 'Reward_Pack_' + Number(i + 1) + '.png');
            icon.anchor.setTo(0.5);
            icon.scale.setTo(0);
            Small_Offer_Background.addChild(icon);
            game.add.tween(icon.scale).to({ x: 0.76, y: 0.76 }, 600, Phaser.Easing.Bounce.Out, true, i * 50 + 200);
            var Items_List_Background = game.add.sprite(-6, 90, 'game_window2_atlas', col);
            Items_List_Background.anchor.setTo(0.5);
            Items_List_Background.scale.setTo(0.76);
            Small_Offer_Background.addChild(Items_List_Background);
          }
          let height = 55 * (num_n.length - 1);
          let ic = 'List_Coin.png';
          for (var j = 0; j < num_n.length; j++) {
            if (num_n[j] == 2) {
              ic = 'List_Energy.png';
            }
            if (num_n[j] == 3) {
              ic = 'List_Joker.png';
            }
            if (num_n[j] == 4) {
              ic = 'List_Cards.png';
            }
            if (num_n[j] == 5) {
              ic = 'List_Card_Back.png';
            }
            var prize_icon = game.add.sprite(
              -70,
              j * (55 + (4 - num_n.length) * 20) - height / 2 - ((4 - num_n.length) * 20) / 2,
              'game_window2_atlas',
              ic,
            );
            prize_icon.anchor.setTo(0.5);
            if (num_n.length == 1) prize_icon.y += ((4 - num_n.length) * 24) / 2;
            if (num_n.length == 4) prize_icon.scale.setTo(0.75);
            if (num_n.length == 3) prize_icon.y -= 8;
            Items_List_Background.addChild(prize_icon);
            if (fff == 3)
              var prize_icon_text = game.add.text(
                30,
                j * (55 + (4 - num_n.length) * 20) - height / 2 - ((4 - num_n.length) * 20) / 2,
                Number(
                  game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p' + num_n[j]],
                ) * 3,
                { font: '48px RussoOne', fill: '#1B617D', align: 'center' },
              );
            else
              var prize_icon_text = game.add.text(
                30,
                j * (55 + (4 - num_n.length) * 20) - height / 2 - ((4 - num_n.length) * 20) / 2,
                game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p' + num_n[j]],
                { font: '48px RussoOne', fill: '#1B617D', align: 'center' },
              );
            prize_icon_text.anchor.setTo(0.5);
            if (num_n.length == 1) prize_icon_text.y += ((4 - num_n.length) * 24) / 2;
            if (num_n.length == 3) prize_icon_text.y -= 8;
            prize_icon_text.stroke = '#fff';
            prize_icon_text.strokeThickness = 4;
            Items_List_Background.addChild(prize_icon_text);
          }
        }
      }
    }
    if (fbv == 1) {
      // FBInstant.payments.getPurchasesAsync().then(function (purchases) {
      //   for (i = 0; i < purchases.length; i++) {
      //     FBInstant.payments
      //       .consumePurchaseAsync(purchases[i]['purchaseToken'])
      //       .then(function () {})
      //       .catch(function (error) {});
      //   }
      // });
    }
    var shop_open = 0;
    window.shop_window = function (type, name, sdvig, spec_a, other_a) {
      if (popup == 0) {
        if (fbv == 1 && FTUE == 41.3) {
          window.eventTrack('FTUE_15_2Shop_is_opened');
        }
        popup_group.y = 0;
        popup = 1;
        blackf();
        var buttontimer3 = setInterval(function () {
          if (payments_catalog.length > 0) {
            clearInterval(buttontimer3);
            if (type == 0) {
              var Big_Kit_Background = game.add.sprite(
                game.camera.width / 2 - 570,
                game.camera.height / 2 + 1120,
                'game_window_atlas',
                'Big_Kit_Background.png',
              );
              Big_Kit_Background.anchor.setTo(0.5);
              popup_group.add(Big_Kit_Background);
              Big_Kit_Background.fixedToCamera = true;
              game.add
                .tween(Big_Kit_Background.cameraOffset)
                .to({ y: '-1000' }, 500, Phaser.Easing.Exponential.Out, true);
              if (starter_kit == 0)
                var text_super = game.add.text(0, -310, game.cache.getJSON('lang')['t269'][0][window.lang], {
                  font: '42px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
              else if (starter_kit == 1)
                var text_super = game.add.text(0, -310, game.cache.getJSON('lang')['t270'][0][window.lang], {
                  font: '42px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
              else if (starter_kit == 2)
                var text_super = game.add.text(0, -310, game.cache.getJSON('lang')['t575'][0][window.lang], {
                  font: '42px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
              else if (starter_kit == 3)
                var text_super = game.add.text(0, -310, game.cache.getJSON('lang')['t576'][0][window.lang], {
                  font: '42px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
              else if (starter_kit == 4)
                var text_super = game.add.text(0, -310, game.cache.getJSON('lang')['t577'][0][window.lang], {
                  font: '42px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
              text_super.anchor.setTo(0.5);
              text_super.stroke = '#1A6383';
              text_super.strokeThickness = 4;
              text_super.setShadow(0, 3, 'rgba(26,99,131,1)', 1);
              Big_Kit_Background.addChild(text_super);
              /*var Green_Background_Super_and_Maxi_Kit = game.add.sprite(
                0,
                -178,
                'game_window2_atlas',
                'Green_Background_Super_and_Maxi_Kit.png',
              );
              Green_Background_Super_and_Maxi_Kit.anchor.setTo(0.5);
              Big_Kit_Background.addChild(Green_Background_Super_and_Maxi_Kit);*/
              var Background_Rays = game.add.sprite(10, -180, 'game_window2_atlas', 'Background_Rays.png');
              Background_Rays.anchor.setTo(0.5);
              Background_Rays.scale.setTo(0.7);
              Big_Kit_Background.addChild(Background_Rays);
              rotate_tween(Background_Rays);
              if (starter_kit == 0)
                var Super_Kit_Pack = game.add.sprite(0, -180, 'game_window2_atlas', 'Chest_Super_Kit.png');
              else if (starter_kit == 1)
                var Super_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Joker_Pack.png');
              else if (starter_kit == 2)
                var Super_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Bag_of_Jokers.png');
              else if (starter_kit == 3)
                var Super_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Jokers_Treasure.png');
              else if (starter_kit == 4)
                var Super_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Big_Joker_Chest.png');
              Super_Kit_Pack.anchor.setTo(0.5);
              Super_Kit_Pack.scale.setTo(0.9);
              Big_Kit_Background.addChild(Super_Kit_Pack);
              var Big_Kits_List_Background = game.add.sprite(
                0,
                70,
                'game_window_atlas',
                'Big_Kits_List_Background.png',
              );
              Big_Kits_List_Background.anchor.setTo(0.5);
              Big_Kit_Background.addChild(Big_Kits_List_Background);
              var Big_Kit_List_Coin = game.add.sprite(-70, -112, 'game_window_atlas', 'Big_Kit_List_Coin.png');
              Big_Kit_List_Coin.anchor.setTo(0.5);
              Big_Kits_List_Background.addChild(Big_Kit_List_Coin);
              if (starter_kit == 0)
                var Big_Kit_List_Coin_text = game.add.text(-30, -112, '3 000', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 1)
                var Big_Kit_List_Coin_text = game.add.text(-30, -112, '5 000', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 2)
                var Big_Kit_List_Coin_text = game.add.text(-30, -112, '10 000', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 3)
                var Big_Kit_List_Coin_text = game.add.text(-30, -112, '20 000', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 4)
                var Big_Kit_List_Coin_text = game.add.text(-30, -112, '25 000', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              Big_Kit_List_Coin_text.anchor.setTo(0, 0.5);
              Big_Kit_List_Coin_text.stroke = '#fff';
              Big_Kit_List_Coin_text.strokeThickness = 4;
              Big_Kits_List_Background.addChild(Big_Kit_List_Coin_text);
              if (starter_kit == 0)
                var Big_Kit_List_Energy = game.add.sprite(-70, -34, 'game_window_atlas', 'Big_Kit_List_Energy.png');
              else if (starter_kit == 1)
                var Big_Kit_List_Energy = game.add.sprite(-70, -34, 'game_window_atlas', 'Big_Kit_List_Joker.png');
              else if (starter_kit == 2)
                var Big_Kit_List_Energy = game.add.sprite(-70, -34, 'game_window_atlas', 'Big_Kit_List_Joker.png');
              else if (starter_kit == 3)
                var Big_Kit_List_Energy = game.add.sprite(-70, -34, 'game_window_atlas', 'Big_Kit_List_Joker.png');
              else if (starter_kit == 4)
                var Big_Kit_List_Energy = game.add.sprite(-70, -34, 'game_window_atlas', 'Big_Kit_List_Joker.png');
              Big_Kit_List_Energy.anchor.setTo(0.5);
              Big_Kits_List_Background.addChild(Big_Kit_List_Energy);
              if (starter_kit == 0)
                var Big_Kit_List_Energy_text = game.add.text(-30, -34, 'x5', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 1)
                var Big_Kit_List_Energy_text = game.add.text(-30, -34, 'x6', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 2)
                var Big_Kit_List_Energy_text = game.add.text(-30, -34, 'x8', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 3)
                var Big_Kit_List_Energy_text = game.add.text(-30, -34, 'x12', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 4)
                var Big_Kit_List_Energy_text = game.add.text(-30, -34, 'x15', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              Big_Kit_List_Energy_text.anchor.setTo(0, 0.5);
              Big_Kit_List_Energy_text.stroke = '#fff';
              Big_Kit_List_Energy_text.strokeThickness = 4;
              Big_Kits_List_Background.addChild(Big_Kit_List_Energy_text);
              if (starter_kit == 0)
                var Big_Kit_List_Joker = game.add.sprite(-70, 40, 'game_window_atlas', 'Big_Kit_List_Joker.png');
              else if (starter_kit == 1)
                var Big_Kit_List_Joker = game.add.sprite(-70, 40, 'game_window_atlas', 'Big_Kit_List_Card_Back.png');
              else if (starter_kit == 2)
                var Big_Kit_List_Joker = game.add.sprite(-70, 40, 'game_window_atlas', 'Big_Kit_List_Card_Back.png');
              else if (starter_kit == 3)
                var Big_Kit_List_Joker = game.add.sprite(-70, 40, 'game_window_atlas', 'Big_Kit_List_Card_Back.png');
              else if (starter_kit == 4)
                var Big_Kit_List_Joker = game.add.sprite(-70, 40, 'game_window_atlas', 'Big_Kit_List_Card_Back.png');
              Big_Kit_List_Joker.anchor.setTo(0.5);
              Big_Kits_List_Background.addChild(Big_Kit_List_Joker);
              if (starter_kit == 0)
                var Big_Kit_List_Joker_text = game.add.text(-30, 40, 'x1', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 1)
                var Big_Kit_List_Joker_text = game.add.text(-30, 40, 'x3', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 2)
                var Big_Kit_List_Joker_text = game.add.text(-30, 40, 'x5', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 3)
                var Big_Kit_List_Joker_text = game.add.text(-30, 40, 'x5', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              else if (starter_kit == 4)
                var Big_Kit_List_Joker_text = game.add.text(-30, 40, 'x10', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
              Big_Kit_List_Joker_text.anchor.setTo(0, 0.5);
              Big_Kit_List_Joker_text.stroke = '#fff';
              Big_Kit_List_Joker_text.strokeThickness = 4;
              Big_Kits_List_Background.addChild(Big_Kit_List_Joker_text);
              if (starter_kit == 0) {
                var Big_Kit_List_Card_Back = game.add.sprite(-70, 115, 'game_window_atlas', 'Big_Kit_List_Card_Back.png');
                Big_Kit_List_Card_Back.anchor.setTo(0.5);
                Big_Kits_List_Background.addChild(Big_Kit_List_Card_Back);
                var Big_Kit_List_Card_Back_text = game.add.text(-30, 115, 'x3', {
                  font: '42px RussoOne',
                  fill: '#1B617D',
                  align: 'left',
                });
                Big_Kit_List_Card_Back_text.anchor.setTo(0, 0.5);
                Big_Kit_List_Card_Back_text.stroke = '#fff';
                Big_Kit_List_Card_Back_text.strokeThickness = 4;
                Big_Kits_List_Background.addChild(Big_Kit_List_Card_Back_text);
              }

              var Big_Kit_Button = game.add.sprite(0, 290, 'game_window_atlas', 'Big_Kit_Button.png');
              Big_Kit_Button.anchor.setTo(0.5);
              button_animation_f(Big_Kit_Button, 1);
              Big_Kit_Button.input.priorityID = 100;
              Big_Kit_Button.events.onInputUp.add(function (item) {
                btnup(item);
                if (popup != 2 && FTUE != 41.4) {
                  popup = 2;
                  if (sound_on == 1) {
                    play_sound('button_X');
                  }
                  if (starter_kit == 0) {
                    if (fbv == 1) {
                      game.setCurrentEvent();
                      window.eventTrack('shop_starter_pack_initiated');
                      window.eventTrack('soga_purchase_initiated', 1, {
                        package_id: 'shop_starter_pack',
                        value: '1.99 $',
                        current_level: level_button.n,
                        conversion: 1 - bought,
                        user_type: bought,
                        lifetime: lifetime_day,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                    }
                    loading();
                    if (animation == 100) {
                      if (bought == 0) {
                        bought_f = 1;
                      }
                      if (fbv == 1) {
                        game.setCurrentEvent();
                        window.eventTrack('shop_starter_pack_successfull');
                        window.eventTrack('soga_purchase_successfull', 1, {
                          package_id: 'shop_starter_pack',
                          value: '1.99 $',
                          current_level: level_button.n,
                          conversion: 1 - bought,
                          first_purchase: bought_f,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                      }
                      if (loading_black_sprite != 0) {
                        loading_black_sprite.destroy();
                        loading_black_sprite = 0;
                      }
                      if (loading_text != 0 && loading_text != 1) {
                        loading_text.destroy();
                        loading_text = 0;
                      }
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                      game.add
                        .tween(popup_group)
                        .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                        .onComplete.add(function (item) {
                          popup_group.removeAll(true);
                          popup = 0;
                          popup_group.y -= game.camera.height;
                          wheel_icon_text = 0;
                          missions_tab_open = 0;
                          animation = 0;
                          starter_kit = 1;
                          bought = 1;
                          bought_f = 0;
                          game.setUserDataAndLog({ bought: bought, starter_kit: starter_kit });
                          chest_open_window(
                            game.cache.getJSON('lang')['Reward!'][0][window.lang],
                            [3000, 5, 1, 0, 3],
                            51,
                            1,
                            {
                              // gameArea: DdnaGameArea.Map,
                              // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                              gameArea: null,
                              actionType: null,
                              productId: 0,
                              //productId: ProductID.shop_starter_pack,
                            },
                          );
                          source_chest = 'Package';
                          package_id_chest = 'shop_starter_pack';
                        });
                    }

                    // else
                    //   purchaseAsync(
                    //     {
                    //       productID: 'shop_starter_pack',
                    //       developerPayload: 'Starter Pack',
                    //     },
                    //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                    //   )
                    //     .then(function (purchase) {
                    //       if (bought == 0) {
                    //         bought_f = 1;
                    //       }
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('shop_starter_pack_successfull');
                    //         window.eventTrack('soga_purchase_successfull', 1, {
                    //           package_id: 'shop_starter_pack',
                    //           value: '1.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           first_purchase: bought_f,
                    //           lifetime: lifetime_day,
                    //           highest_lvl: all_level.lastIndexOf(3) + 2,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       game.add
                    //         .tween(black_sprite)
                    //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    //         .onComplete.add(function (item) {
                    //           item.destroy();
                    //         });
                    //       game.add
                    //         .tween(popup_group)
                    //         .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    //         .onComplete.add(function (item) {
                    //           popup_group.removeAll(true);
                    //           popup = 0;
                    //           popup_group.y -= game.camera.height;
                    //           wheel_icon_text = 0;
                    //           missions_tab_open = 0;
                    //           starter_kit = 1;
                    //           bought = 1;
                    //           bought_f = 0;
                    //           game.setUserDataAndLog({ bought: bought, starter_kit: starter_kit });
                    //           chest_open_window(
                    //             game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    //             [3000, 5, 1, 0, 3],
                    //             51,
                    //             1,
                    //             {
                    //               // gameArea: DdnaGameArea.Map,
                    //               // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                    //               gameArea: null,
                    //               actionType: null,
                    //               //productId: ProductID.shop_starter_pack,
                    //               productId: 0,
                    //             },
                    //           );
                    //           source_chest = 'Package';
                    //           package_id_chest = 'shop_starter_pack';
                    //         });
                    //       // FBInstant.payments
                    //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                    //       //   .then(function () {})
                    //       //   .catch(function (error) {});
                    //     })
                    //     .catch(function (error) {
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('soga_purchase_failed', 1, {
                    //           package_id: 'shop_starter_pack',
                    //           value: '1.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           user_type: bought,
                    //           lifetime: lifetime_day,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       console.log(error);
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       button_click = 0;
                    //       popup = 1;
                    //     });

                  } else if (starter_kit == 1) {
                    if (fbv == 1) {
                      game.setCurrentEvent();
                      window.eventTrack('joker_shop_1_pack_initiated');
                      window.eventTrack('soga_purchase_initiated', 1, {
                        package_id: 'joker_shop_1_pack',
                        value: '8.99 $',
                        current_level: level_button.n,
                        conversion: 1 - bought,
                        user_type: bought,
                        lifetime: lifetime_day,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                    }
                    loading();
                    if (animation == 100) {
                      if (bought == 0) {
                        bought_f = 1;
                      }
                      if (fbv == 1) {
                        game.setCurrentEvent();
                        window.eventTrack('joker_shop_1_pack_successfull');
                        window.eventTrack('soga_purchase_successfull', 1, {
                          package_id: 'joker_shop_1_pack',
                          value: '8.99 $',
                          current_level: level_button.n,
                          conversion: 1 - bought,
                          first_purchase: bought_f,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                      }
                      if (loading_black_sprite != 0) {
                        loading_black_sprite.destroy();
                        loading_black_sprite = 0;
                      }
                      if (loading_text != 0 && loading_text != 1) {
                        loading_text.destroy();
                        loading_text = 0;
                      }
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                      game.add
                        .tween(popup_group)
                        .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                        .onComplete.add(function (item) {
                          popup_group.removeAll(true);
                          popup = 0;
                          popup_group.y -= game.camera.height;
                          wheel_icon_text = 0;
                          missions_tab_open = 0;
                          animation = 0;
                          starter_kit = 2;
                          bought = 1;
                          bought_f = 0;
                          game.setUserDataAndLog({ bought: bought });
                          chest_open_window(
                            game.cache.getJSON('lang')['Reward!'][0][window.lang],
                            [5000, 0, 6, 0, 3],
                            51,
                            1,
                            {
                              // gameArea: DdnaGameArea.Map,
                              // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                              gameArea: null,
                              actionType: null,
                              //productId: ProductID.joker_shop_1_pack,
                              productId: 0,
                            },
                          );
                          source_chest = 'Package';
                          package_id_chest = 'joker_shop_1_pack';
                        });
                    }

                    // else
                    //   purchaseAsync(
                    //     {
                    //       productID: 'joker_shop_1_pack',
                    //       developerPayload: 'Joker Pack',
                    //     },
                    //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                    //   )
                    //     .then(function (purchase) {
                    //       if (bought == 0) {
                    //         bought_f = 1;
                    //       }
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('joker_shop_1_pack_successfull');
                    //         window.eventTrack('soga_purchase_successfull', 1, {
                    //           package_id: 'joker_shop_1_pack',
                    //           value: '8.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           first_purchase: bought_f,
                    //           lifetime: lifetime_day,
                    //           highest_lvl: all_level.lastIndexOf(3) + 2,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       game.add
                    //         .tween(black_sprite)
                    //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    //         .onComplete.add(function (item) {
                    //           item.destroy();
                    //         });
                    //       game.add
                    //         .tween(popup_group)
                    //         .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    //         .onComplete.add(function (item) {
                    //           popup_group.removeAll(true);
                    //           popup = 0;
                    //           popup_group.y -= game.camera.height;
                    //           wheel_icon_text = 0;
                    //           missions_tab_open = 0;
                    //           bought = 1;
                    //           starter_kit = 2;
                    //           bought_f = 0;
                    //           game.setUserDataAndLog({ bought: bought });
                    //           chest_open_window(
                    //             game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    //             [5000, 0, 6, 0, 3],
                    //             51,
                    //             1,
                    //             {
                    //               // gameArea: DdnaGameArea.Map,
                    //               // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                    //               gameArea: null,
                    //               actionType: null,
                    //               productId: 0,
                    //               //productId: ProductID.joker_shop_1_pack,
                    //             },
                    //           );
                    //           source_chest = 'Package';
                    //           package_id_chest = 'joker_shop_1_pack';
                    //         });
                    //       // FBInstant.payments
                    //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                    //       //   .then(function () {})
                    //       //   .catch(function (error) {});
                    //     })
                    //     .catch(function (error) {
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('soga_purchase_failed', 1, {
                    //           package_id: 'joker_shop_1_pack',
                    //           value: '8.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           user_type: bought,
                    //           lifetime: lifetime_day,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       console.log(error);
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       button_click = 0;
                    //       popup = 1;
                    //     });
                  } else if (starter_kit == 2) {
                    if (fbv == 1) {
                      game.setCurrentEvent();
                      window.eventTrack('joker_shop_2_bagofjokers_initiated');
                      window.eventTrack('soga_purchase_initiated', 1, {
                        package_id: 'joker_shop_2_bagofjokers',
                        value: '16.99 $',
                        current_level: level_button.n,
                        conversion: 1 - bought,
                        user_type: bought,
                        lifetime: lifetime_day,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                    }
                    loading();
                    if (animation == 100) {
                      if (bought == 0) {
                        bought_f = 1;
                      }
                      if (fbv == 1) {
                        game.setCurrentEvent();
                        window.eventTrack('joker_shop_2_bagofjokers_successfull');
                        window.eventTrack('soga_purchase_successfull', 1, {
                          package_id: 'joker_shop_2_bagofjokers',
                          value: '16.99 $',
                          current_level: level_button.n,
                          conversion: 1 - bought,
                          first_purchase: bought_f,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                      }
                      if (loading_black_sprite != 0) {
                        loading_black_sprite.destroy();
                        loading_black_sprite = 0;
                      }
                      if (loading_text != 0 && loading_text != 1) {
                        loading_text.destroy();
                        loading_text = 0;
                      }
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                      game.add
                        .tween(popup_group)
                        .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                        .onComplete.add(function (item) {
                          popup_group.removeAll(true);
                          popup = 0;
                          popup_group.y -= game.camera.height;
                          wheel_icon_text = 0;
                          missions_tab_open = 0;
                          animation = 0;
                          starter_kit = 3;
                          bought = 1;
                          bought_f = 0;
                          game.setUserDataAndLog({ bought: bought });
                          chest_open_window(
                            game.cache.getJSON('lang')['Reward!'][0][window.lang],
                            [10000, 0, 8, 0, 5],
                            51,
                            1,
                            {
                              // gameArea: DdnaGameArea.Map,
                              // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                              gameArea: null,
                              actionType: null,
                              productId: 0,
                              //productId: ProductID.joker_shop_2_bagofjokers,
                            },
                          );
                          source_chest = 'Package';
                          package_id_chest = 'joker_shop_2_bagofjokers';
                        });
                    }
                    // else
                    //   purchaseAsync(
                    //     {
                    //       productID: 'joker_shop_2_bagofjokers',
                    //       developerPayload: 'Joker Pack',
                    //     },
                    //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                    //   )
                    //     .then(function (purchase) {
                    //       if (bought == 0) {
                    //         bought_f = 1;
                    //       }
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('joker_shop_2_bagofjokers_successfull');
                    //         window.eventTrack('soga_purchase_successfull', 1, {
                    //           package_id: 'joker_shop_2_bagofjokers',
                    //           value: '16.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           first_purchase: bought_f,
                    //           lifetime: lifetime_day,
                    //           highest_lvl: all_level.lastIndexOf(3) + 2,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       game.add
                    //         .tween(black_sprite)
                    //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    //         .onComplete.add(function (item) {
                    //           item.destroy();
                    //         });
                    //       game.add
                    //         .tween(popup_group)
                    //         .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    //         .onComplete.add(function (item) {
                    //           popup_group.removeAll(true);
                    //           popup = 0;
                    //           popup_group.y -= game.camera.height;
                    //           wheel_icon_text = 0;
                    //           missions_tab_open = 0;
                    //           bought = 1;
                    //           starter_kit = 3;
                    //           bought_f = 0;
                    //           game.setUserDataAndLog({ bought: bought });
                    //           chest_open_window(
                    //             game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    //             [10000, 0, 8, 0, 5],
                    //             51,
                    //             1,
                    //             {
                    //               // gameArea: DdnaGameArea.Map,
                    //               // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                    //               gameArea: null,
                    //               actionType: null,
                    //               //productId: ProductID.joker_shop_2_bagofjokers,
                    //               productId: 0,
                    //             },
                    //           );
                    //           source_chest = 'Package';
                    //           package_id_chest = 'joker_shop_2_bagofjokers';
                    //         });
                    //       // FBInstant.payments
                    //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                    //       //   .then(function () {})
                    //       //   .catch(function (error) {});
                    //     })
                    //     .catch(function (error) {
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('soga_purchase_failed', 1, {
                    //           package_id: 'joker_shop_2_bagofjokers',
                    //           value: '16.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           user_type: bought,
                    //           lifetime: lifetime_day,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       console.log(error);
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       button_click = 0;
                    //       popup = 1;
                    //     });
                  } else if (starter_kit == 3) {
                    if (fbv == 1) {
                      game.setCurrentEvent();
                      window.eventTrack('joker_shop_3_jokerstreasure_initiated');
                      window.eventTrack('soga_purchase_initiated', 1, {
                        package_id: 'joker_shop_3_jokerstreasure',
                        value: '24.99 $',
                        current_level: level_button.n,
                        conversion: 1 - bought,
                        user_type: bought,
                        lifetime: lifetime_day,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                    }
                    loading();
                    if (animation == 100) {
                      if (bought == 0) {
                        bought_f = 1;
                      }
                      if (fbv == 1) {
                        game.setCurrentEvent();
                        window.eventTrack('joker_shop_3_jokerstreasure_successfull');
                        window.eventTrack('soga_purchase_successfull', 1, {
                          package_id: 'joker_shop_3_jokerstreasure',
                          value: '24.99 $',
                          current_level: level_button.n,
                          conversion: 1 - bought,
                          first_purchase: bought_f,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                      }
                      if (loading_black_sprite != 0) {
                        loading_black_sprite.destroy();
                        loading_black_sprite = 0;
                      }
                      if (loading_text != 0 && loading_text != 1) {
                        loading_text.destroy();
                        loading_text = 0;
                      }
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                      game.add
                        .tween(popup_group)
                        .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                        .onComplete.add(function (item) {
                          popup_group.removeAll(true);
                          popup = 0;
                          popup_group.y -= game.camera.height;
                          wheel_icon_text = 0;
                          missions_tab_open = 0;
                          animation = 0;
                          starter_kit = 4;
                          bought = 1;
                          bought_f = 0;
                          game.setUserDataAndLog({ bought: bought });
                          chest_open_window(
                            game.cache.getJSON('lang')['Reward!'][0][window.lang],
                            [20000, 0, 12, 0, 5],
                            51,
                            1,
                            {
                              // gameArea: DdnaGameArea.Map,
                              // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                              // productId: ProductID.joker_shop_3_jokerstreasure,
                              gameArea: null,
                              actionType: null,
                              productId: 0,
                            },
                          );
                          source_chest = 'Package';
                          package_id_chest = 'joker_shop_3_jokerstreasure';
                        });
                    }

                    // else
                    //   purchaseAsync(
                    //     {
                    //       productID: 'joker_shop_3_jokerstreasure',
                    //       developerPayload: 'Joker Pack',
                    //     },
                    //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                    //   )
                    //     .then(function (purchase) {
                    //       if (bought == 0) {
                    //         bought_f = 1;
                    //       }
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('joker_shop_3_jokerstreasure_successfull');
                    //         window.eventTrack('soga_purchase_successfull', 1, {
                    //           package_id: 'joker_shop_3_jokerstreasure',
                    //           value: '24.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           first_purchase: bought_f,
                    //           lifetime: lifetime_day,
                    //           highest_lvl: all_level.lastIndexOf(3) + 2,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       game.add
                    //         .tween(black_sprite)
                    //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    //         .onComplete.add(function (item) {
                    //           item.destroy();
                    //         });
                    //       game.add
                    //         .tween(popup_group)
                    //         .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    //         .onComplete.add(function (item) {
                    //           popup_group.removeAll(true);
                    //           popup = 0;
                    //           popup_group.y -= game.camera.height;
                    //           wheel_icon_text = 0;
                    //           missions_tab_open = 0;
                    //           bought = 1;
                    //           starter_kit = 4;
                    //           bought_f = 0;
                    //           game.setUserDataAndLog({ bought: bought });
                    //           chest_open_window(
                    //             game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    //             [20000, 0, 12, 0, 5],
                    //             51,
                    //             1,
                    //             {
                    //               // gameArea: DdnaGameArea.Map,
                    //               // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                    //               // productId: ProductID.joker_shop_3_jokerstreasure,
                    //               gameArea: null,
                    //               actionType: null,
                    //               productId: 0,
                    //             },
                    //           );
                    //           source_chest = 'Package';
                    //           package_id_chest = 'joker_shop_3_jokerstreasure';
                    //         });
                    //       // FBInstant.payments
                    //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                    //       //   .then(function () {})
                    //       //   .catch(function (error) {});
                    //     })
                    //     .catch(function (error) {
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('soga_purchase_failed', 1, {
                    //           package_id: 'joker_shop_3_jokerstreasure',
                    //           value: '24.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           user_type: bought,
                    //           lifetime: lifetime_day,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       console.log(error);
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       button_click = 0;
                    //       popup = 1;
                    //     });
                  } else if (starter_kit == 4) {
                    if (fbv == 1) {
                      game.setCurrentEvent();
                      window.eventTrack('joker_shop_4_jokerchest_initiated');
                      window.eventTrack('soga_purchase_initiated', 1, {
                        package_id: 'joker_shop_4_jokerchest',
                        value: '32.99 $',
                        current_level: level_button.n,
                        conversion: 1 - bought,
                        user_type: bought,
                        lifetime: lifetime_day,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                    }
                    loading();
                    if (animation == 100) {
                      if (bought == 0) {
                        bought_f = 1;
                      }
                      if (fbv == 1) {
                        game.setCurrentEvent();
                        window.eventTrack('joker_shop_4_jokerchest_successfull');
                        window.eventTrack('soga_purchase_successfull', 1, {
                          package_id: 'joker_shop_4_jokerchest',
                          value: '32.99 $',
                          current_level: level_button.n,
                          conversion: 1 - bought,
                          first_purchase: bought_f,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                      }
                      if (loading_black_sprite != 0) {
                        loading_black_sprite.destroy();
                        loading_black_sprite = 0;
                      }
                      if (loading_text != 0 && loading_text != 1) {
                        loading_text.destroy();
                        loading_text = 0;
                      }
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                      game.add
                        .tween(popup_group)
                        .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                        .onComplete.add(function (item) {
                          popup_group.removeAll(true);
                          popup = 0;
                          popup_group.y -= game.camera.height;
                          wheel_icon_text = 0;
                          missions_tab_open = 0;
                          animation = 0;
                          starter_kit = 1;
                          bought = 1;
                          bought_f = 0;
                          game.setUserDataAndLog({ bought: bought });
                          chest_open_window(
                            game.cache.getJSON('lang')['Reward!'][0][window.lang],
                            [25000, 0, 15, 0, 10],
                            51,
                            1,
                            {
                              // gameArea: DdnaGameArea.Map,
                              // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                              // productId: ProductID.joker_shop_4_jokerchest,
                              gameArea: null,
                              actionType: null,
                              productId: 0,
                            },
                          );
                          source_chest = 'Package';
                          package_id_chest = 'joker_shop_4_jokerchest';
                        });
                    }
                    // else
                    //   purchaseAsync(
                    //     {
                    //       productID: 'joker_shop_4_jokerchest',
                    //       developerPayload: 'Joker Pack',
                    //     },
                    //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                    //   )
                    //     .then(function (purchase) {
                    //       if (bought == 0) {
                    //         bought_f = 1;
                    //       }
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('joker_shop_4_jokerchest_successfull');
                    //         window.eventTrack('soga_purchase_successfull', 1, {
                    //           package_id: 'joker_shop_4_jokerchest',
                    //           value: '32.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           first_purchase: bought_f,
                    //           lifetime: lifetime_day,
                    //           highest_lvl: all_level.lastIndexOf(3) + 2,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       game.add
                    //         .tween(black_sprite)
                    //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    //         .onComplete.add(function (item) {
                    //           item.destroy();
                    //         });
                    //       game.add
                    //         .tween(popup_group)
                    //         .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    //         .onComplete.add(function (item) {
                    //           popup_group.removeAll(true);
                    //           popup = 0;
                    //           popup_group.y -= game.camera.height;
                    //           wheel_icon_text = 0;
                    //           missions_tab_open = 0;
                    //           bought = 1;
                    //           starter_kit = 1;
                    //           bought_f = 0;
                    //           game.setUserDataAndLog({ bought: bought });
                    //           chest_open_window(
                    //             game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    //             [25000, 0, 15, 0, 10],
                    //             51,
                    //             1,
                    //             {
                    //               // gameArea: DdnaGameArea.Map,
                    //               // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                    //               // productId: ProductID.joker_shop_4_jokerchest,
                    //               gameArea: null,
                    //               actionType: null,
                    //               productId: 0,
                    //             },
                    //           );
                    //           source_chest = 'Package';
                    //           package_id_chest = 'joker_shop_4_jokerchest';
                    //         });
                    //       // FBInstant.payments
                    //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                    //       //   .then(function () {})
                    //       //   .catch(function (error) {});
                    //     })
                    //     .catch(function (error) {
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('soga_purchase_failed', 1, {
                    //           package_id: 'joker_shop_4_jokerchest',
                    //           value: '32.99 $',
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           user_type: bought,
                    //           lifetime: lifetime_day,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       console.log(error);
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       button_click = 0;
                    //       popup = 1;
                    //     });
                  }
                }
              });
              Big_Kit_Background.addChild(Big_Kit_Button);
              if (starter_kit == 0)
                var Big_Kit_Button_text = game.add.text(
                  0,
                  0,
                  payments_catalog[
                  payments_catalog.findIndex(function (e) {
                    return e['productID'] == 'shop_starter_pack';
                  })
                  ]['price'],
                  { font: '42px RussoOne', fill: '#fff', align: 'center' },
                );
              else if (starter_kit == 1)
                var Big_Kit_Button_text = game.add.text(
                  0,
                  0,
                  payments_catalog[
                  payments_catalog.findIndex(function (e) {
                    return e['productID'] == 'joker_shop_1_pack';
                  })
                  ]['price'],
                  { font: '42px RussoOne', fill: '#fff', align: 'center' },
                );
              else if (starter_kit == 2)
                var Big_Kit_Button_text = game.add.text(
                  0,
                  0,
                  payments_catalog[
                  payments_catalog.findIndex(function (e) {
                    return e['productID'] == 'joker_shop_2_bagofjokers';
                  })
                  ]['price'],
                  { font: '42px RussoOne', fill: '#fff', align: 'center' },
                );
              else if (starter_kit == 3)
                var Big_Kit_Button_text = game.add.text(
                  0,
                  0,
                  payments_catalog[
                  payments_catalog.findIndex(function (e) {
                    return e['productID'] == 'joker_shop_3_jokerstreasure';
                  })
                  ]['price'],
                  { font: '42px RussoOne', fill: '#fff', align: 'center' },
                );
              else if (starter_kit == 4)
                var Big_Kit_Button_text = game.add.text(
                  0,
                  0,
                  payments_catalog[
                  payments_catalog.findIndex(function (e) {
                    return e['productID'] == 'joker_shop_4_jokerchest';
                  })
                  ]['price'],
                  { font: '42px RussoOne', fill: '#fff', align: 'center' },
                );
              Big_Kit_Button_text.anchor.setTo(0.5);
              Big_Kit_Button_text.stroke = '#47740D';
              Big_Kit_Button_text.strokeThickness = 4;
              Big_Kit_Button_text.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
              Big_Kit_Button.addChild(Big_Kit_Button_text);
            }
            if (type == 0)
              var Big_Kit_Background = game.add.sprite(
                game.camera.width / 2 - 160 - sdvig,
                game.camera.height / 2 + 1120,
                '',
              );
            else
              var Big_Kit_Background = game.add.sprite(
                game.camera.width / 2 + 880 - sdvig,
                game.camera.height / 2 + 1120,
                '',
              );
            Big_Kit_Background.anchor.setTo(0.5);
            Big_Kit_Background.fixedToCamera = true;
            popup_group.add(Big_Kit_Background);
            game.add
              .tween(Big_Kit_Background.cameraOffset)
              .to({ y: '-1000' }, 500, Phaser.Easing.Exponential.Out, true, 100)
              .onComplete.add(function () {
                if (FTUE == 41.4) {
                  FTUE_process();

                }
                if (FTUE == 41.3) {
                  FTUE = 41.4;
                  if (sound_on == 1) {
                    play_sound('hint_with_arrow');
                  }
                  FTUE_Arrow = game.add.sprite(
                    game.camera.width / 2 + 200 + 0 * 300 - 0,
                    game.camera.height / 2 - 78 + 0 * 390 + 60,
                    'game_atlas',
                    'FTUE_Arrow.png',
                  );
                  FTUE_Arrow.scale.setTo(1, -1);
                  FTUE_Arrow.anchor.setTo(0.5, 1.6);
                  FTUE_Arrow.fixedToCamera = true;
                  game.add
                    .tween(FTUE_Arrow.anchor)
                    .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                    .yoyo(true, 200);
                  effects_group.add(FTUE_Arrow);
                  game.world.bringToTop(effects_group);
                }
              });

            if (shop == 1) {

              if (type == 0)
                var Big_Kit_Background2 = game.add.sprite(0, 0, 'game_window_atlas', 'Big_Kit_Background.png');
              else {
                if (spec_a[0][0]['type'] == '2_TNT_Pack.png')
                  var Big_Kit_Background2 = game.add.sprite(
                    1,
                    -120 - 160,
                    'game_window2_atlas',
                    'TNT_Package_Background.png',
                  );
                else if (spec_a[0][0]['type'] == '2_Shuffle_Pack.png')
                  var Big_Kit_Background2 = game.add.sprite(
                    1,
                    -120 - 160,
                    'game_window2_atlas',
                    'Shuffle_Package_Background.png',
                  );
                else if (spec_a[0][0]['type'] == '2_Random_Pack.png')
                  var Big_Kit_Background2 = game.add.sprite(
                    1,
                    -120 - 160,
                    'game_window2_atlas',
                    'Random_Package_Background.png',
                  );
                else if (spec_a[0][0]['type'] == '+5_Cards.png')
                  var Big_Kit_Background2 = game.add.sprite(
                    1,
                    -120 - 160,
                    'game_window2_atlas',
                    'Random_Package_Background.png',
                  );
                else if (spec_a[0][0]['type'] == 'Windmill.png')
                  var Big_Kit_Background2 = game.add.sprite(
                    1,
                    -120 - 160,
                    'game_window2_atlas',
                    'Random_Package_Background.png',
                  );
                else if (spec_a[0][0]['type'] == 'Joker.png')
                  var Big_Kit_Background2 = game.add.sprite(
                    1,
                    -120 - 160,
                    'game_window2_atlas',
                    'Random_Package_Background.png',
                  );
                else if (spec_a[0][0]['type'] == 'List_Joker.png')
                  var Big_Kit_Background2 = game.add.sprite(
                    1,
                    -120 - 160,
                    'game_window2_atlas',
                    'Jocker_Package_Background.png',
                  );
                else if (spec_a[0][0]['type'] == 'magnifying_glass.png')
                  var Big_Kit_Background2 = game.add.sprite(
                    1,
                    -120 - 160,
                    'game_window2_atlas',
                    'Jocker_Package_Background.png',
                  );
                Big_Kit_Background2.anchor.setTo(0.5);
                Big_Kit_Background.addChild(Big_Kit_Background2);
                var Big_Kit_Background2 = game.add.sprite(0, 227 - 100, 'game_window2_atlas', 'Package_Background.png');
              }
              Big_Kit_Background2.anchor.setTo(0.5);
              Big_Kit_Background.addChild(Big_Kit_Background2);

              if (type == 0) {
                if (weekday_offers != -1) {
                  if (JQKA_offers == 0)
                    var Pair_Of_Jacks_Header = game.add.sprite(0, -272, 'game_window_atlas', 'Pair_Of_Jacks_Header.png');
                  else if (JQKA_offers == 1)
                    var Pair_Of_Jacks_Header = game.add.sprite(0, -272, 'game_window_atlas', 'Triple_Queens_Header.png');
                  else if (JQKA_offers == 2)
                    var Pair_Of_Jacks_Header = game.add.sprite(0, -272, 'game_window_atlas', 'Four_Kings_Header.png');
                  else if (JQKA_offers == 3)
                    var Pair_Of_Jacks_Header = game.add.sprite(0, -272, 'game_window_atlas', 'Only_Aces_Header.png');

                  Pair_Of_Jacks_Header.anchor.setTo(0.5, 1);
                  Big_Kit_Background.addChild(Pair_Of_Jacks_Header);
                }
              }

              if (type == 0) {
                var text_maxi = game.add.text(0, -310, spec_a[4][4]['packname'], {
                  font: '30px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
                text_maxi.anchor.setTo(0.5);
                text_maxi.stroke = '#1A6383';
                text_maxi.strokeThickness = 4;
                text_maxi.setShadow(0, 3, 'rgba(26,99,131,1)', 1);
                Big_Kit_Background.addChild(text_maxi);
              } else {
                if (spec_a[0][0]['type'] == '2_TNT_Pack.png') {
                  arc_text(
                    game.cache.getJSON('lang')['TNTPackage'][0][window.lang],
                    '40px',
                    0,
                    0,
                    0,
                    -270,
                    -5,
                    0,
                    Big_Kit_Background,
                    0,
                    20,
                    0,
                  );
                } else if (spec_a[0][0]['type'] == '2_Shuffle_Pack.png') {
                  if (window.lang == 'fr' || window.lang == 'it') {
                    arc_text(
                      game.cache.getJSON('lang')['ShufflePackage1'][0][window.lang],
                      '40px',
                      0,
                      0,
                      0,
                      -290,
                      -5,
                      0,
                      Big_Kit_Background,
                      0,
                      20,
                      0,
                    );
                    arc_text(
                      game.cache.getJSON('lang')['ShufflePackage2'][0][window.lang],
                      '40px',
                      0,
                      0,
                      0,
                      -250,
                      -5,
                      0,
                      Big_Kit_Background,
                      0,
                      20,
                      0,
                    );
                  } else {
                    arc_text(
                      game.cache.getJSON('lang')['ShufflePackage1'][0][window.lang],
                      '40px',
                      0,
                      0,
                      0,
                      -270,
                      -5,
                      0,
                      Big_Kit_Background,
                      0,
                      20,
                      0,
                    );
                  }
                } else if (spec_a[0][0]['type'] == '2_Random_Pack.png') {
                  arc_text(
                    game.cache.getJSON('lang')['CardRemoverPackage1'][0][window.lang],
                    '40px',
                    0,
                    0,
                    0,
                    -290,
                    -5,
                    0,
                    Big_Kit_Background,
                    0,
                    20,
                    0,
                  );
                  arc_text(
                    game.cache.getJSON('lang')['CardRemoverPackage2'][0][window.lang],
                    '40px',
                    0,
                    0,
                    0,
                    -250,
                    -5,
                    0,
                    Big_Kit_Background,
                    0,
                    20,
                    0,
                  );
                } else if (spec_a[0][0]['type'] == '+5_Cards.png') {
                  arc_text(
                    game.cache.getJSON('lang')['5CardsPackage'][0][window.lang],
                    '40px',
                    0,
                    0,
                    0,
                    -270,
                    -5,
                    0,
                    Big_Kit_Background,
                    0,
                    20,
                    0,
                  );
                } else if (spec_a[0][0]['type'] == 'Windmill.png') {
                  arc_text(
                    game.cache.getJSON('lang')['WindmillPackage'][0][window.lang],
                    '40px',
                    0,
                    0,
                    0,
                    -270,
                    -5,
                    0,
                    Big_Kit_Background,
                    0,
                    20,
                    0,
                  );
                } else if (spec_a[0][0]['type'] == 'Joker.png') {
                  arc_text(
                    game.cache.getJSON('lang')['JokerPackage'][0][window.lang],
                    '40px',
                    0,
                    0,
                    0,
                    -270,
                    -5,
                    0,
                    Big_Kit_Background,
                    0,
                    20,
                    0,
                  );
                } else if (spec_a[0][0]['type'] == 'List_Joker.png') {
                  arc_text(
                    game.cache.getJSON('lang')['JokerPackage'][0][window.lang],
                    '40px',
                    0,
                    0,
                    0,
                    -270,
                    -5,
                    0,
                    Big_Kit_Background,
                    0,
                    20,
                    0,
                  );
                } else if (spec_a[0][0]['type'] == 'magnifying_glass.png') {
                  arc_text(
                    game.cache.getJSON('lang')['MagPackage'][0][window.lang],
                    '40px',
                    0,
                    0,
                    0,
                    -270,
                    -5,
                    0,
                    Big_Kit_Background,
                    0,
                    20,
                    0,
                  );
                }
              }

              if (type == 0) {
                /*var Green_Background_Super_and_Maxi_Kit = game.add.sprite(
                  0,
                  -178,
                  'game_window2_atlas',
                  'Green_Background_Super_and_Maxi_Kit.png',
                );
                Green_Background_Super_and_Maxi_Kit.anchor.setTo(0.5);
                Big_Kit_Background.addChild(Green_Background_Super_and_Maxi_Kit);*/
                var Background_Rays = game.add.sprite(10, -180, 'game_window2_atlas', 'Background_Rays.png');
                Background_Rays.anchor.setTo(0.5);
                Background_Rays.scale.setTo(0.7);
                Big_Kit_Background.addChild(Background_Rays);
                rotate_tween(Background_Rays);
              }
              if (type == 0) {

                if (weekday_offers == -1) {
                  if (newDate.getDay() == 0)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Sunday_Pack.png');
                  else if (newDate.getDay() == 1)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Monday_Pack.png');
                  else if (newDate.getDay() == 2)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Thursday_Pack.png');
                  else if (newDate.getDay() == 3)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Wednesday_Pack.png');
                  else if (newDate.getDay() == 4)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Thursday_Pack.png');
                  else if (newDate.getDay() == 5)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Friday_Pack.png');
                  else if (newDate.getDay() == 6)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Saturday_Pack.png');
                } else {
                  if (JQKA_offers == 0)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Pair_Of_Jacks_Pack.png');
                  else if (JQKA_offers == 1)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Triple_Queens_Pack.png');
                  else if (JQKA_offers == 2)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Four_Kings_Pack.png');
                  else if (JQKA_offers == 3)
                    var Maxi_Kit_Pack = game.add.sprite(0, -180, 'game_window_atlas', 'Only_Aces_Park.png');
                }
                Maxi_Kit_Pack.anchor.setTo(0.5);
                Big_Kit_Background.addChild(Maxi_Kit_Pack);


              } else {
                if (spec_a[0][0]['type'] == '2_TNT_Pack.png') {
                  var Maxi_Kit_Pack = game.add.sprite(0, -90, 'game_window2_atlas', 'TNT_Package.png');
                } else if (spec_a[0][0]['type'] == '2_Shuffle_Pack.png') {
                  var Maxi_Kit_Pack = game.add.sprite(0, -90, 'game_window2_atlas', 'Shuffle_Package.png');
                } else if (spec_a[0][0]['type'] == '2_Random_Pack.png') {
                  var Maxi_Kit_Pack = game.add.sprite(0, -90, 'game_window2_atlas', 'Random_Package.png');
                } else if (spec_a[0][0]['type'] == '+5_Cards.png') {
                  var Maxi_Kit_Pack = game.add.sprite(0, -90, 'game_window_atlas', '+5_Cards.png');
                } else if (spec_a[0][0]['type'] == 'Windmill.png') {
                  var Maxi_Kit_Pack = game.add.sprite(0, -90, 'game_window_atlas', 'Windmill.png');
                } else if (spec_a[0][0]['type'] == 'Joker.png') {
                  var Maxi_Kit_Pack = game.add.sprite(0, -90, 'game_window_atlas', 'Joker.png');
                } else if (spec_a[0][0]['type'] == 'List_Joker.png') {
                  var Maxi_Kit_Pack = game.add.sprite(0, -90, 'game_window2_atlas', 'Jocker_Package.png');
                } else if (spec_a[0][0]['type'] == 'magnifying_glass.png') {
                  var Maxi_Kit_Pack = game.add.sprite(0, -90, 'baloon_atlas', 'Magnifier_Package.png');
                }
                Maxi_Kit_Pack.anchor.setTo(0.5);
                Big_Kit_Background.addChild(Maxi_Kit_Pack);
              }

              if (type == 0)
                var Big_Kits_List_Background = game.add.sprite(
                  0,
                  70,
                  'game_window_atlas',
                  'Big_Kits_List_Background.png',
                );
              else var Big_Kits_List_Background = game.add.sprite(0, 70, '');
              Big_Kits_List_Background.anchor.setTo(0.5);
              Big_Kit_Background.addChild(Big_Kits_List_Background);
              for (var i = 0; i < 4; i++) {
                if (spec_a[i][i]['type'] != 0) {
                  if (type == 0) {
                    var Big_Kit_List_Coin = game.add.sprite(
                      -70,
                      -112 + i * 77,
                      spec_a[i][i]['atlas'],
                      spec_a[i][i]['type'],
                    );
                    if (Big_Kit_List_Coin.width > 70) {
                      Big_Kit_List_Coin.scale.setTo(60 / Big_Kit_List_Coin.width);
                    }
                    Big_Kit_List_Coin.anchor.setTo(0.5);
                    Big_Kits_List_Background.addChild(Big_Kit_List_Coin);
                    var Big_Kit_List_Coin_text = game.add.text(-30, -112 + i * 77, spec_a[i][i]['col'], {
                      font: '42px RussoOne',
                      fill: '#1B617D',
                      align: 'left',
                    });
                    Big_Kit_List_Coin_text.anchor.setTo(0, 0.5);
                    Big_Kit_List_Coin_text.stroke = '#fff';
                    Big_Kit_List_Coin_text.strokeThickness = 4;
                    Big_Kits_List_Background.addChild(Big_Kit_List_Coin_text);
                  } else {
                    if (i == 0 || i == 1) {
                      var drawRect1 = game.add.graphics(40, 110 + i * 65 + 2);
                      Big_Kits_List_Background.addChild(drawRect1);
                      drawRect1.beginFill(0xffffff, 1);
                      var drawRect = game.add.graphics(40, 110 + i * 65);
                      Big_Kits_List_Background.addChild(drawRect);
                      drawRect.beginFill(0xeedeba, 1);
                      var Big_Kit_List_Coin = game.add.sprite(
                        0,
                        110 + i * 65,
                        spec_a[i][i]['atlas'],
                        spec_a[i][i]['type'],
                      );
                      if (Big_Kit_List_Coin.width > 70) {
                        Big_Kit_List_Coin.scale.setTo(60 / Big_Kit_List_Coin.width);
                      }
                      Big_Kit_List_Coin.anchor.setTo(0.5);
                      Big_Kits_List_Background.addChild(Big_Kit_List_Coin);
                      var Big_Kit_List_Coin_text = game.add.text(40, 110 + i * 65, spec_a[i][i]['col'], {
                        font: '36px RussoOne',
                        fill: '#1B617D',
                        align: 'left',
                      });
                      Big_Kit_List_Coin_text.anchor.setTo(0, 0.5);
                      Big_Kit_List_Coin_text.stroke = '#fff';
                      Big_Kit_List_Coin_text.strokeThickness = 4;
                      Big_Kits_List_Background.addChild(Big_Kit_List_Coin_text);
                      Big_Kit_List_Coin.x -= (Big_Kit_List_Coin.width / 2 + Big_Kit_List_Coin_text.width) / 2;
                      Big_Kit_List_Coin_text.x -= (Big_Kit_List_Coin.width / 2 + Big_Kit_List_Coin_text.width) / 2;
                      drawRect.drawRoundedRect(0, 0, Big_Kit_List_Coin_text.width * 1.8, 50, 50);
                      drawRect.x -= Big_Kit_List_Coin_text.width + 15;
                      drawRect.y -= Big_Kit_List_Coin_text.height / 2 + 3;
                      drawRect1.drawRoundedRect(0, 0, Big_Kit_List_Coin_text.width * 1.8, 50, 50);
                      drawRect1.x -= Big_Kit_List_Coin_text.width + 15;
                      drawRect1.y -= Big_Kit_List_Coin_text.height / 2 + 3;
                    } else {
                      if (i == 2) {
                        var drawRect1 = game.add.graphics(spec_a[3][3]['type'] != 0 ? -60 : 15, 110 + 2 * 65 + 2);
                        Big_Kits_List_Background.addChild(drawRect1);
                        drawRect1.beginFill(0xffffff, 1);
                        var drawRect = game.add.graphics(spec_a[3][3]['type'] != 0 ? -60 : 15, 110 + 2 * 65);
                        Big_Kits_List_Background.addChild(drawRect);
                        drawRect.beginFill(0xeedeba, 1);
                        var Big_Kit_List_Coin = game.add.sprite(
                          spec_a[3][3]['type'] != 0 ? -100 : -25,
                          110 + 2 * 65,
                          spec_a[i][i]['atlas'],
                          spec_a[i][i]['type'],
                        );
                        if (Big_Kit_List_Coin.width > 70) {
                          Big_Kit_List_Coin.scale.setTo(60 / Big_Kit_List_Coin.width);
                        }
                        Big_Kit_List_Coin.anchor.setTo(0.5);
                        Big_Kits_List_Background.addChild(Big_Kit_List_Coin);
                        var Big_Kit_List_Coin_text = game.add.text(spec_a[3][3]['type'] != 0 ? -60 : 15, 110 + 2 * 65, spec_a[i][i]['col'], {
                          font: '36px RussoOne',
                          fill: '#1B617D',
                          align: 'left',
                        });
                        Big_Kit_List_Coin_text.anchor.setTo(0, 0.5);
                        Big_Kit_List_Coin_text.stroke = '#fff';
                        Big_Kit_List_Coin_text.strokeThickness = 4;
                        Big_Kits_List_Background.addChild(Big_Kit_List_Coin_text);
                        drawRect.drawRoundedRect(0, 0, Big_Kit_List_Coin_text.width * 2.4, 50, 50);
                        drawRect.x -= Big_Kit_List_Coin_text.width + 5;
                        drawRect.y -= Big_Kit_List_Coin_text.height / 2 + 3;
                        drawRect1.drawRoundedRect(0, 0, Big_Kit_List_Coin_text.width * 2.4, 50, 50);
                        drawRect1.x -= Big_Kit_List_Coin_text.width + 5;
                        drawRect1.y -= Big_Kit_List_Coin_text.height / 2 + 3;
                      } else {
                        var drawRect1 = game.add.graphics(80, 110 + 2 * 65 + 2);
                        Big_Kits_List_Background.addChild(drawRect1);
                        drawRect1.beginFill(0xffffff, 1);
                        var drawRect = game.add.graphics(80, 110 + 2 * 65);
                        Big_Kits_List_Background.addChild(drawRect);
                        drawRect.beginFill(0xeedeba, 1);
                        var Big_Kit_List_Coin = game.add.sprite(
                          40,
                          110 + 2 * 65,
                          spec_a[i][i]['atlas'],
                          spec_a[i][i]['type'],
                        );
                        if (Big_Kit_List_Coin.width > 70) {
                          Big_Kit_List_Coin.scale.setTo(60 / Big_Kit_List_Coin.width);
                        }
                        Big_Kit_List_Coin.anchor.setTo(0.5);
                        Big_Kits_List_Background.addChild(Big_Kit_List_Coin);
                        var Big_Kit_List_Coin_text = game.add.text(80, 110 + 2 * 65, spec_a[i][i]['col'], {
                          font: '36px RussoOne',
                          fill: '#1B617D',
                          align: 'left',
                        });
                        Big_Kit_List_Coin_text.anchor.setTo(0, 0.5);
                        Big_Kit_List_Coin_text.stroke = '#fff';
                        Big_Kit_List_Coin_text.strokeThickness = 4;
                        Big_Kits_List_Background.addChild(Big_Kit_List_Coin_text);
                        drawRect.drawRoundedRect(0, 0, Big_Kit_List_Coin_text.width * 2.4, 50, 50);
                        drawRect.x -= Big_Kit_List_Coin_text.width + 5;
                        drawRect.y -= Big_Kit_List_Coin_text.height / 2 + 3;
                        drawRect1.drawRoundedRect(0, 0, Big_Kit_List_Coin_text.width * 2.4, 50, 50);
                        drawRect1.x -= Big_Kit_List_Coin_text.width + 5;
                        drawRect1.y -= Big_Kit_List_Coin_text.height / 2 + 3;
                      }
                    }
                  }
                }
              }
              if (type == 0) var Big_Kit_Button = game.add.sprite(0, 290, 'game_window_atlas', 'Big_Kit_Button.png');
              else var Big_Kit_Button = game.add.sprite(0, 90, 'game_window_atlas', 'Big_Kit_Button.png');
              Big_Kit_Button.anchor.setTo(0.5);
              Big_Kit_Button.bid = spec_a[4][i]['id'];
              Big_Kit_Button.bname = spec_a[4][i]['packname'];
              Big_Kit_Button.breward = spec_a[4][i]['reward'];
              Big_Kit_Button.iii = i;
              button_animation_f(Big_Kit_Button, 1);
              Big_Kit_Button.input.priorityID = 100;
              Big_Kit_Button.events.onInputUp.add(function (item_b) {
                btnup(item_b);
                if (popup != 2 && FTUE != 41.4) {
                  popup = 2;
                  if (sound_on == 1) {
                    play_sound('button_X');
                  }
                  if (fbv == 1) {
                    game.setCurrentEvent();
                    window.eventTrack(item_b.bid + '_initiated');
                    window.eventTrack('soga_purchase_initiated', 1, {
                      package_id: item_b.bid,
                      value: spec_a[4][item_b.iii]['price'],
                      current_level: level_button.n,
                      conversion: 1 - bought,
                      user_type: bought,
                      lifetime: lifetime_day,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                  }
                  loading();
                  if (animation == 100) {
                    if (bought == 0) {
                      bought_f = 1;
                    }
                    if (fbv == 1) {
                      game.setCurrentEvent();
                      window.eventTrack(item_b.bid + '_successfull');
                      window.eventTrack('soga_purchase_successfull', 1, {
                        package_id: item_b.bid,
                        value: spec_a[4][item_b.iii]['price'],
                        current_level: level_button.n,
                        conversion: 1 - bought,
                        first_purchase: bought_f,
                        lifetime: lifetime_day,
                        highest_lvl: all_level.lastIndexOf(3) + 2,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                    }
                    if (loading_black_sprite != 0) {
                      loading_black_sprite.destroy();
                      loading_black_sprite = 0;
                    }
                    if (loading_text != 0 && loading_text != 1) {
                      loading_text.destroy();
                      loading_text = 0;
                    }
                    game.add
                      .tween(black_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(popup_group)
                      .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                      .onComplete.add(function (item) {
                        popup_group.removeAll(true);
                        popup = 0;
                        popup_group.y -= game.camera.height;
                        wheel_icon_text = 0;
                        missions_tab_open = 0;
                        animation = 0;
                        if (type == 0 && weekday_offers == -1) { weekday_offers = newDate.getDay(); game.setUserDataAndLog({ weekday_offers: weekday_offers }); } else
                          if (type == 0 && weekday_offers != -1) { if (JQKA_offers < 3) { JQKA_offers += 1; } else { JQKA_offers = 0; } game.setUserDataAndLog({ JQKA_offers: JQKA_offers }); }
                        bought = 1;
                        bought_f = 0;
                        game.setUserDataAndLog({ bought: bought });
                        chest_open_window(
                          game.cache.getJSON('lang')['Reward!'][0][window.lang],
                          item_b.breward,
                          51,
                          void 0,
                          {
                            // gameArea: DdnaGameArea.Map,
                            // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                            // productId: item_b.bid,
                            gameArea: null,
                            actionType: null,
                            productId: 0,
                          },
                        );
                        source_chest = 'Package';
                        package_id_chest = item_b.bid;
                      });
                  }
                  // else
                  //   purchaseAsync(
                  //     {
                  //       productID: item_b.bid,
                  //       developerPayload: item_b.bname,
                  //     },
                  //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                  //   )
                  //     .then(function (purchase) {
                  //       if (bought == 0) {
                  //         bought_f = 1;
                  //       }
                  //       if (fbv == 1) {
                  //         game.setCurrentEvent();
                  //         window.eventTrack(item_b.bid + '_successfull');
                  //         window.eventTrack('soga_purchase_successfull', 1, {
                  //           package_id: item_b.bid,
                  //           value: spec_a[4][item_b.iii]['price'],
                  //           current_level: level_button.n,
                  //           conversion: 1 - bought,
                  //           first_purchase: bought_f,
                  //           lifetime: lifetime_day,
                  //           highest_lvl: all_level.lastIndexOf(3) + 2,
                  //           mission_completed: missioncompleted,
                  //           c_event: current_event,
                  //         });
                  //       }
                  //       if (loading_black_sprite != 0) {
                  //         loading_black_sprite.destroy();
                  //         loading_black_sprite = 0;
                  //       }
                  //       if (loading_text != 0 && loading_text != 1) {
                  //         loading_text.destroy();
                  //         loading_text = 0;
                  //       }
                  //       game.add
                  //         .tween(black_sprite)
                  //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  //         .onComplete.add(function (item) {
                  //           item.destroy();
                  //         });
                  //       game.add
                  //         .tween(popup_group)
                  //         .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  //         .onComplete.add(function (item) {
                  //           popup_group.removeAll(true);
                  //           popup = 0;
                  //           popup_group.y -= game.camera.height;
                  //           wheel_icon_text = 0;
                  //           missions_tab_open = 0;
                  //           bought = 1;
                  //           bought_f = 0;
                  //           if (type == 0 && weekday_offers == -1) { weekday_offers = newDate.getDay(); game.setUserDataAndLog({ weekday_offers: weekday_offers }); } else
                  //             if (type == 0 && weekday_offers != -1) { if (JQKA_offers < 3) { JQKA_offers += 1; } else { JQKA_offers = 0; } game.setUserDataAndLog({ JQKA_offers: JQKA_offers }); }
                  //           game.setUserDataAndLog({ bought: bought });
                  //           chest_open_window(
                  //             game.cache.getJSON('lang')['Reward!'][0][window.lang],
                  //             item_b.breward,
                  //             51,
                  //             void 0,
                  //             {
                  //               // gameArea: DdnaGameArea.Map,
                  //               // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                  //               // productId: item_b.bid,
                  //               gameArea: null,
                  //               actionType: null,
                  //               productId: 0,
                  //             },
                  //           );
                  //           source_chest = 'Package';
                  //           package_id_chest = item_b.bid;
                  //         });
                  //       // FBInstant.payments
                  //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                  //       //   .then(function () {})
                  //       //   .catch(function (error) {});
                  //     })
                  //     .catch(function (error) {
                  //       if (fbv == 1) {
                  //         game.setCurrentEvent();
                  //         window.eventTrack('soga_purchase_failed', 1, {
                  //           package_id: item_b.bid,
                  //           value: spec_a[4][item_b.iii]['price'],
                  //           current_level: level_button.n,
                  //           conversion: 1 - bought,
                  //           user_type: bought,
                  //           lifetime: lifetime_day,
                  //           mission_completed: missioncompleted,
                  //           c_event: current_event,
                  //         });
                  //       }
                  //       console.log(error);
                  //       if (loading_black_sprite != 0) {
                  //         loading_black_sprite.destroy();
                  //         loading_black_sprite = 0;
                  //       }
                  //       if (loading_text != 0 && loading_text != 1) {
                  //         loading_text.destroy();
                  //         loading_text = 0;
                  //       }
                  //       button_click = 0;
                  //       popup = 1;
                  //     });
                }
              });
              Big_Kit_Background.addChild(Big_Kit_Button);
              var Big_Kit_Button_text = game.add.text(
                0,
                0,
                payments_catalog[
                payments_catalog.findIndex(function (e) {
                  return e['productID'] == spec_a[4][i]['id'];
                })
                ]['price'],
                { font: '42px RussoOne', fill: '#fff', align: 'center' },
              );
              Big_Kit_Button_text.anchor.setTo(0.5);
              Big_Kit_Button_text.stroke = '#47740D';
              Big_Kit_Button_text.strokeThickness = 4;
              Big_Kit_Button_text.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
              Big_Kit_Button.addChild(Big_Kit_Button_text);

            }

            var popup_close = game.add.sprite(game.camera.width + 100, 100, 'game_window_atlas', 'Close_Button.png');
            popup_close.anchor.setTo(0.5);
            button_animation_f(popup_close, 1);
            popup_close.input.priorityID = 100;
            popup_close.events.onInputUp.add(function () {
              if (popup != 2 && FTUE != 41.4) {
                if (fbv == 1 && (FTUE == 41.5 || FTUE == 41)) {
                  FTUE_process();
                  window.eventTrack('FTUE_15_7User_closes_shop');
                }
                popup = 2;
                if (sound_on == 1) {
                  play_sound('button_X');
                }
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                if (special_stage != 0) {
                  bottom_button(0, 0, 0, UI_bottom_group, -1, 1);
                }
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    animation = 0;
                    missions_tab_open = 0;
                    wheel_icon_text = 0;
                    popup_group.y -= game.camera.height;
                    if (special_stage != 0) {
                      build_special_object(special_stage, 1);
                    }
                  });
              }
            }, this);
            popup_group.add(popup_close);
            popup_close.fixedToCamera = true;
            game.add.tween(popup_close.cameraOffset).to({ x: '-200' }, 500, Phaser.Easing.Exponential.Out, true);
            if (type == 0) {
              var text_popup_title = game.add.text(
                game.camera.width / 2,
                game.camera.height / 2 - 340,
                game.cache.getJSON('lang')['t272'][0][window.lang],
                { font: '86px RussoOne', fill: '#fff', align: 'center' },
              );
              text_popup_title.anchor.setTo(0, 0.5);
              text_popup_title.stroke = '#1A6383';
              text_popup_title.strokeThickness = 4;
              text_popup_title.setShadow(0, 4, 'rgba(26,99,131,1)', 1);
              popup_group.add(text_popup_title);
              text_popup_title.alpha = 0;
              text_popup_title.fixedToCamera = true;
              game.add.tween(text_popup_title).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true);
              var popup_title_icon = game.add.sprite(
                game.camera.width / 2 + text_popup_title.width + 10,
                game.camera.height / 2 - 340,
                'game_ui_atlas',
                'Coin_Icon.png',
              );
              popup_title_icon.anchor.setTo(0, 0.5);
              popup_group.add(popup_title_icon);
              popup_title_icon.fixedToCamera = true;
              var text_popup_title2 = game.add.text(
                game.camera.width / 2 + text_popup_title.width + popup_title_icon.width + 20,
                game.camera.height / 2 - 340,
                game.cache.getJSON('lang')['t273'][0][window.lang],
                { font: '86px RussoOne', fill: '#fff', align: 'center' },
              );
              text_popup_title2.anchor.setTo(0, 0.5);
              text_popup_title2.stroke = '#1A6383';
              text_popup_title2.strokeThickness = 4;
              text_popup_title2.setShadow(0, 4, 'rgba(26,99,131,1)', 1);
              popup_group.add(text_popup_title2);
              text_popup_title2.fixedToCamera = true;
              text_popup_title.cameraOffset.x -=
                (text_popup_title.width + text_popup_title2.width + popup_title_icon.width + 20) / 2;
              popup_title_icon.cameraOffset.x -=
                (text_popup_title.width + text_popup_title2.width + popup_title_icon.width + 20) / 2;
              text_popup_title2.cameraOffset.x -=
                (text_popup_title.width + text_popup_title2.width + popup_title_icon.width + 20) / 2;
            } else {
              let text_sprite = game.cache.getJSON('lang')['TNTBOOSTERSP'][0][window.lang];
              let text_text = game.cache.getJSON('lang')['TNTBOOSTERStextP'][0][window.lang];
              if (spec_a[0][0]['type'] == '2_TNT_Pack.png') {
                text_sprite = game.cache.getJSON('lang')['TNTBOOSTERSP'][0][window.lang];
                text_text = game.cache.getJSON('lang')['TNTBOOSTERStextP'][0][window.lang];
              } else if (spec_a[0][0]['type'] == '2_Shuffle_Pack.png') {
                text_sprite = game.cache.getJSON('lang')['ShuffleBoosterP'][0][window.lang];
                text_text = game.cache.getJSON('lang')['ShuffleBoosterTextP'][0][window.lang];
              } else if (spec_a[0][0]['type'] == '2_Random_Pack.png') {
                text_sprite = game.cache.getJSON('lang')['CardRemoverP'][0][window.lang];
                text_text = game.cache.getJSON('lang')['CardRemoverTextP'][0][window.lang];
              } else if (spec_a[0][0]['type'] == '+5_Cards.png') {
                text_sprite = game.cache.getJSON('lang')['5CardsP'][0][window.lang];
                text_text = game.cache.getJSON('lang')['5CardsTextP'][0][window.lang];
              } else if (spec_a[0][0]['type'] == 'Windmill.png') {
                text_sprite = game.cache.getJSON('lang')['WindmillP'][0][window.lang];
                text_text = game.cache.getJSON('lang')['WindmillTextP'][0][window.lang];
              } else if (spec_a[0][0]['type'] == 'Joker.png') {
                text_sprite = game.cache.getJSON('lang')['JokerP'][0][window.lang];
                text_text = game.cache.getJSON('lang')['JokerTextP'][0][window.lang];
              } else if (spec_a[0][0]['type'] == 'List_Joker.png') {
                text_sprite = game.cache.getJSON('lang')['JokerCardsP'][0][window.lang];
                text_text = game.cache.getJSON('lang')['JokerCardsTextP'][0][window.lang];
              } else if (spec_a[0][0]['type'] == 'magnifying_glass.png') {
                text_sprite = game.cache.getJSON('lang')['MagCardsP'][0][window.lang];
                text_text = game.cache.getJSON('lang')['MagCardsTextP'][0][window.lang];
              }
              arc_text(
                text_sprite,
                '100px',
                0,
                0,
                game.camera.width / 2,
                game.camera.height / 2 - 400,
                -8,
                1,
                0,
                0,
                50,
                popup_group,
              );
              var text_popup_title = game.add.text(game.camera.width / 2, game.camera.height / 2 - 320, text_text, {
                font: '28px RussoOne',
                fill: '#fff',
                align: 'center',
              });
              text_popup_title.anchor.setTo(0.5);
              popup_group.add(text_popup_title);
              text_popup_title.alpha = 0;
              text_popup_title.fixedToCamera = true;
              game.add.tween(text_popup_title).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true, 400);
            }
            var t = 1;
            shop_open = 1;
            for (var j = 0; j < 2; j++)
              for (var i = 0; i < 2; i++) {
                if (i > 2) {
                  j = 1;
                }
                if (type == 1 && t == 4)
                  var popup_shop_section = game.add.sprite(
                    shop != 0 ? game.camera.width / 2 + 200 + i * 300 - sdvig : game.camera.width / 2 + 200 + i * 300 - 360,
                    game.camera.height / 2 - 78 + j * 390,
                    'game_window2_atlas',
                    'More_Pack_Background.png',
                  );
                else
                  var popup_shop_section = game.add.sprite(
                    shop != 0 ? game.camera.width / 2 + 200 + i * 300 - sdvig : game.camera.width / 2 + 200 + i * 300 - 360,
                    game.camera.height / 2 - 78 + j * 390,
                    'game_window_atlas',
                    'Coins_Pack_Background.png',
                  );
                popup_shop_section.anchor.setTo(0.5);
                popup_group.add(popup_shop_section);
                popup_shop_section.fixedToCamera = true;
                popup_shop_section.scale.setTo(0);
                if (t != 6) {
                  var ppp = other_a[t - 1][t - 1]['col'];
                  var p_id = other_a[t - 1][t - 1]['id'];
                  var p_tx = other_a[t - 1][t - 1]['packname'];
                  if (t == 1 && shop_free == 1 && type == 0) {
                    ppp = '50';
                  }
                  if (shop_free == 1 && t == 1 && type == 0) {
                    var Green_Background_Free_Gift = game.add.sprite(
                      0,
                      -50,
                      'game_window2_atlas',
                      'Green_Background_Free_Gift.png',
                    );
                    Green_Background_Free_Gift.anchor.setTo(0.5);
                    popup_shop_section.addChild(Green_Background_Free_Gift);
                    var Background_Rays = game.add.sprite(0, -55, 'game_window2_atlas', 'Background_Rays.png');
                    Background_Rays.anchor.setTo(0.5);
                    Background_Rays.scale.setTo(0.7);
                    popup_shop_section.addChild(Background_Rays);
                    rotate_tween(Background_Rays);
                    var Gift = game.add.sprite(0, -50, 'game_window2_atlas', 'Gift.png');
                    Gift.anchor.setTo(0.5);
                    popup_shop_section.addChild(Gift);
                  } else if (type == 0 || (type == 1 && t < 4)) {
                    if (type == 0) {
                      var Coins_Pack_Back_Rays = game.add.sprite(0, -94, 'game_window2_atlas', 'Background_Rays.png');
                      Coins_Pack_Back_Rays.anchor.setTo(0.5);
                      Coins_Pack_Back_Rays.scale.setTo(0.6);
                      popup_shop_section.addChild(Coins_Pack_Back_Rays);
                      rotate_tween(Coins_Pack_Back_Rays);
                    }
                    if (type == 0)
                      var popup_item1_icon = game.add.sprite(
                        0,
                        -84,
                        other_a[t - 1][t - 1]['atlas'],
                        other_a[t - 1][t - 1]['type'],
                      );
                    else
                      var popup_item1_icon = game.add.sprite(
                        0,
                        -90,
                        other_a[t - 1][t - 1]['atlas'],
                        other_a[t - 1][t - 1]['type'],
                      );
                    popup_item1_icon.anchor.setTo(0.5);
                    popup_item1_icon.scale.setTo(0.9);
                    popup_shop_section.addChild(popup_item1_icon);
                    var Coins_Pack_Coins_Amount = game.add.sprite(
                      0,
                      30,
                      'game_window_atlas',
                      'Coins_Pack_Coins_Amount.png',
                    );
                    Coins_Pack_Coins_Amount.anchor.setTo(0.5);
                    popup_shop_section.addChild(Coins_Pack_Coins_Amount);
                    var Coins_Kit_Coins_Amount_Coin = game.add.sprite(
                      -60,
                      30,
                      other_a[t - 1][t - 1]['atlas'],
                      other_a[t - 1][t - 1]['sprite'],
                    );
                    if (Coins_Kit_Coins_Amount_Coin.width > 70) {
                      Coins_Kit_Coins_Amount_Coin.scale.setTo(60 / Coins_Kit_Coins_Amount_Coin.width);
                    }
                    Coins_Kit_Coins_Amount_Coin.anchor.setTo(0.5);
                    popup_shop_section.addChild(Coins_Kit_Coins_Amount_Coin);
                    var popup_item1_num = game.add.text(30, 30, ppp, {
                      font: '32px RussoOne',
                      fill: '#1B617D',
                      align: 'center',
                    });
                    popup_item1_num.anchor.setTo(0.5);
                    popup_item1_num.stroke = '#fff';
                    popup_item1_num.strokeThickness = 4;
                    popup_shop_section.addChild(popup_item1_num);
                  } else {
                    var popup_item1_icon = game.add.sprite(0, -50, 'game_window2_atlas', 'TNT_More_Pack.png');
                    popup_item1_icon.anchor.setTo(0.5);
                    popup_shop_section.addChild(popup_item1_icon);
                  }
                  var popup_item1_button = game.add.sprite(0, 110, 'game_window_atlas', 'Coins_Pack_Button.png');
                  popup_item1_button.anchor.setTo(0.5);
                  popup_shop_section.addChild(popup_item1_button);
                  popup_item1_button.inputEnabled = true;
                  popup_item1_button.scl = 1;
                  popup_item1_button.ttt = t;
                  popup_item1_button.p_id = p_id;
                  popup_item1_button.p_tx = p_tx;
                  popup_item1_button.breward = other_a[t - 1][t - 1]['reward'];
                  popup_item1_button.input.useHandCursor = true;
                  popup_item1_button.input.priorityID = 100;
                  popup_item1_button.events.onInputOver.add(btnover, this);
                  popup_item1_button.events.onInputOut.add(btnout, this);
                  popup_item1_button.events.onInputDown.add(btnclick, this);
                  popup_item1_button.events.onInputUp.add(function (item) {
                    if (button_click == 1 && shop_open == 1) {
                      btnup(item);
                      if (popup != 2) {
                        if (sound_on == 1) {
                          play_sound('button_X');
                        }
                        if (
                          (type == 0 && FTUE != 41.4 && (shop_free == 0 || (shop_free != 0 && item.ttt != 1))) ||
                          (type == 1 && item.ttt != 4)
                        ) {
                          popup = 2;
                          if (fbv == 1) {
                            game.setCurrentEvent();
                            window.eventTrack(item.p_id + '_initiated');
                            window.eventTrack('soga_purchase_initiated', 1, {
                              package_id: item.p_id,
                              value: other_a[item.ttt - 1][item.ttt - 1]['price'],
                              current_level: level_button.n,
                              conversion: 1 - bought,
                              user_type: bought,
                              lifetime: lifetime_day,
                              mission_completed: missioncompleted,
                              c_event: current_event,
                            });
                          }
                          loading();
                          if (animation == 100) {
                            if (bought == 0) {
                              bought_f = 1;
                            }
                            if (fbv == 1) {
                              game.setCurrentEvent();
                              window.eventTrack(item.p_id + '_successfull');
                              window.eventTrack('soga_purchase_successfull', 1, {
                                package_id: item.p_id,
                                value: other_a[item.ttt - 1][item.ttt - 1]['price'],
                                current_level: level_button.n,
                                conversion: 1 - bought,
                                first_purchase: bought_f,
                                lifetime: lifetime_day,
                                highest_lvl: all_level.lastIndexOf(3) + 2,
                                mission_completed: missioncompleted,
                                c_event: current_event,
                              });
                            }
                            if (loading_black_sprite != 0) {
                              loading_black_sprite.destroy();
                              loading_black_sprite = 0;
                            }
                            if (loading_text != 0 && loading_text != 1) {
                              loading_text.destroy();
                              loading_text = 0;
                            }
                            game.add
                              .tween(black_sprite)
                              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                              .onComplete.add(function (itm) {
                                itm.destroy();
                              });
                            game.add
                              .tween(popup_group)
                              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                              .onComplete.add(function () {
                                popup_group.removeAll(true);
                                popup = 0;
                                popup_group.y -= game.camera.height;
                                wheel_icon_text = 0;
                                missions_tab_open = 0;
                                animation = 0;
                                bought = 1;
                                bought_f = 0;
                                game.setUserDataAndLog({ bought: bought });
                                chest_open_window(
                                  game.cache.getJSON('lang')['Reward!'][0][window.lang],
                                  item.breward,
                                  51,
                                  void 0,
                                  {
                                    // gameArea: DdnaGameArea.Map,
                                    // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                                    // productId: item.p_id,
                                    gameArea: null,
                                    actionType: null,
                                    productId: 0,
                                  },
                                );
                                source_chest = 'Package';
                                package_id_chest = item.p_id;
                              });
                          } if (shop == 0) {

                            var new_price = (other_a[item.ttt - 1][item.ttt - 1]['sprite'] == '+5_Cards.png') ? ((item.ttt == 1) ? 1500 : (item.ttt == 2) ? 2500 : 3200) : (other_a[item.ttt - 1][item.ttt - 1]['sprite'] == 'Windmill.png') ? ((item.ttt == 1) ? 1800 : (item.ttt == 2) ? 3000 : 4000) : ((item.ttt == 1) ? 2400 : (item.ttt == 2) ? 4000 : 5600)

                            if (coins >= new_price) {
                              coins -= new_price;
                              text_coins_panel.setText(coins);
                              game.setUserDataAndLog({
                                currencies: coins,
                              });
                              game.setCurrentEvent();
                              window.eventTrack('coins_out', new_price, {
                                user_type: bought,
                                lifetime: lifetime_day,
                                highest_lvl: all_level.lastIndexOf(3) + 2,
                                amount: new_price,
                                source: 'Buy Pre-Level Power Ups',
                                item_id: 0,
                                mission_completed: missioncompleted,
                                c_event: current_event,
                              });

                              if (loading_black_sprite != 0) {
                                loading_black_sprite.destroy();
                                loading_black_sprite = 0;
                              }
                              if (loading_text != 0 && loading_text != 1) {
                                loading_text.destroy();
                                loading_text = 0;
                              }
                              game.add
                                .tween(black_sprite)
                                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                                .onComplete.add(function (itm) {
                                  itm.destroy();
                                });
                              game.add
                                .tween(popup_group)
                                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                                .onComplete.add(function () {
                                  popup_group.removeAll(true);
                                  popup = 0;
                                  popup_group.y -= game.camera.height;
                                  wheel_icon_text = 0;
                                  missions_tab_open = 0;
                                  animation = 0;
                                  bought = 1;
                                  bought_f = 0;
                                  game.setUserDataAndLog({ bought: bought });
                                  chest_open_window(
                                    game.cache.getJSON('lang')['Reward!'][0][window.lang],
                                    item.breward,
                                    51,
                                    void 0,
                                    {
                                      // gameArea: DdnaGameArea.Map,
                                      // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                                      // productId: item.p_id,
                                      gameArea: null,
                                      actionType: null,
                                      productId: 0,
                                    },
                                  );
                                  source_chest = 'Package';
                                  package_id_chest = item.p_id;
                                });
                            }
                            else {
                              if (loading_black_sprite != 0) {
                                loading_black_sprite.destroy();
                                loading_black_sprite = 0;
                              }
                              if (loading_text != 0 && loading_text != 1) {
                                loading_text.destroy();
                                loading_text = 0;
                              }
                              game.add
                                .tween(black_sprite)
                                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                                .onComplete.add(function (itm) {
                                  itm.destroy();
                                });
                              game.add
                                .tween(popup_group)
                                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                                .onComplete.add(function () {
                                  popup_group.removeAll(true);
                                  popup = 0;
                                  popup_group.y -= game.camera.height;
                                  wheel_icon_text = 0;
                                  missions_tab_open = 0;
                                  animation = 0;
                                  get_message(2);
                                });
                            }


                          }
                          // else
                          //   purchaseAsync(
                          //     {
                          //       productID: item.p_id,
                          //       developerPayload: item.p_tx,
                          //     },
                          //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                          //   )
                          //     .then(function (purchase) {
                          //       if (purchase['productID'] == item.p_id) {
                          //         if (bought == 0) {
                          //           bought_f = 1;
                          //         }
                          //         if (fbv == 1) {
                          //           game.setCurrentEvent();
                          //           window.eventTrack(item.p_id + '_successfull');
                          //           window.eventTrack('soga_purchase_successfull', 1, {
                          //             package_id: item.p_id,
                          //             value: other_a[item.ttt - 1][item.ttt - 1]['price'],
                          //             current_level: level_button.n,
                          //             conversion: 1 - bought,
                          //             first_purchase: bought_f,
                          //             lifetime: lifetime_day,
                          //             highest_lvl: all_level.lastIndexOf(3) + 2,
                          //             mission_completed: missioncompleted,
                          //             c_event: current_event,
                          //           });
                          //         }
                          //         if (loading_black_sprite != 0) {
                          //           loading_black_sprite.destroy();
                          //           loading_black_sprite = 0;
                          //         }
                          //         if (loading_text != 0 && loading_text != 1) {
                          //           loading_text.destroy();
                          //           loading_text = 0;
                          //         }
                          //         game.add
                          //           .tween(black_sprite)
                          //           .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                          //           .onComplete.add(function (itm) {
                          //             itm.destroy();
                          //           });
                          //         game.add
                          //           .tween(popup_group)
                          //           .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                          //           .onComplete.add(function () {
                          //             popup_group.removeAll(true);
                          //             popup = 0;
                          //             popup_group.y -= game.camera.height;
                          //             wheel_icon_text = 0;
                          //             missions_tab_open = 0;
                          //             bought = 1;
                          //             bought_f = 0;
                          //             game.setUserDataAndLog({ bought: bought });
                          //             chest_open_window(
                          //               game.cache.getJSON('lang')['Reward!'][0][window.lang],
                          //               item.breward,
                          //               51,
                          //               void 0,
                          //               {
                          //                 // gameArea: DdnaGameArea.Map,
                          //                 // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                          //                 // productId: item.p_id,
                          //                 gameArea: null,
                          //                 actionType: null,
                          //                 productId: 0,
                          //               },
                          //             );
                          //             source_chest = 'Package';
                          //             package_id_chest = item.p_id;
                          //           });
                          //         // FBInstant.payments
                          //         //   .consumePurchaseAsync(purchase['purchaseToken'])
                          //         //   .then(function () {})
                          //         //   .catch(function (error) {});
                          //       }
                          //     })
                          //     .catch(function (error) {
                          //       if (fbv == 1) {
                          //         game.setCurrentEvent();
                          //         window.eventTrack(item.p_id + '_initiated');
                          //         window.eventTrack('soga_purchase_failed', 1, {
                          //           package_id: item.p_id,
                          //           value: other_a[item.ttt - 1][item.ttt - 1]['price'],
                          //           current_level: level_button.n,
                          //           conversion: 1 - bought,
                          //           user_type: bought,
                          //           lifetime: lifetime_day,
                          //           mission_completed: missioncompleted,
                          //           c_event: current_event,
                          //         });
                          //       }
                          //       console.log(error);
                          //       if (loading_black_sprite != 0) {
                          //         loading_black_sprite.destroy();
                          //         loading_black_sprite = 0;
                          //       }
                          //       if (loading_text != 0 && loading_text != 1) {
                          //         loading_text.destroy();
                          //         loading_text = 0;
                          //       }
                          //       button_click = 0;
                          //       popup = 1;
                          //     });
                        } else if (type == 1 && item.ttt == 4) {
                          popup = 2;
                          game.add
                            .tween(black_sprite)
                            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                            .onComplete.add(function (item) {
                              item.destroy();
                            });
                          game.add
                            .tween(popup_group)
                            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                            .onComplete.add(function () {
                              popup_group.removeAll(true);
                              popup = 0;
                              popup_group.y -= game.camera.height;
                              wheel_icon_text = 0;
                              missions_tab_open = 0;

                              if (shop == 1) {
                                shop_window(
                                  0,
                                  0,
                                  0,
                                  [
                                    { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                                    { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                                    { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                                    { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                                    {
                                      4: {
                                        id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                                        packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                                        price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                                        reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                                      },
                                    },
                                  ],
                                  [
                                    {
                                      0: {
                                        type: 'Coins_Pack_1.png',
                                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                        col: '1 000',
                                        id: 'coin_package_001',
                                        packname: '1,000 Coins',
                                        price: '0.99 $',
                                        atlas: 'game_window_atlas',
                                        reward: [1000],
                                      },
                                    },
                                    {
                                      1: {
                                        type: 'Coins_Pack_2.png',
                                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                        col: '6 000',
                                        id: 'coin_package_02',
                                        packname: '6,000 Coins',
                                        price: '4.99 $',
                                        atlas: 'game_window_atlas',
                                        reward: [6000],
                                      },
                                    },
                                    {
                                      2: {
                                        type: 'Coins_Pack_3.png',
                                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                        col: '13 000',
                                        id: 'coin_package_003',
                                        packname: '13,000 Coins',
                                        price: '9.99 $',
                                        atlas: 'game_window_atlas',
                                        reward: [13000],
                                      },
                                    },
                                    {
                                      3: {
                                        type: 'Coins_Pack_4.png',
                                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                        col: '20 000',
                                        id: 'coin_package_004',
                                        packname: '20,000 Coins',
                                        price: '14.99 $',
                                        atlas: 'game_window_atlas',
                                        reward: [20000],
                                      },
                                    },
                                  ],
                                );
                              } else {
                                wheel_window();
                              }


                            });
                        } else if (shop_free == 1 && item.ttt == 1) {
                          if (fbv == 1 && FTUE == 41.4) {
                            window.eventTrack('FTUE_15_3FREE_button_clicked');
                          }
                          popup = 2;
                          f_w_a();
                          game.add
                            .tween(black_sprite)
                            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                            .onComplete.add(function (item) {
                              item.destroy();
                            });
                          game.add
                            .tween(popup_group)
                            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                            .onComplete.add(function () {
                              popup_group.removeAll(true);
                              popup = 0;
                              popup_group.y -= game.camera.height;
                              wheel_icon_text = 0;
                              ShopDate =
                                ddd == 0
                                  ? new Date()
                                  : new Date(
                                    ddd +
                                    ' ' +
                                    new Date().getHours() +
                                    ':' +
                                    new Date().getMinutes() +
                                    ':' +
                                    new Date().getSeconds(),
                                  );
                              ShopDate.setHours(ShopDate.getHours() + shoptimer);
                              shop_free = 2;
                              if (prize_button != 0) {
                                prize_button.destroy();
                                prize_button = 0;
                              }
                              game.setUserDataAndLog({ shop_free: shop_free, shop_time: String(ShopDate) });
                              indicator_system(0);
                              missions_tab_open = 0;
                              if (special_stage != 0)
                                chest_open_window(
                                  game.cache.getJSON('lang')['Reward!'][0][window.lang],
                                  [50, 0, 0, 0, 0],
                                  51,
                                  void 0,
                                  {
                                    // gameArea: DdnaGameArea.Map,
                                    // actionType: DdnaTransactionActionType.DayProgress,
                                    gameArea: null,
                                    actionType: null,
                                  },
                                );
                              else
                                chest_open_window(
                                  game.cache.getJSON('lang')['Reward!'][0][window.lang],
                                  [50, 0, 0, 0, 0],
                                  53,
                                  void 0,
                                  {
                                    // gameArea: DdnaGameArea.Map,
                                    // actionType: DdnaTransactionActionType.DayProgress,
                                    gameArea: null,
                                    actionType: null,
                                  },
                                );
                              source_chest = 'Shop free';
                              package_id_chest = 0;
                            });
                        }
                      }
                    }
                  });
                  if (shop_free == 1 && type == 0 && t == 1)
                    var popup_item1_button_price = game.add.text(
                      0,
                      0,
                      game.cache.getJSON('lang')['t274'][0][window.lang],
                      { font: '32px RussoOne', fill: '#fff', align: 'center' },
                    );
                  else if (type == 0 || (type == 1 && t < 4 && shop == 1))
                    var popup_item1_button_price = game.add.text(
                      0,
                      0,
                      payments_catalog[
                      payments_catalog.findIndex(function (e) {
                        return e['productID'] == other_a[t - 1][t - 1]['id'];
                      })
                      ]['price'],
                      { font: '32px RussoOne', fill: '#fff', align: 'center' },
                    );
                  else if (type == 1 && t < 4 && shop == 0)
                    var popup_item1_button_price = game.add.text(
                      0,
                      0,
                      (other_a[t - 1][t - 1]['sprite'] == '+5_Cards.png') ? ((t == 1) ? '1500' : (t == 2) ? '2500' : '3200') : (other_a[t - 1][t - 1]['sprite'] == 'Windmill.png') ? ((t == 1) ? '1800' : (t == 2) ? '3000' : '4000') : ((t == 1) ? '2400' : (t == 2) ? '4000' : '5600'),
                      { font: '32px RussoOne', fill: '#fff', align: 'center' },
                    );
                  else
                    var popup_item1_button_price = game.add.text(
                      0,
                      0,
                      game.cache.getJSON('lang')['t407'][0][window.lang],
                      { font: '32px RussoOne', fill: '#fff', align: 'center' },
                    );
                  popup_item1_button_price.anchor.setTo(0.5);
                  popup_item1_button_price.stroke = '#47740D';
                  popup_item1_button_price.strokeThickness = 4;
                  popup_item1_button_price.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
                  popup_item1_button.addChild(popup_item1_button_price);
                  if (shop_free != 0 && t == 1 && type == 0) {
                    popup_item1_button.input.useHandCursor = true;
                    scale_tween(popup_item1_button, 500, 0.1, 0.1);
                  }
                } else {
                  if (wheel_num == 0) {
                    var Rectangle = game.add.sprite(0, -86, 'game_window2_atlas', 'Green_Background_Free_Gift.png');
                    Rectangle.anchor.setTo(0.5);
                    Rectangle.scale.setTo(1, 0.68);
                    popup_shop_section.addChild(Rectangle);
                    var Background_Rays = game.add.sprite(0, -85, 'game_window2_atlas', 'Background_Rays.png');
                    Background_Rays.anchor.setTo(0.5);
                    Background_Rays.scale.setTo(0.8);
                    popup_shop_section.addChild(Background_Rays);
                    rotate_tween(Background_Rays);
                  } else {
                    var Rectangle = game.add.sprite(0, -50, 'game_window2_atlas', 'Green_Background_Free_Gift.png');
                    Rectangle.anchor.setTo(0.5);
                    popup_shop_section.addChild(Rectangle);
                    var Background_Rays = game.add.sprite(0, -55, 'game_window2_atlas', 'Background_Rays.png');
                    Background_Rays.anchor.setTo(0.5);
                    popup_shop_section.addChild(Background_Rays);
                    rotate_tween(Background_Rays);
                  }
                  var popup_item1_icon = game.add.sprite(0, -30, 'game_window_atlas', 'Wheel_Coin_Shop.png');
                  popup_item1_icon.anchor.setTo(0.5, 0.6);
                  popup_shop_section.addChild(popup_item1_icon);
                  popup_item1_icon.scale.setTo(0.7);
                  if (wheel_num == 0) {
                    popup_item1_icon.y = -70;
                    popup_item1_icon.scale.setTo(0.6);
                    var Coins_Pack_Coins_Amount = game.add.sprite(
                      0,
                      30,
                      'game_window_atlas',
                      'Coins_Pack_Coins_Amount.png',
                    );
                    Coins_Pack_Coins_Amount.anchor.setTo(0.5);
                    popup_shop_section.addChild(Coins_Pack_Coins_Amount);
                    var popup_item1_num = game.add.text(0, 30, game.cache.getJSON('lang')['t275'][0][window.lang], {
                      font: '32px RussoOne',
                      fill: '#1B617D',
                      align: 'center',
                    });
                    popup_item1_num.anchor.setTo(0.5);
                    popup_item1_num.stroke = '#fff';
                    popup_item1_num.strokeThickness = 4;
                    popup_shop_section.addChild(popup_item1_num);
                  }
                  if (wheel_max > 0)
                    var popup_item1_button = game.add.sprite(0, 110, 'game_window_atlas', 'Coins_Pack_Button.png');
                  else {
                    var popup_item1_button = game.add.sprite(0, 110, 'game_window_atlas', 'Play_Alone_Button.png');
                    popup_item1_button.scale.setTo(0.7);
                  }
                  popup_item1_button.anchor.setTo(0.5);
                  popup_shop_section.addChild(popup_item1_button);
                  if (wheel_max > 0) {
                    popup_item1_button.inputEnabled = true;
                    popup_item1_button.input.useHandCursor = true;
                  }
                  popup_item1_button.scl = 1;
                  popup_item1_button.ttt = t;
                  popup_item1_button.input.priorityID = 100;
                  popup_item1_button.events.onInputOver.add(btnover, this);
                  popup_item1_button.events.onInputOut.add(btnout, this);
                  popup_item1_button.events.onInputDown.add(btnclick, this);
                  popup_item1_button.events.onInputUp.add(function (item) {
                    if (button_click == 1 && shop_open == 1 && wheel_max > 0 && FTUE != 41.4) {
                      btnup(item);
                      if (popup != 2) {
                        popup = 2;
                        if (sound_on == 1) {
                          play_sound('button_X');
                        }
                        game.add
                          .tween(black_sprite)
                          .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                          .onComplete.add(function (item) {
                            item.destroy();
                          });
                        game.add
                          .tween(popup_group)
                          .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                          .onComplete.add(function () {
                            popup_group.removeAll(true);
                            popup = 0;
                            popup_group.y -= game.camera.height;
                            wheel_icon_text = 0;
                            wheel_window();
                          });
                      }
                    }
                  });
                  if (wheel_num > 0)
                    wheel_icon_text = game.add.text(0, 0, game.cache.getJSON('lang')['t274'][0][window.lang], {
                      font: '32px RussoOne',
                      fill: '#fff',
                      align: 'center',
                    });
                  else
                    wheel_icon_text = game.add.text(0, 0, '00:00:00', {
                      font: '32px RussoOne',
                      fill: '#fff',
                      align: 'center',
                    });
                  if (wheel_max == 0) {
                    wheel_icon_text.scale.setTo(1.3);
                  }
                  wheel_icon_text.anchor.setTo(0.5);
                  wheel_icon_text.stroke = '#47740D';
                  wheel_icon_text.strokeThickness = 4;
                  wheel_icon_text.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
                  popup_item1_button.addChild(wheel_icon_text);
                  if (wheel_num > 0) {
                    popup_item1_button.input.useHandCursor = true;
                    scale_tween(popup_item1_button, 500, 0.05, 0.05);
                  }
                }
                game.add
                  .tween(popup_shop_section.scale)
                  .to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, t * 50);
                if (shop_free == 2 && t == 1 && type == 0) {
                  var popup_shop_section = game.add.sprite(
                    game.camera.width / 2 + 200 + i * 300,
                    game.camera.height / 2 - 78 + j * 390,
                    'game_window_atlas',
                    'Coins_Pack_Background.png',
                  );
                  popup_shop_section.anchor.setTo(0.5);
                  popup_group.add(popup_shop_section);
                  popup_shop_section.fixedToCamera = true;
                  popup_shop_section.scale.setTo(0);
                  var Green_Background_Free_Gift = game.add.sprite(
                    0,
                    -50,
                    'game_window2_atlas',
                    'Green_Background_Free_Gift.png',
                  );
                  Green_Background_Free_Gift.anchor.setTo(0.5);
                  popup_shop_section.addChild(Green_Background_Free_Gift);
                  var Background_Rays = game.add.sprite(0, -55, 'game_window2_atlas', 'Background_Rays.png');
                  Background_Rays.anchor.setTo(0.5);
                  Background_Rays.scale.setTo(0.6);
                  popup_shop_section.addChild(Background_Rays);
                  rotate_tween(Background_Rays);
                  var Gift = game.add.sprite(0, -50, 'game_window2_atlas', 'Gift.png');
                  Gift.anchor.setTo(0.5);
                  popup_shop_section.addChild(Gift);
                  game.add
                    .tween(popup_shop_section.scale)
                    .to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, t * 50);
                  game.add.tween(popup_shop_section).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, t * 500);
                  shop_free = 0;
                  game.setUserDataAndLog({ shop_free: shop_free });
                }
                t++;
              }
          }
        }, 100);
      }
    };
    // if (fbv == 1) {
    //   FBInstant.payments.getPurchasesAsync().then(function (purchases) {
    //     for (i = 0; i < purchases.length; i++) {
    //       FBInstant.payments
    //         .consumePurchaseAsync(purchases[i]['purchaseToken'])
    //         .then(function () {})
    //         .catch(function (error) {});
    //     }
    //   });
    // }
    var offer_icon_timer = 0;
    function offer_button() {
      if (OfferDate != 0 && shop == 1 && xmas == 0) {
        if (typeof window.icon != 'undefined') {
          window.icon.cameraOffset.x += 150;
        }

        offer_icon = game.add.sprite(
          game.camera.width / 2 - 480,
          game.camera.height - 100,
          'game_ui_atlas',
          'offer_icon.png',
        );
        offer_icon.scale.setTo(0);
        offer_icon.anchor.setTo(0.5);
        offer_icon.fixedToCamera = true;
        button_animation_f(offer_icon, 1);
        offer_icon.type = 6;
        offer_icon.events.onInputUp.add(function (itm) {
          btnup(itm);
          if (animation == 0 && popup == 0 && update_controll == 0) {
            if (offer_mas[0] == 16)
              special_sales_packages(1, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack2'][0][window.lang], 0);
            else if (offer_mas[0] == 19)
              special_sales_packages(2, 'Carls_Package_Frame', game.cache.getJSON('lang')['pack1'][0][window.lang], 0);
            else if (offer_mas[0] == 25)
              special_sales_packages(
                3,
                'Good_Day_Package_Mock_Up',
                game.cache.getJSON('lang')['pack3'][0][window.lang],
                0,
              );
            else if (offer_mas[0] == 20)
              special_sales_packages(4, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack4'][0][window.lang], 0);
            /*else if (offer_mas[0] == 46)
              special_sales_packages(
                5,
                'Random_booster_package_Frame',
                game.cache.getJSON('lang')['pack5'][0][window.lang],
                0,
              );*/
            else if (offer_mas[0] == 21)
              special_sales_packages(6, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);
            else if (offer_mas[0] == 31)
              special_sales_packages(8, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);
            /*else if (offer_mas[0] == 41)
              special_sales_packages(9, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);
            else if (offer_mas[0] == 51)
              special_sales_packages(10, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);
            else if (offer_mas[0] == 61)
              special_sales_packages(11, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);*/
            /*else if (offer_mas[0] == 35)
              special_sales_packages(12, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack7'][0][window.lang], 0);*/
            else if (offer_mas[0] == 45)
              special_sales_packages(7, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack8'][0][window.lang], 0);
            else if (offer_mas[0] == 36)
              special_sales_packages(13, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack9'][0][window.lang], 0);
            else first_buyer_window(offer_mas[0], 0);
          }
        });
        UI_bottom_group.add(offer_icon);
        game.add.tween(offer_icon.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true);
        var graphics = game.add.graphics(-70, 40);
        graphics.beginFill(0x000000);
        graphics.alpha = 0.5;
        graphics.type = 6;
        graphics.drawRoundedRect(0, 0, 140, 40, 100);
        offer_icon.addChild(graphics);
        offer_icon_timer = game.add.text(0, 62, '00:00', { font: '32px RussoOne', fill: '#FFE6A6', align: 'center' });
        offer_icon_timer.anchor.setTo(0.5);
        offer_icon_timer.stroke = '#733500';
        offer_icon_timer.strokeThickness = 4;
        offer_icon_timer.type = 6;
        offer_icon.addChild(offer_icon_timer);
      }
    }

    window.set_xmas_level = function (n) {
      xmas_level = n;
    }

    function UI_bottom_group_create(t1, t2, t3, t4, d) {
      if (xmas == 1) {
        /*var Level_Bar_Background = game.add.sprite(
          game.camera.width / 2 - 150,
          game.camera.height - 55,
          'xmas_atlas',
          'Level_Bar_Background.png',
        );
        Level_Bar_Background.anchor.setTo(0.5);
        Level_Bar_Background.fixedToCamera = true;
        UI_bottom_group.add(Level_Bar_Background);*/
        var Level_Bar = game.add.sprite(
          game.camera.width / 2 - 150 - 593,
          game.camera.height - 55,
          'xmas_atlas',
          'Level_Bar.png',
        );
        Level_Bar.anchor.setTo(0, 0.5);
        Level_Bar.fixedToCamera = true;
        UI_bottom_group.add(Level_Bar);

        if (xmas_level_win == 1) { xmas_level -= 1; }
        let cropRect = 0;
        let cropEnd = 0;
        if (xmas_level <= 1) {
          cropRect = new Phaser.Rectangle(0, 0, 85 * xmas_level, Level_Bar.height);
          if (xmas_level_win == 1) { xmas_level += 1; }
          cropEnd = 85 * xmas_level;
        }
        else
          if (xmas_level <= 5) {
            cropRect = new Phaser.Rectangle(0, 0, (158 / 4) * (xmas_level - 1) + 85, Level_Bar.height);
            if (xmas_level_win == 1) { xmas_level += 1; }
            cropEnd = (158 / 4) * (xmas_level - 1) + 85;
          }
          else
            if (xmas_level <= 11) {
              cropRect = new Phaser.Rectangle(0, 0, (158 / 6) * (xmas_level - 5) + 85 + 158, Level_Bar.height);
              if (xmas_level_win == 1) { xmas_level += 1; }
              cropEnd = (158 / 6) * (xmas_level - 5) + 85 + 158;
            }
            else
              if (xmas_level <= 18) {
                cropRect = new Phaser.Rectangle(0, 0, (158 / 7) * (xmas_level - 11) + 85 + 158 + 158, Level_Bar.height);
                if (xmas_level_win == 1) { xmas_level += 1; }
                cropEnd = (158 / 7) * (xmas_level - 11) + 85 + 158 + 158;
              }
              else
                if (xmas_level <= 24) {
                  cropRect = new Phaser.Rectangle(0, 0, (158 / 6) * (xmas_level - 18) + 85 + 158 + 158 + 158, Level_Bar.height);
                  if (xmas_level_win == 1) { xmas_level += 1; }
                  cropEnd = (158 / 6) * (xmas_level - 18) + 85 + 158 + 158 + 158;
                }
                else
                  if (xmas_level <= 31) {
                    cropRect = new Phaser.Rectangle(0, 0, (158 / 7) * (xmas_level - 24) + 85 + 158 + 158 + 158 + 158, Level_Bar.height);
                    if (xmas_level_win == 1) { xmas_level += 1; }
                    cropEnd = (158 / 7) * (xmas_level - 24) + 85 + 158 + 158 + 158 + 158;
                  }
                  else
                    if (xmas_level <= 38) {
                      cropRect = new Phaser.Rectangle(0, 0, (158 / 7) * (xmas_level - 31) + 85 + 158 + 158 + 158 + 158 + 158, Level_Bar.height);
                      if (xmas_level_win == 1) { xmas_level += 1; }
                      cropEnd = (158 / 7) * (xmas_level - 31) + 85 + 158 + 158 + 158 + 158 + 158;
                    }
                    else
                      if (xmas_level <= 45) {
                        cropRect = new Phaser.Rectangle(0, 0, (158 / 7) * (xmas_level - 38) + 85 + 158 + 158 + 158 + 158 + 158 + 158, Level_Bar.height);
                        if (xmas_level_win == 1) { xmas_level += 1; }
                        cropEnd = (158 / 7) * (xmas_level - 38) + 85 + 158 + 158 + 158 + 158 + 158 + 158;
                      }
        Level_Bar.crop(cropRect);

        if (xmas_level_win == 1) {


          objects_group.children.forEach(function (child_item) {
            if (child_item.type == 999999999) {
              if (xmas_level == 45)
                child_item.loadTexture('xmas_atlas', 'xmas_darck_7.png');
              else if (xmas_level == 38)
                child_item.loadTexture('xmas_atlas', 'xmas_darck_6.png');
              else if (xmas_level == 31)
                child_item.loadTexture('xmas_atlas', 'xmas_darck_5.png');
              else if (xmas_level == 24)
                child_item.loadTexture('xmas_atlas', 'xmas_darck_4.png');
              else if (xmas_level == 18)
                child_item.loadTexture('xmas_atlas', 'xmas_darck_3.png');
              else if (xmas_level == 11)
                child_item.loadTexture('xmas_atlas', 'xmas_darck_2.png');
              else if (xmas_level == 5)
                child_item.loadTexture('xmas_atlas', 'xmas_darck_1.png');
              else if (xmas_level == 1)
                child_item.loadTexture('xmas_atlas', 'xmas_darck_0.png');
            }
          });

          if (xmas_level == 1 && dialog_mas.indexOf(-245) == -1) {
            objects_group.children.forEach(function (child_item) {
              if (child_item.frameName == "Roof_light.png") {
                child_item.alpha = 0;
              }
              else
                if (child_item.frameName == "Path1_snow.png" || child_item.frameName == "Path2_snow.png") {
                  child_item.alpha = 1;
                }
                else
                  if (child_item.frameName == "b_lamp_9.png") {
                    child_item.alpha = 0;
                  }
            });
          } else if (xmas_level == 5 && dialog_mas.indexOf(-246) == -1) {
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 20212) {
                child_item.alpha = 0;
              }
            });
          } else if (xmas_level == 11 && dialog_mas.indexOf(-247) == -1) {
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 20213) {
                child_item.alpha = 0;
              }
            });
          } else if (xmas_level == 18 && dialog_mas.indexOf(-251) == -1) {
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 20214) {
                child_item.alpha = 0;
              }
            });
          } else if (xmas_level == 24 && dialog_mas.indexOf(-254) == -1) {
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 20215) {
                child_item.alpha = 0;
              }
            });
          } else if (xmas_level == 31 && dialog_mas.indexOf(-255) == -1) {
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 20216) {
                child_item.alpha = 0;
              }
            });
          } else if (xmas_level == 38 && dialog_mas.indexOf(-256) == -1) {
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 20217) {
                child_item.alpha = 0;
              }
            });
          } else if (xmas_level == 45 && dialog_mas.indexOf(-256) == -1) {
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 20218) {
                child_item.alpha = 0;
              }
            });
          }

          var tween = game.add.tween(cropRect).to({ width: cropEnd }, 900, Phaser.Easing.Linear.None, true);
          tween.onUpdateCallback(function () {
            try {
              Level_Bar.crop(cropRect);
            } catch (err) { }
          }, this);

          tween.onComplete.add(function () {
            worldScale = 1;
            animation = 1;
            popup = 1;
            if (xmas_level == 1 && dialog_mas.indexOf(-245) == -1) {
              game.add.tween(follow).to({ x: 1997, y: 625 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function () {
                follow.x = 1997;
                follow.y = 625;
                objects_group.children.forEach(function (child_item) {
                  if (child_item.frameName == "Roof_light.png") {
                    child_item.alpha = 0;
                    game.add.tween(child_item).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                      add_shines(item, 3, 1);
                      add_shines(item, 3, 1);
                      add_shines(item, 3, 1);
                      game.add.tween(item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                    });
                  }
                  else
                    if (child_item.frameName == "Path1_snow.png" || child_item.frameName == "Path2_snow.png") {
                      child_item.alpha = 1;
                      game.add.tween(child_item).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                        add_shines(item, 3, 1);
                        add_shines(item, 3, 1);
                        add_shines(item, 3, 1);
                      });
                    }

                });
                game.add.tween(follow).to({ x: 1460, y: 1680 }, 1000, Phaser.Easing.Linear.None, true, 2000).onComplete.add(function () {
                  follow.x = 1460;
                  follow.y = 1680;

                  objects_group.children.forEach(function (child_item) {
                    if (child_item.frameName == "b_lamp_9.png") {
                      child_item.alpha = 0;

                      child_item.y -= 200;
                      game.add.tween(child_item).to({ y: '+200' }, 800, Phaser.Easing.Bounce.Out, true).onComplete.add(function (item) {
                        add_shines(item, 3, 1);
                        add_shines(item, 3, 1);
                        add_shines(item, 3, 1);
                      });
                      game.add.tween(child_item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          var emitter_lsmoke = game.add.emitter(0, 0, 50);
                          emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
                          emitter_lsmoke.width = item.width;
                          emitter_lsmoke.height = item.height / 2;
                          emitter_lsmoke.bringToTop = true;
                          emitter_lsmoke.setRotation(0, 360, 500);
                          emitter_lsmoke.setAlpha(0.2, 0, 1000);
                          emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 1000);
                          emitter_lsmoke.gravity = 50;
                          emitter_lsmoke.minParticleSpeed.set(50, 50);
                          emitter_lsmoke.maxParticleSpeed.set(50, 50);
                          emitter_lsmoke.explode = true;
                          emitter_lsmoke.blendMode = 3;
                          emitter_lsmoke.x = item.world.x;
                          emitter_lsmoke.y = item.world.y + item.height / 2;
                          emitter_lsmoke.start(false, 500, 0, 20);
                        });
                    }
                  });

                  game.add.tween(effects_group).to({ alpha: 1 }, 2500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                    animation = 0; popup = 0; dialog_window(245, 0);
                  });
                });

                game.add.tween(effects_group.scale).to({ x: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.type == 999999999) {
                      if (xmas_level >= 45)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_8.png');
                      else if (xmas_level >= 38)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_7.png');
                      else if (xmas_level >= 31)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_6.png');
                      else if (xmas_level >= 24)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_5.png');
                      else if (xmas_level >= 18)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_4.png');
                      else if (xmas_level >= 11)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_3.png');
                      else if (xmas_level >= 5)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_2.png');
                      else if (xmas_level >= 1)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_1.png');
                    }
                  });
                });

              });
            } else if (xmas_level == 5 && dialog_mas.indexOf(-246) == -1) {
              game.add.tween(follow).to({ x: 1375, y: 1085 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function () {
                follow.x = 1375;
                follow.y = 1085;
                objects_group.children.forEach(function (child_item) {
                  if (child_item.type == 20212) {
                    child_item.alpha = 0;
                    game.add.tween(child_item).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                      add_shines(item, 3, 1);
                      add_shines(item, 3, 1);
                      add_shines(item, 3, 1);
                      game.add.tween(item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                    });
                  }

                  if (child_item.frameName == 'chimney.png') {
                    var chimney_smoke = game.add.sprite(child_item.x, child_item.y, 'farm_obj_c_atlas', 'Chimney_Smoke_1.png');
                    chimney_smoke.scale.setTo(2.9);
                    chimney_smoke.anchor.setTo(0.65);
                    chimney_smoke.depth = 100;
                    objects_group.add(chimney_smoke);
                    chimney_smoke.animations.add(
                      'chimney_smoke',
                      [
                        'Chimney_Smoke_1.png',
                        'Chimney_Smoke_2.png',
                        'Chimney_Smoke_3.png',
                        'Chimney_Smoke_4.png',
                        'Chimney_Smoke_5.png',
                      ],
                      10,
                      true,
                    );
                    chimney_smoke.animations.play('chimney_smoke');
                  }
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 2500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  animation = 0; popup = 0; dialog_window(246, 0);
                });

                game.add.tween(effects_group.scale).to({ x: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.type == 999999999) {
                      if (xmas_level >= 45)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_8.png');
                      else if (xmas_level >= 38)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_7.png');
                      else if (xmas_level >= 31)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_6.png');
                      else if (xmas_level >= 24)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_5.png');
                      else if (xmas_level >= 18)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_4.png');
                      else if (xmas_level >= 11)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_3.png');
                      else if (xmas_level >= 5)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_2.png');
                      else if (xmas_level >= 1)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_1.png');
                    }
                  });
                });

              });
            } else if (xmas_level == 11 && dialog_mas.indexOf(-247) == -1) {
              game.add.tween(follow).to({ x: 2600, y: 1500 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
                follow.x = 2600;
                follow.y = 1500;
                game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  popup = 0; dialog_window(247, 0);
                });
              });
            } else if (xmas_level == 14 && dialog_mas.indexOf(-249) == -1) {

              game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                animation = 0; popup = 0; dialog_window(249, 0);
              });

            } else if (xmas_level == 18 && dialog_mas.indexOf(-251) == -1) {
              game.add.tween(follow).to({ x: 2090, y: 1296 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
                follow.x = 2090;
                follow.y = 1296;
                game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  popup = 0; dialog_window(251, 0);
                });
              });
            } else if (xmas_level == 21 && dialog_mas.indexOf(-252) == -1) {

              game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                animation = 0; popup = 0; dialog_window(252, 0);
              });

            } else if (xmas_level == 24 && dialog_mas.indexOf(-254) == -1) {
              game.add.tween(follow).to({ x: 2685, y: 2274 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
                follow.x = 2685;
                follow.y = 2274;
                objects_group.children.forEach(function (child_item) {
                  if (child_item.type == 20215) {
                    child_item.alpha = 0;
                    hummer_anim(child_item);
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    game.add.tween(child_item).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 500);
                  }
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 2500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  animation = 0; popup = 0; dialog_window(254, 0);
                });

                game.add.tween(effects_group.scale).to({ x: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.type == 999999999) {
                      if (xmas_level >= 45)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_8.png');
                      else if (xmas_level >= 38)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_7.png');
                      else if (xmas_level >= 31)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_6.png');
                      else if (xmas_level >= 24)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_5.png');
                      else if (xmas_level >= 18)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_4.png');
                      else if (xmas_level >= 11)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_3.png');
                      else if (xmas_level >= 5)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_2.png');
                      else if (xmas_level >= 1)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_1.png');
                    }
                  });
                });
              });
            } else if (xmas_level == 31 && dialog_mas.indexOf(-255) == -1) {
              game.add.tween(follow).to({ x: 3000, y: 1430 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
                follow.x = 3000;
                follow.y = 1430;
                objects_group.children.forEach(function (child_item) {
                  if (child_item.type == 20216 && child_item.frameName == "dwarf_statue.png") {
                    child_item.alpha = 0;
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    child_item.y -= 200;
                    game.add.tween(child_item).to({ y: '+200' }, 800, Phaser.Easing.Bounce.Out, true);
                    game.add.tween(child_item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        var emitter_lsmoke = game.add.emitter(0, 0, 50);
                        emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
                        emitter_lsmoke.width = item.width;
                        emitter_lsmoke.height = item.height / 2;
                        emitter_lsmoke.bringToTop = true;
                        emitter_lsmoke.setRotation(0, 360, 500);
                        emitter_lsmoke.setAlpha(0.2, 0, 1000);
                        emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 1000);
                        emitter_lsmoke.gravity = 50;
                        emitter_lsmoke.minParticleSpeed.set(50, 50);
                        emitter_lsmoke.maxParticleSpeed.set(50, 50);
                        emitter_lsmoke.explode = true;
                        emitter_lsmoke.blendMode = 3;
                        emitter_lsmoke.x = item.world.x;
                        emitter_lsmoke.y = item.world.y + item.height / 2;
                        emitter_lsmoke.start(false, 500, 0, 20);
                      });
                  }
                  if (child_item.type == 20216 && child_item.frameName != "dwarf_statue.png") {
                    game.add.tween(follow).to({ x: 1300, y: 2200 }, 1000, Phaser.Easing.Linear.None, true, 2000).onComplete.add(function (item) {
                      follow.x = 1300;
                      follow.y = 2200;

                      child_item.alpha = 0;
                      add_shines(child_item, 3, 1);
                      add_shines(child_item, 3, 1);
                      add_shines(child_item, 3, 1);
                      child_item.y -= 200;
                      game.add.tween(child_item).to({ y: '+200' }, 800, Phaser.Easing.Bounce.Out, true);
                      game.add.tween(child_item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          var emitter_lsmoke = game.add.emitter(0, 0, 50);
                          emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
                          emitter_lsmoke.width = item.width;
                          emitter_lsmoke.height = item.height / 2;
                          emitter_lsmoke.bringToTop = true;
                          emitter_lsmoke.setRotation(0, 360, 500);
                          emitter_lsmoke.setAlpha(0.2, 0, 1000);
                          emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 1000);
                          emitter_lsmoke.gravity = 50;
                          emitter_lsmoke.minParticleSpeed.set(50, 50);
                          emitter_lsmoke.maxParticleSpeed.set(50, 50);
                          emitter_lsmoke.explode = true;
                          emitter_lsmoke.blendMode = 3;
                          emitter_lsmoke.x = item.world.x;
                          emitter_lsmoke.y = item.world.y + item.height / 2;
                          emitter_lsmoke.start(false, 500, 0, 20);
                        });
                    });
                  }
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 5000, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  animation = 0; popup = 0; dialog_window(255, 0);
                });

                game.add.tween(effects_group.scale).to({ x: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.type == 999999999) {
                      if (xmas_level >= 45)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_8.png');
                      else if (xmas_level >= 38)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_7.png');
                      else if (xmas_level >= 31)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_6.png');
                      else if (xmas_level >= 24)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_5.png');
                      else if (xmas_level >= 18)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_4.png');
                      else if (xmas_level >= 11)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_3.png');
                      else if (xmas_level >= 5)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_2.png');
                      else if (xmas_level >= 1)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_1.png');
                    }
                  });
                });
              });
            } else if (xmas_level == 38 && dialog_mas.indexOf(-256) == -1) {
              game.add.tween(follow).to({ x: 1290, y: 1840 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
                follow.x = 1290;
                follow.y = 1840;
                objects_group.children.forEach(function (child_item) {
                  if (child_item.type == 20217 && child_item.frameName != 'gift_box.png') {
                    child_item.alpha = 0;
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);

                    if (child_item.frameName != 'bench_7.png') {
                      game.add.tween(child_item).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true);
                    } else {
                      child_item.y -= 200;
                      game.add.tween(child_item).to({ y: '+200' }, 800, Phaser.Easing.Bounce.Out, true);
                      game.add.tween(child_item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          var emitter_lsmoke = game.add.emitter(0, 0, 50);
                          emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
                          emitter_lsmoke.width = item.width;
                          emitter_lsmoke.height = item.height / 2;
                          emitter_lsmoke.bringToTop = true;
                          emitter_lsmoke.setRotation(0, 360, 500);
                          emitter_lsmoke.setAlpha(0.2, 0, 1000);
                          emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 1000);
                          emitter_lsmoke.gravity = 50;
                          emitter_lsmoke.minParticleSpeed.set(50, 50);
                          emitter_lsmoke.maxParticleSpeed.set(50, 50);
                          emitter_lsmoke.explode = true;
                          emitter_lsmoke.blendMode = 3;
                          emitter_lsmoke.x = item.world.x;
                          emitter_lsmoke.y = item.world.y + item.height / 2;
                          emitter_lsmoke.start(false, 500, 0, 20);
                        });
                    }
                  }
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 2500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  popup = 0; dialog_window(256, 0);
                });

                game.add.tween(effects_group.scale).to({ x: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.type == 999999999) {
                      if (xmas_level >= 45)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_8.png');
                      else if (xmas_level >= 38)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_7.png');
                      else if (xmas_level >= 31)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_6.png');
                      else if (xmas_level >= 24)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_5.png');
                      else if (xmas_level >= 18)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_4.png');
                      else if (xmas_level >= 11)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_3.png');
                      else if (xmas_level >= 5)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_2.png');
                      else if (xmas_level >= 1)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_1.png');
                    }
                  });
                });
              });
            } else if (xmas_level == 45 && dialog_mas.indexOf(-262) == -1) {
              game.add.tween(follow).to({ x: 987, y: 1490 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
                follow.x = 987;
                follow.y = 1490;
                objects_group.children.forEach(function (child_item) {
                  if (child_item.type == 20218) {
                    child_item.alpha = 0;
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    game.add.tween(child_item).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 500);
                  }
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 2500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  animation = 0; popup = 0; dialog_window(258, 0);
                });

                game.add.tween(effects_group.scale).to({ x: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.type == 999999999) {
                      if (xmas_level >= 45)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_8.png');
                      else if (xmas_level >= 38)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_7.png');
                      else if (xmas_level >= 31)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_6.png');
                      else if (xmas_level >= 24)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_5.png');
                      else if (xmas_level >= 18)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_4.png');
                      else if (xmas_level >= 11)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_3.png');
                      else if (xmas_level >= 5)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_2.png');
                      else if (xmas_level >= 1)
                        child_item.loadTexture('xmas_atlas', 'xmas_darck_1.png');
                    }
                  });
                });
              });
            } else { animation = 0; popup = 0; }
          });
        }

        var Prizes = game.add.sprite(
          game.camera.width / 2 - 150,
          game.camera.height - 164,
          'xmas_atlas',
          'Level_Bar_Background.png',
        );
        Prizes.anchor.setTo(0.5);
        Prizes.scale.setTo(2);
        Prizes.fixedToCamera = true;
        UI_bottom_group.add(Prizes);
        var Play_Level_Button_Background = game.add.sprite(
          game.camera.width - 245,
          game.camera.height,
          'xmas_atlas',
          'Play_Level_Button_Background.png',
        );
        Play_Level_Button_Background.anchor.setTo(0.5, 1);
        Play_Level_Button_Background.fixedToCamera = true;
        UI_bottom_group.add(Play_Level_Button_Background);
        var Info_Button = game.add.sprite(
          game.camera.width / 2 - 780,
          game.camera.height - 260,
          'xmas_atlas',
          'Info_Button.png',
        );
        Info_Button.anchor.setTo(0.5);
        button_animation_f(Info_Button, 1);
        Info_Button.events.onInputDown.add(function (item) {
          btnup(item);
          if (popup == 0 && animation == 0) {
            xmas_popup();
          }
        });
        Info_Button.fixedToCamera = true;
        UI_bottom_group.add(Info_Button);
        for (var i = -2; i < 5; i++) {
          if (i != -1 && i != 1 && ((xmas_level < 3 && i == -2) || (xmas_level < 13 && i == 0) || (xmas_level < 27 && i == 2) || (xmas_level < 34 && i == 3) || (xmas_level < 42 && i == 4))) {
            var Blue_Gift = game.add.sprite(
              (i != 4) ? game.camera.width / 2 - 260 + i * 158 : game.camera.width / 2 - 260 + i * 158 - 30,
              game.camera.height - 60,
              'xmas_atlas',
              (i == 0) ? 'Blue_Gift.png' : (i == 2) ? 'Green_Gift.png' : (i == 3) ? 'Yellow_Gift.png' : 'Blue_Gift.png' ,
            );
            Blue_Gift.anchor.setTo(0.5);
            Blue_Gift.fixedToCamera = true;
            UI_bottom_group.add(Blue_Gift);
          }
          else
            if (xmas_level_win == 1) {
              if (i != -1 && i != 1 && ((xmas_level == 3 && i == -2) || (xmas_level == 13 && i == 0) || (xmas_level == 27 && i == 2) || (xmas_level == 34 && i == 3) || (xmas_level == 42 && i == 4))) {
                var Blue_Gift = game.add.sprite(
                  (i != 4) ? game.camera.width / 2 - 260 + i * 158 : game.camera.width / 2 - 260 + i * 158 - 30,
                  game.camera.height - 60,
                  'xmas_atlas',
                  (i == 0) ? 'Blue_Gift.png' : (i == 2) ? 'Green_Gift.png' : (i == 3) ? 'Yellow_Gift.png' : 'Blue_Gift.png' ,
                );
                Blue_Gift.anchor.setTo(0.5);
                Blue_Gift.fixedToCamera = true;
                UI_bottom_group.add(Blue_Gift);
                game.add.tween(Blue_Gift.scale).to({ x: 1.4, y: 1.4 }, 600, Phaser.Easing.Linear.None, true, 400);
                game.add.tween(Blue_Gift.cameraOffset).to({ y: '-100' }, 600, Phaser.Easing.Linear.None, true, 400);
                game.add.tween(Blue_Gift).to({ alpha: 0 }, 600, Phaser.Easing.Linear.None, true, 400);
              }
            }
        }
        for (var i = 0; i < 8; i++) {
          var Lock = game.add.sprite(
            game.camera.width / 2 - 660 + i * 158,
            game.camera.height - 115,
            'xmas_atlas',
            'Lock.png',
          );
          Lock.anchor.setTo(0.5);
          Lock.fixedToCamera = true;
          UI_bottom_group.add(Lock);
          var Lock_num = game.add.text(
            0,
            10,
            i == 0
              ? '1'
              : i == 1
                ? '5'
                : i == 2
                  ? '11'
                  : i == 3
                    ? '18'
                    : i == 4
                      ? '24'
                      : i == 5
                        ? '31'
                        : i == 6
                          ? '38'
                          : '45',
            { font: '24px RussoOne', fill: '#583345', align: 'center' },
          );
          Lock_num.anchor.setTo(0.5);
          Lock.addChild(Lock_num);
          if ((xmas_level >= 1 && i == 0 && xmas_level_win == 0) || (xmas_level > 1 && i == 0 && xmas_level_win == 1)) {
            Lock.destroy();
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.fixedToCamera = true;
            UI_bottom_group.add(Lock);
          } else if (xmas_level == 1 && i == 0 && xmas_level_win == 1) {
            game.add.tween(Lock).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 400);
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.scale.setTo(0);
            Lock.fixedToCamera = true;
            game.add.tween(Lock.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 400);
            UI_bottom_group.add(Lock);
          }
          if ((xmas_level >= 5 && i == 1 && xmas_level_win == 0) || (xmas_level > 5 && i == 1 && xmas_level_win == 1)) {
            Lock.destroy();
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.fixedToCamera = true;
            UI_bottom_group.add(Lock);
          } else if (xmas_level == 5 && i == 1 && xmas_level_win == 1) {
            game.add.tween(Lock).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 400);
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.scale.setTo(0);
            Lock.fixedToCamera = true;
            game.add.tween(Lock.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 400);
            UI_bottom_group.add(Lock);
          }
          if ((xmas_level >= 11 && i == 2 && xmas_level_win == 0) || (xmas_level > 11 && i == 2 && xmas_level_win == 1)) {
            Lock.destroy();
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.fixedToCamera = true;
            UI_bottom_group.add(Lock);
          } else if (xmas_level == 11 && i == 2 && xmas_level_win == 1) {
            game.add.tween(Lock).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 400);
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.scale.setTo(0);
            Lock.fixedToCamera = true;
            game.add.tween(Lock.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 400);
            UI_bottom_group.add(Lock);
          }
          if ((xmas_level >= 18 && i == 3 && xmas_level_win == 0) || (xmas_level > 18 && i == 3 && xmas_level_win == 1)) {
            Lock.destroy();
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.fixedToCamera = true;
            UI_bottom_group.add(Lock);
          } else if (xmas_level == 18 && i == 3 && xmas_level_win == 1) {
            game.add.tween(Lock).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 400);
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.scale.setTo(0);
            Lock.fixedToCamera = true;
            game.add.tween(Lock.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 400);
            UI_bottom_group.add(Lock);
          }
          if ((xmas_level >= 24 && i == 4 && xmas_level_win == 0) || (xmas_level > 24 && i == 4 && xmas_level_win == 1)) {
            Lock.destroy();
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.fixedToCamera = true;
            UI_bottom_group.add(Lock);
          } else if (xmas_level == 24 && i == 4 && xmas_level_win == 1) {
            game.add.tween(Lock).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 400);
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.scale.setTo(0);
            Lock.fixedToCamera = true;
            game.add.tween(Lock.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 400);
            UI_bottom_group.add(Lock);
          }
          if ((xmas_level >= 31 && i == 5 && xmas_level_win == 0) || (xmas_level > 31 && i == 5 && xmas_level_win == 1)) {
            Lock.destroy();
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.fixedToCamera = true;
            UI_bottom_group.add(Lock);
          } else if (xmas_level == 31 && i == 5 && xmas_level_win == 1) {
            game.add.tween(Lock).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 400);
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.scale.setTo(0);
            Lock.fixedToCamera = true;
            game.add.tween(Lock.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 400);
            UI_bottom_group.add(Lock);
          }
          if ((xmas_level >= 38 && i == 6 && xmas_level_win == 0) || (xmas_level > 38 && i == 6 && xmas_level_win == 1)) {
            Lock.destroy();
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.fixedToCamera = true;
            UI_bottom_group.add(Lock);
          } else if (xmas_level == 38 && i == 6 && xmas_level_win == 1) {
            game.add.tween(Lock).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 400);
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.scale.setTo(0);
            Lock.fixedToCamera = true;
            game.add.tween(Lock.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 400);
            UI_bottom_group.add(Lock);
          }
          if ((xmas_level >= 45 && i == 7 && xmas_level_win == 0) || (xmas_level > 45 && i == 7 && xmas_level_win == 1)) {
            Lock.destroy();
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.fixedToCamera = true;
            UI_bottom_group.add(Lock);
          } else if (xmas_level == 45 && i == 7 && xmas_level_win == 1) {
            game.add.tween(Lock).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 400);
            var Lock = game.add.sprite(
              game.camera.width / 2 - 660 + i * 158,
              game.camera.height - 115,
              'xmas_atlas',
              'Check.png',
            );
            Lock.anchor.setTo(0.5);
            Lock.scale.setTo(0);
            Lock.fixedToCamera = true;
            game.add.tween(Lock.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 400);
            UI_bottom_group.add(Lock);
          }
        }
      }

      if (
        ((shop_free == 1 && shop == 1 && all_level[8] > 0) || (shop_free == 1 && FTUE > 150 && shop == 1)) &&
        xmas == 0
      ) {
        prize_button = game.add.sprite(
          game.camera.width - 350,
          game.camera.height - 110,
          'game_ui_atlas',
          '2Gift_Bottom_Part.png',
        );
        prize_button.anchor.setTo(0.5);
        prize_button.fixedToCamera = true;
        prize_button.scale.setTo(1.3);
        button_animation_f(prize_button, 1.3);
        prize_button.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup == 0 && animation == 0 && missions_tab_open == 0 && update_controll == 0) {
            shop_window(
              0,
              0,
              0,
              [
                { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                {
                  4: {
                    id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                    packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                    price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                    reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                  },
                },
              ],
              [
                {
                  0: {
                    type: 'Coins_Pack_1.png',
                    sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                    col: '1 000',
                    id: 'coin_package_001',
                    packname: '1,000 Coins',
                    price: '0.99 $',
                    atlas: 'game_window_atlas',
                    reward: [1000],
                  },
                },
                {
                  1: {
                    type: 'Coins_Pack_2.png',
                    sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                    col: '6 000',
                    id: 'coin_package_02',
                    packname: '6,000 Coins',
                    price: '4.99 $',
                    atlas: 'game_window_atlas',
                    reward: [6000],
                  },
                },
                {
                  2: {
                    type: 'Coins_Pack_3.png',
                    sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                    col: '13 000',
                    id: 'coin_package_003',
                    packname: '13,000 Coins',
                    price: '9.99 $',
                    atlas: 'game_window_atlas',
                    reward: [13000],
                  },
                },
                {
                  3: {
                    type: 'Coins_Pack_4.png',
                    sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                    col: '20 000',
                    id: 'coin_package_004',
                    packname: '20,000 Coins',
                    price: '14.99 $',
                    atlas: 'game_window_atlas',
                    reward: [20000],
                  },
                },
              ],
            );
          }
        });
        UI_bottom_group.add(prize_button);
        var gift_lid = game.add.sprite(0, -20, 'game_ui_atlas', '2Gift_Lid.png');
        gift_lid.anchor.setTo(0.5);
        prize_button.addChild(gift_lid);
        var gift_shadow = game.add.sprite(0, -14, 'game_ui_atlas', '2Gift_Ribbon_Shadow.png');
        gift_shadow.anchor.setTo(0.5);
        gift_lid.addChild(gift_shadow);
        var gift_ribbon = game.add.sprite(0, -20, 'game_ui_atlas', '2Gift_Ribbon.png');
        gift_ribbon.anchor.setTo(0.5);
        gift_lid.addChild(gift_ribbon);
      }
      if (xmas == 0) {
        level_button = game.add.sprite(
          game.camera.width - 145,
          game.camera.height - 120,
          'game_ui_atlas',
          'Play_Button.png',
        );
      } else {
        level_button = game.add.sprite(
          game.camera.width - 245,
          game.camera.height - 190,
          'xmas_atlas',
          'Play_Level_Button.png',
        );
      }
      level_button.anchor.setTo(0.5);
      level_button.n = 1;
      level_button.ttt = t1;
      if (t1 != 0) {
        button_animation_f(level_button, 1);
      } else {
        level_button.alpha = 0;
      }
      level_button.events.onInputUp.add(function (item) {
        btnup(item);
        if (
          (popup == 0 && animation == 0 && missions_tab_open == 0 && update_controll == 0) ||
          (t1 == 2 && update_controll == 0)
        ) {
          if (item.n == 2) {
            if (fbv == 1) {
              window.eventTrack('FTUE_3_8_PlayButtonClicked');
            }
          } else if (item.n == 3) {
            if (fbv == 1) {
              window.eventTrack('FTUE_5_5_PlayButtonClicked');
            }
          } else if (item.n == 4) {
            if (fbv == 1) {
              window.eventTrack('FTUE_7_5_PlayButtonClicked');
            }
          } else if (item.n == 5) {
            if (fbv == 1) {
              window.eventTrack('FTUE_9_7_PlayButtonClicked');
            }
          }
          if (sound_on == 1) {
            play_sound('button_press');
          }
          if (t1 == 2) {
            if (d != 0) d.destroy();
            f_w_a();
            popup = 0;
            animation = 0;
            missions_tab_open = 0;
            map_move = 0;
            game.world.bringToTop(black_sprite);
          }
          baloon = 0;
          level_select(item);
          t1 = 0;
        }
      });
      level_button.fixedToCamera = true;
      UI_bottom_group.add(level_button);
      level_button.n = xmas == 0 ? all_level.lastIndexOf(3) + 2 : xmas_level + 1;
      level_button.loadTexture('game_ui_atlas', (game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1 || xmas == 1) ? 'Super_Hard_Level_Button.png' : game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? 'Hard_Level_Button.png' : 'Play_Button.png');
      if (xmas == 1 && xmas_level >= 45) { level_button.inputEnabled = false; level_button.visible = 0; }
      text_level_button = game.add.text(-10, 0, level_button.n, {
        font: '52px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      text_level_button.anchor.setTo(0.5);
      text_level_button.type = 100;
      level_button.addChild(text_level_button);
      if (level_button.n > 15 && level_button.n - (1 % 5) == 0) {
        if (first_start == -2) {
          first_start = 0;
          game.setUserDataAndLog({ first_start: first_start });
        }
      }
      if (!level_button.children[1] && sunflowerDate != 0 && xmas == 0) {
        var prize_n = 1;
        if (sunflowerStage >= 2) {
          prize_n = 2;
        }
        if (sunflowerStage >= 8) {
          prize_n = 3;
        }
        var sunflower_small = game.add.sprite(40, -60, 'sunflower_atlas', 'Bean_Icon.png');
        sunflower_small.anchor.setTo(0.5);
        var Sunflower_Prize = game.add.sprite(0, 75, 'sunflower_atlas', 'Sunflower_Prize_' + prize_n + '.png');
        Sunflower_Prize.anchor.setTo(0.5, 1);
        sunflower_small.addChild(Sunflower_Prize);
        sunflower_small.scale.setTo(0.5);
        level_button.addChild(sunflower_small);
      }
      if (!level_button.children[1] && magicbeanDate != 0 && xmas == 0) {
        var Icon_Level_Button = game.add.sprite(40, -60, 'magicbean_atlas', 'Icon_Level_Button.png');
        Icon_Level_Button.anchor.setTo(0.5);
        level_button.addChild(Icon_Level_Button);
      }
      if (xmas == 0) {
        build_button = game.add.sprite(
          game.camera.width / 2 - 815,
          game.camera.height - 120,
          'game_ui_atlas',
          'Tasks_Menu_Button_Inactiv.png',
        );
        build_button.anchor.setTo(0.5);
        build_button.ttt = t2;
        if (t2 != 0) {
          button_animation_f(build_button, 1);
        } else {
          build_button.alpha = 0;
        }
        build_button.events.onInputUp.add(function (item) {
          btnup(item);
          if (
            (popup == 0 && animation == 0 && update_controll == 0) ||
            (t2 == 2 && animation == 0 && update_controll == 0)
          ) {
            if (level_button.n == 3) {
              if (fbv == 1) {
                window.eventTrack('FTUE_5_3_TaskButtonClicked');
              }
            } else if (level_button.n == 4) {
              if (fbv == 1) {
                window.eventTrack('FTUE_7_2_TaskButtonClicked');
              }
            } else if (level_button.n == 5) {
              if (fbv == 1) {
                window.eventTrack('FTUE_9_3_TaskButtonClicked');
              }
            } else if (level_button.n == 6) {
              if (fbv == 1) {
                window.eventTrack('FTUE_11_2_TaskButtonClicked');
              }
            }
            if (sound_on == 1) {
              play_sound('button_press');
            }
            popup = 1;
            if (t2 != 2) {
              blackf();
            } else {
              if (d != 0) d.destroy();
              f_w_a();
            }
            if (FTUE != 5 && FTUE != 10 && FTUE != 14 && FTUE != 20 && FTUE != 23 && FTUE != 26) {
              bottom_button('Activ', 'Inactiv', 'Inactiv', UI_bottom_group, backcard_group);
            } else {
              UI_bottom_group.removeAll(true);
            }
            offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
            build_window();
            t2 = 0;
          }
        });
        build_button.fixedToCamera = true;
        UI_bottom_group.add(build_button);
      }
      if (xmas == 0) {
        invitereward_button = game.add.sprite(
          game.camera.width / 2 - 836,
          game.camera.height - 300,
          'game_ui_atlas',
          'Friends_Button.png',
        );
        invitereward_button.anchor.setTo(0.5);
        invitereward_button.ttt = t3;
        if (t3 != 0 && FTUE >= 42) {
          button_animation_f(invitereward_button, 1);
        } else {
          invitereward_button.alpha = 0;
        }
        invitereward_button.events.onInputUp.add(function (item) {
          return;
          btnup(item);
          if (sound_on == 1) {
            play_sound('button_press');
          }
          if (update_controll == 0) {
            if ((popup == 0 && animation == 0) || FTUE == 42) {
              offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
              friends_create();
            }
          }
        });
        invitereward_button.fixedToCamera = true;
        UI_bottom_group.add(invitereward_button);
        furniture_button = game.add.sprite(
          game.camera.width / 2 - 635,
          game.camera.height - 100,
          'game_ui_atlas',
          'Furniture_Button.png',
        );
        furniture_button.anchor.setTo(0.5);
        furniture_button.ttt = t4;
        if (t4 != 0 && FTUE > 39) {
          button_animation_f(furniture_button, 1);
        } else {
          furniture_button.alpha = 0;
        }
        furniture_button.events.onInputUp.add(function (item) {
          btnup(item);
          if (
            (popup == 0 && animation == 0 && update_controll == 0) ||
            (FTUE == 40 && fff == 0 && update_controll == 0)
          ) {
            if (fbv == 1 && FTUE == 40) {
              window.eventTrack('FTUE_14_2_decorate_icon_clicked');
            }
            offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
            if (sound_on == 1) {
              play_sound('button_press');
            }
            special_show();
            if (FTUE == 40) {
              FTUE_process();
            }
          }
        });
        furniture_button.fixedToCamera = true;
        UI_bottom_group.add(furniture_button);

        //if (FTUE >= 151) {
        // app.xPromo.getItemAsync(XPromoPlacement.IconPictureCombo).then((item) => {
        // const icon = game.make.sprite(offer_icon != 0 ? game.camera.width / 2 - 436 + 60 : game.camera.width / 2 - 536 + 60, game.camera.height - 162 + 60, item.icon);
        // var iw = 121/icon.width;
        // icon.scale.set(iw);
        // icon.anchor.setTo(0.5);
        // icon.fixedToCamera = true;
        // button_animation_f(icon, iw);
        //       UI_bottom_group.add(icon);
        //       window.icon = icon;

        // icon.events.onInputDown.add(() => {
        // 	if (popup == 0 && animation == 0)
        // 	{
        // 		popup = 1;
        // 		btnup(window.icon);
        // 		xPromoWindows(item);
        // 	}
        // });


        //       var indicator = game.add.sprite(
        //         window.icon.width / 2 + 40,
        //         -window.icon.height / 2 - 40,
        //         'game_ui_atlas',
        //         'Friends_Notification.png',
        //       );
        //       indicator.anchor.setTo(0.5);
        //       indicator.scale.setTo(0);
        //       window.icon.addChild(indicator);
        //       game.add.tween(indicator.scale).to({ x: 2, y: 2 }, 400, Phaser.Easing.Bounce.Out, true);
        //       indicator_anim(indicator,2);

        // });
        //}
      }
    }
    // function xPromoWindows(newitem) {
    //       popup_group.y = 0;
    //       popup_group.y += game.camera.height;
    //       popup = 1;
    //       blackf();
    //       var popup_back = windows_f('A New Game!', 111, newitem);
    //       var Play_Button = game.add.sprite(
    //         game.camera.width / 2,
    //         game.camera.height / 2 + 285,
    //         'game_window_atlas',
    //         'Play_Button.png',
    //       );
    //       Play_Button.anchor.setTo(0.5);
    //       popup_group.add(Play_Button);
    //       Play_Button.fixedToCamera = true;
    //       button_animation_f(Play_Button, 1);
    //       Play_Button.events.onInputUp.add(function (item) {
    //           btnup(item);
    //           if (sound_on == 1) {
    //             play_sound('button_press');
    //           }
    // 		newitem.switchGame();
    //       }, this);
    //       var Play_Button_text = game.add.text(0, 0, 'Play Now', {
    //         font: '38px RussoOne',
    //         fill: '#fff',
    //         align: 'center',
    //       });
    //       Play_Button_text.anchor.setTo(0.5);
    //       Play_Button_text.stroke = '#3C6C05';
    //       Play_Button_text.strokeThickness = 4;
    //       Play_Button_text.setShadow(0, 2, 'rgba(60,108,5,1)', 0);
    //       Play_Button.addChild(Play_Button_text);
    //       game.add
    //         .tween(popup_group)
    //         .to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true)
    //         .onComplete.add(function (item) {});
    // }
    if (FTUE != 0) UI_bottom_group_create(1, 1, 1, 1, 0);
    else UI_bottom_group_create(0, 0, 0, 0, 0);
    function contains(where, what) {
      for (var i = 0; i < what.length; i++) {
        if (where.indexOf(what[i]) == -1) return false;
      }
      return true;
    }
    var emitter_smoke = game.add.emitter(0, 0, 50);
    emitter_smoke.makeParticles('game_atlas', 'smoke.png');
    emitter_smoke.bringToTop = true;
    emitter_smoke.setRotation(0, 360, 500);
    emitter_smoke.setAlpha(1, 0, 500);
    emitter_smoke.setScale(0.1, 1, 0.1, 1, 500);
    emitter_smoke.gravity = 0;
    emitter_smoke.minParticleSpeed.set(-500, -500);
    emitter_smoke.maxParticleSpeed.set(500, 500);
    emitter_smoke.explode = true;
    emitter_smoke.blendMode = 1;
    function sparckEffect(obj, xxx, yyy) {
      obj.x = xxx[game.rnd.integerInRange(0, xxx.length - 1)];
      obj.y = yyy[game.rnd.integerInRange(0, yyy.length - 1)];
      let time = game.rnd.integerInRange(500, 2000);
      game.add.tween(obj.scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Linear.None, true, time);
      game.add.tween(obj).to({ angle: 360 }, 600, Phaser.Easing.Linear.None, true, time);
      game.add
        .tween(obj)
        .to({ alpha: 1 }, 600, Phaser.Easing.Linear.None, true, time)
        .onComplete.add(function (item) {
          game.add.tween(item.scale).to({ x: 0, y: 0 }, 600, Phaser.Easing.Linear.None, true);
          game.add.tween(item).to({ angle: 360 }, 600, Phaser.Easing.Linear.None, true);
          game.add
            .tween(item)
            .to({ alpha: 0 }, 600, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              sparckEffect(item, xxx, yyy);
            });
        });
    }
    function newgame_window() {
      if (popup == 0 && missions_tab_open == 0) {
        missions_tab_open = 9999;
        animation = 1;
        popup_group.y = 0;
        popup = 1;
        blackf();
        var popup_close = game.add.sprite(game.camera.width + 100, 100, 'game_window_atlas', 'Close_Button.png');
        popup_close.anchor.setTo(0.5);
        button_animation_f(popup_close, 1);
        popup_close.events.onInputUp.add(function () {
          if (popup != 2) {
            popup = 2;
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup = 0;
                missions_tab_open = 0;
                animation = 0;
                popup_group.y -= game.camera.height;
              });
          }
        }, this);
        popup_group.add(popup_close);
        popup_close.fixedToCamera = true;
        game.add.tween(popup_close.cameraOffset).to({ x: '-200' }, 500, Phaser.Easing.Exponential.Out, true);
        var shine = game.add.sprite(game.camera.width / 2, game.camera.height / 2, 'game_ui_atlas', 'Shine.png');
        shine.anchor.setTo(0.5, 0.52);
        shine.scale.setTo(0);
        shine.alpha = 0.3;
        popup_group.add(shine);
        shine.fixedToCamera = true;
        game.add.tween(shine.scale).to({ x: 4, y: 4 }, 1000, Phaser.Easing.Exponential.Out, true);
        rotate_tween(shine);
        var newgame_image = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2,
          'message_atlas',
          'tales_horizontalbanner.png',
        );
        newgame_image.anchor.setTo(0.5, 0.52);
        newgame_image.scale.setTo(0);
        popup_group.add(newgame_image);
        newgame_image.fixedToCamera = true;
        game.add.tween(newgame_image.scale).to({ x: 3, y: 3 }, 800, Phaser.Easing.Bounce.Out, true);
        var text_popup_title = game.add.text(game.camera.width / 2, game.camera.height / 2 - 360, 'NEW GAME', {
          font: '64px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        text_popup_title.anchor.setTo(0.5);
        text_popup_title.stroke = '#1A6383';
        text_popup_title.strokeThickness = 4;
        text_popup_title.setShadow(0, 4, 'rgba(26,99,131,1)', 1);
        popup_group.add(text_popup_title);
        text_popup_title.alpha = 0;
        text_popup_title.fixedToCamera = true;
        game.add
          .tween(text_popup_title)
          .to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function () {
            animation = 0;
          });
        var Big_Kit_Button = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 400,
          'game_window_atlas',
          'Big_Kit_Button.png',
        );
        Big_Kit_Button.anchor.setTo(0.5);
        Big_Kit_Button.scale.setTo(1.4);
        Big_Kit_Button.inputEnabled = true;
        Big_Kit_Button.events.onInputDown.add(function (item2) {
          if (popup != 2) {
            popup = 2;
            // FBInstant.switchGameAsync('243759199843609', {
            //   originGameId: '279689396297126',
            //   originPlayerId: CurrentUserId,
            //   placement: 0,
            //   promoReward: 0,
            // }).catch(function (e) {
            //   popup = 1;
            // });
          }
        });
        Big_Kit_Button.fixedToCamera = true;
        popup_group.addChild(Big_Kit_Button);
        Big_Kit_Button.input.useHandCursor = true;
        scale_tween(Big_Kit_Button, 500, 0.1, 0.1);
        var Big_Kit_Button_text = game.add.text(0, 0, 'PLAY', { font: '28px RussoOne', fill: '#fff', align: 'center' });
        Big_Kit_Button_text.anchor.setTo(0.5);
        Big_Kit_Button_text.stroke = '#46730C';
        Big_Kit_Button_text.strokeThickness = 4;
        Big_Kit_Button_text.setShadow(0, 4, 'rgba(70,115,12,0.5)', 1);
        Big_Kit_Button.addChild(Big_Kit_Button_text);
      }
    }
    var day_tasks = [];
    var all_day_build = 0;
    var all_day_stars = 0;
    task_create();
    function task_create() {
      day_tasks = [];
      all_day_build = Number(game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0]['builds']);
      all_day_stars = Number(game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0]['stars']);
      for (var i = 0; i < all_day_build; i++) {
        let type = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['type'];
        let sprite = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['icon'];
        let atlas = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['atlas'];
        let preDialog = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['preDialog'];
        let ifComplete = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['ifComplete'];
        let stars = Number(game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['stars']);
        let texts = game.cache.getJSON('lang')[
          game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['text']
        ][0][window.lang];
        let dial = game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + Number(i + 1)][0]['Dialog'];
        day_tasks.push({
          type: type,
          sprite: sprite,
          atlas: atlas,
          preDialog: preDialog,
          ifComplete: ifComplete,
          stars: stars,
          text: texts,
          dialog: dial,
        });
      }
      /* objects_group.children.forEach(function (child_item) {
         if (
           (child_item.type == 16 || child_item.type == -16) &&
           day_tasks.findIndex(function (e) {
             return e['type'] == '2003';
           }) != -1
         ) {
           if (
             mission_task[
               day_tasks.findIndex(function (e) {
                 return e['type'] == '2003';
               })
             ] == 0
           )
             child_item.children[0].angle -= 80;
         }
       });*/
    }
    var mission_day_end_old = 0;
    function ftue_window(sprite, t, xxx, yyy) {
      popup = 1;
      Dialog_Bubble = draw_rect(xxx, yyy, 1430, 252, '#FAF7F0', '#FAF0D8', 0, 0, 0, 5, 30, 0);
      Dialog_Bubble.fixedToCamera = true;
      Dialog_Bubble.scale.setTo(0);
      Dialog_Bubble.alpha = 0;
      var man1_back = draw_circle(-863 + 200, 160 / 2 + 70 - 292 / 2, 292, '#FAF7EF', '#FAF7EF', 0, 0, 0, 5, 0, 0, 0);
      draw_circle(0, 0, 270, '#DBC2A8', '#AC7C64', 0, 0, man1_back, 0, 0, 0, 0);
      Dialog_Bubble.addChild(man1_back);
      man1 = game.add.sprite(-863 + 160, 160 / 2 + 62, 'game_ui_atlas', 'Character.png');
      man1.anchor.setTo(0.5, 1);
      man1.scale.setTo(0.8, 0);
      Dialog_Bubble.addChild(man1);
      dialog_text = game.add.text(-450, 0, t, {
        font: '42px RussoOne',
        fill: '#C27E54',
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 1100,
      });
      dialog_text.anchor.setTo(0, 0.5);
      Dialog_Bubble.addChild(dialog_text);
      /*var Read_More_Button = game.add.sprite(620, 80, 'game_ui_atlas', 'Read_More_Button.png');
        Read_More_Button.anchor.setTo(0.5);
        Dialog_Bubble.addChild(Read_More_Button);
        game.add.tween(Read_More_Button).to( { y: '-10' }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);*/
      game.add.tween(man1.scale).to({ y: 0.8 }, 1000, Phaser.Easing.Elastic.Out, true, 200);
      game.add.tween(Dialog_Bubble.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Exponential.Out, true);
      game.add.tween(Dialog_Bubble).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true);
      return Dialog_Bubble;
    }
    var taks_indicator_mas = [];
    function taks_indicator(nd) {
      var animstart = 0;
      console.log(taks_indicator_mas, all_day_build, complete_task_i, mission_day_end);
      if (taks_indicator_mas.length == 0 && xmas == 0) {
        let n_tasks = [];
        for (i = 0; i < all_day_build; i++) {
          try {
            if (complete_task_i != -1) {
              if (
                contains(mission_number, day_tasks[i]['ifComplete'].split(',')) &&
                contains(day_tasks[i]['ifComplete'].split(','), [day_tasks[complete_task_i]['type']])
              ) {
                n_tasks.push(i);
              }
            }
            else
              if (complete_task_i == -1 && mission_day_end == 0 && contains('0', day_tasks[i]['ifComplete'].split(',')) && nd) {
                n_tasks.push(i);
              }
          } catch (err) { }
        }
        indicator_system(0);
        console.log(n_tasks);
        if (n_tasks.length > 0) {
          if (sound_on == 1) {
            play_sound('new_task_appear');
          }
        }
        for (var i = 0; i < n_tasks.length; i++) {
          if (FTUE >= 42)
            var graphics = draw_rect(
              game.camera.width / 2 - 2122 + 150 * i,
              game.camera.height - 440,
              165,
              165,
              '#F1E6D0',
              '#EED29B',
              0,
              0,
              0,
              5,
              30,
              0,
              1,
            );
          else
            var graphics = draw_rect(
              game.camera.width / 2 - 2122 + 150 * i,
              game.camera.height - 360,
              165,
              165,
              '#F1E6D0',
              '#EED29B',
              0,
              0,
              0,
              5,
              30,
              0,
              1,
            );
          draw_rect_shadow(0, 0, 142, 138, '#000', '#000', 0, 0, graphics, 20);
          draw_rect(0, 0, 142, 138, '#F8F4EC', '#F8F4EC', 0, 0, graphics, 0, 20, 0);
          draw_rect_shadow(0, 0, 126, 122, '#000', '#000', 0, 0, graphics, 20);
          draw_rect(0, 0, 126, 122, '#F7F1E5', '#F4E3BA', 0, 0, graphics, 0, 20, 0);
          graphics.scale.setTo(0);
          graphics.iii = n_tasks[i];
          button_animation_f(graphics, 0.8);
          graphics.inputEnabled = false;
          graphics.events.onInputUp.add(function (item) {
            btnup(item);
            if (
              popup == 0 &&
              animation == 0 &&
              build_button.inputEnabled == true &&
              FTUE >= 35 &&
              update_controll == 0
            ) {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              item.inputEnabled = false;
              popup = 1;
              blackf();
              bottom_button('Activ', 'Inactiv', 'Inactiv', UI_bottom_group, backcard_group);
              build_window();
            }
          });
          var new_task_text = game.add.text(0, 50, game.cache.getJSON('lang')['t276'][0][window.lang], {
            font: '22px RussoOne',
            fill: '#8C3B32',
            align: 'center',
          });
          new_task_text.anchor.setTo(0.5);
          graphics.addChild(new_task_text);
          var task1 = game.add.sprite(0, -15, day_tasks[n_tasks[i]]['atlas'], day_tasks[n_tasks[i]]['sprite'] + '.png');
          if (task1.width > task1.height) task1.scale.setTo(80 / task1.width);
          else task1.scale.setTo(80 / task1.height);
          task1.anchor.setTo(0.5);
          graphics.addChild(task1);
          if (day_tasks[n_tasks[i]]['type'] == 6) {
            task1.tint = 0xca8b5c;
            let sub_task = game.add.sprite(0, -15, 'farm_obj_c_atlas', 'roof_2.png');
            sub_task.anchor.setTo(0.5);
            if (sub_task.width > sub_task.height) sub_task.scale.setTo(80 / sub_task.width);
            else sub_task.scale.setTo(80 / sub_task.height);
            graphics.addChild(sub_task);
          }
          if (day_tasks[n_tasks[i]]['type'] == 128) {
            task1.tint = 0x889699;
          }
          taks_indicator_mas.push(graphics);
          game.add.tween(graphics.cameraOffset).to({ x: '+1300' }, 300, Phaser.Easing.Linear.None, true, i * 100);
          game.add
            .tween(graphics)
            .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true, i * 100)
            .onComplete.add(function (item) {
              item.inputEnabled = true;
              item.input.useHandCursor = true;
              game.world.bringToTop(item);

              game.add.tween(item.cameraOffset).to({ x: build_button.cameraOffset.x, y: build_button.cameraOffset.y }, 300, Phaser.Easing.Cubic.Out, true, 1000);
              game.add.tween(item).to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true, 900).onComplete.add(function (item) {
                item.inputEnabled = false;
                item.input.useHandCursor = false;
                if (animstart == 0) { game.add.tween(build_button.scale).to({ x: 1.1, y: 0.9 }, 400, Phaser.Easing.Elastic.Out, true, 0, 0).yoyo(true, 0); animstart = 1; }
                item.destroy();
                /*add_shines(build_button, 3, 1);
                add_shines(build_button, 3, 1);
                add_shines(build_button, 3, 1);	*/
              });

            });
          game.add.tween(graphics.scale).to({ x: 0.8, y: 0.8 }, 900, Phaser.Easing.Bounce.Out, true, i * 100);
          UI_left_group.add(graphics);
          game.world.bringToTop(UI_left_group);
        }
      }
    }
    function build_action(n_i, taskpause) {
      game.add.tween(effects_group).to({ alpha: 1 }, taskpause, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
        if (day_tasks[n_i]['preDialog'] != '0') {
          var child_item_t = 0;
          animation = 1;
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 300, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item2) {
              item2.destroy();
            });
          game.add.tween(backcard_group).to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true);
          game.add
            .tween(UI_bottom_group)
            .to({ y: '+400' }, 200, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item2) {
              friends_group.removeAll(true);
              backcard_group.removeAll(true); mission_group.removeAll(true);
              backcard_group.alpha = 1;
              item2.removeAll(true);
              UI_bottom_group_create(1, 1, 1, 1, 0);
              item2.y = 400;
              game.add.tween(item2).to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true);
              if (
                day_tasks[n_i]['type'] < 2000 &&
                day_tasks[n_i]['type'] != 88 &&
                day_tasks[n_i]['type'] != 97 &&
                day_tasks[n_i]['type'] != 1027 &&
                day_tasks[n_i]['type'] != 1034 &&
                day_tasks[n_i]['type'] != 132 &&
                day_tasks[n_i]['type'] != 127 &&
                day_tasks[n_i]['type'] != 141 &&
                day_tasks[n_i]['type'] != 183 &&
                day_tasks[n_i]['type'] != 1068 &&
                day_tasks[n_i]['type'] != 1070 &&
                day_tasks[n_i]['type'] != 186
              ) {
                objects_group.children.some(function (child_item2) {
                  console.log(child_item2.type, day_tasks[n_i]['type']);
                  if (
                    Math.abs(child_item2.type) == day_tasks[n_i]['type'] ||
                    (Math.abs(child_item2.type) == 102 && day_tasks[n_i]['type'] == 1028) ||
                    (Math.abs(child_item2.type) == 102 && day_tasks[n_i]['type'] == 1030) ||
                    (Math.abs(child_item2.type) == 102 && day_tasks[n_i]['type'] == 1031) ||
                    (Math.abs(child_item2.type) == 133 && day_tasks[n_i]['type'] == 1040) ||
                    (Math.abs(child_item2.type) == 130 && day_tasks[n_i]['type'] == 1300) ||
                    (Math.abs(child_item2.type) == 161 && day_tasks[n_i]['type'] == 1054) ||
                    (Math.abs(child_item2.type) == 161 && day_tasks[n_i]['type'] == 1055) ||
                    (Math.abs(child_item2.type) == 161 && day_tasks[n_i]['type'] == 1056) ||
                    (Math.abs(child_item2.type) == 161 && day_tasks[n_i]['type'] == 1058) ||
                    (Math.abs(child_item2.type) == 152 && day_tasks[n_i]['type'] == 1059) ||
                    (Math.abs(child_item2.type) == 152 && day_tasks[n_i]['type'] == 1060) ||
                    (Math.abs(child_item2.type) == 183 && day_tasks[n_i]['type'] == 1062) ||
                    (Math.abs(child_item2.type) == 183 && day_tasks[n_i]['type'] == 1063) ||
                    (Math.abs(child_item2.type) == 183 && day_tasks[n_i]['type'] == 1069)
                  ) {
                    child_item_t = child_item2;
                    return true;
                  }
                });
                follow.x = child_item_t.x * worldScale;
                follow.y = child_item_t.y * worldScale;
                last_position = [child_item_t.x * worldScale, child_item_t.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
              }
              game.add.tween(effects_group).to({ alpha: 1 }, 300, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                popup = 0;
                missions_tab_open = 0;
                dialog_window(Number(day_tasks[n_i]['preDialog']), 0, n_i);
                if (Number(day_tasks[n_i]['preDialog']) == 221) {
                  object_outline1 = game.add.sprite(child_item_t.x * worldScale, child_item_t.y * worldScale, child_item_t.key, child_item_t.frameName);
                  object_outline1.anchor.setTo(0.5);
                  object_outline1.scale.setTo(2.9 * worldScale + 0.2 * worldScale);
                  object_outline1.tint = 0xffff00;
                  object_outline2 = game.add.sprite(child_item_t.x * worldScale, child_item_t.y * worldScale, child_item_t.key, child_item_t.frameName);
                  object_outline2.anchor.setTo(0.5);
                  object_outline2.scale.setTo(2.9 * worldScale);
                }
                day_tasks[n_i]['preDialog'] = '0';
              });
            });
        } else if (day_tasks[n_i]['type'] == 97 || day_tasks[n_i]['type'] == 110 || day_tasks[n_i]['type'] == 1300) {
          var tasktype = day_tasks[n_i]['type'];
          animation = 1;
          popup = 1;
          complete_task_i = n_i;
          mission_task[n_i] = 1;
          mission_number.push(day_tasks[n_i]['type']);
          game.setUserDataAndLog({
            complete_task_i: complete_task_i,
            mission_stars_end: mission_stars_end,
            mission_task: JSON.stringify(mission_task),
            mission_number: JSON.stringify(mission_number),
            mission_day_end: mission_day_end,
            all_stars: all_stars,
          });
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item2) {
              item2.destroy();
            });
          game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
          game.add
            .tween(UI_bottom_group)
            .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item2) {
              friends_group.removeAll(true);
              backcard_group.removeAll(true); mission_group.removeAll(true);
              backcard_group.alpha = 1;
              item2.removeAll(true);
              UI_bottom_group_create(1, 1, 1, 1, 0);
              item2.y = 400;
              game.add.tween(item2).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
              var child_item = 0;
              if (
                tasktype == 97 &&
                new_options.findIndex(function (e) {
                  return Math.abs(Number(e['type'])) == Math.abs(Number(54));
                }) == -1
              ) {
                new_options.push({ type: 54, num: [1, 2, 3, 4, 5] });
                new_options.push({ type: 43, num: [1, 2, 3, 4, 5] });
                new_options.push({ type: 541, num: [1, 2, 3, 4, 5] });
                new_options.push({ type: 431, num: [1, 2, 3, 4, 5] });
                new_options.push({ type: 24, num: [1, 2, 3, 4, 5] });
                game.setUserDataAndLog({ new_options: JSON.stringify(new_options) });
              } else if (
                tasktype == 110 &&
                new_options.findIndex(function (e) {
                  return Math.abs(Number(e['type'])) == Math.abs(Number(53));
                }) == -1
              ) {
                var old_item = [1, 2, 3, 4, 5];
                var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(53)) }));
                if (typeof new_options[tp] !== 'undefined') {
                  old_item = new_options[tp]['num'];
                  old_item.push(1, 2, 3, 4, 5);
                  new_options.splice(tp, 1);
                }
                new_options.push({ type: 53, num: old_item });
                var old_item = [1, 2, 3, 4, 5];
                var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(109)) }));
                if (typeof new_options[tp] !== 'undefined') {
                  old_item = new_options[tp]['num'];
                  old_item.push(1, 2, 3, 4, 5);
                  new_options.splice(tp, 1);
                }
                new_options.push({ type: 109, num: old_item });
                game.setUserDataAndLog({ new_options: JSON.stringify(new_options) });
              } else if (
                tasktype == 1300 &&
                new_options.findIndex(function (e) {
                  return Math.abs(Number(e['type'])) == Math.abs(Number(130));
                }) == -1
              ) {
                new_options.push({ type: 130, num: [1, 2, 3, 4, 5, 6] });
                game.setUserDataAndLog({ new_options: JSON.stringify(new_options) });
              }
              indicator_system(0);
              objects_group.children.some(function (child_item2) {
                if (tasktype == 97) {
                  if (child_item2.type == 54) {
                    child_item = child_item2;
                    if (
                      map_tiled_st.findIndex(function (e) {
                        return Number(e['i']) == Number(child_item2.type);
                      }) == -1
                    ) {
                      special_object.push(Number(child_item.type + '' + 1 + '' + 1));
                      map_tiled_st.push({ i: Number(child_item.type), s: Number(1) });
                    }
                    child_item.inputEnabled = true;
                  } else if (child_item2.type == 43) {
                    child_item = child_item2;
                    if (
                      map_tiled_st.findIndex(function (e) {
                        return Number(e['i']) == Number(child_item2.type);
                      }) == -1
                    ) {
                      special_object.push(Number(child_item.type + '' + 1 + '' + 1));
                      map_tiled_st.push({ i: Number(child_item.type), s: Number(1) });
                    }
                    child_item.inputEnabled = true;
                  } else if (child_item2.type == 541) {
                    child_item = child_item2;
                    if (
                      map_tiled_st.findIndex(function (e) {
                        return Number(e['i']) == Number(child_item2.type);
                      }) == -1
                    ) {
                      special_object.push(Number(child_item.type + '' + 1 + '' + 1));
                      map_tiled_st.push({ i: Number(child_item.type), s: Number(1) });
                    }
                    child_item.inputEnabled = true;
                  } else if (child_item2.type == 431) {
                    child_item = child_item2;
                    if (
                      map_tiled_st.findIndex(function (e) {
                        return Number(e['i']) == Number(child_item2.type);
                      }) == -1
                    ) {
                      special_object.push(Number(child_item.type + '' + 1 + '' + 1));
                      map_tiled_st.push({ i: Number(child_item.type), s: Number(1) });
                    }
                    child_item.inputEnabled = true;
                  } else if (child_item2.type == 24) {
                    child_item = child_item2;
                    if (
                      map_tiled_st.findIndex(function (e) {
                        return Number(e['i']) == Number(child_item2.type);
                      }) == -1
                    ) {
                      special_object.push(Number(child_item.type + '' + 1 + '' + 1));
                      map_tiled_st.push({ i: Number(child_item.type), s: Number(1) });
                    }
                    child_item.inputEnabled = true;
                  }
                } else if (tasktype == 110) {
                  if (child_item2.type == 53) {
                    child_item = child_item2;
                    if (
                      map_tiled_st.findIndex(function (e) {
                        return Number(e['i']) == Number(child_item2.type);
                      }) == -1
                    ) {
                      special_object.push(Number(child_item.type + '' + 1 + '' + 1));
                      map_tiled_st.push({ i: Number(child_item.type), s: Number(1) });
                    }
                    child_item.inputEnabled = true;
                  }
                  if (child_item2.type == 109) {
                    child_item = child_item2;
                    if (
                      map_tiled_st.findIndex(function (e) {
                        return Number(e['i']) == Number(child_item2.type);
                      }) == -1
                    ) {
                      special_object.push(Number(child_item.type + '' + 1 + '' + 1));
                      map_tiled_st.push({ i: Number(child_item.type), s: Number(1) });
                    }
                    child_item.inputEnabled = true;
                  }
                } else if (tasktype == 1300) {
                  console.log(
                    'child_item2.type',
                    child_item2.type,
                    map_tiled_st.findIndex(function (e) {
                      return Number(e['i']) == Number(child_item2.type);
                    }),
                  );
                  if (child_item2.type == 130) {
                    child_item = child_item2;
                    if (
                      map_tiled_st.findIndex(function (e) {
                        return Number(e['i']) == Number(child_item2.type);
                      }) == -1
                    ) {
                      special_object.push(Number(child_item.type + '' + 1 + '' + 1));
                      map_tiled_st.push({ i: Number(child_item.type), s: Number(1) });
                    }
                    child_item.inputEnabled = true;
                  }
                }
              });
              child_item.iii = n_i + 1;
              var nnn = 0;
              objects_group.children.some(function (child_item2) {
                if (child_item2.type == 54 && tasktype == 97) {
                  child_item = child_item2;
                  return true;
                }
                else
                  if (child_item2.type == 53 && tasktype == 110) {
                    if (nnn == 18) {
                      child_item = child_item2;
                      return true;
                    } else {
                      nnn++;
                    }
                  }
                  else
                    if (child_item2.type == 130) {
                      child_item = child_item2;
                      return true;
                    }
              });
              follow.x = child_item.x * worldScale;
              follow.y = child_item.y * worldScale;
              last_position = [child_item.x * worldScale, child_item.y * worldScale];
              game.setUserDataAndLog({
                last_position: JSON.stringify(last_position),
                special_object: JSON.stringify(special_object),
                map_tiled_st: JSON.stringify(map_tiled_st),
              });
              game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                missions_tab_open = 0;
                animation = 0;
                popup = 0;
                special_show();
              });
            });
        } else if (
          day_tasks[n_i]['type'] == 79 ||
          day_tasks[n_i]['type'] == 80 ||
          day_tasks[n_i]['type'] == 1016 ||
          day_tasks[n_i]['type'] == 1017 ||
          day_tasks[n_i]['type'] == 1026 ||
          day_tasks[n_i]['type'] == 1027 ||
          day_tasks[n_i]['type'] == 1028 ||
          day_tasks[n_i]['type'] == 1030 ||
          day_tasks[n_i]['type'] == 1031 ||
          day_tasks[n_i]['type'] == 1032 ||
          day_tasks[n_i]['type'] == 1033 ||
          day_tasks[n_i]['type'] == 1034 ||
          day_tasks[n_i]['type'] == 1036 ||
          day_tasks[n_i]['type'] == 1040 ||
          day_tasks[n_i]['type'] == 1046 ||
          day_tasks[n_i]['type'] == 1047 ||
          day_tasks[n_i]['type'] == 1048 ||
          day_tasks[n_i]['type'] == 1043 ||
          day_tasks[n_i]['type'] == 1049 ||
          day_tasks[n_i]['type'] == 1050 ||
          day_tasks[n_i]['type'] == 1051 ||
          day_tasks[n_i]['type'] == 1053 ||
          day_tasks[n_i]['type'] == 1054 ||
          day_tasks[n_i]['type'] == 1055 ||
          day_tasks[n_i]['type'] == 1056 ||
          day_tasks[n_i]['type'] == 1058 ||
          day_tasks[n_i]['type'] == 1059 ||
          day_tasks[n_i]['type'] == 1060 ||
          day_tasks[n_i]['type'] == 1062 ||
          day_tasks[n_i]['type'] == 1063 ||
          day_tasks[n_i]['type'] == 1064 ||
          day_tasks[n_i]['type'] == 1066 ||
          day_tasks[n_i]['type'] == 1067 ||
          day_tasks[n_i]['type'] == 1069 ||
          day_tasks[n_i]['type'] == 1070
        ) {
          animation = 1;
          complete_task_i = n_i;
          mission_task[n_i] = 1;
          mission_number.push(day_tasks[n_i]['type']);
          game.setUserDataAndLog({
            complete_task_i: complete_task_i,
            mission_stars_end: mission_stars_end,
            mission_task: JSON.stringify(mission_task),
            mission_number: JSON.stringify(mission_number),
            mission_day_end: mission_day_end,
            all_stars: all_stars,
          });
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item2) {
              item2.destroy();
            });
          game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
          game.add
            .tween(UI_bottom_group)
            .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item2) {
              friends_group.removeAll(true);
              backcard_group.removeAll(true); mission_group.removeAll(true);
              backcard_group.alpha = 1;
              item2.removeAll(true);
              UI_bottom_group_create(1, 1, 1, 1, 0);
              item2.y = 400;
              game.add.tween(item2).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
              if (day_tasks[n_i]['type'] == 1027) {
                blackf();
                var shine = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2,
                  'game_ui_atlas',
                  'Shine.png',
                );
                shine.anchor.setTo(0.5, 0.52);
                shine.scale.setTo(0);
                shine.alpha = 0.3;
                shine.fixedToCamera = true;
                game.add.tween(shine.scale).to({ x: 2, y: 2 }, 1500, Phaser.Easing.Exponential.In, true, 1300);
                rotate_tween(shine);
                var cloves_sprite = game.add.sprite(
                  game.camera.width / 2 - 500,
                  game.camera.height / 2,
                  'farm_obj_atlas',
                  'Aloe_Vera_Icon.png',
                );
                cloves_sprite.scale.setTo(0);
                cloves_sprite.alpha = 0;
                cloves_sprite.anchor.setTo(0.5);
                cloves_sprite.fixedToCamera = true;
                game.add.tween(cloves_sprite.scale).to({ x: 2.9, y: 2.9 }, 1000, Phaser.Easing.Bounce.Out, true);
                game.add.tween(cloves_sprite).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(cloves_sprite.cameraOffset).to({ x: '+500' }, 1000, Phaser.Easing.Cubic.In, true, 1300);
                game.add
                  .tween(cloves_sprite)
                  .to({ x: 0 }, 1000, Phaser.Easing.Linear.None, true, 1300)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                cloves_sprite = game.add.sprite(
                  game.camera.width / 2 + 500,
                  game.camera.height / 2,
                  'farm_obj_atlas',
                  'Bandage_Icon.png',
                );
                cloves_sprite.scale.setTo(0);
                cloves_sprite.alpha = 0;
                cloves_sprite.anchor.setTo(0.5);
                cloves_sprite.fixedToCamera = true;
                game.add.tween(cloves_sprite.scale).to({ x: 2.9, y: 2.9 }, 1000, Phaser.Easing.Bounce.Out, true);
                game.add.tween(cloves_sprite).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(cloves_sprite.cameraOffset).to({ x: '-500' }, 1000, Phaser.Easing.Cubic.In, true, 1300);
                game.add
                  .tween(cloves_sprite)
                  .to({ x: 0 }, 1000, Phaser.Easing.Linear.None, true, 1300)
                  .onComplete.add(function (item) {
                    item.destroy();
                    cloves_sprite = game.add.sprite(
                      game.camera.width / 2,
                      game.camera.height / 2,
                      'farm_obj_atlas',
                      'Bandage_Aloe_Vera_Icon.png',
                    );
                    cloves_sprite.scale.setTo(0);
                    cloves_sprite.alpha = 0;
                    cloves_sprite.anchor.setTo(0.5);
                    cloves_sprite.fixedToCamera = true;
                    game.add.tween(cloves_sprite.scale).to({ x: 2.9, y: 2.9 }, 1000, Phaser.Easing.Bounce.Out, true);
                    game.add.tween(cloves_sprite).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                    game.add
                      .tween(shine)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 1500)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(cloves_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 1500)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(black_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true, 1500)
                      .onComplete.add(function (item) {
                        item.destroy();
                        popup = 0;
                        missions_tab_open = 0;
                        animation = 0;
                      });
                  });
              } else if (day_tasks[n_i]['type'] == 1043) {
                animation = 1;
                var obj = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 140) {
                    obj = child_item2;
                    return true;
                  }
                });
                follow.x = obj.x * worldScale;
                follow.y = obj.y * worldScale;
                last_position = [obj.x * worldScale, obj.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                var obj_mask = game.add.graphics(0, 0);
                obj_mask.beginFill(0xffffff);
                obj_mask.drawRect(
                  obj.x * worldScale - (obj.width / 2) * worldScale,
                  obj.y * worldScale - (obj.height / 2) * worldScale,
                  obj.width * worldScale,
                  obj.height * worldScale,
                );
                obj.mask = obj_mask;
                game.add
                  .tween(obj_mask)
                  .to({ y: '+' + obj.height * worldScale }, 3000, Phaser.Easing.Linear.None, true, 1000);
                var DogHouse1 = game.add.sprite(obj.x, obj.y, 'farm_obj_c_atlas', 'DogHouse1.png');
                DogHouse1.anchor.setTo(0.5);
                DogHouse1.scale.setTo(2.9);
                objects_group.add(DogHouse1);
                var burn_mask = game.add.graphics(0, 0);
                burn_mask.beginFill(0xffffff);
                burn_mask.drawRect(
                  DogHouse1.x * worldScale - (DogHouse1.width / 2) * worldScale,
                  DogHouse1.y * worldScale - (DogHouse1.height / 2) * worldScale - DogHouse1.height * worldScale,
                  DogHouse1.width * worldScale,
                  DogHouse1.height * worldScale,
                );
                DogHouse1.mask = burn_mask;
                game.add
                  .tween(burn_mask)
                  .to({ y: '+' + DogHouse1.height * worldScale }, 3000, Phaser.Easing.Linear.None, true, 1000);
                var paintbrush = game.add.sprite(obj.x, obj.y - 100, 'farm_obj_atlas', 'paintbrush.png');
                paintbrush.anchor.setTo(0.5);
                paintbrush.alpha = 0;
                paintbrush.scale.setTo(4);
                objects_group.add(paintbrush);
                game.add.tween(paintbrush).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true);
                game.add.tween(paintbrush.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Linear.None, true);
                game.add.tween(paintbrush).to({ y: '+200' }, 500, Phaser.Easing.Cubic.Out, true, 1000, 3).yoyo(true, 0);
                game.add
                  .tween(paintbrush)
                  .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 4500)
                  .onComplete.add(function (item) {
                    item.destroy();
                    obj.mask = 0;
                    obj_mask.destroy();
                    DogHouse1.mask = 0;
                    burn_mask.destroy();
                    DogHouse1.destroy();
                    obj.loadTexture('farm_obj_c_atlas', 'DogHouse1.png');
                  });
                game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  animation = 0;
                  popup = 0;
                  first_create = 1;
                  obj.loadTexture('farm_obj_c_atlas', 'DogHouse1.png');
                  build_special_object(obj, 1);
                });
              } else if (day_tasks[n_i]['type'] == 1069) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 183) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  child_item.loadTexture('farm_obj_c_atlas', 'Safe_Open.png');
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 2000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1063) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 183) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                hummer17_anim(child_item)
                /*game.add.tween(effects_group).to({ alpha: 1 }, 4000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  flex_anim(child_item)
                });*/
                game.add.tween(effects_group).to({ alpha: 1 }, 4000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1064) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 183) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                magnifying_glass_anim(child_item, 50, 1);
                game.add.tween(effects_group).to({ alpha: 1 }, 5000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1066 || day_tasks[n_i]['type'] == 1067) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 183) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1070) {
                animation = 1;
                blackf();
                var Tube_Lid = game.add.sprite(game.camera.width / 2 + 100, game.camera.height / 2 - 100, 'day17_atlas', 'Tube_Lid.png');
                Tube_Lid.scale.setTo(2);
                Tube_Lid.anchor.setTo(0.5);
                Tube_Lid.fixedToCamera = true;

                var Tube_No_Paper = game.add.sprite(game.camera.width / 2 - 50, game.camera.height / 2 + 50, 'day17_atlas', 'Tube_No_Paper.png');
                Tube_No_Paper.scale.setTo(2);
                Tube_No_Paper.anchor.setTo(0.5);
                Tube_No_Paper.fixedToCamera = true;

                game.add.tween(Tube_Lid.cameraOffset).to({ x: '+10', y: '-10' }, 300, Phaser.Easing.Exponential.In, true, 0, 2).yoyo(true, 200);
                game.add.tween(Tube_Lid.cameraOffset).to({ x: '+100', y: '-100' }, 1000, Phaser.Easing.Exponential.In, true, 2500).onComplete.add(function () {
                  game.add.tween(Tube_Lid).to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function (item) {
                    item.destroy();
                  });
                  game.add.tween(Tube_No_Paper).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                    item.destroy();
                  });
                  Tube_2_Papers = game.add.sprite(game.camera.width / 2 - 50, game.camera.height / 2 + 50, 'day17_atlas', 'Tube_2_Papers.png');
                  Tube_2_Papers.scale.setTo(2);
                  Tube_2_Papers.anchor.setTo(0.5);
                  Tube_2_Papers.alpha = 0;
                  Tube_2_Papers.fixedToCamera = true;
                  game.add.tween(Tube_2_Papers).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                    Tube_2_Papers.loadTexture('day17_atlas', 'Tube_1_Paper.png');
                    Testament = game.add.sprite(game.camera.width / 2, game.camera.height / 2, 'day17_atlas', 'Testament.png');
                    Testament.scale.setTo(0);
                    Testament.anchor.setTo(0.5);
                    Testament.fixedToCamera = true;
                    game.add.tween(Testament.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Linear.None, true);
                  });
                });

                game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 1);
                });
              } else if (day_tasks[n_i]['type'] == 1062) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 183) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                crowbar17_anim(child_item)
                game.add.tween(effects_group).to({ alpha: 1 }, 3000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  //child_item.destroy();
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 4000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1051) {
                emitter_smoke2 = 0;
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 160) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                if (emitter_smoke2 == 0) {
                  emitter_smoke2 = game.add.emitter(0, 0, 50);
                  emitter_smoke2.makeParticles('game_atlas', 'smoke.png');
                  emitter_smoke2.width = 150;
                  emitter_smoke2.height = 100;
                  emitter_smoke2.bringToTop = true;
                  emitter_smoke2.setRotation(0, 360, 500);
                  emitter_smoke2.setAlpha(1, 0, 4000);
                  emitter_smoke2.setScale(0.5, 3, 0.5, 3, 4000);
                  emitter_smoke2.gravity = 0;
                  emitter_smoke2.minParticleSpeed.set(-50, -50);
                  emitter_smoke2.maxParticleSpeed.set(50, 50);
                  emitter_smoke2.explode = true;
                  emitter_smoke2.blendMode = 3;
                  emitter_smoke2.x = child_item.x * worldScale;
                  emitter_smoke2.y = child_item.y * worldScale;
                  emitter_smoke2.start(false, 4000, 100);
                }
                hummer_anim2(child_item);
                game.add.tween(effects_group).to({ alpha: 1 }, 3000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  child_item.destroy();
                  emitter_smoke2.on = false;
                  emitter_smoke2 = 0;
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1050) {
                emitter_smoke2 = 0;
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 159) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                if (emitter_smoke2 == 0) {
                  emitter_smoke2 = game.add.emitter(0, 0, 50);
                  emitter_smoke2.makeParticles('game_atlas', 'smoke.png');
                  emitter_smoke2.width = 150;
                  emitter_smoke2.height = 100;
                  emitter_smoke2.bringToTop = true;
                  emitter_smoke2.setRotation(0, 360, 500);
                  emitter_smoke2.setAlpha(1, 0, 4000);
                  emitter_smoke2.setScale(0.5, 3, 0.5, 3, 4000);
                  emitter_smoke2.gravity = 0;
                  emitter_smoke2.minParticleSpeed.set(-50, -50);
                  emitter_smoke2.maxParticleSpeed.set(50, 50);
                  emitter_smoke2.explode = true;
                  emitter_smoke2.blendMode = 3;
                  emitter_smoke2.x = child_item.x * worldScale;
                  emitter_smoke2.y = child_item.y * worldScale;
                  emitter_smoke2.start(false, 4000, 100);
                }
                hummer_anim2(child_item);
                game.add.tween(effects_group).to({ alpha: 1 }, 3000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  child_item.loadTexture('farm_obj_atlas', 'Pagoda_state_3.png');
                  child_item.type = 160;
                  child_item.act = 0;
                  emitter_smoke2.on = false;
                  emitter_smoke2 = 0;
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1049) {
                emitter_smoke2 = 0;
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 158) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                if (emitter_smoke2 == 0) {
                  emitter_smoke2 = game.add.emitter(0, 0, 50);
                  emitter_smoke2.makeParticles('game_atlas', 'smoke.png');
                  emitter_smoke2.width = 150;
                  emitter_smoke2.height = 100;
                  emitter_smoke2.bringToTop = true;
                  emitter_smoke2.setRotation(0, 360, 500);
                  emitter_smoke2.setAlpha(1, 0, 4000);
                  emitter_smoke2.setScale(0.5, 3, 0.5, 3, 4000);
                  emitter_smoke2.gravity = 0;
                  emitter_smoke2.minParticleSpeed.set(-50, -50);
                  emitter_smoke2.maxParticleSpeed.set(50, 50);
                  emitter_smoke2.explode = true;
                  emitter_smoke2.blendMode = 3;
                  emitter_smoke2.x = child_item.x * worldScale;
                  emitter_smoke2.y = child_item.y * worldScale;
                  emitter_smoke2.start(false, 4000, 100);
                }
                hummer_anim2(child_item);
                game.add.tween(effects_group).to({ alpha: 1 }, 3000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  child_item.loadTexture('farm_obj_atlas', 'Pagoda_state_2.png');
                  child_item.type = 159;
                  child_item.act = 0;
                  emitter_smoke2.on = false;
                  emitter_smoke2 = 0;
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1048) {
                emitter_smoke2 = 0;
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 133) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                if (emitter_smoke2 == 0) {
                  emitter_smoke2 = game.add.emitter(0, 0, 50);
                  emitter_smoke2.makeParticles('game_atlas', 'smoke.png');
                  emitter_smoke2.width = 150;
                  emitter_smoke2.height = 100;
                  emitter_smoke2.bringToTop = true;
                  emitter_smoke2.setRotation(0, 360, 500);
                  emitter_smoke2.setAlpha(1, 0, 4000);
                  emitter_smoke2.setScale(0.5, 3, 0.5, 3, 4000);
                  emitter_smoke2.gravity = 0;
                  emitter_smoke2.minParticleSpeed.set(-50, -50);
                  emitter_smoke2.maxParticleSpeed.set(50, 50);
                  emitter_smoke2.explode = true;
                  emitter_smoke2.blendMode = 3;
                  emitter_smoke2.x = child_item.x * worldScale;
                  emitter_smoke2.y = child_item.y * worldScale;
                  emitter_smoke2.start(false, 4000, 100);
                }
                hummer_anim2(child_item);
                game.add.tween(effects_group).to({ alpha: 1 }, 3000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  child_item.loadTexture('farm_obj_c_atlas', 'whiteDoghouse.png');
                  child_item.type = 140;
                  child_item.act = 0;
                  emitter_smoke2.on = false;
                  emitter_smoke2 = 0;
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1047) {
                emitter_smoke2 = 0;
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 133) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                if (emitter_smoke2 == 0) {
                  emitter_smoke2 = game.add.emitter(0, 0, 50);
                  emitter_smoke2.makeParticles('game_atlas', 'smoke.png');
                  emitter_smoke2.width = 150;
                  emitter_smoke2.height = 100;
                  emitter_smoke2.bringToTop = true;
                  emitter_smoke2.setRotation(0, 360, 500);
                  emitter_smoke2.setAlpha(1, 0, 4000);
                  emitter_smoke2.setScale(0.5, 3, 0.5, 3, 4000);
                  emitter_smoke2.gravity = 0;
                  emitter_smoke2.minParticleSpeed.set(-50, -50);
                  emitter_smoke2.maxParticleSpeed.set(50, 50);
                  emitter_smoke2.explode = true;
                  emitter_smoke2.blendMode = 3;
                  emitter_smoke2.x = child_item.x * worldScale;
                  emitter_smoke2.y = child_item.y * worldScale;
                  emitter_smoke2.start(false, 4000, 100);
                }
                hummer_anim2(child_item);
                game.add.tween(effects_group).to({ alpha: 1 }, 3000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  child_item.loadTexture('farm_obj_c_atlas', 'DoghouseUncompleted.png');
                  emitter_smoke2.on = false;
                  emitter_smoke2 = 0;
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1046) {
                emitter_smoke2 = 0;
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 133) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                if (emitter_smoke2 == 0) {
                  emitter_smoke2 = game.add.emitter(0, 0, 50);
                  emitter_smoke2.makeParticles('game_atlas', 'smoke.png');
                  emitter_smoke2.width = 150;
                  emitter_smoke2.height = 100;
                  emitter_smoke2.bringToTop = true;
                  emitter_smoke2.setRotation(0, 360, 500);
                  emitter_smoke2.setAlpha(1, 0, 4000);
                  emitter_smoke2.setScale(0.5, 3, 0.5, 3, 4000);
                  emitter_smoke2.gravity = 0;
                  emitter_smoke2.minParticleSpeed.set(-50, -50);
                  emitter_smoke2.maxParticleSpeed.set(50, 50);
                  emitter_smoke2.explode = true;
                  emitter_smoke2.blendMode = 3;
                  emitter_smoke2.x = child_item.x * worldScale;
                  emitter_smoke2.y = child_item.y * worldScale;
                  emitter_smoke2.start(false, 4000, 100);
                }
                hummer_anim2(child_item);
                game.add.tween(effects_group).to({ alpha: 1 }, 3000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  child_item.loadTexture('farm_obj_c_atlas', 'wood5.png');
                  emitter_smoke2.on = false;
                  emitter_smoke2 = 0;
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1040) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  console.log(child_item2.type);
                  if (Math.abs(child_item2.type) == 133 || Math.abs(child_item2.type) == 132) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale - 200;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                Crowbar_anim(child_item);
                game.add.tween(effects_group).to({ alpha: 1 }, 13000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  child_item.loadTexture('farm_obj_c_atlas', 'OpenedBox.png');
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 14000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  taks_indicator();
                });
              } else if (day_tasks[n_i]['type'] == 1036) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type == 16) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale - 200;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                  //letter(game.cache.getJSON("dialog")["letter2"][0][window.lang],Number(game.cache.getJSON("dialog")["letter2"][0]["coins"]));
                });
              } else if (day_tasks[n_i]['type'] == 1060) {

                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 152) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });

                game.add.tween(child_item.scale).to({ x: '-0.1', y: '+0.1' }, 500, Phaser.Easing.Linear.None, true, 0, 6).yoyo(true, 0);

                game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  var child_item3 = 0;
                  objects_group.children.some(function (child_item2) {
                    if (Math.abs(child_item2.type) == 153) {
                      child_item3 = child_item2;
                      return true;
                    }
                  });

                  var shlang = game.add.sprite(child_item3.x, child_item3.y, 'day_16_atlas', 'Precomp 1_00000.png');
                  shlang.anchor.setTo(0.5);
                  shlang.scale.setTo(2.42);
                  objects_group.add(shlang);

                  var pump_mas = [];
                  for (var i = 0; i <= 35; i++) {
                    let n = 0;
                    if (i < 10) { n = '0' + i; } else { n = i; }
                    pump_mas.push('Precomp 1_000' + n + '.png');
                  }
                  var anim = shlang.animations.add('pump',
                    pump_mas,
                    10,
                    true,
                  );
                  shlang.animations.play('pump');

                  game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    var child_item4 = 0;
                    objects_group.children.some(function (child_item2) {
                      if (Math.abs(child_item2.type) == 163) {
                        child_item4 = child_item2;
                        return true;
                      }
                    });
                    game.add.tween(child_item4.scale).to({ x: '-0.4', y: '-0.4' }, 5000, Phaser.Easing.Linear.None, true);
                    game.add.tween(child_item4).to({ alpha: 0 }, 5000, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                      shlang.destroy();

                      game.add.tween(follow).to({ x: child_item5.x * worldScale, y: child_item5.y * worldScale }, 2000, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                        popup = 0;
                        missions_tab_open = 0;
                        animation = 0;
                        dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                        object_outline1 = game.add.sprite(hole_safe.x * worldScale, hole_safe.y * worldScale, hole_safe.key, hole_safe.frameName);
                        object_outline1.anchor.setTo(0.5);
                        object_outline1.scale.setTo(2.9 * worldScale + 0.2 * worldScale);
                        object_outline1.tint = 0xffff00;
                        object_outline2 = game.add.sprite(hole_safe.x * worldScale, hole_safe.y * worldScale, hole_safe.key, hole_safe.frameName);
                        object_outline2.anchor.setTo(0.5);
                        object_outline2.scale.setTo(2.9 * worldScale);
                      });
                    });
                    var child_item5 = 0;
                    objects_group.children.some(function (child_item2) {
                      if (Math.abs(child_item2.type) == 164) {
                        child_item5 = child_item2;
                        return true;
                      }
                    });

                    if (hole_safe == 0) {
                      hole_safe = game.add.sprite(7 * worldScale, 65 * worldScale, 'farm_obj_atlas', 'hole_safe.png');
                      hole_safe.anchor.setTo(0.5);
                      child_item5.addChild(hole_safe);
                    }

                    var child_item6 = 0;
                    objects_group.children.some(function (child_item2) {
                      if (Math.abs(child_item2.type) == 161) {
                        child_item6 = child_item2;
                        return true;
                      }
                    });
                    game.add.tween(child_item6).to({ alpha: 0 }, 5000, Phaser.Easing.Linear.None, true);
                  });

                });

              } else if (day_tasks[n_i]['type'] == 1059) {

                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 152) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });

                game.add.tween(child_item.scale).to({ x: '-0.1', y: '+0.1' }, 500, Phaser.Easing.Linear.None, true, 0, 1).yoyo(true, 0);

                game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  var child_item3 = 0;
                  objects_group.children.some(function (child_item2) {
                    if (Math.abs(child_item2.type) == 153) {
                      child_item3 = child_item2;
                      return true;
                    }
                  });

                  var shlang = game.add.sprite(child_item3.x, child_item3.y, 'day_16_atlas', 'Precomp 1_00000.png');
                  shlang.anchor.setTo(0.5);
                  shlang.scale.setTo(2.42);
                  objects_group.add(shlang);

                  var pump_mas = [];
                  for (var i = 0; i <= 11; i++) {
                    let n = 0;
                    if (i < 10) { n = '0' + i; } else { n = i; }
                    pump_mas.push('Precomp 1_000' + n + '.png');
                  }
                  var anim = shlang.animations.add('pump',
                    pump_mas,
                    10,
                    false,
                  );
                  anim.onComplete.add(function () {
                    shlang.destroy();
                    var chimney_smoke = game.add.sprite(child_item.x, child_item.y, 'farm_obj_c_atlas', 'Chimney_Smoke_1.png');
                    chimney_smoke.scale.setTo(-2.9, 2.9);
                    chimney_smoke.anchor.setTo(0.65);
                    chimney_smoke.depth = 100;
                    chimney_smoke.tint = 0x000000;
                    objects_group.add(chimney_smoke);
                    var anim = chimney_smoke.animations.add(
                      'chimney_smoke',
                      [
                        'Chimney_Smoke_1.png',
                        'Chimney_Smoke_2.png',
                        'Chimney_Smoke_3.png',
                        'Chimney_Smoke_4.png',
                        'Chimney_Smoke_5.png',
                        'Chimney_Smoke_1.png',
                        'Chimney_Smoke_2.png',
                        'Chimney_Smoke_3.png',
                        'Chimney_Smoke_4.png',
                        'Chimney_Smoke_5.png',
                        'Chimney_Smoke_1.png',
                        'Chimney_Smoke_2.png',
                        'Chimney_Smoke_3.png',
                        'Chimney_Smoke_4.png',
                        'Chimney_Smoke_5.png',
                        'Chimney_Smoke_1.png',
                        'Chimney_Smoke_2.png',
                        'Chimney_Smoke_3.png',
                        'Chimney_Smoke_4.png',
                        'Chimney_Smoke_5.png',
                        'Chimney_Smoke_1.png',
                        'Chimney_Smoke_2.png',
                        'Chimney_Smoke_3.png',
                        'Chimney_Smoke_4.png',
                        'Chimney_Smoke_5.png',
                        'Chimney_Smoke_1.png',
                        'Chimney_Smoke_2.png',
                        'Chimney_Smoke_3.png',
                        'Chimney_Smoke_4.png',
                        'Chimney_Smoke_5.png',
                      ],
                      8,
                      false,
                    );
                    chimney_smoke.animations.play('chimney_smoke');
                    anim.onComplete.add(function () {
                      chimney_smoke.destroy();
                      popup = 0;
                      missions_tab_open = 0;
                      animation = 0;
                      dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                    });
                  });
                  shlang.animations.play('pump');
                });

              } else if (day_tasks[n_i]['type'] == 1058) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 161) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });

                var lasso_mas = [];
                for (var i = 100; i <= 115; i++) {
                  let n = 0;
                  if (i < 10) { n = '0' + i; } else { n = i; }
                  lasso_mas.push('Pre-comp 3_00' + n + '.png');
                }
                var anim = lasso.animations.add('lasso',
                  lasso_mas,
                  20,
                  true,
                );
                lasso.animations.play('lasso');
                lasso.x += 4;
                lasso.y += 8;

                game.add.tween(lasso).to({ x: '-10', y: '-20' }, 3000, Phaser.Easing.Cubic.Out, true, 0);
                game.add.tween(child_item).to({ x: '-10', y: '-20' }, 3000, Phaser.Easing.Cubic.Out, true, 0).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });

              } else if (day_tasks[n_i]['type'] == 1056) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 161) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });

                game.add.tween(lasso).to({ x: '-2', y: '-5' }, 500, Phaser.Easing.Bounce.Out, true, 0, 3).yoyo(true, 0);
                game.add.tween(lasso).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 4000).onComplete.add(function (item) {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });

              } else if (day_tasks[n_i]['type'] == 1055) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 161) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                lasso = game.add.sprite(child_item.x - 26, child_item.y - 214, 'day_16_atlas', 'Pre-comp 3_00000.png');
                lasso.anchor.setTo(0.5);
                lasso.scale.setTo(2);
                objects_group.add(lasso);
                var lasso_mas = [];
                for (var i = 0; i <= 72; i++) {
                  let n = 0;
                  if (i < 10) { n = '0' + i; } else { n = i; }
                  lasso_mas.push('Pre-comp 3_000' + n + '.png');
                }
                var anim = lasso.animations.add('lasso',
                  lasso_mas,
                  20,
                  false,
                );
                anim.onComplete.add(function () {
                  game.add.tween(lasso).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                    popup = 0;
                    missions_tab_open = 0;
                    animation = 0;
                    dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                  });
                }, this);
                lasso.animations.play('lasso');

              } else if (day_tasks[n_i]['type'] == 1054) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 161) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                lasso = game.add.sprite(child_item.x - 26, child_item.y - 214, 'day_16_atlas', 'Pre-comp 1_00000.png');
                lasso.anchor.setTo(0.5);
                lasso.scale.setTo(2);
                objects_group.add(lasso);
                var lasso_mas = [];
                for (var i = 0; i <= 65; i++) {
                  let n = 0;
                  if (i < 10) { n = '0' + i; } else { n = i; }
                  lasso_mas.push('Pre-comp 1_000' + n + '.png');
                }
                var anim = lasso.animations.add('lasso',
                  lasso_mas,
                  20,
                  false,
                );
                anim.onComplete.add(function () {
                  game.add.tween(lasso).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                    item.destroy();
                    popup = 0;
                    missions_tab_open = 0;
                    animation = 0;
                    dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                  });
                }, this);
                lasso.animations.play('lasso');

              } else if (day_tasks[n_i]['type'] == 1053) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 161) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                magnifying_glass_anim(child_item, 100);
                game.add.tween(effects_group).to({ alpha: 1 }, 5000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                    let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                    letter(
                      game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                      Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                    );
                  } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1034) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (Math.abs(child_item2.type) == 132 || Math.abs(child_item2.type) == 133) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                magnifying_glass_anim(child_item, 100);
                game.add.tween(effects_group).to({ alpha: 1 }, 5000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                    let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                    letter(
                      game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                      Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                    );
                  } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1026) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type == 31) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale - 200;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                magnifying_glass_anim(child_item, 100);
                game.add.tween(effects_group).to({ alpha: 1 }, 5000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  blackf();
                  var shine = game.add.sprite(
                    game.camera.width / 2,
                    game.camera.height / 2 - 10,
                    'game_ui_atlas',
                    'Shine.png',
                  );
                  shine.anchor.setTo(0.5, 0.52);
                  shine.scale.setTo(0);
                  shine.alpha = 0.3;
                  shine.fixedToCamera = true;
                  game.add.tween(shine.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Exponential.In, true);
                  rotate_tween(shine);
                  var cloves_sprite = game.add.sprite(
                    game.camera.width / 2,
                    game.camera.height / 2 - 10,
                    'farm_obj_atlas',
                    'Bandage_Icon.png',
                  );
                  cloves_sprite.scale.setTo(0);
                  cloves_sprite.alpha = 0;
                  cloves_sprite.anchor.setTo(0.5);
                  cloves_sprite.fixedToCamera = true;
                  game.add.tween(cloves_sprite.scale).to({ x: 2.9, y: 2.9 }, 1000, Phaser.Easing.Bounce.Out, true);
                  game.add.tween(cloves_sprite).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                  var cloves_sprite_text = game.add.text(
                    game.camera.width / 2,
                    game.camera.height / 2 + 150,
                    'Bandage',
                    { font: '62px RussoOne', fill: '#fff', align: 'center' },
                  );
                  cloves_sprite_text.anchor.setTo(0.5);
                  cloves_sprite_text.alpha = 0;
                  cloves_sprite_text.stroke = '#000';
                  cloves_sprite_text.strokeThickness = 2;
                  cloves_sprite_text.setShadow(0, 3, 'rgba(0,0,0,0.7)', 1);
                  cloves_sprite_text.fixedToCamera = true;
                  game.add.tween(cloves_sprite_text).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000);
                  game.add
                    .tween(cloves_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 2500)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(shine)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 2500)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(cloves_sprite_text)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 2500)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 8000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                    let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                    letter(
                      game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                      Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                    );
                  } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 1);
                });
              } else if (day_tasks[n_i]['type'] == 1033) {
                animation = 1;
                game.add
                  .tween(follow)
                  .to({ x: 1000 * worldScale, y: 800 * worldScale }, 2000, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function () {
                    popup = 0;
                    missions_tab_open = 0;
                    animation = 0;
                    dialog_window(164, 0);
                  });
              } else if (day_tasks[n_i]['type'] == 1032) {
                animation = 1;
                blackf();
                var envelopBodyB = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 + 100,
                  'day14_pic_atlas',
                  'envelopBodyB.png',
                );
                envelopBodyB.scale.setTo(2);
                envelopBodyB.anchor.setTo(0.5);
                envelopBodyB.fixedToCamera = true;
                var envelopeBodyF = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 + 100,
                  'day14_pic_atlas',
                  'envelopeBodyF.png',
                );
                envelopeBodyF.scale.setTo(2);
                envelopeBodyF.anchor.setTo(0.5);
                envelopeBodyF.fixedToCamera = true;
                var envelopeOpened = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 - 330,
                  'day14_pic_atlas',
                  'envelopeOpened.png',
                );
                envelopeOpened.scale.setTo(2);
                envelopeOpened.anchor.setTo(0.5);
                envelopeOpened.fixedToCamera = true;
                var rose_wall_photo = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 + 1000,
                  'day14_pic_atlas',
                  'rose wall photo.png',
                );
                rose_wall_photo.scale.setTo(2);
                rose_wall_photo.anchor.setTo(0.5);
                rose_wall_photo.fixedToCamera = true;
                game.add
                  .tween(rose_wall_photo.cameraOffset)
                  .to({ y: '-1400' }, 1500, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function () {
                    game.world.bringToTop(envelopeBodyF);
                    game.add
                      .tween(rose_wall_photo.cameraOffset)
                      .to({ y: '+500' }, 1000, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function () {
                        envelopeOpened.destroy();
                        var envelopeClosed = game.add.sprite(
                          game.camera.width / 2,
                          game.camera.height / 2,
                          'day14_pic_atlas',
                          'envelopeClosed.png',
                        );
                        envelopeClosed.scale.setTo(2);
                        envelopeClosed.anchor.setTo(0.5);
                        envelopeClosed.fixedToCamera = true;
                        game.add
                          .tween(envelopBodyB.cameraOffset)
                          .to({ x: '+1500' }, 1000, Phaser.Easing.Linear.None, true, 500);
                        game.add
                          .tween(envelopeBodyF.cameraOffset)
                          .to({ x: '+1500' }, 1000, Phaser.Easing.Linear.None, true, 500);
                        game.add
                          .tween(envelopeOpened.cameraOffset)
                          .to({ x: '+1500' }, 1000, Phaser.Easing.Linear.None, true, 500);
                        game.add
                          .tween(rose_wall_photo.cameraOffset)
                          .to({ x: '+1500' }, 1000, Phaser.Easing.Linear.None, true, 500);
                        game.add
                          .tween(envelopeClosed.cameraOffset)
                          .to({ x: '+1500' }, 1000, Phaser.Easing.Linear.None, true, 500)
                          .onComplete.add(function () {
                            envelopBodyB.destroy(true);
                            envelopeBodyF.destroy(true);
                            envelopeOpened.destroy(true);
                            rose_wall_photo.destroy(true);
                            envelopeClosed.destroy(true);
                            popup = 0;
                            missions_tab_open = 0;
                            animation = 0;
                            objects_group.children.some(function (child_item2) {
                              if (child_item2.type == 51 && child_item2.y > 800 && child_item2.y < 900) {
                                child_item2.loadTexture('farm_obj_atlas', 'tree2_broken.png');
                                child_item2.type = 115;
                                child_item2.act = 0;
                                for (var n = 0; n < 10; n++) {
                                  var bug = game.add.sprite(
                                    game.rnd.integerInRange(-20, 20),
                                    game.rnd.integerInRange(-20, 20),
                                    'message_invite_mask',
                                  );
                                  bug.anchor.setTo(0.5);
                                  bug.scale.setTo(0.03);
                                  child_item2.addChild(bug);
                                  bug_anim(bug);
                                }
                                function bug_anim(obj) {
                                  var sx = game.rnd.integerInRange(10, 30);
                                  var spmx = game.rnd.integerInRange(0, 1);
                                  if (spmx == 0) {
                                    spmx = '-';
                                  } else {
                                    spmx = '+';
                                  }
                                  var sy = game.rnd.integerInRange(10, 30);
                                  var spmy = game.rnd.integerInRange(0, 1);
                                  if (spmy == 0) {
                                    spmy = '-';
                                  } else {
                                    spmy = '+';
                                  }
                                  let tween = game.add
                                    .tween(obj)
                                    .to(
                                      { x: spmx + sx, y: spmy + sy },
                                      game.rnd.integerInRange(400, 700),
                                      Phaser.Easing.Linear.None,
                                      true,
                                    )
                                    .yoyo(true, 100);
                                  tween.onComplete.add(function () {
                                    bug_anim(obj);
                                  });
                                }
                                return true;
                              }
                            });
                            dialog_window(161, 1);
                          });
                      });
                  });
              } else if (day_tasks[n_i]['type'] == 1017) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type == 102) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale - 200;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                var Fertilizer_Bag = game.add.sprite(
                  child_item.x - 150,
                  child_item.y - 400,
                  'farm_obj_atlas',
                  'Fertilizer_Bag.png',
                );
                Fertilizer_Bag.scale.setTo(5);
                Fertilizer_Bag.alpha = 0;
                Fertilizer_Bag.anchor.setTo(0.5);
                objects_group.add(Fertilizer_Bag);
                game.add.tween(Fertilizer_Bag).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 1000);
                game.add.tween(Fertilizer_Bag.scale).to({ x: 3, y: 3 }, 1000, Phaser.Easing.Linear.None, true, 1000);
                game.add
                  .tween(Fertilizer_Bag)
                  .to({ y: '+300' }, 1000, Phaser.Easing.Linear.None, true, 1000)
                  .onComplete.add(function () {
                    game.add
                      .tween(Fertilizer_Bag)
                      .to({ x: '-60', y: '-60' }, 500, Phaser.Easing.Cubic.Out, true, 500)
                      .onComplete.add(function () {
                        game.add
                          .tween(Fertilizer_Bag)
                          .to({ x: '+60', y: '+60' }, 500, Phaser.Easing.Cubic.In, true)
                          .onComplete.add(function () {
                            Fertilizer_Bag_anim.alpha = 1;
                            Fertilizer_Bag_anim.animations.play('Comp');
                            game.add
                              .tween(Fertilizer_Bag)
                              .to({ x: '-60', y: '-60' }, 500, Phaser.Easing.Cubic.Out, true, 500)
                              .onComplete.add(function () {
                                game.add
                                  .tween(Fertilizer_Bag)
                                  .to({ x: '+60', y: '+60' }, 500, Phaser.Easing.Cubic.In, true)
                                  .onComplete.add(function () {
                                    Fertilizer_Bag_anim.animations.play('Comp');
                                    game.add
                                      .tween(Fertilizer_Bag)
                                      .to({ x: '-60', y: '-60' }, 500, Phaser.Easing.Cubic.Out, true, 500)
                                      .onComplete.add(function () {
                                        Fertilizer_Bag_anim.alpha = 1;
                                        game.add
                                          .tween(Fertilizer_Bag)
                                          .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                                          .onComplete.add(function () {
                                            Fertilizer_Bag.destroy();
                                          });
                                      });
                                  });
                              });
                          });
                      });
                  });
                var Fertilizer_Bag_anim = game.add.sprite(65, 20, 'farm_obj_atlas', 'Pre-comp 1_00001.png');
                Fertilizer_Bag_anim.scale.setTo(1);
                Fertilizer_Bag_anim.anchor.setTo(0.5);
                Fertilizer_Bag_anim.alpha = 0;
                var anim = Fertilizer_Bag_anim.animations.add(
                  'Comp',
                  [
                    'Pre-comp 1_00001.png',
                    'Pre-comp 1_00002.png',
                    'Pre-comp 1_00003.png',
                    'Pre-comp 1_00004.png',
                    'Pre-comp 1_00005.png',
                    'Pre-comp 1_00006.png',
                    'Pre-comp 1_00007.png',
                    'Pre-comp 1_00008.png',
                    'Pre-comp 1_00010.png',
                  ],
                  10,
                  false,
                );
                Fertilizer_Bag.addChild(Fertilizer_Bag_anim);
                game.add.tween(effects_group).to({ alpha: 1 }, 7000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                    let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                    letter(
                      game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                      Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                    );
                  } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1028) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type == 102) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale - 200;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                var Gramophone = game.add.sprite(
                  child_item.x + 200,
                  child_item.y - 100,
                  'farm_obj_atlas',
                  'Gramophone.png',
                );
                Gramophone.scale.setTo(5);
                Gramophone.alpha = 0;
                Gramophone.anchor.setTo(0.5);
                objects_group.add(Gramophone);
                game.add.tween(Gramophone).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 1000);
                game.add
                  .tween(Gramophone.scale)
                  .to({ x: 3, y: 3 }, 1000, Phaser.Easing.Linear.None, true, 1000)
                  .onComplete.add(function (item) {
                    Gramophone_anim.animations.play('Gramophone_a');
                    Gramophone_anim.alpha = 1;
                    game.add
                      .tween(Gramophone.scale)
                      .to({ x: '+0.1', y: '+0.2' }, 200, Phaser.Easing.Cubic.In, true, 0, -1)
                      .yoyo(true, 100);
                  });
                game.add
                  .tween(Gramophone)
                  .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 6000)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(child_item)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 500)
                      .onComplete.add(function (item) {
                        item.loadTexture('farm_obj_c_atlas', 'RoseMedium.png');
                        item.y -= 90;
                        game.add.tween(item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                      });
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    item.destroy();
                  });
                var Gramophone_anim = game.add.sprite(-65, -55, 'farm_obj_atlas', 'Gramophone_a1.png');
                Gramophone_anim.scale.setTo(1);
                Gramophone_anim.anchor.setTo(0.5);
                Gramophone_anim.alpha = 0;
                var anim = Gramophone_anim.animations.add(
                  'Gramophone_a',
                  [
                    'Gramophone_a1.png',
                    'Gramophone_a2.png',
                    'Gramophone_a3.png',
                    'Gramophone_a4.png',
                    'Gramophone_a5.png',
                    'Gramophone_a6.png',
                    'Gramophone_a7.png',
                    'Gramophone_a8.png',
                    'Gramophone_a9.png',
                    'Gramophone_a10.png',
                    'Gramophone_a11.png',
                    'Gramophone_a12.png',
                    'Gramophone_a13.png',
                    'Gramophone_a14.png',
                    'Gramophone_a15.png',
                  ],
                  10,
                  true,
                );
                Gramophone.addChild(Gramophone_anim);
                game.add.tween(effects_group).to({ alpha: 1 }, 9000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                    let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                    letter(
                      game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                      Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                    );
                  } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1030) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type == 102) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale - 200;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                var trim_1 = game.add.sprite(child_item.x, child_item.y - 30, 'farm_obj_atlas', 'trim_1.png');
                trim_1.scale.setTo(5);
                trim_1.alpha = 0;
                trim_1.anchor.setTo(0.5);
                objects_group.add(trim_1);
                game.add.tween(trim_1).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 500);
                game.add
                  .tween(trim_1.scale)
                  .to({ x: 3, y: 3 }, 1000, Phaser.Easing.Linear.None, true, 500)
                  .onComplete.add(function (item) {
                    trim_1.animations.play('trim');
                  });
                game.add
                  .tween(trim_1)
                  .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 6000)
                  .onComplete.add(function (item) {
                    item.destroy();
                    game.add
                      .tween(child_item)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        item.loadTexture('farm_obj_c_atlas', 'RoseFully.png');
                        item.y -= 90;
                        game.add.tween(item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                      });
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                    add_shines(child_item, 3, 1);
                  });
                trim_1.animations.add(
                  'trim',
                  [
                    'trim_1.png',
                    'trim_2.png',
                    'trim_3.png',
                    'trim_4.png',
                    'trim_5.png',
                    'trim_6.png',
                    'trim_7.png',
                    'trim_8.png',
                  ],
                  10,
                  true,
                );
                game.add.tween(effects_group).to({ alpha: 1 }, 9000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                    let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                    letter(
                      game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                      Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                    );
                  } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 1031) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type == 102) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale - 200;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                game.add
                  .tween(child_item)
                  .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 500)
                  .onComplete.add(function (item) {
                    popup = 111;
                    game.camera.flash(0xffffff, 300);
                  });
                game.add.tween(effects_group).to({ alpha: 1 }, 1400, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  blackf();
                  brochure_hand = game.add.sprite(
                    game.camera.width / 2,
                    game.camera.height / 2 - 50,
                    'day14_pic_atlas',
                    'rose wall photo.png',
                  );
                  brochure_hand.scale.setTo(0);
                  brochure_hand.alpha = 0;
                  brochure_hand.anchor.setTo(0.5);
                  brochure_hand.fixedToCamera = true;
                  game.add.tween(brochure_hand).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true);
                  game.add.tween(brochure_hand.scale).to({ x: 2, y: 2 }, 1000, Phaser.Easing.Elastic.Out, true);
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 4000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                    let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                    letter(
                      game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                      Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                    );
                  } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 1);
                });
              } else if (day_tasks[n_i]['type'] == 1016) {
                animation = 1;
                var child_item = 0;
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type == 102) {
                    child_item = child_item2;
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale - 200;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                var Water_Can = game.add.sprite(
                  child_item.x + 270 * worldScale,
                  child_item.y - 400 * worldScale,
                  'farm_obj_atlas',
                  'Water_Can.png',
                );
                Water_Can.scale.setTo(5);
                Water_Can.alpha = 0;
                Water_Can.anchor.setTo(0.5);
                objects_group.add(Water_Can);
                Water_Can.angle += 30;
                game.add.tween(Water_Can).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000);
                game.add.tween(Water_Can.scale).to({ x: 2.4, y: 2.4 }, 500, Phaser.Easing.Linear.None, true, 1000);
                game.add
                  .tween(Water_Can)
                  .to({ y: '+300' }, 500, Phaser.Easing.Linear.None, true, 1000)
                  .onComplete.add(function () {
                    game.add
                      .tween(Water_Can)
                      .to({ angle: '-30' }, 400, Phaser.Easing.Cubic.Out, true, 500)
                      .onComplete.add(function () {
                        Water_Can_anim.alpha = 1;
                        Water_Can_anim.animations.play('Comp');
                        game.add
                          .tween(Water_Can)
                          .to({ angle: '+30' }, 400, Phaser.Easing.Cubic.Out, true, 500)
                          .onComplete.add(function () {
                            game.add
                              .tween(Water_Can)
                              .to({ angle: '-30' }, 400, Phaser.Easing.Cubic.Out, true, 500)
                              .onComplete.add(function () {
                                Water_Can_anim.animations.play('Comp');
                                game.add
                                  .tween(Water_Can)
                                  .to({ angle: '+30' }, 400, Phaser.Easing.Cubic.Out, true, 500)
                                  .onComplete.add(function () {
                                    game.add
                                      .tween(Water_Can)
                                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                      .onComplete.add(function () {
                                        Water_Can.destroy();
                                      });
                                  });
                              });
                          });
                      });
                  });
                var Water_Can_anim = game.add.sprite(-85, 35, 'farm_obj_atlas', 'Comp 1_00000.png');
                Water_Can_anim.scale.setTo(1);
                Water_Can_anim.anchor.setTo(0.5);
                Water_Can_anim.alpha = 0;
                var anim = Water_Can_anim.animations.add(
                  'Comp',
                  [
                    'Comp 1_00000.png',
                    'Comp 1_00001.png',
                    'Comp 1_00002.png',
                    'Comp 1_00003.png',
                    'Comp 1_00004.png',
                    'Comp 1_00005.png',
                    'Comp 1_00006.png',
                    'Comp 1_00007.png',
                  ],
                  12,
                  false,
                );
                Water_Can.addChild(Water_Can_anim);
                game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                    let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                    letter(
                      game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                      Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                    );
                  } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else if (day_tasks[n_i]['type'] == 79) {
                animation = 1;
                var child_item = 0;
                var child_item_mas = [];
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type == 57) {
                    child_item = child_item2;
                    child_item_mas.push(child_item);
                  }
                  if (child_item_mas.length == 4) {
                    return true;
                  }
                });
                follow.x = child_item.x * worldScale;
                follow.y = child_item.y * worldScale - 200;
                last_position = [child_item.x * worldScale, child_item.y * worldScale];
                game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                var nnn_cloves = 0;
                game.time.events.repeat(100, 30, function () {
                  for (var i = 0; i < child_item_mas.length; i++) {
                    var sdv_x = 0;
                    var sdv_y = 0;
                    sdv_x = get_random_change(['-2', '+2', '0']);
                    sdv_y = get_random_change(['-2', '+2', '0']);
                    game.add
                      .tween(child_item_mas[i])
                      .to({ x: sdv_x, y: sdv_y }, 50, Phaser.Easing.Linear.None, true)
                      .yoyo(true, 50);
                    if (sdv_x == '+2' && nnn_cloves % 2 == 0) {
                      var cloves_sprite = game.add.sprite(
                        game.rnd.integerInRange(-5, 5),
                        0,
                        'farm_obj_atlas',
                        'Cloves.png',
                      );
                      cloves_sprite.anchor.setTo(0.5);
                      cloves_sprite.scale.setTo(0);
                      child_item_mas[i].addChild(cloves_sprite);
                      game.add.tween(cloves_sprite.scale).to({ x: 1.2, y: 1.2 }, 500, Phaser.Easing.Linear.None, true);
                      game.add.tween(cloves_sprite).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(cloves_sprite)
                        .to({ y: '-200' }, 1000, Phaser.Easing.Cubic.Out, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                    }
                  }
                  nnn_cloves++;
                });
                game.add.tween(effects_group).to({ alpha: 1 }, 3100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                    let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                    letter(
                      game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                      Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                    );
                  } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                });
              } else {
                animation = 1;
                blackf();
                var shine = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2,
                  'game_ui_atlas',
                  'Shine.png',
                );
                shine.anchor.setTo(0.5, 0.52);
                shine.scale.setTo(0);
                shine.alpha = 0.3;
                shine.fixedToCamera = true;
                game.add.tween(shine.scale).to({ x: 2, y: 2 }, 1500, Phaser.Easing.Exponential.In, true, 1300);
                rotate_tween(shine);
                var cloves_sprite = game.add.sprite(
                  game.camera.width / 2 - 500,
                  game.camera.height / 2,
                  'farm_obj_atlas',
                  'Cloth.png',
                );
                cloves_sprite.scale.setTo(0);
                cloves_sprite.alpha = 0;
                cloves_sprite.anchor.setTo(0.5);
                cloves_sprite.fixedToCamera = true;
                game.add.tween(cloves_sprite.scale).to({ x: 5.8, y: 5.8 }, 1000, Phaser.Easing.Bounce.Out, true);
                game.add.tween(cloves_sprite).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(cloves_sprite.cameraOffset).to({ x: '+500' }, 1000, Phaser.Easing.Cubic.In, true, 1300);
                game.add
                  .tween(cloves_sprite)
                  .to({ x: 0 }, 1000, Phaser.Easing.Linear.None, true, 1300)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                cloves_sprite = game.add.sprite(
                  game.camera.width / 2 + 500,
                  game.camera.height / 2,
                  'farm_obj_atlas',
                  'Cloves_Oil.png',
                );
                cloves_sprite.scale.setTo(0);
                cloves_sprite.alpha = 0;
                cloves_sprite.anchor.setTo(0.5);
                cloves_sprite.fixedToCamera = true;
                game.add.tween(cloves_sprite.scale).to({ x: 2.9, y: 2.9 }, 1000, Phaser.Easing.Bounce.Out, true);
                game.add.tween(cloves_sprite).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(cloves_sprite.cameraOffset).to({ x: '-500' }, 1000, Phaser.Easing.Cubic.In, true, 1300);
                game.add
                  .tween(cloves_sprite)
                  .to({ x: 0 }, 1000, Phaser.Easing.Linear.None, true, 1300)
                  .onComplete.add(function (item) {
                    item.destroy();
                    cloves_sprite = game.add.sprite(
                      game.camera.width / 2,
                      game.camera.height / 2,
                      'farm_obj_atlas',
                      'Cloth_With_Oil.png',
                    );
                    cloves_sprite.scale.setTo(0);
                    cloves_sprite.alpha = 0;
                    cloves_sprite.anchor.setTo(0.5);
                    cloves_sprite.fixedToCamera = true;
                    game.add.tween(cloves_sprite.scale).to({ x: 2.9, y: 2.9 }, 1000, Phaser.Easing.Bounce.Out, true);
                    game.add.tween(cloves_sprite).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                    game.add
                      .tween(shine)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 1500)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(cloves_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 1500)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(black_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true, 1500)
                      .onComplete.add(function (item) {
                        item.destroy();
                        popup = 0;
                        missions_tab_open = 0;
                        animation = 0;
                        if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                          let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                          letter(
                            game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                            Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                          );
                        } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                      });
                  });
              }
            });
        } else if (day_tasks[n_i]['type'] >= 2000 || day_tasks[n_i]['type'] == 88 || day_tasks[n_i]['type'] == 1020) {
          if (day_tasks[n_i]['sprite'] == 'mail_box_1') {
            /*objects_group.children.forEach(function (child_item) {
              if (child_item.type == 16 || child_item.type == -16) {
                child_item.children[0].angle += 80;
                return true;
              }
            });*/
          }
          complete_task_i = n_i;
          mission_task[n_i] = 1;
          mission_number.push(day_tasks[n_i]['type']);
          game.setUserDataAndLog({
            complete_task_i: complete_task_i,
            mission_stars_end: mission_stars_end,
            mission_task: JSON.stringify(mission_task),
            mission_number: JSON.stringify(mission_number),
            mission_day_end: mission_day_end,
            all_stars: all_stars,
          });
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item2) {
              item2.destroy();
            });
          game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
          game.add
            .tween(UI_bottom_group)
            .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item2) {
              friends_group.removeAll(true);
              backcard_group.removeAll(true); mission_group.removeAll(true);
              backcard_group.alpha = 1;
              item2.removeAll(true);
              UI_bottom_group_create(1, 1, 1, 1);
              item2.y = 400;
              game.add
                .tween(item2)
                .to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  if (
                    day_tasks[n_i]['type'] >= 2000 ||
                    day_tasks[n_i]['type'] == 88 ||
                    day_tasks[n_i]['type'] == 1020
                  ) {
                    var child_item = 0;
                    objects_group.children.some(function (child_item2) {
                      if (
                        (child_item2.type == 16 &&
                          (day_tasks[n_i]['type'] == 2003 || day_tasks[n_i]['type'] == 1020)) ||
                        (child_item2.type == 102 && day_tasks[n_i]['type'] == 2006) ||
                        (child_item2.type == 47 && day_tasks[n_i]['type'] == 2004) ||
                        (child_item2.type == 141 && day_tasks[n_i]['type'] == 2007) ||
                        (child_item2.type == 75 && (day_tasks[n_i]['type'] == 2005 || day_tasks[n_i]['type'] == 88))
                      ) {
                        child_item = child_item2;
                        return true;
                      }
                    });
                    follow.x = child_item.x * worldScale;
                    follow.y = child_item.y * worldScale - 200;
                    last_position = [child_item.x * worldScale, child_item.y * worldScale];
                    game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                    game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      var col = 100;
                      if (day_tasks[n_i]['type'] == 2003 || day_tasks[n_i]['type'] == 1020) {
                        col = 100;
                      } else if (day_tasks[n_i]['type'] == 2004) {
                        col = 200;
                      } else if (day_tasks[n_i]['type'] == 2005 || day_tasks[n_i]['type'] == 88) {
                        col = 350;
                      } else if (day_tasks[n_i]['type'] == 2006) {
                        col = 400;
                      } else if (day_tasks[n_i]['type'] == 2007) {
                        col = 300;
                      }
                      animation = 1;
                      coins += col;
                      game.setCurrentEvent();
                      if (col == 100) {
                        window.eventTrack('coins_in', col, {
                          user_type: bought,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          amount: col,
                          source: 'Check mailbox',
                          package_id: 0,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });

                        // save collected coins
                        game.setUserDataAndLog({ currencies: coins });
                      }
                      else if (col == 200) {
                        window.eventTrack('coins_in', col, {
                          user_type: bought,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          amount: col,
                          source: 'Sell honey',
                          package_id: 0,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });

                        // save collected coins
                        game.setUserDataAndLog({ currencies: coins });
                      }
                      else if (col == 350) {
                        window.eventTrack('coins_in', col, {
                          user_type: bought,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          amount: col,
                          source: 'Sell plums',
                          package_id: 0,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });

                        // save collected coins
                        game.setUserDataAndLog({ currencies: coins });
                      }
                      else if (col == 300) {
                        window.eventTrack('coins_in', col, {
                          user_type: bought,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          amount: col,
                          source: 'Feed Snow',
                          package_id: 0,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });

                        // save collected coins
                        game.setUserDataAndLog({ currencies: coins });
                      }
                      else {
                        window.eventTrack('coins_in', col, {
                          user_type: bought,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          amount: col,
                          source: 'Water Flowers',
                          package_id: 0,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });

                        // save collected coins
                        game.setUserDataAndLog({ currencies: coins });

                      }
                      if (day_tasks[n_i]['type'] == 2007) {

                        dog_eat_anim(child_item);
                        game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                          popup = 0;
                          missions_tab_open = 0;
                          animation = 0;
                          var p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                          p_text = p_text.replace('[x]', col);
                          message(
                            p_text,
                            game.camera.x + game.camera.width / 2,
                            game.camera.y + game.camera.height / 2,
                          );
                          var coins_text = coins - col;
                          text_coins_panel.setText(coins_text);
                          var var_coins = 0;
                          if (sound_on == 1) {
                            play_sound('coins_add');
                          }
                          game.time.events.repeat(
                            100,
                            10,
                            function () {
                              var get_coin = game.add.sprite(
                                child_item.x * worldScale + game.rnd.integerInRange(-50, 50),
                                child_item.y * worldScale + game.rnd.integerInRange(-50, 50),
                                'game_ui_atlas',
                                'Coin_Icon.png',
                              );
                              get_coin.anchor.setTo(0.5);
                              get_coin.scale.setTo(0);
                              get_coin.alpha = 0;
                              effects_group.add(get_coin);
                              game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(get_coin.scale)
                                .to({ x: 0.5, y: 0.5 }, 400, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(get_coin)
                                .to(
                                  { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                                  600,
                                  Phaser.Easing.Linear.None,
                                  true,
                                )
                                .onComplete.add(function (item) {
                                  item.destroy();
                                  var_coins += col / 10;
                                  text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                                });
                            },
                            this,
                          );
                        });

                      } else
                        if (day_tasks[n_i]['type'] == 2006) {
                          var Water_Can = game.add.sprite(
                            child_item.x + 270 * worldScale,
                            child_item.y - 400 * worldScale,
                            'farm_obj_atlas',
                            'Water_Can.png',
                          );
                          Water_Can.scale.setTo(5);
                          Water_Can.alpha = 0;
                          Water_Can.anchor.setTo(0.5);
                          objects_group.add(Water_Can);
                          Water_Can.angle += 30;
                          game.add.tween(Water_Can).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000);
                          game.add
                            .tween(Water_Can.scale)
                            .to({ x: 2.4, y: 2.4 }, 500, Phaser.Easing.Linear.None, true, 1000);
                          game.add
                            .tween(Water_Can)
                            .to({ y: '+300' }, 500, Phaser.Easing.Linear.None, true, 1000)
                            .onComplete.add(function () {
                              game.add
                                .tween(Water_Can)
                                .to({ angle: '-30' }, 400, Phaser.Easing.Cubic.Out, true, 500)
                                .onComplete.add(function () {
                                  Water_Can_anim.alpha = 1;
                                  Water_Can_anim.animations.play('Comp');
                                  game.add
                                    .tween(Water_Can)
                                    .to({ angle: '+30' }, 400, Phaser.Easing.Cubic.Out, true, 500)
                                    .onComplete.add(function () {
                                      game.add
                                        .tween(Water_Can)
                                        .to({ angle: '-30' }, 400, Phaser.Easing.Cubic.Out, true, 500)
                                        .onComplete.add(function () {
                                          Water_Can_anim.animations.play('Comp');
                                          game.add
                                            .tween(Water_Can)
                                            .to({ angle: '+30' }, 400, Phaser.Easing.Cubic.Out, true, 500)
                                            .onComplete.add(function () {
                                              game.add
                                                .tween(Water_Can)
                                                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                                .onComplete.add(function () {
                                                  Water_Can.destroy();
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                          var Water_Can_anim = game.add.sprite(-85, 35, 'farm_obj_atlas', 'Comp 1_00000.png');
                          Water_Can_anim.scale.setTo(1);
                          Water_Can_anim.anchor.setTo(0.5);
                          Water_Can_anim.alpha = 0;
                          var anim = Water_Can_anim.animations.add(
                            'Comp',
                            [
                              'Comp 1_00000.png',
                              'Comp 1_00001.png',
                              'Comp 1_00002.png',
                              'Comp 1_00003.png',
                              'Comp 1_00004.png',
                              'Comp 1_00005.png',
                              'Comp 1_00006.png',
                              'Comp 1_00007.png',
                            ],
                            12,
                            false,
                          );
                          Water_Can.addChild(Water_Can_anim);
                          game.add.tween(effects_group).to({ alpha: 1 }, 6000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                            popup = 0;
                            missions_tab_open = 0;
                            animation = 0;
                            var p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                            p_text = p_text.replace('[x]', col);
                            message(
                              p_text,
                              game.camera.x + game.camera.width / 2,
                              game.camera.y + game.camera.height / 2,
                            );
                            var coins_text = coins - col;
                            text_coins_panel.setText(coins_text);
                            var var_coins = 0;
                            if (sound_on == 1) {
                              play_sound('coins_add');
                            }
                            game.time.events.repeat(
                              100,
                              10,
                              function () {
                                var get_coin = game.add.sprite(
                                  child_item.x * worldScale + game.rnd.integerInRange(-50, 50),
                                  child_item.y * worldScale + game.rnd.integerInRange(-50, 50),
                                  'game_ui_atlas',
                                  'Coin_Icon.png',
                                );
                                get_coin.anchor.setTo(0.5);
                                get_coin.scale.setTo(0);
                                get_coin.alpha = 0;
                                effects_group.add(get_coin);
                                game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                game.add
                                  .tween(get_coin.scale)
                                  .to({ x: 0.5, y: 0.5 }, 400, Phaser.Easing.Linear.None, true);
                                game.add
                                  .tween(get_coin)
                                  .to(
                                    { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                                    600,
                                    Phaser.Easing.Linear.None,
                                    true,
                                  )
                                  .onComplete.add(function (item) {
                                    item.destroy();
                                    var_coins += col / 10;
                                    text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                                  });
                              },
                              this,
                            );
                          });
                        } else {
                          var p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                          p_text = p_text.replace('[x]', col);
                          message(p_text, game.camera.x + game.camera.width / 2, game.camera.y + game.camera.height / 2);
                          var coins_text = coins - col;
                          text_coins_panel.setText(coins_text);
                          var var_coins = 0;
                          if (sound_on == 1) {
                            play_sound('coins_add');
                          }
                          game.time.events.repeat(
                            100,
                            10,
                            function () {
                              var get_coin = game.add.sprite(
                                child_item.x * worldScale + game.rnd.integerInRange(-50, 50),
                                child_item.y * worldScale + game.rnd.integerInRange(-50, 50),
                                'game_ui_atlas',
                                'Coin_Icon.png',
                              );
                              get_coin.anchor.setTo(0.5);
                              get_coin.scale.setTo(0);
                              get_coin.alpha = 0;
                              effects_group.add(get_coin);
                              game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                              game.add.tween(get_coin.scale).to({ x: 0.5, y: 0.5 }, 400, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(get_coin)
                                .to(
                                  { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                                  600,
                                  Phaser.Easing.Linear.None,
                                  true,
                                )
                                .onComplete.add(function (item) {
                                  item.destroy();
                                  var_coins += col / 10;
                                  text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                                });
                            },
                            this,
                          );
                          game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                            animation = 0;
                            if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                              let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                              letter(
                                game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                                Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                              );
                            } else if (day_tasks[complete_task_i]['dialog'] != 0)
                              dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                          });
                        }
                    });
                  }
                });
              popup = 0;
              missions_tab_open = 0;
            });
        } else if (day_tasks[n_i]['type'] == 1002 || day_tasks[n_i]['type'] == 1003) {
          complete_task_i = n_i;
          mission_task[n_i] = 1;
          mission_number.push(day_tasks[n_i]['type']);
          game.setUserDataAndLog({
            complete_task_i: complete_task_i,
            mission_stars_end: mission_stars_end,
            mission_task: JSON.stringify(mission_task),
            mission_number: JSON.stringify(mission_number),
            mission_day_end: mission_day_end,
            all_stars: all_stars,
          });
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item2) {
              item2.destroy();
            });
          game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
          game.add
            .tween(UI_bottom_group)
            .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item2) {
              friends_group.removeAll(true);
              backcard_group.removeAll(true); mission_group.removeAll(true);
              backcard_group.alpha = 1;
              item2.removeAll(true);
              UI_bottom_group_create(1, 1, 1, 1);
              item2.y = 400;
              game.add
                .tween(item2)
                .to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  animation = 1;
                  game.add
                    .tween(follow)
                    .to({ x: 1700 * worldScale, y: 1400 * worldScale }, 1000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      var f_obj = 0;
                      objects_group.children.forEach(function (child_item) {
                        if (child_item.t == 'water') {
                          child_item.destroy();
                        }
                        if (child_item.type == 35 || child_item.type == -35) {
                          f_obj = child_item;
                        }
                      });
                      let f_sprite = [];
                      if (day_tasks[n_i]['type'] == 1003) f_sprite = ['Water_1.png', 'Water_2.png', 'Water_3.png'];
                      else f_sprite = ['Drops_1.png', 'Drops_2.png'];
                      f_water = game.add.sprite(f_obj.x, f_obj.y - 110, 'farm_obj_atlas', f_sprite[0]);
                      f_water.scale.setTo(2.9);
                      f_water.anchor.setTo(0.5, 1);
                      f_water.depth = 100;
                      f_water.t = 'water';
                      objects_group.add(f_water);
                      f_water.animations.add('f_water', f_sprite, 8, true);
                      f_water.animations.play('f_water');
                      game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                        animation = 0;
                        if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                          let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                          letter(
                            game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                            Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                          );
                        } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                      });
                    });
                });
              popup = 0;
              missions_tab_open = 0;
            });
        } else if (day_tasks[n_i]['type'] == 990 || day_tasks[n_i]['type'] == 21 || day_tasks[n_i]['type'] > 1000) {
          complete_task_i = n_i;
          mission_task[n_i] = 1;
          mission_number.push(day_tasks[n_i]['type']);
          game.setUserDataAndLog({
            complete_task_i: complete_task_i,
            mission_stars_end: mission_stars_end,
            mission_task: JSON.stringify(mission_task),
            mission_number: JSON.stringify(mission_number),
            mission_day_end: mission_day_end,
            all_stars: all_stars,
          });
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item2) {
              item2.destroy();
            });
          game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
          game.add
            .tween(UI_bottom_group)
            .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item2) {
              friends_group.removeAll(true);
              backcard_group.removeAll(true); mission_group.removeAll(true);
              backcard_group.alpha = 1;
              item2.removeAll(true);
              UI_bottom_group_create(1, 1, 1, 1, 0);
              item2.y = 400;
              game.add
                .tween(item2)
                .to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  if (day_tasks[n_i]['type'] == 1018) {
                    animation = 1;
                    follow.x = 3400 * worldScale;
                    follow.y = 1000 * worldScale;
                    last_position = [3400 * worldScale, 1000 * worldScale];
                    game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                    game.add.tween(effects_group).to({ alpha: 1 }, 2000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      animation = 0;
                      dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                    });
                  } else if (day_tasks[n_i]['type'] == 1014) {
                    animation = 1;
                    blackf();
                    var Rose_Competition_Newspaper = game.add.sprite(
                      game.camera.width / 2,
                      game.camera.height * 2,
                      'photo_atlas',
                      'Newspaper.png',
                    );
                    Rose_Competition_Newspaper.scale.setTo(2);
                    Rose_Competition_Newspaper.anchor.setTo(0.5, 1);
                    Rose_Competition_Newspaper.fixedToCamera = true;
                    game.add
                      .tween(Rose_Competition_Newspaper.cameraOffset)
                      .to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Linear.None, true);
                    var Hand = game.add.sprite(99, -152, 'photo_atlas', 'Hand.png');
                    Rose_Competition_Newspaper.addChild(Hand);
                    var Image = game.add.sprite(-226, -288, 'photo_atlas', 'Competition_Image.png');
                    Rose_Competition_Newspaper.addChild(Image);
                    game.add.tween(effects_group).to({ alpha: 1 }, 2000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      if (Rose_Competition_Newspaper != 0) {
                        game.add
                          .tween(Rose_Competition_Newspaper.cameraOffset)
                          .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            Rose_Competition_Newspaper.destroy();
                            Rose_Competition_Newspaper = 0;
                          });
                      }
                      animation = 0;
                      dialog_window(Number(day_tasks[complete_task_i]['dialog']), 1);
                    });
                  } else if (day_tasks[n_i]['type'] == 1035) {
                    animation = 1;
                    blackf();
                    var Rose_Competition_Newspaper = game.add.sprite(
                      game.camera.width / 2,
                      game.camera.height * 2,
                      'photo_atlas',
                      'Newspaper.png',
                    );
                    Rose_Competition_Newspaper.scale.setTo(2);
                    Rose_Competition_Newspaper.anchor.setTo(0.5, 1);
                    Rose_Competition_Newspaper.fixedToCamera = true;
                    game.add
                      .tween(Rose_Competition_Newspaper.cameraOffset)
                      .to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Linear.None, true);
                    var Hand = game.add.sprite(99, -152, 'photo_atlas', 'Hand.png');
                    Rose_Competition_Newspaper.addChild(Hand);
                    var Image = game.add.sprite(-226, -288, 'photo_atlas', 'Winner_Image.png');
                    Rose_Competition_Newspaper.addChild(Image);
                    game.add.tween(effects_group).to({ alpha: 1 }, 2000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      if (Rose_Competition_Newspaper != 0) {
                        game.add
                          .tween(Rose_Competition_Newspaper.cameraOffset)
                          .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            Rose_Competition_Newspaper.destroy();
                            Rose_Competition_Newspaper = 0;
                          });
                      }
                      animation = 0;
                      dialog_window(Number(day_tasks[complete_task_i]['dialog']), 1);
                    });
                  } else if (day_tasks[n_i]['type'] == 1111) {
                    animation = 1;
                    coins += 200;
                    var col = 200;
                    game.setCurrentEvent();
                    window.eventTrack('coins_in', col, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: col,
                      source: 'Sell honey first time',
                      package_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });

                    // save collected coins
                    game.setUserDataAndLog({ currencies: coins });

                    var p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                    p_text = p_text.replace('[x]', '300');
                    message(p_text, game.camera.x + game.camera.width / 2, game.camera.y + game.camera.height / 2);
                    var coins_text = coins - col;
                    text_coins_panel.setText(coins_text);
                    var var_coins = 0;
                    if (sound_on == 1) {
                      play_sound('coins_add');
                    }
                    game.time.events.repeat(
                      100,
                      10,
                      function () {
                        var get_coin = game.add.sprite(
                          game.camera.x + game.camera.width / 2 + game.rnd.integerInRange(-50, 50),
                          game.camera.y + game.camera.height / 2 + game.rnd.integerInRange(-50, 50),
                          'game_ui_atlas',
                          'Coin_Icon.png',
                        );
                        get_coin.anchor.setTo(0.5);
                        get_coin.scale.setTo(0);
                        get_coin.alpha = 0;
                        effects_group.add(get_coin);
                        game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                        game.add.tween(get_coin.scale).to({ x: 0.5, y: 0.5 }, 400, Phaser.Easing.Linear.None, true);
                        game.add
                          .tween(get_coin)
                          .to(
                            { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                            600,
                            Phaser.Easing.Linear.None,
                            true,
                          )
                          .onComplete.add(function (item) {
                            item.destroy();
                            var_coins += col / 10;
                            text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                          });
                      },
                      this,
                    );
                    game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      animation = 0;
                      dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                    });
                  } else if (day_tasks[n_i]['type'] == 1021) {
                    animation = 1;
                    follow.x = 3600 * worldScale;
                    follow.y = 1600 * worldScale;
                    last_position = [3600 * worldScale, 1600 * worldScale];
                    game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                    game.add.tween(effects_group).to({ alpha: 1 }, 2000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      animation = 0;
                      dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                    });
                  } else {
                    if (Number(day_tasks[complete_task_i]['dialog']) > 1000) {
                      let l = Number(day_tasks[complete_task_i]['dialog']) - 1000;
                      letter(
                        game.cache.getJSON('dialog')['letter' + l][0][window.lang],
                        Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
                      );
                    } else dialog_window(Number(day_tasks[complete_task_i]['dialog']), 0);
                  }
                });
              popup = 0;
              missions_tab_open = 0;
            });
        } else if (day_tasks[n_i]['type'] == 998) {
          var object = 0;
          objects_group.children.forEach(function (child_item) {
            if (child_item.type == 4) {
              object = child_item;
              object.iii = n_i + 1;
            }
          });
          complete_task_i = n_i;
          mission_task[n_i] = 1;
          mission_number.push(day_tasks[n_i]['type']);
          game.setUserDataAndLog({
            complete_task_i: complete_task_i,
            mission_stars_end: mission_stars_end,
            mission_task: JSON.stringify(mission_task),
            mission_number: JSON.stringify(mission_number),
            mission_day_end: mission_day_end,
            all_stars: all_stars,
          });
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item2) {
              item2.destroy();
            });
          game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
          game.add
            .tween(UI_bottom_group)
            .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item2) {
              friends_group.removeAll(true);
              backcard_group.removeAll(true); mission_group.removeAll(true);
              backcard_group.alpha = 1;
              item2.removeAll(true);
              UI_bottom_group_create(1, 1, 1, 1, 0);
              item2.y = 400;
              game.add
                .tween(item2)
                .to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  first_create = 1;
                  build_special_object(object, 1);
                });
              popup = 0;
              missions_tab_open = 0;
              follow.x = 2400 * worldScale;
              follow.y = 1000 * worldScale;
              last_position = [2400 * worldScale, 1000 * worldScale];
              game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
            });
        } else if (
          act1_array.findIndex(function (e) {
            return e['type'] == day_tasks[n_i]['type'];
          }) == -1
        ) {
          objects_group.children.some(function (child_item2) {
            if (
              child_item2.type == day_tasks[n_i]['type'] ||
              (child_item2.type == 61 && child_item2.x > 1000 && child_item2.x < 1200 && day_tasks[n_i]['type'] == 125)
            ) {
              animation = 1;
              let child_item = child_item2;
              complete_task_i = n_i;
              mission_task[n_i] = 1;
              mission_number.push(day_tasks[n_i]['type']);
              game.setUserDataAndLog({
                complete_task_i: complete_task_i,
                mission_stars_end: mission_stars_end,
                mission_task: JSON.stringify(mission_task),
                mission_number: JSON.stringify(mission_number),
                mission_day_end: mission_day_end,
                all_stars: all_stars,
              });
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item2) {
                  item2.destroy();
                });
              game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
              game.add
                .tween(UI_bottom_group)
                .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item2) {
                  friends_group.removeAll(true);
                  backcard_group.removeAll(true); mission_group.removeAll(true);
                  backcard_group.alpha = 1;
                  item2.removeAll(true);
                  UI_bottom_group_create(1, 1, 1, 1, 0);
                  item2.y = 400;
                  game.add.tween(item2).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
                  popup = 0;
                  missions_tab_open = 0;
                  follow.x = child_item.world.x * worldScale;
                  follow.y = child_item.world.y * worldScale;
                  last_position = [child_item.world.x * worldScale, child_item.world.y * worldScale];
                  game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                  if (
                    child_item.type == 13 ||
                    child_item.type == 23 ||
                    child_item.type == 41 ||
                    child_item.type == 45 ||
                    child_item.type == 52 ||
                    child_item.type == 56 ||
                    child_item.type == 93 ||
                    child_item.type == 98 ||
                    child_item.type == 142 ||
                    child_item.type == 187
                  ) {
                    var ot = child_item.type;
                    var item_iii = n_i;
                    objects_group.children.some(function (child_item2) {
                      if (child_item2.type == ot) {
                        let child_item = child_item2;
                        if (emitter_smoke2 == 0) {
                          follow.x = child_item.world.x * worldScale;
                          follow.y = child_item.world.y * worldScale;
                          last_position = [child_item.world.x * worldScale, child_item.world.y * worldScale];
                        }
                        object_destroy(child_item, item_iii);
                      }
                    });
                  } else object_destroy(child_item, n_i);
                });
              return true;
            }
          });
        } else if (
          act1_array.findIndex(function (e) {
            return e['type'] == day_tasks[n_i]['type'];
          }) != -1
        ) {
          animation = 1;
          var index = [];
          index.push(
            act1_array.findIndex(function (e) {
              return e['type'] == day_tasks[n_i]['type'];
            }),
          );
          complete_task_i = n_i;
          mission_task[n_i] = 1;
          mission_number.push(day_tasks[n_i]['type']);
          game.setUserDataAndLog({
            complete_task_i: complete_task_i,
            mission_stars_end: mission_stars_end,
            mission_task: JSON.stringify(mission_task),
            mission_number: JSON.stringify(mission_number),
            mission_day_end: mission_day_end,
            all_stars: all_stars,
          });
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item2) {
              item2.destroy();
            });
          game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
          game.add
            .tween(UI_bottom_group)
            .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item2) {
              friends_group.removeAll(true);
              backcard_group.removeAll(true); mission_group.removeAll(true);
              backcard_group.alpha = 1;
              item2.removeAll(true);
              UI_bottom_group_create(1, 1, 1, 1, 0);
              item2.y = 400;
              game.add.tween(item2).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
              popup = 0;
              missions_tab_open = 0;
              follow.x = act1_array[index[0]]['xxx'] * 1.2 * worldScale;
              follow.y = act1_array[index[0]]['yyy'] * 1.2 * worldScale + 304 * worldScale;
              last_position = [
                act1_array[index[0]]['xxx'] * 1.2 * worldScale,
                act1_array[index[0]]['yyy'] * 1.2 * worldScale + 304 * worldScale,
              ];
              game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
              if (
                act1_array[index[0]]['type'] == 5 ||
                act1_array[index[0]]['type'] == 89 ||
                act1_array[index[0]]['type'] == 96 ||
                act1_array[index[0]]['type'] == 95 ||
                act1_array[index[0]]['type'] == 43 ||
                act1_array[index[0]]['type'] == 54 ||
                act1_array[index[0]]['type'] == 46 ||
                act1_array[index[0]]['type'] == 27 ||
                act1_array[index[0]]['type'] == 24 ||
                act1_array[index[0]]['type'] == 51
              ) {
                index = [];
                for (var i = 0; i < act1_array.length; i++) {
                  if (
                    act1_array[i]['type'] == day_tasks[n_i]['type'] &&
                    (act1_array[i]['act'] == 2 || act1_array[i]['act'] == 1)
                  ) {
                    index.push(i);
                  }
                }
              }
              if (act1_array[index[0]]['change'] == 0) object_create(index, n_i, 0);
              else object_change(index, n_i);
            });
        }
      });
    }
    var progress_step = 0;
    var current_prize = 0;
    var task_iii = 0;
    var task_time = 0;
    var new_tasks = [];
    var backcard_group_c = 0;
    if (typeof complete_task_i === 'undefined' || isNaN(complete_task_i)) {
      complete_task_i = -1;
    }
    if (complete_task_i != -1 && typeof day_tasks[complete_task_i] !== "undefined" && typeof day_tasks[complete_task_i]['type'] !== "undefined") {
      console.log('complete_task_i', complete_task_i);
      missioncompleted = day_tasks[complete_task_i]['type'] + '_' + day_tasks[complete_task_i]['text'];
      missioncompleted = missioncompleted.replace(/ /g, "_");
    }

    function build_window() {
      let group_Texture_1 = game.add.group();
      group_Texture_1.y = -235;
      let task_ticket_spr = draw_rect(172, 235, 344, 469, '#70EAF1', '#32A9CE', 0, 0, 0, 5, 30, 0, 0);
      draw_rect_shadow(0, 0, 320, 446, '#000', '#000', 0, 0, task_ticket_spr, 20);
      draw_rect(0, 0, 320, 446, '#FEFDF9', '#FAF1DC', 0, 0, task_ticket_spr, 0, 20, 0);
      draw_rect(0, -20, 279, 232, '#FFFFFD', '#FFFFFD', 0, 0, task_ticket_spr, 0, 20, 0);
      draw_rect(0, -20, 273, 226, '#F9EED9', '#FAEBC9', 0, 0, task_ticket_spr, 0, 20, 0);
      draw_rect(0, -189, 320, 69, '#D0EEFA', '#D0EEFA', 0, 0, task_ticket_spr, 0, 20, 0);
      group_Texture_1.add(task_ticket_spr);
      group_Texture_1.inputEnabled = false;
      group_Texture_1.y = 0;
      let renderTexture_1 = game.make.renderTexture(344, 474);
      renderTexture_1.render(group_Texture_1);
      group_Texture_1.destroy();
      let group_Texture_2 = game.add.group();
      group_Texture_2.y = -235;
      let task_ticket2_spr = draw_rect(172, 235, 344, 469, '#FCF9ED', '#EDCF95', 0, 0, 0, 5, 30, 0, 0);
      draw_rect_shadow(0, 0, 320, 446, '#000', '#000', 0, 0, task_ticket2_spr, 20);
      draw_rect(0, 0, 320, 446, '#FEFDF9', '#FAF1DC', 0, 0, task_ticket2_spr, 0, 20, 0);
      draw_rect(0, -20, 279, 232, '#FFFFFD', '#FFFFFD', 0, 0, task_ticket2_spr, 0, 20, 0);
      draw_rect(0, -20, 273, 226, '#F9EED9', '#FAEBC9', 0, 0, task_ticket2_spr, 0, 20, 0);
      draw_rect(0, -189, 320, 69, '#FAEAC7', '#FAEAC7', 0, 0, task_ticket2_spr, 0, 20, 0);
      group_Texture_2.add(task_ticket2_spr);
      group_Texture_2.inputEnabled = false;
      group_Texture_2.y = 0;
      let renderTexture_2 = game.make.renderTexture(344, 474);
      renderTexture_2.render(group_Texture_2);
      group_Texture_2.destroy();

      for (var i = 0; i < taks_indicator_mas.length; i++) {
        game.add
          .tween(taks_indicator_mas[i])
          .to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            item.destroy();
          });
        game.add.tween(taks_indicator_mas[i].scale).to({ x: 0, y: 0 }, 300, Phaser.Easing.Linear.None, true);
      }

      taks_indicator_mas = [];
      animation = 0;
      popup = 1;
      var all_build = Number(game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0]['builds_all']);
      progress_step = 761 / all_day_stars;
      backcard_group.removeAll(true); mission_group.removeAll(true);
      backcard_group_c = game.add.group();
      backcard_group.add(backcard_group_c);
      backcard_group.mask = null;
      missions_tab_open = 3;
      if (FTUE != 5) game.world.bringToTop(UI_top_group);
      game.world.bringToTop(backcard_group);
      w = 0;
      current_prize = 0;
      var n = 0;
      var n_max = 10;
      var all_width = 0;
      var all_width_n = 0;
      new_tasks = [];
      var last_i = -1;
      var taskpause = 1500;

      for (i = 0; i < all_day_build; i++) {
        if ((mission_task[i] != 1 && n < n_max) || i == complete_task_i) {
          if (
            day_tasks[i]['ifComplete'] == '0' ||
            (day_tasks[i]['ifComplete'] != '0' && contains(mission_number, day_tasks[i]['ifComplete'].split(',')))
          ) {
            all_width += 360;
            if (i != complete_task_i) {
              all_width_n += 360;
            }
            last_i = i;
          }
        }
        if (complete_task_i != -1)
          if (
            contains(mission_number, day_tasks[i]['ifComplete'].split(',')) &&
            contains(day_tasks[i]['ifComplete'].split(','), [day_tasks[complete_task_i]['type']])
          ) {
            new_tasks.push(i);
          }
      }

      if (day_tasks.length == 0) {
        var popup_back = windows_f(game.cache.getJSON('lang')['t334'][0][window.lang], 4);

        var no_task_text = game.add.text(0, 200, game.cache.getJSON('lang')['t277'][0][window.lang], {
          font: '28px RussoOne',
          fill: '#8C3B32',
          align: 'center',
        });

        no_task_text.anchor.setTo(0.5);
        popup_back.addChild(no_task_text);
      }
      else {
        for (i = 0; i < all_day_build; i++) {
          if ((mission_task[i] != 1 && n < n_max) || i == complete_task_i) {
            if (
              day_tasks[i]['ifComplete'] == '0' ||
              (day_tasks[i]['ifComplete'] != '0' && contains(mission_number, day_tasks[i]['ifComplete'].split(',')))
            ) {
              if (day_tasks[i]['type'] >= 2000) {
                var task_ticket = game.add.sprite(
                  game.camera.width / 2 + n * 360 - all_width / 2 + 180,
                  game.camera.height / 2 + 40,
                  renderTexture_1,
                );
              } else {
                var task_ticket = game.add.sprite(
                  game.camera.width / 2 + n * 360 - all_width / 2 + 180,
                  game.camera.height / 2 + 40,
                  renderTexture_2,
                );
              }
              if (all_width_n / 360 > 5) {
                task_ticket.x += (360 * Math.floor(all_width_n / 360 - 5)) / 2;
              }
              console.log(all_width_n / 360, (360 * Math.floor(all_width_n / 360 - 5)) / 2);
              task_ticket.anchor.setTo(0.5);
              task_ticket.scale.setTo(0);
              backcard_group_c.add(task_ticket);
              let pause = 50 * n;
              if (FTUE == 5 && i == 0) {
                game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  FTUE_process();
                });
              }
              if (i == complete_task_i) {
                animation = 1;
                var Task_Completed_Check = game.add.sprite(0, 150, 'game_ui_atlas', 'Task_Completed_Check.png');
                Task_Completed_Check.anchor.setTo(0.5);
                Task_Completed_Check.scale.setTo(0);
                task_ticket.addChild(Task_Completed_Check);
                game.add
                  .tween(Task_Completed_Check.scale)
                  .to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true, last_i * 50 + 500);
                game.add
                  .tween(task_ticket)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, last_i * 50 + 800)
                  .onComplete.add(function () {
                    game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      if (animation != -1) animation = 0;
                      FTUE_process();

                    });
                  });
              }

              if (new_tasks.length == 0 && complete_task_i != -1) {
                if (all_width_n / 360 > 5) {
                  if (complete_task_i == last_i) {
                    game.add
                      .tween(task_ticket)
                      .to({ x: '+0' }, 500, Phaser.Easing.Linear.None, true, last_i * 50 + 1000);
                  } else if (complete_task_i == 0) {
                    game.add
                      .tween(task_ticket)
                      .to({ x: '-360' }, 500, Phaser.Easing.Linear.None, true, last_i * 50 + 1000);
                  } else if (i < complete_task_i) {
                    game.add
                      .tween(task_ticket)
                      .to({ x: '+0' }, 500, Phaser.Easing.Linear.None, true, last_i * 50 + 1000);
                  } else if (i > complete_task_i) {
                    game.add
                      .tween(task_ticket)
                      .to({ x: '-360' }, 500, Phaser.Easing.Linear.None, true, last_i * 50 + 1000);
                  }
                } else {
                  if (complete_task_i == last_i) {
                    game.add
                      .tween(task_ticket)
                      .to({ x: '+180' }, 500, Phaser.Easing.Linear.None, true, last_i * 50 + 1000);
                  } else if (complete_task_i == 0) {
                    game.add
                      .tween(task_ticket)
                      .to({ x: '-180' }, 500, Phaser.Easing.Linear.None, true, last_i * 50 + 1000);
                  } else if (i < complete_task_i) {
                    game.add
                      .tween(task_ticket)
                      .to({ x: '+180' }, 500, Phaser.Easing.Linear.None, true, last_i * 50 + 1000);
                  } else if (i > complete_task_i) {
                    game.add
                      .tween(task_ticket)
                      .to({ x: '-180' }, 500, Phaser.Easing.Linear.None, true, last_i * 50 + 1000);
                  }
                }
              } else if (new_tasks.length != 0 && complete_task_i != -1) {
                if (new_tasks.indexOf(i) != -1) {
                  pause += 1300;
                }
                if (i > complete_task_i) {
                  task_ticket.x -= 180;
                  if (last_i != -1) {
                    last_i = -1;
                  }
                } else if (i <= complete_task_i) {
                  task_ticket.x += 180;
                }
              }
              if (pause > 1200) {
                animation = 1;
                task_ticket.x += 4000;
                task_ticket.scale.setTo(1);
                var tween = game.add
                  .tween(task_ticket)
                  .to({ x: '-4000' }, 1500, Phaser.Easing.Exponential.Out, true, pause);
                tween.onComplete.add(function () {
                  if (animation != -1) animation = 0;
                  indicator_system(0);
                });
                tween.onStart.add(function (item) {
                  game.world.bringToTop(item);
                });
                tween.onUpdateCallback(function (item) {
                  game.world.bringToTop(backcard_group);
                }, this);
              } else game.add.tween(task_ticket.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true, pause);
              var task1 = game.add.sprite(0, -30, day_tasks[i]['atlas'], day_tasks[i]['sprite'] + '.png');
              if (day_tasks[i]['type'] == 127) {
                let sub_task = game.add.sprite(14, 20, 'farm_obj_c_atlas', 'Dogbody.png');
                sub_task.anchor.setTo(0.5);
                task1.addChild(sub_task);
                let doghead = game.add.sprite(0, -10, 'farm_obj_c_atlas', 'Head1.png');
                doghead.anchor.setTo(0.5);
                sub_task.addChild(doghead);
              } else if (day_tasks[i]['type'] == 73) {
                let sub_task = game.add.sprite(0, -30, 'farm_obj_atlas', 'magnifying_glass.png');
                sub_task.scale.setTo(0.5);
                sub_task.anchor.setTo(0.5);
                task1.addChild(sub_task);
              } else if (day_tasks[i]['type'] == 86) {
                let sub_task = game.add.sprite(-10, 6, 'farm_obj_atlas', 'stoune_dirty.png');
                sub_task.anchor.setTo(0.5);
                task1.addChild(sub_task);
              } else if (day_tasks[i]['type'] == 74) {
                let sub_task = game.add.sprite(0, 10, 'farm_obj_atlas', 'Stick.png');
                sub_task.scale.setTo(0.8);
                sub_task.angle += 15;
                sub_task.anchor.setTo(1, 0.5);
                task1.addChild(sub_task);
              } else if (day_tasks[i]['type'] == 84) {
                let sub_task = game.add.sprite(0, 20, 'farm_obj_atlas', 'fire_1.png');
                sub_task.scale.setTo(2);
                sub_task.anchor.setTo(0.5, 1);
                task1.addChild(sub_task);
              }
              if (day_tasks[i]['atlas'] != 'char_atlas') {
                if (day_tasks[i]['type'] == 1015) {
                  task1.height = 224;
                  task1.width = 266;
                  task1.y += 8;
                } else if (day_tasks[i]['type'] != 999) {
                  if (task1.width > task1.height) task1.scale.setTo(140 / task1.width);
                  else task1.scale.setTo(140 / task1.height);
                } else task1.scale.setTo(2.1);
              } else {
                task1.scale.setTo(0.9);
                task1.y += 7;
              }
              var task_text = game.add.text(0, -190, day_tasks[i]['text'], {
                font: '24px RussoOne',
                fill: '#8B3B32',
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 320,
              });
              task_text.anchor.setTo(0.5);
              task_text.stroke = '#fff';
              task_text.lineSpacing = -10;
              task_text.strokeThickness = 4;
              task_ticket.addChild(task_text);
              task1.anchor.setTo(0.5);
              task_ticket.addChild(task1);
              if (day_tasks[i]['type'] == 6) {
                task1.tint = 0xca8b5c;
                let sub_task = game.add.sprite(0, -30, 'farm_obj_c_atlas', 'roof_2.png');
                sub_task.anchor.setTo(0.5);
                if (sub_task.width > sub_task.height) sub_task.scale.setTo(140 / sub_task.width);
                else sub_task.scale.setTo(140 / sub_task.height);
                task_ticket.addChild(sub_task);
              }
              if (day_tasks[i]['type'] == 128) {
                task1.tint = 0x889699;
              }

              if (day_tasks[i]['type'] >= 2000) {

                var Coins_On_Task = game.add.sprite(0, -23, 'game_ui_atlas', 'Coins_On_Task.png');
                Coins_On_Task.anchor.setTo(0.5);
                task_ticket.addChild(Coins_On_Task);

                var sss = 100;

                if (day_tasks[i]['type'] == 2003) {
                  sss = 100;
                } else if (day_tasks[i]['type'] == 2004) {
                  sss = 200;
                } else if (day_tasks[i]['type'] == 2005) {
                  sss = 350;
                } else if (day_tasks[i]['type'] == 2006) {
                  sss = 400;
                } else if (day_tasks[i]['type'] == 2007) {
                  sss = 300;
                }
                var Coins_On_Task_text = game.add.text(55, 95, '+' + sss, {
                  font: '24px RussoOne',
                  fill: '#fff',
                  align: 'center',
                  wordWrap: true,
                  wordWrapWidth: 320,
                });
                Coins_On_Task_text.anchor.setTo(0.5);
                Coins_On_Task_text.stroke = '#B57A36';
                Coins_On_Task_text.lineSpacing = -10;
                Coins_On_Task_text.strokeThickness = 4;
                Coins_On_Task.addChild(Coins_On_Task_text);

                var Coins_On_Task_icon = game.add.sprite(110, 89, 'game_window2_atlas', 'List_Coin.png');
                Coins_On_Task_icon.anchor.setTo(0.5);
                Coins_On_Task_icon.scale.setTo(0.58);
                Coins_On_Task.addChild(Coins_On_Task_icon);
              }

              var taskbuy = 0;
              var green_button = game.add.sprite(0, 150, 'game_ui_atlas', 'Green_Star_Button.png');
              green_button.anchor.setTo(0.5);
              green_button.t = 'button';
              if (day_tasks[i]['stars'] > all_stars) {
                button_animation_f(green_button, 1);
              }
              if (current_prize == 0 && i != complete_task_i) {
                green_button.inputEnabled = true;
                green_button.input.useHandCursor = true;
              } else {
                green_button.inputEnabled = false;
                if (i == complete_task_i) green_button.alpha = 0;
              }
              green_button.iii = i;
              green_button.events.onInputUp.add(function (item) {
                if (animation == 0 && FTUE != 29 && FTUE != 30 && FTUE != 24 && taskbuy == 0) {
                  if (day_tasks[item.iii]['type'] == 1) {
                    if (fbv == 1) {
                      window.eventTrack('FTUE_5_4_CutEntryFreeConfirmed');
                    }
                  } else if (day_tasks[item.iii]['type'] == 2) {
                    if (fbv == 1) {
                      window.eventTrack('FTUE_7_3_RemoveIvyFromHouseConfirmed');
                    }
                  } else if (day_tasks[item.iii]['type'] == 62) {
                    if (fbv == 1) {
                      window.eventTrack('FTUE_9_4_CheckOutHouseInsideConfirmed');
                    }
                  } else if (day_tasks[item.iii]['type'] == 3) {
                    if (fbv == 1) {
                      window.eventTrack('FTUE_11_3_A_ClearWindowsButtonClicked');
                    }
                  } else if (day_tasks[item.iii]['type'] == 4) {
                    if (fbv == 1) {
                      window.eventTrack('FTUE_11_3_B_FixHouseSurfaceButtonClicked');
                    }
                  }
                  item.inputEnabled = false;
                  if (typeof day_tasks[item.iii] == 'undefined' || !day_tasks[item.iii]) {
                    item.iii--;
                  }
                  if (day_tasks[item.iii]['stars'] <= all_stars) {

                    if (FTUE > 30)
                      for (var i = 0; i < missions.length; i += 4) {
                        if (missions[i] == -10) {
                          if (missions[i + 2] < missions[i + 1]) {
                            missions[i + 2] += 1;
                          }
                        }
                      }

                    missioncompleted = day_tasks[item.iii]['type'] + '_' + day_tasks[item.iii]['text'];
                    missioncompleted = missioncompleted.replace(/ /g, "_");
                    console.log(missioncompleted);
                    if (day_tasks[item.iii]['type'] < 2000 && day_tasks[item.iii]['type'] != 999) {
                      taskpause = 2600;
                      mission_day_end_old = mission_stars_end;
                      mission_day_end += 1;
                      mission_stars_end += day_tasks[item.iii]['stars'];
                      for (i = 1; i <= 5; i++) {
                        if (
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + i + 'position'
                            ],
                          ) != 0 &&
                          day_prize[i - 1] == 0
                        )
                          if (
                            Number(
                              game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                              'prize' + i + 'position'
                              ],
                            ) <= mission_stars_end
                          ) {
                            day_prize[i - 1] = -1;
                            backcard_group.children.forEach(function (child_item) {
                              if (child_item.ip == i - 1) current_prize = child_item;
                            });
                            //game.setUserDataAndLog({ day_prize: JSON.stringify(day_prize) });
                            taskpause = 4500;
                          }
                      }
                      /*game.setUserDataAndLog({
                        mission_stars_end: mission_stars_end,
                        mission_day_end: mission_day_end,
                      });*/
                    }
                    if (FTUE <= 6 || day_tasks.length == 0) {
                      taskpause = 1500;
                    }
                    if (day_tasks[item.iii]['type'] != 62) {
                      FTUE_process();
                    } else {
                      f_w_a();
                    }
                    animation = -1;
                    taskbuy = 1;
                    all_stars -= day_tasks[item.iii]['stars'];
                    text_stars_panel.setText(all_stars);
                    game.time.events.repeat(100, day_tasks[item.iii]['stars'], function () {
                      if (sound_on == 1) {
                        play_sound('Allocating_Stars_to_a_mission');
                      }
                      var star_emitter = game.add.emitter(text_stars_panel.world.x, text_stars_panel.world.y, 100);
                      star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                      star_emitter.setAlpha(1, 0, 800);
                      star_emitter.setScale(3, 0, 3, 0, 800);
                      star_emitter.start(false, 1200, 10);
                      star_emitter.bringToTop = true;
                      game.add.tween(effects_group).to({ alpha: 1 }, 1100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                        star_emitter.destroy();
                      });
                      var get_star = game.add.sprite(
                        star_icon.world.x,
                        star_icon.world.y,
                        'game_ui_atlas',
                        'Star_Icon.png',
                      );
                      get_star.anchor.setTo(0.5);
                      effects_group.add(get_star);
                      game.world.bringToTop(effects_group);
                      game.add.tween(get_star.scale).to({ x: 0.6, y: 0.6 }, 1000, Phaser.Easing.Linear.None, true);
                      var tween = game.add
                        .tween(get_star)
                        .to({ x: item.world.x - 25, y: item.world.y }, 1000, Phaser.Easing.Cubic.In, true);
                      game.add
                        .tween(get_star)
                        .to({ angle: 0 }, 1000, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (ooo) {
                          game.add.tween(ooo.scale).to({ x: 1.5, y: 1.5 }, 400, Phaser.Easing.Linear.None, true);
                          game.add
                            .tween(ooo)
                            .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function (itm) {
                              itm.destroy();
                              if (FTUE > 6 && day_tasks.length != 0 && taskpause > 1500) {
                                bar_text.setText(mission_stars_end + '/' + all_day_stars);
                                // app.ddna.addEvent(DdnaEventName.Progress, {
                                //   pEpisodeNumber: Number(mission_stars_end),
                                //   pDay: Number(map_n),
                                // });
                                if (taskpause != 5000) {
                                  taskpause = 5000;
                                  game.add.tween(item).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                                  if (typeof day_tasks[item.iii]['type'] !== 'undefined')
                                    if (day_tasks[item.iii]['type'] < 2000 && day_tasks[item.iii]['type'] != 999) {
                                      let cropRect = new Phaser.Rectangle(
                                        0,
                                        0,
                                        mission_day_end_old * progress_step,
                                        gift_bar_level.height,
                                      );
                                      mission_day_end_old = mission_stars_end;
                                      gift_bar_level.crop(cropRect);
                                      var tween = game.add
                                        .tween(cropRect)
                                        .to(
                                          { width: mission_stars_end * progress_step },
                                          900,
                                          Phaser.Easing.Linear.None,
                                          true,
                                        );
                                      tween.onUpdateCallback(function () {
                                        try {
                                          gift_bar_level.crop(cropRect);
                                        } catch (err) { }
                                      }, this);
                                      get_prize();
                                    }
                                }
                              }
                            });
                        });
                      tween.onUpdateCallback(function () {
                        star_emitter.x = get_star.x;
                        star_emitter.y = get_star.y;
                      }, this);
                    });

                    if (day_tasks[item.iii]['type'] == 999) {
                      game.add.tween(effects_group).to({ alpha: 1 }, taskpause, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                        mission_task[item.iii] = 1;
                        mission_number.push(day_tasks[item.iii]['type']);
                        mission_day_end_old = mission_stars_end;
                        mission_day_end += 1;
                        mission_stars_end += day_tasks[item.iii]['stars'];
                        game.add.tween(task_ticket).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
                        bar_text.setText(mission_stars_end + '/' + all_day_stars);
                        let cropRect = new Phaser.Rectangle(
                          0,
                          0,
                          mission_day_end_old * progress_step,
                          gift_bar_level.height,
                        );
                        mission_day_end_old = mission_stars_end;
                        gift_bar_level.crop(cropRect);
                        var tween = game.add
                          .tween(cropRect)
                          .to({ width: mission_stars_end * progress_step }, 900, Phaser.Easing.Linear.None, true);
                        tween.onUpdateCallback(function () {
                          try {
                            gift_bar_level.crop(cropRect);
                          } catch (err) { }
                        }, this);
                        mission_day_end = 0;
                        mission_stars_end = 0;
                        mission_day_end_old = 0;
                        day_prize = [0, 0, 0, 0, 0, 0];
                        mission_task = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                        map_n += 1;
                        complete_task_i = -1;
                        task_create();
                        game.setUserDataAndLog({
                          day_prize: JSON.stringify(day_prize),
                          complete_task_i: complete_task_i,
                          mission_stars_end: mission_stars_end,
                          mission_task: JSON.stringify(mission_task),
                          mission_number: JSON.stringify(mission_number),
                          mission_day_end: mission_day_end,
                          map_n: map_n,
                        });
                        current_prize = -100;
                        get_prize();
                      });
                    } else if (taskpause >= 4500) {
                      task_iii = item.iii;
                      task_time = 1000;
                    } else {
                      build_action(item.iii, taskpause);
                    }


                  } else {

                    FTUE_process();
                    btnup(item);
                    game.add
                      .tween(black_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                      .onComplete.add(function (item2) {
                        item2.destroy();
                      });
                    game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                    game.add
                      .tween(UI_bottom_group)
                      .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item2) {
                        friends_group.removeAll(true);
                        backcard_group.removeAll(true); mission_group.removeAll(true);
                        backcard_group.alpha = 1;
                        item2.removeAll(true);
                        UI_bottom_group_create(1, 1, 1, 1, 0);
                        item2.y = 400;
                        game.add.tween(item2).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
                        popup = 0;
                        missions_tab_open = 0;
                        complete_task_i = -1;
                        game.setUserDataAndLog({ complete_task_i: complete_task_i });
                        buildstart = 1;
                        level = level_button.n;
                        level_select(level_button);
                        //instruction_popup(level_button);
                      });
                  }
                }
              });
              task_ticket.addChild(green_button);
              if (day_tasks[i]['stars'] <= all_stars) {
                scale_tween(green_button, 500, 0.05, 0.05);
              }
              var green_button_text = game.add.text(10, 0, day_tasks[i]['stars'], {
                font: '38px RussoOne',
                fill: '#fff',
                align: 'center',
              });
              green_button_text.anchor.setTo(0, 0.5);
              green_button_text.stroke = '#457310';
              green_button_text.strokeThickness = 2;
              green_button_text.setShadow(0, 3, 'rgba(69,115,16,0.7)', 1);
              green_button.addChild(green_button_text);
              n++;
            }
          }
        }
      }


      if (FTUE > 6 && day_tasks.length != 0) {
        var graphics = game.add.graphics(game.camera.width / 2 - 690, game.camera.height / 2 - 304);
        graphics.beginFill(0xa39069);
        graphics.alpha = 0;
        graphics.drawRoundedRect(0, 0, 271, 60, 80);
        backcard_group.add(graphics);
        game.add.tween(graphics).to({ alpha: 0.9 }, 500, Phaser.Easing.Linear.None, true);
        var graphics = game.add.graphics(game.camera.width / 2 - 690, game.camera.height / 2 - 310);
        graphics.beginFill(0xf0e3ca);
        graphics.alpha = 0;
        graphics.drawRoundedRect(0, 0, 271, 60, 80);
        backcard_group.add(graphics);
        var day_text = game.add.text(135, 32, game.cache.getJSON('lang')['t278'][0][window.lang] + ' ' + map_n, {
          font: '38px RussoOne',
          fill: '#84342c',
          align: 'center',
        });
        day_text.anchor.setTo(0.5);
        graphics.addChild(day_text);
        game.add.tween(graphics).to({ alpha: 0.9 }, 500, Phaser.Easing.Linear.None, true);
        var gift_bar = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 - 280,
          'game_ui_atlas',
          'Gift_Bar.png',
        );
        gift_bar.anchor.setTo(0.5);
        gift_bar.alpha = 0;
        backcard_group.add(gift_bar);
        game.add.tween(gift_bar).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 50);
        var gift_bar_level = game.add.sprite(-378, -6, 'game_ui_atlas', 'Gift_Bar_Level.png');
        gift_bar_level.anchor.setTo(0, 0.5);
        let cropRect = new Phaser.Rectangle(0, 0, mission_stars_end * progress_step, gift_bar_level.height);
        gift_bar_level.crop(cropRect);
        gift_bar.addChild(gift_bar_level);
        var gift_shine = game.add.sprite(400, 0, 'game_ui_atlas', '2Gift_Shine.png');
        gift_shine.anchor.setTo(0.5);
        gift_bar.addChild(gift_shine);
        rotate_tween(gift_shine);
        var black_sprite_build = game.add.sprite(0, 0, 'message_invite_mask');
        black_sprite_build.alpha = 0;
        black_sprite_build.width = game.camera.width;
        black_sprite_build.height = game.camera.height;
        backcard_group.add(black_sprite_build);
        var gift = game.add.sprite(gift_bar.x + 400, gift_bar.y, 'game_ui_atlas', '2Gift_Bottom_Part.png');
        gift.anchor.setTo(0.5);
        gift.alpha = 0;
        backcard_group.add(gift);
        game.add.tween(gift).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 50);
        var gift_lid = game.add.sprite(0, -20, 'game_ui_atlas', '2Gift_Lid.png');
        gift_lid.anchor.setTo(0.5);
        gift.addChild(gift_lid);
        var gift_shadow = game.add.sprite(0, -14, 'game_ui_atlas', '2Gift_Ribbon_Shadow.png');
        gift_shadow.anchor.setTo(0.5);
        gift_lid.addChild(gift_shadow);
        var gift_ribbon = game.add.sprite(0, -20, 'game_ui_atlas', '2Gift_Ribbon.png');
        gift_ribbon.anchor.setTo(0.5);
        gift_lid.addChild(gift_ribbon);
        var bar_text = game.add.text(0, -5, mission_stars_end + '/' + all_day_stars, {
          font: '30px RussoOne',
          fill: '#fff',
          align: 'left',
        });
        bar_text.anchor.setTo(0, 0.5);
        bar_text.stroke = '#8C3C33';
        bar_text.strokeThickness = 4;
        gift_bar.addChild(bar_text);
        var gift_bar_star = game.add.sprite(-25, -8, 'game_ui_atlas', 'Gift_Bar_Star.png');
        gift_bar_star.anchor.setTo(0.5);
        gift_bar.addChild(gift_bar_star);
        for (i = 1; i <= 5; i++) {
          if (
            Number(game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0]['prize' + i + 'position']) != 0 &&
            day_prize[i - 1] == -1
          )
            if (
              Number(game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0]['prize' + i + 'position']) >
              mission_stars_end
            ) {
              day_prize[i - 1] = 0;
            }
          if (
            Number(game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0]['prize' + i + 'position']) != 0 &&
            day_prize[i - 1] == 0
          ) {
            var gift_icon = game.add.sprite(
              game.camera.width / 2 -
              378 +
              progress_step *
              Number(game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0]['prize' + i + 'position']),
              game.camera.height / 2 - 360 - 400,
              'game_ui_atlas',
              'Mini_Gift_BG.png',
            );
            gift_icon.anchor.setTo(0.5, 1);
            backcard_group.add(gift_icon);
            gift_icon.ip = i - 1;
            game.add.tween(gift_icon).to({ y: '+445' }, 600, Phaser.Easing.Bounce.Out, true, 100 * i);
            var rays_mini_gift = game.add.sprite(-2, -75, 'game_ui_atlas', 'Rays_Mini_Gift.png');
            rays_mini_gift.anchor.setTo(0.5);
            gift_icon.addChild(rays_mini_gift);
            rotate_tween(rays_mini_gift);
            var mini_gift = game.add.sprite(-2, -60, 'game_ui_atlas', 'Mini_Gift.png');
            mini_gift.anchor.setTo(0.5);
            gift_icon.addChild(mini_gift);
            var sparkle_mini_gift = game.add.sprite(-26, -75, 'game_ui_atlas', 'Sparkle_Mini_Gift.png');
            sparkle_mini_gift.anchor.setTo(0.5);
            sparkle_mini_gift.alpha = 0;
            sparkle_mini_gift.scale.setTo(0);
            gift_icon.addChild(sparkle_mini_gift);
            sparckEffect(sparkle_mini_gift, [-26, 26], [-75, -71]);
          }
        }
        game.setUserDataAndLog({ day_prize: JSON.stringify(day_prize) });
      } else {
      }


      function get_prize() {
        if (current_prize != 0) {
          animation = 1;
          if (current_prize == -100) {
            game.add.tween(UI_bottom_group).to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true);
            game.add
              .tween(gift)
              .to({ angle: '+6' }, 50, Phaser.Easing.Linear.None, true, 1000)
              .onComplete.add(function () {
                game.add
                  .tween(gift)
                  .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function () {
                    game.add
                      .tween(gift)
                      .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function () {
                        game.add
                          .tween(gift)
                          .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function () {
                            game.add
                              .tween(gift)
                              .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                              .onComplete.add(function () {
                                game.add
                                  .tween(gift)
                                  .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                  .onComplete.add(function () {
                                    game.add
                                      .tween(gift)
                                      .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                      .onComplete.add(function () {
                                        game.add
                                          .tween(gift)
                                          .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                          .onComplete.add(function () {
                                            game.add
                                              .tween(gift)
                                              .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                              .onComplete.add(function () {
                                                game.add
                                                  .tween(gift)
                                                  .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                                  .onComplete.add(function () {
                                                    game.add
                                                      .tween(gift)
                                                      .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                                      .onComplete.add(function () {
                                                        game.add
                                                          .tween(gift)
                                                          .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                                          .onComplete.add(function () {
                                                            game.add
                                                              .tween(gift)
                                                              .to(
                                                                { angle: '+12' },
                                                                100,
                                                                Phaser.Easing.Linear.None,
                                                                true,
                                                              )
                                                              .onComplete.add(function () {
                                                                game.add
                                                                  .tween(gift)
                                                                  .to(
                                                                    { angle: '-12' },
                                                                    100,
                                                                    Phaser.Easing.Linear.None,
                                                                    true,
                                                                  )
                                                                  .onComplete.add(function () {
                                                                    game.add
                                                                      .tween(gift)
                                                                      .to(
                                                                        { angle: '+12' },
                                                                        100,
                                                                        Phaser.Easing.Linear.None,
                                                                        true,
                                                                      )
                                                                      .onComplete.add(function () {
                                                                        game.add
                                                                          .tween(gift)
                                                                          .to(
                                                                            { angle: '-6' },
                                                                            100,
                                                                            Phaser.Easing.Linear.None,
                                                                            true,
                                                                          );
                                                                      });
                                                                  });
                                                              });
                                                          });
                                                      });
                                                  });
                                              });
                                          });
                                      });
                                  });
                              });
                          });
                      });
                  });
              });
            game.add
              .tween(gift.scale)
              .to({ x: 1.2, y: 1.2 }, 400, Phaser.Easing.Linear.None, true, 1000)
              .onComplete.add(function () {
                game.add
                  .tween(gift.scale)
                  .to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function () {
                    game.add
                      .tween(gift.scale)
                      .to({ x: 1.2, y: 1.2 }, 400, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function () {
                        game.add
                          .tween(gift.scale)
                          .to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function () {
                            game.add.tween(gift.scale).to({ x: 2.5, y: 2.5 }, 1000, Phaser.Easing.Cubic.In, true);
                            game.add.tween(black_sprite).to({ alpha: 0 }, 700, Phaser.Easing.Linear.None, true);
                            game.add.tween(black_sprite_build).to({ alpha: 0.8 }, 500, Phaser.Easing.Linear.None, true);
                            game.add.tween(gift_shine.scale).to({ x: 0, y: 0 }, 800, Phaser.Easing.Linear.None, true);
                            game.add
                              .tween(gift)
                              .to({ alpha: 1 }, 1200, Phaser.Easing.Linear.None, true)
                              .onComplete.add(function (item) {
                                let xxx = item.x;
                                let yyy = item.y;
                                item.destroy();
                                var gift = game.add.sprite(xxx, yyy + 92, 'game_ui_atlas', '2Gift_Bottom_Part.png');
                                gift.anchor.setTo(0.5, 1);
                                gift.scale.setTo(2.5);
                                backcard_group.add(gift);
                                var gift_lid = game.add.sprite(0, -63, 'game_ui_atlas', '2Gift_Lid.png');
                                gift_lid.anchor.setTo(0.5);
                                gift.addChild(gift_lid);
                                var gift_shadow = game.add.sprite(0, -14, 'game_ui_atlas', '2Gift_Ribbon_Shadow.png');
                                gift_shadow.anchor.setTo(0.5);
                                gift_lid.addChild(gift_shadow);
                                var gift_ribbon = game.add.sprite(0, -20, 'game_ui_atlas', '2Gift_Ribbon.png');
                                gift_ribbon.anchor.setTo(0.5);
                                gift_lid.addChild(gift_ribbon);
                                game.add
                                  .tween(gift.scale)
                                  .to({ y: 2.1 }, 200, Phaser.Easing.Cubic.Out, true)
                                  .onComplete.add(function () {
                                    game.add.tween(gift).to({ y: '-50' }, 200, Phaser.Easing.Cubic.In, true);
                                    game.add
                                      .tween(gift.scale)
                                      .to({ y: 2.5 }, 200, Phaser.Easing.Cubic.In, true)
                                      .onComplete.add(function () {
                                        game.add
                                          .tween(gift_lid)
                                          .to(
                                            {
                                              x: [gift_lid.x, gift_lid.x + 30, gift_lid.x + 100, gift_lid.x + 100],
                                              y: [gift_lid.y, gift_lid.y - 150, gift_lid.y - 100, gift_lid.y + 50],
                                            },
                                            600,
                                            Phaser.Easing.Cubic.Out,
                                            true,
                                          )
                                          .interpolation(function (v, k) {
                                            return Phaser.Math.bezierInterpolation(v, k);
                                          });
                                        game.add
                                          .tween(gift_lid)
                                          .to({ angle: '+360' }, 500, Phaser.Easing.Cubic.Out, true)
                                          .onComplete.add(function () {
                                            game.add
                                              .tween(backcard_group)
                                              .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true)
                                              .onComplete.add(function () {
                                                friends_group.removeAll(true);
                                                backcard_group.removeAll(true); mission_group.removeAll(true);
                                                backcard_group.alpha = 1;
                                                UI_bottom_group.removeAll(true);
                                                UI_bottom_group_create(1, 1, 1, 1, 0);
                                                UI_bottom_group.y = 400;
                                                game.add
                                                  .tween(UI_bottom_group)
                                                  .to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
                                              });
                                            let p_mas = [];
                                            for (var i = 1; i <= 12; i++) {
                                              let c = 0;
                                              for (var j = 1; j <= 3; j++) {
                                                if (
                                                  Number(
                                                    game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                    'DaySetting'
                                                    ][0]['endprize' + j + 't'],
                                                  ) == 1
                                                ) {
                                                  if (i == 1) {
                                                    c = 1;
                                                    p_mas.push(
                                                      Number(
                                                        game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                        'DaySetting'
                                                        ][0]['endprize' + j],
                                                      ),
                                                    );
                                                  }
                                                } else if (
                                                  Number(
                                                    game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                    'DaySetting'
                                                    ][0]['endprize' + j + 't'],
                                                  ) == 2
                                                ) {
                                                  /*if (i == 2)
                                    {
                                      c = 1;
                                      p_mas.push(Number(game.cache.getJSON('buildings')['Day'+String(map_n-1)][0]['DaySetting'][0]['endprize'+j]));
                                    }	*/
                                                } else if (
                                                  Number(
                                                    game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                    'DaySetting'
                                                    ][0]['endprize' + j + 't'],
                                                  ) == 3
                                                ) {
                                                  if (i == 4) {
                                                    c = 1;
                                                    p_mas.push(
                                                      Number(
                                                        game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                        'DaySetting'
                                                        ][0]['endprize' + j],
                                                      ),
                                                    );
                                                  }
                                                } else if (
                                                  Number(
                                                    game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                    'DaySetting'
                                                    ][0]['endprize' + j + 't'],
                                                  ) == 4
                                                ) {
                                                  if (i == 5) {
                                                    c = 1;
                                                    p_mas.push(
                                                      Number(
                                                        game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                        'DaySetting'
                                                        ][0]['endprize' + j],
                                                      ),
                                                    );
                                                  }
                                                } else if (
                                                  Number(
                                                    game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                    'DaySetting'
                                                    ][0]['endprize' + j + 't'],
                                                  ) == 5
                                                ) {
                                                  if (i == 3) {
                                                    c = 1;
                                                    p_mas.push(
                                                      Number(
                                                        game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                        'DaySetting'
                                                        ][0]['endprize' + j],
                                                      ),
                                                    );
                                                  }
                                                } else if (
                                                  Number(
                                                    game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                    'DaySetting'
                                                    ][0]['endprize' + j + 't'],
                                                  ) == 11
                                                ) {
                                                  if (i == 12) {
                                                    c = 1;
                                                    p_mas.push(
                                                      Number(
                                                        game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                        'DaySetting'
                                                        ][0]['endprize' + j],
                                                      ),
                                                    );
                                                  }
                                                } else if (
                                                  Number(
                                                    game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                    'DaySetting'
                                                    ][0]['endprize' + j + 't'],
                                                  ) == 8
                                                ) {
                                                  if (i == 9) {
                                                    c = 1;
                                                    p_mas.push(
                                                      Number(
                                                        game.cache.getJSON('buildings')['Day' + String(map_n - 1)][0][
                                                        'DaySetting'
                                                        ][0]['endprize' + j],
                                                      ),
                                                    );
                                                  }
                                                }
                                              }
                                              if (i == 2) {
                                                c = 1;
                                                if (Number(lifes) < 5) p_mas.push(Number(5 - Number(lifes)));
                                                else p_mas.push(Number(1));
                                              }
                                              if (c == 0) {
                                                p_mas.push(0);
                                              }
                                            }
                                            chest_open_window(
                                              game.cache.getJSON('lang')['Reward!'][0][window.lang],
                                              p_mas,
                                              52,
                                              void 0,
                                              {
                                                // gameArea: DdnaGameArea.Map,
                                                // actionType: DdnaTransactionActionType.DailyGift,
                                                gameArea: null,
                                                actionType: null,
                                              },
                                            );
                                            source_chest = 'Day compile';
                                            package_id_chest = 0;
                                          });
                                        game.add
                                          .tween(gift)
                                          .to({ y: '+50' }, 400, Phaser.Easing.Bounce.Out, true)
                                          .onComplete.add(function () {
                                            game.add
                                              .tween(gift)
                                              .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                              .onComplete.add(function () {
                                                item.destroy();
                                              });
                                          });
                                      });
                                  });
                              });
                            game.add
                              .tween(gift)
                              .to(
                                {
                                  x: [gift.x, gift.x - 100, gift.x - 200, gift.x - 400],
                                  y: [gift.y, gift.y - 100, gift.y - 50, gift.y + 500],
                                },
                                1200,
                                Phaser.Easing.Quadratic.In,
                                true,
                              )
                              .interpolation(function (v, k) {
                                return Phaser.Math.bezierInterpolation(v, k);
                              });
                          });
                      });
                  });
              });
          } else
            game.add
              .tween(current_prize.scale)
              .to({ x: 2, y: 2 }, 500, Phaser.Easing.Linear.None, true, 1000)
              .onComplete.add(function () {
                game.add
                  .tween(current_prize)
                  .to({ alpha: 0 }, 600, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                    popup = 0;
                    animation = 0;
                    missions_tab_open = 0;
                    console.log(
                      'current_prize: ',
                      current_prize.ip,
                      map_n,
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1)
                        ],
                      ),
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ),
                      [
                        Number(
                          game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                          'prize' + Number(current_prize.ip + 1)
                          ],
                        ),
                        0,
                        0,
                        0,
                        0,
                      ],
                    );
                    if (
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ) == 1
                    )
                      chest_open_window(
                        game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                        [
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + Number(current_prize.ip + 1)
                            ],
                          ),
                          0,
                          0,
                          0,
                          0,
                        ],
                        51.6,
                        void 0,
                        {
                          // gameArea: DdnaGameArea.Map,
                          // actionType: DdnaTransactionActionType.DayProgress,
                          gameArea: null,
                          actionType: null,
                        },
                      );
                    else if (
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ) == 2
                    )
                      chest_open_window(
                        game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                        [
                          0,
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + Number(current_prize.ip + 1)
                            ],
                          ),
                          0,
                          0,
                          0,
                        ],
                        51.6,
                        void 0,
                        {
                          // gameArea: DdnaGameArea.Map,
                          // actionType: DdnaTransactionActionType.DayProgress,
                          gameArea: null,
                          actionType: null,
                        },
                      );
                    else if (
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ) == 5
                    )
                      chest_open_window(
                        game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                        [
                          0,
                          0,
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + Number(current_prize.ip + 1)
                            ],
                          ),
                          0,
                          0,
                        ],
                        51.6,
                        void 0,
                        {
                          // gameArea: DdnaGameArea.Map,
                          // actionType: DdnaTransactionActionType.DayProgress,
                          gameArea: null,
                          actionType: null,
                        },
                      );
                    else if (
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ) == 3
                    )
                      chest_open_window(
                        game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                        [
                          0,
                          0,
                          0,
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + Number(current_prize.ip + 1)
                            ],
                          ),
                          0,
                        ],
                        51.6,
                        void 0,
                        {
                          // gameArea: DdnaGameArea.Map,
                          // actionType: DdnaTransactionActionType.DayProgress,
                          gameArea: null,
                          actionType: null,
                        },
                      );
                    else if (
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ) == 4
                    )
                      chest_open_window(
                        game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                        [
                          0,
                          0,
                          0,
                          0,
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + Number(current_prize.ip + 1)
                            ],
                          ),
                        ],
                        51.6,
                        void 0,
                        {
                          // gameArea: DdnaGameArea.Map,
                          // actionType: DdnaTransactionActionType.DayProgress,
                          gameArea: null,
                          actionType: null,
                        },
                      );
                    else if (
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ) == 8
                    )
                      chest_open_window(
                        game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                        [
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + Number(current_prize.ip + 1)
                            ],
                          ),
                        ],
                        51.6,
                        void 0,
                        {
                          // gameArea: DdnaGameArea.Map,
                          // actionType: DdnaTransactionActionType.DayProgress,
                          gameArea: null,
                          actionType: null,
                        },
                      );
                    else if (
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ) == 7
                    )
                      chest_open_window(
                        game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                        [
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + Number(current_prize.ip + 1)
                            ],
                          ),
                          0,
                          0,
                        ],
                        51.6,
                        void 0,
                        {
                          // gameArea: DdnaGameArea.Map,
                          // actionType: DdnaTransactionActionType.DayProgress,
                          gameArea: null,
                          actionType: null,
                        },
                      );
                    else if (
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ) == 11
                    )
                      chest_open_window(
                        game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                        [
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + Number(current_prize.ip + 1)
                            ],
                          ),
                        ],
                        51.6,
                        void 0,
                        {
                          // gameArea: DdnaGameArea.Map,
                          // actionType: DdnaTransactionActionType.DayProgress,
                          gameArea: null,
                          actionType: null,
                        },
                      );
                    else if (
                      Number(
                        game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                        'prize' + Number(current_prize.ip + 1) + 't'
                        ],
                      ) == 12
                    )
                      chest_open_window(
                        game.cache.getJSON('lang')['FREEGIFT'][0][window.lang],
                        [
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          0,
                          Number(
                            game.cache.getJSON('buildings')['Day' + map_n][0]['DaySetting'][0][
                            'prize' + Number(current_prize.ip + 1)
                            ],
                          ),
                        ],
                        51.6,
                        void 0,
                        {
                          // gameArea: DdnaGameArea.Map,
                          // actionType: DdnaTransactionActionType.DayProgress,
                          gameArea: null,
                          actionType: null,
                        },
                      );
                    source_chest = 'Day progress';
                    package_id_chest = 0;
                  });
              });
        }
      }
      indicator_system(0);
    }

    function prize_special_create(x, y, id, name, price, icon, atlas, col, bonus, pback, prize) {
      var Prizes_Background = game.add.sprite(x, y, 'special_sales_atlas', 'Prizes_Background.png');
      Prizes_Background.scale.setTo(2);
      Prizes_Background.anchor.setTo(0.5);
      pback.addChild(Prizes_Background);
      var energy_u = 0;
      if (icon[0] == 'Energy.png') {
        if (x == -270) {
          energy_u = 1;
          var Small_Offer = game.add.sprite(x, y - 120, atlas[0], 'Infinity_Symbol.png');
          Small_Offer.scale.setTo(2);
          Small_Offer.anchor.setTo(0.5);
          pback.addChild(Small_Offer);
          var Small_Offer = game.add.sprite(x, y - 120, atlas[0], icon[0]);
          Small_Offer.scale.setTo(1.5);
          Small_Offer.anchor.setTo(0.5);
          pback.addChild(Small_Offer);
          var Time = game.add.sprite(x, y + 20, atlas[0], 'Time.png');
          Time.scale.setTo(1.5);
          Time.anchor.setTo(0.5);
          pback.addChild(Time);
          var time_text = game.add.text(x + 44, y + 20, '1h', {
            font: '50px RussoOne',
            fill: '#fff',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 200,
          });
          time_text.anchor.setTo(0.5);
          time_text.lineSpacing = -10;
          time_text.stroke = '#0f6b97';
          time_text.strokeThickness = 4;
          time_text.setShadow(0, 4, 'rgba(15,107,151,0.7)', 1);
          pback.addChild(time_text);
          var Small_Offer = game.add.sprite(x - 80, y + 105, 'game_window2_atlas', 'List_Coin.png');
          Small_Offer.anchor.setTo(0.5);
          pback.addChild(Small_Offer);
          var Small_Offer_text = game.add.text(x + 40, y + 105, 'x1000', {
            font: '48px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          Small_Offer_text.anchor.setTo(0.5);
          Small_Offer_text.stroke = '#0D6A96';
          Small_Offer_text.strokeThickness = 4;
          Small_Offer_text.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
          pback.addChild(Small_Offer_text);
        } else {
          energy_u = 6;
          var Small_Offer = game.add.sprite(x, y - 120, atlas[0], 'Infinity_Symbol.png');
          Small_Offer.scale.setTo(2);
          Small_Offer.anchor.setTo(0.5);
          pback.addChild(Small_Offer);
          var Small_Offer = game.add.sprite(x, y - 120, atlas[0], icon[0]);
          Small_Offer.scale.setTo(1.5);
          Small_Offer.anchor.setTo(0.5);
          pback.addChild(Small_Offer);
          var Time = game.add.sprite(x, y + 20, atlas[0], 'Time.png');
          Time.scale.setTo(1.5);
          Time.anchor.setTo(0.5);
          pback.addChild(Time);
          var time_text = game.add.text(x + 44, y + 20, '6h', {
            font: '50px RussoOne',
            fill: '#fff',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 200,
          });
          time_text.anchor.setTo(0.5);
          time_text.lineSpacing = -10;
          time_text.stroke = '#0f6b97';
          time_text.strokeThickness = 4;
          time_text.setShadow(0, 4, 'rgba(15,107,151,0.7)', 1);
          pback.addChild(time_text);
          var Small_Offer = game.add.sprite(x - 80, y + 105, 'game_window2_atlas', 'List_Coin.png');
          Small_Offer.anchor.setTo(0.5);
          pback.addChild(Small_Offer);
          if (bought == 0)
            var Small_Offer_text = game.add.text(x + 40, y + 105, 'x2000', {
              font: '48px RussoOne',
              fill: '#fff',
              align: 'center',
            });
          else
            var Small_Offer_text = game.add.text(x + 40, y + 105, 'x4000', {
              font: '48px RussoOne',
              fill: '#fff',
              align: 'center',
            });
          Small_Offer_text.anchor.setTo(0.5);
          Small_Offer_text.stroke = '#0D6A96';
          Small_Offer_text.strokeThickness = 4;
          Small_Offer_text.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
          pback.addChild(Small_Offer_text);
        }
      } else if (icon.length == 1) {

        if (bonus.length != 0) {
          var Discount_Tag = game.add.sprite(x + 140, y - 198, 'special_sales_atlas', 'Discount_Tag.png');
          Discount_Tag.anchor.setTo(0.5);
          pback.addChild(Discount_Tag);

          var Discount_Tag_text = game.add.text(x + 185, y - 205, '+' + Math.round(100 * bonus[0] / col[0]) + '%', {
            font: '30px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          Discount_Tag_text.angle = 35;
          Discount_Tag_text.anchor.setTo(0.5);
          pback.addChild(Discount_Tag_text);
        }

        var Small_Offer = game.add.sprite(x, y - 90, atlas[0], icon[0]);
        Small_Offer.anchor.setTo(0.5);
        pback.addChild(Small_Offer);
        if (icon[0] == 'List_Joker.png') {
          Small_Offer.scale.setTo(2.5);
        }
        if (icon[0] == 'tnt_booster.png') {
          Small_Offer.scale.setTo(1.5);
        }
        if (icon[0] == 'List_Joker.png' || icon[0] == 'tnt_booster.png')
          var Small_Offer_text = game.add.text(x, y + 60, 'x' + col[0], {
            font: '48px RussoOne',
            fill: '#fff',
            align: 'center',
          });
        else {
          var p_text = game.cache.getJSON('lang')['RewardCoins'][0][window.lang];
          p_text = p_text.replace('[x]', col[0]);
          var Small_Offer_text = game.add.text(x, y + 60, p_text, {
            font: '48px RussoOne',
            fill: '#fff',
            align: 'center',
          });
        }
        Small_Offer_text.anchor.setTo(0.5);
        Small_Offer_text.stroke = '#0D6A96';
        Small_Offer_text.strokeThickness = 4;
        Small_Offer_text.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
        pback.addChild(Small_Offer_text);
        /*if (bonus.length != 0) {
          var p_text = game.cache.getJSON('lang')['RewardBonus'][0][window.lang];
          p_text = p_text.replace('[x]', bonus[0]);
          var Small_Offer_text = game.add.text(x, y + 110, p_text, {
            font: '38px RussoOne',
            fill: '#0D6A96',
            align: 'center',
          });
          Small_Offer_text.anchor.setTo(0.5);
          Small_Offer_text.stroke = '#fff';
          Small_Offer_text.strokeThickness = 4;
          pback.addChild(Small_Offer_text);
        }*/
      } else if (icon.length == 4) {
        var n = 0;
        for (var i = -1; i <= 1; i++)
          for (var j = -1; j <= 1; j++) {
            if (i != 0 && j != 0) {
              var Small_Offer = game.add.sprite(x + 100 * i, y + 80 * j - 50, atlas[n], icon[n]);
              Small_Offer.anchor.setTo(0.5);
              if (icon[n] != 'Random_Booster_Icon.png') {
                Small_Offer.scale.setTo(1.6);
              }
              pback.addChild(Small_Offer);
              var Small_Offer_text = game.add.text(x + 100 * i, y + 80 * j + 70 - 50, 'x' + col[n], {
                font: '30px RussoOne',
                fill: '#fff',
                align: 'center',
              });
              Small_Offer_text.anchor.setTo(0.5);
              Small_Offer_text.stroke = '#0D6A96';
              Small_Offer_text.strokeThickness = 4;
              Small_Offer_text.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
              pback.addChild(Small_Offer_text);
              n++;
            }
          }
      } else if (icon.length == 3) {
        var n = 0;
        for (var i = -1; i <= 1; i++)
          for (var j = -1; j <= 1; j++) {
            if ((i == 0 && j == -1) || (i == -1 && j == 1) || (i == 1 && j == 1)) {
              var Small_Offer = game.add.sprite(x + 100 * i, y + 80 * j - 50, atlas[n], icon[n]);
              Small_Offer.anchor.setTo(0.5);
              Small_Offer.scale.setTo(1.6);
              pback.addChild(Small_Offer);
              var Small_Offer_text = game.add.text(x + 100 * i, y + 80 * j + 70 - 50, 'x' + col[n], {
                font: '30px RussoOne',
                fill: '#fff',
                align: 'center',
              });
              Small_Offer_text.anchor.setTo(0.5);
              Small_Offer_text.stroke = '#0D6A96';
              Small_Offer_text.strokeThickness = 4;
              Small_Offer_text.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
              pback.addChild(Small_Offer_text);
              n++;
            }
          }
      }
      var button_green = draw_rect(x, y + 210, 408 * 0.9, 135 * 0.9, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
      draw_rect_shadow(0, 0, 374 * 0.9, 102 * 0.9, '#000', '#000', 0, 0, button_green, 500);
      draw_rect(0, 0, 374 * 0.9, 102 * 0.9, '#7ED12B', '#7ED12B', 0, 0, button_green, 0, 500, 0);
      draw_rect(0, 0, 370 * 0.9, 100 * 0.9, '#C2F33F', '#51C001', 0, 1, button_green, 0, 500, 0);
      button_animation_f(button_green, 1);
      button_green.id = id;
      button_green.nm = name;
      button_green.price = price;
      button_green.prize = prize;
      button_green.energy_u = energy_u;
      button_green.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup != 2) {
          popup = 2;
          if (fbv == 1) {
            game.setCurrentEvent();
            window.eventTrack(item.id + '_initiated');
            window.eventTrack('soga_purchase_initiated', 1, {
              package_id: item.id,
              value: item.price,
              current_level: level_button.n,
              conversion: 1 - bought,
              user_type: bought,
              lifetime: lifetime_day,
              mission_completed: missioncompleted,
              c_event: current_event,
            });
          }
          loading();
          if (animation == 100) {
            if (item.energy_u != 0) {
              if (unlimited_lifesDate == 0) {
                unlimited_lifesDate =
                  ddd == 0
                    ? new Date()
                    : new Date(
                      ddd +
                      ' ' +
                      new Date().getHours() +
                      ':' +
                      new Date().getMinutes() +
                      ':' +
                      new Date().getSeconds(),
                    );
              }
              unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() + item.energy_u);
              if (Number(lifes) < Number(max_lifes)) {
                lifes = Number(max_lifes);
              }
              if (text_lifes != 0 && typeof text_lifes !== 'undefined') text_lifes.setText(lifes);
              LifeDate = 0;
              game.setUserDataAndLog({
                lifes: String(lifes),
                life_time: String(LifeDate),
                unlimited_lifesDate: String(unlimited_lifesDate),
              });
              lifetextChange();
              if (lifes_panel_plus != 0) {
                lifes_panel_plus.destroy();
                lifes_panel_plus = 0;
              }
            }
            offer_mas.splice(0, 1);
            OfferDate = 0;
            game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas), OfferDate: String(OfferDate) });
            if (offer_icon != 0) {
              if (offer_icon.inputEnabled == true) {
                offer_icon.inputEnabled = false;
                game.add
                  .tween(offer_icon)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
                    offer_icon_timer = 0;
                    item.destroy();
                  });
              }
            }
            if (bought == 0) {
              bought_f = 1;
            }
            if (fbv == 1) {
              game.setCurrentEvent();
              window.eventTrack(item.id + '_successfull');
              window.eventTrack('soga_purchase_successfull', 1, {
                package_id: item.id,
                value: item.price,
                current_level: level_button.n,
                conversion: 1 - bought,
                first_purchase: bought_f,
                lifetime: lifetime_day,
                highest_lvl: all_level.lastIndexOf(3) + 2,
                mission_completed: missioncompleted,
                c_event: current_event,
              });
            }
            if (loading_black_sprite != 0) {
              loading_black_sprite.destroy();
              loading_black_sprite = 0;
            }
            if (loading_text != 0 && loading_text != 1) {
              loading_text.destroy();
              loading_text = 0;
            }
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (itm) {
                itm.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (itm) {
                popup_group.alpha = 1;
                bought = 1;
                bought_f = 0;
                game.setUserDataAndLog({ bought: bought });
                popup_group.removeAll(true);
                popup = 0;
                missions_tab_open = 0;
                animation = 0;
                popup_group.y -= game.camera.height;
                chest_open_window(
                  game.cache.getJSON('lang')['PurchaseSuccessful'][0][window.lang],
                  item.prize,
                  51,
                  void 0,
                  {
                    // gameArea: DdnaGameArea.Map,
                    // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                    // productId: item.id,
                    gameArea: null,
                    actionType: null,
                    productId: 0,
                  },
                );
                source_chest = 'Package';
                package_id_chest = item.id;
              });
          }
          // else
          //   purchaseAsync(
          //     {
          //       productID: item.id,
          //       developerPayload: item.name,
          //     },
          //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
          //   )
          //     .then(function (purchase) {
          //       if (item.energy_u != 0) {
          //         if (unlimited_lifesDate == 0) {
          //           unlimited_lifesDate =
          //             ddd == 0
          //               ? new Date()
          //               : new Date(
          //                 ddd +
          //                 ' ' +
          //                 new Date().getHours() +
          //                 ':' +
          //                 new Date().getMinutes() +
          //                 ':' +
          //                 new Date().getSeconds(),
          //               );
          //         }
          //         unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() + item.energy_u);
          //         if (Number(lifes) < Number(max_lifes)) {
          //           lifes = Number(max_lifes);
          //         }
          //         if (text_lifes != 0 && typeof text_lifes !== 'undefined') text_lifes.setText(lifes);
          //         LifeDate = 0;
          //         game.setUserDataAndLog({
          //           lifes: String(lifes),
          //           life_time: String(LifeDate),
          //           unlimited_lifesDate: String(unlimited_lifesDate),
          //         });
          //         lifetextChange();
          //         if (lifes_panel_plus != 0) {
          //           lifes_panel_plus.destroy();
          //           lifes_panel_plus = 0;
          //         }
          //       }
          //       offer_mas.splice(0, 1);
          //       OfferDate = 0;
          //       game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas), OfferDate: String(OfferDate) });
          //       if (offer_icon != 0) {
          //         if (offer_icon.inputEnabled == true) {
          //           offer_icon.inputEnabled = false;
          //           game.add
          //             .tween(offer_icon)
          //             .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
          //             .onComplete.add(function (item) {
          //               offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
          //               offer_icon_timer = 0;
          //               item.destroy();
          //             });
          //         }
          //       }
          //       if (bought == 0) {
          //         bought_f = 1;
          //       }
          //       if (fbv == 1) {
          //         game.setCurrentEvent();
          //         window.eventTrack(item.id + '_successfull');
          //         window.eventTrack('soga_purchase_successfull', 1, {
          //           package_id: item.id,
          //           value: item.price,
          //           current_level: level_button.n,
          //           conversion: 1 - bought,
          //           first_purchase: bought_f,
          //           lifetime: lifetime_day,
          //           highest_lvl: all_level.lastIndexOf(3) + 2,
          //           mission_completed: missioncompleted,
          //           c_event: current_event,
          //         });
          //       }
          //       if (loading_black_sprite != 0) {
          //         loading_black_sprite.destroy();
          //         loading_black_sprite = 0;
          //       }
          //       if (loading_text != 0 && loading_text != 1) {
          //         loading_text.destroy();
          //         loading_text = 0;
          //       }
          //       if (sound_on == 1) {
          //         play_sound('button_X');
          //       }
          //       game.add
          //         .tween(black_sprite)
          //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
          //         .onComplete.add(function (itm) {
          //           itm.destroy();
          //         });
          //       game.add
          //         .tween(popup_group)
          //         .to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true)
          //         .onComplete.add(function (itm) {
          //           popup_group.alpha = 1;
          //           bought = 1;
          //           bought_f = 0;
          //           game.setUserDataAndLog({ bought: bought });
          //           popup_group.removeAll(true);
          //           popup = 0;
          //           missions_tab_open = 0;
          //           animation = 0;
          //           special_timer = 0;
          //           popup_group.y -= game.camera.height;
          //           chest_open_window(
          //             game.cache.getJSON('lang')['PurchaseSuccessful'][0][window.lang],
          //             item.prize,
          //             51,
          //             void 0,
          //             {
          //               // gameArea: DdnaGameArea.Map,
          //               // actionType: DdnaTransactionActionType.RealMoneyPurchase,
          //               // productId: item.id,
          //               gameArea: null,
          //           actionType: null,
          //           productId: 0,
          //             },
          //           );
          //           source_chest = 'Package';
          //           package_id_chest = item.id;
          //         });
          //       // FBInstant.payments
          //       //   .consumePurchaseAsync(purchase['purchaseToken'])
          //       //   .then(function () {})
          //       //   .catch(function (error) {});
          //     })
          //     .catch(function (error) {
          //       if (fbv == 1) {
          //         game.setCurrentEvent();
          //         window.eventTrack('soga_purchase_failed', 1, {
          //           package_id: item.id,
          //           value: item.price,
          //           current_level: level_button.n,
          //           conversion: 1 - bought,
          //           user_type: bought,
          //           lifetime: lifetime_day,
          //           mission_completed: missioncompleted,
          //           c_event: current_event,
          //         });
          //       }
          //       if (loading_black_sprite != 0) {
          //         loading_black_sprite.destroy();
          //         loading_black_sprite = 0;
          //       }
          //       if (loading_text != 0 && loading_text != 1) {
          //         loading_text.destroy();
          //         loading_text = 0;
          //       }
          //       console.log(error);
          //       popup = 1;
          //     });
        }
      }, this);
      pback.addChild(button_green);
      var buttontimer = setInterval(function () {
        if (payments_catalog.length > 0) {
          clearInterval(buttontimer);
          var text_button_green = game.add.text(
            0,
            0,
            payments_catalog[
            payments_catalog.findIndex(function (e) {
              return e['productID'] == id;
            })
            ]['price'],
            { font: '50px RussoOne', fill: '#fff', align: 'center', wordWrap: true, wordWrapWidth: 260 },
          );
          text_button_green.anchor.setTo(0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#457310';
          text_button_green.strokeThickness = 5;
          text_button_green.setShadow(0, 5, 'rgba(69,115,16,0.7)', 1);
          button_green.addChild(text_button_green);
        }
      }, 100);
    }

    var special_timer = 0;
    function special_sales_packages(n, frm, title, level) {
      console.log(offer_mas.length, offer_mas[0], level);
      if (offer_mas.length == 0 || offer_mas[0] < 0 || level == 0) {
        popup = 1;
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        blackf();
        var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
        popup_group.add(popup_back);
        popup_back.fixedToCamera = true;
        var Pop_Up_Background = game.add.sprite(0, 0, 'special_sales_atlas', 'Pop_Up_Background.png');
        Pop_Up_Background.scale.setTo(2);
        Pop_Up_Background.anchor.setTo(0.5, 0);
        popup_back.addChild(Pop_Up_Background);
        var bn1 = 0;
        var bn2 = 0;
        var bn3 = 0;
        var bn4 = 0;
        var bn5 = 0;
        var bn6 = 0;
        if (n == 13) {
          var joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 90;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor.scale).to({ x: 0.8, y: 0.8 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor).to({ x: -300, y: 0 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 0.9, y: 0.9 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: -430, y: -150 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 0.9, y: 0.9 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: -430, y: 180 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 1.1, y: 1.1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: -490, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 90;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor.scale).to({ x: 0.8, y: 0.8 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor).to({ x: 300, y: 0 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 0.9, y: 0.9 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: 430, y: -150 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 0.9, y: 0.9 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: 430, y: 180 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 1.1, y: 1.1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: 490, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 600);
        }
        if (n == 13) {
          if (bought == 0) {
            prize_special_create(
              -270,
              -20,
              bought == 1 ? 'energy1h_2000coins_buyer' : 'energy1h_1000coins_newbuyer',
              'Energy Pack',
              '4.99 $',
              ['Energy.png'],
              ['unlimited_energy_atlas'],
              [],
              [],
              popup_back,
              [1000, 0, 0, 0, 0],
            );
            prize_special_create(
              270,
              -20,
              bought == 1 ? 'energy6h_4000coins_buyer' : 'energy6h_2000coins_newbuyer',
              'Energy Pack',
              '49.99 $',
              ['Energy.png'],
              ['unlimited_energy_atlas'],
              [],
              [],
              popup_back,
              [2000, 0, 0, 0, 0],
            );
          } else {
            prize_special_create(
              0,
              -20,
              bought == 1 ? 'energy6h_4000coins_buyer' : 'energy6h_2000coins_newbuyer',
              'Energy Pack',
              '49.99 $',
              ['Energy.png'],
              ['unlimited_energy_atlas'],
              [],
              [],
              popup_back,
              [4000, 0, 0, 0, 0],
            );
          }
        } else if (n == 1) {
          bn1 = game.rnd.integerInRange(6000 * 0.01, 6000 * 0.15);
          bn2 = game.rnd.integerInRange(4000 * 0.1, 4000 * 0.2);
          prize_special_create(
            0,
            -20,
            bought == 1 ? 'coin_special_sale_buyer_5' : 'coin_special_sale_newbuyer_5',
            'Coins Package',
            bought == 1 ? '14.99 $' : '13.99 $',
            ['Medium_Offer.png'],
            ['special_sales_atlas'],
            bought == 1 ? [6000] : [4000],
            bought == 1 ? [bn1] : [bn2],
            popup_back,
            [bought == 1 ? 6000 + bn1 : 4000 + bn2, 0, 0, 0, 0],
          );
        } else if (n == 4) {
          prize_special_create(
            0,
            -20,
            bought == 1 ? 'joker_low_package_buyer' : 'joker_low_package_newbuyer',
            'Joker Sale!',
            bought == 1 ? '3.99 $' : '2.99 $',
            ['List_Joker.png'],
            ['game_window2_atlas'],
            [5],
            [],
            popup_back,
            [0, 0, 5, 0, 0],
          );
        } else if (n == 6 || n == 8 || n == 9 || n == 10 || n == 11) {
          var Guy = game.add.sprite(420, 296, 'special_sales_atlas', 'Grandpa.png');
          Guy.scale.setTo(0);
          Guy.anchor.setTo(0.5, 1);
          game.add.tween(Guy.scale).to({ x: 2, y: 2 }, 800, Phaser.Easing.Elastic.Out, true, 500);
          popup_back.addChild(Guy);
          if (n == 6) {
            bn1 = game.rnd.integerInRange(7500 * 0.05, 7500 * 0.15);
            prize_special_create(
              0,
              -20,
              'single_coins_package_1',
              'Single Coin Package',
              '4.99 $',
              ['Medium_Offer.png'],
              ['special_sales_atlas'],
              [7500],
              [bn1],
              popup_back,
              [7500 + bn1, 0, 0, 0, 0],
            );
          } else if (n == 8) {
            bn1 = game.rnd.integerInRange(15000 * 0.05, 15000 * 0.15);
            prize_special_create(
              0,
              -20,
              'single_coins_package_2',
              'Single Coin Package',
              '10.99 $',
              ['Medium_Offer.png'],
              ['special_sales_atlas'],
              [15000],
              [bn1],
              popup_back,
              [15000 + bn1, 0, 0, 0, 0],
            );
          } else if (n == 9) {
            bn1 = game.rnd.integerInRange(30000 * 0.05, 30000 * 0.15);
            prize_special_create(
              0,
              -20,
              'single_coins_package_3',
              'Single Coin Package',
              '19.99 $',
              ['Medium_Offer.png'],
              ['special_sales_atlas'],
              [30000],
              [bn1],
              popup_back,
              [30000 + bn1, 0, 0, 0, 0],
            );
          } else if (n == 10) {
            bn1 = game.rnd.integerInRange(40000 * 0.05, 40000 * 0.15);
            prize_special_create(
              0,
              -20,
              'single_coins_package_4',
              'Single Coin Package',
              '24.99 $',
              ['Medium_Offer.png'],
              ['special_sales_atlas'],
              [40000],
              [bn1],
              popup_back,
              [40000 + bn1, 0, 0, 0, 0],
            );
          } else if (n == 11) {
            bn1 = game.rnd.integerInRange(60000 * 0.05, 60000 * 0.15);
            prize_special_create(
              0,
              -20,
              'single_coins_package_5',
              'Single Coin Package',
              '34.99 $',
              ['Medium_Offer.png'],
              ['special_sales_atlas'],
              [60000],
              [bn1],
              popup_back,
              [60000 + bn1, 0, 0, 0, 0],
            );
          }
          var Guy = game.add.sprite(-400, 296, 'special_sales_atlas', 'Grandma.png');
          Guy.scale.setTo(0);
          Guy.anchor.setTo(0.5, 1);
          game.add.tween(Guy.scale).to({ x: 2, y: 2 }, 800, Phaser.Easing.Elastic.Out, true, 500);
          popup_back.addChild(Guy);
        } else if (n == 7) {
          prize_special_create(
            0,
            -20,
            bought == 1 ? 'tnt_low_package' : 'tnt_low_package_newbuyer',
            'TNT package',
            bought == 1 ? '6.99 $' : '4.99 $',
            ['tnt_booster.png'],
            ['game_atlas'],
            [5],
            [],
            popup_back,
            [0, 0, 0, 0, 0, 5],
          );
        }
        var Coin_Package_Frame = game.add.sprite(0, 0, 'special_sales_atlas', frm + '.png');
        Coin_Package_Frame.scale.setTo(2);
        Coin_Package_Frame.anchor.setTo(0.5, 0);
        popup_back.addChild(Coin_Package_Frame);
        add_shines(Coin_Package_Frame, -1, 1);
        add_shines(Coin_Package_Frame, -1, 1);
        add_shines(Coin_Package_Frame, -1, 1);
        add_shines(Coin_Package_Frame, -1, 1);
        add_shines(Coin_Package_Frame, -1, 1);
        add_shines(Coin_Package_Frame, -1, 1);
        arc_text(title, '64px', 0, 0, 0, -370, -5, 0, popup_back, 0, 20);
        if (n == 4) {
          var joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 90;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor).to({ x: -300, y: 0 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 2.3, y: 2.3 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: -430, y: -150 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 2.3, y: 2.3 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: -430, y: 180 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 2.5, y: 2.5 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: -490, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 3, y: 3 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: -630, y: -210 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 3, y: 3 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: -630, y: 240 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 3.2, y: 3.2 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: -720, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 90;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor).to({ x: 300, y: 0 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 2.3, y: 2.3 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: 430, y: -150 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 2.3, y: 2.3 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: 430, y: 180 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 2.5, y: 2.5 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: 490, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 3, y: 3 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: 630, y: -210 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 3, y: 3 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: 630, y: 240 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_window2_atlas', 'List_Joker.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 3.2, y: 3.2 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: 720, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 700);
        } else if (n == 7) {
          var joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 90;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor.scale).to({ x: 0.8, y: 0.8 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor).to({ x: -300, y: 0 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 0.9, y: 0.9 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: -430, y: -150 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 0.9, y: 0.9 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: -430, y: 180 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 1.1, y: 1.1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: -490, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.6, y: 1.6 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: -630, y: -210 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.6, y: 1.6 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: -630, y: 240 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.8, y: 1.8 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: -720, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 90;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor.scale).to({ x: 0.8, y: 0.8 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          game.add.tween(joker_decor).to({ x: 300, y: 0 }, 500, Phaser.Easing.Cubic.Out, true, 500);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 0.9, y: 0.9 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: 430, y: -150 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 0.9, y: 0.9 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: 430, y: 180 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor.scale).to({ x: 1.1, y: 1.1 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          game.add.tween(joker_decor).to({ x: 490, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 600);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.6, y: 1.6 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: 630, y: -210 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.6, y: 1.6 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: 630, y: 240 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'game_atlas', 'tnt_booster.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.8, y: 1.8 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: 720, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 700);
        } else if (n == 13) {
          var joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.6, y: 1.6 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: -630, y: -210 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.6, y: 1.6 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: -630, y: 240 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle -= 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.8, y: 1.8 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: -720, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 50;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.6, y: 1.6 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: 630, y: -210 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 130;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.6, y: 1.6 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: 630, y: 240 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          joker_decor = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Energy.png');
          joker_decor.anchor.setTo(0.5);
          joker_decor.scale.setTo(0);
          joker_decor.angle += 100;
          joker_decor.alpha = 0;
          popup_back.addChild(joker_decor);
          game.add.tween(joker_decor).to({ alpha: 1 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor.scale).to({ x: 1.8, y: 1.8 }, 500, Phaser.Easing.Cubic.Out, true, 700);
          game.add.tween(joker_decor).to({ x: 720, y: 20 }, 500, Phaser.Easing.Cubic.Out, true, 700);
        }
        if (n == 12) {
          Pop_Up_Background.y -= Pop_Up_Background.height / 2 - 120 + 135;
          Coin_Package_Frame.y -= Pop_Up_Background.height / 2 + 135;
          bn1 = game.rnd.integerInRange(15000 * 0.01, 15000 * 0.15);
          bn2 = game.rnd.integerInRange(5000 * 0.05, 5000 * 0.2);
          prize_special_create(
            -460,
            -20,
            bought == 1 ? 'below2000coins_buyer_1' : 'below2000coins_newbuyer_1',
            'Coins Package',
            bought == 1 ? '10.99 $' : '4.99 $',
            ['Small_Offer.png'],
            ['special_sales_atlas'],
            bought == 1 ? [15000] : [5000],
            bought == 1 ? [bn1] : [bn2],
            popup_back,
            [bought == 1 ? 15000 + bn1 : 5000 + bn2, 0, 0, 0, 0],
          );
          bn3 = game.rnd.integerInRange(15000 * 0.01, 15000 * 0.15);
          bn4 = game.rnd.integerInRange(5000 * 0.05, 5000 * 0.2);
          prize_special_create(
            460,
            -20,
            bought == 1 ? 'below2000coins_buyer_2' : 'below2000coins_newbuyer_2',
            'Coins Package',
            bought == 1 ? '24.99 $' : '8.99 $',
            ['Small_Offer.png'],
            ['special_sales_atlas'],
            bought == 1 ? [45000] : [15000],
            bought == 1 ? [bn3] : [bn4],
            popup_back,
            [bought == 1 ? 45000 + bn3 : 15000 + bn4, 0, 0, 0, 0],
          );
        } else if (n == 1) {
          Pop_Up_Background.y -= Pop_Up_Background.height / 2 - 120 + 135;
          Coin_Package_Frame.y -= Pop_Up_Background.height / 2 + 135;
          bn3 = game.rnd.integerInRange(2000 * 0.01, 2000 * 0.15);
          bn4 = game.rnd.integerInRange(1000 * 0.1, 1000 * 0.2);
          prize_special_create(
            -460,
            -20,
            bought == 1 ? 'coin_special_sale_buyer_4' : 'coin_special_sale_newbuyer_4',
            'Coins Package',
            bought == 1 ? '4.99 $' : '3.99 $',
            ['Small_Offer.png'],
            ['special_sales_atlas'],
            bought == 1 ? [2000] : [1000],
            bought == 1 ? [bn3] : [bn4],
            popup_back,
            [bought == 1 ? 2000 + bn3 : 1000 + bn4, 0, 0, 0, 0],
          );
          bn5 = game.rnd.integerInRange(10000 * 0.01, 10000 * 0.15);
          bn6 = game.rnd.integerInRange(7000 * 0.1, 7000 * 0.2);
          prize_special_create(
            460,
            -20,
            bought == 1 ? 'coin_special_sale_buyer_6' : 'coin_special_sale_newbuyer_6',
            'Coins Package',
            bought == 1 ? '49.99 $' : '14.99 $',
            ['Big_Offer.png'],
            ['special_sales_atlas'],
            bought == 1 ? [10000] : [7000],
            bought == 1 ? [bn5] : [bn6],
            popup_back,
            [bought == 1 ? 10000 + bn5 : 7000 + bn6, 0, 0, 0, 0],
          );
        } else if (n == 2) {
          Pop_Up_Background.y -= Pop_Up_Background.height / 2 - 120 + 135;
          Coin_Package_Frame.y -= Pop_Up_Background.height / 2 + 135;
          prize_special_create(
            -460,
            -20,
            bought == 1 ? 'carls_package_buyer_1' : 'carls_package_newbuyer_1',
            "Carl's Package",
            bought == 1 ? '2.99 $' : '1.99 $',
            ['List_Coin.png', 'List_Joker.png', 'List_Card_Back.png', 'List_Cards.png'],
            ['game_window2_atlas', 'game_window2_atlas', 'game_window2_atlas', 'game_window2_atlas'],
            [1000, 1, 1, 3],
            [],
            popup_back,
            [1000, 0, 1, 3, 1],
          );
          prize_special_create(
            460,
            -20,
            bought == 1 ? 'carls_package_buyer_2' : 'carls_package_newbuyer_2',
            "Carl's Package",
            bought == 1 ? '4.99 $' : '3.99 $',
            ['List_Coin.png', 'List_Joker.png', 'List_Card_Back.png', 'List_Cards.png'],
            ['game_window2_atlas', 'game_window2_atlas', 'game_window2_atlas', 'game_window2_atlas'],
            [4000, 2, 2, 6],
            [],
            popup_back,
            [4000, 0, 2, 6, 2],
          );
          var Guy = game.add.sprite(-30, 264, 'char_atlas', 'Lover_Guy_Twinkling.png');
          Guy.scale.setTo(0);
          Guy.anchor.setTo(0.5, 1);
          game.add.tween(Guy.scale).to({ x: 2.1, y: 2.1 }, 800, Phaser.Easing.Elastic.Out, true, 500);
          popup_back.addChild(Guy);
        } else if (n == 3) {
          Pop_Up_Background.y -= Pop_Up_Background.height / 2 - 120 + 135;
          Coin_Package_Frame.y -= Pop_Up_Background.height / 2 + 235;
          prize_special_create(
            -460,
            -20,
            bought == 1 ? 'goodday_package_buyer_1' : 'goodday_package_newbuyer_1',
            'Good Day Package',
            bought == 1 ? '7.99 $' : '6.99 $',
            ['List_Joker.png', 'List_Coin.png', 'List_Card_Back.png'],
            ['game_window2_atlas', 'game_window2_atlas', 'game_window2_atlas'],
            [1, 6000, 3],
            [],
            popup_back,
            [6000, 0, 1, 0, 3],
          );
          prize_special_create(
            460,
            -20,
            bought == 1 ? 'goodday_package_buyer_2' : 'goodday_package_newbuyer_2',
            'Good Day Package',
            bought == 1 ? '10.99 $' : '9.99 $',
            ['List_Joker.png', 'List_Coin.png', 'List_Card_Back.png'],
            ['game_window2_atlas', 'game_window2_atlas', 'game_window2_atlas'],
            [3, 12000, 6],
            [],
            popup_back,
            [12000, 0, 3, 0, 6],
          );
          var Guy = game.add.sprite(-30, 264, 'special_sales_atlas', 'Character.png');
          Guy.scale.setTo(0);
          Guy.anchor.setTo(0.5, 1);
          game.add.tween(Guy.scale).to({ x: 2, y: 2 }, 800, Phaser.Easing.Elastic.Out, true, 500);
          popup_back.addChild(Guy);
        } else if (n == 4 || n == 6 || n == 7 || n == 8 || n == 9 || n == 10 || n == 11 || n == 13) {
          Pop_Up_Background.y -= Pop_Up_Background.height / 2 - 120 + 135;
          Coin_Package_Frame.y -= Pop_Up_Background.height / 2 + 135;
        } else if (n == 5) {
          Pop_Up_Background.y -= Pop_Up_Background.height / 2 - 120 + 135;
          Coin_Package_Frame.y -= Pop_Up_Background.height / 2 + 135;
          prize_special_create(
            -460,
            -20,
            bought == 1 ? 'random_package_buyer_1' : 'random_package_newbuyer_1',
            'Random Booster',
            bought == 1 ? '6.99 $' : '3.99 $',
            ['List_Coin.png', 'Random_Booster_Icon.png', 'Random_Booster_Icon.png', 'Random_Booster_Icon.png'],
            ['game_window2_atlas', 'special_sales_atlas', 'special_sales_atlas', 'special_sales_atlas'],
            [2000, 1, 1, 1],
            [],
            popup_back,
            get_random_change([
              [2000, 0, 1, 1, 1],
              [2000, 0, 1, 0, 1, 0, 1, 0],
              [2000, 0, 0, 0, 0, 1, 1, 1],
              [2000, 0, 0, 1, 0, 1, 0, 1],
            ]),
          );
          prize_special_create(
            460,
            -20,
            bought == 1 ? 'random_package_buyer_2' : 'random_package_newbuyer_2',
            'Random Booster',
            bought == 1 ? '9.99 $' : '6.99 $',
            ['List_Coin.png', 'Random_Booster_Icon.png', 'Random_Booster_Icon.png', 'Random_Booster_Icon.png'],
            ['game_window2_atlas', 'special_sales_atlas', 'special_sales_atlas', 'special_sales_atlas'],
            [8000, 4, 4, 4],
            [],
            popup_back,
            get_random_change([
              [8000, 0, 4, 4, 4],
              [8000, 0, 4, 0, 4, 0, 4, 0],
              [8000, 0, 0, 0, 0, 4, 4, 4],
              [8000, 0, 0, 4, 0, 4, 0, 4],
            ]),
          );
          var Guy = game.add.sprite(-30, 264, 'special_sales_atlas', 'Character.png');
          Guy.scale.setTo(0);
          Guy.anchor.setTo(0.5, 1);
          game.add.tween(Guy.scale).to({ x: 2, y: 2 }, 800, Phaser.Easing.Elastic.Out, true, 500);
          popup_back.addChild(Guy);
        }
        if (n == 3) {
          var Value = game.add.sprite(-660, -250, '');
          Value.anchor.setTo(0.5);
          Value.scale.setTo(0);
          popup_back.addChild(Value);
          game.add.tween(Value.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 500);
          var Value_Background = game.add.sprite(0, 0, 'special_sales_atlas', 'Value_Background.png');
          Value_Background.anchor.setTo(0.5);
          Value_Background.scale.setTo(2);
          Value.addChild(Value_Background);
          var Value_Background_text = game.add.text(0, 0, game.cache.getJSON('lang')['Valueof'][0][window.lang], {
            font: '26px RussoOne',
            fill: '#0D6A96',
            align: 'center',
          });
          Value_Background_text.anchor.setTo(0.5, 1);
          Value_Background_text.angle -= 20;
          Value.addChild(Value_Background_text);
          var Value_Background_text = game.add.text(0, 0, '6.99$', {
            font: '46px RussoOne',
            fill: '#0D6A96',
            align: 'center',
          });
          Value_Background_text.anchor.setTo(0.5, 0.2);
          Value_Background_text.angle -= 20;
          Value.addChild(Value_Background_text);
          var Value = game.add.sprite(660, -250, '');
          Value.anchor.setTo(0.5);
          Value.scale.setTo(0);
          popup_back.addChild(Value);
          game.add.tween(Value.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 500);
          var Value_Background = game.add.sprite(0, 0, 'special_sales_atlas', 'Value_Background.png');
          Value_Background.anchor.setTo(0.5);
          Value_Background.scale.setTo(2);
          Value.addChild(Value_Background);
          var Value_Background_text = game.add.text(0, 0, game.cache.getJSON('lang')['Valueof'][0][window.lang], {
            font: '26px RussoOne',
            fill: '#0D6A96',
            align: 'center',
          });
          Value_Background_text.anchor.setTo(0.5, 1);
          Value_Background_text.angle += 20;
          Value.addChild(Value_Background_text);
          var Value_Background_text = game.add.text(0, 0, '14.99$', {
            font: '46px RussoOne',
            fill: '#0D6A96',
            align: 'center',
          });
          Value_Background_text.anchor.setTo(0.5, 0.2);
          Value_Background_text.angle += 20;
          Value.addChild(Value_Background_text);
        } else if (n == 4 || n == 7) {
          var Value = game.add.sprite(530, -300, '');
          Value.anchor.setTo(0.5);
          Value.scale.setTo(0);
          popup_back.addChild(Value);
          game.add.tween(Value.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 500);
          var Value_Background = game.add.sprite(0, 0, 'special_sales_atlas', 'Value_Background.png');
          Value_Background.anchor.setTo(0.5);
          Value_Background.scale.setTo(2);
          Value.addChild(Value_Background);
          var Value_Background_text = game.add.text(0, 0, 'Save', {
            font: '40px RussoOne',
            fill: '#0D6A96',
            align: 'center',
          });
          Value_Background_text.anchor.setTo(0.5, 1);
          Value_Background_text.angle += 20;
          Value.addChild(Value_Background_text);
          if (n == 4)
            var Value_Background_text = game.add.text(0, 0, '30%', {
              font: '56px RussoOne',
              fill: '#0D6A96',
              align: 'center',
            });
          else
            var Value_Background_text = game.add.text(0, 0, '36%', {
              font: '56px RussoOne',
              fill: '#0D6A96',
              align: 'center',
            });
          Value_Background_text.anchor.setTo(0.5, 0.2);
          Value_Background_text.angle += 20;
          Value.addChild(Value_Background_text);
        }
        let rnd_time = '00';
        if (offer_icon == 0 && OfferDate == 0) {
          rnd_time = game.rnd.integerInRange(5, 20);
          OfferDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          OfferDate.setMinutes(OfferDate.getMinutes() + rnd_time);
          game.setUserDataAndLog({ OfferDate: String(OfferDate) });
        }
        special_timer = game.add.text(0, -278, rnd_time + ':00', {
          font: '40px RussoOne',
          fill: '#0D6A96',
          align: 'center',
        });
        special_timer.anchor.setTo(0.5);
        popup_back.addChild(special_timer);
        var popup_close = game.add.sprite(
          Pop_Up_Background.width / 2 + 50,
          -Pop_Up_Background.height / 2 - 150,
          'game_window_atlas',
          'Close_Button.png',
        );
        popup_close.anchor.setTo(0.5);
        popup_close.lv = level;
        button_animation_f(popup_close, 1);
        popup_close.events.onInputUp.add(function (item) {
          if (popup != 2) {
            popup = 2;
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (itm) {
                itm.destroy();
              });
            if (special_stage != 0 && s == 2) {
              bottom_button(0, 0, 0, UI_bottom_group, -1, 1);
            }
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function () {
                var offer_mas_n = offer_mas[0];
                if (offer_mas[0] < 0) {
                  offer_mas[0] *= -1;
                }
                game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas) });
                if (item.lv != 0 || offer_mas_n < 0) {
                  if (offer_icon == 0) {
                    if (item.lv != 0) {
                      offer_mas.push(item.lv);
                    }
                    offer_button();
                    game.setUserDataAndLog({ OfferDate: String(OfferDate), offer_mas: JSON.stringify(offer_mas) });
                  } else {
                    offer_mas.push(item.lv);
                    game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas) });
                  }
                }
                missions_tab_open = 0;
                popup_group.removeAll(true);
                popup = 0;
                animation = 0;
                popup_group.y -= game.camera.height;
                special_timer = 0;
                entryPointData_function();
              });
          }
        }, this);
        popup_back.addChild(popup_close);
        game.add
          .tween(popup_group)
          .to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function (item) { });
      } else {
        if (level != 0) {
          offer_mas.push(-level);
          game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas) });
        }
      }
    }

    function Crowbar_anim(obj) {
      var Crowbar = game.add.sprite(0, -100, 'farm_obj_atlas', 'Crowbar.png');
      Crowbar.scale.setTo(0.5);
      Crowbar.anchor.setTo(0.5);
      obj.addChild(Crowbar);
      game.add
        .tween(Crowbar)
        .to({ x: '+46', y: '+75' }, 1000, Phaser.Easing.Linear.None, true, 500)
        .onComplete.add(function () {
          game.add
            .tween(Crowbar)
            .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
            .onComplete.add(function () {
              var nail = game.add.sprite(Crowbar.x - 25, Crowbar.y + 20, 'farm_obj_atlas', 'nail.png');
              nail.scale.setTo(0.5);
              nail.anchor.setTo(0.5);
              obj.addChild(nail);
              game.add.tween(nail).to({ angle: '+360' }, 500, Phaser.Easing.Linear.None, true);
              game.add.tween(nail).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
              game.add.tween(nail).to({ y: '-50' }, 500, Phaser.Easing.Linear.None, true);
            });
          game.add
            .tween(Crowbar)
            .to({ angle: '+10' }, 300, Phaser.Easing.Exponential.Out, true, 500)
            .onComplete.add(function () {
              game.add
                .tween(Crowbar)
                .to({ angle: '-10' }, 500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  game.add
                    .tween(Crowbar)
                    .to({ x: '-35', y: '-20' }, 1000, Phaser.Easing.Linear.None, true, 500)
                    .onComplete.add(function () {
                      game.add
                        .tween(Crowbar)
                        .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          var nail = game.add.sprite(Crowbar.x - 25, Crowbar.y + 20, 'farm_obj_atlas', 'nail.png');
                          nail.scale.setTo(0.5);
                          nail.anchor.setTo(0.5);
                          obj.addChild(nail);
                          game.add.tween(nail).to({ angle: '+360' }, 500, Phaser.Easing.Linear.None, true);
                          game.add.tween(nail).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
                          game.add.tween(nail).to({ y: '-50' }, 500, Phaser.Easing.Linear.None, true);
                        });
                      game.add
                        .tween(Crowbar)
                        .to({ angle: '+10' }, 300, Phaser.Easing.Exponential.Out, true, 500)
                        .onComplete.add(function () {
                          game.add
                            .tween(Crowbar)
                            .to({ angle: '-10' }, 500, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function () {
                              game.add
                                .tween(Crowbar)
                                .to({ x: '-25', y: '+12' }, 1000, Phaser.Easing.Linear.None, true, 500)
                                .onComplete.add(function () {
                                  game.add
                                    .tween(Crowbar)
                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                                    .onComplete.add(function () {
                                      var nail = game.add.sprite(
                                        Crowbar.x - 25,
                                        Crowbar.y + 20,
                                        'farm_obj_atlas',
                                        'nail.png',
                                      );
                                      nail.scale.setTo(0.5);
                                      nail.anchor.setTo(0.5);
                                      obj.addChild(nail);
                                      game.add.tween(nail).to({ angle: '+360' }, 500, Phaser.Easing.Linear.None, true);
                                      game.add.tween(nail).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
                                      game.add.tween(nail).to({ y: '-50' }, 500, Phaser.Easing.Linear.None, true);
                                    });
                                  game.add
                                    .tween(Crowbar)
                                    .to({ angle: '+10' }, 300, Phaser.Easing.Exponential.Out, true, 500)
                                    .onComplete.add(function () {
                                      game.add
                                        .tween(Crowbar)
                                        .to({ angle: '-10' }, 500, Phaser.Easing.Linear.None, true)
                                        .onComplete.add(function () {
                                          game.add
                                            .tween(Crowbar)
                                            .to({ x: '+42', y: '+20' }, 1000, Phaser.Easing.Linear.None, true, 500)
                                            .onComplete.add(function () {
                                              game.add
                                                .tween(Crowbar)
                                                .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                                                .onComplete.add(function () {
                                                  var nail = game.add.sprite(
                                                    Crowbar.x - 25,
                                                    Crowbar.y + 20,
                                                    'farm_obj_atlas',
                                                    'nail.png',
                                                  );
                                                  nail.scale.setTo(0.5);
                                                  nail.anchor.setTo(0.5);
                                                  obj.addChild(nail);
                                                  game.add
                                                    .tween(nail)
                                                    .to({ angle: '+360' }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(nail)
                                                    .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(nail)
                                                    .to({ y: '-50' }, 500, Phaser.Easing.Linear.None, true);
                                                });
                                              game.add
                                                .tween(Crowbar)
                                                .to({ angle: '+10' }, 300, Phaser.Easing.Exponential.Out, true, 500)
                                                .onComplete.add(function () {
                                                  game.add
                                                    .tween(Crowbar)
                                                    .to({ angle: '-10' }, 500, Phaser.Easing.Linear.None, true)
                                                    .onComplete.add(function () {
                                                      game.add
                                                        .tween(Crowbar)
                                                        .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 500);
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    }

    function dog_eat_anim(obj) {
      animation = 1;
      var child_item_1 = 0;
      objects_group.children.some(function (child_item2) {
        if (Math.abs(child_item2.type) == 127) {
          child_item_1 = child_item2;
          return true;
        }
      });
      game.add.tween(child_item_1).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 500);
      var food_full = game.add.sprite(obj.x, obj.y, 'farm_obj_c_atlas', 'Bowl_Food_1.png');
      food_full.anchor.setTo(0.5);
      food_full.alpha = 0;
      food_full.scale.setTo(2.9);
      objects_group.add(food_full);
      game.add.tween(food_full).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000);
      game.add.tween(obj).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 1000);
      var food_dog = game.add.sprite(obj.x, obj.y, 'farm_obj_c_atlas', 'DogEatting1.png');
      food_dog.anchor.setTo(0.1, 1.05);
      food_dog.alpha = 0;
      food_dog.scale.setTo(2.9);
      objects_group.add(food_dog);
      food_dog.animations.add(
        'DogEatting',
        ['DogEatting1.png', 'DogEatting2.png', 'DogEatting3.png', 'DogEatting4.png'],
        5,
        true,
      );
      food_dog.animations.play('DogEatting');
      game.add
        .tween(food_dog)
        .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1500)
        .onComplete.add(function () {
          game.add.tween(food_full).to({ alpha: 0 }, 2500, Phaser.Easing.Linear.None, true, 2000);
          game.add
            .tween(obj)
            .to({ alpha: 1 }, 2500, Phaser.Easing.Linear.None, true, 2000)
            .onComplete.add(function () {
              game.add.tween(child_item_1).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 500);
              game.add.tween(food_dog).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
            });
        });
    }

    function magnifying_glass_anim(obj, s, h) {
      var magnifying_glass = game.add.sprite(
        obj.x * worldScale,
        obj.y * worldScale,
        'farm_obj_atlas',
        'magnifying_glass.png',
      );
      if (h == 1) { magnifying_glass.y -= 40 * worldScale; magnifying_glass.x -= 10 * worldScale; }
      magnifying_glass.alpha = 0;
      magnifying_glass.scale.setTo(3 * worldScale);
      magnifying_glass.anchor.setTo(0.5);
      game.add
        .tween(magnifying_glass.scale)
        .to({ x: 1 * worldScale, y: 1 * worldScale }, 500, Phaser.Easing.Linear.None, true);
      game.add
        .tween(magnifying_glass)
        .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
        .onComplete.add(function () {
          game.add
            .tween(magnifying_glass)
            .to(
              { x: '-' + String(s * worldScale), y: '-' + String(s / 2 * worldScale) },
              500,
              Phaser.Easing.Linear.None,
              true,
              500,
            )
            .onComplete.add(function () {
              game.add
                .tween(magnifying_glass)
                .to({ y: '+' + String(s * worldScale) }, 500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  game.add
                    .tween(magnifying_glass)
                    .to(
                      { x: '+' + String(s * 2 * worldScale), y: '-' + String(s * worldScale) },
                      1000,
                      Phaser.Easing.Linear.None,
                      true,
                    )
                    .onComplete.add(function () {
                      game.add
                        .tween(magnifying_glass)
                        .to({ y: '+' + String(s * worldScale) }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          game.add
                            .tween(magnifying_glass)
                            .to(
                              { x: '-' + String(s * worldScale), y: '-' + String(s / 2 * worldScale) },
                              500,
                              Phaser.Easing.Linear.None,
                              true,
                            )
                            .onComplete.add(function () {
                              game.add
                                .tween(magnifying_glass)
                                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function (item) {
                                  item.destroy();
                                });
                            });
                        });
                    });
                });
            });
        });
    }

    function stik_anim(obj) {
      var stik = game.add.sprite(obj.x * worldScale, obj.y * worldScale, 'farm_obj_atlas', 'Stick.png');
      stik.alpha = 0;
      stik.scale.setTo(1.5 * worldScale);
      stik.anchor.setTo(1, 0.5);
      game.add
        .tween(stik)
        .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
        .onComplete.add(function () {
          game.add
            .tween(stik)
            .to({ angle: '+10' }, 250, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function () {
              game.add
                .tween(stik)
                .to({ angle: '-20' }, 500, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function () {
                  game.add
                    .tween(stik)
                    .to({ angle: '+20' }, 500, Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function () {
                      game.add
                        .tween(stik)
                        .to({ angle: '-20' }, 500, Phaser.Easing.Cubic.Out, true)
                        .onComplete.add(function () {
                          stik.destroy();
                        });
                    });
                });
            });
        });
    }

    function broom_stick_anim(obj) {
      var emitter_smoke_h = game.add.emitter(0, 0, 50);
      emitter_smoke_h.makeParticles('game_atlas', 'smoke.png');
      emitter_smoke_h.bringToTop = true;
      emitter_smoke_h.setRotation(0, 360, 500);
      emitter_smoke_h.setAlpha(0.4, 0, 500);
      emitter_smoke_h.setScale(0.1, 0.4, 0.1, 0.4, 500);
      emitter_smoke_h.gravity = 90;
      emitter_smoke_h.explode = true;
      emitter_smoke_h.blendMode = 3;
      emitter_smoke_h.minParticleSpeed.set(-100, -100);
      emitter_smoke_h.maxParticleSpeed.set(100, 100);
      var broom_stick = game.add.sprite(
        obj.x * worldScale,
        obj.y * worldScale - 250 * worldScale,
        'farm_obj_atlas',
        'Broom_stick.png',
      );
      broom_stick.alpha = 0;
      broom_stick.scale.setTo(1.5 * worldScale);
      broom_stick.anchor.setTo(0.5);
      emitter_smoke_h.x = obj.x * worldScale;
      emitter_smoke_h.y = obj.y * worldScale + broom_stick.height / 2 - 150 * worldScale;
      game.add.tween(broom_stick).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
      game.add
        .tween(broom_stick)
        .to({ y: '+' + String(100 * worldScale) }, 500, Phaser.Easing.Linear.None, true)
        .onComplete.add(function () {
          emitter_smoke_h.start(true, 400, 0, 12);
          game.add
            .tween(broom_stick)
            .to({ angle: '+10' }, 250, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function () {
              emitter_smoke_h.start(true, 400, 0, 12);
              game.add
                .tween(broom_stick)
                .to({ angle: '-20' }, 500, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function () {
                  emitter_smoke_h.start(true, 400, 0, 12);
                  game.add
                    .tween(broom_stick)
                    .to({ angle: '+20' }, 500, Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function () {
                      emitter_smoke_h.start(true, 400, 0, 12);
                      game.add
                        .tween(broom_stick)
                        .to({ angle: '-20' }, 500, Phaser.Easing.Cubic.Out, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                          emitter_smoke_h.destroy();
                        });
                    });
                });
            });
        });
    }

    function hummer17_anim(obj) {
      var hummer17 = game.add.sprite(obj.x * worldScale, obj.y * worldScale, 'day17_atlas', 'Hammer_00000.png');
      hummer17.anchor.setTo(0.5);
      hummer17.scale.setTo(2 * worldScale);
      objects_group.add(hummer17);

      var anim = [];

      for (i = 0; i <= 70; i += 2) {
        let ii = i;
        if (i < 10) { ii = '0' + i; }
        anim.push('Hammer_000' + ii + '.png');
      }

      var animcrowbar = hummer17.animations.add(
        'hummer17',
        anim,
        10,
        false,
      );
      hummer17.animations.play('hummer17');

      animcrowbar.onComplete.add(function () {
        game.add.tween(hummer17.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
          hummer17.destroy();
        });
      }, this);
    }

    function flex_anim(obj) {

      obj.loadTexture('farm_obj_c_atlas', 'Safe_Engraved.png');

      var flex = game.add.sprite(obj.x * worldScale - 12 * worldScale, obj.y * worldScale + 12 * worldScale, 'day17_atlas', 'Pre-comp 2_00000.png');
      flex.anchor.setTo(0.5);
      flex.scale.setTo(2 * worldScale);
      objects_group.add(flex);

      var anim = [];

      for (i = 0; i <= 104; i += 2) {
        let ii = i;
        if (i < 10) { ii = '00' + i; } else if (i < 100) { ii = '0' + i; }
        anim.push('Pre-comp 2_00' + ii + '.png');
      }

      var animcrowbar = flex.animations.add(
        'flex',
        anim,
        10,
        false,
      );
      flex.animations.play('flex');

      animcrowbar.onComplete.add(function () {
        game.add.tween(flex.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
          flex.destroy();
          dialog_window(277, 0);
        });
      }, this);
    }

    function crowbar17_anim(obj) {
      var crowbar = game.add.sprite(obj.x * worldScale * worldScale, obj.y * worldScale * worldScale, 'day17_atlas', 'Pre-comp 1_00000.png');
      crowbar.anchor.setTo(0.5);
      crowbar.scale.setTo(2 * worldScale);
      objects_group.add(crowbar);

      var anim = [];

      for (i = 0; i <= 68; i += 2) {
        let ii = i;
        if (i < 10) { ii = '0' + i; }
        anim.push('Pre-comp 1_000' + ii + '.png');
      }

      var animcrowbar = crowbar.animations.add(
        'crowbar',
        anim,
        10,
        false,
      );
      crowbar.animations.play('crowbar');

      animcrowbar.onComplete.add(function () {
        game.add.tween(crowbar.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
          crowbar.destroy();
        });
      }, this);
    }

    function hummer_anim2(obj) {
      var hammer = game.add.sprite(
        obj.x * worldScale + 50 * worldScale,
        obj.y * worldScale + 50 * worldScale,
        'farm_obj_atlas',
        'hammer.png',
      );
      hammer.anchor.setTo(0.7);
      hammer.scale.setTo(3);
      hammer.alpha = 0;
      game.add.tween(hammer.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
      game.add
        .tween(hammer)
        .to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          game.add
            .tween(item)
            .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add
                .tween(item)
                .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(item)
                    .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      game.add
                        .tween(item)
                        .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(item)
                            .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function (item) {
                              game.add
                                .tween(item)
                                .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function (item) {
                                  game.add
                                    .tween(item)
                                    .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
                                    .onComplete.add(function (item) {
                                      game.add
                                        .tween(item)
                                        .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                                        .onComplete.add(function (item) {
                                          game.add
                                            .tween(item)
                                            .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
                                            .onComplete.add(function (item) {
                                              game.add
                                                .tween(item)
                                                .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                                                .onComplete.add(function (item) {
                                                  game.add
                                                    .tween(item)
                                                    .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
                                                    .onComplete.add(function (item) {
                                                      game.add
                                                        .tween(item)
                                                        .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                                                        .onComplete.add(function (item) {
                                                          game.add
                                                            .tween(item)
                                                            .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
                                                            .onComplete.add(function (item) {
                                                              game.add
                                                                .tween(item)
                                                                .to(
                                                                  { angle: '-30' },
                                                                  50,
                                                                  Phaser.Easing.Linear.None,
                                                                  true,
                                                                )
                                                                .onComplete.add(function (item) {
                                                                  game.add
                                                                    .tween(item)
                                                                    .to(
                                                                      { angle: '+30' },
                                                                      150,
                                                                      Phaser.Easing.Linear.None,
                                                                      true,
                                                                    )
                                                                    .onComplete.add(function (item) {
                                                                      game.add
                                                                        .tween(item)
                                                                        .to(
                                                                          { angle: '-30' },
                                                                          50,
                                                                          Phaser.Easing.Linear.None,
                                                                          true,
                                                                        )
                                                                        .onComplete.add(function (item) {
                                                                          game.add
                                                                            .tween(item)
                                                                            .to(
                                                                              { angle: '+30' },
                                                                              150,
                                                                              Phaser.Easing.Linear.None,
                                                                              true,
                                                                            )
                                                                            .onComplete.add(function (item) {
                                                                              game.add
                                                                                .tween(item)
                                                                                .to(
                                                                                  { angle: '-30' },
                                                                                  50,
                                                                                  Phaser.Easing.Linear.None,
                                                                                  true,
                                                                                )
                                                                                .onComplete.add(function (item) {
                                                                                  game.add
                                                                                    .tween(hammer.scale)
                                                                                    .to(
                                                                                      { x: 3, y: 3 },
                                                                                      400,
                                                                                      Phaser.Easing.Linear.None,
                                                                                      true,
                                                                                    );
                                                                                  game.add
                                                                                    .tween(item)
                                                                                    .to(
                                                                                      { alpha: 0 },
                                                                                      400,
                                                                                      Phaser.Easing.Linear.None,
                                                                                      true,
                                                                                    )
                                                                                    .onComplete.add(function (item) {
                                                                                      item.destroy();
                                                                                    });
                                                                                });
                                                                            });
                                                                        });
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    }

    function hummer_anim(obj) {
      var emitter_smoke_h = game.add.emitter(0, 0, 50);
      emitter_smoke_h.makeParticles('game_atlas', 'smoke.png');
      emitter_smoke_h.bringToTop = true;
      emitter_smoke_h.setRotation(0, 360, 500);
      emitter_smoke_h.setAlpha(1, 0, 500);
      emitter_smoke_h.setScale(0.1, 1, 0.1, 1, 500);
      emitter_smoke_h.gravity = 0;
      emitter_smoke_h.explode = true;
      emitter_smoke_h.blendMode = 1;
      emitter_smoke_h.minParticleSpeed.set(-500, -500);
      emitter_smoke_h.maxParticleSpeed.set(500, 500);
      emitter_smoke_h.x = obj.x * worldScale;
      emitter_smoke_h.y = obj.y * worldScale;
      var hammer = game.add.sprite(
        obj.x * worldScale + 50 * worldScale,
        obj.y * worldScale + 50 * worldScale,
        'farm_obj_atlas',
        'hammer.png',
      );
      hammer.anchor.setTo(0.7);
      hammer.scale.setTo(3);
      hammer.alpha = 0;
      game.add.tween(hammer.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
      game.add
        .tween(hammer)
        .to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          game.add
            .tween(item)
            .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add
                .tween(item)
                .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  emitter_smoke_h.start(true, 200, 0, 6);
                  game.add
                    .tween(item)
                    .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      game.add
                        .tween(item)
                        .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          emitter_smoke_h.start(true, 200, 0, 6);
                          game.add
                            .tween(item)
                            .to({ angle: '+30' }, 150, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function (item) {
                              game.add
                                .tween(item)
                                .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function (item) {
                                  emitter_smoke_h.start(true, 200, 0, 6);
                                  game.add.tween(hammer.scale).to({ x: 3, y: 3 }, 400, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(item)
                                    .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true)
                                    .onComplete.add(function (item) {
                                      item.destroy();
                                      emitter_smoke_h.destroy();
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
      if (obj.type == 24) {
        if (obj.frameName == 'c_border_1.png') {
          emitter_smoke_h.x -= 180 * worldScale;
          hammer.x -= 180 * worldScale;
          emitter_smoke_h.y += 60 * worldScale;
          hammer.y += 60 * worldScale;
        } else if (obj.frameName == 'c_border_6.png') {
          emitter_smoke_h.x -= 100 * worldScale;
          hammer.x -= 100 * worldScale;
          emitter_smoke_h.y -= 50 * worldScale;
          hammer.y -= 50 * worldScale;
        } else if (obj.frameName == 'c_border_2.png') {
          emitter_smoke_h.x -= 100 * worldScale;
          hammer.x -= 100 * worldScale;
          emitter_smoke_h.y -= 50 * worldScale;
          hammer.y -= 50 * worldScale;
        }
      }
    }

    function object_change(obj, iii) {
      animation = 1;
      var aud = 0;
      objects_group.children.some(function (child_item2) {
        if (child_item2.type == day_tasks[iii]['type'] && child_item2.act == 2) {
          if (
            child_item2.type == 103 ||
            child_item2.type == 104 ||
            child_item2.type == 105 ||
            child_item2.type == 106
          ) {
            game.add
              .tween(child_item2)
              .to({ alpha: 0 }, 4200, Phaser.Easing.Linear.None, true, 300)
              .onComplete.add(function (item) {
                item.destroy(true);
              });
          } else {
            game.add
              .tween(child_item2)
              .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 300)
              .onComplete.add(function (item) {
                item.destroy(true);
              });
          }
          if (obj.length == 1) return true;
        }
      });
      object_create(obj, iii, 1);
    }

    var compl = 0;
    var emitter_smoke2 = 0;
    function object_create(obj, iii, t) {
      emitter_smoke2 = 0;
      depth_border = 0.001;
      animation = 1;
      var aud = 0;
      compl = 0;

      if (day_tasks[iii]['type'] == 184) {
        var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(109)) }));
        if (typeof new_options[tp] !== 'undefined') {
          new_options.push({ type: -184, num: new_options[tp]['num'] });
          game.setUserDataAndLog({ new_options: JSON.stringify(new_options) });
        }
      }

      if (day_tasks[iii]['type'] == 29) {
        complete_task_spec = 0;
      }
      if (day_tasks[iii]['type'] == 152) {
        game.add.tween(waterpump).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
      }
      let index = [];
      index.push(
        act1_array.findIndex(function (e) {
          return e['type'] == day_tasks[iii]['type'];
        }),
      );
      if ((act1_array[index[0]]['type'] == 18 || act1_array[index[0]]['type'] == 133 || act1_array[index[0]]['type'] == 149) && emitter_smoke2 == 0) {
        emitter_smoke2 = game.add.emitter(0, 0, 50);
        emitter_smoke2.makeParticles('game_atlas', 'smoke.png');
        emitter_smoke2.width = 150;
        emitter_smoke2.height = 100;
        emitter_smoke2.bringToTop = true;
        emitter_smoke2.setRotation(0, 360, 500);
        emitter_smoke2.setAlpha(1, 0, 4000);
        emitter_smoke2.setScale(0.5, 3, 0.5, 3, 4000);
        emitter_smoke2.gravity = 0;
        emitter_smoke2.minParticleSpeed.set(-50, -50);
        emitter_smoke2.maxParticleSpeed.set(50, 50);
        emitter_smoke2.explode = true;
        emitter_smoke2.blendMode = 3;
        emitter_smoke2.x = act1_array[index[0]]['xxx'] * 1.2 * worldScale;
        emitter_smoke2.y = (act1_array[index[0]]['yyy'] * 1.2 + 304) * worldScale;
        emitter_smoke2.start(false, 5000, 100);
      }
      for (var i = obj.length - 1; i >= 0; i--) {
        if (t == 1) {
          act1_array[obj[i]]['sprite'] = act1_array[obj[i]]['change'];
          if (day_tasks[iii]['type'] != 71 && day_tasks[iii]['type'] != 87 && day_tasks[iii]['type'] != 166) {
            act1_array[obj[i]]['atlas'] = 'farm_obj_c_atlas';
          } else {
            act1_array[obj[i]]['atlas'] = 'farm_obj_atlas';
          }
          act1_array[obj[i]]['xxx'] = act1_array[obj[i]]['change_x'];
          act1_array[obj[i]]['yyy'] = act1_array[obj[i]]['change_y'];
        }
        tile = game.add.sprite(
          Number(act1_array[obj[i]]['xxx']) * 1.2,
          Number(act1_array[obj[i]]['yyy']) * 1.2 + 304,
          act1_array[obj[i]]['atlas'],
          act1_array[obj[i]]['sprite'] + '.png',
        );
        tile.anchor.setTo(0.5);
        tile.scale.setTo(2.9);
        tile.depth = -1 * act1_array[obj[i]]['zzz'];
        if (
          tile.frameName == 'border_1.png' ||
          tile.frameName == 'border_2.png' ||
          tile.frameName == 'borderL_1.png' ||
          tile.frameName == 'borderL_2.png' ||
          tile.frameName == 'borderL_3.png' ||
          tile.frameName == 'borderL_4.png' ||
          tile.frameName == 'borderL_5.png' ||
          tile.frameName == 'borderR_1.png' ||
          tile.frameName == 'borderR_2.png' ||
          tile.frameName == 'borderR_3.png' ||
          tile.frameName == 'borderR_4.png' ||
          tile.frameName == 'borderR_5.png' ||
          tile.frameName == 'FenceA_1.png' ||
          tile.frameName == 'FenceB_1.png' ||
          tile.frameName == 'FenceD_1.png'
        ) {
          tile.depth -= depth_border;
          depth_border += 0.001;
        }
        if (Math.abs(act1_array[obj[i]]['type']) == 128) {
          tile.tint = 0x889699;
        }
        tile.type = -1 * act1_array[obj[i]]['type'];
        tile.alpha = 0;
        tile.iii = iii + 1;
        tile.ni = act1_array[obj[i]]['iii'];
        objects_group.add(tile);
        objects_group.sort('depth', Phaser.Group.SORT_ASCENDING);
        objects_group.sort('depth', Phaser.Group.SORT_ASCENDING);
        objects_group.sort('depth', Phaser.Group.SORT_ASCENDING);
        if (
          Math.abs(tile.type) == 7 ||
          Math.abs(tile.type) == 5 ||
          Math.abs(tile.type) == 4 ||
          Math.abs(tile.type) == 33 ||
          Math.abs(tile.type) == 6 ||
          Math.abs(tile.type) == 11 ||
          Math.abs(tile.type) == 12 ||
          Math.abs(tile.type) == 10 ||
          Math.abs(tile.type) == 30 ||
          Math.abs(tile.type) == 16 ||
          Math.abs(tile.type) == 4 ||
          Math.abs(tile.type) == 18 ||
          Math.abs(tile.type) == 26 ||
          Math.abs(tile.type) == 35 ||
          Math.abs(tile.type) == 47 ||
          Math.abs(tile.type) == 63 ||
          Math.abs(tile.type) == 58
        ) {
          if (sound_on == 1 && aud == 0) {
            aud = 1;
            play_sound('Something_is_constructed');
          }
        } else if (Math.abs(tile.type) == 8 || Math.abs(tile.type) == 9) {
          if (sound_on == 1 && aud == 0) {
            aud = 1;
            play_sound('remove_bushes');
          }
        } else if (
          Math.abs(tile.type) == 34 ||
          Math.abs(tile.type) == 9 ||
          Math.abs(tile.type) == 32 ||
          Math.abs(tile.type) == 15 ||
          Math.abs(tile.type) == 14 ||
          Math.abs(tile.type) == 24 ||
          Math.abs(tile.type) == 25 ||
          Math.abs(tile.type) == 27 ||
          Math.abs(tile.type) == 28 ||
          Math.abs(tile.type) == 29 ||
          Math.abs(tile.type) == 59 ||
          Math.abs(tile.type) == 40 ||
          Math.abs(tile.type) == 43 ||
          Math.abs(tile.type) == 46 ||
          Math.abs(tile.type) == 49 ||
          Math.abs(tile.type) == 50 ||
          Math.abs(tile.type) == 51 ||
          Math.abs(tile.type) == 53 ||
          Math.abs(tile.type) == 54 ||
          Math.abs(tile.type) == 61 ||
          Math.abs(tile.type) == 55 ||
          Math.abs(tile.type) == 57 ||
          Math.abs(tile.type) == 109 ||
          Math.abs(tile.type) == 184
        ) {
          if (sound_on == 1 && aud == 0) {
            aud = 1;
            play_sound('Construction_Fast');
          }
        }
        if (act1_array[obj[i]]['change'] == 'e_tree_1') {
          tile.type = 515;
          tile.inputEnabled = true;
        }

        if (tile.type == 127 || tile.type == -127) {
          var doghead = game.add.sprite(0, -10, 'farm_obj_c_atlas', 'Head1.png');
          doghead.anchor.setTo(0.5);
          tile.addChild(doghead);
          doghead.animations.add(
            'doghead',
            [
              'Head1.png',
              'Head2.png',
              'Head3.png',
              'Head4.png',
              'Head5.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
              'Head6.png',
              'Head7.png',
              'Head8.png',
            ],
            6,
            true,
          );
          doghead.animations.play('doghead');
          var DogSleeping = game.add.sprite(-12, 8, 'farm_obj_c_atlas', 'DogSleeping.png');
          DogSleeping.anchor.setTo(0, 1);
          DogSleeping.alpha = 0;
          tile.addChild(DogSleeping);
          var DogSleepingZ = game.add.sprite(20, -24, 'farm_obj_c_atlas', 'DogSleepingZ.png');
          DogSleepingZ.anchor.setTo(1, 1);
          DogSleepingZ.scale.setTo(0);
          DogSleepingZ.alpha = 1;
          DogSleeping.addChild(DogSleepingZ);
          game.add.tween(DogSleepingZ.scale).to({ x: 1, y: 1 }, 1500, Phaser.Easing.Linear.None, true, 0, -1).loop(true);
          game.add.tween(DogSleepingZ).to({ alpha: 0 }, 1500, Phaser.Easing.Cubic.In, true, 0, -1).loop(true);
          scale_tween(DogSleeping, 1500, 0.05, 0.05, -1);
          dog_sleep(doghead, DogSleeping);
        } else if (tile.type == 39 || tile.type == -39) {
          if (f_water != 0) {
            f_water.destroy();
          }
          objects_group.children.some(function (child_item2) {
            if (child_item2.type == 35 || child_item2.type == -35) {
              var numEl = parseInt(child_item2.frameName.match(/\d(?=\D*$)/));
              tile.loadTexture('farm_obj_c_atlas', 'fountane_full_' + numEl + '.png', 1);
              tile.x -=
                Number(game.cache.getJSON('buildings')['Special'][0]['Special' + Math.abs(tile.type)][0]['x' + 1]) *
                1.2;
              tile.y -=
                Number(game.cache.getJSON('buildings')['Special'][0]['Special' + Math.abs(tile.type)][0]['y' + 1]) *
                1.2 +
                320 -
                16;
              tile.x +=
                Number(game.cache.getJSON('buildings')['Special'][0]['Special' + Math.abs(tile.type)][0]['x' + numEl]) *
                1.2;
              tile.y +=
                Number(game.cache.getJSON('buildings')['Special'][0]['Special' + Math.abs(tile.type)][0]['y' + numEl]) *
                1.2 +
                320 -
                16;
              game.add
                .tween(child_item2)
                .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 300)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              special_object.push(Number(39 + '' + numEl + '' + 1));
              map_tiled_st.push({ i: 39, s: Number(numEl) });
              game.setUserDataAndLog({
                special_object: JSON.stringify(special_object),
                map_tiled_st: JSON.stringify(map_tiled_st),
              });
              if (numEl != 7) {
                var fountane_full = game.add.sprite(tile.x, tile.y, 'farm_obj_c_atlas', 'ff' + numEl + '_0.png');
                fountane_full.scale.setTo(2.9);
                fountane_full.anchor.setTo(0.5);
                fountane_full.depth = tile.depth;
                objects_group.add(fountane_full);
                fountane_full.animations.add(
                  'fountane_full',
                  [
                    'ff' + numEl + '_0.png',
                    'ff' + numEl + '_1.png',
                    'ff' + numEl + '_2.png',
                    'ff' + numEl + '_3.png',
                    'ff' + numEl + '_4.png',
                  ],
                  6,
                  true,
                );
                fountane_full.animations.play('fountane_full');
              } else {
                var fountane_full = game.add.sprite(tile.x, tile.y, 'farm_obj_c_atlas', 'fountane_full_' + numEl + '.png');
                fountane_full.scale.setTo(2.9);
                fountane_full.anchor.setTo(0.5);
                fountane_full.depth = tile.depth;
                objects_group.add(fountane_full);
              }
              tile.fount = fountane_full;
              return true;
            }
          });
        } else if (act1_array[obj[i]]['sprite'] == 'many_leaves') {
          tile.scale.setTo(0);
          tile.type = 84;
          tile.act = 0;
        } else if (Math.abs(tile.type) == 48) {
          tile.scale.setTo(1);
          var wing2_s = game.add.sprite(0, 0, 'farm_obj_c_atlas', 'wing2_s.png');
          wing2_s.anchor.setTo(0.5);
          tile.addChild(wing2_s);
          game.add
            .tween(tile)
            .to({ x: '+0', y: '-20' }, game.rnd.integerInRange(1000, 2000), Phaser.Easing.Linear.None, true, 0, -1)
            .yoyo(true, 100);
          game.add.tween(wing2_s).to({ alpha: 0 }, 100, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 10);
        }
        if (Math.abs(tile.type) == 62) {
          tile.type = 11;
          tile.act = 0;
        }
        if (Math.abs(tile.type) == 111) {
          tile.type = 131;
          tile.act = 0;
        }
        if (Math.abs(tile.type) == 132) {
          tile.type = 133;
          tile.act = 0;
        }
        if (Math.abs(tile.type) == 73) {
          tile.type = 74;
          tile.act = 0;
        }
        if (
          Math.abs(tile.type) == 43 &&
          (tile.frameName == 'walkway_broken_1.png' ||
            tile.frameName == 'walkway_1.png' ||
            tile.frameName == 'walkway_2.png' ||
            tile.frameName == 'walkway_3.png' ||
            tile.frameName == 'walkway_4.png' ||
            tile.frameName == 'walkway_5.png' ||
            tile.frameName == 'walkway_6.png')
        ) {
          tile.scale.setTo(tile.scale.x / 2);
          tile.x += 100;
          tile.y += 50;
        }
        if (act1_array[obj[i]]['sprite'] == 'car_broken_details_1') {
          tile.type = 19;
          tile.act = 0;
        } else if (act1_array[obj[i]]['sprite'] == 'car_broken_details_2') {
          tile.type = 20;
          tile.act = 0;
        } else if (Math.abs(tile.type) == 149) {

          objects_group.children.forEach(function (child_item) {
            if (Math.abs(child_item.type) == 166 || Math.abs(child_item.type) == 165) {
              game.add.tween(child_item).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
            }
          });

        } else if (Math.abs(tile.type) == 165 && tile.frameName == 'fundament_1.png') {
          tile.type = 166;
          tile.act = 0;
        } else if (Math.abs(tile.type) == 165 && tile.frameName == 'fundament_2_L.png') {
          tile.type = 166;
          tile.act = 2;
          act1_array.push({
            type: '166',
            xxx: String(tile.x / 1.2),
            yyy: String(tile.y / 1.2 - 320 + 16),
            zzz: String(-tile.depth),
            sprite: 'fundament_2_L',
            act: '2',
            atlas: 'farm_obj_atlas',
            change: 'fundament_3_L',
            change_x: String(tile.x / 1.2),
            change_y: String(tile.y / 1.2 - 320 + 16 + 43),
            iii: 621,
          });
        } else if (Math.abs(tile.type) == 165 && tile.frameName == 'fundament_2_R.png') {
          tile.type = 166;
          tile.act = 2;
          act1_array.push({
            type: '166',
            xxx: String(tile.x / 1.2),
            yyy: String(tile.y / 1.2 - 320 + 16),
            zzz: String(-tile.depth),
            sprite: 'fundament_2_R',
            act: '2',
            atlas: 'farm_obj_atlas',
            change: 'fundament_3_R',
            change_x: String(tile.x / 1.2),
            change_y: String(tile.y / 1.2 - 320 + 16 + 43),
            iii: 621,
          });
        } else if (Math.abs(tile.type) == 50) {
          tile.type = 51;
          tile.act = 2;
          act1_array.push({
            type: '51',
            xxx: String(tile.x / 1.2),
            yyy: String(tile.y / 1.2 - 320 + 16),
            zzz: String(-tile.depth),
            sprite: 'tree',
            act: '2',
            atlas: 'farm_obj_c_atlas',
            change: 'e_tree_1',
            change_x: String((tile.x + 20) / 1.2),
            change_y: String((tile.y + 60) / 1.2 - 320 + 16 + 33),
            iii: 438,
          });
        } else if (
          Math.abs(tile.type) == 54 &&
          (tile.frameName == 'border_1.png' || tile.frameName == 'border_2.png')
        ) {
          tile.type = 541;
        } else if (
          Math.abs(tile.type) == 43 &&
          (tile.frameName == 'border_1.png' || tile.frameName == 'border_2.png')
        ) {
          tile.type = 431;
        } else if (Math.abs(tile.type) == 77) {
          tile.type = 84;
          tile.act = 0;
        } else if (Math.abs(tile.type) == 81) {
          if (tile.frameName == 'Cloth_1.png') {
            tile.animations.add(
              'Cloth',
              ['Cloth_1.png', 'Cloth_2.png', 'Cloth_3.png', 'Cloth_4.png', 'Cloth_5.png', 'Cloth_6.png'],
              10,
              true,
            );
            tile.animations.play('Cloth');
          }
          tile.type = 82;
          tile.act = 0;
        }
        objects_group.sort('depth', Phaser.Group.SORT_ASCENDING);
        let pause_t = 300;
        let time_t = 800;
        var pause_d = 500;

        if (Math.abs(act1_array[obj[i]]['type']) == 183) {
          var child_item3 = 0;
          objects_group.children.some(function (child_item2) {
            if (Math.abs(child_item2.type) == 164) {
              child_item3 = child_item2;
              return true;
            }
          });

          follow.x = child_item3.x * worldScale;
          follow.y = child_item3.y * worldScale;

          game.add.tween(child_item3.children[0]).to({ y: -200 * worldScale }, 700, Phaser.Easing.Linear.None, true, 300);
          game.add.tween(child_item3.children[0]).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 300).onComplete.add(function () {
            child_item3.children.some(function (child_item2) {
              child_item2.destroy();
            });
          });

          time_t = 2500;
          pause_d = 1500;
        }

        if (Math.abs(act1_array[obj[i]]['type']) == 141) {
          game.add.tween(tile).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
          dog_eat_anim(tile);
          pause_t = 5000;
          time_t = 1000;
        } else if (Math.abs(act1_array[obj[i]]['type']) == 73) {
          magnifying_glass_anim(tile, 100);
          pause_t = 3000;
          time_t = 1000;
        } else if (
          Math.abs(act1_array[obj[i]]['type']) == 103 ||
          Math.abs(act1_array[obj[i]]['type']) == 104 ||
          Math.abs(act1_array[obj[i]]['type']) == 105 ||
          Math.abs(act1_array[obj[i]]['type']) == 106
        ) {
          if (Math.abs(act1_array[obj[i]]['type']) == 103) {
            tile.type = 104;
            tile.act = 2;
            act1_array.push({
              type: '104',
              xxx: String(tile.x / 1.2),
              yyy: String(tile.y / 1.2 - 304),
              zzz: String(-tile.depth),
              sprite: 'stoune2',
              act: '2',
              atlas: 'farm_obj_c_atlas',
              change: 'stoune3',
              change_x: String(tile.x / 1.2),
              change_y: String(tile.y / 1.2 - 304 + 50),
              iii: 5400,
            });
          } else if (Math.abs(act1_array[obj[i]]['type']) == 104) {
            tile.type = 105;
            tile.act = 2;
            act1_array.push({
              type: '105',
              xxx: String(tile.x / 1.2),
              yyy: String(tile.y / 1.2 - 304),
              zzz: String(-tile.depth),
              sprite: 'stoune3',
              act: '2',
              atlas: 'farm_obj_c_atlas',
              change: 'stoune4',
              change_x: String(tile.x / 1.2),
              change_y: String(tile.y / 1.2 - 304 + 50),
              iii: 5401,
            });
          } else if (Math.abs(act1_array[obj[i]]['type']) == 105) {
            tile.type = 106;
            tile.act = 2;
            act1_array.push({
              type: '106',
              xxx: String(tile.x / 1.2),
              yyy: String(tile.y / 1.2 - 304),
              zzz: String(-tile.depth),
              sprite: 'stoune4',
              act: '2',
              atlas: 'farm_obj_c_atlas',
              change: 'stoune_statue_1',
              change_x: String(tile.x / 1.2),
              change_y: String(tile.y / 1.2 - 304 + 50),
              iii: 5402,
            });
          }
          var child_item = 0;
          objects_group.children.some(function (child_item2) {
            if (child_item2.type == act1_array[obj[i]]['type']) {
              child_item = child_item2;
              return true;
            }
          });
          follow.x = child_item.x * worldScale;
          follow.y = child_item.y * worldScale - 200;
          var Carving_Tool = game.add.sprite(
            child_item.x - 150,
            child_item.y - 400,
            'farm_obj_atlas',
            'Carving_Tool.png',
          );
          Carving_Tool.scale.setTo(-5, 5);
          Carving_Tool.alpha = 0;
          Carving_Tool.anchor.setTo(0.5);
          objects_group.add(Carving_Tool);
          game.add.tween(Carving_Tool).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
          game.add.tween(Carving_Tool.scale).to({ x: -3, y: 3 }, 500, Phaser.Easing.Linear.None, true);
          game.add
            .tween(Carving_Tool)
            .to({ y: '+300' }, 500, Phaser.Easing.Linear.None, true)
            .onComplete.add(function () {
              game.add
                .tween(Carving_Tool)
                .to({ x: '-60', y: '-60' }, 250, Phaser.Easing.Cubic.Out, true, 500)
                .onComplete.add(function () {
                  game.add
                    .tween(Carving_Tool)
                    .to({ x: '+60', y: '+60' }, 250, Phaser.Easing.Cubic.In, true)
                    .onComplete.add(function () {
                      emitter_smoke_h.start(true, 500, 0, 6);
                      emitter_fall_h.start(false, 800, 0, 6);
                      game.add
                        .tween(Carving_Tool)
                        .to({ x: '-60', y: '-60' }, 250, Phaser.Easing.Cubic.Out, true, 500)
                        .onComplete.add(function () {
                          game.add
                            .tween(Carving_Tool)
                            .to({ x: '+60', y: '+60' }, 250, Phaser.Easing.Cubic.In, true)
                            .onComplete.add(function () {
                              emitter_smoke_h.start(true, 500, 0, 6);
                              emitter_fall_h.start(false, 800, 0, 6);
                              game.add
                                .tween(Carving_Tool)
                                .to({ x: '-60', y: '-60' }, 250, Phaser.Easing.Cubic.Out, true, 500)
                                .onComplete.add(function () {
                                  game.add
                                    .tween(Carving_Tool)
                                    .to({ x: '+60', y: '+60' }, 250, Phaser.Easing.Cubic.In, true)
                                    .onComplete.add(function () {
                                      emitter_smoke_h.start(true, 500, 0, 6);
                                      emitter_fall_h.start(false, 800, 0, 6);
                                      game.add
                                        .tween(Carving_Tool)
                                        .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                                        .onComplete.add(function () {
                                          Carving_Tool.destroy();
                                          emitter_smoke_h.destroy();
                                          emitter_fall_h.destroy();
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
          var emitter_smoke_h = game.add.emitter(0, 0, 50);
          emitter_smoke_h.makeParticles('game_atlas', 'smoke.png');
          emitter_smoke_h.bringToTop = true;
          emitter_smoke_h.setRotation(0, 360, 500);
          emitter_smoke_h.setAlpha(1, 0, 500);
          emitter_smoke_h.setScale(0.1, 1, 0.1, 1, 500);
          emitter_smoke_h.gravity = 0;
          emitter_smoke_h.explode = true;
          emitter_smoke_h.blendMode = 1;
          emitter_smoke_h.minParticleSpeed.set(-500, -500);
          emitter_smoke_h.maxParticleSpeed.set(500, 500);
          emitter_smoke_h.x = child_item.x * worldScale;
          emitter_smoke_h.y = child_item.y * worldScale;
          var emitter_fall_h = game.add.emitter(0, 0, 50);
          emitter_fall_h.makeParticles('farm_obj_atlas', [
            'sculpture_2_fall1.png',
            'sculpture_2_fall2.png',
            'sculpture_2_fall3.png',
          ]);
          emitter_fall_h.bringToTop = true;
          emitter_fall_h.setRotation(0, 360, 1000);
          emitter_fall_h.setAlpha(2, 0, 1000);
          emitter_fall_h.minParticleScale = 0.5;
          emitter_fall_h.maxParticleScale = 2;
          emitter_fall_h.gravity = 400;
          emitter_fall_h.blendMode = 0;
          emitter_fall_h.setXSpeed(-200, 200);
          emitter_fall_h.setYSpeed(-300, -150);
          emitter_fall_h.x = child_item.x * worldScale;
          emitter_fall_h.y = child_item.y * worldScale;
          pause_t = 0;
          time_t = 4500;
          pause_d = 100;
        } else if (act1_array[obj[i]]['type'] == 111) {
          var ttt = tile;
          hummer_anim(tile);
          pause_t = 7000;
          tile.alpha = 1;
          game.add.tween(effects_group).to({ alpha: 1 }, 1800, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
            hummer_anim(ttt);
          });
          tile.loadTexture('farm_obj_atlas', 'Ladder1.png');
          tile.animations.add(
            'Ladder_anim',
            [
              'Ladder1.png',
              'Ladder2.png',
              'Ladder3.png',
              'Ladder4.png',
              'Ladder5.png',
              'Ladder6.png',
              'Ladder7.png',
              'Ladder8.png',
            ],
            2,
            false,
          );
          tile.animations.play('Ladder_anim');
          objects_group.children.some(function (child_item2) {
            if (child_item2.type == 120 && child_item2.alpha != 0) {
              game.add.tween(child_item2).to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true);
              child_item2.animations.add(
                'Big_Wood_Planks',
                ['Big_Wood_Planks_3.png', 'Big_Wood_Planks_2.png', 'Big_Wood_Planks_1.png'],
                1,
                false,
              );
              child_item2.animations.play('Big_Wood_Planks');
              game.add
                .tween(child_item2)
                .to({ alpha: 1 }, 2500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
            } else if (child_item2.type == 121 && child_item2.alpha != 0) {
              game.add.tween(child_item2).to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true);
              child_item2.animations.add(
                'Small_Wood_Planks',
                ['Small_Wood_Planks_3.png', 'Small_Wood_Planks_2.png', 'Small_Wood_Planks_1.png'],
                1,
                false,
              );
              child_item2.animations.play('Small_Wood_Planks');
              game.add
                .tween(child_item2)
                .to({ alpha: 1 }, 2500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
            }
          });
          game.add
            .tween(follow)
            .to(
              { x: '+' + String(100 * worldScale), y: '-' + String(300 * worldScale) },
              2000,
              Phaser.Easing.Linear.None,
              true,
              4000,
            );
        } else if (
          act1_array[obj[i]]['type'] == 4 ||
          act1_array[obj[i]]['type'] == 6 ||
          act1_array[obj[i]]['type'] == 33 ||
          act1_array[obj[i]]['type'] == 24 ||
          act1_array[obj[i]]['type'] == 7 ||
          act1_array[obj[i]]['type'] == 63 ||
          act1_array[obj[i]]['type'] == 47 ||
          act1_array[obj[i]]['type'] == 16 ||
          act1_array[obj[i]]['type'] == 111 ||
          (act1_array[obj[i]]['type'] == 165 && tile.frameName != 'fundament_1.png') ||
          act1_array[obj[i]]['type'] == 166 ||
          act1_array[obj[i]]['type'] == 149
        ) {
          hummer_anim(tile);
          pause_t = 500;
          time_t = 1000;
        } else if (
          act1_array[obj[i]]['type'] == 53 ||
          act1_array[obj[i]]['type'] == 28 ||
          act1_array[obj[i]]['type'] == 91 ||
          act1_array[obj[i]]['type'] == 59 ||
          act1_array[obj[i]]['type'] == 54 ||
          act1_array[obj[i]]['type'] == 77 ||
          act1_array[obj[i]]['type'] == 99 ||
          act1_array[obj[i]]['type'] == 49 ||
          act1_array[obj[i]]['type'] == 109 ||
          act1_array[obj[i]]['type'] == 184
        ) {
          pause_t = 0;
          time_t = 200;
          pause_d = 100;
        } else if (act1_array[obj[i]]['type'] == 92 || act1_array[obj[i]]['type'] == 89) {
          var emitter_lsmoke = game.add.emitter(0, 0, 50);
          emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
          emitter_lsmoke.width = tile.width;
          emitter_lsmoke.height = tile.height;
          emitter_lsmoke.bringToTop = true;
          emitter_lsmoke.setRotation(0, 360, 500);
          emitter_lsmoke.setAlpha(0.2, 0, 1000);
          emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 1000);
          emitter_lsmoke.gravity = 0;
          emitter_lsmoke.minParticleSpeed.set(-50, -50);
          emitter_lsmoke.maxParticleSpeed.set(50, 50);
          emitter_lsmoke.explode = true;
          emitter_lsmoke.blendMode = 3;
          emitter_lsmoke.x = tile.x * worldScale;
          emitter_lsmoke.y = tile.y * worldScale;
          emitter_lsmoke.start(false, 1000, 100, 40);
          var emitter_leaf = game.add.emitter(0, 0, 50);
          emitter_leaf.makeParticles('farm_obj_atlas', 'leaf.png');
          emitter_leaf.width = tile.width;
          emitter_leaf.height = tile.height;
          emitter_leaf.bringToTop = true;
          emitter_leaf.setRotation(0, 360, 500);
          emitter_leaf.setAlpha(1, 0, 1000);
          emitter_leaf.setScale(0.2, 1, 0.2, 1, 1000);
          emitter_leaf.gravity = 0;
          emitter_leaf.minParticleSpeed.set(-50, -50);
          emitter_leaf.maxParticleSpeed.set(50, 50);
          emitter_leaf.explode = true;
          emitter_leaf.blendMode = 0;
          emitter_leaf.x = tile.x * worldScale;
          emitter_leaf.y = tile.y * worldScale;
          emitter_leaf.start(false, 1000, 100, 40);
          pause_t = 0;
          time_t = 3000;
          pause_d = 100;
        } else if (
          act1_array[obj[i]]['type'] == 183 ||
          act1_array[obj[i]]['type'] == 15 ||
          act1_array[obj[i]]['type'] == 132 ||
          act1_array[obj[i]]['type'] == 140 ||
          act1_array[obj[i]]['type'] == 55 ||
          act1_array[obj[i]]['type'] == 152 ||
          (act1_array[obj[i]]['type'] == 165 && tile.frameName == 'fundament_1.png')
        ) {
          if (act1_array[obj[i]]['type'] == 140) {
            var child_item = 0;
            objects_group.children.some(function (child_item2) {
              if (child_item2.frameName == 'whiteDoghouse.png' && child_item2.alpha != 0) {
                child_item = child_item2;
                return true;
              }
            });
            follow.x = child_item.x * worldScale;
            follow.y = child_item.y * worldScale;
            game.add.tween(child_item).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true);
            game.add
              .tween(child_item)
              .to({ y: '-300' }, 1000, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                item.destroy();
                follow.x = tile.x * worldScale;
                follow.y = tile.y * worldScale;
              });
            pause_t = 2000;
            time_t = 400;
          } else if (act1_array[obj[i]]['type'] == 183) {
            pause_t = 2000;
            time_t = 400;
          } else {
            pause_t = 500;
            time_t = 400;
          }
          pause_d = 100;
          tile.y -= 200;
          game.add.tween(tile).to({ y: '+200' }, time_t * 2, Phaser.Easing.Bounce.Out, true, pause_t);
          game.add
            .tween(tile)
            .to({ alpha: 1 }, time_t, Phaser.Easing.Linear.None, true, pause_t)
            .onComplete.add(function (item) {
              var emitter_lsmoke = game.add.emitter(0, 0, 50);
              emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
              emitter_lsmoke.width = item.width;
              emitter_lsmoke.height = item.height / 2;
              emitter_lsmoke.bringToTop = true;
              emitter_lsmoke.setRotation(0, 360, 500);
              emitter_lsmoke.setAlpha(0.2, 0, 1000);
              emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 1000);
              emitter_lsmoke.gravity = 50;
              emitter_lsmoke.minParticleSpeed.set(50, 50);
              emitter_lsmoke.maxParticleSpeed.set(50, 50);
              emitter_lsmoke.explode = true;
              emitter_lsmoke.blendMode = 3;
              emitter_lsmoke.x = item.world.x;
              emitter_lsmoke.y = item.world.y + item.height / 2;
              emitter_lsmoke.start(false, 500, 0, 20);
            });
        }
        if (
          act1_array[obj[i]]['type'] == 91 ||
          act1_array[obj[i]]['type'] == 99 ||
          act1_array[obj[i]]['type'] == 57 ||
          act1_array[obj[i]]['type'] == 59 ||
          act1_array[obj[i]]['type'] == 49 ||
          act1_array[obj[i]]['type'] == 28
        ) {
          tile.alpha = 1;
          tile.scale.setTo(0);
          game.add.tween(tile.scale).to({ x: 2.7, y: 3.1 }, 400, Phaser.Easing.Bounce.Out, true, pause_t);
          game.add
            .tween(tile)
            .to({ y: '-20' }, 400, Phaser.Easing.Exponential.Out, true, pause_t)
            .onComplete.add(function (itm) {
              game.add.tween(itm.scale).to({ x: '+0.2', y: '-0.2' }, 400, Phaser.Easing.Bounce.Out, true);
              game.add.tween(itm).to({ y: '+20' }, 400, Phaser.Easing.Elastic.Out, true);
            });
        }

        if (act1_array[obj[i]]['type'] == 186) {
          var child_item3 = 0;
          objects_group.children.some(function (child_item2) {
            if (Math.abs(child_item2.type) == 185) {
              child_item3 = child_item2;
              return true;
            }
          });

          var shlang = game.add.sprite(child_item3.x, child_item3.y, 'day_16_atlas', 'Precomp 1_00000.png');
          shlang.anchor.setTo(0.5);
          shlang.scale.setTo(2.42);
          objects_group.add(shlang);

          var pump_mas = [];
          for (var ix = 0; ix <= 35; ix++) {
            let n = 0;
            if (ix < 10) { n = '0' + ix; } else { n = ix; }
            pump_mas.push('Precomp 1_000' + n + '.png');
          }
          var anim = shlang.animations.add('pump',
            pump_mas,
            10,
            true,
          );
          shlang.animations.play('pump');

          pause_t = 200;
          time_t = 2000;

          tile.loadTexture('build_icon_atlas', 'clear_water.png');
          scale_tween(tile, 2500, 0.05, 0.05, -1);
        }



        objects_group.sort('depth', Phaser.Group.SORT_ASCENDING);
        act1_array.splice(obj[i], 1);

        game.add
          .tween(tile)
          .to({ alpha: 1 }, time_t, Phaser.Easing.Linear.None, true, pause_t)
          .onComplete.add(function (item) {
            if (day_tasks[iii]['type'] == 186) { shlang.destroy(); }
            if (emitter_smoke2 != 0) {
              emitter_smoke2.on = false;
              emitter_smoke2 = 0;
            }
            var new_obj = 0;
            objects_group.children.some(function (child_item2) {
              if (child_item2.type == day_tasks[iii]['type'] && child_item2.act == 0) {
                new_obj = child_item2;
                return true;
              }
            });
            if (
              act1_array.findIndex(function (e) {
                return e['type'] == day_tasks[iii]['type'];
              }) != -1
            ) {
              let index = [];
              index.push(
                act1_array.findIndex(function (e) {
                  return e['type'] == day_tasks[iii]['type'];
                }),
              );

              follow.x = act1_array[index[0]]['xxx'] * 1.2 * worldScale;
              follow.y = act1_array[index[0]]['yyy'] * 1.2 * worldScale + 304 * worldScale;
              last_position = [
                act1_array[index[0]]['xxx'] * 1.2 * worldScale,
                act1_array[index[0]]['yyy'] * 1.2 * worldScale + 304 * worldScale,
              ];
              game.add
                .tween(tile)
                .to({ alpha: 1 }, pause_d, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  if (act1_array[index[0]]['change'] == 0) object_create(index, iii, 0);
                  else object_change(index, iii);
                });
            } else if (new_obj != 0) {
              object_destroy(new_obj, iii);
            } else {

              if (compl == 0) {
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type < 0) {
                    child_item2.type *= -1;
                  }
                });
                /* if (item.type == 16) {
                   var mail_flag = game.add.sprite(5, -14, 'farm_obj_c_atlas', 'mail_flag_emty.png');
                   mail_flag.anchor.setTo(0, 0.5);
                   mail_flag.depth = 10;
                   item.addChild(mail_flag);
                 }*/
                console.log(item.type, item.frameName);

                if (
                  item.type == 141 ||
                  item.type == 57 ||
                  item.type == 59 ||
                  item.type == 72 ||
                  item.type == 28 ||
                  item.type == 5 ||
                  item.type == 91 ||
                  item.type == 92 ||
                  item.type == 129 ||
                  item.type == 149 ||
                  item.type == 99 ||
                  item.type == 49 ||
                  //item.type == 109 ||
                  item.type == 51 ||
                  item.type == 515 ||
                  item.type == 95 ||
                  item.type == 96 ||
                  item.type == 184 ||
                  item.frameName == 'roof_1.png' ||
                  item.frameName == 'balcony_floor_white.png' ||
                  item.frameName == 'Plum_1.png' ||
                  item.frameName == 'bench_1.png' ||
                  item.frameName == 'place_mosaic_tiles_1.png' ||
                  item.frameName == 'flowers_by_window_1.png' ||
                  item.frameName == 'ivy_1.png' ||
                  item.frameName == 'ceiling_1.png' ||
                  item.frameName == 'mail_box_1.png' ||
                  item.frameName == 'b_lamp_1.png' ||
                  item.frameName == 'celing_1.png' ||
                  item.frameName == 'porch_1.png' ||
                  item.frameName == 'flower_pot_1.png' ||
                  item.frameName == 'door_1.png' ||
                  item.frameName == 'porch_roof_1.png' ||
                  item.frameName == 'fountane_empty_1.png' ||
                  item.frameName == 'bushes_around_fontane_1.png' ||
                  item.frameName == 'chinmey_1.png' ||
                  item.frameName == 'Flower_Bed_1.png' ||
                  item.frameName == 'bee_hive_1.png' ||
                  item.frameName == 'bush_whiteflowers_1.png' ||
                  item.frameName == 'arch1.png' ||
                  item.frameName == 'Bird_House_1.png' ||
                  item.frameName == 'fountane_full_1.png' ||
                  item.frameName == 'stoune_statue_1.png' ||
                  item.frameName == 'BalconyRailing_1.png' ||
                  item.frameName == 'DoorBalcony1.png' ||
                  item.frameName == 'WindowBalcony_1.png'
                ) {
                  if (item.type == 51 || item.type == 515) {
                    objects_group.children.some(function (child_item2) {
                      if (child_item2.frameName == 'a_tree_1.png') {
                        item = child_item2;
                        return true;
                      }
                    });
                  }
                  if (item.type != 51 || ((item.type == 51 || item.type == 515) && item.frameName == 'a_tree_1.png')) {
                    popup = 0;
                    first_create = 1;
                    build_special_object(item, 1);
                  } else task_complite(iii);
                } else task_complite(iii);
                compl = 1;
                objects_group.sort('depth', Phaser.Group.SORT_ASCENDING);
              }
            }
          });
      }
    }

    var compl = 0;
    function object_destroy(obj, iii) {
      animation = 1;
      compl = 0;
      var item_iii = iii;
      var object_d = obj;
      var xxx = game.rnd.integerInRange(-4, 4);
      var yyy = game.rnd.integerInRange(-4, 4);
      var pause = 1150;
      var speed = 500;
      follow.x = object_d.x * worldScale;
      follow.y = object_d.y * worldScale;
      if (object_d.type == 64 || object_d.type == 65 || object_d.type == 66) {
        follow.y += 80;
      }
      last_position = [object_d.x * worldScale, object_d.y * worldScale];
      game.add
        .tween(object_d)
        .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
        .onComplete.add(function () {
          if (object_d.type == 107) {
            objects_group.children.some(function (child_item2) {
              if (child_item2.type == 120 && child_item2.alpha == 0) {
                game.add.tween(child_item2).to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true);
                child_item2.animations.add(
                  'Big_Wood_Planks',
                  ['Big_Wood_Planks_1.png', 'Big_Wood_Planks_2.png', 'Big_Wood_Planks_3.png'],
                  0.5,
                  false,
                );
                child_item2.animations.play('Big_Wood_Planks');
                return true;
              }
            });
          } else if (object_d.type == 108) {
            objects_group.children.some(function (child_item2) {
              if (child_item2.type == 121 && child_item2.alpha == 0) {
                game.add.tween(child_item2).to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true);
                child_item2.animations.add(
                  'Small_Wood_Planks',
                  ['Small_Wood_Planks_1.png', 'Small_Wood_Planks_2.png', 'Small_Wood_Planks_3.png'],
                  0.4,
                  false,
                );
                child_item2.animations.play('Small_Wood_Planks');
                return true;
              }
            });
          }
          if (object_d.type == 74) {
            stik_anim(object_d);
            pause = 1500;
          } else if ((object_d.frameName == 'leaves3.png' || object_d.frameName == 'Leaves_Ashes.png') && object_d.type != 154) {
            broom_stick_anim(object_d);
            pause = 3000;
          } else if (object_d.frameName == 'leaves3.png' && object_d.type == 154) {

            lasso = game.add.sprite(object_d.x + 100, object_d.y - 214, 'day_16_atlas', 'comp 1_00000.png');
            lasso.anchor.setTo(0.5);
            lasso.scale.setTo(2);
            objects_group.add(lasso);
            var lasso_mas = [];
            for (var i = 0; i <= 47; i++) {
              let n = 0;
              if (i < 10) { n = '0' + i; } else { n = i; }
              lasso_mas.push('comp 1_000' + n + '.png');
            }
            var anim = lasso.animations.add('lasso',
              lasso_mas,
              10,
              false,
            );
            anim.onComplete.add(function () {
              lasso.destroy();
            }, this);
            lasso.animations.play('lasso');

            pause = 3000;
          } else if (object_d.type == 84) {
            objects_group.children.some(function (child_item2) {
              if (child_item2.type == 90) {
                game.add.tween(child_item2).to({ alpha: 1 }, 3000, Phaser.Easing.Linear.None, true);
              }
            });
            var emitter_burn = game.add.emitter(0, 0, 50);
            var burn_mask = game.add.graphics(0, 0);
            burn_mask.beginFill(0xffffff);
            burn_mask.drawRect(
              object_d.world.x - object_d.width / 2,
              object_d.world.y - object_d.height / 2,
              object_d.width,
              object_d.height,
            );
            object_d.mask = burn_mask;
            game.add
              .tween(burn_mask)
              .to({ y: '+' + object_d.height }, 3000, Phaser.Easing.Linear.None, true)
              .onComplete.add(function () {
                emitter_burn.on = false;
                burn_mask.alpha = 0;
                fire.destroy();
              });
            emitter_burn.makeParticles('farm_obj_atlas', 'smoke.png');
            emitter_burn.width = object_d.width;
            emitter_burn.height = object_d.height;
            emitter_burn.bringToTop = true;
            emitter_burn.setRotation(0, 360, 500);
            emitter_burn.setAlpha(1, 0, 4000);
            emitter_burn.setScale(0.2, 2, 0.2, 2, 4000);
            emitter_burn.gravity = -100;
            emitter_burn.minParticleSpeed.set(-50, -50);
            emitter_burn.maxParticleSpeed.set(50, 50);
            emitter_burn.explode = true;
            emitter_burn.blendMode = 2;
            emitter_burn.x = object_d.world.x;
            emitter_burn.y = object_d.world.y;
            emitter_burn.start(false, 5000, 100);
            var fire = game.add.sprite(object_d.world.x - 10, object_d.world.y + 60, 'farm_obj_atlas', 'fire_1.png');
            fire.anchor.setTo(0.5, 1);
            fire.scale.setTo(0);
            fire.animations.add(
              'fire',
              [
                'fire_1.png',
                'fire_2.png',
                'fire_3.png',
                'fire_4.png',
                'fire_5.png',
                'fire_6.png',
                'fire_7.png',
                'fire_8.png',
              ],
              10,
              true,
            );
            fire.animations.play('fire');
            game.add.tween(fire.scale).to({ x: 4, y: 4 }, 500, Phaser.Easing.Linear.None, true);
            pause = 3100;
          } else if (
            object_d.type == 17 ||
            object_d.frameName == 'BROKEN_INSIDE.png' ||
            object_d.frameName == 'rat.png'
          ) {
            pause = 100;
          } else if (object_d.type == 142) {
            speed = 1500;
            pause = 500;
          } else if (object_d.type == 133 || object_d.type == 18) {
            pause = 3000;
          } else
            game.time.events.repeat(100, 10, function () {
              xxx = game.rnd.integerInRange(-4, 4);
              yyy = game.rnd.integerInRange(-4, 4);
              game.add
                .tween(object_d)
                .to({ x: object_d.x + xxx, y: object_d.y + yyy }, 20, Phaser.Easing.Quadratic.In, true)
                .onComplete.add(function () {
                  game.add
                    .tween(object_d)
                    .to({ x: object_d.x - xxx, y: object_d.y - yyy }, 20, Phaser.Easing.Quadratic.Out, true);
                });
            });
          if (object_d.type == 1 || object_d.type == 2 || object_d.type == 114 || object_d.type == 115 || object_d.type == 180) {
            var emitter_lsmoke = game.add.emitter(0, 0, 50);
            emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
            emitter_lsmoke.width = object_d.width;
            emitter_lsmoke.height = object_d.height;
            emitter_lsmoke.bringToTop = true;
            emitter_lsmoke.setRotation(0, 360, 500);
            emitter_lsmoke.setAlpha(0.2, 0, 500);
            emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 500);
            emitter_lsmoke.gravity = 0;
            emitter_lsmoke.minParticleSpeed.set(-50, -50);
            emitter_lsmoke.maxParticleSpeed.set(50, 50);
            emitter_lsmoke.explode = true;
            emitter_lsmoke.blendMode = 3;
            emitter_lsmoke.x = object_d.world.x;
            emitter_lsmoke.y = object_d.world.y;
            emitter_lsmoke.start(false, 500, 50, 40);
            var emitter_leaf = game.add.emitter(0, 0, 50);
            emitter_leaf.makeParticles('farm_obj_atlas', 'leaf.png');
            emitter_leaf.width = object_d.width;
            emitter_leaf.height = object_d.height;
            emitter_leaf.bringToTop = true;
            emitter_leaf.setRotation(0, 360, 500);
            emitter_leaf.setAlpha(1, 0, 500);
            emitter_leaf.setScale(0.2, 1, 0.2, 1, 500);
            emitter_leaf.gravity = 0;
            emitter_leaf.minParticleSpeed.set(-50, -50);
            emitter_leaf.maxParticleSpeed.set(50, 50);
            emitter_leaf.explode = true;
            emitter_leaf.blendMode = 0;
            emitter_leaf.x = object_d.world.x;
            emitter_leaf.y = object_d.world.y;
            emitter_leaf.start(false, 500, 50, 40);
          } else if (object_d.type == 98 || object_d.type == 13 || object_d.type == 94 || object_d.type == 61) {
            var emitter_lsmoke = game.add.emitter(0, 0, 50);
            emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
            emitter_lsmoke.width = object_d.width;
            emitter_lsmoke.height = object_d.height;
            emitter_lsmoke.bringToTop = true;
            emitter_lsmoke.setRotation(0, 360, 500);
            emitter_lsmoke.setAlpha(0.2, 0, 1000);
            emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 1000);
            emitter_lsmoke.gravity = 0;
            emitter_lsmoke.minParticleSpeed.set(0, 0);
            emitter_lsmoke.maxParticleSpeed.set(0, 0);
            emitter_lsmoke.explode = true;
            emitter_lsmoke.blendMode = 3;
            emitter_lsmoke.x = object_d.world.x;
            emitter_lsmoke.y = object_d.world.y;
            emitter_lsmoke.start(false, 1000, 50, 50);
            var emitter_leaf = game.add.emitter(0, 0, 50);
            emitter_leaf.makeParticles('farm_obj_atlas', 'a_field_broken_2.png');
            emitter_leaf.width = object_d.width;
            emitter_leaf.height = object_d.height;
            emitter_leaf.bringToTop = true;
            emitter_leaf.setRotation(0, 0, 500);
            emitter_leaf.setAlpha(0, 1, 1000);
            emitter_leaf.setScale(3, 0, 3, 0, 1000);
            emitter_leaf.gravity = -200;
            emitter_leaf.minParticleSpeed.set(0, 0);
            emitter_leaf.maxParticleSpeed.set(0, 0);
            emitter_leaf.explode = true;
            emitter_leaf.blendMode = 2;
            emitter_leaf.x = object_d.world.x;
            emitter_leaf.y = object_d.world.y;
            emitter_leaf.start(false, 1000, 50, 50);
          }
          game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
            if (
              object_d.type == 1 ||
              object_d.type == 2 ||
              object_d.type == 13 ||
              object_d.type == 23 ||
              object_d.type == 41 ||
              object_d.type == 45 ||
              object_d.type == 114 ||
              object_d.type == 115
            ) {
              if (sound_on == 1) {
                play_sound('remove_bushes');
              }
            } else if (
              object_d.type == 3 ||
              object_d.type == 22 ||
              object_d.type == 64 ||
              object_d.type == 65 ||
              object_d.type == 66 ||
              object_d.type == 42 ||
              object_d.type == 44 ||
              object_d.type == 112 ||
              object_d.type == 113
            ) {
              if (sound_on == 1) {
                play_sound('remove_planks');
              }
            } else if (
              object_d.type == 17 ||
              object_d.type == 19 ||
              object_d.type == 20 ||
              object_d.type == 25 ||
              object_d.type == 52 ||
              object_d.type == 56 ||
              object_d.type == 184
            ) {
              if (sound_on == 1) {
                play_sound('Construction_Fast');
              }
            }
          });
          if (
            object_d.type != 142 &&
            object_d.type != 86 &&
            object_d.type != 17 &&
            object_d.type != 18 &&
            object_d.type != 133 &&
            object_d.frameName != 'BROKEN_INSIDE.png' &&
            object_d.type != 84 &&
            object_d.frameName != 'leaves3.png' &&
            object_d.frameName != 'Leaves_Ashes.png' &&
            object_d.frameName != 'rat.png' &&
            object_d.type != 181
          ) {
            game.add.tween(object_d).to({ y: '-200' }, 500, Phaser.Easing.Quadratic.Out, true, pause);
            game.add.tween(object_d.scale).to({ x: 2.3, y: 2.3 }, 500, Phaser.Easing.Quadratic.Out, true, pause);
          }
          game.add
            .tween(object_d)
            .to({ alpha: 0 }, speed, Phaser.Easing.Quadratic.Out, true, pause)
            .onComplete.add(function () {
              if (emitter_smoke2 != 0) {
                emitter_smoke2.on = false;
                emitter_smoke2 = 0;
              }
              let ot = object_d.type;
              object_d.destroy();
              if (ot == 77 || ot == 83) {
                objects_group.children.some(function (child_item2) {
                  if (child_item2.frameName == 'many_leaves.png') {
                    if (child_item2.scale.x == 0)
                      game.add.tween(child_item2.scale).to({ x: 1.2, y: 1.2 }, 500, Phaser.Easing.Quadratic.Out, true);
                    else
                      game.add
                        .tween(child_item2.scale)
                        .to({ x: '+0.2', y: '+0.2' }, 500, Phaser.Easing.Quadratic.Out, true);
                    return true;
                  }
                });
              }
              var child_item = 0;
              if (Math.abs(ot) != 61) {
                objects_group.children.some(function (child_item2) {
                  if (child_item2.type == ot) {
                    compl = 1;
                    child_item = child_item2;
                    if (emitter_smoke2 == 0) {
                      follow.x = child_item.world.x * worldScale;
                      follow.y = child_item.world.y * worldScale;
                      last_position = [child_item.world.x * worldScale, child_item.world.y * worldScale];
                      game.setUserDataAndLog({ last_position: JSON.stringify(last_position) });
                    }
                    return true;
                  }
                });
              }
              if (compl == 0) {
                compl = 1;
                game.add
                  .tween(object_d)
                  .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function () {
                    var n = 1;
                    if (object_d.type == 11) {
                      var o = 0;
                      objects_group.children.some(function (child_item2) {
                        if (child_item2.frameName == 'door_1.png') {
                          o = child_item2;
                          o.type = 11;
                          return true;
                        }
                      });
                      first_create = 1;
                      build_special_object(o, 1);
                    } else if (object_d.type == 5) {
                      var o = 0;
                      objects_group.children.some(function (child_item2) {
                        if (child_item2.type < 0) {
                          child_item2.type *= -1;
                        }
                        if (child_item2.type == 5) {
                          if (n == 0) {
                            o = child_item2;
                          } else n -= 1;
                        }
                      });
                      first_create = 1;
                      build_special_object(o, 1);
                    } else if (object_d.type == 2) {
                      animation = 1;
                      game.add
                        .tween(follow)
                        .to({ x: 2400 * worldScale, y: 850 * worldScale }, 2000, Phaser.Easing.Linear.None, true, 500)
                        .onComplete.add(function () {
                          task_complite(item_iii);
                        });
                    } else task_complite(item_iii);
                  });
              } else object_destroy(child_item, item_iii);
            });
        });
    }

    function task_complite(item_iii) {
      if (dialog_check == 0) {
        if (day_tasks[item_iii]['dialog'] == '0' || (item_iii >= 0 && mission_task[item_iii] != 1)) {
          popup = 0;
          animation = 0;
          taks_indicator(1);
          FTUE_process();
        } else {
          popup = 0;
          FTUE_process();
          if (Number(day_tasks[item_iii]['dialog']) > 1000) {
            let l = Number(day_tasks[item_iii]['dialog']) - 1000;
            letter(
              game.cache.getJSON('dialog')['letter' + l][0][window.lang],
              Number(game.cache.getJSON('dialog')['letter' + l][0]['coins']),
            );
          } else dialog_window(Number(day_tasks[item_iii]['dialog']), 0);
        }
      }
    }

    var check_input = 0;
    var first_create = 0;
    function build_special_object(itm, m) {
      if (((map_move == 0 && FTUE > 30) || FTUE <= 30) && (FTUE >= 42 || (FTUE <= 41.1 && (fff == 0 || fff == 2)))) {
        missions_tab_open = 0;
        animation = 0;
        var FTUEarrow1 = 0;
        var FTUEarrow2 = 0;
        var FTUEarrow3 = 0;
        if (first_create == 0) {
          check_input = itm.inputEnabled;
        } else {
          check_input = null;
        }
        if (check_input == true) {
          objects_group.children.forEach(function (child_item) {
            if (child_item.inputEnabled == true && child_item.special) {
              child_item.special.destroy(true);
              child_item.special = 0;
            }
          });
          if (
            itm.type == 7 ||
            itm.type == 6 ||
            itm.type == 15 ||
            itm.type == 16 ||
            itm.type == 35 ||
            itm.type == 39 ||
            itm.type == 55 ||
            itm.type == 47
          )
            var special_icon = game.add.sprite(itm.x, itm.y, 'game_ui_atlas', 'Indicator_Furniture.png');
          else if (
            itm.type == 6 ||
            itm.type == 14 ||
            itm.type == 4 ||
            itm.type == 5 ||
            itm.type == 10 ||
            itm.type == 12 ||
            itm.type == 30 ||
            itm.type == 31 ||
            itm.type == 11 ||
            itm.type == 33 ||
            itm.type == 54 ||
            itm.type == 541 ||
            itm.type == 43 ||
            itm.type == 431 ||
            itm.type == 95 ||
            itm.type == 96 ||
            itm.type == 106 ||
            itm.type == 24
          )
            var special_icon = game.add.sprite(itm.x, itm.y, 'game_ui_atlas', 'Indicator_House.png');
          else var special_icon = game.add.sprite(itm.x, itm.y, 'game_ui_atlas', 'Indicator_Plant.png');
          special_icon.anchor.setTo(0.5, 1);
          special_icon.scale.setTo(1);
          special_icon.obj = itm;
          itm.special = special_icon;
          if (itm.type == 59) {
            special_icon.x += 100;
            special_icon.y -= 110;
          } else if (itm.type == 146 || itm.type == 147) {
            special_icon.y -= 100;
          } else if (itm.type == 129) {
            special_icon.x += 50;
          } else if (itm.type == 117) {
            special_icon.x += 140;
            special_icon.y -= 130;
          } else if (itm.type == 4) {
            special_icon.x -= 210;
          } else if (itm.type == 40) {
            special_icon.x += 60;
            special_icon.y += 150;
          } else if (itm.type == 43) {
            special_icon.x += 400;
            special_icon.y += 220;
          } else if (itm.type == 431) {
            special_icon.x += 400;
            special_icon.y += 300;
          } else if (itm.type == 24) {
            special_icon.x += 150;
          } else if (itm.type == 95) {
            special_icon.x = 3133.2;
            special_icon.y = 1888;
          } else if (itm.type == 96) {
            special_icon.x = 3230.4;
            special_icon.y = 1738;
          } else if (itm.type == 53) {
            special_icon.x -= 1070;
            special_icon.y += 920;
          } else if (itm.type == 63 || itm.type == 47 || itm.type == 57) {
            special_icon.y -= 70;
          } else if (itm.type == 55) {
            special_icon.y -= 40;
          } else if (itm.type == 16) {
            special_icon.y -= 70;
            special_icon.x += 10;
          } else if (itm.type == 170) {
            special_icon.y -= 70;
            special_icon.x += 10;
          }

          objects_group.addChild(special_icon);
        }
        if (check_input != true && itm.type == 9) {
          complete_level_spec = 0;
        }
        f_w_a();
        if (FTUE == 41.1 && fff == 0) {
          if (w != 0) {
            f_w_a();
          }
          fff = 1;
        }
        if ((popup == 0 && missions_tab_open == 0) || (FTUE == 41.1 && (fff == 1 || fff == 2))) {
          let group_Texture_1 = game.add.group();
          group_Texture_1.y = -83;
          var task1 = draw_rect(83, 83, 165, 165, '#F1E6D0', '#EED29B', 0, 0, 0, 5, 30, 0, 0);
          draw_rect_shadow(0, 0, 142, 138, '#000', '#000', 0, 0, task1, 20);
          draw_rect(0, 0, 142, 138, '#F8F4EC', '#F8F4EC', 0, 0, task1, 0, 20, 0);
          draw_rect_shadow(0, 0, 126, 122, '#000', '#000', 0, 0, task1, 20);
          draw_rect(0, 0, 126, 122, '#F7F1E5', '#F4E3BA', 0, 0, task1, 0, 20, 0);
          group_Texture_1.add(task1);
          group_Texture_1.inputEnabled = false;
          group_Texture_1.y = 0;
          var renderTexture_1 = game.make.renderTexture(165, 170);
          renderTexture_1.render(group_Texture_1);
          group_Texture_1.destroy();
          let group_Texture_2 = game.add.group();
          group_Texture_2.y = -83;
          var task1 = draw_rect(83, 83, 165, 165, '#F1E6D0', '#EED29B', 0, 0, 0, 5, 30, 0, 0);
          draw_rect_shadow(0, 0, 142, 138, '#000', '#000', 0, 0, task1, 20);
          draw_rect(0, 0, 142, 138, '#5695B0', '#1A577A', 0, 0, task1, 0, 20, 0);
          draw_rect(0, 0, 138, 134, '#97CBE0', '#227294', 0, 0, task1, 0, 20, 0);
          draw_rect_shadow(0, 0, 122, 116, '#000', '#000', 0, 0, task1, 20);
          draw_rect(0, 0, 124, 118, '#F7F6EF', '#F9F0DB', 0, 0, task1, 0, 20, 0);
          group_Texture_2.add(task1);
          group_Texture_2.inputEnabled = false;
          group_Texture_2.y = 0;
          var renderTexture_2 = game.make.renderTexture(165, 170);
          renderTexture_2.render(group_Texture_2);
          group_Texture_2.destroy();
          popup = 1;
          if (special_stage == 0) {
            game.add.tween(UI_bottom_group).to({ y: '+400' }, 500, Phaser.Easing.Exponential.Out, true);
          }
          special_stage = itm;
          var all_width = 0;
          var ci = 0;
          var price = 0;
          popup_group.y = 0;
          popup_group.y += game.camera.height;
          if (itm.frameName == 'roof_1.png' && check_input != true) {
            itm.tint = 0xca8b5c;
          }
          if (itm.frameName == 'balcony_floor_white.png' && check_input != true) {
            itm.tint = 0x889699;
          }
          if (itm.frameName == 'house_3_0.png') {
            if (check_input != true) {
              itm.tint = 0xffd25e;
            }
            var new_wall = game.add.sprite(itm.x, itm.y, 'farm_obj_c_atlas', 'house_3_0.png');
            new_wall.anchor.setTo(0.5);
            new_wall.scale.setTo(2.9);
            new_wall.depth = itm.depth;
            objects_group.add(new_wall);
            game.add
              .tween(new_wall)
              .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                item.destroy(true);
              });
            var house = game.add.sprite(0, 0, 'farm_obj_c_atlas', 'house_3_1.png');
            house.anchor.setTo(0.5);
            itm.addChild(house);
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 4 || child_item.type == -4) {
                if (child_item.frameName == 'house_2_0.png') {
                  if (check_input != true) {
                    child_item.tint = 0xffd25e;
                  }
                  var new_wall = game.add.sprite(child_item.x, child_item.y, 'farm_obj_c_atlas', 'house_2_0.png');
                  new_wall.anchor.setTo(0.5);
                  new_wall.scale.setTo(2.9);
                  new_wall.depth = child_item.depth;
                  objects_group.add(new_wall);
                  game.add
                    .tween(new_wall)
                    .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.destroy(true);
                    });
                  var house = game.add.sprite(0, 0, 'farm_obj_c_atlas', 'house_2_1.png');
                  house.anchor.setTo(0.5);
                  child_item.addChild(house);
                } else if (child_item.frameName == 'house_1_0.png') {
                  if (check_input != true) {
                    child_item.tint = 0xffd25e;
                  }
                  var new_wall = game.add.sprite(child_item.x, child_item.y, 'farm_obj_c_atlas', 'house_1_0.png');
                  new_wall.anchor.setTo(0.5);
                  new_wall.scale.setTo(2.9);
                  new_wall.depth = child_item.depth;
                  objects_group.add(new_wall);
                  game.add
                    .tween(new_wall)
                    .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.destroy(true);
                    });
                  var house = game.add.sprite(0, 0, 'farm_obj_c_atlas', 'house_1_1.png');
                  house.anchor.setTo(0.5);
                  child_item.addChild(house);
                }
              }
            });
            objects_group.sort('depth', Phaser.Group.SORT_ASCENDING);
          }
          var numEl = parseInt(itm.frameName.match(/\d(?=\D*$)/));
          var old_name = numEl;
          var current_i = numEl;
          var sprite_name = itm.frameName.replace(numEl + '.png', '');
          if (itm.type == 4) {
            if (itm.tint == 0xffd25e) {
              current_i = 1;
              old_name = 1;
            } else if (itm.tint == 0x71c1c9) {
              current_i = 2;
              old_name = 2;
            } else if (itm.tint == 0xffb990) {
              current_i = 3;
              old_name = 3;
            } else if (itm.tint == 0x808080) {
              current_i = 4;
              old_name = 4;
            } else if (itm.tint == 0xff00ff) {
              current_i = 5;
              old_name = 5;
            } else if (itm.tint == 0x993300) {
              current_i = 6;
              old_name = 6;
            }
          } else if (itm.type == 6) {
            if (itm.tint == 0xca8b5c) {
              current_i = 1;
              old_name = 1;
            } else if (itm.tint == 0x58431c) {
              current_i = 2;
              old_name = 2;
            }
            if (itm.tint == 0x197760) {
              current_i = 3;
              old_name = 3;
            } else if (itm.tint == 0x7f6fac) {
              current_i = 4;
              old_name = 4;
            } else if (itm.tint == 0x3060a1) {
              current_i = 5;
              old_name = 5;
            }
            if (itm.tint == 0xaf3636) {
              current_i = 6;
              old_name = 6;
            }
          } else if (itm.type == 128) {
            if (itm.tint == 0x889699) {
              current_i = 1;
              old_name = 1;
            } else if (itm.tint == 0xa49a7c) {
              current_i = 2;
              old_name = 2;
            }
            if (itm.tint == 0x6c5364) {
              current_i = 3;
              old_name = 3;
            } else if (itm.tint == 0x287e92) {
              current_i = 4;
              old_name = 4;
            } else if (itm.tint == 0x8f320e) {
              current_i = 5;
              old_name = 5;
            }
          }
          var max_element = 8;
          if (
            special_object.indexOf(Number(itm.type * m + '' + 1 + '' + 0)) == -1 &&
            special_object.indexOf(Number(itm.type * m + '' + 1 + '' + 1)) == -1 &&
            special_object.indexOf(Number(itm.type * m + '' + 1 + '' + 2)) == -1
          ) {
            if (itm.type == -140) {
              itm.type = Math.abs(itm.type);
            }
            for (i = 1; i <= max_element; i++) {
              var tp = new_options.findIndex(function (e) {
                return Number(Math.abs(e['type'])) == itm.type * m;
              });
              if (
                ((Number(
                  game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i + 'ifTask'],
                ) > 0 &&
                  typeof new_options[tp] !== 'undefined' &&
                  new_options[tp]['num'].indexOf(i) != -1) ||
                  Number(
                    game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i + 'ifTask'],
                  ) == 0) &&
                Number(game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i]) != -1
              ) {
                all_width += 200;
                if (Number(game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i]) > 0)
                  special_object.push(Number(itm.type * m + '' + i + '' + 0));
                else special_object.push(Number(itm.type * m + '' + i + '' + 2));
              }
            }
          } else {
            for (i = 1; i <= max_element; i++) {
              var tp = new_options.findIndex(function (e) {
                return Number(Math.abs(e['type'])) == itm.type * m;
              });
              if (
                ((Number(
                  game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i + 'ifTask'],
                ) > 0 &&
                  typeof new_options[tp] !== 'undefined' &&
                  new_options[tp]['num'].indexOf(i) != -1) ||
                  Number(
                    game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i + 'ifTask'],
                  ) == 0) &&
                Number(game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i]) != -1
              ) {
                all_width += 180;
                if (special_object.indexOf(Number(itm.type * m + '' + i + '' + 2)) != -1) {
                  special_object.splice(special_object.indexOf(Number(itm.type * m + '' + i + '' + 2)), 1);
                  special_object.push(Number(itm.type * m + '' + i + '' + 1));
                }
              }
            }
          }
          var Item_Name_Price_BG = 0;
          function information(itm2, price) {
            Item_Name_Price_BG = game.add.sprite(
              itm2.cameraOffset.x,
              itm2.cameraOffset.y - itm2.height / 2 - 30,
              'game_window_atlas',
              'Item_Name_Price_BG.png',
            );
            Item_Name_Price_BG.anchor.setTo(0.5, 1);
            Item_Name_Price_BG.scale.setTo(0);
            Item_Name_Price_BG.fixedToCamera = true;
            popup_group.add(Item_Name_Price_BG);
            game.add.tween(Item_Name_Price_BG.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Exponential.Out, true);
            let price_icon = game.add.sprite(-90, -80, 'game_ui_atlas', 'Coin_Icon.png');
            price_icon.scale.setTo(0.6);
            price_icon.anchor.setTo(0.5);
            Item_Name_Price_BG.addChild(price_icon);
            let name_text = game.add.text(
              0,
              -146,
              game.cache.getJSON('lang')[
              game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['name']
              ][0][window.lang],
              { font: '36px RussoOne', fill: '#0D6A96', align: 'center' },
            );
            name_text.anchor.setTo(0.5);
            name_text.stroke = '#fff';
            name_text.lineSpacing = -10;
            name_text.strokeThickness = 4;
            Item_Name_Price_BG.addChild(name_text);
            let price_text = game.add.text(-45, -75, price, {
              font: '42px RussoOne',
              fill: '#8C3B32',
              align: 'center',
            });
            price_text.anchor.setTo(0, 0.5);
            price_text.stroke = '#fff';
            price_text.strokeThickness = 4;
            Item_Name_Price_BG.addChild(price_text);
          }

          if (FTUE == 7) {
            w = ftue_window(
              'Main_Presenting.png',
              game.cache.getJSON('lang')['t324'][0][window.lang],
              game.camera.width / 2,
              game.camera.height / 2 - 220,
            );
            if (sound_on == 1) {
              play_sound('hint_with_arrow');
            }
            FTUEarrow1 = game.add.sprite(
              game.camera.width / 2 + 0 * 180 - all_width / 2 + 90,
              game.camera.height - 110,
              'game_atlas',
              'FTUE_Arrow.png',
            );
            FTUEarrow1.anchor.setTo(0.5, 1.6);
            FTUEarrow1.fixedToCamera = true;
            game.add
              .tween(FTUEarrow1.anchor)
              .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
              .yoyo(true, 200);
            FTUEarrow2 = game.add.sprite(
              game.camera.width / 2 + 1 * 180 - all_width / 2 + 90,
              game.camera.height - 110,
              'game_atlas',
              'FTUE_Arrow.png',
            );
            FTUEarrow2.anchor.setTo(0.5, 1.6);
            FTUEarrow2.fixedToCamera = true;
            game.add
              .tween(FTUEarrow2.anchor)
              .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
              .yoyo(true, 200);
            FTUEarrow3 = game.add.sprite(
              game.camera.width / 2 + 2 * 180 - all_width / 2 + 90,
              game.camera.height - 110,
              'game_atlas',
              'FTUE_Arrow.png',
            );
            FTUEarrow3.anchor.setTo(0.5, 1.6);
            FTUEarrow3.fixedToCamera = true;
            game.add
              .tween(FTUEarrow3.anchor)
              .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
              .yoyo(true, 200);
            FTUE_Arrow = game.add.sprite(
              game.camera.width / 2 + 800,
              game.camera.height - 110,
              'game_atlas',
              'FTUE_Arrow.png',
            );
            FTUE_Arrow.anchor.setTo(0.5, 1.6);
            FTUE_Arrow.fixedToCamera = true;
            game.add
              .tween(FTUE_Arrow.anchor)
              .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
              .yoyo(true, 200);
          }
          var xiii = 1;
          for (i = 1; i <= max_element; i++) {
            var tp = new_options.findIndex(function (e) {
              return Number(Math.abs(e['type'])) == itm.type * m;
            });
            if (
              ((Number(game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i + 'ifTask']) >
                0 &&
                typeof new_options[tp] !== 'undefined' &&
                new_options[tp]['num'].indexOf(i) != -1) ||
                Number(
                  game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i + 'ifTask'],
                ) == 0) &&
              Number(game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['s' + i]) != -1
            ) {
              if (current_i != i)
                var task1 = game.add.sprite(
                  game.camera.width / 2 + (xiii - 1) * 180 - all_width / 2 + 90,
                  game.camera.height - 110,
                  renderTexture_1,
                );
              else
                var task1 = game.add.sprite(
                  game.camera.width / 2 + (xiii - 1) * 180 - all_width / 2 + 90,
                  game.camera.height - 110,
                  renderTexture_2,
                );
              xiii++;
              task1.anchor.setTo(0.5);
              popup_group.add(task1);
              task1.fixedToCamera = true;
              task1.obj = itm;
              task1.iii = i;
              button_animation_f(task1, 1);
              task1.events.onInputUp.add(function (item) {
                btnup(item);
                if (popup != 2) {
                  popup = 2;
                  game.add.tween(effects_group).to({ alpha: 1 }, 100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    popup = 1;
                  });
                  if (FTUEarrow1 != 0) {
                    FTUEarrow1.destroy();
                    FTUEarrow1 = 0;
                    FTUEarrow2.destroy();
                    FTUEarrow3.destroy();
                    w.destroy();
                    w = 0;
                  }
                  if (animation == 0 && current_i != item.iii) {
                    if (Math.abs(item.obj.type) == 7) {
                      if (fbv == 1 && FTUE < 50) {
                        window.eventTrack('FTUE_3_5_BenchChosen');
                      }
                    }
                    if (fbv == 1 && FTUE == 41.1) {
                      window.eventTrack('FTUE_14_4_Bench_changed');
                    }
                    if (sound_on == 1) {
                      play_sound('item_switched');
                    }
                    /*if (item.obj.type == 16) {
                      if (item.iii == 1) {
                        item.obj.children[0].x = 0;
                        item.obj.children[0].y = -14;
                      } else if (item.iii == 2) {
                        item.obj.children[0].x = -7;
                        item.obj.children[0].y = -10;
                      } else if (item.iii == 3) {
                        item.obj.children[0].x = -5;
                        item.obj.children[0].y = -5;
                      } else if (item.iii == 4) {
                        item.obj.children[0].x = -7;
                        item.obj.children[0].y = -10;
                      } else if (item.iii == 5) {
                        item.obj.children[0].x = -7;
                        item.obj.children[0].y = -10;
                      }
                    }*/
                    popup_group.children.forEach(function (child_item) {
                      if (child_item.iii > 0) {
                        child_item.loadTexture(renderTexture_1);
                      }
                    });
                    item.loadTexture(renderTexture_2);
                    if (current_i != item.iii) {
                      if (special_object.indexOf(Number(item.obj.type * m + '' + item.iii + '' + 1)) != -1) price = 0;
                      else if (
                        Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          's' + item.iii
                          ],
                        ) > 0
                      )
                        price = Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          's' + item.iii
                          ],
                        );
                      else price = 0;
                    } else price = 0;
                    if ((FTUE == 41.1 && fff == 1) || old_name == item.iii) {
                      price = 0;
                    }
                    ci = item.iii;

                    if (Math.abs(item.obj.type) == 174) {
                      var obj_des = 0;
                      objects_group.children.forEach(function (child_item) {
                        if ((child_item.type == 51 || child_item.type == -51 || child_item.frameName == 'tree2_broken.png') && child_item.frameName != 'tree.png') {
                          if (obj_des == 0) { obj_des = child_item; }
                          if (child_item.x > obj_des.x) { obj_des = child_item; }
                        }
                      });
                      if (ci == 1)
                        obj_des.alpha = 1;
                      else
                        obj_des.alpha = 0;
                    }

                    objects_group.children.forEach(function (child_item) {

                      if (
                        child_item.type == item.obj.type &&
                        sprite_name != 'chinmey_broken' &&
                        sprite_name != 'chinmey'
                      ) {
                        if (child_item.type != 4 && child_item.type != 6 && child_item.type != 128) {
                          child_item.loadTexture(
                            'farm_obj_c_atlas',
                            child_item.frameName.replace(current_i + '.', item.iii + '.'),
                            1,
                          );
                          child_item.x -=
                            Number(
                              game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                              'x' + current_i
                              ],
                            ) * 1.2;
                          child_item.y -=
                            Number(
                              game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                              'y' + current_i
                              ],
                            ) *
                            1.2 +
                            320 -
                            16;
                          child_item.x +=
                            Number(
                              game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                              'x' + item.iii
                              ],
                            ) * 1.2;
                          child_item.y +=
                            Number(
                              game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                              'y' + item.iii
                              ],
                            ) *
                            1.2 +
                            320 -
                            16;
                        } else if (child_item.type == 4) {
                          if (item.iii == 1) child_item.tint = 0xffd25e;
                          else if (item.iii == 2) child_item.tint = 0x71c1c9;
                          else if (item.iii == 3) child_item.tint = 0xffb990;
                          else if (item.iii == 4) child_item.tint = 0x808080;
                          else if (item.iii == 5) child_item.tint = 0xff00ff;
                          else if (item.iii == 6) child_item.tint = 0x993300;
                        } else if (child_item.type == 6) {
                          if (item.iii == 1) child_item.tint = 0xca8b5c;
                          else if (item.iii == 2) child_item.tint = 0x58431c;
                          else if (item.iii == 3) child_item.tint = 0x197760;
                          else if (item.iii == 4) child_item.tint = 0x7f6fac;
                          else if (item.iii == 5) child_item.tint = 0x3060a1;
                          else if (item.iii == 6) child_item.tint = 0xaf3636;
                        } else if (child_item.type == 128) {
                          if (item.iii == 1) child_item.tint = 0x889699;
                          else if (item.iii == 2) child_item.tint = 0xa49a7c;
                          else if (item.iii == 3) child_item.tint = 0x6c5364;
                          else if (item.iii == 4) child_item.tint = 0x287e92;
                          else if (item.iii == 5) child_item.tint = 0x8f320e;
                        }
                        if (child_item.type == 39) {
                          let numEl = parseInt(child_item.frameName.match(/\d(?=\D*$)/));
                          child_item.fount.destroy();
                          if (numEl != 7) {
                            var fountane_full = game.add.sprite(
                              child_item.x,
                              child_item.y,
                              'farm_obj_c_atlas',
                              'ff' + numEl + '_0.png',
                            );
                            fountane_full.scale.setTo(2.9);
                            fountane_full.anchor.setTo(0.5);
                            fountane_full.depth = child_item.depth;
                            objects_group.add(fountane_full);
                            fountane_full.animations.add(
                              'fountane_full',
                              [
                                'ff' + numEl + '_0.png',
                                'ff' + numEl + '_1.png',
                                'ff' + numEl + '_2.png',
                                'ff' + numEl + '_3.png',
                                'ff' + numEl + '_4.png',
                              ],
                              6,
                              true,
                            );
                            fountane_full.animations.play('fountane_full');
                          } else {
                            var fountane_full = game.add.sprite(child_item.x, child_item.y, 'farm_obj_c_atlas', 'fountane_full_' + numEl + '.png');
                            fountane_full.scale.setTo(2.9);
                            fountane_full.anchor.setTo(0.5);
                            fountane_full.depth = child_item.depth;
                            objects_group.add(fountane_full);
                          }
                          child_item.fount = fountane_full;
                        }
                        animation = 1;
                        if (
                          Math.abs(child_item.type) == 7 ||
                          (Math.abs(child_item.type) == 15 && child_item.frameName != 'flower_pot.png')
                        ) {
                          if (child_item.special)
                            game.add
                              .tween(child_item.special)
                              .to({ y: '-40' }, 200, Phaser.Easing.Exponential.Out, true)
                              .onComplete.add(function () {
                                game.add
                                  .tween(child_item.special)
                                  .to({ y: '+40' }, 300, Phaser.Easing.Bounce.Out, true);
                              });
                          game.add
                            .tween(child_item)
                            .to({ y: '-40' }, 200, Phaser.Easing.Exponential.Out, true)
                            .onComplete.add(function () {
                              game.add
                                .tween(child_item)
                                .to({ y: '+40' }, 300, Phaser.Easing.Bounce.Out, true)
                                .onComplete.add(function () {
                                  animation = 0;
                                });
                            });
                        } else animation = 0;
                      }
                    });
                    current_i = item.iii;
                    if (Item_Name_Price_BG != 0) {
                      Item_Name_Price_BG.destroy(true);
                    }
                    if (price > 0) {
                      information(item, price);
                    }
                  }
                }
              });
              if (itm.type == 4 || itm.type == -4) {
                var task1_image = game.add.graphics(0, 0);
                if (i == 1) {
                  task1_image.beginFill(0xffd25e);
                } else if (i == 2) {
                  task1_image.beginFill(0x71c1c9);
                } else if (i == 3) {
                  task1_image.beginFill(0xffb990);
                } else if (i == 4) {
                  task1_image.beginFill(0x808080);
                } else if (i == 5) {
                  task1_image.beginFill(0xff00ff);
                } else if (i == 6) {
                  task1_image.beginFill(0x993300);
                }
                task1_image.drawRect(-40, -40, 80, 80);
              } else if (itm.type == 6 || itm.type == -6) {
                var task1_image = game.add.graphics(0, 0);
                if (i == 1) {
                  task1_image.beginFill(0xca8b5c);
                } else if (i == 2) {
                  task1_image.beginFill(0x58431c);
                } else if (i == 3) {
                  task1_image.beginFill(0x197760);
                } else if (i == 4) {
                  task1_image.beginFill(0x7f6fac);
                } else if (i == 5) {
                  task1_image.beginFill(0x3060a1);
                } else if (i == 6) {
                  task1_image.beginFill(0xaf3636);
                }
                task1_image.drawRect(-40, -40, 80, 80);
              } else if (itm.type == 128 || itm.type == -128) {
                var task1_image = game.add.graphics(0, 0);
                if (i == 1) {
                  task1_image.beginFill(0x889699);
                } else if (i == 2) {
                  task1_image.beginFill(0xa49a7c);
                } else if (i == 3) {
                  task1_image.beginFill(0x6c5364);
                } else if (i == 4) {
                  task1_image.beginFill(0x287e92);
                } else if (i == 5) {
                  task1_image.beginFill(0x8f320e);
                }
                task1_image.drawRect(-40, -40, 80, 80);
              } else {
                if ((sprite_name == 'tulip_purple_' || sprite_name == 'tulip_yellow_') && Math.abs(itm.type) == 28) {
                  var task1_image = game.add.sprite(0, 0, 'farm_obj_c_atlas', 'flower_orange_' + i + '.png');
                } else
                  if (sprite_name == 'Bowl_Empty_') {
                    var task1_image = game.add.sprite(0, 0, 'build_icon_atlas', 'Bowl_Empty_' + i + '.png');
                  } else if (sprite_name == 'b_lamp_' || sprite_name == 'f_lamp_' || sprite_name == 'lamp_') {
                    var task1_image = game.add.sprite(0, 0, 'game_ui_atlas', 'b_lamp_' + i + '.png');
                  } else var task1_image = game.add.sprite(0, 0, 'farm_obj_c_atlas', sprite_name + i + '.png');
                if (task1_image.width > task1_image.height) task1_image.scale.setTo(120 / task1_image.width);
                else task1_image.scale.setTo(120 / task1_image.height);
                task1_image.anchor.setTo(0.5);
              }

              task1.addChild(task1_image);
              if ((complete_level_spec == 100 || complete_level_spec == 101) && itm.type == 9 && (i == 4 || i == 5)) {
                var task1_new = game.add.sprite(30, -31, 'game_window_atlas', 'NEW_ITEM_RIBBON.png');
                task1_new.anchor.setTo(0.5);
                task1.addChild(task1_new);
                var new_text = game.add.text(
                  task1.width / 2 - 40,
                  -task1.height / 2 + 37,
                  game.cache.getJSON('lang')['t392'][0][window.lang],
                  { font: '28px RussoOne', fill: '#FFF', align: 'center' },
                );
                new_text.angle = 46;
                new_text.anchor.setTo(0.5);
                task1.addChild(new_text);
                complete_level_spec += 1;
              }
              var fi = new_options.findIndex(function (e) {
                return Number(e['type']) == Math.abs(Number(itm.type));
              });
              if (fi != -1 && new_options[fi]['num'].indexOf(i) != -1) {
                var task1_new = game.add.sprite(30, -31, 'game_window_atlas', 'NEW_ITEM_RIBBON.png');
                task1_new.anchor.setTo(0.5);
                task1.addChild(task1_new);
                var new_text = game.add.text(
                  task1.width / 2 - 40,
                  -task1.height / 2 + 37,
                  game.cache.getJSON('lang')['t392'][0][window.lang],
                  { font: '28px RussoOne', fill: '#FFF', align: 'center' },
                );
                new_text.angle = 46;
                new_text.anchor.setTo(0.5);
                task1.addChild(new_text);
              }
              if (special_object.indexOf(Number(itm.type * m + '' + i + '' + 1)) != -1) {
                var task1_check = game.add.sprite(0, 80, 'game_ui_atlas', 'Green_Check_Sign_Background.png');
                task1_check.anchor.setTo(0.5);
                task1.addChild(task1_check);
                var task1_check = game.add.sprite(0, 80, 'game_ui_atlas', 'Task_Completed_Check.png');
                task1_check.scale.setTo(0.5);
                task1_check.anchor.setTo(0.5);
                task1.addChild(task1_check);
              }
            }
          }

          if (
            new_options.findIndex(function (e) {
              return Number(e['type']) == Number(itm.type);
            }) != -1
          ) {
            new_options[
              new_options.findIndex(function (e) {
                return Number(e['type']) == Number(itm.type);
              })
            ]['type'] *= -1;
            game.setUserDataAndLog({ new_options: JSON.stringify(new_options) });
          }

          /*if (
            new_options.findIndex(function (e) {
              return Number(e['type']) == Number(itm.type);
            }) != -1
          ) {
            new_options.splice(
              new_options.findIndex(function (e) {
                return Number(e['type']) == Number(itm.type);
              }),
              1,
            );
            new_options.push({ type: -Math.abs(Number(itm.type)), num: [] });
            game.setUserDataAndLog({ new_options: JSON.stringify(new_options) });
          }*/
          var green_button = game.add.sprite(
            game.camera.width / 2 + 800,
            game.camera.height - 110,
            'game_window_atlas',
            'Agree_Button.png',
          );
          green_button.anchor.setTo(0.5);
          green_button.scale.setTo(1);
          green_button.obj = itm;
          green_button.click = 0;
          button_animation_f(green_button, 1);
          green_button.events.onInputUp.add(function (item) {
            if (item.click == 0 && popup != 2) {
              if (Math.abs(item.obj.type) == 7) {
                if (fbv == 1 && FTUE < 50) {
                  window.eventTrack('FTUE_3_6_ChosenBenchConfirmed');
                }
              }
              if (fbv == 1 && FTUE == 41.1) {
                FTUE_check = 2;
                window.eventTrack('FTUE_14_5_Confirm_Bench_button_clicked');
              }
              btnup(item);
              special_build = 0;
              if (coins >= price && animation == 0) {


                if (FTUE > 30 && price > 0)
                  for (var i = 0; i < missions.length; i += 4) {
                    if (missions[i] == -3) {
                      if (missions[i + 2] < missions[i + 1]) {
                        missions[i + 2] += 1;
                      }
                    }
                  }

                item.click = 1;
                special_stage = 0;
                first_create = 0;
                if (sound_on == 1) {
                  play_sound('item_confirmed');
                }
                var timer = 2500;
                popup = 1;
                if (old_name != current_i || check_input != true) {
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.type == item.obj.type || child_item.type == -item.obj.type) {
                      if (sound_on == 1) {
                        play_sound('default_construction_done');
                      }
                      add_shines(child_item, 3, 1);
                      add_shines(child_item, 3, 1);
                      add_shines(child_item, 3, 1);
                      if (Math.abs(child_item.type) == 4 || Math.abs(child_item.type) == 6) {
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                        add_shines(child_item, 3, 1);
                      }
                      if (child_item.type == 7 || (child_item.type == 15 && child_item.frameName != 'flower_pot.png')) {
                        game.add
                          .tween(child_item)
                          .to({ y: '-40' }, 200, Phaser.Easing.Exponential.Out, true)
                          .onComplete.add(function () {
                            game.add.tween(child_item).to({ y: '+40' }, 300, Phaser.Easing.Bounce.Out, true);
                          });
                      } else if (
                        child_item.type == 24 ||
                        child_item.type == 54 ||
                        child_item.type == 43 ||
                        child_item.type == 95 ||
                        child_item.type == 96 ||
                        child_item.type == 541 ||
                        child_item.type == 431 ||
                        child_item.type == 109 ||
                        child_item.type == 184
                      ) {
                        if (game.rnd.integerInRange(1, 3) == 2) hummer_anim(child_item);
                      }
                    }
                  });
                  if (check_input == null) {
                    if (
                      (Math.abs(item.obj.type) != 140 &&
                        game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + item.obj.iii][0]['Dialog'] ==
                        '0') ||
                      (map_n == 15 &&
                        Math.abs(item.obj.type) == 140 &&
                        game.cache.getJSON('buildings')['Day' + map_n][0]['Building17'][0]['Dialog'] == '0')
                    ) {
                      timer = 500;
                      popup = 0;
                    }
                  } else {
                    timer = 500;
                    popup = 0;
                  }
                } else {
                  timer = 500;
                  popup = 0;
                }
                if (check_input == true) special_show(1);
                if (FTUEarrow1 != 0) {
                  FTUEarrow1.destroy();
                  FTUEarrow1 = 0;
                  FTUEarrow2.destroy();
                  FTUEarrow3.destroy();
                  w.destroy();
                  w = 0;
                }
                f_w_a();
                if (
                  map_tiled_st.findIndex(function (e) {
                    return Number(e['i']) == Number(itm.type);
                  }) == -1
                )
                  map_tiled_st.push({ i: Number(itm.type), s: Number(current_i) });
                else {
                  map_tiled_st[
                    map_tiled_st.findIndex(function (e) {
                      return Number(e['i']) == Number(itm.type);
                    })
                  ]['s'] = Number(current_i);
                }
                if (special_object.indexOf(Number(item.obj.type * m + '' + ci + '' + 1)) == -1)
                  special_object.push(Number(item.obj.type * m + '' + ci + '' + 1));
                coins -= price;
                if (check_input != true) {
                  game.setCurrentEvent();
                  window.eventTrack('mission_completed', 1, {
                    user_type: bought,
                    lifetime: lifetime_day,
                    highest_lvl: all_level.lastIndexOf(3) + 2,
                    name:
                      game.cache.getJSON('lang')[
                      game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['name']
                      ][0]['en'] +
                      '-' +
                      String(current_i),
                    price: price,
                    optional: 0,
                    mission_completed: missioncompleted,
                    c_event: current_event,
                  });
                }
                game.setCurrentEvent();
                window.eventTrack('coins_out', price, {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: price,
                  source: 'build object',
                  item_id: game.cache.getJSON('lang')[
                    game.cache.getJSON('buildings')['Special'][0]['Special' + itm.type * m][0]['name']
                  ][0]['en'],
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                text_coins_panel.setText(coins);
                game.setUserDataAndLog({
                  special_object: JSON.stringify(special_object),
                  map_tiled_st: JSON.stringify(map_tiled_st),
                });
                game.add.tween(UI_bottom_group).to({ y: '-400' }, 500, Phaser.Easing.Exponential.Out, true);
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, timer, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function () {
                    popup_group.removeAll(true);
                    popup_group.y -= game.camera.height;
                    if (FTUE == 41.1 && fff == 1) {
                      w = ftue_window(
                        'Main_Presenting.png',
                        game.cache.getJSON('lang')['t325'][0][window.lang],
                        game.camera.width / 2 + 140,
                        game.camera.height - 140,
                      );
                      if (sound_on == 1) {
                        play_sound('hint_with_arrow');
                      }
                      FTUE_Arrow = game.add.sprite(
                        game.camera.width / 2 - 745,
                        game.camera.height - 120,
                        'game_atlas',
                        'FTUE_Arrow.png',
                      );
                      FTUE_Arrow.anchor.setTo(0.5, 1.6);
                      FTUE_Arrow.fixedToCamera = true;
                      game.add
                        .tween(FTUE_Arrow.anchor)
                        .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                        .yoyo(true, 200);
                      effects_group.add(FTUE_Arrow);
                      game.world.bringToTop(effects_group);
                      fff = 2;
                      game.saveDataAll();
                    }
                    if (check_input == null) {
                      if (
                        (Math.abs(item.obj.type) != 140 &&
                          game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + item.obj.iii][0]['Dialog'] ==
                          '0') ||
                        (map_n == 15 &&
                          Math.abs(item.obj.type) == 140 &&
                          game.cache.getJSON('buildings')['Day' + map_n][0]['Building17'][0]['Dialog'] == '0')
                      ) {
                        popup = 0;
                        taks_indicator();
                      } else {
                        popup = 0;
                        if (Math.abs(item.obj.type) == 140)
                          dialog_window(
                            Number(game.cache.getJSON('buildings')['Day' + map_n][0]['Building17'][0]['Dialog']),
                            0,
                          );
                        else
                          dialog_window(
                            Number(
                              game.cache.getJSON('buildings')['Day' + map_n][0]['Building' + item.obj.iii][0]['Dialog'],
                            ),
                            0,
                          );
                      }
                    } else popup = 0;
                  });
                if (check_input != true)
                  if (item.obj.type == 33) {
                    var chimney_smoke = game.add.sprite(
                      item.obj.x,
                      item.obj.y,
                      'farm_obj_c_atlas',
                      'Chimney_Smoke_1.png',
                    );
                    chimney_smoke.scale.setTo(2.9);
                    chimney_smoke.anchor.setTo(0.65);
                    chimney_smoke.depth = 100;
                    objects_group.add(chimney_smoke);
                    chimney_smoke.animations.add(
                      'chimney_smoke',
                      [
                        'Chimney_Smoke_1.png',
                        'Chimney_Smoke_2.png',
                        'Chimney_Smoke_3.png',
                        'Chimney_Smoke_4.png',
                        'Chimney_Smoke_5.png',
                      ],
                      10,
                      true,
                    );
                    chimney_smoke.animations.play('chimney_smoke');
                  }
              } else if (animation == 0) {
                item.click = 1;
                animation = 1;
                game.add.tween(UI_bottom_group).to({ y: '-400' }, 500, Phaser.Easing.Exponential.Out, true);
                objects_group.children.forEach(function (child_item) {
                  if (
                    (child_item.type == item.obj.type || child_item.type == -item.obj.type) &&
                    sprite_name != 'chinmey_broken' &&
                    sprite_name != 'chinmey'
                  ) {
                    if (
                      child_item.type != 4 &&
                      child_item.type != -4 &&
                      child_item.type != 6 &&
                      child_item.type != -6 &&
                      child_item.type != 128 &&
                      child_item.type != -128
                    ) {
                      child_item.loadTexture(
                        'farm_obj_c_atlas',
                        child_item.frameName.replace(current_i + '.', old_name + '.'),
                        1,
                      );
                      child_item.x -=
                        Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          'x' + current_i
                          ],
                        ) * 1.2;
                      child_item.y -=
                        Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          'y' + current_i
                          ],
                        ) *
                        1.2 +
                        320 -
                        16;
                      child_item.x +=
                        Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          'x' + old_name
                          ],
                        ) * 1.2;
                      child_item.y +=
                        Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          'y' + old_name
                          ],
                        ) *
                        1.2 +
                        320 -
                        16;
                    } else if (child_item.type == 4) {
                      if (old_name == 1) child_item.tint = 0xffd25e;
                      else if (old_name == 2) child_item.tint = 0x71c1c9;
                      else if (old_name == 3) child_item.tint = 0xffb990;
                      else if (old_name == 4) child_item.tint = 0x808080;
                      else if (old_name == 5) child_item.tint = 0xff00ff;
                      else if (old_name == 6) child_item.tint = 0x993300;
                    } else if (child_item.type == 6) {
                      if (old_name == 1) child_item.tint = 0xca8b5c;
                      else if (old_name == 2) child_item.tint = 0x58431c;
                      else if (old_name == 3) child_item.tint = 0x197760;
                      else if (old_name == 4) child_item.tint = 0x7f6fac;
                      else if (old_name == 5) child_item.tint = 0x3060a1;
                      else if (old_name == 6) child_item.tint = 0xaf3636;
                    } else if (child_item.type == 128) {
                      if (old_name == 1) child_item.tint = 0x889699;
                      else if (old_name == 2) child_item.tint = 0xa49a7c;
                      else if (old_name == 3) child_item.tint = 0x6c5364;
                      else if (old_name == 4) child_item.tint = 0x287e92;
                      else if (old_name == 5) child_item.tint = 0x8f320e;
                    }
                    if (child_item.type == 39) {
                      let numEl = parseInt(child_item.frameName.match(/\d(?=\D*$)/));
                      child_item.fount.destroy();
                      if (numEl != 7) {
                        var fountane_full = game.add.sprite(
                          child_item.x,
                          child_item.y,
                          'farm_obj_c_atlas',
                          'ff' + numEl + '_0.png',
                        );
                        fountane_full.scale.setTo(2.9);
                        fountane_full.anchor.setTo(0.5);
                        fountane_full.depth = child_item.depth;
                        objects_group.add(fountane_full);
                        fountane_full.animations.add(
                          'fountane_full',
                          [
                            'ff' + numEl + '_0.png',
                            'ff' + numEl + '_1.png',
                            'ff' + numEl + '_2.png',
                            'ff' + numEl + '_3.png',
                            'ff' + numEl + '_4.png',
                          ],
                          6,
                          true,
                        );
                        fountane_full.animations.play('fountane_full');
                      } else {
                        var fountane_full = game.add.sprite(child_item.x, child_item.y, 'farm_obj_c_atlas', 'fountane_full_' + numEl + '.png');
                        fountane_full.scale.setTo(2.9);
                        fountane_full.anchor.setTo(0.5);
                        fountane_full.depth = child_item.depth;
                        objects_group.add(fountane_full);
                      }
                      child_item.fount = fountane_full;
                    }
                  }
                });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    animation = 0;
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    if (shop == 1) {
                      shop_window(
                        0,
                        0,
                        0,
                        [
                          { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                          { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                          { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                          { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                          {
                            4: {
                              id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                              packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                              price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                              reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                            },
                          },
                        ],
                        [
                          {
                            0: {
                              type: 'Coins_Pack_1.png',
                              sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                              col: '1 000',
                              id: 'coin_package_001',
                              packname: '1,000 Coins',
                              price: '0.99 $',
                              atlas: 'game_window_atlas',
                              reward: [1000],
                            },
                          },
                          {
                            1: {
                              type: 'Coins_Pack_2.png',
                              sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                              col: '6 000',
                              id: 'coin_package_02',
                              packname: '6,000 Coins',
                              price: '4.99 $',
                              atlas: 'game_window_atlas',
                              reward: [6000],
                            },
                          },
                          {
                            2: {
                              type: 'Coins_Pack_3.png',
                              sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                              col: '13 000',
                              id: 'coin_package_003',
                              packname: '13,000 Coins',
                              price: '9.99 $',
                              atlas: 'game_window_atlas',
                              reward: [13000],
                            },
                          },
                          {
                            3: {
                              type: 'Coins_Pack_4.png',
                              sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                              col: '20 000',
                              id: 'coin_package_004',
                              packname: '20,000 Coins',
                              price: '14.99 $',
                              atlas: 'game_window_atlas',
                              reward: [20000],
                            },
                          },
                        ],
                      );
                    } else if (shop == 0) {
                      get_message(2);
                    }
                  });
              }
            }
          });
          popup_group.add(green_button);
          green_button.fixedToCamera = true;
          if (check_input == true && FTUE != 41.1) {
            var green_button = game.add.sprite(
              game.camera.width / 2 - 800,
              game.camera.height - 110,
              'game_window_atlas',
              'Cancel_Button.png',
            );
            green_button.anchor.setTo(0.5);
            green_button.scale.setTo(1);
            green_button.obj = itm;
            green_button.click = 0;
            button_animation_f(green_button, 1);
            green_button.events.onInputUp.add(function (item) {
              btnup(item);
              if (animation == 0 && item.click == 0) {

                if (Math.abs(item.obj.type) == 174) {
                  var obj_des = 0;
                  objects_group.children.forEach(function (child_item) {
                    if ((child_item.type == 51 || child_item.type == -51 || child_item.frameName == 'tree2_broken.png') && child_item.frameName != 'tree.png') {
                      if (obj_des == 0) { obj_des = child_item; }
                      if (child_item.x > obj_des.x) { obj_des = child_item; }
                    }
                  });
                  if (old_name == 1)
                    obj_des.alpha = 1;
                  else
                    obj_des.alpha = 0;
                }

                item.click = 1;
                special_stage = 0;
                first_create = 0;
                special_build = 0;
                animation = 1;
                game.add.tween(UI_bottom_group).to({ y: '-400' }, 500, Phaser.Easing.Exponential.Out, true);
                objects_group.children.forEach(function (child_item) {
                  if (
                    (child_item.type == item.obj.type || child_item.type == -item.obj.type) &&
                    sprite_name != 'chinmey_broken' &&
                    sprite_name != 'chinmey'
                  ) {
                    if (
                      child_item.type != 4 &&
                      child_item.type != -4 &&
                      child_item.type != 6 &&
                      child_item.type != -6 &&
                      child_item.type != 128 &&
                      child_item.type != -128
                    ) {
                      child_item.loadTexture(
                        'farm_obj_c_atlas',
                        child_item.frameName.replace(current_i + '.', old_name + '.'),
                        1,
                      );
                      child_item.x -=
                        Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          'x' + current_i
                          ],
                        ) * 1.2;
                      child_item.y -=
                        Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          'y' + current_i
                          ],
                        ) *
                        1.2 +
                        320 -
                        16;
                      child_item.x +=
                        Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          'x' + old_name
                          ],
                        ) * 1.2;
                      child_item.y +=
                        Number(
                          game.cache.getJSON('buildings')['Special'][0]['Special' + item.obj.type * m][0][
                          'y' + old_name
                          ],
                        ) *
                        1.2 +
                        320 -
                        16;
                    } else if (child_item.type == 4) {
                      if (old_name == 1) child_item.tint = 0xffd25e;
                      else if (old_name == 2) child_item.tint = 0x71c1c9;
                      else if (old_name == 3) child_item.tint = 0xffb990;
                      else if (old_name == 4) child_item.tint = 0x808080;
                      else if (old_name == 5) child_item.tint = 0xff00ff;
                      else if (old_name == 6) child_item.tint = 0x993300;
                    } else if (child_item.type == 6) {
                      if (old_name == 1) child_item.tint = 0xca8b5c;
                      else if (old_name == 2) child_item.tint = 0x58431c;
                      else if (old_name == 3) child_item.tint = 0x197760;
                      else if (old_name == 4) child_item.tint = 0x7f6fac;
                      else if (old_name == 5) child_item.tint = 0x3060a1;
                      else if (old_name == 6) child_item.tint = 0xaf3636;
                    } else if (child_item.type == 128) {
                      if (old_name == 1) child_item.tint = 0x889699;
                      else if (old_name == 2) child_item.tint = 0xa49a7c;
                      else if (old_name == 3) child_item.tint = 0x6c5364;
                      else if (old_name == 4) child_item.tint = 0x287e92;
                      else if (old_name == 5) child_item.tint = 0x8f320e;
                    }
                    if (child_item.type == 39) {
                      let numEl = parseInt(child_item.frameName.match(/\d(?=\D*$)/));
                      child_item.fount.destroy();
                      if (numEl != 7) {
                        var fountane_full = game.add.sprite(
                          child_item.x,
                          child_item.y,
                          'farm_obj_c_atlas',
                          'ff' + numEl + '_0.png',
                        );
                        fountane_full.scale.setTo(2.9);
                        fountane_full.anchor.setTo(0.5);
                        fountane_full.depth = child_item.depth;
                        objects_group.add(fountane_full);
                        fountane_full.animations.add(
                          'fountane_full',
                          [
                            'ff' + numEl + '_0.png',
                            'ff' + numEl + '_1.png',
                            'ff' + numEl + '_2.png',
                            'ff' + numEl + '_3.png',
                            'ff' + numEl + '_4.png',
                          ],
                          6,
                          true,
                        );
                        fountane_full.animations.play('fountane_full');
                      } else {
                        var fountane_full = game.add.sprite(child_item.x, child_item.y, 'farm_obj_c_atlas', 'fountane_full_' + numEl + '.png');
                        fountane_full.scale.setTo(2.9);
                        fountane_full.anchor.setTo(0.5);
                        fountane_full.depth = child_item.depth;
                        objects_group.add(fountane_full);
                      }
                      child_item.fount = fountane_full;
                    }
                  }
                });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    animation = 0;
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                  });
                if (check_input == true) special_show(1);
              }
            });
            popup_group.add(green_button);
            green_button.fixedToCamera = true;
          }
          game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
        }
        itm.inputEnabled = true;
        itm.input.pixelPerfectClick = true;
        if (itm.type == 7 || itm.type == -7 || itm.type == 10 || itm.type == -10) {
          itm.input.pixelPerfectClick = false;
        }
      }
    }

    function special_show(n) {
      objects_group.children.forEach(function (child_item) {
        if (child_item.inputEnabled == true && child_item.special) {
          child_item.special.destroy(true);
          child_item.special = 0;
        }
      });
      popup = 1;
      animation = 1;
      UI_right_controll = 1;
      for (var i = 0; i < taks_indicator_mas.length; i++) {
        taks_indicator_mas[i].destroy();
      }
      taks_indicator_mas = [];
      var type_controll = [];
      game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
        if (FTUE != 41.1) {
          animation = 0;
          popup = 0;
        }
      });
      objects_group.children.forEach(function (child_item) {
        if (
          child_item.inputEnabled == true &&
          !child_item.special &&
          type_controll.indexOf(child_item.type) == -1 &&
          child_item.frameName != 'window_5.png' &&
          child_item.frameName != 'window_6.png' &&
          child_item.frameName != 'window_7.png' &&
          child_item.frameName != 'house_1_1.png' &&
          child_item.frameName != 'house_1_2.png' &&
          child_item.frameName != 'house_1_3.png' &&
          child_item.frameName != 'house_2_1.png' &&
          child_item.frameName != 'house_2_2.png' &&
          child_item.frameName != 'house_2_3.png'
        ) {
          type_controll.push(child_item.type);
          if (
            child_item.type == 7 ||
            child_item.type == 6 ||
            child_item.type == 15 ||
            child_item.type == 16 ||
            child_item.type == 35 ||
            child_item.type == 39 ||
            child_item.type == 55 ||
            child_item.type == 47
          )
            var special_icon = game.add.sprite(child_item.x, child_item.y, 'game_ui_atlas', 'Indicator_Furniture.png');
          else if (
            child_item.type == 6 ||
            child_item.type == 14 ||
            child_item.type == 4 ||
            child_item.type == 5 ||
            child_item.type == 10 ||
            child_item.type == 12 ||
            child_item.type == 30 ||
            child_item.type == 31 ||
            child_item.type == 11 ||
            child_item.type == 33 ||
            child_item.type == 54 ||
            child_item.type == 541 ||
            child_item.type == 43 ||
            child_item.type == 431 ||
            child_item.type == 95 ||
            child_item.type == 96 ||
            child_item.type == 106 ||
            child_item.type == 24
          )
            var special_icon = game.add.sprite(child_item.x, child_item.y, 'game_ui_atlas', 'Indicator_House.png');
          else var special_icon = game.add.sprite(child_item.x, child_item.y, 'game_ui_atlas', 'Indicator_Plant.png');
          special_icon.anchor.setTo(0.5, 1);
          special_icon.scale.setTo(0);
          special_icon.obj = child_item;
          special_icon.inputEnabled = true;
          special_icon.input.useHandCursor = true;
          special_icon.input.priorityID = 500;
          special_icon.events.onInputDown.add(function (item) {
            map_stop = 1;
          });
          special_icon.events.onInputUp.add(function (item) {
            map_stop = 0;
            if (fbv == 1 && FTUE == 41.1) {
              window.eventTrack('FTUE_14_3_bench_icon_clicked');
            }

            // TODO this prevents it from working in the beginning!
            if ((popup == 0 && FTUE != 41.1) || (FTUE == 41.1 && animation == 0 && FTUE_Arrow != 0)) {
              UI_right_controll = 0;
              build_special_object(item.obj, 1);
            }
          });
          child_item.special = special_icon;
          objects_group.addChild(special_icon);
          if (child_item.type == 59) {
            special_icon.x += 100;
            special_icon.y -= 110;
          } else if (child_item.type == 146 || child_item.type == 147) {
            special_icon.y -= 100;
          } else if (child_item.type == 129) {
            special_icon.x += 50;
          } else if (child_item.type == 117) {
            special_icon.x += 140;
            special_icon.y -= 130;
          } else if (child_item.type == 4) {
            special_icon.x -= 210;
          } else if (child_item.type == 40) {
            special_icon.x += 60;
            special_icon.y += 150;
          } else if (child_item.type == 43) {
            special_icon.x += 400;
            special_icon.y += 220;
          } else if (child_item.type == 431) {
            special_icon.x += 400;
            special_icon.y += 300;
          } else if (child_item.type == 24) {
            special_icon.x += 150;
          } else if (child_item.type == 95) {
            special_icon.x = 3133.2;
            special_icon.y = 1888;
          } else if (child_item.type == 96) {
            special_icon.x = 3230.4;
            special_icon.y = 1738;
          } else if (child_item.type == 53) {
            special_icon.x -= 1070;
            special_icon.y += 920;
          } else if (child_item.type == 63 || child_item.type == 47 || child_item.type == 57) {
            special_icon.y -= 70;
          } else if (child_item.type == 55) {
            special_icon.y -= 40;
          } else if (child_item.type == 16) {
            special_icon.y -= 70;
            special_icon.x += 10;
          } else if (child_item.type == 170) {
            special_icon.y -= 70;
            special_icon.x += 10;
          }
          game.add
            .tween(special_icon)
            .to({ y: '-40' }, 200, Phaser.Easing.Exponential.Out, true, 400)
            .onComplete.add(function () {
              game.add
                .tween(special_icon)
                .to({ y: '+40' }, 300, Phaser.Easing.Bounce.Out, true)
                .onComplete.add(function () {
                  //if (FTUE != 41.1) {popup = 0;}
                });
            });
          game.add
            .tween(special_icon.scale)
            .to({ x: 1, y: 1 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function () {
              //if (FTUE != 41.1) {popup = 0;}
            });
          if (
            new_options.findIndex(function (e) {
              return Number(e['type']) == Number(child_item.type);
            }) != -1
          ) {
            special_icon.loadTexture('game_ui_atlas', 'Indicator_Exclamation_Point.png');
          }
          if (complete_level_spec < 100 && complete_level_spec != -1 && child_item.type == 9) {
            special_icon.loadTexture('game_ui_atlas', 'Indicator_Exclamation_Point.png');
            complete_level_spec = 100;
          }
          if (complete_task_spec < 100 && complete_task_spec != -1 && child_item.type == 34) {
            special_icon.loadTexture('game_ui_atlas', 'Indicator_Exclamation_Point.png');
            complete_task_spec = 100;
          }
        } else if (child_item.special) {
          type_controll.push(child_item.type);
        }
      });
      type_controll = [];
      if (!n) bottom_button(0, 0, 0, UI_bottom_group, -1);
    }

    var button_setting = 0;
    var wheel_icon = 0;
    var wheel_ad_icon = 0;
    var friends_icon = 0;
    var wheel_icon_shine = 0;
    var friends_icon_timer = 0;
    var Wheel_Sale_Ribbon = 0;
    var Timer_BG = 0;
    window.UI_right_create = function () {
      button_setting = game.add.sprite(game.camera.width - 140, 100, 'game_ui_atlas', 'Settings_Button.png');
      button_setting.anchor.setTo(0.5);
      button_setting.priorityID = 1000;
      button_animation_f(button_setting, 1);
      button_setting.events.onInputUp.add(function (item) {
        btnup(item);
        if (animation == 0 && popup == 0 && FTUE != 152 && update_controll == 0) setting_window();
      });
      button_setting.fixedToCamera = true;
      UI_right_group.add(button_setting);
      if (FTUE >= 151 && fbv == 1 && all_level[10] > 0) {
        friends_icon = game.add.sprite(game.camera.width - 140, 550, '');
        friends_icon.fixedToCamera = true;
        UI_right_group.add(friends_icon);
        var friends_icon_shine = game.add.sprite(0, 0, 'game_ui_atlas', 'shine.png');
        friends_icon_shine.anchor.setTo(0.5);
        rotate_tween(friends_icon_shine);
        friends_icon.addChild(friends_icon_shine);
        var friends_icon_icon = game.add.sprite(-15, 0, 'game_ui_atlas', 'Gift_Box.png');
        friends_icon_icon.anchor.setTo(0.5);
        friends_icon_icon.inputEnabled = true;
        friends_icon_icon.priorityID = 1000;
        friends_icon_icon.events.onInputDown.add(function (item) {
          if (update_controll == 0) {
            if (button_setting.alpha == 0) {
              button_setting.alpha = 1;
              wheel_icon.alpha = 1;
            }
            friends_window();
          }
        });
        friends_icon.addChild(friends_icon_icon);
        var friends_icon_b = game.add.sprite(0, 112, 'game_ui_atlas', 'Button_ui.png');
        friends_icon_b.anchor.setTo(0.5);
        button_animation_f(friends_icon_b, 1);
        friends_icon_b.priorityID = 1000;
        friends_icon_b.events.onInputDown.add(function (item) {
          if (sound_on == 1) {
            play_sound('button_press');
          }
          btnup(item);
          if (update_controll == 0) {
            if (button_setting.alpha == 0) {
              button_setting.alpha = 1;
              wheel_icon.alpha = 1;
            }
            friends_window();
          }
        });
        friends_icon.addChild(friends_icon_b);
        var friends_icon_text = game.add.text(0, -3, game.cache.getJSON('lang')['t282'][0][window.lang], {
          font: '30px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        friends_icon_text.anchor.setTo(0.5);
        friends_icon_text.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
        friends_icon_b.addChild(friends_icon_text);
        friends_icon_timer = game.add.text(0, 165, '', { font: '30px RussoOne', fill: '#fff', align: 'center' });
        friends_icon_timer.anchor.setTo(0.5);
        friends_icon_timer.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
        friends_icon.addChild(friends_icon_timer);
      }
      wheel_icon = game.add.sprite(game.camera.width - 140, 280, '');
      wheel_icon.fixedToCamera = true;
      wheel_icon_shine = game.add.sprite(0, 0, 'game_ui_atlas', 'shine.png');
      wheel_icon_shine.anchor.setTo(0.5);
      if (wheel_num <= 0) {
        wheel_icon_shine.alpha = 0;
      }
      wheel_icon.addChild(wheel_icon_shine);
      rotate_tween(wheel_icon_shine);
      var wheel_icon_icon = game.add.sprite(0, 0, 'game_ui_atlas', 'Wheel_Button_Free_Spin.png');
      wheel_icon_icon.anchor.setTo(0.5);
      wheel_icon_icon.inputEnabled = true;
      wheel_icon_icon.priorityID = 1000;
      wheel_icon_icon.events.onInputDown.add(function () {
        if (wheel_icon.alpha != 0 && FTUE != 152 && update_controll == 0) {
          if (fbv == 1 && FTUE == 36) {
            window.eventTrack('FTUE_13_2Wheel_icon_clicked');
          }
          if (button_setting.alpha == 0) {
            button_setting.alpha = 1;
          }
          wheel_window();
        }
      });
      wheel_icon.addChild(wheel_icon_icon);
      var wheel_icon_b = game.add.sprite(0, 100, 'game_ui_atlas', 'Button_ui.png');
      wheel_icon_b.anchor.setTo(0.5);
      button_animation_f(wheel_icon_b, 1);
      wheel_icon_b.priorityID = 1000;
      wheel_icon_b.events.onInputDown.add(function (item) {
        btnup(item);
        if (wheel_icon.alpha != 0 && FTUE != 152 && update_controll == 0) {
          if (fbv == 1 && FTUE == 36) {
            window.eventTrack('FTUE_13_2Wheel_icon_clicked');
          }
          if (button_setting.alpha == 0) {
            button_setting.alpha = 1;
          }
          wheel_window();
        }
      });
      var wheel_b_text = game.add.text(0, -3, game.cache.getJSON('lang')['t283'][0][window.lang], {
        font: '30px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      wheel_b_text.anchor.setTo(0.5);
      wheel_b_text.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
      wheel_icon_b.addChild(wheel_b_text);
      wheel_icon.addChild(wheel_icon_b);
      Wheel_Sale_Ribbon = game.add.sprite(0, -3, 'game_ui_atlas', 'Wheel_Sale_Ribbon.png');
      Wheel_Sale_Ribbon.anchor.setTo(0.5);
      Wheel_Sale_Ribbon.alpha = 0;
      wheel_icon_icon.addChild(Wheel_Sale_Ribbon);
      Timer_BG = game.add.sprite(-6, -22, 'game_ui_atlas', 'Timer_BG.png');
      Timer_BG.anchor.setTo(0.5);
      Timer_BG.alpha = 0;
      wheel_icon_icon.addChild(Timer_BG);
      var wheel_icon_SALEtext = game.add.text(-8, -15, game.cache.getJSON('lang')['SALE'][0][window.lang], {
        font: '18px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      wheel_icon_SALEtext.anchor.setTo(0.5);
      wheel_icon_SALEtext.stroke = '#44190F';
      wheel_icon_SALEtext.strokeThickness = 2;
      wheel_icon_SALEtext.angle = -22;
      Timer_BG.addChild(wheel_icon_SALEtext);
      wheel_icon_text2 = game.add.text(0, 2, '', { font: '16px RussoOne', fill: '#fff', align: 'center' });
      wheel_icon_text2.anchor.setTo(0.5);
      wheel_icon_text2.angle = -22;
      wheel_icon_text2.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
      Timer_BG.addChild(wheel_icon_text2);
      wheel_max = 3;
      if (wheel_max <= 0) {
        wheel_icon.alpha = 0;
        wheel_icon.children.forEach(function (child_item) {
          child_item.inputEnabled = false;
        });
        if (friends_icon != 0) {
          friends_icon.cameraOffset.y = 280;
        }
      }
      UI_right_group.add(wheel_icon);
      if (wheel_num > 0) {
        wheel_icon_label = game.add.sprite(37, -37, 'game_atlas', 'wheel_icon_label.png');
        wheel_icon_label.anchor.setTo(0.5);
        wheel_icon.addChild(wheel_icon_label);
        wheel_num_text = game.add.text(0, 2, wheel_num, { font: '28px RussoOne', fill: '#fff', align: 'center' });
        wheel_num_text.anchor.setTo(0.5);
        wheel_icon_label.addChild(wheel_num_text);
      } else {
        if (wheel_ads == 0 || shop == 0) {
          wheel_ad_icon = game.add.sprite(0, 0, 'game_atlas', 'ad_icon.png');
          wheel_ad_icon.anchor.setTo(0.5);
          wheel_icon.addChild(wheel_ad_icon);
        } else {
          wheel_ad_icon = game.add.text(0, 0, '', { font: '36px RussoOne', fill: '#FFD75A', align: 'center' });
          wheel_ad_icon.stroke = '#ffffff';
          wheel_ad_icon.strokeThickness = 4;
          wheel_ad_icon.setShadow(0, 3, 'rgba(0,0,0,1)', 1);
          wheel_ad_icon.anchor.setTo(0.5);
          wheel_icon.addChild(wheel_ad_icon);
        }
      }
      game.world.bringToTop(UI_right_group);
    }

    function UI_top_create() {
      coins_panel = game.add.sprite((xmas == 0) ? game.camera.width / 2 - 440 : game.camera.width / 2 + 570, (xmas == 0) ? 72 : 82, 'game_ui_atlas', 'Coins_Bar.png');
      coins_panel.anchor.setTo(0.5);
      coins_panel.fixedToCamera = true;
      UI_top_group.add(coins_panel);
      if ((shop == 1 && all_level[8] > 0) || FTUE > 150) {
        coins_panel.inputEnabled = true;
        coins_panel.events.onInputUp.add(function (item) {
          if (animation == 0) {
            if (missions_tab_open == 3 || missions_tab_open == 1 || missions_tab_open == 2 || FTUE == 41.2) {
              missions_tab_open = 0;
              if (
                animation == 0 &&
                FTUE != 30 &&
                FTUE != 31 &&
                FTUE != 32 &&
                FTUE != 33 &&
                FTUE != 41 &&
                (FTUE < 42 || FTUE > 46)
              ) {
                animation = 1;
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(UI_bottom_group)
                  .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    FTUE_process();
                    backcard_group.cameraOffset.x = 0;
                    friends_group.removeAll(true);
                    backcard_group.removeAll(true); mission_group.removeAll(true);
                    backcard_group.alpha = 1;
                    item.removeAll(true);
                    UI_bottom_group_create(1, 1, 1, 1, 0);
                    item.y = 400;
                    game.add
                      .tween(item)
                      .to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        animation = 0;
                        popup = 0;
                        if (shop == 1) {
                          shop_window(
                            0,
                            0,
                            0,
                            [
                              { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                              { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                              { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                              { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                              {
                                4: {
                                  id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                                  packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                                  price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                                  reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                                },
                              },
                            ],
                            [
                              {
                                0: {
                                  type: 'Coins_Pack_1.png',
                                  sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                  col: '1 000',
                                  id: 'coin_package_001',
                                  packname: '1,000 Coins',
                                  price: '0.99 $',
                                  atlas: 'game_window_atlas',
                                  reward: [1000],
                                },
                              },
                              {
                                1: {
                                  type: 'Coins_Pack_2.png',
                                  sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                  col: '6 000',
                                  id: 'coin_package_02',
                                  packname: '6,000 Coins',
                                  price: '4.99 $',
                                  atlas: 'game_window_atlas',
                                  reward: [6000],
                                },
                              },
                              {
                                2: {
                                  type: 'Coins_Pack_3.png',
                                  sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                  col: '13 000',
                                  id: 'coin_package_003',
                                  packname: '13,000 Coins',
                                  price: '9.99 $',
                                  atlas: 'game_window_atlas',
                                  reward: [13000],
                                },
                              },
                              {
                                3: {
                                  type: 'Coins_Pack_4.png',
                                  sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                  col: '20 000',
                                  id: 'coin_package_004',
                                  packname: '20,000 Coins',
                                  price: '14.99 $',
                                  atlas: 'game_window_atlas',
                                  reward: [20000],
                                },
                              },
                            ],
                          );
                        } else if (shop == 0) {
                          get_message(2);
                        }
                      });
                    complete_task_i = -1;
                  });
              }
              animation = 1;
            } else if (popup == 0) {
              animation = 0;
              if (shop == 1) {
                shop_window(
                  0,
                  0,
                  0,
                  [
                    { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                    { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                    { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                    { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                    {
                      4: {
                        id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                        packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                        price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                        reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                      },
                    },
                  ],
                  [
                    {
                      0: {
                        type: 'Coins_Pack_1.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '1 000',
                        id: 'coin_package_001',
                        packname: '1,000 Coins',
                        price: '0.99 $',
                        atlas: 'game_window_atlas',
                        reward: [1000],
                      },
                    },
                    {
                      1: {
                        type: 'Coins_Pack_2.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '6 000',
                        id: 'coin_package_02',
                        packname: '6,000 Coins',
                        price: '4.99 $',
                        atlas: 'game_window_atlas',
                        reward: [6000],
                      },
                    },
                    {
                      2: {
                        type: 'Coins_Pack_3.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '13 000',
                        id: 'coin_package_003',
                        packname: '13,000 Coins',
                        price: '9.99 $',
                        atlas: 'game_window_atlas',
                        reward: [13000],
                      },
                    },
                    {
                      3: {
                        type: 'Coins_Pack_4.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '20 000',
                        id: 'coin_package_004',
                        packname: '20,000 Coins',
                        price: '14.99 $',
                        atlas: 'game_window_atlas',
                        reward: [20000],
                      },
                    },
                  ],
                );
              } else if (shop == 0) {
                get_message(2);
              }
            }
          }
        }, this);
      }
      var coin_icon = game.add.sprite(-110, -8, 'game_ui_atlas', 'Coin_Icon.png');
      coin_icon.anchor.setTo(0.5);
      coins_panel.addChild(coin_icon);
      if ((shop == 1 && all_level[8] > 0) || FTUE > 150) {
        get_coins_plus_button = game.add.sprite(110, 0, 'game_ui_atlas', 'Get_Coins_Plus_Button.png');
        get_coins_plus_button.anchor.setTo(0.5);
        coins_panel.addChild(get_coins_plus_button);
        button_animation_f(get_coins_plus_button, 1);
        get_coins_plus_button.events.onInputUp.add(function (item) {
          btnup(item);
          if (sound_on == 1) {
            play_sound('button_press');
          }
          if (animation == 0) {
            if (life_panel.alpha == 0) {
              life_panel.alpha = 1;
              stars_panel.alpha = 1;
            }
            if (
              missions_tab_open == 3 ||
              missions_tab_open == 1 ||
              missions_tab_open == 2 ||
              missions_tab_open == 33 ||
              FTUE == 41.2
            ) {
              missions_tab_open = 0;
              if (
                animation == 0 &&
                FTUE != 30 &&
                FTUE != 31 &&
                FTUE != 32 &&
                FTUE != 33 &&
                FTUE != 41 &&
                (FTUE < 42 || FTUE > 46)
              ) {
                animation = 1;
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(UI_bottom_group)
                  .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    FTUE_process();
                    backcard_group.cameraOffset.x = 0;
                    friends_group.removeAll(true);
                    backcard_group.removeAll(true); mission_group.removeAll(true);
                    backcard_group.alpha = 1;
                    item.removeAll(true);
                    UI_bottom_group_create(1, 1, 1, 1, 0);
                    item.y = 400;
                    game.add
                      .tween(item)
                      .to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        animation = 0;
                        popup = 0;
                        if (shop == 1) {
                          shop_window(
                            0,
                            0,
                            0,
                            [
                              { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                              { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                              { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                              { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                              {
                                4: {
                                  id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                                  packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                                  price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                                  reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                                },
                              },
                            ],
                            [
                              {
                                0: {
                                  type: 'Coins_Pack_1.png',
                                  sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                  col: '1 000',
                                  id: 'coin_package_001',
                                  packname: '1,000 Coins',
                                  price: '0.99 $',
                                  atlas: 'game_window_atlas',
                                  reward: [1000],
                                },
                              },
                              {
                                1: {
                                  type: 'Coins_Pack_2.png',
                                  sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                  col: '6 000',
                                  id: 'coin_package_02',
                                  packname: '6,000 Coins',
                                  price: '4.99 $',
                                  atlas: 'game_window_atlas',
                                  reward: [6000],
                                },
                              },
                              {
                                2: {
                                  type: 'Coins_Pack_3.png',
                                  sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                  col: '13 000',
                                  id: 'coin_package_003',
                                  packname: '13,000 Coins',
                                  price: '9.99 $',
                                  atlas: 'game_window_atlas',
                                  reward: [13000],
                                },
                              },
                              {
                                3: {
                                  type: 'Coins_Pack_4.png',
                                  sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                  col: '20 000',
                                  id: 'coin_package_004',
                                  packname: '20,000 Coins',
                                  price: '14.99 $',
                                  atlas: 'game_window_atlas',
                                  reward: [20000],
                                },
                              },
                            ],
                          );
                        } else if (shop == 0) {
                          get_message(2);
                        }
                      });
                    popup = 0;
                    missions_tab_open = 0;
                    complete_task_i = -1;
                  });
              }
              animation = 1;
            } else if (popup == 0) {
              animation = 0;
              if (shop == 1) {
                shop_window(
                  0,
                  0,
                  0,
                  [
                    { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                    { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                    { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                    { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                    {
                      4: {
                        id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                        packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                        price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                        reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                      },
                    },
                  ],
                  [
                    {
                      0: {
                        type: 'Coins_Pack_1.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '1 000',
                        id: 'coin_package_001',
                        packname: '1,000 Coins',
                        price: '0.99 $',
                        atlas: 'game_window_atlas',
                        reward: [1000],
                      },
                    },
                    {
                      1: {
                        type: 'Coins_Pack_2.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '6 000',
                        id: 'coin_package_02',
                        packname: '6,000 Coins',
                        price: '4.99 $',
                        atlas: 'game_window_atlas',
                        reward: [6000],
                      },
                    },
                    {
                      2: {
                        type: 'Coins_Pack_3.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '13 000',
                        id: 'coin_package_003',
                        packname: '13,000 Coins',
                        price: '9.99 $',
                        atlas: 'game_window_atlas',
                        reward: [13000],
                      },
                    },
                    {
                      3: {
                        type: 'Coins_Pack_4.png',
                        sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                        col: '20 000',
                        id: 'coin_package_004',
                        packname: '20,000 Coins',
                        price: '14.99 $',
                        atlas: 'game_window_atlas',
                        reward: [20000],
                      },
                    },
                  ],
                );
              } else if (shop == 0) {
                get_message(2);
              }
            }
          }
        }, this);
      }
      text_coins_panel = game.add.text(0, -5, coins_text, {
        font: '32px RussoOne',
        fill: '#8B3B30',
        align: 'center',
      });
      text_coins_panel.anchor.setTo(0.5);
      coins_panel.addChild(text_coins_panel);
      if (xmas == 0) {
        life_panel = game.add.sprite(game.camera.width / 2 - 770, 102, 'game_ui_atlas', 'Energy_Bar.png');
        life_panel.anchor.setTo(0.5);
        life_panel.fixedToCamera = true;
        UI_top_group.add(life_panel);
        life_text_timer = game.add.text(10, -62, game.cache.getJSON('lang')['Energy'][0][window.lang], {
          font: '20px RussoOne',
          fill: '#8B3B30',
          align: 'center',
        });
        life_text_timer.anchor.setTo(0.5);
        life_panel.addChild(life_text_timer);
        life_line = game.add.sprite(-134, -25, 'game_ui_atlas', 'Energy_Level_Bar.png');
        life_line.anchor.setTo(0, 0.5);
        life_line.w = life_line.width;
        life_panel.addChild(life_line);
        var cropRect = new Phaser.Rectangle(0, 0, lifes * (life_line.w / max_lifes), life_line.height);
        try {
          life_line.crop(cropRect);
        } catch (err) { }
        life_icon = game.add.sprite(-124, -27, 'game_ui_atlas', 'Thunder_Icon.png');
        life_icon.anchor.setTo(0.5);
        life_panel.addChild(life_icon);
        stars_panel = game.add.sprite(game.camera.width / 2 - 160, 72, 'game_ui_atlas', 'Star_Bar.png');
        stars_panel.anchor.setTo(0.5);
        stars_panel.fixedToCamera = true;
        UI_top_group.add(stars_panel);
        star_icon = game.add.sprite(-60, 0, 'game_ui_atlas', 'Star_Icon.png');
        star_icon.anchor.setTo(0.5);
        stars_panel.addChild(star_icon);

        text_lifes = game.add.text(20, -25, lifes, { font: '32px RussoOne', fill: '#fff', align: 'center' });
        text_lifes.anchor.setTo(0.5);
        text_lifes.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
        life_panel.addChild(text_lifes);
        text_life_panel = game.add.text(16, 40, game.cache.getJSON('lang')['Max'][0][window.lang], {
          font: '40px RussoOne',
          fill: '#8B3B30',
          align: 'center',
        });
        text_life_panel.anchor.setTo(0.5);
        life_panel.addChild(text_life_panel);
        text_stars_panel = game.add.text(18, -5, all_stars, {
          font: '32px RussoOne',
          fill: '#8B3B30',
          align: 'center',
        });
        text_stars_panel.anchor.setTo(0.5);
        stars_panel.addChild(text_stars_panel);
        if (Number(lifes) < Number(max_lifes)) {
          lifes_panel_plus = game.add.sprite(16, 40, 'game_ui_atlas', 'Get_Energy_Button.png');
          lifes_panel_plus.anchor.setTo(0.5);
          button_animation_f(lifes_panel_plus, 1);
          lifes_panel_plus.events.onInputUp.add(function (item) {
            if (sound_on == 1) {
              play_sound('button_press');
            }
            btnup(item);
            if (
              (popup == 0 ||
                missions_tab_open == 3 ||
                missions_tab_open == 1 ||
                missions_tab_open == 2 ||
                missions_tab_open == 33) && animation == 0
            ) {
              popup = 1;
              if (
                missions_tab_open == 3 ||
                missions_tab_open == 1 ||
                missions_tab_open == 2 ||
                missions_tab_open == 33
              ) {
                missions_tab_open = 0;
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(UI_bottom_group)
                  .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    FTUE_process();
                    backcard_group.cameraOffset.x = 0;
                    friends_group.removeAll(true);
                    backcard_group.removeAll(true); mission_group.removeAll(true);
                    backcard_group.alpha = 1;
                    item.removeAll(true);
                    UI_bottom_group_create(1, 1, 1, 1, 0);
                    item.y = 400;
                    game.add
                      .tween(item)
                      .to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        get_message(1);
                      });
                    popup = 0;
                    complete_task_i = -1;
                  });
              } else {
                popup = 0;
                get_message(1);
              }
            }
          });
          life_panel.addChild(lifes_panel_plus);
          var get_energy_thunder_icon = game.add.sprite(78, -4, 'game_ui_atlas', 'Get_Energy_Thunder_Icon.png');
          get_energy_thunder_icon.anchor.setTo(0.5);
          lifes_panel_plus.addChild(get_energy_thunder_icon);
          var get_energy_thunder_text = game.add.text(-25, -1, game.cache.getJSON('lang')['t284'][0][window.lang], {
            font: '22px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          get_energy_thunder_text.lineSpacing = -10;
          get_energy_thunder_text.anchor.setTo(0.5);
          get_energy_thunder_text.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
          lifes_panel_plus.addChild(get_energy_thunder_text);
        }
      } else {
        var Top_Spider_Webs = game.add.sprite(0, 0, 'xmas_atlas', 'Top_Decorations.png');
        Top_Spider_Webs.fixedToCamera = true;
        UI_top_group.add(Top_Spider_Webs);
        var Top_Spider_Webs = game.add.sprite(game.camera.width, 0, 'xmas_atlas', 'Top_Decorations.png');
        Top_Spider_Webs.scale.setTo(-1, 1);
        Top_Spider_Webs.fixedToCamera = true;
        UI_top_group.add(Top_Spider_Webs);
        var Title_Background = game.add.sprite(game.camera.width / 2, 0, 'xmas_atlas', 'Title_Background.png');
        Title_Background.anchor.setTo(0.5, 0);
        Title_Background.fixedToCamera = true;
        UI_top_group.add(Title_Background);
        xmas_title = game.add.text(game.camera.width / 2, 50, game.cache.getJSON('lang')['t554'][0][window.lang], {
          font: '58px RussoOne',
          fill: '#FEFFFF',
          align: 'center',
        });
        xmas_title.stroke = '#DF5C7B';
        xmas_title.strokeThickness = 2;
        xmas_title.anchor.setTo(0.5);
        xmas_title.setShadow(0, 4, 'rgba(95,1,63,1)', 4);
        xmas_title.fixedToCamera = true;
        UI_top_group.add(xmas_title);
        var popup_close = game.add.sprite(game.camera.width - 100, 82, 'game_window_atlas', 'Close_Button.png');
        popup_close.anchor.setTo(0.5);
        button_animation_f(popup_close, 1);
        popup_close.fixedToCamera = true;
        popup_close.events.onInputUp.add(function () {
          if (popup != 2) {
            if (Clock.alpha != 0) {
              if (popup == 0 && animation == 0) {
                popup = 2;
                xmas = 0;
                xmas_level_win = 0;
                from_map = -2;
                //game.world.removeAll(true);
                //game.state.start('Map');
                play_level(1);
              }
            } else {
              popup = 2;
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                  missions_tab_open = 0;
                  animation = 0;
                  xmas_title.setText('xmas');
                  xmas_exit_text.alpha = 1;
                  graphics_Clock.alpha = 1;
                  Clock.alpha = 1;
                  xmas_timer.alpha = 1;
                });
            }
          }
        });
        UI_top_group.add(popup_close);
        xmas_exit_text = game.add.text(game.camera.width - 100, 152, game.cache.getJSON('lang')['t555'][0][window.lang], {
          font: '24px RussoOne',
          fill: '#ffffff',
          align: 'center',
        });
        xmas_exit_text.lineSpacing = -10;
        xmas_exit_text.anchor.setTo(0.5);
        xmas_exit_text.fixedToCamera = true;
        UI_top_group.add(xmas_exit_text);
        graphics_Clock = game.add.graphics(game.camera.width / 2 - 135, 100);
        graphics_Clock.beginFill(0x000000);
        graphics_Clock.alpha = 0.5;
        graphics_Clock.drawRoundedRect(0, 0, 270, 60, 80);
        graphics_Clock.fixedToCamera = true;
        UI_top_group.add(graphics_Clock);
        Clock = game.add.sprite(game.camera.width / 2 - 135, 130, 'xmas_atlas', 'Clock.png');
        Clock.anchor.setTo(0.5);
        Clock.fixedToCamera = true;
        UI_top_group.add(Clock);
        xmas_timer = game.add.text(game.camera.width / 2, 130, '', {
          font: '32px RussoOne',
          fill: '#ffffff',
          align: 'center',
        });
        xmas_timer.anchor.setTo(0.5);
        xmas_timer.fixedToCamera = true;
        UI_top_group.add(xmas_timer);
        var Number_Tickets_Background = game.add.sprite(
          game.camera.width / 2 - 650,
          82,
          'xmas_atlas',
          'Number_Tickets_Background.png',
        );
        Number_Tickets_Background.anchor.setTo(0.5);
        Number_Tickets_Background.fixedToCamera = true;
        UI_top_group.add(Number_Tickets_Background);
        xmas_ticket_text = game.add.text(0, -2, xmas_ticket, {
          font: '40px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        xmas_ticket_text.anchor.setTo(0.5);
        xmas_ticket_text.setShadow(0, 0, 'rgba(0,0,0,0.8)', 10);
        Number_Tickets_Background.addChild(xmas_ticket_text);
        var Ticket = game.add.sprite(-100, -5, 'xmas_atlas', 'Ticket.png');
        Ticket.anchor.setTo(0.5);
        Number_Tickets_Background.addChild(Ticket);
        var Plus_Button = game.add.sprite(100, -5, 'game_ui_atlas', 'Get_Coins_Plus_Button.png');
        Plus_Button.anchor.setTo(0.5);
        button_animation_f(Plus_Button, 1);
        Plus_Button.events.onInputUp.add(function () {
          if (popup == 0 && animation == 0) {
            xmas_shop_window();
          }
        });
        Number_Tickets_Background.addChild(Plus_Button);
      }
    }

    var xmas_exit_text = 0;
    var xmas_title = 0;
    var graphics_Clock = 0;
    var Clock = 0;
    function xmas_shop_window(spec_a, other_a) {
      if (popup == 0) {
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        blackf();

        xmas_title.setText(game.cache.getJSON('lang')['t506'][0][window.lang]);
        xmas_exit_text.alpha = 0;
        graphics_Clock.alpha = 0;
        Clock.alpha = 0;
        xmas_timer.alpha = 0;

        var xmas_Background = game.add.sprite(
          0,
          game.camera.height,
          'xmas_atlas',
          'BG_Decorations.png',
        );
        xmas_Background.anchor.setTo(0, 1);
        xmas_Background.scale.setTo(2);
        xmas_Background.fixedToCamera = true;
        popup_group.add(xmas_Background);

        var xmas_Background = game.add.sprite(
          game.camera.width,
          game.camera.height,
          'xmas_atlas',
          'BG_Decorations2.png',
        );
        xmas_Background.anchor.setTo(1, 1);
        xmas_Background.scale.setTo(2);
        xmas_Background.fixedToCamera = true;
        popup_group.add(xmas_Background);

        for (var i = 0; i < 4; i++) {
          if (i == 0)
            var Mini_Packages_Background = game.add.sprite(
              (shop == 1) ? game.camera.width / 2 - 100 : game.camera.width / 2 + 140,
              game.camera.height / 2 - 66,
              'xmas_atlas',
              'Mini_Packages_Background.png',
            );
          else if (i == 1)
            var Mini_Packages_Background = game.add.sprite(
              (shop == 1) ? game.camera.width / 2 - 390 : game.camera.width / 2 - 150,
              game.camera.height / 2 - 66,
              'xmas_atlas',
              'Mini_Packages_Background.png',
            );
          else if (i == 2)
            var Mini_Packages_Background = game.add.sprite(
              (shop == 1) ? game.camera.width / 2 - 100 : game.camera.width / 2 + 140,
              game.camera.height / 2 + 304,
              'xmas_atlas',
              'Mini_Packages_Background.png',
            );
          else if (i == 3)
            var Mini_Packages_Background = game.add.sprite(
              (shop == 1) ? game.camera.width / 2 - 390 : game.camera.width / 2 - 150,
              game.camera.height / 2 + 304,
              'xmas_atlas',
              'Mini_Packages_Background.png',
            );

          Mini_Packages_Background.anchor.setTo(0.5);
          Mini_Packages_Background.fixedToCamera = true;
          popup_group.add(Mini_Packages_Background);

          var Tickets_Pack = game.add.sprite(
            0,
            -70,
            'xmas_atlas',
            i == 0
              ? '10_Tickets_Pack.png'
              : i == 1
                ? '3_Tickets_Pack.png'
                : i == 2
                  ? '30_Tickets_Pack.png'
                  : '20_Tickets_Pack.png',
          );
          Tickets_Pack.anchor.setTo(0.5);
          Mini_Packages_Background.addChild(Tickets_Pack);

          var Amount_Items_Field = game.add.sprite(0, 40, 'xmas_atlas', 'Amount_Items_Field.png');
          Amount_Items_Field.anchor.setTo(0.5);
          Mini_Packages_Background.addChild(Amount_Items_Field);

          var Tickets_Pack_col = game.add.text(0, 0, i == 0 ? 'x12' : i == 1 ? 'x3' : i == 2 ? 'x50' : 'x25', {
            font: '30px RussoOne',
            fill: '#016B97',
            align: 'center',
          });
          Tickets_Pack_col.stroke = '#ffffff';
          Tickets_Pack_col.strokeThickness = 4;
          Tickets_Pack_col.anchor.setTo(0.5);
          Amount_Items_Field.addChild(Tickets_Pack_col);

          var button_green = game.add.sprite(0, 110, 'game_window_atlas', 'Green_Button.png');
          button_green.anchor.setTo(0.5);
          button_green.scale.setTo(0.55);
          button_green.iii = i;
          button_animation_f(button_green, 0.55);
          button_green.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              popup = 2;
              var col = 0;
              var price = 0;
              if (item.iii == 0) {
                col = 12;
                price = 1900;
              } else if (item.iii == 1) {
                col = 3;
                price = 500;
              } else if (item.iii == 2) {
                col = 50;
                price = 7000;
              } else if (item.iii == 3) {
                col = 25;
                price = 3800;
              }

              if (coins >= price) {
                coins -= price;
                text_coins_panel.setText(coins);
                game.setUserDataAndLog({
                  currencies: coins,
                });
                current_event = 'xmas';
                window.eventTrack('coins_out', price, {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: price,
                  source: 'Buy tickets',
                  item_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    missions_tab_open = 0;
                    xmas_title.setText('xmas');
                    xmas_exit_text.alpha = 1;
                    graphics_Clock.alpha = 1;
                    Clock.alpha = 1;
                    xmas_timer.alpha = 1;
                    animation = 0;
                    bought = 1;
                    bought_f = 0;
                    game.setUserDataAndLog({ bought: bought });
                    chest_open_window(
                      game.cache.getJSON('lang')['Reward!'][0][window.lang],
                      [0, 0, 0, 0, 0, 0, 0, 0, 0, col],
                      51,
                      1,
                      {
                        // gameArea: DdnaGameArea.Map,
                        // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                        // productId: ProductID.ticket_xmas_offer,
                        gameArea: null,
                        actionType: null,
                        productId: 0,
                      },
                    );
                  });
              }
              else {
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    xmas_title.setText('xmas');
                    xmas_exit_text.alpha = 1;
                    graphics_Clock.alpha = 1;
                    Clock.alpha = 1;
                    xmas_timer.alpha = 1;
                    popup_group.y -= game.camera.height;
                    if (all_level[8] > 0 || FTUE > 150) {
                      if (shop == 1) {
                        shop_window(
                          0,
                          0,
                          0,
                          [
                            { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                            { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                            { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                            { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                            {
                              4: {
                                id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                                packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                                price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                                reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                              },
                            },
                          ],
                          [
                            {
                              0: {
                                type: 'Coins_Pack_1.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '1 000',
                                id: 'coin_package_001',
                                packname: '1,000 Coins',
                                price: '0.99 $',
                                atlas: 'game_window_atlas',
                                reward: [1000],
                              },
                            },
                            {
                              1: {
                                type: 'Coins_Pack_2.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '6 000',
                                id: 'coin_package_02',
                                packname: '6,000 Coins',
                                price: '4.99 $',
                                atlas: 'game_window_atlas',
                                reward: [6000],
                              },
                            },
                            {
                              2: {
                                type: 'Coins_Pack_3.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '13 000',
                                id: 'coin_package_003',
                                packname: '13,000 Coins',
                                price: '9.99 $',
                                atlas: 'game_window_atlas',
                                reward: [13000],
                              },
                            },
                            {
                              3: {
                                type: 'Coins_Pack_4.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '20 000',
                                id: 'coin_package_004',
                                packname: '20,000 Coins',
                                price: '14.99 $',
                                atlas: 'game_window_atlas',
                                reward: [20000],
                              },
                            },
                          ],
                        );
                      } else if (shop == 0) {
                        get_message(2);
                      }
                    }
                  });
              }
            }
          });
          Mini_Packages_Background.addChild(button_green);

          var coins_icon = game.add.sprite(0, 0, 'game_window_atlas', 'Big_Kit_List_Coin.png');
          coins_icon.anchor.setTo(0, 0.5);
          button_green.addChild(coins_icon);

          var text_button_green = game.add.text(
            coins_icon.width / 2 + 40,
            0,
            i == 0 ? '1900' : i == 1 ? '500' : i == 2 ? '7000' : '3800',
            {
              font: '50px RussoOne',
              fill: '#fff',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 260,
            },
          );
          text_button_green.anchor.setTo(0, 0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#457310';
          text_button_green.strokeThickness = 4;
          text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
          button_green.addChild(text_button_green);

          coins_icon.x -= (coins_icon.width + text_button_green.width + 40) / 2;
          text_button_green.x -= (coins_icon.width + text_button_green.width + 40) / 2;
        }

        if (shop == 1) {
          var Special_Sales_Background = game.add.sprite(
            game.camera.width / 2 + 270,
            game.camera.height / 2 + 120,
            'xmas_atlas',
            'Special_Sales_BG.png',
          );
          Special_Sales_Background.anchor.setTo(0.5);
          Special_Sales_Background.fixedToCamera = true;
          popup_group.add(Special_Sales_Background);

          var package_title = game.add.text(0, -300, game.cache.getJSON('lang')['t507'][0][window.lang], {
            font: '38px RussoOne',
            fill: '#FEFFFF',
            align: 'center',
          });
          package_title.stroke = '#DF5C7B';
          package_title.strokeThickness = 2;
          package_title.anchor.setTo(0.5);
          package_title.setShadow(0, 4, 'rgba(95,1,63,1)', 4);
          Special_Sales_Background.addChild(package_title);

          var Special_Sales_Pack = game.add.sprite(0, -50, 'xmas_atlas', 'Special_Sales_Pack.png');
          Special_Sales_Pack.anchor.setTo(0.5);
          Special_Sales_Background.addChild(Special_Sales_Pack);

          var Special_Sales_Items_Background = game.add.sprite(
            0,
            170,
            'xmas_atlas',
            'Special_Sales_Items_Background.png',
          );
          Special_Sales_Items_Background.anchor.setTo(0.5);
          Special_Sales_Background.addChild(Special_Sales_Items_Background);

          var Discount_Pumpkin = game.add.sprite(
            230,
            -220,
            'xmas_atlas',
            'Discount_BG.png',
          );
          Discount_Pumpkin.anchor.setTo(0.5);
          Special_Sales_Background.addChild(Discount_Pumpkin);

          var Discount_Pumpkin_text = game.add.text(0, -10, game.cache.getJSON('lang')['t508'][0][window.lang], {
            font: '28px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          Discount_Pumpkin_text.angle = 15;
          Discount_Pumpkin_text.lineSpacing = -15;
          Discount_Pumpkin_text.anchor.setTo(0.5);
          Discount_Pumpkin_text.stroke = '#AE320A';
          Discount_Pumpkin_text.strokeThickness = 8;
          Discount_Pumpkin.addChild(Discount_Pumpkin_text);

          var Items_icon = game.add.sprite(-130, -20, 'game_window_atlas', 'Big_Kit_List_Coin.png');
          Items_icon.anchor.setTo(0, 0.5);
          Items_icon.scale.setTo(0.6);
          Special_Sales_Items_Background.addChild(Items_icon);

          var Items_text = game.add.text(Items_icon.width + 10 - 130, -20, '1500', {
            font: '30px RussoOne',
            fill: '#016B97',
            align: 'center',
          });
          Items_text.anchor.setTo(0, 0.5);
          Items_text.stroke = '#ffffff';
          Items_text.strokeThickness = 4;
          Special_Sales_Items_Background.addChild(Items_text);

          var Items_icon = game.add.sprite(40, -20, 'xmas_atlas', 'Ticket.png');
          Items_icon.anchor.setTo(0, 0.5);
          Items_icon.scale.setTo(0.4);
          Special_Sales_Items_Background.addChild(Items_icon);

          var Items_text = game.add.text(Items_icon.width + 10 + 40, -20, '20', {
            font: '30px RussoOne',
            fill: '#016B97',
            align: 'center',
          });
          Items_text.anchor.setTo(0, 0.5);
          Items_text.stroke = '#ffffff';
          Items_text.strokeThickness = 4;
          Special_Sales_Items_Background.addChild(Items_text);

          var Items_icon = game.add.sprite(-80, 24, 'game_window2_atlas', 'List_Card_Back.png');
          Items_icon.anchor.setTo(0, 0.5);
          Items_icon.scale.setTo(0.5);
          Special_Sales_Items_Background.addChild(Items_icon);

          var Items_text = game.add.text(Items_icon.width + 10 - 80, 24, '1', {
            font: '30px RussoOne',
            fill: '#016B97',
            align: 'center',
          });
          Items_text.anchor.setTo(0, 0.5);
          Items_text.stroke = '#ffffff';
          Items_text.strokeThickness = 4;
          Special_Sales_Items_Background.addChild(Items_text);

          var Items_icon = game.add.sprite(20, 24, 'game_window2_atlas', 'List_Joker.png');
          Items_icon.anchor.setTo(0, 0.5);
          Items_icon.scale.setTo(0.5);
          Special_Sales_Items_Background.addChild(Items_icon);

          var Items_text = game.add.text(Items_icon.width + 10 + 20, 24, '1', {
            font: '30px RussoOne',
            fill: '#016B97',
            align: 'center',
          });
          Items_text.anchor.setTo(0, 0.5);
          Items_text.stroke = '#ffffff';
          Items_text.strokeThickness = 4;
          Special_Sales_Items_Background.addChild(Items_text);

          var button_green = game.add.sprite(0, 284, 'game_window_atlas', 'Green_Button.png');
          button_green.anchor.setTo(0.5);
          button_green.scale.setTo(0.7);
          button_animation_f(button_green, 0.7);
          button_green.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              popup = 2;
              loading();
              if (animation == 100) {
                if (bought == 0) {
                  bought_f = 1;
                }
                if (fbv == 1) {
                  window.eventTrack('ticket_xmas_offer_successfull');
                  window.eventTrack('soga_purchase_successfull', 1, {
                    package_id: 'ticket_xmas_offer',
                    value: '4.99 $',
                    current_level: level_button.n,
                    conversion: 1 - bought,
                    first_purchase: bought_f,
                    lifetime: lifetime_day,
                    highest_lvl: all_level.lastIndexOf(3) + 2,
                    mission_completed: missioncompleted,
                    c_event: current_event,
                  });
                }
                if (loading_black_sprite != 0) {
                  loading_black_sprite.destroy();
                  loading_black_sprite = 0;
                }
                if (loading_text != 0 && loading_text != 1) {
                  loading_text.destroy();
                  loading_text = 0;
                }
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    missions_tab_open = 0;
                    animation = 0;
                    bought = 1;
                    bought_f = 0;
                    xmas_title.setText('xmas');
                    xmas_exit_text.alpha = 1;
                    graphics_Clock.alpha = 1;
                    Clock.alpha = 1;
                    xmas_timer.alpha = 1;
                    game.setUserDataAndLog({ bought: bought });
                    chest_open_window(
                      game.cache.getJSON('lang')['Reward!'][0][window.lang],
                      [1500, 0, 1, 0, 1, 0, 0, 0, 0, 20],
                      51,
                      1,
                      {
                        // gameArea: DdnaGameArea.Map,
                        // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                        // productId: ProductID.ticket_xmas_offer,
                        gameArea: null,
                        actionType: null,
                        productId: 0,
                      },
                    );
                  });
              }
              // else
              //   purchaseAsync(
              //     {
              //       productID: 'ticket_xmas_offer',
              //       developerPayload: 'Premium spin',
              //     },
              //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
              //   )
              //     .then(function (purchase) {
              //       if (bought == 0) {
              //         bought_f = 1;
              //       }
              //       if (fbv == 1) {
              //         game.setCurrentEvent();
              //         window.eventTrack('ticket_xmas_offer_successfull');
              //         window.eventTrack('soga_purchase_successfull', 1, {
              //           package_id: 'ticket_xmas_offer',
              //           value: '2.99 $',
              //           current_level: level_button.n,
              //           conversion: 1 - bought,
              //           first_purchase: bought_f,
              //           lifetime: lifetime_day,
              //           highest_lvl: all_level.lastIndexOf(3) + 2,
              //           mission_completed: missioncompleted,
              //           c_event: current_event,
              //         });
              //       }
              //       if (loading_black_sprite != 0) {
              //         loading_black_sprite.destroy();
              //         loading_black_sprite = 0;
              //       }
              //       if (loading_text != 0 && loading_text != 1) {
              //         loading_text.destroy();
              //         loading_text = 0;
              //       }
              //       game.add
              //         .tween(black_sprite)
              //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              //         .onComplete.add(function (item) {
              //           item.destroy();
              //         });
              //       game.add
              //         .tween(popup_group)
              //         .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              //         .onComplete.add(function (item) {
              //           popup_group.removeAll(true);
              //           popup = 0;
              //           popup_group.y -= game.camera.height;
              //           missions_tab_open = 0;
              //           animation = 0;
              //           bought = 1;
              //           bought_f = 0;
              //           xmas_title.setText('xmas');
              //           xmas_exit_text.alpha = 1;
              //           graphics_Clock.alpha = 1;
              //           Clock.alpha = 1;
              //           xmas_timer.alpha = 1;
              //           game.setUserDataAndLog({ bought: bought });
              //           chest_open_window(
              //             game.cache.getJSON('lang')['Reward!'][0][window.lang],
              //             [1500, 0, 1, 0, 1, 0, 0, 0, 0, 20],
              //             51,
              //             1,
              //             {
              //               // gameArea: DdnaGameArea.Map,
              //               // actionType: DdnaTransactionActionType.RealMoneyPurchase,
              //               // productId: ProductID.ticket_xmas_offer,
              //               gameArea: null,
              //       actionType: null,
              //       productId: 0,
              //             },
              //           );
              //         });
              //       // FBInstant.payments
              //       //   .consumePurchaseAsync(purchase['purchaseToken'])
              //       //   .then(function () {})
              //       //   .catch(function (error) {});
              //     })
              //     .catch(function (error) {
              //       if (fbv == 1) {
              //         game.setCurrentEvent();
              //         window.eventTrack('ticket_xmas_offer_failed', 1, {
              //           package_id: 'ticket_xmas_offer',
              //           value: '4.99 $',
              //           current_level: level_button.n,
              //           conversion: 1 - bought,
              //           user_type: bought,
              //           lifetime: lifetime_day,
              //           mission_completed: missioncompleted,
              //           c_event: current_event,
              //         });
              //       }
              //       console.log(error);
              //       if (loading_black_sprite != 0) {
              //         loading_black_sprite.destroy();
              //         loading_black_sprite = 0;
              //       }
              //       if (loading_text != 0 && loading_text != 1) {
              //         loading_text.destroy();
              //         loading_text = 0;
              //       }
              //       popup = 1;
              //     });
            }
          });
          Special_Sales_Background.addChild(button_green);

          var buttontimer = setInterval(function () {
            if (payments_catalog.length > 0) {
              clearInterval(buttontimer);
              var button_green_text = game.add.text(
                0,
                0,
                payments_catalog[
                payments_catalog.findIndex(function (e) {
                  return e['productID'] == 'ticket_xmas_offer';
                })
                ]['price'],
                { font: '40px RussoOne', fill: '#fff', align: 'center' },
              );
              button_green_text.anchor.setTo(0.5);
              button_green_text.stroke = '#46730C';
              button_green_text.strokeThickness = 4;
              button_green_text.setShadow(0, 4, 'rgba(70,115,12,0.5)', 1);
              button_green.addChild(button_green_text);
            }
          }, 100);
        }

        game.world.bringToTop(UI_top_group);
        game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
      }
    }

    function lifetextChange(timer) {
      if (Number(lifes) < Number(max_lifes) && unlimited_lifesDate == 0) {
        if (timer && life_text_timer != 0) {
          life_text_timer.setText(timer);
        }
        var cropRect = new Phaser.Rectangle(0, 0, lifes * (life_line.w / max_lifes), life_line.height);
        try {
          life_line.crop(cropRect);
        } catch (err) { }
      } else {
        if (!timer && life_text_timer != 0) {
          life_text_timer.setText(game.cache.getJSON('lang')['Energy'][0][window.lang]);
        }
        var cropRect = new Phaser.Rectangle(0, 0, lifes * (life_line.w / max_lifes), life_line.height);
        try {
          life_line.crop(cropRect);
        } catch (err) { }
        if (unlimited_lifesDate != 0) {
          if (is_map == 1) {
            if (timer && life_text_timer != 0) {
              life_text_timer.setText(timer);
            }
            if (life_icon != 0 && life_icon.frameName != 'Energy.png') {
              if (typeof life_icon !== "undefined") {
                life_icon.destroy();
                life_icon = game.add.sprite(-124, -27, 'unlimited_energy_atlas', 'Energy.png');
                life_icon.anchor.setTo(0.5);
                life_panel.addChild(life_icon);
              }
              //life_icon.loadTexture('unlimited_energy_atlas', 'Energy.png');
            }
          }
        } else {
          if (life_icon != 0 && life_icon.frameName != 'Thunder_Icon.png') {
            if (typeof life_icon !== "undefined") {
              life_icon.destroy();
              life_icon = game.add.sprite(-124, -27, 'game_ui_atlas', 'Thunder_Icon.png');
              life_icon.anchor.setTo(0.5);
              life_panel.addChild(life_icon);
            }
            //life_icon.loadTexture('game_ui_atlas', 'Thunder_Icon.png');
          }
        }
      }
    }
    var FTUE_Arrow = 0;
    if (FTUE > 37 && xmas == 0) {
      UI_right_create();
    }

    if (all_level[0] > 0 || FTUE > 150) {
      UI_top_create();
    }

    if (xmasDate != 0 && xmasDate != -1 && xmas == 0) {
      xmas_create(0);
      xmastimer();
    }

    if (sunflowerDate != 0 && xmas == 0) {
      sunflower_create(0);
      sunflowertimer();
    }

    if (baloonDate != 0 && xmas == 0) {
      baloon_create(0);
      balloon_timer();
    }

    if (magicbeanDate != 0 && xmas == 0) {
      magicbean_create(0);
      magicbeantimer();
    }

    level_button.n = xmas == 0 ? all_level.lastIndexOf(3) + 2 : xmas_level + 1;
    level_button.loadTexture('game_ui_atlas', (game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1 || xmas == 1) ? 'Super_Hard_Level_Button.png' : game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? 'Hard_Level_Button.png' : 'Play_Button.png');
    text_level_button.setText(level_button.n);

    if (game.cache.checkImageKey('context_avatar') == true) {
      game.cache.removeImage('context_avatar');
    }

    context_name = 0;
    context_id = 0;
    var all_friends = 0;

    game.add.tween(effects_group).to({ alpha: 1 }, 100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
      if ((all_level.lastIndexOf(3) + 2 > 3 || all_level.lastIndexOf(300) + 2 > 3) && fbv == 1) {
        fetchAndLogScore('default', 'completedLevels').then(function (friends) {
          all_friends = friends.length - 1;
          indicator_system(0);
          for (var nnn = 0; nnn < friends.length; nnn++) {
            if (friends[nnn]['user']['playerId'] != CurrentUserId)
              if (helpers_id.indexOf(friends[nnn]['user']['playerId']) == -1) {
                try {
                  game.load.image('context_avatar', friends[nnn]['user']['avatarUrl'], 1);
                  game.load.crossOrigin = true;
                  game.load.start();
                } catch (err) {
                  //console.log('Error detected '+err.name);
                }
                context_name = friends[nnn]['user']['handle'];
                context_id = friends[nnn]['user']['playerId'];
                avatar_check_context = setInterval(function () {
                  if (is_map == 1) {
                    try {
                      if (game.cache.checkImageKey('context_avatar') == true) {
                        context_avatar = 'context_avatar';
                        clearInterval(avatar_check_context);
                        avatar_check_context = 0;
                      }
                    } catch (err) {
                      //console.log('Error detected '+err.name);
                      clearInterval(avatar_check_context);
                      avatar_check_context = 0;
                    }
                  }
                }, 500);
                break;
              }
          }
        });
      } else {
        if (fbv == 1) {
          fetchAndLogScore('default', 'completedLevels').then(function (friends) {
            all_friends = friends.length - 1;
            indicator_system(0);
          });
        }
        context_name = game.cache.getJSON('lang')['t344_1'][0][window.lang];
      }
    });

    /*
      -8 = Clear (20-35) Diamond
      -8 = Clear (45-60) Diamond
      -8 = Clear (70-90) Diamond
      -8 = Clear (100-130) Diamond
      -8 = Clear (140-180) Diamond
      -8 = Clear (190-230) Diamond
      -6 = Clear (20-35) Club
      -6 = Clear (45-60) Club
      -6 = Clear (70-90) Club
      -6 = Clear (100-130) Club
      -6 = Clear (140-180) Club
      -6 = Clear (190-230) Club
      -1 = Clear (20-35) Heart
      -1 = Clear (45-60) Heart
      -1 = Clear (70-90) Heart
      -1 = Clear (100-130) Heart
      -1 = Clear (140-180) Heart
      -1 = Clear (190-230) Heart
      -7 = Clear (20-35) Spade Cards
      -7 = Clear (45-60) Spade Cards
      -7 = Clear (70-90) Spade Cards
      -7 = Clear (100-130) Spade Cards
      -7 = Clear (140-180) Spade Cards
      -7 = Clear (190-230) Spade Cards
      -9 = Clear Any (20-35) Cards
      -9 = Clear Any (45-60) Cards
      -9 = Clear Any (70-90) Cards
      -9 = Clear Any (100-150) Cards
      -9 = Clear Any (170-250) Cards
      -9 = Clear Any (260-350) Cards
      -12 = Clear (5-15) Jacks
      -12 = Clear (25-40) Jacks
      -12 = Clear (45-70) Jacks
      -13 = Clear (5-15) Queens
      -13 = Clear (25-40) Queens
      -13 = Clear (45-70) Queens
      -14 = Clear (5-15) Kings
      -14 = Clear (25-40) Kings
      -14 = Clear (45-70) Kings
      -15 = Clear (5-15) Aces
      -15 = Clear (25-40) Aces
      -15 = Clear (45-70) Aces
      -2 = Collect (2-5) Stars
      -2 = Collect (6-9) Stars
      -2 = Collect (10-15) Stars
      -4 = Get (2-5) Bonus Streaks
      -4 = Get (6-11) Bonus Streaks
      -4 = Get (12-20) Bonus Streaks
      -5 = Finish (1-3) level with 5 cards left
      -5 = Finish (4-7) level with 5 cards left
      -5 = Finish (8-12) level with 5 cards left
      -16 = Spin Wheel (1-3) times
      -17 = Use (1-3) Joker Booster
      -18 = Use (1-3) TNT Booster
      -19 = Use (1-3) Shuffle Booster
      -20 = Use (1-3) Magnifier
      -21 = Use (1-3) Random Remover
      -3 = Buy (3-5) new garden items
      -3 = Buy (7-10) new garden items
      -3 = Buy (11-15) new garden items
      -10 = Complete (2-3) story tasks
      -10 = Complete (4-6) story tasks
      -10 = Complete (7-10) story tasks
      -22 = Collect (3-5) Gifts from friends
      -22 = Collect (7-10) Gifts from friends
      -22 = Collect (11-15) Gifts from friends
      -11 = Ask (3-5) friends for Helper-Cards
      -11 = Ask (7-10) friends for Helper-Cards
      -11 = Ask (11-15) friends for Helper-Cards
    */
    var gift = 0;
    var black_sprite_build = 0;
    var gift_shine2 = 0;
    var mis_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    var old_keys = Number(keys);
    window.mission_create = function (indx) {

      var d888 = [350, 200, 200, 100, 100, 50];

      if (mis_n == -1 && ((missions_tab_back != 0 && popup != 0 && missions_tab_open == 33) || is_map == 0)) {
        game.add.tween(mission_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 1400).onComplete.add(function () {
          mis_n = 0;
          mission_create(0);
        });
      }
      else
        if (mis_n == 0) {
          if (mission_loser == 0 || FTUE < 150) {
            if (FTUE >= 150) {
              mis_n = go(d888);
              mis_coins = game.rnd.integerInRange(Number(game.cache.getJSON('missions_json')['MissionR' + mis_n][0]['colmin']), Number(game.cache.getJSON('missions_json')['MissionR' + mis_n][0]['colmax']));
            }
            else {
              mis_n = 1;
              mis_coins = 50;
            }
          }
          else {
            mission_loser = 0;
            mis_n = 1;
            mis_coins = game.rnd.integerInRange(Number(game.cache.getJSON('missions_json')['MissionR' + mis_n][0]['colmin']), Number(game.cache.getJSON('missions_json')['MissionR' + mis_n][0]['colmax']));
          }
          if (misDate == 0) {
            misDate = ddd == 0 ? new Date() : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
            misDate.setHours(misDate.getHours() + 1 * Math.floor(mis_coins / 10));
            //game.setUserDataAndLog({mis_n: mis_n, mis_coins: mis_coins, keys: keys, misDate: String(misDate), coin_missions_completed: coin_missions_completed, coin_missions_shown: coin_missions_shown, mission_skip_success: mission_skip_success, mission_skip_fail: mission_skip_fail});

            coin_missions_completed = 0;
            coin_missions_shown = 6;
            mission_skip_success = 0;
            mission_skip_fail = 0;

            window.eventTrack('Coin_Mission_started', 1, {
              required_coins: mis_coins,
              coin_missions_completed: coin_missions_completed,
              coin_missions_shown: coin_missions_shown,
              completion_rate: Math.round(Number(keys) / (Number(mis_coins) / 100)),
              mission_skip_success: mission_skip_success,
              mission_skip_fail: mission_skip_fail,
            });

            game.setUserDataAndLog({ mis_n: mis_n, mis_coins: mis_coins, keys: keys, misDate: String(misDate), coin_missions_completed: coin_missions_completed, coin_missions_shown: coin_missions_shown, mission_skip_success: mission_skip_success, mission_skip_fail: mission_skip_fail });
          }
        }

      if ((missions_tab_back != 0 && popup != 0 && missions_tab_open == 33) || (is_map == 0 && missions_tab_back != 0)) {
        if (gift_shine2 != 0 && typeof gift_shine2 !== "undefined") { gift_shine2.destroy(); gift_shine2 = 0; }
        mission_group.removeAll(true);
        mission_group.children.forEach(function (child_item) {
          child_item.destroy();
        });
        game.world.bringToTop(mission_group);
        var Progress_Bar = game.add.sprite(game.camera.width / 2, 187, 'game_ui_atlas', 'Progress_Bar.png');
        Progress_Bar.anchor.setTo(0.5);
        Progress_Bar.alpha = 0;
        game.add.tween(Progress_Bar).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        mission_group.add(Progress_Bar);
        missions_tab_back.addChild(Progress_Bar);
        var Gift_Bar = game.add.sprite(game.camera.width / 2, 215, 'game_ui_atlas', 'Gift_Bar.png');
        Gift_Bar.anchor.setTo(0.5);
        Gift_Bar.alpha = 0;
        game.add.tween(Gift_Bar).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        mission_group.add(Gift_Bar);
        missions_tab_back.addChild(Gift_Bar);
        var Gift_Bar_Level = game.add.sprite(game.camera.width / 2 - 380, 208, 'game_ui_atlas', 'Gift_Bar_Level.png');
        Gift_Bar_Level.anchor.setTo(0, 0.5);
        Gift_Bar_Level.alpha = 0;
        game.add.tween(Gift_Bar_Level).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        Gift_Bar_Level.w = Gift_Bar_Level.width;
        mission_group.add(Gift_Bar_Level);
        missions_tab_back.addChild(Gift_Bar_Level);

        let cropRect = new Phaser.Rectangle(
          0,
          0,
          old_keys * (Gift_Bar_Level.w / mis_coins),
          Gift_Bar_Level.height,
        );
        Gift_Bar_Level.crop(cropRect);

        var Gift_Bar_Level_icon = game.add.sprite(game.camera.width / 2, 204, 'game_ui_atlas', 'Key_Hunt_Mini_Task_Ticket_Coin.png');
        Gift_Bar_Level_icon.anchor.setTo(0, 0.5);
        Gift_Bar_Level_icon.scale.setTo(0.5);
        Gift_Bar_Level_icon.alpha = 0;
        game.add.tween(Gift_Bar_Level_icon).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        mission_group.add(Gift_Bar_Level_icon);
        missions_tab_back.addChild(Gift_Bar_Level_icon);

        var Gift_Bar_Level_text = game.add.text(game.camera.width / 2 + 35, 208, Number(old_keys) + '/' + Number(mis_coins), {
          font: '28px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        Gift_Bar_Level_text.anchor.setTo(0, 0.5);
        Gift_Bar_Level_text.alpha = 0;
        game.add.tween(Gift_Bar_Level_text).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        Gift_Bar_Level_text.stroke = '#8B3B32';
        Gift_Bar_Level_text.strokeThickness = 4;
        mission_group.add(Gift_Bar_Level_text);
        missions_tab_back.addChild(Gift_Bar_Level_text);

        Gift_Bar_Level_icon.x -= (Gift_Bar_Level_icon.width + 20 + Gift_Bar_Level_text.width) / 2;
        Gift_Bar_Level_text.x -= (Gift_Bar_Level_icon.width + 20 + Gift_Bar_Level_text.width) / 2;

        var tween = game.add.tween(cropRect).to({ width: keys * (Gift_Bar_Level.w / mis_coins) }, 1000, Phaser.Easing.Linear.None, true);
        tween.c = cropRect;
        tween.onUpdateCallback(function (item) {
          try {
            Gift_Bar_Level.crop(item.c);
          } catch (err) { }
        }, this);

        // final text change
        tween.onComplete.add(function () {
          Gift_Bar_Level_text.setText(Number(keys) + '/' + Number(mis_coins));
          old_keys = Number(keys);
        });

        var new_keys = Number(old_keys);

        // text change update
        game.time.events.repeat(100, 10, function () {
          new_keys = Number(new_keys) + Number(Math.floor((Number(keys) - Number(old_keys)) / 10));
          Gift_Bar_Level_text.setText(Number(new_keys) + '/' + Number(mis_coins));
        }, this);

        var reset_text = game.add.text(game.camera.width / 2, 175, mis_n == -1 ? '' : game.cache.getJSON('lang')['t543'][0][window.lang], {
          font: '24px RussoOne',
          fill: '#0D6A96',
          align: 'center',
        });
        reset_text.anchor.setTo(0, 1);
        reset_text.alpha = 0;
        game.add.tween(reset_text).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        reset_text.stroke = '#F9F0DA';
        reset_text.strokeThickness = 4;
        mission_group.add(reset_text);
        missions_tab_back.addChild(reset_text);

        misDate_timer_text = game.add.text(game.camera.width / 2 + reset_text.width + 10, 175, mis_n == -1 ? game.cache.getJSON('lang')['t544'][0][window.lang] : '00:00:00', {
          font: '32px RussoOne',
          fill: '#8C3B32',
          align: 'center',
        });

        misDate_timer_text.anchor.setTo(0, 1);
        misDate_timer_text.alpha = 0;
        game.add.tween(misDate_timer_text).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        misDate_timer_text.stroke = '#F9F0DA';
        misDate_timer_text.strokeThickness = 4;
        mission_group.add(misDate_timer_text);
        missions_tab_back.addChild(misDate_timer_text);

        reset_text.x -= (reset_text.width + 10 + misDate_timer_text.width) / 2;
        misDate_timer_text.x -= (reset_text.width + 10 + misDate_timer_text.width) / 2;

        gift_shine2 = game.add.sprite(game.camera.width / 2 + 380, 208, 'game_ui_atlas', 'Gift_Shine.png');
        gift_shine2.anchor.setTo(0.5);
        gift_shine2.alpha = 0;
        game.add.tween(gift_shine2).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        mission_group.add(gift_shine2);
        missions_tab_back.addChild(gift_shine2);
        rotate_tween(gift_shine2);

        var gift_l = mis_coins <= 100 ? 1 : mis_coins <= 200 ? 2 : mis_coins <= 300 ? 3 : mis_coins <= 400 ? 4 : mis_coins <= 500 ? 5 : 6;

        gift = game.add.sprite(game.camera.width / 2 + 380, 208, 'game_ui_atlas', 'GiftBox_lv' + gift_l + '_B.png');
        gift.anchor.setTo(0.5);
        gift.alpha = 0;
        game.add.tween(gift).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
        mission_group.add(gift);
        missions_tab_back.addChild(gift);
        var gift_lid = game.add.sprite(2, -5, 'game_ui_atlas', 'GiftBox_lv' + gift_l + '_T.png');
        gift_lid.anchor.setTo(0.5, 1);
        gift.addChild(gift_lid);

        mission_group.alpha = 0;
        misDate_timer();

        if (Number(keys) >= Number(mis_coins)) {

          window.eventTrack('Coin_Mission_completed', 1, {
            required_coins: mis_coins,
            coin_missions_completed: coin_missions_completed,
            coin_missions_shown: coin_missions_shown,
            completion_rate: Math.round(Number(keys) / (Number(mis_coins) / 100)),
            mission_skip_success: mission_skip_success,
            mission_skip_fail: mission_skip_fail,
          });

          game.setUserDataAndLog({ coin_missions_completed: coin_missions_completed, coin_missions_shown: coin_missions_shown, mission_skip_success: mission_skip_success, mission_skip_fail: mission_skip_fail });

          animation = 1;
          popup = 2;
          level_end_check = 1;
          game.add.tween(UI_bottom_group).to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true);
          game.add
            .tween(gift)
            .to({ angle: '+6' }, 50, Phaser.Easing.Linear.None, true, 1000)
            .onComplete.add(function () {
              game.add
                .tween(gift)
                .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  game.add
                    .tween(gift)
                    .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      game.add
                        .tween(gift)
                        .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          game.add
                            .tween(gift)
                            .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function () {
                              game.add
                                .tween(gift)
                                .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function () {
                                  game.add
                                    .tween(gift)
                                    .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                    .onComplete.add(function () {
                                      game.add
                                        .tween(gift)
                                        .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                        .onComplete.add(function () {
                                          game.add
                                            .tween(gift)
                                            .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                            .onComplete.add(function () {
                                              game.add
                                                .tween(gift)
                                                .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                                .onComplete.add(function () {
                                                  game.add
                                                    .tween(gift)
                                                    .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                                    .onComplete.add(function () {
                                                      game.add
                                                        .tween(gift)
                                                        .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                                        .onComplete.add(function () {
                                                          game.add
                                                            .tween(gift)
                                                            .to(
                                                              { angle: '+12' },
                                                              100,
                                                              Phaser.Easing.Linear.None,
                                                              true,
                                                            )
                                                            .onComplete.add(function () {
                                                              game.add
                                                                .tween(gift)
                                                                .to(
                                                                  { angle: '-12' },
                                                                  100,
                                                                  Phaser.Easing.Linear.None,
                                                                  true,
                                                                )
                                                                .onComplete.add(function () {
                                                                  game.add
                                                                    .tween(gift)
                                                                    .to(
                                                                      { angle: '+12' },
                                                                      100,
                                                                      Phaser.Easing.Linear.None,
                                                                      true,
                                                                    )
                                                                    .onComplete.add(function () {
                                                                      game.add
                                                                        .tween(gift)
                                                                        .to(
                                                                          { angle: '-6' },
                                                                          100,
                                                                          Phaser.Easing.Linear.None,
                                                                          true,
                                                                        );
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
          game.add
            .tween(gift.scale)
            .to({ x: 1.2, y: 1.2 }, 400, Phaser.Easing.Linear.None, true, 1000)
            .onComplete.add(function () {
              game.add
                .tween(gift.scale)
                .to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  game.add
                    .tween(gift.scale)
                    .to({ x: 1.2, y: 1.2 }, 400, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      game.add
                        .tween(gift.scale)
                        .to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {


                          if (is_map) { game.add.tween(black_sprite).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true); }
                          game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                            friends_group.removeAll(true);
                            backcard_group.removeAll(true); mission_group.removeAll(true);
                            backcard_group.alpha = 1;
                            UI_bottom_group.removeAll(true);
                            UI_bottom_group_create(1, 1, 1, 1, 0);
                            UI_bottom_group.y = 400;
                            game.add
                              .tween(UI_bottom_group)
                              .to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
                          });

                          var nnn = 1;
                          while (game.cache.getJSON('missions_json')['MissionR' + mis_n][0]['reward' + nnn] != '0') {
                            var mis_r1 = game.cache.getJSON('missions_json')['MissionR' + mis_n][0]['reward' + nnn].split(',');
                            var mis_r1c = game.cache.getJSON('missions_json')['MissionR' + mis_n][0]['reward' + nnn + 'c'].split(',');
                            var rnd = go(mis_r1c) - 1;
                            var pos = -1;
                            for (var i = 0; i < mis_r1.length; i++) {
                              if (mis_r1[i].indexOf('-') != -1) {
                                mis_r1[i] = Number(game.rnd.integerInRange(Number(mis_r1[i].split('-')[0]), Number(mis_r1[i].split('-')[1])));
                              }
                              mis_r1[i] = Number(mis_r1[i]);
                              if (i < rnd) {
                                mis_r1[i] = 0;
                              } else
                                if (i >= rnd && mis_r1[i] != 0 && pos == -1) {
                                  pos = i;
                                } else
                                  if (i > pos) {
                                    mis_r1[i] = 0;
                                  }
                            }

                            for (var i = 0; i < mis_r1.length; i++) {
                              mis_r[i] = mis_r[i] + mis_r1[i];
                            }
                            nnn++;
                          }
                          popup = 0;
                          animation = 0;
                          missions_tab_open = 0;
                          //level_end_check = 0;
                          black_sprite2 = black_sprite;
                          chest_open_window(
                            game.cache.getJSON('lang')['Reward!'][0][window.lang],
                            mis_r,
                            is_map ? 51.5 : 51.7,
                            void 0,
                            {
                              // gameArea: DdnaGameArea.Map,
                              // actionType: DdnaTransactionActionType.DailyGift,
                              gameArea: null,
                              actionType: null,
                            },
                          );
                          misDate = 0;
                          keys = Number(keys) - Number(mis_coins);
                          old_keys = 0;
                          mis_n = 0;
                          mis_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                          game.setUserDataAndLog({ mis_n: mis_n, mis_coins: mis_coins, keys: keys, misDate: String(misDate) });
                          mission_create(0);
                          source_chest = 'Missions compile';
                          package_id_chest = 0;

                        });
                    });
                });
            });
        }

      }

      let mas_check = [];
      let mission_col = Number(game.cache.getJSON('missions_json')['MissionSetting'][0]['MissionCol']);
      let mission_n = 0;
      for (var i = 0; i < missions.length; i += 4) {
        mas_check.push(Math.abs(missions[i]));
      };
      for (var i = 0; i < missions.length; i += 4) {
        /*if (keys == -1) {
          if (missions[i + 3] <= 10) missions[i] = 0;
        }*/
        if (missions[i] == -100) {
          missions[i] = 0;
        }
        if (missions[i] == 0) {
          let a = 0;
          let mission_type = 0;
          while (a == 0) {
            mission_n = game.rnd.integerInRange(1, mission_col);
            mission_type = Number(game.cache.getJSON('missions_json')['Mission' + mission_n][0]['type']);
            if (all_level[Number(game.cache.getJSON('missions_json')['Mission' + mission_n][0]['level'])] > 0 || Number(game.cache.getJSON('missions_json')['Mission' + mission_n][0]['level']) == 0)
              if (mas_check.indexOf(Math.abs(mission_type)) == -1 && mission_type != indx) {
                a = 1;
                mas_check.push(Math.abs(mission_type));
              }
          }
          let m_min = Number(game.cache.getJSON('missions_json')['Mission' + mission_n][0]['colmin']);
          let m_max = Number(game.cache.getJSON('missions_json')['Mission' + mission_n][0]['colmax']);
          console.log('m_min', m_min, 'm_max', m_max);
          if (m_min >= 20) { m_min = m_min / 5; }
          if (m_max >= 20) { m_max = m_max / 5; }
          let mission_target = Number(game.cache.getJSON('missions_json')['Mission' + mission_n][0]['colmin']) >= 20 ? game.rnd.integerInRange(m_min, m_max) * 5 : game.rnd.integerInRange(m_min, m_max);
          let mission_prize = 0;
          mission_prize = Number(game.cache.getJSON('missions_json')['Mission' + mission_n][0]['coins']);
          missions[i] = mission_type;
          missions[i + 1] = mission_target;
          missions[i + 2] = 0;
          missions[i + 3] = mission_prize;
        }
      }
      game.setUserDataAndLog({ missions: JSON.stringify(missions) });
    };
    mission_create(0);
    game.setUserDataAndLog({ missions: JSON.stringify(missions) });
    window.mission_element_create = function (i) {
      missions_tab_open = 33;
      let yyy = 1;
      let xxx = 0;
      xxx = i;
      if (xxx > 2) {
        xxx -= 3;
        yyy = -1;
      }
      if (missions[i * 4] != 0 && missions[i * 4] != -100) {
        var mission_bg = game.add.sprite(
          game.camera.width / 2 - 430 + 430 * xxx,
          game.camera.height / 2 - 150 * yyy + 20,
          'game_ui_atlas',
          'Key_Hunt_Mini_Task_Ticket.png',
        );
        mission_bg.anchor.setTo(0.5);
        mission_bg.scale.setTo(0);
        mission_bg.indx = i;
        missions_tab_back.addChild(mission_bg);
        if (missions[i * 4 + 2] >= missions[i * 4 + 1]) {
          mission_bg.inputEnabled = true;
          mission_bg.events.onInputUp.add(function (item) {
            if (popup != 2 && is_map == 0) {
              popup = 2;
            }
          });
          var mission_bg_c = game.add.sprite(0, 0, 'game_ui_atlas', 'Key_Hunt_Mini_Task_Ticket_Completed.png');
          mission_bg_c.anchor.setTo(0.5);
          mission_bg_c.alpha = 0;
          mission_bg.addChild(mission_bg_c);
          game.add.tween(mission_bg_c).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 600 + 50 * i);
        }
        game.add.tween(mission_bg.scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Bounce.Out, true, 50 * i);
        game.add
          .tween(mission_bg)
          .to({ alpha: 1 }, 600, Phaser.Easing.Bounce.Out, true, 50 * i)
          .onComplete.add(function (item) {
            level_end_check2 = 0;
            if (missions[item.indx * 4 + 2] >= missions[item.indx * 4 + 1]) {
              game.add
                .tween(item.scale)
                .to({ x: 1.05, y: 1.05 }, 400, Phaser.Easing.Linear.None, true, 1400)
                .yoyo(true, 100);
            }
          });
        var mission_target = missions[i * 4 + 1];
        var mission_title = '';
        mission_title = game.cache.getJSON('lang')['Mission' + Math.abs(missions[i * 4])][0][window.lang];
        mission_title = mission_title.replace('[x]', mission_target);
        mission_title = game.add.text(0, -90, mission_title, {
          font: '28px RussoOne',
          fill: '#8b3b30',
          align: 'center',
          wordWrap: true,
          wordWrapWidth: 370,
        });
        mission_title.anchor.setTo(0.5);
        mission_title.lineSpacing = -10;
        mission_title.indx = i;
        mission_bg.addChild(mission_title);
        var mission_line = game.add.sprite(-155, -32, 'game_ui_atlas', 'Key_Hunt_Mini_Task_Ticket_Level_Bar.png');
        mission_line.w = mission_line.width;
        mission_line.anchor.setTo(0, 0.5);
        mission_line.indx = i;
        mission_bg.addChild(mission_line);
        var cropRect = new Phaser.Rectangle(0, 0, 0, mission_line.height);
        mission_line.crop(cropRect);
        var tween = game.add
          .tween(cropRect)
          .to(
            { width: missions[i * 4 + 2] * (mission_line.w / missions[i * 4 + 1]) },
            1000,
            Phaser.Easing.Linear.None,
            true,
            600 + 50 * i,
          );
        tween.c = cropRect;
        tween.onUpdateCallback(function (item) {
          try {
            mission_line.crop(item.c);
          } catch (err) { }
        }, this);
        var mission_icon = game.add.sprite(
          -129,
          -33,
          'game_ui_atlas',
          'missions_icon' + Number(missions[i * 4] * -1) + '.png',
        );
        mission_icon.anchor.setTo(0.5);
        mission_icon.indx = i;
        mission_bg.addChild(mission_icon);
        var mission_target_text = game.add.text(0, -32, '0/' + missions[i * 4 + 1], {
          font: '24px RussoOne',
          fill: '#fff',
          align: 'center',
        });

        mission_target_text.anchor.setTo(0.5);
        mission_target_text.indx = i;
        mission_target_text.stroke = '#8B3B32';
        mission_target_text.strokeThickness = 4;
        mission_bg.addChild(mission_target_text);
        var m_t = 0;
        var tween2 = game.add
          .tween(mission_target_text)
          .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 600 + 50 * i);

        tween2.ooo = mission_target_text;
        tween2.ppp = missions[i * 4 + 2] / 60;

        tween2.onUpdateCallback(function (item) {
          if (m_t < missions[item.ooo.indx * 4 + 2]) {
            m_t += item.ppp;
          }
          item.ooo.setText(Number(Math.round(m_t)) + '/' + Number(missions[item.ooo.indx * 4 + 1]));
        }, this);
        tween2.onComplete.add(function (item) {
          item.setText(Number(missions[item.indx * 4 + 2]) + '/' + Number(missions[item.indx * 4 + 1]));
        }, this);
        var mission_shine = game.add.sprite(150, -40, 'game_ui_atlas', 'shine.png');
        mission_shine.anchor.setTo(0.5);
        mission_shine.scale.setTo(0);
        mission_shine.indx = i;
        rotate_tween(mission_shine);
        mission_bg.addChild(mission_shine);
        game.add
          .tween(mission_shine)
          .to({ alpha: 1 }, 600, Phaser.Easing.Bounce.Out, true, 50 * i)
          .onComplete.add(function (item) {
            if (missions[item.indx * 4 + 2] >= missions[item.indx * 4 + 1]) {
              game.add.tween(item.scale).to({ x: 0.6, y: 0.6 }, 800, Phaser.Easing.Bounce.Out, true, 1400);
            }
          });
        //if (missions[i * 4 + 3] < 10) {missions[i * 4 + 3]*=10;}
        var mission_reward_icon = game.add.sprite(150, -40, 'game_ui_atlas', 'Key_Hunt_Mini_Task_Ticket_Coin.png');
        //else var mission_reward_icon = game.add.sprite(150, -40, 'game_atlas', 'key_mission.png');
        mission_reward_icon.anchor.setTo(0.5);
        mission_reward_icon.indx = i;
        mission_bg.addChild(mission_reward_icon);
        var mission_reward = game.add.text(150, 10, 'x' + missions[i * 4 + 3], {
          font: '20px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        mission_reward.anchor.setTo(0.5);
        mission_reward.indx = i;
        mission_bg.addChild(mission_reward);
        if (missions[i * 4 + 2] < missions[i * 4 + 1]) {
          if (is_map == 1) {
            var mission_skip = game.add.sprite(0, 70, 'game_ui_atlas', 'Skip_Button.png');
            mission_skip.anchor.setTo(0.5);
            mission_skip.indx = i;
            mission_skip.priorityID = 1000;
            mission_bg.addChild(mission_skip);
            button_animation_f(mission_skip, 1);
            mission_skip.events.onInputUp.add(function (item) {
              btnup(item);
              if (popup != 2 && FTUE > 33 && FTUE != 50 && FTUE != 51 && animation == 0) {
                var indx = item.indx;
                if (FTUE < 150) {
                  if (missions[indx * 4] == -6) {
                    if (fbv == 1) {
                      window.eventTrack('FTUE_11_X_ClearClubsSkipButtonClicked');
                    }
                  } else if (missions[indx * 4] == -8) {
                    if (fbv == 1) {
                      window.eventTrack('FTUE_11_X_ClearDiamondsSkipButtonClicked');
                    }
                  }
                  if (fbv == 1) {
                    window.eventTrack('FTUE_11_X_ClearXSkipButtonClicked');
                  }
                }
                loading();
                if (fbv == 1) {
                  console.log("%cThis should not happen!", "color:orange");
                  // var preloadedRewardedVideo = null;
                  // getRewardedVideoAsync(placement.Rewarded1, {
                  //   adContext: DdnaAdContext.RewardedMap,
                  //   adGameArea: DdnaAdGameArea.Map,
                  //   adRewardType: TAdRewardType.No,
                  //   levelNumber: null,
                  // })
                  //   .then(function (rewarded) {
                  //     preloadedRewardedVideo = rewarded;
                  //     return preloadedRewardedVideo.loadAsync();
                  //   })
                  //   .then(function () {
                  //     console.log('Rewarded video preloaded');
                  //     if (music_on == 1) {
                  //       music.pause();
                  //     }
                  //     if (sound_on == 1) {
                  //       ambient.pause();
                  //     }
                  //     preloadedRewardedVideo
                  //       .showAsync()
                  //       .then(function () {
                  //         console.log('Rewarded video watched successfully');
                  //         popup = 1;
                  //         if (loading_black_sprite != 0) {
                  //           loading_black_sprite.destroy();
                  //           loading_black_sprite = 0;
                  //         }
                  //         if (loading_text != 0 && loading_text != 1) {
                  //           loading_text.destroy();
                  //           loading_text = 0;
                  //         }
                  //         loading_text = 1;
                  //         coin_missions_shown++;
                  //         mission_skip_success++;
                  //         game.setUserDataAndLog({ coin_missions_shown: coin_missions_shown, mission_skip_success: mission_skip_success, mission_skip_fail: mission_skip_fail });
                  //         missions_tab_back.children.forEach(function (child_item) {
                  //           if (child_item.indx == indx) {
                  //             game.add
                  //               .tween(child_item)
                  //               .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                  //               .onComplete.add(function (item2) {
                  //                 item2.destroy();
                  //                 mission_element_create(indx);
                  //               });
                  //           }
                  //         });
                  //         let ms = missions[indx * 4];
                  //         missions[indx * 4] = 0;
                  //         mission_create(ms);
                  //         if (music_on == 1) {
                  //           music.play();
                  //         }
                  //       })
                  //       .catch(function (e) {
                  //         console.error(e.message);
                  //         if (loading_black_sprite != 0) {
                  //           loading_black_sprite.destroy();
                  //           loading_black_sprite = 0;
                  //         }
                  //         if (loading_text != 0 && loading_text != 1) {
                  //           loading_text.destroy();
                  //           loading_text = 0;
                  //         }
                  //         loading_text = 1;
                  //         popup_group.removeAll(true);
                  //         backcard_group.removeAll(true); mission_group.removeAll(true);
                  //         popup = 0;
                  //         black_sprite.destroy();
                  //         popup_group.y -= game.camera.height;
                  //         UI_bottom_group.removeAll(true);
                  //         UI_bottom_group_create(1, 1, 1, 1, 0);
                  //         UI_bottom_group.y = 400;
                  //         game.add.tween(UI_bottom_group).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
                  //         mission_skip_fail++;
                  //         game.setUserDataAndLog({ coin_missions_shown: coin_missions_shown, mission_skip_success: mission_skip_success, mission_skip_fail: mission_skip_fail });
                  //         no_ad(3, 0);
                  //         if (music_on == 1) {
                  //           music.play();
                  //         }
                  //       });
                  //   })
                  //   .catch(function (err) {
                  //     console.error('Rewarded video failed to preload: ' + err.message);
                  //     if (loading_black_sprite != 0) {
                  //       loading_black_sprite.destroy();
                  //       loading_black_sprite = 0;
                  //     }
                  //     if (loading_text != 0 && loading_text != 1) {
                  //       loading_text.destroy();
                  //       loading_text = 0;
                  //     }
                  //     loading_text = 1;
                  //     popup_group.removeAll(true);
                  //     backcard_group.removeAll(true); mission_group.removeAll(true);
                  //     popup = 0;
                  //     black_sprite.destroy();
                  //     popup_group.y -= game.camera.height;
                  //     UI_bottom_group.removeAll(true);
                  //     UI_bottom_group_create(1, 1, 1, 1, 0);
                  //     UI_bottom_group.y = 400;
                  //     game.add.tween(UI_bottom_group).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
                  //     mission_skip_fail++;
                  //     game.setUserDataAndLog({ coin_missions_shown: coin_missions_shown, mission_skip_success: mission_skip_success, mission_skip_fail: mission_skip_fail });
                  //     no_ad(3, 0);
                  //   });
                } else {
                  if (music_on == 1) music.pause();
                  if (sound_on == 1) ambient.pause();

                  sdkHandler.trigger(
                    'rewardedAd',
                    {
                      callback: function (success) {
                        if (music_on == 1) music.play();
                        if (sound_on == 1) ambient.play();

                        if (success) {
                          console.log('Rewarded video watched successfully 3');
                          popup = 1;
                          if (loading_black_sprite != 0) {
                            loading_black_sprite.destroy();
                            loading_black_sprite = 0;
                          }
                          if (loading_text != 0 && loading_text != 1) {
                            loading_text.destroy();
                            loading_text = 0;
                          }
                          loading_text = 1;
                          missions_tab_back.children.forEach(function (child_item) {
                            if (child_item.indx == indx) {
                              game.add
                                .tween(child_item)
                                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function (item2) {
                                  item2.destroy();
                                  mission_element_create(indx);
                                });
                            }
                          });
                          let ms = missions[indx * 4];
                          missions[indx * 4] = 0;
                          mission_create(ms);
                        } else {
                          console.error('Rewarded video failed to load 3');

                          if (loading_black_sprite != 0) {
                            loading_black_sprite.destroy();
                            loading_black_sprite = 0;
                          }
                          if (loading_text != 0 && loading_text != 1) {
                            loading_text.destroy();
                            loading_text = 0;
                          }
                          loading_text = 1;
                          popup_group.removeAll(true);
                          backcard_group.removeAll(true); mission_group.removeAll(true);
                          popup = 0;
                          black_sprite.destroy();
                          popup_group.y -= game.camera.height;
                          UI_bottom_group.removeAll(true);
                          UI_bottom_group_create(1, 1, 1, 1, 0);
                          UI_bottom_group.y = 400;
                          game.add.tween(UI_bottom_group).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
                          no_ad(3, 0);
                        }
                      },
                    },
                    this,
                  );
                }
                popup = 2;
              }
            });
            var mission_skip_text = game.add.text(20, 0, game.cache.getJSON('lang')['t285'][0][window.lang], {
              font: '28px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            mission_skip_text.anchor.setTo(0.5);
            mission_skip_text.lineSpacing = -10;
            mission_skip_text.stroke = '#457310';
            mission_skip_text.strokeThickness = 2;
            mission_skip_text.setShadow(0, 3, 'rgba(69,115,16,0.7)', 1);
            mission_skip.addChild(mission_skip_text);
          }
        } else {
          var mission_skip = game.add.sprite(0, 70, 'game_ui_atlas', 'Button.png');
          mission_skip.anchor.setTo(0.5);
          mission_bg.addChild(mission_skip);
          mission_skip.scale.setTo(2);
          mission_skip.indx = i;
          mission_skip.inputEnabled = false;
          mission_skip.alpha = 0;
          mission_skip.click = 0;
          mission_skip.scl = 1;
          mission_skip.priorityID = 1000;
          mission_skip.events.onInputUp.add(function (item) {
            level_end_check2 = 1;
            if (FTUE != 51)
              if (item.click == 0 && popup != 2 && animation == 0)
                if (
                  (FTUE == 31 && item.indx == 0) ||
                  (FTUE == 32 && item.indx == 1) ||
                  (FTUE == 33 && item.indx == 2) ||
                  FTUE > 33
                ) {
                  if (is_map != 1) {
                    if (level == 6) {
                      if (fbv == 1) {
                        window.eventTrack('FTUE_11_9_1_user_clicked');
                      }
                    }
                  }
                  popup = 2;
                  animation = 1;
                  level_end_check2 = 1;
                  var indx = item.indx;
                  item.click = 1;
                  if (FTUE <= 33) {
                    if (missions[indx * 4] == -1) {
                      if (fbv == 1) {
                        window.eventTrack('FTUE_11_6_B_ClearHeartsCompleteClicked');
                      }
                    } else if (missions[indx * 4] == -6) {
                      if (fbv == 1) {
                        window.eventTrack('FTUE_11_6_A_ClearClubsCompleteClicked');
                      }
                    } else if (missions[indx * 4] == -7) {
                      if (fbv == 1) {
                        window.eventTrack('FTUE_11_6_C_ClearSpadesCompleteClicked');
                      }
                    }
                  }
                  if (is_map == 1) {
                    FTUE_process();
                    indicator_system(0);
                  }
                  missions_tab_back.children.forEach(function (child_item) {
                    if (child_item.indx == indx) {
                      game.add
                        .tween(child_item)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item2) {
                          item2.destroy();
                          mission_element_create(indx);
                        });
                    }
                  });
                  if (missions[indx * 4 + 3] > 0) {
                    var x1 = item.world.x;
                    var y1 = item.world.y;
                    var col = missions[indx * 4 + 3];
                    coins = Number(coins) + Number(col);
                    keys = Number(keys) + Number(col);
                    coin_missions_completed++;
                    coin_missions_shown++;
                    game.setUserDataAndLog({ keys: String(keys), coin_missions_completed: coin_missions_completed, coin_missions_shown: coin_missions_shown });
                    game.setCurrentEvent();
                    window.eventTrack('coins_in', col, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: col,
                      source: 'missions',
                      package_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });

                    // save collected coins
                    game.setUserDataAndLog({ currencies: coins });

                    var ctext = 0;
                    var c_el = 0;
                    if (is_map == 1) {
                      coins_text = coins - col;
                      text_coins_panel.setText(coins_text);
                      ctext = coins_text;
                      c_el = text_coins_panel;
                    } else {
                      let coins_txt = coins - col;
                      UI_Coins_BG.children[1].setText(coins_txt);
                      ctext = coins_txt;
                      c_el = UI_Coins_BG.children[1];
                    }
                    var var_coins = 0;
                    if (sound_on == 1) {
                      play_sound('coins_add');
                    }
                    game.time.events.repeat(
                      100,
                      10,
                      function () {
                        var get_coin = game.add.sprite(
                          x1 + game.rnd.integerInRange(-10, 10),
                          y1 + game.rnd.integerInRange(-10, 10),
                          'game_atlas',
                          'icon_coins.png',
                        );
                        get_coin.anchor.setTo(0.5);
                        get_coin.scale.setTo(0);
                        get_coin.alpha = 0;
                        effects_group.add(get_coin);
                        game.world.bringToTop(effects_group);
                        game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                        game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                        game.add
                          .tween(get_coin)
                          .to({ x: c_el.world.x, y: c_el.world.y }, 600, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            item.destroy();
                            var_coins += col / 10;
                            c_el.setText(Math.ceil(ctext + var_coins));
                            if (Number(keys) < Number(mis_coins)) {
                              level_end_check = 0;
                              animation = 0;
                              if (popup == 2) { popup = 1; }
                            }
                          });
                      },
                      this,
                    );
                  }
                  missions[indx * 4] = 0;
                  mission_create(0);
                  game.setUserDataAndLog({ missions: JSON.stringify(missions) });
                }
            popup = 2;
            // save collected coins
            game.setUserDataAndLog({ currencies: coins });
          });
          mission_skip_text = game.add.text(0, 0, game.cache.getJSON('lang')['Complete'][0][window.lang], {
            font: '30px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          mission_skip_text.anchor.setTo(0.5);
          mission_skip_text.stroke = '#457310';
          mission_skip_text.strokeThickness = 2;
          mission_skip_text.setShadow(0, 3, 'rgba(69,115,16,0.7)', 1);
          mission_skip.addChild(mission_skip_text);
          game.add.tween(mission_skip.scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Bounce.Out, true, 2000 + 50 * i);
          game.add
            .tween(mission_skip)
            .to({ alpha: 1 }, 600, Phaser.Easing.Linear.None, true, 2000 + 50 * i)
            .onComplete.add(function (item) {
              item.inputEnabled = true;
              item.input.useHandCursor = true;
              scale_tween(item, 500, 0.05, 0.05);
            });
          var Green_Check = game.add.sprite(-129, -20, 'game_ui_atlas', 'Green_Check.png');
          Green_Check.alpha = 0;
          Green_Check.anchor.setTo(0.5);
          Green_Check.scale.setTo(4);
          mission_bg.addChild(Green_Check);
          game.add.tween(Green_Check).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 1400 + 50 * i);
          game.add.tween(Green_Check.scale).to({ x: 1, y: 1 }, 800, Phaser.Easing.Bounce.Out, true, 1400 + 50 * i);
        }
      } else {
        var mission_bg = game.add.sprite(
          game.camera.width / 2 - 180 + 430 * xxx,
          game.camera.height / 2 - 156 * yyy,
          'game_ui_atlas',
          'Wait_Mission_Mini_Ticket.png',
        );
        mission_bg.anchor.setTo(0.5);
        mission_bg.scale.setTo(0);
        mission_bg.indx = i;
        missions_tab_back.addChild(mission_bg);
        game.add.tween(mission_bg.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true);
        var mission_wait_text = game.add.text(0, -74, game.cache.getJSON('lang')['t286'][0][window.lang], {
          font: '30px RussoOne',
          fill: '#8C3B32',
          align: 'center',
          wordWrap: true,
          wordWrapWidth: 400,
        });
        mission_wait_text.indx = i;
        mission_wait_text.lineSpacing = -10;
        mission_wait_text.anchor.setTo(0.5);
        mission_wait_text.stroke = '#fff';
        mission_wait_text.strokeThickness = 4;
        mission_bg.addChild(mission_wait_text);
        var mission_wait_timer = game.add.text(-30, 47, '00:00:00', {
          font: '40px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        mission_wait_timer.anchor.setTo(0.5);
        mission_wait_timer.indx = i;
        mission_wait_timer.t = 'timer';
        mission_wait_timer.stroke = '#8C3B32';
        mission_wait_timer.strokeThickness = 4;
        mission_wait_timer.setShadow(0, 3, 'rgba(140,59,50,0.7)', 1);
        mission_bg.addChild(mission_wait_timer);
        var wait_mission_mini_ticket_clock = game.add.sprite(
          130,
          45,
          'game_ui_atlas',
          'Wait_Mission_Mini_Ticket_Clock.png',
        );
        wait_mission_mini_ticket_clock.anchor.setTo(0.5);
        wait_mission_mini_ticket_clock.indx = i;
        mission_bg.addChild(wait_mission_mini_ticket_clock);
      }
    };
    missions_tab_icon = game.add.sprite(-12, 379, '');
    missions_tab_icon.fixedToCamera = true;
    missions_tab_icon.alpha = 0;
    function mission_destroy(index) {
      var indx = index;
      if (missions_tab_back != 0) {
        missions_tab_back.children.forEach(function (child_item) {
          if (child_item.indx == indx) {
            game.add
              .tween(child_item)
              .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item2) {
                item2.destroy();
              });
          }
        });
      }
    }
    missions_tab_back2 = game.add.sprite(0, 0, '');
    missions_tab_back = game.add.sprite(0, 0, '');
    window.keycomplete = function () {
      keys = 20;
      mission_destroy(10);
      game.add.tween(effects_group).to({ alpha: 1 }, 510, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
        key_mission_create(1);
      });
    };
    function key_mission_create(t) {
      missions_tab_open = 33;
      if (t == 0) {
        if (missions_tab_back != 0) {
          missions_tab_back.destroy();
          missions_tab_back2.destroy();
        }
        missions_tab_back2 = game.add.sprite(0, 0, '');
        missions_tab_back = game.add.sprite(0, 0, '');
        backcard_group.add(missions_tab_back);
        backcard_group.mask = null;
      }
      /*if (keys != -1) {
        var mission_key_back = game.add.sprite(
          game.camera.width / 2 - 640 - 1000,
          game.camera.height / 2,
          'game_ui_atlas',
          'Key_Hunt_Big_Ticket.png',
        );
        mission_key_back.anchor.setTo(0.5);
        mission_key_back.indx = 10;
        missions_tab_back.addChild(mission_key_back);
        game.add.tween(mission_key_back).to({ x: '+1000' }, 500, Phaser.Easing.Linear.None, true);
        var mission_tab_key_title = game.add.text(0, -240, game.cache.getJSON('lang')['KeyHunt'][0][window.lang], {
          font: '46px RussoOne',
          fill: '#fff',
          align: 'left',
        });
        mission_tab_key_title.anchor.setTo(0.5);
        mission_tab_key_title.indx = 10;
        mission_tab_key_title.setShadow(0, 4, 'rgba(0,0,0,0.5)', 2);
        mission_key_back.addChild(mission_tab_key_title);
        var mission_key_line = game.add.sprite(-186, -171, 'game_ui_atlas', 'Key_Hunt_Big_Ticket_Level_Bar.png');
        mission_key_line.w = mission_key_line.width;
        mission_key_line.anchor.setTo(0, 0.5);
        mission_key_line.indx = 10;
        mission_key_line.t = 'line';
        mission_key_back.addChild(mission_key_line);
        var cropRect = new Phaser.Rectangle(0, 0, keys * (mission_key_line.w / keys_max), mission_key_line.height);
        if (mission_key_line.width > mission_key_line.w)
          cropRect = new Phaser.Rectangle(0, 0, mission_key_line.w, mission_key_line.height);
        mission_key_line.crop(cropRect);
        var mission_key_title = game.add.text(0, -170, keys + '/' + keys_max, {
          font: '30px RussoOne',
          fill: '#fff',
          align: 'right',
        });
        mission_key_title.stroke = '#8B3B32';
        mission_key_title.strokeThickness = 4;
        mission_key_title.anchor.setTo(0.5);
        mission_key_title.indx = 10;
        mission_key_title.t = 'line_text';
        mission_key_back.addChild(mission_key_title);
        key_mission_timer_text = game.add.text(-45, 220, '0:00:00:00', {
          font: '40px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        key_mission_timer_text.anchor.setTo(0.5);
        key_mission_timer_text.indx = 10;
        key_mission_timer_text.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
        mission_key_back.addChild(key_mission_timer_text);
        if (keys >= keys_max) {
          var key_mission_z = game.add.graphics(0, 0);
          key_mission_z.beginFill(0xfaf5e9);
          key_mission_z.drawRect(-215, 160, 430, 114);
          mission_key_back.addChild(key_mission_z);
          key_mission_timer_text.alpha = 0;
          var mission_key_complete = game.add.sprite(0, 220, 'game_ui_atlas', 'Button.png');
          mission_key_complete.anchor.setTo(0.5);
          mission_key_complete.scale.setTo(1);
          mission_key_complete.indx = 10;
          mission_key_back.addChild(mission_key_complete);
          mission_key_complete.inputEnabled = true;
          mission_key_complete.scl = 1;
          mission_key_complete.events.onInputUp.add(function (item) {
            if (popup != 2) {
              popup = 2;
              key_mission_timer_text.aplha = 1;
              keys = -1;
              game.setUserDataAndLog({ keys: String(keys) });
              mission_destroy(10);
              if (sound_on == 1) {
                play_sound('reward_window');
              }
              if (backcards[backcards_col - 1] == 0) {
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(UI_bottom_group)
                  .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    backcard_group.removeAll(true); mission_group.removeAll(true);
                    backcard_group.alpha = 1;
                    item.removeAll(true);
                    UI_bottom_group_create(1, 1, 1, 1, 0);
                    item.y = 400;
                    game.add.tween(item).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
                    popup = 0;
                    missions_tab_open = 0;
                    keymissioncomplite();
                  });
              } else {
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add.tween(backcard_group).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(UI_bottom_group)
                  .to({ y: '+400' }, 400, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    backcard_group.removeAll(true); mission_group.removeAll(true);
                    backcard_group.alpha = 1;
                    item.removeAll(true);
                    UI_bottom_group_create(1, 1, 1, 1, 0);
                    item.y = 400;
                    game.add.tween(item).to({ y: '-400' }, 400, Phaser.Easing.Linear.None, true);
                    popup = 0;
                    missions_tab_open = 0;
                    coins += 1000;
                    var p_text = game.cache.getJSON('lang')['GotXCoins'][0][window.lang];
                    p_text = p_text.replace('[x]', '1000');
                    ok_message(2, 1000, game.cache.getJSON('lang')['ReceivedCoins'][0][window.lang], p_text);
                    game.setCurrentEvent();
                    window.eventTrack('coins_in', 1000, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: 1000,
                      source: 'Key mission complete',
                      package_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                  });
              }
            }
          });
          var mission_key_complete_text = game.add.text(0, 0, game.cache.getJSON('lang')['Complete'][0][window.lang], {
            font: '34px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          mission_key_complete_text.anchor.setTo(0.5);
          mission_key_complete.addChild(mission_key_complete_text);
          mission_key_complete.input.useHandCursor = true;
          scale_tween(mission_key_complete, 500, 0.1, 0.1);
        }
      } else {
        var mission_key_parent = game.add.sprite(game.camera.width / 2 - 650, game.camera.height / 2, '');
        mission_key_parent.anchor.setTo(0.5);
        mission_key_parent.scale.setTo(0.5);
        missions_tab_back.addChild(mission_key_parent);
        var mission_tab_key_title = game.add.text(
          game.camera.width / 2 - 650,
          game.camera.height / 2 - 700,
          game.cache.getJSON('lang')['t287'][0][window.lang],
          { font: '46px RussoOne', fill: '#fff', align: 'center' },
        );
        mission_tab_key_title.anchor.setTo(0.5);
        mission_tab_key_title.setShadow(0, 4, 'rgba(13,106,150,0.7)', 2);
        missions_tab_back.addChild(mission_tab_key_title);
        game.add.tween(mission_tab_key_title).to({ y: '+500' }, 400, Phaser.Easing.Linear.None, true);
        var mission_key_shine = game.add.sprite(0, 0, 'game_ui_atlas', 'Shine.png');
        mission_key_shine.anchor.setTo(0.5);
        mission_key_shine.scale.setTo(0);
        mission_key_shine.alpha = 0;
        mission_key_parent.addChild(mission_key_shine);
        game.add.tween(mission_key_shine.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Linear.None, true);
        game.add.tween(mission_key_shine).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
        var mission_key = game.add.sprite(0, 0, 'game_ui_atlas', 'Big_Key_Right.png');
        mission_key.anchor.setTo(0.5);
        mission_key.angle = -90;
        mission_key.scale.setTo(0);
        mission_key_parent.addChild(mission_key);
        game.add.tween(mission_key).to({ angle: '+90' }, 500, Phaser.Easing.Linear.None, true, 400);
        game.add.tween(mission_key).to({ x: '+350', y: '+100' }, 500, Phaser.Easing.Linear.None, true, 400);
        game.add.tween(mission_key.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 400);
        var mission_key = game.add.sprite(0, 0, 'game_ui_atlas', 'Medium_Key_Right.png');
        mission_key.anchor.setTo(0.5);
        mission_key.angle = -90;
        mission_key.scale.setTo(0);
        mission_key_parent.addChild(mission_key);
        game.add.tween(mission_key).to({ angle: '+90' }, 500, Phaser.Easing.Linear.None, true, 550);
        game.add.tween(mission_key).to({ x: '+305', y: '-40' }, 500, Phaser.Easing.Linear.None, true, 550);
        game.add.tween(mission_key.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 550);
        var mission_key = game.add.sprite(0, 0, 'game_ui_atlas', 'Small_Key_Right.png');
        mission_key.anchor.setTo(0.5);
        mission_key.angle = -90;
        mission_key.scale.setTo(0);
        mission_key_parent.addChild(mission_key);
        game.add.tween(mission_key).to({ angle: '+90' }, 500, Phaser.Easing.Linear.None, true, 700);
        game.add.tween(mission_key).to({ x: '+170', y: '-130' }, 500, Phaser.Easing.Linear.None, true, 700);
        game.add.tween(mission_key.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 700);
        var mission_key = game.add.sprite(0, 0, 'game_ui_atlas', 'Big_Key_Right.png');
        mission_key.anchor.setTo(0.5);
        mission_key.angle = 90;
        mission_key.scale.setTo(0);
        mission_key_parent.addChild(mission_key);
        game.add.tween(mission_key).to({ angle: '-90' }, 500, Phaser.Easing.Linear.None, true, 400);
        game.add.tween(mission_key).to({ x: '-350', y: '+100' }, 500, Phaser.Easing.Linear.None, true, 400);
        game.add.tween(mission_key.scale).to({ x: -1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 400);
        var mission_key = game.add.sprite(0, 0, 'game_ui_atlas', 'Medium_Key_Right.png');
        mission_key.anchor.setTo(0.5);
        mission_key.angle = 90;
        mission_key.scale.setTo(0);
        mission_key_parent.addChild(mission_key);
        game.add.tween(mission_key).to({ angle: '-90' }, 500, Phaser.Easing.Linear.None, true, 550);
        game.add.tween(mission_key).to({ x: '-305', y: '-40' }, 500, Phaser.Easing.Linear.None, true, 550);
        game.add.tween(mission_key.scale).to({ x: -1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 550);
        var mission_key = game.add.sprite(0, 0, 'game_ui_atlas', 'Small_Key_Right.png');
        mission_key.anchor.setTo(0.5);
        mission_key.angle = 90;
        mission_key.scale.setTo(0);
        mission_key_parent.addChild(mission_key);
        game.add.tween(mission_key).to({ angle: '-90' }, 500, Phaser.Easing.Linear.None, true, 700);
        game.add.tween(mission_key).to({ x: '-170', y: '-130' }, 500, Phaser.Easing.Linear.None, true, 700);
        game.add.tween(mission_key.scale).to({ x: -1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 700);
        var countdown_bar = game.add.sprite(
          game.camera.width / 2 - 650,
          game.camera.height / 2 + 150,
          'game_ui_atlas',
          'Countdown_Bar.png',
        );
        countdown_bar.anchor.setTo(0.5, 0);
        countdown_bar.scale.setTo(0);
        missions_tab_back.addChild(countdown_bar);
        game.add.tween(countdown_bar.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true, 1000);
        var clock = game.add.sprite(150, 76, 'game_ui_atlas', 'Clock.png');
        clock.anchor.setTo(0.5);
        countdown_bar.addChild(clock);
        key_mission_timer_text = game.add.text(-40, 74, '0:00:00:00', {
          font: '40px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        key_mission_timer_text.anchor.setTo(0.5);
        key_mission_timer_text.indx = 10;
        key_mission_timer_text.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
        countdown_bar.addChild(key_mission_timer_text);
        var mission_key_card = game.add.sprite(0, 0, 'game_ui_atlas', 'Mystery_Card.png');
        mission_key_card.anchor.setTo(0.5);
        mission_key_card.scale.setTo(0);
        mission_key_parent.addChild(mission_key_card);
        game.add.tween(mission_key_card.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 300);
      }*/
    }
    function createColorImage(game, source, x1, y1, color) {
      var color = Phaser.Color.hexToColor(color);
      return game.add.sprite(
        x1,
        y1,
        game.add
          .bitmapData(source.width, source.height)
          .fill(color.r, color.g, color.b)
          .blendDestinationAtop()
          .draw(source, 0, 0, source.width, source.height),
      );
    }
    function keymissioncomplite() {
      if (popup == 0 || popup == 2) {
        popup_group.y = 0;
        popup = 1;
        blackf();
        var text_popup_title = game.add.text(
          game.camera.width / 2,
          game.camera.height / 2 - 250,
          game.cache.getJSON('lang')['YouMadeIt'][0][window.lang],
          { font: '80px RussoOne', fill: '#fff', align: 'center' },
        );
        text_popup_title.anchor.setTo(0.5);
        text_popup_title.alpha = 0;
        popup_group.add(text_popup_title);
        text_popup_title.fixedToCamera = true;
        game.add.tween(text_popup_title).to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true);
        var text_popup_title2 = game.add.text(
          game.camera.width / 2,
          game.camera.height / 2 - 180,
          game.cache.getJSON('lang')['MysteryCard'][0][window.lang],
          { font: '50px RussoOne', fill: '#fff', align: 'center' },
        );
        text_popup_title2.anchor.setTo(0.5);
        text_popup_title2.alpha = 0;
        popup_group.add(text_popup_title2);
        text_popup_title2.fixedToCamera = true;
        game.add.tween(text_popup_title2).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true);
        var shine_title = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 20,
          'game_atlas',
          'shine_title.png',
        );
        shine_title.anchor.setTo(0.5);
        shine_title.scale.setTo(0);
        shine_title.alpha = 0;
        popup_group.add(shine_title);
        shine_title.fixedToCamera = true;
        var Suprise_Card = game.add.sprite(-10000, game.camera.height / 2 + 20, 'game_atlas', 'Suprise_Card.png');
        var Suprise_Card1 = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 20,
          'game_atlas',
          'Suprise_Card.png',
        );
        Suprise_Card1.anchor.setTo(0.5);
        Suprise_Card1.scale.setTo(0);
        popup_group.add(Suprise_Card1);
        Suprise_Card1.fixedToCamera = true;
        button_animation_f(Suprise_Card1, 1);
        Suprise_Card1.events.onInputUp.add(function (item) {
          btnup(item);
          Suprise_Card1.inputEnabled = false;
          Suprise_Card2.inputEnabled = false;
          Suprise_Card3.inputEnabled = false;
          game.add.tween(text_popup_title).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add.tween(text_popup_title2).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add.tween(Suprise_Card2).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add.tween(Suprise_Card3).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add
            .tween(Suprise_Card1.cameraOffset)
            .to({ x: game.camera.width / 2, y: game.camera.height / 2 + 20 }, 800, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add.tween(shine_title).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
              game.add.tween(shine_title.scale).to({ x: 3, y: 3 }, 2000, Phaser.Easing.Linear.None, true);
              rotate_tween(shine_title);
              game.add
                .tween(Suprise_Card_white)
                .to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(Suprise_Card_white)
                    .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      game.add
                        .tween(backcard_prize.scale)
                        .to({ x: 0.7, y: 0.7 }, 100, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(backcard_prize.scale)
                            .to({ x: 0.6, y: 0.6 }, 100, Phaser.Easing.Linear.None, true);
                        }, this);
                      game.add
                        .tween(backcard_prize2.scale)
                        .to({ x: 0.9, y: 0.9 }, 100, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(backcard_prize2.scale)
                            .to({ x: 0.8, y: 0.8 }, 100, Phaser.Easing.Linear.None, true);
                        }, this);
                      game.add.tween(backcard_prize2).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(backcard_prize)
                        .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(backcard_prize.children[0])
                            .to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true, 1200)
                            .onComplete.add(function (item) {
                              game.add
                                .tween(black_sprite)
                                .to({ alpha: 0 }, 1000, Phaser.Easing.Exponential.In, true)
                                .onComplete.add(function (item) {
                                  item.destroy();
                                  popup_group.removeAll(true);
                                  popup = 0;
                                  popup_group.y -= game.camera.height;
                                });
                              game.add.tween(shine_title).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                              game.add.tween(backcard.scale).to({ x: 0, y: 0 }, 1000, Phaser.Easing.Linear.None, true);
                              game.add.tween(backcard).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true);
                              game.add.tween(backcard).to({ angle: 720 }, 1000, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(backcard.cameraOffset)
                                .to(
                                  { x: build_button.cameraOffset.x, y: build_button.cameraOffset.y + 30 },
                                  1000,
                                  Phaser.Easing.Linear.None,
                                  true,
                                )
                                .onComplete.add(function (item) {
                                  indicator_system(0);
                                }, this);
                              let col = 500;
                              coins += col;
                              game.setCurrentEvent();
                              window.eventTrack('coins_in', 500, {
                                user_type: bought,
                                lifetime: lifetime_day,
                                highest_lvl: all_level.lastIndexOf(3) + 2,
                                amount: 500,
                                source: 'Key mission complete',
                                package_id: 0,
                                mission_completed: missioncompleted,
                                c_event: current_event,
                              });

                              // save collected coins
                              game.setUserDataAndLog({ currencies: coins });

                              var coins_text = coins - col;
                              text_coins_panel.setText(coins_text);
                              var var_coins = 0;
                              if (sound_on == 1) {
                                play_sound('coins_add');
                              }
                              game.setCurrentEvent();
                              window.eventTrack('booster_in', 1, {
                                user_type: bought,
                                lifetime: lifetime_day,
                                highest_lvl: all_level.lastIndexOf(3) + 2,
                                amount: 1,
                                source: 'TNT',
                                item_id: 0,
                                mission_completed: missioncompleted,
                                c_event: current_event,
                              });
                              booster_tnt_col += 1;
                              game.setUserDataAndLog({
                                booster_tnt_col: booster_tnt_col,
                                backcards: JSON.stringify(backcards),
                              });
                              game.time.events.repeat(
                                100,
                                10,
                                function () {
                                  backcard_prize.alpha = 0;
                                  backcard_prize2.alpha = 0;
                                  var get_coin = game.add.sprite(
                                    backcard_prize.x + game.rnd.integerInRange(-50, 50),
                                    backcard_prize.y + game.rnd.integerInRange(-50, 50),
                                    'game_atlas',
                                    'icon_coins.png',
                                  );
                                  get_coin.anchor.setTo(0.5);
                                  get_coin.scale.setTo(0);
                                  get_coin.alpha = 0;
                                  effects_group.add(get_coin);
                                  game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(get_coin.scale)
                                    .to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(get_coin)
                                    .to(
                                      { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                                      600,
                                      Phaser.Easing.Linear.None,
                                      true,
                                    )
                                    .onComplete.add(function (item) {
                                      item.destroy();
                                      var_coins += 500 / 10;
                                      text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                                    });
                                },
                                this,
                              );
                            }, this);
                        }, this);
                    }, this);
                  backcard.alpha = 1;
                  Suprise_Card1.alpha = 0;
                }, this);
            }, this);
          game.add.tween(Suprise_Card1.scale).to({ x: 1.4, y: 1.4 }, 800, Phaser.Easing.Linear.None, true);
        });
        game.add.tween(Suprise_Card1.scale).to({ x: 1, y: 1 }, 800, Phaser.Easing.Linear.None, true);
        game.add
          .tween(Suprise_Card1)
          .to({ angle: 720 }, 800, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            item.inputEnabled = true;
          });
        var Suprise_Card2 = game.add.sprite(
          game.camera.width / 2 - 260,
          game.camera.height / 2 + 20,
          'game_atlas',
          'Suprise_Card.png',
        );
        Suprise_Card2.anchor.setTo(0.5);
        Suprise_Card2.scale.setTo(0);
        popup_group.add(Suprise_Card2);
        Suprise_Card2.fixedToCamera = true;
        button_animation_f(Suprise_Card2, 1);
        Suprise_Card2.events.onInputUp.add(function (item) {
          btnup(item);
          Suprise_Card1.inputEnabled = false;
          Suprise_Card2.inputEnabled = false;
          Suprise_Card3.inputEnabled = false;
          game.add.tween(text_popup_title).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add.tween(text_popup_title2).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add.tween(Suprise_Card1).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add.tween(Suprise_Card3).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add
            .tween(Suprise_Card2.cameraOffset)
            .to({ x: game.camera.width / 2, y: game.camera.height / 2 + 20 }, 800, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add.tween(shine_title).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
              game.add.tween(shine_title.scale).to({ x: 3, y: 3 }, 2000, Phaser.Easing.Linear.None, true);
              rotate_tween(shine_title);
              game.add
                .tween(Suprise_Card_white)
                .to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(Suprise_Card_white)
                    .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      game.add
                        .tween(backcard_prize.scale)
                        .to({ x: 0.7, y: 0.7 }, 100, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(backcard_prize.scale)
                            .to({ x: 0.6, y: 0.6 }, 100, Phaser.Easing.Linear.None, true);
                        }, this);
                      game.add
                        .tween(backcard_prize2.scale)
                        .to({ x: 0.9, y: 0.9 }, 100, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(backcard_prize2.scale)
                            .to({ x: 0.8, y: 0.8 }, 100, Phaser.Easing.Linear.None, true);
                        }, this);
                      game.add.tween(backcard_prize2).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(backcard_prize)
                        .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(backcard_prize.children[0])
                            .to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true, 1200)
                            .onComplete.add(function (item) {
                              game.add
                                .tween(black_sprite)
                                .to({ alpha: 0 }, 1000, Phaser.Easing.Exponential.In, true)
                                .onComplete.add(function (item) {
                                  item.destroy();
                                  popup_group.removeAll(true);
                                  popup = 0;
                                  popup_group.y -= game.camera.height;
                                });
                              game.add.tween(shine_title).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                              game.add.tween(backcard.scale).to({ x: 0, y: 0 }, 1000, Phaser.Easing.Linear.None, true);
                              game.add.tween(backcard).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true);
                              game.add.tween(backcard).to({ angle: 720 }, 1000, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(backcard.cameraOffset)
                                .to(
                                  { x: build_button.cameraOffset.x, y: build_button.cameraOffset.y + 30 },
                                  1000,
                                  Phaser.Easing.Linear.None,
                                  true,
                                )
                                .onComplete.add(function (item) {
                                  indicator_system(0);
                                }, this);
                              let col = 500;
                              coins += col;
                              game.setCurrentEvent();
                              window.eventTrack('coins_in', 500, {
                                user_type: bought,
                                lifetime: lifetime_day,
                                highest_lvl: all_level.lastIndexOf(3) + 2,
                                amount: 500,
                                source: 'Key mission complete',
                                package_id: 0,
                                mission_completed: missioncompleted,
                                c_event: current_event,
                              });

                              // save collected coins
                              game.setUserDataAndLog({ currencies: coins });

                              var coins_text = coins - col;
                              text_coins_panel.setText(coins_text);
                              var var_coins = 0;
                              if (sound_on == 1) {
                                play_sound('coins_add');
                              }
                              game.setCurrentEvent();
                              window.eventTrack('booster_in', 1, {
                                user_type: bought,
                                lifetime: lifetime_day,
                                highest_lvl: all_level.lastIndexOf(3) + 2,
                                amount: 1,
                                source: 'TNT',
                                item_id: 0,
                                mission_completed: missioncompleted,
                                c_event: current_event,
                              });
                              booster_tnt_col += 1;
                              game.setUserDataAndLog({
                                booster_tnt_col: booster_tnt_col,
                                backcards: JSON.stringify(backcards),
                              });
                              game.time.events.repeat(
                                100,
                                10,
                                function () {
                                  backcard_prize.alpha = 0;
                                  backcard_prize2.alpha = 0;
                                  var get_coin = game.add.sprite(
                                    backcard_prize.x + game.rnd.integerInRange(-50, 50),
                                    backcard_prize.y + game.rnd.integerInRange(-50, 50),
                                    'game_atlas',
                                    'icon_coins.png',
                                  );
                                  get_coin.anchor.setTo(0.5);
                                  get_coin.scale.setTo(0);
                                  get_coin.alpha = 0;
                                  effects_group.add(get_coin);
                                  game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(get_coin.scale)
                                    .to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(get_coin)
                                    .to(
                                      { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                                      600,
                                      Phaser.Easing.Linear.None,
                                      true,
                                    )
                                    .onComplete.add(function (item) {
                                      item.destroy();
                                      var_coins += 500 / 10;
                                      text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                                    });
                                },
                                this,
                              );
                            }, this);
                        }, this);
                    }, this);
                  backcard.alpha = 1;
                  Suprise_Card2.alpha = 0;
                }, this);
            }, this);
          game.add.tween(Suprise_Card2.scale).to({ x: 1.4, y: 1.4 }, 800, Phaser.Easing.Linear.None, true);
        });
        game.add.tween(Suprise_Card2.scale).to({ x: 1, y: 1 }, 800, Phaser.Easing.Linear.None, true);
        game.add
          .tween(Suprise_Card2)
          .to({ angle: 720 }, 800, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            item.inputEnabled = true;
          });
        var Suprise_Card3 = game.add.sprite(
          game.camera.width / 2 + 260,
          game.camera.height / 2 + 20,
          'game_atlas',
          'Suprise_Card.png',
        );
        Suprise_Card3.anchor.setTo(0.5);
        Suprise_Card3.scale.setTo(0);
        popup_group.add(Suprise_Card3);
        Suprise_Card3.fixedToCamera = true;
        button_animation_f(Suprise_Card3, 1);
        Suprise_Card3.events.onInputUp.add(function (item) {
          btnup(item);
          Suprise_Card1.inputEnabled = false;
          Suprise_Card2.inputEnabled = false;
          Suprise_Card3.inputEnabled = false;
          game.add.tween(text_popup_title).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add.tween(text_popup_title2).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add.tween(Suprise_Card1).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add.tween(Suprise_Card2).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
          game.add
            .tween(Suprise_Card3.cameraOffset)
            .to({ x: game.camera.width / 2, y: game.camera.height / 2 + 20 }, 800, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add.tween(shine_title).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
              game.add.tween(shine_title.scale).to({ x: 3, y: 3 }, 2000, Phaser.Easing.Linear.None, true);
              rotate_tween(shine_title);
              game.add
                .tween(Suprise_Card_white)
                .to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(Suprise_Card_white)
                    .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      game.add
                        .tween(backcard_prize.scale)
                        .to({ x: 0.7, y: 0.7 }, 100, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(backcard_prize.scale)
                            .to({ x: 0.6, y: 0.6 }, 100, Phaser.Easing.Linear.None, true);
                        }, this);
                      game.add
                        .tween(backcard_prize2.scale)
                        .to({ x: 0.9, y: 0.9 }, 100, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(backcard_prize2.scale)
                            .to({ x: 0.8, y: 0.8 }, 100, Phaser.Easing.Linear.None, true);
                        }, this);
                      game.add.tween(backcard_prize2).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(backcard_prize)
                        .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(backcard_prize.children[0])
                            .to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true, 1200)
                            .onComplete.add(function (item) {
                              game.add
                                .tween(black_sprite)
                                .to({ alpha: 0 }, 1000, Phaser.Easing.Exponential.In, true)
                                .onComplete.add(function (item) {
                                  item.destroy();
                                  popup_group.removeAll(true);
                                  popup = 0;
                                  popup_group.y -= game.camera.height;
                                });
                              game.add.tween(shine_title).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);
                              game.add.tween(backcard.scale).to({ x: 0, y: 0 }, 1000, Phaser.Easing.Linear.None, true);
                              game.add.tween(backcard).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true);
                              game.add.tween(backcard).to({ angle: 720 }, 1000, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(backcard.cameraOffset)
                                .to(
                                  { x: build_button.cameraOffset.x, y: build_button.cameraOffset.y + 30 },
                                  1000,
                                  Phaser.Easing.Linear.None,
                                  true,
                                )
                                .onComplete.add(function (item) {
                                  indicator_system(0);
                                }, this);
                              let col = 500;
                              coins += col;
                              game.setCurrentEvent();
                              window.eventTrack('coins_in', 500, {
                                user_type: bought,
                                lifetime: lifetime_day,
                                highest_lvl: all_level.lastIndexOf(3) + 2,
                                amount: 500,
                                source: 'Key mission complete',
                                package_id: 0,
                                mission_completed: missioncompleted,
                                c_event: current_event,
                              });

                              // save collected coins
                              game.setUserDataAndLog({ currencies: coins });

                              var coins_text = coins - col;
                              text_coins_panel.setText(coins_text);
                              var var_coins = 0;
                              if (sound_on == 1) {
                                play_sound('coins_add');
                              }
                              game.setCurrentEvent();
                              window.eventTrack('booster_in', 1, {
                                user_type: bought,
                                lifetime: lifetime_day,
                                highest_lvl: all_level.lastIndexOf(3) + 2,
                                amount: 1,
                                source: 'TNT',
                                item_id: 0,
                                mission_completed: missioncompleted,
                                c_event: current_event,
                              });
                              booster_tnt_col += 1;
                              game.setUserDataAndLog({
                                booster_tnt_col: booster_tnt_col,
                                backcards: JSON.stringify(backcards),
                              });
                              game.time.events.repeat(
                                100,
                                10,
                                function () {
                                  backcard_prize.alpha = 0;
                                  backcard_prize2.alpha = 0;
                                  var get_coin = game.add.sprite(
                                    backcard_prize.x + game.rnd.integerInRange(-50, 50),
                                    backcard_prize.y + game.rnd.integerInRange(-50, 50),
                                    'game_atlas',
                                    'icon_coins.png',
                                  );
                                  get_coin.anchor.setTo(0.5);
                                  get_coin.scale.setTo(0);
                                  get_coin.alpha = 0;
                                  effects_group.add(get_coin);
                                  game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(get_coin.scale)
                                    .to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(get_coin)
                                    .to(
                                      { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                                      600,
                                      Phaser.Easing.Linear.None,
                                      true,
                                    )
                                    .onComplete.add(function (item) {
                                      item.destroy();
                                      var_coins += 500 / 10;
                                      text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                                    });
                                },
                                this,
                              );
                            }, this);
                        }, this);
                    }, this);
                  backcard.alpha = 1;
                  Suprise_Card3.alpha = 0;
                }, this);
            }, this);
          game.add.tween(Suprise_Card3.scale).to({ x: 1.4, y: 1.4 }, 800, Phaser.Easing.Linear.None, true);
        });
        game.add.tween(Suprise_Card3.scale).to({ x: 1, y: 1 }, 800, Phaser.Easing.Linear.None, true);
        game.add
          .tween(Suprise_Card3)
          .to({ angle: 720 }, 800, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            item.inputEnabled = true;
          });
        for (var i = 1; i <= backcards.length; i++) {
          if (backcards[i - 1] == 0 && i > 3) {
            var sprite = 'backcard_' + i + '.png';
            backcards[i - 1] = 1;
            break;
          }
        }
        var backcard = game.add.sprite(game.camera.width / 2, game.camera.height / 2 + 20, 'game5_atlas', sprite);
        backcard.scale.setTo(1.8);
        backcard.anchor.setTo(0.5);
        backcard.alpha = 0;
        popup_group.add(backcard);
        backcard.fixedToCamera = true;
        var backcard_prize = game.add.sprite(
          game.camera.width / 2 + 80,
          game.camera.height / 2 + 170,
          'game_window_atlas',
          'Coins_Pack_2.png',
        );
        backcard_prize.scale.setTo(0.6);
        backcard_prize.anchor.setTo(0.5);
        backcard_prize.alpha = 0;
        popup_group.add(backcard_prize);
        backcard_prize.fixedToCamera = true;
        var prize_icon_text = game.add.text(0, 0, '+500', { font: '64px RussoOne', fill: '#fff', align: 'center' });
        prize_icon_text.anchor.setTo(0.5);
        backcard_prize.addChild(prize_icon_text);
        prize_icon_text.stroke = '#800200';
        prize_icon_text.strokeThickness = 8;
        var backcard_prize2 = game.add.sprite(
          game.camera.width / 2 - 80,
          game.camera.height / 2 + 170,
          'game_atlas',
          'tnt_booster.png',
        );
        backcard_prize2.scale.setTo(0.8);
        backcard_prize2.anchor.setTo(0.5);
        backcard_prize2.alpha = 0;
        popup_group.add(backcard_prize2);
        backcard_prize2.fixedToCamera = true;
        var prize2_icon_text = game.add.text(0, 0, 'x1', { font: '64px RussoOne', fill: '#fff', align: 'center' });
        prize2_icon_text.anchor.setTo(0.5);
        backcard_prize2.addChild(prize2_icon_text);
        prize2_icon_text.stroke = '#800200';
        prize2_icon_text.strokeThickness = 8;
        var Suprise_Card_white = createColorImage(
          game,
          Suprise_Card,
          game.camera.width / 2,
          game.camera.height / 2 + 20,
          '#ffffff',
        );
        Suprise_Card_white.anchor.setTo(0.5);
        Suprise_Card_white.alpha = 0;
        Suprise_Card_white.scale.setTo(1.4);
        popup_group.add(Suprise_Card_white);
        Suprise_Card_white.fixedToCamera = true;
      }
    }
    if (wheel_num < 1) {
      if (WheelDate == 0) {
        WheelDate =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        WheelDate.setHours(WheelDate.getHours() + time_wheel);
        game.setUserDataAndLog({ wheel_time: String(WheelDate) });
      }
    }
    var white_sprite = game.add.sprite(0, 0, black);
    white_sprite.alpha = 1;
    game.add
      .tween(white_sprite)
      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
      .onComplete.add(function (item) { });
    white_sprite.fixedToCamera = true;
    function homescreen_window() {
      if (shortcut == 0) {
        // FBInstant.canCreateShortcutAsync().then(function (canCreate) {
        //   if (canCreate) {
        //     FBInstant.createShortcutAsync().then(function () {
        //       shortcut = 1;
        //       game.setUserDataAndLog({ shortcut: shortcut });
        //     });
        //   }
        // });
      }
    }
    var inv_friends = 0;
    function no_ad(type, p) {
      //1 - life, 2 - coin, 3 - wheel_num
      if (popup == 0) {
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        blackf();
        var popup_back = windows_f(game.cache.getJSON('lang')['NoAD'][0][window.lang], 2);
        var ui_lives_icon_shine = game.add.sprite(0, -80, 'game_window_atlas', 'Ray_Behind_Energy.png');
        ui_lives_icon_shine.anchor.setTo(0.5);
        popup_back.addChild(ui_lives_icon_shine);
        var ui_lives_icon = game.add.sprite(0, -80, 'game_atlas', 'ad_icon.png');
        ui_lives_icon.anchor.setTo(0.5);
        ui_lives_icon.scale.setTo(2);
        popup_back.addChild(ui_lives_icon);
        var ui_lives_icon_no = game.add.sprite(0, -80, 'game_window_atlas', 'No_Sign.png');
        ui_lives_icon_no.anchor.setTo(0.5);
        popup_back.addChild(ui_lives_icon_no);
        var girl = game.add.sprite(-250, -60, 'char_atlas', 'Main_Scared.png');
        girl.anchor.setTo(0.5);
        girl.scale.setTo(1.5);
        popup_back.addChild(girl);
        var button_green = game.add.sprite(0, 270, 'game_window_atlas', 'Green_Button.png');
        button_green.anchor.setTo(0.5);
        button_animation_f(button_green, 1);
        button_green.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup != 2) {
            if (sound_on == 1) {
              play_sound('button_press');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup = 0;
                popup_group.y -= game.camera.height;
              });
          }
        }, this);
        popup_back.addChild(button_green);
        var text_button_green = game.add.text(0, 0, 'OK', {
          font: '50px RussoOne',
          fill: '#fff',
          align: 'center',
          wordWrap: true,
          wordWrapWidth: 260,
        });
        text_button_green.anchor.setTo(0.5);
        text_button_green.lineSpacing = -10;
        text_button_green.stroke = '#457310';
        text_button_green.strokeThickness = 4;
        text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
        button_green.addChild(text_button_green);
        game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
      }
    }
    var socialhub_friends_scroll_size = 0;
    var socialhub_lives_scroll_size = 0;
    function backcard_create() {
      backcard_group.mask = backcard_mask;
      missions_tab_open = 2;
      game.world.bringToTop(backcard_group);
      game.world.bringToTop(UI_top_group);
      let selected_card = 0;
      let c = backcards.length;
      backcard_group.removeAll(true); mission_group.removeAll(true);
      function __backcards(i) {
        if (backcards[i] == 0) {
          if (end_card == 0) { end_card = card_ticket; }
          var unlocked_card = game.add.sprite(0, 0, 'game_ui_atlas', 'Unlocked_Card.png');
          unlocked_card.anchor.setTo(0.5);
          card_ticket.addChild(unlocked_card);
          var unlocked_card_shine = game.add.sprite(0, 0, 'game_ui_atlas', 'Unlocked_Card_Shine.png');
          unlocked_card_shine.anchor.setTo(0.5);
          unlocked_card_shine.angle = game.rnd.integerInRange(0, 360);
          card_ticket.addChild(unlocked_card_shine);
          rotate_tween(unlocked_card_shine);
          var unlocked_card_lock = game.add.sprite(0, 0, 'game_ui_atlas', 'Lock.png');
          unlocked_card_lock.anchor.setTo(0.5);
          card_ticket.addChild(unlocked_card_lock);
        } else {
          var backcard = game.add.sprite(0, 0, 'game5_atlas', 'backcard_' + Number(i + 1) + '.png');
          backcard.anchor.setTo(0.5);
          backcard.scale.setTo(1.39);
          card_ticket.addChild(backcard);
          var selected_card_frame = game.add.sprite(0, 0, 'game_ui_atlas', 'Selected_Card_Frame.png');
          selected_card_frame.anchor.setTo(0.5);
          selected_card_frame.alpha = 0;
          card_ticket.addChild(selected_card_frame);
          if (backcards_select == 'backcard_' + Number(i + 1) + '.png') {
            selected_card_frame.alpha = 1;
            selected_card = selected_card_frame;
          }
          backcard = game.add.sprite(
            -backcard.width / 2,
            backcard.height / 2,
            'game5_atlas',
            'backcard_' + Number(i + 1) + '.png',
          );
          backcard.anchor.setTo(0, 1);
          backcard.scale.setTo(1.39);
          card_ticket.addChild(backcard);
          game.add.tween(backcard).to({ x: '-5', y: '-15' }, 200, Phaser.Easing.Linear.None, true, 350);
          game.add.tween(backcard).to({ angle: '-7' }, 200, Phaser.Easing.Linear.None, true, 350);
        }
      }

      var end_card = 0;

      for (var i = 0; i < c; i++) {
        if (i < backcards.length) {
          if (i % 2 == 0)
            var card_ticket = game.add.sprite(
              game.camera.width / 2 - 705 + (i / 2) * 235,
              game.camera.height / 2 - 162,
              'game_ui_atlas',
              'Card_Ticket.png',
            );
          else
            var card_ticket = game.add.sprite(
              game.camera.width / 2 - 705 + ((i - 1) / 2) * 235,
              game.camera.height / 2 + 162,
              'game_ui_atlas',
              'Card_Ticket.png',
            );
          card_ticket.anchor.setTo(0.5);
          card_ticket.scale.setTo(0);
          card_ticket.i = i;
          backcard_group.add(card_ticket);
          card_ticket.inputEnabled = true;
          if (backcards[i] != 0) {
            card_ticket.input.useHandCursor = true;
          }
          card_ticket.events.onInputDown.add(function (item) {
            if (backcards[item.i] != 0) {
              selected_card.alpha = 0;
              item.children[1].alpha = 1;
              selected_card = item.children[1];
              backcards_select = 'backcard_' + Number(item.i + 1) + '.png';
              game.setUserDataAndLog({ backcards_select: backcards_select });
              if (FTUE == 52) {
                FTUE_process();
              }
            }
          });
          game.add.tween(card_ticket.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true, 50);
          if (backcards[i] == 1) {
            backcards[i] = 2;
          }
          __backcards(i);
        }
      }

      if (backcards[backcards.length - 1] != 0) {
        card_ticket.x = end_card.x;
        card_ticket.y = end_card.y;
      }

      game.setUserDataAndLog({ backcards: JSON.stringify(backcards) });
      indicator_system(0);
    }
    var friends_group = game.add.group();
    friends_group.fixedToCamera = true;
    var friends_create_timer = 0;
    var FTUE_check = 0;
    function friends_create() {
      try {
        backcard_group.mask = backcard_mask2;
        missions_tab_open = 1;
        popup = 1;
        if (fbv == 1 && FTUE == 42) {
          window.eventTrack('FTUE_16_2_Friends_menu_is_opened');
        }
        if (FTUE != 42) {
          blackf();
        } else {
          FTUE_process();
        }
        game.world.bringToTop(UI_top_group);
        game.world.bringToTop(backcard_group);
        game.world.bringToTop(friends_group);
        let selected_card = 0;
        backcard_group.removeAll(true); mission_group.removeAll(true);
        friends_group.removeAll(true);

        fetchAndLogScore('default', 'completedLevels').then(function (entries) {
          if (fbv == 0) {
            var entries = [];
          }
          if (entries)
            if (typeof entries[0] !== 'undefined' || fbv == 0) {
              let mas = [];
              // if (fbv == 0) {
              //   mas = [];
              //   mas['rank'] = 0;
              //   mas['score'] = 0;
              //   mas['user'] = [];
              //   mas['user']['avatarUrl'] = '';
              //   mas['user']['handle'] = 'Carl';
              //   mas['user']['playerId'] = 0;
              //   mas['user']['isCurrentUser'] = false;
              //   entries.unshift(mas);
              //   mas = [];
              //   mas['rank'] = 0;
              //   mas['score'] = 0;
              //   mas['user'] = [];
              //   mas['user']['avatarUrl'] = '';
              //   mas['user']['handle'] = 'Carl';
              //   mas['user']['playerId'] = 1;
              //   mas['user']['isCurrentUser'] = false;
              //   entries.unshift(mas);
              //   mas = [];
              //   mas['rank'] = 0;
              //   mas['score'] = 0;
              //   mas['user'] = [];
              //   mas['user']['avatarUrl'] = '';
              //   mas['user']['handle'] = 'Carl';
              //   mas['user']['playerId'] = 2;
              //   mas['user']['isCurrentUser'] = false;
              //   entries.unshift(mas);
              //   mas = [];
              //   mas['rank'] = 0;
              //   mas['score'] = 0;
              //   mas['user'] = [];
              //   mas['user']['avatarUrl'] = '';
              //   mas['user']['handle'] = 'Carl';
              //   mas['user']['playerId'] = 3;
              //   mas['user']['isCurrentUser'] = false;
              //   entries.unshift(mas);
              //   mas = [];
              //   mas['rank'] = 0;
              //   mas['score'] = 0;
              //   mas['user'] = [];
              //   mas['user']['avatarUrl'] = '';
              //   mas['user']['handle'] = 'Carl';
              //   mas['user']['playerId'] = 4;
              //   mas['user']['isCurrentUser'] = false;
              //   entries.unshift(mas);
              // }

              mas = [];
              mas['rank'] = 0;
              mas['score'] = 0;
              mas['user'] = [];
              mas['user']['avatarUrl'] = '';
              mas['user']['handle'] = 'Carl';
              mas['user']['playerId'] = 4;
              mas['user']['isCurrentUser'] = false;
              entries.unshift(mas);
              mas = [];
              mas['rank'] = 0;
              mas['score'] = 0;
              mas['user'] = [];
              mas['user']['avatarUrl'] = '';
              mas['user']['handle'] = 'Egor';
              mas['user']['playerId'] = 5;
              mas['user']['isCurrentUser'] = false;
              entries.unshift(mas);
              mas = [];
              mas['rank'] = 0;
              mas['score'] = 0;
              mas['user'] = [];
              mas['user']['avatarUrl'] = '';
              mas['user']['handle'] = game.cache.getJSON('lang')['t344'][0][window.lang];
              mas['user']['playerId'] = 6;
              mas['user']['isCurrentUser'] = false;
              entries.unshift(mas);

              let c = fbv == 1 ? Math.round(entries.length / 10) * 10 + 10 : 10;

              currentindex = entries.findIndex(function (e) {
                return e['user']['isCurrentUser'] == true;
              });

              //  entries.splice(currentindex, 1);

              try {
                for (i = 0; i < entries.length; i++) {
                  if (entries[i]['user']['avatarUrl'] != '') {
                    game.load.crossOrigin = true;
                    if (game.cache.checkImageKey('fcreate_avatar' + i) == true) {
                      game.load.removeImage('fcreate_avatar' + i);
                    }
                    game.load.image('fcreate_avatar' + i, entries[i]['user']['avatarUrl'], 1);
                  }
                }
                game.load.start();
              } catch (err) {
                //console.log('Error detected '+err.name);
              }

              for (var i = 0; i < c; i++) {
                let name = 'New Friend';
                let star = 0;
                let sprite = 'Add_Friend.png';
                if (i < entries.length) name = entries[i]['user']['handle'];
                if (i < entries.length) star = entries[i]['score'];
                if (i < entries.length) sprite = 'Friend_Frame.png';
                if (i % 2 == 0)
                  var ticket = game.add.sprite(
                    game.camera.width / 2 - 470 + (i / 2) * 235,
                    game.camera.height / 2 - 80,
                    'game_ui_atlas',
                    sprite,
                  );
                else
                  var ticket = game.add.sprite(
                    game.camera.width / 2 - 470 + ((i - 1) / 2) * 235,
                    game.camera.height / 2 + 244,
                    'game_ui_atlas',
                    sprite,
                  );
                ticket.anchor.setTo(0.5);
                ticket.scale.setTo(0);
                if (i < entries.length) {
                  ticket.uid = entries[i]['user']['playerId'];
                }
                ticket.i = i;
                backcard_group.add(ticket);
                if (i < entries.length && entries[i]['user']['playerId'] > 10)
                  var avatar = game.add.image(0, -7, 'game_atlas', 'no_avatar.png');
                else {
                  if (i == 0) var avatar = game.add.sprite(0, -7, 'game_ui_atlas', 'main_small.png');
                  else if (i == 1) var avatar = game.add.sprite(0, -7, 'game_ui_atlas', 'evil_small.png');
                  else var avatar = game.add.sprite(0, -7, 'game_ui_atlas', 'lover_small.png');
                }
                avatar.anchor.setTo(0.5);
                avatar.i = i;
                avatar.type = 'ava';
                avatar.width = avatar.height = 200;
                ticket.addChild(avatar);
                var card_ticket = game.add.sprite(0, 0, 'game_ui_atlas', sprite);
                card_ticket.anchor.setTo(0.5);
                card_ticket.i = i;
                ticket.addChild(card_ticket);
                if (sprite == 'Add_Friend.png' && fbv == 1) card_ticket.inputEnabled = true;

                card_ticket.events.onInputUp.add(function (item) {
                  if (animation == 0 && map_move == 0 && FTUE > 45 && popup != 2) {
                    animation = 1;
                    if (FTUE == 46) {
                      FTUE_process();
                      FTUE_check = 1;
                    }
                    popup = 2;
                    let group = game.add.group();
                    group.y = -344;
                    var r_image = get_random_change([
                      'HELP_ME.jpg',
                      'ENJOY_YOUR_GARDEN.jpg',
                      'FIX_YOUR_HOUSE_AND_GARDEN.jpg',
                    ]);
                    var r_txt = get_random_change(['PlayWithMe1', 'PlayWithMe2']);
                    var message_invite = game.add.sprite(668 / 2, 344 / 2, 'message_atlas', r_image);
                    message_invite.scale.setTo(2);
                    message_invite.anchor.setTo(0.5);
                    group.add(message_invite);
                    group.inputEnabled = false;
                    group.y = 0;
                    let group2 = game.add.group();
                    group2.addChild(group);
                    var renderTexture = game.make.renderTexture(668, 344);
                    renderTexture.render(group2);
                    group2.destroy();
                    var mID =
                      ddd == 0
                        ? new Date()
                        : new Date(
                          ddd +
                          ' ' +
                          new Date().getHours() +
                          ':' +
                          new Date().getMinutes() +
                          ':' +
                          new Date().getSeconds(),
                        );
                    loading();
                    // FBInstant.context
                    //   .chooseAsync({
                    //     filters: ['NEW_PLAYERS_ONLY'],
                    //     minSize: 3,
                    //   })
                    //   .then(function () {
                    //     if (FTUE == 46) {
                    //       if (fbv == 1) {
                    //         window.eventTrack('FTUE_16_7_Context_switch');
                    //       }
                    //     }
                    //     if (loading_black_sprite != 0) {
                    //       loading_black_sprite.destroy();
                    //       loading_black_sprite = 0;
                    //     }
                    //     if (loading_text != 0 && loading_text != 1) {
                    //       loading_text.destroy();
                    //       loading_text = 0;
                    //     }
                    //     popup = 1;
                    //     animation = 0;
                    //     numFriendsInvited += 1;
                    //     game.setUserDataAndLog({ numFriendsInvited: numFriendsInvited });
                    //     updateAsync(
                    //       {
                    //         action: 'CUSTOM',
                    //         image: renderTexture.getBase64(),
                    //         text: game.cache.getJSON('lang')[r_txt][0][window.lang],
                    //         template: 'play_turn',
                    //         data: {
                    //           userId: CurrentUserId,
                    //           messageId: mID.getTime(),
                    //           data: 'SetNewFriend',
                    //           bonus: 0,
                    //         },
                    //         strategy: 'IMMEDIATE',
                    //         notification: 'NO_PUSH',
                    //       },
                    //       {
                    //         actionLevel: null,
                    //         targetUserID: null,
                    //         socialActionType: DdnaSocialActionType.InviteFriend,
                    //         socialRewardType: DdnaSocialRewardType.No,
                    //       },
                    //     );
                    //   })
                    //   .catch(function (error) {
                    //     popup = 1;
                    //     animation = 0;
                    //     if (loading_black_sprite != 0) {
                    //       loading_black_sprite.destroy();
                    //       loading_black_sprite = 0;
                    //     }
                    //     if (loading_text != 0 && loading_text != 1) {
                    //       loading_text.destroy();
                    //       loading_text = 0;
                    //     }
                    //   });
                  }
                });

                var friend_name = game.add.text(0, -120, name, {
                  font: '24px RussoOne',
                  fill: '#8B3B32',
                  align: 'center',
                });

                friend_name.anchor.setTo(0.5);
                ticket.addChild(friend_name);
                var friend_star = game.add.text(-34, 118, star, {
                  font: '18px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });

                friend_star.anchor.setTo(0.5);
                ticket.addChild(friend_star);
                var friend_timer = game.add.text(48, 118, '', {
                  font: '18px RussoOne',
                  fill: '#8B3B32',
                  align: 'center',
                });

                friend_timer.anchor.setTo(0.5);
                friend_timer.tp = 'timer';
                ticket.addChild(friend_timer);
                function get_prize(item) {
                  FTUE_process();
                  if (FriendPrizeDate == 0) {
                    friends_invite.push(item.userid);
                  }
                  gift_mas.push(item.userid);
                  var d =
                    ddd == 0
                      ? new Date()
                      : new Date(
                        ddd +
                        ' ' +
                        new Date().getHours() +
                        ':' +
                        new Date().getMinutes() +
                        ':' +
                        new Date().getSeconds(),
                      );
                  d.setHours(d.getHours() + 24);
                  helpers_id.push(item.userid);
                  helpers_time.push(d);

                  if (FTUE > 30)
                    for (var i = 0; i < missions.length; i += 4) {
                      if (missions[i] == -22) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }

                  game.setUserDataAndLog({
                    gift_mas: JSON.stringify(gift_mas),
                    helpers_id: JSON.stringify(helpers_id),
                    helpers_time: JSON.stringify(helpers_time),
                    friends_invite: JSON.stringify(friends_invite),
                    missions: JSON.stringify(missions),
                  });
                  let x1 = item.world.x;
                  let y1 = item.world.y;
                  item.destroy();
                  var col = 10;
                  coins += col;
                  game.setCurrentEvent();
                  window.eventTrack('coins_in', 10, {
                    user_type: bought,
                    lifetime: lifetime_day,
                    highest_lvl: all_level.lastIndexOf(3) + 2,
                    amount: 10,
                    source: 'Friend menu',
                    package_id: 0,
                    mission_completed: missioncompleted,
                    c_event: current_event,
                  });

                  // save collected coins
                  game.setUserDataAndLog({ currencies: coins });

                  coins_text = coins - col;
                  text_coins_panel.setText(coins_text);
                  var var_coins = 0;
                  if (sound_on == 1) {
                    play_sound('coins_add');
                  }
                  game.time.events.repeat(
                    100,
                    10,
                    function () {
                      var get_coin = game.add.sprite(
                        x1 + game.rnd.integerInRange(-10, 10),
                        y1 + game.rnd.integerInRange(-10, 10),
                        'game_atlas',
                        'icon_coins.png',
                      );
                      get_coin.anchor.setTo(0.5);
                      get_coin.scale.setTo(0);
                      get_coin.alpha = 0;
                      effects_group.add(get_coin);
                      game.world.bringToTop(effects_group);
                      game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                      game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(get_coin)
                        .to(
                          { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                          600,
                          Phaser.Easing.Linear.None,
                          true,
                        )
                        .onComplete.add(function (item2) {
                          item2.destroy();
                          var_coins += col / 10;
                          text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                        });
                    },
                    this,
                  );
                  if (fbv == 1) {
                    console.log("%cThis should not happen!", "color:orange");
                    // let group = game.add.group();
                    // group.y = -344;
                    // var user_avatar = game.add.image(668 / 2 - 8, 344 / 2 + 20, 'game_atlas', 'no_avatar.png');
                    // user_avatar.anchor.setTo(0.5);
                    // user_avatar.width = user_avatar.height = 190;
                    // group.add(user_avatar);
                    // if (game.cache.checkImageKey('c_user_avatar') == true) {
                    //   user_avatar.loadTexture('c_user_avatar');
                    //   user_avatar.width = user_avatar.height = 190;
                    // }
                    // var message_invite = game.add.sprite(668 / 2, 344 / 2, 'message_atlas', 'Friend_Coins.png');
                    // message_invite.scale.setTo(2);
                    // message_invite.anchor.setTo(0.5);
                    // group.add(message_invite);
                    // group.inputEnabled = false;
                    // group.y = 0;
                    // let group2 = game.add.group();
                    // group2.addChild(group);
                    // var renderTexture = game.make.renderTexture(668, 344);
                    // renderTexture.render(group2);
                    // group2.destroy();
                    // updateAsync(
                    //   {
                    //     action: 'CUSTOM',
                    //     image: renderTexture.getBase64(),
                    //     text: 'Thank you for the free Solitaire Garden coins!',
                    //     template: 'play_turn',
                    //     data: {},
                    //     strategy: 'IMMEDIATE',
                    //     notification: 'NO_PUSH',
                    //   },
                    //   {
                    //     actionLevel: null,
                    //     targetUserID: CurrentContext,
                    //     socialActionType: DdnaSocialActionType.CoinRequest,
                    //     socialRewardType: DdnaSocialRewardType.Coins,
                    //   },
                    // );
                  }

                  if (FriendPrizeDate == 0) {
                    let cropRect = new Phaser.Rectangle(
                      0,
                      0,
                      (friends_invite.length - 1) * (gift_bar_level.w / 12),
                      gift_bar_level.height,
                    );
                    var tween = game.add
                      .tween(cropRect)
                      .to(
                        { width: friends_invite.length * (gift_bar_level.w / 12) },
                        900,
                        Phaser.Easing.Linear.None,
                        true,
                      );
                    tween.onUpdateCallback(function () {
                      try {
                        gift_bar_level.crop(cropRect);
                      } catch (err) { }
                    }, this);
                    friends_create_timer.setText(friends_invite.length + '/12');
                    friends_invite_complite();
                  }
                }
                function check_result(item) {
                  // FBInstant.context
                  //   .createAsync(item.userid)
                  //   .then(function () {
                  //     CurrentContext = item.userid;
                  //     get_prize(item);
                  //   })
                  //   .catch(function (e) {});
                }
                if (i < entries.length) {
                  if (shop == 0 || i == 0 || i == 1 || fbv == 0) {
                    if (gift_mas.indexOf(entries[i]['user']['playerId']) == -1) {
                      var offer_gift_button = game.add.sprite(47, 54, 'game_ui_atlas', 'Offer_Gift_Button.png');
                      offer_gift_button.anchor.setTo(0.5);
                      offer_gift_button.userid = entries[i]['user']['playerId'];
                      offer_gift_button.scl = 1;
                      offer_gift_button.iii = i;
                      offer_gift_button.inputEnabled = true;
                      offer_gift_button.events.onInputUp.add(function (item) {
                        if (item.iii != 0 && item.iii != 1 && FTUE > 45 && map_move == 0) {
                          if (animation == 0) {
                            get_prize(item);
                          }
                        } else {
                          if ((item.iii == 0 && FTUE == 44) || (item.iii == 1 && FTUE == 45) || FTUE > 150) {
                            if (fbv == 1 && FTUE == 44) {
                              window.eventTrack('FTUE_16_4_User_clicked_on_first_NPC');
                            }
                            if (fbv == 1 && FTUE == 45) {
                              window.eventTrack('FTUE_16_5_User_clicked_on_second_NPC');
                            }
                            get_prize(item);
                          }
                        }
                      });
                      ticket.addChild(offer_gift_button);
                      offer_gift_button.input.useHandCursor = true;
                      scale_tween(offer_gift_button, 600, 0.1, 0.1);
                    }
                  } else if (gift_mas.indexOf(entries[i]['user']['playerId']) == -1) {
                    var offer_gift_button = game.add.sprite(47, 54, 'game_ui_atlas', 'Offer_Gift_Button.png');
                    offer_gift_button.anchor.setTo(0.5);
                    offer_gift_button.userid = entries[i]['user']['playerId'];
                    offer_gift_button.scl = 1;
                    offer_gift_button.iii = i;
                    offer_gift_button.inputEnabled = true;
                    offer_gift_button.events.onInputUp.add(function (item) {
                      if (item.iii != 0 && item.iii != 1 && FTUE > 45) {
                        if (map_move == 0) {
                          if (animation == 0) {
                            if (CurrentContext != item.userid) check_result(item);
                            else get_prize(item);
                          }
                        }
                      } else {
                        if ((item.iii == 0 && FTUE == 44) || (item.iii == 1 && FTUE == 45) || FTUE > 150) {
                          if (fbv == 1 && FTUE == 44) {
                            window.eventTrack('FTUE_16_4_User_clicked_on_first_NPC');
                          }
                          if (fbv == 1 && FTUE == 45) {
                            window.eventTrack('FTUE_16_5_User_clicked_on_second_NPC');
                          }
                          get_prize(item);
                        }
                      }
                    });
                    ticket.addChild(offer_gift_button);
                    offer_gift_button.input.useHandCursor = true;
                    scale_tween(offer_gift_button, 600, 0.1, 0.1);
                  }
                } else {
                  if (fbv == 1) {
                    var offer_gift_button = game.add.sprite(47, 54, 'game_ui_atlas', 'Offer_Gift_Button.png');
                    offer_gift_button.anchor.setTo(0.5);
                    ticket.addChild(offer_gift_button);
                    scale_tween(offer_gift_button, 600, 0.1, 0.1);
                  }
                }
                game.add.tween(ticket.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true, 50 * i);
              }

              var an = 0;
              setTimeout(function () {
                try {
                  if (missions_tab_open == 1) {
                    for (var i = 0; i < entries.length; i++) {
                      if (game.cache.checkImageKey('fcreate_avatar' + i) == true) {
                        an += 1;
                        try {
                          backcard_group.children.forEach(function (item) {
                            item.children.forEach(function (item) {
                              if (item.i == i && item.type == 'ava') {
                                item.loadTexture('fcreate_avatar' + i);
                                item.width = item.height = 200;
                              }
                            });
                          });
                        } catch (err) {
                          //console.log('Error detected '+err.name);
                        }
                      }
                    }
                  }
                } catch (err) {
                  //console.log('Error detected '+err.name);
                }
              }, 1000);
            }
          let gift_bar = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 - 320,
            'game_ui_atlas',
            'Gift_Bar.png',
          );
          gift_bar.anchor.setTo(0.5);
          gift_bar.alpha = 0;
          friends_group.add(gift_bar);
          game.add.tween(gift_bar).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 200);
          let gift_bar_level = game.add.sprite(-377, -7, 'game_ui_atlas', 'Gift_Bar_Level.png');
          gift_bar_level.anchor.setTo(0, 0.5);
          gift_bar_level.w = gift_bar_level.width;
          gift_bar.addChild(gift_bar_level);
          if (FriendPrizeDate == 0) {
            let cropRect = new Phaser.Rectangle(
              0,
              0,
              friends_invite.length * (gift_bar_level.w / 12),
              gift_bar_level.height,
            );
            gift_bar_level.crop(cropRect);
          } else {
            let cropRect = new Phaser.Rectangle(0, 0, 0, gift_bar_level.height);
            gift_bar_level.crop(cropRect);
          }
          var gift_shine = game.add.sprite(400, 0, 'game_ui_atlas', '2Gift_Shine.png');
          gift_shine.anchor.setTo(0.5);
          gift_bar.addChild(gift_shine);
          rotate_tween(gift_shine);
          var black_sprite_build = game.add.sprite(0, 0, 'message_invite_mask');
          black_sprite_build.alpha = 0;
          black_sprite_build.width = game.camera.width;
          black_sprite_build.height = game.camera.height;
          friends_group.add(black_sprite_build);
          var gift = game.add.sprite(gift_bar.x + 400, gift_bar.y, 'game_ui_atlas', 'Gift_Bottom_Part.png');
          gift.anchor.setTo(0.5);
          gift.alpha = 0;
          friends_group.add(gift);
          game.add.tween(gift).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 50);
          var gift_lid = game.add.sprite(0, -20, 'game_ui_atlas', 'Gift_Lid.png');
          gift_lid.anchor.setTo(0.5);
          gift.addChild(gift_lid);
          var gift_shadow = game.add.sprite(0, -14, 'game_ui_atlas', 'Gift_Ribbon_Shadow.png');
          gift_shadow.anchor.setTo(0.5);
          gift_lid.addChild(gift_shadow);
          var gift_ribbon = game.add.sprite(0, -20, 'game_ui_atlas', 'Gift_Ribbon.png');
          gift_ribbon.anchor.setTo(0.5);
          gift_lid.addChild(gift_ribbon);
          if (FriendPrizeDate == 0)
            friends_create_timer = game.add.text(0, -4, friends_invite.length + '/12', {
              font: '30px RussoOne',
              fill: '#fff',
              align: 'center',
            });
          else
            friends_create_timer = game.add.text(0, -4, '', { font: '30px RussoOne', fill: '#fff', align: 'center' });
          friends_create_timer.anchor.setTo(0.5);
          friends_create_timer.stroke = '#8C3C33';
          friends_create_timer.strokeThickness = 4;
          gift_bar.addChild(friends_create_timer);
          friends_invite_complite();
          function friends_invite_complite() {
            if (friends_invite.length >= 12 && FriendPrizeDate == 0) {
              friends_invite = [];
              game.setUserDataAndLog({ friends_invite: JSON.stringify(friends_invite) });
              animation = 1;
              game.add
                .tween(gift)
                .to({ angle: '+6' }, 50, Phaser.Easing.Linear.None, true, 1000)
                .onComplete.add(function () {
                  game.add
                    .tween(gift)
                    .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      game.add
                        .tween(gift)
                        .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          game.add
                            .tween(gift)
                            .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function () {
                              game.add
                                .tween(gift)
                                .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function () {
                                  game.add
                                    .tween(gift)
                                    .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                    .onComplete.add(function () {
                                      game.add
                                        .tween(gift)
                                        .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                        .onComplete.add(function () {
                                          game.add
                                            .tween(gift)
                                            .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                            .onComplete.add(function () {
                                              game.add
                                                .tween(gift)
                                                .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                                .onComplete.add(function () {
                                                  game.add
                                                    .tween(gift)
                                                    .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                                    .onComplete.add(function () {
                                                      game.add
                                                        .tween(gift)
                                                        .to({ angle: '+12' }, 100, Phaser.Easing.Linear.None, true)
                                                        .onComplete.add(function () {
                                                          game.add
                                                            .tween(gift)
                                                            .to({ angle: '-12' }, 100, Phaser.Easing.Linear.None, true)
                                                            .onComplete.add(function () {
                                                              game.add
                                                                .tween(gift)
                                                                .to(
                                                                  { angle: '+12' },
                                                                  100,
                                                                  Phaser.Easing.Linear.None,
                                                                  true,
                                                                )
                                                                .onComplete.add(function () {
                                                                  game.add
                                                                    .tween(gift)
                                                                    .to(
                                                                      { angle: '-12' },
                                                                      100,
                                                                      Phaser.Easing.Linear.None,
                                                                      true,
                                                                    )
                                                                    .onComplete.add(function () {
                                                                      game.add
                                                                        .tween(gift)
                                                                        .to(
                                                                          { angle: '+12' },
                                                                          100,
                                                                          Phaser.Easing.Linear.None,
                                                                          true,
                                                                        )
                                                                        .onComplete.add(function () {
                                                                          game.add
                                                                            .tween(gift)
                                                                            .to(
                                                                              { angle: '-6' },
                                                                              100,
                                                                              Phaser.Easing.Linear.None,
                                                                              true,
                                                                            );
                                                                        });
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
              game.add
                .tween(gift.scale)
                .to({ x: 1.2, y: 1.2 }, 400, Phaser.Easing.Linear.None, true, 1000)
                .onComplete.add(function () {
                  game.add
                    .tween(gift.scale)
                    .to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      game.add
                        .tween(gift.scale)
                        .to({ x: 1.2, y: 1.2 }, 400, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          game.add
                            .tween(gift.scale)
                            .to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function () {
                              game.add.tween(gift.scale).to({ x: 2.5, y: 2.5 }, 1000, Phaser.Easing.Cubic.In, true);
                              game.add.tween(black_sprite).to({ alpha: 0 }, 700, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(black_sprite_build)
                                .to({ alpha: 0.8 }, 500, Phaser.Easing.Linear.None, true);
                              game.world.bringToTop(UI_top_group);
                              game.add.tween(gift_shine.scale).to({ x: 0, y: 0 }, 800, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(gift)
                                .to({ alpha: 1 }, 1200, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function (item) {
                                  let xxx = item.x;
                                  let yyy = item.y;
                                  item.destroy();
                                  gift = game.add.sprite(xxx, yyy + 92, 'game_ui_atlas', 'Gift_Bottom_Part.png');
                                  gift.anchor.setTo(0.5, 1);
                                  gift.scale.setTo(2.5);
                                  friends_group.add(gift);
                                  var gift_lid = game.add.sprite(0, -63, 'game_ui_atlas', 'Gift_Lid.png');
                                  gift_lid.anchor.setTo(0.5);
                                  gift.addChild(gift_lid);
                                  var gift_shadow = game.add.sprite(0, -14, 'game_ui_atlas', 'Gift_Ribbon_Shadow.png');
                                  gift_shadow.anchor.setTo(0.5);
                                  gift_lid.addChild(gift_shadow);
                                  var gift_ribbon = game.add.sprite(0, -20, 'game_ui_atlas', 'Gift_Ribbon.png');
                                  gift_ribbon.anchor.setTo(0.5);
                                  gift_lid.addChild(gift_ribbon);
                                  game.add
                                    .tween(gift.scale)
                                    .to({ y: 2.1 }, 200, Phaser.Easing.Cubic.Out, true)
                                    .onComplete.add(function () {
                                      game.add.tween(gift).to({ y: '-50' }, 200, Phaser.Easing.Cubic.In, true);
                                      game.add
                                        .tween(gift.scale)
                                        .to({ y: 2.5 }, 200, Phaser.Easing.Cubic.In, true)
                                        .onComplete.add(function () {
                                          var x1 = gift.world.x;
                                          var y1 = gift.world.y - 80;
                                          var col = 100;
                                          coins += col;
                                          game.setCurrentEvent();
                                          window.eventTrack('coins_in', 100, {
                                            user_type: bought,
                                            lifetime: lifetime_day,
                                            highest_lvl: all_level.lastIndexOf(3) + 2,
                                            amount: 100,
                                            source: 'Friends invite complite',
                                            package_id: 0,
                                            mission_completed: missioncompleted,
                                            c_event: current_event,
                                          });

                                          // save collected coins
                                          game.setUserDataAndLog({ currencies: coins });

                                          var coins_text = coins - col;
                                          text_coins_panel.setText(coins_text);
                                          var var_coins = 0;
                                          if (sound_on == 1) {
                                            play_sound('coins_add');
                                          }
                                          game.time.events.repeat(
                                            100,
                                            10,
                                            function () {
                                              var get_coin = game.add.sprite(
                                                x1 + game.rnd.integerInRange(-20, 20),
                                                y1 + game.rnd.integerInRange(-10, 10),
                                                'game_atlas',
                                                'icon_coins.png',
                                              );
                                              get_coin.anchor.setTo(0.5);
                                              get_coin.scale.setTo(0);
                                              get_coin.alpha = 0;
                                              effects_group.add(get_coin);
                                              game.world.bringToTop(effects_group);
                                              game.add
                                                .tween(get_coin)
                                                .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                              game.add
                                                .tween(get_coin.scale)
                                                .to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                                              game.add
                                                .tween(get_coin)
                                                .to(
                                                  { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                                                  600,
                                                  Phaser.Easing.Linear.None,
                                                  true,
                                                )
                                                .onComplete.add(function (item) {
                                                  item.destroy();
                                                  var_coins += col / 10;
                                                  text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                                                });
                                            },
                                            this,
                                          );
                                          game.add
                                            .tween(gift_lid)
                                            .to(
                                              {
                                                x: [gift_lid.x, gift_lid.x + 30, gift_lid.x + 100, gift_lid.x + 100],
                                                y: [gift_lid.y, gift_lid.y - 150, gift_lid.y - 100, gift_lid.y + 50],
                                              },
                                              600,
                                              Phaser.Easing.Cubic.Out,
                                              true,
                                            )
                                            .interpolation(function (v, k) {
                                              return Phaser.Math.bezierInterpolation(v, k);
                                            });
                                          game.add
                                            .tween(gift_lid)
                                            .to({ angle: '+360' }, 500, Phaser.Easing.Cubic.Out, true)
                                            .onComplete.add(function () { });
                                          game.add
                                            .tween(gift)
                                            .to({ y: '+50' }, 400, Phaser.Easing.Bounce.Out, true)
                                            .onComplete.add(function () {
                                              game.add
                                                .tween(gift)
                                                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                                .onComplete.add(function () {
                                                  item.destroy();
                                                  game.add
                                                    .tween(black_sprite)
                                                    .to({ alpha: 0.8 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(black_sprite_build)
                                                    .to({ alpha: 0 }, 700, Phaser.Easing.Linear.None, true)
                                                    .onComplete.add(function () {
                                                      animation = 0;
                                                      gift = game.add.sprite(
                                                        gift_bar.x + 400,
                                                        gift_bar.y,
                                                        'game_ui_atlas',
                                                        'Gift_Bottom_Part.png',
                                                      );
                                                      gift.anchor.setTo(0.5);
                                                      gift.alpha = 0;
                                                      friends_group.add(gift);
                                                      game.add
                                                        .tween(gift)
                                                        .to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 50);
                                                      gift_lid = game.add.sprite(
                                                        0,
                                                        -20,
                                                        'game_ui_atlas',
                                                        'Gift_Lid.png',
                                                      );
                                                      gift_lid.anchor.setTo(0.5);
                                                      gift.addChild(gift_lid);
                                                      gift_shadow = game.add.sprite(
                                                        0,
                                                        -14,
                                                        'game_ui_atlas',
                                                        'Gift_Ribbon_Shadow.png',
                                                      );
                                                      gift_shadow.anchor.setTo(0.5);
                                                      gift_lid.addChild(gift_shadow);
                                                      gift_ribbon = game.add.sprite(
                                                        0,
                                                        -20,
                                                        'game_ui_atlas',
                                                        'Gift_Ribbon.png',
                                                      );
                                                      gift_ribbon.anchor.setTo(0.5);
                                                      gift_lid.addChild(gift_ribbon);
                                                      let cropRect = new Phaser.Rectangle(
                                                        0,
                                                        0,
                                                        (friends_invite.length - 1) * (gift_bar_level.w / 12),
                                                        gift_bar_level.height,
                                                      );
                                                      gift_bar_level.crop(cropRect);
                                                      friends_create_timer.setText(friends_invite.length + '/12');
                                                      FriendPrizeDate =
                                                        ddd == 0
                                                          ? new Date()
                                                          : new Date(
                                                            ddd +
                                                            ' ' +
                                                            new Date().getHours() +
                                                            ':' +
                                                            new Date().getMinutes() +
                                                            ':' +
                                                            new Date().getSeconds(),
                                                          );
                                                      FriendPrizeDate.setHours(FriendPrizeDate.getHours() + 48);
                                                      game.setUserDataAndLog({
                                                        FriendPrizeDate: String(FriendPrizeDate),
                                                      });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                              game.add
                                .tween(gift)
                                .to(
                                  {
                                    x: [gift.x, gift.x - 100, gift.x - 200, gift.x - 400],
                                    y: [gift.y, gift.y - 100, gift.y - 50, gift.y + 500],
                                  },
                                  1200,
                                  Phaser.Easing.Quadratic.In,
                                  true,
                                )
                                .interpolation(function (v, k) {
                                  return Phaser.Math.bezierInterpolation(v, k);
                                });
                            });
                        });
                    });
                });
            }
          }
        });
        bottom_button(0, 0, 0, UI_bottom_group, backcard_group);
        FTUE_process();
      } catch (err) {
        //console.log('Error detected '+err.name);
      }
    }
    function bottom_button(type1, type2, type3, group, close_group, t) {
      var pause = 200;
      if (t) {
        pause = 1;
      }
      game.add
        .tween(group)
        .to({ y: '+400' }, pause, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          if (!t) {
            animation = 1;
          }
          group.removeAll(true);
          mission_group.removeAll(true);
          var return_button = game.add.sprite(
            game.camera.width / 2 - 745,
            game.camera.height - 120,
            'game_ui_atlas',
            'Return_Button.png',
          );
          return_button.anchor.setTo(0.5);
          button_animation_f(return_button, 1);
          return_button.input.priorityID = 1000;
          return_button.events.onInputUp.add(function (item) {
            if (fbv == 1 && FTUE_check == 1) {
              window.eventTrack('FTUE_16_8_Friend_menu_closed');
            }
            if (fbv == 1 && FTUE_check == 2) {
              window.eventTrack('FTUE_14_6_back_Button');
            }
            btnup(item);
            if (sound_on == 1) {
              play_sound('button_X');
            }
            update_controll = 1;
            if (close_group != -1) {
              if (
                animation == 0 &&
                FTUE != 30 &&
                FTUE != 31 &&
                FTUE != 32 &&
                FTUE != 33 &&
                (FTUE < 42 || FTUE > 46) &&
                FTUE != 51 &&
                FTUE != 50 &&
                FTUE != 52
              ) {

                if (offer_icon != 0) {
                  offer_icon.destroy();
                  offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
                }
                UI_right_controll = 0;
                animation = 1;
                if (FTUE == 34) {
                  if (fbv == 1) {
                    window.eventTrack('FTUE_11_10_BackButtonClicked');
                  }
                }
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 200, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add.tween(close_group).to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(group)
                  .to({ y: '+400' }, 200, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    backcard_group.cameraOffset.x = 0;
                    friends_group.removeAll(true);
                    close_group.removeAll(true);
                    close_group.alpha = 1;
                    item.removeAll(true);
                    UI_bottom_group_create(1, 1, 1, 1, 0);
                    if (offer_icon != 0) {
                      offer_icon.destroy();
                      offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
                    }
                    item.y = 400;
                    game.add
                      .tween(item)
                      .to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        animation = 0;
                      });
                    popup = 0;
                    missions_tab_open = 0;
                    mission_group.removeAll(true);
                    complete_task_i = -1;
                    indicator_system(0);
                    FTUE_process();
                  });
              }
            } else {
              if (
                (animation == 0 && FTUE != 30 && FTUE != 31 && FTUE != 32 && FTUE != 33 && FTUE != 41.1) ||
                (FTUE == 41.1 && fff == 2 && FTUE != 51 && FTUE != 50 && FTUE != 52)
              ) {
                if (offer_icon != 0) {
                  offer_icon.destroy();
                  offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
                }
                UI_right_controll = 0;
                animation = 1;
                if (FTUE == 34) {
                  if (fbv == 1) {
                    window.eventTrack('FTUE_11_10_BackButtonClicked');
                  }
                }
                objects_group.children.forEach(function (child_item) {
                  if (child_item.inputEnabled == true && child_item.special) {
                    child_item.special.destroy(true);
                    child_item.special = 0;
                  }
                });
                game.add
                  .tween(group)
                  .to({ y: '+400' }, 200, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    backcard_group.cameraOffset.x = 0;
                    friends_group.removeAll(true);
                    item.removeAll(true);
                    UI_bottom_group_create(1, 1, 1, 1, 0);
                    if (offer_icon != 0) {
                      offer_icon.destroy();
                      offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
                    }
                    item.y = 400;
                    game.add
                      .tween(item)
                      .to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        animation = 0;
                      });
                    popup = 0;
                    missions_tab_open = 0;
                    mission_group.removeAll(true);
                    indicator_system(0);
                    FTUE_process();
                  });
              }
              if (FTUE == 41.1 && fff == 2) {
                if (w != 0) {
                  f_w_a();
                }
              }
            }
          });
          return_button.fixedToCamera = true;
          group.add(return_button);
          if (type1 != 0) {
            var tasks_menu_button = game.add.sprite(
              game.camera.width / 2 - 200,
              game.camera.height - 120,
              'game_ui_atlas',
              'Tasks_Menu_Button_' + type1 + '.png',
            );
            tasks_menu_button.anchor.setTo(0.5);
            tasks_menu_button.fixedToCamera = true;
            group.add(tasks_menu_button);
            button_animation_f(tasks_menu_button, 1);
            tasks_menu_button.events.onInputUp.add(function (item) {
              btnup(item);
              if (sound_on == 1) {
                play_sound('button_press');
              }
              if (missions_tab_open != 3)
                if (tasks_menu_button.frameName != 'Tasks_Menu_Button_Activ.png')
                  if (
                    animation == 0 &&
                    FTUE != 30 &&
                    FTUE != 31 &&
                    FTUE != 32 &&
                    FTUE != 33 &&
                    FTUE != 34 &&
                    FTUE != 51 &&
                    FTUE != 50 &&
                    FTUE != 52
                  ) {
                    animation = 1;
                    tasks_menu_button.loadTexture('game_ui_atlas', 'Tasks_Menu_Button_Activ.png');
                    events_menu_button.loadTexture('game_ui_atlas', 'Events_Menu_Button_Inactiv.png');
                    cards_menu_button.loadTexture('game_ui_atlas', 'Cards_Menu_Button_Inactiv.png');
                    game.add
                      .tween(close_group)
                      .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        animation = 0;
                        friends_group.removeAll(true);
                        close_group.removeAll(true);
                        close_group.alpha = 1;
                        missions_tab_open = 0;
                        backcard_group.cameraOffset.x = 0;
                        build_window();
                        complete_task_i = -1;
                      });
                  }
            });
            var events_menu_button = game.add.sprite(
              game.camera.width / 2,
              game.camera.height - 120,
              'game_ui_atlas',
              'Events_Menu_Button_' + type2 + '.png',
            );
            events_menu_button.anchor.setTo(0.5);
            events_menu_button.fixedToCamera = true;
            group.add(events_menu_button);
            button_animation_f(events_menu_button, 1);
            events_menu_button.events.onInputUp.add(function (item) {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              btnup(item);
              if (events_menu_button.frameName != 'Events_Menu_Button_Activ.png')
                if (
                  animation == 0 &&
                  FTUE != 31 &&
                  FTUE != 32 &&
                  FTUE != 33 &&
                  FTUE != 34 &&
                  FTUE != 51 &&
                  FTUE != 50 &&
                  FTUE != 52
                ) {
                  animation = 1;
                  tasks_menu_button.loadTexture('game_ui_atlas', 'Tasks_Menu_Button_Inactiv.png');
                  events_menu_button.loadTexture('game_ui_atlas', 'Events_Menu_Button_Activ.png');
                  cards_menu_button.loadTexture('game_ui_atlas', 'Cards_Menu_Button_Inactiv.png');
                  game.add
                    .tween(close_group)
                    .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      animation = 0;
                      FTUE_process();
                      missions_tab_open = 0;
                      friends_group.removeAll(true);
                      close_group.removeAll(true);
                      close_group.alpha = 1;
                      backcard_group.cameraOffset.x = 0;
                      key_mission_create(0);
                      complete_task_i = -1;
                      mission_create(0);
                      for (i = 0; i < 6; i++) {
                        mission_element_create(i);
                      }
                    });
                }
            });
            var cards_menu_button = game.add.sprite(
              game.camera.width / 2 + 200,
              game.camera.height - 120,
              'game_ui_atlas',
              'Cards_Menu_Button_' + type3 + '.png',
            );
            cards_menu_button.anchor.setTo(0.5);
            cards_menu_button.fixedToCamera = true;
            group.add(cards_menu_button);
            button_animation_f(cards_menu_button, 1);
            cards_menu_button.events.onInputUp.add(function (item) {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              btnup(item);
              if (cards_menu_button.frameName != 'Cards_Menu_Button_Activ.png')
                if (
                  animation == 0 &&
                  FTUE != 31 &&
                  FTUE != 32 &&
                  FTUE != 33 &&
                  FTUE != 34 &&
                  FTUE != 50 &&
                  FTUE != 52
                ) {
                  animation = 1;
                  tasks_menu_button.loadTexture('game_ui_atlas', 'Tasks_Menu_Button_Inactiv.png');
                  events_menu_button.loadTexture('game_ui_atlas', 'Events_Menu_Button_Inactiv.png');
                  cards_menu_button.loadTexture('game_ui_atlas', 'Cards_Menu_Button_Activ.png');
                  game.add
                    .tween(close_group)
                    .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      animation = 0;
                      friends_group.removeAll(true);
                      close_group.removeAll(true);
                      close_group.alpha = 1;
                      missions_tab_open = 0;
                      backcard_group.cameraOffset.x = 0;
                      backcard_create();
                      complete_task_i = -1;
                      if (FTUE == 51) {
                        FTUE_process();
                      }
                    });
                }
            });
          }
          if (!t) {
            game.world.bringToTop(group);
            game.add
              .tween(group)
              .to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                animation = 0;
              });
            indicator_system(0, tasks_menu_button, events_menu_button, cards_menu_button);
          }
        });
    }
    var socialhub_open_controll = 0;
    function socialhub_tab_open(type) { }
    function btnover(item) {
      if (item.scl > 0) {
        game.add.tween(item.scale).to({ x: item.scl + 0.05, y: item.scl + 0.05 }, 100, Phaser.Easing.Linear.None, true);
      } else {
        game.add
          .tween(item.scale)
          .to({ x: item.scl - 0.05, y: -item.scl + 0.05 }, 100, Phaser.Easing.Linear.None, true);
      }
    }
    function btnout(item) {
      if (item.scl > 0) {
        game.add.tween(item.scale).to({ x: item.scl, y: item.scl }, 100, Phaser.Easing.Linear.None, true);
      } else {
        game.add.tween(item.scale).to({ x: item.scl, y: -item.scl }, 100, Phaser.Easing.Linear.None, true);
      }
    }
    function btnclick(item) {
      map_stop = 1;
      button_click = 1;
      if (item.scl > 0) {
        game.add.tween(item.scale).to({ x: item.scl - 0.05, y: item.scl - 0.05 }, 100, Phaser.Easing.Linear.None, true);
      } else {
        game.add
          .tween(item.scale)
          .to({ x: item.scl + 0.05, y: -item.scl - 0.05 }, 100, Phaser.Easing.Linear.None, true);
      }
    }
    function btnup(item) {
      map_stop = 0;
      button_click = 0;
      if (item.scl > 0) {
        game.add.tween(item.scale).to({ x: item.scl, y: item.scl }, 100, Phaser.Easing.Linear.None, true);
      } else {
        game.add.tween(item.scale).to({ x: item.scl, y: -item.scl }, 100, Phaser.Easing.Linear.None, true);
      }
    }
    game.input.onUp.add(MapStop, this);
    game.input.addMoveCallback(tap_move, this);

    function message(text, x, y) {
      message_text = game.add.text(x, y, text, { font: '40px RussoOne', fill: '#fff', align: 'center' });
      message_text.stroke = '#000';
      message_text.strokeThickness = 4;
      message_text.anchor.setTo(0.5, 0.5);
      game.add.tween(message_text).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 200);
      game.add
        .tween(message_text)
        .to({ y: '-150' }, 1200, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          item.destroy();
        });
    }

    function rotate_tween(item) {
      game.add
        .tween(item)
        .to({ angle: 360 }, 5000, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (itm) {
          rotate_tween(itm);
        });
    }
    function get_random_change(mass) {
      var array = mass;
      var len_arr = array.length;
      var rand_num = [Math.floor(Math.random() * len_arr)];
      var rand_el = array[rand_num];
      return rand_el;
    }
    dialog_check = 0;
    var dialog_type = 0;
    var text_n = 1;
    var dialog_finish = -1;
    var dialog_time = 0;
    var text_color = '';
    var graphics_task = 0;
    var man1 = 0;
    var man2 = 0;
    var dialog_text = 0;
    var scrn = 0;
    var Empty_Picture = 0;
    var Hand_Picture = 0;
    var picture_medal = 0;
    var n_iii = 0;
    game.input.onUp.add(function () {
      if (FTUE == 41.5) {
        FTUE_process();
      }
      if (dialog_check != 0 && dialog_finish != -1 && animation == 0) {
        if (dialog_finish == 1) {
          if (typeof game.cache.getJSON('dialog')['dialog' + dialog_check][0]['message' + text_n] !== 'undefined') {
            if (game.cache.getJSON('dialog')['dialog' + dialog_check][0]['message' + text_n][0]['fade'] == 1) {
              if (game.cache.getJSON('dialog')['dialog' + dialog_check][0]['message' + text_n][0]['type'] == 2) {
                game.add.tween(man2).to({ alpha: 0 }, 500, Phaser.Easing.Exponential.Out, true);
              }
            }
          }
          if (
            typeof game.cache.getJSON('dialog')['dialog' + dialog_check][0]['message' + text_n][0]['screen'] ==
            'undefined'
          ) {
            text_n++;
            dialog_text.destroy();
            if (typeof game.cache.getJSON('dialog')['dialog' + dialog_check][0]['message' + text_n] !== 'undefined') {
              popup = 1;
              dialog_process(dialog_type, dialog_check, 400);
              if (fbv == 1 && dialog_check == 10) {
                window.eventTrack('FTUE_9_4_1_firstDialog_played');
              }
            } else {
              if (scrn == 0) {
                if (dialog_check != 4)
                  game.add.tween(UI_top_group).to({ y: '+400' }, 500, Phaser.Easing.Exponential.Out, true);
                else {
                  FTUE_Arrow.destroy();
                  FTUE_Arrow = 0;
                }
                animation = 1;
                game.add.tween(UI_bottom_group).to({ y: '-400' }, 500, Phaser.Easing.Exponential.Out, true);
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                    animation = 0;
                  });
                var isDialog = end_dialog2(dialog_check);
                var dc = dialog_check;
                dialog_check = 0;
                if (object_outline1 != 0) { object_outline1.destroy(); object_outline2.destroy(); object_outline1 = 0; object_outline2 = 0; }
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup_group.y -= game.camera.height;
                    if (dc != 0 && !isDialog) {
                      if (dc == 1) {
                        if (fbv == 1) {
                          window.eventTrack('FTUE_7_4_LongDialogueCompleted');
                        }
                      } else if (dc == 28) {
                        if (fbv == 1) {
                          window.eventTrack('FTUE_9_6_ThirdDialogueCompleted');
                        }
                      }
                      popup = 0;
                      animation = 0;
                      if (dc != 12 && dc != 76 && !n_iii) taks_indicator(1);
                      end_dialog(dc);
                      dc = 0;
                      if (n_iii) {
                        animation = -1;
                        build_action(n_iii, 500);
                        n_iii = 0;
                      }
                    }
                  });
              } else if (animation == 0) {
                if (popup_group.aaa != 2) {
                  text_n--;
                  animation = 1;
                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.aaa = 2;
                      popup_group.removeAll(true);

                      if (game.device.desktop)
                        var tap_text = game.add.text(
                          game.camera.width / 2,
                          game.camera.height - 50,
                          game.cache.getJSON('lang')['t460'][0][window.lang],
                          { font: '56px RussoOne', fill: '#fff', align: 'center' },
                        );
                      else
                        var tap_text = game.add.text(
                          game.camera.width / 2,
                          game.camera.height - 50,
                          game.cache.getJSON('lang')['t250'][0][window.lang],
                          { font: '56px RussoOne', fill: '#fff', align: 'center' },
                        );
                      tap_text.anchor.setTo(0.5);
                      popup_group.add(tap_text);
                      tap_text.stroke = '#000';
                      tap_text.strokeThickness = 4;
                      tap_text.setShadow(0, 4, 'rgba(0,0,0,0.5)', 1);
                      tap_text.fixedToCamera = true;
                      scale_tween(tap_text, 500, 0.1, 0.1, -1);
                      game.add
                        .tween(popup_group)
                        .to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          animation = 0;
                        });
                      if (FTUE < 151 && scrn == 4) {
                        if (fbv == 1) {
                          window.eventTrack('FTUE_9_4_3_portrait_only');
                        }
                        FTUE_Arrow = game.add.sprite(
                          game.camera.width / 2,
                          game.camera.height - 50,
                          'game_atlas',
                          'FTUE_Arrow.png',
                        );
                        FTUE_Arrow.anchor.setTo(0.5, 1.6);
                        FTUE_Arrow.fixedToCamera = true;
                        game.add
                          .tween(FTUE_Arrow.anchor)
                          .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                          .yoyo(true, 200);
                        popup_group.add(FTUE_Arrow);
                        game.world.bringToTop(effects_group);
                      }
                    });
                } else {
                  popup_group.aaa = 0;
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  dialog_check = 0;
                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup_group.y -= game.camera.height;
                      popup = 1;
                      black_sprite = game.add.sprite(0, 0, 'message_invite_mask');
                      black_sprite.alpha = 0;
                      black_sprite.width = game.camera.width;
                      black_sprite.height = game.camera.height;
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          Empty_Picture.destroy();
                          if (picture_medal != 0) {
                            picture_medal.destroy();
                            picture_medal = 0;
                          }
                          Hand_Picture.destroy();
                          game.world.bringToTop(item);
                          game.add
                            .tween(black_sprite)
                            .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function (item) {
                              item.destroy();
                              game.add.tween(UI_top_group).to({ y: '+400' }, 500, Phaser.Easing.Exponential.Out, true);
                              animation = 1;
                              game.add
                                .tween(UI_bottom_group)
                                .to({ y: '-400' }, 500, Phaser.Easing.Exponential.Out, true)
                                .onComplete.add(function (item) {
                                  animation = 0;
                                  popup = 0;
                                  if (scrn != 4 && scrn != 7) {
                                    taks_indicator(1);
                                  } else {
                                    if (scrn == 4) {
                                      if (fbv == 1) {
                                        window.eventTrack('FTUE_9_4_4_user_closed_portrait');
                                      }
                                      dialog_window(29, 1);
                                    }
                                    if (scrn == 7) {
                                      dialog_window(72, 1);
                                    }
                                    if (scrn == 9) {
                                      dialog_window(156, 1);
                                    }
                                  }
                                  scrn = 0;
                                });
                            });
                        });
                      black_sprite.fixedToCamera = true;
                    });
                }
              }
            }
          } else {
            game.add.tween(UI_top_group).to({ y: '+400' }, 500, Phaser.Easing.Exponential.Out, true);
            animation = 1;
            game.add
              .tween(UI_bottom_group)
              .to({ y: '-400' }, 500, Phaser.Easing.Exponential.Out, true)
              .onComplete.add(function (item) {
                animation = 0;
              });
            scrn = game.cache.getJSON('dialog')['dialog' + dialog_check][0]['message' + text_n][0]['screen'];
            text_n++;
            dialog_text.destroy();
            if (object_outline1 != 0) { object_outline1.destroy(); object_outline2.destroy(); object_outline1 = 0; object_outline2 = 0; }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            dialog_check = 0;
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup_group.y -= game.camera.height;
                popup = 1;
                black_sprite = game.add.sprite(0, 0, 'message_invite_mask');
                black_sprite.alpha = 0;
                black_sprite.width = game.camera.width;
                black_sprite.height = game.camera.height;
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    if (scrn != 0) {
                      if (scrn == 8)
                        Empty_Picture = game.add.sprite(
                          game.camera.width / 2,
                          game.camera.height / 2,
                          'background_young_rose_gift',
                        );
                      else
                        Empty_Picture = game.add.sprite(
                          game.camera.width / 2,
                          game.camera.height / 2,
                          'Green_Background',
                        );
                      Empty_Picture.anchor.setTo(0.5);
                      if (game.world.width / Empty_Picture.width > 1)
                        Empty_Picture.scale.setTo(game.world.width / Empty_Picture.width);
                      else if (game.world.height / Empty_Picture.height > 1)
                        Empty_Picture.scale.setTo(game.world.height / Empty_Picture.height);
                      Empty_Picture.fixedToCamera = true;
                      Hand_Picture = game.add.sprite(
                        game.camera.width / 2 + 100,
                        game.camera.height,
                        'photo_atlas',
                        'Hand_Picture_Frame.png',
                      );
                      Hand_Picture.anchor.setTo(0.5, 1);
                      Hand_Picture.scale.setTo(2);
                      Hand_Picture.fixedToCamera = true;
                      if (scrn != 10 && scrn != 12) {
                        var photo_mask = game.add.graphics(0, 0);
                        photo_mask.beginFill(0xffffff);
                        photo_mask.drawRect(-210, -452 - 305, 285, 300);
                        Hand_Picture.addChild(photo_mask);
                      }
                      if (scrn == 1) {
                        var Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_2_BW.png');
                        var Wedding_picture2 = game.add.sprite(-65, -310, 'photo_atlas', 'PIC_2.png');
                      } else if (scrn == 2) {
                        var Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_7_BW.png');
                        var Wedding_picture2 = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_7.png');
                      } else if (scrn == 3) {
                        Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_3_BW.png');
                        var Wedding_picture2 = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_3.png');
                      } else if (scrn == 4) {
                        if (fbv == 1 && FTUE < 150) {
                          window.eventTrack('FTUE_9_5_SecondDialoguePolaroidCompleted');
                        }
                        Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_4_BW.png');
                        var Wedding_picture2 = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_4.png');
                      } else if (scrn == 5) {
                        Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'HOUSE_BW.png');
                        var Wedding_picture2 = game.add.sprite(-62, -310, 'photo_atlas', 'House.png');
                        picture_medal = game.add.sprite(
                          game.camera.width / 2 - 250,
                          game.camera.height / 2 - 270,
                          'game_ui_atlas',
                          'FIRST_PLACE_RIBBON.png',
                        );
                        picture_medal.anchor.setTo(0.5);
                        picture_medal.fixedToCamera = true;
                        var picture_text = game.add.sprite(220, 620, 'game_ui_atlas', 'TEXT.png');
                        picture_text.anchor.setTo(0.5);
                        picture_medal.addChild(picture_text);
                      } else if (scrn == 6) {
                        Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_1_BW.png');
                        var Wedding_picture2 = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_1.png');
                      } else if (scrn == 7) {
                        Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_5_BW.png');
                        var Wedding_picture2 = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_5.png');
                      } else if (scrn == 8) {
                        Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_9_BW.png');
                        var Wedding_picture2 = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_9.png');
                        Wedding_picture.alpha = 0;
                        Wedding_picture2.alpha = 0;
                        Hand_Picture.alpha = 0;
                      } else if (scrn == 9) {
                        Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_9_BW.png');
                        var Wedding_picture2 = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_9.png');
                      } else if (scrn == 10) {
                        Wedding_picture = game.add.sprite(-62, -310, '');
                        var Wedding_picture2 = game.add.sprite(-62, -310, '');
                        Wedding_picture.alpha = 0;
                        Wedding_picture2.alpha = 0;
                        Hand_Picture.loadTexture('photo_atlas', 'Pictures_Album.png');
                        Hand_Picture.cameraOffset.y -= 150;
                      } else if (scrn == 11) {
                        Wedding_picture = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_11_BW.png');
                        var Wedding_picture2 = game.add.sprite(-62, -310, 'photo_atlas', 'PIC_11.png');
                      } else if (scrn == 12) {
                        Wedding_picture = game.add.sprite(-62, -310, '');
                        var Wedding_picture2 = game.add.sprite(-62, -310, '');
                        Wedding_picture.alpha = 0;
                        Wedding_picture2.alpha = 0;
                        Hand_Picture.loadTexture('photo_atlas', 'Safe_Detail.png');
                        Hand_Picture.cameraOffset.y -= 150;
                        Hand_Picture.cameraOffset.x -= 50;
                      }
                      Wedding_picture.anchor.setTo(0.5);
                      Hand_Picture.addChild(Wedding_picture);
                      Wedding_picture2.anchor.setTo(0.5);
                      if (scrn != 10 && scrn != 12) { Wedding_picture2.mask = photo_mask; }
                      Hand_Picture.addChild(Wedding_picture2);
                      if (scrn != 8 && scrn != 10 && scrn != 12) {
                        var tween = game.add
                          .tween(photo_mask)
                          .to({ y: '+300' }, 2000, Phaser.Easing.Linear.None, true, 1000);
                        var emitter666 = game.add.emitter(
                          game.camera.x + game.camera.width / 2,
                          game.camera.y + game.camera.height / 2,
                          200,
                        );
                        emitter666.width = 700;
                        emitter666.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                        emitter666.minParticleSpeed.set(0, 50);
                        emitter666.maxParticleSpeed.set(0, 100);
                        emitter666.minParticleScale = 0.5;
                        emitter666.maxParticleScale = 2;
                        emitter666.setRotation(0, 360);
                        emitter666.setAlpha(0.3, 1, 400);
                        tween.onStart.add(function () {
                          if (sound_on == 1) {
                            play_sound('photo_transition');
                          }
                          emitter666.start(false, 400, 10, 100);
                        }, this);
                        tween.onUpdateCallback(function () {
                          emitter666.y = photo_mask.world.y - 870;
                        }, this);
                      }
                    }
                    game.world.bringToTop(item);
                    game.add
                      .tween(black_sprite)
                      .to({ alpha: 0 }, 1500, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        item.destroy();
                        game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                          if (scrn == 1) {
                            popup = 0;
                            animation = 0;
                            dialog_window(17, 1);
                          } else if (scrn == 2) {
                            popup = 0;
                            animation = 0;
                            dialog_window(19, 1);
                          } else if (scrn == 3) {
                            popup = 0;
                            animation = 0;
                            dialog_window(26, 1);
                          } else if (scrn == 4) {
                            if (fbv == 1) {
                              window.eventTrack('FTUE_9_4_2_portrait_and_dialog_shown');
                            }
                            popup = 0;
                            animation = 0;
                            dialog_window(28, 1);
                          } else if (scrn == 5) {
                            popup = 0;
                            animation = 0;
                            dialog_window(42, 1);
                          } else if (scrn == 6) {
                            popup = 0;
                            animation = 0;
                            dialog_window(45, 1);
                          } else if (scrn == 7) {
                            popup = 0;
                            animation = 0;
                            dialog_window(67, 1);
                          } else if (scrn == 8) {
                            popup = 0;
                            animation = 0;
                            dialog_window(101, 1);
                          } else if (scrn == 9) {
                            popup = 0;
                            animation = 0;
                            dialog_window(155, 1);
                          } else if (scrn == 10) {

                            mission_number.push("1068");
                            complete_task_i = 13;
                            mission_task[13] = 1;
                            game.saveDataAll();

                            popup = 0;
                            animation = 0;
                            dialog_window(283, 1);
                          } else if (scrn == 11) {
                            popup = 0;
                            animation = 0;
                            dialog_window(289, 1);
                          } else if (scrn == 12) {
                            popup = 0;
                            animation = 0;
                            dialog_window(293, 1);
                          }
                        });
                      });
                  });
                black_sprite.fixedToCamera = true;
              });
          }
        } else {
          game.time.events.remove(dialog_time);
          dialog_text.setText(text_color);
          dialog_time = 0;
          dialog_finish = 1;
        }
      }
    });

    var Dialog_Bubble = 0;
    var name1_rect = 0;
    var name2_rect = 0;
    var dog = 0;
    var dialog_name1 = 0;
    var dialog_name2 = 0;
    var brochure_hand = 0;
    function dialog_window(gialog_n, s, n_i) {
      if (popup == 0 && missions_tab_open == 0) {
        popup_group.removeAll();
        n_iii = n_i;
        if (gialog_n != 4) game.add.tween(UI_top_group).to({ y: '-400' }, 500, Phaser.Easing.Exponential.In, true);
        game.add
          .tween(UI_bottom_group)
          .to({ y: '+400' }, 500, Phaser.Easing.Exponential.In, true)
          .onComplete.add(function (item) {
            animation = 0;
          });
        dialog_mas.push(gialog_n * -1);
        game.setUserDataAndLog({ dialog_mas: JSON.stringify(dialog_mas) });
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        dialog_check = gialog_n;
        dialog_type = Number(game.cache.getJSON('dialog')['dialog' + gialog_n][0]['type']);
        text_n = 1;
        animation = 1;
        if (s != 1) {
          blackf();
        }
        man1 = game.add.sprite(
          game.camera.width / 2 - 1700,
          game.camera.height - 200,
          'char_atlas',
          game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man1'],
        );
        man1.anchor.setTo(0.5, 1);
        if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man1_name'][0][window.lang] == 'Alice') {
          man1.scale.setTo(2.2);
        } else {
          man1.scale.setTo(2.6);
        }
        popup_group.add(man1);
        man1.zzz = 4;
        man1.fixedToCamera = true;
        man1.angle -= 10;

        var man1_darck = game.add.sprite(
          0,
          0,
          'char_atlas',
          game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man1'],
        );
        man1_darck.anchor.setTo(0.5, 1);
        man1_darck.tint = 0x000000;
        man1_darck.alpha = 0;
        man1.addChild(man1_darck);

        if (
          (dialog_type == 2 && game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man1_show'] == 1) ||
          dialog_type == 1
        ) {
          game.add
            .tween(man1.cameraOffset)
            .to({ x: game.camera.width / 2 - 500 }, 400, Phaser.Easing.Exponential.Out, true, 500);
          game.add.tween(man1).to({ angle: 0 }, 800, Phaser.Easing.Elastic.Out, true, 700);
          //man1.children[0].alpha = 0;
        }
        if (dialog_type == 2 && game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man2'] != '0') {
          man2 = game.add.sprite(
            game.camera.width / 2 + 1700,
            game.camera.height - 200,
            'char_atlas',
            game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man2'],
          );
          man2.anchor.setTo(0.5, 1);
          man2.scale.setTo(2.6);
          popup_group.add(man2);
          man2.zzz = 4;
          man2.fixedToCamera = true;
          man2.angle += 10;

          var man2_darck = game.add.sprite(
            0,
            0,
            'char_atlas',
            game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man2'],
          );
          man2_darck.anchor.setTo(0.5, 1);
          man2_darck.tint = 0x000000;
          man2_darck.alpha = 0;
          man2.addChild(man2_darck);

          if (dialog_check == 112 || dialog_check == 136) {
            man2.tint = 0x000000;
          }
          if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man2_show'] == 1) {
            game.add
              .tween(man2.cameraOffset)
              .to({ x: game.camera.width / 2 + 500 }, 400, Phaser.Easing.Exponential.Out, true, 500);
            game.add.tween(man2).to({ angle: 0 }, 800, Phaser.Easing.Elastic.Out, true, 700);
          }
        }
        Dialog_Bubble = draw_rect(
          game.camera.width / 2,
          game.camera.height - 170,
          1708,
          249,
          '#FAF7F0',
          '#FAF0D8',
          0,
          0,
          0,
          5,
          30,
          1,
          1,
        );
        popup_group.add(Dialog_Bubble);
        Dialog_Bubble.zzz = 3;
        Dialog_Bubble = game.add.sprite(
          game.camera.width / 2,
          game.camera.height - 294,
          'game_window_atlas',
          'Dialog_Bubble.png',
        );
        Dialog_Bubble.anchor.setTo(0.5, 1);
        popup_group.add(Dialog_Bubble);
        Dialog_Bubble.zzz = 3;
        Dialog_Bubble.fixedToCamera = true;
        name1_rect = game.add.sprite(
          game.camera.width / 2 - 650,
          game.camera.height - 290,
          'game_window_atlas',
          'Name_Rectangle.png',
        );
        name1_rect.anchor.setTo(0.5);
        name1_rect.alpha = 0;
        popup_group.add(name1_rect);
        name1_rect.zzz = 2;
        name1_rect.fixedToCamera = true;
        dialog_name1 = game.add.text(
          0,
          0,
          game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man1_name'][0][window.lang],
          { font: '32px RussoOne', fill: '#fff', align: 'center' },
        );
        dialog_name1.anchor.setTo(0.5);
        name1_rect.addChild(dialog_name1);
        dialog_name1.zzz = 1;
        if (dialog_type == 2) {
          name2_rect = game.add.sprite(
            game.camera.width / 2 + 650,
            game.camera.height - 290,
            'game_window_atlas',
            'Name_Rectangle.png',
          );
          name2_rect.anchor.setTo(0.5);
          name2_rect.alpha = 0;
          popup_group.add(name2_rect);
          name2_rect.zzz = 2;
          name2_rect.fixedToCamera = true;
          dialog_name2 = game.add.text(
            0,
            0,
            game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man2_name'][0][window.lang],
            { font: '32px RussoOne', fill: '#fff', align: 'center' },
          );
          dialog_name2.anchor.setTo(0.5);
          name2_rect.addChild(dialog_name2);
          dialog_name2.zzz = 1;
        }
        var Read_More_Button = game.add.sprite(
          game.camera.width / 2 - 740 + 42,
          game.camera.height - 90,
          'game_window_atlas',
          'Read_More_Button.png',
        );
        popup_group.add(Read_More_Button);
        Read_More_Button.zzz = 2;
        Read_More_Button.fixedToCamera = true;
        game.add
          .tween(Read_More_Button.cameraOffset)
          .to({ y: '-20' }, 400, Phaser.Easing.Linear.None, true, 0, -1)
          .yoyo(true, 300);
        var button_skip = game.add.sprite(
          game.camera.width / 2 + 770 - 129,
          game.camera.height - 110,
          'game_window_atlas',
          'Skip_Button.png',
        );
        popup_group.add(button_skip);
        button_skip.fixedToCamera = true;
        button_skip.inputEnabled = true;
        button_skip.zzz = 2;
        button_skip.input.useHandCursor = true;
        button_skip.events.onInputDown.add(function () {
          if (dialog_check != 0 && animation == 0) {
            if (scrn != 0) {

              if (gialog_n == 288) {
                if (Tube_2_Papers != 0)
                  game.add.tween(Tube_2_Papers).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                    item.destroy();
                  });
                if (Testament != 0)
                  game.add.tween(Testament).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                    item.destroy();
                  });
              }

              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              dialog_check = 0;
              dialog_text.destroy();
              if (object_outline1 != 0) { object_outline1.destroy(); object_outline2.destroy(); object_outline1 = 0; object_outline2 = 0; }
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  popup_group.removeAll(true);
                  popup_group.y -= game.camera.height;
                  popup = 1;
                  black_sprite = game.add.sprite(0, 0, 'message_invite_mask');
                  black_sprite.alpha = 0;
                  black_sprite.width = game.camera.width;
                  black_sprite.height = game.camera.height;
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      Empty_Picture.destroy();
                      if (picture_medal != 0) {
                        picture_medal.destroy();
                        picture_medal = 0;
                      }
                      Hand_Picture.destroy();
                      game.world.bringToTop(item);
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                          game.add.tween(UI_top_group).to({ y: '+400' }, 500, Phaser.Easing.Exponential.Out, true);
                          animation = 1;
                          game.add
                            .tween(UI_bottom_group)
                            .to({ y: '-400' }, 500, Phaser.Easing.Exponential.Out, true)
                            .onComplete.add(function (item) {
                              animation = 0;
                              popup = 0;
                              if (scrn != 4) {
                                taks_indicator(1);
                              } else dialog_window(29, 1);
                              scrn = 0;
                            });
                        });
                    });
                  black_sprite.fixedToCamera = true;
                });
            } else {
              var dcheck = dialog_check;
              dialog_check = 0;
              var isDialog = end_dialog2(dcheck);
              dialog_text.destroy();
              if (object_outline1 != 0) { object_outline1.destroy(); object_outline2.destroy(); object_outline1 = 0; object_outline2 = 0; }
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              if (gialog_n != 4)
                game.add.tween(UI_top_group).to({ y: '+400' }, 500, Phaser.Easing.Exponential.Out, true);
              else {
                FTUE_Arrow.destroy();
                FTUE_Arrow = 0;
              }
              animation = 1;
              game.add.tween(UI_bottom_group).to({ y: '-400' }, 500, Phaser.Easing.Exponential.Out, true);
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  if (!isDialog) {
                    if (dcheck == 1) {
                      if (fbv == 1 && FTUE < 150) {
                        window.eventTrack('FTUE_7_4_LongDialogueCompleted');
                      }
                    } else if (dcheck == 28) {
                      if (fbv == 1 && FTUE < 150) {
                        window.eventTrack('FTUE_9_6_ThirdDialogueCompleted');
                      }
                    }
                    popup_group.removeAll(true);
                    popup_group.y -= game.camera.height;
                    popup = 0;
                    animation = 0;
                    if (dcheck != 12 && dcheck != 76 && !n_i) taks_indicator(1);
                    end_dialog(dcheck);
                    dcheck = 0;
                    if (n_i) {
                      animation = -1;
                      build_action(n_i, 500);
                    }
                  }
                });
            }
          }
        });
        dialog_process(dialog_type, gialog_n, 1000);
        game.add
          .tween(popup_group)
          .to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function (item) { });
        game.world.bringToTop(popup_group);
      }
    }
    function end_dialog2(dcheck) {
      var isDialog = 0;
      if (dcheck == 259) {
        isDialog = 1;
        popup = 1;
        animation = 1;
        game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {

          game.add.tween(follow).to({ x: 987, y: 1490 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
            follow.x = 987;
            follow.y = 1490;
            animation = 0; popup = 0; dialog_window(260, 0);
          });

        });
      } else
        if (dcheck == 256) {
          isDialog = 1;
          popup = 1;
          animation = 1;
          game.add.tween(follow).to({ x: 923, y: 1750 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
            follow.x = 923;
            follow.y = 1750;
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 20217 && child_item.frameName == 'gift_box.png') {
                child_item.alpha = 0;
                add_shines(child_item, 3, 1);
                add_shines(child_item, 3, 1);
                add_shines(child_item, 3, 1);
                game.add.tween(child_item).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 500);
              }
            });
            game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
              game.add.tween(follow).to({ x: 1370, y: 1710 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
                follow.x = 1370;
                follow.y = 1710;
                animation = 0; popup = 0; dialog_window(257, 0);
              });

            });
          });

        } else
          if (dcheck == 251) {
            isDialog = 1;
            popup = 1;
            animation = 1;
            objects_group.children.forEach(function (child_item) {
              if (child_item.type == 20214) {
                child_item.alpha = 0;
                add_shines(child_item, 3, 1);
                add_shines(child_item, 3, 1);
                add_shines(child_item, 3, 1);

                if (child_item.frameName != 'flower_pot_8.png') {
                  hummer_anim(child_item);
                  game.add.tween(child_item).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 1000);
                }
                else {
                  child_item.y -= 200;
                  game.add.tween(child_item).to({ y: '+200' }, 800, Phaser.Easing.Bounce.Out, true, 1000);
                  game.add.tween(child_item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000)
                    .onComplete.add(function (item) {
                      var emitter_lsmoke = game.add.emitter(0, 0, 50);
                      emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
                      emitter_lsmoke.width = item.width;
                      emitter_lsmoke.height = item.height / 2;
                      emitter_lsmoke.bringToTop = true;
                      emitter_lsmoke.setRotation(0, 360, 500);
                      emitter_lsmoke.setAlpha(0.2, 0, 1000);
                      emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 1000);
                      emitter_lsmoke.gravity = 50;
                      emitter_lsmoke.minParticleSpeed.set(50, 50);
                      emitter_lsmoke.maxParticleSpeed.set(50, 50);
                      emitter_lsmoke.explode = true;
                      emitter_lsmoke.blendMode = 3;
                      emitter_lsmoke.x = item.world.x;
                      emitter_lsmoke.y = item.world.y + item.height / 2;
                      emitter_lsmoke.start(false, 500, 0, 20);
                    });
                }
              }
            });
            game.add.tween(effects_group).to({ alpha: 1 }, 3500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
              popup = 0;
              animation = 1;
              transition_xmas(dcheck);
            });
            game.add.tween(effects_group.scale).to({ x: 1 }, 2500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
              objects_group.children.forEach(function (child_item) {
                if (child_item.type == 999999999) {
                  if (xmas_level >= 45)
                    child_item.loadTexture('xmas_atlas', 'xmas_darck_8.png');
                  else if (xmas_level >= 38)
                    child_item.loadTexture('xmas_atlas', 'xmas_darck_7.png');
                  else if (xmas_level >= 31)
                    child_item.loadTexture('xmas_atlas', 'xmas_darck_6.png');
                  else if (xmas_level >= 24)
                    child_item.loadTexture('xmas_atlas', 'xmas_darck_5.png');
                  else if (xmas_level >= 18)
                    child_item.loadTexture('xmas_atlas', 'xmas_darck_4.png');
                  else if (xmas_level >= 11)
                    child_item.loadTexture('xmas_atlas', 'xmas_darck_3.png');
                  else if (xmas_level >= 5)
                    child_item.loadTexture('xmas_atlas', 'xmas_darck_2.png');
                  else if (xmas_level >= 1)
                    child_item.loadTexture('xmas_atlas', 'xmas_darck_1.png');
                }
              });
            });
          } else
            if (dcheck == 247) {
              isDialog = 1;
              popup = 1;
              animation = 1;
              objects_group.children.forEach(function (child_item) {
                if (child_item.type == 20213) {
                  child_item.alpha = 0;
                  add_shines(child_item, 3, 1);
                  add_shines(child_item, 3, 1);
                  add_shines(child_item, 3, 1);

                  if (child_item.frameName != 'snowMan.png') {
                    game.add.tween(child_item).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 1000);
                  }
                  else {
                    child_item.y -= 200;
                    game.add.tween(child_item).to({ y: '+200' }, 800, Phaser.Easing.Bounce.Out, true, 1000);
                    game.add.tween(child_item).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000)
                      .onComplete.add(function (item) {
                        var emitter_lsmoke = game.add.emitter(0, 0, 50);
                        emitter_lsmoke.makeParticles('game_atlas', 'smoke.png');
                        emitter_lsmoke.width = item.width;
                        emitter_lsmoke.height = item.height / 2;
                        emitter_lsmoke.bringToTop = true;
                        emitter_lsmoke.setRotation(0, 360, 500);
                        emitter_lsmoke.setAlpha(0.2, 0, 1000);
                        emitter_lsmoke.setScale(0.2, 1, 0.2, 1, 1000);
                        emitter_lsmoke.gravity = 50;
                        emitter_lsmoke.minParticleSpeed.set(50, 50);
                        emitter_lsmoke.maxParticleSpeed.set(50, 50);
                        emitter_lsmoke.explode = true;
                        emitter_lsmoke.blendMode = 3;
                        emitter_lsmoke.x = item.world.x;
                        emitter_lsmoke.y = item.world.y + item.height / 2;
                        emitter_lsmoke.start(false, 500, 0, 20);
                      });
                  }
                }
              });
              game.add.tween(effects_group).to({ alpha: 1 }, 2500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                popup = 0; dialog_window(248, 0);
              });

              game.add.tween(effects_group.scale).to({ x: 1 }, 2500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                objects_group.children.forEach(function (child_item) {
                  if (child_item.type == 999999999) {
                    if (xmas_level >= 45)
                      child_item.loadTexture('xmas_atlas', 'xmas_darck_8.png');
                    else if (xmas_level >= 38)
                      child_item.loadTexture('xmas_atlas', 'xmas_darck_7.png');
                    else if (xmas_level >= 31)
                      child_item.loadTexture('xmas_atlas', 'xmas_darck_6.png');
                    else if (xmas_level >= 24)
                      child_item.loadTexture('xmas_atlas', 'xmas_darck_5.png');
                    else if (xmas_level >= 18)
                      child_item.loadTexture('xmas_atlas', 'xmas_darck_4.png');
                    else if (xmas_level >= 11)
                      child_item.loadTexture('xmas_atlas', 'xmas_darck_3.png');
                    else if (xmas_level >= 5)
                      child_item.loadTexture('xmas_atlas', 'xmas_darck_2.png');
                    else if (xmas_level >= 1)
                      child_item.loadTexture('xmas_atlas', 'xmas_darck_1.png');
                  }
                });
              });
            } else
              if (dcheck == 243) {
                isDialog = 1;
                xmas_create(1);
                popup = 2;
                xmas = 1;
                from_map = 2;

                if (n == 1 || xmas == 1) {
                  buch_rnd = 5;
                }
                else {
                  if (buch_rnd == 5) { buch_rnd = game.rnd.integerInRange(1, 4); }
                }
                animation = 1;
                var graphics = game.add.graphics(0, 0);
                if (n == 0 && xmas == 0) {
                  graphics.beginFill(0x386217);
                } else {
                  graphics.beginFill(0x74ADBA);
                }
                graphics.alpha = 0;
                graphics.drawRect(0, 0, game.camera.width, game.camera.height);
                graphics.fixedToCamera = true;
                game.add.tween(graphics).to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true);
                buch_create(game.camera.width / 2 + 150, -1000, -2.2, -2.2, '0', '+900', 45, 800, 0xffffff, buch_rnd);
                buch_create(
                  game.camera.width / 2 - 150,
                  game.camera.height + 1000,
                  2.2,
                  2.2,
                  '0',
                  '-900',
                  45,
                  800,
                  0xffffff,
                  buch_rnd,
                );
                var graphics = game.add.graphics(0, 0);
                if (n == 0 && xmas == 0) {
                  graphics.beginFill(0x386217);
                } else {
                  graphics.beginFill(0x74ADBA);
                }
                graphics.alpha = 0;
                graphics.drawRect(0, 0, game.camera.width, game.camera.height);
                graphics.fixedToCamera = true;
                game.add.tween(graphics).to({ alpha: 0.5 }, 800, Phaser.Easing.Linear.None, true);
                buch_create(
                  game.camera.width + 1000,
                  game.camera.height + 1000,
                  2.2,
                  2.2,
                  '-1000',
                  '-1000',
                  0,
                  0,
                  0xffffff,
                  buch_rnd,
                );
                buch_create(-1000, -1000, -2.2, 2.2, '+1000', '+1000', 90, 0, 0xffffff, buch_rnd);
                buch_create(game.camera.width + 1000, -1000, 2.2, -2.2, '-1000', '+1000', 0, 400, 0xffffff, buch_rnd);
                buch_create(-1000, game.camera.height + 1000, -2.2, -2.2, '+1000', '-1000', -90, 400, 0xffffff, buch_rnd);
                if (sound_on == 1) {
                  play_sound('leaves');
                }

                game.time.events.add(2500, function () {
                  for (var m = 0; m < angl_mas.length; m++) {
                    angl_mas2[m] = angl_mas[m].angle;
                  }
                  worldScale = 0.8;
                  follow.x = 1800 * worldScale;
                  follow.y = 1600 * worldScale;
                  last_position = [1800 * worldScale, 1600 * worldScale];
                  game.world.removeAll(true);
                  game.state.start('Map');
                });

              } else
                if (dcheck == 12) {
                  isDialog = 1;
                  var oil_obj = 0;
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.type == 17) {
                      oil_obj = child_item;
                      return true;
                    }
                  });
                  animation == 1;
                  game.add
                    .tween(follow)
                    .to({ x: oil_obj.x * worldScale, y: oil_obj.y * worldScale }, 2000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      game.add.tween(oil_obj.scale).to({ x: 2.9, y: 2.9 }, 2000, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(oil_obj)
                        .to({ alpha: 1 }, 2000, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          animation = 0;
                          popup = 0;
                          first_start = 0;
                          last_position = [oil_obj.x, oil_obj.y];
                          dialog_window(13, 0);
                        });
                    });
                } else if (dcheck == 217) {
                  isDialog = 1;
                  animation = 1;
                  var oil_obj = 0;
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.type == 161) {
                      oil_obj = child_item;
                      return true;
                    }
                  });
                  game.add.tween(follow).to({ x: oil_obj.x * worldScale, y: oil_obj.y * worldScale }, 2000, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                    animation = 0;
                    popup = 0;
                    dialog_window(218, 0);
                    object_outline1 = game.add.sprite(oil_obj.x * worldScale, oil_obj.y * worldScale, oil_obj.key, oil_obj.frameName);
                    object_outline1.anchor.setTo(0.5);
                    object_outline1.scale.setTo(2.9 * worldScale + 0.2 * worldScale);
                    object_outline1.tint = 0xffff00;
                    object_outline2 = game.add.sprite(oil_obj.x * worldScale, oil_obj.y * worldScale, oil_obj.key, oil_obj.frameName);
                    object_outline2.anchor.setTo(0.5);
                    object_outline2.scale.setTo(2.9 * worldScale);
                  });
                } else if (dcheck == 235 || dcheck == 252 || dcheck == 258) {
                  isDialog = 1;
                  popup = 1;
                  animation = 1;
                  game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    popup = 1;
                    animation = 1;
                    if (dcheck != 258)
                      black_screen(dcheck);
                    else {
                      game.add.tween(follow).to({ x: 2455, y: 2060 }, 1000, Phaser.Easing.Linear.None, true, 1000).onComplete.add(function (item) {
                        follow.x = 2455;
                        follow.y = 2060;
                        black_screen(dcheck);
                      });
                    }
                  });
                } else if (dcheck == 234) {
                  isDialog = 1;
                  popup = 1;
                  animation = 1;

                  var lasso_mas = [];
                  for (var i = 100; i <= 171; i++) {
                    let n = 0;
                    if (i < 10) { n = '0' + i; } else { n = i; }
                    lasso_mas.push('Pre-comp 3_00' + n + '.png');
                  }
                  var anim = lasso.animations.add('lasso',
                    lasso_mas,
                    20,
                    false,
                  );
                  anim.onComplete.add(function () {
                    game.add.tween(lasso).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                      item.destroy();
                      popup = 0;
                      animation = 0;
                      dialog_window(235, 0);
                    });
                  }, this);
                  lasso.animations.play('lasso');

                } else if (dcheck == 231) {
                  isDialog = 1;
                  popup = 1;
                  animation = 1;
                  game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    popup = 1;
                    animation = 1;
                    black_screen(dcheck);
                  });
                } else if (dcheck == 132) {
                  isDialog = 1;
                  popup = 1;
                  animation = 1;
                  game.add
                    .tween(follow)
                    .to({ x: 3300, y: 1000 }, 2000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      popup = 1;
                      animation = 1;
                      black_screen(dcheck);
                    });
                } else if (dcheck == 74) {
                  isDialog = 1;
                  animation = 1;
                  game.add
                    .tween(follow)
                    .to({ x: 3000, y: 1800 }, 2000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      animation = 0;
                      popup = 0;
                      dialog_window(87, 0);
                    });
                } else if (dcheck == 87) {
                  isDialog = 1;
                  animation = 1;
                  objects_group.children.forEach(function (child_item) {
                    if (child_item.frameName == 'rat.png') {
                      game.add.tween(child_item).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true);
                      let rnd1 = game.rnd.integerInRange(100, 200) * 10;
                      let rnd2 = game.rnd.integerInRange(100, 300) * 10;
                      rat_walk(child_item, 200, rnd1, rnd2);
                    }
                  });
                  game.add
                    .tween(follow)
                    .to({ x: 3000 * worldScale, y: 1800 * worldScale }, 1300, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      animation = 0;
                      popup = 0;
                      dialog_window(88, 0);
                    });
                } else if (dcheck == 144) {
                  isDialog = 1;
                  animation = 1;
                  game.add
                    .tween(follow)
                    .to({ x: 2980 * worldScale, y: 1200 * worldScale }, 2000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      animation = 0;
                      popup = 0;
                      dialog_window(145, 0);
                    });
                } else if (dcheck == 161) {
                  isDialog = 1;
                  animation = 1;
                  game.add
                    .tween(follow)
                    .to({ x: 1000 * worldScale, y: 800 * worldScale }, 2000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      animation = 0;
                      popup = 0;
                      dialog_window(162, 0);
                    });
                } else if (dcheck == 137) {
                  isDialog = 1;
                  animation = 1;
                  game.add
                    .tween(follow)
                    .to({ x: 2480 * worldScale, y: 1900 * worldScale }, 2000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function () {
                      animation = 0;
                      popup = 0;
                      dialog_window(1372, 0);
                    });
                }
      return isDialog;
    }
    function end_dialog(dcheck) {
      if (dcheck == 271) {
        popup = 1;
        animation = 1;
        var child_item = 0;
        objects_group.children.some(function (child_item2) {
          if (Math.abs(child_item2.type) == 183) {
            child_item = child_item2;
            return true;
          }
        });

        follow.x = child_item.x * worldScale;
        follow.y = child_item.y * worldScale;

        game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true).onComplete.add(function () {
          animation = 0; popup = 0; dialog_window(272, 0);
        });
      }
      if (dcheck == 279) {
        dialog_window(280, 0);
      } else
        if (dcheck == 276) {

          var child_item = 0;
          objects_group.children.some(function (child_item2) {
            if (Math.abs(child_item2.type) == 183) {
              child_item = child_item2;
              return true;
            }
          });

          flex_anim(child_item);

        } else
          if (dcheck == 245 || dcheck == 246 || dcheck == 248 || dcheck == 254 || dcheck == 255 || dcheck == 257 || dcheck == 260) {
            animation = 1;
            transition_xmas(dcheck);
          }
          else
            if (dcheck == 285) {
              popup = 1;
              animation = 1;
              game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                animation = 0; popup = 0;
                chest_open_window(game.cache.getJSON('lang')['FREEGIFT'][0][window.lang], [500, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1], 51.77, void 0, {
                  // gameArea: DdnaGameArea.Map,
                  // actionType: DdnaTransactionActionType.DayProgress,
                  gameArea: null,
                  actionType: null,
                });
                source_chest = 'free gift';
                package_id_chest = 0;
              });
            } else
              if (dcheck == 179) {
                animation = 1;
                game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  letter(
                    game.cache.getJSON('dialog')['letter2'][0][window.lang],
                    Number(game.cache.getJSON('dialog')['letter2'][0]['coins']),
                  );
                });
              } else if (dcheck == 76 || dcheck == 99 || dcheck == 164) {
                popup = 1;
                animation = 1;
                black_screen(dcheck);
              } else if (dcheck == 203 || dcheck == 213) {
                sunflowerStage = 0;
                game.setUserDataAndLog({ sunflowerStage: sunflowerStage });
                animation = 1;
                game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  animation = 0;
                  entryPointData_function();
                });
              } else if (dcheck == 85) {
                chest_open_window(game.cache.getJSON('lang')['FREEGIFT'][0][window.lang], [500, 0, 0, 0, 0], 51.5, void 0, {
                  // gameArea: DdnaGameArea.Map,
                  // actionType: DdnaTransactionActionType.DayProgress,
                  gameArea: null,
                  actionType: null,
                });
                source_chest = 'free gift';
                package_id_chest = 0;
              } else if (dcheck == 86) {
                chest_open_window(game.cache.getJSON('lang')['FREEGIFT'][0][window.lang], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1440], 51.5, void 0, {
                  // gameArea: DdnaGameArea.Map,
                  // actionType: DdnaTransactionActionType.DayProgress,
                  gameArea: null,
                  actionType: null,
                });
              } else if (dcheck == 68) {
                chest_open_window(game.cache.getJSON('lang')['t390'][0][window.lang], [50, 0, 0, 0, 0], 51.5, void 0, {
                  // gameArea: DdnaGameArea.Map,
                  // actionType: DdnaTransactionActionType.DayProgress,
                  gameArea: null,
                  actionType: null,
                });
                source_chest = 'Mrs Evergreen';
                package_id_chest = 0;
              } else if (dcheck == 111) {
                animation = 1;
                game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  dialog_window(112, 0);
                });
              } else if (dcheck == 130) {
                animation = 1;
                game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  dialog_window(131, 0);
                });
              } else if (dcheck == 135) {
                animation = 1;
                game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  dialog_window(136, 0);
                });
              } else if (dcheck == 1372) {
                blackf();
                dog = game.add.sprite(game.camera.width / 2 - 50, game.camera.height / 2 + 1000, 'char_atlas', 'Dog_sad2.png');
                dog.anchor.setTo(0.5);
                dog.scale.setTo(3);
                dog.alpha = 0;
                dog.fixedToCamera = true;
                game.add
                  .tween(dog)
                  .to({ alpha: 1 }, 400, Phaser.Easing.Exponential.Out, true, 500)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 1000)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                  });
                game.add.tween(dog.cameraOffset).to({ y: '-1000' }, 800, Phaser.Easing.Exponential.Out, true, 500);
                animation = 1;
                game.add.tween(effects_group).to({ alpha: 1 }, 2500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  animation = 0;
                  dialog_window(1373, 1);
                });
              } else if (dcheck == 139) {
                blackf();
                var shine = game.add.sprite(game.camera.width / 2, game.camera.height / 2 - 10, 'game_ui_atlas', 'Shine.png');
                shine.anchor.setTo(0.5, 0.52);
                shine.scale.setTo(0);
                shine.alpha = 0.3;
                shine.fixedToCamera = true;
                game.add.tween(shine.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Exponential.In, true);
                rotate_tween(shine);
                var cloves_sprite = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 - 10,
                  'farm_obj_atlas',
                  'Aloe_Vera_Icon.png',
                );
                cloves_sprite.scale.setTo(0);
                cloves_sprite.alpha = 0;
                cloves_sprite.anchor.setTo(0.5);
                cloves_sprite.fixedToCamera = true;
                game.add.tween(cloves_sprite.scale).to({ x: 2.9, y: 2.9 }, 1000, Phaser.Easing.Bounce.Out, true);
                game.add.tween(cloves_sprite).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                var cloves_sprite_text = game.add.text(game.camera.width / 2, game.camera.height / 2 + 150, 'Aloe vera', {
                  font: '62px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
                cloves_sprite_text.anchor.setTo(0.5);
                cloves_sprite_text.alpha = 0;
                cloves_sprite_text.stroke = '#000';
                cloves_sprite_text.strokeThickness = 2;
                cloves_sprite_text.setShadow(0, 3, 'rgba(0,0,0,0.7)', 1);
                cloves_sprite_text.fixedToCamera = true;
                game.add.tween(cloves_sprite_text).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000);
                animation = 1;
                game.add
                  .tween(cloves_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 2500)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(shine)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 2500)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(cloves_sprite_text)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 2500)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true, 2500)
                  .onComplete.add(function (item) {
                    item.destroy();
                    animation = 0;
                  });
              } else if (dcheck == 188) {
                blackf();
                dog = game.add.sprite(
                  game.camera.width / 2 - 50,
                  game.camera.height / 2 + 1300,
                  'char_atlas',
                  'Dog_neutral2.png',
                );
                dog.anchor.setTo(0.5, 1);
                dog.scale.setTo(3);
                dog.fixedToCamera = true;
                var cloves_sprite = game.add.sprite(
                  game.camera.width / 2 - 500,
                  game.camera.height / 2 - 50,
                  'char_atlas',
                  'collar.png',
                );
                cloves_sprite.scale.setTo(0);
                cloves_sprite.alpha = 0;
                cloves_sprite.anchor.setTo(0.5);
                cloves_sprite.fixedToCamera = true;
                game.add.tween(cloves_sprite.scale).to({ x: 2.9, y: 2.9 }, 1000, Phaser.Easing.Bounce.Out, true, 1500);
                game.add
                  .tween(cloves_sprite)
                  .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 1500)
                  .onComplete.add(function (item) {
                    game.add.tween(item.cameraOffset).to({ x: '+410' }, 500, Phaser.Easing.Cubic.Out, true, 300);
                    game.add
                      .tween(item)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 300)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                  });
                game.add.tween(dog.cameraOffset).to({ y: '-1000' }, 800, Phaser.Easing.Exponential.Out, true, 500);
                game.add
                  .tween(dog)
                  .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 3000)
                  .onComplete.add(function (item) {
                    dog.loadTexture('char_atlas', 'Dog_excited.png');
                    game.add
                      .tween(dog)
                      .to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        add_shines(item, 3, 1);
                        add_shines(item, 3, 1);
                        add_shines(item, 3, 1);
                        game.add
                          .tween(item)
                          .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 3000)
                          .onComplete.add(function (item) {
                            item.destroy();
                          });
                      });
                  });
                scale_tween(dog, 500, 0.01, 0.05);
                animation = 1;
                game.add.tween(effects_group).to({ alpha: 1 }, 7000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  animation = 0;
                  dialog_window(189, 1);
                });
              } else if (dcheck == 142) {
                blackf();
                dog = game.add.sprite(game.camera.width / 2 - 50, game.camera.height / 2 + 1300, 'char_atlas', 'Dog_sad2.png');
                dog.anchor.setTo(0.5, 1);
                dog.scale.setTo(3);
                dog.fixedToCamera = true;
                var cloves_sprite = game.add.sprite(
                  game.camera.width / 2 - 500,
                  game.camera.height / 2 - 50,
                  'farm_obj_atlas',
                  'Bandage_Aloe_Vera_Icon.png',
                );
                cloves_sprite.scale.setTo(0);
                cloves_sprite.alpha = 0;
                cloves_sprite.anchor.setTo(0.5);
                cloves_sprite.fixedToCamera = true;
                game.add.tween(cloves_sprite.scale).to({ x: 2.9, y: 2.9 }, 1000, Phaser.Easing.Bounce.Out, true, 1500);
                game.add
                  .tween(cloves_sprite)
                  .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, 1500)
                  .onComplete.add(function (item) {
                    game.add.tween(item.cameraOffset).to({ x: '+410' }, 500, Phaser.Easing.Cubic.Out, true, 300);
                    game.add.tween(item.scale).to({ x: 0.2, y: 0.2 }, 500, Phaser.Easing.Linear.None, true, 300);
                    game.add
                      .tween(item)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 300)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                  });
                game.add.tween(dog.cameraOffset).to({ y: '-1000' }, 800, Phaser.Easing.Exponential.Out, true, 500);
                game.add
                  .tween(dog)
                  .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 3000)
                  .onComplete.add(function (item) {
                    dog.loadTexture('char_atlas', 'Dog_excited3.png');
                    game.add
                      .tween(dog)
                      .to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        add_shines(item, 3, 1);
                        add_shines(item, 3, 1);
                        add_shines(item, 3, 1);
                        game.add
                          .tween(item)
                          .to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 3000)
                          .onComplete.add(function (item) {
                            item.destroy();
                          });
                      });
                  });
                scale_tween(dog, 500, 0.01, 0.05);
                animation = 1;
                game.add.tween(effects_group).to({ alpha: 1 }, 7000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  animation = 0;
                  dialog_window(1422, 1);
                });
              } else if (dcheck == 160) {
                game.add
                  .tween(brochure_hand)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    brochure_hand.destroy();
                  });
              } else if (dcheck == 165) {
                animation = 1;
                blackf();
                brochure_hand = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height + 1200,
                  'day14_pic_atlas',
                  'brochure_hand.png',
                );
                brochure_hand.scale.setTo(2);
                brochure_hand.anchor.setTo(0.5, 1);
                brochure_hand.fixedToCamera = true;
                game.add.tween(brochure_hand.cameraOffset).to({ y: '-1200' }, 1000, Phaser.Easing.Exponential.In, true);
                game.add.tween(effects_group).to({ alpha: 1 }, 2000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  animation = 0;
                  dialog_window(166, 1);
                });
              } else if (dcheck == 166) {
                game.add
                  .tween(brochure_hand.cameraOffset)
                  .to({ y: '+1200' }, 1000, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function () {
                    brochure_hand.destroy();
                  });
                animation = 1;
                game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  dialog_window(167, 0);
                });
              } else {
                FTUE_process();
              }
    }
    var Xmas_Rod = 0;
    function dialog_process(type, gialog_n, pause) {
      if (popup != 0 && missions_tab_open == 0) {

        game.time.events.add(pause, function () {
          if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['task'] != '0') {
            if (graphics_task != 0) {
              graphics_task.destroy();
              graphics_task = 0;
            }
            graphics_task = game.add.graphics(game.camera.width / 2 - 100, -240);
            graphics_task.beginFill(0xffd8b4);
            graphics_task.drawRect(0, 0, 200, 200);
            popup_group.add(graphics_task);
            graphics_task.fixedToCamera = true;
            game.add.tween(graphics_task.cameraOffset).to({ y: '+' + 280 }, 500, Phaser.Easing.Exponential.Out, true);
            var icon = game.add.sprite(
              100,
              100,
              'farm_tiled',
              game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['task'] + '.png',
            );
            icon.anchor.setTo(0.5);
            icon.scale.setTo(0.6);
            graphics_task.addChild(icon);
          }
        });
        dialog_finish = -1;
        if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['type'] == '1') {
          Dialog_Bubble.scale.setTo(1, 1);
          Dialog_Bubble.cameraOffset.x = game.camera.width / 2 - 350;
          if (man1.frameName != game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite']) {
            game.add
              .tween(man1)
              .to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                item.destroy(true);
              });
            let s = man1.scale.x;
            man1 = game.add.sprite(
              game.camera.width / 2 - 500,
              game.camera.height - 200,
              'char_atlas',
              game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite'],
            );
            man1.anchor.setTo(0.5, 1);
            man1.scale.setTo(s);
            popup_group.add(man1);
            man1.fixedToCamera = true;
            man1.alpha = 0;
            man1.zzz = 4;

            var man1_darck = game.add.sprite(
              0,
              0,
              'char_atlas',
              game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite'],
            );
            man1_darck.anchor.setTo(0.5, 1);
            man1_darck.tint = 0x000000;
            man1_darck.alpha = 0;
            man1.addChild(man1_darck);

            game.add.tween(man1).to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true);
            popup_group.sort('zzz', Phaser.Group.SORT_DESCENDING);
          }
          if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man1_show'] == 0) {
            game.add
              .tween(man1.cameraOffset)
              .to({ x: game.camera.width / 2 - 600 }, 300, Phaser.Easing.Exponential.Out, true);
            game.add.tween(man1).to({ angle: 0 }, 800, Phaser.Easing.Elastic.Out, true, 100);
          }
          if (
            game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite'] !=
            'postman_png_onthephone_r.png' &&
            game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite'] != 'Dog_excited_h.png'
          )
            dialog_name1.setText(game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man1_name'][0][window.lang]);
          else if (
            game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite'] ==
            'postman_png_onthephone_r.png'
          )
            dialog_name1.setText(game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man3_name'][0][window.lang]);
          else dialog_name1.setText(game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man4_name'][0][window.lang]);
          game.add.tween(name1_rect).to({ alpha: 1 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
          if (type == 2) {
            game.add.tween(name2_rect).to({ alpha: 0 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
          }
          if (man2 != 0) {
            if (type == 2 && man2.scale.x != 2.2) {
              game.add
                .tween(man2.scale)
                .to({ x: 2.2, y: 2.2 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
              man2.children[0].alpha = 0.5;
            }
          }
          if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man1_name'][0][window.lang] == 'Alice') {
            if (man1.scale.x != 2.2) {
              game.add
                .tween(man1.scale)
                .to({ x: 2.2, y: 2.2 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
              man1.children[0].alpha = 0;
            }
          } else {
            if (man1.scale.x != 2.6) {
              game.add
                .tween(man1.scale)
                .to({ x: 2.6, y: 2.6 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
              man1.children[0].alpha = 0;
            }
          }
        } else {
          Dialog_Bubble.scale.setTo(-1, 1);
          Dialog_Bubble.cameraOffset.x = game.camera.width / 2 + 350;
          if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite'] != '0') {
            if (
              man2.frameName != game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite']
            ) {
              game.add
                .tween(man2)
                .to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  item.destroy(true);
                });
              let s = man2.scale.x;
              man2 = game.add.sprite(
                game.camera.width / 2 + 500,
                game.camera.height - 200,
                'char_atlas',
                game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite'],
              );
              man2.anchor.setTo(0.5, 1);
              man2.scale.setTo(s);
              popup_group.add(man2);
              man2.fixedToCamera = true;
              man2.alpha = 0;
              man2.zzz = 4;

              var man2_darck = game.add.sprite(
                0,
                0,
                'char_atlas',
                game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['sprite'],
              );
              man2_darck.anchor.setTo(0.5, 1);
              man2_darck.tint = 0x000000;
              man2_darck.alpha = 0;
              man2.addChild(man2_darck);

              game.add.tween(man2).to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true);
              popup_group.sort('zzz', Phaser.Group.SORT_DESCENDING);
            }
            if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man2_show'] == 0) {
              game.add
                .tween(man2.cameraOffset)
                .to({ x: game.camera.width / 2 + 600 }, 300, Phaser.Easing.Exponential.Out, true);
              game.add.tween(man2).to({ angle: 0 }, 800, Phaser.Easing.Elastic.Out, true, 100);
            }
            if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['type'] == '2')
              dialog_name2.setText(game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man2_name'][0][window.lang]);
            else if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0]['type'] == '3')
              dialog_name2.setText(game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man3_name'][0][window.lang]);
            else
              dialog_name2.setText(game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man4_name'][0][window.lang]);
            game.add.tween(name2_rect).to({ alpha: 1 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
            if (type == 2) {
              game.add.tween(name1_rect).to({ alpha: 0 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
            }
            if (game.cache.getJSON('dialog')['dialog' + gialog_n][0]['man1_name'][0][window.lang] == 'Alice') {
              if (man1.scale.x != 1.9) {
                game.add
                  .tween(man1.scale)
                  .to({ x: 1.9, y: 1.9 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
                man1.children[0].alpha = 0.5;
              }
            } else {
              if (man1.scale.x != 2.2) {
                game.add
                  .tween(man1.scale)
                  .to({ x: 2.2, y: 2.2 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
                man1.children[0].alpha = 0.5;
              }
            }
            if (type == 2 && man2.scale.x != 2.6) {
              game.add
                .tween(man2.scale)
                .to({ x: 2.6, y: 2.6 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 100);
              man2.children[0].alpha = 0;
            }
          }
        }

        if (text_n == 2 && gialog_n == 288) {
          game.add.tween(Tube_2_Papers).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
            item.destroy();
          });
          Tube_2_Papers = 0;
        } else
          if (text_n == 1 && gialog_n == 288) {
            game.add.tween(Testament).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
              item.destroy();
            });
            Testament = 0;
          } else
            if (text_n == 4 && gialog_n == 260) {
              animation = 1;
              var shine = game.add.sprite(game.camera.width / 2, game.camera.height / 2 - 200, 'game_ui_atlas', 'Shine.png');
              shine.anchor.setTo(0.5, 0.52);
              shine.scale.setTo(0);
              shine.alpha = 0.3;
              shine.fixedToCamera = true;
              game.add.tween(shine.scale).to({ x: 2, y: 2 }, 1000, Phaser.Easing.Exponential.Out, true);
              rotate_tween(shine);
              Xmas_Rod = game.add.sprite(
                230,
                -250,
                'xmas_atlas',
                'Xmas_Rod.png',
              );
              Xmas_Rod.scale.setTo(0);
              Xmas_Rod.anchor.setTo(0.5);
              man1.addChild(Xmas_Rod);

              game.add.tween(Xmas_Rod.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 500).onComplete.add(function () {
                game.add.tween(Xmas_Rod.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Linear.None, true, 500);
                game.add.tween(Xmas_Rod).to({ angle: 720 }, 1000, Phaser.Easing.Linear.None, true, 500);
                game.add.tween(shine).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 500);
                game.add.tween(Xmas_Rod).to({ x: 20, y: -100 }, 1000, Phaser.Easing.Linear.None, true, 500).onComplete.add(function (item) {

                  animation = 0;

                });
              });
            } else
              if (text_n == 5 && gialog_n == 260) {
                animation = 1;

                game.add.tween(Xmas_Rod).to({ x: 350, y: -220 }, 1000, Phaser.Easing.Cubic.In, true, 500);
                game.add.tween(Xmas_Rod.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 500)
                game.add.tween(Xmas_Rod).to({ angle: 720 }, 1000, Phaser.Easing.Cubic.In, true, 500).onComplete.add(function () {

                  game.add.tween(Xmas_Rod).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 500);

                  var emitter_smoke_h = game.add.emitter(0, 0, 50);
                  emitter_smoke_h.makeParticles('game_atlas', 'smoke.png');
                  emitter_smoke_h.bringToTop = true;
                  emitter_smoke_h.setRotation(0, 360, 500);
                  emitter_smoke_h.setAlpha(1, 0, 500);
                  emitter_smoke_h.setScale(0.1, 1, 0.1, 1, 500);
                  emitter_smoke_h.gravity = 0;
                  emitter_smoke_h.explode = true;
                  emitter_smoke_h.blendMode = 1;
                  emitter_smoke_h.minParticleSpeed.set(-500, -500);
                  emitter_smoke_h.maxParticleSpeed.set(500, 500);
                  emitter_smoke_h.x = Xmas_Rod.world.x + 50;
                  emitter_smoke_h.y = Xmas_Rod.world.y - 100;
                  emitter_smoke_h.start(true, 200, 0, 6);

                  game.add
                    .tween(man2.scale)
                    .to({ x: -2.6, y: 2.6 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 600);
                  game.add
                    .tween(man2.cameraOffset)
                    .to({ x: '+1000' }, 1000, Phaser.Easing.Cubic.Out, true, 1500)
                    .onComplete.add(function (item) {
                      man2.visible = false;
                      man2.cameraOffset.x -= 1000;
                      animation = 0;
                    });

                });
              } else
                if (text_n == 7 && gialog_n == 212) {
                  animation = 1;
                  game.add
                    .tween(man2.scale)
                    .to({ x: -2.6, y: 2.6 }, 300, Phaser.Easing.Exponential.Out, true, pause / 2 + 600);
                  game.add
                    .tween(man2.cameraOffset)
                    .to({ x: '+1000' }, 1000, Phaser.Easing.Cubic.Out, true, 1500)
                    .onComplete.add(function (item) {
                      man2.visible = false;
                      man2.cameraOffset.x -= 1000;
                      animation = 0;
                    });
                }
                else
                  if (text_n == 9 && gialog_n == 212) {
                    man2.visible = true;
                  }
        text_color = game.cache.getJSON('dialog')['dialog' + gialog_n][0]['message' + text_n][0][window.lang];
        dialog_text = game.add.text(360, game.camera.height - 230, text_color, {
          font: '38px RussoOne',
          fill: '#C27E54',
          align: 'left',
          wordWrap: true,
          wordWrapWidth: 1300,
        });
        dialog_text.anchor.setTo(0);
        popup_group.add(dialog_text);
        dialog_text.fixedToCamera = true;
        var color = text_color.match(/([^\]\[]+)(?=\])/g);
        if (color != null)
          for (var i = 0; i < color.length; i += 2) {
            dialog_text.addColor(color[i], text_color.indexOf('[' + color[i] + ']'));
            dialog_text.addColor('#C27E54', text_color.indexOf('[' + color[i + 1] + ']') - 9);
            text_color = text_color.replace('[' + color[i] + ']', '');
            text_color = text_color.replace('[/]', '');
          }
        var new_text = '';
        var i = 0;
        dialog_text.setText(new_text);
        dialog_time = 1;
        game.time.events.add(pause / 2, function () {
          game.time.events.repeat(100, text_color.length / 5, function () {
            if (dialog_finish != 1 && dialog_time != 0) {
              if (sound_on == 1) {
                play_sound('Dialog_text_appears');
              }
            }
          });
        });
        game.time.events.add(
          pause,
          function () {
            dialog_finish = 0;
            dialog_time = game.time.events.repeat(
              20,
              text_color.length,
              function () {
                new_text += text_color[i];
                i++;
                dialog_text.setText(new_text);
                if (i == text_color.length - 1) {
                  dialog_finish = 1;
                }
              },
              this,
            );
          },
          this,
        );
      }
    }
    function letter(t, c) {
      if (popup == 0 && missions_tab_open == 0) {
        popup_group.y = 0;
        popup_group.y += game.camera.height;
        popup = 1;
        blackf();
        var Hand_Paper = game.add.sprite(
          game.camera.width / 2 + 130,
          game.camera.height,
          'game_window2_atlas',
          'Hand_Paper.png',
        );
        Hand_Paper.scale.setTo(2.5);
        Hand_Paper.anchor.setTo(0.5, 1);
        Hand_Paper.fixedToCamera = true;
        popup_group.add(Hand_Paper);
        if (c != 750) {
          var Picture = game.add.sprite(
            game.camera.width / 2 + 280,
            game.camera.height / 2 - 380,
            'game_window2_atlas',
            'Picture.png',
          );
          Picture.scale.setTo(1);
          Picture.anchor.setTo(0.5);
          Picture.fixedToCamera = true;
          popup_group.add(Picture);
          var Picture = game.add.sprite(
            game.camera.width / 2 + 80,
            game.camera.height / 2 + 220,
            'game_window2_atlas',
            'Signature.png',
          );
          Picture.scale.setTo(0.9);
          Picture.anchor.setTo(0.5);
          Picture.fixedToCamera = true;
          popup_group.add(Picture);
        } else {
          var Picture = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 - 60,
            'photo_atlas',
            'Winner_Letter.png',
          );
          Picture.scale.setTo(2);
          Picture.anchor.setTo(0.5);
          Picture.fixedToCamera = true;
          popup_group.add(Picture);
        }
        var letter_text = game.add.text(game.camera.width / 2, game.camera.height / 2 - 300, t, {
          font: '28px RussoOne',
          fill: '#8D3A32',
          align: 'left',
          wordWrap: true,
          wordWrapWidth: 600,
        });
        letter_text.anchor.setTo(0.5, 0);
        letter_text.angle -= 2;
        letter_text.lineSpacing = -8;
        letter_text.addFontStyle('italic', 0);
        letter_text.stroke = '#fff';
        letter_text.strokeThickness = 4;
        popup_group.add(letter_text);
        letter_text.fixedToCamera = true;
        var button_green = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 320,
          'game_atlas',
          'button_green.png',
        );
        button_green.anchor.setTo(0.5);
        button_green.scale.setTo(0.75);
        button_green.inputEnabled = true;
        button_green.scl = 0.75;
        button_green.events.onInputOver.add(btnover, this);
        button_green.events.onInputOut.add(btnout, this);
        button_green.events.onInputDown.add(btnclick, this);
        button_green.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup != 2) {
            popup = 2;
            if (c > 0) {
              coins += c;
              game.setCurrentEvent();
              window.eventTrack('coins_in', c, {
                user_type: bought,
                lifetime: lifetime_day,
                highest_lvl: all_level.lastIndexOf(3) + 2,
                amount: c,
                source: 'Get letter',
                package_id: 0,
                mission_completed: missioncompleted,
                c_event: current_event,
              });

              // save collected coins
              game.setUserDataAndLog({ currencies: coins });

              var coins_text = coins - c;
              text_coins_panel.setText(coins_text);
              var var_coins = 0;
              if (sound_on == 1) {
                play_sound('coins_add');
              }
              game.time.events.repeat(
                100,
                10,
                function () {
                  var get_coin = game.add.sprite(
                    item.x + game.rnd.integerInRange(-50, 50),
                    item.y + game.rnd.integerInRange(-50, 50),
                    'game_atlas',
                    'icon_coins.png',
                  );
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0);
                  get_coin.alpha = 0;
                  effects_group.add(get_coin);
                  game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(get_coin)
                    .to(
                      { x: text_coins_panel.world.x, y: text_coins_panel.world.y },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    )
                    .onComplete.add(function (item) {
                      item.destroy();
                      var_coins += c / 10;
                      text_coins_panel.setText(Math.ceil(coins_text + var_coins));
                    });
                },
                this,
              );
            }
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                taks_indicator();
                popup_group.removeAll(true);
                popup_group.y -= game.camera.height;
                game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                  popup = 0;
                  animation = 0;
                  if (c == 750) dialog_window(180, 0);
                  else dialog_window(30, 0);
                  /*objects_group.children.forEach(function (child_item) {
                    if (child_item.type == 16 || child_item.type == -16) {
                      child_item.children[0].angle += 80;
                      return true;
                    }
                  });*/
                });
              });
          }
        });
        popup_group.add(button_green);
        button_green.fixedToCamera = true;
        if (c > 0)
          var button_green_text = game.add.text(0, 0, game.cache.getJSON('lang')['Claim'][0][window.lang], {
            font: '40px RussoOne',
            fill: '#fff',
            align: 'center',
          });
        else
          var button_green_text = game.add.text(0, 0, 'Ok', { font: '40px RussoOne', fill: '#fff', align: 'center' });
        button_green_text.anchor.setTo(0.5);
        button_green_text.stroke = '#47740D';
        button_green_text.strokeThickness = 4;
        button_green_text.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
        button_green.addChild(button_green_text);
        game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
      }
    }
    function mydayx(t) {
      let width = 0;
      let mas = [];
      for (var i = 0; i < t.length; i++) {
        if (t[i] == ' ' || t[i] == '0') {
          width += 100;
        } else {
          var l = game.add.sprite(
            game.camera.width / 2 + width,
            game.camera.height / 2 - 80,
            'game_ui_atlas',
            t[i] + '.png',
          );
          l.scale.setTo(2);
          l.anchor.setTo(0, 0.5);
          width += l.width;
          l.fixedToCamera = true;
          mas.push(l);
        }
      }
      for (var i = 0; i < mas.length; i++) {
        mas[i].cameraOffset.x -= width / 2;
        mas[i].xxx = mas[i].cameraOffset.x;
        mas[i].yyy = mas[i].cameraOffset.y;
        mas[i].cameraOffset.x = game.rnd.integerInRange(0, game.camera.width);
        mas[i].cameraOffset.y = game.rnd.integerInRange(0, game.camera.height);
        mas[i].scale.setTo(0);
        game.add.tween(mas[i].scale).to({ x: 2, y: 2 }, 600, Phaser.Easing.Quadratic.Out, true);
        game.add
          .tween(mas[i].cameraOffset)
          .to({ x: mas[i].xxx, y: mas[i].yyy }, 1200, Phaser.Easing.Exponential.Out, true);
        game.add
          .tween(mas[i])
          .to({ alpha: 0 }, 600, Phaser.Easing.Linear.None, true, 1500)
          .onComplete.add(function (item) {
            item.destroy();
          });
      }
    }
    window.arc_text = function (txt, size, h, a, xxx, yyy, sss, fix, par, effetc, space, group) {
      let width = 0;
      let mas_h = [];
      let mas_a = [];
      let mas = [];
      let hhh = -h;
      let aaa = -a;
      if (txt.length % 2 == 0) {
        for (var i = 0; i < Math.floor(txt.length / 2); i++) {
          mas_h.push(hhh);
          mas_a.push(aaa);
          hhh += h / (txt.length / 2);
          aaa += a / (txt.length / 2);
        }
        for (var i = Math.ceil(txt.length / 2); i < txt.length; i++) {
          hhh += h / (txt.length / 2);
          aaa += a / (txt.length / 2);
          mas_h.push(-hhh);
          mas_a.push(aaa);
        }
      } else {
        for (var i = 0; i < Math.floor(txt.length / 2); i++) {
          mas_h.push(hhh);
          mas_a.push(aaa);
          hhh += h / (txt.length / 2);
          aaa += a / (txt.length / 2);
        }
        for (var i = Math.ceil(txt.length / 2); i <= txt.length; i++) {
          hhh += h / (txt.length / 2);
          aaa += a / (txt.length / 2);
          mas_h.push(-hhh);
          mas_a.push(aaa);
        }
      }
      for (var i = 0; i < txt.length; i++) {
        if (txt[i] == ' ') {
          width += space;
        } else {
          var message_text_c = game.add.text(xxx + width, yyy - mas_h[i], txt[i], {
            font: size + ' RussoOne',
            fill: '#904821',
            align: 'center',
          });
          message_text_c.anchor.setTo(0.5);
          message_text_c.angle = mas_a[i];
          message_text_c.setShadow(0, 5, 'rgba(0,0,0,0.5)', 10);
          if (fix) {
            message_text_c.fixedToCamera = true;
          }
          var message_text2 = game.add.text(0, sss, txt[i], {
            font: size + ' RussoOne',
            fill: '#fff',
            align: 'center',
          });
          var grd = message_text2.context.createLinearGradient(
            message_text2.width / 2,
            0,
            message_text2.width / 2,
            message_text2.height,
          );
          grd.addColorStop(0, '#FFEDC1');
          grd.addColorStop(0.5, '#FFEDC1');
          grd.addColorStop(0.5, '#FFD164');
          grd.addColorStop(1, '#FFD164');
          message_text2.fill = grd;
          message_text2.anchor.setTo(0.5);
          message_text2.stroke = '#FFFF7D';
          message_text2.strokeThickness = 2;
          message_text_c.addChild(message_text2);
          if (fix) {
            message_text_c.cameraOffset.x += message_text_c.width / 2;
          } else {
            message_text_c.x += message_text_c.width / 2;
          }
          width += message_text_c.width;
          mas.push(message_text_c);
          if (group != 0) {
            popup_group.add(message_text_c);
          }
          if (par != 0) {
            par.addChild(message_text_c);
          }
        }
      }
      for (var i = 0; i < mas.length; i++) {
        if (fix) {
          mas[i].cameraOffset.x -= width / 2;
        } else {
          mas[i].x -= width / 2;
        }
        if (effetc == 1) {
          mas[i].xxx = mas[i].cameraOffset.x;
          mas[i].yyy = mas[i].cameraOffset.y;
          mas[i].cameraOffset.x = game.rnd.integerInRange(0, game.camera.width);
          mas[i].cameraOffset.y = game.rnd.integerInRange(0, game.camera.height);
          mas[i].scale.setTo(0);
          game.add.tween(mas[i].scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Quadratic.Out, true);
          game.add
            .tween(mas[i].cameraOffset)
            .to({ x: mas[i].xxx, y: mas[i].yyy }, 1200, Phaser.Easing.Exponential.Out, true);
          game.add
            .tween(mas[i])
            .to({ alpha: 0 }, 600, Phaser.Easing.Linear.None, true, 1500)
            .onComplete.add(function (item) {
              item.destroy();
            });
        }
      }
    };
    // if (fbv == 1) {
    //   game.load.image('c_user_avatar', FBInstant.player.getPhoto(), 1);
    // }
    game.load.start();
    function transition_xmas(t) {
      window.eventTrack('xmas_share_' + Number(t - 204) + '_shown');
      var txt = game.cache.getJSON('lang')['t546'][0][window.lang];
      if (t == 246) { txt = game.cache.getJSON('lang')['t547'][0][window.lang]; } else
        if (t == 248) { txt = game.cache.getJSON('lang')['t548'][0][window.lang]; } else
          if (t == 251) { txt = game.cache.getJSON('lang')['t549'][0][window.lang]; } else
            if (t == 254) { txt = game.cache.getJSON('lang')['t550'][0][window.lang]; } else
              if (t == 255) { txt = game.cache.getJSON('lang')['t551'][0][window.lang]; } else
                if (t == 257) { txt = game.cache.getJSON('lang')['t552'][0][window.lang]; } else
                  if (t == 260) { txt = game.cache.getJSON('lang')['t553'][0][window.lang]; }
      popup_group.y = 0;
      animation = 1;
      popup = 1;
      if (sound_on == 1) {
        play_sound('share_moment');
      }
      blackf();
      var popup_close = game.add.sprite(
        game.camera.width - 100,
        100,
        'game_window_atlas',
        'Close_Button.png',
      );
      popup_close.anchor.setTo(0.5);
      button_animation_f(popup_close, 1);
      popup_close.fixedToCamera = true;
      popup_close.events.onInputUp.add(function () {
        if (popup != 2) {
          popup = 2;
          if (sound_on == 1) {
            play_sound('button_X');
          }
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item) {
              item.destroy();
            });
          game.add
            .tween(popup_group)
            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function (item) {
              popup_group.removeAll(true);
              popup = 0;
              animation = 0;
              popup_group.y -= game.camera.height;
              black_sprite.destroy();
              popup_group.removeAll(true);
            });
        }
      }, this);
      popup_group.add(popup_close);
      var background_share_img = game.add.bitmapData(game.camera.width, game.camera.height);
      background_share_img.copy(
        game.canvas,
        game.camera.width / 2 - 370,
        game.camera.height / 2 - 370,
        740,
        740,
        0,
        0,
        null,
        null,
        0,
        0,
        0,
        1,
        1,
        1,
        null,
        0,
      );
      var background_share = game.add.sprite(
        game.camera.width / 2,
        game.camera.height / 2 - 80,
        background_share_img,
      );
      background_share.anchor.setTo(0);
      background_share.x -= 370;
      background_share.y -= 370;
      background_share.fixedToCamera = true;
      popup_group.add(background_share);
      var user_avatar = game.add.image(
        game.camera.width / 2 + 190,
        game.camera.height / 2 - 16,
        'game_atlas',
        'no_avatar.png',
      );
      user_avatar.anchor.setTo(0.5);
      user_avatar.width = user_avatar.height = 190;
      user_avatar.angle = 9;
      user_avatar.fixedToCamera = true;
      popup_group.add(user_avatar);
      if (game.cache.checkImageKey('c_user_avatar') == true) {
        user_avatar.loadTexture('c_user_avatar');
        user_avatar.width = user_avatar.height = 190;
      }
      var Frame2 = game.add.sprite(
        game.camera.width / 2,
        game.camera.height / 2 - 60,
        'xmas_atlas',
        'Frame2.png',
      );
      Frame2.anchor.setTo(0.5);
      Frame2.scale.setTo(2);
      Frame2.fixedToCamera = true;
      popup_group.add(Frame2);
      var result_text = game.add.text(game.camera.width / 2, game.camera.height / 2 + 224, txt, {
        font: '30px RussoOne',
        fill: '#8C3B32',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 700,
      });
      result_text.anchor.setTo(0.5);
      result_text.fixedToCamera = true;
      popup_group.add(result_text);
      result_text.lineSpacing = -10;
      var button_green = game.add.sprite(
        game.camera.width / 2,
        game.camera.height / 2 + 410,
        'game_window_atlas',
        'Green_Button.png',
      );
      button_green.anchor.setTo(0.5);
      button_green.scale.setTo(1);
      button_green.txt = txt;
      button_green.inputEnabled = true;
      button_green.events.onInputUp.add(function (item) {
        if (popup != 2) {
          window.eventTrack('xmas_share_' + Number(t - 204) + '_clicked');
          popup = 2;
          let group = game.add.group();
          group.y = -200;
          var message_invite = game.add.sprite(580, 320, background_share_img);
          message_invite.scale.setTo(0.6);
          message_invite.anchor.setTo(0.5);
          group.add(message_invite);
          var user_avatar = game.add.image(340, 200 + 65, 'game_atlas', 'no_avatar.png');
          user_avatar.anchor.setTo(0.5);
          user_avatar.width = user_avatar.height = 116;
          user_avatar.angle = 9;
          group.add(user_avatar);
          var Frame2 = game.add.sprite(-30, -20, 'xmas_atlas', 'Frame2.png');
          Frame2.anchor.setTo(0);
          Frame2.scale.setTo(1.2);
          group.add(Frame2);
          if (game.cache.checkImageKey('c_user_avatar') == true) {
            user_avatar.loadTexture('c_user_avatar');
            user_avatar.width = user_avatar.height = 116;
          }
          var result_text = game.add.text(225, 405, item.txt, {
            font: '20px RussoOne',
            fill: '#8C3B32',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 450,
          });
          result_text.anchor.setTo(0.5);
          group.add(result_text);
          result_text.lineSpacing = -10;
          group.inputEnabled = false;
          group.y = 0;
          let group2 = game.add.group();
          group2.addChild(group);
          var renderTexture = game.make.renderTexture(450, 450);
          renderTexture.render(group2);
          group2.destroy();
          loading();

          console.log("%cRemoved share async called!", "color:orange");
          window.eventTrack('xmas_share_' + Number(t - 204) + '_success');
          popup = 0;
          animation = 0;
          black_sprite.destroy();
          popup_group.removeAll(true);
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }

          // shareAsync(
          //   {
          //     intent: 'SHARE',
          //     image: renderTexture.getBase64(),
          //     text: item.txt,
          //     data: {},
          //   },
          //   {
          //     actionLevel: null,
          //     targetUserID: null,
          //     socialActionType: DdnaSocialActionType.ShareDayEnd,
          //     socialRewardType: DdnaSocialRewardType.No,
          //   },
          // )
          //   .then(function () {
          //     window.eventTrack('xmas_share_' + Number(t - 204) + '_success');
          //     popup = 0;
          //     animation = 0;
          //     black_sprite.destroy();
          //     popup_group.removeAll(true);
          //     if (loading_black_sprite != 0) {
          //       loading_black_sprite.destroy();
          //       loading_black_sprite = 0;
          //     }
          //     if (loading_text != 0 && loading_text != 1) {
          //       loading_text.destroy();
          //       loading_text = 0;
          //     }
          //   })
          //   .catch(function (error) {
          //     window.eventTrack('xmas_share_' + Number(t - 204) + '_fail');
          //     popup = 0;
          //     animation = 0;
          //     black_sprite.destroy();
          //     popup_group.removeAll(true);
          //     if (loading_black_sprite != 0) {
          //       loading_black_sprite.destroy();
          //       loading_black_sprite = 0;
          //     }
          //     if (loading_text != 0 && loading_text != 1) {
          //       loading_text.destroy();
          //       loading_text = 0;
          //     }
          //   });
        }
      });
      button_green.fixedToCamera = true;
      popup_group.add(button_green);
      var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t259'][0][window.lang], {
        font: '48px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      text_button_green.anchor.setTo(0.5);
      text_button_green.stroke = '#47740D';
      text_button_green.strokeThickness = 4;
      text_button_green.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
      button_green.addChild(text_button_green);
      button_green.input.useHandCursor = true;
      scale_tween(button_green, 500, 0.1, 0.1);
    }

    function transition(t) {
      var dog_bone = 0;
      popup_group.y = 0;
      animation = 1;
      popup = 1;
      if (map_n > 1 && fbv == 1) {
        var txt = game.cache.getJSON('lang')['t289'][0][window.lang];
        var xxx = 1300;
        var yyy = 1190;
        if (map_n == 3) {
          txt = game.cache.getJSON('lang')['t290'][0][window.lang];
          xxx = 2380;
          yyy = 950;
        } else if (map_n == 4) {
          txt = game.cache.getJSON('lang')['t291'][0][window.lang];
          xxx = 2380;
          yyy = 950;
        } else if (map_n == 5) {
          txt = game.cache.getJSON('lang')['t292'][0][window.lang];
          xxx = 2100;
          yyy = 1100;
        } else if (map_n == 6) {
          txt = game.cache.getJSON('lang')['t293'][0][window.lang];
          xxx = 1650;
          yyy = 1380;
        } else if (map_n == 7) {
          txt = game.cache.getJSON('lang')['t294'][0][window.lang];
          xxx = 1050;
          yyy = 1650;
        } else if (map_n == 8) {
          txt = game.cache.getJSON('lang')['t295'][0][window.lang];
          xxx = 1050;
          yyy = 1650;
        } else if (map_n == 9) {
          txt = game.cache.getJSON('lang')['t296'][0][window.lang];
          xxx = 980;
          yyy = 1300;
        } else if (map_n == 10) {
          txt = game.cache.getJSON('lang')['t296'][0][window.lang];
          xxx = 1200;
          yyy = 900;
        } else if (map_n == 11) {
          txt = game.cache.getJSON('lang')['t378'][0][window.lang];
          xxx = 2490;
          yyy = 1360;
        } else if (map_n == 12) {
          txt = game.cache.getJSON('lang')['t378'][0][window.lang];
          xxx = 3250;
          yyy = 1430;
        } else if (map_n == 13) {
          txt = game.cache.getJSON('lang')['t446'][0][window.lang];
          xxx = 3200;
          yyy = 1730;
        } else if (map_n == 14) {
          txt = game.cache.getJSON('lang')['t461'][0][window.lang];
          xxx = 2980;
          yyy = 1240;
        } else if (map_n == 15) {
          txt = game.cache.getJSON('lang')['t462'][0][window.lang];
          xxx = 2980;
          yyy = 1240;
        } else if (map_n == 16) {
          txt = game.cache.getJSON('lang')['t491'][0][window.lang];
          xxx = 2700;
          yyy = 2100;
        } else if (map_n == 17) {
          txt = game.cache.getJSON('lang')['t545'][0][window.lang];
          xxx = 2460;
          yyy = 2120;
        } else if (map_n == 18) {
          txt = game.cache.getJSON('lang')['t589'][0][window.lang];
          xxx = 2950;
          yyy = 1740;
        }
        game.add
          .tween(follow)
          .to({ x: xxx * worldScale, y: yyy * worldScale }, 2000, Phaser.Easing.Linear.None, true, 500)
          .onComplete.add(function () {
            if (map_n == 14) {
              dog_bone = game.add.sprite(
                xxx * worldScale - 100 * worldScale,
                yyy * worldScale,
                'char_atlas',
                'Dog_withabone2.png',
              );
              dog_bone.anchor.setTo(0.5);
              dog_bone.scale.setTo(2);
            }
            game.add
              .tween(follow)
              .to({ x: xxx * worldScale, y: yyy * worldScale }, 10, Phaser.Easing.Linear.None, true)
              .onComplete.add(function () {
                if (sound_on == 1) {
                  play_sound('share_moment');
                }
                blackf();
                var popup_close = game.add.sprite(
                  game.camera.width - 100,
                  100,
                  'game_window_atlas',
                  'Close_Button.png',
                );
                popup_close.anchor.setTo(0.5);
                button_animation_f(popup_close, 1);
                popup_close.fixedToCamera = true;
                popup_close.events.onInputUp.add(function () {
                  if (popup != 2) {
                    popup = 2;
                    if (sound_on == 1) {
                      play_sound('button_X');
                    }
                    game.add
                      .tween(black_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(popup_group)
                      .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                      .onComplete.add(function (item) {
                        if (map_n == 10) {
                          follow.x = 2400 * worldScale;
                          follow.y = 1000 * worldScale;
                        }
                        popup_group.removeAll(true);
                        popup = 0;
                        popup_group.y -= game.camera.height;
                        black_sprite.destroy();
                        popup_group.removeAll(true);
                        trans(0.5);
                      });
                  }
                }, this);
                popup_group.add(popup_close);
                var background_share_img = game.add.bitmapData(game.camera.width, game.camera.height);
                background_share_img.copy(
                  game.canvas,
                  game.camera.width / 2 - 370,
                  game.camera.height / 2 - 370,
                  740,
                  740,
                  0,
                  0,
                  null,
                  null,
                  0,
                  0,
                  0,
                  1,
                  1,
                  1,
                  null,
                  0,
                );
                if (dog_bone != 0) {
                  dog_bone.destroy();
                }
                var background_share = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 - 80,
                  background_share_img,
                );
                background_share.anchor.setTo(0);
                background_share.x -= 370;
                background_share.y -= 370;
                background_share.fixedToCamera = true;
                popup_group.add(background_share);
                var user_avatar = game.add.image(
                  game.camera.width / 2 + 190,
                  game.camera.height / 2 - 16,
                  'game_atlas',
                  'no_avatar.png',
                );
                user_avatar.anchor.setTo(0.5);
                user_avatar.width = user_avatar.height = 190;
                user_avatar.angle = 9;
                user_avatar.fixedToCamera = true;
                popup_group.add(user_avatar);
                if (game.cache.checkImageKey('c_user_avatar') == true) {
                  user_avatar.loadTexture('c_user_avatar');
                  user_avatar.width = user_avatar.height = 190;
                }
                var Frame2 = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 - 60,
                  'game_window2_atlas',
                  'Frame2.png',
                );
                Frame2.anchor.setTo(0.5);
                Frame2.scale.setTo(2);
                Frame2.fixedToCamera = true;
                popup_group.add(Frame2);
                var result_text = game.add.text(game.camera.width / 2, game.camera.height / 2 + 224, txt, {
                  font: '30px RussoOne',
                  fill: '#8C3B32',
                  align: 'center',
                  wordWrap: true,
                  wordWrapWidth: 700,
                });
                result_text.anchor.setTo(0.5);
                result_text.fixedToCamera = true;
                popup_group.add(result_text);
                result_text.lineSpacing = -10;
                var button_green = game.add.sprite(
                  game.camera.width / 2,
                  game.camera.height / 2 + 410,
                  'game_window_atlas',
                  'Green_Button.png',
                );
                button_green.anchor.setTo(0.5);
                button_green.scale.setTo(1);
                button_green.txt = txt;
                button_green.inputEnabled = true;
                button_green.events.onInputUp.add(function (item) {
                  if (popup != 2) {
                    popup = 2;
                    let group = game.add.group();
                    group.y = -200;
                    var message_invite = game.add.sprite(580, 320, background_share_img);
                    message_invite.scale.setTo(0.6);
                    message_invite.anchor.setTo(0.5);
                    group.add(message_invite);
                    var user_avatar = game.add.image(340, 200 + 65, 'game_atlas', 'no_avatar.png');
                    user_avatar.anchor.setTo(0.5);
                    user_avatar.width = user_avatar.height = 116;
                    user_avatar.angle = 9;
                    group.add(user_avatar);
                    var Frame2 = game.add.sprite(-30, -20, 'game_window2_atlas', 'Frame2.png');
                    Frame2.anchor.setTo(0);
                    Frame2.scale.setTo(1.2);
                    group.add(Frame2);
                    if (game.cache.checkImageKey('c_user_avatar') == true) {
                      user_avatar.loadTexture('c_user_avatar');
                      user_avatar.width = user_avatar.height = 116;
                    }
                    var result_text = game.add.text(225, 405, item.txt, {
                      font: '20px RussoOne',
                      fill: '#8C3B32',
                      align: 'center',
                      wordWrap: true,
                      wordWrapWidth: 450,
                    });
                    result_text.anchor.setTo(0.5);
                    group.add(result_text);
                    result_text.lineSpacing = -10;
                    group.inputEnabled = false;
                    group.y = 0;
                    let group2 = game.add.group();
                    group2.addChild(group);
                    var renderTexture = game.make.renderTexture(450, 450);
                    renderTexture.render(group2);
                    group2.destroy();
                    loading();

                    console.log("%cRemoved share async called!", "color:orange");

                    if (map_n == 10) {
                      follow.x = 2400 * worldScale;
                      follow.y = 1000 * worldScale;
                    }
                    popup = 2;
                    black_sprite.destroy();
                    popup_group.removeAll(true);
                    trans(0.5);
                    if (loading_black_sprite != 0) {
                      loading_black_sprite.destroy();
                      loading_black_sprite = 0;
                    }
                    if (loading_text != 0 && loading_text != 1) {
                      loading_text.destroy();
                      loading_text = 0;
                    }
                    // shareAsync(
                    //   {
                    //     intent: 'SHARE',
                    //     image: renderTexture.getBase64(),
                    //     text: item.txt,
                    //     data: {},
                    //   },
                    //   {
                    //     actionLevel: null,
                    //     targetUserID: null,
                    //     socialActionType: DdnaSocialActionType.ShareDayEnd,
                    //     socialRewardType: DdnaSocialRewardType.No,
                    //   },
                    // )
                    //   .then(function () {
                    //     if (map_n == 10) {
                    //       follow.x = 2400 * worldScale;
                    //       follow.y = 1000 * worldScale;
                    //     }
                    //     popup = 2;
                    //     black_sprite.destroy();
                    //     popup_group.removeAll(true);
                    //     trans(0.5);
                    //     if (loading_black_sprite != 0) {
                    //       loading_black_sprite.destroy();
                    //       loading_black_sprite = 0;
                    //     }
                    //     if (loading_text != 0 && loading_text != 1) {
                    //       loading_text.destroy();
                    //       loading_text = 0;
                    //     }
                    //   })
                    //   .catch(function (error) {
                    //     if (map_n == 10) {
                    //       follow.x = 2400 * worldScale;
                    //       follow.y = 1000 * worldScale;
                    //     }
                    //     popup = 2;
                    //     black_sprite.destroy();
                    //     popup_group.removeAll(true);
                    //     trans(0.5);
                    //     if (loading_black_sprite != 0) {
                    //       loading_black_sprite.destroy();
                    //       loading_black_sprite = 0;
                    //     }
                    //     if (loading_text != 0 && loading_text != 1) {
                    //       loading_text.destroy();
                    //       loading_text = 0;
                    //     }
                    //   });


                  }
                });
                button_green.fixedToCamera = true;
                popup_group.add(button_green);
                var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t259'][0][window.lang], {
                  font: '48px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
                text_button_green.anchor.setTo(0.5);
                text_button_green.stroke = '#47740D';
                text_button_green.strokeThickness = 4;
                text_button_green.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
                button_green.addChild(text_button_green);
                button_green.input.useHandCursor = true;
                scale_tween(button_green, 500, 0.1, 0.1);
              });
          });
      } else {
        trans(0);
      }
      function trans(a) {
        game.add.tween(effects_group).to({ alpha: 1 }, 200, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          var mask = game.add.graphics(game.camera.width / 2, game.camera.height / 2);
          mask.beginFill(0xffffff);
          mask.drawCircle(0, 0, 2300);
          mask.fixedToCamera = true;
          black_sprite = game.add.sprite(0, 0, 'message_invite_mask');
          black_sprite.alpha = 1;
          black_sprite.width = game.camera.width;
          black_sprite.height = game.camera.height;
          black_sprite.fixedToCamera = true;
          var bmd = game.add.bitmapData(game.camera.width, game.camera.height);
          bmd.copy(game.canvas, 0, 0, game.camera.width, game.camera.height, 0, 0, null, null, 0, 0, 0);
          var ssssssss = game.add.sprite(0, 0, bmd);
          ssssssss.scale.setTo(1);
          ssssssss.mask = mask;
          ssssssss.fixedToCamera = true;
          game.add.tween(mask.scale).to({ x: 0.0001, y: 0.0001 }, 1000, Phaser.Easing.Linear.None, true);
          game.add
            .tween(black_sprite)
            .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true)
            .onComplete.add(function () {
              game.add
                .tween(transition_text)
                .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  game.add
                    .tween(transition_text)
                    .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 2000)
                    .onComplete.add(function () {
                      if (sound_on == 1) {
                        play_sound('new_day_jingle');
                      }
                      game.add
                        .tween(mask.scale)
                        .to({ x: 1, y: 1 }, 1000, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          ssssssss.destroy();
                          black_sprite.destroy();
                          mask.destroy();
                          if (button_setting != 0) {
                            button_setting.destroy();
                          }
                          if (wheel_icon != 0) {
                            wheel_icon.destroy();
                          }
                          if (friends_icon != 0) {
                            friends_icon.destroy();
                          }
                          UI_right_create();
                          game.world.bringToTop(UI_right_group);
                          arc_text(
                            game.cache.getJSON('lang')['t393'][0][window.lang] + ' ' + map_n + '!',
                            '250px',
                            0,
                            0,
                            game.camera.width / 2,
                            game.camera.height / 2,
                            -10,
                            1,
                            0,
                            1,
                            100,
                            0,
                          );
                          game.add.tween(effects_group).to({ alpha: 1 }, 2200, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                            if (fbv == 1) {
                              game.setCurrentEvent();
                              window.eventTrack('game_day', 1, {
                                game_day: map_n,
                                user_type: bought,
                                lifetime: lifetime_day,
                                highest_lvl: all_level.lastIndexOf(3) + 2,
                                mission_completed: missioncompleted,
                                current_level: level_button.n,
                                conversion: 1 - bought,
                                c_event: current_event,
                              });
                            }
                            popup = 0;
                            animation = 0;
                            if (map_n == 2) {
                              dialog_window(22, 0);
                            } else if (map_n == 3) {
                              dialog_window(23, 0);
                            } else if (map_n == 4) {
                              dialog_window(24, 0);
                              /*objects_group.children.forEach(function (child_item) {
                                if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                  return true;
                                }
                              });*/
                            } else if (map_n == 5) {
                              dialog_window(31, 0);
                              /*objects_group.children.forEach(function (child_item) {
                                if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                  return true;
                                }
                              });*/
                            } else if (map_n == 6) {
                              dialog_window(47, 0);
                              /*objects_group.children.forEach(function (child_item) {
                                if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                  return true;
                                }
                              });*/
                            } else if (map_n == 7) {
                              dialog_window(38, 0);
                              /*objects_group.children.forEach(function (child_item) {
                                if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                  return true;
                                }
                              });*/
                            } else if (map_n == 8) {
                              dialog_window(54, 0);
                              /*objects_group.children.forEach(function (child_item) {
                                if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                  return true;
                                }
                              });*/
                            } else if (map_n == 9) {
                              animation = 1;
                              game.add
                                .tween(follow)
                                .to(
                                  { x: 3000 * worldScale, y: 1800 * worldScale },
                                  2000,
                                  Phaser.Easing.Linear.None,
                                  true,
                                  500,
                                )
                                .onComplete.add(function () {
                                  objects_group.children.forEach(function (child_item) {
                                    /*if (child_item.type == 16 || child_item.type == -16) {
                                      child_item.children[0].angle -= 80;
                                    } else*/ if (child_item.type == 999990) {
                                      game.add
                                        .tween(child_item)
                                        .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                                        .onComplete.add(function (item) {
                                          item.destroy();
                                        });
                                    }
                                  });
                                  game.add.tween(effects_group).to({ alpha: 1 }, 1100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                                    animation = 0;
                                    dialog_window(59, 0);
                                  });
                                });
                            } else if (map_n == 10) {
                              dialog_window(74, 0);
                              objects_group.children.forEach(function (child_item) {
                                /*if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                } else*/ if (child_item.frameName == 'bags.png') {
                                  child_item.alpha = 1;
                                }
                              });
                            } else if (map_n == 11) {
                              dialog_window(90, 0);
                              objects_group.children.forEach(function (child_item) {
                                /*if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                }*/
                              });
                            } else if (map_n == 12) {
                              dialog_window(106, 0);
                              objects_group.children.forEach(function (child_item) {
                                /*if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                }*/
                              });
                            } else if (map_n == 13) {
                              dialog_window(132, 0);
                              objects_group.children.forEach(function (child_item) {
                                /*if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                }*/
                              });
                            } else if (map_n == 14) {
                              dialog_window(151, 0);
                              objects_group.children.forEach(function (child_item) {
                                /*if (child_item.type == 16 || child_item.type == -16) {
                                  child_item.children[0].angle -= 80;
                                }*/
                              });
                            } else if (map_n == 15) {
                              dialog_window(1722, 0);
                              objects_group.children.forEach(function (child_item) {
                                /* if (child_item.type == 16 || child_item.type == -16) {
                                   child_item.children[0].angle -= 80;
                                 }*/
                              });
                            } else if (map_n == 16) {
                              dialog_window(214, 0);
                              objects_group.children.forEach(function (child_item) {
                                /* if (child_item.type == 16 || child_item.type == -16) {
                                   child_item.children[0].angle -= 80;
                                 }*/
                              });
                            } else if (map_n == 17) {
                              dialog_window(261, 0);
                            } else taks_indicator();
                          });
                        });
                    });
                });
            });
          var transition_text = game.add.text(game.camera.width / 2, game.camera.height / 2, t, {
            font: '48px RussoOne',
            fill: '#ffffff',
            align: 'left',
            wordWrap: true,
            wordWrapWidth: game.camera.width - 400,
          });
          transition_text.anchor.setTo(0.5);
          transition_text.alpha = 0;
          transition_text.fixedToCamera = true;
        });
      }
    }
    function black_screen(a) {
      game.add.tween(effects_group).to({ alpha: 1 }, 200, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
        var mask = game.add.graphics(game.camera.width / 2, game.camera.height / 2);
        mask.beginFill(0xffffff);
        mask.drawCircle(0, 0, 2300);
        mask.fixedToCamera = true;
        black_sprite = game.add.sprite(0, 0, 'message_invite_mask');
        black_sprite.alpha = 1;
        black_sprite.width = game.camera.width;
        black_sprite.height = game.camera.height;
        black_sprite.fixedToCamera = true;
        var bmd = game.add.bitmapData(game.camera.width, game.camera.height);
        bmd.copy(game.canvas, 0, 0, game.camera.width, game.camera.height, 0, 0, null, null, 0, 0, 0);
        var ssssssss = game.add.sprite(0, 0, bmd);
        ssssssss.scale.setTo(1);
        ssssssss.mask = mask;
        ssssssss.fixedToCamera = true;
        game.add.tween(mask.scale).to({ x: 0.0001, y: 0.0001 }, 1000, Phaser.Easing.Linear.None, true);
        game.add
          .tween(black_sprite)
          .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true)
          .onComplete.add(function () {
            game.add
              .tween(transition_text)
              .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true)
              .onComplete.add(function () {
                game.add
                  .tween(transition_text)
                  .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 2000)
                  .onComplete.add(function () {
                    game.add
                      .tween(mask.scale)
                      .to({ x: 1, y: 1 }, 1000, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function () {
                        ssssssss.destroy();
                        black_sprite.destroy();
                        mask.destroy();
                        popup = 0;
                        animation = 0;
                        if (a == 76) dialog_window(77, 0);
                        else if (a == 99) dialog_window(100, 0);
                        else if (a == 164) dialog_window(165, 0);
                        else if (a == 231) dialog_window(232, 0);
                        else if (a == 252) dialog_window(253, 0);
                        else if (a == 258) dialog_window(259, 0);
                        else if (a == 235) {
                          animation = 1;
                          waterpump = game.add.sprite(2040 * worldScale, 1260 * worldScale, 'farm_obj_c_atlas', 'waterpump.png');
                          waterpump.anchor.setTo(0.5);
                          waterpump.scale.setTo(2.9);
                          objects_group.add(waterpump);
                          game.add.tween(follow).to({ x: 2020 * worldScale, y: 1300 * worldScale }, 2000, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                            animation = 0;
                            dialog_window(236, 0);
                          });
                        }
                      });
                  });
              });
          });
        var transition_text = game.add.text(
          game.camera.width / 2,
          game.camera.height / 2,
          game.cache.getJSON('lang')['t389'][0][window.lang],
          {
            font: '48px RussoOne',
            fill: '#ffffff',
            align: 'left',
            wordWrap: true,
            wordWrapWidth: game.camera.width - 400,
          },
        );
        transition_text.anchor.setTo(0.5);
        transition_text.alpha = 0;
        transition_text.fixedToCamera = true;
      });
    }
    function social_invite_window() {
      if (popup == 0 && missions_tab_open == 0) {
        missions_tab_open = 999;
        var pack_name = 0;
        var array_b = [];
        var b_id = 0;
        array_b = [3000, 0, 0, 0, 0];
        if (sound_on == 1) {
          play_sound('receiving_gift');
        }
        itm_a = [];
        animation = 1;
        popup_group.y = 0;
        popup = 1;
        blackf();
        var width = 0;
        var popup_close = game.add.sprite(game.camera.width + 100, 100, 'game_window_atlas', 'Close_Button.png');
        popup_close.anchor.setTo(0.5);
        button_animation_f(popup_close, 1);
        popup_close.events.onInputUp.add(function () {
          if (popup != 2) {
            popup = 2;
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup = 0;
                missions_tab_open = 0;
                animation = 0;
                popup_group.y -= game.camera.height;
                stage_start();
              });
          }
        }, this);
        popup_group.add(popup_close);
        popup_close.fixedToCamera = true;
        game.add.tween(popup_close.cameraOffset).to({ x: '-200' }, 500, Phaser.Easing.Exponential.Out, true);
        var shine = game.add.sprite(game.camera.width / 2, game.camera.height / 2, 'game_ui_atlas', 'Shine.png');
        shine.anchor.setTo(0.5, 0.52);
        shine.scale.setTo(0);
        shine.alpha = 0.3;
        popup_group.add(shine);
        shine.fixedToCamera = true;
        game.add.tween(shine.scale).to({ x: 4, y: 4 }, 1000, Phaser.Easing.Exponential.Out, true);
        rotate_tween(shine);
        var text_popup_title = game.add.text(
          game.camera.width / 2,
          game.camera.height / 2 - 360,
          game.cache.getJSON('lang')['t395'][0][window.lang],
          { font: '64px RussoOne', fill: '#fff', align: 'center' },
        );
        text_popup_title.anchor.setTo(0.5);
        text_popup_title.stroke = '#1A6383';
        text_popup_title.strokeThickness = 4;
        text_popup_title.setShadow(0, 4, 'rgba(26,99,131,1)', 1);
        popup_group.add(text_popup_title);
        text_popup_title.alpha = 0;
        text_popup_title.fixedToCamera = true;
        game.add
          .tween(text_popup_title)
          .to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function () {
            animation = 0;
          });
        var text_popup_title = game.add.text(
          game.camera.width / 2,
          game.camera.height / 2 - 300,
          game.cache.getJSON('lang')['t394'][0][window.lang],
          { font: '44px RussoOne', fill: '#fff', align: 'center' },
        );
        text_popup_title.anchor.setTo(0.5);
        text_popup_title.stroke = '#1A6383';
        text_popup_title.strokeThickness = 3;
        text_popup_title.setShadow(0, 3, 'rgba(26,99,131,1)', 1);
        popup_group.add(text_popup_title);
        text_popup_title.alpha = 0;
        text_popup_title.fixedToCamera = true;
        game.add
          .tween(text_popup_title)
          .to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true, 100)
          .onComplete.add(function () {
            animation = 0;
          });
        var Big_Kit_Button = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 400,
          'game_window_atlas',
          'Big_Kit_Button.png',
        );
        Big_Kit_Button.anchor.setTo(0.5);
        Big_Kit_Button.scale.setTo(1.4);
        Big_Kit_Button.inputEnabled = true;
        Big_Kit_Button.events.onInputDown.add(function (item2) {
          if (popup != 2) {
            var b = 0;
            if (fff == 3) {
              b = 1;
            }
            popup = 2;
            let group = game.add.group();
            group.y = -344;
            var r_image = get_random_change(['HELP_ME.jpg', 'ENJOY_YOUR_GARDEN.jpg', 'FIX_YOUR_HOUSE_AND_GARDEN.jpg']);
            var r_txt = get_random_change(['PlayWithMe1', 'PlayWithMe2']);
            var message_invite = game.add.sprite(668 / 2, 344 / 2, 'message_atlas', r_image);
            message_invite.scale.setTo(2);
            message_invite.anchor.setTo(0.5);
            group.add(message_invite);
            group.inputEnabled = false;
            group.y = 0;
            let group2 = game.add.group();
            group2.addChild(group);
            var renderTexture = game.make.renderTexture(668, 344);
            renderTexture.render(group2);
            group2.destroy();
            var mID =
              ddd == 0
                ? new Date()
                : new Date(
                  ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                );
            loading();

            console.log("%cRemoved share async called!", "color:orange");


            if (loading_black_sprite != 0) {
              loading_black_sprite.destroy();
              loading_black_sprite = 0;
            }
            if (loading_text != 0 && loading_text != 1) {
              loading_text.destroy();
              loading_text = 0;
            }
            if (success) {
              for (var i = 0; i < array_b.length; i++) {
                if (array_b[i] > 0) {
                  if (i == 0) {
                    if (lf != 0) {
                      array_b[i] = Number(array_b[i]) + lf * 50;
                    }
                    coins += Number(array_b[i]);
                    game.setCurrentEvent();
                    window.eventTrack('coins_in', Number(array_b[i]), {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: Number(array_b[i]),
                      source: 'social invite window',
                      package_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                  } else if (i == 1) {
                    lifes = Number(lifes) + Number(array_b[i]);
                  } else if (i == 2) {
                    game.setCurrentEvent();
                    window.eventTrack('booster_in', Number(array_b[i]), {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: Number(array_b[i]),
                      source: 'Joker',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                    free_joker += Number(array_b[i]);
                  } else if (i == 3) {
                    free_three += Number(array_b[i]);
                  } else if (i == 4) {
                    game.setCurrentEvent();
                    window.eventTrack('booster_in', Number(array_b[i]), {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: Number(array_b[i]),
                      source: 'UndoMove',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                    free_cardback += Number(array_b[i]);
                  }
                }
              }
              array222 = array_b;
              reward_animation();
              if (sound_on == 1) {
                play_sound('button_X');
              }
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  popup_group.alpha = 1;
                  bought = 1;
                  bought_f = 0;
                  game.setUserDataAndLog({ bought: bought });
                  popup_group.removeAll(true);
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  popup_group.y -= game.camera.height;
                  stage_start();
                });
              first_start = -1;
              game.setUserDataAndLog({ first_start: first_start });
            } else {
              popup = 1;
            }

            // shareAsync(
            //   {
            //     intent: 'SHARE',
            //     image: renderTexture.getBase64(),
            //     text: game.cache.getJSON('lang')[r_txt][0][window.lang],
            //     data: {
            //       userId: CurrentUserId,
            //       messageId: mID.getTime(),
            //       data: 'SetNewFriend',
            //       bonus: b,
            //     },
            //   },
            //   {
            //     actionLevel: null,
            //     targetUserID: null,
            //     socialActionType: DdnaSocialActionType.InviteFriend,
            //     socialRewardType: DdnaSocialRewardType.No,
            //   },
            // )
            //   .then(function (success) {
            //     if (loading_black_sprite != 0) {
            //       loading_black_sprite.destroy();
            //       loading_black_sprite = 0;
            //     }
            //     if (loading_text != 0 && loading_text != 1) {
            //       loading_text.destroy();
            //       loading_text = 0;
            //     }
            //     if (success) {
            //       for (var i = 0; i < array_b.length; i++) {
            //         if (array_b[i] > 0) {
            //           if (i == 0) {
            //             if (lf != 0) {
            //               array_b[i] = Number(array_b[i]) + lf * 50;
            //             }
            //             coins += Number(array_b[i]);
            //             game.setCurrentEvent();
            //             window.eventTrack('coins_in', Number(array_b[i]), {
            //               user_type: bought,
            //               lifetime: lifetime_day,
            //               highest_lvl: all_level.lastIndexOf(3) + 2,
            //               amount: Number(array_b[i]),
            //               source: 'social invite window',
            //               package_id: 0,
            //               mission_completed: missioncompleted,
            //               c_event: current_event,
            //             });
            //           } else if (i == 1) {
            //             lifes = Number(lifes) + Number(array_b[i]);
            //           } else if (i == 2) {
            //             game.setCurrentEvent();
            //             window.eventTrack('booster_in', Number(array_b[i]), {
            //               user_type: bought,
            //               lifetime: lifetime_day,
            //               highest_lvl: all_level.lastIndexOf(3) + 2,
            //               amount: Number(array_b[i]),
            //               source: 'Joker',
            //               item_id: 0,
            //               mission_completed: missioncompleted,
            //               c_event: current_event,
            //             });
            //             free_joker += Number(array_b[i]);
            //           } else if (i == 3) {
            //             free_three += Number(array_b[i]);
            //           } else if (i == 4) {
            //             game.setCurrentEvent();
            //             window.eventTrack('booster_in', Number(array_b[i]), {
            //               user_type: bought,
            //               lifetime: lifetime_day,
            //               highest_lvl: all_level.lastIndexOf(3) + 2,
            //               amount: Number(array_b[i]),
            //               source: 'UndoMove',
            //               item_id: 0,
            //               mission_completed: missioncompleted,
            //               c_event: current_event,
            //             });
            //             free_cardback += Number(array_b[i]);
            //           }
            //         }
            //       }
            //       array222 = array_b;
            //       reward_animation();
            //       if (sound_on == 1) {
            //         play_sound('button_X');
            //       }
            //       game.add
            //         .tween(black_sprite)
            //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            //         .onComplete.add(function (item) {
            //           item.destroy();
            //         });
            //       game.add
            //         .tween(popup_group)
            //         .to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true)
            //         .onComplete.add(function (item) {
            //           popup_group.alpha = 1;
            //           bought = 1;
            //           bought_f = 0;
            //           game.setUserDataAndLog({ bought: bought });
            //           popup_group.removeAll(true);
            //           popup = 0;
            //           missions_tab_open = 0;
            //           animation = 0;
            //           popup_group.y -= game.camera.height;
            //           stage_start();
            //         });
            //       first_start = -1;
            //       game.setUserDataAndLog({ first_start: first_start });
            //     } else {
            //       popup = 1;
            //     }
            //   })
            //   .catch(function (error) {
            //     if (loading_black_sprite != 0) {
            //       loading_black_sprite.destroy();
            //       loading_black_sprite = 0;
            //     }
            //     if (loading_text != 0 && loading_text != 1) {
            //       loading_text.destroy();
            //       loading_text = 0;
            //     }
            //   });
          }
        });
        Big_Kit_Button.fixedToCamera = true;
        popup_group.addChild(Big_Kit_Button);
        Big_Kit_Button.input.useHandCursor = true;
        scale_tween(Big_Kit_Button, 500, 0.1, 0.1);
        var Big_Kit_Button_text = game.add.text(0, 0, game.cache.getJSON('lang')['t282'][0][window.lang], {
          font: '28px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        Big_Kit_Button_text.anchor.setTo(0.5);
        Big_Kit_Button_text.stroke = '#46730C';
        Big_Kit_Button_text.lineSpacing = -10;
        Big_Kit_Button_text.strokeThickness = 4;
        Big_Kit_Button_text.setShadow(0, 4, 'rgba(70,115,12,0.5)', 1);
        Big_Kit_Button.addChild(Big_Kit_Button_text);
        var prizes = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
        popup_group.add(prizes);
        prizes.fixedToCamera = true;
        var lf = 0;
        for (var i = 0; i < array_b.length; i++) {
          if (array_b[i] > 0) {
            let spr = 'List_Coin.png';
            if (i == 0) {
              spr = 'List_Coin.png';
            } else if (i == 1) {
              spr = 'List_Energy.png';
            } else if (i == 2) {
              spr = 'List_Joker.png';
            } else if (i == 3) {
              spr = 'List_Cards.png';
            } else if (i == 4) {
              spr = 'List_Card_Back.png';
            }
            var prize_Rays = game.add.sprite(width, 0, 'game_window2_atlas', 'Rays.png');
            prize_Rays.anchor.setTo(0.5);
            prize_Rays.scale.setTo(0);
            prizes.addChild(prize_Rays);
            game.add.tween(prize_Rays.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, i * 200);
            rotate_tween(prize_Rays);
            var prize_Shiny_Ellipse = game.add.sprite(width, 0, 'game_window2_atlas', 'Shiny_Ellipse.png');
            prize_Shiny_Ellipse.anchor.setTo(0.5);
            prize_Shiny_Ellipse.alpha = 0;
            prizes.addChild(prize_Shiny_Ellipse);
            game.add
              .tween(prize_Shiny_Ellipse)
              .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, i * 200)
              .onComplete.add(function (item) {
                add_shines(item, -1, 1);
                add_shines(item, -1, 1);
              });
            var prize_1 = game.add.sprite(width, 0, 'game_window2_atlas', spr);
            prize_1.anchor.setTo(0.5);
            prize_1.scale.setTo(0);
            prize_1.iii = i;
            prizes.addChild(prize_1);
            game.add.tween(prize_1.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Bounce.Out, true, i * 200);
            width += prize_Shiny_Ellipse.width + 100;
            itm_a.push(prize_1);
            var prize_1_text = game.add.text(0, 86, array_b[i], {
              font: '26px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            prize_1_text.anchor.setTo(0.5);
            prize_1.addChild(prize_1_text);
          } else {
            itm_a.push(0);
          }
        }
        prizes.cameraOffset.x -= width / 2 - 140;
      }
    }
    function rewarded_referral_window() {
      if (popup == 0 && missions_tab_open == 0) {
        if (fbv == 1 && all_level.lastIndexOf(3) + 2 > 10 && all_level.lastIndexOf(3) + 2 <= 13) {
          window.eventTrack('FTUE_17_5GetFreeClub_rewards_is_shown');
        }
        missions_tab_open = 999;
        animation = 1;
        popup_group.y = 0;
        popup = 1;
        blackf();
        var width = 0;
        var popup_close = game.add.sprite(game.camera.width + 100, 100, 'game_window_atlas', 'Close_Button.png');
        popup_close.anchor.setTo(0.5);
        button_animation_f(popup_close, 1);
        popup_close.events.onInputUp.add(function () {
          if (popup != 2) {
            if (fbv == 1 && all_level.lastIndexOf(3) + 2 > 10 && all_level.lastIndexOf(3) + 2 <= 13) {
              window.eventTrack('FTUE_17_6_bClose_button_clicked');
            }
            popup = 2;
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup = 0;
                missions_tab_open = 0;
                animation = 0;
                popup_group.y -= game.camera.height;
                stage_start();
                if (fbv == 1 && all_level.lastIndexOf(3) + 2 > 10 && all_level.lastIndexOf(3) + 2 <= 13) {
                  window.eventTrack('FTUE_17_7_Map_is_visible');
                }
              });
          }
        }, this);
        popup_group.add(popup_close);
        popup_close.fixedToCamera = true;
        game.add.tween(popup_close.cameraOffset).to({ x: '-200' }, 500, Phaser.Easing.Exponential.Out, true);
        var shine = game.add.sprite(game.camera.width / 2, game.camera.height / 2, 'game_ui_atlas', 'Shine.png');
        shine.anchor.setTo(0.5, 0.52);
        shine.scale.setTo(0);
        shine.alpha = 0.3;
        popup_group.add(shine);
        shine.fixedToCamera = true;
        game.add.tween(shine.scale).to({ x: 4, y: 4 }, 1000, Phaser.Easing.Exponential.Out, true);
        rotate_tween(shine);
        var text_popup_title = game.add.text(
          game.camera.width / 2,
          game.camera.height / 2 - 360,
          game.cache.getJSON('lang')['t396'][0][window.lang],
          { font: '64px RussoOne', fill: '#fff', align: 'center' },
        );
        text_popup_title.anchor.setTo(0.5);
        text_popup_title.stroke = '#1A6383';
        text_popup_title.strokeThickness = 4;
        text_popup_title.setShadow(0, 4, 'rgba(26,99,131,1)', 1);
        popup_group.add(text_popup_title);
        text_popup_title.alpha = 0;
        text_popup_title.fixedToCamera = true;
        game.add
          .tween(text_popup_title)
          .to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true)
          .onComplete.add(function () {
            animation = 0;
          });
        var text_popup_title = game.add.text(
          game.camera.width / 2,
          game.camera.height / 2 - 300,
          game.cache.getJSON('lang')['t397'][0][window.lang],
          { font: '44px RussoOne', fill: '#fff', align: 'center' },
        );
        text_popup_title.anchor.setTo(0.5);
        text_popup_title.stroke = '#1A6383';
        text_popup_title.strokeThickness = 3;
        text_popup_title.setShadow(0, 3, 'rgba(26,99,131,1)', 1);
        popup_group.add(text_popup_title);
        text_popup_title.alpha = 0;
        text_popup_title.fixedToCamera = true;
        game.add
          .tween(text_popup_title)
          .to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true, 100)
          .onComplete.add(function () {
            animation = 0;
          });
        var Big_Kit_Button = game.add.sprite(
          game.camera.width / 2,
          game.camera.height / 2 + 400,
          'game_window_atlas',
          'Big_Kit_Button.png',
        );
        Big_Kit_Button.anchor.setTo(0.5);
        Big_Kit_Button.scale.setTo(1.4);
        Big_Kit_Button.inputEnabled = true;
        Big_Kit_Button.events.onInputDown.add(function (item2) {
          if (popup != 2) {
            if (fbv == 1 && all_level.lastIndexOf(3) + 2 > 10 && all_level.lastIndexOf(3) + 2 <= 13) {
              window.eventTrack('FTUE_17_6_aInvite_Friend_clicked');
            }
            var b = 0;
            if (fff == 3) {
              b = 1;
            }
            popup = 2;
            if (sound_on == 1) {
              play_sound('button_X');
            }
            let group = game.add.group();
            group.y = -344;
            var r_image = get_random_change(['HELP_ME.jpg', 'ENJOY_YOUR_GARDEN.jpg', 'FIX_YOUR_HOUSE_AND_GARDEN.jpg']);
            var r_txt = get_random_change(['PlayWithMe1', 'PlayWithMe2']);
            var message_invite = game.add.sprite(668 / 2, 344 / 2, 'message_atlas', r_image);
            message_invite.scale.setTo(2);
            message_invite.anchor.setTo(0.5);
            group.add(message_invite);
            group.inputEnabled = false;
            group.y = 0;
            let group2 = game.add.group();
            group2.addChild(group);
            var renderTexture = game.make.renderTexture(668, 344);
            renderTexture.render(group2);
            group2.destroy();
            var mID =
              ddd == 0
                ? new Date()
                : new Date(
                  ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                );
            loading();

            console.log("%cRemoved share async called!", "color:orange");


            if (loading_black_sprite != 0) {
              loading_black_sprite.destroy();
              loading_black_sprite = 0;
            }
            if (loading_text != 0 && loading_text != 1) {
              loading_text.destroy();
              loading_text = 0;
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup = 0;
                missions_tab_open = 0;
                animation = 0;
                popup_group.y -= game.camera.height;
                stage_start();
                if (fbv == 1 && all_level.lastIndexOf(3) + 2 > 10 && all_level.lastIndexOf(3) + 2 <= 13) {
                  window.eventTrack('FTUE_17_7_Map_is_visible');
                }
              });

            // shareAsync(
            //   {
            //     intent: 'SHARE',
            //     image: renderTexture.getBase64(),
            //     text: game.cache.getJSON('lang')[r_txt][0][window.lang],
            //     data: {
            //       userId: CurrentUserId,
            //       messageId: mID.getTime(),
            //       data: 'SetNewFriend',
            //       bonus: b,
            //     },
            //   },
            //   {
            //     actionLevel: null,
            //     targetUserID: null,
            //     socialActionType: DdnaSocialActionType.InviteFriend,
            //     socialRewardType: DdnaSocialRewardType.No,
            //   },
            // )
            //   .then(function () {
            //     if (loading_black_sprite != 0) {
            //       loading_black_sprite.destroy();
            //       loading_black_sprite = 0;
            //     }
            //     if (loading_text != 0 && loading_text != 1) {
            //       loading_text.destroy();
            //       loading_text = 0;
            //     }
            //     game.add
            //       .tween(black_sprite)
            //       .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            //       .onComplete.add(function (item) {
            //         item.destroy();
            //       });
            //     game.add
            //       .tween(popup_group)
            //       .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
            //       .onComplete.add(function (item) {
            //         popup_group.removeAll(true);
            //         popup = 0;
            //         missions_tab_open = 0;
            //         animation = 0;
            //         popup_group.y -= game.camera.height;
            //         stage_start();
            //         if (fbv == 1 && all_level.lastIndexOf(3) + 2 > 10 && all_level.lastIndexOf(3) + 2 <= 13) {
            //           window.eventTrack('FTUE_17_7_Map_is_visible');
            //         }
            //       });
            //   })
            //   .catch(function (error) {
            //     popup = 1;
            //     if (loading_black_sprite != 0) {
            //       loading_black_sprite.destroy();
            //       loading_black_sprite = 0;
            //     }
            //     if (loading_text != 0 && loading_text != 1) {
            //       loading_text.destroy();
            //       loading_text = 0;
            //     }
            //   });
          }
        });
        Big_Kit_Button.fixedToCamera = true;
        popup_group.addChild(Big_Kit_Button);
        Big_Kit_Button.input.useHandCursor = true;
        scale_tween(Big_Kit_Button, 500, 0.1, 0.1);
        var Big_Kit_Button_text = game.add.text(0, 0, game.cache.getJSON('lang')['t282_1'][0][window.lang], {
          font: '28px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        Big_Kit_Button_text.anchor.setTo(0.5);
        Big_Kit_Button_text.stroke = '#46730C';
        Big_Kit_Button_text.lineSpacing = -10;
        Big_Kit_Button_text.strokeThickness = 4;
        Big_Kit_Button_text.setShadow(0, 4, 'rgba(70,115,12,0.5)', 1);
        Big_Kit_Button.addChild(Big_Kit_Button_text);
        var num_n = [];
        var i = all_chests.indexOf(0);
        if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p1']) > 0) {
          num_n.push(1);
        }
        if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p2']) > 0) {
          num_n.push(2);
        }
        if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p3']) > 0) {
          num_n.push(3);
        }
        if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p4']) > 0) {
          num_n.push(4);
        }
        if (Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p5']) > 0) {
          num_n.push(5);
        }
        var width = 0;
        var prizes = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
        popup_group.add(prizes);
        prizes.fixedToCamera = true;
        var lf = 0;
        for (var j = 0; j < num_n.length; j++) {
          let spr = 'List_Coin.png';
          if (num_n[j] - 1 == 0) {
            spr = 'List_Coin.png';
          } else if (num_n[j] - 1 == 1) {
            spr = 'List_Energy.png';
          } else if (num_n[j] - 1 == 2) {
            spr = 'List_Joker.png';
          } else if (num_n[j] - 1 == 3) {
            spr = 'List_Cards.png';
          } else if (num_n[j] - 1 == 4) {
            spr = 'List_Card_Back.png';
          }
          var prize_Rays = game.add.sprite(width, 0, 'game_window2_atlas', 'Rays.png');
          prize_Rays.anchor.setTo(0.5);
          prize_Rays.scale.setTo(0);
          prizes.addChild(prize_Rays);
          game.add.tween(prize_Rays.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, j * 200);
          rotate_tween(prize_Rays);
          var prize_Shiny_Ellipse = game.add.sprite(width, 0, 'game_window2_atlas', 'Shiny_Ellipse.png');
          prize_Shiny_Ellipse.anchor.setTo(0.5);
          prize_Shiny_Ellipse.alpha = 0;
          prizes.addChild(prize_Shiny_Ellipse);
          game.add
            .tween(prize_Shiny_Ellipse)
            .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, j * 200)
            .onComplete.add(function (item) {
              add_shines(item, -1, 1);
              add_shines(item, -1, 1);
            });
          var prize_1 = game.add.sprite(width, 0, 'game_window2_atlas', spr);
          prize_1.anchor.setTo(0.5);
          prize_1.scale.setTo(0);
          prize_1.iii = j;
          prizes.addChild(prize_1);
          game.add.tween(prize_1.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Bounce.Out, true, j * 200);
          width += prize_Shiny_Ellipse.width + 100;
          itm_a.push(prize_1);
          if (fff == 3)
            var prize_1_text = game.add.text(
              0,
              86,
              Number(game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p' + num_n[j]]) *
              3,
              { font: '26px RussoOne', fill: '#fff', align: 'center' },
            );
          else
            var prize_1_text = game.add.text(
              0,
              86,
              game.cache.getJSON('buildings')['FriendsReward'][0]['Reward' + Number(i + 1)][0]['p' + num_n[j]],
              { font: '26px RussoOne', fill: '#fff', align: 'center' },
            );
          prize_1_text.anchor.setTo(0.5);
          prize_1.addChild(prize_1_text);
        }
        prizes.cameraOffset.x -= width / 2 - 140;
      }
    }
    function first_buyer_window(level, level_ad) {
      if (popup == 0 && missions_tab_open == 0 && (level == 15 || level == 30 || level == 50 || level == 70 || level == 90 || level == 110)) {
        if (offer_mas.length == 0 || offer_mas[0] < 0 || level_ad == 0) {
          popup = 1;
          missions_tab_open = 999;
          animation = 1;
          var pack_name = 0;
          var array_b = [];
          var b_id = 0;
          if (level == 15) {
            window.eventTrack('Starter1_Pkg_Lvl15_shown');
            b_id = 'pop_up_specialoffer_non_buyers_0';
            array_b = [3000, 5, 1, 0, 3];
            pack_name = game.cache.getJSON('lang')['t383'][0][window.lang];
          } else if (level == 30) {
            window.eventTrack('Special2_Pkg_Lvl30_shown');
            b_id = 'pop_up_specialoffer_non_buyers_1';
            array_b = [2000, 1, 2, 0, 3];
            pack_name = game.cache.getJSON('lang')['t384'][0][window.lang];
          } else if (level == 50) {
            window.eventTrack('Joker3_Pkg_Lvl50_shown');
            b_id = 'pop_up_specialoffer_non_buyers_2';
            array_b = [0, 0, 3, 0, 0];
            pack_name = game.cache.getJSON('lang')['t385'][0][window.lang];
          } else if (level == 70) {
            window.eventTrack('Mega4_Pkg_Lvl70_shown');
            b_id = 'pop_up_specialoffer_non_buyers_3';
            array_b = [1000, 0, 0, 0, 3, 0, 0, 0, 0, 0, 3];
            pack_name = game.cache.getJSON('lang')['t386'][0][window.lang];
          } else if (level == 90) {
            window.eventTrack('Ultra5_rare_Pkg_Lvl90_shown');
            b_id = 'pop_up_specialoffer_non_buyers_4';
            array_b = [1000, 0, 1, 0, 0, 1];
            pack_name = game.cache.getJSON('lang')['t387'][0][window.lang];
          } else if (level == 110) {
            window.eventTrack('LastChance6_Pkg_Lvl110_shown');
            b_id = 'pop_up_specialoffer_non_buyers_5';
            array_b = [1000, 0, 3, 0, 0];
            pack_name = game.cache.getJSON('lang')['t388'][0][window.lang];
          }
          if (sound_on == 1) {
            play_sound('receiving_gift');
          }
          itm_a = [];
          popup_group.y = 0;
          blackf();
          var width = 0;
          let rnd_time = '00';
          if (offer_icon == 0 && OfferDate == 0) {
            rnd_time = game.rnd.integerInRange(5, 20);
            OfferDate =
              ddd == 0
                ? new Date()
                : new Date(
                  ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                );
            OfferDate.setMinutes(OfferDate.getMinutes() + rnd_time);
            game.setUserDataAndLog({ OfferDate: String(OfferDate) });
          }
          special_timer = game.add.text(game.camera.width / 2, game.camera.height / 2 - 278, rnd_time + ':00', {
            font: '40px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          special_timer.anchor.setTo(0.5);
          special_timer.fixedToCamera = true;
          popup_group.add(special_timer);
          var popup_close = game.add.sprite(game.camera.width + 100, 100, 'game_window_atlas', 'Close_Button.png');
          popup_close.anchor.setTo(0.5);
          popup_close.lv = level_ad;
          button_animation_f(popup_close, 1);
          popup_close.events.onInputUp.add(function (item) {
            if (popup != 2) {
              popup = 2;
              if (sound_on == 1) {
                play_sound('button_X');
              }
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (itm) {
                  itm.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function () {
                  var offer_mas_n = offer_mas[0];
                  if (offer_mas[0] < 0) {
                    offer_mas[0] *= -1;
                  }
                  game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas) });
                  if (item.lv != 0 || offer_mas_n < 0) {
                    if (offer_icon == 0) {
                      if (item.lv != 0) {
                        offer_mas.push(item.lv);
                      }
                      offer_button();
                      game.setUserDataAndLog({ OfferDate: String(OfferDate), offer_mas: JSON.stringify(offer_mas) });
                    } else {
                      offer_mas.push(item.lv);
                      game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas) });
                    }
                  }
                  popup_group.removeAll(true);
                  popup = 0;
                  missions_tab_open = 0;
                  animation = 0;
                  popup_group.y -= game.camera.height;
                });
            }
          }, this);
          popup_group.add(popup_close);
          popup_close.fixedToCamera = true;
          game.add.tween(popup_close.cameraOffset).to({ x: '-200' }, 500, Phaser.Easing.Exponential.Out, true);
          var shine = game.add.sprite(game.camera.width / 2, game.camera.height / 2, 'game_ui_atlas', 'Shine.png');
          shine.anchor.setTo(0.5, 0.52);
          shine.scale.setTo(0);
          shine.alpha = 0.3;
          popup_group.add(shine);
          shine.fixedToCamera = true;
          game.add.tween(shine.scale).to({ x: 4, y: 4 }, 1000, Phaser.Easing.Exponential.Out, true);
          rotate_tween(shine);
          var text_popup_title = game.add.text(game.camera.width / 2, game.camera.height / 2 - 360, pack_name, {
            font: '64px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          text_popup_title.anchor.setTo(0.5);
          text_popup_title.stroke = '#1A6383';
          text_popup_title.strokeThickness = 4;
          text_popup_title.setShadow(0, 4, 'rgba(26,99,131,1)', 1);
          popup_group.add(text_popup_title);
          text_popup_title.alpha = 0;
          text_popup_title.fixedToCamera = true;
          game.add
            .tween(text_popup_title)
            .to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true)
            .onComplete.add(function () {
              animation = 0;
            });
          var Big_Kit_Button = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 + 400,
            'game_window_atlas',
            'Big_Kit_Button.png',
          );
          Big_Kit_Button.anchor.setTo(0.5);
          Big_Kit_Button.scale.setTo(1.4);
          Big_Kit_Button.inputEnabled = true;
          Big_Kit_Button.events.onInputDown.add(function (item2) {
            if (popup != 2) {
              popup = 2;
              if (fbv == 1) {
                game.setCurrentEvent();
                window.eventTrack(b_id + '_initiated');
                window.eventTrack('soga_purchase_initiated', 1, {
                  package_id: b_id,
                  value: '1.99 $',
                  current_level: level_button.n,
                  conversion: 1 - bought,
                  user_type: bought,
                  lifetime: lifetime_day,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
              }
              loading();
              if (animation == 100) {
                offer_mas.splice(0, 1);
                OfferDate = 0;
                game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas), OfferDate: String(OfferDate) });
                if (offer_icon != 0) {
                  if (offer_icon.inputEnabled == true) {
                    offer_icon.inputEnabled = false;
                    game.add
                      .tween(offer_icon)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
                        offer_icon_timer = 0;
                        item.destroy();
                      });
                  }
                }
                if (bought == 0) {
                  bought_f = 1;
                }
                if (fbv == 1) {
                  game.setCurrentEvent();
                  window.eventTrack(b_id + '_successfull');
                  window.eventTrack('soga_purchase_successfull', 1, {
                    package_id: b_id,
                    value: '1.99 $',
                    current_level: level_button.n,
                    conversion: 1 - bought,
                    first_purchase: bought_f,
                    lifetime: lifetime_day,
                    highest_lvl: all_level.lastIndexOf(3) + 2,
                    mission_completed: missioncompleted,
                    c_event: current_event,
                  });
                }
                if (loading_black_sprite != 0) {
                  loading_black_sprite.destroy();
                  loading_black_sprite = 0;
                }
                if (loading_text != 0 && loading_text != 1) {
                  loading_text.destroy();
                  loading_text = 0;
                }
                for (var i = 0; i < array_b.length; i++) {
                  if (array_b[i] > 0) {
                    if (i == 0) {
                      if (lf != 0) {
                        array_b[i] = Number(array_b[i]) + lf * 50;
                      }
                      coins += Number(array_b[i]);
                      game.setCurrentEvent();

                      window.eventTrack('coins_in', Number(array_b[i]), {
                        user_type: bought,
                        lifetime: lifetime_day,
                        highest_lvl: all_level.lastIndexOf(3) + 2,
                        amount: Number(array_b[i]),
                        source: 'first buyer window',
                        package_id: b_id,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });

                      // save collected coins
                      game.setUserDataAndLog({ currencies: coins });

                    } else if (i == 1) {
                      lifes = Number(lifes) + Number(array_b[i]);
                    } else if (i == 2) {
                      game.setCurrentEvent();
                      window.eventTrack('booster_in', Number(array_b[i]), {
                        user_type: bought,
                        lifetime: lifetime_day,
                        highest_lvl: all_level.lastIndexOf(3) + 2,
                        amount: Number(array_b[i]),
                        source: 'Joker',
                        item_id: 0,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                      free_joker += Number(array_b[i]);
                    } else if (i == 3) {
                      free_three += Number(array_b[i]);
                    } else if (i == 4) {
                      game.setCurrentEvent();
                      window.eventTrack('booster_in', Number(array_b[i]), {
                        user_type: bought,
                        lifetime: lifetime_day,
                        highest_lvl: all_level.lastIndexOf(3) + 2,
                        amount: Number(array_b[i]),
                        source: 'UndoMove',
                        item_id: 0,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                      free_cardback += Number(array_b[i]);
                    } else if (i == 8) {
                      game.setCurrentEvent();
                      window.eventTrack('booster_in', Number(array_b[i]), {
                        user_type: bought,
                        lifetime: lifetime_day,
                        highest_lvl: all_level.lastIndexOf(3) + 2,
                        amount: Number(array_b[i]),
                        source: 'Magnifier',
                        item_id: 0,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                      if (free_booster_spec < 0) free_booster_spec -= Number(array_b[i]); else free_booster_spec += Number(array_b[i]);
                    }
                  }
                }
                game.setUserDataAndLog({
                  currencies: coins,
                  lifes: String(lifes),
                  free_joker: free_joker,
                  free_three: free_three,
                  free_cardback: free_cardback,
                  free_booster_spec: free_booster_spec,
                });
                array222 = array_b;
                reward_animation();
                if (sound_on == 1) {
                  play_sound('button_X');
                }
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.alpha = 1;
                    bought = 1;
                    bought_f = 0;
                    game.setUserDataAndLog({ bought: bought });
                    popup_group.removeAll(true);
                    popup = 0;
                    missions_tab_open = 0;
                    animation = 0;
                    popup_group.y -= game.camera.height;
                  });
              }
              // else
              //   purchaseAsync(
              //     {
              //       productID: b_id,
              //       developerPayload: pack_name,
              //     },
              //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
              //   )
              //     .then(function (purchase) {
              //       if (b_id == 'pop_up_specialoffer_non_buyers_0') { starter_kit = 1; }
              //       offer_mas.splice(0, 1);
              //       OfferDate = 0;
              //       game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas), OfferDate: String(OfferDate), starter_kit: starter_kit });
              //       if (offer_icon != 0) {
              //         if (offer_icon.inputEnabled == true) {
              //           offer_icon.inputEnabled = false;
              //           game.add
              //             .tween(offer_icon)
              //             .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
              //             .onComplete.add(function (item) {
              //               offer_icon = 0; if (typeof window.icon != 'undefined') { window.icon.cameraOffset.x -= 150; }
              //               offer_icon_timer = 0;
              //               item.destroy();
              //             });
              //         }
              //       }
              //       if (bought == 0) {
              //         bought_f = 1;
              //       }
              //       if (fbv == 1) {
              //         game.setCurrentEvent();
              //         window.eventTrack(b_id + '_successfull');
              //         window.eventTrack('soga_purchase_successfull', 1, {
              //           package_id: b_id,
              //           value: '1.99 $',
              //           current_level: level_button.n,
              //           conversion: 1 - bought,
              //           first_purchase: bought_f,
              //           lifetime: lifetime_day,
              //           highest_lvl: all_level.lastIndexOf(3) + 2,
              //           mission_completed: missioncompleted,
              //           c_event: current_event,
              //         });
              //       }
              //       if (loading_black_sprite != 0) {
              //         loading_black_sprite.destroy();
              //         loading_black_sprite = 0;
              //       }
              //       if (loading_text != 0 && loading_text != 1) {
              //         loading_text.destroy();
              //         loading_text = 0;
              //       }
              //       for (var i = 0; i < array_b.length; i++) {
              //         if (array_b[i] > 0) {
              //           if (i == 0) {
              //             if (lf != 0) {
              //               array_b[i] = Number(array_b[i]) + lf * 50;
              //             }
              //             coins += Number(array_b[i]);
              //             game.setCurrentEvent();
              //             window.eventTrack('coins_in', Number(array_b[i]), {
              //               user_type: bought,
              //               lifetime: lifetime_day,
              //               highest_lvl: all_level.lastIndexOf(3) + 2,
              //               amount: Number(array_b[i]),
              //               source: 'first buyer window',
              //               package_id: b_id,
              //               mission_completed: missioncompleted,
              //               c_event: current_event,
              //             });
              //           } else if (i == 1) {
              //             lifes = Number(lifes) + Number(array_b[i]);
              //           } else if (i == 2) {
              //             game.setCurrentEvent();
              //             window.eventTrack('booster_in', Number(array_b[i]), {
              //               user_type: bought,
              //               lifetime: lifetime_day,
              //               highest_lvl: all_level.lastIndexOf(3) + 2,
              //               amount: Number(array_b[i]),
              //               source: 'Joker',
              //               item_id: 0,
              //               mission_completed: missioncompleted,
              //               c_event: current_event,
              //             });
              //             free_joker += Number(array_b[i]);
              //           } else if (i == 3) {
              //             free_three += Number(array_b[i]);
              //           } else if (i == 4) {
              //             game.setCurrentEvent();
              //             window.eventTrack('booster_in', Number(array_b[i]), {
              //               user_type: bought,
              //               lifetime: lifetime_day,
              //               highest_lvl: all_level.lastIndexOf(3) + 2,
              //               amount: Number(array_b[i]),
              //               source: 'UndoMove',
              //               item_id: 0,
              //               mission_completed: missioncompleted,
              //               c_event: current_event,
              //             });
              //             free_cardback += Number(array_b[i]);
              //           } else if (i == 8) {
              //             game.setCurrentEvent();
              //             window.eventTrack('booster_in', Number(array_b[i]), {
              //               user_type: bought,
              //               lifetime: lifetime_day,
              //               highest_lvl: all_level.lastIndexOf(3) + 2,
              //               amount: Number(array_b[i]),
              //               source: 'Magnifier',
              //               item_id: 0,
              //               mission_completed: missioncompleted,
              //               c_event: current_event,
              //             });
              //             if (free_booster_spec < 0) free_booster_spec -= Number(array_b[i]); else free_booster_spec += Number(array_b[i]);
              //           }
              //         }
              //       }
              //       game.setUserDataAndLog({
              //         lifes: String(lifes),
              //         free_booster_spec: free_booster_spec,
              //       });
              //       array222 = array_b;
              //       reward_animation();
              //       if (sound_on == 1) {
              //         play_sound('button_X');
              //       }
              //       game.add
              //         .tween(black_sprite)
              //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              //         .onComplete.add(function (item) {
              //           item.destroy();
              //         });
              //       game.add
              //         .tween(popup_group)
              //         .to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true)
              //         .onComplete.add(function (item) {
              //           popup_group.alpha = 1;
              //           bought = 1;
              //           bought_f = 0;
              //           game.setUserDataAndLog({ bought: bought });
              //           popup_group.removeAll(true);
              //           popup = 0;
              //           missions_tab_open = 0;
              //           animation = 0;
              //           popup_group.y -= game.camera.height;
              //         });
              //       // FBInstant.payments
              //       //   .consumePurchaseAsync(purchase['purchaseToken'])
              //       //   .then(function () {})
              //       //   .catch(function (error) {});
              //     })
              //     .catch(function (error) {
              //       if (fbv == 1) {
              //         game.setCurrentEvent();
              //         window.eventTrack('soga_purchase_failed', 1, {
              //           package_id: b_id,
              //           value: '1.99 $',
              //           current_level: level_button.n,
              //           conversion: 1 - bought,
              //           user_type: bought,
              //           lifetime: lifetime_day,
              //           mission_completed: missioncompleted,
              //           c_event: current_event,
              //         });
              //       }
              //       if (loading_black_sprite != 0) {
              //         loading_black_sprite.destroy();
              //         loading_black_sprite = 0;
              //       }
              //       if (loading_text != 0 && loading_text != 1) {
              //         loading_text.destroy();
              //         loading_text = 0;
              //       }
              //       console.log(error);
              //       popup = 1;
              //     });
            }
          });
          Big_Kit_Button.fixedToCamera = true;
          popup_group.addChild(Big_Kit_Button);
          Big_Kit_Button.input.useHandCursor = true;
          scale_tween(Big_Kit_Button, 500, 0.1, 0.1);
          var buttontimer = setInterval(function () {
            if (payments_catalog.length > 0) {
              clearInterval(buttontimer);
              var Big_Kit_Button_text = game.add.text(
                0,
                0,
                payments_catalog[
                payments_catalog.findIndex(function (e) {
                  return e['productID'] == b_id;
                })
                ]['price'],
                { font: '28px RussoOne', fill: '#fff', align: 'center' },
              );
              Big_Kit_Button_text.anchor.setTo(0.5);
              Big_Kit_Button_text.stroke = '#46730C';
              Big_Kit_Button_text.strokeThickness = 4;
              Big_Kit_Button_text.setShadow(0, 4, 'rgba(70,115,12,0.5)', 1);
              Big_Kit_Button.addChild(Big_Kit_Button_text);
            }
          }, 100);
          var prizes = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
          popup_group.add(prizes);
          prizes.fixedToCamera = true;
          var lf = 0;
          for (var i = 0; i < array_b.length; i++) {
            if (array_b[i] > 0) {
              let spr = 'List_Coin.png';
              if (i == 0) {
                spr = 'List_Coin.png';
              } else if (i == 1) {
                spr = 'List_Energy.png';
              } else if (i == 2) {
                spr = 'List_Joker.png';
              } else if (i == 3) {
                spr = 'List_Cards.png';
              } else if (i == 4) {
                spr = 'List_Card_Back.png';
              }
              var prize_Rays = game.add.sprite(width, 0, 'game_window2_atlas', 'Rays.png');
              prize_Rays.anchor.setTo(0.5);
              prize_Rays.scale.setTo(0);
              prizes.addChild(prize_Rays);
              game.add.tween(prize_Rays.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, i * 200);
              rotate_tween(prize_Rays);
              var prize_Shiny_Ellipse = game.add.sprite(width, 0, 'game_window2_atlas', 'Shiny_Ellipse.png');
              prize_Shiny_Ellipse.anchor.setTo(0.5);
              prize_Shiny_Ellipse.alpha = 0;
              prizes.addChild(prize_Shiny_Ellipse);
              game.add
                .tween(prize_Shiny_Ellipse)
                .to({ alpha: 1 }, 1000, Phaser.Easing.Linear.None, true, i * 200)
                .onComplete.add(function (item) {
                  add_shines(item, -1, 1);
                  add_shines(item, -1, 1);
                });
              var prize_1 = game.add.sprite(width, 0, 'game_window2_atlas', spr);
              prize_1.anchor.setTo(0.5);
              prize_1.scale.setTo(0);
              prize_1.iii = i;
              prizes.addChild(prize_1);
              game.add.tween(prize_1.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Bounce.Out, true, i * 200);
              width += prize_Shiny_Ellipse.width + 100;
              itm_a.push(prize_1);
              var prize_1_text = game.add.text(0, 86, array_b[i], {
                font: '26px RussoOne',
                fill: '#fff',
                align: 'center',
              });
              prize_1_text.anchor.setTo(0.5);
              prize_1.addChild(prize_1_text);
            } else {
              itm_a.push(0);
            }
          }
          prizes.cameraOffset.x -= width / 2 - 140;
        } else {
          if (level_ad != 0) {
            offer_mas.push(-level_ad);
            game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas) });
          }
        }
      }
    }
    function bot_sub_window() {
      if (popup == 0 && missions_tab_open == 0) {
        if (botopt == 0) {
          window.eventTrack('SG_Bot_Opt_in_shown');
        } else {
          window.eventTrack('SG_repeated_Bot_Opt_in_shown');
        }
        missions_tab_open = 999;
        popup_group.y = 0;
        animation = 0;
        popup = 1;
        blackf();
        var width = 0;
        var array_b = [500, 0, 0, 0, 0];
        var popup_back = windows_f(game.cache.getJSON('lang')['t398'][0][window.lang], 105);
        var text_popup_title = game.add.text(0, 180, game.cache.getJSON('lang')['t399'][0][window.lang], {
          font: '34px RussoOne',
          fill: '#8B3B30',
          align: 'center',
          wordWrap: true,
          wordWrapWidth: 500,
        });
        text_popup_title.anchor.setTo(0.5);
        popup_back.addChild(text_popup_title);
        text_popup_title.alpha = 0;
        game.add.tween(text_popup_title).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true, 100);
        var Big_Kit_Button = game.add.sprite(0, 320, 'game_window_atlas', 'Big_Kit_Button.png');
        Big_Kit_Button.anchor.setTo(0.5);
        Big_Kit_Button.scale.setTo(1.4);
        Big_Kit_Button.inputEnabled = true;
        Big_Kit_Button.events.onInputDown.add(function (item2) {
          if (popup != 2) {
            if (botopt == 0) {
              window.eventTrack('SG_Bot_Opt_in_accepted');
            } else {
              window.eventTrack('SG_repeated_Bot_Opt_in_accepted');
            }
            popup = 2;
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup = 0;
                missions_tab_open = 0;
                animation = 0;
                popup_group.y -= game.camera.height;
                botopt = 1;
                game.setUserDataAndLog({ botopt: botopt });
                // window.eventTrack('FB_Bot_Opt_in_shown');
                // FBInstant.player
                //   .subscribeBotAsync()
                //   .then(function () {
                //     window.eventTrack('FB_Bot_Opt_in_accepted');
                //     chest_open_window(
                //       game.cache.getJSON('lang')['Reward!'][0][window.lang],
                //       [500, 0, 0, 0, 0],
                //       51.5,
                //       void 0,
                //       {
                //         gameArea: DdnaGameArea.Map,
                //         actionType: DdnaTransactionActionType.BotSubscription,
                //       },
                //     );
                //     source_chest = 'bot subscribe';
                //     package_id_chest = 0;
                //   })
                //   .catch(function (e) {
                //     entryPointData_function();
                //     window.eventTrack('FB_Bot_Opt_in_declined');
                //     console.log('Subscribtion for bot has been failed, error: ' + e.message);
                //   });
              });
          }
        });
        popup_back.addChild(Big_Kit_Button);
        Big_Kit_Button.input.useHandCursor = true;
        scale_tween(Big_Kit_Button, 500, 0.1, 0.1);
        var Big_Kit_Button_text = game.add.text(0, 0, game.cache.getJSON('lang')['t400'][0][window.lang], {
          font: '28px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        Big_Kit_Button_text.anchor.setTo(0.5);
        Big_Kit_Button_text.stroke = '#46730C';
        Big_Kit_Button_text.lineSpacing = -10;
        Big_Kit_Button_text.strokeThickness = 4;
        Big_Kit_Button_text.setShadow(0, 4, 'rgba(70,115,12,0.5)', 1);
        Big_Kit_Button.addChild(Big_Kit_Button_text);
        var Red_Ribbon = game.add.sprite(287, -140, 'botsub_atlas', 'Red_Ribbon.png');
        Red_Ribbon.anchor.setTo(0.5);
        popup_back.addChild(Red_Ribbon);
        var Red_Ribbon_text = game.add.text(37, -37, game.cache.getJSON('lang')['Subscribe500'][0][window.lang], {
          font: '24px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        Red_Ribbon_text.anchor.setTo(0.5);
        Red_Ribbon_text.angle = 45;
        Red_Ribbon_text.stroke = '#46730C';
        Red_Ribbon_text.lineSpacing = -10;
        Red_Ribbon_text.strokeThickness = 4;
        Red_Ribbon_text.setShadow(0, 4, 'rgba(70,115,12,0.5)', 1);
        Red_Ribbon.addChild(Red_Ribbon_text);
        var Coins_Gift_Right_Bottom_Corner = game.add.sprite(
          -540,
          250,
          'botsub_atlas',
          'Coins_Gift_Right_Bottom_Corner.png',
        );
        Coins_Gift_Right_Bottom_Corner.anchor.setTo(0.5);
        popup_back.addChild(Coins_Gift_Right_Bottom_Corner);
        var Coins_Gift_Right_Bottom_Corner = game.add.sprite(540, 250, 'botsub_atlas', 'Coins_Left_Bottom_Corner.png');
        Coins_Gift_Right_Bottom_Corner.anchor.setTo(0.5);
        popup_back.addChild(Coins_Gift_Right_Bottom_Corner);
        var Coins_Gift_Right_Bottom_Corner = game.add.sprite(
          -540,
          -150,
          'botsub_atlas',
          'Floating_Coins_Energy_Left_Side.png',
        );
        Coins_Gift_Right_Bottom_Corner.anchor.setTo(0.5);
        popup_back.addChild(Coins_Gift_Right_Bottom_Corner);
        var Coins_Gift_Right_Bottom_Corner = game.add.sprite(
          540,
          -150,
          'botsub_atlas',
          'Floating_Coins_Right_Side.png',
        );
        Coins_Gift_Right_Bottom_Corner.anchor.setTo(0.5);
        popup_back.addChild(Coins_Gift_Right_Bottom_Corner);
      }
    }

    if (xmas != 0) {
      var emitter = game.add.emitter(game.world.centerX, -32, 50);
      emitter.makeParticles('xmas_atlas', 'snowflake.png');
      emitter.bringToTop = true;
      emitter.fixedToCamera = true;
      emitter.maxParticleScale = 0.3;
      emitter.minParticleScale = 0.2;
      emitter.setYSpeed(100, 200);
      emitter.setXSpeed(10, 20);
      emitter.gravity = 0;
      emitter.width = game.world.width * 1.5;
      emitter.minRotation = 0;
      emitter.maxRotation = 40;
      emitter.start(false, 15000, 1000);
    } else {
      var emitter = game.add.emitter(0, -50, 200);
      emitter.width = 1280;
      emitter.bringToTop = true;
      emitter.fixedToCamera = true;
      emitter.makeParticles('farm_obj_atlas', 'leaf.png');
      emitter.height = game.camera.height;
      emitter.setXSpeed(200, 500);
      emitter.setYSpeed(10, 20);
      emitter.bringToTop = true;
      emitter.setAlpha(0.1, 1, 500);
      emitter.setScale(-1, 1, 0.5, 0.5, 15000, Phaser.Easing.Sinusoidal.InOut, true);
      emitter.gravity = 50;
      emitter.start(false, 15000, 2500);
    }
    emitter.update();
    if (FTUE > 150 && first_start == 1) {
      first_start = 0;
      game.setUserDataAndLog({ first_start: first_start });
    }
    if (mission_number.indexOf('61') != -1) {
      if (
        new_options.findIndex(function (e) {
          return Number(e['type']) == 61;
        }) == -1 &&
        new_options.findIndex(function (e) {
          return Number(e['type']) == -61;
        }) == -1
      )
        new_options.push({ type: 61, num: [4, 5, 6] });
    } else {
      if (
        new_options.findIndex(function (e) {
          return Number(e['type']) == -61;
        }) == -1
      )
        new_options.push({ type: -61, num: [4, 5, 6] });
    }
    if (mission_number.indexOf('63') != -1) {
      if (
        new_options.findIndex(function (e) {
          return Number(e['type']) == 63;
        }) == -1 &&
        new_options.findIndex(function (e) {
          return Number(e['type']) == -63;
        }) == -1
      )
        new_options.push({ type: 63, num: [4, 5] });
    } else {
      if (
        new_options.findIndex(function (e) {
          return Number(e['type']) == -63;
        }) == -1
      )
        new_options.push({ type: -63, num: [4, 5] });
    }
    game.setUserDataAndLog({ new_options: JSON.stringify(new_options) });
    game.world.bringToTop(UI_bottom_group);
    game.world.bringToTop(UI_top_group);
    indicator_system(0);
    function stage_start() {
      if (all_level.lastIndexOf(300) != -1) {
        replayed = 0;
        retriesIteration = 0;
        if (all_level[2] == 300) {
          homescreen_window();
        }
        if (complete_level_spec != -1) {
          complete_level_spec += 1;
        }
        if (all_level.lastIndexOf(300) - (7 % 10) == 0 && first_start == -2) {
          first_start = 0;
          game.setUserDataAndLog({ first_start: first_start });
        }
        all_level[all_level.lastIndexOf(300)] = 3;
        if (new_options.findIndex(function (e) { return Math.abs(Number(e['type'])) == 7 }) == -1)
          if (all_level.lastIndexOf(3) + 2 >= 8) {
            new_options.push({ type: 7, num: [4, 5] });
            game.setUserDataAndLog({ new_options: JSON.stringify(new_options) });
          }
        // updateAndLogScore('completedLevels', 'default', all_level.length);
        game.setUserDataAndLog({ retriesIteration: retriesIteration, level_star: JSON.stringify(all_level) });
        all_stars -= 1;
        text_stars_panel.setText(all_stars);
        popup = 1;
        animation = 10;
        level_button.n = xmas == 0 ? all_level.lastIndexOf(3) + 2 : xmas_level + 1;
        level_button.loadTexture('game_ui_atlas', (game.cache.getJSON('buildings')['SuperHardLevel'].split(',').indexOf(String(level_button.n)) != -1 || xmas == 1) ? 'Super_Hard_Level_Button.png' : game.cache.getJSON('buildings')['HardLevel'].split(',').indexOf(String(level_button.n)) != -1 ? 'Hard_Level_Button.png' : 'Play_Button.png');
        text_level_button.setText(level_button.n);
        if (level_button.n == 2) {
          if (fbv == 1) {
            window.eventTrack('FTUE_3_1_MapLoadedAndVisible');
          }
        } else if (level_button.n == 3) {
          if (fbv == 1) {
            window.eventTrack('FTUE_5_1_MapLoadedAndVisible');
          }
        } else if (level_button.n == 4) {
          if (fbv == 1) {
            window.eventTrack('FTUE_7_1_MapLoadedAndVisible');
          }
        } else if (level_button.n == 5) {
          if (fbv == 1) {
            window.eventTrack('FTUE_9_1_MapLoadedAndVisible');
          }
        } else if (level_button.n == 6) {
          if (fbv == 1) {
            window.eventTrack('FTUE_11_1_MapLoadedAndVisible');
          }
        }
        game.time.events.repeat(
          100,
          1,
          function () {
            var star_emitter = game.add.emitter(level_button.world.x, level_button.world.y, 100);
            star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
            star_emitter.setAlpha(1, 0, 400);
            star_emitter.setScale(3, 0, 3, 0, 400);
            star_emitter.start(false, 770, 10);
            star_emitter.bringToTop = true;
            var get_star = game.add.sprite(
              game.camera.width / 2 + 745,
              game.camera.height - 120,
              'game_ui_atlas',
              'Star_Icon.png',
            );
            get_star.anchor.setTo(0.5);
            get_star.scale.setTo(0);
            get_star.alpha = 0;
            get_star.fixedToCamera = true;
            effects_group.add(get_star);
            game.world.bringToTop(effects_group);
            if (sound_on == 1) {
              play_sound('received_star');
            }
            game.add.tween(get_star).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
            game.add
              .tween(get_star)
              .to({ angle: 0 }, 750, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                game.add.tween(item.scale).to({ x: 2, y: 2 }, 200, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(item)
                  .to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                all_stars += 1;
                text_stars_panel.setText(all_stars);
                popup = 0;
                animation = 0;
                missions_tab_open = 0;
                if (entryPointData_w == 1) {
                } else {
                  FTUE_process();
                }
                indicator_system(0);
                if (offer_mas.length == 0)
                  windows_offer(0);
                buildstart = 0;
              });
            game.add.tween(get_star.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
            var tween = game.add
              .tween(get_star.cameraOffset)
              .to({ x: star_icon.worldPosition.x, y: star_icon.worldPosition.y }, 750, Phaser.Easing.Cubic.In, true);
            tween.onUpdateCallback(function () {
              star_emitter.x = get_star.x;
              star_emitter.y = get_star.y;
            }, this);
            game.add.tween(effects_group).to({ alpha: 1 }, 760, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
              star_emitter.destroy();
            });
          },
          this,
        );
      } else {
        popup = 1;
        animation = 1;
        game.add.tween(effects_group).to({ alpha: 1 }, 100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          popup = 0;
          animation = 0;
          var new_day = 0;
          if (map_n == 2) {
            if (dialog_mas.indexOf(-22) == -1) {
              new_day = 1;
              dialog_window(22, 0);
            }
          } else if (map_n == 3) {
            if (dialog_mas.indexOf(-23) == -1) {
              new_day = 1;
              dialog_window(23, 0);
            }
          } else if (map_n == 4) {
            if (dialog_mas.indexOf(-24) == -1) {
              new_day = 1;
              dialog_window(24, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                  return true;
                }
              });*/
            }
          } else if (map_n == 5) {
            if (dialog_mas.indexOf(-31) == -1) {
              new_day = 1;
              dialog_window(31, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                  return true;
                }
              });*/
            }
          } else if (map_n == 6) {
            if (dialog_mas.indexOf(-47) == -1) {
              new_day = 1;
              dialog_window(47, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                  return true;
                }
              });*/
            }
          } else if (map_n == 7) {
            if (dialog_mas.indexOf(-38) == -1) {
              new_day = 1;
              dialog_window(38, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                  return true;
                }
              });*/
            }
          } else if (map_n == 8) {
            if (dialog_mas.indexOf(-54) == -1) {
              new_day = 1;
              dialog_window(54, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                  return true;
                }
              });*/
            }
          } else if (map_n == 9) {
            if (dialog_mas.indexOf(-59) == -1) {
              new_day = 1;
              animation = 1;
              game.add
                .tween(follow)
                .to({ x: 3000 * worldScale, y: 1800 * worldScale }, 2000, Phaser.Easing.Linear.None, true, 500)
                .onComplete.add(function () {
                  objects_group.children.forEach(function (child_item) {
                    /*if (child_item.type == 16 || child_item.type == -16) {
                      child_item.children[0].angle -= 80;
                    } else*/ if (child_item.type == 999990) {
                      game.add
                        .tween(child_item)
                        .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                    }
                  });
                  game.add.tween(effects_group).to({ alpha: 1 }, 1100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    animation = 0;
                    dialog_window(59, 0);
                  });
                });
            }
          } else if (map_n == 10) {
            if (dialog_mas.indexOf(-74) == -1) {
              new_day = 1;
              dialog_window(74, 0);
              objects_group.children.forEach(function (child_item) {
                /*if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                } else*/ if (child_item.frameName == 'bags.png') {
                  child_item.alpha = 1;
                }
              });
            }
          } else if (map_n == 11) {
            if (dialog_mas.indexOf(-90) == -1) {
              new_day = 1;
              dialog_window(90, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                }
              });*/
            }
          } else if (map_n == 12) {
            if (dialog_mas.indexOf(-106) == -1) {
              new_day = 1;
              dialog_window(106, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                }
              });*/
            }
          } else if (map_n == 13) {
            if (dialog_mas.indexOf(-132) == -1) {
              new_day = 1;
              dialog_window(132, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                }
              });*/
            }
          } else if (map_n == 14) {
            if (dialog_mas.indexOf(-151) == -1) {
              new_day = 1;
              dialog_window(151, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                }
              });*/
            }
          } else if (map_n == 15) {
            if (dialog_mas.indexOf(-1722) == -1) {
              new_day = 1;
              dialog_window(1722, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                }
              });*/
            }
          } else if (map_n == 16) {
            if (dialog_mas.indexOf(-214) == -1) {
              new_day = 1;
              dialog_window(214, 0);
              /*objects_group.children.forEach(function (child_item) {
                if (child_item.type == 16 || child_item.type == -16) {
                  child_item.children[0].angle -= 80;
                }
              });*/
            }
          } else if (map_n == 17) {
            if (dialog_mas.indexOf(-261) == -1) {
              new_day = 1;
              dialog_window(261, 0);
            }
          }
          if (new_day == 1) {
            if (fbv == 1) {
              game.setCurrentEvent();
              window.eventTrack('game_day', 1, {
                game_day: map_n,
                user_type: bought,
                lifetime: lifetime_day,
                highest_lvl: all_level.lastIndexOf(3) + 2,
                mission_completed: missioncompleted,
                current_level: level_button.n,
                conversion: 1 - bought,
                c_event: current_event,
              });
            }
          }
          taks_indicator();
          FTUE_process();
        });
      }
    }
    // if (fbv == 1) {
    //   async function trackBotConversion() {
    //     try {
    //       // const entryPointData2 = FBInstant.getEntryPointData();
    //       //await trackBotMessageConversion({ messageId: String(entryPointData2.messageId) });
    //     } catch (error) {
    //       //console.log('Error message', error.message);
    //     }
    //   }
    //   if (entryPointData != null) if (typeof entryPointData.messageId !== 'undefined') trackBotConversion();
    // }
    var emitter_c = 0;
    function windows_offer(nul) {
      var l = get_random_change([15, 30, 50, 70, 90, 110]);
      var r = get_random_change([0, 0, 0, 0, 1]);
      if (
        (level_button.n == 15 ||
          (level_button.n > 15 && r == 1 && l == 15) ||
          level_button.n == 30 ||
          (level_button.n > 30 && r == 1 && l == 30) ||
          level_button.n == 50 ||
          (level_button.n > 50 && r == 1 && l == 50) ||
          level_button.n == 70 ||
          (level_button.n > 70 && r == 1 && l == 70) ||
          level_button.n == 90 ||
          (level_button.n > 90 && r == 1 && l == 90) ||
          level_button.n == 110 ||
          (level_button.n > 110 && r == 1 && l == 110) ||
          (offer_icon == 0 &&
            (offer_mas[0] == -15 ||
              offer_mas[0] == -30 ||
              offer_mas[0] == -50 ||
              offer_mas[0] == -70 ||
              offer_mas[0] == -90 ||
              offer_mas[0] == -110))) &&
        fbv == 1 &&
        shop == 1 &&
        bought == 0
      ) {
        if (entryPointData_w == 0) {
          if (
            level_button.n == 15 ||
            level_button.n == 30 ||
            level_button.n == 50 ||
            level_button.n == 70 ||
            level_button.n == 90 ||
            level_button.n == 110
          ) {
            if (nul == 0) first_buyer_window(level_button.n, level_button.n);
            else first_buyer_window(level_button.n, 0);
          } else {
            if (nul == 0) first_buyer_window(l, l);
            else first_buyer_window(l, 0);
          }
        }
      } else if (
        (level_button.n == 17 ||
          (level_button.n > 17 && (level_button.n - 17) % 10 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -16)) &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(1, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack2'][0][window.lang], 16);
          else special_sales_packages(1, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack2'][0][window.lang], 0);
        }
      } else if (
        (level_button.n == 19 ||
          (level_button.n > 19 && (level_button.n - 19) % 10 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -19)) &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(2, 'Carls_Package_Frame', game.cache.getJSON('lang')['pack1'][0][window.lang], 19);
          else special_sales_packages(2, 'Carls_Package_Frame', game.cache.getJSON('lang')['pack1'][0][window.lang], 0);
        }
      } else if (
        (level_button.n == 25 ||
          (level_button.n > 25 && (level_button.n - 25) % 10 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -25)) &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(
              3,
              'Good_Day_Package_Mock_Up',
              game.cache.getJSON('lang')['pack3'][0][window.lang],
              25,
            );
          else
            special_sales_packages(
              3,
              'Good_Day_Package_Mock_Up',
              game.cache.getJSON('lang')['pack3'][0][window.lang],
              0,
            );
        }
      } else if (
        (level_button.n == 20 ||
          (level_button.n > 20 && (level_button.n - 20) % 10 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -20)) &&
        free_joker == 0 &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(4, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack4'][0][window.lang], 20);
          else special_sales_packages(4, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack4'][0][window.lang], 0);
        }
      } /*else if (
        (level_button.n == 46 ||
          (level_button.n > 46 && (level_button.n - 46) % 11 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -46)) &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(
              5,
              'Random_booster_package_Frame',
              game.cache.getJSON('lang')['pack5'][0][window.lang],
              46,
            );
          else
            special_sales_packages(
              5,
              'Random_booster_package_Frame',
              game.cache.getJSON('lang')['pack5'][0][window.lang],
              0,
            );
        }
      }*/ else if (
        (level_button.n == 21 ||
          (level_button.n > 21 && (level_button.n - 21) % 12 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -21)) &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(6, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 21);
          else special_sales_packages(6, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);
        }
      } else if (
        (level_button.n == 31 ||
          (level_button.n > 31 && (level_button.n - 31) % 13 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -31)) &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(8, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 31);
          else special_sales_packages(8, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);
        }
      } /*else if (
        (level_button.n == 41 ||
          (level_button.n > 41 && (level_button.n - 41) % 14 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -41)) &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(9, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 41);
          else special_sales_packages(9, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);
        }
      } else if (
        (level_button.n == 51 ||
          (level_button.n > 51 && (level_button.n - 51) % 15 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -51)) &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(10, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 51);
          else special_sales_packages(10, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);
        }
      } else if (
        (level_button.n == 61 ||
          (level_button.n > 61 && (level_button.n - 61) % 16 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -61)) &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(11, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 61);
          else special_sales_packages(11, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack6'][0][window.lang], 0);
        }
      } else if (
        (level_button.n == 35 ||
          (level_button.n > 35 && (level_button.n - 35) % 18 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -35)) &&
        coins <= 2000 &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(12, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack7'][0][window.lang], 35);
          else special_sales_packages(12, 'Coin_Package_Frame', game.cache.getJSON('lang')['pack7'][0][window.lang], 0);
        }
      }*/ else if (
        (level_button.n == 45 ||
          (level_button.n > 45 && (level_button.n - 45) % 17 == 0) ||
          (offer_icon == 0 && offer_mas[0] == -45)) &&
        booster_tnt_col == 0 &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(7, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack8'][0][window.lang], 45);
          else special_sales_packages(7, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack8'][0][window.lang], 0);
        }
      } else if (
        (level_button.n >= 36 || (offer_icon == 0 && offer_mas[0] == -36)) &&
        lifes == 0 &&
        fbv == 1 &&
        shop == 1
      ) {
        if (entryPointData_w == 0) {
          if (nul == 0)
            special_sales_packages(13, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack9'][0][window.lang], 36);
          else special_sales_packages(13, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack9'][0][window.lang], 0);
        }
      } else if (
        all_level.length > friendpassed_best &&
        friendpassed_best != 0 &&
        FTUE > 150 &&
        fbv == 1 &&
        entryPointData_w == 0
      ) {
        scorebeaten_popup();
        friendpassed_best = 0;
      } else if (buildstart == 3 && FTUE >= 153 && entryPointData_w == 0) {
        popup = 1;
        blackf();
        bottom_button('Activ', 'Inactiv', 'Inactiv', UI_bottom_group, backcard_group);
        build_window();
      } else {
        if (nul == 1) {
          if (all_level.lastIndexOf(300) != -1) {
            popup = 1;
            animation = 10;
          } else {
            popup = 1;
            animation = 1;
          }
          game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
            stage_start();
          });
        }
      }
      game.setUserDataAndLog({ offer_mas: JSON.stringify(offer_mas) });
    }
    function balloon_congratulation() {
      var all_prize_mas_n = all_prize_mas;
      all_prize_mas = [0, 0, 0, 0, 0, 0, 0];
      popup_group.y = 0;
      popup_group.y += game.camera.height;
      popup = 1;
      blackf();
      var popup_back = windows_f(game.cache.getJSON('lang')['Congratulations'][0][window.lang], 7);
      var Shiny_Orange_Background = game.add.sprite(0, 0, 'baloon_atlas', 'Shiny_Orange_Background.png');
      Shiny_Orange_Background.anchor.setTo(0.5);
      Shiny_Orange_Background.scale.setTo(2);
      Shiny_Orange_Background.alpha = 0.5;
      popup_back.addChild(Shiny_Orange_Background);
      var shine_title = game.add.sprite(0, 50, 'game_atlas', 'shine_title.png');
      shine_title.anchor.setTo(0.5);
      shine_title.scale.setTo(0);
      popup_back.addChild(shine_title);
      game.add.tween(shine_title.scale).to({ x: 3, y: 3 }, 500, Phaser.Easing.Linear.None, true, 200);
      rotate_tween(shine_title);
      var anim_num = 0;
      for (var i = 0; i < all_prize_mas_n.length; i++) {
        if (all_prize_mas_n[i] != 0) {
          anim_num++;
        }
      }
      var chest = game.add.sprite(0, 200, 'baloon_atlas', 'Big_Chest.png');
      chest.anchor.setTo(0.5, 1);
      popup_back.addChild(chest);
      game.add
        .tween(chest.scale)
        .to({ x: '+0.1', y: '+0.2' }, 200, Phaser.Easing.Cubic.In, true, 1000, anim_num - 1)
        .yoyo(true, 200);
      add_shines(chest, -1, 1);
      add_shines(chest, -1, 1);
      add_shines(chest, -1, 1);
      anim_num = -400;
      var ppp = 0;
      for (var i = 0; i < all_prize_mas_n.length; i++) {
        if (all_prize_mas_n[i] != 0) {
          anim_num += 600;
          let spr = 'List_Coin.png';
          let atlas = 'game_window2_atlas';
          let col = 0;
          let scl = 1.6;
          col = all_prize_mas_n[i];
          if (i == 0) {
            spr = 'List_Coin.png';
          } else if (i == 1) {
            spr = 'List_Energy.png';
          } else if (i == 2) {
            spr = 'List_Joker.png';
          } else if (i == 3) {
            spr = 'List_Cards.png';
          } else if (i == 4) {
            spr = 'List_Card_Back.png';
          } else if (i == 5) {
            spr = 'tnt_booster.png';
            atlas = 'game_atlas';
            scl = 0.85;
          } else if (i == 6) {
            spr = 'shuffle_booster.png';
            atlas = 'game_atlas';
            scl = 0.85;
          } else if (i == 7) {
            spr = 'bullseye_booster.png';
            atlas = 'game_atlas';
            scl = 0.85;
          }
          if (ppp == 0) var item_icon = game.add.sprite(-200, -110, atlas, spr);
          else if (ppp == 1) var item_icon = game.add.sprite(200, -110, atlas, spr);
          else if (ppp == 2) var item_icon = game.add.sprite(-250, 110, atlas, spr);
          else if (ppp == 3) var item_icon = game.add.sprite(250, 110, atlas, spr);
          else if (ppp == 4) var item_icon = game.add.sprite(-350, 0, atlas, spr);
          else if (ppp == 5) var item_icon = game.add.sprite(350, 0, atlas, spr);
          else if (ppp == 6) var item_icon = game.add.sprite(0, -160, atlas, spr);
          item_icon.anchor.setTo(0.5);
          item_icon.scale.setTo(0);
          item_icon.alpha = 0;
          item_icon.scl = scl;
          item_icon.x1 = item_icon.x;
          item_icon.y1 = item_icon.y;
          item_icon.x = 0;
          item_icon.y = -20;
          popup_back.addChild(item_icon);
          game.add.tween(item_icon).to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 1000 + anim_num);
          game.add
            .tween(item_icon.scale)
            .to({ x: item_icon.scl, y: item_icon.scl }, 250, Phaser.Easing.Linear.None, true, 1000 + anim_num);
          var tween = game.add
            .tween(item_icon)
            .to(
              {
                x: [item_icon.x, item_icon.x, item_icon.x1, item_icon.x1],
                y: [item_icon.y, item_icon.y, item_icon.y1 - 400, item_icon.y1],
              },
              500,
              Phaser.Easing.Linear.None,
              true,
              1000 + anim_num,
            )
            .interpolation(function (v, k) {
              return Phaser.Math.bezierInterpolation(v, k);
            });
          if (ppp == 0)
            var item_text = game.add.text(-200, -40, 'x' + col, {
              font: '38px RussoOne',
              fill: '#0C6993',
              align: 'center',
            });
          else if (ppp == 1)
            var item_text = game.add.text(200, -40, 'x' + col, {
              font: '38px RussoOne',
              fill: '#0C6993',
              align: 'center',
            });
          else if (ppp == 2)
            var item_text = game.add.text(-250, 180, 'x' + col, {
              font: '38px RussoOne',
              fill: '#0C6993',
              align: 'center',
            });
          else if (ppp == 3)
            var item_text = game.add.text(250, 180, 'x' + col, {
              font: '38px RussoOne',
              fill: '#0C6993',
              align: 'center',
            });
          else if (ppp == 4)
            var item_text = game.add.text(-350, 70, 'x' + col, {
              font: '38px RussoOne',
              fill: '#0C6993',
              align: 'center',
            });
          else if (ppp == 5)
            var item_text = game.add.text(350, 70, 'x' + col, {
              font: '38px RussoOne',
              fill: '#0C6993',
              align: 'center',
            });
          else if (ppp == 6)
            var item_text = game.add.text(0, -90, 'x' + col, {
              font: '38px RussoOne',
              fill: '#0C6993',
              align: 'center',
            });
          item_text.scale.setTo(0);
          item_text.alpha = 0;
          item_text.anchor.setTo(0.5);
          item_text.x1 = item_text.x;
          item_text.y1 = item_text.y;
          item_text.x = 0;
          item_text.y = 50;
          item_text.stroke = '#fff';
          item_text.strokeThickness = 4;
          popup_back.addChild(item_text);
          game.add.tween(item_text).to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 1000 + anim_num);
          game.add.tween(item_text.scale).to({ x: 1, y: 1 }, 250, Phaser.Easing.Linear.None, true, 1000 + anim_num);
          var tween = game.add
            .tween(item_text)
            .to(
              {
                x: [item_text.x, item_text.x, item_text.x1, item_text.x1],
                y: [item_text.y, item_text.y, item_text.y1 - 400, item_text.y1],
              },
              500,
              Phaser.Easing.Linear.None,
              true,
              1000 + anim_num,
            )
            .interpolation(function (v, k) {
              return Phaser.Math.bezierInterpolation(v, k);
            });
          ppp++;
        }
      }
      var girl = game.add.sprite(game.camera.width / 2 - 1600, game.camera.height, 'char_atlas', 'Main_Twinkling.png');
      girl.scale.setTo(2.6);
      girl.anchor.setTo(0.5, 1);
      girl.fixedToCamera = true;
      girl.angle -= 10;
      popup_group.add(girl);
      game.add.tween(girl.cameraOffset).to({ x: '+1000' }, 400, Phaser.Easing.Exponential.Out, true, 800);
      game.add.tween(girl).to({ angle: 0 }, 800, Phaser.Easing.Elastic.Out, true, 1000);
      emitter_c = game.add.emitter(0, 0, 50);
      emitter_c.makeParticles('particle');
      emitter_c.setRotation(0, 360, 500);
      emitter_c.explode = true;
      emitter_c.width = game.camera.width;
      emitter_c.bringToTop = true;
      emitter_c.minParticleSpeed.set(0, 100);
      emitter_c.maxParticleSpeed.set(0, 200);
      emitter_c.gravity = 100;
      emitter_c.x = game.camera.x + game.camera.width / 2;
      emitter_c.y = game.camera.y;
      emitter_c.start(false, 6000, 100);
      emitter_c.blendMode = 0;
      emitter_c.setAlpha(1, 0, 5000);
      emitter_c.setScale(0.1, 1.4, 0.1, 1.4);
      emitter_c.maxParticleScale = 1.4;
      emitter_c.minParticleScale = 0.4;
      emitter_c.forEach(function (particle) {
        var a = game.rnd.integerInRange(1, 5);
        if (a == 1) particle.tint = 0xffff00;
        else if (a == 2) particle.tint = 0xff0000;
        else if (a == 3) particle.tint = 0x00ff00;
        else if (a == 4) particle.tint = 0x0000ff;
        else if (a == 5) particle.tint = 0x00ffff;
      });
      var button_green = draw_rect(0, 270, 408 * 0.9, 135 * 0.9, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
      draw_rect_shadow(0, 0, 374 * 0.9, 102 * 0.9, '#000', '#000', 0, 0, button_green, 500);
      draw_rect(0, 0, 374 * 0.9, 102 * 0.9, '#7ED12B', '#7ED12B', 0, 0, button_green, 0, 500, 0);
      draw_rect(0, 0, 370 * 0.9, 100 * 0.9, '#C2F33F', '#51C001', 0, 1, button_green, 0, 500, 0);
      button_animation_f(button_green, 1);
      button_green.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup != 2) {
          if (emitter_c != 0) {
            emitter_c.destroy();
            emitter_c = 0;
          }
          popup = 2;
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item) {
              item.destroy();
            });
          game.add
            .tween(popup_group)
            .to({ alpha: 0 }, 1000, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function (item) {
              popup_group.removeAll(true);
              popup = 0;
              animation = 0;
              popup_group.alpha = 1;
              popup_group.y -= game.camera.height;
              array222 = 0;
              missions_tab_open = 0;
              chest_open_window(game.cache.getJSON('lang')['Reward!'][0][window.lang], all_prize_mas_n, 51, void 0, {
                // gameArea: DdnaGameArea.Map,
                // actionType: DdnaTransactionActionType.MissionComplete,
                gameArea: null,
                actionType: null,
              });
              source_chest = 'balloon';
              package_id_chest = 0;
            });
        }
      }, this);
      popup_back.addChild(button_green);
      var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['Continue'][0][window.lang], {
        font: '38px RussoOne',
        fill: '#fff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 260,
      });
      text_button_green.anchor.setTo(0.5);
      text_button_green.lineSpacing = -10;
      text_button_green.stroke = '#457310';
      text_button_green.strokeThickness = 5;
      text_button_green.setShadow(0, 5, 'rgba(69,115,16,0.7)', 1);
      button_green.addChild(text_button_green);
      game.add
        .tween(popup_group)
        .to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true)
        .onComplete.add(function (item) {
          baloon = 0;
        });
    }
    var entryPointData_type = 0;
    var bot_show = 0;
    var entryPointData_w = 0;
    if (xmas == 0) {
      if (baloon == 0) {
        entryPointData_function();
        baloon = 0;
        baloon_stage = 0;
        all_prize_mas = [0, 0, 0, 0, 0, 0, 0];
      } else {
        if (
          all_prize_mas[0] != 0 ||
          all_prize_mas[1] != 0 ||
          all_prize_mas[2] != 0 ||
          all_prize_mas[3] != 0 ||
          all_prize_mas[4] != 0 ||
          all_prize_mas[5] != 0 ||
          all_prize_mas[6] != 0
        ) {
          balloon_congratulation();
        } else {
          baloon = 0;
          baloon_stage = 0;
          all_prize_mas = [0, 0, 0, 0, 0, 0, 0];
        }
      }
    } else {
      if (xmas_level_win == 1) { animation = 1; }
      if (dialog_mas.indexOf(-244) == -1) {
        animation = 1;
        popup = 1;
        if (from_map == 1) { from_map = -1; }
        worldScale = 0.8;
        objects_group.scale.setTo(objects_group.scale.x * worldScale, objects_group.scale.y * worldScale);
        game.world.setBounds(0, 0, (xmas == 1) ? (objects_group.width - 300) / 1.42 + 100 : objects_group.width / 1.42 + 100, objects_group.height / 1.25);
        follow.x = 1800;
        follow.y = 1600;
        last_position = [1800 * worldScale, 1600 * worldScale];
        game.add.tween(follow).to({ x: 1580, y: 880 }, 3000, Phaser.Easing.Linear.None, true, 3000).onComplete.add(function () {
          follow.x = 1580;
          follow.y = 880;
          animation = 0;
          popup = 0;
          dialog_window(244, 0);
        });
        from_map = -1;
      } else {

        if (backcards.length < 43 && shop == 1) {
          if (from_map == 1) {
            animation = 1;
            game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
              santa_sales_packages();
            });
            from_map = -1;
          } else {
            if (from_map == 2 && xmas_ticket < 6) {
              animation = 1;
              game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                santa_sales_packages();
              });
              from_map = -1;
            }
          }
        } else {
          if (from_map == 1 || from_map == 2)
            from_map = -1;
        }
      }
    }
    function entryPointData_function() {
      var date =
        ddd == 0
          ? new Date()
          : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
      entryPointData_w = 0;
      if (dailyday_new != 0) {
        var today =
          ddd == 0
            ? new Date()
            : new Date(
              ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
            );
        dailyday_old = today.getDate();
      }
      if (
        ((all_level[4] > 0 && dailyday_old == dailyday_new) ||
          (all_level[4] > 0 && dailyday_old != dailyday_new && dailyday_old != dailyday_current)) &&
        entryPointData_type != 5
      ) {
        popup = 1;
        animation = 1;
        if (game.cache.checkImageKey('daily_bonus_atlas') != true) {
          game.load.atlasJSONHash(
            'daily_bonus_atlas',
            'resource/daily_bonus_asset.png',
            'resource/daily_bonus_asset.json',
            1,
          );
          game.load.start();
          entryPointData_type = 5;
          loading();
          entryPointData_w = 1;
        } else {
          if (dailyday_old == dailyday_new && dailyday > 0) {
            if (dailyday_old == 0) {
              var today =
                ddd == 0
                  ? new Date()
                  : new Date(
                    ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                  );
              dailyday_current = today.getDate();
            } else {
              dailyday_current = dailyday_old;
            }
            dailyday_create(dailyday_new);
            dailyday++;
            if (dailyday > 7) {
              dailyday = 1;
            }
            dailyday *= -1;
            var tomorrow =
              ddd == 0
                ? new Date()
                : new Date(
                  ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                );
            tomorrow.setDate(tomorrow.getDate() + 1);
            dailyday_new = tomorrow.getDate();
            game.setUserDataAndLog({
              dailyday: dailyday,
              dailyday_new: String(dailyday_new),
              dailyday_current: dailyday_current,
            });
          } else if (dailyday_old != dailyday_new && dailyday > 0) {
            if (dailyday_old == 0) {
              var today =
                ddd == 0
                  ? new Date()
                  : new Date(
                    ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                  );
              dailyday_current = today.getDate();
            } else {
              dailyday_current = dailyday_old;
            }
            dailyday = 1;
            dailyday_create(dailyday_new);
            dailyday++;
            dailyday *= -1;
            var tomorrow =
              ddd == 0
                ? new Date()
                : new Date(
                  ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                );
            tomorrow.setDate(tomorrow.getDate() + 1);
            dailyday_new = tomorrow.getDate();
            game.setUserDataAndLog({
              dailyday: dailyday,
              dailyday_new: String(dailyday_new),
              dailyday_current: dailyday_current,
            });
          }
        }
        if (dailyday_old == 0) {
          entryPointData_w = 1;
        }
        if (dailyday_current != 0) {
          entryPointData_w = 1;
        }
      } else if (sunflowerDate == 0 && sunflowerDate_new != 0 && sunflowerStage > 0) {
        popup = 0;
        missions_tab_open = 0;
        animation = 0;
        if (sunflowerStage >= 20) { dialog_window(203, 0); } else { dialog_window(213, 0); }
        sunflowerStage = 0;
        game.setUserDataAndLog({ sunflowerStage: sunflowerStage });
        entryPointData_w = 1;
      } /*else if (
	    xmas_level < 45 &&
	    xmasDate == 0 &&
	    all_level.lastIndexOf(3) + 2 >= 20 &&
	    entryPointData_type != 2021 &&
		dialog_mas.indexOf(-243) == -1
	  ){
        popup = 1;
        animation = 1;
        if (game.cache.checkImageKey('xmas_atlas') != true) {
          game.load.atlasJSONHash('xmas_atlas', 'resource/xmas.png', 'resource/xmas.json', 1);
		  game.load.atlasJSONHash('xmas_map_atlas', 'resource/xmas_map_atlas.png', 'resource/xmas_map_atlas.json', 1);
		  game.load.json('halloween_map', 'resource/json/halloween_map.json', 1);
          game.load.start();
          entryPointData_type = 2021;
          loading();
        } else {
          entryPointData_type = 0;
          popup = 0;
          missions_tab_open = 0;
          animation = 0;
		  dialog_window(243,0);
        }
        entryPointData_w = 1;
	  }*/ else if (
        baloonDate == 0 &&
        sunflowerDate == 0 &&
        sunflowerDate_new == 0 &&
        magicbeanDate == 0 &&
        all_level.lastIndexOf(3) + 2 >= 15 &&
        all_level.lastIndexOf(3) + 2 <= level_max - 25 &&
        Bean_Icon == 0 &&
        entryPointData_type != 2
      ) {
        popup = 1;
        animation = 1;
        if (game.cache.checkImageKey('sunflower_atlas') != true) {
          game.load.atlasJSONHash(
            'sunflower_atlas',
            'resource/sunflower_atlas.png',
            'resource/sunflower_atlas.json',
            1,
          );
          game.load.start();
          entryPointData_type = 2;
          loading();
        } else {
          entryPointData_type = 0;
          popup = 0;
          missions_tab_open = 0;
          animation = 0;
          sunflower_create(1);
        }
        entryPointData_w = 1;
      } else if (
        baloonDate == 0 &&
        magicbeanDate == 0 &&
        magicbeanDate_new == 0 &&
        sunflowerDate == 0 &&
        all_level.lastIndexOf(3) + 2 >= 35 &&
        all_level.lastIndexOf(3) + 2 <= level_max - 50 &&
        MagicBean_Icon == 0 &&
        entryPointData_type != 3
      ) {
        popup = 1;
        animation = 1;
        if (game.cache.checkImageKey('magicbean_atlas') != true) {
          game.load.atlasJSONHash(
            'magicbean_atlas',
            'resource/magicbean_atlas.png',
            'resource/magicbean_atlas.json',
            1,
          );
          game.load.start();
          entryPointData_type = 3;
          loading();
        } else {
          entryPointData_type = 0;
          popup = 0;
          missions_tab_open = 0;
          animation = 0;
          magicbean_create(1);
        }
        entryPointData_w = 1;
      } else if (
        baloonDate == 0 &&
        baloonDate_new == 0 &&
        magicbeanDate == 0 &&
        sunflowerDate == 0 &&
        all_level.lastIndexOf(3) + 2 >= 40 &&
        all_level.lastIndexOf(3) + 2 <= level_max - 25 &&
        Balloon_Map_Icon == 0 &&
        entryPointData_type != 4
      ) {
        popup = 1;
        animation = 1;
        if (game.cache.checkImageKey('baloon_atlas') != true) {
          game.load.atlasJSONHash('baloon_atlas', 'resource/baloon_asset.png', 'resource/baloon_asset.json', 1);
          game.load.start();
          entryPointData_type = 4;
          loading();
        } else {
          entryPointData_type = 0;
          popup = 0;
          missions_tab_open = 0;
          animation = 0;
          baloon_create(1);
        }
        entryPointData_w = 1;
      } else if (
        offer_mas.length != 0 &&
        offer_mas[0] < 0 &&
        all_level.lastIndexOf(300) == -1 &&
        entryPointData_type != 6
      ) {
        popup = 1;
        animation = 1;
        if (game.cache.checkImageKey('special_sales_atlas') != true) {
          game.load.atlasJSONHash('special_sales_atlas', 'resource/special_sales.png', 'resource/special_sales.json');
          game.load.start();
          entryPointData_type = 6;
          loading();
        } else {
          popup = 0;
          missions_tab_open = 0;
          animation = 0;
          windows_offer(1);
        }
        entryPointData_w = 1;
      } else if (all_level.lastIndexOf(3) + 2 > 2 && all_level.lastIndexOf(3) + 2 <= 11 && coins < 300 && dialog_mas.indexOf(-85) == -1) {
        popup = 0;
        missions_tab_open = 0;
        animation = 0;
        dialog_window(85, 0);
        entryPointData_w = 1;
      } else if (Number(lifes) <= 0 && dialog_mas.indexOf(-86) == -1) {
        popup = 0;
        missions_tab_open = 0;
        animation = 0;
        dialog_window(86, 0);
        entryPointData_w = 1;
      } else if (
        level_button.n >= 36 &&
        lifes == 0 &&
        fbv == 1 &&
        shop == 1 &&
        offer_mas[0] != 36 &&
        offer_mas[0] != -36 &&
        offer_mas.length == 0
      ) {
        popup = 0;
        missions_tab_open = 0;
        animation = 0;
        special_sales_packages(13, 'Joker_Sale_Frame', game.cache.getJSON('lang')['pack9'][0][window.lang], 36);
        entryPointData_w = 1;
      } else {
        if (entryPointData != null && all_level.lastIndexOf(3) + 2 >= 7)
          if (typeof entryPointData.gamePayload !== 'undefined')
            if (typeof entryPointData.gamePayload.gift !== 'undefined')
              if (
                entryPointData.gamePayload.gift &&
                message_id.filter(function (item) {
                  return item === entryPointData.gamePayload.gift['id'];
                }).length == 0
              ) {
                game.setCurrentEvent();
                window.eventTrack('gamebot_entry', 1, {
                  messageCategory: entryPointData.messageCategory,
                  messageId: entryPointData.messageId,
                  user_type: bought,
                  lifetime: lifetime_day,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                popup = 0;
                missions_tab_open = 0;
                if (entryPointData.gamePayload.gift['giftData'][0]['itemId'] == 'coins') {
                  chest_open_window(
                    game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    [entryPointData.gamePayload.gift['giftData'][0]['amount'], 0, 0, 0, 0],
                    51.5,
                    void 0,
                    {
                      // gameArea: DdnaGameArea.Map,
                      // actionType: DdnaTransactionActionType.GamebotEntry,
                      gameArea: null,
                      actionType: null,
                    },
                  ); //coins,energy,joker,freecards,undomove
                  source_chest = 'gamebot_entry';
                  package_id_chest = 0;
                } else if (entryPointData.gamePayload.gift['giftData'][0]['itemId'] == 'energy') {
                  chest_open_window(
                    game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    [0, entryPointData.gamePayload.gift['giftData'][0]['amount'], 0, 0, 0],
                    51.5,
                    void 0,
                    {
                      // gameArea: DdnaGameArea.Map,
                      // actionType: DdnaTransactionActionType.GamebotEntry,
                      gameArea: null,
                      actionType: null,
                    },
                  ); //coins,energy,joker,freecards,undomove
                } else if (entryPointData.gamePayload.gift['giftData'][0]['itemId'] == 'cards') {
                  chest_open_window(
                    game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    [0, 0, 0, entryPointData.gamePayload.gift['giftData'][0]['amount'], 0],
                    51.5,
                    void 0,
                    {
                      // gameArea: DdnaGameArea.Map,
                      // actionType: DdnaTransactionActionType.GamebotEntry,
                      gameArea: null,
                      actionType: null,
                    },
                  ); //coins,energy,joker,freecards,undomove
                } else if (entryPointData.gamePayload.gift['giftData'][0]['itemId'] == 'joker') {
                  chest_open_window(
                    game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    [0, 0, entryPointData.gamePayload.gift['giftData'][0]['amount'], 0, 0],
                    51.5,
                    void 0,
                    {
                      // gameArea: DdnaGameArea.Map,
                      // actionType: DdnaTransactionActionType.GamebotEntry,
                      gameArea: null,
                      actionType: null,
                    },
                  ); //coins,energy,joker,freecards,undomove
                } else if (entryPointData.gamePayload.gift['giftData'][0]['itemId'] == 'undo') {
                  chest_open_window(
                    game.cache.getJSON('lang')['Reward!'][0][window.lang],
                    [0, 0, 0, 0, entryPointData.gamePayload.gift['giftData'][0]['amount']],
                    51.5,
                    void 0,
                    {
                      // gameArea: DdnaGameArea.Map,
                      // actionType: DdnaTransactionActionType.GamebotEntry,
                      gameArea: null,
                      actionType: null,
                    },
                  ); //coins,energy,joker,freecards,undomove
                }
                message_id.push(entryPointData.gamePayload.gift['id']);
                game.setUserDataAndLog({ message_id: JSON.stringify(message_id) });
                entryPointData = null;
                entryPointData_w = 1;
              }
        if (entryPointData != null)
          if (
            entryPointData['data'] == 'NewFriend' &&
            message_id.filter(function (item) {
              return item === entryPointData['messageId'];
            }).length == 0 &&
            entryPointData['userId'] != CurrentUserId
          )
            if (all_friends_invite.indexOf(entryPointData['userId']) == -1) {
              if (FTUE >= 151) {
                fff = 4;
                game.setUserDataAndLog({ fff: fff });
                new_friends([entryPointData['userName']], [0, 0, 0, 0, 0], entryPointData['bonus']);
                all_friends_invite.push(entryPointData['userId']);
                message_id.push(entryPointData['messageId']);
                game.setUserDataAndLog({
                  message_id: JSON.stringify(message_id),
                  all_friends_invite: JSON.stringify(all_friends_invite),
                });
                entryPointData = null;
                entryPointData_w = 1;
              }
            }
        fetchAndLogScore('default', 'completedLevels').then(function (friends) {
          for (var nnn = 0; nnn < friends.length; nnn++) {
            if (all_friends_invite.indexOf(friends[nnn]['user']['playerId']) == -1)
              all_friends_invite.push(friends[nnn]['user']['playerId']);
          }
          game.setUserDataAndLog({ all_friends_invite: JSON.stringify(all_friends_invite) });
        });
        if (entryPointData != null)
          if (
            entryPointData['data'] == 'SetNewFriend' &&
            message_id.filter(function (item) {
              return item === entryPointData['messageId'];
            }).length == 0 &&
            entryPointData['userId'] != CurrentUserId
          ) {
            var b = 0;
            if (entryPointData['bonus'] == 1) {
              b = 1;
            }
            let group = game.add.group();
            group.y = -344;
            var message_invite = game.add.sprite(668 / 2, 344 / 2, 'message_atlas', 'Friend_Helper_Ingame.png');
            message_invite.scale.setTo(2);
            message_invite.anchor.setTo(0.5);
            group.add(message_invite);
            group.inputEnabled = false;
            group.y = 0;
            let group2 = game.add.group();
            group2.addChild(group);
            var renderTexture = game.make.renderTexture(668, 344);
            renderTexture.render(group2);
            group2.destroy();
            var mID =
              ddd == 0
                ? new Date()
                : new Date(
                  ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                );
            console.log("%cRemoved update Async called!", "color:orange");

            //   updateAsync(
            //   {
            //     action: 'CUSTOM',
            //     image: renderTexture.getBase64(),
            //     text: 'New friend joined the game!',
            //     template: 'play_turn',
            //     data: {
            //       userName: CurrentUserName,
            //       userId: CurrentUserId,
            //       messageId: mID.getTime(),
            //       data: 'NewFriend',
            //       bonus: b,
            //     },
            //     strategy: 'IMMEDIATE',
            //     notification: 'NO_PUSH',
            //   },
            //   {
            //     actionLevel: null,
            //     targetUserID: entryPointData['userId'],
            //     socialActionType: DdnaSocialActionType.RewardedReferral,
            //     socialRewardType: DdnaSocialRewardType.No,
            //   },
            // );
            message_id.push(entryPointData['messageId']);
            game.setUserDataAndLog({ message_id: JSON.stringify(message_id) });
            entryPointData = null;
            entryPointData_w = 1;
            console.log('p7', entryPointData_w);
            entryPointData_function();
          }
        // if (entryPointData_w == 0) {
        //   if (bot_show == 0)
        //     if (
        //       (all_level.lastIndexOf(300) + 2 == 3 || (all_level.lastIndexOf(300) + 2 - 3) % 8 == 0) &&
        //       entryPointData_type != 1
        //     ) {
        //       popup = 1;
        //       animation = 1;
        //       bot_show = 1;
        //       entryPointData_w = 1;
        //       popup = 0;
        //       missions_tab_open = 0;
        //       entryPointData_type = 0;
        //       bot_sub_window();


        //       // FBInstant.player
        //       //   .canSubscribeBotAsync()
        //       //   .then(function (can_subscribe) {
        //       //     if (loading_black_sprite != 0) {
        //       //       loading_black_sprite.destroy();
        //       //       loading_black_sprite = 0;
        //       //     }
        //       //     if (loading_text != 0 && loading_text != 1) {
        //       //       loading_text.destroy();
        //       //       loading_text = 0;
        //       //     }
        //       //     if (can_subscribe) {
        //       //       if (game.cache.checkImageKey('botsub_atlas') != true) {
        //       //         bot_show = 0;
        //       //         game.load.atlasJSONHash(
        //       //           'botsub_atlas',
        //       //           'resource/botsub_atlas.png',
        //       //           'resource/botsub_atlas.json',
        //       //           1,
        //       //         );
        //       //         game.load.start();
        //       //         entryPointData_type = 1;
        //       //         loading();
        //       //       } else {
        //       //         popup = 0;
        //       //         missions_tab_open = 0;
        //       //         entryPointData_type = 0;
        //       //         bot_sub_window();
        //       //       }
        //       //       entryPointData_w = 1;
        //       //     } else {
        //       //       entryPointData_function();
        //       //       console.log('We can not subscribe for bot, and have no error.');
        //       //     }
        //       //   })
        //       //   .catch(function (e) {
        //       //     if (loading_black_sprite != 0) {
        //       //       loading_black_sprite.destroy();
        //       //       loading_black_sprite = 0;
        //       //     }
        //       //     if (loading_text != 0 && loading_text != 1) {
        //       //       loading_text.destroy();
        //       //       loading_text = 0;
        //       //     }
        //       //     entryPointData_function();
        //       //     console.log('We can not subscribe for bot: ' + e.message);
        //       //   });
        //     } else {
        //       if (all_chests.indexOf(0) < 10)
        //         if (FTUE >= 153 && fbv == 1 && all_level[10] > 0)
        //           if (ReferralDate == 0) {
        //             ReferralDate =
        //               ddd == 0
        //                 ? new Date()
        //                 : new Date(
        //                   ddd +
        //                   ' ' +
        //                   new Date().getHours() +
        //                   ':' +
        //                   new Date().getMinutes() +
        //                   ':' +
        //                   new Date().getSeconds(),
        //                 );
        //             ReferralDate.setHours(ReferralDate.getHours() + 24);
        //             game.setUserDataAndLog({ ReferralDate: String(ReferralDate) });
        //             popup = 0;
        //             missions_tab_open = 0;
        //             rewarded_referral_window();
        //             entryPointData_w = 1;
        //           } else if (all_level[17] > 0 && coins < 1000 && first_start != -1 && first_start != -2) {
        //             popup = 0;
        //             missions_tab_open = 0;
        //             first_start = -2;
        //             game.setUserDataAndLog({ first_start: first_start });
        //             social_invite_window();
        //             entryPointData_w = 1;
        //           }
        //     }
        // }
      }
      if (entryPointData_w == 0) {
        if (game.cache.checkImageKey('farm_obj_c_atlas') != true) {
          game.load.atlasJSONHash('farm_obj_c_atlas', 'resource/farm_obj_c.png', 'resource/farm_obj_c.json', 1);
        }
        if (game.cache.checkImageKey('message_atlas') != true) {
          game.load.atlasJSONHash(
            'message_atlas',
            'resource/message/message_atlas.png',
            'resource/message/message_atlas.json',
            1,
          );
        }
        if (game.cache.checkImageKey('Green_Background') != true) {
          game.load.image('Green_Background', 'resource/Green_Background.jpg', 1);
        }
        if (game.cache.checkImageKey('background_young_rose_gift') != true) {
          game.load.image('background_young_rose_gift', 'resource/background_young_rose_gift.jpg', 1);
        }
        if (game.cache.checkImageKey('botsub_atlas') != true) {
          game.load.atlasJSONHash('botsub_atlas', 'resource/botsub_atlas.png', 'resource/botsub_atlas.json', 1);
        }
        /*if (game.cache.checkImageKey('xmas_atlas') != true) {
          game.load.atlasJSONHash('xmas_atlas', 'resource/xmas.png', 'resource/xmas.json', 1);
        }
        if (game.cache.checkImageKey('xmas_map_atlas') != true) {
          game.load.atlasJSONHash('xmas_map_atlas', 'resource/xmas_map_atlas.png', 'resource/xmas_map_atlas.json', 1);
        }
        if (game.cache.checkImageKey('halloween_map') != true) {
          game.load.json('halloween_map', 'resource/json/halloween_map.json', 1);
        }*/
        if (game.cache.checkImageKey('sunflower_atlas') != true) {
          game.load.atlasJSONHash(
            'sunflower_atlas',
            'resource/sunflower_atlas.png',
            'resource/sunflower_atlas.json',
            1,
          );
        }
        if (game.cache.checkImageKey('magicbean_atlas') != true) {
          game.load.atlasJSONHash(
            'magicbean_atlas',
            'resource/magicbean_atlas.png',
            'resource/magicbean_atlas.json',
            1,
          );
        }
        if (game.cache.checkImageKey('daily_bonus_atlas') != true) {
          game.load.atlasJSONHash(
            'daily_bonus_atlas',
            'resource/daily_bonus_asset.png',
            'resource/daily_bonus_asset.json',
            1,
          );
        }
        if (game.cache.checkImageKey('day_16_atlas') != true) {
          game.load.atlasJSONHash('day_16_atlas', 'resource/day_16_atlas.png', 'resource/day_16_atlas.json', 1);
        }
        if (game.cache.checkImageKey('day17_atlas') != true) {
          game.load.atlasJSONHash('day17_atlas', 'resource/day17_atlas.png', 'resource/day17_atlas.json', 1);
        }
        if (game.cache.checkImageKey('day17_2_atlas') != true) {
          game.load.atlasJSONHash('day17_2_atlas', 'resource/day17_2_atlas.png', 'resource/day17_2_atlas.json', 1);
        }
        if (game.cache.checkImageKey('day14_pic_atlas') != true) {
          game.load.atlasJSONHash('day14_pic_atlas', 'resource/day14_pic.png', 'resource/day14_pic.json', 1);
        }
        if (game.cache.checkImageKey('build_icon_atlas') != true) {
          game.load.atlasJSONHash('build_icon_atlas', 'resource/build_icon.png', 'resource/build_icon.json', 1);
        }
        if (game.cache.checkImageKey('baloon_atlas') != true) {
          game.load.atlasJSONHash('baloon_atlas', 'resource/baloon_asset.png', 'resource/baloon_asset.json', 1);
        }
        if (game.cache.checkImageKey('unlimited_energy_atlas') != true) {
          game.load.atlasJSONHash(
            'unlimited_energy_atlas',
            'resource/unlimited_energy.png',
            'resource/unlimited_energy.json',
            1,
          );
        }
        if (game.cache.checkImageKey('special_sales_atlas') != true) {
          game.load.atlasJSONHash('special_sales_atlas', 'resource/special_sales.png', 'resource/special_sales.json');
        }
        game.load.start();
        if (all_level.lastIndexOf(300) != -1) {
          popup = 1;
          animation = 10;
        } else {
          popup = 1;
          animation = 1;
        }
        game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          stage_start();
        });
      }
      console.log(entryPointData_w, popup, animation, all_level.lastIndexOf(300));
    }
    var xmas_res = 0;
    game.load.onFileComplete.add(function (progress, cacheKey, success, totalLoaded, totalFiles) {
      if (entryPointData_type != 0) {

        if (success == true && entryPointData_type == 2021 && cacheKey == 'xmas_atlas') {
          xmas_res++;
        } else if (success == false && entryPointData_type == 2021) {
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }

        if (success == true && entryPointData_type == 2021 && cacheKey == 'xmas_map_atlas') {
          xmas_res++;
        } else if (success == false && entryPointData_type == 2021) {
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }

        if (success == true && entryPointData_type == 2021 && cacheKey == 'halloween_map') {
          xmas_res++;
        } else if (success == false && entryPointData_type == 2021) {
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }

        console.log('xmas_res', xmas_res);
        if (xmas_res >= 3 && entryPointData_type == 2021) {
          entryPointData_type = 0;
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }

        if (success == true && entryPointData_type == 6 && cacheKey == 'special_sales_atlas') {
          entryPointData_type = 0;
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        } else if (success == false && entryPointData_type == 6) {
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }
        if (success == true && entryPointData_type == 5 && cacheKey == 'daily_bonus_atlas') {
          entryPointData_type = 0;
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        } else if (success == false && entryPointData_type == 5) {
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }
        if (success == true && entryPointData_type == 4 && cacheKey == 'baloon_atlas') {
          entryPointData_type = 0;
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        } else if (success == false && entryPointData_type == 4) {
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }
        if (success == true && entryPointData_type == 3 && cacheKey == 'magicbean_atlas') {
          entryPointData_type = 0;
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        } else if (success == false && entryPointData_type == 3) {
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }
        if (success == true && entryPointData_type == 2 && cacheKey == 'sunflower_atlas') {
          entryPointData_type = 0;
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        } else if (success == false && entryPointData_type == 2) {
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }
        if (success == true && entryPointData_type == 1 && cacheKey == 'botsub_atlas') {
          entryPointData_type = 0;
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        } else if (success == false && entryPointData_type == 1) {
          if (loading_black_sprite != 0) {
            loading_black_sprite.destroy();
            loading_black_sprite = 0;
          }
          if (loading_text != 0 && loading_text != 1) {
            loading_text.destroy();
            loading_text = 0;
          }
          entryPointData_function();
        }
      }
    }, this);
    if (mission_stars_end >= all_day_stars) {
      cheat = 1;
      nextday();
      cheat = 0;
    }
    function draw_circle(x, y, r, col1, col2, sdv1, sdv2, par, sadow, round, sadow_n, fix) {
      var box = game.add.sprite(x + sdv1, y + sdv2, '');
      if (sadow != 0) {
        var myShadow = game.add.graphics(sdv1, sdv2);
        myShadow.beginFill(0x000000);
        if (sadow_n == 0) myShadow.drawCircle(0, 0 + sadow, r);
        else myShadow.drawCircle(0, 0, r + sadow * 2);
        myShadow.endFill();
        myShadow.alpha = 0.3;
      }
      var myBmp = game.add.bitmapData(r, r);
      var myGrd = myBmp.context.createLinearGradient(r / 2, 0, r / 2, r);
      myGrd.addColorStop(0, col1);
      myGrd.addColorStop(1, col2);
      myBmp.context.fillStyle = myGrd;
      myBmp.context.fillRect(0, 0, r, r);
      var grandientSpr = game.add.sprite(0, 0, myBmp);
      grandientSpr.anchor.setTo(0.5);
      var myMask = game.add.graphics(sdv1, sdv2);
      myMask.beginFill(0x000000);
      myMask.drawCircle(0, 0, r);
      myMask.endFill();
      grandientSpr.mask = myMask;
      if (sadow != 0) {
        box.addChild(myShadow);
      }
      box.addChild(grandientSpr);
      box.addChild(myMask);
      if (fix == 1) {
        box.fixedToCamera = true;
      }
      if (par) {
        par.addChild(box);
      }
      return box;
    }
    function draw_rect(x, y, w, h, col1, col2, sdv1, sdv2, par, sadow, round, sadow_n, fix) {
      var box = game.add.sprite(x + sdv1, y + sdv2, '');
      if (sadow != 0) {
        var myShadow = game.add.graphics(sdv1, sdv2);
        myShadow.beginFill(0x000000);
        if (sadow_n == 0) myShadow.drawRoundedRect(-w / 2, sadow - h / 2, w, h, round);
        else myShadow.drawRoundedRect(-w / 2 - sadow, -h / 2 - sadow, w + sadow * 2, h + sadow * 2, round);
        myShadow.endFill();
        myShadow.alpha = 0.3;
      }
      var myBmp = game.add.bitmapData(w, h);
      var myGrd = myBmp.context.createLinearGradient(w / 2, 0, w / 2, h);
      myGrd.addColorStop(0, col1);
      myGrd.addColorStop(1, col2);
      myBmp.context.fillStyle = myGrd;
      myBmp.context.fillRect(0, 0, w, h);
      var grandientSpr = game.add.sprite(0, 0, myBmp);
      grandientSpr.anchor.setTo(0.5);
      var myMask = game.add.graphics(sdv1, sdv2);
      myMask.beginFill(0x000000);
      myMask.drawRoundedRect(-w / 2, -h / 2, w, h, round);
      myMask.endFill();
      grandientSpr.mask = myMask;
      if (sadow != 0) {
        box.addChild(myShadow);
      }
      box.addChild(grandientSpr);
      box.addChild(myMask);
      if (fix == 1) {
        box.fixedToCamera = true;
      }
      if (par) {
        par.addChild(box);
      }
      return box;
    }
    function draw_rect_shadow(x, y, w, h, col1, col2, sdv1, sdv2, par, round, fix) {
      var box = game.add.sprite(x + sdv1, y + sdv2, '');
      var i = 5;
      w += i * 2 - 2;
      h += i * 2 - 2;
      var myBmp = game.add.bitmapData(w, h);
      var myGrd = myBmp.context.createLinearGradient(w / 2, 0, w / 2, h);
      myGrd.addColorStop(0, col1);
      myGrd.addColorStop(1, col2);
      myBmp.context.fillStyle = myGrd;
      myBmp.context.fillRect(0, 0, w, h);
      var grandientSpr = game.add.sprite(0, 0, myBmp);
      grandientSpr.anchor.setTo(0.5);
      var myMask = game.add.graphics(sdv1, sdv2);
      myMask.beginFill(0x000000);
      myMask.drawRoundedRect(-w / 2, -h / 2, w, h, round);
      myMask.endFill();
      grandientSpr.mask = myMask;
      grandientSpr.alpha = 0.1 / i;
      box.addChild(grandientSpr);
      box.addChild(myMask);
      if (par) {
        par.addChild(box);
      }
      if (fix == 1) {
        box.fixedToCamera = true;
      }
    }
    if (sunflowerStage < 0) {
      sunflowerStage = 0;
      magicbeanStage = 0;
      if (unlimited_lifesDate != 0) {
        unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() - unlimited_lifesDate_old);
      }
      game.setUserDataAndLog({
        unlimited_lifesDate: String(unlimited_lifesDate),
        magicbeanStage: magicbeanStage,
        sunflowerStage: sunflowerStage,
      });
    }
    if (Number(lifes) < Number(max_lifes) && LifeDate == 0) {
      LifeDate =
        ddd == 0
          ? new Date()
          : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
      LifeDate.setMinutes(LifeDate.getMinutes() + time_life);
      game.setUserDataAndLog({ life_time: String(LifeDate) });
    }

    function santa_sales_packages() {

      popup = 1;
      popup_group.y = 0;
      popup_group.y += game.camera.height;
      blackf();
      var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
      popup_group.add(popup_back);
      popup_back.fixedToCamera = true;
      var Pop_Up_Background = game.add.sprite(0, -340, 'xmas_atlas', 'Background.png');
      Pop_Up_Background.scale.setTo(2);
      Pop_Up_Background.anchor.setTo(0.5, 0);
      popup_back.addChild(Pop_Up_Background);

      var girl = game.add.sprite(-540, -270, 'char_atlas', 'Main_Excited_h.png');
      girl.scale.setTo(1.7);
      girl.anchor.setTo(0.5, 0);
      popup_back.addChild(girl);

      var Prize_Background = game.add.sprite(0, 0, 'xmas_atlas', 'Prize_Background.png');
      Prize_Background.scale.setTo(2);
      Prize_Background.anchor.setTo(0.5);
      popup_back.addChild(Prize_Background);

      var Prize = game.add.sprite(0, -125, 'xmas_atlas', 'Prize.png');
      Prize.scale.setTo(1);
      Prize.anchor.setTo(0.5);
      popup_back.addChild(Prize);

      var Xmas_Card_Background = game.add.sprite(340, 40, 'xmas_atlas', 'Xmas_Card_Background.png');
      Xmas_Card_Background.scale.setTo(1);
      Xmas_Card_Background.anchor.setTo(0.5);
      popup_back.addChild(Xmas_Card_Background);

      var Xmas_Card = game.add.sprite(340, 0, 'xmas_atlas', 'Xmas_Card.png');
      Xmas_Card.scale.setTo(1);
      Xmas_Card.anchor.setTo(0.5);
      popup_back.addChild(Xmas_Card);

      var plus = game.add.sprite(270, 0, 'xmas_atlas', 'plus.png');
      plus.scale.setTo(1);
      plus.anchor.setTo(0.5);
      popup_back.addChild(plus);

      var Xmas_Card_text = game.add.text(340, 100, game.cache.getJSON('lang')['t557'][0][window.lang], {
        font: '40px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      Xmas_Card_text.stroke = '#215D9A';
      Xmas_Card_text.strokeThickness = 8;
      Xmas_Card_text.lineSpacing = -10;
      Xmas_Card_text.setShadow(0, 4, 'rgba(0,0,0,0.5)', 10);
      Xmas_Card_text.anchor.setTo(0.5);
      popup_back.addChild(Xmas_Card_text);

      var icon1 = game.add.sprite(-140, 20, 'game_window_atlas', 'Big_Kit_List_Coin.png');
      icon1.scale.setTo(1);
      icon1.anchor.setTo(0.5);
      popup_back.addChild(icon1);
      var icon1_text = game.add.text(-44, 20, '10 000', {
        font: '36px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      icon1_text.stroke = '#215D9A';
      icon1_text.strokeThickness = 6;
      icon1_text.anchor.setTo(0.5);
      popup_back.addChild(icon1_text);

      var icon1 = game.add.sprite(70, 20, 'xmas_atlas', 'Ticket.png');
      icon1.scale.setTo(0.6);
      icon1.anchor.setTo(0.5);
      popup_back.addChild(icon1);
      var icon1_text = game.add.text(140, 20, 'x10', {
        font: '36px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      icon1_text.stroke = '#215D9A';
      icon1_text.strokeThickness = 6;
      icon1_text.anchor.setTo(0.5);
      popup_back.addChild(icon1_text);

      var icon1 = game.add.sprite(-100, 80, 'game_window_atlas', "Big_Kit_List_Joker.png");
      icon1.scale.setTo(0.8);
      icon1.anchor.setTo(0.5);
      popup_back.addChild(icon1);
      var icon1_text = game.add.text(-30, 80, 'x5', {
        font: '36px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      icon1_text.stroke = '#215D9A';
      icon1_text.strokeThickness = 6;
      icon1_text.anchor.setTo(0.5);
      popup_back.addChild(icon1_text);

      var icon1 = game.add.sprite(60, 80, 'game_atlas', 'tnt_booster.png');
      icon1.scale.setTo(0.4);
      icon1.anchor.setTo(0.5);
      popup_back.addChild(icon1);
      var icon1_text = game.add.text(130, 80, 'x3', {
        font: '36px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      icon1_text.stroke = '#215D9A';
      icon1_text.strokeThickness = 6;
      icon1_text.anchor.setTo(0.5);
      popup_back.addChild(icon1_text);

      var icon1 = game.add.sprite(-100, 140, 'game_atlas', 'booster_3_prev.png');
      icon1.scale.setTo(0.4);
      icon1.anchor.setTo(0.5);
      popup_back.addChild(icon1);
      var icon1_text = game.add.text(-30, 140, 'x3', {
        font: '36px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      icon1_text.stroke = '#215D9A';
      icon1_text.strokeThickness = 6;
      icon1_text.anchor.setTo(0.5);
      popup_back.addChild(icon1_text);

      var icon1 = game.add.sprite(60, 140, 'game5_atlas', '5_Cards.png');
      icon1.scale.setTo(0.4);
      icon1.anchor.setTo(0.5);
      popup_back.addChild(icon1);
      var icon1_text = game.add.text(130, 140, 'x3', {
        font: '36px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      icon1_text.stroke = '#215D9A';
      icon1_text.strokeThickness = 6;
      icon1_text.anchor.setTo(0.5);
      popup_back.addChild(icon1_text);

      var Coin_Package_Frame = game.add.sprite(0, -440, 'xmas_atlas', 'Frame.png');
      Coin_Package_Frame.scale.setTo(2);
      Coin_Package_Frame.anchor.setTo(0.5, 0);
      popup_back.addChild(Coin_Package_Frame);
      add_shines(Coin_Package_Frame, -1, 1);
      add_shines(Coin_Package_Frame, -1, 1);
      add_shines(Coin_Package_Frame, -1, 1);
      add_shines(Coin_Package_Frame, -1, 1);
      add_shines(Coin_Package_Frame, -1, 1);
      add_shines(Coin_Package_Frame, -1, 1);
      arc_text(game.cache.getJSON('lang')['pack10'][0][window.lang], '64px', 0, 0, 0, -370, -5, 0, popup_back, 0, 20);

      var button_green = draw_rect(0, 260, 408 * 0.9, 135 * 0.9, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
      draw_rect_shadow(0, 0, 374 * 0.9, 102 * 0.9, '#000', '#000', 0, 0, button_green, 500);
      draw_rect(0, 0, 374 * 0.9, 102 * 0.9, '#7ED12B', '#7ED12B', 0, 0, button_green, 0, 500, 0);
      draw_rect(0, 0, 370 * 0.9, 100 * 0.9, '#C2F33F', '#51C001', 0, 1, button_green, 0, 500, 0);
      button_animation_f(button_green, 1);
      button_green.id = bought == 1 ? 'mega_christmas_offer_buyer' : 'mega_christmas_offer_no_buyer';
      button_green.nm = "Santa's Big Package";
      button_green.price = bought == 1 ? '19.99' : '14.99';
      button_green.prize = [10000, 0, 5, 0, 3, 3, 0, 0, 0, 10, 0, 2, 3];
      button_green.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup != 2) {
          popup = 2;
          loading();
          if (animation == 100) {
            if (bought == 0) {
              bought_f = 1;
            }
            if (fbv == 1) {
              game.setCurrentEvent();
              window.eventTrack(item.id + '_successfull');
              window.eventTrack('soga_purchase_successfull', 1, {
                package_id: item.id,
                value: item.price,
                current_level: level_button.n,
                conversion: 1 - bought,
                first_purchase: bought_f,
                lifetime: lifetime_day,
                highest_lvl: all_level.lastIndexOf(3) + 2,
                mission_completed: missioncompleted,
                c_event: current_event,
              });
            }
            if (loading_black_sprite != 0) {
              loading_black_sprite.destroy();
              loading_black_sprite = 0;
            }
            if (loading_text != 0 && loading_text != 1) {
              loading_text.destroy();
              loading_text = 0;
            }
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (itm) {
                itm.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (itm) {
                popup_group.alpha = 1;
                bought = 1;
                bought_f = 0;
                game.setUserDataAndLog({ bought: bought });
                popup_group.removeAll(true);
                popup = 0;
                missions_tab_open = 0;
                animation = 0;
                special_timer = 0;
                popup_group.y -= game.camera.height;
                chest_open_window(
                  game.cache.getJSON('lang')['PurchaseSuccessful'][0][window.lang],
                  item.prize,
                  51,
                  void 0,
                  {
                    // gameArea: DdnaGameArea.Map,
                    // actionType: DdnaTransactionActionType.RealMoneyPurchase,
                    actionType: null,
                    gameArea: null,
                    productId: item.id,
                  },
                );
                source_chest = 'Package';
                package_id_chest = item.id;
              });
          }
          // else {
          //   purchaseAsync(
          //     {
          //       productID: item.id,
          //       developerPayload: item.name,
          //     },
          //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
          //   ).then(function (purchase) {
          //     if (bought == 0) {
          //       bought_f = 1;
          //     }
          //     if (fbv == 1) {
          //       game.setCurrentEvent();
          //       window.eventTrack(item.id + '_successfull');
          //       window.eventTrack('soga_purchase_successfull', 1, {
          //         package_id: item.id,
          //         value: item.price,
          //         current_level: level_button.n,
          //         conversion: 1 - bought,
          //         first_purchase: bought_f,
          //         lifetime: lifetime_day,
          //         highest_lvl: all_level.lastIndexOf(3) + 2,
          //         mission_completed: missioncompleted,
          //         c_event: current_event,
          //       });
          //     }
          //     if (loading_black_sprite != 0) {
          //       loading_black_sprite.destroy();
          //       loading_black_sprite = 0;
          //     }
          //     if (loading_text != 0 && loading_text != 1) {
          //       loading_text.destroy();
          //       loading_text = 0;
          //     }
          //     if (sound_on == 1) {
          //       play_sound('button_X');
          //     }
          //     game.add
          //       .tween(black_sprite)
          //       .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
          //       .onComplete.add(function (itm) {
          //         itm.destroy();
          //       });
          //     game.add
          //       .tween(popup_group)
          //       .to({ alpha: 0 }, 500, Phaser.Easing.Quadratic.Out, true)
          //       .onComplete.add(function (itm) {
          //         popup_group.alpha = 1;
          //         bought = 1;
          //         bought_f = 0;
          //         game.setUserDataAndLog({ bought: bought });
          //         popup_group.removeAll(true);
          //         popup = 0;
          //         missions_tab_open = 0;
          //         animation = 0;
          //         special_timer = 0;
          //         popup_group.y -= game.camera.height;
          //         chest_open_window(
          //           game.cache.getJSON('lang')['PurchaseSuccessful'][0][window.lang],
          //           item.prize,
          //           51,
          //           void 0,
          //           {
          //             gameArea: DdnaGameArea.Map,
          //             actionType: DdnaTransactionActionType.RealMoneyPurchase,
          //             productId: item.id,
          //           },
          //         );
          //         source_chest = 'Package';
          //         package_id_chest = item.id;
          //       });
          //     // FBInstant.payments
          //     //   .consumePurchaseAsync(purchase['purchaseToken'])
          //     //   .then(function () {})
          //     //   .catch(function (error) {});
          //     // })
          //     // .catch(function (error) {
          //     // if (fbv == 1) {
          //     //   game.setCurrentEvent();
          //     //   window.eventTrack('soga_purchase_failed', 1, {
          //     // 	package_id: item.id,
          //     // 	value: item.price,
          //     // 	current_level: level_button.n,
          //     // 	conversion: 1 - bought,
          //     // 	user_type: bought,
          //     // 	lifetime: lifetime_day,
          //     // 	mission_completed: missioncompleted,
          //     // 	c_event: current_event,
          //     //   });
          //     // }
          //     // if (loading_black_sprite != 0) {
          //     //   loading_black_sprite.destroy();
          //     //   loading_black_sprite = 0;
          //     // }
          //     // if (loading_text != 0 && loading_text != 1) {
          //     //   loading_text.destroy();
          //     //   loading_text = 0;
          //     // }
          //     // console.log(error);
          //     // popup = 1;
          //   });
          // }
        }
      });
      popup_back.addChild(button_green);

      var buttontimer = setInterval(function () {
        if (payments_catalog.length > 0) {
          clearInterval(buttontimer);
          var text_button_green = game.add.text(
            0,
            0,
            payments_catalog[
            payments_catalog.findIndex(function (e) {
              return e['productID'] == bought == 1 ? 'mega_christmas_offer_buyer' : 'mega_christmas_offer_no_buyer';
            })
            ]['price'],
            { font: '50px RussoOne', fill: '#fff', align: 'center', wordWrap: true, wordWrapWidth: 260 },
          );
          text_button_green.anchor.setTo(0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#457310';
          text_button_green.strokeThickness = 5;
          text_button_green.setShadow(0, 5, 'rgba(69,115,16,0.7)', 1);
          button_green.addChild(text_button_green);
        }
      }, 100);

      var popup_close = game.add.sprite(
        Pop_Up_Background.width / 2 + 50,
        -Pop_Up_Background.height / 2 - 150,
        'game_window_atlas',
        'Close_Button.png',
      );
      popup_close.anchor.setTo(0.5);
      popup_close.lv = level;
      button_animation_f(popup_close, 1);
      popup_close.events.onInputUp.add(function (item) {
        if (popup != 2) {
          popup = 2;
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (itm) {
              itm.destroy();
            });
          game.add
            .tween(popup_group)
            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function () {
              missions_tab_open = 0;
              popup_group.removeAll(true);
              popup = 0;
              animation = 0;
              popup_group.y -= game.camera.height;
            });
        }
      }, this);
      popup_back.addChild(popup_close);
      game.add
        .tween(popup_group)
        .to({ y: '-' + game.camera.height }, 1000, Phaser.Easing.Exponential.Out, true)
        .onComplete.add(function (item) { });

    }

    var Testament = 0;
    var Tube_2_Papers = 0;

    game.time.events.add(2000, function () {

      /*var booster4 = game.add.sprite(game.world.centerX + 1*1.4,game.world.height - 110*1.4,'');
      booster4.anchor.setTo(0.5);
      booster4.scale.setTo(1);
      button_animation_f(booster4, 1);
      booster4.events.onInputDown.add(function (itm) {
        btnup(itm);
      }, this);
     
    var booster4_anim = game.add.sprite(-42+20, 85,'game5_atlas','backcard_1.png');
    booster4_anim.anchor.setTo(0,1);
    booster4_anim.scale.setTo(0.75);
    booster4.addChild(booster4_anim);
    booster4_anim.angle = -50;
    var booster4_black = game.add.sprite(0, 0,'game5_atlas','backcard_1.png');
    booster4_black.anchor.setTo(0,1);
    booster4_black.tint = '#000'
    booster4_black.alpha = 0.8;
    booster4_anim.addChild(booster4_black);
    game.add.tween(booster4_anim).to( { angle: '+40' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 1000);
    game.add.tween(booster4_anim).to( { x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 1000);
     
    var booster4_anim = game.add.sprite(-42+20, 85,'game5_atlas','backcard_1.png');
    booster4_anim.anchor.setTo(0,1);
    booster4_anim.scale.setTo(0.8);
    booster4.addChild(booster4_anim);
    booster4_anim.angle = -40;
    var booster4_black = game.add.sprite(0, 0,'game5_atlas','backcard_1.png');
    booster4_black.anchor.setTo(0,1);
    booster4_black.tint = '#000'
    booster4_black.alpha = 0.6;
    booster4_anim.addChild(booster4_black);
    game.add.tween(booster4_anim).to( { angle: '+30' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 1000);
    game.add.tween(booster4_anim).to( { x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 1000);
     
    var booster4_anim = game.add.sprite(-42+20, 85,'game5_atlas','backcard_1.png');
    booster4_anim.anchor.setTo(0,1);
    booster4_anim.scale.setTo(0.85);
    booster4.addChild(booster4_anim);
    booster4_anim.angle = -30;
    var booster4_black = game.add.sprite(0, 0,'game5_atlas','backcard_1.png');
    booster4_black.anchor.setTo(0,1);
    booster4_black.tint = '#000'
    booster4_black.alpha = 0.4;
    booster4_anim.addChild(booster4_black);
    game.add.tween(booster4_anim).to( { angle: '+20' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 1000);
    game.add.tween(booster4_anim).to( { x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 1000);
     
    var booster4_anim = game.add.sprite(-42+20, 85,'game5_atlas','backcard_1.png');
    booster4_anim.anchor.setTo(0,1);
    booster4_anim.scale.setTo(0.9);
    booster4.addChild(booster4_anim);
    booster4_anim.angle = -20;
    var booster4_black = game.add.sprite(0, 0,'game5_atlas','backcard_1.png');
    booster4_black.anchor.setTo(0,1);
    booster4_black.tint = '#000'
    booster4_black.alpha = 0.2;
    booster4_anim.addChild(booster4_black);
    game.add.tween(booster4_anim).to( { angle: '+10' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 1000);
    game.add.tween(booster4_anim).to( { x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 1000);
     
      var booster4_top = game.add.sprite(20,0,'ingame_atlas','+5.png');
      booster4_top.anchor.setTo(0.5);
    booster4.addChild(booster4_top);
    game.add.tween(booster4_top).to( { x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 1000);
     
    var booster4_button_green = game.add.sprite(0, 80,'game_atlas', 'button_green.png');
      booster4_button_green.anchor.setTo(0.5);
      booster4_button_green.scale.setTo(0.6);
      booster4.addChild(booster4_button_green);
     
    var Red_Bubble = game.add.sprite(70, 50, 'game5_atlas', 'Red_Bubble.png');
    Red_Bubble.anchor.setTo(0.5);
    booster4.addChild(Red_Bubble);
     
    var Bubble = game.add.sprite(-80,80,'ingame_atlas','Bubble.png');
      Bubble.anchor.setTo(1, 0.5);
    booster4.addChild(Bubble);
    game.add.tween(Bubble).to( { x: '-20' }, 600, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 0);
     
    var free_five_text = game.add.text(-Bubble.width/2-8, 0,  game.device.desktop ? 'Click here to\nget more cards' : 'Tap here to get\nmore cards', {font: '24px RussoOne', fill: '#8A3C36', align: 'center'});
    free_five_text.anchor.setTo(0.5);
    Bubble.addChild(free_five_text);	*/
    });

    if ((xmas == 1 && from_map == -1) || from_map == -2) {
      from_map = 0;
      buch_rnd = 5;
      function leaves_angle(obj, t, n1, n2) {
        game.add
          .tween(obj)
          .to({ angle: n1 }, t, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            game.add
              .tween(item)
              .to({ angle: n2 }, t, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                leaves_angle(item, t, n1, n2);
              });
          });
      }
      function buch_create(xxx, yyy, sssx, sssy, tx, ty, r, p, c, i, rnd) {
        var leaves_back = game.add.sprite(xxx, yyy, '');
        leaves_back.anchor.setTo(0.75);
        leaves_back.fixedToCamera = true;
        leaves_back.scale.setTo(sssx, sssy);
        leaves_back.angle = r;
        var leaves3 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-3.png');
        leaves3.anchor.setTo(0.75);
        leaves_back.addChild(leaves3);
        leaves3.tint = c;
        var leaves2 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-2.png');
        leaves2.anchor.setTo(0.75);
        leaves_back.addChild(leaves2);
        leaves2.tint = c;
        var leaves1 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-1.png');
        leaves1.anchor.setTo(0.75);
        leaves_back.addChild(leaves1);
        leaves1.tint = c;
        var flowers = game.add.sprite(0, 0, 'loading_atlas', 'flowers' + rnd + '-1.png');
        flowers.anchor.setTo(0.75);
        leaves2.addChild(flowers);
        flowers.tint = c;
        leaves3.angle = angl_mas2[0];
        leaves2.angle = angl_mas2[1];
        leaves1.angle = angl_mas2[2];
        leaves_angle(leaves3, 3000, '+2', '-2');
        leaves_angle(leaves2, 2000, '+1', '-1');
        leaves_angle(leaves1, 1000, '+0.5', '-0.5');
        game.add.tween(leaves_back.cameraOffset).to({ x: tx, y: ty }, 800, Phaser.Easing.Exponential.In, true, p + 500);
        game.add
          .tween(leaves_back)
          .to({ alpha: 1 }, 800, Phaser.Easing.Exponential.In, true, p + 500)
          .onComplete.add(function (item) {
            leaves_back.destroy(1);
          });
      }
      var graphics = game.add.graphics(0, 0);
      if (xmas == 0) {
        graphics.beginFill(0x386217);
      } else {
        graphics.beginFill(0x74ADBA);
      }
      graphics.alpha = 1;
      graphics.drawRect(0, 0, game.camera.width, game.camera.height);
      graphics.fixedToCamera = true;
      game.add.tween(graphics).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 500);
      buch_create(game.camera.width / 2 + 150, -100, -2.2, -2.2, '0', '-1000', 45, 800, 0xffffff, 0, buch_rnd);
      buch_create(
        game.camera.width / 2 - 150,
        game.camera.height + 100,
        2.2,
        2.2,
        '0',
        '+1000',
        45,
        800,
        0xffffff,
        3,
        buch_rnd,
      );
      var graphics = game.add.graphics(0, 0);
      if (xmas == 0) {
        graphics.beginFill(0x386217);
      } else {
        graphics.beginFill(0x74ADBA);
      }
      graphics.alpha = 0.5;
      graphics.drawRect(0, 0, game.camera.width, game.camera.height);
      graphics.fixedToCamera = true;
      game.add.tween(graphics).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 500);
      buch_create(game.camera.width, game.camera.height, 2.2, 2.2, '+1000', '+1000', 0, 0, 0xffffff, 6, buch_rnd);
      buch_create(0, 0, -2.2, 2.2, '-1000', '-1000', 90, 0, 0xffffff, 9, buch_rnd);
      buch_create(game.camera.width, 0, 2.2, -2.2, '+1000', '-1000', 0, 400, 0xffffff, 12, buch_rnd);
      buch_create(0, game.camera.height, -2.2, -2.2, '-1000', '+1000', -90, 400, 0xffffff, 15, buch_rnd);
    }

  },
  update: function () {
    if ((popup == 0 && animation == 0 && UI_right_controll == 0) || animation == 10 || FTUE == 36 || FTUE == 152) {
      if (UI_right_group.alpha == 0) {
        update_controll = 1;
        UI_right_group.x = 600;
        game.add
          .tween(UI_right_group)
          .to({ x: '-600' }, 200, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            item.x = 0;
            if (popup == 0 && leaves_group == 0) {
              UI_right_group.removeAll(true); UI_right_create();
              game.world.bringToTop(UI_right_group);
            }
          });
        UI_left_group.x = -600;
        game.add
          .tween(UI_left_group)
          .to({ x: '+600' }, 200, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            item.x = 0;
            if (popup == 0 && leaves_group == 0) {
              game.world.bringToTop(UI_left_group);
            }
          });
        UI_right_group.alpha = 1;
        UI_left_group.alpha = 1;
      }
    } else {
      if (UI_right_group.alpha == 1) {
        update_controll = 1;
        UI_right_group.x = 0;
        game.add
          .tween(UI_right_group)
          .to({ x: '+600' }, 200, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            item.x = 600;
            item.alpha = 0;
          });
        UI_left_group.x = 0;
        game.add
          .tween(UI_left_group)
          .to({ x: '-600' }, 200, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            item.x = -600;
            item.alpha = 0;
          });
        UI_right_group.alpha = 0.99;
        UI_left_group.alpha = 0.99;
      }
    }
    if (level_button != 0)
      if ((popup == 0 && animation == 0) || animation == 10 || level_button.ttt == 2) {
        if (level_button.alpha == 0) {
          update_controll = 1;
          level_button.cameraOffset.y += 400;
          game.add.tween(level_button.cameraOffset).to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true);
        }
        level_button.alpha = 1;
      } else {
        level_button.alpha = 0;
      }
    if (build_button != 0)
      if ((popup == 0 && animation == 0) || animation == 10 || build_button.ttt == 2) {
        if (build_button.alpha == 0) {
          update_controll = 1;
          build_button.cameraOffset.y += 400;
          game.add.tween(build_button.cameraOffset).to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true);
        }
        build_button.alpha = 1;
      } else {
        build_button.alpha = 0;
      }
    if (prize_button != 0 && shop_free == 1 && shop == 1) {
      if (popup == 0 && animation == 0) {
        if (prize_button.alpha == 0) {
          update_controll = 1;
          prize_button.cameraOffset.y += 400;
          game.add.tween(prize_button.cameraOffset).to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true);
        }
        prize_button.alpha = 1;
      } else {
        prize_button.alpha = 0;
      }
    }
    if (FTUE > 42) {
      if (invitereward_button != 0)
        if ((popup == 0 && animation == 0) || animation == 10 || invitereward_button.ttt == 2) {
          if (invitereward_button.alpha == 0) {
            // remove this otherwise it will be set all the time!
            // update_controll = 1;
            invitereward_button.cameraOffset.y += 400;
            game.add.tween(invitereward_button.cameraOffset).to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true);
          }
          // invitereward_button.alpha = 1;
        } else {
          invitereward_button.alpha = 0;
        }
    }
    if (FTUE > 40) {
      if (furniture_button != 0)
        if ((popup == 0 && animation == 0) || animation == 10 || furniture_button.ttt == 2) {
          if (furniture_button.alpha == 0) {
            update_controll = 1;
            furniture_button.cameraOffset.y += 400;
            game.add.tween(furniture_button.cameraOffset).to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true);
          }
          furniture_button.alpha = 1;
        } else {
          furniture_button.alpha = 0;
        }
    }
    if (offer_icon != 0) {
      if ((popup == 0 && animation == 0) || animation == 10) {
        if (offer_icon.alpha == 0) {
          update_controll = 1;
          offer_icon.cameraOffset.y += 400;
          game.add.tween(offer_icon.cameraOffset).to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true);
        }
        offer_icon.alpha = 1;
      } else {
        offer_icon.alpha = 0;
      }
    }
    if (typeof window.icon !== 'undefined') {
      if ((popup == 0 && animation == 0) || animation == 10) {
        if (window.icon.alpha == 0) {
          update_controll = 1;
          window.icon.cameraOffset.y += 400;
          game.add.tween(window.icon.cameraOffset).to({ y: '-400' }, 200, Phaser.Easing.Linear.None, true);
        }
        window.icon.alpha = 1;
      } else {
        window.icon.alpha = 0;
      }
    }
    if (update_controll == 1) {
      update_controll = 2;
      game.time.events.add(400, function () {
        update_controll = 0;
      });
    }
    objects_group.children.forEach(function (child_item) {
      if (child_item.depth != -1) {
        if (
          child_item.x + child_item.width < game.camera.x ||
          child_item.x - child_item.width > game.camera.x + (game.camera.width / worldScale) * 1.1 ||
          child_item.y + child_item.height < game.camera.y ||
          child_item.y - child_item.height > game.camera.y + (game.camera.height / worldScale) * 1.2
        ) {
          if (child_item.visible == true) child_item.visible = false;
        } else {
          if (child_item.visible == false) child_item.visible = true;
        }
      }
    });
    if (popup == 0 && missions_tab_open == 0 && animation == 0 && w == 0 && FTUE != 40) {
      if (game.input.pointer1.isDown && game.input.pointer2.isDown) {
        zooming = true;
        easing = 0.1;
        olddistance = distance;
        distance = Phaser.Math.distance(
          game.input.pointer1.x,
          game.input.pointer1.y,
          game.input.pointer2.x,
          game.input.pointer2.y,
        );
        distancedelta = Math.abs(olddistance - distance);
        if (olddistance > distance && distancedelta > 4) {
          mapSizeCurrent -= 200;
        } else if (olddistance < distance && distancedelta > 4) {
          mapSizeCurrent += 200;
        }
        mapSizeCurrent = Phaser.Math.clamp(mapSizeCurrent, worldwidth, mapSizeMax);
        worldScale = mapSizeCurrent / mapSizeMax;
        if (game.input.pointer1.x < game.input.pointer2.x) {
          zoompoint.x =
            game.input.pointer1.worldX + Math.abs(game.input.pointer1.worldX - game.input.pointer2.worldX) / 2;
        } else {
          zoompoint.x =
            game.input.pointer2.worldX + Math.abs(game.input.pointer1.worldX - game.input.pointer2.worldX) / 2;
        }
        if (game.input.pointer1.y < game.input.pointer2.y) {
          zoompoint.y =
            game.input.pointer1.worldY + Math.abs(game.input.pointer1.worldY - game.input.pointer2.worldY) / 2;
        } else {
          zoompoint.y =
            game.input.pointer2.worldY + Math.abs(game.input.pointer1.worldY - game.input.pointer2.worldY) / 2;
        }
      } else {
        zooming = true;
        zoompoint.x = game.input.mousePointer.worldX;
        zoompoint.y = game.input.mousePointer.worldY;
        var snap = 40;
        zoompoint.x = zoompoint.x - (zoompoint.x % snap);
        zoompoint.y = zoompoint.y - (zoompoint.y % snap);
        if (!game.device.desktop) {
          easing = 0;
        }
      }
      if (game.input.activePointer.isDown && !game.input.pointer2.isDown) {
        zooming = false;
        game.camera.follow(follow, Phaser.Camera.FOLLOW_LOCKON, 0.2, 0.2);
      } else {
        var rescalefactorx = mapSizeX / (mapSizeX * objects_group.scale.x);
        var rescalefactory = mapSizeY / (mapSizeY * objects_group.scale.y);
        prevScale.x = Math.round(objects_group.scale.x * 10000) / 10000;
        prevScale.y = Math.round(objects_group.scale.y * 10000) / 10000;
        nextScale.x = Math.round((prevScale.x + (worldScale - objects_group.scale.x) * easing) * 10000) / 10000;
        nextScale.y = Math.round((prevScale.y + (worldScale - objects_group.scale.y) * easing) * 10000) / 10000;
        var xAdjust = (zoompoint.x - (game.camera.x + game.camera.width / 2)) * (nextScale.x - prevScale.x);
        var yAdjust = (zoompoint.y - (game.camera.y + game.camera.height / 2)) * (nextScale.y - prevScale.y);
        if (prevScale.x != nextScale.x || prevScale.y != nextScale.y) {
          zooming = true;
          game.camera.follow(follow);
          var scaleAdjustX = nextScale.x / prevScale.x;
          var scaleAdjustY = nextScale.y / prevScale.y;
          var focusX = (game.camera.x + game.camera.width / 2) * scaleAdjustX + xAdjust * rescalefactorx;
          var focusY = (game.camera.y + game.camera.height / 2) * scaleAdjustY + yAdjust * rescalefactory;
          follow.x = focusX;
          follow.y = focusY;
        } else {
          game.camera.follow(follow, Phaser.Camera.FOLLOW_LOCKON, 0.2, 0.2);
          zooming = false;
        }
        objects_group.scale.x += (worldScale - objects_group.scale.x) * easing;
        objects_group.scale.y += (worldScale - objects_group.scale.y) * easing;
        game.world.setBounds(0, 0, (xmas == 1) ? (objects_group.width - 300) / 1.42 + 100 : objects_group.width / 1.42 + 100, objects_group.height / 1.25);
      }
    }
    else
      game.world.setBounds(0, 0, (xmas == 1) ? (objects_group.width - 300) / 1.42 + 100 : objects_group.width / 1.42 + 100, objects_group.height / 1.25);
    for (var j = 0; j < node_mas.length; j++) {
      if (node_mas[j].y < game.camera.y || node_mas[j].y > game.camera.y + game.camera.height)
        node_mas[j].visible = false;
      else node_mas[j].visible = true;
    }
    if (prize_wheel_arrow != 0) {
      if (prize_wheel_arrow.angle > 160 || prize_wheel_arrow.angle < -160) {
        if (bright_area.angle != 135) {
          bright_area.angle = -225;
          if (sound_on == 1) {
            play_sound('Prizewheel_Spin');
          }
        }
      }
      if (prize_wheel_arrow.angle > -10 && prize_wheel_arrow.angle < 10) {
        bright_area.angle = -45;
      }
      if (prize_wheel_arrow.angle > -152 && prize_wheel_arrow.angle < -115) {
        if (bright_area.angle != -180) {
          bright_area.angle = -180;
          if (sound_on == 1) {
            play_sound('Prizewheel_Spin');
          }
        }
      }
      if (prize_wheel_arrow.angle > bright_area.angle + 70 && prize_wheel_arrow.angle >= 0) {
        if (sound_on == 1) {
          play_sound('Prizewheel_Spin');
        }
        bright_area.angle += 45;
      } else if (prize_wheel_arrow.angle > bright_area.angle + 70 && prize_wheel_arrow.angle < 0) {
        if (sound_on == 1) {
          play_sound('Prizewheel_Spin');
        }
        bright_area.angle += 45;
      }
    }
    if (sound_on == 0) {
      ambient.pause();
    }
    if (music_on == 0) {
      music.pause();
    }
    if (popup == 1) {
      game.world.bringToTop(popup_group);
      if (dialog_check == 0) {
        game.world.bringToTop(effects_group);
      }
      if (typeof loading_black_sprite !== 'undefined' && loading_black_sprite != 0) {
        game.world.bringToTop(loading_black_sprite);
      }
      if (typeof loading_text !== 'undefined' && loading_text != 0 && loading_text != 1) {
        game.world.bringToTop(loading_text);
      }
    }
    if (follow != 0) {
      if (follow.y < game.camera.height / 2) {
        follow.y = game.camera.height / 2;
        game.camera.focusOnXY(follow.x, follow.y);
      }
      if (follow.y > game.world.height - game.camera.height / 2) {
        follow.y = game.world.height - game.camera.height / 2;
        game.camera.focusOnXY(follow.x, follow.y);
      }
      if (follow.x < game.camera.width / 2) {
        follow.x = game.camera.width / 2;
        game.camera.focusOnXY(follow.x, follow.y);
      }
      if (follow.x > game.world.width - game.camera.width / 2) {
        follow.x = game.world.width - game.camera.width / 2;
        game.camera.focusOnXY(follow.x, follow.y);
      }
    }

    game.world.bringToTop(leaves_group);
  },
};

var games = function (game) { };
var level_col = 0;
var cards_deck = [];
var deck_n = 0;
var deck_col = 3;
var cards_discarded = [];
var destroy_cards = [];
var hazard_cards = [];
var start_card_mas = [];
var start_card_mas2 = [];
var cards_deck_col = 30;
var coins_text = 0;
var coins_reward = 0;
var booster4 = 0;
var booster4_1 = 0;
var booster5 = 0;
var UI_EndGame_btn = 0;
var TimerCheck = 0;
var FTUE_Arrow_n = 3;
var booster5_c = 0;
var cards_group;
var info_button = 0;
var close_suitcase_button = 0;
var suitcase_label = 0;
var suitcase_label_text = 0;
var message_text = 0;
var level_mas = [];
var card_text = 0;
var emitter = 0;

games.prototype = {
  preload: function () {
    game.input.maxPointers = 1;
    is_map = 0;
    booster4_1 = 0;
    game.resizeGame();
    function leaves_angle(obj, t, n1, n2) {
      game.add
        .tween(obj)
        .to({ angle: n1 }, t, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          game.add
            .tween(item)
            .to({ angle: n2 }, t, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              leaves_angle(item, t, n1, n2);
            });
        });
    }
    function buch_create(xxx, yyy, sssx, sssy, tx, ty, r, p, c, i, rnd) {
      var leaves_back = game.add.sprite(xxx, yyy, '');
      leaves_back.anchor.setTo(0.75);
      leaves_back.fixedToCamera = true;
      leaves_back.scale.setTo(sssx, sssy);
      leaves_back.angle = r;
      var leaves3 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-3.png');
      leaves3.anchor.setTo(0.75);
      leaves_back.addChild(leaves3);
      leaves3.tint = c;
      var leaves2 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-2.png');
      leaves2.anchor.setTo(0.75);
      leaves_back.addChild(leaves2);
      leaves2.tint = c;
      var leaves1 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-1.png');
      leaves1.anchor.setTo(0.75);
      leaves_back.addChild(leaves1);
      leaves1.tint = c;
      var flowers = game.add.sprite(0, 0, 'loading_atlas', 'flowers' + rnd + '-1.png');
      flowers.anchor.setTo(0.75);
      leaves2.addChild(flowers);
      flowers.tint = c;
      leaves3.angle = angl_mas2[0];
      angl_mas[0] = leaves3;
      leaves2.angle = angl_mas2[1];
      angl_mas[1] = leaves2;
      leaves1.angle = angl_mas2[2];
      angl_mas[2] = leaves1;
      leaves_angle(leaves3, 3000, '+2', '-2');
      leaves_angle(leaves2, 2000, '+1', '-1');
      leaves_angle(leaves1, 1000, '+0.5', '-0.5');
      game.add.tween(leaves_back.cameraOffset).to({ x: tx, y: ty }, 800, Phaser.Easing.Exponential.Out, true, p);
    }
    var graphics = game.add.graphics(0, 0);
    if (xmas == 0) {
      graphics.beginFill(0x386217);
    } else {
      graphics.beginFill(0x74ADBA);
    }
    graphics.alpha = 1;
    graphics.drawRect(0, 0, game.camera.width, game.camera.height);
    graphics.fixedToCamera = true;
    buch_create(game.camera.width / 2 + 150, -100, -2.2, -2.2, '0', '0', 45, 800, 0xffffff, 0, buch_rnd);
    buch_create(game.camera.width / 2 - 150, game.camera.height + 100, 2.2, 2.2, '0', '0', 45, 800, 0xffffff, 3, buch_rnd);
    var graphics = game.add.graphics(0, 0);
    if (xmas == 0) {
      graphics.beginFill(0x386217);
    } else {
      graphics.beginFill(0x74ADBA);
    }
    graphics.alpha = 0.5;
    graphics.drawRect(0, 0, game.camera.width, game.camera.height);
    graphics.fixedToCamera = true;
    buch_create(game.camera.width, game.camera.height, 2.2, 2.2, '0', '0', 0, 0, 0xffffff, 6, buch_rnd);
    buch_create(0, 0, -2.2, 2.2, '0', '0', 90, 0, 0xffffff, 9, buch_rnd);
    buch_create(game.camera.width, 0, 2.2, -2.2, '0', '0', 0, 400, 0xffffff, 12, buch_rnd);
    buch_create(0, game.camera.height, -2.2, -2.2, '0', '0', -90, 400, 0xffffff, 15, buch_rnd);
    load_com = 2;
    function res_load() {
      if (level == -1) {
        level = all_level.lastIndexOf(3) + 2;
      }
      if (level >= 1) {
        if (game.cache.checkImageKey('farm_obj_c_atlas') != true) {
          game.load.atlasJSONHash('farm_obj_c_atlas', 'resource/farm_obj_c.png', 'resource/farm_obj_c.json', 1);
        }
      }
      if ((map_n >= 10 || level > 50) && map_n <= 14) {
        if (game.cache.checkImageKey('day14_pic_atlas') != true) {
          game.load.atlasJSONHash('day14_pic_atlas', 'resource/day14_pic.png', 'resource/day14_pic.json', 1);
        }
      }
      if ((map_n >= 11 || level > 60) && map_n <= 17) {
        if (game.cache.checkImageKey('day_16_atlas') != true) {
          game.load.atlasJSONHash('day_16_atlas', 'resource/day_16_atlas.png', 'resource/day_16_atlas.json', 1);
        }
      }
      if ((map_n >= 12 || level > 100) && map_n <= 17) {
        if (game.cache.checkImageKey('day17_atlas') != true) {
          game.load.atlasJSONHash('day17_atlas', 'resource/day17_atlas.png', 'resource/day17_atlas.json', 1);
        }
        if (game.cache.checkImageKey('day17_2_atlas') != true) {
          game.load.atlasJSONHash('day17_2_atlas', 'resource/day17_2_atlas.png', 'resource/day17_2_atlas.json', 1);
        }
      }
      if (map_n >= 2) {
        if (game.cache.checkImageKey('background_young_rose_gift') != true) {
          game.load.image('background_young_rose_gift', 'resource/background_young_rose_gift.jpg', 1);
        }
      }
      if (level > 3) {
        if (game.cache.checkImageKey('Green_Background') != true) {
          game.load.image('Green_Background', 'resource/Green_Background.jpg', 1);
        }
      }
      if (level > 4) {
        if (game.cache.checkImageKey('build_icon_atlas') != true) {
          game.load.atlasJSONHash('build_icon_atlas', 'resource/build_icon.png', 'resource/build_icon.json', 1);
        }
      }
      if (level > 5) {
        if (game.cache.checkImageKey('unlimited_energy_atlas') != true) {
          game.load.atlasJSONHash(
            'unlimited_energy_atlas',
            'resource/unlimited_energy.png',
            'resource/unlimited_energy.json',
            1,
          );
        }
      }
      if (level > 1) {
        if (game.cache.checkImageKey('message_atlas') != true) {
          game.load.atlasJSONHash(
            'message_atlas',
            'resource/message/message_atlas.png',
            'resource/message/message_atlas.json',
            1,
          );
        }
      }
      if (level >= 20) {
        if (game.cache.checkImageKey('mayor_reward_atlas') != true) {
          game.load.atlasJSONHash(
            'mayor_reward_atlas',
            'resource/mayor_reward.png',
            'resource/mayor_reward.json',
            1,
          );
        }
      }
      if (xmas == 1) {
        level_mas = game.cache.getJSON('buildings')['XmasSetting'][0]['levels'].split(',');
        game.load.json(
          'level' + Number(level_mas[xmas_level]),
          'resource/levels/level' + Number(level_mas[xmas_level]) + '.json',
          1,
        );
        level = level_mas[xmas_level];
        if (game.cache.checkImageKey('background_h') != true) {
          game.load.image('background_h', 'resource/game/bg_xmas.jpg', 1);
        }
        backcards_select_old = backcards_select;
        backcards_select = 'Back_Cards_xmas.png';
      } else if (baloon != 1) {
        if (game.cache.checkImageKey('background1') != true) {
          game.load.image('background1', 'resource/game/bg_1.jpg', 1);
        }
        if (map_n % 8 == 2) {
          if (game.cache.checkImageKey('background2') != true) {
            game.load.image('background2', 'resource/game/bg_2.jpg', 1);
          }
        }
        if (map_n % 8 == 3) {
          if (game.cache.checkImageKey('background3') != true) {
            game.load.image('background3', 'resource/game/bg_3.jpg', 1);
          }
        }
        if (map_n % 8 == 4) {
          if (game.cache.checkImageKey('background4') != true) {
            game.load.image('background4', 'resource/game/bg_4.jpg', 1);
          }
        }
        if (map_n % 8 == 5) {
          if (game.cache.checkImageKey('background5') != true) {
            game.load.image('background5', 'resource/game/bg_5.jpg', 1);
          }
        }
        if (map_n % 8 == 6) {
          if (game.cache.checkImageKey('background6') != true) {
            game.load.image('background6', 'resource/game/bg_6.jpg', 1);
          }
        }
        if (map_n % 8 == 7) {
          if (game.cache.checkImageKey('background7') != true) {
            game.load.image('background7', 'resource/game/bg_7.jpg', 1);
          }
        }
        if (map_n % 8 == 8) {
          if (game.cache.checkImageKey('background8') != true) {
            game.load.image('background8', 'resource/game/bg_8.jpg', 1);
          }
        }
        game.load.json('level' + level, 'resource/levels/level' + level + '.json', 1);
      } else {
        if (game.cache.checkImageKey('background_b') != true) {
          game.load.image('background_b', 'resource/game/bg_baloon.jpg', 1);
        }
        level_mas = game.cache
          .getJSON('buildings')
        ['BalloonSetting'][0]['Challenge' + baloonlevel][0]['levels'].split(',');
        console.log(level_mas);
        for (var i = 0; i < level_mas.length; i++) {
          game.load.json('level' + Number(level_mas[i]), 'resource/levels/level' + Number(level_mas[i]) + '.json', 1);
        }
      }
      if (game.cache.checkImageKey('fog_atlas') != true && level > 30) {
        game.load.atlasJSONHash('fog_atlas', 'resource/fog_atlas.png', 'resource/fog_atlas.json', 1);
      }
    }
    res_load();
    game.load.start();
    game.load.onFileComplete.add(function (progress, cacheKey, success, totalLoaded, totalFiles) {
      if (load_com == 2) {
        if (success == false) {
          game.load.removeAll();
          res_load();
        }
      }
    }, this);
  },

  create: function () {
    var newDate = new Date();
    if (weekday_offers != -1 && weekday_offers != newDate.getDay()) { weekday_offers = -1; game.setUserDataAndLog({ weekday_offers: weekday_offers }); }
    level_end_check = 0;
    var p3_cards = 0;
    if (magicbeanStage > 0) {
      sunflowerStage = -1;
      game.setUserDataAndLog({ sunflowerStage: sunflowerStage });
    }
    if (game.cache.checkJSONKey('level' + level) != true) {
      game.world.removeAll(true);
      game.state.start('Game');
    }
    console.log('Level ' + level + ' loading completed: ', game.cache.checkJSONKey('level' + level));

    sdkHandler.trigger('levelStart', {
      level: level
    }, this);

    var bottom_game_group = game.add.group();
    var top_game_group = game.add.group();
    if (baloon == 1) {
      level = Number(level_mas[baloon_stage]);
      console.log('(1)Balloon level: ', level, baloon_stage, level_mas);
    }

    function draw_circle(x, y, r, col1, col2, sdv1, sdv2, par, sadow, round, sadow_n, fix) {
      var box = game.add.sprite(x + sdv1, y + sdv2, '');
      if (sadow != 0) {
        var myShadow = game.add.graphics(sdv1, sdv2);
        myShadow.beginFill(0x000000);
        if (sadow_n == 0) myShadow.drawCircle(0, 0 + sadow, r);
        else myShadow.drawCircle(0, 0, r + sadow * 2);
        myShadow.endFill();
        myShadow.alpha = 0.3;
      }
      var myBmp = game.add.bitmapData(r, r);
      var myGrd = myBmp.context.createLinearGradient(r / 2, 0, r / 2, r);
      myGrd.addColorStop(0, col1);
      myGrd.addColorStop(1, col2);
      myBmp.context.fillStyle = myGrd;
      myBmp.context.fillRect(0, 0, r, r);
      var grandientSpr = game.add.sprite(0, 0, myBmp);
      grandientSpr.anchor.setTo(0.5);
      var myMask = game.add.graphics(sdv1, sdv2);
      myMask.beginFill(0x000000);
      myMask.drawCircle(0, 0, r);
      myMask.endFill();
      grandientSpr.mask = myMask;
      if (sadow != 0) {
        box.addChild(myShadow);
      }
      box.addChild(grandientSpr);
      box.addChild(myMask);
      if (fix == 1) {
        box.fixedToCamera = true;
      }
      if (par) {
        par.addChild(box);
      }
      return box;
    }

    function draw_rect(x, y, w, h, col1, col2, sdv1, sdv2, par, sadow, round, sadow_n, fix) {
      var box = game.add.sprite(x + sdv1, y + sdv2, '');
      if (sadow != 0) {
        var myShadow = game.add.graphics(sdv1, sdv2);
        myShadow.beginFill(0x000000);
        if (sadow_n == 0) myShadow.drawRoundedRect(-w / 2, sadow - h / 2, w, h, round);
        else myShadow.drawRoundedRect(-w / 2 - sadow, -h / 2 - sadow, w + sadow * 2, h + sadow * 2, round);
        myShadow.endFill();
        myShadow.alpha = 0.3;
      }
      var myBmp = game.add.bitmapData(w, h);
      var myGrd = myBmp.context.createLinearGradient(w / 2, 0, w / 2, h);
      myGrd.addColorStop(0, col1);
      myGrd.addColorStop(1, col2);
      myBmp.context.fillStyle = myGrd;
      myBmp.context.fillRect(0, 0, w, h);
      var grandientSpr = game.add.sprite(0, 0, myBmp);
      grandientSpr.anchor.setTo(0.5);
      var myMask = game.add.graphics(sdv1, sdv2);
      myMask.beginFill(0x000000);
      myMask.drawRoundedRect(-w / 2, -h / 2, w, h, round);
      myMask.endFill();
      grandientSpr.mask = myMask;
      if (sadow != 0) {
        box.addChild(myShadow);
      }
      box.addChild(grandientSpr);
      box.addChild(myMask);
      if (fix == 1) {
        box.fixedToCamera = true;
      }
      if (par) {
        par.addChild(box);
      }
      return box;
    }

    function draw_rect_shadow(x, y, w, h, col1, col2, sdv1, sdv2, par, round, fix) {
      var box = game.add.sprite(x + sdv1, y + sdv2, '');
      for (var i = 0; i < 5; i++) {
        w += i * 2 - 2;
        h += i * 2 - 2;
        var myBmp = game.add.bitmapData(w, h);
        var myGrd = myBmp.context.createLinearGradient(w / 2, 0, w / 2, h);
        myGrd.addColorStop(0, col1);
        myGrd.addColorStop(1, col2);
        myBmp.context.fillStyle = myGrd;
        myBmp.context.fillRect(0, 0, w, h);
        var grandientSpr = game.add.sprite(0, 0, myBmp);
        grandientSpr.anchor.setTo(0.5);
        var myMask = game.add.graphics(sdv1, sdv2);
        myMask.beginFill(0x000000);
        myMask.drawRoundedRect(-w / 2, -h / 2, w, h, round);
        myMask.endFill();
        grandientSpr.mask = myMask;
        grandientSpr.alpha = 0.1 / i;
        box.addChild(grandientSpr);
        box.addChild(myMask);
      }
      if (par) {
        par.addChild(box);
      }
      if (fix == 1) {
        box.fixedToCamera = true;
      }
    }

    friend_avatar = 0;
    levels_played++;
    var last_lvl = 0;
    if (level == level_max) {
      last_lvl = 1;
    }
    var level_num = String(level);
    while (level_num.length < 4) {
      level_num = String('0' + String(level_num));
    }

    // app.ddna.missionTracker.trackMissionStart({
    //   levelNumber: level,
    //   starsGained: 0,
    //   retriesIteration,
    //   difficulty: 0,
    //   entryFriendId: pre_helper == 1 ? context_id : null,
    //   isHard: false,
    //   moves:
    //     baloon == 1
    //       ? Number(game.cache.getJSON('buildings')['BalloonSetting'][0]['Challenge' + baloonlevel][0]['moves']) - 1
    //       : Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['CardsDeckCol']) - 1,
    // });
    retriesIteration++;
    game.setUserDataAndLog({ retriesIteration: retriesIteration });

    if (fbv == 1) {
      game.setCurrentEvent();
      if (baloon == 1)
        window.eventTrack('level_start_balloon', 1, {
          nr: baloonlevel,
          lvl: level_num,
          count: levels_played,
          replayed: replayed != 0 ? 1 : 0,
          pre_helper: pre_helper,
          moves:
            Number(game.cache.getJSON('buildings')['BalloonSetting'][0]['Challenge' + baloonlevel][0]['moves']) - 1,
          user_type: bought,
          lifetime: lifetime_day,
          mission_completed: missioncompleted,
          c_event: current_event,
        });
      else
        window.eventTrack('level_start', 1, {
          nr: level_num,
          last_lvl: last_lvl,
          count: levels_played,
          replayed: replayed != 0 ? 1 : 0,
          pre_helper: pre_helper,
          moves: Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['CardsDeckCol']) - 1,
          user_type: bought,
          lifetime: lifetime_day,
          mission_completed: missioncompleted,
          c_event: current_event,
        });
    }
    if (level == 1) {
      if (fbv == 1) {
        window.eventTrack('FTUE_2_1_BoardLoadedAndVisible');
      }
    } else if (level == 2) {
      if (fbv == 1) {
        window.eventTrack('FTUE_4_1_BoardLoadedAndVisible');
      }
    } else if (level == 3) {
      if (fbv == 1) {
        window.eventTrack('FTUE_6_1_BoardLoadedAndVisible');
      }
    } else if (level == 4) {
      if (fbv == 1) {
        window.eventTrack('FTUE_8_1_BoardLoadedAndVisible');
      }
    } else if (level == 5) {
      if (fbv == 1) {
        window.eventTrack('FTUE_10_1_BoardLoadedAndVisible');
      }
    }

    window.winlevel = function () {
      cards_group.removeAll(true);
      game_win();
      game_loss();
    };

    window.winlevelm = function () {
      for (var j = 0; j < cards_group.length; j++) {
        var setcarddraw = game.rnd.integerInRange(1, 52);
        if (level >= 6)
          for (var i = 0; i < missions.length; i += 4) {
            if (missions[i] == -1) {
              if (setcarddraw >= 14 && setcarddraw <= 26) {
                if (missions[i + 2] < missions[i + 1]) {
                  missions[i + 2] += 1;
                }
              }
            }
            if (missions[i] == -6) {
              if (setcarddraw >= 1 && setcarddraw <= 13) {
                if (missions[i + 2] < missions[i + 1]) {
                  missions[i + 2] += 1;
                }
              }
            }
            if (missions[i] == -7) {
              if (setcarddraw >= 27 && setcarddraw <= 39) {
                if (missions[i + 2] < missions[i + 1]) {
                  missions[i + 2] += 1;
                }
              }
            }
            if (missions[i] == -8) {
              if (setcarddraw >= 40 && setcarddraw <= 52) {
                if (missions[i + 2] < missions[i + 1]) {
                  missions[i + 2] += 1;
                }
              }
            }
            if (missions[i] == -9) {
              if (setcarddraw >= 1 && setcarddraw <= 52) {
                if (missions[i + 2] < missions[i + 1]) {
                  missions[i + 2] += 1;
                }
              }
            }
            if (missions[i] == -12) {
              if (setcarddraw == 11 || setcarddraw == 24 || setcarddraw == 37 || setcarddraw == 50) {
                if (missions[i + 2] < missions[i + 1]) {
                  missions[i + 2] += 1;
                }
              }
            }
            if (missions[i] == -13) {
              if (setcarddraw == 12 || setcarddraw == 25 || setcarddraw == 38 || setcarddraw == 51) {
                if (missions[i + 2] < missions[i + 1]) {
                  missions[i + 2] += 1;
                }
              }
            }
            if (missions[i] == -14) {
              if (setcarddraw == 13 || setcarddraw == 26 || setcarddraw == 39 || setcarddraw == 52) {
                if (missions[i + 2] < missions[i + 1]) {
                  missions[i + 2] += 1;
                }
              }
            }
            if (missions[i] == -15) {
              if (setcarddraw == 1 || setcarddraw == 14 || setcarddraw == 27 || setcarddraw == 40) {
                if (missions[i + 2] < missions[i + 1]) {
                  missions[i + 2] += 1;
                }
              }
            }
          }
      }
      cards_group.removeAll(true);
      game_win();
      game_loss();
    };
    if (sound_on == 1) {
      play_sound('level_started_jingle');
    }
    w = 0;
    function ftue_window(sprite, t, xxx, yyy, b) {
      if (!b) {
        black_sprite = game.add.sprite(game.world.centerX, game.world.centerY, 'message_invite_mask');
        black_sprite.width = game.world.width;
        black_sprite.height = game.world.height;
        black_sprite.anchor.setTo(0.5);
        black_sprite.alpha = 0;
        game.add
          .tween(black_sprite)
          .to({ alpha: 0.8 }, 500, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) { });
      }
      popup = 1;
      var Dialog_Bubble = draw_rect(xxx, yyy, 1430, 252, '#FAF7F0', '#FAF0D8', 0, 0, 0, 5, 30, 0);
      Dialog_Bubble.fixedToCamera = true;
      Dialog_Bubble.scale.setTo(0);
      Dialog_Bubble.alpha = 0;
      Dialog_Bubble.obj = 0;
      var man1_back = draw_circle(-863 + 200, 160 / 2 + 70 - 292 / 2, 292, '#FAF7EF', '#FAF7EF', 0, 0, 0, 5, 0, 0, 0);
      draw_circle(0, 0, 270, '#DBC2A8', '#AC7C64', 0, 0, man1_back, 0, 0, 0, 0);
      Dialog_Bubble.addChild(man1_back);
      var man1 = game.add.sprite(-863 + 160, 160 / 2 + 62, 'game_ui_atlas', 'Character.png');
      man1.anchor.setTo(0.5, 1);
      man1.scale.setTo(0.8, 0);
      Dialog_Bubble.addChild(man1);
      var dialog_text = game.add.text(-450, 0, t, {
        font: '42px RussoOne',
        fill: '#C27E54',
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 1100,
      });
      dialog_text.anchor.setTo(0, 0.5);
      Dialog_Bubble.addChild(dialog_text);
      /*var Read_More_Button = game.add.sprite(620, 80, 'game_ui_atlas', 'Read_More_Button.png');
        Read_More_Button.anchor.setTo(0.5);
        Dialog_Bubble.addChild(Read_More_Button);
        game.add.tween(Read_More_Button).to( { y: '-10' }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);*/
      game.add.tween(man1.scale).to({ y: 0.8 }, 1000, Phaser.Easing.Elastic.Out, true, 200);
      game.add.tween(Dialog_Bubble.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Exponential.Out, true);
      game.add.tween(Dialog_Bubble).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true);

      if (game.device.desktop)
        var dialog_text = game.add.text(1000, 1000, game.cache.getJSON('lang')['t460'][0][window.lang], {
          font: '56px RussoOne',
          fill: '#fff',
          align: 'left',
        });
      else
        var dialog_text = game.add.text(1000, 1000, game.cache.getJSON('lang')['t250'][0][window.lang], {
          font: '56px RussoOne',
          fill: '#fff',
          align: 'left',
        });
      dialog_text.anchor.setTo(0);
      dialog_text.alpha = 0;
      Dialog_Bubble.addChild(dialog_text);
      game.add.tween(dialog_text).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 500);
      return Dialog_Bubble;
    }
    game.input.onDown.add(function () {
      if (
        w != 0 &&
        (level == 3 ||
          level == 10 ||
          (level == 2 && joker_first == -1) ||
          (baloon == 1 && free_booster_spec < 0 && FTUE_Arrow == 0) ||
          booster4 != 0)
      ) {
        if (level == 2 && joker_first == -1) {
          joker_first = -2;
          if (FTUE_Arrow != 0) {
            FTUE_Arrow.destroy();
            FTUE_Arrow = 0;
          }
        }
        if (FTUE_Arrow != 0 && level != 1 && level != 2) {
          FTUE_Arrow.destroy();
          FTUE_Arrow = 0;
        }
        game.add
          .tween(w)
          .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
          .onComplete.add(function (item) {
            if (item.obj != 0) {
              item.obj.destroy();
            }
            item.destroy();
            animation = 0;
            popup = 0;
            if (baloon == 1 && free_booster_spec < 0 && FTUE_Arrow == 0) {
              animation = 1;
              popup = 1;
              w = ftue_window(
                'Main_Presenting.png',
                game.cache.getJSON('lang')['t487'][0][window.lang],
                game.camera.width / 2,
                game.camera.height / 2 - 300,
                1,
              );
              if (sound_on == 1) {
                play_sound('hint_with_arrow');
              }
              FTUE_Arrow = game.add.sprite(booster_spec.x, booster_spec.y - 20, 'game_atlas', 'FTUE_Arrow.png');
              FTUE_Arrow.anchor.setTo(0.5, 1.6);
              FTUE_Arrow.alpha = 0;
              game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
              game.add
                .tween(FTUE_Arrow.anchor)
                .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                .yoyo(true, 200);
            }
          });
        game.add
          .tween(black_sprite)
          .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
          .onComplete.add(function (item) {
            item.destroy();
          });
        w = 0;
      }
    });
    for (var m = 0; m < angl_mas.length; m++) {
      angl_mas2[m] = angl_mas[m].angle;
    }
    function levelfinish() {
      cards_group.removeAll(true);
      game_win();
      game_loss();
    }
    popup = 0;
    is_map = 0;
    suitcase_label = 0;
    game.resizeGame();
    {
      animation = 1;
      var combo = 0;
      var suitcase_close = 0;
      cards_deck = [];
      deck_n = 0;
      deck_col = 3;
      cards_discarded = [];
      destroy_cards = [];
      hazard_cards = [];
      start_card_mas = [];
      start_card_mas2 = [];
      cards_deck_col = 30;
      coins_reward = 0;
      UI_EndGame_btn = 0;
      var booster1_price = 100;
      var booster2_price = 200;
      var booster3_price = 600;
      var booster4_price = 400;
      var booster_tnt_price = 850;
      var booster_eye_price = 400;
      var booster_shuffle_price = 300;
      var booster_timestop_price = 225;
      var booster_spec_price = 100;
      function gameTracking(string, ftuen) { }

      if (xmas == 1) {
        game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background_h');
      } else if (baloon != 1) {
        game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background1');
        if (map_n % 8 == 1) game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background1');
        else if (map_n % 8 == 2)
          game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background2');
        else if (map_n % 8 == 3)
          game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background3');
        else if (map_n % 8 == 4)
          game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background4');
        else if (map_n % 8 == 5)
          game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background5');
        else if (map_n % 8 == 6)
          game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background6');
        else if (map_n % 8 == 7)
          game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background7');
        else if (map_n % 8 == 8)
          game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background8');
      } else game.background = game.add.sprite(game.world.centerX, game.world.centerY, 'background_b');
      game.background.anchor.setTo(0.5);
      let w_back = game.world.width / game.background.width;
      let h_back = game.world.height / game.background.height;
      if (w_back > 1) game.background.scale.setTo(w_back);
      if (game.world.height / game.background.height > 1)
        game.background.scale.setTo(game.background.scale.x - 1 + h_back);
      var bottom_bar = game.add.sprite(game.world.centerX, game.world.height, 'game_atlas', 'bottom_bar.png');
      bottom_bar.anchor.setTo(0.5, 1);
      bottom_bar.scale.setTo(2.1, 1.5);
      if (music != 0) {
        music.destroy();
      }
      music = game.add.audio('gameplay_music', 1, true);
      music.volume = 0.2;
      music.play();
      if (music_on == 0) {
        music.pause();
      };
      if (xmas == 1) {
        if (Number(game.cache.getJSON('buildings')['XmasSetting'][0]['cards'].split(',')[xmas_level]) != 0)
          cards_deck_col = Number(game.cache.getJSON('buildings')['XmasSetting'][0]['cards'].split(',')[xmas_level]);
        else
          cards_deck_col = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['CardsDeckCol']);
        var card_col_sum = 1;
        while (typeof game.cache.getJSON('level' + level)['Card' + card_col_sum + 'Stage1'] !== 'undefined') {
          card_col_sum++;
        }
        deck_col = Math.ceil((cards_deck_col + card_col_sum) / 52);
      }
      else
        if (baloon != 1) {
          cards_deck_col = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['CardsDeckCol']);
          var card_col_sum = 1;
          while (typeof game.cache.getJSON('level' + level)['Card' + card_col_sum + 'Stage1'] !== 'undefined') {
            card_col_sum++;
          }
          deck_col = Math.ceil((cards_deck_col + card_col_sum) / 52);
        } else if (baloon_stage == 0) {
          deck_col = 5;
          cards_deck_col = Number(
            game.cache.getJSON('buildings')['BalloonSetting'][0]['Challenge' + baloonlevel][0]['moves'],
          );
        }
      var WinStreak = 5;
      var star1 = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['star1']);
      var star2 = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['star2']);
      var star3 = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['star3']);
      var prize3 = level == 83 ? 200 : level == 75 ? 100 : 25;

      if (free_prebooster1_select == 1) {
        free_three += 5;
        free_prebooster1_select = 0;
        if (level != 12) {
          free_prebooster1 -= 1;
          game.setUserDataAndLog({ free_prebooster1: free_prebooster1 });
        }
      }

      if (free_three > 0) {
        deck_col += 1;
      }

      for (var i = 0; i < cards_deck_col - 1; i++) {
        cards_deck[i] = 0;
      }
      window.joker_stat = function () {
        if (booster3_price_text != 0) {
          booster3_price_text.destroy();
        }
        if (booster3_coin != 0) {
          booster3_coin.destroy();
        }
        if (free_joker > 0 || shop == 0) {
          if (free_joker > 0)
            booster3_price_text = game.add.text(
              game.world.centerX + 560 + booster3.width / 2,
              game.world.height - 18,
              game.cache.getJSON('lang')['FREE'][0][window.lang] + ' x' + free_joker,
              { font: '26px RussoOne', fill: '#fff', align: 'center' },
            );
          else
            booster3_price_text = game.add.text(
              game.world.centerX + 560 + booster3.width / 2,
              game.world.height - 18,
              booster3_price,
              { font: '26px RussoOne', fill: '#fff', align: 'center' },
            );
          booster3_price_text.stroke = '#000';
          booster3_price_text.strokeThickness = 3;
          booster3_price_text.anchor.setTo(0.5, 0.5);
          if (baloon == 1) bottom_game_group.add(booster3_price_text);
          booster3_coin = game.add.sprite(
            game.world.centerX + 560 + booster3.width / 2 - booster3_price_text.width / 2 - 16,
            game.world.height - 20,
            'game_atlas',
            'icon_coins.png',
          );
          booster3_coin.anchor.setTo(0.5, 0.5);
          booster3_coin.scale.setTo(0.7);
          if (baloon == 1) bottom_game_group.add(booster3_coin);
        } else {
          booster3_price_text = game.add.sprite(
            booster3.width / 2 - 20,
            booster3.height / 2 - 20,
            'game_ui_atlas',
            'Get_Coins_Plus_Button.png',
          );
          booster3_price_text.scale.setTo(0.7);
          booster3_price_text.anchor.setTo(0.5);
          booster3.addChild(booster3_price_text);
        }
      };
      var booster6_price_text = 0;
      var booster6_coin = 0;
      var booster_spec = 0;
      window.special_stat = function () {
        if (booster6_price_text != 0) {
          booster6_price_text.destroy();
        }
        if (booster6_coin != 0) {
          booster6_coin.destroy();
        }
        if (free_booster_spec > 0 || free_booster_spec < 0 || shop == 0) {
          if (free_booster_spec > 0 || free_booster_spec < 0)
            booster6_price_text = game.add.text(
              game.world.centerX + 560 + booster_spec.width / 2,
              game.world.height - 18,
              game.cache.getJSON('lang')['FREE'][0][window.lang] + ' x' + Math.abs(free_booster_spec),
              { font: '26px RussoOne', fill: '#fff', align: 'center' },
            );
          else
            booster6_price_text = game.add.text(
              game.world.centerX + 560 + booster_spec.width / 2,
              game.world.height - 18,
              booster_spec_price,
              { font: '26px RussoOne', fill: '#fff', align: 'center' },
            );
          booster6_price_text.stroke = '#000';
          booster6_price_text.strokeThickness = 3;
          booster6_price_text.anchor.setTo(0.5, 0.5);
          booster6_coin = game.add.sprite(
            game.world.centerX + 560 + booster_spec.width / 2 - booster6_price_text.width / 2 - 16,
            game.world.height - 20,
            'game_atlas',
            'icon_coins.png',
          );
          booster6_coin.anchor.setTo(0.5, 0.5);
          booster6_coin.scale.setTo(0.7);
        } else {
          booster6_price_text = game.add.sprite(
            booster_spec.width / 2 - 35,
            booster_spec.height / 2 - 35,
            'game_ui_atlas',
            'Get_Coins_Plus_Button.png',
          );
          booster6_price_text.scale.setTo(0.7);
          booster6_price_text.anchor.setTo(0.5);
          booster_spec.addChild(booster6_price_text);
          //booster6_price_text.y += 400;
        }
      };
      if (level > 1) {
        if (level > 5 || baloon == 1) {
          var booster3 = game.add.sprite(
            game.world.centerX + 560 + 60,
            game.world.height - 164 + 63,
            'game_atlas',
            'Joker_Boost.png',
          );
          booster3.b = 3;
          booster3.anchor.setTo(0.5);
          if (baloon == 1) bottom_game_group.add(booster3);
          button_animation_f(booster3, 1);
          booster3.events.onInputDown.add(function (itm) {
            btnup(itm);
            booster_active(itm);
          }, this);
          var booster3_price_text = 0;
          var booster3_coin = 0;
          joker_stat();
        }
        booster5 = game.add.sprite(
          game.world.centerX + 400 + 60,
          game.world.height - 164 + 63,
          'game_atlas',
          'booster_3_prev_off.png',
        );
        booster5.b = 5;
        booster5.anchor.setTo(0.5);
        if (baloon == 1) bottom_game_group.add(booster5);
        booster5.off = 1;
        button_animation_f(booster5, 1);
        booster5.events.onInputDown.add(function (itm) {
          btnup(itm);
          booster_active(itm);
        }, this);
        if (free_cardback > 0)
          var booster5_price_text = game.add.text(
            game.world.centerX + 400 + booster5.width / 2,
            game.world.height - 18,
            game.cache.getJSON('lang')['FREE'][0][window.lang] + ' x' + free_cardback,
            { font: '26px RussoOne', fill: '#fff', align: 'center' },
          );
        else
          var booster5_price_text = game.add.text(
            game.world.centerX + 400 + booster5.width / 2,
            game.world.height - 18,
            booster1_price,
            { font: '26px RussoOne', fill: '#fff', align: 'center' },
          );
        booster5_price_text.stroke = '#000';
        booster5_price_text.strokeThickness = 3;
        booster5_price_text.anchor.setTo(0.5, 0.5);
        if (baloon == 1) bottom_game_group.add(booster5_price_text);
        var booster5_coin = game.add.sprite(
          game.world.centerX + 400 + booster5.width / 2 - booster5_price_text.width / 2 - 16,
          game.world.height - 20,
          'game_atlas',
          'icon_coins.png',
        );
        booster5_coin.anchor.setTo(0.5);
        booster5_coin.scale.setTo(0.7);
        if (baloon == 1) bottom_game_group.add(booster5_coin);
      }
      if (baloon == 1) {
        booster_spec = game.add.sprite(
          game.world.centerX + 560 + 60,
          game.world.height - 164 + 63,
          'game_atlas',
          'Magnifier_Booster.png',
        );
        booster_spec.anchor.setTo(0.5);
        booster_spec.b = 6;
        button_animation_f(booster_spec, 1);
        booster_spec.events.onInputDown.add(function (itm) {
          btnup(itm);
          booster_active(itm);
        }, this);
        special_stat();
        booster_spec.y += 400;
        if (free_booster_spec > 0 || free_booster_spec < 0 || shop == 0) {
          booster6_price_text.y += 400;
          booster6_coin.y += 400;
        }
      }

      function windows_f(name, s) {
        var popup_back = game.add.sprite(game.camera.width / 2, game.camera.height / 2, '');
        popup_group.add(popup_back);
        popup_back.fixedToCamera = true;
        var popup_back2 = draw_rect(0, 0, 930, 790, '#FBF7E6', '#E6C077', 0, 0, 0, 5, 40, 0);
        draw_rect_shadow(0, 0, 894, 750, '#000', '#000', 0, 0, popup_back2, 30);
        draw_rect(0, 0, 894, 750, '#FBF9F6', '#F7EED4', 0, 0, popup_back2, 0, 30, 0);
        popup_back.addChild(popup_back2);
        if (s == 1) {
          var Pop_Up_Image = game.add.sprite(0, -50, 'game_window_atlas', 'Pop_Up_Image.png');
          Pop_Up_Image.scale.setTo(2);
          Pop_Up_Image.anchor.setTo(0.5);
          popup_back.addChild(Pop_Up_Image);
        } else if (s == 2) {
          var Pop_Up_Image = game.add.sprite(0, -90, 'game_window_atlas', 'Background.png');
          Pop_Up_Image.scale.setTo(2);
          Pop_Up_Image.anchor.setTo(0.5);
          popup_back.addChild(Pop_Up_Image);
        }
        if (s == 33) var pop_up_header = game.add.sprite(-5, -394, 'magicbean_atlas', 'Header.png');
        else if (s == 3) var pop_up_header = game.add.sprite(-5, -364, 'baloon_atlas', 'Pup_Up_Header.png');
        else var pop_up_header = game.add.sprite(0, -4, 'game_window_atlas', 'Pop_Up_Header.png');
        pop_up_header.anchor.setTo(0.5);
        pop_up_header.scale.setTo(2);
        popup_back.addChild(pop_up_header);
        pop_up_header.tint = 0x2BB5DC;
        let text_group = game.add.group();
        popup_back.addChild(text_group);
        let www = 0;
        for (var i = 0; i < name.length; i++) {
          if (s == 3 || s == 33)
            var text_popup_title = game.add.text(www, -320 - 120 - 40, name[i], {
              font: '48px RussoOne',
              fill: '#fff',
              align: 'left',
            });
          else
            var text_popup_title = game.add.text(www, -320 - 120, name[i], {
              font: '48px RussoOne',
              fill: '#fff',
              align: 'left',
            });
          text_popup_title.anchor.setTo(0, 0.5);
          text_group.add(text_popup_title);
          text_popup_title.stroke = '#0D6A96';
          text_popup_title.strokeThickness = 4;
          text_popup_title.setShadow(0, 4, 'rgba(13,106,150,0.9)', 0);
          www += text_popup_title.width - 4;
          text_popup_title.alpha = 0;
          game.add.tween(text_popup_title).to({ alpha: 1 }, 300, Phaser.Easing.Exponential.In, true, 50 * i);
          game.add.tween(text_popup_title).to({ y: '+120' }, 500, Phaser.Easing.Exponential.Out, true, 50 * i);
        }
        text_group.x -= www / 2;
        var popup_close = game.add.sprite(930 / 2 - 20, -790 / 2 + 20, 'game_window_atlas', 'Close_Button.png');
        popup_close.anchor.setTo(0.5);
        button_animation_f(popup_close, 1);
        popup_close.events.onInputUp.add(function (itm) {
          btnup(itm);
          if (popup != 2) {
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup = 0;
                popup_group.y -= game.camera.height;
              });
          }
        }, this);
        popup_back.addChild(popup_close);
        return popup_back;
      }
      var cards_group = game.add.group();
      var generation = 0;
      var wild_cards = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['WildCol']);
      var hazard_card = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['HazardCol']);
      var max_depth = 0;
      var delay = 2300;
      var card_n = 1;
      var water_n = 0;
      var card = 0;
      var card_active = 0;
      var bcard = 0;
      var card_size = 1.4;
      function shuffle_card(array) {
        for (let i = array.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
      }
      window.baloon_level_select = function (plus) {
        popup_group.y = 0;
        if (plus == 1) {
          baloon_stage += 0.5;
          level_bar_text.setText(Number(baloon_stage + 1) + '/' + level_mas.length);
          del_cards = 0;
          //let cropRect = new Phaser.Rectangle(0, 0, 0, Level_Bar.height);
          //Level_Bar.crop(cropRect);
        } else {
          baloon_stage += 0.5;
        }
        popup = 1;
        animation = 1;
        blackf();
        var all_nod = game.add.sprite(game.world.centerX, game.world.centerY, '');
        all_nod.alpha = 0;
        popup_group.add(all_nod);
        for (var i = 0; i < level_mas.length; i++) {
          var nod = game.add.sprite(0, i * 350, 'baloon_atlas', 'Nod.png');
          nod.anchor.setTo(0.5);
          all_nod.addChild(nod);
          let nod_text = game.add.text(0, -50, 'LV' + Number(level_mas.length - i), {
            font: '44px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          nod_text.anchor.setTo(0.5);
          nod_text.stroke = '#8954AC';
          nod_text.strokeThickness = 6;
          nod.addChild(nod_text);
          if (baloon_stage + 1 < level_mas.length - i) {
            nod.loadTexture('baloon_atlas', 'NodGrey.png');
            nod_text.alpha = 0.5;
          }
          if (i < level_mas.length && i != 0) {
            var chest = game.add.sprite(0, i * 350 - 175, 'baloon_atlas', 'Big_Chest.png');
            chest.anchor.setTo(0.5);
            chest.scale.setTo(0.45);
            all_nod.addChild(chest);
            if (baloon_stage + 0.5 < level_mas.length - i) {
              chest.alpha = 0.5;
            }
          }
        }
        game.add.tween(all_nod).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
        if (baloon_stage == 0.5) {
          all_nod.y -= (level_mas.length - 1) * 350;
        } else {
          all_nod.y -= (level_mas.length - 1) * 350 - baloon_stage * 350 + 175;
        }
        game.add
          .tween(all_nod)
          .to({ y: '+175' }, 1000, Phaser.Easing.Linear.None, true, 500)
          .onComplete.add(function () {
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(popup_group)
              .to({ alpha: 0 }, 1000, Phaser.Easing.Quadratic.Out, true)
              .onComplete.add(function (item) {
                popup_group.removeAll(true);
                popup_group.alpha = 1;
                popup_group.y -= game.camera.height;
                array222 = 0;
                missions_tab_open = 0;
                if (plus == 1) {
                  prize_mas = [0, 0, 0, 0, 0, 0, 0];
                  if (baloon_stage < level_mas.length) {
                    card_deck.scale.setTo(1.4);
                    game.add.tween(bottom_game_group).to({ y: '-400' }, 500, Phaser.Easing.Linear.None, true);
                    game.add.tween(booster_spec).to({ y: '+400' }, 500, Phaser.Easing.Linear.None, true);
                    if (free_booster_spec > 0 || free_booster_spec < 0 || shop == 0) {
                      game.add.tween(booster6_price_text).to({ y: '+400' }, 500, Phaser.Easing.Linear.None, true);
                      game.add.tween(booster6_coin).to({ y: '+400' }, 500, Phaser.Easing.Linear.None, true);
                    }
                    game.add.tween(top_game_group).to({ y: '+400' }, 500, Phaser.Easing.Linear.None, true);
                    level = Number(level_mas[baloon_stage]);
                    console.log('(2)Balloon level: ', level, baloon_stage, level_mas);
                    game.add.tween(effects_group).to({ alpha: 1 }, 100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      let old_card = card;
                      cards_create();
                      cards_generation();
                      card = old_card;
                      game.add.tween(effects_group).to({ alpha: 1 }, delay + 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                        if (baloon_stage == 0) visible_cards(1);
                        else {
                          popup = 0;
                          animation = 0;
                          visible_cards(0);
                        }
                      });
                    });
                  } else {
                  }
                } else {
                  popup = 0;
                  animation = 0;
                }
              });
          });
        var arrow = game.add.sprite(game.world.centerX - 130, game.world.centerY, 'baloon_atlas', 'Arrow.png');
        arrow.anchor.setTo(0.5);
        arrow.alpha = 0;
        popup_group.add(arrow);
        game.add.tween(arrow).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
        var balloon = game.add.sprite(game.world.centerX - 250, game.world.centerY - 50, 'baloon_atlas', 'Balloon.png');
        balloon.anchor.setTo(0.5);
        balloon.scale.setTo(0);
        popup_group.add(balloon);
        game.add.tween(balloon.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true);
        game.add.tween(balloon).to({ y: '+10' }, 1000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 0);
      };
      var first_click = 0;
      function bonus_cards_create() {
        first_click = 0;
        bonus_cards_lost = -1;
        card_size = 1.2;
        cards_group.removeAll(true);
        var bonus_cards = 12;
        var type_cards = [
          0,
          get_random_change([50, 100, 250]),
          get_random_change([50, 100, 250]),
          get_random_change([50, 100, 250]),
          get_random_change([50, 100, 250, 500]),
          get_random_change([50, 100, 250, 1000, 2000]),
          0,
          get_random_change([2, 3]),
          get_random_change([2, 4, 5]),
          get_random_change([2, 6, 7]),
          get_random_change([50, 50, 100, 250]),
          get_random_change([50, 50, 100, 250]),
        ]; //coins,energy,joker,freecards,undomove,tnt,suffle,eye
        shuffle_card(type_cards);
        var mas_x = [300, 100, -300, 0, 0, -300, -350, 300, 350, -100, -600, 600];
        var mas_y = [260, 530, 260, 800, 260, 800, 530, 800, 530, 530, 530, 530];
        delay = 500;
        game.world.bringToTop(cards_group);
        while (bonus_cards > 0) {
          bcard = game.add.sprite(
            game.world.centerX + mas_x[bonus_cards - 1],
            mas_y[bonus_cards - 1],
            'baloon_atlas',
            'Back.png',
          );
          bcard.depth = 1;
          bcard.vis = 0;
          bcard.angle = 0;
          bcard.value = type_cards[bonus_cards - 1];
          bcard.draw = 0;
          bcard.inputEnabled = true;
          bcard.events.onInputDown.add(function (item) {
            card_bonus_select(item, 0);
          }, this);
          bcard.anchor.setTo(0.5, 0.5);
          bcard.hazard_type = 0;
          bcard.ht = 0;
          bcard.hazard_timer = 0;
          bcard.n = 0;
          bcard.input.useHandCursor = true;
          //bcard.input.priorityID = 10;
          if (game.world.height > 1080) {
            bcard.y += (game.world.height - 1080) / 2;
          }
          bcard.x1 = bcard.x;
          bcard.y1 = bcard.y;
          bcard.ang = bcard.angle;
          bcard.chek = 0;
          bcard.scale.setTo(card_size);
          bcard.realwidth = bcard.width;
          cards_group.add(bcard);
          var bcard_mask = game.add.graphics(0, 0);
          bcard_mask.beginFill(0xffffff);
          bcard_mask.drawRect(
            bcard.x1 - bcard.width / 2 + 4,
            bcard.y1 - bcard.height / 2 + 4,
            bcard.width - 8,
            bcard.height - 12,
          );
          var bcard_effect = game.add.graphics(bcard.x1 - 30, bcard.y1 - 230);
          bcard_effect.beginFill(0xfbf182);
          bcard_effect.drawRect(0, -20, 50, bcard.height + 40);
          bcard_effect.angle = 45;
          bcard_effect.mask = bcard_mask;
          bcard.effect = bcard_effect;
          bcard_effect.alpha = 0;
          bcard.spark = 0;
          bcard.scale.setTo(card_size + 0.2);
          bcard.x -= 2000;
          bcard.y += game.rnd.integerInRange(-100, 100);
          bcard.angle -= 270;
          animation = 1;
          popup = 1;
          var tween = game.add
            .tween(bcard)
            .to(
              {
                x: [bcard.x, bcard.x, bcard.x1 + 250, bcard.x1],
                y: [bcard.y, bcard.y, bcard.y1 - 400, bcard.y1],
              },
              1000,
              Phaser.Easing.Quadratic.Out,
              true,
              delay,
            )
            .interpolation(function (v, k) {
              return Phaser.Math.bezierInterpolation(v, k);
            });
          tween.onComplete.add(function (item) {
            game.add.tween(item.scale).to({ x: '-0.2', y: '-0.2' }, 200, Phaser.Easing.Bounce.Out, true);
            add_shines(item, -1, 0);
            item.effect.alpha = 0;
            var twn = game.add
              .tween(item.effect)
              .to({ alpha: 0 }, 100, Phaser.Easing.Linear.None, true, game.rnd.integerInRange(500, 1000));
            twn.onComplete.add(function (item) {
              let p = game.rnd.integerInRange(1500, 3500);
              game.add
                .tween(item)
                .to({ x: '+200', y: '+240' }, 1000, Phaser.Easing.Linear.None, true, p)
                .onComplete.add(function (item) {
                  item.x -= 200;
                  item.y -= 240;
                  twn.start();
                });
              game.add.tween(item).to({ alpha: 0.6 }, 500, Phaser.Easing.Linear.None, true, p).yoyo(true, 0);
            }, this);
          });
          game.add.tween(bcard).to({ angle: bcard.ang }, 500, Phaser.Easing.Linear.None, true, delay);
          delay += game.rnd.integerInRange(50, 150);
          bonus_cards -= 1;
        }
        game.add.tween(effects_group).to({ alpha: 1 }, delay + 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          bonus_cards_lost = 0;
          if (baloon_stage < 1 && free_booster_spec < 0) {
            w = ftue_window(
              'Main_Presenting.png',
              game.cache.getJSON('lang')['t464'][0][window.lang],
              game.camera.width / 2,
              game.camera.height / 2 - 300,
              1,
            );
          } else {
            popup = 0;
            animation = 0;
          }
        });
      }
      var bonus_cards_lost = 0;
      var bonus_cards_group = game.add.group();
      var prize_mas = [0, 0, 0, 0, 0, 0, 0];
      function card_bonus_select(itm, n) {
        if ((itm.vis == 0 && animation == 0 && popup == 0 && bonus_cards_lost == 0) || n == 1) {
          itm.effect.scale.setTo(0);
          itm.spark = 1;
          if ((first_click < 4 && baloonlevel == 1) || (first_click < 1 && baloonlevel != 1)) {
            while (itm.value == 0) {
              let pr = cards_group.getRandom();
              let pr_v = pr.value;
              pr.value = itm.value;
              itm.value = pr_v;
            }
          }
          if (itm.frameName == 'Back.png') {
            first_click++;
          }
          animation = 1;
          var spr = 0;
          var col = 0;
          if (itm.value == 0) {
            spr = 'Bomb.png';
          } else if (itm.value == 2) {
            spr = 'Energy.png';
            col = 1;
          } else if (itm.value == 3) {
            spr = 'Joker.png';
            col = 1;
          } else if (itm.value == 4) {
            spr = 'Extra_Card.png';
            col = 1;
          } else if (itm.value == 5) {
            spr = 'Undo.png';
            col = 1;
          } else if (itm.value == 6) {
            spr = 'TNT.png';
            col = 1;
          } else if (itm.value == 7) {
            spr = 'Shuffle.png';
            col = 1;
          } else if (itm.value == 50) {
            spr = '50_Coins.png';
            col = 50;
          } else if (itm.value == 100) {
            spr = '100_Coins.png';
            col = 100;
          } else if (itm.value == 250) {
            spr = '250_Coins.png';
            col = 250;
          } else if (itm.value == 500) {
            spr = '500_Coins.png';
            col = 500;
          } else if (itm.value == 1000) {
            spr = '1000_Coins.png';
            col = 1000;
          } else if (itm.value == 2000) {
            spr = '2000_Coins.png';
            col = 2000;
          }
          itm.vis = 1;
          if (col != 0) {
            let ctext = game.add.text(0, 60, 'x' + col, { font: '36px RussoOne', fill: '#fff', align: 'center' });
            ctext.anchor.setTo(0.5);
            ctext.setShadow(0, 5, 'rgba(0,0,0,0.5)', 5);
            itm.addChild(ctext);
          }
          itm.loadTexture('baloon_atlas', spr, 0);
          itm.scale.setTo(1);
          itm.cc = itm.frameName;
          itm.loadTexture('baloon_atlas', 'Back.png', false);
          game.add.tween(itm.scale).to({ x: 0, y: card_size + 0.05 }, 100, Phaser.Easing.Linear.None, true);
          game.add
            .tween(itm)
            .to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              item.loadTexture('baloon_atlas', spr, false);
              game.add
                .tween(item.scale)
                .to({ x: card_size, y: card_size }, 50, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  if (bonus_cards_lost == 0) {
                    if (col == 0 || cards_group.length <= 3) {
                      bonus_cards_lost = 1;
                      game.add
                        .tween(itm)
                        .to({ angle: '-5' }, 25, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          game.add
                            .tween(itm)
                            .to({ angle: '+10' }, 50, Phaser.Easing.Linear.None, true, 0, -1)
                            .yoyo(true, 0);
                        });
                      game.add
                        .tween(itm.scale)
                        .to({ x: card_size + 0.2, y: card_size + 0.2 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          emitter.bringToTop = true;
                          emitter.minParticleSpeed.set(-500, -500);
                          emitter.maxParticleSpeed.set(500, 500);
                          emitter.x = itm.x;
                          emitter.y = itm.y;
                          emitter.start(true, 600, 0, 50);
                          itm.destroy();
                        });
                      game.add
                        .tween(itm.scale)
                        .to({ x: card_size + 0.1, y: card_size + 0.1 }, 200, Phaser.Easing.Linear.None, true, 0, 0)
                        .yoyo(true, 0);
                      //game.add.tween(itm.shine.scale).to( { x: 1.4, y: 1.4 }, 500, Phaser.Easing.Linear.None, true);
                      itm.effect.scale.setTo(0);
                      itm.spark = 1;
                      /*game.add.tween(itm.shine).to( { alpha: 0 }, 400, Phaser.Easing.Linear.None, true).onComplete.add(function(item) {
                    item.destroy();
                  });*/
                    } else {
                      if (itm.value == 2) {
                        prize_mas[1] += 1;
                      } else if (itm.value == 3) {
                        prize_mas[2] += 1;
                      } else if (itm.value == 4) {
                        prize_mas[3] += 1;
                      } else if (itm.value == 5) {
                        prize_mas[4] += 1;
                      } else if (itm.value == 6) {
                        prize_mas[5] += 1;
                      } else if (itm.value == 7) {
                        prize_mas[6] += 1;
                      } else if (itm.value == 50) {
                        prize_mas[0] += 50;
                      } else if (itm.value == 100) {
                        prize_mas[0] += 100;
                      } else if (itm.value == 250) {
                        prize_mas[0] += 250;
                      } else if (itm.value == 500) {
                        prize_mas[0] += 500;
                      } else if (itm.value == 1000) {
                        prize_mas[0] += 1000;
                      } else if (itm.value == 2000) {
                        prize_mas[0] += 2000;
                      }
                      animation = 0;
                      game.add
                        .tween(itm.scale)
                        .to({ x: card_size + 0.1, y: card_size + 0.1 }, 200, Phaser.Easing.Linear.None, true, 0, 0)
                        .yoyo(true, 0);
                      //game.add.tween(itm.shine.scale).to( { x: 1.4, y: 1.4 }, 500, Phaser.Easing.Linear.None, true);
                      itm.effect.scale.setTo(0);
                      itm.spark = 1;
                    }
                  } else {
                    itm.effect.scale.setTo(0);
                    itm.spark = 1;
                    bonus_cards_group.add(itm);
                  }
                });
            });
          game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
            console.log('BALLOON (1): ', bonus_cards_lost, col, n);
            if (bonus_cards_lost == 1 && n == 0) {
              bonus_cards_lost = 2;
              cards_group.children.forEach(function (element1) {
                if (element1.vis != 1) {
                  animation = 0;
                  card_bonus_select(element1, 1);
                }
              });
              animation = 1;
              game.add.tween(effects_group).to({ alpha: 1 }, 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                bonus_cards_group.children.forEach(function (element1) {
                  game.add.tween(element1).to({ y: '+1000' }, 500, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(element1)
                    .to({ angle: 720 }, 500, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      //item.shine.alpha = 0;
                      item.effect.scale.setTo(0);
                      item.spark = 1;
                      item.destroy();
                    });
                });
              });
              game.add.tween(effects_group).to({ alpha: 1 }, 1100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                var allchest = game.add.sprite(
                  game.camera.centerX + 800,
                  game.camera.height - 200,
                  'baloon_atlas',
                  'Big_Chest.png',
                );
                allchest.anchor.setTo(0.5);
                allchest.scale.setTo(0);
                game.add
                  .tween(allchest.scale)
                  .to({ x: 1.1, y: 1.1 }, 500, Phaser.Easing.Bounce.Out, true)
                  .onComplete.add(function () {
                    cards_group.children.forEach(function (element1) {
                      /*game.add.tween(element1.shine).to( { alpha: 0 }, 400, Phaser.Easing.Linear.None, true).onComplete.add(function(item) {
                      item.destroy();
                    });*/
                      game.add
                        .tween(element1)
                        .to({ x: allchest.x, y: allchest.y }, 500, Phaser.Easing.Linear.None, true);
                      game.add.tween(element1).to({ angle: 360 }, 500, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(element1)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                      game.add.tween(element1.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Linear.None, true);
                    });
                    console.log('BALLOON (2): ', prize_mas, popup, animation);
                    game.add
                      .tween(allchest.scale)
                      .to({ x: 0, y: 0 }, 500, Phaser.Easing.Cubic.Out, true, 600)
                      .onComplete.add(function () {
                        if (
                          prize_mas[0] != 0 ||
                          prize_mas[1] != 0 ||
                          prize_mas[2] != 0 ||
                          prize_mas[3] != 0 ||
                          prize_mas[4] != 0 ||
                          prize_mas[5] != 0 ||
                          prize_mas[6] != 0
                        ) {
                          missions_tab_open = 0;
                          popup = 0;
                          chest_open_window(
                            game.cache.getJSON('lang')['t463'][0][window.lang],
                            prize_mas,
                            51.51,
                            void 0,
                            {
                              gameArea: null,
                              actionType: null
                              // gameArea: DdnaGameArea.Level,
                              // actionType: DdnaTransactionActionType.MissionComplete,
                            },
                          );
                          all_prize_mas[0] += prize_mas[0];
                          all_prize_mas[1] += prize_mas[1];
                          all_prize_mas[2] += prize_mas[2];
                          all_prize_mas[3] += prize_mas[3];
                          all_prize_mas[4] += prize_mas[4];
                          all_prize_mas[5] += prize_mas[5];
                          all_prize_mas[6] += prize_mas[6];
                          prize_mas = [0, 0, 0, 0, 0, 0, 0];
                        } else {
                          gwin = 0;
                          baloon_level_select(1);
                        }
                      });
                  });
              });
            }
          });
        }
      }
      var all_cards = 0;
      function cards_create() {
        cards_discarded = [];
        destroy_cards = [];
        hazard_cards = [];
        start_card_mas = [];
        start_card_mas2 = [];
        cards_group.removeAll(true);
        generation = 0;
        wild_cards = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['WildCol']);
        hazard_card = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['HazardCol']);
        max_depth = 0;
        if (baloon != 1 || baloon_stage == 0) {
          delay = 2300;
        } else {
          delay = 500;
        }
        card_n = 1;
        water_n = 0;
        card_size = 1.4;
        game.time.events.repeat(
          2000,
          1,
          function () {
            if (sound_on == 1) {
              play_sound('Cards are placed');
            }
          },
          this,
        );
        while (typeof game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'] !== 'undefined') {
          card_active = game.add.sprite(
            game.world.centerX +
            Number(game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['x']) * card_size,
            Number(game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['y']) * card_size,
            'game5_atlas',
            backcards_select,
          );
          card_active.depth = Number(game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['depth']);
          card_active.vis = Number(game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['visible']);
          card_active.angle = Number(game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['angle']);
          card_active.value = Number(game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['value']);
          card_active.draw = Number(game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['draw']);
          card_active.inputEnabled = true;
          card_active.input.useHandCursor = true;
          card_active.events.onInputDown.add(card_select, this);
          card_active.anchor.setTo(0.5, 0.5);
          card_active.hazard_type = Number(
            game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['hazard_type'],
          );
          card_active.ht = Number(game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['hazard_type']);
          card_active.hazard_timer = Number(
            game.cache.getJSON('level' + level)['Card' + card_n + 'Stage1'][0]['hazard_timer'],
          );
          card_active.n = 0;
          if (game.world.height > 1080) {
            card_active.y += (game.world.height - 1080) / 2;
          }
          card_active.x1 = card_active.x;
          card_active.y1 = card_active.y;
          card_active.ang = card_active.angle;
          card_active.chek = 0;
          card_active.scale.setTo(card_size);
          card_active.realwidth = card_active.width;
          cards_group.add(card_active);
          if (card_active.vis == 1) {
            card_active.vis = 2;
          }
          card_active.y -= 1200;
          card_active.angle -= 270;
          animation = 1;
          game.add
            .tween(card_active)
            .to({ x: card_active.x1, y: card_active.y1 }, 500, Phaser.Easing.Linear.None, true, delay);
          game.add.tween(card_active).to({ angle: card_active.ang }, 500, Phaser.Easing.Linear.None, true, delay);
          delay += 50;
          if (card_active.value == 105) {
            p3_cards += 1;
          }
          if (card_active.depth > max_depth) max_depth = card_active.depth;
          if (
            card_active.value != 0 &&
            card_active.value != 101 &&
            card_active.value != 102 &&
            card_active.value != 103 &&
            card_active.value != 104 &&
            card_active.value != 105 &&
            card_active.value != 115
          ) {
            cards_discarded.push(card_active.draw);
            if (card_active.vis == 10) card_active.loadTexture('game_atlas', 'card' + card_active.draw + '.png', 0);
          }
          if (card_active.value == 101 || card_active.value == 102 || card_active.value == 105) {
            if (card_active.vis == 10) card_active.loadTexture('game_atlas', 'card' + card_active.value + '.png', 0);
            else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.value == 115) {
            if (card_active.vis == 10) {
              card_active.loadTexture('game5_atlas', 'TornadoCard_back.png', 0);
              var cards_tornado = game.add.sprite(0, 0, 'game5_atlas');
              cards_tornado.anchor.setTo(0.5);
              cards_tornado.animations.add(
                'Tornado',
                [
                  'TornadoCardVFX1.png',
                  'TornadoCardVFX2.png',
                  'TornadoCardVFX3.png',
                  'TornadoCardVFX4.png',
                  'TornadoCardVFX5.png',
                  'TornadoCardVFX6.png',
                  'TornadoCardVFX7.png',
                  'TornadoCardVFX8.png',
                ],
                20,
                true,
              );
              card_active.addChild(cards_tornado);
              cards_tornado.animations.play('Tornado');
            } else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.hazard_type == 1) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            if (card_active.value == 0) {
              card_active.value = game.rnd.integerInRange(1, 13);
              card_active.draw = get_random_change([
                card_active.value,
                card_active.value + 13,
                card_active.value + 13 * 2,
                card_active.value + 13 * 3,
              ]);
            }
            cards_discarded.push(card_active.draw);
            if (card_active.vis == 10) {
              card_active.loadTexture('game_atlas', 'card' + card_active.draw + '.png', 0);
              var tickingbomb = game.add.sprite(-94, -158, 'game_atlas', 'tickingbomb.png');
              tickingbomb.scale.setTo(0.55);
              card_active.addChild(tickingbomb);
              var tickingbomb_text = game.add.text(-48, -74, card_active.hazard_timer, {
                font: '40px RussoOne',
                fill: '#fff',
                align: 'center',
              });
              tickingbomb_text.anchor.setTo(0.5);
              grd = tickingbomb_text.context.createLinearGradient(0, 0, 0, tickingbomb_text.height);
              grd.addColorStop(0, '#F4F7CC');
              grd.addColorStop(1, '#E2C773');
              tickingbomb_text.fill = grd;
              card_active.addChild(tickingbomb_text);
            } else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.hazard_type == 2) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            if (card_active.value == 0) {
              card_active.value = game.rnd.integerInRange(1, 13);
              card_active.draw = get_random_change([
                card_active.value,
                card_active.value + 13,
                card_active.value + 13 * 2,
                card_active.value + 13 * 3,
              ]);
            }
            cards_discarded.push(card_active.draw);
            if (card_active.vis == 10) {
              card_active.loadTexture('game_atlas', 'card' + card_active.draw + '.png', 0);
              var frozen = game.add.sprite(0, 0, 'game_atlas', 'Ice_card.png');
              frozen.anchor.setTo(0.5);
              card_active.addChild(frozen);
            } else {
              card_active.loadTexture('game5_atlas', backcards_select, 0);
            }
          }
          if (card_active.hazard_type == 3 && card_active.value == 103) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            if (card_active.vis == 10) card_active.loadTexture('game_atlas', 'card_lock.png', 0);
            else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.hazard_type == 3 && card_active.value == 104) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            if (card_active.vis == 10) card_active.loadTexture('game_atlas', 'card_key.png', 0);
            else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.hazard_type == 4) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            if (card_active.value == 0) {
              card_active.value = game.rnd.integerInRange(1, 13);
              card_active.draw = get_random_change([
                card_active.value,
                card_active.value + 13,
                card_active.value + 13 * 2,
                card_active.value + 13 * 3,
              ]);
            }
            cards_discarded.push(card_active.draw);
            if (card_active.vis == 10) {
              card_active.loadTexture('game_atlas', 'card' + card_active.draw + '.png', 0);
              var cards_lowering = game.add.sprite(0, 0, 'game_atlas', 'cards_lowering.png');
              cards_lowering.anchor.setTo(0.5);
              card_active.addChild(cards_lowering);
            } else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.hazard_type == 5) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            if (card_active.value == 0) {
              card_active.value = game.rnd.integerInRange(1, 13);
              card_active.draw = get_random_change([
                card_active.value,
                card_active.value + 13,
                card_active.value + 13 * 2,
                card_active.value + 13 * 3,
              ]);
            }
            cards_discarded.push(card_active.draw);
            if (card_active.vis == 10) {
              card_active.loadTexture('game_atlas', 'card' + card_active.draw + '.png', 0);
              var cards_rising = game.add.sprite(0, 0, 'game_atlas', 'cards_rising.png');
              cards_rising.anchor.setTo(0.5);
              card_active.addChild(cards_rising);
            } else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.hazard_type == 6 || card_active.ht == 6) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            water_n += 1;
            generation_inspection = 0;
            if (card_active.value == 0) {
              while (generation_inspection == 0) {
                card_active.value = game.rnd.integerInRange(1, 13);
                card_active.draw = get_random_change([
                  card_active.value,
                  card_active.value + 13,
                  card_active.value + 13 * 2,
                  card_active.value + 13 * 3,
                ]);
                if (
                  cards_discarded.filter(function (item) {
                    return item === card_active.draw;
                  }).length >= deck_col
                ) {
                  generation_inspection = 0;
                } else {
                  generation_inspection = 1;
                }
              }
              cards_discarded.push(card_active.draw);
            }
            if (card_active.vis == 10) {
              card_active.loadTexture('game_atlas', 'card' + card_active.draw + '.png', 0);
              var cards_water = game.add.sprite(0, -4, 'game_atlas');
              cards_water.anchor.setTo(0.5);
              cards_water.animations.add('WAVE', ['WAVE1.png', 'WAVE2.png', 'WAVE3.png', 'WAVE2.png'], 6, true);
              cards_water.alpha = 0.6;
              card_active.addChild(cards_water);
              cards_water.animations.play('WAVE');
            } else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.hazard_type == 7) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            card_active.value = -1;
            if (card_active.vis == 10) {
              card_active.loadTexture('game_atlas', 'card_fish.png', 0);
              var cards_water = game.add.sprite(0, -4, 'game_atlas');
              cards_water.anchor.setTo(0.5);
              cards_water.animations.add('WAVE', ['WAVE1.png', 'WAVE2.png', 'WAVE3.png', 'WAVE2.png'], 6, true);
              cards_water.alpha = 0.5;
              var cards_fish = game.add.sprite(5, 60, 'game_atlas', 'fish1.png');
              cards_fish.anchor.setTo(0.5, 1);
              cards_fish.angle -= 20;
              card_active.addChild(cards_water);
              card_active.addChild(cards_fish);
              cards_water.animations.play('WAVE');
              fish_rotate(cards_fish);
            } else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.hazard_type == 8) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            card_active.value = -1;
            if (card_active.vis == 10) {
              card_active.loadTexture('game_atlas', 'card_fish.png', 0);
              var cards_water = game.add.sprite(0, -4, 'game_atlas');
              cards_water.anchor.setTo(0.5);
              cards_water.animations.add('WAVE', ['WAVE1.png', 'WAVE2.png', 'WAVE3.png', 'WAVE2.png'], 6, true);
              cards_water.alpha = 0.5;
              var cards_fish = game.add.sprite(0, 60, 'game_atlas', 'crab.png');
              cards_fish.anchor.setTo(0.5, 1);
              cards_fish.scale.setTo(0.7);
              var crab_right_hand = game.add.sprite(-32, -38, 'game_atlas', 'crab_right_hand.png');
              cards_fish.addChild(crab_right_hand);
              crab_right_hand.anchor.setTo(1, 1);
              crab_right_hand.angle = 0;
              var crab_left_hand = game.add.sprite(32, -38, 'game_atlas', 'crab_left_hand.png');
              cards_fish.addChild(crab_left_hand);
              crab_left_hand.anchor.setTo(0, 1);
              crab_left_hand.angle = -0;
              var cards_fish2 = game.add.sprite(0, 0, 'game_atlas', 'crab.png');
              cards_fish.addChild(cards_fish2);
              cards_fish2.anchor.setTo(0.5, 1);
              card_active.addChild(cards_water);
              card_active.addChild(cards_fish);
              cards_water.animations.play('WAVE');
              crab_animation(cards_fish, game.rnd.integerInRange(1900, 2100));
            } else card_active.loadTexture('game5_atlas', backcards_select, 0);
          }
          if (card_active.hazard_type == 9) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            card_active.hp = 3;
            if (card_active.value == 0) {
              card_active.value = game.rnd.integerInRange(1, 13);
              card_active.draw = get_random_change([
                card_active.value,
                card_active.value + 13,
                card_active.value + 13 * 2,
                card_active.value + 13 * 3,
              ]);
            }
            cards_discarded.push(card.draw);
            if (card_active.vis == 10) {
              card_active.loadTexture('game_atlas', 'card' + card_active.draw + '.png', 0);
              var algae = game.add.sprite(0, 0, 'game_atlas', 'algae_3.png');
              algae.scale.setTo(0.8);
              algae.anchor.setTo(0.5);
              card_active.addChild(algae);
            } else {
              card_active.loadTexture('game5_atlas', backcards_select, 0);
            }
          }
          if (card_active.hazard_type == 10) {
            hazard_cards.push(card_active);
            card_active.n = hazard_cards.length - 1;
            card_active.std = 3;
            if (card_active.value == 0) {
              card_active.value = game.rnd.integerInRange(1, 13);
              card_active.draw = get_random_change([
                card_active.value,
                card_active.value + 13,
                card_active.value + 13 * 2,
                card_active.value + 13 * 3,
              ]);
            }
            cards_discarded.push(card_active.draw);
            if (card_active.vis == 10) {
              card_active.loadTexture('game_atlas', 'card' + card_active.draw + '.png', 0);
              var fog = game.add.sprite(0, 0, 'fog_atlas', 'FogCard_Full0001.png');
              fog.scale.setTo(2);
              fog.anchor.setTo(0.5);
              card_active.addChild(fog);
              fog.animations.add(
                'FOG1',
                [
                  'FogCard_Full0001.png',
                  'FogCard_Full0002.png',
                  'FogCard_Full0003.png',
                  'FogCard_Full0004.png',
                  'FogCard_Full0005.png',
                  'FogCard_Full0006.png',
                  'FogCard_Full0007.png',
                  'FogCard_Full0008.png',
                  'FogCard_Full0009.png',
                  'FogCard_Full0010.png',
                  'FogCard_Full0011.png',
                  'FogCard_Full0012.png',
                  'FogCard_Full0013.png',
                ],
                8,
                true,
              );
              fog.animations.play('FOG1');
            } else {
              card_active.loadTexture('game5_atlas', backcards_select, 0);
            }
          }
          card_active.children.forEach(function (item) {
            item.alp = item.alpha;
            item.alpha = 0;
          });
          card_n++;
        }
        all_cards = cards_group.length;
      }
      cards_create();
      function fish_rotate(item) {
        game.add
          .tween(item)
          .to({ angle: '+30' }, 1000, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            game.add
              .tween(item)
              .to({ angle: '-30' }, 1000, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                fish_rotate(item);
              });
          });
      }
      function crab_animation2(itm) {
        game.add
          .tween(itm.children[0])
          .to({ angle: 20 }, 100, Phaser.Easing.Quadratic.Out, true)
          .onComplete.add(function (item) {
            game.add.tween(item).to({ angle: 0 }, 100, Phaser.Easing.Quadratic.In, true);
          });
        game.add
          .tween(itm.children[1])
          .to({ angle: -20 }, 100, Phaser.Easing.Quadratic.Out, true)
          .onComplete.add(function (item) {
            game.add.tween(item).to({ angle: 0 }, 100, Phaser.Easing.Quadratic.In, true);
          });
        game.add
          .tween(itm)
          .to({ angle: '+5' }, 50, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            game.add
              .tween(item)
              .to({ angle: '-5' }, 50, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(itm)
                  .to({ angle: '-5' }, 50, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ angle: '+5' }, 50, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        crab_animation2(item);
                      });
                  });
              });
          });
      }
      function crab_animation(itm, t) {
        game.add
          .tween(itm.children[0])
          .to({ angle: 20 }, t, Phaser.Easing.Quadratic.Out, true)
          .onComplete.add(function (item) {
            game.add.tween(item).to({ angle: 0 }, t, Phaser.Easing.Quadratic.In, true);
          });
        game.add
          .tween(itm.children[1])
          .to({ angle: -20 }, t, Phaser.Easing.Quadratic.Out, true)
          .onComplete.add(function (item) {
            game.add.tween(item).to({ angle: 0 }, t, Phaser.Easing.Quadratic.In, true);
          });
        game.add
          .tween(itm)
          .to({ y: '-20' }, t, Phaser.Easing.Quadratic.Out, true)
          .onComplete.add(function (item) {
            game.add
              .tween(item)
              .to({ y: '+20' }, t, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                crab_animation(item, t);
              });
          });
      }
      window.deck_change = function () {
        card_back_group.removeAll();
        cdn = 1;
        for (var i = 0; i < cards_deck_col - 1 - deck_n; i++) {
          if (level_joker.indexOf(i + 1) != -1) {
            console.log('level_joker_i', level_joker, level_joker.indexOf(i + deck_n), i, deck_n, i + deck_n);
            var card_back = game.add.sprite(
              (game.world.centerX + 1 * card_size - 10 * (cards_deck_col - 1 - deck_n)) + cdn * 10,
              game.world.height - 90 * card_size,
              'game_atlas',
              'joker.png',
            );
          }
          else {
            var card_back = game.add.sprite(
              (game.world.centerX + 1 * card_size - 10 * (cards_deck_col - 1 - deck_n)) + cdn * 10,
              game.world.height - 90 * card_size,
              'game5_atlas',
              backcards_select,
            );
          }
          if (level_joker.indexOf(i + 1) != -1)
            card_back.scale.setTo(card_size - 0.3, card_size - 0.3);
          else
            card_back.scale.setTo(-card_size, card_size);
          card_back.anchor.setTo(0.5);
          if (i > 25) { card_back.alpha = (cdn - 25) / (cards_deck_col - deck_n); }
          if (baloon == 1) bottom_game_group.add(card_back);
          card_back_group.add(card_back);
          cdn++;
        }

        if (typeof card_deck !== "undefined" && card_deck != 0) {
          game.world.bringToTop(card_deck);
          if (level_joker.indexOf(cards_deck_col - 1 - deck_n) != -1) { card_deck.loadTexture('game_atlas', 'joker.png'); card_deck.scale.setTo(card_size - 0.3, card_size - 0.3); } else
            if (cards_deck_col - 1 - deck_n > 0) {
              card_deck.loadTexture('game5_atlas', backcards_select); card_deck.scale.setTo(-card_size, card_size);
            }
        }


        game.world.bringToTop(card_text);
        game.world.bringToTop(effects_group);
      }
      var cd = 0;
      var cdn = 1;
      var card_deck = 0;
      var cardtimer = game.time.create();
      var card_back_group = game.add.group();
      if (baloon == 1) bottom_game_group.add(card_back_group);
      game.add.tween(effects_group).to({ alpha: 1 }, delay + 400, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
        if (level != 1) {
          cardtimer.repeat(50, cards_deck_col - deck_n, function () { //
            var card_back = game.add.sprite(
              game.world.centerX - 200,
              game.world.height + 100,
              'game5_atlas',
              backcards_select,
            );
            card_back.scale.setTo(-card_size, card_size);
            card_back.anchor.setTo(0.5);
            //card_back.alpha = cdn/(cards_deck_col - deck_n);
            if (baloon == 1) bottom_game_group.add(card_back);
            card_back_group.add(card_back);
            game.add
              .tween(card_back)
              .to(
                { x: (game.world.centerX + 1 * card_size - 10 * (cards_deck_col - deck_n)) + cdn * 10, y: game.world.height - 90 * card_size },
                200,
                Phaser.Easing.Linear.None,
                true,
              )
              .onComplete.add(function (item) {
                cd += 1;
                //item.destroy();
                //card_deck.alpha = 1;
                //card_text.setText(cd);

                if (cd >= cards_deck_col - deck_n) {
                  item.destroy();
                  if (level != 1) {
                    card_deck = game.add.sprite(
                      game.world.centerX + 1 * card_size,
                      game.world.height - 90 * card_size,
                      'game5_atlas',
                      backcards_select,
                    );
                    card_deck.inputEnabled = true;
                    card_deck.input.useHandCursor = true;
                    card_deck.events.onInputDown.add(card_add, this);
                    card_deck.anchor.setTo(0.5);
                    card_deck.scale.setTo(card_size);
                    //card_deck.alpha = 0;
                    if (baloon == 1) bottom_game_group.add(card_deck);
                    card_text = game.add.text(game.world.centerX + 1 * card_size, game.world.height - 40 * card_size, cd, {
                      font: '36px RussoOne',
                      fill: '#fff',
                      align: 'center',
                    });
                    card_text.alpha = 0;
                    card_text.anchor.setTo(0.5, 0.5);
                    card_text.setShadow(0, 5, 'rgba(0,0,0,0.5)', 5);
                    if (baloon == 1) bottom_game_group.add(card_text);
                  }
                }

              });
            cdn++;
          });
        } else {
          cardtimer.add(50, function () { });
        }
        cardtimer.onComplete.add(function () {
          game.add.tween(effects_group).to({ alpha: 1 }, 100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
            visible_cards(1);
            if (level == 1) {
              if (sound_on == 1) {
                play_sound('hint_with_arrow');
              }
              FTUE_Arrow = game.add.sprite(0, 0, 'game_atlas', 'FTUE_Arrow.png');
              FTUE_Arrow.anchor.setTo(0.5, 1.6);
              FTUE_Arrow.alpha = 0;
              cards_group.children.forEach(function (element1) {
                if (element1.value == FTUE_Arrow_n) {
                  FTUE_Arrow.x = element1.x;
                  FTUE_Arrow.y = element1.y;
                  FTUE_Arrow.angle = element1.angle;
                }
              });
              game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
              game.add
                .tween(FTUE_Arrow.anchor)
                .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                .yoyo(true, 200);
            }
          });
        });
      });
      cardtimer.start();
      var start_card = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['StartCardVal']);
      var start_generation_card = start_card;
      var draw_card_s = Number(game.cache.getJSON('level' + level)['LevelSetting'][0]['StartCardDraw']);
      if (start_card == 0) {
        start_card = game.rnd.integerInRange(1, 13);
        start_generation_card = start_card;
        draw_card_s = get_random_change([start_card, start_card + 13, start_card + 13 * 2, start_card + 13 * 3]);
      }
      if (level == 1) {
        card = game.add.sprite(
          game.world.centerX + 200,
          game.world.height - 90 * card_size,
          'game_atlas',
          'card' + draw_card_s + '.png',
        );
        card.anchor.setTo(0.5, 0.5);
        cards_discarded.push(draw_card_s);
        card.scale.setTo(card_size);
        start_card_mas2.push(card);
      }

      var i1 = 0;
      var generation_card = 0;
      var generation_inspection = 0;
      var deck = 0;
      var draw_card = 0;
      function cards_generation() {
        cards_group.sort('depth', Phaser.Group.SORT_ASCENDING);
        while (wild_cards > 0) {
          var scard = cards_group.getRandom();
          if (scard.value == 0) {
            scard.value = game.rnd.integerInRange(101, 102);
            scard.draw = scard.value;
            wild_cards -= 1;
            if (scard.vis == 1) scard.loadTexture('game_atlas', 'card' + scard.value + '.png', 0);
            else scard.loadTexture('game5_atlas', backcards_select, 0);
          }
        }
        while (hazard_card > 0) {
          if (game.rnd.integerInRange(1, 2) == 1) {
            var scard = cards_group.getRandom();
            if (scard.hazard_type == 0) {
              if (scard.value == 0) {
                scard.value = game.rnd.integerInRange(1, 13);
                scard.draw = get_random_change([
                  scard.value,
                  scard.value + 13,
                  scard.value + 13 * 2,
                  scard.value + 13 * 3,
                ]);
                cards_discarded.push(scard.draw);
              }
              scard.hazard_type = 1;
              scard.hazard_timer = 5;
              hazard_card -= 1;
              hazard_cards.push(scard);
              scard.n = hazard_cards.length - 1;
              if (scard.vis == 1) {
                scard.loadTexture('game_atlas', 'card' + scard.draw + '.png', 0);
                tickingbomb = game.add.sprite(-94, -158, 'game_atlas', 'tickingbomb.png');
                tickingbomb.scale.setTo(0.55);
                scard.addChild(tickingbomb);
                tickingbomb_text = game.add.text(-48, -74, scard.hazard_timer, {
                  font: '40px RussoOne',
                  fill: '#fff',
                  align: 'center',
                });
                tickingbomb_text.anchor.setTo(0.5);
                grd = tickingbomb_text.context.createLinearGradient(0, 0, 0, tickingbomb_text.height);
                grd.addColorStop(0, '#F4F7CC');
                grd.addColorStop(1, '#E2C773');
                tickingbomb_text.fill = grd;
                scard.addChild(tickingbomb_text);
              } else scard.loadTexture('game5_atlas', backcards_select, 0);
            }
          } else {
            var scard = cards_group.getRandom();
            while (scard.depth != max_depth) {
              scard = cards_group.getRandom();
            }
            if (scard.hazard_type == 0) {
              if (scard.value == 0) {
                scard.value = game.rnd.integerInRange(1, 13);
                scard.draw = get_random_change([
                  scard.value,
                  scard.value + 13,
                  scard.value + 13 * 2,
                  scard.value + 13 * 3,
                ]);
                cards_discarded.push(scard.draw);
              }
              scard.hazard_type = 2;
              hazard_card -= 1;
              hazard_cards.push(scard);
              scard.n = hazard_cards.length - 1;
              scard.loadTexture('game_atlas', 'card' + scard.draw + '.png', 0);
              frozen = game.add.sprite(0, 0, 'game_atlas', 'Ice_card.png');
              frozen.anchor.setTo(0.5);
              scard.addChild(frozen);
            }
          }
        }
        while (generation != cards_group.length) {
          var stop = 0;
          if (game.rnd.integerInRange(0, 1) == 0 && deck == 0 && i1 < cards_deck_col - 1) {
            generation_card = start_generation_card;
            generation_inspection = 0;
            while (generation_inspection == 0) {
              start_generation_card = game.rnd.integerInRange(1, 13);
              draw_card = get_random_change([
                start_generation_card,
                start_generation_card + 13,
                start_generation_card + 13 * 2,
                start_generation_card + 13 * 3,
              ]);
              if (
                cards_discarded.filter(function (item) {
                  return item === draw_card;
                }).length >= deck_col
              ) {
                generation_inspection = 0;
                start_generation_card = generation_card;
              } else {
                generation_inspection = 1;
                cards_deck[i1] = draw_card;
                cards_discarded.push(draw_card);
                i1 += 1;
                deck = 1;
              }
            }
          } else {
            if (deck == 1) {
              deck = 0;
            }
            while (stop == 0) {
              setcard = cards_group.getRandom();
              cards_group.children.forEach(function (element) {
                if (
                  (setcard.x + setcard.width / 2 >= element.x - element.width / 2 &&
                    setcard.x - setcard.width / 2 <= element.x + element.width / 2 &&
                    setcard.y + setcard.height / 2 >= element.y - element.height / 2 &&
                    setcard.y - setcard.height / 2 <= element.y + element.height / 2 &&
                    setcard.depth < element.depth &&
                    element.value == 0) ||
                  (setcard.value != 0 && setcard.chek == 1)
                ) {
                  setcard = 0;
                }
              });
              if (setcard != 0) {
                setcard.chek = 1;
                stop = 1;
                if (setcard.value != 0) {
                  setcard = -1;
                }
              }
            }
            if (setcard != -1) {
              generation_card = start_generation_card;
              generation_inspection = 0;
              var v = 0;
              while (generation_inspection == 0) {
                if (v < 5) {
                  if (game.rnd.integerInRange(0, 1) == 0) {
                    start_generation_card += 1;
                    if (start_generation_card > 13) {
                      start_generation_card = 1;
                    }
                  } else {
                    start_generation_card -= 1;
                    if (start_generation_card < 1) {
                      start_generation_card = 13;
                    }
                  }
                } else {
                  start_generation_card = game.rnd.integerInRange(1, 13);
                }
                draw_card = get_random_change([
                  start_generation_card,
                  start_generation_card + 13,
                  start_generation_card + 13 * 2,
                  start_generation_card + 13 * 3,
                ]);
                if (
                  cards_discarded.filter(function (item) {
                    return item === draw_card;
                  }).length >= deck_col
                ) {
                  generation_inspection = 0;
                  start_generation_card = generation_card;
                } else {
                  generation_inspection = 1;
                }
                v++;
              }
              setcard.value = start_generation_card;
              setcard.draw = draw_card;
              cards_discarded.push(draw_card);
              if (setcard.vis == 1) setcard.loadTexture('game_atlas', 'card' + draw_card + '.png', 0);
              else setcard.loadTexture('game5_atlas', backcards_select, 0);
            }
            generation += 1;
          }
        }
        game.world.bringToTop(cards_group);
        game.world.bringToTop(bottom_game_group);
        game.world.bringToTop(top_game_group);
        hzcol = hazard_cards.length;
      }
      cards_generation();
      for (var i = 0; i < cards_deck_col; i++) {
        generation_inspection = 0;
        if (cards_deck[i] == 0) {
          var carddeck;
          while (generation_inspection == 0) {
            carddeck = game.rnd.integerInRange(1, 13);
            carddeck = get_random_change([carddeck, carddeck + 13, carddeck + 13 * 2, carddeck + 13 * 3]);
            if (
              cards_discarded.filter(function (item) {
                return item === carddeck;
              }).length >= deck_col
            ) {
              generation_inspection = 0;
            } else {
              generation_inspection = 1;
              cards_deck[i] = carddeck;
              cards_discarded.push(carddeck);
            }
          }
        }
      }
      game.world.bringToTop(cards_group);
      game.world.bringToTop(bottom_game_group);
      game.world.bringToTop(top_game_group);
      var hzcol = hazard_cards.length;

      UI_Coins_BG = game.add.sprite(game.world.centerX - 750, -170, 'game_ui_atlas', 'Coins_Bar.png');
      UI_Coins_BG.anchor.setTo(0.5);
      var coin_icon = game.add.sprite(-110, -8, 'game_ui_atlas', 'Coin_Icon.png');
      coin_icon.anchor.setTo(0.5);
      UI_Coins_BG.addChild(coin_icon);
      var coins_text = game.add.text(0, -5, coins, { font: '32px RussoOne', fill: '#8B3B30', align: 'center' });
      coins_text.anchor.setTo(0.5);
      UI_Coins_BG.addChild(coins_text);
      game.add.tween(UI_Coins_BG).to({ y: 70 }, 400, Phaser.Easing.Linear.None, true, 500);
      if (FTUE > 150) {
        var coins_panel_plus = game.add.sprite(110, 0, 'game_ui_atlas', 'Get_Coins_Plus_Button.png');
        coins_panel_plus.anchor.setTo(0.5);
        UI_Coins_BG.addChild(coins_panel_plus);
        coins_panel_plus.inputEnabled = true;
        coins_panel_plus.input.useHandCursor = true;
        coins_panel_plus.scl = 1;
        coins_panel_plus.events.onInputOver.add(btnover, this);
        coins_panel_plus.events.onInputOut.add(btnout, this);
        coins_panel_plus.events.onInputDown.add(btnclick, this);
        coins_panel_plus.events.onInputUp.add(function (item) {
          btnup(item);
          if (popup == 0 && animation == 0 && cards_group.length > 0)
            if (shop == 1) {
              shop_window(
                0,
                0,
                0,
                [
                  { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                  { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                  { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                  { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                  {
                    4: {
                      id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                      packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                      price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                      reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                    },
                  },
                ],
                [
                  {
                    0: {
                      type: 'Coins_Pack_1.png',
                      sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                      col: '1 000',
                      id: 'coin_package_001',
                      packname: '1,000 Coins',
                      price: '0.99 $',
                      atlas: 'game_window_atlas',
                      reward: [1000],
                    },
                  },
                  {
                    1: {
                      type: 'Coins_Pack_2.png',
                      sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                      col: '6 000',
                      id: 'coin_package_02',
                      packname: '6,000 Coins',
                      price: '4.99 $',
                      atlas: 'game_window_atlas',
                      reward: [6000],
                    },
                  },
                  {
                    2: {
                      type: 'Coins_Pack_3.png',
                      sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                      col: '13 000',
                      id: 'coin_package_003',
                      packname: '13,000 Coins',
                      price: '9.99 $',
                      atlas: 'game_window_atlas',
                      reward: [13000],
                    },
                  },
                  {
                    3: {
                      type: 'Coins_Pack_4.png',
                      sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                      col: '20 000',
                      id: 'coin_package_004',
                      packname: '20,000 Coins',
                      price: '14.99 $',
                      atlas: 'game_window_atlas',
                      reward: [20000],
                    },
                  },
                ],
              );
            } else if (shop == 0) {
              get_message(2);
            }
        }, this);
      }
      var ui_streak_progress = 0;
      var UI_Streak_Present = 0;
      if (baloon == 1) {
        var Ingame_Level_Bar_UI = game.add.sprite(game.world.centerX - 450, 70, '');
        Ingame_Level_Bar_UI.anchor.setTo(0.5);
        Ingame_Level_Bar_UI.y = -116;
        game.add.tween(Ingame_Level_Bar_UI).to({ y: 70 }, 400, Phaser.Easing.Linear.None, true, 500);
        var graphics = game.add.graphics(-110, -30);
        graphics.beginFill(0x000000);
        graphics.alpha = 0.5;
        graphics.drawRoundedRect(0, 0, 220, 60, 80);
        Ingame_Level_Bar_UI.addChild(graphics);
        var Balloon_Icon = game.add.sprite(-70, 0, 'game_atlas', 'Balloon_Icon.png');
        Balloon_Icon.anchor.setTo(0.5);
        Ingame_Level_Bar_UI.addChild(Balloon_Icon);
        var Chest = game.add.sprite(70, 0, 'baloon_atlas', 'Big_Chest.png');
        Chest.anchor.setTo(0.5);
        Chest.scale.setTo(0.2);
        Ingame_Level_Bar_UI.addChild(Chest);
        var level_bar_text = game.add.text(0, 0, Number(baloon_stage + 1) + '/' + level_mas.length, {
          font: '30px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        level_bar_text.anchor.setTo(0.5);
        Ingame_Level_Bar_UI.addChild(level_bar_text);
        if (baloon == 1) top_game_group.add(Ingame_Level_Bar_UI);

      }
      var level_joker = [];
      var streak_array = [];
      var Safe_Icon_text = 0;
      if (level != 1 && level != 2) {
        var UI_Streak_BG = game.add.sprite(game.world.centerX, 50, ''); //+630
        UI_Streak_BG.anchor.setTo(0.5);
        UI_Streak_BG.y = -100;
        UI_Streak_Present = game.add.sprite(148, 5, streak_combo == 0 ? 'game_ui_atlas' : streak_combo == 1 ? 'game_atlas' : streak_combo == 2 ? 'game_ui_atlas' : 'game_atlas', streak_combo == 0 ? "Coin_Icon.png" : streak_combo == 1 ? "Three_Cards.png" : streak_combo == 2 ? "Coin_Icon.png" : "joker.png");
        UI_Streak_Present.scale.setTo(streak_combo == 0 ? 0.7 : streak_combo == 1 ? 0.4 : streak_combo == 2 ? 0.7 : 0.3);
        UI_Streak_Present.anchor.setTo(0.5);
        UI_Streak_BG.addChild(UI_Streak_Present);
        game.add.tween(UI_Streak_BG).to({ y: 50 }, 400, Phaser.Easing.Linear.None, true, 500);
        if (baloon == 1) top_game_group.add(UI_Streak_BG);

        for (var i = 0; i < 5; i++) {
          var Streak_Bonus_Card = game.add.sprite(i * 58 - 149, 10, 'game_atlas', 'Card_Streak_Bonus.png');
          Streak_Bonus_Card.anchor.setTo(0.5);
          UI_Streak_BG.addChild(Streak_Bonus_Card);
        }
      }

      Safe_Icon = game.add.sprite(game.world.centerX + 740, 70, '');
      Safe_Icon.anchor.setTo(0.5);
      Safe_Icon.y = -200;
      game.add.tween(Safe_Icon).to({ y: 70 }, 400, Phaser.Easing.Linear.None, true, 500);
      if (baloon == 1) top_game_group.add(Safe_Icon);
      var graphics = game.add.graphics(-170, -30);
      graphics.beginFill(0x000000);
      graphics.alpha = 0.5;
      graphics.drawRoundedRect(0, 0, 190, 60, 80);
      Safe_Icon.addChild(graphics);
      var Safe_Icon2 = game.add.sprite(0, 0, 'game_atlas', 'Safe_Icon.png');
      Safe_Icon2.anchor.setTo(0.5);
      Safe_Icon2.scale.setTo(0.9);
      Safe_Icon.addChild(Safe_Icon2);
      var Coin_Icon = game.add.sprite(-130, -4, 'game_ui_atlas', 'Coin_Icon.png');
      Coin_Icon.anchor.setTo(0.5);
      Coin_Icon.scale.setTo(0.5);
      Safe_Icon.addChild(Coin_Icon);

      Safe_Icon_text = game.add.text(-80, 0, prize3, {
        font: '30px RussoOne',
        fill: '#fff',
        align: 'center',
      });
      Safe_Icon_text.anchor.setTo(0.5);
      Safe_Icon.addChild(Safe_Icon_text);


      function streak_progress(n, t) {
        if (level != 1 && level != 2) {
          if (t == 1) {
            var streak_bonus = 1;

            var Streak_Bonus_Card = game.add.sprite(streak_array.length * 58 - 149, 10, 'game_atlas', n == 1 ? "Black_Card.png" : "Red_Card.png");
            Streak_Bonus_Card.anchor.setTo(0.5);
            Streak_Bonus_Card.scale.setTo(0);
            UI_Streak_BG.addChild(Streak_Bonus_Card);
            Streak_Bonus_Card.n = n;
            game.add.tween(Streak_Bonus_Card.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Bounce.Out, true);

            streak_array.push(Streak_Bonus_Card);

            if (streak_array.length >= 5) {
              if (streak_array[0].n == streak_array[1].n && streak_array[1].n == streak_array[2].n && streak_array[2].n == streak_array[3].n && streak_array[3].n == streak_array[4].n) {
                streak_bonus = 2;
              }
              console.log('streak_bonus:', streak_bonus, streak_array[0].n, streak_array[1].n, streak_array[2].n, streak_array[3].n, streak_array[4].n);
              if (FTUE > 30)
                for (var i = 0; i < missions.length; i += 4) {
                  if (missions[i] == -4) {
                    if (missions[i + 2] < missions[i + 1]) {
                      missions[i + 2] += 1;
                    }
                  }
                }
              message(game.cache.getJSON('lang')['FriendsText6'][0][window.lang], 0, 0, 1);
              for (var i = 0; i < streak_array.length; i++) {
                streak_array[i].destroy(true);
              }
              streak_array = [];
              if (streak_combo < 3) { streak_combo += 1; if (level <= 5 && streak_combo == 3) { streak_combo = 1; } } else { streak_combo = 0; }

              game.add.tween(UI_Streak_Present.scale).to({ x: '+0.2', y: '+0.2' }, 250, Phaser.Easing.Linear.None, true, 0, 1).yoyo(true, 0);
              game.add.tween(UI_Streak_Present).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                item.destroy();
                UI_Streak_Present = game.add.sprite(148, 5, streak_combo == 0 ? 'game_ui_atlas' : streak_combo == 1 ? 'game_atlas' : streak_combo == 2 ? 'game_ui_atlas' : 'game_atlas', streak_combo == 0 ? "Coin_Icon.png" : streak_combo == 1 ? "Three_Cards.png" : streak_combo == 2 ? "Coin_Icon.png" : "joker.png");
                UI_Streak_Present.scale.setTo(streak_combo == 0 ? 0.7 : streak_combo == 1 ? 0.4 : streak_combo == 2 ? 0.7 : 0.3);
                UI_Streak_Present.anchor.setTo(0.5);
                UI_Streak_Present.alpha = 0;
                UI_Streak_BG.addChild(UI_Streak_Present);
                game.add.tween(UI_Streak_Present).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
              });

              animation = 1;
              popup = 1;

              if (streak_combo == 2) {
                var nnn = 0;
                var cdc = cards_deck_col;
                cards_deck_col += 1 * streak_bonus;
                game.time.events.repeat(100, 1 * streak_bonus, function () {
                  var card_new = game.add.sprite(UI_Streak_Present.world.x, UI_Streak_Present.world.y, 'game5_atlas', backcards_select);
                  card_new.anchor.setTo(0.5);
                  card_new.scale.setTo(0);
                  game.add.tween(card_new.scale).to({ x: card_size, y: card_size }, 1000, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(card_new)
                    .to({ x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size }, 1000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                      card_deck.alpha = 1;
                      //card_text.alpha = 1;
                      cdc += 1;
                      card_text.setText(cdc - 1 - deck_n);
                      deck_change();
                    });
                  nnn++;
                  if (nnn == 1 * streak_bonus) {
                    popup = 0;
                    animation = 0;
                  }
                }, this);
                if (deck_n >= cards_deck_col - 2) {
                  card_deck = game.add.sprite(
                    game.world.centerX + 1 * card_size,
                    game.world.height - 90 * card_size,
                    'game5_atlas',
                    backcards_select,
                  );
                  card_deck.inputEnabled = true;
                  card_deck.events.onInputDown.add(card_add, this);
                  card_deck.anchor.setTo(0.5);
                  card_deck.scale.setTo(card_size);
                  if (baloon == 1) bottom_game_group.add(card_deck);
                  card_text = game.add.text(
                    game.world.centerX + 1 * card_size,
                    game.world.height - 40 * card_size,
                    cards_deck_col - 1 - deck_n,
                    { font: '36px RussoOne', fill: '#fff', align: 'center' },
                  );
                  card_text.alpha = 0;
                  card_text.anchor.setTo(0.5);
                  if (baloon == 1) bottom_game_group.add(card_text);
                  deck_change();
                  if (booster4 != 0) {
                    booster4.destroy(); if (booster4_1 != 0 && booster4_1 != -1) { booster4_1.destroy(); booster4_1 = -1; }
                    booster4 = 0;
                  }
                  if (UI_EndGame_btn != 0) {
                    UI_EndGame_btn.destroy();
                    UI_EndGame_btn = 0;
                  }
                }
                let plus5 = [];
                while (plus5.length < 1 * streak_bonus) {
                  card_n = game.rnd.integerInRange(1, 13);
                  if (
                    plus5.filter(function (item) {
                      return item === card_n;
                    }).length == 0
                  ) {
                    plus5.push(card_n);
                    let draw_card_n = get_random_change([card_n, card_n + 13, card_n + 13 * 2, card_n + 13 * 3]);
                    cards_deck.push(draw_card_n);
                  }
                }
              } else if (streak_combo == 0) {
                var nnn = 0;
                var cdc = cards_deck_col;
                cards_deck_col += 1 * streak_bonus;
                game.time.events.repeat(100, 1 * streak_bonus, function () {
                  var card_new = game.add.sprite(UI_Streak_Present.world.x, UI_Streak_Present.world.y, 'game_atlas', "joker.png");
                  card_new.anchor.setTo(0.5);
                  card_new.scale.setTo(0);
                  game.add.tween(card_new.scale).to({ x: card_size, y: card_size }, 1000, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(card_new)
                    .to({ x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size }, 1000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                      card_deck.alpha = 1;
                      //card_text.alpha = 1;
                      cdc += 1;
                      var lj = game.rnd.integerInRange(1, cdc - 1 - deck_n);;
                      while (level_joker.indexOf(lj) != -1) {
                        lj = game.rnd.integerInRange(1, cdc - 1 - deck_n);
                      }
                      level_joker.push(lj);
                      card_text.setText(cdc - 1 - deck_n);
                      deck_change();
                    });
                  nnn++;
                  if (nnn == 1 * streak_bonus) {
                    popup = 0;
                    animation = 0;
                    console.log('level_joker', level_joker);
                  }
                }, this);
                if (deck_n >= cards_deck_col - 2) {
                  card_deck = game.add.sprite(
                    game.world.centerX + 1 * card_size,
                    game.world.height - 90 * card_size,
                    'game5_atlas',
                    backcards_select,
                  );
                  card_deck.inputEnabled = true;
                  card_deck.events.onInputDown.add(card_add, this);
                  card_deck.anchor.setTo(0.5);
                  card_deck.scale.setTo(card_size);
                  if (baloon == 1) bottom_game_group.add(card_deck);
                  card_text = game.add.text(
                    game.world.centerX + 1 * card_size,
                    game.world.height - 40 * card_size,
                    cards_deck_col - 1 - deck_n,
                    { font: '36px RussoOne', fill: '#fff', align: 'center' },
                  );
                  card_text.alpha = 0;
                  card_text.anchor.setTo(0.5);
                  if (baloon == 1) bottom_game_group.add(card_text);
                  deck_change();
                  if (booster4 != 0) {
                    booster4.destroy(); if (booster4_1 != 0 && booster4_1 != -1) { booster4_1.destroy(); booster4_1 = -1; }
                    booster4 = 0;
                  }
                  if (UI_EndGame_btn != 0) {
                    UI_EndGame_btn.destroy();
                    UI_EndGame_btn = 0;
                  }
                }

              } else {
                var nnn = 0;
                var col = 25 * streak_bonus;
                //coins += 25*streak_bonus;
                prize3 += 25 * streak_bonus;
                game.setCurrentEvent();
                window.eventTrack('coins_in', col, {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: col,
                  source: 'Streak',
                  package_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });

                // save collected coins
                game.setUserDataAndLog({ currencies: coins });

                var coins_t = Number(Safe_Icon_text.text);
                Safe_Icon_text.setText(coins_t);
                var var_coins = 0;
                var var_coins_m = 0;
                if (sound_on == 1) {
                  play_sound('coins_add');
                }
                game.time.events.repeat(
                  100,
                  10,
                  function () {
                    var star_emitter = game.add.emitter(UI_Streak_Present.world.x, UI_Streak_Present.world.y, 100);
                    star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                    star_emitter.setAlpha(1, 0, 800);
                    star_emitter.setScale(3, 0, 3, 0, 800);
                    star_emitter.start(false, 1500, 10);
                    var get_coin = game.add.sprite(UI_Streak_Present.world.x, UI_Streak_Present.world.y, 'ingame_atlas', 'Coin.png');
                    get_coin.anchor.setTo(0.5);
                    get_coin.scale.setTo(0);
                    get_coin.alpha = 1;
                    get_coin.em = star_emitter;
                    effects_group.add(get_coin);
                    game.world.bringToTop(effects_group);
                    var_coins_m += col / 10;
                    game.add.tween(get_coin.scale).to({ x: 0.6, y: 0.6 }, 1000, Phaser.Easing.Linear.None, true);
                    var tween = game.add
                      .tween(get_coin)
                      .to(
                        {
                          x: [UI_Streak_Present.world.x, game.world.centerX + 350, game.world.centerX + 350, Safe_Icon_text.world.x],
                          y: [UI_Streak_Present.world.y, 200, 200, Safe_Icon_text.world.y],
                        },
                        1000,
                        Phaser.Easing.Quadratic.Out,
                        true,
                        0,
                        -1,
                      )
                      .interpolation(function (v, k) {
                        return Phaser.Math.bezierInterpolation(v, k);
                      });
                    tween.onUpdateCallback(function () {
                      star_emitter.x = get_coin.x;
                      star_emitter.y = get_coin.y;
                    }, this);
                    game.add
                      .tween(get_coin)
                      .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        item.em.destroy();
                        item.destroy();
                        var_coins += col / 10;
                        Safe_Icon_text.setText(Math.ceil(coins_t + var_coins));
                      });

                    nnn++;
                    if (nnn == 10) {
                      popup = 0;
                      animation = 0;
                    }
                  },
                  this,
                );
              }

            }

          } else {
            for (var i = 0; i < streak_array.length; i++) {
              streak_array[i].destroy(true);
            }
            streak_array = [];
          }
        }
      }
      function message(text, xx, yy, type) {
        if (type != 10) {
          message_text = game.add.text(game.world.centerX, game.world.centerY, text, {
            font: '74px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          message_text.stroke = '#8B5A0A';
          message_text.strokeThickness = 8;
          var grd = message_text.context.createLinearGradient(0, 0, 0, message_text.height);
          grd.addColorStop(0, '#FFE9AE');
          grd.addColorStop(1, '#FCB921');
          message_text.fill = grd;
          message_text.scale.setTo(0);
          message_text.anchor.setTo(0.5, 0.5);
          game.add.tween(message_text.scale).to({ x: 1.1, y: 1.1 }, 400, Phaser.Easing.Linear.None, true);
          game.add.tween(message_text).to({ y: '-200' }, 1500, Phaser.Easing.Linear.None, true);
          game.add
            .tween(message_text)
            .to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add.tween(item.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
              game.add
                .tween(item)
                .to({ alpha: 0 }, 600, Phaser.Easing.Linear.None, true, 400)
                .onComplete.add(function (item) {
                  item.destroy();
                  message_text = 0;
                });
            });
        } else {
          message_text = game.add.text(xx, yy, text, { font: '40px RussoOne', fill: '#fff', align: 'center' });
          message_text.stroke = '#000';
          message_text.strokeThickness = 4;
          message_text.anchor.setTo(0.5, 0.5);
          var message_coin = game.add.sprite(message_text.width / 2 + 20, 0, 'game_atlas', 'icon_coins.png');
          message_coin.anchor.setTo(0.5, 0.5);
          message_coin.scale.setTo(0.7);
          message_text.addChild(message_coin);
          game.add.tween(message_text).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 200);
          game.add
            .tween(message_text)
            .to({ y: '-150' }, 600, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              item.destroy();
              message_text = 0;
            });
        }
        game.world.bringToTop(message_text);
      }
      function polygonPolygon(points1, points2) {
        var a = points1;
        var b = points2;
        var polygons = [a, b];
        var minA, maxA, projected, minB, maxB, j;
        for (var i = 0; i < polygons.length; i++) {
          var polygon = polygons[i];
          for (var i1 = 0; i1 < polygon.length; i1 += 2) {
            var i2 = (i1 + 2) % polygon.length;
            var normal = { x: polygon[i2 + 1] - polygon[i1 + 1], y: polygon[i1] - polygon[i2] };
            minA = maxA = null;
            for (var j = 0; j < a.length; j += 2) {
              projected = normal.x * a[j] + normal.y * a[j + 1];
              if (minA === null || projected < minA) {
                minA = projected;
              }
              if (maxA === null || projected > maxA) {
                maxA = projected;
              }
            }
            minB = maxB = null;
            for (var j = 0; j < b.length; j += 2) {
              projected = normal.x * b[j] + normal.y * b[j + 1];
              if (minB === null || projected < minB) {
                minB = projected;
              }
              if (maxB === null || projected > maxB) {
                maxB = projected;
              }
            }
            if (maxA < minB || maxB < minA) {
              return false;
            }
          }
        }
        return true;
      }
      var dlmax = 0;
      function getPoints1(element1) {
        var xxx1 =
          ((-element1.realwidth + 8) / 2) * Math.cos((element1.angle * 3.14) / 180) -
          ((element1.height - 10) / 2 - 2) * Math.sin((element1.angle * 3.14) / 180) +
          element1.x;
        var yyy1 =
          ((-element1.realwidth + 8) / 2) * Math.sin((element1.angle * 3.14) / 180) +
          ((element1.height - 10) / 2 - 2) * Math.cos((element1.angle * 3.14) / 180) +
          element1.y;
        var xxx2 =
          ((-element1.realwidth + 8) / 2) * Math.cos((element1.angle * 3.14) / 180) -
          ((-element1.height + 10) / 2 - 2) * Math.sin((element1.angle * 3.14) / 180) +
          element1.x;
        var yyy2 =
          ((-element1.realwidth + 8) / 2) * Math.sin((element1.angle * 3.14) / 180) +
          ((-element1.height + 10) / 2 - 2) * Math.cos((element1.angle * 3.14) / 180) +
          element1.y;
        var xxx3 =
          ((element1.realwidth - 8) / 2) * Math.cos((element1.angle * 3.14) / 180) -
          ((-element1.height + 10) / 2 - 2) * Math.sin((element1.angle * 3.14) / 180) +
          element1.x;
        var yyy3 =
          ((element1.realwidth - 8) / 2) * Math.sin((element1.angle * 3.14) / 180) +
          ((-element1.height + 10) / 2 - 2) * Math.cos((element1.angle * 3.14) / 180) +
          element1.y;
        var xxx4 =
          ((element1.realwidth - 8) / 2) * Math.cos((element1.angle * 3.14) / 180) -
          ((element1.height - 10) / 2 - 2) * Math.sin((element1.angle * 3.14) / 180) +
          element1.x;
        var yyy4 =
          ((element1.realwidth - 8) / 2) * Math.sin((element1.angle * 3.14) / 180) +
          ((element1.height - 10) / 2 - 2) * Math.cos((element1.angle * 3.14) / 180) +
          element1.y;
        return [xxx1, yyy1, xxx2, yyy2, xxx3, yyy3, xxx4, yyy4];
      }
      function getPoints2(element2) {
        var xxx1 =
          ((-element2.realwidth + 8) / 2) * Math.cos((element2.angle * 3.14) / 180) -
          ((element2.height - 10) / 2) * Math.sin((element2.angle * 3.14) / 180) +
          element2.x;
        var yyy1 =
          ((-element2.realwidth + 8) / 2) * Math.sin((element2.angle * 3.14) / 180) +
          ((element2.height - 10) / 2) * Math.cos((element2.angle * 3.14) / 180) +
          element2.y;
        var xxx2 =
          ((-element2.realwidth + 8) / 2) * Math.cos((element2.angle * 3.14) / 180) -
          ((-element2.height + 10) / 2) * Math.sin((element2.angle * 3.14) / 180) +
          element2.x;
        var yyy2 =
          ((-element2.realwidth + 8) / 2) * Math.sin((element2.angle * 3.14) / 180) +
          ((-element2.height + 10) / 2) * Math.cos((element2.angle * 3.14) / 180) +
          element2.y;
        var xxx3 =
          ((element2.realwidth - 8) / 2) * Math.cos((element2.angle * 3.14) / 180) -
          ((-element2.height + 10) / 2) * Math.sin((element2.angle * 3.14) / 180) +
          element2.x;
        var yyy3 =
          ((element2.realwidth - 8) / 2) * Math.sin((element2.angle * 3.14) / 180) +
          ((-element2.height + 10) / 2) * Math.cos((element2.angle * 3.14) / 180) +
          element2.y;
        var xxx4 =
          ((element2.realwidth - 8) / 2) * Math.cos((element2.angle * 3.14) / 180) -
          ((element2.height - 10) / 2) * Math.sin((element2.angle * 3.14) / 180) +
          element2.x;
        var yyy4 =
          ((element2.realwidth - 8) / 2) * Math.sin((element2.angle * 3.14) / 180) +
          ((element2.height - 10) / 2) * Math.cos((element2.angle * 3.14) / 180) +
          element2.y;
        return [xxx1, yyy1, xxx2, yyy2, xxx3, yyy3, xxx4, yyy4];
      }
      var hlpw = 0;
      function visible_cards(t) {
        if (bonus_cards_lost != -1) {
          cards_group.children.forEach(function (element1) {
            var c_vis = 1;
            cards_group.children.forEach(function (element2) {
              var points1 = getPoints1(element1);
              var points2 = getPoints2(element2);
              if (element1.vis == 0)
                if (polygonPolygon(points1, points2) == true && element1.depth < element2.depth) {
                  c_vis = 0;
                }
            });
            if (element1.vis == 2) {
              c_vis = 1;
            }
            if (c_vis == 1 && (element1.vis == 0 || element1.vis == 2)) {
              element1.vis = 1;
              if (element1.hazard_type != 3) {
                if (element1.hazard_type == 1) {
                  element1.loadTexture('game_atlas', 'card' + element1.draw + '.png', 0);
                  var tickingbomb = game.add.sprite(-94, -158, 'game_atlas', 'tickingbomb.png');
                  tickingbomb.scale.setTo(0.55);
                  element1.addChild(tickingbomb);
                  var tickingbomb_text = game.add.text(-48, -74, element1.hazard_timer, {
                    font: '40px RussoOne',
                    fill: '#fff',
                    align: 'center',
                  });
                  tickingbomb_text.anchor.setTo(0.5);
                  var grd = tickingbomb_text.context.createLinearGradient(0, 0, 0, tickingbomb_text.height);
                  grd.addColorStop(0, '#F4F7CC');
                  grd.addColorStop(1, '#E2C773');
                  tickingbomb_text.fill = grd;
                  element1.addChild(tickingbomb_text);
                } else if (element1.hazard_type == 2) {
                  element1.loadTexture('game_atlas', 'card' + element1.draw + '.png', 0);
                  var frozen = game.add.sprite(0, 0, 'game_atlas', 'Ice_card.png');
                  frozen.anchor.setTo(0.5);
                  element1.addChild(frozen);
                } else if (element1.hazard_type == 9) {
                  element1.loadTexture('game_atlas', 'card' + element1.draw + '.png', 0);
                  var algae = game.add.sprite(0, 0, 'game_atlas', 'algae_3.png');
                  algae.scale.setTo(0.8);
                  algae.anchor.setTo(0.5);
                  element1.addChild(algae);
                } else if (element1.hazard_type == 10) {
                  element1.loadTexture('game_atlas', 'card' + element1.draw + '.png', 0);
                  element1.std = 3;
                  if (element1.children[0]) {
                    element1.children[0].destroy();
                  }
                  var fog = game.add.sprite(0, 0, 'fog_atlas', 'FogCard_Full0001.png');
                  fog.scale.setTo(2);
                  fog.anchor.setTo(0.5);
                  element1.addChild(fog);
                  fog.animations.add(
                    'FOG1',
                    [
                      'FogCard_Full0001.png',
                      'FogCard_Full0002.png',
                      'FogCard_Full0003.png',
                      'FogCard_Full0004.png',
                      'FogCard_Full0005.png',
                      'FogCard_Full0006.png',
                      'FogCard_Full0007.png',
                      'FogCard_Full0008.png',
                      'FogCard_Full0009.png',
                      'FogCard_Full0010.png',
                      'FogCard_Full0011.png',
                      'FogCard_Full0012.png',
                      'FogCard_Full0013.png',
                    ],
                    8,
                    true,
                  );
                  fog.animations.play('FOG1');
                } else if (element1.hazard_type == 4) {
                  element1.loadTexture('game_atlas', 'card' + element1.draw + '.png', 0);
                  var cards_lowering = game.add.sprite(0, 0, 'game_atlas', 'cards_lowering.png');
                  cards_lowering.anchor.setTo(0.5);
                  element1.addChild(cards_lowering);
                } else if (element1.hazard_type == 5) {
                  element1.loadTexture('game_atlas', 'card' + element1.draw + '.png', 0);
                  var cards_rising = game.add.sprite(0, 0, 'game_atlas', 'cards_rising.png');
                  cards_rising.anchor.setTo(0.5);
                  element1.addChild(cards_rising);
                } else if (element1.hazard_type == 6 || element1.ht == 6) {
                  element1.loadTexture('game_atlas', 'card' + element1.draw + '.png', 0);
                  var cards_water = game.add.sprite(0, -4, 'game_atlas');
                  cards_water.anchor.setTo(0.5);
                  cards_water.animations.add('WAVE', ['WAVE1.png', 'WAVE2.png', 'WAVE3.png', 'WAVE2.png'], 6, true);
                  cards_water.alpha = 0.6;
                  element1.addChild(cards_water);
                  cards_water.animations.play('WAVE');
                } else if (element1.hazard_type == 7) {
                  element1.loadTexture('game_atlas', 'card_fish.png', 0);
                  var cards_water = game.add.sprite(0, -4, 'game_atlas');
                  cards_water.anchor.setTo(0.5);
                  cards_water.animations.add('WAVE', ['WAVE1.png', 'WAVE2.png', 'WAVE3.png', 'WAVE2.png'], 6, true);
                  cards_water.alpha = 0.6;
                  var cards_fish = game.add.sprite(0, 0, 'game_atlas', 'fish1.png');
                  cards_fish.anchor.setTo(0.5);
                  cards_fish.angle -= 20;
                  element1.addChild(cards_water);
                  element1.addChild(cards_fish);
                  cards_water.animations.play('WAVE');
                  fish_rotate(cards_fish);
                } else if (element1.hazard_type == 8) {
                  element1.loadTexture('game_atlas', 'card_fish.png', 0);
                  var cards_water = game.add.sprite(0, -4, 'game_atlas');
                  cards_water.anchor.setTo(0.5);
                  cards_water.animations.add('WAVE', ['WAVE1.png', 'WAVE2.png', 'WAVE3.png', 'WAVE2.png'], 6, true);
                  cards_water.alpha = 0.5;
                  var cards_fish = game.add.sprite(0, 60, 'game_atlas', 'crab.png');
                  cards_fish.anchor.setTo(0.5, 1);
                  cards_fish.scale.setTo(0.7);
                  var crab_right_hand = game.add.sprite(-32, -38, 'game_atlas', 'crab_right_hand.png');
                  cards_fish.addChild(crab_right_hand);
                  crab_right_hand.anchor.setTo(1, 1);
                  crab_right_hand.angle = 0;
                  var crab_left_hand = game.add.sprite(32, -38, 'game_atlas', 'crab_left_hand.png');
                  cards_fish.addChild(crab_left_hand);
                  crab_left_hand.anchor.setTo(0, 1);
                  crab_left_hand.angle = -0;
                  var cards_fish2 = game.add.sprite(0, 0, 'game_atlas', 'crab.png');
                  cards_fish.addChild(cards_fish2);
                  cards_fish2.anchor.setTo(0.5, 1);
                  element1.addChild(cards_water);
                  element1.addChild(cards_fish);
                  cards_water.animations.play('WAVE');
                  crab_animation(cards_fish, game.rnd.integerInRange(1900, 2100));
                } else if (element1.value == 115) {
                  element1.loadTexture('game5_atlas', 'TornadoCard_back.png', 0);
                  var cards_tornado = game.add.sprite(0, 0, 'game5_atlas');
                  cards_tornado.anchor.setTo(0.5);
                  cards_tornado.animations.add(
                    'Tornado',
                    [
                      'TornadoCardVFX1.png',
                      'TornadoCardVFX2.png',
                      'TornadoCardVFX3.png',
                      'TornadoCardVFX4.png',
                      'TornadoCardVFX5.png',
                      'TornadoCardVFX6.png',
                      'TornadoCardVFX7.png',
                      'TornadoCardVFX8.png',
                    ],
                    20,
                    true,
                  );
                  element1.addChild(cards_tornado);
                  cards_tornado.animations.play('Tornado');
                } else {
                  element1.loadTexture('game_atlas', 'card' + element1.draw + '.png', 0);
                }
              } else {
                if (element1.value == 103) element1.loadTexture('game_atlas', 'card_lock.png', 0);
                if (element1.value == 104) element1.loadTexture('game_atlas', 'card_key.png', 0);
              }
              element1.scale.setTo(card_size);
              element1.cc = element1.frameName;
              element1.loadTexture('game5_atlas', backcards_select, 0);
              element1.children.forEach(function (item) {
                item.alp = item.alpha;
                item.alpha = 0;
              });
              if (t == 0 || t == 5) {
                game.add.tween(element1.scale).to({ x: 0, y: card_size + 0.02 }, 100, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(element1)
                  .to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    if (item.value != 115) {
                      if (item.hazard_type == 7 || item.hazard_type == 8)
                        item.loadTexture('game_atlas', 'card_fish.png', false);
                      else if (item.value == 103) item.loadTexture('game_atlas', 'card_lock.png', false);
                      else if (item.value == 104) item.loadTexture('game_atlas', 'card_key.png', false);
                      else item.loadTexture('game_atlas', 'card' + item.draw + '.png', false);
                    } else {
                      item.loadTexture('game5_atlas', 'TornadoCard_back.png', 0);
                    }
                    item.children.forEach(function (item2) {
                      item2.alpha = item2.alp;
                    });
                    if (t == 0)
                      game.add
                        .tween(item.scale)
                        .to({ x: card_size, y: card_size }, 100, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          if (
                            ((item.value == 101 && level == 5) || (item.value == 102 && level == 7)) &&
                            joker_first == 1
                          ) {
                            if (FTUE_Arrow != 0) {
                              FTUE_Arrow.destroy();
                              FTUE_Arrow = 0;
                            }
                            joker_first = -1;
                            animation = 1;
                            if (item.value == 101)
                              w = ftue_window(
                                'Main_Presenting.png',
                                game.cache.getJSON('lang')['t346'][0][window.lang],
                                game.camera.width / 2,
                                game.camera.height / 2 + 100,
                              );
                            else
                              w = ftue_window(
                                'Main_Presenting.png',
                                game.cache.getJSON('lang')['t345'][0][window.lang],
                                game.camera.width / 2,
                                game.camera.height / 2 + 320,
                              );
                            var ccc = game.add.sprite(item.x, item.y, 'game_atlas', 'card' + item.draw + '.png');
                            ccc.angle = item.angle;
                            ccc.anchor.setTo(0.5);
                            ccc.scale.setTo(card_size);
                            w.obj = ccc;
                            game.world.bringToTop(item);
                            popup = 1;
                            if (sound_on == 1) {
                              play_sound('hint_with_arrow');
                            }
                            FTUE_Arrow = game.add.sprite(item.x, item.y - 20, 'game_atlas', 'FTUE_Arrow.png');
                            FTUE_Arrow.anchor.setTo(0.5, 1.6);
                            FTUE_Arrow.alpha = 0;
                            game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                            game.add
                              .tween(FTUE_Arrow.anchor)
                              .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                              .yoyo(true, 200);
                          }
                        });
                    else
                      game.add
                        .tween(item.scale)
                        .to({ x: card_size, y: card_size }, 100, Phaser.Easing.Linear.None, true);
                  });
              } else {
                var dl = element1.x;
                if (dlmax < dl) {
                  dlmax = dl;
                }
                game.add
                  .tween(element1.scale)
                  .to({ x: 0, y: card_size + 0.02 }, 100, Phaser.Easing.Linear.None, true, dl);
                game.add
                  .tween(element1)
                  .to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true, dl)
                  .onComplete.add(function (item) {
                    if (item.value != 115) {
                      if (item.hazard_type == 7 || item.hazard_type == 8)
                        item.loadTexture('game_atlas', 'card_fish.png', false);
                      else if (item.value == 103) item.loadTexture('game_atlas', 'card_lock.png', false);
                      else if (item.value == 104) item.loadTexture('game_atlas', 'card_key.png', false);
                      else item.loadTexture('game_atlas', 'card' + item.draw + '.png', false);
                    } else {
                      item.loadTexture('game5_atlas', 'TornadoCard_back.png', 0);
                    }
                    item.children.forEach(function (item2) {
                      item2.alpha = item2.alp;
                    });
                    game.add.tween(item.scale).to({ x: card_size, y: card_size }, 100, Phaser.Easing.Linear.None, true);
                  });
              }
            }
          });
          if (t == 1) {
            game.add
              .tween(effects_group)
              .to({ alpha: 1 }, dlmax + 100, Phaser.Easing.Linear.None, true)
              .onComplete.add(function () {
                if (level == 1) {
                  if (fbv == 1) {
                    window.eventTrack('FTUE_2_2_BasicRulesTutorialConfirmed');
                  }
                  animation = 1;
                  let ccc = 0;
                  w = ftue_window(
                    'Main_Presenting.png',
                    game.cache.getJSON('lang')['t326'][0][window.lang],
                    game.camera.width / 2,
                    game.camera.height / 2 - 250,
                  );
                  cards_group.children.forEach(function (element1) {
                    if (element1.value == 3) {
                      ccc = game.add.sprite(element1.x, element1.y, 'game_atlas', 'card' + element1.draw + '.png');
                      ccc.angle = element1.angle;
                      ccc.anchor.setTo(0.5);
                      ccc.scale.setTo(card_size);
                      w.obj = ccc;
                    }
                  });
                  game.world.bringToTop(ccc);
                  game.world.bringToTop(card);
                  game.world.bringToTop(FTUE_Arrow);
                } else {
                  card_text.setText(cards_deck_col - 1 - deck_n);
                  deck_change();
                  card = game.add.sprite(card_deck.x, card_deck.y, 'game5_atlas', backcards_select);
                  card.anchor.setTo(0.5, 0.5);
                  cards_discarded.push(draw_card_s);
                  card.scale.setTo(card_size);
                  start_card_mas2.push(card);
                  if (baloon == 1) bottom_game_group.add(card);
                  game.add.tween(card.scale).to({ x: 0, y: card_size + 0.2 }, 200, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(card)
                    .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.loadTexture('game_atlas', 'card' + draw_card_s + '.png', false);
                      game.add
                        .tween(item.scale)
                        .to({ x: card_size, y: card_size }, 200, Phaser.Easing.Linear.None, true);
                    });
                  game.add
                    .tween(card)
                    .to(
                      { x: game.world.centerX + 200, y: game.world.height - 90 * card_size },
                      400,
                      Phaser.Easing.Linear.None,
                      true,
                    )
                    .onComplete.add(function (item) {
                      if (context_name != "Carl") {
                        // Removed this otherwise the game freeze when switchen to
                        // a level after gathering more then 1 magic beans
                        //if (magicbeanStage < 2) {
                        animation = 0;
                        //console.log(level,all_level[level-1]);
                        if (level == 26 && suitcase_add == 0) {
                          booster_tnt_col += 3;
                          suitcase_tutorial(1);

                        } else if (
                          level == 40 &&
                          (all_level[level - 1] == 0 || typeof all_level[level - 1] == 'undefined') &&
                          suitcase_add != 2
                        ) {
                          booster_eye_col += 1;
                          suitcase_tutorial(2);
                        } else if (
                          level == 45 &&
                          (all_level[level - 1] == 0 || typeof all_level[level - 1] == 'undefined') &&
                          suitcase_add != 3
                        ) {
                          booster_shuffle_col += 1;
                          suitcase_tutorial(3);
                        }
                        //}
                      }
                    }, this);
                  game.world.bringToTop(card);
                  // this had to be changed otherwise the preboosters are not applied
                  // for the levels
                  // if (hlpw == 0 && fbv == 1 && (context_name != 0 || level <= 3)) {
                  var prebooster_select = free_three > 0 || free_prebooster2_select || free_prebooster3_select;
                  if (hlpw == 0 && prebooster_select) {
                    popup = 0;
                    help_end();
                    context_name = 0;
                  }
                  else {
                    if (level == 10 && FTUE_Arrow == 0) {
                      w = ftue_window(
                        'Main_Presenting.png',
                        game.cache.getJSON('lang')['t348'][0][window.lang],
                        game.camera.width / 2,
                        game.camera.height / 2 + 320,
                      );
                      game.world.bringToTop(UI_Streak_BG);
                      if (sound_on == 1) {
                        play_sound('hint_with_arrow');
                      }
                      cards_group.children.forEach(function (element1) {
                        if (element1.value == 1 && element1.vis == 1) {
                          var ccc = game.add.sprite(
                            element1.x,
                            element1.y,
                            'game_atlas',
                            'card' + element1.draw + '.png',
                          );
                          ccc.angle = element1.angle;
                          ccc.anchor.setTo(0.5);
                          ccc.scale.setTo(card_size);
                          w.obj = ccc;
                          var tickingbomb = game.add.sprite(-94, -158, 'game_atlas', 'tickingbomb.png');
                          tickingbomb.scale.setTo(0.55);
                          ccc.addChild(tickingbomb);
                          var tickingbomb_text = game.add.text(-48, -74, '5', {
                            font: '40px RussoOne',
                            fill: '#fff',
                            align: 'center',
                          });
                          tickingbomb_text.anchor.setTo(0.5);
                          var grd = tickingbomb_text.context.createLinearGradient(0, 0, 0, tickingbomb_text.height);
                          grd.addColorStop(0, '#F4F7CC');
                          grd.addColorStop(1, '#E2C773');
                          tickingbomb_text.fill = grd;
                          ccc.addChild(tickingbomb_text);
                        }
                      });
                      FTUE_Arrow = game.add.sprite(
                        game.world.centerX,
                        game.world.centerY,
                        'game_atlas',
                        'FTUE_Arrow.png',
                      );
                      FTUE_Arrow.anchor.setTo(0.5, 1.6);
                      FTUE_Arrow.alpha = 0;
                      game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(FTUE_Arrow.anchor)
                        .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                        .yoyo(true, 200);
                    }
                  }
                }
              });
          }
        }
      }
      if (level > 26 || baloon == 1 || xmas == 1 || (level == 26 && suitcase_add != 0)) {
        suitcase_close = game.add.sprite(
          game.world.centerX + 815,
          game.world.height - 164 + 63,
          'game_atlas',
          'suitcase_close.png',
        );
        suitcase_close.anchor.setTo(0.5);
        suitcase_close.scale.setTo(1);
        if (baloon == 1) bottom_game_group.add(suitcase_close);
        suitcase_close.inputEnabled = true;
        suitcase_close.input.useHandCursor = true;
        suitcase_close.events.onInputDown.add(function () {
          if (popup == 0 && animation == 0 && cards_group.length > 0 && animation == 0) {
            popup = 1;
            game.add
              .tween(suitcase_close.scale)
              .to({ x: 0.8, y: 0.8 }, 200, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(suitcase_close.scale)
                  .to({ x: 1, y: 1 }, 200, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    suitcase_open(0);
                  });
              });
          }
        }, this);
        var suitcase_close_text = game.add.text(
          suitcase_close.x,
          game.world.height - 18,
          game.cache.getJSON('lang')['t401'][0][window.lang],
          { font: '26px RussoOne', fill: '#fff', align: 'center' },
        );
        suitcase_close_text.stroke = '#000';
        suitcase_close_text.strokeThickness = 3;
        suitcase_close_text.anchor.setTo(0.5, 0.5);
        if (baloon == 1) bottom_game_group.add(suitcase_close_text);
        suitcase_label = game.add.sprite(60, -40, 'game_atlas', 'wheel_icon_label.png');
        suitcase_label.anchor.setTo(0.5);
        suitcase_label.alpha = 0;
        suitcase_close.addChild(suitcase_label);
        suitcase_label_text = game.add.text(
          0,
          2,
          booster_tnt_col + booster_eye_col + booster_shuffle_col + booster_timestop_col,
          { font: '20px RussoOne', fill: '#fff', align: 'center' },
        );
        suitcase_label_text.anchor.setTo(0.5);
        suitcase_label.addChild(suitcase_label_text);
      }
      var suitcase_cloud = 0;
      function suitcase_tutorial(t) {
        popup = 1;
        blackf();
        var shine_title = game.add.sprite(
          game.world.centerX,
          game.world.centerY - 100,
          'game_atlas',
          'shine_title.png',
        );
        shine_title.anchor.setTo(0.5);
        shine_title.scale.setTo(0);
        popup_group.add(shine_title);
        game.add.tween(shine_title.scale).to({ x: 3, y: 3 }, 500, Phaser.Easing.Linear.None, true, 200);
        rotate_tween(shine_title);
        var spr = 0;
        var tex = '';
        if (t == 1) {
          spr = 'suitcase_close.png';
          tex = game.cache.getJSON('lang')['SuitcaseTutorial'][0][window.lang];
        } else if (t == 2) {
          spr = 'bullseye_booster.png';
          tex =
            game.cache.getJSON('lang')['BullseyeBooster'][0][window.lang] +
            '\n' +
            game.cache.getJSON('lang')['BullseyeBoosterText'][0][window.lang];
        } else if (t == 3) {
          spr = 'shuffle_booster.png';
          tex =
            game.cache.getJSON('lang')['ShuffleBooster'][0][window.lang] +
            '\n' +
            game.cache.getJSON('lang')['ShuffleBoosterText'][0][window.lang];
        } else if (t == 4) {
          spr = 'time_booster.png';
          tex =
            game.cache.getJSON('lang')['TimeBooster'][0][window.lang] +
            '\n' +
            game.cache.getJSON('lang')['TimeBoosterText'][0][window.lang];
        }
        suitcase_add = t;
        if (all_level[39] > 0) {
          suitcase_add = 2;
        }
        if (all_level[44] > 0) {
          suitcase_add = 3;
        }
        if (all_level[120] > 0) {
          suitcase_add = 4;
        }
        game.setUserDataAndLog({ suitcase_add: suitcase_add });
        var suitcase_close_icon = game.add.sprite(game.world.centerX, game.world.centerY - 100, 'game_atlas', spr);
        suitcase_close_icon.anchor.setTo(0.5);
        suitcase_close_icon.scale.setTo(0);
        popup_group.add(suitcase_close_icon);
        game.add.tween(suitcase_close_icon.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Linear.None, true, 300);
        var suitcase_tutorial_text = game.add.text(game.world.centerX, game.world.centerY + 100, tex, {
          font: '30px RussoOne',
          fill: '#fff',
          align: 'center',
          wordWrap: true,
          wordWrapWidth: 1200,
        });
        suitcase_tutorial_text.anchor.setTo(0.5);
        suitcase_tutorial_text.alpha = 0;
        popup_group.add(suitcase_tutorial_text);
        game.add.tween(suitcase_tutorial_text).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true, 400);
        var button_green = game.add.sprite(
          game.world.centerX,
          game.world.centerY + 229 + 600,
          'game_atlas',
          'button_green.png',
        );
        button_green.anchor.setTo(0.5);
        button_green.scale.setTo(0.9);
        button_green.inputEnabled = true;
        button_green.scl = 0.9;
        button_green.input.useHandCursor = true;
        button_green.events.onInputDown.add(function () {
          if (popup != 2) {
            popup = 2;
            if (sound_on == 1) {
              play_sound('button_X');
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add.tween(shine_title).to({ alpha: 0 }, 400, Phaser.Easing.Quadratic.Out, true);
            game.add.tween(suitcase_tutorial_text).to({ alpha: 0 }, 400, Phaser.Easing.Quadratic.Out, true);
            game.add.tween(button_green).to({ y: '+600' }, 400, Phaser.Easing.Quadratic.Out, true);
            if (t != 1) {
              game.add.tween(suitcase_close_icon.scale).to({ x: 0, y: 0 }, 800, Phaser.Easing.Linear.None, true);
              game.add
                .tween(suitcase_close_icon)
                .to(
                  { x: game.world.centerX + 815, y: game.world.height - 164 + 63 },
                  800,
                  Phaser.Easing.Quadratic.In,
                  true,
                );
              game.add
                .tween(suitcase_close_icon)
                .to({ alpha: 1 }, 800, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  game.add.tween(suitcase_close).to({ x: '-10', y: '-10' }, 200, Phaser.Easing.Quadratic.Out, true);
                  game.add
                    .tween(suitcase_close)
                    .to({ angle: '-10' }, 200, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      game.add.tween(suitcase_close).to({ x: '+15', y: '+5' }, 100, Phaser.Easing.Quadratic.Out, true);
                      game.add
                        .tween(suitcase_close)
                        .to({ angle: '+15' }, 100, Phaser.Easing.Quadratic.Out, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(suitcase_close)
                            .to({ x: '-5', y: '+5' }, 50, Phaser.Easing.Quadratic.Out, true);
                          game.add.tween(suitcase_close).to({ angle: '-5' }, 50, Phaser.Easing.Quadratic.Out, true);
                        });
                    });
                  popup = 0;
                  item.destroy();
                });
            } else {
              game.add.tween(suitcase_close_icon.scale).to({ x: 1, y: 1 }, 800, Phaser.Easing.Quadratic.Out, true);
              game.add
                .tween(suitcase_close_icon)
                .to(
                  { x: game.world.centerX + 815, y: game.world.height - 164 + 63 },
                  800,
                  Phaser.Easing.Quadratic.Out,
                  true,
                )
                .onComplete.add(function (item) {
                  suitcase_close = game.add.sprite(item.x, item.y, 'game_atlas', 'suitcase_close.png');
                  suitcase_close.anchor.setTo(0.5);
                  suitcase_close.scale.setTo(1);
                  suitcase_close.inputEnabled = true;
                  if (baloon == 1) bottom_game_group.add(suitcase_close);
                  suitcase_close.events.onInputDown.add(function () {
                    if (popup == 2 && animation == 0) {
                      popup = 1;
                      game.add.tween(suitcase_cloud).to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(suitcase_close.scale)
                        .to({ x: 0.8, y: 0.8 }, 200, Phaser.Easing.Quadratic.In, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(suitcase_close.scale)
                            .to({ x: 1, y: 1 }, 200, Phaser.Easing.Quadratic.Out, true)
                            .onComplete.add(function (item) {
                              suitcase_open(1);
                            });
                        });
                    }
                  }, this);
                  var suitcase_close_text = game.add.text(
                    suitcase_close.x,
                    game.world.height - 18,
                    game.cache.getJSON('lang')['t401'][0][window.lang],
                    { font: '26px RussoOne', fill: '#fff', align: 'center' },
                  );
                  suitcase_close_text.stroke = '#000';
                  suitcase_close_text.strokeThickness = 3;
                  suitcase_close_text.anchor.setTo(0.5, 0.5);
                  if (baloon == 1) bottom_game_group.add(suitcase_close_text);
                  suitcase_label = game.add.sprite(60, -40, 'game_atlas', 'wheel_icon_label.png');
                  suitcase_label.anchor.setTo(0.5);
                  suitcase_label.alpha = 0;
                  suitcase_close.addChild(suitcase_label);
                  suitcase_label_text = game.add.text(
                    0,
                    2,
                    booster_tnt_col + booster_eye_col + booster_shuffle_col + booster_timestop_col,
                    { font: '20px RussoOne', fill: '#fff', align: 'center' },
                  );
                  suitcase_label_text.anchor.setTo(0.5);
                  suitcase_label.addChild(suitcase_label_text);
                  suitcase_close.input.useHandCursor = true;
                  scale_tween(suitcase_close, 500, 0.1, 0.1, -1);
                  suitcase_cloud = game.add.sprite(
                    suitcase_close.x - 50,
                    suitcase_close.y - 60,
                    'game_atlas',
                    'stargate_cloud.png',
                  );
                  suitcase_cloud.anchor.setTo(0.5, 1);
                  suitcase_cloud.scale.setTo(0);
                  var chest_cloud_text = game.add.text(0, -60, game.cache.getJSON('lang')['TapMe'][0][window.lang], {
                    font: '24px RussoOne',
                    fill: '#6A3011',
                    align: 'center',
                    wordWrap: true,
                    wordWrapWidth: 180,
                  });
                  chest_cloud_text.anchor.setTo(0.5, 0.5);
                  chest_cloud_text.lineSpacing = -10;
                  suitcase_cloud.addChild(chest_cloud_text);
                  game.add.tween(suitcase_cloud.scale).to({ x: 1, y: 1 }, 300, Phaser.Easing.Linear.None, true);
                  popup_group.removeAll(true);
                });
            }
          }
        }, this);
        popup_group.add(button_green);
        button_green.input.useHandCursor = true;
        scale_tween(button_green, 500, 0.1, 0.1, -1);
        var button_green_text = game.add.text(0, 0, game.cache.getJSON('lang')['Continue'][0][window.lang], {
          font: '44px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        button_green_text.anchor.setTo(0.5);
        button_green.addChild(button_green_text);
        game.add.tween(button_green).to({ y: '-600' }, 600, Phaser.Easing.Linear.None, true, 300);
      }
      var ticket_booster_group = game.add.group();
      var ticket_booster_mask = 0;
      var booster_check = 0;
      var ticket_booster1 = 0;
      var ticket_booster2 = 0;
      var ticket_booster3 = 0;
      var tnt_booster_text = 0;
      var bullseye_booster_text = 0;
      var shuffle_booster_text = 0;
      var tnt_booster_cloud = 0;
      function suitcase_open(t) {
        if (animation == 0) {
          if (sound_on == 1) {
            play_sound('suitcase_open');
          }
          ticket_booster_group.removeAll(true);
          ticket_booster_group.t = t;
          ticket_booster_group.y = 0;
          ticket_booster_group.h = 0;
          popup = 30;
          animation = 1;
          black_sprite = game.add.sprite(game.world.centerX, game.world.centerY, 'message_invite_mask');
          black_sprite.width = game.world.width;
          black_sprite.height = game.world.height;
          black_sprite.anchor.setTo(0.5);
          black_sprite.alpha = 0;
          game.add
            .tween(black_sprite)
            .to({ alpha: 0.5 }, 500, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) { });
          suitcase_close.destroy();
          suitcase_close = game.add.sprite(
            game.world.centerX + 815,
            game.world.height - 164 + 63,
            'game_atlas',
            'suitcase_close.png',
          );
          suitcase_close.anchor.setTo(0.5);
          suitcase_close.inputEnabled = true;
          suitcase_close.input.useHandCursor = true;
          if (baloon == 1) bottom_game_group.add(suitcase_close);
          suitcase_close.events.onInputDown.add(function () {
            if (popup == 0 && animation == 0) {
              popup = 1;
              if (t == 1) {
                game.add.tween(suitcase_cloud).to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true);
              }
              game.add
                .tween(suitcase_close.scale)
                .to({ x: 0.8, y: 0.8 }, 200, Phaser.Easing.Quadratic.In, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(suitcase_close.scale)
                    .to({ x: 1, y: 1 }, 200, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      suitcase_open(0);
                    });
                });
            }
          }, this);
          suitcase_label = game.add.sprite(60, -40, 'game_atlas', 'wheel_icon_label.png');
          suitcase_label.anchor.setTo(0.5);
          suitcase_label.alpha = 0;
          suitcase_close.addChild(suitcase_label);
          suitcase_label_text = game.add.text(
            0,
            2,
            booster_tnt_col + booster_eye_col + booster_shuffle_col + booster_timestop_col,
            { font: '20px RussoOne', fill: '#fff', align: 'center' },
          );
          suitcase_label_text.anchor.setTo(0.5);
          suitcase_label.addChild(suitcase_label_text);
          suitcase_close.loadTexture('game_atlas', 'suitcase_open.png', false);
          game.world.bringToTop(suitcase_close);
          game.add.tween(suitcase_close).to({ x: '-10', y: '-10' }, 200, Phaser.Easing.Quadratic.Out, true, 100);
          game.add
            .tween(suitcase_close)
            .to({ angle: '-10' }, 200, Phaser.Easing.Quadratic.Out, true, 100)
            .onComplete.add(function (item) {
              game.add.tween(suitcase_close).to({ x: '+15', y: '+5' }, 100, Phaser.Easing.Quadratic.Out, true);
              game.add
                .tween(suitcase_close)
                .to({ angle: '+15' }, 100, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  game.add.tween(suitcase_close).to({ x: '-5', y: '+5' }, 50, Phaser.Easing.Quadratic.Out, true);
                  game.add
                    .tween(suitcase_close)
                    .to({ angle: '-5' }, 50, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      if (ticket_booster_mask != 0) {
                        ticket_booster_mask.destroy();
                      }
                      ticket_booster_mask = game.add.graphics(0, 0);
                      ticket_booster_mask.beginFill(0xffffff);
                      ticket_booster_mask.drawRect(
                        game.world.centerX + 100,
                        game.world.height - 164 + 63 - 610,
                        870,
                        630,
                      );
                      ticket_booster_group.mask = ticket_booster_mask;
                      ////////////TNT//////////
                      ticket_booster1 = game.add.sprite(
                        game.world.centerX + 815,
                        game.world.height - 164 + 63 - 87,
                        'game_atlas',
                        'ticket_booster.png',
                      );
                      ticket_booster1.anchor.setTo(0.5);
                      ticket_booster1.n = 1;
                      ticket_booster_group.add(ticket_booster1);
                      booster_check = 0;
                      cards_group.children.forEach(function (element1) {
                        if (booster_tnt_col > 0 || (coins >= booster_tnt_price && shop == 0))
                          if (element1.vis == 1)
                            if (
                              element1.value != 101 &&
                              element1.value != 102 &&
                              element1.value != 103 &&
                              element1.value != 105 &&
                              element1.value != 104 &&
                              element1.hazard_type != 9 &&
                              element1.hazard_type != 7 &&
                              element1.hazard_type != 8 &&
                              element1.hazard_type != 3
                            ) {
                              booster_check = 1;
                            }
                      });
                      if (booster_check == 1)
                        var tnt_booster = game.add.sprite(0, -30, 'game_atlas', 'tnt_booster.png');
                      else var tnt_booster = game.add.sprite(0, -30, 'game_atlas', 'tnt_booster_grey.png');
                      tnt_booster.anchor.setTo(0.5);
                      tnt_booster.t = t;
                      tnt_booster.scale.setTo(0.9);
                      button_animation_f(tnt_booster, 0.9);
                      tnt_booster.events.onInputUp.add(function (itm) {
                        btnup(itm);
                        if (popup == 3 && game_move == 0 && animation == 0) {
                          booster_tnt_animation(itm);
                        }
                        game_move = 0;
                      }, this);
                      ticket_booster1.addChild(tnt_booster);
                      if (booster_tnt_col > 0 || (coins >= booster_tnt_price && shop == 0)) {
                        var p_text = game.cache.getJSON('lang')['t297'][0][window.lang];
                        p_text = p_text.replace('[x]', booster_tnt_col);
                        if (booster_tnt_col > 0)
                          tnt_booster_text = game.add.text(0, 56, p_text, {
                            font: '26px RussoOne',
                            fill: '#fff',
                            align: 'center',
                          });
                        else
                          tnt_booster_text = game.add.text(10, 56, booster_tnt_price, {
                            font: '26px RussoOne',
                            fill: '#fff',
                            align: 'center',
                          });
                        tnt_booster_text.anchor.setTo(0.5);
                        tnt_booster_text.stroke = '#000';
                        tnt_booster_text.strokeThickness = 3;
                        ticket_booster1.addChild(tnt_booster_text);
                        if (booster_tnt_col <= 0) {
                          var tnt_booster_coin = game.add.sprite(
                            -tnt_booster_text.width / 2 - 10,
                            54,
                            'game_atlas',
                            'icon_coins.png',
                          );
                          tnt_booster_coin.anchor.setTo(0.5, 0.5);
                          tnt_booster_coin.scale.setTo(0.7);
                          ticket_booster1.addChild(tnt_booster_coin);
                        }
                      } else {
                        tnt_booster_text = game.add.sprite(
                          tnt_booster.width / 2 - 20,
                          tnt_booster.height / 2 - 20,
                          'game_ui_atlas',
                          'Get_Coins_Plus_Button.png',
                        );
                        tnt_booster_text.scale.setTo(0.7);
                        tnt_booster_text.anchor.setTo(0.5);
                        tnt_booster.addChild(tnt_booster_text);
                      }
                      ticket_booster_group.y += 212;
                      ticket_booster_group.h += 212;
                      ////////////Bulls-eye//////////
                      if (level >= 40 || suitcase_add >= 2 || baloon == 1 || xmas == 1) {
                        ticket_booster2 = game.add.sprite(
                          game.world.centerX + 815,
                          game.world.height - 164 + 63 - 296,
                          'game_atlas',
                          'ticket_booster.png',
                        );
                        ticket_booster2.anchor.setTo(0.5);
                        ticket_booster2.n = 2;
                        ticket_booster_group.add(ticket_booster2);
                        booster_check = 0;
                        cards_group.children.forEach(function (element1) {
                          if (booster_eye_col > 0 || (coins >= booster_eye_price && shop == 0))
                            if (
                              element1.vis == 1 &&
                              element1.value != 101 &&
                              element1.value != 102 &&
                              element1.value != 103 &&
                              element1.value != 105 &&
                              element1.value != 104 &&
                              element1.hazard_type != 9 &&
                              element1.hazard_type != 7 &&
                              element1.hazard_type != 8 &&
                              element1.hazard_type != 3
                            ) {
                              booster_check = 1;
                            }
                        });
                        if (booster_check == 1)
                          var bullseye_booster = game.add.sprite(0, -30, 'game_atlas', 'bullseye_booster.png');
                        else var bullseye_booster = game.add.sprite(0, -30, 'game_atlas', 'bullseye_booster_grey.png');
                        bullseye_booster.anchor.setTo(0.5);
                        bullseye_booster.t = t;
                        bullseye_booster.scale.setTo(0.9);
                        button_animation_f(bullseye_booster, 0.9);
                        bullseye_booster.events.onInputUp.add(function (itm) {
                          btnup(itm);
                          if (popup == 3 && game_move == 0 && animation == 0) {
                            booster_bullseye_animation(itm);
                          }
                          game_move = 0;
                        }, this);
                        ticket_booster2.addChild(bullseye_booster);
                        if (booster_eye_col > 0 || (coins >= booster_eye_price && shop == 0)) {
                          var p_text = game.cache.getJSON('lang')['t297'][0][window.lang];
                          p_text = p_text.replace('[x]', booster_eye_col);
                          if (booster_eye_col > 0)
                            bullseye_booster_text = game.add.text(0, 56, p_text, {
                              font: '26px RussoOne',
                              fill: '#fff',
                              align: 'center',
                            });
                          else
                            bullseye_booster_text = game.add.text(10, 56, booster_eye_price, {
                              font: '26px RussoOne',
                              fill: '#fff',
                              align: 'center',
                            });
                          bullseye_booster_text.anchor.setTo(0.5);
                          bullseye_booster_text.stroke = '#000';
                          bullseye_booster_text.strokeThickness = 3;
                          ticket_booster2.addChild(bullseye_booster_text);
                          if (booster_eye_col <= 0) {
                            var bullseye_booster_coin = game.add.sprite(
                              -bullseye_booster_text.width / 2 - 10,
                              54,
                              'game_atlas',
                              'icon_coins.png',
                            );
                            bullseye_booster_coin.anchor.setTo(0.5, 0.5);
                            bullseye_booster_coin.scale.setTo(0.7);
                            ticket_booster2.addChild(bullseye_booster_coin);
                          }
                        } else {
                          bullseye_booster_text = game.add.sprite(
                            bullseye_booster.width / 2 - 20,
                            bullseye_booster.height / 2 - 20,
                            'game_ui_atlas',
                            'Get_Coins_Plus_Button.png',
                          );
                          bullseye_booster_text.scale.setTo(0.7);
                          bullseye_booster_text.anchor.setTo(0.5);
                          bullseye_booster.addChild(bullseye_booster_text);
                        }
                        ticket_booster_group.y += 209;
                        ticket_booster_group.h += 209;
                      }
                      ////////////Shuffle//////////
                      if (level >= 45 || suitcase_add >= 3 || baloon == 1 || xmas == 1) {
                        ticket_booster3 = game.add.sprite(
                          game.world.centerX + 815,
                          game.world.height - 164 + 63 - 505,
                          'game_atlas',
                          'ticket_booster.png',
                        );
                        ticket_booster3.anchor.setTo(0.5);
                        ticket_booster3.n = 3;
                        ticket_booster_group.add(ticket_booster3);
                        booster_check = 0;
                        cards_group.children.forEach(function (element1) {
                          if (booster_shuffle_col > 0 || (coins >= booster_shuffle_price && shop == 0))
                            if (element1.vis == 1)
                              if (
                                element1.value != 101 &&
                                element1.value != 102 &&
                                element1.value != 103 &&
                                element1.value != 105 &&
                                element1.value != 104 &&
                                element1.hazard_type != 1 &&
                                element1.hazard_type != 9 &&
                                (element1.hazard_type != 10 || (element1.hazard_type == 10 && element1.std != 3)) &&
                                element1.hazard_type != 7 &&
                                element1.hazard_type != 8 &&
                                element1.hazard_type != 3 &&
                                element1.value != 115
                              ) {
                                booster_check = 1;
                              }
                        });
                        if (booster_check == 1)
                          var shuffle_booster = game.add.sprite(0, -30, 'game_atlas', 'shuffle_booster.png');
                        else var shuffle_booster = game.add.sprite(0, -30, 'game_atlas', 'shuffle_booster_grey.png');
                        shuffle_booster.anchor.setTo(0.5);
                        shuffle_booster.t = t;
                        shuffle_booster.scale.setTo(0.9);
                        button_animation_f(shuffle_booster, 0.9);
                        shuffle_booster.events.onInputUp.add(function (itm) {
                          btnup(itm);
                          if (popup == 3 && game_move == 0 && animation == 0) {
                            booster_shuffle_animation(itm);
                          }
                          game_move = 0;
                        }, this);
                        ticket_booster3.addChild(shuffle_booster);
                        if (booster_shuffle_col > 0 || (coins >= booster_shuffle_price && shop == 0)) {
                          var p_text = game.cache.getJSON('lang')['t297'][0][window.lang];
                          p_text = p_text.replace('[x]', booster_shuffle_col);
                          if (booster_shuffle_col > 0)
                            shuffle_booster_text = game.add.text(0, 56, p_text, {
                              font: '26px RussoOne',
                              fill: '#fff',
                              align: 'center',
                            });
                          else
                            shuffle_booster_text = game.add.text(10, 56, booster_shuffle_price, {
                              font: '26px RussoOne',
                              fill: '#fff',
                              align: 'center',
                            });
                          shuffle_booster_text.anchor.setTo(0.5);
                          shuffle_booster_text.stroke = '#000';
                          shuffle_booster_text.strokeThickness = 3;
                          ticket_booster3.addChild(shuffle_booster_text);
                          if (booster_shuffle_col <= 0) {
                            var shuffle_booster_coin = game.add.sprite(
                              -shuffle_booster_text.width / 2 - 10,
                              54,
                              'game_atlas',
                              'icon_coins.png',
                            );
                            shuffle_booster_coin.anchor.setTo(0.5, 0.5);
                            shuffle_booster_coin.scale.setTo(0.7);
                            ticket_booster3.addChild(shuffle_booster_coin);
                          }
                        } else {
                          shuffle_booster_text = game.add.sprite(
                            shuffle_booster.width / 2 - 20,
                            shuffle_booster.height / 2 - 20,
                            'game_ui_atlas',
                            'Get_Coins_Plus_Button.png',
                          );
                          shuffle_booster_text.scale.setTo(0.7);
                          shuffle_booster_text.anchor.setTo(0.5);
                          shuffle_booster.addChild(shuffle_booster_text);
                        }
                        ticket_booster_group.y += 209;
                        ticket_booster_group.h += 209;
                      }
                      game.add
                        .tween(ticket_booster_group)
                        .to({ y: '-' + ticket_booster_group.y }, 500, Phaser.Easing.Quadratic.Out, true, 100)
                        .onComplete.add(function () {
                          game.add.tween(info_button).to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true);
                          if (ticket_booster_group.t != 1) {
                            game.add
                              .tween(close_suitcase_button)
                              .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true);
                          }
                          animation = 0;
                          popup = 3;
                        });
                      game.world.bringToTop(ticket_booster_group);
                      if (t == 1) {
                        tnt_booster_cloud = game.add.sprite(
                          game.world.centerX + 815 - 50,
                          game.world.height - 164 + 63 - 143,
                          'game_atlas',
                          'stargate_cloud.png',
                        );
                        tnt_booster_cloud.anchor.setTo(0.5, 1);
                        tnt_booster_cloud.scale.setTo(0);
                        var chest_cloud_text = game.add.text(
                          0,
                          -60,
                          game.cache.getJSON('lang')['TryMe'][0][window.lang],
                          {
                            font: '20px RussoOne',
                            fill: '#6A3011',
                            align: 'center',
                            wordWrap: true,
                            wordWrapWidth: 180,
                          },
                        );
                        chest_cloud_text.anchor.setTo(0.5, 0.5);
                        chest_cloud_text.lineSpacing = -10;
                        tnt_booster_cloud.addChild(chest_cloud_text);
                        game.add
                          .tween(tnt_booster_cloud.scale)
                          .to({ x: 1, y: 1 }, 300, Phaser.Easing.Linear.None, true, 500);
                        game.world.bringToTop(tnt_booster_cloud);
                      }
                      info_button = game.add.sprite(
                        game.world.centerX + 750,
                        game.world.height - 164 + 63 + 18,
                        'game_atlas',
                        'info_button.png',
                      );
                      info_button.anchor.setTo(0.5);
                      info_button.scale.setTo(1.1);
                      button_animation_f(info_button, 1.1);
                      info_button.events.onInputDown.add(function (item) {
                        btnup(item);
                        booster_info();
                      }, this);
                      info_button.alpha = 0;
                      close_suitcase_button = game.add.sprite(
                        game.world.centerX + 880,
                        game.world.height - 164 + 63 + 18 - ticket_booster_group.h,
                        'game_window2_atlas',
                        'Close_Button.png',
                      );
                      close_suitcase_button.anchor.setTo(0.5);
                      close_suitcase_button.scale.setTo(0.8);
                      button_animation_f(close_suitcase_button, 0.8);
                      close_suitcase_button.events.onInputDown.add(function (item) {
                        btnup(item);
                        if (info_box_9slices1 != 0) {
                          info_box_9slices1.destroy();
                          info_box_9slices1 = 0;
                        }
                        if (info_box_9slices2 != 0) {
                          info_box_9slices2.destroy();
                          info_box_9slices2 = 0;
                        }
                        if (info_box_9slices3 != 0) {
                          info_box_9slices3.destroy();
                          info_box_9slices3 = 0;
                        }
                        if (popup == 3 && ticket_booster_group.t != 1) {
                          if (sound_on == 1) {
                            play_sound('suitcase_close');
                          }
                          popup = 30;
                          if (info_button != 0) {
                            info_button.destroy();
                            info_button = 0;
                          }
                          game.add
                            .tween(black_sprite)
                            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                            .onComplete.add(function (item) {
                              item.destroy();
                            });
                          game.add
                            .tween(ticket_booster_group)
                            .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
                            .onComplete.add(function (item) {
                              suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
                              game.add
                                .tween(suitcase_close)
                                .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                                .onComplete.add(function (item) {
                                  game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                                });
                              popup = 0;
                            });
                          if (close_suitcase_button != 0) {
                            close_suitcase_button.destroy();
                            close_suitcase_button = 0;
                          }
                        }
                      }, this);
                      close_suitcase_button.alpha = 0;
                    });
                });
            });
        }
      }
      var info_box_9slices1 = 0;
      var info_box_9slices2 = 0;
      var info_box_9slices3 = 0;
      var info_box_9slices4 = 0;
      function booster_info() {
        if (info_box_9slices1 == 0 && info_box_9slices2 == 0 && info_box_9slices3 == 0) {
          if ((level >= 26 || suitcase_add >= 1 || baloon == 1 || xmas == 1) && info_box_9slices1 == 0) {
            info_box_9slices1 = game.add.sprite(
              ticket_booster1.x - 285,
              ticket_booster1.y - 32,
              'game_atlas',
              'info_box_9slices.png',
            );
            info_box_9slices1.anchor.setTo(0.5);
            info_box_9slices1.scale.setTo(0);
            ticket_booster_group.add(info_box_9slices1);
            var info_box_text = game.add.text(0, -16, game.cache.getJSON('lang')['TNTBooster'][0][window.lang], {
              font: '18px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            info_box_text.anchor.setTo(0.5);
            info_box_9slices1.addChild(info_box_text);
            var info_box_text = game.add.text(0, 19, game.cache.getJSON('lang')['TNTBoosterText'][0][window.lang], {
              font: '16px RussoOne',
              fill: '#850800',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 280,
            });
            info_box_text.lineSpacing = -10;
            info_box_text.anchor.setTo(0.5);
            info_box_9slices1.addChild(info_box_text);
            var info_box_9slices1_close = game.add.sprite(144, -30, 'game_window2_atlas', 'Close_Button.png');
            info_box_9slices1_close.anchor.setTo(0.5);
            info_box_9slices1_close.scale.setTo(0.4);
            button_animation_f(info_box_9slices1_close, 0.4);
            info_box_9slices1_close.events.onInputDown.add(function (item) {
              btnup(item);
              if (info_box_9slices1 != 0) {
                info_box_9slices1.destroy();
                info_box_9slices1 = 0;
              }
            }, this);
            info_box_9slices1.addChild(info_box_9slices1_close);
            game.add.tween(info_box_9slices1.scale).to({ x: 1.3, y: 1.3 }, 700, Phaser.Easing.Elastic.Out, true);
          }
          if ((level >= 40 || suitcase_add >= 2 || baloon == 1 || xmas == 1) && info_box_9slices2 == 0) {
            info_box_9slices2 = game.add.sprite(
              ticket_booster2.x - 285,
              ticket_booster2.y - 32,
              'game_atlas',
              'info_box_9slices.png',
            );
            info_box_9slices2.anchor.setTo(0.5);
            info_box_9slices2.scale.setTo(0);
            ticket_booster_group.add(info_box_9slices2);
            var info_box_text = game.add.text(0, -16, game.cache.getJSON('lang')['BullseyeBooster'][0][window.lang], {
              font: '18px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            info_box_text.anchor.setTo(0.5);
            info_box_9slices2.addChild(info_box_text);
            var info_box_text = game.add.text(
              0,
              19,
              game.cache.getJSON('lang')['BullseyeBoosterText'][0][window.lang],
              { font: '16px RussoOne', fill: '#850800', align: 'center', wordWrap: true, wordWrapWidth: 280 },
            );
            info_box_text.lineSpacing = -10;
            info_box_text.anchor.setTo(0.5);
            info_box_9slices2.addChild(info_box_text);
            var info_box_9slices2_close = game.add.sprite(144, -30, 'game_window2_atlas', 'Close_Button.png');
            info_box_9slices2_close.anchor.setTo(0.5);
            info_box_9slices2_close.scale.setTo(0.4);
            button_animation_f(info_box_9slices2_close, 0.4);
            info_box_9slices2_close.events.onInputDown.add(function (item) {
              btnup(item);
              if (info_box_9slices2 != 0) {
                info_box_9slices2.destroy();
                info_box_9slices2 = 0;
              }
            }, this);
            info_box_9slices2.addChild(info_box_9slices2_close);
            game.add.tween(info_box_9slices2.scale).to({ x: 1.3, y: 1.3 }, 700, Phaser.Easing.Elastic.Out, true);
          }
          if ((level >= 45 || suitcase_add >= 3 || baloon == 1 || xmas == 1) && info_box_9slices3 == 0) {
            info_box_9slices3 = game.add.sprite(
              ticket_booster3.x - 285,
              ticket_booster3.y - 32,
              'game_atlas',
              'info_box_9slices.png',
            );
            info_box_9slices3.anchor.setTo(0.5);
            info_box_9slices3.scale.setTo(0);
            ticket_booster_group.add(info_box_9slices3);
            var info_box_text = game.add.text(0, -16, game.cache.getJSON('lang')['ShuffleBooster'][0][window.lang], {
              font: '18px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            info_box_text.anchor.setTo(0.5);
            info_box_9slices3.addChild(info_box_text);
            var info_box_text = game.add.text(0, 19, game.cache.getJSON('lang')['ShuffleBoosterText'][0][window.lang], {
              font: '16px RussoOne',
              fill: '#850800',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 280,
            });
            info_box_text.lineSpacing = -10;
            info_box_text.anchor.setTo(0.5);
            info_box_9slices3.addChild(info_box_text);
            var info_box_9slices3_close = game.add.sprite(144, -30, 'game_window2_atlas', 'Close_Button.png');
            info_box_9slices3_close.anchor.setTo(0.5);
            info_box_9slices3_close.scale.setTo(0.4);
            button_animation_f(info_box_9slices3_close, 0.4);
            info_box_9slices3_close.events.onInputDown.add(function (item) {
              btnup(item);
              if (info_box_9slices3 != 0) {
                info_box_9slices3.destroy();
                info_box_9slices3 = 0;
              }
            }, this);
            info_box_9slices3.addChild(info_box_9slices3_close);
            game.add.tween(info_box_9slices3.scale).to({ x: 1.3, y: 1.3 }, 700, Phaser.Easing.Elastic.Out, true);
          }
        } else {
          if (info_box_9slices1 != 0) {
            info_box_9slices1.destroy();
            info_box_9slices1 = 0;
          }
          if (info_box_9slices2 != 0) {
            info_box_9slices2.destroy();
            info_box_9slices2 = 0;
          }
          if (info_box_9slices3 != 0) {
            info_box_9slices3.destroy();
            info_box_9slices3 = 0;
          }
          if (info_box_9slices4 != 0) {
            info_box_9slices4.destroy();
            info_box_9slices4 = 0;
          }
        }
      }
      var emitter_smoke = game.add.emitter(0, 0, 50);
      emitter_smoke.makeParticles('game_atlas', 'smoke.png');
      emitter_smoke.bringToTop = true;
      emitter_smoke.setRotation(0, 360, 500);
      emitter_smoke.setAlpha(1, 0, 500);
      emitter_smoke.setScale(0.1, 1, 0.1, 1, 500);
      emitter_smoke.gravity = 0;
      emitter_smoke.minParticleSpeed.set(-500, -500);
      emitter_smoke.maxParticleSpeed.set(500, 500);
      emitter_smoke.explode = true;
      emitter_smoke.blendMode = 1;
      function booster_time_animation(itm) {
        booster_check = 0;
        cards_group.children.forEach(function (element1) {
          if (booster_timestop_col > 0 || coins >= booster_timestop_price)
            if (element1.vis == 1)
              if (element1.hazard_type == 1 || element1.hazard_type == 4 || element1.hazard_type == 5) {
                booster_check = 1;
              }
        });
        if (booster_check == 1) {
          if (sound_on == 1) {
            play_sound('suitcase_close');
          }
          if (close_suitcase_button != 0) {
            close_suitcase_button.destroy();
            close_suitcase_button = 0;
          }
          if (info_button != 0) {
            info_button.destroy();
            info_button = 0;
          }
          if (info_box_9slices1 != 0) {
            info_box_9slices1.destroy();
            info_box_9slices1 = 0;
          }
          if (info_box_9slices2 != 0) {
            info_box_9slices2.destroy();
            info_box_9slices2 = 0;
          }
          if (info_box_9slices3 != 0) {
            info_box_9slices3.destroy();
            info_box_9slices3 = 0;
          }
          if (info_box_9slices4 != 0) {
            info_box_9slices4.destroy();
            info_box_9slices4 = 0;
          }
          popup = 4;
          game.add
            .tween(itm.scale)
            .to({ x: 0.8, y: 0.8 }, 200, Phaser.Easing.Quadratic.In, true)
            .onComplete.add(function () {
              game.add
                .tween(itm.scale)
                .to({ x: 1, y: 1 }, 200, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function () {
                  if (itm.t == 1) {
                    game.add.tween(tnt_booster_cloud).to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true);
                  }
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(ticket_booster_group)
                    .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
                    .onComplete.add(function (item) {
                      suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
                      game.add
                        .tween(suitcase_close)
                        .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                        .onComplete.add(function (item) {
                          game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                        });
                      start_card_mas = [];
                      if (booster_timestop_col > 0) {
                        booster_timestop_col -= 1;
                        game.setUserDataAndLog({ booster_timestop_col: booster_timestop_col });
                        if (booster_timestop_col > 0) {
                          var p_text = game.cache.getJSON('lang')['t297'][0][window.lang];
                          p_text = p_text.replace('[x]', booster_timestop_col);
                          time_booster_text.setText(p_text);
                        }
                      } else if (coins >= booster_timestop_price) {
                        coins -= booster_timestop_price;
                        coins_text.setText(coins);
                      }
                      cards_group.children.forEach(function (element1) {
                        if (element1.vis == 1)
                          if (element1.hazard_type == 1 || element1.hazard_type == 4 || element1.hazard_type == 5) {
                            booster_check = 1;
                            game.add.tween(element1).to({ angle: 720 }, 400, Phaser.Easing.Linear.None, true);
                            hazard_cards[element1.n].hazard_type = -1;
                            element1.hazard_type = 0;
                            start_card_mas = [];
                            element1.children.forEach(function (element2) {
                              element2.alpha = 0;
                            });
                          }
                      });
                      var t = 400;
                      if (sound_on == 1) {
                        play_sound('timewarp');
                      }
                      game.add.tween(effects_group).to({ alpha: 1 }, t, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                        popup = 0;
                        animation = 0;
                        game_win();
                        game_loss();
                        visible_cards(0);
                      });
                    });
                });
            });
        } else {
          if (booster_timestop_col > 0 || coins >= booster_timestop_price) {
            animation = 1;
            game.add
              .tween(itm)
              .to({ x: '+5' }, 50, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ x: '-10' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ x: '+10' }, 100, Phaser.Easing.Quadratic.In, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ x: '-5' }, 50, Phaser.Easing.Quadratic.In, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
          } else {
            if (sound_on == 1) {
              play_sound('suitcase_close');
            }
            popup = 30;
            if (close_suitcase_button != 0) {
              close_suitcase_button.destroy();
              close_suitcase_button = 0;
            }
            if (info_button != 0) {
              info_button.destroy();
              info_button = 0;
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(ticket_booster_group)
              .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
                game.add
                  .tween(suitcase_close)
                  .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                  });
                popup = 0;
                if (shop == 1) {
                  shop_window(
                    0,
                    0,
                    0,
                    [
                      { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                      { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                      { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                      { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                      {
                        4: {
                          id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                          packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                          price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                          reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                        },
                      },
                    ],
                    [
                      {
                        0: {
                          type: 'Coins_Pack_1.png',
                          sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                          col: '1 000',
                          id: 'coin_package_001',
                          packname: '1,000 Coins',
                          price: '0.99 $',
                          atlas: 'game_window_atlas',
                          reward: [1000],
                        },
                      },
                      {
                        1: {
                          type: 'Coins_Pack_2.png',
                          sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                          col: '6 000',
                          id: 'coin_package_02',
                          packname: '6,000 Coins',
                          price: '4.99 $',
                          atlas: 'game_window_atlas',
                          reward: [6000],
                        },
                      },
                      {
                        2: {
                          type: 'Coins_Pack_3.png',
                          sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                          col: '13 000',
                          id: 'coin_package_003',
                          packname: '13,000 Coins',
                          price: '9.99 $',
                          atlas: 'game_window_atlas',
                          reward: [13000],
                        },
                      },
                      {
                        3: {
                          type: 'Coins_Pack_4.png',
                          sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                          col: '20 000',
                          id: 'coin_package_004',
                          packname: '20,000 Coins',
                          price: '14.99 $',
                          atlas: 'game_window_atlas',
                          reward: [20000],
                        },
                      },
                    ],
                  );
                } else if (shop == 0) {
                  get_message(2);
                }
              });
            animation = 1;
            game.add
              .tween(itm)
              .to({ x: '+5' }, 50, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ x: '-10' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ x: '+10' }, 100, Phaser.Easing.Quadratic.In, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ x: '-5' }, 50, Phaser.Easing.Quadratic.In, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
            game.add
              .tween(time_booster_text.scale)
              .to({ x: '+0.2', y: '+0.2' }, 100, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(time_booster_text.scale)
                  .to({ x: '-0.2', y: '-0.2' }, 100, Phaser.Easing.Linear.None, true);
              });
          }
        }
      }
      function booster_shuffle_animation(itm) {
        booster_check = 0;
        cards_group.children.forEach(function (element1) {
          if (booster_shuffle_col > 0 || (coins >= booster_shuffle_price && shop == 0))
            if (element1.vis == 1)
              if (
                element1.value != 101 &&
                element1.value != 102 &&
                element1.value != 103 &&
                element1.value != 105 &&
                element1.value != 104 &&
                element1.hazard_type != 1 &&
                element1.hazard_type != 9 &&
                (element1.hazard_type != 10 || (element1.hazard_type == 10 && element1.std != 3)) &&
                element1.hazard_type != 7 &&
                element1.hazard_type != 8 &&
                element1.hazard_type != 3 &&
                element1.value != 115
              ) {
                booster_check = 1;
              }
        });
        if (booster_check == 1) {
          game.setCurrentEvent();
          window.eventTrack('booster_out', 1, {
            user_type: bought,
            lifetime: lifetime_day,
            highest_lvl: all_level.lastIndexOf(3) + 2,
            amount: 1,
            source: 'Shuffle',
            item_id: 0,
            mission_completed: missioncompleted,
            c_event: current_event,
          });
          consumed_Shuffle += 1;
          if (sound_on == 1) {
            play_sound('suitcase_close');
          }
          if (close_suitcase_button != 0) {
            close_suitcase_button.destroy();
            close_suitcase_button = 0;
          }
          if (info_button != 0) {
            info_button.destroy();
            info_button = 0;
          }
          if (info_box_9slices1 != 0) {
            info_box_9slices1.destroy();
            info_box_9slices1 = 0;
          }
          if (info_box_9slices2 != 0) {
            info_box_9slices2.destroy();
            info_box_9slices2 = 0;
          }
          if (info_box_9slices3 != 0) {
            info_box_9slices3.destroy();
            info_box_9slices3 = 0;
          }
          if (info_box_9slices4 != 0) {
            info_box_9slices4.destroy();
            info_box_9slices4 = 0;
          }
          popup = 4;
          game.add
            .tween(itm.scale)
            .to({ x: 0.8, y: 0.8 }, 200, Phaser.Easing.Quadratic.In, true)
            .onComplete.add(function () {
              game.add
                .tween(itm.scale)
                .to({ x: 1, y: 1 }, 200, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function () {
                  if (itm.t == 1) {
                    game.add.tween(tnt_booster_cloud).to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true);
                  }
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(ticket_booster_group)
                    .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
                    .onComplete.add(function (item) {
                      suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
                      game.add
                        .tween(suitcase_close)
                        .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                        .onComplete.add(function (item) {
                          game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                        });
                      start_card_mas = [];
                      if (booster_shuffle_col > 0) {
                        booster_shuffle_col -= 1;

                        if (FTUE > 30)
                          for (var i = 0; i < missions.length; i += 4) {
                            if (missions[i] == -19) {
                              if (missions[i + 2] < missions[i + 1]) {
                                missions[i + 2] += 1;
                              }
                            }
                          }
                        if (booster_shuffle_col > 0) {
                          var p_text = game.cache.getJSON('lang')['t297'][0][window.lang];
                          p_text = p_text.replace('[x]', booster_shuffle_col);
                          shuffle_booster_text.setText(p_text);
                        } else {
                          shuffle_booster_text.setText(booster_shuffle_price);
                          var shuffle_booster_coin = game.add.sprite(
                            -shuffle_booster_text.width / 2 - 10,
                            54,
                            'game_atlas',
                            'icon_coins.png',
                          );
                          shuffle_booster_coin.anchor.setTo(0.5, 0.5);
                          shuffle_booster_coin.scale.setTo(0.7);
                          ticket_booster3.addChild(shuffle_booster_coin);
                        }
                      } else if (coins >= booster_shuffle_price) {
                        coins -= booster_shuffle_price;
                        game.setCurrentEvent();
                        window.eventTrack('coins_out', booster_shuffle_price, {
                          user_type: bought,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          amount: booster_shuffle_price,
                          source: 'Buy shuffle',
                          item_id: 0,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                        booster_shuffle_price += 150;
                        coins_text.setText(coins);
                      }
                      cards_group.children.forEach(function (element1) {
                        if (element1.vis == 1)
                          if (
                            element1.value != 101 &&
                            element1.value != 102 &&
                            element1.value != 103 &&
                            element1.value != 105 &&
                            element1.value != 104 &&
                            element1.hazard_type != 1 &&
                            element1.hazard_type != 9 &&
                            (element1.hazard_type != 10 || (element1.hazard_type == 10 && element1.std != 3)) &&
                            element1.hazard_type != 7 &&
                            element1.hazard_type != 8 &&
                            element1.hazard_type != 3 &&
                            element1.value != 115
                          ) {
                            game.add
                              .tween(element1.scale)
                              .to({ x: 0, y: card_size + 0.02 }, 200, Phaser.Easing.Linear.None, true);
                            game.add
                              .tween(element1)
                              .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
                              .onComplete.add(function (item) {
                                item.loadTexture('game5_atlas', backcards_select, false);
                                element1.vis = 2;
                                if (element1.hazard_type != 2 && element1.hazard_type != 6 && element1.ht != 6)
                                  if (element1.children[0]) element1.children[0].destroy();
                                game.add
                                  .tween(item.scale)
                                  .to({ x: card_size, y: card_size }, 200, Phaser.Easing.Linear.None, true);
                              });
                          }
                      });
                      if (sound_on == 1) {
                        play_sound('SHUFFLE');
                      }
                      game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                        for (var i = 0; i < cards_group.length * 2; i++) {
                          var setcard1 = cards_group.getRandom();
                          var setcard2 = cards_group.getRandom();
                          if (
                            setcard1.value != 101 &&
                            setcard1.value != 102 &&
                            setcard1.value != 103 &&
                            setcard1.value != 105 &&
                            setcard1.value != 104 &&
                            setcard1.hazard_type != 1 &&
                            setcard1.hazard_type != 9 &&
                            (setcard1.hazard_type != 10 || (setcard1.hazard_type == 10 && setcard1.std != 3)) &&
                            setcard1.hazard_type != 7 &&
                            setcard1.hazard_type != 8 &&
                            setcard1.hazard_type != 3 &&
                            setcard1.value != 115
                          )
                            if (
                              setcard2.value != 101 &&
                              setcard2.value != 102 &&
                              setcard2.value != 103 &&
                              setcard2.value != 105 &&
                              setcard2.value != 104 &&
                              setcard2.hazard_type != 1 &&
                              setcard2.hazard_type != 9 &&
                              (setcard2.hazard_type != 10 || (setcard2.hazard_type == 10 && setcard2.std != 3)) &&
                              setcard2.hazard_type != 7 &&
                              setcard2.hazard_type != 8 &&
                              setcard2.hazard_type != 3 &&
                              setcard2.value != 115
                            ) {
                              let x1 = setcard1.x;
                              let y1 = setcard1.y;
                              let an1 = setcard1.angle;
                              let d1 = setcard1.depth;
                              let v1 = setcard1.vis;
                              let ht = 0;
                              let ht2 = 0;
                              var n = 0;
                              var n2 = 0;
                              if (setcard1.hazard_type == 2 || setcard1.hazard_type == 6 || setcard1.ht == 6) {
                                ht = setcard1.ht;
                                n = setcard1.n;
                                if (setcard1.children[0]) setcard1.children[0].destroy();
                                setcard1.hazard_type = 0;
                                setcard1.ht = 0;
                              }
                              if (setcard2.hazard_type == 2 || setcard2.hazard_type == 6 || setcard2.ht == 6) {
                                ht2 = setcard2.ht;
                                n2 = setcard2.n;
                                if (setcard2.children[0]) setcard2.children[0].destroy();
                                setcard2.hazard_type = 0;
                                setcard2.ht = 0;
                              }
                              setcard1.x = setcard2.x;
                              setcard1.y = setcard2.y;
                              setcard1.angle = setcard2.angle;
                              setcard1.depth = setcard2.depth;
                              setcard1.vis = setcard2.vis;
                              if (ht2 != 0) {
                                setcard1.hazard_type = ht2;
                                setcard1.ht = ht2;
                                setcard1.n = n2;
                              }
                              setcard2.x = x1;
                              setcard2.y = y1;
                              setcard2.angle = an1;
                              setcard2.depth = d1;
                              setcard2.vis = v1;
                              if (ht != 0) {
                                setcard2.hazard_type = ht;
                                setcard2.ht = ht;
                                setcard2.n = n;
                              }
                              cards_group.sort('depth', Phaser.Group.SORT_ASCENDING);
                            }
                        }
                        cards_group.children.forEach(function (element1) {
                          if (element1.vis == 2) {
                            element1.vis = 1;
                            if (element1.ht == 6)
                              if (!element1.children[0]) {
                                var cards_water = game.add.sprite(0, -4, 'game_atlas');
                                cards_water.anchor.setTo(0.5);
                                cards_water.animations.add(
                                  'WAVE',
                                  ['WAVE1.png', 'WAVE2.png', 'WAVE3.png', 'WAVE2.png'],
                                  6,
                                  true,
                                );
                                cards_water.alpha = 0.6;
                                element1.addChild(cards_water);
                                cards_water.animations.play('WAVE');
                                element1.hazard_type = 6;
                                element1.ht = 6;
                              }
                            if (element1.ht == 2)
                              if (!element1.children[0]) {
                                var frozen = game.add.sprite(0, 0, 'game_atlas', 'Ice_card.png');
                                frozen.anchor.setTo(0.5);
                                element1.addChild(frozen);
                                element1.hazard_type = 2;
                                element1.ht = 2;
                              }
                            if (element1.hazard_type == 4) {
                              var cards_lowering = game.add.sprite(0, 0, 'game_atlas', 'cards_lowering.png');
                              cards_lowering.anchor.setTo(0.5);
                              element1.addChild(cards_lowering);
                            } else if (element1.hazard_type == 5) {
                              element1.loadTexture('game_atlas', 'card' + element1.draw + '.png', 0);
                              var cards_rising = game.add.sprite(0, 0, 'game_atlas', 'cards_rising.png');
                              cards_rising.anchor.setTo(0.5);
                              element1.addChild(cards_rising);
                            }
                            if (
                              element1.value != 101 &&
                              element1.value != 102 &&
                              element1.value != 103 &&
                              element1.value != 105 &&
                              element1.value != 104 &&
                              element1.hazard_type != 1 &&
                              element1.hazard_type != 9 &&
                              (element1.hazard_type != 10 || (element1.hazard_type == 10 && element1.std != 3)) &&
                              element1.hazard_type != 7 &&
                              element1.hazard_type != 8 &&
                              element1.hazard_type != 3
                            ) {
                              game.add
                                .tween(element1.scale)
                                .to({ x: 0, y: card_size + 0.02 }, 200, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(element1)
                                .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function (item) {
                                  item.loadTexture('game_atlas', 'card' + item.draw + '.png', false);
                                  game.add
                                    .tween(item.scale)
                                    .to({ x: card_size, y: card_size }, 200, Phaser.Easing.Linear.None, true);
                                });
                            }
                          }
                        });
                      });
                      game.add.tween(effects_group).to({ alpha: 1 }, 1000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                        popup = 0;
                        animation = 0;
                        game_win();
                        game_loss();
                      });
                    });
                });
            });
        } else {
          if (booster_shuffle_col > 0 || (coins >= booster_shuffle_price && shop == 0)) {
            animation = 1;
            game.add
              .tween(itm)
              .to({ x: '+5' }, 50, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ x: '-10' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ x: '+10' }, 100, Phaser.Easing.Quadratic.In, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ x: '-5' }, 50, Phaser.Easing.Quadratic.In, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
          } else {
            if (sound_on == 1) {
              play_sound('suitcase_close');
            }
            popup = 30;
            if (close_suitcase_button != 0) {
              close_suitcase_button.destroy();
              close_suitcase_button = 0;
            }
            if (info_button != 0) {
              info_button.destroy();
              info_button = 0;
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(ticket_booster_group)
              .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
                game.add
                  .tween(suitcase_close)
                  .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                  });
                popup = 0;
                if (shop == 1) {
                  shop_window(
                    1,
                    0,
                    600,
                    [
                      { 0: { type: '2_Shuffle_Pack.png', col: '20x', atlas: 'game_window2_atlas' } },
                      { 1: { type: 'Big_Kit_List_Coin.png', col: '2 000', atlas: 'game_window_atlas' } },
                      { 2: { type: 'Big_Kit_List_Energy.png', col: '5x', atlas: 'game_window_atlas' } },
                      { 3: { type: 'List_Cards.png', col: '1x', atlas: 'game_window2_atlas' } },
                      {
                        4: {
                          id: 'shuffle_ingame_pack',
                          packname: 'Shuffle Package',
                          price: '9.99 $',
                          reward: [2000, 5, 0, 1, 0, 0, 20, 0],
                        },
                      },
                    ],
                    [
                      {
                        0: {
                          type: '2_Shuffle_Pack.png',
                          sprite: '2_Shuffle_Pack.png',
                          col: '2x',
                          id: 'shuffle_ingame1',
                          packname: '2x Shuffle',
                          price: '1.99 $',
                          atlas: 'game_window2_atlas',
                          reward: [0, 0, 0, 0, 0, 0, 2, 0],
                        },
                      },
                      {
                        1: {
                          type: '5_Shuffle_Pack.png',
                          sprite: '5_Shuffle_Pack.png',
                          col: '5x',
                          id: 'shuffle_ingame2',
                          packname: '5x Shuffle',
                          price: '3.99 $',
                          atlas: 'game_window2_atlas',
                          reward: [0, 0, 0, 0, 0, 0, 5, 0],
                        },
                      },
                      {
                        2: {
                          type: '10_Shuffle_Pack.png',
                          sprite: '10_Shuffle_Pack.png',
                          col: '10x',
                          id: 'shuffle_ingame3',
                          packname: '10x Shuffle',
                          price: '5.99 $',
                          atlas: 'game_window2_atlas',
                          reward: [0, 0, 0, 0, 0, 0, 10, 0],
                        },
                      },
                      { 3: { type: 0, sprite: 0, col: 0, id: 0, packname: 0, price: 0, atlas: 'game_atlas' } },
                    ],
                  );
                } else if (shop == 0) {
                  get_message(2);
                }
              });
            animation = 1;
            game.add
              .tween(itm)
              .to({ x: '+5' }, 50, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ x: '-10' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ x: '+10' }, 100, Phaser.Easing.Quadratic.In, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ x: '-5' }, 50, Phaser.Easing.Quadratic.In, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
            game.add
              .tween(shuffle_booster_text.scale)
              .to({ x: '+0.2', y: '+0.2' }, 100, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(shuffle_booster_text.scale)
                  .to({ x: '-0.2', y: '-0.2' }, 100, Phaser.Easing.Linear.None, true);
              });
          }
        }
      }
      function booster_bullseye_animation(itm) {
        booster_check = 0;
        cards_group.children.forEach(function (element1) {
          if (booster_eye_col > 0 || (coins >= booster_eye_price && shop == 0))
            if (
              element1.vis == 1 &&
              element1.value != 101 &&
              element1.value != 102 &&
              element1.value != 103 &&
              element1.value != 105 &&
              element1.value != 104 &&
              element1.hazard_type != 9 &&
              element1.hazard_type != 7 &&
              element1.hazard_type != 8 &&
              element1.hazard_type != 3
            ) {
              booster_check = 1;
            }
        });
        if (booster_check == 1) {
          game.setCurrentEvent();
          window.eventTrack('booster_out', 1, {
            user_type: bought,
            lifetime: lifetime_day,
            highest_lvl: all_level.lastIndexOf(3) + 2,
            amount: 1,
            source: 'Bullseye',
            item_id: 0,
            mission_completed: missioncompleted,
            c_event: current_event,
          });
          if (sound_on == 1) {
            play_sound('suitcase_close');
          }
          if (close_suitcase_button != 0) {
            close_suitcase_button.destroy();
            close_suitcase_button = 0;
          }
          if (info_button != 0) {
            info_button.destroy();
            info_button = 0;
          }
          if (info_box_9slices1 != 0) {
            info_box_9slices1.destroy();
            info_box_9slices1 = 0;
          }
          if (info_box_9slices2 != 0) {
            info_box_9slices2.destroy();
            info_box_9slices2 = 0;
          }
          if (info_box_9slices3 != 0) {
            info_box_9slices3.destroy();
            info_box_9slices3 = 0;
          }
          if (info_box_9slices4 != 0) {
            info_box_9slices4.destroy();
            info_box_9slices4 = 0;
          }
          popup = 4;
          game.add
            .tween(itm.scale)
            .to({ x: 0.8, y: 0.8 }, 200, Phaser.Easing.Quadratic.In, true)
            .onComplete.add(function () {
              game.add
                .tween(itm.scale)
                .to({ x: 1, y: 1 }, 200, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function () {
                  if (itm.t == 1) {
                    game.add.tween(tnt_booster_cloud).to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true);
                  }
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(ticket_booster_group)
                    .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
                    .onComplete.add(function (item) {
                      suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
                      game.add
                        .tween(suitcase_close)
                        .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                        .onComplete.add(function (item) {
                          game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                        });
                      combo = 1;
                      start_card_mas = [];
                      if (booster_eye_col > 0) {
                        booster_eye_col -= 1;

                        if (FTUE > 30)
                          for (var i = 0; i < missions.length; i += 4) {
                            if (missions[i] == -21) {
                              if (missions[i + 2] < missions[i + 1]) {
                                missions[i + 2] += 1;
                              }
                            }
                          }
                        if (booster_eye_col > 0) {
                          var p_text = game.cache.getJSON('lang')['t297'][0][window.lang];
                          p_text = p_text.replace('[x]', booster_eye_col);
                          bullseye_booster_text.setText(p_text);
                        } else {
                          bullseye_booster_text.setText(booster_eye_price);
                          var bullseye_booster_coin = game.add.sprite(
                            -bullseye_booster_text.width / 2 - 10,
                            54,
                            'game_atlas',
                            'icon_coins.png',
                          );
                          bullseye_booster_coin.anchor.setTo(0.5, 0.5);
                          bullseye_booster_coin.scale.setTo(0.7);
                          ticket_booster2.addChild(bullseye_booster_coin);
                        }
                      } else if (coins >= booster_eye_price) {
                        coins -= booster_eye_price;
                        game.setCurrentEvent();
                        window.eventTrack('coins_out', booster_eye_price, {
                          user_type: bought,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          amount: booster_eye_price,
                          source: 'Buy bullseye',
                          item_id: 0,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                        booster_eye_price += 150;
                        coins_text.setText(coins);
                      }
                      var aim_card = 0;
                      cards_group.children.forEach(function (element1) {
                        if (
                          element1.vis == 1 &&
                          element1.value != 101 &&
                          element1.value != 102 &&
                          element1.value != 103 &&
                          element1.value != 105 &&
                          element1.value != 104 &&
                          element1.hazard_type != 9 &&
                          element1.hazard_type != 7 &&
                          element1.hazard_type != 8 &&
                          element1.hazard_type != 3
                        ) {
                          if (aim_card == 0) aim_card = element1;
                          else if (game.rnd.integerInRange(0, 2) == 1) aim_card = element1;
                        }
                      });
                      var bullseye_asset = game.add.sprite(aim_card.x, aim_card.y, 'game_atlas', 'bullseye_asset.png');
                      bullseye_asset.anchor.setTo(0.5);
                      bullseye_asset.scale.setTo(0);
                      if (
                        aim_card.hazard_type == 1 ||
                        aim_card.hazard_type == 2 ||
                        aim_card.hazard_type == 4 ||
                        aim_card.hazard_type == 5
                      ) {
                        hazard_cards[aim_card.n].hazard_type = -1;
                        aim_card.hazard_type = 0;
                      }
                      game.add
                        .tween(bullseye_asset.scale)
                        .to({ x: 1, y: 1 }, 800, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(bullseye_asset.scale)
                            .to({ x: 0, y: 0 }, 200, Phaser.Easing.Linear.None, true, 200)
                            .onComplete.add(function (item) {
                              if (sound_on == 1) {
                                play_sound('Bullseye');
                              }
                              emitter.bringToTop = true;
                              emitter.minParticleSpeed.set(-400, -400);
                              emitter.maxParticleSpeed.set(400, 400);
                              emitter.x = aim_card.x;
                              emitter.y = aim_card.y;
                              emitter.start(true, 500, 0, 20);
                              if (aim_card.hazard_type == 6 || aim_card.ht == 6) {
                                hazard_cards[aim_card.n].hazard_type = -1;
                                aim_card.hazard_type = 0;
                                water_n -= 1;
                                if (water_n == 0) {
                                  for (var i = 0; i < hzcol; i++) {
                                    if (hazard_cards[i].hazard_type == 7) {
                                      game.add
                                        .tween(hazard_cards[i])
                                        .to({ y: '-200' }, 600, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(hazard_cards[i])
                                        .to({ angle: '+360' }, 600, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(hazard_cards[i])
                                        .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 200)
                                        .onComplete.add(function (itemn) {
                                          itemn.destroy();
                                          game_win();
                                          game_loss();
                                          visible_cards(0);
                                        });
                                      hazard_cards[hazard_cards[i].n].hazard_type = -1;
                                      if (sound_on == 1) {
                                        play_sound('anchor');
                                      }
                                    }
                                  }
                                }
                              }
                              aim_card.destroy();
                              combo += 1;
                              popup = 0;
                              animation = 0;
                              game_win();
                              game_loss();
                              visible_cards(0);
                            });
                        });
                    });
                });
            });
        } else {
          if (booster_eye_col > 0 || (coins >= booster_eye_price && shop == 0)) {
            animation = 1;
            game.add
              .tween(itm)
              .to({ x: '+5' }, 50, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ x: '-10' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ x: '+10' }, 100, Phaser.Easing.Quadratic.In, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ x: '-5' }, 50, Phaser.Easing.Quadratic.In, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
          } else {
            if (sound_on == 1) {
              play_sound('suitcase_close');
            }
            popup = 30;
            if (close_suitcase_button != 0) {
              close_suitcase_button.destroy();
              close_suitcase_button = 0;
            }
            if (info_button != 0) {
              info_button.destroy();
              info_button = 0;
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(ticket_booster_group)
              .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
                game.add
                  .tween(suitcase_close)
                  .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                  });
                popup = 0;
                if (shop == 1) {
                  shop_window(
                    1,
                    0,
                    600,
                    [
                      { 0: { type: '2_Random_Pack.png', col: '20x', atlas: 'game_window2_atlas' } },
                      { 1: { type: 'Big_Kit_List_Coin.png', col: '2 000', atlas: 'game_window_atlas' } },
                      { 2: { type: 'Big_Kit_List_Energy.png', col: '5x', atlas: 'game_window_atlas' } },
                      { 3: { type: 'List_Cards.png', col: '1x', atlas: 'game_window2_atlas' } },
                      {
                        4: {
                          id: 'randomcard_ingame_pack',
                          packname: 'Bullseye Package',
                          price: '13.99 $',
                          reward: [2000, 5, 0, 1, 0, 0, 0, 20],
                        },
                      },
                    ],
                    [
                      {
                        0: {
                          type: '2_Random_Pack.png',
                          sprite: '2_Random_Pack.png',
                          col: '2x',
                          id: 'randomcard_ingame1',
                          packname: '2x Bullseye',
                          price: '1.99 $',
                          atlas: 'game_window2_atlas',
                          reward: [0, 0, 0, 0, 0, 0, 0, 2],
                        },
                      },
                      {
                        1: {
                          type: '5_Random_Pack.png',
                          sprite: '5_Random_Pack.png',
                          col: '5x',
                          id: 'randomcard_ingame2',
                          packname: '5x Bullseye',
                          price: '3.99 $',
                          atlas: 'game_window2_atlas',
                          reward: [0, 0, 0, 0, 0, 0, 0, 5],
                        },
                      },
                      {
                        2: {
                          type: '10_Random_Pack.png',
                          sprite: '10_Random_Pack.png',
                          col: '10x',
                          id: 'randomcard_ingame3',
                          packname: '10x Bullseye',
                          price: '6.99 $',
                          atlas: 'game_window2_atlas',
                          reward: [0, 0, 0, 0, 0, 0, 0, 10],
                        },
                      },
                      { 3: { type: 0, sprite: 0, col: 0, id: 0, packname: 0, price: 0, atlas: 'game_atlas' } },
                    ],
                  );
                } else if (shop == 0) {
                  get_message(2);
                }
              });
            animation = 1;
            game.add
              .tween(itm)
              .to({ x: '+5' }, 50, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ x: '-10' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ x: '+10' }, 100, Phaser.Easing.Quadratic.In, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ x: '-5' }, 50, Phaser.Easing.Quadratic.In, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
            game.add
              .tween(bullseye_booster_text.scale)
              .to({ x: '+0.2', y: '+0.2' }, 100, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(bullseye_booster_text.scale)
                  .to({ x: '-0.2', y: '-0.2' }, 100, Phaser.Easing.Linear.None, true);
              });
          }
        }
      }
      function booster_tnt_animation(itm) {
        booster_check = 0;
        cards_group.children.forEach(function (element1) {
          if (booster_tnt_col > 0 || (coins >= booster_tnt_price && shop == 0))
            if (element1.vis == 1)
              if (
                element1.value != 101 &&
                element1.value != 102 &&
                element1.value != 103 &&
                element1.value != 105 &&
                element1.value != 104 &&
                element1.hazard_type != 9 &&
                element1.hazard_type != 7 &&
                element1.hazard_type != 8 &&
                element1.hazard_type != 3
              ) {
                booster_check = 1;
              }
        });
        if (booster_check == 1) {
          game.setCurrentEvent();
          window.eventTrack('booster_out', 1, {
            user_type: bought,
            lifetime: lifetime_day,
            highest_lvl: all_level.lastIndexOf(3) + 2,
            amount: 1,
            source: 'TNT',
            item_id: 0,
            mission_completed: missioncompleted,
            c_event: current_event,
          });
          consumed_TNT += 1;
          if (sound_on == 1) {
            play_sound('suitcase_close');
          }
          if (close_suitcase_button != 0) {
            close_suitcase_button.destroy();
            close_suitcase_button = 0;
          }
          if (info_button != 0) {
            info_button.destroy();
            info_button = 0;
          }
          if (info_box_9slices1 != 0) {
            info_box_9slices1.destroy();
            info_box_9slices1 = 0;
          }
          if (info_box_9slices2 != 0) {
            info_box_9slices2.destroy();
            info_box_9slices2 = 0;
          }
          if (info_box_9slices3 != 0) {
            info_box_9slices3.destroy();
            info_box_9slices3 = 0;
          }
          if (info_box_9slices4 != 0) {
            info_box_9slices4.destroy();
            info_box_9slices4 = 0;
          }
          popup = 4;
          game.add
            .tween(itm.scale)
            .to({ x: 0.8, y: 0.8 }, 200, Phaser.Easing.Quadratic.In, true)
            .onComplete.add(function () {
              game.add
                .tween(itm.scale)
                .to({ x: 1, y: 1 }, 200, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function () {
                  if (itm.t == 1) {
                    game.add.tween(tnt_booster_cloud).to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true);
                  }
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(ticket_booster_group)
                    .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
                    .onComplete.add(function (item) {
                      suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
                      game.add
                        .tween(suitcase_close)
                        .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                        .onComplete.add(function (item) {
                          game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                        });
                      var tm = 200;
                      start_card_mas = [];
                      combo = 1;
                      if (booster_tnt_col > 0) {
                        booster_tnt_col -= 1;

                        if (FTUE > 30)
                          for (var i = 0; i < missions.length; i += 4) {
                            if (missions[i] == -18) {
                              if (missions[i + 2] < missions[i + 1]) {
                                missions[i + 2] += 1;
                              }
                            }
                          }
                        if (booster_tnt_col > 0) {
                          var p_text = game.cache.getJSON('lang')['t297'][0][window.lang];
                          p_text = p_text.replace('[x]', booster_tnt_col);
                          tnt_booster_text.setText(p_text);
                        } else {
                          tnt_booster_text.setText(booster_tnt_price);
                          var tnt_booster_coin = game.add.sprite(
                            -tnt_booster_text.width / 2 - 10,
                            54,
                            'game_atlas',
                            'icon_coins.png',
                          );
                          tnt_booster_coin.anchor.setTo(0.5, 0.5);
                          tnt_booster_coin.scale.setTo(0.7);
                          ticket_booster1.addChild(tnt_booster_coin);
                        }
                      } else if (coins >= booster_tnt_price) {
                        coins -= booster_tnt_price;
                        game.setCurrentEvent();
                        window.eventTrack('coins_out', booster_tnt_price, {
                          user_type: bought,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          amount: booster_tnt_price,
                          source: 'Buy TNT',
                          item_id: 0,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                        booster_tnt_price += 400;
                        coins_text.setText(coins);
                      }
                      cards_group.children.forEach(function (element1) {
                        var dest_card = 0;
                        cards_group.children.forEach(function (element2) {
                          var points1 = getPoints1(element1);
                          var points2 = getPoints2(element2);
                          if (polygonPolygon(points1, points2) == true && element1.depth < element2.depth) {
                            dest_card = 1;
                          }
                        });
                        if (element1.vis == 1 && dest_card == 0)
                          if (
                            element1.value != 101 &&
                            element1.value != 102 &&
                            element1.value != 103 &&
                            element1.value != 105 &&
                            element1.value != 104 &&
                            element1.hazard_type != 9 &&
                            element1.hazard_type != 7 &&
                            element1.hazard_type != 8 &&
                            element1.hazard_type != 3
                          ) {
                            var tnt_asset = game.add.sprite(element1.x, -100, 'game_atlas', 'tnt_asset.png');
                            tnt_asset.anchor.setTo(0.5, 0.6);
                            tnt_asset.crd = element1;
                            tnt_asset.tm = tm;
                            game.add
                              .tween(tnt_asset)
                              .to({ y: element1.y }, 500, Phaser.Easing.Quadratic.In, true)
                              .onComplete.add(function (item) {
                                game.add
                                  .tween(item.scale)
                                  .to({ x: 0.9, y: 0.9 }, 50, Phaser.Easing.Linear.None, true)
                                  .onComplete.add(function () {
                                    game.add.tween(item.scale).to({ x: 1, y: 1 }, 50, Phaser.Easing.Linear.None, true);
                                  });
                                game.add
                                  .tween(item)
                                  .to({ angle: '+15' }, 100, Phaser.Easing.Linear.None, true, item.tm)
                                  .onComplete.add(function (item) {
                                    game.add
                                      .tween(item)
                                      .to({ angle: '-30' }, 90, Phaser.Easing.Linear.None, true)
                                      .onComplete.add(function (item) {
                                        game.add
                                          .tween(item)
                                          .to({ angle: '+30' }, 80, Phaser.Easing.Linear.None, true)
                                          .onComplete.add(function (item) {
                                            game.add
                                              .tween(item)
                                              .to({ angle: '-30' }, 70, Phaser.Easing.Linear.None, true)
                                              .onComplete.add(function (item) {
                                                game.add
                                                  .tween(item)
                                                  .to({ angle: '+30' }, 60, Phaser.Easing.Linear.None, true)
                                                  .onComplete.add(function (item) {
                                                    game.add
                                                      .tween(item)
                                                      .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                                                      .onComplete.add(function (item) {
                                                        game.add
                                                          .tween(item)
                                                          .to({ angle: '+30' }, 50, Phaser.Easing.Linear.None, true)
                                                          .onComplete.add(function (item) {
                                                            game.add
                                                              .tween(item)
                                                              .to({ angle: '-30' }, 50, Phaser.Easing.Linear.None, true)
                                                              .onComplete.add(function (item) {
                                                                game.add
                                                                  .tween(item)
                                                                  .to(
                                                                    { angle: '+30' },
                                                                    50,
                                                                    Phaser.Easing.Linear.None,
                                                                    true,
                                                                  )
                                                                  .onComplete.add(function (item) {
                                                                    game.add
                                                                      .tween(item.scale)
                                                                      .to(
                                                                        { x: 1.4, y: 1.4 },
                                                                        200,
                                                                        Phaser.Easing.Linear.None,
                                                                        true,
                                                                      );
                                                                    if (sound_on == 1) {
                                                                      play_sound('TNT_individual_explosion');
                                                                    }
                                                                    game.add
                                                                      .tween(item)
                                                                      .to(
                                                                        { alpha: 0 },
                                                                        200,
                                                                        Phaser.Easing.Linear.None,
                                                                        true,
                                                                      )
                                                                      .onComplete.add(function (item) {
                                                                        if (
                                                                          item.crd.hazard_type == 1 ||
                                                                          item.crd.hazard_type == 2 ||
                                                                          item.crd.hazard_type == 4 ||
                                                                          item.crd.hazard_type == 5
                                                                        ) {
                                                                          hazard_cards[item.crd.n].hazard_type = -1;
                                                                          item.crd.hazard_type = 0;
                                                                          start_card_mas = [];
                                                                        }
                                                                        if (
                                                                          item.crd.hazard_type == 6 ||
                                                                          item.crd.ht == 6
                                                                        ) {
                                                                          hazard_cards[item.crd.n].hazard_type = -1;
                                                                          item.crd.hazard_type = 0;
                                                                          water_n -= 1;
                                                                          if (water_n == 0) {
                                                                            for (var i = 0; i < hzcol; i++) {
                                                                              if (hazard_cards[i].hazard_type == 7) {
                                                                                game.add
                                                                                  .tween(hazard_cards[i])
                                                                                  .to(
                                                                                    { y: '-200' },
                                                                                    600,
                                                                                    Phaser.Easing.Linear.None,
                                                                                    true,
                                                                                  );
                                                                                game.add
                                                                                  .tween(hazard_cards[i])
                                                                                  .to(
                                                                                    { angle: '+360' },
                                                                                    600,
                                                                                    Phaser.Easing.Linear.None,
                                                                                    true,
                                                                                  );
                                                                                game.add
                                                                                  .tween(hazard_cards[i])
                                                                                  .to(
                                                                                    { alpha: 0 },
                                                                                    400,
                                                                                    Phaser.Easing.Linear.None,
                                                                                    true,
                                                                                    200,
                                                                                  )
                                                                                  .onComplete.add(function (itemn) {
                                                                                    itemn.destroy();
                                                                                    visible_cards(0);
                                                                                  });
                                                                                hazard_cards[
                                                                                  hazard_cards[i].n
                                                                                ].hazard_type = -1;
                                                                                if (sound_on == 1) {
                                                                                  play_sound('anchor');
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                        emitter_smoke.bringToTop = true;
                                                                        emitter_smoke.minParticleSpeed.set(-500, -500);
                                                                        emitter_smoke.maxParticleSpeed.set(500, 500);
                                                                        emitter_smoke.x = item.x;
                                                                        emitter_smoke.y = item.y;
                                                                        emitter_smoke.start(true, 600, 0, 6);
                                                                        item.crd.destroy();
                                                                        item.destroy();
                                                                        combo += 1;
                                                                        game_win();
                                                                        game_loss();
                                                                        visible_cards(0);
                                                                      }, this);
                                                                  }, this);
                                                              }, this);
                                                          }, this);
                                                      }, this);
                                                  }, this);
                                              }, this);
                                          }, this);
                                      }, this);
                                  }, this);
                              }, this);
                            tm += 200;
                          }
                      });
                      game.add.tween(effects_group).to({ alpha: 1 }, tm + 2500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                        popup = 0;
                        animation = 0;
                        game_win();
                        game_loss();
                        visible_cards(0);
                      });
                    });
                });
            });
        } else {
          if (booster_tnt_col > 0 || (coins >= booster_tnt_price && shop == 0)) {
            animation = 1;
            game.add
              .tween(itm)
              .to({ x: '+5' }, 50, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ x: '-10' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ x: '+10' }, 100, Phaser.Easing.Quadratic.In, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ x: '-5' }, 50, Phaser.Easing.Quadratic.In, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
          } else {
            if (sound_on == 1) {
              play_sound('suitcase_close');
            }
            popup = 30;
            if (close_suitcase_button != 0) {
              close_suitcase_button.destroy();
              close_suitcase_button = 0;
            }
            if (info_button != 0) {
              info_button.destroy();
              info_button = 0;
            }
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(ticket_booster_group)
              .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
                game.add
                  .tween(suitcase_close)
                  .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                  });
                popup = 0;
                if (shop == 1) {
                  shop_window(
                    1,
                    0,
                    600,
                    [
                      { 0: { type: '2_TNT_Pack.png', col: '15x', atlas: 'game_window2_atlas' } },
                      { 1: { type: 'Big_Kit_List_Coin.png', col: '5 000', atlas: 'game_window_atlas' } },
                      { 2: { type: 'Big_Kit_List_Energy.png', col: '3x', atlas: 'game_window_atlas' } },
                      { 3: { type: 'Big_Kit_List_Card_Back.png', col: '2x', atlas: 'game_window_atlas' } },
                      {
                        4: {
                          id: 'tnt_ingame_pack',
                          packname: 'TNT Package',
                          price: '24.99 $',
                          reward: [5000, 5, 15, 0, 2, 15, 0, 0],
                        },
                      },
                    ],
                    [
                      {
                        0: {
                          type: '2_TNT_Pack.png',
                          sprite: '2_TNT_Pack.png',
                          col: '2x',
                          id: 'tnt_ingame1',
                          packname: '2x TNT',
                          price: '4.49 $',
                          atlas: 'game_window2_atlas',
                          reward: [0, 0, 0, 0, 0, 2],
                        },
                      },
                      {
                        1: {
                          type: '5_TNT_Pack.png',
                          sprite: '5_TNT_Pack.png',
                          col: '5x',
                          id: 'tnt_ingame2',
                          packname: '5x TNT',
                          price: '10.99 $',
                          atlas: 'game_window2_atlas',
                          reward: [0, 0, 0, 0, 0, 5],
                        },
                      },
                      {
                        2: {
                          type: '10_TNT_Pack.png',
                          sprite: '10_TNT_Pack.png',
                          col: '10x',
                          id: 'tnt_ingame3',
                          packname: '10x TNT',
                          price: '19.99 $',
                          atlas: 'game_window2_atlas',
                          reward: [0, 0, 0, 0, 0, 10],
                        },
                      },
                      { 3: { type: 0, sprite: 0, col: 0, id: 0, packname: 0, price: 0, atlas: 'game_atlas' } },
                    ],
                  );
                } else if (shop == 0) {
                  get_message(2);
                }
              });
            animation = 1;
            game.add
              .tween(itm)
              .to({ x: '+5' }, 50, Phaser.Easing.Quadratic.In, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ x: '-10' }, 100, Phaser.Easing.Quadratic.In, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ x: '+10' }, 100, Phaser.Easing.Quadratic.In, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ x: '-5' }, 50, Phaser.Easing.Quadratic.In, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
            game.add
              .tween(tnt_booster_text.scale)
              .to({ x: '+0.2', y: '+0.2' }, 100, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(tnt_booster_text.scale)
                  .to({ x: '-0.2', y: '-0.2' }, 100, Phaser.Easing.Linear.None, true);
              });
          }
        }
      }
      function get_random_change(mass) {
        var array = mass;
        var len_arr = array.length;
        var rand_num = [Math.floor(Math.random() * len_arr)];
        var rand_el = array[rand_num];
        return rand_el;
      }
      var new_depth = 100;
      function hazard_lowering_rising_controll() {
        for (var i = 0; i < hzcol; i++) {
          setcard = hazard_cards[i];
          if (setcard.vis == 1) {
            if (setcard.hazard_type == 4) {
              if (setcard.value > 1) {
                setcard.value -= 1;
                setcard.draw -= 1;
              } else {
                setcard.value = 13;
                setcard.draw = 13;
              }
              setcard.loadTexture('game_atlas', 'card' + setcard.draw + '.png', 0);
            } else if (setcard.hazard_type == 5) {
              if (setcard.value < 13) {
                setcard.value += 1;
                setcard.draw += 1;
              } else {
                setcard.value = 1;
                setcard.draw = 1;
              }
              setcard.loadTexture('game_atlas', 'card' + setcard.draw + '.png', 0);
            }
          }
        }
      }
      function hazard_bomb_controll() {
        for (var i = 0; i < hzcol; i++) {
          setcard = hazard_cards[i];
          cards_group.children.forEach(function (element) {
            if (
              setcard.x + setcard.width / 2 >= element.x - element.width / 2 &&
              setcard.x - setcard.width / 2 <= element.x + element.width / 2 &&
              setcard.y + setcard.height / 2 >= element.y - element.height / 2 &&
              setcard.y - setcard.height / 2 <= element.y + element.height / 2 &&
              setcard.depth < element.depth
            ) {
              setcard = 0;
            }
          });
          if (setcard != 0) {
            if (hazard_cards[i].vis == 1 && hazard_cards[i].hazard_type == 1) {
              if (hazard_cards[i].hazard_timer > 1) {
                if (sound_on == 1) {
                  play_sound('Hazardbombcountdown');
                }
                hazard_cards[i].hazard_timer -= 1;
                hazard_cards[i].children[1].setText(hazard_cards[i].hazard_timer);
              } else {
                emitter.bringToTop = true;
                emitter.minParticleSpeed.set(-500, -500);
                emitter.maxParticleSpeed.set(500, 500);
                emitter.x = hazard_cards[i].x;
                emitter.y = hazard_cards[i].y;
                emitter.start(true, 600, 0, 50);
                clearTimeout(TimerCheck);
                card_check();
                if (sound_on == 1) {
                  play_sound('WildCard_Explosion_Use');
                }
                start_card_mas = [];
                var hx = hazard_cards[i].x;
                var hy = hazard_cards[i].y;
                hazard_cards[i].destroy();
                hazard_cards[i].hazard_type = -1;
                var new_cards = game.rnd.integerInRange(3, 5);
                new_depth += 10;
                var new_y = 10;
                while (new_cards > 0) {
                  var scard = 0;
                  if (cards_group.length > 0) {
                    scard = cards_group.getRandom();
                    var card_new = game.add.sprite(scard.x, scard.y + new_y, 'game5_atlas', backcards_select);
                  } else {
                    var card_new = game.add.sprite(hx, hy + new_y, 'game5_atlas', backcards_select);
                  }
                  card_new.depth = new_depth;
                  card_new.vis = 1;
                  if (scard != 0) {
                    card_new.angle = scard.angle;
                  }
                  card_new.inputEnabled = true;
                  card_new.events.onInputDown.add(card_select, this);
                  card_new.anchor.setTo(0.5, 0.5);
                  card_new.hazard_type = 0;
                  card_new.hazard_timer = 0;
                  card_new.realwidth = card_new.width;
                  card_new.n = 0;
                  card_new.scale.setTo(0);
                  cards_group.add(card_new);
                  game.add
                    .tween(card_new.scale)
                    .to({ x: card_size, y: card_size }, 300, Phaser.Easing.Linear.None, true);
                  generation_inspection = 0;
                  var new_generation_card = game.rnd.integerInRange(1, 13);
                  draw_card = get_random_change([
                    new_generation_card,
                    new_generation_card + 13,
                    new_generation_card + 13 * 2,
                    new_generation_card + 13 * 3,
                  ]);
                  card_new.value = new_generation_card;
                  card_new.draw = draw_card;
                  card_new.loadTexture('game_atlas', 'card' + card_new.draw + '.png', 0);
                  cards_discarded.push(draw_card);
                  new_depth += 1;
                  new_y += 10;
                  new_cards -= 1;
                }
              }
            }
          }
        }
        visible_cards(0);
      }
      var fc = 0;
      var FTUE_Arrow = 0;
      var tornado_use = 0;
      var setcard = 0;
      var joker_first = 1;
      var card_anim = 0;
      var del_cards = 0;
      function card_select(item) {
        if ((level == 1 && item.value == 3) || (level == 5 && item.value == 101) || (level == 7 && item.value == 102)) {
          if (w != 0) {
            animation = 0;
            popup = 0;
            if (FTUE_Arrow != 0 && level != 1) {
              FTUE_Arrow.destroy();
              FTUE_Arrow = 0;
            }
            if (w.obj != 0) {
              w.obj.destroy();
            }
            game.add
              .tween(w)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            w = 0;
          }
        }

        if (animation == 0 && popup == 0) {
          setcard = item;
          cards_group.children.forEach(function (element) {
            var points1 = getPoints1(setcard);
            var points2 = getPoints2(element);
            if (polygonPolygon(points1, points2) && setcard.depth < element.depth) {
              setcard = 0;
            }
          });

          if (setcard != 0) {
            if (
              setcard.frameName != backcards_select &&
              setcard.value != 101 &&
              setcard.value != 102 &&
              setcard.value != 103 &&
              setcard.value != 105 &&
              setcard.value != 104 &&
              setcard.hazard_type != 2 &&
              setcard.hazard_type != 9 &&
              (setcard.hazard_type != 10 ||
                (setcard.hazard_type == 10 && setcard.std != 3) ||
                (setcard.hazard_type == 10 && start_card == 1000)) &&
              setcard.hazard_type != 7 &&
              setcard.hazard_type != 8 &&
              setcard.value != 115
            ) {
              if (
                setcard.value == start_card + 1 ||
                setcard.value == start_card - 1 ||
                (start_card == 13 && setcard.value == 1) ||
                (start_card == 1 && setcard.value == 13) ||
                start_card == 1000
              ) {
                // app.ddna.missionTracker.onCardMatched();
                card_add_n = 0;
                if (level == 1 && combo == 0) {
                  if (fbv == 1) {
                    window.eventTrack('FTUE_2_3_FirstCardInFirstRowClicked');
                  }
                } else if (level == 1 && combo == 7) {
                  if (fbv == 1) {
                    window.eventTrack('FTUE_2_4_FirstCardInSecondRowClicked');
                  }
                } else if (level == 2 && combo == 0) {
                  if (fbv == 1) {
                    window.eventTrack('FTUE_4_2_FirstCardClicked');
                  }
                } else if (level == 3 && combo == 0) {
                  if (fbv == 1) {
                    window.eventTrack('FTUE_6_3_FirstCardClicked');
                  }
                } else if (level == 4 && combo == 0) {
                  if (fbv == 1) {
                    window.eventTrack('FTUE_8_2_FirstCardClicked');
                  }
                } else if (level == 5 && combo == 0) {
                  if (fbv == 1) {
                    window.eventTrack('FTUE_10_2_FirstCardClicked');
                  }
                }
                if (combo == 0) {
                  combo = 1;
                }
                fogCheck();
                if (level == 1) {
                  var is_FTUE_Arrow = 0;
                  if (FTUE_Arrow_n < 13) {
                    FTUE_Arrow_n += 1;
                  } else {
                    if (FTUE_Arrow_n == 13) {
                      FTUE_Arrow_n = 1;
                    } else {
                      FTUE_Arrow_n = 2;
                    }
                  }
                  cards_group.children.forEach(function (element1) {
                    if (element1.value == FTUE_Arrow_n) {
                      game.add
                        .tween(FTUE_Arrow)
                        .to({ x: element1.x, y: element1.y }, 200, Phaser.Easing.Linear.None, true);
                      game.add.tween(FTUE_Arrow).to({ angle: element1.angle }, 200, Phaser.Easing.Linear.None, true);
                      is_FTUE_Arrow = 1;
                    }
                  });
                  if (is_FTUE_Arrow == 0) {
                    game.add.tween(FTUE_Arrow).to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true);
                  } else is_FTUE_Arrow = 0;
                } else {
                  if (FTUE_Arrow != 0) {
                    FTUE_Arrow.destroy();
                    FTUE_Arrow = 0;
                  }
                }
                if (level >= 6)
                  for (var i = 0; i < missions.length; i += 4) {
                    if (missions[i] == -1) {
                      if (setcard.draw >= 14 && setcard.draw <= 26) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                    if (missions[i] == -6) {
                      if (setcard.draw >= 1 && setcard.draw <= 13) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                    if (missions[i] == -7) {
                      if (setcard.draw >= 27 && setcard.draw <= 39) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                    if (missions[i] == -8) {
                      if (setcard.draw >= 40 && setcard.draw <= 52) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                    if (missions[i] == -9) {
                      if (setcard.draw >= 1 && setcard.draw <= 52) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                    if (missions[i] == -12) {
                      if (setcard.draw == 11 || setcard.draw == 24 || setcard.draw == 37 || setcard.draw == 50) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                    if (missions[i] == -13) {
                      if (setcard.draw == 12 || setcard.draw == 25 || setcard.draw == 38 || setcard.draw == 51) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                    if (missions[i] == -14) {
                      if (setcard.draw == 13 || setcard.draw == 26 || setcard.draw == 39 || setcard.draw == 52) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                    if (missions[i] == -15) {
                      if (setcard.draw == 1 || setcard.draw == 14 || setcard.draw == 27 || setcard.draw == 40) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                  }
                clearTimeout(TimerCheck);
                TimerCheck = setTimeout(function () {
                  card_check();
                }, 6000);
                var setcard2 = game.add.sprite(setcard.x, setcard.y, 'game_atlas', setcard.frameName);
                setcard2.angle = setcard.angle;
                setcard2.scale.setTo(card_size);
                setcard2.anchor.setTo(0.5, 0.5);
                setcard2.oldx = setcard.x;
                setcard2.oldy = setcard.y;
                setcard2.oldvalue = setcard.value;
                setcard2.oldstart = start_card;
                setcard2.oldangle = setcard.angle;
                setcard2.olddepth = setcard.depth;
                setcard2.olddraw = setcard.draw;
                setcard2.indeck = 0;
                start_card_mas.push(setcard2);
                start_card_mas2.push(setcard2);
                if (baloon == 1) bottom_game_group.add(setcard2);
                start_card = setcard.value;
                if (setcard.hazard_type == 6 || setcard.ht == 6) {
                  hazard_cards[setcard.n].hazard_type = -1;
                  setcard.hazard_type = 0;
                  water_n -= 1;
                  if (water_n == 0) {
                    for (var i = 0; i < hzcol; i++) {
                      if (hazard_cards[i].hazard_type == 7) {
                        game.add.tween(hazard_cards[i]).to({ y: '-200' }, 600, Phaser.Easing.Linear.None, true);
                        game.add.tween(hazard_cards[i]).to({ angle: '+360' }, 600, Phaser.Easing.Linear.None, true);
                        game.add
                          .tween(hazard_cards[i])
                          .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 200)
                          .onComplete.add(function (itemn) {
                            itemn.destroy();
                            visible_cards(0);
                          });
                        hazard_cards[hazard_cards[i].n].hazard_type = -1;
                        if (sound_on == 1) {
                          play_sound('anchor');
                        }
                      }
                    }
                  }
                }
                if (setcard.hazard_type == 4 || setcard.hazard_type == 5) {
                  hazard_cards[setcard.n].hazard_type = -1;
                  setcard.hazard_type = 0;
                }
                if (setcard.hazard_type == 1) {
                  hazard_cards[setcard.n].hazard_type = -1;
                  setcard.hazard_type = 0;
                  start_card_mas = [];
                }
                if (setcard.vis == 0) {
                  setcard.vis = 1;
                  setcard2.loadTexture('game_atlas', 'card' + setcard.draw + '.png', 0);
                }
                var sht = setcard.hazard_type;
                setcard.destroy();
                if (sht != 1) {
                  combo += 1;
                }
                if (level == 2 && joker_first == 1) {
                  animation = 1;
                  w = ftue_window(
                    'Main_Presenting.png',
                    game.cache.getJSON('lang')['t347'][0][window.lang],
                    game.camera.width / 2,
                    game.camera.height / 2,
                  );
                  game.world.bringToTop(booster5);
                  popup = 1;
                  joker_first = -1;
                  if (sound_on == 1) {
                    play_sound('hint_with_arrow');
                  }

                  FTUE_Arrow = game.add.graphics(booster5.x, booster5.y);
                  FTUE_Arrow.lineStyle(8, 0xffff00);
                  FTUE_Arrow.drawCircle(0, 0, 190);
                  FTUE_Arrow.alpha = 0;
                  game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(FTUE_Arrow.scale)
                    .to({ x: 1.1, y: 1.1 }, 400, Phaser.Easing.Linear.None, true, 0, -1)
                    .yoyo(true, 100);

                  /* FTUE_Arrow = game.add.sprite(booster5.x, booster5.y - 20, 'game_atlas', 'FTUE_Arrow.png');
                   FTUE_Arrow.anchor.setTo(0.5, 1.6);
                   FTUE_Arrow.alpha = 0;
                   game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                   game.add
                     .tween(FTUE_Arrow.anchor)
                     .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                     .yoyo(true, 200);*/
                }
                if (combo == 4) {
                  message(game.cache.getJSON('lang')['Nice'][0][window.lang], 0, 0, 1);
                }
                if (combo == 9) {
                  message(game.cache.getJSON('lang')['Amazing'][0][window.lang], 0, 0, 1);
                }
                var combo_s = combo;
                if (combo > 10) {
                  combo_s = 10;
                }
                if (sound_on == 1) {
                  play_sound('rising_tones' + combo_s);
                }
                hazard_bomb_controll();
                hazard_lowering_rising_controll();
                if ((setcard2.olddraw >= 14 && setcard2.olddraw <= 26) || (setcard2.olddraw >= 40 && setcard2.olddraw <= 52)) {
                  streak_progress(2, 1);
                } else if ((setcard2.olddraw >= 1 && setcard2.olddraw <= 13) || (setcard2.olddraw >= 27 && setcard2.olddraw <= 39)) {
                  streak_progress(1, 1);
                }
                if (cards_group.length > 0)
                  if (level > 1 && level <= 7) {
                    if (popup == 0 && animation == 0) {
                      var check = 1;
                      cards_group.children.forEach(function (element1) {
                        if (check != 2) {
                          check = 1;
                          cards_group.children.forEach(function (element2) {
                            if (element1.vis != 0) {
                              var points1 = getPoints1(element1);
                              var points2 = getPoints2(element2);
                              if (polygonPolygon(points1, points2) == true && element1.depth < element2.depth) {
                                check = 0;
                              }
                            } else {
                              check = 0;
                            }
                          });
                          if (check == 1) {
                            if (
                              element1.value != 104 &&
                              element1.hazard_type != 2 &&
                              element1.hazard_type != 7 &&
                              element1.hazard_type != 9 &&
                              (element1.hazard_type != 10 || (element1.hazard_type == 10 && element1.std != 3))
                            ) {
                              if (
                                element1.value == start_card + 1 ||
                                element1.value == start_card - 1 ||
                                (start_card == 13 && element1.value == 1) ||
                                (start_card == 1 && element1.value == 13) ||
                                start_card == 1000 ||
                                element1.value == 101 ||
                                element1.value == 102
                              ) {
                                check = 2;
                              }
                            }
                          }
                        }
                      });
                      if (check != 2) {
                        if (level == 2) {
                          if (fbv == 1) {
                            window.eventTrack('FTUE_4_3_RefreshCardTutorialConfirmed');
                          }
                          animation = 1;
                          w = ftue_window(
                            'Main_Presenting.png',
                            game.cache.getJSON('lang')['Tutorial2'][0][window.lang],
                            game.camera.width / 2,
                            game.camera.height / 2,
                          );
                          game.world.bringToTop(card_deck);
                          game.world.bringToTop(card_text);
                        } else if (level == 6 && joker_first == 1) {
                          animation = 1;
                          w = ftue_window(
                            'Main_Presenting.png',
                            game.cache.getJSON('lang')['t327'][0][window.lang],
                            game.camera.width / 2,
                            game.camera.height / 2,
                          );
                          game.world.bringToTop(booster3);
                        }
                        if (level == 6 && joker_first == 1) {
                          popup = 1;
                          joker_first = -1;
                          if (sound_on == 1) {
                            play_sound('hint_with_arrow');
                          }
                          FTUE_Arrow = game.add.sprite(booster3.x, booster3.y - 20, 'game_atlas', 'FTUE_Arrow.png');
                          FTUE_Arrow.anchor.setTo(0.5, 1.6);
                          FTUE_Arrow.alpha = 0;
                          game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                          game.add
                            .tween(FTUE_Arrow.anchor)
                            .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                            .yoyo(true, 200);
                          card_deck.scale.setTo(card_size);
                          card_deck.input.useHandCursor = true;
                          scale_tween(card_deck, 200, 0.1, 0.1, 3);
                        } else if (level == 2) {
                          if (sound_on == 1) {
                            play_sound('hint_with_arrow');
                          }
                          FTUE_Arrow = game.add.sprite(card_deck.x, card_deck.y - 20, 'game_atlas', 'FTUE_Arrow.png');
                          FTUE_Arrow.anchor.setTo(0.5, 1.6);
                          FTUE_Arrow.alpha = 0;
                          game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                          game.add
                            .tween(FTUE_Arrow.anchor)
                            .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                            .yoyo(true, 200);
                          card_deck.scale.setTo(card_size);
                          card_deck.input.useHandCursor = true;
                          scale_tween(card_deck, 200, 0.1, 0.1, 3);
                        }
                        check = 2;
                      }
                    }
                  }
                card_anim = 1;
                game.add
                  .tween(setcard2)
                  .to({ angle: '+720' }, 750, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    game.add.tween(item).to({ angle: 0 }, 50, Phaser.Easing.Linear.None, true);
                  }, this);
                game.add
                  .tween(setcard2)
                  .to({ x: setcard2.x + (card.x - setcard2.x) / 2, y: '-200' }, 300, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ x: card.x, y: card.y }, 500, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        card_anim = 0;
                        animation = 0;
                        game_win();
                        game_loss();
                        visible_cards(0);
                      }, this);
                  }, this);
              } else {
                // app.ddna.missionTracker.onCardMatched();
                animation = 1;
                game.add
                  .tween(item)
                  .to({ angle: '+10' }, 40, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ angle: '-10' }, 40, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ angle: '+10' }, 40, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            game.add
                              .tween(item)
                              .to({ angle: '-10' }, 40, Phaser.Easing.Linear.None, true)
                              .onComplete.add(function (item) {
                                animation = 0;
                                if (level > 1 && level <= 7 && FTUE_Arrow == 0) {
                                  let obj = card_check(2);
                                  if (sound_on == 1) {
                                    play_sound('hint_with_arrow');
                                  }
                                  FTUE_Arrow = game.add.sprite(0, 0, 'game_atlas', 'FTUE_Arrow.png');
                                  FTUE_Arrow.anchor.setTo(0.5, 1.6);
                                  FTUE_Arrow.alpha = 0;
                                  FTUE_Arrow.x = obj.x;
                                  FTUE_Arrow.y = obj.y;
                                  FTUE_Arrow.angle = obj.angle;
                                  game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(FTUE_Arrow.anchor)
                                    .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                                    .yoyo(true, 200);
                                }
                              });
                          });
                      });
                  });
              }
            } else {
              if (setcard.hazard_type == 10) {
                animation = 1;
                game.add
                  .tween(item)
                  .to({ angle: '+10' }, 40, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ angle: '-10' }, 40, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ angle: '+10' }, 40, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            game.add
                              .tween(item)
                              .to({ angle: '-10' }, 40, Phaser.Easing.Linear.None, true)
                              .onComplete.add(function (item) {
                                animation = 0;
                              });
                          });
                      });
                  });
              } else if (setcard.hazard_type == 8) {
                hazard_cards[setcard.n].hazard_type = -1;
                hazard_cards[setcard.n].children[1].destroy();
                game.add
                  .tween(setcard)
                  .to({ alpha: 0 }, 600, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                    visible_cards(0);
                  });
                for (var i = 0; i < hzcol; i++) {
                  if (hazard_cards[i].hazard_type == 9 && hazard_cards[i].children[0]) {
                    if (hazard_cards[i].hp > 1) {
                      var algae = game.add.sprite(hazard_cards[i].x, hazard_cards[i].y, 'game_atlas', "algae_" + Number(hazard_cards[i].hp) + ".png");
                      algae.scale.setTo(card_size * 0.8);
                      algae.anchor.setTo(0.5);
                      algae.angle = hazard_cards[i].angle;
                      game.add.tween(algae).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 500);
                      hazard_cards[i].hp -= 1;
                      var algae = game.add.sprite(0, 0, 'game_atlas', "algae_" + Number(hazard_cards[i].hp) + ".png");
                      algae.scale.setTo(0.8);
                      algae.anchor.setTo(0.5);
                      algae.alpha = 0;
                      hazard_cards[i].addChild(algae);
                      game.add.tween(algae).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 500);
                      hazard_cards[i].children[0].destroy();
                    } else {
                      game.add.tween(hazard_cards[i].children[0]).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 500).onComplete.add(function (item) {
                        item.destroy();
                      });
                      hazard_cards[i].hazard_type = -1;
                    }
                    var cards_fish = game.add.sprite(setcard.x, setcard.y + 60, 'game_atlas', 'crab.png');
                    cards_fish.anchor.setTo(0.5, 1);
                    cards_fish.scale.setTo(0.7);
                    cards_fish.angle = setcard.angle;
                    var crab_right_hand = game.add.sprite(-32, -38, 'game_atlas', 'crab_right_hand.png');
                    cards_fish.addChild(crab_right_hand);
                    crab_right_hand.anchor.setTo(1, 1);
                    crab_right_hand.angle = 0;
                    var crab_left_hand = game.add.sprite(32, -38, 'game_atlas', 'crab_left_hand.png');
                    cards_fish.addChild(crab_left_hand);
                    crab_left_hand.anchor.setTo(0, 1);
                    crab_left_hand.angle = -0;
                    var cards_fish2 = game.add.sprite(0, 0, 'game_atlas', 'crab.png');
                    cards_fish.addChild(cards_fish2);
                    cards_fish2.anchor.setTo(0.5, 1);
                    var x11 = setcard.x + Math.abs(hazard_cards[i].x - setcard.x) / 2;
                    var y11 = setcard.y - 300;
                    var x22 = hazard_cards[i].x;
                    var y22 = hazard_cards[i].y + 60;
                    var tween = game.add.tween(cards_fish).to(
                      {
                        x: [x11, x22],
                        y: [y11, y22],
                      },
                      500,
                    );
                    tween.interpolation(function (v, k) {
                      return Phaser.Math.bezierInterpolation(v, k);
                    });
                    tween.start();
                    tween.onComplete.add(function (item) {
                      crab_animation2(item);
                      game.add.tween(item).to({ y: '-40' }, 500, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(item)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 400)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                    });
                    game.add
                      .tween(cards_fish)
                      .to({ angle: hazard_cards[i].angle }, 500, Phaser.Easing.Linear.None, true);
                  }
                }
              } else if (setcard.hazard_type == 2) {
                if (
                  setcard.value == start_card + 1 ||
                  setcard.value == start_card - 1 ||
                  (start_card == 13 && setcard.value == 1) ||
                  (start_card == 1 && setcard.value == 13) ||
                  start_card == 1000
                ) {
                  if (start_card_mas2.length > 1) {
                    for (var m = start_card_mas2.length - 1; m > 0; m--) {
                      if (start_card_mas2[m]) {
                        game.add
                          .tween(start_card_mas2[start_card_mas2.length - 1])
                          .to({ angle: 360 }, 600, Phaser.Easing.Linear.None, true);
                        game.add
                          .tween(start_card_mas2[start_card_mas2.length - 1])
                          .to({ y: '+400' }, 600, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            item.destroy();
                          });
                        start_card = start_card_mas2[m].oldstart;
                        start_card_mas2.splice(m, 1);
                        game_loss();
                        card = start_card_mas2[m - 1];
                        break;
                      }
                    }
                  } else {
                    card_add();
                  }
                  game.add.tween(setcard.scale).to({ x: 0.8, y: 0.8 }, 200, Phaser.Easing.Cubic.In, true);
                  game.add
                    .tween(setcard)
                    .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      game.add.tween(item.scale).to({ x: card_size, y: card_size }, 200, Phaser.Easing.Cubic.Out, true);
                    });
                  if (typeof setcard.children[0] !== 'undefined') {
                    setcard.children[0].destroy();
                  }
                  setcard.hazard_type = 0;
                  hazard_cards[setcard.n].hazard_type = -1;
                  if (sound_on == 1) {
                    play_sound('ice_break');
                  }
                  var frozen_animation = game.add.sprite(0, 0, 'game_atlas', 'Ice_card_break1.png');
                  frozen_animation.anchor.setTo(0.5);
                  frozen_animation.animations.add(
                    'Ice',
                    [
                      'Ice_card_break1.png',
                      'Ice_card_break2.png',
                      'Ice_card_break3.png',
                      'Ice_card_break4.png',
                      'Ice_card_break5.png',
                    ],
                    10,
                    false,
                  );
                  frozen_animation.animations.play('Ice');
                  setcard.addChild(frozen_animation);
                  frozen_animation.animations.currentAnim.onComplete.add(function () {
                    if (typeof setcard.children[0] !== 'undefined') {
                      setcard.children[0].destroy();
                    }
                  }, this);
                  start_card_mas = [];
                }
              } else if (setcard.value == 101) {
                wild_card(setcard, 1);
                hazard_bomb_controll();
              } else if (setcard.value == 102) {
                wild_card(setcard, 2);
                hazard_bomb_controll();
              } else if (setcard.value == 105) {
                wild_card(setcard, 3);
              } else if (setcard.value == 104) {
                if (sound_on == 1) {
                  play_sound('Hazard_Key_Use');
                }
                for (var i = 0; i < hzcol; i++) {
                  if (hazard_cards[i].value == 103) {
                    var key = game.add.sprite(setcard.x, setcard.y, 'game_atlas', setcard.frameName);
                    key.angle = setcard.angle;
                    key.scale.setTo(1);
                    key.anchor.setTo(0.5, 0.5);
                    game.add.tween(key).to({ angle: 360 }, 400, Phaser.Easing.Linear.None, true);
                    game.add
                      .tween(key)
                      .to({ x: hazard_cards[i].x, y: hazard_cards[i].y }, 400, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(hazard_cards[i])
                      .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 400)
                      .onComplete.add(function (item) {
                        item.destroy();
                        visible_cards(0);
                        if (sound_on == 1) {
                          play_sound('hazard_lock_open');
                        }
                        game_win();
                        game_loss();
                      });
                  }
                }
                visible_cards(0);
                setcard.destroy();
                start_card_mas = [];
              } else if (setcard.value == 115 && tornado_use == 0) {
                tornado_use = 1;
                popup = 1;
                if (typeof setcard.children[0] !== 'undefined') {
                  setcard.children[0].destroy();
                }
                item.destroy();
                var tornado_n = 0;
                cards_group.children.forEach(function (element1) {
                  if (element1.vis == 1)
                    if (
                      element1.value != 101 &&
                      element1.value != 102 &&
                      element1.value != 103 &&
                      element1.value != 105 &&
                      element1.value != 104 &&
                      element1.hazard_type != 9 &&
                      (element1.hazard_type != 10 || (element1.hazard_type == 10 && element1.std != 3)) &&
                      element1.hazard_type != 7 &&
                      element1.hazard_type != 8 &&
                      element1.hazard_type != 3 &&
                      element1.value != 115 &&
                      element1.hazard_type != 1
                    ) {
                      var yes = 0;
                      cards_group.children.forEach(function (element2) {
                        var points1 = getPoints1(element1);
                        var points2 = getPoints2(element2);
                        if (polygonPolygon(points1, points2) == true && element1.depth < element2.depth) {
                          yes = 1;
                        }
                      });
                      if (yes == 0) {
                        tornado_n += 1;
                        var cards_tornado = game.add.sprite(setcard.x, setcard.y, 'game5_atlas');
                        cards_tornado.anchor.setTo(0.5);
                        cards_tornado.animations.add(
                          'Tornado',
                          [
                            'TornadoCardVFX1.png',
                            'TornadoCardVFX2.png',
                            'TornadoCardVFX3.png',
                            'TornadoCardVFX4.png',
                            'TornadoCardVFX5.png',
                            'TornadoCardVFX6.png',
                            'TornadoCardVFX7.png',
                            'TornadoCardVFX8.png',
                          ],
                          20,
                          true,
                        );
                        cards_tornado.animations.play('Tornado');
                        game.add
                          .tween(cards_tornado)
                          .to({ x: element1.x, y: element1.y }, 600, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            game.add
                              .tween(item)
                              .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 200)
                              .onComplete.add(function (item) {
                                item.destroy();
                              });
                          });
                        game.add
                          .tween(cards_tornado.scale)
                          .to({ x: 1.5, y: 1.5 }, 600, Phaser.Easing.Linear.None, true);
                      }
                      game.add
                        .tween(element1)
                        .to({ x: element1.x, y: element1.y }, 600, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(item.scale)
                            .to({ x: 0, y: card_size + 0.02 }, 50, Phaser.Easing.Linear.None, true);
                          game.add
                            .tween(item)
                            .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function (item) {
                              item.loadTexture('game5_atlas', backcards_select, false);
                              game.add
                                .tween(item.scale)
                                .to({ x: card_size, y: card_size }, 50, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(item)
                                .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function (item) {
                                  game.add
                                    .tween(item.scale)
                                    .to({ x: 0, y: card_size + 0.02 }, 50, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(item)
                                    .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                                    .onComplete.add(function (item) {
                                      item.loadTexture('game_atlas', 'card' + item.draw + '.png', false);
                                      game.add
                                        .tween(item.scale)
                                        .to({ x: card_size, y: card_size }, 50, Phaser.Easing.Linear.None, true);
                                      game.add
                                        .tween(item)
                                        .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                                        .onComplete.add(function (item) {
                                          game.add
                                            .tween(item.scale)
                                            .to({ x: 0, y: card_size + 0.02 }, 50, Phaser.Easing.Linear.None, true);
                                          game.add
                                            .tween(item)
                                            .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                                            .onComplete.add(function (item) {
                                              item.loadTexture('game5_atlas', backcards_select, false);
                                              game.add
                                                .tween(item.scale)
                                                .to(
                                                  { x: card_size, y: card_size },
                                                  50,
                                                  Phaser.Easing.Linear.None,
                                                  true,
                                                );
                                              game.add
                                                .tween(item)
                                                .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                                                .onComplete.add(function (item) {
                                                  game.add
                                                    .tween(item.scale)
                                                    .to(
                                                      { x: 0, y: card_size + 0.02 },
                                                      50,
                                                      Phaser.Easing.Linear.None,
                                                      true,
                                                    );
                                                  game.add
                                                    .tween(item)
                                                    .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                                                    .onComplete.add(function (item) {
                                                      item.loadTexture(
                                                        'game_atlas',
                                                        'card' + item.draw + '.png',
                                                        false,
                                                      );
                                                      game.add
                                                        .tween(item.scale)
                                                        .to(
                                                          { x: card_size, y: card_size },
                                                          50,
                                                          Phaser.Easing.Linear.None,
                                                          true,
                                                        );
                                                      game.add
                                                        .tween(item)
                                                        .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                                                        .onComplete.add(function (item) {
                                                          game.add
                                                            .tween(item.scale)
                                                            .to(
                                                              { x: 0, y: card_size + 0.02 },
                                                              50,
                                                              Phaser.Easing.Linear.None,
                                                              true,
                                                            );
                                                          game.add
                                                            .tween(item)
                                                            .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                                                            .onComplete.add(function (item) {
                                                              item.loadTexture('game5_atlas', backcards_select, false);
                                                              game.add
                                                                .tween(item.scale)
                                                                .to(
                                                                  { x: card_size, y: card_size },
                                                                  50,
                                                                  Phaser.Easing.Linear.None,
                                                                  true,
                                                                );
                                                              game.add
                                                                .tween(item)
                                                                .to({ alpha: 1 }, 50, Phaser.Easing.Linear.None, true)
                                                                .onComplete.add(function (item) {
                                                                  tornado_use = 0;
                                                                  animation = 0;
                                                                  popup = 0;
                                                                  for (var i = 0; i < cards_group.length * 2; i++) {
                                                                    var setcard1 = cards_group.getRandom();
                                                                    var setcard2 = cards_group.getRandom();
                                                                    if (
                                                                      setcard1.value != 101 &&
                                                                      setcard1.value != 102 &&
                                                                      setcard1.value != 103 &&
                                                                      setcard1.value != 105 &&
                                                                      setcard1.value != 104 &&
                                                                      setcard1.hazard_type != 1 &&
                                                                      setcard1.hazard_type != 9 &&
                                                                      (setcard1.hazard_type != 10 ||
                                                                        (setcard1.hazard_type == 10 &&
                                                                          setcard1.std != 3)) &&
                                                                      setcard1.hazard_type != 7 &&
                                                                      setcard1.hazard_type != 8 &&
                                                                      setcard1.hazard_type != 3 &&
                                                                      setcard1.value != 115 &&
                                                                      setcard1.hazard_type != 1
                                                                    )
                                                                      if (
                                                                        setcard2.value != 101 &&
                                                                        setcard2.value != 102 &&
                                                                        setcard2.value != 103 &&
                                                                        setcard2.value != 105 &&
                                                                        setcard2.value != 104 &&
                                                                        setcard2.hazard_type != 1 &&
                                                                        setcard2.hazard_type != 9 &&
                                                                        (setcard2.hazard_type != 10 ||
                                                                          (setcard2.hazard_type == 10 &&
                                                                            setcard2.std != 3)) &&
                                                                        setcard2.hazard_type != 7 &&
                                                                        setcard2.hazard_type != 8 &&
                                                                        setcard2.hazard_type != 3 &&
                                                                        setcard2.value != 115 &&
                                                                        setcard2.hazard_type != 1
                                                                      ) {
                                                                        var v1 = setcard1.value;
                                                                        var d1 = setcard1.draw;
                                                                        setcard1.value = setcard2.value;
                                                                        setcard1.draw = setcard2.draw;
                                                                        setcard2.value = v1;
                                                                        setcard2.draw = d1;
                                                                      }
                                                                  }
                                                                  cards_group.children.forEach(function (element1) {
                                                                    if (
                                                                      element1.value != 101 &&
                                                                      element1.value != 102 &&
                                                                      element1.value != 103 &&
                                                                      element1.value != 105 &&
                                                                      element1.value != 104 &&
                                                                      element1.hazard_type != 1 &&
                                                                      element1.hazard_type != 9 &&
                                                                      (element1.hazard_type != 10 ||
                                                                        (element1.hazard_type == 10 &&
                                                                          element1.std != 3)) &&
                                                                      element1.hazard_type != 7 &&
                                                                      element1.hazard_type != 8 &&
                                                                      element1.hazard_type != 3 &&
                                                                      element1.value != 115
                                                                    ) {
                                                                      element1.vis = 0;
                                                                    }
                                                                  });
                                                                  visible_cards(5);
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    }
                });
                if (tornado_n == 0) {
                  tornado_use = 0;
                  animation = 0;
                  popup = 0;
                  game_win();
                  game_loss();
                  visible_cards(0);
                }
              }
            }
          } else {
            animation = 1;
            game.add
              .tween(item)
              .to({ angle: '+10' }, 40, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ angle: '-10' }, 40, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ angle: '+10' }, 40, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ angle: '-10' }, 40, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
          }
        }
      }

      function fogCheck() {
        cards_group.children.forEach(function (element1) {
          if (element1.hazard_type == 10 && element1.vis == 1) {
            if (element1.std > 0) {
              element1.std -= 1;
            } else if (element1.std == 0) {
              element1.std = 3;
            }
            if (element1.std == 3) {
              element1.children[0].loadTexture('fog_atlas', 'FogCard_Full0001.png', 0);
              element1.children[0].animations.add(
                'FOG1',
                [
                  'FogCard_Full0001.png',
                  'FogCard_Full0002.png',
                  'FogCard_Full0003.png',
                  'FogCard_Full0004.png',
                  'FogCard_Full0005.png',
                  'FogCard_Full0006.png',
                  'FogCard_Full0007.png',
                  'FogCard_Full0008.png',
                  'FogCard_Full0009.png',
                  'FogCard_Full0010.png',
                  'FogCard_Full0011.png',
                  'FogCard_Full0012.png',
                  'FogCard_Full0013.png',
                ],
                8,
                true,
              );
              element1.children[0].animations.play('FOG1');
            } else if (element1.std == 2) {
              element1.children[0].loadTexture('fog_atlas', 'FogCard_Mid0001.png', 0);
              element1.children[0].animations.add(
                'FOG2',
                [
                  'FogCard_Mid0001.png',
                  'FogCard_Mid0002.png',
                  'FogCard_Mid0003.png',
                  'FogCard_Mid0004.png',
                  'FogCard_Mid0005.png',
                  'FogCard_Mid0006.png',
                  'FogCard_Mid0007.png',
                  'FogCard_Mid0008.png',
                  'FogCard_Mid0009.png',
                  'FogCard_Mid0010.png',
                  'FogCard_Mid0011.png',
                  'FogCard_Mid0012.png',
                  'FogCard_Mid0013.png',
                ],
                8,
                true,
              );
              element1.children[0].animations.play('FOG2');
            } else if (element1.std == 1) {
              element1.children[0].loadTexture('fog_atlas', 'FogCard_Low0001.png', 0);
              element1.children[0].animations.add(
                'FOG3',
                [
                  'FogCard_Low0001.png',
                  'FogCard_Low0002.png',
                  'FogCard_Low0003.png',
                  'FogCard_Low0004.png',
                  'FogCard_Low0005.png',
                  'FogCard_Low0006.png',
                  'FogCard_Low0007.png',
                  'FogCard_Low0008.png',
                  'FogCard_Low0009.png',
                  'FogCard_Low0010.png',
                  'FogCard_Low0011.png',
                  'FogCard_Low0012.png',
                  'FogCard_Low0013.png',
                ],
                8,
                true,
              );
              element1.children[0].animations.play('FOG3');
            } else if (element1.std == 0) {
              element1.children[0].loadTexture('fog_atlas', 'FogCard_Mid0001.png', 0);
              element1.children[0].animations.add(
                'FOG2',
                [
                  'FogCard_Mid0001.png',
                  'FogCard_Mid0002.png',
                  'FogCard_Mid0003.png',
                  'FogCard_Mid0004.png',
                  'FogCard_Mid0005.png',
                  'FogCard_Mid0006.png',
                  'FogCard_Mid0007.png',
                  'FogCard_Mid0008.png',
                  'FogCard_Mid0009.png',
                  'FogCard_Mid0010.png',
                  'FogCard_Mid0011.png',
                  'FogCard_Mid0012.png',
                  'FogCard_Mid0013.png',
                ],
                8,
                true,
              );
              element1.children[0].animations.play('FOG2');
            }
          }
        });
      }
      var gift = 0;
      var black_sprite_build = 0;
      var gift_shine = 0;
      var mis_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var old_keys = Number(keys);

      function game_mission(b) {
        if (level == 6) {
          if (fbv == 1) {
            window.eventTrack('FTUE_11_9_MissionLevel_displayed');
          }
          if (fbv == 1) {
            window.eventTrack('FTUE_2_8_RewardScreen_shown');
          }
          w = ftue_window(
            'Main_Excited.png',
            game.cache.getJSON('lang')['t379'][0][window.lang],
            game.camera.width / 2,
            game.camera.height / 2 - 350,
          );
          FTUE_Arrow = game.add.sprite(
            game.camera.width / 2 + 15,
            game.camera.height / 2 + 180,
            'game_atlas',
            'FTUE_Arrow.png',
          );
          FTUE_Arrow.alpha = 0;
          FTUE_Arrow.angle = 180;
          FTUE_Arrow.anchor.setTo(0.5, 1.6);
          FTUE_Arrow.fixedToCamera = true;
          game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
          effects_group.add(FTUE_Arrow);
          game.world.bringToTop(effects_group);
          black_sprite.destroy();
          game.add
            .tween(FTUE_Arrow)
            .to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true, 2000)
            .onComplete.add(function () {
              game.world.bringToTop(effects_group);
            });
        }
        if (b) {
          blackf();
        }
        missions_tab_back2 = game.add.sprite(0, 0, '');
        missions_tab_back = game.add.sprite(-game.world.width / 2 + 640, 0, '');
        game.world.bringToTop(missions_tab_back);
        misDate_timer();
        timerId6 = setInterval(function () {
          misDate_timer();
        }, 1000);
        mission_create(0);
        if (level == 6) {
          missions[4 * 4 + 2] = missions[4 * 4 + 1];
        }
        for (i = 0; i < 6; i++) {
          mission_element_create(i);
        }

        if (game.device.desktop)
          var tap_text = game.add.text(
            game.world.centerX + 330,
            game.world.height - 50 + 300,
            game.cache.getJSON('lang')['t460'][0][window.lang],
            { font: '56px RussoOne', fill: '#fff', align: 'center' },
          );
        else
          var tap_text = game.add.text(
            game.world.centerX + 330,
            game.world.height - 50 + 300,
            game.cache.getJSON('lang')['t250'][0][window.lang],
            { font: '56px RussoOne', fill: '#fff', align: 'center' },
          );
        tap_text.anchor.setTo(0.5);
        popup_group.add(tap_text);
        scale_tween(tap_text, 500, 0.1, 0.1, -1);
        game.add
          .tween(tap_text)
          .to({ y: '-300' }, 800, Phaser.Easing.Exponential.Out, true, 1000)
          .onComplete.add(function (item) {
            level_end_check = 0;
            popup = 1;
            animation = 0;
            if (fbv == 1 && level == 6) {
              window.eventTrack('FTUE_2_8_RewardScreen_animation_done');
            }
          });
        missions_tab_back.addChild(tap_text);
        if (level == 6) {
          game.world.bringToTop(w);
        }
      }
      missions_tab_back = 0;
      var firstfive = 0;
      var button_ad = 0;
      var wheel_ad_icon = 0;

      // game loss
      window.game_loss = function () {
        if (deck_n >= cards_deck_col - 1 && cards_group.length > 0) {
          clearTimeout(TimerCheck);
          var loss = 1;
          cards_group.children.forEach(function (element1) {
            let loss_c = 1;
            cards_group.children.forEach(function (element) {
              if (
                element1.x + element1.width / 2 >= element.x - element.width / 2 &&
                element1.x - element1.width / 2 <= element.x + element.width / 2 &&
                element1.y + element1.height / 2 >= element.y - element.height / 2 &&
                element1.y - element1.height / 2 <= element.y + element.height / 2 &&
                element1.depth < element.depth
              ) {
                loss_c = 0;
              }
            });
            if (loss_c == 1)
              if (
                element1.value == start_card + 1 ||
                element1.value == start_card - 1 ||
                (start_card == 13 && element1.value == 1) ||
                (start_card == 1 && element1.value == 13) ||
                element1.value == 101 ||
                element1.value == 102 ||
                element1.value == 105
              ) {
                loss = 0;
              }
          });

          if (UI_EndGame_btn == 0 && cards_deck_col - 1 - deck_n <= 0) {
            //loss == 1 &&
            UI_EndGame_btn = draw_rect(
              game.world.centerX - 760,
              game.world.height - 100,
              408 * 0.6,
              135 * 0.6,
              '#FFFFB2',
              '#EB942D',
              0,
              0,
              0,
              5,
              500,
              0,
              0,
            );
            draw_rect_shadow(0, 0, 374 * 0.6, 102 * 0.6, '#000', '#000', 0, 0, UI_EndGame_btn, 500);
            draw_rect(0, 0, 374 * 0.6, 102 * 0.6, '#900108', '#900108', 0, 0, UI_EndGame_btn, 0, 500, 0);
            draw_rect(0, 0, 370 * 0.6, 100 * 0.6, '#EE1C25', '#893631', 0, 1, UI_EndGame_btn, 0, 500, 0);
            button_animation_f(UI_EndGame_btn, 1);
            if (baloon == 1) bottom_game_group.add(UI_EndGame_btn);
            UI_EndGame_btn.events.onInputDown.add(function (item) {
              result = 0;
              btnup(item);
              if (baloon == 0 && magicbeanDate == 0) {
                game.setCurrentEvent();
                replayed = 1;
                window.eventTrack('level_lost', 1, {
                  nr: level,
                  pre_helper: pre_helper,
                  consumed_5cards_all: consumed_5cards_all,
                  consumed_5Cards: consumed_5Cards,
                  consumed_5Cards_x2: consumed_5Cards_x2,
                  consumed_5Cards_x3: consumed_5Cards_x3,
                  consumed_joker: consumed_joker,
                  consumed_TNT: consumed_TNT,
                  consumed_Shuffle: consumed_Shuffle,
                  consumed_backbutton: consumed_backbutton,
                  consumed_3Helpercards: consumed_3Helpercards,
                  moves_used: moves_used,
                  cards_left: cards_deck_col - 1 - deck_n,
                  p3_cards: p3_cards,
                  user_type: bought,
                  lifetime: lifetime_day,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });

                // app.ddna.missionTracker.trackMissionFail({
                //   stars: 0,
                //   levelScore: 0,
                // });
                if (magicbeanStage >= 6) {
                  magicbeanStage = 0;
                  unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() - unlimited_lifesDate_old);
                  LifeDate = 0;
                  game.setUserDataAndLog({
                    lifes: String(lifes),
                    life_time: String(LifeDate),
                    unlimited_lifesDate: String(unlimited_lifesDate),
                    magicbeanStage: magicbeanStage,
                  });
                }
                replayed += 1;

                if (fbv == 0) {
                  sdkHandler.trigger(
                    'levelFinish',
                    {
                      level: level,
                      score: all_stars,
                      state: 'lose',
                      callback: function (error) { },
                    },
                    this,
                  );
                }
                if (level >= 6 && baloon == 0) {
                  popup = 2;
                  game_mission(1);
                } else get_popup(2);
              } else if (baloon == 1) {
                baloon_giveup();
              } else if (magicbeanDate != 0) {
                magicbean_giveup();
              }
            }, this);
            var UI_EndGame_btn_text = game.add.text(0, 0, game.cache.getJSON('lang')['t298'][0][window.lang], {
              font: '42px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            UI_EndGame_btn_text.anchor.setTo(0.5);
            UI_EndGame_btn_text.setShadow(0, 3, 'rgba(0,0,0,0.5)', 2);
            UI_EndGame_btn.addChild(UI_EndGame_btn_text);
            UI_EndGame_btn.scale.setTo(0);
            game.add.tween(UI_EndGame_btn.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true);
          }

          if (booster4 == 0) {

            if (free_five < 0) {
              animation = 1;
              w = ftue_window(
                'Main_Presenting.png',
                game.cache.getJSON('lang')['t540'][0][window.lang],
                game.camera.width / 2,
                game.camera.height / 2,
              );

              if (sound_on == 1) {
                play_sound('hint_with_arrow');
              }
              FTUE_Arrow = game.add.sprite(game.world.centerX + 1 * card_size, game.world.height - 110 * card_size, 'game_atlas', 'FTUE_Arrow.png');
              FTUE_Arrow.anchor.setTo(0.5, 1.6);
              FTUE_Arrow.alpha = 0;
              game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                animation = 0;
              });
              game.add
                .tween(FTUE_Arrow.anchor)
                .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                .yoyo(true, 200);

              free_five *= -1;
              free_five += 3000;
              game.setUserDataAndLog({ free_five: free_five });
            }


            if (booster4_1 != -1 && free_five >= 0 && level >= 15) {
              booster4_1 = game.add.sprite(game.world.centerX + 1 * card_size - 220, game.world.height - 110 * card_size, '');
              booster4_1.anchor.setTo(0.5);
              booster4_1.scale.setTo(0);
              booster4_1.b = 14;
              button_animation_f(booster4_1, 1);
              booster4_1.events.onInputDown.add(function (itm) {
                btnup(itm);
                booster_active(itm);
              }, this);
              if (baloon == 1) bottom_game_group.add(booster4_1);

              /*var booster4_anim = game.add.sprite(-42+20, 85,'game5_atlas','backcard_1.png');
              booster4_anim.anchor.setTo(0,1);
              booster4_anim.scale.setTo(0.75);
              booster4_1.addChild(booster4_anim);
              booster4_anim.angle = -50;
              var booster4_black = game.add.sprite(0, 0,'game5_atlas','backcard_1.png');
              booster4_black.anchor.setTo(0,1);
              booster4_black.tint = '#000'
              booster4_black.alpha = 0.8;
              booster4_anim.addChild(booster4_black);
              game.add.tween(booster4_anim).to( { angle: '+40' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);
              game.add.tween(booster4_anim).to( { x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);
      
              var booster4_anim = game.add.sprite(-42+20, 85,'game5_atlas','backcard_1.png');
              booster4_anim.anchor.setTo(0,1);
              booster4_anim.scale.setTo(0.8);
              booster4_1.addChild(booster4_anim);
              booster4_anim.angle = -40;
              var booster4_black = game.add.sprite(0, 0,'game5_atlas','backcard_1.png');
              booster4_black.anchor.setTo(0,1);
              booster4_black.tint = '#000'
              booster4_black.alpha = 0.6;
              booster4_anim.addChild(booster4_black);
              game.add.tween(booster4_anim).to( { angle: '+30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);
              game.add.tween(booster4_anim).to( { x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);*/

              var booster4_anim = game.add.sprite(-42 + 20, 85, 'game5_atlas', 'backcard_1.png');
              booster4_anim.anchor.setTo(0, 1);
              booster4_anim.scale.setTo(0.85);
              booster4_1.addChild(booster4_anim);
              booster4_anim.angle = -30;
              var booster4_black = game.add.sprite(0, 0, 'game5_atlas', 'backcard_1.png');
              booster4_black.anchor.setTo(0, 1);
              booster4_black.tint = '#000'
              booster4_black.alpha = 0.4;
              booster4_anim.addChild(booster4_black);
              game.add.tween(booster4_anim).to({ angle: '+20' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);
              game.add.tween(booster4_anim).to({ x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);

              var booster4_anim = game.add.sprite(-42 + 20, 85, 'game5_atlas', 'backcard_1.png');
              booster4_anim.anchor.setTo(0, 1);
              booster4_anim.scale.setTo(0.9);
              booster4_1.addChild(booster4_anim);
              booster4_anim.angle = -20;
              var booster4_black = game.add.sprite(0, 0, 'game5_atlas', 'backcard_1.png');
              booster4_black.anchor.setTo(0, 1);
              booster4_black.tint = '#000'
              booster4_black.alpha = 0.2;
              booster4_anim.addChild(booster4_black);
              game.add.tween(booster4_anim).to({ angle: '+10' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);
              game.add.tween(booster4_anim).to({ x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);

              var booster4_top = game.add.sprite(20, 0, 'ingame_atlas', '+3.png');
              booster4_top.anchor.setTo(0.5);
              booster4_1.addChild(booster4_top);
              game.add.tween(booster4_top).to({ x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);

              var booster4_mask = game.add.graphics(0, 0);
              booster4_mask.beginFill(0xffffff);
              booster4_mask.drawRect(-186 / 2, -12 + 104 / 2, 186, 300);
              booster4_1.addChild(booster4_mask);
              var booster4_1_button_green = game.add.sprite(0, 0, 'game_atlas', 'button_green.png');
              booster4_1_button_green.anchor.setTo(0.5);
              booster4_1_button_green.scale.setTo(0.6);
              booster4_1_button_green.mask = booster4_mask;
              booster4_1.addChild(booster4_1_button_green);
              booster4_1_button_green.b = 14;

              var get_lifes = game.add.sprite(0, 0, 'game_atlas', 'ad_icon.png');
              get_lifes.anchor.setTo(0.5);
              booster4_1_button_green.addChild(get_lifes);

              game.add.tween(booster4_1.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Elastic.Out, true).onComplete.add(function (item) {

                game.add.tween(booster4_1_button_green).to({ y: 80 }, 200, Phaser.Easing.Linear.None, true);

              });
            }


            booster4 = game.add.sprite(game.world.centerX + 1 * card_size, game.world.height - 110 * card_size, '');
            booster4.anchor.setTo(0.5);
            booster4.scale.setTo(0);
            booster4.b = 4;
            button_animation_f(booster4, 1);
            booster4.events.onInputDown.add(function (itm) {
              btnup(itm);
              booster_active(itm);
            }, this);
            if (baloon == 1) bottom_game_group.add(booster4);

            var booster4_anim = game.add.sprite(-42 + 20, 85, 'game5_atlas', 'backcard_1.png');
            booster4_anim.anchor.setTo(0, 1);
            booster4_anim.scale.setTo(0.75);
            booster4.addChild(booster4_anim);
            booster4_anim.angle = -50;
            var booster4_black = game.add.sprite(0, 0, 'game5_atlas', 'backcard_1.png');
            booster4_black.anchor.setTo(0, 1);
            booster4_black.tint = '#000'
            booster4_black.alpha = 0.8;
            booster4_anim.addChild(booster4_black);
            game.add.tween(booster4_anim).to({ angle: '+40' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);
            game.add.tween(booster4_anim).to({ x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);

            var booster4_anim = game.add.sprite(-42 + 20, 85, 'game5_atlas', 'backcard_1.png');
            booster4_anim.anchor.setTo(0, 1);
            booster4_anim.scale.setTo(0.8);
            booster4.addChild(booster4_anim);
            booster4_anim.angle = -40;
            var booster4_black = game.add.sprite(0, 0, 'game5_atlas', 'backcard_1.png');
            booster4_black.anchor.setTo(0, 1);
            booster4_black.tint = '#000'
            booster4_black.alpha = 0.6;
            booster4_anim.addChild(booster4_black);
            game.add.tween(booster4_anim).to({ angle: '+30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);
            game.add.tween(booster4_anim).to({ x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);

            var booster4_anim = game.add.sprite(-42 + 20, 85, 'game5_atlas', 'backcard_1.png');
            booster4_anim.anchor.setTo(0, 1);
            booster4_anim.scale.setTo(0.85);
            booster4.addChild(booster4_anim);
            booster4_anim.angle = -30;
            var booster4_black = game.add.sprite(0, 0, 'game5_atlas', 'backcard_1.png');
            booster4_black.anchor.setTo(0, 1);
            booster4_black.tint = '#000'
            booster4_black.alpha = 0.4;
            booster4_anim.addChild(booster4_black);
            game.add.tween(booster4_anim).to({ angle: '+20' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);
            game.add.tween(booster4_anim).to({ x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);

            var booster4_anim = game.add.sprite(-42 + 20, 85, 'game5_atlas', 'backcard_1.png');
            booster4_anim.anchor.setTo(0, 1);
            booster4_anim.scale.setTo(0.9);
            booster4.addChild(booster4_anim);
            booster4_anim.angle = -20;
            var booster4_black = game.add.sprite(0, 0, 'game5_atlas', 'backcard_1.png');
            booster4_black.anchor.setTo(0, 1);
            booster4_black.tint = '#000'
            booster4_black.alpha = 0.2;
            booster4_anim.addChild(booster4_black);
            game.add.tween(booster4_anim).to({ angle: '+10' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);
            game.add.tween(booster4_anim).to({ x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);

            var booster4_top = game.add.sprite(20, 0, 'ingame_atlas', '+5.png');
            booster4_top.anchor.setTo(0.5);
            booster4.addChild(booster4_top);
            game.add.tween(booster4_top).to({ x: '-30' }, 1000, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 1000);

            var booster4_mask = game.add.graphics(0, 0);
            booster4_mask.beginFill(0xffffff);
            booster4_mask.drawRect(-186 / 2, -12 + 104 / 2, 186, 300);
            booster4.addChild(booster4_mask);
            var booster4_button_green = game.add.sprite(0, 0, 'game_atlas', 'button_green.png');
            booster4_button_green.anchor.setTo(0.5);
            booster4_button_green.scale.setTo(0.6);
            booster4_button_green.mask = booster4_mask;
            booster4.addChild(booster4_button_green);
            booster4_button_green.b = 4;

            if (free_five > 0) {
              var Red_Bubble = game.add.sprite(70, 50, 'game5_atlas', 'Red_Bubble.png');
              Red_Bubble.anchor.setTo(0.5);
              booster4.addChild(Red_Bubble);

              var free_five_text = game.add.text(1, 1, free_five > 3000 ? free_five - 3000 : free_five > 2000 ? free_five - 2000 : free_five > 1000 ? free_five - 1000 : Math.abs(free_five), { font: '24px RussoOne', fill: '#fff', align: 'center' });
              free_five_text.anchor.setTo(0.5);
              Red_Bubble.addChild(free_five_text);
            }

            if (booster4_1 == 0 || booster4_1 == -1) {
              var Bubble = game.add.sprite(-80, 80, 'ingame_atlas', 'Bubble.png');
              Bubble.anchor.setTo(1, 0.5);

              var free_five_text = game.add.text(-Bubble.width / 2 - 8, 0, game.device.desktop ? game.cache.getJSON('lang')['t597'][0][window.lang] : game.cache.getJSON('lang')['t598'][0][window.lang], { font: '24px RussoOne', fill: '#8A3C36', align: 'center' });
              free_five_text.anchor.setTo(0.5);
              Bubble.addChild(free_five_text);

              Bubble.scale.setTo(0);
              booster4.addChild(Bubble);
              game.add.tween(Bubble).to({ x: '-20' }, 600, Phaser.Easing.Linear.None, true, 500, -1).yoyo(true, 0);
              game.add.tween(Bubble.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true, 500);
            }

            if (free_five == 0)
              var booster4_price_text = game.add.text(30, 0, booster4_price, { font: '42px RussoOne', fill: '#fff', align: 'center' });
            else
              var booster4_price_text = game.add.text(0, 0, game.cache.getJSON('lang')['FREE'][0][window.lang], { font: '48px RussoOne', fill: '#fff', align: 'center' });
            booster4_price_text.anchor.setTo(0.5);
            booster4_price_text.setShadow(0, 2, 'rgba(0,0,0,0.4)', 5);
            booster4_button_green.addChild(booster4_price_text);
            game.add
              .tween(booster4.scale)
              .to({ x: 1, y: 1 }, 500, Phaser.Easing.Elastic.Out, true)
              .onComplete.add(function (item) {

                game.add.tween(booster4_button_green).to({ y: 80 }, 200, Phaser.Easing.Linear.None, true);

              });

            if (free_five <= 0) {
              var booster4_price_icon = game.add.sprite(-booster4_price_text.width / 2 - 10, 0, 'ingame_atlas', 'Coin.png');
              booster4_price_icon.anchor.setTo(0.5);
              booster4_price_icon.scale.setTo(0.5);
              booster4_button_green.addChild(booster4_price_icon);
              booster4_price_text += (booster4_price_text.width + booster4_price_icon.width) / 2;
              booster4_price_icon += (booster4_price_text.width + booster4_price_icon.width) / 2;
            }
          }

        }
      };
      function wild_card(item, type) {
        if (type != 3) {
          if (FTUE_Arrow != 0) {
            FTUE_Arrow.destroy();
            FTUE_Arrow = 0;
          }
          if (type == 1) {
            if (sound_on == 1) {
              play_sound('WildCard_Explosion_Use');
            }
            emitter.bringToTop = true;
            emitter.minParticleSpeed.set(-500, -500);
            emitter.maxParticleSpeed.set(500, 500);
            emitter.x = item.x;
            emitter.y = item.y;
            emitter.start(true, 600, 0, 50);
          } else {
            if (sound_on == 1) {
              play_sound('WildCard_LineSweeper_Use');
            }
            emitter.bringToTop = true;
            emitter.minParticleSpeed.set(-800, -100);
            emitter.maxParticleSpeed.set(800, 100);
            emitter.x = item.x;
            emitter.y = item.y;
            emitter.start(true, 600, 0, 50);
          }
          cards_group.children.forEach(function (element1) {
            var c_dest = 1;
            if (element1.hazard_type == 0)
              if (
                (Phaser.Math.distance(item.x, item.y, element1.x, element1.y) <= 380 && type == 1) ||
                (item.y + item.height / 2 >= element1.y - element1.height / 2 + 50 &&
                  item.y - item.height / 2 <= element1.y + element1.height / 2 - 50 &&
                  type == 2)
              ) {
                cards_group.children.forEach(function (element2) {
                  var points1 = getPoints1(element1);
                  var points2 = getPoints2(element2);
                  if (polygonPolygon(points1, points2) == true && element1.depth < element2.depth) {
                    c_dest = 0;
                  }
                });
                if (c_dest == 1) {
                  destroy_cards.push(element1);
                }
              }
          });
          for (var i = 0; i < destroy_cards.length; i++) {
            if (destroy_cards[i].hazard_type == 1) {
              hazard_cards[destroy_cards[i].n].hazard_type = -1;
              destroy_cards[i].hazard_type = 0;
            }
            game.add.tween(destroy_cards[i].scale).to({ x: 0, y: 0 }, 400, Phaser.Easing.Linear.None, true);
            game.add
              .tween(destroy_cards[i])
              .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                cards_group.remove(item);
                game_win();
                game_loss();
                visible_cards(0);
              });
          }
          destroy_cards = [];
          start_card_mas = [];
        } else {
          if (sound_on == 1) {
            play_sound('Booster_FiveCards_Use');
          }
          var plus3 = [];
          game.time.events.repeat(
            Phaser.Timer.SECOND * 0.2,
            3,
            function () {
              var new_card = game.add.sprite(item.x, item.y, 'game5_atlas', backcards_select);
              new_card.anchor.setTo(0.5, 0.5);
              new_card.scale.setTo(card_size);
              game.add
                .tween(new_card)
                .to(
                  { x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size },
                  600,
                  Phaser.Easing.Linear.None,
                  true,
                )
                .onComplete.add(function (item) {
                  item.destroy();
                  cards_deck_col += 1;
                  var a = 0;
                  while (a == 0) {
                    var card_plus3 = game.rnd.integerInRange(1, 13);
                    if (
                      plus3.filter(function (item) {
                        return item === card_plus3;
                      }).length == 0
                    ) {
                      plus3.push(card_plus3);
                      var draw_card_n = get_random_change([
                        card_plus3,
                        card_plus3 + 13,
                        card_plus3 + 13 * 2,
                        card_plus3 + 13 * 3,
                      ]);
                      cards_deck.push(draw_card_n);
                      a = 1;
                    }
                  }
                  if (deck_n >= cards_deck_col - 2) {
                    card_deck = game.add.sprite(
                      game.world.centerX + 1 * card_size,
                      game.world.height - 90 * card_size,
                      'game5_atlas',
                      backcards_select,
                    );
                    card_deck.inputEnabled = true;
                    card_deck.events.onInputDown.add(card_add, this);
                    card_deck.anchor.setTo(0.5, 0.5);
                    card_deck.scale.setTo(card_size);
                    if (baloon == 1) bottom_game_group.add(card_deck);
                    card_text = game.add.text(
                      game.world.centerX + 1 * card_size,
                      game.world.height - 40 * card_size,
                      cards_deck_col - 1 - deck_n,
                      { font: '36px RussoOne', fill: '#fff', align: 'center' },
                    );
                    card_text.alpha = 0;
                    card_text.anchor.setTo(0.5, 0.5);
                    if (baloon == 1) bottom_game_group.add(card_text);
                    deck_change();
                    if (booster4 != 0) {
                      booster4.destroy(); if (booster4_1 != 0 && booster4_1 != -1) { booster4_1.destroy(); booster4_1 = -1; }
                      booster4 = 0;
                    }
                    if (UI_EndGame_btn != 0) {
                      UI_EndGame_btn.destroy();
                      UI_EndGame_btn = 0;
                    }
                  }
                  card_text.setText(cards_deck_col - 1 - deck_n);
                  deck_change();
                  game_win();
                  visible_cards(0);
                  game_loss();
                });
              item.destroy();
            },
            this,
          );
        }
      }
      function misDate_timer() {
        if (misDate != 0) {
          var NowDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          var timeDiff = misDate.getTime() - NowDate.getTime();
          var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
          var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
          var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
          var diffSec = Math.floor((timeDiff / 1000) % 60);
          if (timeDiff <= 0) {

            coin_missions_completed = 0;
            coin_missions_shown = 6;
            mission_skip_success = 0;
            mission_skip_fail = 0;


            window.eventTrack('Coin_Mission_failed', 1, {
              required_coins: mis_coins,
              coin_missions_completed: coin_missions_completed,
              coin_missions_shown: coin_missions_shown,
              completion_rate: Math.round(Number(keys) / (Number(mis_coins) / 100)),
              mission_skip_success: mission_skip_success,
              mission_skip_fail: mission_skip_fail,
            });

            misDate = 0;
            keys = 0;
            mis_n = -1;
            game.setUserDataAndLog({ mis_n: mis_n, keys: keys, misDate: String(misDate), coin_missions_completed: coin_missions_completed, coin_missions_shown: coin_missions_shown, mission_skip_success: mission_skip_success, mission_skip_fail: mission_skip_fail });
            mission_loser = 1;
            mission_create(0);

          } else {
            if (diffDay > 0) {
              diffHour += 24;
            }
            if (diffHour < 10) {
              diffHour = '0' + diffHour;
            }
            if (diffMin < 10) {
              diffMin = '0' + diffMin;
            }
            if (diffSec < 10) {
              diffSec = '0' + diffSec;
            }
            var timer = diffHour + ':' + diffMin + ':' + diffSec;
            if (misDate_timer_text != 0 && typeof misDate_timer_text !== "undefined") {
              misDate_timer_text.setText(timer);
            }
          }
        }
      }
      var gwin = 0;
      function rotate_tween(item) {
        game.add
          .tween(item)
          .to({ angle: 360 }, 5000, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (itm) {
            rotate_tween(itm);
          });
      }
      var sunflowerStage_old = sunflowerStage;
      var sunflowerStage_max = 2;
      var magicbeanStage_max = 2;
      var prize_n = 1;
      var sunflower_timer = 0;
      var sunflower_graphics = 0;
      var magicbean_timer = 0;
      function sunflowertimer() {
        if (sunflowerDate != 0) {
          var NowDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          var timeDiff = sunflowerDate.getTime() - NowDate.getTime();
          var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
          var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
          var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
          var diffSec = Math.floor((timeDiff / 1000) % 60);
          if (timeDiff <= 0) {
            sunflowerStage = 1;
            sunflowerDate = 0;
            sunflowerDate_new =
              ddd == 0
                ? new Date()
                : new Date(
                  ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                );
            sunflowerDate_new.setHours(sunflowerDate_new.getHours() + 120);
            if (sunflower_graphics != 0) {
              sunflower_graphics.destroy();
              sunflower_graphics = 0;
              sunflower_timer.destroy();
              sunflower_timer = 0;
            }
            game.setUserDataAndLog({
              sunflowerDate: String(sunflowerDate),
              sunflowerDate_new: String(sunflowerDate_new),
            });
          } else {
            if (diffDay > 0) {
              diffHour += 24;
            }
            if (diffHour < 10) {
              diffHour = '0' + diffHour;
            }
            if (diffMin < 10) {
              diffMin = '0' + diffMin;
            }
            if (diffSec < 10) {
              diffSec = '0' + diffSec;
            }
            if (sunflower_timer != 0) {
              sunflower_timer.setText(diffHour + ':' + diffMin + ':' + diffSec);
            }
          }
        }
      }
      function magicbeantimer() {
        if (magicbeanDate != 0) {
          var NowDate =
            ddd == 0
              ? new Date()
              : new Date(
                ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
              );
          var timeDiff = magicbeanDate.getTime() - NowDate.getTime();
          var diffDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
          var diffHour = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
          var diffMin = Math.floor((timeDiff / 1000 / 60) % 60);
          var diffSec = Math.floor((timeDiff / 1000) % 60);
          if (timeDiff <= 0) {
            if (unlimited_lifesDate != 0) {
              unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() - unlimited_lifesDate_old);
              game.setUserDataAndLog({
                unlimited_lifesDate: String(unlimited_lifesDate),
              });
            }
            magicbeanStage = 0;
            magicbeanDate = 0;
            magicbeanDate_new =
              ddd == 0
                ? new Date()
                : new Date(
                  ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                );
            magicbeanDate_new.setHours(magicbeanDate_new.getHours() + 144);
            if (sunflower_graphics != 0) {
              sunflower_graphics.destroy();
              sunflower_graphics = 0;
              magicbean_timer.destroy();
              magicbean_timer = 0;
            }
            game.setUserDataAndLog({
              magicbeanDate: String(magicbeanDate),
              magicbeanDate_new: String(magicbeanDate_new),
              magicbeanStage: magicbeanStage,
            });
          } else {
            if (diffDay > 0) {
              diffHour += 24;
            }
            if (diffHour < 10) {
              diffHour = '0' + diffHour;
            }
            if (diffMin < 10) {
              diffMin = '0' + diffMin;
            }
            if (diffSec < 10) {
              diffSec = '0' + diffSec;
            }
            if (magicbean_timer != 0) {
              magicbean_timer.setText(diffHour + ':' + diffMin + ':' + diffSec);
            }
          }
        }
      }

      function mayor_offer_wheel(coins_reward) {

        var Spotlight1 = game.add.sprite(game.world.centerX + 100, -100, 'mayor_reward_atlas', 'Spotlight.png');
        Spotlight1.anchor.setTo(0.5, 0);
        Spotlight1.scale.setTo(2);
        Spotlight1.alpha = 0;
        popup_group.add(Spotlight1);

        var Spotlight2 = game.add.sprite(game.world.centerX - 100, -100, 'mayor_reward_atlas', 'Spotlight.png');
        Spotlight2.anchor.setTo(0.5, 0);
        Spotlight2.scale.setTo(2);
        Spotlight2.alpha = 0;
        popup_group.add(Spotlight2);

        var Mayor_Neutral = game.add.sprite(game.world.centerX + 700, game.world.height, 'char_atlas', 'Mayor_Neutral.png');
        Mayor_Neutral.scale.setTo(3);
        Mayor_Neutral.anchor.setTo(0.5, 1);
        popup_group.add(Mayor_Neutral);

        var emitter = game.add.emitter(game.world.centerX, 200, 200);
        emitter.makeParticles('ingame_atlas', 'Coin.png');
        emitter.setScale(0.6, 0.6, 0.6, 0.6, 5000);
        emitter.minParticleSpeed.set(-800, -800);
        emitter.maxParticleSpeed.set(800, 800);
        emitter.gravity = 500;
        popup_group.add(emitter);

        var Wheel = game.add.sprite(game.world.centerX, game.world.centerY - 100, 'mayor_reward_atlas', 'Wheel.png');
        Wheel.anchor.setTo(0.5);
        Wheel.scale.setTo(0);
        popup_group.add(Wheel);
        game.add.tween(Wheel.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Elastic.Out, true);

        var Wheel = game.add.sprite(game.world.centerX, game.world.centerY - 100, '');
        Wheel.anchor.setTo(0.5);
        Wheel.alpha = 0;
        popup_group.add(Wheel);
        game.add.tween(Wheel).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true, 500);

        var Selection = game.add.sprite(game.world.centerX, game.world.centerY - 104, 'mayor_reward_atlas', 'Selection.png');
        Selection.anchor.setTo(17 / Selection.width, 1 - 14 / Selection.height);
        Selection.alpha = 0;
        popup_group.add(Selection);
        game.add.tween(Selection).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true, 500);

        var prize1_text = game.add.text(220, -100, 'X2', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        Wheel.addChild(prize1_text);
        prize1_text = game.add.text(-100, -220, 'X2', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        Wheel.addChild(prize1_text);
        prize1_text = game.add.text(-220, -100, 'X3', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        Wheel.addChild(prize1_text);
        prize1_text = game.add.text(220, 100, 'X3', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        Wheel.addChild(prize1_text);
        prize1_text = game.add.text(-100, 220, 'X10', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        Wheel.addChild(prize1_text);
        prize1_text = game.add.text(-220, 100, 'X2', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        Wheel.addChild(prize1_text);
        prize1_text = game.add.text(100, 220, 'X2', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        Wheel.addChild(prize1_text);
        prize1_text = game.add.text(100, -220, 'X5', { font: '50px RussoOne', fill: '#fff', align: 'center' });
        prize1_text.anchor.setTo(0.5);
        prize1_text.stroke = '#0D739F';
        prize1_text.strokeThickness = 12;
        Wheel.addChild(prize1_text);

        var button_green_yes = game.add.sprite(
          game.world.centerX,
          game.world.height - 130 + 1000,
          'game_window_atlas',
          'Play_With_Friend_Button.png',
        );
        button_green_yes.anchor.setTo(0.5);
        //button_animation_f(button_green_yes, 1);
        game.add.tween(button_green_yes).to({ y: '-1000' }, 500, Phaser.Easing.Exponential.Out, true);
        button_green_yes.inputEnabled = true;
        button_green_yes.events.onInputUp.add(function (item) {
          if (popup != 2) {
            Spotlight1.alpha = 1;
            Spotlight2.alpha = 1;
            game.add.tween(Spotlight1).to({ x: '-1000' }, 2000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 100);
            game.add.tween(Spotlight1).to({ angle: '-40' }, 2000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 100);
            game.add.tween(Spotlight2).to({ x: '+1000' }, 2000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 100);
            game.add.tween(Spotlight2).to({ angle: '+40' }, 2000, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 100);

            popup = 2;
            var rnd = go(d8);
            var r = 2880 + rnd * 45;
            var c_reward = coins_reward;
            game.add.tween(Selection).to({ angle: '+' + r }, 10000, Phaser.Easing.Cubic.InOut, true).onComplete.add(function (item) {

              Mayor_Neutral.loadTexture('char_atlas', 'Mayor_Excited.png');

              if (rnd == 1) //x2
              {
                c_reward *= 2;

              } else if (rnd == 2) //x3
              {
                c_reward *= 3;
              } else if (rnd == 3) //x2
              {
                c_reward *= 2;
              } else if (rnd == 4) //x10
              {
                c_reward *= 10;
              } else if (rnd == 5) //x2
              {
                c_reward *= 2;
              } else if (rnd == 6) //x3
              {
                c_reward *= 3;
              } else if (rnd == 7) //x2
              {
                c_reward *= 2;
              }
              else if (rnd == 8) //x5
              {
                c_reward *= 5;
              }

              var var_coins = coins_reward;
              game.time.events.repeat(
                100,
                10,
                function () {
                  var_coins += (c_reward - coins_reward) / 10;
                  Coin_text.setText(Math.ceil(var_coins));
                  emitter.start(true, 5000, null, 2);
                },
                this,
              );

            });

            game.add.tween(effects_group).to({ alpha: 1 }, 12000, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
              coins_reward = c_reward;
              coins += coins_reward;
              game.setCurrentEvent();

              window.eventTrack('coins_in', coins_reward, {
                user_type: bought,
                lifetime: lifetime_day,
                highest_lvl: all_level.lastIndexOf(3) + 2,
                amount: coins_reward,
                source: 'Win level',
                package_id: 0,
                mission_completed: missioncompleted,
                c_event: current_event,
              });

              // save collected coins
              game.setUserDataAndLog({ currencies: coins });

              var coins_t = coins - coins_reward;
              coins_text.setText(coins_t);
              var var_coins = 0;
              var var_coins_m = 0;
              if (sound_on == 1) {
                play_sound('coins_add');
              }
              game.time.events.repeat(
                100,
                10,
                function () {
                  var star_emitter = game.add.emitter(Coin_text.world.x, Coin_text.world.y, 100);
                  star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                  star_emitter.setAlpha(1, 0, 800);
                  star_emitter.setScale(3, 0, 3, 0, 800);
                  star_emitter.start(false, 1500, 10);
                  effects_group.add(star_emitter);
                  var get_coin = game.add.sprite(Coin_Icon.world.x, Coin_Icon.world.y, 'ingame_atlas', 'Coin.png');
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0.4);
                  get_coin.alpha = 1;
                  get_coin.em = star_emitter;
                  effects_group.add(get_coin);
                  game.world.bringToTop(effects_group);
                  var_coins_m += coins_reward / 10;
                  Coin_text.setText(Math.ceil(coins_reward - var_coins_m));
                  if (Math.ceil(coins_reward - var_coins_m) <= 1) {
                    Coin_text.setText(0);
                  }
                  game.add.tween(get_coin.scale).to({ x: 0.6, y: 0.6 }, 1000, Phaser.Easing.Linear.None, true);
                  var tween = game.add.tween(get_coin).to({ x: coin_icon.world.x, y: coin_icon.world.y }, 1000, Phaser.Easing.Quadratic.Out, true);
                  tween.onUpdateCallback(function () {
                    star_emitter.x = get_coin.x;
                    star_emitter.y = get_coin.y;
                  }, this);
                  game.add
                    .tween(get_coin)
                    .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      item.em.destroy();
                      item.destroy();
                      var_coins += coins_reward / 10;
                      coins_text.setText(Math.ceil(coins_t + var_coins));
                    });
                },
                this,
              );
              game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                game.add
                  .tween(popup_group)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function () {
                    popup_group.removeAll(true);
                    popup_group.alpha = 1;
                    animation = 1;
                    popup = 0;
                    if (mayoroffer == 1) {
                      mayor_offer(coins_reward);
                    }
                    else
                      if (level >= 6) {
                        game_mission(0);
                      } else {
                        get_popup(1);
                      }
                  });
              });
            });


          }
        });
        popup_group.add(button_green_yes);
        scale_tween(button_green_yes, 500, 0.1, 0.1, -1);

        var text_button_green = game.add.text(0, -2, 'Spin', {
          font: '56px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        text_button_green.anchor.setTo(0.5);
        text_button_green.lineSpacing = -10;
        text_button_green.stroke = '#3C6C05';
        text_button_green.strokeThickness = 4;
        text_button_green.setShadow(0, 2, 'rgba(60,108,5,1)', 0);
        button_green_yes.addChild(text_button_green);

        var Coins_Number_Back = game.add.sprite(game.world.centerX, game.world.centerY - 100, 'mayor_reward_atlas', 'Coins_Number_Back.png');
        Coins_Number_Back.anchor.setTo(0.5);
        popup_group.add(Coins_Number_Back);
        Coins_Number_Back.scale.setTo(0);
        game.add.tween(Coins_Number_Back.scale).to({ x: 1, y: 1 }, 300, Phaser.Easing.Elastic.Out, true, 500)

        var Coin_Number_Background2 = game.add.sprite(
          30, -7,
          'ingame_atlas',
          'Coin_Number_Background.png',
        );
        Coin_Number_Background2.anchor.setTo(0.5);
        Coins_Number_Back.addChild(Coin_Number_Background2);

        var Coin_Icon = game.add.sprite(-80, -13, 'game_ui_atlas', 'Coin_Icon.png');
        Coin_Icon.anchor.setTo(0.5);
        Coin_Icon.scale.setTo(1.4);
        Coins_Number_Back.addChild(Coin_Icon);

        var Coin_text = game.add.text(0, -5, coins_reward, { font: '42px RussoOne', fill: '#fff', align: 'center' });
        Coin_text.anchor.setTo(0, 0.5);
        Coin_text.setShadow(0, 4, 'rgba(0,0,0,0.7)', 10);
        Coins_Number_Back.addChild(Coin_text);
      }

      function mayor_offer(coins_reward) {
        mayoroffer = 0;
        var Ribbon = game.add.sprite(game.world.centerX, 200 - 1000, 'mayor_reward_atlas', 'Ribbon.png');
        Ribbon.anchor.setTo(0.5);
        popup_group.add(Ribbon);
        game.add.tween(Ribbon).to({ y: '+1000' }, 500, Phaser.Easing.Exponential.Out, true);

        var Blue_Ribbon_text = game.add.text(0, -25, game.cache.getJSON('lang')['t591'][0][window.lang], {
          font: '48px RussoOne',
          fill: '#fff',
          align: 'center',
        });

        Blue_Ribbon_text.anchor.setTo(0.5);
        Blue_Ribbon_text.setShadow(0, 4, 'rgba(0,0,0,0.7)', 10);
        Ribbon.addChild(Blue_Ribbon_text);

        var Mayor_Neutral = game.add.sprite(game.world.centerX + 1700, game.world.height, 'char_atlas', 'Mayor_Neutral.png');
        Mayor_Neutral.scale.setTo(3);
        Mayor_Neutral.anchor.setTo(0.5, 1);
        popup_group.add(Mayor_Neutral);
        game.add.tween(Mayor_Neutral).to({ x: '-1000' }, 500, Phaser.Easing.Exponential.Out, true);

        var Text_Bubble = game.add.sprite(game.world.centerX, 400, 'mayor_reward_atlas', 'Text_Bubble.png');
        Text_Bubble.scale.setTo(0);
        Text_Bubble.anchor.setTo(0.5);
        popup_group.add(Text_Bubble);
        game.add.tween(Text_Bubble.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 500);

        var Speech_Bubble_text = game.add.text(0, -15, game.cache.getJSON('lang')['t592'][0][window.lang], {
          font: '38px RussoOne',
          fill: '#8B3C33',
          align: 'center',
          wordWrap: true,
          wordWrapWidth: 600,
        });

        Speech_Bubble_text.anchor.setTo(0.5);
        Text_Bubble.addChild(Speech_Bubble_text);

        var Coin_Number_Background = game.add.sprite(
          game.world.centerX - 15,
          game.world.centerY + 300,
          '',
        );

        Coin_Number_Background.anchor.setTo(0.5);
        Coin_Number_Background.alpha = 0;
        popup_group.add(Coin_Number_Background);
        game.add.tween(Coin_Number_Background).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);

        var Coin_Number_mask = game.add.graphics(0, 0);
        Coin_Number_mask.beginFill(0xffffff);
        Coin_Number_mask.drawRect(
          game.world.centerX - 70,
          game.world.centerY + 250,
          game.world.centerX + 100,
          game.world.centerY + 350,
        );
        popup_group.add(Coin_Number_mask);

        var Coin_Number_Background2 = game.add.sprite(
          - 385 + 440,
          0,
          'ingame_atlas',
          'Coin_Number_Background.png',
        );
        Coin_Number_Background2.mask = Coin_Number_mask;
        Coin_Number_Background2.anchor.setTo(0.5);
        Coin_Number_Background.addChild(Coin_Number_Background2);

        var Coin_back = game.add.sprite(0, 0, '');
        Coin_back.anchor.setTo(0.5);
        Coin_back.scale.setTo(1);
        Coin_Number_Background2.addChild(Coin_back);

        var Coin_Icon = game.add.sprite(0, -4, 'game_ui_atlas', 'Coin_Icon.png');
        Coin_Icon.anchor.setTo(0, 0.5);
        Coin_Icon.scale.setTo(0.5);
        Coin_back.addChild(Coin_Icon);

        var Coin_text = game.add.text(Coin_Icon.width + 10, 0, coins_reward, { font: '42px RussoOne', fill: '#fff', align: 'center' });
        Coin_text.anchor.setTo(0, 0.5);
        Coin_text.setShadow(0, 4, 'rgba(0,0,0,0.7)', 10);
        Coin_back.addChild(Coin_text);

        Coin_Icon.x -= (Coin_Icon.width + 10 + Coin_text.width) / 2 + 15;
        Coin_text.x -= (Coin_Icon.width + 10 + Coin_text.width) / 2 + 15;

        var Safe_Icon3 = game.add.sprite(-100, -50, 'game_atlas', 'Pre-comp 7_00027.png');
        Safe_Icon3.anchor.setTo(0.5);
        Safe_Icon3.scale.setTo(2);
        Coin_Number_Background.addChild(Safe_Icon3);

        Coin_Number_Background.y -= 250;
        Coin_Number_mask.y -= 250;

        var button_green_no = game.add.sprite(
          game.world.centerX - 200,
          game.world.height - 130 + 1000,
          'game_window_atlas',
          'Play_Alone_Button.png',
        );
        button_green_no.anchor.setTo(0.5);
        button_animation_f(button_green_no, 1);
        button_green_no.events.onInputUp.add(function (item) {

          if (popup == 0) {
            popup = 2;
            coins += coins_reward;
            game.setCurrentEvent();

            window.eventTrack('coins_in', coins_reward, {
              user_type: bought,
              lifetime: lifetime_day,
              highest_lvl: all_level.lastIndexOf(3) + 2,
              amount: coins_reward,
              source: 'Win level',
              package_id: 0,
              mission_completed: missioncompleted,
              c_event: current_event,
            });

            // save collected coins
            game.setUserDataAndLog({ currencies: coins });

            var coins_t = coins - coins_reward;
            coins_text.setText(coins_t);
            var var_coins = 0;
            var var_coins_m = 0;
            if (sound_on == 1) {
              play_sound('coins_add');
            }
            game.time.events.repeat(
              100,
              10,
              function () {
                var star_emitter = game.add.emitter(Coin_text.world.x, Coin_text.world.y, 100);
                star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                star_emitter.setAlpha(1, 0, 800);
                star_emitter.setScale(3, 0, 3, 0, 800);
                star_emitter.start(false, 1500, 10);
                effects_group.add(star_emitter);
                var get_coin = game.add.sprite(Coin_Icon.world.x, Coin_Icon.world.y, 'ingame_atlas', 'Coin.png');
                get_coin.anchor.setTo(0.5);
                get_coin.scale.setTo(0.4);
                get_coin.alpha = 1;
                get_coin.em = star_emitter;
                effects_group.add(get_coin);
                game.world.bringToTop(effects_group);
                var_coins_m += coins_reward / 10;
                Coin_text.setText(Math.ceil(coins_reward - var_coins_m));
                if (Math.ceil(coins_reward - var_coins_m) <= 1) {
                  Coin_text.setText(0);
                }
                game.add.tween(get_coin.scale).to({ x: 0.6, y: 0.6 }, 1000, Phaser.Easing.Linear.None, true);
                var tween = game.add.tween(get_coin).to({ x: coin_icon.world.x, y: coin_icon.world.y }, 1000, Phaser.Easing.Quadratic.Out, true);
                tween.onUpdateCallback(function () {
                  star_emitter.x = get_coin.x;
                  star_emitter.y = get_coin.y;
                }, this);
                game.add
                  .tween(get_coin)
                  .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    item.em.destroy();
                    item.destroy();
                    var_coins += coins_reward / 10;
                    coins_text.setText(Math.ceil(coins_t + var_coins));
                  });
              },
              this,
            );
            game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
              game.add
                .tween(popup_group)
                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  popup_group.removeAll(true);
                  popup_group.alpha = 1;
                  animation = 1;
                  popup = 0;
                  if (mayoroffer == 1) {
                    mayor_offer(coins_reward);
                  }
                  else
                    if (level >= 6) {
                      game_mission(0);
                    } else {
                      get_popup(1);
                    }
                });
            });
          }
        });
        popup_group.add(button_green_no);
        game.add.tween(button_green_no).to({ y: '-1000' }, 500, Phaser.Easing.Exponential.Out, true);

        var text_button_green_alone = game.add.text(0, 0, game.cache.getJSON('lang')['t594'][0][window.lang], {
          font: '30px RussoOne',
          fill: '#fff',
          align: 'center',
          wordWrap: true,
          wordWrapWidth: 220,
        });
        text_button_green_alone.lineSpacing = -12;
        text_button_green_alone.anchor.setTo(0.5);
        text_button_green_alone.stroke = '#7C7C7C';
        text_button_green_alone.strokeThickness = 4;
        text_button_green_alone.setShadow(0, 2, 'rgba(124,124,124,1)', 0);
        button_green_no.addChild(text_button_green_alone);

        var button_green_yes = game.add.sprite(
          game.world.centerX + 200,
          game.world.height - 130 + 1000,
          'game_window_atlas',
          'Play_With_Friend_Button.png',
        );
        button_green_yes.anchor.setTo(0.5);
        button_green_yes.inputEnabled = true;
        button_green_yes.events.onInputUp.add(function (item) {
          console.log("%cThis can happen, but sharing should be disabled!", "color:orange");

          if (popup != 2) {
            popup = 2;
            loading();

            if (music_on == 1) music.pause();
            if (sound_on == 1) ambient.pause();

            sdkHandler.trigger(
              'rewardedAd',
              {
                callback: function (success) {
                  if (music_on == 1) music.play();
                  if (sound_on == 1) ambient.play();

                  if (success) {
                    console.log('Rewarded video watched successfully 4');
                    game.add.tween(popup_group).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
                      popup_group.removeAll(true);
                      popup_group.alpha = 1;
                      animation = 1;
                      popup = 0;
                      mayor_offer_wheel(coins_reward)
                    });

                    if (loading_black_sprite != 0) {
                      loading_black_sprite.destroy();
                      loading_black_sprite = 0;
                    }

                    if (loading_text != 0 && loading_text != 1) {
                      loading_text.destroy();
                      loading_text = 0;
                    }

                    loading_text = 1;

                  } else {
                    console.log('Failed to watch rewarded Ad 4')
                    if (loading_black_sprite != 0) {
                      loading_black_sprite.destroy();
                      loading_black_sprite = 0;
                    }
                    if (loading_text != 0 && loading_text != 1) {
                      loading_text.destroy();
                      loading_text = 0;
                    }
                    loading_text = 1;
                    popup = 2;
                    coins += coins_reward;
                    game.setCurrentEvent();

                    window.eventTrack('coins_in', coins_reward, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: coins_reward,
                      source: 'Win level',
                      package_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });

                    // save collected coins
                    game.setUserDataAndLog({ currencies: coins });

                    var coins_t = coins - coins_reward;
                    coins_text.setText(coins_t);
                    var var_coins = 0;
                    var var_coins_m = 0;
                    if (sound_on == 1) {
                      play_sound('coins_add');
                    }
                    game.time.events.repeat(
                      100,
                      10,
                      function () {
                        var star_emitter = game.add.emitter(Coin_text.world.x, Coin_text.world.y, 100);
                        star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                        star_emitter.setAlpha(1, 0, 800);
                        star_emitter.setScale(3, 0, 3, 0, 800);
                        star_emitter.start(false, 1500, 10);
                        effects_group.add(star_emitter);
                        var get_coin = game.add.sprite(Coin_Icon.world.x, Coin_Icon.world.y, 'ingame_atlas', 'Coin.png');
                        get_coin.anchor.setTo(0.5);
                        get_coin.scale.setTo(0.4);
                        get_coin.alpha = 1;
                        get_coin.em = star_emitter;
                        effects_group.add(get_coin);
                        game.world.bringToTop(effects_group);
                        var_coins_m += coins_reward / 10;
                        Coin_text.setText(Math.ceil(coins_reward - var_coins_m));
                        if (Math.ceil(coins_reward - var_coins_m) <= 1) {
                          Coin_text.setText(0);
                        }
                        game.add.tween(get_coin.scale).to({ x: 0.6, y: 0.6 }, 1000, Phaser.Easing.Linear.None, true);
                        var tween = game.add.tween(get_coin).to({ x: coin_icon.world.x, y: coin_icon.world.y }, 1000, Phaser.Easing.Quadratic.Out, true);
                        tween.onUpdateCallback(function () {
                          star_emitter.x = get_coin.x;
                          star_emitter.y = get_coin.y;
                        }, this);
                        game.add
                          .tween(get_coin)
                          .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            item.em.destroy();
                            item.destroy();
                            var_coins += coins_reward / 10;
                            coins_text.setText(Math.ceil(coins_t + var_coins));
                          });
                      },
                      this,
                    );
                    game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      game.add
                        .tween(popup_group)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function () {
                          popup_group.removeAll(true);
                          popup_group.alpha = 1;
                          animation = 1;
                          popup = 0;
                          if (mayoroffer == 1) {
                            mayor_offer(coins_reward);
                          }
                          else
                            if (level >= 6) {
                              game_mission(0);
                            } else {
                              get_popup(1);
                            }
                        });
                    });
                  }
                },
              },
              this,
            );

          }

          // transformed to rewarded ad!
          //   var preloadedRewardedVideo = null;
          //   getRewardedVideoAsync(placement.Rewarded1, {
          //     adContext: DdnaAdContext.RewardedInGame,
          //     adGameArea: DdnaAdGameArea.Level,
          //     adRewardType: TAdRewardType.No,
          //     levelNumber: level,
          //   })
          //     .then(function (rewarded) {
          //       preloadedRewardedVideo = rewarded;
          //       return preloadedRewardedVideo.loadAsync();
          //     })
          //     .then(function () {
          //       console.log('Rewarded video preloaded');
          //       if (music_on == 1) {
          //         music.pause();
          //       }
          //       if (sound_on == 1) {
          //         ambient.pause();
          //       }
          //       preloadedRewardedVideo
          //         .showAsync()
          //         .then(function () {
          //           console.log('Rewarded video watched successfully');
          //           game.add.tween(popup_group).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function () {
          //             popup_group.removeAll(true);
          //             popup_group.alpha = 1;
          //             animation = 1;
          //             popup = 0;
          //             mayor_offer_wheel(coins_reward)
          //           });
          //           if (loading_black_sprite != 0) {
          //             loading_black_sprite.destroy();
          //             loading_black_sprite = 0;
          //           }
          //           if (loading_text != 0 && loading_text != 1) {
          //             loading_text.destroy();
          //             loading_text = 0;
          //           }
          //           loading_text = 1;
          //           if (music_on == 1) {
          //             music.play();
          //           }
          //         })
          //         .catch(function (e) {
          //           console.error(e.message);
          //           if (loading_black_sprite != 0) {
          //             loading_black_sprite.destroy();
          //             loading_black_sprite = 0;
          //           }
          //           if (loading_text != 0 && loading_text != 1) {
          //             loading_text.destroy();
          //             loading_text = 0;
          //           }
          //           loading_text = 1;
          //           popup = 2;
          //           coins += coins_reward;
          //           game.setCurrentEvent();

          //           window.eventTrack('coins_in', coins_reward, {
          //             user_type: bought,
          //             lifetime: lifetime_day,
          //             highest_lvl: all_level.lastIndexOf(3) + 2,
          //             amount: coins_reward,
          //             source: 'Win level',
          //             package_id: 0,
          //             mission_completed: missioncompleted,
          //             c_event: current_event,
          //           });
          //           var coins_t = coins - coins_reward;
          //           coins_text.setText(coins_t);
          //           var var_coins = 0;
          //           var var_coins_m = 0;
          //           if (sound_on == 1) {
          //             play_sound('coins_add');
          //           }
          //           game.time.events.repeat(
          //             100,
          //             10,
          //             function () {
          //               var star_emitter = game.add.emitter(Coin_text.world.x, Coin_text.world.y, 100);
          //               star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
          //               star_emitter.setAlpha(1, 0, 800);
          //               star_emitter.setScale(3, 0, 3, 0, 800);
          //               star_emitter.start(false, 1500, 10);
          //               effects_group.add(star_emitter);
          //               var get_coin = game.add.sprite(Coin_Icon.world.x, Coin_Icon.world.y, 'ingame_atlas', 'Coin.png');
          //               get_coin.anchor.setTo(0.5);
          //               get_coin.scale.setTo(0.4);
          //               get_coin.alpha = 1;
          //               get_coin.em = star_emitter;
          //               effects_group.add(get_coin);
          //               game.world.bringToTop(effects_group);
          //               var_coins_m += coins_reward / 10;
          //               Coin_text.setText(Math.ceil(coins_reward - var_coins_m));
          //               if (Math.ceil(coins_reward - var_coins_m) <= 1) {
          //                 Coin_text.setText(0);
          //               }
          //               game.add.tween(get_coin.scale).to({ x: 0.6, y: 0.6 }, 1000, Phaser.Easing.Linear.None, true);
          //               var tween = game.add.tween(get_coin).to({ x: coin_icon.world.x, y: coin_icon.world.y }, 1000, Phaser.Easing.Quadratic.Out, true);
          //               tween.onUpdateCallback(function () {
          //                 star_emitter.x = get_coin.x;
          //                 star_emitter.y = get_coin.y;
          //               }, this);
          //               game.add
          //                 .tween(get_coin)
          //                 .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
          //                 .onComplete.add(function (item) {
          //                   item.em.destroy();
          //                   item.destroy();
          //                   var_coins += coins_reward / 10;
          //                   coins_text.setText(Math.ceil(coins_t + var_coins));
          //                 });
          //             },
          //             this,
          //           );
          //           game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          //             game.add
          //               .tween(popup_group)
          //               .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
          //               .onComplete.add(function () {
          //                 popup_group.removeAll(true);
          //                 popup_group.alpha = 1;
          //                 animation = 1;
          //                 popup = 0;
          //                 if (mayoroffer == 1) {
          //                   mayor_offer(coins_reward);
          //                 }
          //                 else
          //                   if (level >= 6) {
          //                     game_mission(0);
          //                   } else {
          //                     get_popup(1);
          //                   }
          //               });
          //           });
          //           if (music_on == 1) {
          //             music.play();
          //           }
          //         });
          //     })
          //     .catch(function (err) {
          //       console.error('Rewarded video failed to preload: ' + err.message);
          //       if (loading_black_sprite != 0) {
          //         loading_black_sprite.destroy();
          //         loading_black_sprite = 0;
          //       }
          //       if (loading_text != 0 && loading_text != 1) {
          //         loading_text.destroy();
          //         loading_text = 0;
          //       }
          //       loading_text = 1;
          //       popup = 2;
          //       coins += coins_reward;
          //       game.setCurrentEvent();
          //       window.eventTrack('coins_in', coins_reward, {
          //         user_type: bought,
          //         lifetime: lifetime_day,
          //         highest_lvl: all_level.lastIndexOf(3) + 2,
          //         amount: coins_reward,
          //         source: 'Win level',
          //         package_id: 0,
          //         mission_completed: missioncompleted,
          //         c_event: current_event,
          //       });
          //       var coins_t = coins - coins_reward;
          //       coins_text.setText(coins_t);
          //       var var_coins = 0;
          //       var var_coins_m = 0;
          //       if (sound_on == 1) {
          //         play_sound('coins_add');
          //       }
          //       game.time.events.repeat(
          //         100,
          //         10,
          //         function () {
          //           var star_emitter = game.add.emitter(Coin_text.world.x, Coin_text.world.y, 100);
          //           star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
          //           star_emitter.setAlpha(1, 0, 800);
          //           star_emitter.setScale(3, 0, 3, 0, 800);
          //           star_emitter.start(false, 1500, 10);
          //           effects_group.add(star_emitter);
          //           var get_coin = game.add.sprite(Coin_Icon.world.x, Coin_Icon.world.y, 'ingame_atlas', 'Coin.png');
          //           get_coin.anchor.setTo(0.5);
          //           get_coin.scale.setTo(0.4);
          //           get_coin.alpha = 1;
          //           get_coin.em = star_emitter;
          //           effects_group.add(get_coin);
          //           game.world.bringToTop(effects_group);
          //           var_coins_m += coins_reward / 10;
          //           Coin_text.setText(Math.ceil(coins_reward - var_coins_m));
          //           if (Math.ceil(coins_reward - var_coins_m) <= 1) {
          //             Coin_text.setText(0);
          //           }
          //           game.add.tween(get_coin.scale).to({ x: 0.6, y: 0.6 }, 1000, Phaser.Easing.Linear.None, true);
          //           var tween = game.add.tween(get_coin).to({ x: coin_icon.world.x, y: coin_icon.world.y }, 1000, Phaser.Easing.Quadratic.Out, true);
          //           tween.onUpdateCallback(function () {
          //             star_emitter.x = get_coin.x;
          //             star_emitter.y = get_coin.y;
          //           }, this);
          //           game.add
          //             .tween(get_coin)
          //             .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
          //             .onComplete.add(function (item) {
          //               item.em.destroy();
          //               item.destroy();
          //               var_coins += coins_reward / 10;
          //               coins_text.setText(Math.ceil(coins_t + var_coins));
          //             });
          //         },
          //         this,
          //       );
          //       game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          //         game.add
          //           .tween(popup_group)
          //           .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
          //           .onComplete.add(function () {
          //             popup_group.removeAll(true);
          //             popup_group.alpha = 1;
          //             animation = 1;
          //             popup = 0;
          //             if (mayoroffer == 1) {
          //               mayor_offer(coins_reward);
          //             }
          //             else
          //               if (level >= 6) {
          //                 game_mission(0);
          //               } else {
          //                 get_popup(1);
          //               }
          //           });
          //       });
          //     });

          // }
        });
        popup_group.add(button_green_yes);
        scale_tween(button_green_yes, 500, 0.1, 0.1, -1);
        game.add.tween(button_green_yes).to({ y: '-1000' }, 500, Phaser.Easing.Exponential.Out, true);

        var Mini_Icon_Wheel = game.add.sprite(button_green_yes.width / 2 - 75, 0, 'mayor_reward_atlas', 'Mini_Icon_Wheel.png');
        Mini_Icon_Wheel.anchor.setTo(0.5);
        button_green_yes.addChild(Mini_Icon_Wheel);

        // Multiply earnings x10 Button
        var text_button_green = game.add.text(-46, -23, game.cache.getJSON('lang')['t595'][0][window.lang], {
          font: '22px RussoOne',
          fill: '#fff',
          align: 'center',
        });

        text_button_green.anchor.setTo(0.5);
        text_button_green.lineSpacing = -10;
        text_button_green.stroke = '#3C6C05';
        text_button_green.strokeThickness = 4;
        text_button_green.setShadow(0, 2, 'rgba(60,108,5,1)', 0);
        button_green_yes.addChild(text_button_green);

        var text_button_green = game.add.text(-46, 23, game.cache.getJSON('lang')['t596'][0][window.lang], {
          font: '38px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        text_button_green.anchor.setTo(0.5);
        text_button_green.lineSpacing = -10;
        text_button_green.stroke = '#3C6C05';
        text_button_green.strokeThickness = 4;
        text_button_green.setShadow(0, 2, 'rgba(60,108,5,1)', 0);
        button_green_yes.addChild(text_button_green);


        var uptext = game.cache.getJSON('lang')['t593'][0][window.lang];
        var uptext_w = 0;

        var uptext_parent = game.add.sprite(game.world.centerX, game.world.height - 230, '');
        uptext_parent.anchor.setTo(0.5);
        popup_group.add(uptext_parent);

        for (i = 0; i < uptext.length; i++) {
          var uptext_i = game.add.text(uptext_w, 0, uptext[i], {
            font: Number(80 + i * 10) + 'px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          uptext_i.anchor.setTo(0, 1);
          uptext_i.lineSpacing = -10;
          uptext_i.stroke = '#0D6895';
          uptext_i.strokeThickness = 20;
          uptext_i.setShadow(0, 2, 'rgba(60,108,5,1)', 0);
          uptext_parent.addChild(uptext_i);
          uptext_w += uptext_i.width - 10;
          uptext_i.scale.setTo(0);
          game.add.tween(uptext_i.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Elastic.Out, true, i * 100);
        }

        uptext_parent.x -= uptext_w / 2;

      }

      var timerId6 = 0;
      var mayoroffer = level >= 20 ? (game.rnd.integerInRange(0, 100) < 25 ? 1 : 0) : 0;
      function win_get_coins(coins_reward) {
        levels_played = 0;
        replayed = 0;
        if (sunflowerStage < 0) {
          sunflowerStage = 0;
          game.setUserDataAndLog({ sunflowerStage: sunflowerStage });
        }
        if (popup == 0) {
          if (sunflowerDate != 0 && baloon == 0 && xmas == 0) {
            if (sunflowerStage >= 2) {
              sunflowerStage_max = 6;
              sunflowerStage_old = sunflowerStage - 2;
              prize_n = 2;
            }
            if (sunflowerStage >= 8) {
              sunflowerStage_max = 12;
              sunflowerStage_old = sunflowerStage - 8;
              prize_n = 3;
            }
            var Liana = game.add.sprite(game.world.centerX - 750, -1000, 'sunflower_atlas', 'Liana.png');
            Liana.scale.setTo(1.4);
            Liana.anchor.setTo(0.5, 0);
            game.add.tween(Liana).to({ y: '+1000' }, 800, Phaser.Easing.Exponential.Out, true);
            popup_group.add(Liana);
            game.world.bringToTop(UI_Coins_BG);
            game.world.bringToTop(Safe_Icon);
            var Progress_Bar_Background = game.add.sprite(0, 175, 'sunflower_atlas', 'Progress_Bar_Background.png');
            Progress_Bar_Background.anchor.setTo(0.5);
            Liana.addChild(Progress_Bar_Background);
            var Progress_Bar = game.add.sprite(-103, -8, 'sunflower_atlas', 'Progress_Bar.png');
            Progress_Bar.anchor.setTo(0, 0.5);
            Progress_Bar_Background.addChild(Progress_Bar);
            var sunflower_gift_rays = game.add.sprite(
              Progress_Bar_Background.width / 2 - 8,
              -15,
              'sunflower_atlas',
              'RAYS.png',
            );
            sunflower_gift_rays.scale.setTo(0.2);
            sunflower_gift_rays.anchor.setTo(0.5);
            Progress_Bar_Background.addChild(sunflower_gift_rays);
            rotate_tween(sunflower_gift_rays);
            var sunflower_gift = game.add.sprite(
              Progress_Bar_Background.width / 2 - 8,
              -15,
              'sunflower_atlas',
              'GIFT' + prize_n + '.png',
            );
            sunflower_gift.scale.setTo(0.2);
            sunflower_gift.anchor.setTo(0.5);
            Progress_Bar_Background.addChild(sunflower_gift);
            var sunflower_gift_2 = game.add.sprite(0, -75, 'sunflower_atlas', 'LID' + prize_n + '.png');
            sunflower_gift_2.anchor.setTo(0.5);
            sunflower_gift.addChild(sunflower_gift_2);
            var sunflower_gift_3 = game.add.sprite(0, -40, 'sunflower_atlas', 'RIBBON' + prize_n + '.png');
            sunflower_gift_3.anchor.setTo(0.5);
            sunflower_gift_2.addChild(sunflower_gift_3);
            var sunflower_stage = game.add.text(0, -4, sunflowerStage_old + '/' + sunflowerStage_max, {
              font: '24px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            sunflower_stage.anchor.setTo(0.5);
            sunflower_stage.stroke = '#112056';
            sunflower_stage.strokeThickness = 4;
            Progress_Bar_Background.addChild(sunflower_stage);
            var width_step = Progress_Bar.width / sunflowerStage_max;
            let cropRect = new Phaser.Rectangle(0, 0, sunflowerStage_old * width_step, Progress_Bar.height);
            Progress_Bar.crop(cropRect);
            var Bean_Icon = game.add.sprite(0, 300, 'sunflower_atlas', 'Bean_Icon.png');
            Bean_Icon.scale.setTo(1.2);
            Bean_Icon.anchor.setTo(0.5);
            Liana.addChild(Bean_Icon);
            var Sunflower_Prize = game.add.sprite(0, 75, 'sunflower_atlas', 'Sunflower_Prize_' + prize_n + '.png');
            Sunflower_Prize.anchor.setTo(0.5, 1);
            Bean_Icon.addChild(Sunflower_Prize);
            sunflower_graphics = game.add.graphics(-70, 60);
            sunflower_graphics.beginFill(0x000000);
            sunflower_graphics.alpha = 0.5;
            sunflower_graphics.drawRoundedRect(0, 0, 140, 40, 100);
            Bean_Icon.addChild(sunflower_graphics);
            sunflower_timer = game.add.text(0, 82, '00:00:00', {
              font: '24px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            sunflower_timer.anchor.setTo(0.5);
            Bean_Icon.addChild(sunflower_timer);
            sunflowertimer();
            timerId6 = setInterval(function () {
              sunflowertimer();
            }, 1000);
          } else if (magicbeanDate != 0 && baloon == 0 && xmas == 0) {
            prize_n = 0;
            if (magicbeanStage >= 2) {
              magicbeanStage_max = 6;
              prize_n = 1;
            }
            if (magicbeanStage >= 6) {
              magicbeanStage_max = 12;
              prize_n = 2;
            }
            if (magicbeanStage >= 12) {
              magicbeanStage_max = 20;
              prize_n = 3;
            }
            if (magicbeanStage >= 20) {
              magicbeanStage_max = 20;
              prize_n = 4;
            }
            var Liana = game.add.sprite(game.world.centerX - 750, -1000, 'magicbean_atlas', 'Liana.png');
            Liana.scale.setTo(1.4);
            Liana.anchor.setTo(0.5, 0);
            game.add.tween(Liana).to({ y: '+1000' }, 800, Phaser.Easing.Exponential.Out, true);
            popup_group.add(Liana);
            game.world.bringToTop(UI_Coins_BG);
            game.world.bringToTop(Safe_Icon);
            var Progress_Bar_Background = game.add.sprite(0, 175, 'magicbean_atlas', 'Progress_Bar_Background.png');
            Progress_Bar_Background.anchor.setTo(0.5);
            Liana.addChild(Progress_Bar_Background);
            if (magicbeanStage >= 20) {
              Progress_Bar_Background.alpha = 0;
            }
            var Progress_Bar = game.add.sprite(-103, -8, 'magicbean_atlas', 'Progress_Bar.png');
            Progress_Bar.anchor.setTo(0, 0.5);
            Progress_Bar_Background.addChild(Progress_Bar);
            var sunflower_gift = game.add.sprite(Progress_Bar_Background.width / 2 - 8, -15, '');
            sunflower_gift.scale.setTo(0.2);
            sunflower_gift.anchor.setTo(0.5);
            Progress_Bar_Background.addChild(sunflower_gift);
            sunflower_gift.alpha = 0;
            var sunflower_stage = game.add.text(0, -4, magicbeanStage + '/' + magicbeanStage_max, {
              font: '24px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            sunflower_stage.anchor.setTo(0.5);
            sunflower_stage.stroke = '#112056';
            sunflower_stage.strokeThickness = 4;
            Progress_Bar_Background.addChild(sunflower_stage);
            var width_step = Progress_Bar.width / magicbeanStage_max;
            let cropRect = new Phaser.Rectangle(0, 0, magicbeanStage * width_step, Progress_Bar.height);
            Progress_Bar.crop(cropRect);
            var Bean_Icon = game.add.sprite(0, 300, 'magicbean_atlas', 'Bean_Icon.png');
            Bean_Icon.scale.setTo(1.2);
            Bean_Icon.anchor.setTo(0.5);
            Liana.addChild(Bean_Icon);
            var Sunflower_Prize = game.add.sprite(0, 72, 'magicbean_atlas', 'Bean_Prize_' + prize_n + '.png');
            Sunflower_Prize.anchor.setTo(0.5, 1);
            Bean_Icon.addChild(Sunflower_Prize);
            sunflower_graphics = game.add.graphics(-70, 60);
            sunflower_graphics.beginFill(0x000000);
            sunflower_graphics.alpha = 0.5;
            sunflower_graphics.drawRoundedRect(0, 0, 140, 40, 100);
            Bean_Icon.addChild(sunflower_graphics);
            magicbean_timer = game.add.text(0, 82, '00:00:00', {
              font: '24px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            magicbean_timer.anchor.setTo(0.5);
            Bean_Icon.addChild(magicbean_timer);
            timerId6 = setInterval(function () {
              magicbeantimer();
            }, 1000);
          }
          if (sound_on == 1) {
            play_sound('congratulations_jingle');
          }
          animation = 1;
          leader_group.x = 0;
          leader_group.y = 0;
          popup_group.y = 0;
          popup = 1;
          var Big_Star_Background = game.add.sprite(
            game.world.centerX,
            game.world.centerY - 100,
            'ingame_atlas',
            'Big_Star_Background.png',
          );
          Big_Star_Background.anchor.setTo(0.5);
          Big_Star_Background.scale.setTo(0);
          popup_group.add(Big_Star_Background);
          game.add.tween(Big_Star_Background.scale).to({ x: 1, y: 1 }, 800, Phaser.Easing.Bounce.Out, true);
          var Big_Star = game.add.sprite(0, -20, 'ingame_atlas', 'Big_Star.png');
          Big_Star.anchor.setTo(0.5);
          Big_Star_Background.addChild(Big_Star);
          var Blue_Ribbon = game.add.sprite(
            game.world.centerX,
            game.world.centerY + 100,
            'ingame_atlas',
            'Blue_Ribbon.png',
          );
          Blue_Ribbon.anchor.setTo(0.5);
          Blue_Ribbon.scale.setTo(0);
          popup_group.add(Blue_Ribbon);
          game.add.tween(Blue_Ribbon.scale).to({ x: 1, y: 1 }, 800, Phaser.Easing.Bounce.Out, true, 100);
          var Blue_Ribbon_text = game.add.text(0, -30, game.cache.getJSON('lang')['t299'][0][window.lang], {
            font: '48px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          Blue_Ribbon_text.anchor.setTo(0.5);
          Blue_Ribbon_text.setShadow(0, 4, 'rgba(0,0,0,0.7)', 10);
          Blue_Ribbon.addChild(Blue_Ribbon_text);

          var Coin_Number_Background = game.add.sprite(
            game.world.centerX - 15,
            game.world.centerY + 300,
            '',
          );
          Coin_Number_Background.anchor.setTo(0.5);
          popup_group.add(Coin_Number_Background);

          var Coin_Number_mask = game.add.graphics(0, 0);
          Coin_Number_mask.beginFill(0xffffff);
          Coin_Number_mask.drawRect(
            game.world.centerX - 70,
            game.world.centerY + 250,
            game.world.centerX + 100,
            game.world.centerY + 350,
          );
          popup_group.add(Coin_Number_mask);

          var Coin_Number_Background2 = game.add.sprite(
            - 385,
            0,
            'ingame_atlas',
            'Coin_Number_Background.png',
          );
          Coin_Number_Background2.mask = Coin_Number_mask;
          Coin_Number_Background2.anchor.setTo(0.5);
          Coin_Number_Background.addChild(Coin_Number_Background2);

          var Coin_back = game.add.sprite(0, 0, '');
          Coin_back.anchor.setTo(0.5);
          Coin_back.scale.setTo(0);
          Coin_Number_Background2.addChild(Coin_back);

          var Coin_Icon = game.add.sprite(0, -4, 'game_ui_atlas', 'Coin_Icon.png');
          Coin_Icon.anchor.setTo(0, 0.5);
          Coin_Icon.scale.setTo(0.5);
          Coin_back.addChild(Coin_Icon);

          var Coin_text = game.add.text(Coin_Icon.width + 10, 0, '0', { font: '42px RussoOne', fill: '#fff', align: 'center' });
          Coin_text.anchor.setTo(0, 0.5);
          Coin_text.setShadow(0, 4, 'rgba(0,0,0,0.7)', 10);
          Coin_back.addChild(Coin_text);

          Coin_Icon.x -= (Coin_Icon.width + 10 + Coin_text.width) / 2 + 15;
          Coin_text.x -= (Coin_Icon.width + 10 + Coin_text.width) / 2 + 15;

          var Safe_Icon3 = game.add.sprite(-100, -50, 'game_atlas', 'Pre-comp 7_00001.png');
          Safe_Icon3.anchor.setTo(0.5);
          Safe_Icon3.scale.setTo(2);
          Safe_Icon3.alpha = 0;

          var Safe_mas = [];
          for (var i = 1; i <= 27; i++) {
            let n = 0;
            if (i < 10) { n = '0' + i; } else { n = i; }
            Safe_mas.push('Pre-comp 7_000' + n + '.png');
          }
          Safe_Icon3.animations.add('Safe_Appearing',
            Safe_mas,
            16,
            false,
          );
          Coin_Number_Background.addChild(Safe_Icon3);

          if (xmas == 0)
            var Main_Excited = game.add.sprite(
              game.world.centerX + 1700,
              game.world.height,
              'char_atlas',
              'Main_Excited.png',
            );
          else
            var Main_Excited = game.add.sprite(
              game.world.centerX - 1700,
              game.world.height,
              'char_atlas',
              'Main_Excited_h.png',
            );
          Main_Excited.anchor.setTo(0.5, 1);
          if (xmas == 0) Main_Excited.scale.setTo(-3, 3);
          else Main_Excited.scale.setTo(3);
          popup_group.add(Main_Excited);
          game.add
            .tween(Main_Excited)
            .to({ x: xmas == 0 ? '-1000' : '+1000' }, 800, Phaser.Easing.Exponential.Out, true, 200);

          if (game.device.desktop)
            var tap_text = game.add.text(
              game.world.centerX,
              game.world.height - 50 + 300,
              game.cache.getJSON('lang')['t460'][0][window.lang],
              { font: '56px RussoOne', fill: '#fff', align: 'center' },
            );
          else
            var tap_text = game.add.text(
              game.world.centerX,
              game.world.height - 50 + 300,
              game.cache.getJSON('lang')['t250'][0][window.lang],
              { font: '56px RussoOne', fill: '#fff', align: 'center' },
            );
          tap_text.anchor.setTo(0.5);
          popup_group.add(tap_text);
          scale_tween(tap_text, 500, 0.1, 0.1, -1);
          game.add
            .tween(tap_text)
            .to({ y: '-300' }, 800, Phaser.Easing.Exponential.Out, true, 2500)
            .onComplete.add(function (item) {
              animation = 0;
              if (level < 7) {
                if (sound_on == 1) {
                  play_sound('hint_with_arrow');
                }
                FTUE_Arrow = game.add.sprite(
                  game.world.centerX,
                  game.world.height - 28,
                  'game_atlas',
                  'FTUE_Arrow.png',
                );
                FTUE_Arrow.anchor.setTo(0.5, 1.6);
                FTUE_Arrow.scale.setTo(0.6);
                FTUE_Arrow.alpha = 0;
                popup_group.add(FTUE_Arrow);
                game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                game.add
                  .tween(FTUE_Arrow.anchor)
                  .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                  .yoyo(true, 200);
              }
            });
          game.input.onDown.add(function () {
            if (animation == 999 && level_end_check == 0) {
              animation = 1;
              level_end_check = 1;
              game.add
                .tween(popup_group)
                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function () {
                  popup_group.removeAll(true);
                  popup_group.alpha = 1;
                  animation = 1;
                  popup = 0;
                  if (mayoroffer == 1) {
                    mayor_offer(coins_reward);
                  }
                  else
                    if (level >= 6) {
                      game_mission(0);
                    } else {
                      get_popup(1);
                    }
                });
            } else if (animation == 0 && missions_tab_back == 0) {



              if (FTUE_Arrow != 0) {
                FTUE_Arrow.destroy();
                FTUE_Arrow = 0;
              }
              if (level == 1) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_2_8_RewardClaimed_TappedToContinue');
                }
              } else if (level == 2) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_4_7_RewardClaimed_TappedToContinue');
                }
              } else if (level == 3) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_6_6_RewardClaimed_TappedToContinue');
                }
              } else if (level == 4) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_8_5_RewardClaimed_TappedToContinue');
                }
              } else if (level == 5) {
                if (fbv == 1) {
                  window.eventTrack('FTUE_10_4_RewardClaimed_TappedToContinue');
                }
              }
              animation = 1;

              if (mayoroffer != 1) {
                coins += coins_reward;
                game.setCurrentEvent();

                // quick fix for saving the currency after a level has been finished
                saveon = 1;
                game.setUserDataAndLog({ currencies: coins });
                window.eventTrack('coins_in', coins_reward, {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: coins_reward,
                  source: 'Win level',
                  package_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });

                // save collected coins
                game.setUserDataAndLog({ currencies: coins });

                var coins_t = coins - coins_reward;
                coins_text.setText(coins_t);
                var var_coins = 0;
                var var_coins_m = 0;
                if (sound_on == 1) {
                  play_sound('coins_add');
                }
                game.time.events.repeat(
                  100,
                  10,
                  function () {
                    var star_emitter = game.add.emitter(Coin_text.world.x, Coin_text.world.y, 100);
                    star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                    star_emitter.setAlpha(1, 0, 800);
                    star_emitter.setScale(3, 0, 3, 0, 800);
                    star_emitter.start(false, 1500, 10);
                    effects_group.add(star_emitter);
                    var get_coin = game.add.sprite(Coin_Icon.world.x, Coin_Icon.world.y, 'ingame_atlas', 'Coin.png');
                    get_coin.anchor.setTo(0.5);
                    get_coin.scale.setTo(0.4);
                    get_coin.alpha = 1;
                    get_coin.em = star_emitter;
                    effects_group.add(get_coin);
                    game.world.bringToTop(effects_group);
                    var_coins_m += coins_reward / 10;
                    Coin_text.setText(Math.ceil(coins_reward - var_coins_m));
                    if (Math.ceil(coins_reward - var_coins_m) <= 1) {
                      Coin_text.setText(0);
                    }
                    game.add.tween(get_coin.scale).to({ x: 0.6, y: 0.6 }, 1000, Phaser.Easing.Linear.None, true);
                    var tween = game.add.tween(get_coin).to({ x: coin_icon.world.x, y: coin_icon.world.y }, 1000, Phaser.Easing.Quadratic.Out, true);
                    tween.onUpdateCallback(function () {
                      star_emitter.x = get_coin.x;
                      star_emitter.y = get_coin.y;
                    }, this);
                    game.add
                      .tween(get_coin)
                      .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        item.em.destroy();
                        item.destroy();
                        var_coins += coins_reward / 10;
                        coins_text.setText(Math.ceil(coins_t + var_coins));
                      });
                  },
                  this,
                );
              }

              game.add.tween(effects_group).to({ alpha: 1 }, (mayoroffer != 1) ? 1500 : 500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                if (xmas == 1) {
                  game.add.tween(tap_text).to({ y: '+400' }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(shine_title.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(Big_Star_Background.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(Blue_Ribbon.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add
                    .tween(Coin_Number_Background)
                    .to({ y: '+1000' }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      var Next_Prize_Background = game.add.sprite(
                        game.world.width - 500,
                        400,
                        'xmas_atlas',
                        'Next_Prize_Background.png',
                      );
                      Next_Prize_Background.scale.setTo(0);
                      Next_Prize_Background.anchor.setTo(0.5);
                      popup_group.add(Next_Prize_Background);

                      let n_start = -1;
                      let n_end = 0;
                      var spr = 'Xmas_Prize_1.png';
                      if (xmas_level != 1) {
                        for (var i = xmas_level - 1; i < 45; i++) {
                          if (game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(',')[i] != 0) {
                            n_end = i;
                            if (i == 4) {
                              spr = 'Xmas_Prize_2.png';
                            } else if (i == 10) {
                              spr = 'Xmas_Prize_3.png';
                            } else if (i == 17) {
                              spr = 'Xmas_Prize_4.png';
                            } else if (i == 23) {
                              spr = 'Xmas_Prize_5.png';
                            } else if (i == 30) {
                              spr = 'Xmas_Prize_6.png';
                            } else if (i == 37) {
                              spr = 'Xmas_Prize_7.png';
                            } else if (i == 44) {
                              spr = 'Xmas_Prize_8.png';
                            }
                            break;
                          }
                        }

                        for (var i = xmas_level - 2; i >= 0; i--) {
                          if (game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(',')[i] != 0) {
                            n_start = i;
                            break;
                          }
                        }
                      }

                      var Next_Prize_image = game.add.sprite(0, -40, 'xmas_atlas', spr);
                      if (Next_Prize_image.width > Next_Prize_image.height) {
                        Next_Prize_image.scale.setTo(200 / Next_Prize_image.width);
                      } else {
                        Next_Prize_image.scale.setTo(200 / Next_Prize_image.height);
                      }
                      Next_Prize_image.anchor.setTo(0.5);
                      Next_Prize_Background.addChild(Next_Prize_image);

                      var Ribbon = game.add.sprite(28, -10, 'xmas_atlas', 'Ribbon.png');
                      Ribbon.anchor.setTo(1);
                      Next_Prize_Background.addChild(Ribbon);

                      var Ribbon_text = game.add.text(-98, -98, game.cache.getJSON('lang')['t509'][0][window.lang], { font: '20px RussoOne', fill: '#fff', align: 'center' });
                      Ribbon_text.lineSpacing = -10;
                      Ribbon_text.angle = -45;
                      Ribbon_text.anchor.setTo(0.5);
                      Ribbon.addChild(Ribbon_text);

                      var Next_Prize_Level_Bar = game.add.sprite(
                        -106,
                        120,
                        'xmas_atlas',
                        'Next_Prize_Level_Bar.png',
                      );
                      Next_Prize_Level_Bar.anchor.setTo(0, 0.5);
                      Next_Prize_Level_Bar.w = Next_Prize_Level_Bar.width;
                      Next_Prize_Background.addChild(Next_Prize_Level_Bar);

                      var Next_Prize_text = game.add.text(
                        0,
                        120,
                        Number(xmas_level - 1 - n_start) + '/' + Number(n_end - n_start),
                        { font: '26px RussoOne', fill: '#fff', align: 'center' },
                      );
                      Next_Prize_text.anchor.setTo(0.5);
                      Next_Prize_text.stroke = '#573344';
                      Next_Prize_text.strokeThickness = 4;
                      Next_Prize_text.setShadow(0, 2, 'rgba(87,51,68,0.9)', 0);
                      Next_Prize_Background.addChild(Next_Prize_text);

                      var Check = game.add.sprite(94, 120, 'xmas_atlas', 'Check.png');
                      Check.anchor.setTo(0.5);
                      Check.scale.setTo(0);
                      Next_Prize_Background.addChild(Check);

                      let cropRect = new Phaser.Rectangle(
                        0,
                        0,
                        (Next_Prize_Level_Bar.w / (n_end - n_start)) * (xmas_level - 2 - n_start),
                        Next_Prize_Level_Bar.height,
                      );
                      Next_Prize_Level_Bar.crop(cropRect);

                      game.add
                        .tween(Next_Prize_Background.scale)
                        .to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 0)
                        .onComplete.add(function () {
                          var tween = game.add
                            .tween(cropRect)
                            .to(
                              { width: (Next_Prize_Level_Bar.w / (n_end - n_start)) * (xmas_level - 1 - n_start) },
                              500,
                              Phaser.Easing.Linear.None,
                              true,
                            );
                          tween.onUpdateCallback(function () {
                            try {
                              Next_Prize_Level_Bar.crop(cropRect);
                            } catch (err) { }
                          }, this);

                          tween.onComplete.add(function () {
                            if (Number(xmas_level - 1 - n_start) == Number(n_end - n_start)) {
                              game.add.tween(Check.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true).onComplete.add(function () {
                                game.add.tween(Next_Prize_Background.scale).to({ x: '+0.05', y: '+0.05' }, 200, Phaser.Easing.Linear.None, true, 1).yoyo(true, 0);
                              });
                              add_shines(Next_Prize_Background, -1, 1);
                              add_shines(Next_Prize_Background, -1, 1);
                              add_shines(Next_Prize_Background, -1, 1);
                            }
                          })

                          var prize_1_Rays = game.add.sprite(game.world.centerX, game.world.centerY - 150, 'game_window2_atlas', 'Rays.png');
                          prize_1_Rays.anchor.setTo(0.5);
                          prize_1_Rays.scale.setTo(0);
                          popup_group.add(prize_1_Rays);
                          game.add
                            .tween(prize_1_Rays.scale)
                            .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                          rotate_tween(prize_1_Rays);

                          var prize_1 = game.add.sprite(
                            game.world.centerX,
                            game.world.centerY - 150,
                            'xmas_atlas',
                            'Ticket.png',
                          );
                          prize_1.scale.setTo(0);
                          prize_1.anchor.setTo(0.5);
                          popup_group.add(prize_1);
                          game.add.tween(prize_1.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                          var prize_1_text = game.add.text(
                            game.world.centerX,
                            game.world.centerY - 10,
                            'x' +
                            game.cache.getJSON('buildings')['XmasSetting'][0]['tickets'].split(',')[
                            xmas_level - 1
                            ],
                            { font: '58px RussoOne', fill: '#fff', align: 'center' },
                          );
                          prize_1_text.anchor.setTo(0.5);
                          prize_1_text.stroke = '#573344';
                          prize_1_text.strokeThickness = 6;
                          prize_1_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                          popup_group.add(prize_1_text);

                          xmas_ticket += Number(
                            game.cache.getJSON('buildings')['XmasSetting'][0]['tickets'].split(',')[
                            xmas_level - 1
                            ],
                          );

                          let prize_level = game.cache.getJSON('buildings')['XmasSetting'][0]['prizes'].split(',')[xmas_level - 1];
                          if (prize_level != 0) {
                            if (prize_level == 1) {
                              var prize_2_Rays = game.add.sprite(game.world.centerX - 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_2_Rays.anchor.setTo(0.5);
                              prize_2_Rays.scale.setTo(0);
                              popup_group.add(prize_2_Rays);
                              game.add
                                .tween(prize_2_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_2_Rays);
                              var prize_2 = game.add.sprite(
                                game.world.centerX - 200,
                                game.world.centerY + 50,
                                'game_window2_atlas',
                                'List_Coin.png',
                              );
                              prize_2.scale.setTo(0);
                              prize_2.anchor.setTo(0.5);
                              popup_group.add(prize_2);
                              game.add
                                .tween(prize_2.scale)
                                .to({ x: 2, y: 2 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_2_text = game.add.text(
                                game.world.centerX - 200,
                                game.world.centerY + 180,
                                'x100',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_2_text.anchor.setTo(0.5);
                              prize_2_text.stroke = '#573344';
                              prize_2_text.strokeThickness = 6;
                              prize_2_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_2_text);
                              coins += 100;

                              var prize_3_Rays = game.add.sprite(game.world.centerX + 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_3_Rays.anchor.setTo(0.5);
                              prize_3_Rays.scale.setTo(0);
                              popup_group.add(prize_3_Rays);
                              game.add
                                .tween(prize_3_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_3_Rays);
                              var prize_3 = game.add.sprite(
                                game.world.centerX + 200,
                                game.world.centerY + 50,
                                'game5_atlas',
                                '5_Cards.png',
                              );
                              prize_3.scale.setTo(0);
                              prize_3.anchor.setTo(0.5);
                              popup_group.add(prize_3);
                              game.add
                                .tween(prize_3.scale)
                                .to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_3_text = game.add.text(
                                game.world.centerX + 200,
                                game.world.centerY + 180,
                                'x1',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_3_text.anchor.setTo(0.5);
                              prize_3_text.stroke = '#573344';
                              prize_3_text.strokeThickness = 6;
                              prize_3_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_3_text);
                              if (free_five >= 0) { free_five += 1; } else { free_five -= 1; }
                            } else if (prize_level == 2) {
                              var prize_2_Rays = game.add.sprite(game.world.centerX - 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_2_Rays.anchor.setTo(0.5);
                              prize_2_Rays.scale.setTo(0);
                              popup_group.add(prize_2_Rays);
                              game.add
                                .tween(prize_2_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_2_Rays);
                              var prize_2 = game.add.sprite(
                                game.world.centerX - 200,
                                game.world.centerY + 50,
                                'game_window2_atlas',
                                'List_Coin.png',
                              );
                              prize_2.scale.setTo(0);
                              prize_2.anchor.setTo(0.5);
                              popup_group.add(prize_2);
                              game.add
                                .tween(prize_2.scale)
                                .to({ x: 2, y: 2 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_2_text = game.add.text(
                                game.world.centerX - 200,
                                game.world.centerY + 180,
                                'x200',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_2_text.anchor.setTo(0.5);
                              prize_2_text.stroke = '#573344';
                              prize_2_text.strokeThickness = 6;
                              prize_2_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_2_text);
                              coins += 200;
                              var prize_3_Rays = game.add.sprite(game.world.centerX + 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_3_Rays.anchor.setTo(0.5);
                              prize_3_Rays.scale.setTo(0);
                              popup_group.add(prize_3_Rays);
                              game.add
                                .tween(prize_3_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_3_Rays);
                              var prize_3 = game.add.sprite(
                                game.world.centerX + 200,
                                game.world.centerY + 50,
                                'game_atlas',
                                'Magnifier_Booster.png',
                              );
                              prize_3.scale.setTo(0);
                              prize_3.anchor.setTo(0.5);
                              popup_group.add(prize_3);
                              game.add
                                .tween(prize_3.scale)
                                .to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_3_text = game.add.text(
                                game.world.centerX + 200,
                                game.world.centerY + 180,
                                'x2',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_3_text.anchor.setTo(0.5);
                              prize_3_text.stroke = '#573344';
                              prize_3_text.strokeThickness = 6;
                              prize_3_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_3_text);
                              free_booster_spec += 2;
                            } else if (prize_level == 3) {
                              var prize_2_Rays = game.add.sprite(game.world.centerX - 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_2_Rays.anchor.setTo(0.5);
                              prize_2_Rays.scale.setTo(0);
                              popup_group.add(prize_2_Rays);
                              game.add
                                .tween(prize_2_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_2_Rays);
                              var prize_2 = game.add.sprite(
                                game.world.centerX - 200,
                                game.world.centerY + 50,
                                'game_window2_atlas',
                                'List_Joker.png',
                              );
                              prize_2.scale.setTo(0);
                              prize_2.anchor.setTo(0.5);
                              popup_group.add(prize_2);
                              game.add
                                .tween(prize_2.scale)
                                .to({ x: 2, y: 2 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_2_text = game.add.text(
                                game.world.centerX - 200,
                                game.world.centerY + 180,
                                'x1',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_2_text.anchor.setTo(0.5);
                              prize_2_text.stroke = '#573344';
                              prize_2_text.strokeThickness = 6;
                              prize_2_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_2_text);
                              free_joker += 1;
                              var prize_3_Rays = game.add.sprite(game.world.centerX + 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_3_Rays.anchor.setTo(0.5);
                              prize_3_Rays.scale.setTo(0);
                              popup_group.add(prize_3_Rays);
                              game.add
                                .tween(prize_3_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_3_Rays);
                              var prize_3 = game.add.sprite(
                                game.world.centerX + 200,
                                game.world.centerY + 50,
                                'game_atlas',
                                'bullseye_booster.png',
                              );
                              prize_3.scale.setTo(0);
                              prize_3.anchor.setTo(0.5);
                              popup_group.add(prize_3);
                              game.add
                                .tween(prize_3.scale)
                                .to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_3_text = game.add.text(
                                game.world.centerX + 200,
                                game.world.centerY + 180,
                                'x1',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_3_text.anchor.setTo(0.5);
                              prize_3_text.stroke = '#573344';
                              prize_3_text.strokeThickness = 6;
                              prize_3_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_3_text);
                              booster_eye_col += 1;
                            } else if (prize_level == 4) {
                              var prize_2_Rays = game.add.sprite(game.world.centerX - 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_2_Rays.anchor.setTo(0.5);
                              prize_2_Rays.scale.setTo(0);
                              popup_group.add(prize_2_Rays);
                              game.add
                                .tween(prize_2_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_2_Rays);
                              var prize_2 = game.add.sprite(
                                game.world.centerX - 200,
                                game.world.centerY + 50,
                                'game_window2_atlas',
                                'List_Joker.png',
                              );
                              prize_2.scale.setTo(0);
                              prize_2.anchor.setTo(0.5);
                              popup_group.add(prize_2);
                              game.add
                                .tween(prize_2.scale)
                                .to({ x: 2, y: 2 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_2_text = game.add.text(
                                game.world.centerX - 200,
                                game.world.centerY + 180,
                                'x1',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_2_text.anchor.setTo(0.5);
                              prize_2_text.stroke = '#573344';
                              prize_2_text.strokeThickness = 6;
                              prize_2_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_2_text);
                              free_joker += 1;
                              var prize_3_Rays = game.add.sprite(game.world.centerX + 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_3_Rays.anchor.setTo(0.5);
                              prize_3_Rays.scale.setTo(0);
                              popup_group.add(prize_3_Rays);
                              game.add
                                .tween(prize_3_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_3_Rays);
                              var prize_3 = game.add.sprite(
                                game.world.centerX + 200,
                                game.world.centerY + 50,
                                'game_atlas',
                                'shuffle_booster.png',
                              );
                              prize_3.scale.setTo(0);
                              prize_3.anchor.setTo(0.5);
                              popup_group.add(prize_3);
                              game.add
                                .tween(prize_3.scale)
                                .to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_3_text = game.add.text(
                                game.world.centerX + 200,
                                game.world.centerY + 180,
                                'x1',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_3_text.anchor.setTo(0.5);
                              prize_3_text.stroke = '#573344';
                              prize_3_text.strokeThickness = 6;
                              prize_3_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_3_text);
                              booster_shuffle_col += 1;
                            } else if (prize_level == 5) {
                              var prize_2_Rays = game.add.sprite(game.world.centerX - 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_2_Rays.anchor.setTo(0.5);
                              prize_2_Rays.scale.setTo(0);
                              popup_group.add(prize_2_Rays);
                              game.add
                                .tween(prize_2_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_2_Rays);
                              var prize_2 = game.add.sprite(
                                game.world.centerX - 200,
                                game.world.centerY + 50,
                                'game_atlas',
                                'tnt_booster.png',
                              );
                              prize_2.scale.setTo(0);
                              prize_2.anchor.setTo(0.5);
                              popup_group.add(prize_2);
                              game.add
                                .tween(prize_2.scale)
                                .to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_2_text = game.add.text(
                                game.world.centerX - 200,
                                game.world.centerY + 180,
                                'x1',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_2_text.anchor.setTo(0.5);
                              prize_2_text.stroke = '#573344';
                              prize_2_text.strokeThickness = 6;
                              prize_2_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_2_text);
                              booster_tnt_col += 1;
                              var prize_3_Rays = game.add.sprite(game.world.centerX + 200, game.world.centerY + 50, 'game_window2_atlas', 'Rays.png');
                              prize_3_Rays.anchor.setTo(0.5);
                              prize_3_Rays.scale.setTo(0);
                              popup_group.add(prize_3_Rays);
                              game.add
                                .tween(prize_3_Rays.scale)
                                .to({ x: 1.3, y: 1.3 }, 500, Phaser.Easing.Cubic.Out, true, 0);
                              rotate_tween(prize_3_Rays);
                              var prize_3 = game.add.sprite(
                                game.world.centerX + 200,
                                game.world.centerY + 50,
                                'game5_atlas',
                                '5_Cards.png',
                              );
                              prize_3.scale.setTo(0);
                              prize_3.anchor.setTo(0.5);
                              popup_group.add(prize_3);
                              game.add
                                .tween(prize_3.scale)
                                .to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true, 0);

                              var prize_3_text = game.add.text(
                                game.world.centerX + 200,
                                game.world.centerY + 180,
                                'x1',
                                { font: '58px RussoOne', fill: '#fff', align: 'center' },
                              );
                              prize_3_text.anchor.setTo(0.5);
                              prize_3_text.stroke = '#573344';
                              prize_3_text.strokeThickness = 6;
                              prize_3_text.setShadow(0, 4, 'rgba(87,51,68,0.9)', 0);
                              popup_group.add(prize_3_text);
                              if (free_five >= 0) { free_five += 1; } else { free_five -= 1; }
                            }
                          }
                          game.setUserDataAndLog({
                            currencies: coins,
                            lifes: lifes,
                            free_five: free_five,
                            free_joker: free_joker,
                            free_three: free_three,
                            free_cardback: free_cardback,
                            free_booster_spec: free_booster_spec,
                            booster_eye_col: booster_eye_col,
                            booster_tnt_col: booster_tnt_col,
                            booster_shuffle_col: booster_shuffle_col,
                            xmas_ticket: xmas_ticket,
                          });

                          if (game.device.desktop)
                            var tap_text = game.add.text(
                              game.world.centerX,
                              game.world.height - 50 + 300,
                              game.cache.getJSON('lang')['t460'][0][window.lang],
                              { font: '56px RussoOne', fill: '#fff', align: 'center' },
                            );
                          else
                            var tap_text = game.add.text(
                              game.world.centerX,
                              game.world.height - 50 + 300,
                              game.cache.getJSON('lang')['t250'][0][window.lang],
                              { font: '56px RussoOne', fill: '#fff', align: 'center' },
                            );
                          tap_text.anchor.setTo(0.5);
                          popup_group.add(tap_text);
                          scale_tween(tap_text, 500, 0.1, 0.1, -1);
                          game.add
                            .tween(tap_text)
                            .to({ y: '-300' }, 800, Phaser.Easing.Exponential.Out, true, 2500)
                            .onComplete.add(function () {
                              animation = 999;
                            });

                        });
                    });
                } else if (magicbeanDate != 0 && baloon == 0 && magicbeanStage < 20) {
                  game.add.tween(tap_text).to({ y: '+400' }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(shine_title.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(Big_Star_Background.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(Blue_Ribbon.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add
                    .tween(Coin_Number_Background)
                    .to({ y: '+1000' }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      let cropRect = new Phaser.Rectangle(0, 0, magicbeanStage * width_step, Progress_Bar.height);
                      magicbeanStage += 1;
                      game.setUserDataAndLog({ magicbeanStage: magicbeanStage });
                      var tween = game.add
                        .tween(cropRect)
                        .to({ width: magicbeanStage * width_step }, 900, Phaser.Easing.Linear.None, true);
                      tween.onUpdateCallback(function () {
                        try {
                          Progress_Bar.crop(cropRect);
                        } catch (err) { }
                      }, this);
                      tween.onComplete.add(function () {
                        sunflower_stage.setText(magicbeanStage + '/' + magicbeanStage_max);
                        if (
                          magicbeanStage == 2 ||
                          magicbeanStage == 6 ||
                          magicbeanStage == 12 ||
                          magicbeanStage == 20
                        ) {
                          if (magicbeanStage == 6) {
                            if (unlimited_lifesDate == 0) {
                              unlimited_lifesDate =
                                ddd == 0
                                  ? new Date()
                                  : new Date(
                                    ddd +
                                    ' ' +
                                    new Date().getHours() +
                                    ':' +
                                    new Date().getMinutes() +
                                    ':' +
                                    new Date().getSeconds(),
                                  );
                            }
                            var NowDate = ddd == 0 ? new Date() : new Date(ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
                            var timeDiff = magicbeanDate.getTime() - NowDate.getTime();
                            unlimited_lifesDate_old = timeDiff;
                            unlimited_lifesDate.setMilliseconds(unlimited_lifesDate.getMilliseconds() + unlimited_lifesDate_old);
                            if (Number(lifes) < max_lifes) {
                              lifes = Number(max_lifes);
                            }
                            LifeDate = 0;
                            game.setUserDataAndLog({
                              lifes: String(lifes),
                              life_time: String(LifeDate),
                              unlimited_lifesDate: String(unlimited_lifesDate),
                              unlimited_lifesDate_old: unlimited_lifesDate_old,
                            });
                          }
                          game.add
                            .tween(Sunflower_Prize.scale)
                            .to({ x: 0, y: 0 }, 500, Phaser.Easing.Cubic.In, true)
                            .onComplete.add(function () {
                              if (prize_n != 4) {
                                Sunflower_Prize.loadTexture(
                                  'magicbean_atlas',
                                  'Bean_Prize_' + Number(prize_n + 1) + '.png',
                                );
                              }
                              game.add
                                .tween(Sunflower_Prize.scale)
                                .to({ x: 1, y: 1 }, 1000, Phaser.Easing.Elastic.Out, true)
                                .onComplete.add(function () {
                                  var prize_icon = 'List_Cards';
                                  var prize_icon_a = 'game_window2_atlas';
                                  var prize_icon_s = 2;
                                  var prize_icon_text = game.cache.getJSON('lang')['t499'][0][window.lang];
                                  if (magicbeanStage == 6) {
                                    prize_icon = 'Energy';
                                    prize_icon_a = 'unlimited_energy_atlas';
                                    prize_icon_s = 1;
                                    prize_icon_text = game.cache.getJSON('lang')['UnlimitedEnergy'][0][window.lang];
                                  } else if (magicbeanStage == 12) {
                                    prize_icon = 'bullseye_asset';
                                    prize_icon_a = 'game_atlas';
                                    prize_icon_s = 1.5;
                                    prize_icon_text = game.cache.getJSON('lang')['t501'][0][window.lang];
                                  } else if (magicbeanStage == 20) {
                                    prize_icon = 'card101';
                                    prize_icon_a = 'game_atlas';
                                    prize_icon_s = 1;
                                    prize_icon_text = game.cache.getJSON('lang')['t500'][0][window.lang];
                                  }
                                  var prize_Rays = game.add.sprite(300, 300, 'game_window2_atlas', 'Rays.png');
                                  prize_Rays.anchor.setTo(0.5);
                                  prize_Rays.scale.setTo(0);
                                  Liana.addChild(prize_Rays);
                                  game.add
                                    .tween(prize_Rays.scale)
                                    .to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 500);
                                  rotate_tween(prize_Rays);
                                  var r1 = game.add.sprite(300, 300, prize_icon_a, prize_icon + '.png');
                                  r1.anchor.setTo(0.5);
                                  r1.scale.setTo(0);
                                  r1.alpha = 0;
                                  Liana.addChild(r1);
                                  var r1_text = game.add.text(600, 300, prize_icon_text, {
                                    font: '42px RussoOne',
                                    fill: '#fff',
                                    align: 'left',
                                    wordWrap: true,
                                    wordWrapWidth: 260,
                                  });
                                  r1_text.stroke = '#0686f2';
                                  r1_text.strokeThickness = 4;
                                  r1_text.setShadow(0, 5, 'rgba(6,134,242,0.7)', 1);
                                  r1_text.anchor.setTo(0, 0.5);
                                  r1_text.alpha = 0;
                                  Liana.addChild(r1_text);
                                  game.add
                                    .tween(r1.scale)
                                    .to(
                                      { x: prize_icon_s, y: prize_icon_s },
                                      500,
                                      Phaser.Easing.Linear.None,
                                      true,
                                      500,
                                    );
                                  game.add.tween(r1).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 500);
                                  game.add.tween(r1_text).to({ x: '-200' }, 500, Phaser.Easing.Cubic.Out, true, 1000);
                                  game.add
                                    .tween(r1_text)
                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000)
                                    .onComplete.add(function (item) {
                                      game.add
                                        .tween(prize_Rays.scale)
                                        .to({ x: 0, y: 0 }, 500, Phaser.Easing.Linear.None, true, 1000);
                                      game.add.tween(r1).to({ x: '-400' }, 500, Phaser.Easing.Cubic.In, true, 1000);
                                      game.add
                                        .tween(r1.scale)
                                        .to({ x: 0, y: 0 }, 500, Phaser.Easing.Linear.None, true, 1000);
                                      game.add
                                        .tween(r1_text)
                                        .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 1000)
                                        .onComplete.add(function (item) {
                                          game.add
                                            .tween(popup_group)
                                            .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                            .onComplete.add(function () {
                                              popup_group.removeAll(true);
                                              popup_group.alpha = 1;
                                              popup = 0;
                                              if (mayoroffer == 1) {
                                                mayor_offer(coins_reward);
                                              }
                                              else
                                                if (level >= 6) {
                                                  game_mission(0);
                                                } else {
                                                  get_popup(1);
                                                }
                                            });
                                        });
                                    });
                                });
                            });
                        } else {
                          game.add
                            .tween(popup_group)
                            .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 1000)
                            .onComplete.add(function () {
                              popup_group.removeAll(true);
                              popup_group.alpha = 1;
                              popup = 0;
                              if (mayoroffer == 1) {
                                mayor_offer(coins_reward);
                              }
                              else
                                if (level >= 6) {
                                  game_mission(0);
                                } else {
                                  get_popup(1);
                                }
                            });
                        }
                      });
                      game.time.events.repeat(
                        180,
                        5,
                        function () {
                          var star_emitter = game.add.emitter(
                            Bean_Icon.world.x + Bean_Icon.width / 2,
                            Bean_Icon.world.y,
                            100,
                          );
                          star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                          star_emitter.setAlpha(0.5, 0, 800);
                          star_emitter.setScale(1, 0, 1, 0, 800);
                          star_emitter.start(false, 900, 10);
                          var get_coin = game.add.sprite(
                            Bean_Icon.world.x + Bean_Icon.width / 2,
                            Bean_Icon.world.y,
                            'magicbean_atlas',
                            'SMALL_STAR.png',
                          );
                          get_coin.anchor.setTo(0.5);
                          get_coin.scale.setTo(game.rnd.realInRange(0.2, 0.4));
                          get_coin.em = star_emitter;
                          effects_group.add(get_coin);
                          game.world.bringToTop(effects_group);
                          var tween = game.add
                            .tween(get_coin)
                            .to(
                              {
                                x: [
                                  Bean_Icon.world.x + Bean_Icon.width / 2 + game.rnd.integerInRange(5, 25),
                                  Bean_Icon.world.x + Bean_Icon.width / 2 + 100 + game.rnd.integerInRange(5, 25),
                                  sunflower_gift.world.x + 100 + game.rnd.integerInRange(5, 25),
                                  sunflower_gift.world.x,
                                ],
                                y: [
                                  Bean_Icon.world.y + game.rnd.integerInRange(5, 25),
                                  Bean_Icon.world.y,
                                  sunflower_gift.world.y,
                                  sunflower_gift.world.y,
                                ],
                              },
                              900,
                              Phaser.Easing.Quadratic.Out,
                              true,
                              0,
                              -1,
                            )
                            .interpolation(function (v, k) {
                              return Phaser.Math.bezierInterpolation(v, k);
                            });
                          tween.onUpdateCallback(function () {
                            star_emitter.x = get_coin.x;
                            star_emitter.y = get_coin.y;
                          }, this);
                          game.add
                            .tween(sunflower_gift.scale)
                            .to({ x: '+0.02', y: '+0.02' }, 100, Phaser.Easing.Linear.None, true, 700, 1)
                            .yoyo(true, 0);
                          game.add
                            .tween(get_coin)
                            .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 500)
                            .onComplete.add(function (item) {
                              item.em.destroy();
                              item.destroy();
                            });
                        },
                        this,
                      );
                    });
                } else if (sunflowerDate != 0 && baloon == 0) {
                  game.add.tween(tap_text).to({ y: '+400' }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(shine_title.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(Big_Star_Background.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(Blue_Ribbon.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add
                    .tween(Coin_Number_Background)
                    .to({ y: '+1000' }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      let cropRect = new Phaser.Rectangle(0, 0, sunflowerStage_old * width_step, Progress_Bar.height);
                      sunflowerStage_old += 1;
                      sunflowerStage += 1;
                      game.setUserDataAndLog({ sunflowerStage: sunflowerStage });
                      var tween = game.add
                        .tween(cropRect)
                        .to({ width: sunflowerStage_old * width_step }, 900, Phaser.Easing.Linear.None, true);
                      tween.onUpdateCallback(function () {
                        try {
                          Progress_Bar.crop(cropRect);
                        } catch (err) { }
                      }, this);
                      tween.onComplete.add(function () {
                        sunflower_stage.setText(sunflowerStage_old + '/' + sunflowerStage_max);
                        if (sunflowerStage_old == sunflowerStage_max) {
                          game.add
                            .tween(Sunflower_Prize.scale)
                            .to({ x: 0, y: 0 }, 500, Phaser.Easing.Cubic.In, true)
                            .onComplete.add(function () {
                              Sunflower_Prize.loadTexture(
                                'sunflower_atlas',
                                'Sunflower_Prize_' + Number(prize_n + 1) + '.png',
                              );
                              add_shines(Bean_Icon, -1, 1);
                              add_shines(Bean_Icon, -1, 1);
                              add_shines(Bean_Icon, -1, 1);
                              game.add
                                .tween(Sunflower_Prize.scale)
                                .to({ x: 1, y: 1 }, 1000, Phaser.Easing.Elastic.Out, true)
                                .onComplete.add(function () {
                                  game.add
                                    .tween(sunflower_gift_rays)
                                    .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true);
                                  game.add
                                    .tween(sunflower_gift.scale)
                                    .to({ x: 0.8, y: 0.8 }, 800, Phaser.Easing.Linear.None, true);
                                  var tween = game.add
                                    .tween(sunflower_gift)
                                    .to(
                                      {
                                        x: [
                                          sunflower_gift.x,
                                          game.world.centerX - 200,
                                          game.world.centerX - 200,
                                          game.world.centerX + 50,
                                        ],
                                        y: [sunflower_gift.y, 550, 550, 420],
                                      },
                                      800,
                                      Phaser.Easing.Quadratic.Out,
                                      true,
                                    )
                                    .interpolation(function (v, k) {
                                      return Phaser.Math.bezierInterpolation(v, k);
                                    });
                                  tween.onComplete.add(function () {
                                    arc_text(
                                      game.cache.getJSON('lang')['Reward!'][0][window.lang],
                                      '100px',
                                      0,
                                      0,
                                      game.world.centerX + 500,
                                      game.world.centerY - 220,
                                      -8,
                                      1,
                                      0,
                                      0,
                                      50,
                                      popup_group,
                                    );
                                    var Mrs_Evergreen_excited = game.add.sprite(
                                      game.world.centerX - 450,
                                      game.world.height,
                                      'sunflower_atlas',
                                      'Grandma.png',
                                    );
                                    Mrs_Evergreen_excited.anchor.setTo(0.5, 1);
                                    Mrs_Evergreen_excited.scale.setTo(0);
                                    popup_group.add(Mrs_Evergreen_excited);
                                    game.add
                                      .tween(sunflower_gift.scale)
                                      .to({ x: '+0.05', y: '-0.05' }, 200, Phaser.Easing.Linear.None, true, 0, 4)
                                      .yoyo(true, 0);
                                    game.add
                                      .tween(Mrs_Evergreen_excited.scale)
                                      .to({ x: 1, y: 1 }, 1000, Phaser.Easing.Elastic.Out, true)
                                      .onComplete.add(function () {
                                        game.add
                                          .tween(sunflower_gift_2)
                                          .to({ angle: '+45' }, 400, Phaser.Easing.Linear.None, true, 600)
                                          .onComplete.add(function () {
                                            game.add
                                              .tween(sunflower_gift)
                                              .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                              .onComplete.add(function () {
                                                var bubble = game.add.sprite(
                                                  game.world.centerX - 450,
                                                  270,
                                                  'sunflower_atlas',
                                                  'bubble.png',
                                                );
                                                bubble.anchor.setTo(0.5);
                                                bubble.scale.setTo(0);
                                                popup_group.add(bubble);
                                                game.add
                                                  .tween(bubble.scale)
                                                  .to({ x: 1, y: 1 }, 800, Phaser.Easing.Elastic.Out, true);
                                                var bubble_text = game.add.text(
                                                  0,
                                                  -17,
                                                  game.cache.getJSON('lang')['t498'][0][window.lang],
                                                  { font: '42px RussoOne', fill: '#8E2E2D', align: 'center' },
                                                );
                                                bubble_text.anchor.setTo(0.5);
                                                bubble.addChild(bubble_text);
                                                if (sunflowerStage_max == 2) {
                                                  if (unlimited_lifesDate == 0) {
                                                    unlimited_lifesDate =
                                                      ddd == 0
                                                        ? new Date()
                                                        : new Date(
                                                          ddd +
                                                          ' ' +
                                                          new Date().getHours() +
                                                          ':' +
                                                          new Date().getMinutes() +
                                                          ':' +
                                                          new Date().getSeconds(),
                                                        );
                                                  }
                                                  unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() + 1);
                                                  if (Number(lifes) < max_lifes) {
                                                    lifes = Number(max_lifes);
                                                  }
                                                  LifeDate = 0;
                                                  coins += 100;
                                                  game.setUserDataAndLog({
                                                    life_time: String(LifeDate),
                                                    unlimited_lifesDate: String(unlimited_lifesDate),
                                                  });
                                                  var prize_Rays = game.add.sprite(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 30,
                                                    'sunflower_atlas',
                                                    'RAYS.png',
                                                  );
                                                  prize_Rays.anchor.setTo(0.5);
                                                  prize_Rays.alpha = 0;
                                                  popup_group.add(prize_Rays);
                                                  game.add
                                                    .tween(prize_Rays)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(prize_Rays.scale)
                                                    .to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Bounce.Out, true);
                                                  rotate_tween(prize_Rays);
                                                  var p1 = game.add.sprite(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 30,
                                                    'unlimited_energy_atlas',
                                                    'Energy.png',
                                                  );
                                                  p1.anchor.setTo(0.5);
                                                  popup_group.add(p1);
                                                  var p1_text = game.add.text(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 150,
                                                    '1h',
                                                    { font: '52px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                  p1_text.anchor.setTo(0.5);
                                                  popup_group.add(p1_text);
                                                  p1_text.setShadow(0, 5, 'rgba(8,103,148,1)', 10);
                                                  p1.alpha = 0;
                                                  p1_text.alpha = 0;
                                                  game.add
                                                    .tween(p1)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(p1_text)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  var prize_Rays = game.add.sprite(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 30,
                                                    'sunflower_atlas',
                                                    'RAYS.png',
                                                  );
                                                  prize_Rays.anchor.setTo(0.5);
                                                  prize_Rays.alpha = 0;
                                                  popup_group.add(prize_Rays);
                                                  game.add
                                                    .tween(prize_Rays)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(prize_Rays.scale)
                                                    .to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Bounce.Out, true);
                                                  rotate_tween(prize_Rays);
                                                  var p2 = game.add.sprite(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 30,
                                                    'game_window2_atlas',
                                                    'List_Coin.png',
                                                  );
                                                  p2.scale.setTo(2);
                                                  p2.anchor.setTo(0.5);
                                                  popup_group.add(p2);
                                                  var p2_text = game.add.text(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 150,
                                                    'х100',
                                                    { font: '42px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                  p2_text.anchor.setTo(0.5);
                                                  popup_group.add(p2_text);
                                                  p2_text.setShadow(0, 5, 'rgba(8,103,148,1)', 10);
                                                  p2.alpha = 0;
                                                  p2_text.alpha = 0;
                                                  game.add
                                                    .tween(p2)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(p2_text)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                } else if (sunflowerStage_max == 6) {
                                                  coins += 500;
                                                  lifes = Number(lifes) + 5;
                                                  game.setCurrentEvent();
                                                  window.eventTrack('booster_in', 1, {
                                                    user_type: bought,
                                                    lifetime: lifetime_day,
                                                    highest_lvl: all_level.lastIndexOf(3) + 2,
                                                    amount: 1,
                                                    source: 'Joker',
                                                    item_id: 0,
                                                    mission_completed: missioncompleted,
                                                    c_event: current_event,
                                                  });
                                                  free_joker += 1;
                                                  LifeDate = 0;
                                                  //                               if ((FTUE < 151 && all_level[5] > 0) || FTUE >= 151 || FTUE == 35 || dreset == 1)
                                                  //                                 app.transactions.set({
                                                  //                                   items: [
                                                  //                                     { type: Currency.Coins, amount: coins },
                                                  //                                     { type: Currency.Joker, amount: free_joker },
                                                  //                                     { type: Currency.Energy, amount: String(lifes) },
                                                  //                                   ],
                                                  //                                   // gameArea: DdnaGameArea.Level,
                                                  //                                   // actionType: DdnaTransactionActionType.LevelFinish,
                                                  //                                   gameArea: null,
                                                  // actionType: null,
                                                  //                                 });

                                                  game.setUserDataAndLog({
                                                    life_time: String(LifeDate),
                                                  });
                                                  var prize_Rays = game.add.sprite(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 30,
                                                    'sunflower_atlas',
                                                    'RAYS.png',
                                                  );
                                                  prize_Rays.anchor.setTo(0.5);
                                                  prize_Rays.alpha = 0;
                                                  popup_group.add(prize_Rays);
                                                  game.add
                                                    .tween(prize_Rays)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(prize_Rays.scale)
                                                    .to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Bounce.Out, true);
                                                  rotate_tween(prize_Rays);
                                                  var p1 = game.add.sprite(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 30,
                                                    'game_window2_atlas',
                                                    'List_Joker.png',
                                                  );
                                                  p1.scale.setTo(2);
                                                  p1.anchor.setTo(0.5);
                                                  popup_group.add(p1);
                                                  var p1_text = game.add.text(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 150,
                                                    'x1',
                                                    { font: '52px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                  p1_text.anchor.setTo(0.5);
                                                  popup_group.add(p1_text);
                                                  p1_text.setShadow(0, 5, 'rgba(8,103,148,1)', 10);
                                                  p1.alpha = 0;
                                                  p1_text.alpha = 0;
                                                  game.add
                                                    .tween(p1)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(p1_text)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  var prize_Rays = game.add.sprite(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 30,
                                                    'sunflower_atlas',
                                                    'RAYS.png',
                                                  );
                                                  prize_Rays.anchor.setTo(0.5);
                                                  prize_Rays.alpha = 0;
                                                  popup_group.add(prize_Rays);
                                                  game.add
                                                    .tween(prize_Rays)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(prize_Rays.scale)
                                                    .to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Bounce.Out, true);
                                                  rotate_tween(prize_Rays);
                                                  var p2 = game.add.sprite(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 30,
                                                    'game_window2_atlas',
                                                    'List_Coin.png',
                                                  );
                                                  p2.scale.setTo(2);
                                                  p2.anchor.setTo(0.5);
                                                  popup_group.add(p2);
                                                  var p2_text = game.add.text(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 150,
                                                    'х500',
                                                    { font: '52px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                  p2_text.anchor.setTo(0.5);
                                                  popup_group.add(p2_text);
                                                  p2_text.setShadow(0, 5, 'rgba(8,103,148,1)', 10);
                                                  p2.alpha = 0;
                                                  p2_text.alpha = 0;
                                                  game.add
                                                    .tween(p2)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(p2_text)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  var prize_Rays = game.add.sprite(
                                                    game.world.centerX + 190,
                                                    game.world.centerY + 290,
                                                    'sunflower_atlas',
                                                    'RAYS.png',
                                                  );
                                                  prize_Rays.anchor.setTo(0.5);
                                                  prize_Rays.alpha = 0;
                                                  popup_group.add(prize_Rays);
                                                  game.add
                                                    .tween(prize_Rays)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(prize_Rays.scale)
                                                    .to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Bounce.Out, true);
                                                  rotate_tween(prize_Rays);
                                                  var p2 = game.add.sprite(
                                                    game.world.centerX + 190,
                                                    game.world.centerY + 290,
                                                    'game_window2_atlas',
                                                    'List_Energy.png',
                                                  );
                                                  p2.scale.setTo(2);
                                                  p2.anchor.setTo(0.5);
                                                  popup_group.add(p2);
                                                  var p2_text = game.add.text(
                                                    game.world.centerX + 190,
                                                    game.world.centerY + 410,
                                                    'х5',
                                                    { font: '52px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                  p2_text.anchor.setTo(0.5);
                                                  p2_text.setShadow(0, 5, 'rgba(8,103,148,1)', 10);
                                                  popup_group.add(p2_text);
                                                  p2.alpha = 0;
                                                  p2_text.alpha = 0;
                                                  game.add
                                                    .tween(p2)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(p2_text)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                } else if (sunflowerStage_max == 12) {
                                                  coins += 1000;
                                                  lifes = Number(lifes) + 5;
                                                  game.setCurrentEvent();
                                                  window.eventTrack('booster_in', 3, {
                                                    user_type: bought,
                                                    lifetime: lifetime_day,
                                                    highest_lvl: all_level.lastIndexOf(3) + 2,
                                                    amount: 3,
                                                    source: 'Joker',
                                                    item_id: 0,
                                                    mission_completed: missioncompleted,
                                                    c_event: current_event,
                                                  });
                                                  free_joker += 3;
                                                  LifeDate = 0;
                                                  game.setCurrentEvent();
                                                  window.eventTrack('booster_in', 1, {
                                                    user_type: bought,
                                                    lifetime: lifetime_day,
                                                    highest_lvl: all_level.lastIndexOf(3) + 2,
                                                    amount: 1,
                                                    source: 'TNT',
                                                    item_id: 0,
                                                    mission_completed: missioncompleted,
                                                    c_event: current_event,
                                                  });
                                                  booster_tnt_col += 1;
                                                  sunflowerDate = 0;
                                                  sunflowerDate_new =
                                                    ddd == 0
                                                      ? new Date()
                                                      : new Date(
                                                        ddd +
                                                        ' ' +
                                                        new Date().getHours() +
                                                        ':' +
                                                        new Date().getMinutes() +
                                                        ':' +
                                                        new Date().getSeconds(),
                                                      );
                                                  sunflowerDate_new.setHours(sunflowerDate_new.getHours() + 120);
                                                  game.setUserDataAndLog({
                                                    life_time: String(LifeDate),
                                                    sunflowerDate: String(sunflowerDate),
                                                    sunflowerDate_new: String(sunflowerDate_new),
                                                  });
                                                  var prize_Rays = game.add.sprite(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 30,
                                                    'sunflower_atlas',
                                                    'RAYS.png',
                                                  );
                                                  prize_Rays.anchor.setTo(0.5);
                                                  prize_Rays.alpha = 0;
                                                  popup_group.add(prize_Rays);
                                                  game.add
                                                    .tween(prize_Rays)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(prize_Rays.scale)
                                                    .to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Bounce.Out, true);
                                                  rotate_tween(prize_Rays);
                                                  var p1 = game.add.sprite(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 30,
                                                    'game_window2_atlas',
                                                    'List_Joker.png',
                                                  );
                                                  p1.scale.setTo(2);
                                                  p1.anchor.setTo(0.5);
                                                  popup_group.add(p1);
                                                  var p1_text = game.add.text(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 150,
                                                    'x3',
                                                    { font: '52px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                  p1_text.anchor.setTo(0.5);
                                                  popup_group.add(p1_text);
                                                  p1_text.setShadow(0, 5, 'rgba(8,103,148,1)', 10);
                                                  p1.alpha = 0;
                                                  p1_text.alpha = 0;
                                                  game.add
                                                    .tween(p1)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(p1_text)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  var prize_Rays = game.add.sprite(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 30,
                                                    'sunflower_atlas',
                                                    'RAYS.png',
                                                  );
                                                  prize_Rays.anchor.setTo(0.5);
                                                  prize_Rays.alpha = 0;
                                                  popup_group.add(prize_Rays);
                                                  game.add
                                                    .tween(prize_Rays)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(prize_Rays.scale)
                                                    .to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Bounce.Out, true);
                                                  rotate_tween(prize_Rays);
                                                  var p2 = game.add.sprite(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 30,
                                                    'game_window2_atlas',
                                                    'List_Coin.png',
                                                  );
                                                  p2.scale.setTo(2);
                                                  p2.anchor.setTo(0.5);
                                                  popup_group.add(p2);
                                                  var p2_text = game.add.text(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 150,
                                                    'х1000',
                                                    { font: '52px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                  p2_text.anchor.setTo(0.5);
                                                  popup_group.add(p2_text);
                                                  p2_text.setShadow(0, 5, 'rgba(8,103,148,1)', 10);
                                                  p2.alpha = 0;
                                                  p2_text.alpha = 0;
                                                  game.add
                                                    .tween(p2)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(p2_text)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  var prize_Rays = game.add.sprite(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 290,
                                                    'sunflower_atlas',
                                                    'RAYS.png',
                                                  );
                                                  prize_Rays.anchor.setTo(0.5);
                                                  prize_Rays.alpha = 0;
                                                  popup_group.add(prize_Rays);
                                                  game.add
                                                    .tween(prize_Rays)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(prize_Rays.scale)
                                                    .to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Bounce.Out, true);
                                                  rotate_tween(prize_Rays);
                                                  var p2 = game.add.sprite(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 290,
                                                    'game_window2_atlas',
                                                    'List_Energy.png',
                                                  );
                                                  p2.scale.setTo(2);
                                                  p2.anchor.setTo(0.5);
                                                  popup_group.add(p2);
                                                  var p2_text = game.add.text(
                                                    game.world.centerX + 60,
                                                    game.world.centerY + 410,
                                                    'х5',
                                                    { font: '52px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                  p2_text.anchor.setTo(0.5);
                                                  popup_group.add(p2_text);
                                                  p2_text.setShadow(0, 5, 'rgba(8,103,148,1)', 10);
                                                  p2.alpha = 0;
                                                  p2_text.alpha = 0;
                                                  game.add
                                                    .tween(p2)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(p2_text)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  var prize_Rays = game.add.sprite(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 290,
                                                    'sunflower_atlas',
                                                    'RAYS.png',
                                                  );
                                                  prize_Rays.anchor.setTo(0.5);
                                                  prize_Rays.alpha = 0;
                                                  popup_group.add(prize_Rays);
                                                  game.add
                                                    .tween(prize_Rays)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(prize_Rays.scale)
                                                    .to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Bounce.Out, true);
                                                  rotate_tween(prize_Rays);
                                                  var p2 = game.add.sprite(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 290,
                                                    'game_atlas',
                                                    'tnt_booster.png',
                                                  );
                                                  p2.anchor.setTo(0.5);
                                                  popup_group.add(p2);
                                                  var p2_text = game.add.text(
                                                    game.world.centerX + 320,
                                                    game.world.centerY + 410,
                                                    'х1',
                                                    { font: '52px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                  p2_text.anchor.setTo(0.5);
                                                  popup_group.add(p2_text);
                                                  p2_text.setShadow(0, 5, 'rgba(8,103,148,1)', 10);
                                                  p2.alpha = 0;
                                                  p2_text.alpha = 0;
                                                  game.add
                                                    .tween(p2)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(p2_text)
                                                    .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                                                }
                                                animation = 999;

                                                if (game.device.desktop)
                                                  var tap_text = game.add.text(
                                                    game.world.centerX + 190,
                                                    game.world.height - 50 + 300,
                                                    game.cache.getJSON('lang')['t460'][0][window.lang],
                                                    { font: '56px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                else
                                                  var tap_text = game.add.text(
                                                    game.world.centerX + 190,
                                                    game.world.height - 50 + 300,
                                                    game.cache.getJSON('lang')['t250'][0][window.lang],
                                                    { font: '56px RussoOne', fill: '#fff', align: 'center' },
                                                  );
                                                tap_text.anchor.setTo(0.5);
                                                popup_group.add(tap_text);
                                                scale_tween(tap_text, 500, 0.1, 0.1, -1);
                                                game.add
                                                  .tween(tap_text)
                                                  .to({ y: '-300' }, 800, Phaser.Easing.Exponential.Out, true, 1000);
                                              });
                                          });
                                        game.add
                                          .tween(sunflower_gift_2)
                                          .to(
                                            {
                                              x: [
                                                sunflower_gift_2.x,
                                                sunflower_gift_2.x + 60,
                                                sunflower_gift_2.x + 60,
                                                sunflower_gift_2.x + 120,
                                              ],
                                              y: [
                                                sunflower_gift_2.y,
                                                sunflower_gift_2.y,
                                                sunflower_gift_2.y,
                                                sunflower_gift_2.y + 50,
                                              ],
                                            },
                                            400,
                                            Phaser.Easing.Quadratic.Out,
                                            true,
                                            600,
                                          )
                                          .interpolation(function (v, k) {
                                            return Phaser.Math.bezierInterpolation(v, k);
                                          });
                                      });
                                  });
                                });
                            });
                        } else {
                          game.add
                            .tween(popup_group)
                            .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true, 1000)
                            .onComplete.add(function () {
                              popup_group.removeAll(true);
                              popup_group.alpha = 1;
                              popup = 0;
                              if (mayoroffer == 1) {
                                mayor_offer(coins_reward);
                              }
                              else
                                if (level >= 6) {
                                  game_mission(0);
                                } else {
                                  get_popup(1);
                                }
                            });
                        }
                      });
                      game.time.events.repeat(
                        180,
                        5,
                        function () {
                          var star_emitter = game.add.emitter(
                            Bean_Icon.world.x + Bean_Icon.width / 2,
                            Bean_Icon.world.y,
                            100,
                          );
                          star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                          star_emitter.setAlpha(0.5, 0, 800);
                          star_emitter.setScale(1, 0, 1, 0, 800);
                          star_emitter.start(false, 900, 10);
                          var get_coin = game.add.sprite(
                            Bean_Icon.world.x + Bean_Icon.width / 2,
                            Bean_Icon.world.y,
                            'sunflower_atlas',
                            'SMALL_STAR.png',
                          );
                          get_coin.anchor.setTo(0.5);
                          get_coin.scale.setTo(game.rnd.realInRange(0.2, 0.4));
                          get_coin.em = star_emitter;
                          effects_group.add(get_coin);
                          game.world.bringToTop(effects_group);
                          var tween = game.add
                            .tween(get_coin)
                            .to(
                              {
                                x: [
                                  Bean_Icon.world.x + Bean_Icon.width / 2 + game.rnd.integerInRange(5, 25),
                                  Bean_Icon.world.x + Bean_Icon.width / 2 + 100 + game.rnd.integerInRange(5, 25),
                                  sunflower_gift.world.x + 100 + game.rnd.integerInRange(5, 25),
                                  sunflower_gift.world.x,
                                ],
                                y: [
                                  Bean_Icon.world.y + game.rnd.integerInRange(5, 25),
                                  Bean_Icon.world.y,
                                  sunflower_gift.world.y,
                                  sunflower_gift.world.y,
                                ],
                              },
                              900,
                              Phaser.Easing.Quadratic.Out,
                              true,
                              0,
                              -1,
                            )
                            .interpolation(function (v, k) {
                              return Phaser.Math.bezierInterpolation(v, k);
                            });
                          tween.onUpdateCallback(function () {
                            star_emitter.x = get_coin.x;
                            star_emitter.y = get_coin.y;
                          }, this);
                          game.add
                            .tween(sunflower_gift.scale)
                            .to({ x: '+0.02', y: '+0.02' }, 100, Phaser.Easing.Linear.None, true, 700, 1)
                            .yoyo(true, 0);
                          game.add
                            .tween(get_coin)
                            .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 500)
                            .onComplete.add(function (item) {
                              item.em.destroy();
                              item.destroy();
                            });
                        },
                        this,
                      );
                    });
                } else {
                  game.add.tween(tap_text).to({ y: '+400' }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(shine_title.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(Main_Excited).to({ x: '+1000' }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(Big_Star_Background.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add.tween(Blue_Ribbon.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Exponential.In, true);
                  game.add
                    .tween(Coin_Number_Background)
                    .to({ y: '+1000' }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      popup = 0;
                      if (mayoroffer == 1) {
                        mayor_offer(coins_reward);
                      }
                      else
                        if (level >= 6) {
                          if (baloon == 0) {
                            game_mission(0);
                          } else {
                            get_popup(1);
                          }
                        } else {
                          get_popup(1);
                        }
                    });
                }
              });
            }
          }, this);
          game.add
            .tween(Coin_Number_Background)
            .to({ alpha: 1 }, 800, Phaser.Easing.Exponential.Out, true)
            .onComplete.add(function (item) {
              var var_coins = 0;
              var var_coins_m = 0;
              game.time.events.repeat(
                100,
                10,
                function () {
                  var_coins += coins_reward / 10;
                  Coin_text.setText(Math.ceil(var_coins));
                },
                this,
              );
              game.add.tween(Safe_Icon).to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true);

              game.add.tween(Coin_Number_Background).to({ alpha: 1 }, 800, Phaser.Easing.Exponential.Out, true).onComplete.add(function () {
                Safe_Icon3.alpha = 1;
                Safe_Icon3.animations.play('Safe_Appearing');
                game.add.tween(Coin_Number_Background2).to({ x: '+440' }, 500, Phaser.Easing.Exponential.Out, true, 1000).onComplete.add(function () {
                  game.add.tween(Coin_back.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Bounce.Out, true);
                });
              });

              var Safe_Icon2 = game.add.sprite(game.world.centerX + 740, 70, 'game_atlas', 'Pre-comp 4_00000.png');
              Safe_Icon2.anchor.setTo(0.5);
              Safe_Icon2.scale.setTo(0.9);

              var Safe_mas = [];
              for (var i = 0; i <= 23; i++) {
                let n = 0;
                if (i < 10) { n = '0' + i; } else { n = i; }
                Safe_mas.push('Pre-comp 4_000' + n + '.png');
              }
              Safe_Icon2.animations.add('Safe_Disappearing',
                Safe_mas,
                10,
                false,
              );
              Safe_Icon2.animations.play('Safe_Disappearing');

            });
        }
      }
      function xmas_get_prize() {
        //alert('xmas!');
      }
      game.input.onUp.add(function () {
        if (w != 0 && popup != 2 && missions_tab_back != 0 && missions_tab_back != 1) {
          if (fbv == 1 && level == 6) {
            window.eventTrack('FTUE_2_8_RewardScreen_continue_clicked');
          }
          if (FTUE_Arrow != 0) {
            FTUE_Arrow.destroy();
            FTUE_Arrow = 0;
          }
          if (w != 0) {
            game.add
              .tween(w)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                if (item.obj != 0) {
                  item.obj.destroy();
                }
                item.destroy();
                animation = 0;
                popup = 0;
              });
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
          }
          w = 0;
        }
        if (level_end_check == 0 && animation == 0 && level_end_check2 == 0) {
          game.add
            .tween(popup_group)
            .to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true)
            .onComplete.add(function () {
              if (popup == 2 && missions_tab_back != 0 && missions_tab_back != 1) {
                popup = 1;
              } else if (popup != 2 && missions_tab_back != 0 && missions_tab_back != 1) {
                if (level_end_check2 == 0) {
                  popup = 2;
                  if (sound_on == 1) {
                    play_sound('button_X');
                  }
                  game.add
                    .tween(missions_tab_back)
                    .to({ y: '+' + game.world.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup = 0;
                      popup_group.y -= game.world.height;
                      missions_tab_back = 1;
                      if (result == 1) {
                        get_popup(1);
                      } else {
                        get_popup(2);
                      }
                    });
                }
              }
            });
        }
      });
      var prize_plus = 0;
      var shine_title = 0;

      // game win
      function congratulations() {
        blackf();
        game.world.bringToTop(UI_Coins_BG);
        game.world.bringToTop(Safe_Icon);
        if (sound_on == 1) {
          play_sound('Congratulations_Text_Music');
        }
        shine_title = game.add.sprite(
          game.world.centerX,
          game.world.centerY - 55,
          'ingame_atlas',
          'Background_Rays.png',
        );
        shine_title.scale.setTo(0);
        shine_title.anchor.setTo(0.5);
        game.add.tween(shine_title.scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Linear.None, true);
        rotate_tween(shine_title);
        var message_text1 = game.add.text(
          game.world.centerX,
          game.world.centerY - 150,
          game.cache.getJSON('lang')['Congratulations'][0][window.lang],
          { font: '74px RussoOne', fill: '#fff', align: 'center' },
        );
        message_text1.stroke = '#8B5A0A';
        message_text1.strokeThickness = 8;
        var grd = message_text1.context.createLinearGradient(0, 0, 0, message_text1.height);
        grd.addColorStop(0, '#FFE9AE');
        grd.addColorStop(1, '#FCB921');
        message_text1.fill = grd;
        message_text1.scale.setTo(0);
        message_text1.anchor.setTo(0.5);
        game.add.tween(message_text1.scale).to({ x: 1.1, y: 1.1 }, 600, Phaser.Easing.Linear.None, true);
        game.add
          .tween(message_text1)
          .to({ alpha: 1 }, 600, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) {
            game.add.tween(item.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
          });
        var message_text_c = game.add.text(
          game.world.centerX - 4,
          game.world.centerY - 40,
          game.cache.getJSON('lang')['YouWin'][0][window.lang],
          { font: '120px RussoOne', fill: '#F24B38', align: 'center' },
        );
        message_text_c.scale.setTo(0);
        message_text_c.anchor.setTo(0.5);
        var message_text2 = game.add.text(0, -10, game.cache.getJSON('lang')['YouWin'][0][window.lang], {
          font: '120px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        var grd = message_text2.context.createLinearGradient(0, 0, 0, message_text2.height);
        grd.addColorStop(0, '#FCFFFF');
        grd.addColorStop(1, '#9EEBFD');
        message_text2.fill = grd;
        message_text2.anchor.setTo(0.5);
        message_text2.setShadow(0, 5, 'rgba(147,32,189,1)', 0);
        message_text_c.addChild(message_text2);
        game.add.tween(message_text_c.scale).to({ x: 1.1, y: 1.1 }, 600, Phaser.Easing.Linear.None, true, 300);
        game.add
          .tween(message_text_c)
          .to({ alpha: 1 }, 600, Phaser.Easing.Linear.None, true, 300)
          .onComplete.add(function (item) {
            game.add.tween(item.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
          });
        game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          game.add.tween(message_text1.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Linear.None, true);
          game.add.tween(message_text1).to({ alpha: 1 }, 600, Phaser.Easing.Linear.None, true);
          game.add.tween(message_text_c.scale).to({ x: 0, y: 0 }, 500, Phaser.Easing.Linear.None, true, 100);
          game.add
            .tween(message_text_c)
            .to({ alpha: 1 }, 600, Phaser.Easing.Linear.None, true, 100)
            .onComplete.add(function (item) {
              popup = 0;
              win_get_coins(prize3 + prize_plus);
              prize_plus = 0;

              sdkHandler.trigger(
                'levelFinish',
                {
                  level: level,
                  score: all_stars,
                  state: 'win',
                  callback: function (error) { },
                },
                this,
              );
            });
        },
          this,
        );
      }

      var n_score_deck = 1;
      function game_win_score_deck(d) {
        game.add.tween(effects_group).to({ alpha: 1 }, 100, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          if (level == 1) {
            d = 0;
            if (fbv == 1) {
              window.eventTrack('FTUE_2_5_LevelOneCompleted');
            }
          }
          if (d > 0) {
            win_status = 0;
            d -= 1;
            if (sound_on == 1) {
              play_sound('remaining_card_0' + n_score_deck);
            }
            if (n_score_deck < 8) {
              n_score_deck++;
            } else {
              n_score_deck = 1;
            }
            var card_back = game.add.sprite(card_deck.x, card_deck.y, 'game5_atlas', backcards_select);
            card_back.scale.setTo(card_size, card_size);
            card_back.anchor.setTo(0.5, 0.5);
            game.add.tween(card_back).to({ alpha: 0 }, 150, Phaser.Easing.Linear.None, true);
            game.add
              .tween(card_back)
              .to({ y: '-200' }, 100, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                message(
                  '+' + 1 * combo,
                  item.x + game.rnd.integerInRange(-40, 40),
                  item.y + game.rnd.integerInRange(-40, 40),
                  10,
                );
                prize_plus += 1 * combo;
                Safe_Icon_text.setText(Number(Safe_Icon_text.text) + 1 * combo);
                combo += 1;
                deck_n += 1;
                if (d > 0) {
                  card_text.setText(d);
                  deck_change();
                  game_win_score_deck(d);
                } else {
                  congratulations();
                  deck_change();
                }
              });
            if (d <= 0) {
              card_deck.destroy();
              card_text.destroy();
            }
          } else {
            congratulations();
          }
        },
          this,
        );
      }
      var level_star = 0;
      var level_complete = 0;
      var setting_open = 0;

      window.game_win = function () {
        if (baloon == 1) {
          del_cards = all_cards - cards_group.length;
          //let cropRect = new Phaser.Rectangle(0, 0, (Level_Bar.w / all_cards) * del_cards, Level_Bar.height);
          //Level_Bar.crop(cropRect);
        }
        if (gwin == 0) {
          if (cards_group.length <= 0 && baloon == 1 && baloon_stage + 1 < level_mas.length) {
            baloon_level_select();
            game.add.tween(effects_group).to({ alpha: 1 }, 2200, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
              game.add.tween(bottom_game_group).to({ y: '+400' }, 500, Phaser.Easing.Linear.None, true);
              game.add.tween(top_game_group).to({ y: '-400' }, 500, Phaser.Easing.Linear.None, true);
              game.add.tween(booster_spec).to({ y: '-400' }, 500, Phaser.Easing.Linear.None, true);
              if (free_booster_spec > 0 || free_booster_spec < 0 || shop == 0) {
                game.add.tween(booster6_price_text).to({ y: '-400' }, 500, Phaser.Easing.Linear.None, true);
                game.add.tween(booster6_coin).to({ y: '-400' }, 500, Phaser.Easing.Linear.None, true);
              }
              bonus_cards_create();
            });
            gwin = 1;
          } else if (cards_group.length <= 0) {
            if (baloon == 1) {
              baloonlevel++;
              baloonDate = 0;
              baloonDate_new =
                ddd == 0
                  ? new Date()
                  : new Date(
                    ddd + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
                  );
              baloonDate_new.setHours(baloonDate_new.getHours() + 168);
              game.setUserDataAndLog({
                baloonlevel: baloonlevel,
                baloonDate: String(baloonDate),
                baloonDate_new: String(baloonDate_new),
              });
            } else if (xmas == 1) {
              xmas_level++;
              game.setUserDataAndLog({ xmas_level: xmas_level });
              xmas_level_win = 1;

              if (xmas_level >= 45) {
                xmasDate = -1;
                game.setUserDataAndLog({ xmasDate: String(xmasDate) });
              }

              if (Number(game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(",")[xmas_level - 1]) == 1) {
                mission_number.push("170");
                special_object.push(Number("17011"));
                map_tiled_st.push({ i: Number(170), s: Number(1) });
                var old_item = [2];
                var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(170)) }));
                if (typeof new_options[tp] !== 'undefined') {
                  old_item = new_options[tp]['num'];
                  old_item.push(2);
                  new_options.splice(tp, 1);
                }
                new_options.push({ type: 170, num: old_item });

                var old_item = [8];
                var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(15)) }));
                if (typeof new_options[tp] !== 'undefined') {
                  old_item = new_options[tp]['num'];
                  old_item.push(8);
                  new_options.splice(tp, 1);
                }
                new_options.push({ type: 15, num: old_item });

                var old_item = [8];
                var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(55)) }));
                if (typeof new_options[tp] !== 'undefined') {
                  old_item = new_options[tp]['num'];
                  old_item.push(8);
                  new_options.splice(tp, 1);
                }
                new_options.push({ type: 55, num: old_item });
              } else
                if (Number(game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(",")[xmas_level - 1]) == 2) {
                  mission_number.push("171");
                  special_object.push(Number("17111"));
                  map_tiled_st.push({ i: Number(171), s: Number(1) });
                  var old_item = [2];
                  var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(171)) }));
                  if (typeof new_options[tp] !== 'undefined') {
                    old_item = new_options[tp]['num'];
                    old_item.push(2);
                    new_options.splice(tp, 1);
                  }
                  new_options.push({ type: 171, num: old_item });
                } else
                  if (Number(game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(",")[xmas_level - 1]) == 3) {
                    mission_number.push("515");
                    special_object.push(Number("51511"));
                    map_tiled_st.push({ i: Number(515), s: Number(1) });
                    var old_item = [2];
                    var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(515)) }));
                    if (typeof new_options[tp] !== 'undefined') {
                      old_item = new_options[tp]['num'];
                      old_item.push(2);
                      new_options.splice(tp, 1);
                    }
                    new_options.push({ type: 515, num: old_item });

                    var old_item = [7];
                    var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(39)) }));
                    if (typeof new_options[tp] !== 'undefined') {
                      old_item = new_options[tp]['num'];
                      old_item.push(7);
                      new_options.splice(tp, 1);
                    }
                    new_options.push({ type: 39, num: old_item });
                  } else
                    if (Number(game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(",")[xmas_level - 1]) == 4) {
                      var old_item = [7];
                      var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(16)) }));
                      if (typeof new_options[tp] !== 'undefined') {
                        old_item = new_options[tp]['num'];
                        old_item.push(7);
                        new_options.splice(tp, 1);
                      }
                      new_options.push({ type: 16, num: old_item });

                      var old_item = [8];
                      var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(29)) }));
                      if (typeof new_options[tp] !== 'undefined') {
                        old_item = new_options[tp]['num'];
                        old_item.push(8);
                        new_options.splice(tp, 1);
                      }
                      new_options.push({ type: 29, num: old_item });

                      var old_item = [7];
                      var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(11)) }));
                      if (typeof new_options[tp] !== 'undefined') {
                        old_item = new_options[tp]['num'];
                        old_item.push(7);
                        new_options.splice(tp, 1);
                      }
                      new_options.push({ type: 11, num: old_item });

                      var old_item = [3];
                      var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(32)) }));
                      if (typeof new_options[tp] !== 'undefined') {
                        old_item = new_options[tp]['num'];
                        old_item.push(3);
                        new_options.splice(tp, 1);
                      }
                      new_options.push({ type: 32, num: old_item });

                      mission_number.push("172");
                      special_object.push(Number("17211"));
                      map_tiled_st.push({ i: Number(172), s: Number(1) });
                      var old_item = [2];
                      var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(172)) }));
                      if (typeof new_options[tp] !== 'undefined') {
                        old_item = new_options[tp]['num'];
                        old_item.push(2);
                        new_options.splice(tp, 1);
                      }
                      new_options.push({ type: 172, num: old_item });
                    } else
                      if (Number(game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(",")[xmas_level - 1]) == 5) {
                        var old_item = [7];
                        var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(53)) }));
                        if (typeof new_options[tp] !== 'undefined') {
                          old_item = new_options[tp]['num'];
                          old_item.push(7);
                          new_options.splice(tp, 1);
                        }
                        new_options.push({ type: 53, num: old_item });
                        var old_item = [7];
                        var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(109)) }));
                        if (typeof new_options[tp] !== 'undefined') {
                          old_item = new_options[tp]['num'];
                          old_item.push(7);
                          new_options.splice(tp, 1);
                        }
                        new_options.push({ type: 109, num: old_item });
                        var old_item = [7];
                        var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(58)) }));
                        if (typeof new_options[tp] !== 'undefined') {
                          old_item = new_options[tp]['num'];
                          old_item.push(7);
                          new_options.splice(tp, 1);
                        }
                        new_options.push({ type: 58, num: old_item });

                        mission_number.push("173");
                        special_object.push(Number("17311"));
                        map_tiled_st.push({ i: Number(173), s: Number(1) });
                        var old_item = [2];
                        var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(173)) }));
                        if (typeof new_options[tp] !== 'undefined') {
                          old_item = new_options[tp]['num'];
                          old_item.push(2);
                          new_options.splice(tp, 1);
                        }
                        new_options.push({ type: 173, num: old_item });
                      } else
                        if (Number(game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(",")[xmas_level - 1]) == 6) {
                          var old_item = [6];
                          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(106)) }));
                          if (typeof new_options[tp] !== 'undefined') {
                            old_item = new_options[tp]['num'];
                            old_item.push(6);
                            new_options.splice(tp, 1);
                          }
                          new_options.push({ type: 106, num: old_item });

                          mission_number.push("461");
                          special_object.push(Number("46111"));
                          map_tiled_st.push({ i: Number(461), s: Number(1) });
                          var old_item = [2];
                          var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(461)) }));
                          if (typeof new_options[tp] !== 'undefined') {
                            old_item = new_options[tp]['num'];
                            old_item.push(2);
                            new_options.splice(tp, 1);
                          }
                          new_options.push({ type: 461, num: old_item });
                        } else
                          if (Number(game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(",")[xmas_level - 1]) == 7) {
                            var old_item = [7];
                            var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(7)) }));
                            if (typeof new_options[tp] !== 'undefined') {
                              old_item = new_options[tp]['num'];
                              old_item.push(7);
                              new_options.splice(tp, 1);
                            }
                            new_options.push({ type: 7, num: old_item });

                            if (mission_number.indexOf("145") == -1) {
                              mission_number.push("145");
                              special_object.push(Number("14511"));
                              map_tiled_st.push({ i: Number(145), s: Number(1) });
                            }
                            var old_item = [3];
                            var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(145)) }));
                            if (typeof new_options[tp] !== 'undefined') {
                              old_item = new_options[tp]['num'];
                              old_item.push(3);
                              new_options.splice(tp, 1);
                            }
                            new_options.push({ type: 145, num: old_item });
                          } else
                            if (Number(game.cache.getJSON('buildings')['XmasSetting'][0]['items'].split(",")[xmas_level - 1]) == 8) {
                              mission_number.push("174");
                              special_object.push(Number("17411"));
                              map_tiled_st.push({ i: Number(174), s: Number(1) });
                              var old_item = [2];
                              var tp = new_options.findIndex((function (e) { return Math.abs(Number(e['type'])) == Math.abs(Number(174)) }));
                              if (typeof new_options[tp] !== 'undefined') {
                                old_item = new_options[tp]['num'];
                                old_item.push(2);
                                new_options.splice(tp, 1);
                              }
                              new_options.push({ type: 174, num: old_item });
                            }


              game.setUserDataAndLog({ mission_number: JSON.stringify(mission_number), special_object: JSON.stringify(special_object), map_tiled_st: JSON.stringify(map_tiled_st), new_options: JSON.stringify(new_options) });
            }
            result = 1;
            var level_num = String(level);
            while (level_num.length < 4) {
              level_num = String('0' + String(level_num));
            }
            if (fbv == 1) {
              game.setCurrentEvent();
              if (baloon == 1)
                window.eventTrack('level_end_balloon', 1, {
                  nr: baloonlevel,
                  pre_helper: pre_helper,
                  consumed_5cards_all: consumed_5cards_all,
                  consumed_5Cards: consumed_5Cards,
                  consumed_5Cards_x2: consumed_5Cards_x2,
                  consumed_5Cards_x3: consumed_5Cards_x3,
                  consumed_joker: consumed_joker,
                  consumed_TNT: consumed_TNT,
                  consumed_Shuffle: consumed_Shuffle,
                  consumed_backbutton: consumed_backbutton,
                  consumed_3Helpercards: consumed_3Helpercards,
                  moves_used: moves_used,
                  cards_left: cards_deck_col - 1 - deck_n,
                  p3_cards: p3_cards,
                  user_type: bought,
                  lifetime: lifetime_day,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
              else
                window.eventTrack('level_end', 1, {
                  nr: level_num,
                  pre_helper: pre_helper,
                  consumed_5cards_all: consumed_5cards_all,
                  consumed_5Cards: consumed_5Cards,
                  consumed_5Cards_x2: consumed_5Cards_x2,
                  consumed_5Cards_x3: consumed_5Cards_x3,
                  consumed_joker: consumed_joker,
                  consumed_TNT: consumed_TNT,
                  consumed_Shuffle: consumed_Shuffle,
                  consumed_backbutton: consumed_backbutton,
                  consumed_3Helpercards: consumed_3Helpercards,
                  moves_used: moves_used,
                  cards_left: cards_deck_col - 1 - deck_n,
                  p3_cards: p3_cards,
                  user_type: bought,
                  lifetime: lifetime_day,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
              function sumTo(n) {
                return (n * (n + 1)) / 2;
              }
              // app.ddna.missionTracker.trackMissionComplete({
              //   totalReward: prize3 + sumTo(cards_deck_col - 1 - deck_n),
              //   totalScore: 0,
              //   movesLeft: cards_deck_col - 1 - deck_n,
              //   levelScore: 0,
              //   stars: 0,
              // });
            }



            if (level == 2) {
              if (fbv == 1 && baloon != 1) {
                window.eventTrack('FTUE_4_5_LastCardClicked');
              }
            } else if (level == 3) {
              if (fbv == 1 && baloon != 1) {
                window.eventTrack('FTUE_6_4_LastCardClicked');
              }
            } else if (level == 4) {
              if (fbv == 1 && baloon != 1) {
                window.eventTrack('FTUE_8_3_LastCardClicked');
              }
            } else if (level == 5) {
              if (fbv == 1 && baloon != 1) {
                window.eventTrack('FTUE_10_3_LastCardClicked');
              }
            }
            emitter.width = 1280;
            emitter.bringToTop = true;
            emitter.minParticleSpeed.set(0, 100);
            emitter.maxParticleSpeed.set(0, 200);
            emitter.gravity = 100;
            emitter.x = game.world.centerX;
            emitter.y = 0;
            emitter.start(false, 6000, 100);
            emitter.blendMode = 0;
            emitter.setAlpha(1, 0, 5000);
            emitter.setScale(0.1, 1.4, 0.1, 1.4);
            emitter.maxParticleScale = 1.4;
            emitter.minParticleScale = 0.4;
            emitter.forEach(function (particle) {
              var a = game.rnd.integerInRange(1, 5);
              if (a == 1) particle.tint = 0xffff00;
              else if (a == 2) particle.tint = 0xff0000;
              else if (a == 3) particle.tint = 0x00ff00;
              else if (a == 4) particle.tint = 0x0000ff;
              else if (a == 5) particle.tint = 0x00ffff;
            });
            clearTimeout(TimerCheck);
            gwin = 1;
            animation = 1;
            level_complete = 1;
            if (setting_open == 1) {
              setting_open = 0;
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.world.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.world.height;
                });
            }
            var cdeck = cards_deck_col - 1 - deck_n;
            level_finish = level;
            if (baloon != 1 && xmas != 1) {
              all_level[level - 1] = 300;
              level_star = 3;
              all_stars += 1;
              if (FTUE > 30)
                for (var i = 0; i < missions.length; i += 4) {
                  if (missions[i] == -2) {
                    if (missions[i + 2] < missions[i + 1]) {
                      missions[i + 2] += 1;
                    }
                  }
                  if (missions[i] == -5) {
                    if (cdeck >= 5) {
                      if (missions[i + 2] < missions[i + 1]) {
                        missions[i + 2] += 1;
                      }
                    }
                  }
                }
              if (buildstart == 2) {
                buildstart = 3;
              }
              if (all_level_col != level) {
                if (all_level[level] == -1) {
                  all_level[level] = 0;
                }
              }
            }

            game.setUserDataAndLog({ level_star: JSON.stringify(all_level) });
            if (FTUE < 151) {
              game.saveDataAll();
            }
            combo = 1;
            if (level > 1) { win_status = 10000; }
            game_win_score_deck(cdeck);
          }
        }
      };

      var scaletween = 0;
      var card_add_n = 0;
      var card_add_s = [];
      var ftue_n = 0;
      var exactmatch = 0;
      function card_add() {
        var booster_pause = 10;
        if (level == 2 && joker_first == -2) {
          if (w != 0) {
            booster_pause = 600;
            if (FTUE_Arrow != 0) {
              FTUE_Arrow.destroy();
              FTUE_Arrow = 0;
            }
            game.add
              .tween(w)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                if (item.obj != 0) {
                  item.obj.destroy();
                }
                item.destroy();
                animation = 0;
                popup = 0;
              });
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            w = 0;
          }
        }
        game.add.tween(effects_group).to({ alpha: 1 }, booster_pause, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          if (level <= 7 && card_check(1) == 2) {
            if (FTUE_Arrow == 0) {
              let obj = card_check(2);
              if (sound_on == 1) {
                play_sound('hint_with_arrow');
              }
              FTUE_Arrow = game.add.sprite(0, 0, 'game_atlas', 'FTUE_Arrow.png');
              FTUE_Arrow.anchor.setTo(0.5, 1.6);
              FTUE_Arrow.alpha = 0;
              FTUE_Arrow.x = obj.x;
              FTUE_Arrow.y = obj.y;
              FTUE_Arrow.angle = obj.angle;
              game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
              game.add
                .tween(FTUE_Arrow.anchor)
                .to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1)
                .yoyo(true, 200);
            }
            animation = 1;
            game.add
              .tween(card_deck)
              .to({ angle: '+10' }, 40, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                game.add
                  .tween(item)
                  .to({ angle: '-10' }, 40, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(item)
                      .to({ angle: '+10' }, 40, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(item)
                          .to({ angle: '-10' }, 40, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            animation = 0;
                          });
                      });
                  });
              });
          } else if (animation == 0 && popup == 0 && cards_group.length > 0) {
            // app.ddna.missionTracker.onDeckCardOpened();
            moves_used += 1;
            if (level == 2) {
              if (fbv == 1) {
                window.eventTrack('FTUE_4_4_CardRefreshClicked');
              }
            }
            if (ftue_n == 0) {
              ftue_n = game.rnd.integerInRange(1, 2);
              if (FTUE >= 150) ftue_n = game.rnd.integerInRange(1, 3);
              if (level_max - level <= 100) ftue_n = game.rnd.integerInRange(1, 3);
              if (level_max - level < 50) ftue_n = game.rnd.integerInRange(1, 4);
            }
            clearTimeout(TimerCheck);
            card_check(1);
            if (sound_on == 1) {
              play_sound('Cardreserve');
            }
            booster4 = 0;
            animation = 1;
            streak_progress(0, 0);
            combo = 1;
            if (card_add_n >= 5 || FTUE < 150 || exactmatch == 1) {
              cards_group.children.forEach(function (element1) {
                if (element1.vis != 0) {
                  card_add_s.push(element1);
                }
              });
            }
            if (cards_deck[deck_n] == 0 || typeof cards_deck[deck_n] == 'undefined') {
              var carddeck;
              carddeck = game.rnd.integerInRange(1, 13);
              carddeck = get_random_change([carddeck, carddeck + 13, carddeck + 13 * 2, carddeck + 13 * 3]);
              cards_deck[deck_n] = carddeck;
            }
            if (log == 1) {
              if (card_add_n >= 5) {
                console.log('card_add_n: ', card_add_n, ' probability: ', ftue_n, ' (1 - success)');
              }
            }
            if (
              (card_add_n >= 5 && ftue_n == 1 && card_add_s.length > 0) ||
              (FTUE < 150 && ftue_n == 1 && card_add_s.length > 0) || (exactmatch == 1 && card_add_s.length > 0)
            ) {
              var carddeck = get_random_change(card_add_s).value + get_random_change([-1, 1]);
              if (carddeck < 1) {
                carddeck = 13;
              } else if (carddeck > 13) {
                carddeck = 1;
              }
              carddeck = get_random_change([carddeck, carddeck + 13, carddeck + 13 * 2, carddeck + 13 * 3]);
              cards_deck[deck_n] = carddeck;
              card_add_s = [];
              card_add_n = 1;
              if (log == 1) {
                console.log('сard received!');
              }
            } else {
              card_add_n++;
              if (log == 1) {
                console.log('card_add_n: ', card_add_n);
              }
            }
            if (FTUE < 150) {
              ftue_n -= 1;
            } else {
              ftue_n = 0;
            }
            if (level == 2) { cards_deck[deck_n] = 9; }
            console.log('deck_n', deck_n, level_joker.indexOf(deck_n));
            if (level_joker.indexOf(cards_deck_col - 1 - deck_n) != -1) { cards_deck[deck_n] = 1000; }
            var new_card = game.add.sprite(card_deck.x, card_deck.y, 'game5_atlas', backcards_select);
            new_card.scale.setTo(card_size);
            new_card.anchor.setTo(0.5, 0.5);
            new_card.cc = cards_deck[deck_n] == 1000 ? 'joker.png' : 'card' + cards_deck[deck_n] + '.png';
            new_card.oldvalue = cards_deck[deck_n] - 13 * (Math.ceil(cards_deck[deck_n] / 13) - 1);
            new_card.oldstart = start_card;
            new_card.olddraw = cards_deck[deck_n];
            new_card.indeck = 1;
            start_card_mas.push(new_card);
            start_card_mas2.push(new_card);
            if (baloon == 1) bottom_game_group.add(new_card);
            game.add.tween(new_card.scale).to({ x: 0, y: card_size + 0.2 }, 200, Phaser.Easing.Linear.None, true);
            game.add
              .tween(new_card)
              .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                item.loadTexture('game_atlas', item.cc, false);
                if (item.olddraw == 1000)
                  game.add.tween(item.scale).to({ x: card_size - 0.3, y: card_size - 0.3 }, 200, Phaser.Easing.Linear.None, true);
                else
                  game.add.tween(item.scale).to({ x: card_size, y: card_size }, 200, Phaser.Easing.Linear.None, true);

              });
            game.add
              .tween(new_card)
              .to({ x: card.x, y: card.y }, 400, Phaser.Easing.Linear.None, true)
              .onComplete.add(function (item) {
                animation = 0;
              }, this);
            if (level_joker.indexOf(cards_deck_col - 1 - deck_n) != -1) { start_card = 1000; level_joker.splice(level_joker.indexOf(cards_deck_col - 1 - deck_n), 1); start_card_mas = []; } else { start_card = cards_deck[deck_n] - 13 * (Math.ceil(cards_deck[deck_n] / 13) - 1); }
            deck_n += 1;
            card_text.setText(cards_deck_col - 1 - deck_n);
            deck_change();
            if (scaletween == 0)
              if (cards_deck_col - 1 - deck_n < 10) {
                scaletween = 1;
                scale_tween_deck(card_text, 500, 0.3, 0.3, -1);
              }
            deck_change();
            game.world.bringToTop(new_card);
            if (deck_n >= cards_deck_col - 1) {
              scaletween = 0;
              card_deck.destroy();
              card_text.destroy();
              ingameHelp_group.removeAll(true);
              clearInterval(friend_avatar_time);
              game_loss();
            } else if (cards_deck_col - 1 - deck_n == 3 && context2_name != -1 && fbv == 1) {
              ingameHelp();
            }


            if (level > 1 && level < 9) {
              var check = 1;
              cards_group.children.forEach(function (element1) {
                if (check != 2) {
                  check = 1;
                  cards_group.children.forEach(function (element2) {
                    if (element1.vis != 0) {
                      var points1 = getPoints1(element1);
                      var points2 = getPoints2(element2);
                      if (polygonPolygon(points1, points2) == true && element1.depth < element2.depth) {
                        check = 0;
                      }
                    } else {
                      check = 0;
                    }
                  });
                  if (check == 1) {
                    if (
                      element1.value != 101 &&
                      element1.value != 102 &&
                      element1.value != 104 &&
                      element1.hazard_type != 2 &&
                      element1.hazard_type != 7 &&
                      element1.hazard_type != 9 &&
                      (element1.hazard_type != 10 || (element1.hazard_type == 10 && element1.std != 3))
                    ) {
                      if (
                        element1.value == start_card + 1 ||
                        element1.value == start_card - 1 ||
                        (start_card == 13 && element1.value == 1) ||
                        (start_card == 1 && element1.value == 13) ||
                        start_card == 1000 ||
                        element1.value == 101 ||
                        element1.value == 102
                      ) {
                        check = 2;
                        if (FTUE_Arrow != 0) {
                          FTUE_Arrow.destroy();
                          FTUE_Arrow = 0;
                        }
                      }
                    }
                  }
                }
              });
            }
            fogCheck();
          }
        });
      }
      function booster_active(item) {
        var booster_pause = 10;
        if ((level == 6 && item.b == 3 && joker_first == -1) || (free_booster_spec < 0 && item.b == 6) || item.b == 4) {
          if (item.b != 4) { joker_first = -2; }
          if (w != 0) {
            if (FTUE_Arrow != 0) {
              FTUE_Arrow.destroy();
              FTUE_Arrow = 0;
            }
            booster_pause = 600;
            game.add
              .tween(w)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                if (item.obj != 0) {
                  item.obj.destroy();
                }
                item.destroy();
                animation = 0;
                popup = 0;
              });
            game.add
              .tween(black_sprite)
              .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
              .onComplete.add(function (item) {
                item.destroy();
              });
            w = 0;
          }
        }
        game.add.tween(effects_group).to({ alpha: 1 }, booster_pause, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
          if (
            (animation == 0 && popup == 0 && cards_group.length > 0) ||
            (joker_first == -1 && level == 6) ||
            (free_booster_spec < 0 && item.b == 6) || (item.b == 4)
          ) {
            if (item.b == 6 && first_click < 12) {
              game.setCurrentEvent();
              window.eventTrack('booster_out', 1, {
                user_type: bought,
                lifetime: lifetime_day,
                highest_lvl: all_level.lastIndexOf(3) + 2,
                amount: 1,
                source: 'Magnifier',
                item_id: 0,
                mission_completed: missioncompleted,
                c_event: current_event,
              });
              animation = 1;
              if (free_booster_spec > 0 || free_booster_spec < 0 || (coins >= booster_spec_price && shop == 0)) {

                if (FTUE > 30)
                  for (var i = 0; i < missions.length; i += 4) {
                    if (missions[i] == -20) {
                      if (missions[i + 2] < missions[i + 1]) {
                        missions[i + 2] += 1;
                      }
                    }
                  }

                if (sound_on == 1) {
                  play_sound('Booster_Joker_Use');
                }
                let bonuscard = -1;
                while (bonuscard == -1) {
                  bonuscard = cards_group.getRandom();
                  if (bonuscard.frameName != 'Back.png') bonuscard = -1;
                }
                let spr = 0;
                if (bonuscard.value == 0) {
                  spr = 'Bomb';
                } else if (bonuscard.value == 2) {
                  spr = 'Energy';
                } else if (bonuscard.value == 3) {
                  spr = 'Joker';
                } else if (bonuscard.value == 4) {
                  spr = 'Extra_Card';
                } else if (bonuscard.value == 5) {
                  spr = 'Undo';
                } else if (bonuscard.value == 6) {
                  spr = 'TNT';
                } else if (bonuscard.value == 7) {
                  spr = 'Shuffle';
                } else if (bonuscard.value == 50) {
                  spr = '50_Coins';
                } else if (bonuscard.value == 100) {
                  spr = '100_Coins';
                } else if (bonuscard.value == 250) {
                  spr = '250_Coins';
                } else if (bonuscard.value == 500) {
                  spr = '500_Coins';
                } else if (bonuscard.value == 1000) {
                  spr = '1000_Coins';
                } else if (bonuscard.value == 2000) {
                  spr = '2000_Coins';
                }
                var bonuscard3 = game.add.sprite(0, 0, 'baloon_atlas', spr + '.png');
                bonuscard3.anchor.setTo(0.5);
                bonuscard.addChild(bonuscard3);
                var bcard_mask_2 = game.add.graphics(0, 0);
                bcard_mask_2.beginFill(0xffffff);
                bcard_mask_2.drawRect(
                  bonuscard.x1 - bonuscard.width / 2 + 4,
                  bonuscard.y1 - bonuscard.height / 2 + 4,
                  bonuscard.width - 8,
                  bonuscard.height - 12,
                );
                var bcard_effect_2 = game.add.graphics(-30, -230);
                bcard_effect_2.beginFill(0xffffff);
                bcard_effect_2.drawRect(0, -20, 50, bonuscard.height + 45);
                bcard_effect_2.angle = 45;
                bcard_effect_2.mask = bcard_mask_2;
                bcard_effect_2.alpha = 0.9;
                bonuscard.addChild(bcard_effect_2);
                var bonuscard2 = game.add.sprite(0, 0, 'baloon_atlas', 'Back.png');
                bonuscard2.anchor.setTo(0.5);
                bonuscard.addChild(bonuscard2);
                var GunShot = game.add.sprite(0, 0, 'baloon_atlas', 'GunShot 05_00001.png');
                GunShot.anchor.setTo(0.5);
                GunShot.alpha = 0;
                bonuscard.addChild(GunShot);
                GunShot.animations.add(
                  'GunShot',
                  ['GunShot 05_00001.png', 'GunShot 05_00002.png', 'GunShot 05_00003.png', 'GunShot 05_00004.png'],
                  14,
                  false,
                );
                var Magnifier = game.add.sprite(booster_spec.x, booster_spec.y, 'baloon_atlas', 'Magnifier.png');
                Magnifier.anchor.setTo(0.35);
                game.add
                  .tween(Magnifier)
                  .to({ x: bonuscard.x, y: bonuscard.y }, 1000, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function () {
                    first_click++;
                    bonuscard.loadTexture('baloon_atlas', spr + '_g.png');
                    game.add
                      .tween(Magnifier.scale)
                      .to({ x: '-0.1', y: '-0.1' }, 500, Phaser.Easing.Exponential.InOut, true)
                      .yoyo(true, 0);
                    game.add.tween(Magnifier).to({ alpha: 0 }, 0, Phaser.Easing.Linear.None, true, 1000);
                    game.add
                      .tween(GunShot)
                      .to({ alpha: 1 }, 100, Phaser.Easing.Linear.None, true, 300)
                      .onComplete.add(function () {
                        GunShot.animations.play('GunShot');
                      });
                    game.add
                      .tween(bonuscard.scale)
                      .to({ x: '+0.1', y: '+0.1' }, 500, Phaser.Easing.Linear.None, true, 900)
                      .yoyo(true, 0);
                    game.add
                      .tween(bonuscard2)
                      .to({ alpha: 1 }, 900, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item2) {
                        GunShot.destroy();
                        item2.destroy();
                        var bonuscard2_t = game.add.sprite(0, 0, 'baloon_atlas', 'Back_effect1.png');
                        bonuscard2_t.anchor.setTo(0.5);
                        bonuscard2_t.mask = bcard_mask_2;
                        bonuscard.addChild(bonuscard2_t);
                        game.add
                          .tween(bonuscard2_t)
                          .to({ x: '-50', y: '+200' }, 500, Phaser.Easing.Cubic.In, true)
                          .onComplete.add(function () {
                            game.add
                              .tween(bonuscard3)
                              .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                              .onComplete.add(function () {
                                game.add
                                  .tween(bcard_effect_2)
                                  .to({ x: '+200', y: '+240' }, 500, Phaser.Easing.Linear.None, true)
                                  .onComplete.add(function (item3) {
                                    item3.destroy();
                                    bonuscard2_t.destroy();
                                    bonuscard2_d.destroy();
                                    bcard_mask_2.destroy();
                                    animation = 0;
                                  });
                              });
                          });
                        var bonuscard2_d = game.add.sprite(0, 0, 'baloon_atlas', 'Back_effect2.png');
                        bonuscard2_d.anchor.setTo(0.5);
                        bonuscard2_d.mask = bcard_mask_2;
                        bonuscard.addChild(bonuscard2_d);
                        game.add.tween(bonuscard2_d).to({ x: '+50', y: '-200' }, 500, Phaser.Easing.Cubic.In, true);
                      });
                  });
                if (free_booster_spec < 0) {
                  free_booster_spec *= -1;
                }
                if (free_booster_spec <= 0) {
                  coins -= booster_spec_price;
                  game.setCurrentEvent();
                  window.eventTrack('coins_out', booster_spec_price, {
                    user_type: bought,
                    lifetime: lifetime_day,
                    highest_lvl: all_level.lastIndexOf(3) + 2,
                    amount: booster_spec_price,
                    source: 'Buy magnifier',
                    item_id: 0,
                    mission_completed: missioncompleted,
                    c_event: current_event,
                  });

                  coins_text.setText(coins);
                  booster_spec_price *= 2;
                  special_stat();
                } else {
                  free_booster_spec -= 1;
                  game.setUserDataAndLog({ free_booster_spec: free_booster_spec });
                  special_stat();
                }
              } else {
                animation = 0;
                if (shop == 1) {
                  shop_window(
                    1,
                    0,
                    600,
                    [
                      { 0: { type: 'magnifying_glass.png', col: '30x', atlas: 'farm_obj_atlas' } },
                      { 1: { type: 'Big_Kit_List_Coin.png', col: '2 000', atlas: 'game_window_atlas' } },
                      { 2: { type: 'List_Joker.png', col: '1x', atlas: 'game_window2_atlas' } },
                      { 3: { type: 'List_Cards.png', col: '3x', atlas: 'game_window2_atlas' } },
                      {
                        4: {
                          id: 'magnifier_ingame_pack',
                          packname: 'Magnifier Package',
                          price: '7.99 $',
                          reward: [2000, 0, 1, 3, 0, 0, 0, 0, 30],
                        },
                      },
                    ],
                    [
                      {
                        0: {
                          type: '3_Magnifier_Pack.png',
                          sprite: '3_Magnifier_Pack.png',
                          col: '3x',
                          id: 'magnifier_ingame_1',
                          packname: '3x Magnifiers',
                          price: '1.99 $',
                          atlas: 'baloon_atlas',
                          reward: [0, 0, 0, 0, 0, 0, 0, 0, 3],
                        },
                      },
                      {
                        1: {
                          type: '10_Magnifier_Pack.png',
                          sprite: '10_Magnifier_Pack.png',
                          col: '10x',
                          id: 'magnifier_ingame_2',
                          packname: '10x Magnifiers',
                          price: '3.99 $',
                          atlas: 'baloon_atlas',
                          reward: [0, 0, 0, 0, 0, 0, 0, 0, 10],
                        },
                      },
                      {
                        2: {
                          type: '20_Magnifier_Pack.png',
                          sprite: '20_Magnifier_Pack.png',
                          col: '20x',
                          id: 'magnifier_ingame_3',
                          packname: '20x Magnifiers',
                          price: '5.99 $',
                          atlas: 'baloon_atlas',
                          reward: [0, 0, 0, 0, 0, 0, 0, 0, 20],
                        },
                      },
                      { 3: { type: 0, sprite: 0, col: 0, id: 0, packname: 0, price: 0, atlas: 'game_atlas' } },
                    ],
                  );
                } else if (shop == 0) {
                  get_message(2);
                }
              }
            } else if (item.b == 3) {
              game.setCurrentEvent();
              window.eventTrack('booster_out', 1, {
                user_type: bought,
                lifetime: lifetime_day,
                highest_lvl: all_level.lastIndexOf(3) + 2,
                amount: 1,
                source: 'Joker',
                item_id: 0,
                mission_completed: missioncompleted,
                c_event: current_event,
              });
              if (start_card != 1000)
                if (free_joker > 0 || (coins >= booster3_price && shop == 0)) {

                  if (FTUE > 30)
                    for (var i = 0; i < missions.length; i += 4) {
                      if (missions[i] == -17) {
                        if (missions[i + 2] < missions[i + 1]) {
                          missions[i + 2] += 1;
                        }
                      }
                    }
                  consumed_joker += 1;
                  if (sound_on == 1) {
                    play_sound('Booster_Joker_Use');
                  }
                  combo += 1;
                  //streak_progress(1, 1);
                  start_card_mas = [];
                  card = game.add.sprite(
                    game.world.centerX + 200,
                    game.world.height - 90 * card_size,
                    'game_atlas',
                    'joker.png',
                  );
                  card.anchor.setTo(0.5);
                  cards_discarded.push(draw_card);
                  card.scale.setTo(card_size - 0.3);
                  card.oldstart = start_card;
                  if (baloon == 1) bottom_game_group.add(card);
                  start_card_mas2.push(card);
                  start_card = 1000;
                  if (free_joker <= 0) {
                    coins -= booster3_price;
                    game.setCurrentEvent();
                    window.eventTrack('coins_out', booster3_price, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: booster3_price,
                      source: 'Buy joker',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });

                    coins_text.setText(coins);
                    booster3_price *= 2;
                    joker_stat();
                  } else {
                    free_joker -= 1;
                    joker_stat();
                  }
                } else {
                  if (shop == 1) {
                    shop_window(
                      1,
                      0,
                      600,
                      [
                        { 0: { type: 'List_Joker.png', col: '20x', atlas: 'game_window2_atlas' } },
                        { 1: { type: 'Big_Kit_List_Coin.png', col: '3 000', atlas: 'game_window_atlas' } },
                        { 2: { type: 'Big_Kit_List_Energy.png', col: '2x', atlas: 'game_window_atlas' } },
                        { 3: { type: 'List_Cards.png', col: '3x', atlas: 'game_window2_atlas' } },
                        {
                          4: {
                            id: 'joker_ingame_pack',
                            packname: 'Joker Package',
                            price: '19.99 $',
                            reward: [3000, 2, 20, 3, 0, 0, 0, 0],
                          },
                        },
                      ],
                      [
                        {
                          0: {
                            type: '2_Jockers_Pack.png',
                            sprite: 'List_Joker.png',
                            col: '2x',
                            id: 'joker_ingame1',
                            packname: '2x Jokers',
                            price: '2.99 $',
                            atlas: 'game_window2_atlas',
                            reward: [0, 0, 2],
                          },
                        },
                        {
                          1: {
                            type: '5_Jockers_Pack.png',
                            sprite: 'List_Joker.png',
                            col: '5x',
                            id: 'joker_ingame2',
                            packname: '5x Jokers',
                            price: '5.99 $',
                            atlas: 'game_window2_atlas',
                            reward: [0, 0, 5],
                          },
                        },
                        {
                          2: {
                            type: '10_Jockers_Pack.png',
                            sprite: 'List_Joker.png',
                            col: '10x',
                            id: 'joker_ingame3',
                            packname: '10x Jokers',
                            price: '10.99 $',
                            atlas: 'game_window2_atlas',
                            reward: [0, 0, 10],
                          },
                        },
                        { 3: { type: 0, sprite: 0, col: 0, id: 0, packname: 0, price: 0, atlas: 'game_atlas' } },
                      ],
                    );
                  } else if (shop == 0) {
                    get_message(2);
                  }
                }
            } else if (item.b == 41) {
              if (firstfive == 0) {
                popup = 0;
                wheel_window();
              } else {
                popup = 0;
                wheel_window();
              }
            } else if (item.b == 14) {

              popup = 2;
              animation = 1;
              loading();

              if (music_on == 1) music.pause();
              if (sound_on == 1) ambient.pause();

              sdkHandler.trigger(
                'rewardedAd',
                {
                  callback: function (success) {
                    if (music_on == 1) music.play();
                    if (sound_on == 1) ambient.play();

                    if (success) {
                      console.log('Rewarded video watched successfully 7');
                      //popup = 0;
                      if (loading_black_sprite != 0) {
                        loading_black_sprite.destroy();
                        loading_black_sprite = 0;
                      }
                      if (loading_text != 0 && loading_text != 1) {
                        loading_text.destroy();
                        loading_text = 0;
                      }
                      loading_text = 1;

                      if (sound_on == 1) {
                        play_sound('Booster_FiveCards_Use');
                      }
                      combo = 1;
                      streak_progress(0, 0);
                      if (booster4 != 0) {
                        booster4.destroy(); if (booster4_1 != 0 && booster4_1 != -1) { booster4_1.destroy(); booster4_1 = -1; }
                        booster4 = 0;
                      }
                      card_deck = game.add.sprite(
                        game.world.centerX + 1 * card_size,
                        game.world.height - 90 * card_size,
                        'game5_atlas',
                        backcards_select,
                      );
                      card_deck.inputEnabled = true;
                      card_deck.events.onInputDown.add(card_add, this);
                      card_deck.anchor.setTo(0.5, 0.5);
                      card_deck.scale.setTo(card_size);
                      //card_deck.alpha = 0;
                      if (baloon == 1) bottom_game_group.add(card_deck);
                      var nnn = 0;
                      var cdc = cards_deck_col;
                      //cards_deck_col += 5;
                      game.time.events.repeat(
                        100,
                        3,
                        function () {
                          var card_new = game.add.sprite(
                            game.world.centerX + 1 * card_size - 100 * card_size,
                            game.world.height - 90 * card_size + 300 * card_size,
                            'game5_atlas',
                            backcards_select,
                          );
                          card_new.anchor.setTo(0.5, 0.5);
                          effects_group.add(card_new);
                          game.add
                            .tween(card_new)
                            .to({ x: card_deck.x, y: card_deck.y }, 300, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function (item) {
                              cards_deck_col += 1;
                              item.destroy();
                              card_deck.alpha = 1;
                              //card_text.alpha = 1;
                              cdc += 1;
                              card_text.setText(cdc - 1 - deck_n);
                              deck_change();
                              booster4 = 0;
                            });
                          nnn++;
                          if (nnn == 3) {
                            popup = 0;
                            animation = 0;
                          }
                        },
                        this,
                      );
                      card_text = game.add.text(
                        game.world.centerX + 1 * card_size,
                        game.world.height - 40 * card_size,
                        cdc - 1 - deck_n,
                        { font: '36px RussoOne', fill: '#fff', align: 'center' },
                      );
                      card_text.alpha = 0;
                      card_text.anchor.setTo(0.5);
                      if (baloon == 1) bottom_game_group.add(card_text);
                      deck_change();
                      let plus5 = [];
                      while (plus5.length < 3) {
                        card_n = game.rnd.integerInRange(1, 13);
                        if (
                          plus5.filter(function (item) {
                            return item === card_n;
                          }).length == 0
                        ) {
                          plus5.push(card_n);
                          let draw_card_n = get_random_change([card_n, card_n + 13, card_n + 13 * 2, card_n + 13 * 3]);
                          cards_deck.push(draw_card_n);
                        }
                      }
                      if (UI_EndGame_btn != 0) {
                        UI_EndGame_btn.destroy();
                        UI_EndGame_btn = 0;
                      }

                      if (music_on == 1) {
                        music.play();
                      }

                    } else {
                      console.error('Rewarded video failed to load 7');
                      if (loading_black_sprite != 0) {
                        loading_black_sprite.destroy();
                        loading_black_sprite = 0;
                      }
                      if (loading_text != 0 && loading_text != 1) {
                        loading_text.destroy();
                        loading_text = 0;
                      }
                      loading_text = 1;
                      popup = 0;
                      animation = 0;
                      no_ad(3, 0);
                    }
                  },
                },
                this,
              );

              // transformed to rewarded ad!
              // var preloadedRewardedVideo = null;
              // getRewardedVideoAsync(placement.Rewarded1, {
              //   adContext: DdnaAdContext.RewardedInGame,
              //   adGameArea: DdnaAdGameArea.Level,
              //   adRewardType: TAdRewardType.WheelSpin,
              //   levelNumber: level,
              // })
              //   .then(function (rewarded) {
              //     preloadedRewardedVideo = rewarded;
              //     return preloadedRewardedVideo.loadAsync();
              //   })
              //   .then(function () {
              //     console.log('Rewarded video preloaded');
              //     if (music_on == 1) {
              //       music.pause();
              //     }
              //     if (sound_on == 1) {
              //       ambient.pause();
              //     }
              //     preloadedRewardedVideo
              //       .showAsync()
              //       .then(function () {
              //         console.log('Rewarded video watched successfully');
              //         //popup = 0;
              //         if (loading_black_sprite != 0) {
              //           loading_black_sprite.destroy();
              //           loading_black_sprite = 0;
              //         }
              //         if (loading_text != 0 && loading_text != 1) {
              //           loading_text.destroy();
              //           loading_text = 0;
              //         }
              //         loading_text = 1;

              //         if (sound_on == 1) {
              //           play_sound('Booster_FiveCards_Use');
              //         }
              //         combo = 1;
              //         streak_progress(0, 0);
              //         if (booster4 != 0) {
              //           booster4.destroy(); if (booster4_1 != 0 && booster4_1 != -1) { booster4_1.destroy(); booster4_1 = -1; }
              //           booster4 = 0;
              //         }
              //         card_deck = game.add.sprite(
              //           game.world.centerX + 1 * card_size,
              //           game.world.height - 90 * card_size,
              //           'game5_atlas',
              //           backcards_select,
              //         );
              //         card_deck.inputEnabled = true;
              //         card_deck.events.onInputDown.add(card_add, this);
              //         card_deck.anchor.setTo(0.5, 0.5);
              //         card_deck.scale.setTo(card_size);
              //         //card_deck.alpha = 0;
              //         if (baloon == 1) bottom_game_group.add(card_deck);
              //         var nnn = 0;
              //         var cdc = cards_deck_col;
              //         //cards_deck_col += 5;
              //         game.time.events.repeat(
              //           100,
              //           3,
              //           function () {
              //             var card_new = game.add.sprite(
              //               game.world.centerX + 1 * card_size - 100 * card_size,
              //               game.world.height - 90 * card_size + 300 * card_size,
              //               'game5_atlas',
              //               backcards_select,
              //             );
              //             card_new.anchor.setTo(0.5, 0.5);
              //             effects_group.add(card_new);
              //             game.add
              //               .tween(card_new)
              //               .to({ x: card_deck.x, y: card_deck.y }, 300, Phaser.Easing.Linear.None, true)
              //               .onComplete.add(function (item) {
              //                 cards_deck_col += 1;
              //                 item.destroy();
              //                 card_deck.alpha = 1;
              //                 //card_text.alpha = 1;
              //                 cdc += 1;
              //                 card_text.setText(cdc - 1 - deck_n);
              //                 deck_change();
              //                 booster4 = 0;
              //               });
              //             nnn++;
              //             if (nnn == 3) {
              //               popup = 0;
              //               animation = 0;
              //             }
              //           },
              //           this,
              //         );
              //         card_text = game.add.text(
              //           game.world.centerX + 1 * card_size,
              //           game.world.height - 40 * card_size,
              //           cdc - 1 - deck_n,
              //           { font: '36px RussoOne', fill: '#fff', align: 'center' },
              //         );
              //         card_text.alpha = 0;
              //         card_text.anchor.setTo(0.5);
              //         if (baloon == 1) bottom_game_group.add(card_text);
              //         deck_change();
              //         let plus5 = [];
              //         while (plus5.length < 3) {
              //           card_n = game.rnd.integerInRange(1, 13);
              //           if (
              //             plus5.filter(function (item) {
              //               return item === card_n;
              //             }).length == 0
              //           ) {
              //             plus5.push(card_n);
              //             let draw_card_n = get_random_change([card_n, card_n + 13, card_n + 13 * 2, card_n + 13 * 3]);
              //             cards_deck.push(draw_card_n);
              //           }
              //         }
              //         if (UI_EndGame_btn != 0) {
              //           UI_EndGame_btn.destroy();
              //           UI_EndGame_btn = 0;
              //         }

              //         if (music_on == 1) {
              //           music.play();
              //         }
              //       })
              //       .catch(function (e) {
              //         console.error(e.message);
              //         if (loading_black_sprite != 0) {
              //           loading_black_sprite.destroy();
              //           loading_black_sprite = 0;
              //         }
              //         if (loading_text != 0 && loading_text != 1) {
              //           loading_text.destroy();
              //           loading_text = 0;
              //         }
              //         loading_text = 1;
              //         popup = 0;
              //         animation = 0;
              //         no_ad(3, 0);
              //         if (music_on == 1) {
              //           music.play();
              //         }
              //       });
              //   })
              //   .catch(function (err) {
              //     console.error('Rewarded video failed to preload: ' + err.message);
              //     if (loading_black_sprite != 0) {
              //       loading_black_sprite.destroy();
              //       loading_black_sprite = 0;
              //     }
              //     if (loading_text != 0 && loading_text != 1) {
              //       loading_text.destroy();
              //       loading_text = 0;
              //     }
              //     loading_text = 1;
              //     popup = 0;
              //     animation = 0;
              //     no_ad(3, 0);
              //   });



            } else if (item.b == 4) {
              {
                if (coins >= booster4_price || free_five > 0) {
                  consumed_5cards_all += 1;
                  if (booster4_price == 400) {
                    consumed_5Cards = 1;
                  } else if (booster4_price == 800) {
                    consumed_5Cards_x2 = 1;
                  } else {
                    consumed_5Cards_x3 = 1;
                  }
                  popup = 2;
                  if (sound_on == 1) {
                    play_sound('Booster_FiveCards_Use');
                  }
                  combo = 1;
                  streak_progress(0, 0);
                  if (booster4 != 0) {
                    booster4.destroy(); if (booster4_1 != 0 && booster4_1 != -1) { booster4_1.destroy(); booster4_1 = -1; }
                    booster4 = 0;
                  }
                  card_deck = game.add.sprite(
                    game.world.centerX + 1 * card_size,
                    game.world.height - 90 * card_size,
                    'game5_atlas',
                    backcards_select,
                  );
                  card_deck.inputEnabled = true;
                  card_deck.events.onInputDown.add(card_add, this);
                  card_deck.anchor.setTo(0.5, 0.5);
                  card_deck.scale.setTo(card_size);
                  //card_deck.alpha = 0;
                  if (baloon == 1) bottom_game_group.add(card_deck);
                  var nnn = 0;
                  var cdc = cards_deck_col;
                  //cards_deck_col += 5;
                  game.time.events.repeat(
                    100,
                    5,
                    function () {
                      var card_new = game.add.sprite(
                        game.world.centerX + 1 * card_size - 100 * card_size,
                        game.world.height - 90 * card_size + 300 * card_size,
                        'game5_atlas',
                        backcards_select,
                      );
                      card_new.anchor.setTo(0.5, 0.5);
                      effects_group.add(card_new);
                      game.add
                        .tween(card_new)
                        .to({ x: card_deck.x, y: card_deck.y }, 300, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          cards_deck_col += 1;
                          item.destroy();
                          card_deck.alpha = 1;
                          //card_text.alpha = 1;
                          cdc += 1;
                          card_text.setText(cdc - 1 - deck_n);
                          deck_change();
                          booster4 = 0;
                        });
                      nnn++;
                      if (nnn == 5) {
                        popup = 0;
                      }
                    },
                    this,
                  );
                  card_text = game.add.text(
                    game.world.centerX + 1 * card_size,
                    game.world.height - 40 * card_size,
                    cdc - 1 - deck_n,
                    { font: '36px RussoOne', fill: '#fff', align: 'center' },
                  );
                  card_text.alpha = 0;
                  card_text.anchor.setTo(0.5);
                  if (baloon == 1) bottom_game_group.add(card_text);
                  deck_change();
                  let plus5 = [];
                  while (plus5.length < 5) {
                    card_n = game.rnd.integerInRange(1, 13);
                    if (
                      plus5.filter(function (item) {
                        return item === card_n;
                      }).length == 0
                    ) {
                      plus5.push(card_n);
                      let draw_card_n = get_random_change([card_n, card_n + 13, card_n + 13 * 2, card_n + 13 * 3]);
                      cards_deck.push(draw_card_n);
                    }
                  }
                  if (UI_EndGame_btn != 0) {
                    UI_EndGame_btn.destroy();
                    UI_EndGame_btn = 0;
                  }

                  if (free_five <= 0) {
                    coins -= booster4_price;
                    game.setCurrentEvent();
                    window.eventTrack('coins_out', booster4_price, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: booster4_price,
                      source: 'Buy five cards',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                    coins_text.setText(coins);
                    booster4_price *= 2;
                  }
                  else {
                    if (level > 5) {
                      if (free_five > 1000) { free_five -= 1001; exactmatch = 1; } else { free_five -= 1; }
                      game.setUserDataAndLog({ free_five: free_five });
                    }
                  }
                } else {
                  if (shop == 1) {
                    shop_window(
                      0,
                      0,
                      0,
                      [
                        { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                        { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                        { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                        { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                        {
                          4: {
                            id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                            packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                            price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                            reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                          },
                        },
                      ],
                      [
                        {
                          0: {
                            type: 'Coins_Pack_1.png',
                            sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                            col: '1 000',
                            id: 'coin_package_001',
                            packname: '1,000 Coins',
                            price: '0.99 $',
                            atlas: 'game_window_atlas',
                            reward: [1000],
                          },
                        },
                        {
                          1: {
                            type: 'Coins_Pack_2.png',
                            sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                            col: '6 000',
                            id: 'coin_package_02',
                            packname: '6,000 Coins',
                            price: '4.99 $',
                            atlas: 'game_window_atlas',
                            reward: [6000],
                          },
                        },
                        {
                          2: {
                            type: 'Coins_Pack_3.png',
                            sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                            col: '13 000',
                            id: 'coin_package_003',
                            packname: '13,000 Coins',
                            price: '9.99 $',
                            atlas: 'game_window_atlas',
                            reward: [13000],
                          },
                        },
                        {
                          3: {
                            type: 'Coins_Pack_4.png',
                            sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                            col: '20 000',
                            id: 'coin_package_004',
                            packname: '20,000 Coins',
                            price: '14.99 $',
                            atlas: 'game_window_atlas',
                            reward: [20000],
                          },
                        },
                      ],
                    );
                  } else if (shop == 0) {
                    get_message(2);
                  }
                }
              }
            } else if (item.b == 5 && card_anim == 0) {
              game.setCurrentEvent();
              window.eventTrack('booster_out', 1, {
                user_type: bought,
                lifetime: lifetime_day,
                highest_lvl: all_level.lastIndexOf(3) + 2,
                amount: 1,
                source: 'UndoMove',
                item_id: 0,
                mission_completed: missioncompleted,
                c_event: current_event,
              });
              if (coins >= booster1_price || free_cardback > 0) {
                if (start_card_mas.length > 0) {
                  consumed_backbutton += 1;
                  if (FTUE_Arrow != 0 && level != 1 && level != 2) {
                    FTUE_Arrow.destroy();
                    FTUE_Arrow = 0;
                  }
                  clearTimeout(TimerCheck);
                  card_check(1);
                  if (sound_on == 1) {
                    play_sound('UndoMove_Use');
                  }
                  combo = 1;
                  start_card_mas2.splice(start_card_mas2.length - 1, 1);
                  if (start_card_mas[start_card_mas.length - 1].indeck == 0) {
                    animation = 1;
                    var card_back = start_card_mas[start_card_mas.length - 1];
                    start_card = card_back.oldstart;
                    card_back.value = card_back.oldvalue;
                    card_back.vis = 1;
                    card_back.realwidth = 120;
                    card_back.draw = card_back.olddraw;
                    card_back.depth = card_back.olddepth;
                    card_back.inputEnabled = true;
                    card_back.events.onInputDown.add(card_select, this);
                    start_card_mas.splice(start_card_mas.length - 1, 1);
                    game.world.bringToTop(card_back);
                    if (card_back.oldangle)
                      game.add.tween(card_back).to({ angle: card_back.oldangle }, 500, Phaser.Easing.Linear.None, true);
                    game.add
                      .tween(card_back)
                      .to({ x: card_back.oldx, y: card_back.oldy }, 500, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        animation = 0;
                        cards_group.add(item);
                      }, this);
                  } else {
                    animation = 1;
                    start_card = start_card_mas[start_card_mas.length - 1].oldstart;
                    cards_deck.push(start_card_mas[start_card_mas.length - 1].draw);
                    var card_back = start_card_mas[start_card_mas.length - 1];
                    var card_new_back = game.add.sprite(card_back.x, card_back.y, 'game5_atlas', backcards_select);
                    card_new_back.scale.setTo(0, card_size);
                    card_new_back.anchor.setTo(0.5, 0.5);
                    game.add
                      .tween(card_back.scale)
                      .to({ x: -0.4, y: card_size }, 100, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        game.add
                          .tween(card_back.scale)
                          .to({ x: 0, y: card_size }, 100, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            game.add
                              .tween(card_new_back.scale)
                              .to({ x: 0.4, y: card_size }, 100, Phaser.Easing.Linear.None, true)
                              .onComplete.add(function (item) {
                                game.add
                                  .tween(card_new_back.scale)
                                  .to({ x: card_size, y: card_size }, 100, Phaser.Easing.Linear.None, true);
                              });
                          });
                      });
                    game.add
                      .tween(card_back)
                      .to(
                        { x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size },
                        400,
                        Phaser.Easing.Linear.None,
                        true,
                      );
                    game.add
                      .tween(card_new_back)
                      .to(
                        { x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size },
                        400,
                        Phaser.Easing.Linear.None,
                        true,
                      )
                      .onComplete.add(function (item) {
                        animation = 0;
                        item.destroy();
                        if (deck_n >= cards_deck_col - 1) {
                          card_deck = game.add.sprite(
                            game.world.centerX + 1 * card_size,
                            game.world.height - 90 * card_size,
                            'game5_atlas',
                            backcards_select,
                          );
                          card_deck.inputEnabled = true;
                          card_deck.events.onInputDown.add(card_add, this);
                          card_deck.anchor.setTo(0.5, 0.5);
                          card_deck.scale.setTo(card_size);
                          if (baloon == 1) bottom_game_group.add(card_deck);
                          card_text = game.add.text(
                            game.world.centerX + 1 * card_size,
                            game.world.height - 40 * card_size,
                            cards_deck_col - 1 - deck_n,
                            { font: '36px RussoOne', fill: '#fff', align: 'center' },
                          );
                          card_text.alpha = 0;
                          card_text.anchor.setTo(0.5);
                          if (baloon == 1) bottom_game_group.add(card_text);
                          deck_change();
                          booster4.destroy(); if (booster4_1 != 0 && booster4_1 != -1) { booster4_1.destroy(); booster4_1 = -1; }
                          if (UI_EndGame_btn != 0) {
                            UI_EndGame_btn.destroy();
                            UI_EndGame_btn = 0;
                          }
                          booster4 = 0;
                        }
                        start_card_mas[start_card_mas.length - 1].destroy();
                        start_card_mas.splice(start_card_mas.length - 1, 1);
                        deck_n -= 1;
                        card_text.setText(cards_deck_col - 1 - deck_n);
                        deck_change();
                      }, this);
                    game.world.bringToTop(card_text);
                  }
                  if (free_cardback > 0) {
                    free_cardback -= 1;
                    booster5_price_text.setText(
                      game.cache.getJSON('lang')['FREE'][0][window.lang] + ' x' + free_cardback,
                    );
                    if (free_cardback <= 0) {
                      booster5_price_text.setText(booster1_price);
                      booster5_coin.destroy();
                      booster5_coin = game.add.sprite(
                        game.world.centerX + 400 + booster5.width / 2 - booster5_price_text.width / 2 - 16,
                        game.world.height - 20,
                        'game_atlas',
                        'icon_coins.png',
                      );
                      booster5_coin.anchor.setTo(0.5, 0.5);
                      booster5_coin.scale.setTo(0.7);
                      if (baloon == 1) bottom_game_group.add(booster5_coin);
                    }
                  } else {
                    coins -= booster1_price;
                    game.setCurrentEvent();
                    window.eventTrack('coins_out', booster1_price, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: booster1_price,
                      source: 'Buy cardback',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                    coins_text.setText(coins);
                    booster1_price *= 2;
                    booster5_price_text.setText(booster1_price);
                    booster5_coin.destroy();
                    booster5_coin = game.add.sprite(
                      game.world.centerX + 400 + booster5.width / 2 - booster5_price_text.width / 2 - 16,
                      game.world.height - 20,
                      'game_atlas',
                      'icon_coins.png',
                    );
                    booster5_coin.anchor.setTo(0.5, 0.5);
                    booster5_coin.scale.setTo(0.7);
                    if (baloon == 1) bottom_game_group.add(booster5_coin);
                  }
                }
              } else {
                if (shop == 1) {
                  shop_window(
                    0,
                    0,
                    0,
                    [
                      { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                      { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                      { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                      { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                      {
                        4: {
                          id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                          packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                          price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                          reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                        },
                      },
                    ],
                    [
                      {
                        0: {
                          type: 'Coins_Pack_1.png',
                          sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                          col: '1 000',
                          id: 'coin_package_001',
                          packname: '1,000 Coins',
                          price: '0.99 $',
                          atlas: 'game_window_atlas',
                          reward: [1000],
                        },
                      },
                      {
                        1: {
                          type: 'Coins_Pack_2.png',
                          sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                          col: '6 000',
                          id: 'coin_package_02',
                          packname: '6,000 Coins',
                          price: '4.99 $',
                          atlas: 'game_window_atlas',
                          reward: [6000],
                        },
                      },
                      {
                        2: {
                          type: 'Coins_Pack_3.png',
                          sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                          col: '13 000',
                          id: 'coin_package_003',
                          packname: '13,000 Coins',
                          price: '9.99 $',
                          atlas: 'game_window_atlas',
                          reward: [13000],
                        },
                      },
                      {
                        3: {
                          type: 'Coins_Pack_4.png',
                          sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                          col: '20 000',
                          id: 'coin_package_004',
                          packname: '20,000 Coins',
                          price: '14.99 $',
                          atlas: 'game_window_atlas',
                          reward: [20000],
                        },
                      },
                    ],
                  );
                } else if (shop == 0) {
                  get_message(2);
                }
              }
            }
          }
        });
      }
      var d8 = [150, 10, 40, 40, 270, 20, 380, 90];
      function go(m) {
        var sum = 1000;
        var p = Math.random() * sum;
        for (var i = 0; i < m.length; i++) {
          if (p > m[i]) {
            p -= m[i];
          } else {
            return i + 1;
            break;
          }
        }
      }
      function wheel_window() {
        if (popup == 0) {
          if (sound_on == 1) {
            play_sound('button_press');
          }
          popup_group.y = 0;
          popup = 1;
          blackf();
          var prize_wheel_icons = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 - 100,
            'game_window2_atlas',
            'Wheel_Background.png',
          );
          prize_wheel_icons.anchor.setTo(0.5);
          popup_group.add(prize_wheel_icons);
          prize_wheel_icons.fixedToCamera = true;
          var prize_wheel_i = game.add.sprite(2, -194, 'game_window2_atlas', 'Cards_top.png');
          prize_wheel_i.anchor.setTo(0.5);
          prize_wheel_icons.addChild(prize_wheel_i);
          var prize_wheel_i = game.add.sprite(130, 122, 'game_window2_atlas', 'Cards_top.png');
          prize_wheel_i.anchor.setTo(0.5);
          prize_wheel_i.angle = 135;
          prize_wheel_icons.addChild(prize_wheel_i);
          var prize_wheel_i = game.add.sprite(-130, 122, 'game_window2_atlas', 'Cards_top.png');
          prize_wheel_i.anchor.setTo(0.5);
          prize_wheel_i.angle = -135;
          prize_wheel_icons.addChild(prize_wheel_i);
          var prize_wheel_i = game.add.sprite(-170, -180, 'game_window2_atlas', 'Medium_Coins.png');
          prize_wheel_i.anchor.setTo(0.5);
          prize_wheel_icons.addChild(prize_wheel_i);
          var prize_wheel_i = game.add.sprite(156, -160, 'game_window2_atlas', 'Low_Coins.png');
          prize_wheel_i.anchor.setTo(0.5);
          prize_wheel_icons.addChild(prize_wheel_i);
          var prize_wheel_i = game.add.sprite(-210, -15, 'game_window2_atlas', 'Low_Coins.png');
          prize_wheel_i.anchor.setTo(0.5);
          prize_wheel_icons.addChild(prize_wheel_i);
          var prize_wheel_i = game.add.sprite(220, -15, 'game_window2_atlas', 'Medium_Coins.png');
          prize_wheel_i.anchor.setTo(0.5);
          prize_wheel_icons.addChild(prize_wheel_i);
          var prize_wheel_i = game.add.sprite(-7, 210, 'game_window2_atlas', 'Lots_Of_Coins.png');
          prize_wheel_i.anchor.setTo(0.5);
          prize_wheel_icons.addChild(prize_wheel_i);
          prize_wheel_arrow = game.add.sprite(
            game.camera.width / 2,
            game.camera.height / 2 - 100,
            'game_window2_atlas',
            'Wheel_Arrow.png',
          );
          prize_wheel_arrow.anchor.setTo(0.35, 0.5);
          popup_group.add(prize_wheel_arrow);
          prize_wheel_arrow.fixedToCamera = true;
          var Curtain_Left = game.add.sprite(-450, 0, 'game_window2_atlas', 'Curtain_Left.png');
          popup_group.add(Curtain_Left);
          Curtain_Left.scale.setTo(2);
          Curtain_Left.fixedToCamera = true;
          game.add.tween(Curtain_Left.cameraOffset).to({ x: '+450' }, 800, Phaser.Easing.Exponential.Out, true, 500);
          var Curtain_Left2 = game.add.sprite(0, Curtain_Left.height, 'game_window2_atlas', 'Curtain_Left.png');
          Curtain_Left2.scale.setTo(1, -1);
          Curtain_Left.addChild(Curtain_Left2);
          var Curtain_Right = game.add.sprite(game.camera.width + 450, 0, 'game_window2_atlas', 'Curtain_Left.png');
          Curtain_Right.anchor.setTo(0, 0);
          Curtain_Right.scale.setTo(-2, 2);
          popup_group.add(Curtain_Right);
          Curtain_Right.fixedToCamera = true;
          game.add.tween(Curtain_Right.cameraOffset).to({ x: '-450' }, 800, Phaser.Easing.Exponential.Out, true, 500);
          var Curtain_Right2 = game.add.sprite(0, Curtain_Right.height, 'game_window2_atlas', 'Curtain_Left.png');
          Curtain_Right2.scale.setTo(1, -1);
          Curtain_Right.addChild(Curtain_Right2);
          if (wheel_num == 0) var girl = game.add.sprite(-450, game.camera.height, 'char_atlas', 'Main_Twinkling.png');
          else var girl = game.add.sprite(-450, game.camera.height, 'char_atlas', 'Main_Presenting.png');
          girl.anchor.setTo(0.5, 1);
          girl.scale.setTo(-2.4, 2.4);
          popup_group.add(girl);
          girl.fixedToCamera = true;
          game.add
            .tween(girl.cameraOffset)
            .to({ x: game.camera.width / 2 - 560 }, 400, Phaser.Easing.Linear.None, true, 400);
          var prize1_text = game.add.text(220, -220, '10', { font: '50px RussoOne', fill: '#fff', align: 'center' });
          prize1_text.anchor.setTo(0.5);
          prize1_text.stroke = '#0D739F';
          prize1_text.strokeThickness = 12;
          prize1_text.angle = 45;
          prize_wheel_icons.addChild(prize1_text);
          prize1_text = game.add.text(-220, -220, '25', { font: '50px RussoOne', fill: '#fff', align: 'center' });
          prize1_text.anchor.setTo(0.5);
          prize1_text.stroke = '#0D739F';
          prize1_text.angle = -45;
          prize1_text.strokeThickness = 12;
          prize_wheel_icons.addChild(prize1_text);
          prize1_text = game.add.text(-290, 0, '10', { font: '50px RussoOne', fill: '#fff', align: 'center' });
          prize1_text.anchor.setTo(0.5);
          prize1_text.stroke = '#0D739F';
          prize1_text.strokeThickness = 12;
          prize_wheel_icons.addChild(prize1_text);
          prize1_text = game.add.text(290, 0, '25', { font: '50px RussoOne', fill: '#fff', align: 'center' });
          prize1_text.anchor.setTo(0.5);
          prize1_text.stroke = '#0D739F';
          prize1_text.strokeThickness = 12;
          prize_wheel_icons.addChild(prize1_text);
          prize1_text = game.add.text(-190, 190, '+1', { font: '50px RussoOne', fill: '#fff', align: 'center' });
          prize1_text.anchor.setTo(0.5);
          prize1_text.stroke = '#0D739F';
          prize1_text.angle = 45;
          prize1_text.strokeThickness = 12;
          prize_wheel_icons.addChild(prize1_text);
          prize1_text = game.add.text(0, 290, '50', { font: '50px RussoOne', fill: '#fff', align: 'center' });
          prize1_text.anchor.setTo(0.5);
          prize1_text.stroke = '#0D739F';
          prize1_text.strokeThickness = 12;
          prize_wheel_icons.addChild(prize1_text);
          prize1_text = game.add.text(190, 190, '+1', { font: '50px RussoOne', fill: '#fff', align: 'center' });
          prize1_text.anchor.setTo(0.5);
          prize1_text.stroke = '#0D739F';
          prize1_text.angle = -45;
          prize1_text.strokeThickness = 12;
          prize_wheel_icons.addChild(prize1_text);
          prize1_text = game.add.text(0, -270, '+5', { font: '50px RussoOne', fill: '#fff', align: 'center' });
          prize1_text.anchor.setTo(0.5);
          prize1_text.stroke = '#0D739F';
          prize1_text.strokeThickness = 12;
          prize_wheel_icons.addChild(prize1_text);
          function wheel_lightbulb_f(itm) {
            if (itm) {
              if (itm.alpha == 0)
                game.add
                  .tween(itm)
                  .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    wheel_lightbulb_f(item);
                  });
              else
                game.add
                  .tween(itm)
                  .to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    wheel_lightbulb_f(item);
                  });
            } else
              prize_wheel_icons.children.forEach(function (child_item) {
                if (child_item.n == 1 || child_item.n == 2) {
                  if (child_item.alpha == 0)
                    game.add
                      .tween(child_item)
                      .to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        wheel_lightbulb_f(item);
                      });
                  else
                    game.add
                      .tween(child_item)
                      .to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        wheel_lightbulb_f(item);
                      });
                }
              });
          }
          bright_area = game.add.sprite(0, -5, 'game_window2_atlas', 'Wheel_Selected_Part.png');
          bright_area.anchor.setTo(0.05);
          bright_area.angle = -45;
          bright_area.alpha = 1;
          prize_wheel_icons.addChild(bright_area);
          var popup_close = game.add.sprite(game.camera.width - 100, 100, 'game_window_atlas', 'Close_Button.png');
          popup_close.anchor.setTo(0.5);
          button_animation_f(popup_close, 1);
          popup_close.events.onInputUp.add(function () {
            if (popup != 2) {
              popup = 2;
              if (sound_on == 1) {
                play_sound('button_X');
              }
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add.tween(Curtain_Left.cameraOffset).to({ x: '-450' }, 500, Phaser.Easing.Quadratic.Out, true);
              game.add
                .tween(Curtain_Right.cameraOffset)
                .to({ x: '+450' }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup = 0;
                      prize_wheel_arrow = 0;
                      popup_group.y -= game.camera.height;
                    });
                });
            }
          }, this);
          popup_group.add(popup_close);
          popup_close.fixedToCamera = true;
          function wheel_spin(item) {
            if (popup != 2) {
              popup = 2;
              if (FTUE > 30)
                for (var i = 0; i < missions.length; i += 4) {
                  if (missions[i] == -16) {
                    if (missions[i + 2] < missions[i + 1]) {
                      missions[i + 2] += 1;
                    }
                  }
                }
              if (sound_on == 1) {
                play_sound('button_press');
              }
              if (item != 0)
                game.add
                  .tween(item)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (itm) {
                    itm.destroy();
                  });
              game.add
                .tween(popup_close)
                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (itm) {
                  itm.destroy();
                });
              var rnd = go(d8);
              if (prize_wheel_arrow.angle == 0) var r = 2880 + rnd * 45 + game.rnd.integerInRange(-15, 15);
              game.add
                .tween(prize_wheel_arrow)
                .to({ angle: '+' + r }, 10000, Phaser.Easing.Cubic.InOut, true)
                .onComplete.add(function (item) {
                  popup = 1;
                  var prz = prize_wheel_arrow.angle;
                  if (sound_on == 1) {
                    play_sound('PrizeWheel_Win_Song');
                  }
                  game.add
                    .tween(bright_area)
                    .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
                    .onComplete.add(function (item) {
                      game.add
                        .tween(bright_area)
                        .to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          game.add
                            .tween(bright_area)
                            .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function (item) {
                              game.add
                                .tween(bright_area)
                                .to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true)
                                .onComplete.add(function (item) {
                                  game.add
                                    .tween(bright_area)
                                    .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
                                    .onComplete.add(function (item) {
                                      game.add
                                        .tween(bright_area)
                                        .to({ alpha: 0 }, 300, Phaser.Easing.Linear.None, true)
                                        .onComplete.add(function (item) {
                                          game.add
                                            .tween(bright_area)
                                            .to({ alpha: 1 }, 300, Phaser.Easing.Linear.None, true)
                                            .onComplete.add(function (item) { });
                                        });
                                    });
                                });
                            });
                        });
                      game.add.tween(girl).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true);
                      var girl_new = game.add.sprite(
                        game.camera.width / 2 - 610,
                        game.camera.height,
                        'char_atlas',
                        'Main_Excited.png',
                      );
                      girl_new.anchor.setTo(0.5, 1);
                      girl_new.scale.setTo(-2.4, 2.4);
                      girl_new.alpha = 0;
                      popup_group.add(girl_new);
                      girl_new.fixedToCamera = true;
                      game.add.tween(girl_new).to({ alpha: 1 }, 800, Phaser.Easing.Linear.None, true);
                      var button_green1 = game.add.sprite(
                        game.camera.width / 2,
                        game.camera.height / 2 + 400,
                        'game_window2_atlas',
                        'Free_Spin_Claim_Button.png',
                      );
                      button_green1.anchor.setTo(0.5);
                      button_green1.inputEnabled = true;
                      button_green1.alpha = 0;
                      button_green1.events.onInputUp.add(function (item) {
                        btnup(item);
                        if (popup != 2) {
                          popup = 2;
                          game.add
                            .tween(black_sprite)
                            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                            .onComplete.add(function (item) {
                              item.destroy();
                            });
                          game.add
                            .tween(Curtain_Left.cameraOffset)
                            .to({ x: '-450' }, 500, Phaser.Easing.Quadratic.Out, true);
                          game.add
                            .tween(Curtain_Right.cameraOffset)
                            .to({ x: '+450' }, 500, Phaser.Easing.Quadratic.Out, true)
                            .onComplete.add(function (item) {
                              game.add
                                .tween(popup_group)
                                .to({ y: '+' + game.world.height }, 500, Phaser.Easing.Quadratic.Out, true)
                                .onComplete.add(function (item) {
                                  prize_wheel_arrow = 0;
                                  popup_group.removeAll(true);
                                  popup_group.y -= game.world.height;
                                  var col = 0;
                                  if (rnd == 1) {
                                    col = 1;
                                    firstfive = 2;
                                  }
                                  if (rnd == 7) {
                                    coins += 10;
                                    col = 10;
                                    var p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                                    p_text = p_text.replace('[x]', '10');
                                    message(p_text, coins_text.x, coins_text.y, 1);
                                  }
                                  if (rnd == 2) {
                                    col = 5;
                                    firstfive = 2;
                                  }
                                  if (rnd == 5) {
                                    coins += 25;
                                    col = 25;
                                    var p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                                    p_text = p_text.replace('[x]', '25');
                                    message(p_text, coins_text.x, coins_text.y, 1);
                                  }
                                  if (rnd == 8) {
                                    coins += 25;
                                    col = 25;
                                    var p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                                    p_text = p_text.replace('[x]', '25');
                                    message(p_text, coins_text.x, coins_text.y, 1);
                                  }
                                  if (rnd == 6) {
                                    coins += 50;
                                    col = 50;
                                    var p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                                    p_text = p_text.replace('[x]', '50');
                                    message(p_text, coins_text.x, coins_text.y, 1);
                                  }
                                  if (rnd == 3) {
                                    col = 1;
                                    firstfive = 2;
                                  }
                                  if (rnd == 4) {
                                    coins += 10;
                                    col = 10;
                                    var p_text = game.cache.getJSON('lang')['WheelAddCoins'][0][window.lang];
                                    p_text = p_text.replace('[x]', '10');
                                    message(p_text, coins_text.x, coins_text.y, 1);
                                  }
                                  if (firstfive == 2) {
                                    popup = 0;
                                    firstfive = 1;
                                  } else {
                                    popup = 1;
                                    game.add.tween(effects_group).to({ alpha: 1 }, 1500, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                                      popup = 0;
                                      wheel_window();
                                    }
                                    );
                                  }
                                  if (col > 5) {
                                    game.setCurrentEvent();
                                    window.eventTrack('coins_in', col, {
                                      user_type: bought,
                                      lifetime: lifetime_day,
                                      highest_lvl: all_level.lastIndexOf(3) + 2,
                                      amount: col,
                                      source: 'Wheel level',
                                      package_id: 0,
                                      mission_completed: missioncompleted,
                                      c_event: current_event,
                                    });

                                    // save collected coins
                                    game.setUserDataAndLog({ currencies: coins });

                                    var coins_t = coins - col;
                                    coins_text.setText(coins_t);
                                    var var_coins = 0;
                                    if (sound_on == 1) {
                                      play_sound('coins_add');
                                    }
                                    game.time.events.repeat(
                                      100,
                                      10,
                                      function () {
                                        var get_coin = game.add.sprite(
                                          game.world.centerX + game.rnd.integerInRange(-50, 50),
                                          game.world.centerY + game.rnd.integerInRange(-50, 50),
                                          'game_atlas',
                                          'icon_coins.png',
                                        );
                                        get_coin.anchor.setTo(0.5);
                                        get_coin.scale.setTo(0);
                                        get_coin.alpha = 0;
                                        effects_group.add(get_coin);
                                        game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                                        game.add
                                          .tween(get_coin.scale)
                                          .to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                                        game.add
                                          .tween(get_coin)
                                          .to(
                                            { x: UI_Coins_BG.x, y: UI_Coins_BG.y },
                                            600,
                                            Phaser.Easing.Linear.None,
                                            true,
                                          )
                                          .onComplete.add(function (item) {
                                            item.destroy();
                                            var_coins += col / 10;
                                            coins_text.setText(Math.ceil(coins_t + var_coins));
                                          });
                                      },
                                      this,
                                    );
                                  } else {
                                    combo = 1;
                                    streak_progress(0, 0);
                                    if (booster4 != 0) {
                                      booster4.destroy(); if (booster4_1 != 0 && booster4_1 != -1) { booster4_1.destroy(); booster4_1 = -1; }
                                      booster4 = 0;
                                    }
                                    card_deck = game.add.sprite(
                                      game.world.centerX + 1 * card_size,
                                      game.world.height - 90 * card_size,
                                      'game5_atlas',
                                      backcards_select,
                                    );
                                    card_deck.inputEnabled = true;
                                    card_deck.events.onInputDown.add(card_add, this);
                                    card_deck.anchor.setTo(0.5, 0.5);
                                    card_deck.scale.setTo(card_size);
                                    //card_deck.alpha = 0;
                                    if (baloon == 1) bottom_game_group.add(card_deck);
                                    var nnn = 0;
                                    game.time.events.repeat(
                                      100,
                                      col,
                                      function () {
                                        var card_new = game.add.sprite(
                                          game.world.centerX + 1 * card_size - 100 * card_size,
                                          game.world.height - 90 * card_size + 300 * card_size,
                                          'game5_atlas',
                                          backcards_select,
                                        );
                                        card_new.anchor.setTo(0.5, 0.5);
                                        game.add
                                          .tween(card_new)
                                          .to({ x: card_deck.x, y: card_deck.y }, 300, Phaser.Easing.Linear.None, true)
                                          .onComplete.add(function (item) {
                                            item.destroy();
                                            card_deck.alpha = 1;
                                            //card_text.alpha = 1;
                                            cards_deck_col += 1;
                                            card_text.setText(cards_deck_col - 1 - deck_n);
                                            deck_change();
                                            booster4 = 0;
                                          });
                                        nnn++;
                                        if (nnn == col) {
                                          popup = 0;
                                        }
                                      },
                                      this,
                                    );
                                    card_text = game.add.text(
                                      game.world.centerX + 1 * card_size,
                                      game.world.height - 40 * card_size,
                                      cards_deck_col - 1 - deck_n,
                                      { font: '36px RussoOne', fill: '#fff', align: 'center' },
                                    );
                                    card_text.alpha = 0;
                                    card_text.anchor.setTo(0.5);
                                    if (baloon == 1) bottom_game_group.add(card_text);
                                    deck_change();
                                    var plus5 = [];
                                    while (plus5.length < col) {
                                      var card_n = game.rnd.integerInRange(1, 13);
                                      if (
                                        plus5.filter(function (item) {
                                          return item === card_n;
                                        }).length == 0
                                      ) {
                                        plus5.push(card_n);
                                        var draw_card_n = get_random_change([
                                          card_n,
                                          card_n + 13,
                                          card_n + 13 * 2,
                                          card_n + 13 * 3,
                                        ]);
                                        cards_deck.push(draw_card_n);
                                      }
                                    }
                                    if (UI_EndGame_btn != 0) {
                                      UI_EndGame_btn.destroy();
                                      UI_EndGame_btn = 0;
                                    }
                                  }
                                });
                            });
                        }
                      });
                      popup_group.add(button_green1);
                      button_green1.fixedToCamera = true;
                      button_green1.input.useHandCursor = true;
                      scale_tween(button_green1, 500, 0.1, 0.1);
                      var button_green1_text = game.add.text(
                        0,
                        2,
                        game.cache.getJSON('lang')['Claim'][0][window.lang],
                        { font: '52px RussoOne', fill: '#fff', align: 'center' },
                      );
                      button_green1_text.anchor.setTo(0.5);
                      button_green1_text.lineSpacing = -10;
                      button_green1_text.stroke = '#457310';
                      button_green1_text.strokeThickness = 4;
                      button_green1_text.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
                      button_green1.addChild(button_green1_text);
                      game.add.tween(button_green1).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                    });
                });
            }
          }
          if (firstfive == 1) {
            var button_green1 = game.add.sprite(
              game.camera.width / 2,
              game.camera.height / 2 + 400,
              'game_atlas',
              'blue_button.png',
            );
            button_green1.anchor.setTo(0.5);
            button_green1.scale.setTo(2.1);
            button_green1.inputEnabled = true;
            button_green1.scl = 2.1;
            button_green1.events.onInputOver.add(btnover, this);
            button_green1.events.onInputOut.add(btnout, this);
            button_green1.events.onInputDown.add(btnclick, this);
            button_green1.events.onInputUp.add(function (item) {
              btnup(item);
              if (popup != 2) {
                loading();
                if (fbv == 1) {
                  console.log("%cThis should not happen!", "color:orange");

                  // var preloadedRewardedVideo = null;
                  // getRewardedVideoAsync(placement.Rewarded1, {
                  //   adContext: DdnaAdContext.RewardedInGame,
                  //   adGameArea: DdnaAdGameArea.Level,
                  //   adRewardType: TAdRewardType.WheelSpin,
                  //   levelNumber: level,
                  // })
                  //   .then(function (rewarded) {
                  //     preloadedRewardedVideo = rewarded;
                  //     return preloadedRewardedVideo.loadAsync();
                  //   })
                  //   .then(function () {
                  //     console.log('Rewarded video preloaded');
                  //     if (music_on == 1) {
                  //       music.pause();
                  //     }
                  //     if (sound_on == 1) {
                  //       ambient.pause();
                  //     }
                  //     preloadedRewardedVideo
                  //       .showAsync()
                  //       .then(function () {
                  //         console.log('Rewarded video watched successfully');
                  //         popup = 0;
                  //         if (loading_black_sprite != 0) {
                  //           loading_black_sprite.destroy();
                  //           loading_black_sprite = 0;
                  //         }
                  //         if (loading_text != 0 && loading_text != 1) {
                  //           loading_text.destroy();
                  //           loading_text = 0;
                  //         }
                  //         loading_text = 1;
                  //         wheel_spin(item);
                  //         if (music_on == 1) {
                  //           music.play();
                  //         }
                  //       })
                  //       .catch(function (e) {
                  //         console.error(e.message);
                  //         if (loading_black_sprite != 0) {
                  //           loading_black_sprite.destroy();
                  //           loading_black_sprite = 0;
                  //         }
                  //         if (loading_text != 0 && loading_text != 1) {
                  //           loading_text.destroy();
                  //           loading_text = 0;
                  //         }
                  //         loading_text = 1;
                  //         popup_group.removeAll(true);
                  //         popup = 0;
                  //         black_sprite.destroy();
                  //         popup_group.y -= game.camera.height;
                  //         no_ad(3, 0);
                  //         if (music_on == 1) {
                  //           music.play();
                  //         }
                  //       });
                  //   })
                  //   .catch(function (err) {
                  //     console.error('Rewarded video failed to preload: ' + err.message);
                  //     if (loading_black_sprite != 0) {
                  //       loading_black_sprite.destroy();
                  //       loading_black_sprite = 0;
                  //     }
                  //     if (loading_text != 0 && loading_text != 1) {
                  //       loading_text.destroy();
                  //       loading_text = 0;
                  //     }
                  //     loading_text = 1;
                  //     popup_group.removeAll(true);
                  //     popup = 0;
                  //     black_sprite.destroy();
                  //     popup_group.y -= game.camera.height;
                  //     no_ad(3, 0);
                  //   });
                } else {
                  if (music_on == 1) music.pause();
                  if (sound_on == 1) ambient.pause();

                  sdkHandler.trigger(
                    'rewardedAd',
                    {
                      callback: function (success) {
                        if (music_on == 1) music.play();
                        if (sound_on == 1) ambient.play();

                        if (success) {
                          console.log('Rewarded video watched successfully 5');
                          popup = 0;
                          if (loading_black_sprite != 0) {
                            loading_black_sprite.destroy();
                            loading_black_sprite = 0;
                          }
                          if (loading_text != 0 && loading_text != 1) {
                            loading_text.destroy();
                            loading_text = 0;
                          }
                          loading_text = 1;
                          wheel_spin(item);
                        } else {
                          console.log('Failed to watch rewarded Ad 5')
                          if (loading_black_sprite != 0) {
                            loading_black_sprite.destroy();
                            loading_black_sprite = 0;
                          }
                          if (loading_text != 0 && loading_text != 1) {
                            loading_text.destroy();
                            loading_text = 0;
                          }
                          loading_text = 1;
                          popup_group.removeAll(true);
                          popup = 0;
                          black_sprite.destroy();
                          popup_group.y -= game.camera.height;
                          no_ad(3, 0);
                        }
                      },
                    },
                    this,
                  );
                }
                popup = 2;
              }
            });
            popup_group.add(button_green1);
            button_green1.fixedToCamera = true;
            var button_green1_text = game.add.text(-30, 2, game.cache.getJSON('lang')['WatchAd'][0][window.lang], {
              font: '22px RussoOne',
              fill: '#fff',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 280,
            });
            button_green1_text.lineSpacing = -10;
            button_green1_text.anchor.setTo(0.5);
            button_green1.addChild(button_green1_text);
            var button_green1_icon = game.add.sprite(60, 0, 'game_atlas', 'ad_icon.png');
            button_green1_icon.anchor.setTo(0.5);
            button_green1_icon.scale.setTo(0.7);
            button_green1.addChild(button_green1_icon);
          }
          if (firstfive == 0) {
            wheel_spin(0);
          }
          firstfive = 1;
          game.add
            .tween(popup_group)
            .to({ alpha: 1 }, 500, Phaser.Easing.Exponential.Out, true)
            .onComplete.add(function (item) { });
          game.world.bringToTop(popup_group);
        }
      }
      leader_group = game.add.group();
      popup_group = game.add.group();
      function blackf() {
        black_sprite = game.add.sprite(game.world.centerX, game.world.centerY, 'message_invite_mask');
        black_sprite.width = game.world.width;
        black_sprite.height = game.world.height;
        black_sprite.inputEnabled = true;
        black_sprite.anchor.setTo(0.5);
        black_sprite.alpha = 0;
        game.add
          .tween(black_sprite)
          .to({ alpha: 0.8 }, 500, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (item) { });
      }
      function help_level_start() {
        popup_group.removeAll();
        popup = 0;
        animation = 0;
        popup_group.y = 0;
        if (level == 26 && suitcase_add == 0) {
          booster_tnt_col += 3;
          suitcase_tutorial(1);
        } else if (
          level == 40 &&
          (all_level[level - 1] == 0 || typeof all_level[level - 1] == 'undefined') &&
          suitcase_add != 2
        ) {
          booster_eye_col += 1;
          suitcase_tutorial(2);
        } else if (
          level == 45 &&
          (all_level[level - 1] == 0 || typeof all_level[level - 1] == 'undefined') &&
          suitcase_add != 3
        ) {
          booster_shuffle_col += 1;
          suitcase_tutorial(3);
        } else if (level == 3) {
          if (fbv == 1) {
            window.eventTrack('FTUE_6_2_StreakMeterTutorialConfirmed');
          }
          w = ftue_window(
            'Main_Presenting.png',
            game.cache.getJSON('lang')['Tutorial3'][0][window.lang],
            game.camera.width / 2,
            game.camera.height / 2,
          );
          game.world.bringToTop(UI_Streak_BG);
          if (sound_on == 1) {
            play_sound('hint_with_arrow');
          }
          FTUE_Arrow = game.add.graphics(UI_Streak_BG.x + 120, UI_Streak_BG.y);
          FTUE_Arrow.lineStyle(8, 0xffff00);
          FTUE_Arrow.drawCircle(15, 0, 130);
          FTUE_Arrow.alpha = 0;
          game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
          game.add
            .tween(FTUE_Arrow.scale)
            .to({ x: 1.1, y: 1.1 }, 400, Phaser.Easing.Linear.None, true, 0, -1)
            .yoyo(true, 100);
        } else if (level == 10 && FTUE_Arrow == 0) {
          w = ftue_window(
            'Main_Presenting.png',
            game.cache.getJSON('lang')['t348'][0][window.lang],
            game.camera.width / 2,
            game.camera.height / 2 + 320,
          );
          game.world.bringToTop(UI_Streak_BG);
          if (sound_on == 1) {
            play_sound('hint_with_arrow');
          }
          cards_group.children.forEach(function (element1) {
            if (element1.value == 1 && element1.vis == 1) {
              var ccc = game.add.sprite(element1.x, element1.y, 'game_atlas', 'card' + element1.draw + '.png');
              ccc.angle = element1.angle;
              ccc.anchor.setTo(0.5);
              ccc.scale.setTo(card_size);
              w.obj = ccc;
              var tickingbomb = game.add.sprite(-94, -158, 'game_atlas', 'tickingbomb.png');
              tickingbomb.scale.setTo(0.55);
              ccc.addChild(tickingbomb);
              var tickingbomb_text = game.add.text(-48, -74, '5', {
                font: '40px RussoOne',
                fill: '#fff',
                align: 'center',
              });
              tickingbomb_text.anchor.setTo(0.5);
              var grd = tickingbomb_text.context.createLinearGradient(0, 0, 0, tickingbomb_text.height);
              grd.addColorStop(0, '#F4F7CC');
              grd.addColorStop(1, '#E2C773');
              tickingbomb_text.fill = grd;
              ccc.addChild(tickingbomb_text);
            }
          });
          FTUE_Arrow = game.add.sprite(game.world.centerX, game.world.centerY, 'game_atlas', 'FTUE_Arrow.png');
          FTUE_Arrow.anchor.setTo(0.5, 1.6);
          FTUE_Arrow.alpha = 0;
          game.add.tween(FTUE_Arrow).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
          game.add.tween(FTUE_Arrow.anchor).to({ y: 1.7 }, 200, Phaser.Easing.Linear.None, true, 0, -1).yoyo(true, 200);
        }
      }
      function help_end() {
        if (free_prebooster3_select == 1) {

          var nnn = 3;
          popup = 1;
          animation = 1;
          free_prebooster3 -= 1;
          game.setUserDataAndLog({ free_prebooster3: free_prebooster3 });
          free_prebooster3_select = 0;

          blackf();
          game.time.events.repeat(500, nnn, function () {
            var new_card = game.add.sprite(game.world.centerX, game.world.centerY, 'game_atlas', "joker.png");
            new_card.anchor.setTo(0.5);
            new_card.scale.setTo(0);
            new_card.alpha = 0;
            game.add.tween(new_card.scale).to({ x: card_size * 2, y: card_size * 2 }, 500, Phaser.Easing.Bounce.Out, true);
            game.add.tween(new_card).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
              game.add.tween(new_card.scale).to({ x: card_size, y: card_size }, 600, Phaser.Easing.Linear.None, true);
              game.add.tween(new_card).to({ angle: 360 }, 600, Phaser.Easing.Linear.None, true);
              game.add.tween(new_card).to({ x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size }, 600, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                item.destroy();
                cards_deck_col += 1;
                var lj = game.rnd.integerInRange(1, cards_deck_col - 1 - deck_n);;
                while (level_joker.indexOf(lj) != -1) {
                  lj = game.rnd.integerInRange(1, cards_deck_col - 1 - deck_n);
                }
                level_joker.push(lj);
                card_text.setText(cards_deck_col - 1 - deck_n);
                deck_change();
              });
            });
            nnn -= 1;
          });
          game.add.tween(effects_group).to({ alpha: 1 }, 1500 + 500 * nnn, Phaser.Easing.Linear.None, true).onComplete.add(function () {
            game.add.tween(black_sprite).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
              item.destroy();
              //console.log('level_joker', level_joker);
              help_end();
            });
          });
        } else if (free_prebooster2_select == 1) {
          popup = 1;
          animation = 1;
          free_prebooster2 -= 1;
          game.setUserDataAndLog({ free_prebooster2: free_prebooster2 });
          free_prebooster2_select = 0;

          function magic_6(nnn) {
            booster_check = 0;
            cards_group.children.forEach(function (element1) {
              if (
                element1.vis == 1 &&
                element1.value != 101 &&
                element1.value != 102 &&
                element1.value != 103 &&
                element1.value != 105 &&
                element1.value != 104 &&
                element1.hazard_type != 9 &&
                element1.hazard_type != 7 &&
                element1.hazard_type != 8 &&
                element1.hazard_type != 3
              ) {
                booster_check = 1;
              }
            });
            if (booster_check == 1) {
              var aim_card = 0;
              cards_group.children.forEach(function (element1) {
                if (
                  element1.vis == 1 &&
                  element1.value != 101 &&
                  element1.value != 102 &&
                  element1.value != 103 &&
                  element1.value != 105 &&
                  element1.value != 104 &&
                  element1.hazard_type != 9 &&
                  element1.hazard_type != 7 &&
                  element1.hazard_type != 8 &&
                  element1.hazard_type != 3
                ) {
                  if (aim_card == 0) aim_card = element1;
                  else if (game.rnd.integerInRange(0, 2) == 1) aim_card = element1;
                }
              });
              var bullseye_asset = game.add.sprite(
                aim_card.x,
                aim_card.y,
                'game_atlas',
                'bullseye_asset.png',
              );
              bullseye_asset.anchor.setTo(0.5);
              bullseye_asset.scale.setTo(0);
              if (
                aim_card.hazard_type == 1 ||
                aim_card.hazard_type == 2 ||
                aim_card.hazard_type == 4 ||
                aim_card.hazard_type == 5
              ) {
                hazard_cards[aim_card.n].hazard_type = -1;
                aim_card.hazard_type = 0;
              }
              game.add
                .tween(bullseye_asset.scale)
                .to({ x: 1, y: 1 }, 800, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(bullseye_asset.scale)
                    .to({ x: 0, y: 0 }, 200, Phaser.Easing.Linear.None, true, 200)
                    .onComplete.add(function (item) {
                      if (sound_on == 1) {
                        play_sound('Bullseye');
                      }
                      emitter.bringToTop = true;
                      emitter.minParticleSpeed.set(-400, -400);
                      emitter.maxParticleSpeed.set(400, 400);
                      emitter.x = aim_card.x;
                      emitter.y = aim_card.y;
                      emitter.start(true, 500, 0, 20);
                      if (aim_card.hazard_type == 6 || aim_card.ht == 6) {
                        hazard_cards[aim_card.n].hazard_type = -1;
                        aim_card.hazard_type = 0;
                        water_n -= 1;
                        if (water_n == 0) {
                          for (var i = 0; i < hzcol; i++) {
                            if (hazard_cards[i].hazard_type == 7) {
                              game.add
                                .tween(hazard_cards[i])
                                .to({ y: '-200' }, 600, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(hazard_cards[i])
                                .to({ angle: '+360' }, 600, Phaser.Easing.Linear.None, true);
                              game.add
                                .tween(hazard_cards[i])
                                .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 200)
                                .onComplete.add(function (itemn) {
                                  itemn.destroy();
                                  magic_6_check(nnn);
                                });
                              hazard_cards[hazard_cards[i].n].hazard_type = -1;
                              if (sound_on == 1) {
                                play_sound('anchor');
                              }
                            }
                          }
                        } else {
                          game.add
                            .tween(bullseye_asset)
                            .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                            .onComplete.add(function () {
                              magic_6_check(nnn);
                            });
                        }
                        aim_card.destroy();
                      } else {
                        aim_card.destroy();
                        game.add
                          .tween(bullseye_asset)
                          .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function () {
                            magic_6_check(nnn);
                          });
                      }
                    });
                });
            } else {
              help_end();
            }
          }
          function magic_6_check(n) {
            if (n == 0) {
              magic_6(2);
            } else
              if (n == 2) {
                magic_6(1);
              } else {
                game_win();
                game_loss();
                visible_cards(0);
                help_end();
              }
          }
          magic_6(0);

        } else if (free_three > 0) {
          blackf();
          game.time.events.repeat(500, free_three, function () {
            var new_card = game.add.sprite(game.world.centerX, game.world.centerY, 'game5_atlas', backcards_select);
            new_card.anchor.setTo(0.5);
            new_card.scale.setTo(0);
            new_card.alpha = 0;
            game.add.tween(new_card.scale).to({ x: card_size * 2, y: card_size * 2 }, 500, Phaser.Easing.Bounce.Out, true);
            game.add.tween(new_card).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
              game.add.tween(new_card.scale).to({ x: card_size, y: card_size }, 600, Phaser.Easing.Linear.None, true);
              game.add.tween(new_card).to({ angle: 360 }, 600, Phaser.Easing.Linear.None, true);
              game.add.tween(new_card).to({ x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size }, 600, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
                item.destroy();
                cards_deck_col += 1;
                card_text.setText(cards_deck_col - 1 - deck_n);
                deck_change();
              });
            });
            free_three -= 1;
            /*if (free_three <= 0) {
              animation = 0;
              popup = 0;
            }*/
          });
          game.add.tween(effects_group).to({ alpha: 1 }, 1500 + 500 * free_three, Phaser.Easing.Linear.None, true).onComplete.add(function () {
            game.add.tween(black_sprite).to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true).onComplete.add(function (item) {
              item.destroy();
              help_end();
            });
          });
        } else if (magicbeanStage < 2 || baloon == 1) {
          help_level_start();
        } else {
          blackf();
          game.world.bringToTop(popup_group);
          var Character = game.add.sprite(game.camera.x, game.world.height, 'magicbean_atlas', 'Character.png');
          Character.anchor.setTo(0, 1);
          Character.scale.setTo(2, 0);
          popup_group.add(Character);
          var Bean_Prize_4 = game.add.sprite(
            game.world.centerX,
            game.world.centerY,
            'magicbean_atlas',
            'Bean_Prize_4.png',
          );
          Bean_Prize_4.anchor.setTo(0.5);
          Bean_Prize_4.scale.setTo(0);
          popup_group.add(Bean_Prize_4);
          game.add.tween(Character.scale).to({ y: 2 }, 1000, Phaser.Easing.Elastic.Out, true);
          game.add.tween(Bean_Prize_4.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Bounce.Out, true, 500);
          var pause = 0;
          if (magicbeanStage >= 2) {
            var prize_Rays = game.add.sprite(
              game.world.centerX - 300,
              game.world.centerY - 250,
              'game_window2_atlas',
              'Rays.png',
            );
            prize_Rays.anchor.setTo(0.5);
            prize_Rays.scale.setTo(0);
            popup_group.add(prize_Rays);
            game.add.tween(prize_Rays.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 1500);
            rotate_tween(prize_Rays);
            var r1 = game.add.sprite(game.world.centerX, game.world.centerY, 'game_window2_atlas', 'List_Cards.png');
            r1.anchor.setTo(0.5);
            r1.scale.setTo(0);
            r1.alpha = 0;
            popup_group.add(r1);
            game.add.tween(r1.scale).to({ x: 2, y: 2 }, 500, Phaser.Easing.Linear.None, true, 1000);
            game.add.tween(r1).to({ x: '-300', y: '-250' }, 500, Phaser.Easing.Cubic.In, true, 1000);
            game.add.tween(r1).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000);
            pause += 200;
          }
          if (magicbeanStage >= 6) {
            var prize_Rays = game.add.sprite(
              game.world.centerX - 100,
              game.world.centerY - 350,
              'game_window2_atlas',
              'Rays.png',
            );
            prize_Rays.anchor.setTo(0.5);
            prize_Rays.scale.setTo(0);
            popup_group.add(prize_Rays);
            game.add.tween(prize_Rays.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 1500 + pause);
            rotate_tween(prize_Rays);
            var r1 = game.add.sprite(game.world.centerX, game.world.centerY, 'unlimited_energy_atlas', 'Energy.png');
            r1.anchor.setTo(0.5);
            r1.scale.setTo(0);
            r1.alpha = 0;
            popup_group.add(r1);
            game.add.tween(r1.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 1000 + pause);
            game.add.tween(r1).to({ x: '-100', y: '-350' }, 500, Phaser.Easing.Cubic.In, true, 1000 + pause);
            game.add.tween(r1).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000 + pause);
            pause += 200;
          }
          if (magicbeanStage >= 12) {
            var prize_Rays = game.add.sprite(
              game.world.centerX + 100,
              game.world.centerY - 350,
              'game_window2_atlas',
              'Rays.png',
            );
            prize_Rays.anchor.setTo(0.5);
            prize_Rays.scale.setTo(0);
            popup_group.add(prize_Rays);
            game.add.tween(prize_Rays.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 1500 + pause);
            rotate_tween(prize_Rays);
            var r1 = game.add.sprite(game.world.centerX, game.world.centerY, 'game_atlas', 'bullseye_asset.png');
            r1.anchor.setTo(0.5);
            r1.scale.setTo(0);
            r1.alpha = 0;
            popup_group.add(r1);
            game.add.tween(r1.scale).to({ x: 1.5, y: 1.5 }, 500, Phaser.Easing.Linear.None, true, 1000 + pause);
            game.add.tween(r1).to({ x: '+100', y: '-350' }, 500, Phaser.Easing.Cubic.In, true, 1000 + pause);
            game.add.tween(r1).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000 + pause);
            pause += 200;
          }
          if (magicbeanStage >= 20) {
            var prize_Rays = game.add.sprite(
              game.world.centerX + 300,
              game.world.centerY - 250,
              'game_window2_atlas',
              'Rays.png',
            );
            prize_Rays.anchor.setTo(0.5);
            prize_Rays.scale.setTo(0);
            popup_group.add(prize_Rays);
            game.add.tween(prize_Rays.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Bounce.Out, true, 1500 + pause);
            rotate_tween(prize_Rays);
            var r1 = game.add.sprite(game.world.centerX, game.world.centerY, 'game_atlas', 'card101.png');
            r1.anchor.setTo(0.5);
            r1.scale.setTo(0);
            r1.alpha = 0;
            popup_group.add(r1);
            game.add.tween(r1.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Linear.None, true, 1000 + pause);
            game.add.tween(r1).to({ x: '+300', y: '-250' }, 500, Phaser.Easing.Cubic.In, true, 1000 + pause);
            game.add.tween(r1).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 1000 + pause);
          }
          game.add
            .tween(popup_group)
            .to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None, true, 2000 + pause)
            .onComplete.add(function () {
              popup_group.removeAll();
              popup_group.alpha = 1;
              if (magicbeanStage >= 2) {
                var new_card = game.add.sprite(game.world.centerX, game.world.centerY, 'game5_atlas', backcards_select);
                new_card.anchor.setTo(0.5);
                new_card.scale.setTo(0);
                new_card.alpha = 0;
                game.add
                  .tween(new_card.scale)
                  .to({ x: card_size * 2, y: card_size * 2 }, 500, Phaser.Easing.Bounce.Out, true);
                game.add
                  .tween(new_card)
                  .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    game.add
                      .tween(new_card.scale)
                      .to({ x: card_size, y: card_size }, 600, Phaser.Easing.Linear.None, true);
                    game.add.tween(new_card).to({ angle: 360 }, 600, Phaser.Easing.Linear.None, true);
                    game.add
                      .tween(new_card)
                      .to(
                        { x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size },
                        600,
                        Phaser.Easing.Linear.None,
                        true,
                      )
                      .onComplete.add(function (item) {
                        item.destroy();
                        cards_deck_col += 1;
                        card_text.setText(cards_deck_col - 1 - deck_n);
                        deck_change();
                        game.add
                          .tween(black_sprite)
                          .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            item.destroy();
                            if (magicbeanStage >= 12) {
                              function magic_6(nnn) {
                                booster_check = 0;
                                cards_group.children.forEach(function (element1) {
                                  if (
                                    element1.vis == 1 &&
                                    element1.value != 101 &&
                                    element1.value != 102 &&
                                    element1.value != 103 &&
                                    element1.value != 105 &&
                                    element1.value != 104 &&
                                    element1.hazard_type != 9 &&
                                    element1.hazard_type != 7 &&
                                    element1.hazard_type != 8 &&
                                    element1.hazard_type != 3
                                  ) {
                                    booster_check = 1;
                                  }
                                });
                                if (booster_check == 1) {
                                  var aim_card = 0;
                                  cards_group.children.forEach(function (element1) {
                                    if (
                                      element1.vis == 1 &&
                                      element1.value != 101 &&
                                      element1.value != 102 &&
                                      element1.value != 103 &&
                                      element1.value != 105 &&
                                      element1.value != 104 &&
                                      element1.hazard_type != 9 &&
                                      element1.hazard_type != 7 &&
                                      element1.hazard_type != 8 &&
                                      element1.hazard_type != 3
                                    ) {
                                      if (aim_card == 0) aim_card = element1;
                                      else if (game.rnd.integerInRange(0, 2) == 1) aim_card = element1;
                                    }
                                  });
                                  var bullseye_asset = game.add.sprite(
                                    aim_card.x,
                                    aim_card.y,
                                    'game_atlas',
                                    'bullseye_asset.png',
                                  );
                                  bullseye_asset.anchor.setTo(0.5);
                                  bullseye_asset.scale.setTo(0);
                                  if (
                                    aim_card.hazard_type == 1 ||
                                    aim_card.hazard_type == 2 ||
                                    aim_card.hazard_type == 4 ||
                                    aim_card.hazard_type == 5
                                  ) {
                                    hazard_cards[aim_card.n].hazard_type = -1;
                                    aim_card.hazard_type = 0;
                                  }
                                  game.add
                                    .tween(bullseye_asset.scale)
                                    .to({ x: 1, y: 1 }, 800, Phaser.Easing.Linear.None, true)
                                    .onComplete.add(function (item) {
                                      game.add
                                        .tween(bullseye_asset.scale)
                                        .to({ x: 0, y: 0 }, 200, Phaser.Easing.Linear.None, true, 200)
                                        .onComplete.add(function (item) {
                                          if (sound_on == 1) {
                                            play_sound('Bullseye');
                                          }
                                          emitter.bringToTop = true;
                                          emitter.minParticleSpeed.set(-400, -400);
                                          emitter.maxParticleSpeed.set(400, 400);
                                          emitter.x = aim_card.x;
                                          emitter.y = aim_card.y;
                                          emitter.start(true, 500, 0, 20);
                                          if (aim_card.hazard_type == 6 || aim_card.ht == 6) {
                                            hazard_cards[aim_card.n].hazard_type = -1;
                                            aim_card.hazard_type = 0;
                                            water_n -= 1;
                                            if (water_n == 0) {
                                              for (var i = 0; i < hzcol; i++) {
                                                if (hazard_cards[i].hazard_type == 7) {
                                                  game.add
                                                    .tween(hazard_cards[i])
                                                    .to({ y: '-200' }, 600, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(hazard_cards[i])
                                                    .to({ angle: '+360' }, 600, Phaser.Easing.Linear.None, true);
                                                  game.add
                                                    .tween(hazard_cards[i])
                                                    .to({ alpha: 0 }, 400, Phaser.Easing.Linear.None, true, 200)
                                                    .onComplete.add(function (itemn) {
                                                      itemn.destroy();
                                                      magic_6_check(nnn);
                                                    });
                                                  hazard_cards[hazard_cards[i].n].hazard_type = -1;
                                                  if (sound_on == 1) {
                                                    play_sound('anchor');
                                                  }
                                                }
                                              }
                                            } else {
                                              game.add
                                                .tween(bullseye_asset)
                                                .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                                .onComplete.add(function () {
                                                  popup = 0;
                                                  animation = 0;
                                                  magic_6_check(nnn);
                                                });
                                            }
                                            aim_card.destroy();
                                          } else {
                                            aim_card.destroy();
                                            game.add
                                              .tween(bullseye_asset)
                                              .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                              .onComplete.add(function () {
                                                popup = 0;
                                                animation = 0;
                                                magic_6_check(nnn);
                                              });
                                          }
                                        });
                                    });
                                } else {
                                  help_level_start();
                                }
                              }
                              function magic_6_check(n) {
                                if (n == 0) {
                                  popup = 1;
                                  magic_6(1);
                                } else {
                                  game_win();
                                  game_loss();
                                  visible_cards(0);
                                  if (magicbeanStage >= 20) {
                                    popup = 1;
                                    blackf();
                                    var new_card = game.add.sprite(
                                      game.world.centerX,
                                      game.world.centerY,
                                      'game_atlas',
                                      'card101.png',
                                    );
                                    new_card.anchor.setTo(0.5);
                                    new_card.scale.setTo(card_size * 2);
                                    new_card.alpha = 0;
                                    game.add
                                      .tween(new_card.scale)
                                      .to({ x: card_size * 2, y: card_size * 2 }, 500, Phaser.Easing.Bounce.Out, true);
                                    game.add
                                      .tween(new_card)
                                      .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                                      .onComplete.add(function (item) {
                                        game.add
                                          .tween(black_sprite)
                                          .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                                          .onComplete.add(function (item) {
                                            item.destroy();
                                          });
                                        game.add
                                          .tween(new_card)
                                          .to({ angle: 360 }, 500, Phaser.Easing.Linear.None, true);
                                        game.add
                                          .tween(new_card.scale)
                                          .to({ x: 0, y: 0 }, 500, Phaser.Easing.Linear.None, true)
                                          .onComplete.add(function (item) {
                                            var aaa = 0;
                                            cards_group.children.forEach(function (element1) {
                                              if (aaa == 0)
                                                if (
                                                  element1.vis == 0 &&
                                                  element1.value != 101 &&
                                                  element1.value != 102 &&
                                                  element1.value != 103 &&
                                                  element1.value != 105 &&
                                                  element1.value != 104 &&
                                                  element1.hazard_type != 9 &&
                                                  element1.hazard_type != 7 &&
                                                  element1.hazard_type != 8 &&
                                                  element1.hazard_type != 3
                                                ) {
                                                  element1.value = 101;
                                                  element1.draw = 101;
                                                  aaa = 1;
                                                }
                                            });
                                            help_level_start();
                                          });
                                      });
                                  } else {
                                    help_level_start();
                                  }
                                }
                              }
                              magic_6(0);
                            } else {
                              help_level_start();
                            }
                          });
                      });
                  });
              }
            });
        }
      }

      // this is a facebook specific function, so it's not needed for the web version
      function help_window() {
        if (popup == 0) {
          // console.log('helper: ', FBInstant.context.getID(), context_name);
          if (sound_on == 1) {
            play_sound('take_my_help');
          }
          button_click = 0;
          popup_group.y = 0;
          popup_group.y += game.world.height;
          popup = 1;
          hlpw = 1;
          blackf();
          var Blue_Bar = game.add.sprite(game.world.centerX, game.world.centerY, 'ingame_atlas', 'Blue_Bar.png');
          Blue_Bar.anchor.setTo(0.5);
          popup_group.add(Blue_Bar);
          if (level > 3 && context_name != game.cache.getJSON('lang')['t344_1'][0][window.lang]) {
            if (context_avatar != 0 && game.cache.checkImageKey(context_avatar))
              friend_avatar = game.add.image(game.world.centerX - 200, game.world.centerY, context_avatar);
            else
              friend_avatar = game.add.image(
                game.world.centerX - 200,
                game.world.centerY,
                'game_atlas',
                'no_avatar.png',
              );
          } else
            friend_avatar = game.add.sprite(
              game.world.centerX - 200,
              game.world.centerY,
              'game_ui_atlas',
              'lover_small.png',
            );
          friend_avatar.anchor.setTo(0.5);
          friend_avatar.width = friend_avatar.height = 170;
          friend_avatar.angle = -15;
          popup_group.add(friend_avatar);
          var Friend_Frame1 = game.add.sprite(
            game.world.centerX - 200,
            game.world.centerY,
            'ingame_atlas',
            'Friend_Frame1.png',
          );
          Friend_Frame1.anchor.setTo(0.5);
          popup_group.add(Friend_Frame1);
          var Friend_Hat = game.add.sprite(
            game.world.centerX - 230,
            game.world.centerY - 150,
            'ingame_atlas',
            'Friend_Hat.png',
          );
          Friend_Hat.anchor.setTo(0.5, 0.9);
          Friend_Hat.alpha = 0;
          popup_group.add(Friend_Hat);
          var Gift_Background = game.add.sprite(
            game.world.centerX - 50,
            game.world.centerY + 60,
            'ingame_atlas',
            'Gift_Background.png',
          );
          Gift_Background.anchor.setTo(0.5);
          Gift_Background.scale.setTo(0);
          popup_group.add(Gift_Background);
          let boost = -1;
          boost = game.rnd.integerInRange(0, 1);
          if (boost == 0) var graphics_icon = game.add.sprite(0, -10, 'game5_atlas', backcards_select);
          else var graphics_icon = game.add.sprite(0, -10, 'game_ui_atlas', 'Coin_Icon.png');
          graphics_icon.scale.setTo(80 / graphics_icon.width);
          graphics_icon.anchor.setTo(0.5);
          Gift_Background.addChild(graphics_icon);
          var text_help = game.add.text(
            game.world.centerX + 1000,
            game.world.centerY,
            game.cache.getJSON('lang')['t300'][0][window.lang],
            { font: '48px RussoOne', fill: '#11616C', align: 'left' },
          );
          text_help.anchor.setTo(0, 0.5);
          popup_group.addChild(text_help);
          game.add
            .tween(popup_group)
            .to({ y: '-' + game.world.height }, 500, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add
                .tween(Friend_Hat)
                .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add.tween(Friend_Hat).to({ y: '+100' }, 500, Phaser.Easing.Bounce.Out, true);
                });
              game.add.tween(Gift_Background.scale).to({ x: 1, y: 1 }, 300, Phaser.Easing.Linear.None, true);
              game.add.tween(text_help).to({ x: game.world.centerX + 60 }, 600, Phaser.Easing.Bounce.Out, true);

              game.time.events.add(1100, function () {

                if (boost == 0) {
                  var new_card = game.add.sprite(friend_avatar.x, friend_avatar.y, 'game5_atlas', backcards_select);
                  new_card.anchor.setTo(0.5);
                  new_card.scale.setTo(0);
                  game.add
                    .tween(new_card.scale)
                    .to({ x: card_size, y: card_size }, 600, Phaser.Easing.Linear.None, true);
                  game.add
                    .tween(new_card)
                    .to(
                      { x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    )
                    .onComplete.add(function (item) {
                      item.destroy();
                      cards_deck_col += 1;
                      card_text.setText(cards_deck_col - 1 - deck_n);
                      deck_change();
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                      game.add
                        .tween(popup_group)
                        .to({ y: '+' + game.world.height }, 500, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          popup_group.y = 0;
                          popup_group.removeAll();
                          help_end();
                        });
                    });
                }
                else {
                  coins_reward = boost * 10;
                  coins += coins_reward;
                  game.setCurrentEvent();
                  window.eventTrack('coins_in', coins_reward, {
                    user_type: bought,
                    lifetime: lifetime_day,
                    highest_lvl: all_level.lastIndexOf(3) + 2,
                    amount: coins_reward,
                    source: 'Helper',
                    package_id: 0,
                    mission_completed: missioncompleted,
                    c_event: current_event,
                  });

                  // save collected coins
                  game.setUserDataAndLog({ currencies: coins });


                  var coins_t = coins - coins_reward;
                  coins_text.setText(coins_t);
                  var var_coins = 0;
                  game.world.bringToTop(effects_group);
                  if (sound_on == 1) {
                    play_sound('coins_add');
                  }
                  game.time.events.repeat(
                    100,
                    10,
                    function () {
                      var get_coin = game.add.sprite(
                        friend_avatar.x,
                        friend_avatar.y,
                        'game_ui_atlas',
                        'Coin_Icon.png',
                      );
                      get_coin.anchor.setTo(0.5);
                      get_coin.scale.setTo(0);
                      get_coin.alpha = 0;
                      effects_group.add(get_coin);
                      game.add.tween(get_coin).to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true);
                      game.add.tween(get_coin.scale).to({ x: 0.5, y: 0.5 }, 500, Phaser.Easing.Linear.None, true);
                      game.add
                        .tween(get_coin)
                        .to({ x: UI_Coins_BG.x, y: UI_Coins_BG.y }, 600, Phaser.Easing.Linear.None, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                          var_coins += coins_reward / 10;
                          coins_text.setText(Math.ceil(coins_t + var_coins));
                        });
                    },
                    this,
                  );

                  game.time.events.add(1100, function () {
                    game.add
                      .tween(black_sprite)
                      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        item.destroy();
                      });
                    game.add
                      .tween(popup_group)
                      .to({ y: '+' + game.world.height }, 500, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        popup_group.y = 0;
                        popup_group.removeAll();
                        help_end();
                      });
                  });
                }
              },
                this,
              );
            });
        }
      }

      function setting_window() {
        if ((popup == 0 && missions_tab_open == 0 && animation == 0) || (is_map == 0 && popup == 0)) {
          if (sound_on == 1) {
            play_sound('button_press');
          }
          popup_group.y = 0;
          popup_group.y += game.camera.height;
          popup = 1;
          blackf();
          var popup_back = windows_f(game.cache.getJSON('lang')['Settings'][0][window.lang], 10);
          var setting_border = draw_rect(-220, 20, 282, 492, '#A0814F', '#FFFFFF', 0, 0, 0, 0, 40, 0);
          draw_rect(0, 0, 276, 486, '#FFFFFF', '#A0814F', 0, 0, setting_border, 0, 40, 0);
          draw_rect(0, 0, 270, 480, '#EAD7B5', '#E2BE77', 0, 0, setting_border, 0, 30, 0);
          popup_back.addChild(setting_border);
          if (noSocial == 0) {
            var text_v = game.add.text(0, 308, gver, { font: '26px RussoOne', fill: '#9D543D', align: 'center' });
            text_v.anchor.setTo(0.5);
            popup_back.addChild(text_v);
            // var text_userid = game.add.text(
            //   0,
            //   340,
            //   game.cache.getJSON('lang')['t262'][0][window.lang] + ' ' + CurrentUserId,
            //   { font: '26px RussoOne', fill: '#9D543D', align: 'center' },
            // );
            // text_userid.anchor.setTo(0.5);
            // popup_back.addChild(text_userid);
          }
          var girl = game.add.sprite(180, 170, 'char_atlas', 'Main_Thinking.png');
          girl.anchor.setTo(0.5, 1);
          girl.scale.setTo(0);
          popup_back.addChild(girl);
          game.add.tween(girl.scale).to({ x: 1.5, y: 1.5 }, 800, Phaser.Easing.Elastic.Out, true, 300);
          if (is_map == 1) {
            var quit_level_button = draw_rect(180, 190, 408, 135, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
            draw_rect_shadow(0, 0, 374, 102, '#000', '#000', 0, 0, quit_level_button, 500);
            draw_rect(0, 0, 374, 102, '#900108', '#900108', 0, 0, quit_level_button, 0, 500, 0);
            draw_rect(0, 0, 370, 100, '#EE1C25', '#893631', 0, 1, quit_level_button, 0, 500, 0);
            popup_back.addChild(quit_level_button);
            button_animation_f(quit_level_button, 1);
            quit_level_button.events.onInputUp.add(function (item) {
              btnup(item);
              if (popup != 2) {
                popup = 2;
                if (sound_on == 1) {
                  play_sound('button_press');
                }
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    missions_tab_open = 0;
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    reset_question();
                  });
              }
            });
            var quit_level_button_text = game.add.text(0, -2, game.cache.getJSON('lang')['t352'][0][window.lang], {
              font: '38px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            quit_level_button_text.anchor.setTo(0.5);
            quit_level_button.addChild(quit_level_button_text);
          } else {
            var quit_level_button = draw_rect(180, 190, 408, 135, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
            draw_rect_shadow(0, 0, 374, 102, '#000', '#000', 0, 0, quit_level_button, 500);
            draw_rect(0, 0, 374, 102, '#900108', '#900108', 0, 0, quit_level_button, 0, 500, 0);
            draw_rect(0, 0, 370, 100, '#EE1C25', '#893631', 0, 1, quit_level_button, 0, 500, 0);
            popup_back.addChild(quit_level_button);
            button_animation_f(quit_level_button, 1);

            quit_level_button.events.onInputUp.add(function (item) {
              btnup(item);
              if (popup != 2) {
                popup = 2;
                // app.ddna.missionTracker.trackMissionFail({
                //   stars: 0,
                //   levelScore: 0,
                // });



                if (baloon == 1) {
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup = 0;
                      popup_group.y -= game.camera.height;
                      baloon_giveup();
                    });
                } else if (magicbeanDate != 0) {
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup = 0;
                      popup_group.y -= game.camera.height;
                      magicbean_giveup();
                    });
                } else {
                  if (magicbeanStage >= 6) {
                    magicbeanStage = 0;
                    unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() - unlimited_lifesDate_old);
                    LifeDate = 0;
                    game.setUserDataAndLog({
                      lifes: String(lifes),
                      life_time: String(LifeDate),
                      unlimited_lifesDate: String(unlimited_lifesDate),
                      magicbeanStage: magicbeanStage,
                    });
                  }

                  replayed = 1;
                  game.setCurrentEvent();
                  window.eventTrack('level_lost', 1, {
                    nr: level,
                    pre_helper: pre_helper,
                    consumed_5cards_all: consumed_5cards_all,
                    consumed_5Cards: consumed_5Cards,
                    consumed_5Cards_x2: consumed_5Cards_x2,
                    consumed_5Cards_x3: consumed_5Cards_x3,
                    consumed_joker: consumed_joker,
                    consumed_TNT: consumed_TNT,
                    consumed_Shuffle: consumed_Shuffle,
                    consumed_backbutton: consumed_backbutton,
                    consumed_3Helpercards: consumed_3Helpercards,
                    moves_used: moves_used,
                    cards_left: cards_deck_col - 1 - deck_n,
                    p3_cards: p3_cards,
                    user_type: bought,
                    lifetime: lifetime_day,
                    mission_completed: missioncompleted,
                    c_event: current_event,
                  });

                  sdkHandler.trigger(
                    'levelFinish',
                    {
                      level: level,
                      score: all_stars,
                      state: 'lose',
                      callback: function (error) { },
                    },
                    this,
                  );

                  game.fetchAndLogUserData();
                  replayed += 1;
                  game.camera.fade(0xffffff, 1000);
                }
              }
            });
            var quit_level_button_text = game.add.text(0, -2, game.cache.getJSON('lang')['t305'][0][window.lang], {
              font: '32px RussoOne',
              fill: '#fff',
              align: 'center',
            });
            quit_level_button_text.anchor.setTo(0.5);
            quit_level_button.addChild(quit_level_button_text);
          }
          if (music_on == 1) var button_music = game.add.sprite(-220, -120, 'game_window_atlas', 'Music_On.png');
          else var button_music = game.add.sprite(-220, -120, 'game_window_atlas', 'Music_Off.png');
          button_music.anchor.setTo(0.5);
          popup_back.addChild(button_music);
          button_animation_f(button_music, 1);
          button_music.events.onInputDown.add(function (item) {
            btnup(item);
            if (music_on == 1) {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              item.loadTexture('game_window_atlas', 'Music_Off.png', false);
              music_on = 0;
              text_button_music.setText(game.cache.getJSON('lang')['MusicOff'][0][window.lang]);
              game.setUserDataAndLog({ music_on: music_on });
              music.pause();
            } else {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              item.loadTexture('game_window_atlas', 'Music_On.png', false);
              music_on = 1;
              text_button_music.setText(game.cache.getJSON('lang')['MusicOn'][0][window.lang]);
              game.setUserDataAndLog({ music_on: music_on });
              music.play();
            }
          }, this);
          if (sound_on == 1) var button_sound = game.add.sprite(-220, 110, 'game_window_atlas', 'SFX_On.png');
          else var button_sound = game.add.sprite(-220, 110, 'game_window_atlas', 'SFX_Off.png');
          button_sound.anchor.setTo(0.5);
          popup_back.addChild(button_sound);
          button_sound.inputEnabled = true;
          button_animation_f(button_sound, 1);
          button_sound.events.onInputDown.add(function (item) {
            btnup(item);
            if (sound_on == 1) {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              item.loadTexture('game_window_atlas', 'SFX_Off.png', false);
              sound_on = 0;
              text_button_sound.setText(game.cache.getJSON('lang')['SFXOff'][0][window.lang]);
              ambient.pause();
              game.setUserDataAndLog({ sound_on: sound_on });
            } else {
              item.loadTexture('game_window_atlas', 'SFX_On.png', false);
              sound_on = 1;
              text_button_sound.setText(game.cache.getJSON('lang')['SFXOn'][0][window.lang]);
              game.setUserDataAndLog({ sound_on: sound_on });
              if (sound_on == 1) {
                play_sound('button_press');
              }
            }
          }, this);
          var text_button_music = game.add.text(
            button_music.x,
            button_music.y + 120,
            game.cache.getJSON('lang')['MusicOn'][0][window.lang],
            { font: '26px RussoOne', fill: '#9D543D', align: 'center' },
          );
          text_button_music.anchor.setTo(0.5);
          popup_back.addChild(text_button_music);
          var text_button_sound = game.add.text(
            button_sound.x,
            button_sound.y + 120,
            game.cache.getJSON('lang')['SFXOn'][0][window.lang],
            { font: '26px RussoOne', fill: '#9D543D', align: 'center' },
          );
          text_button_sound.anchor.setTo(0.5);
          popup_back.addChild(text_button_sound);
          if (music_on == 0) {
            text_button_music.setText(game.cache.getJSON('lang')['MusicOff'][0][window.lang]);
          } else {
            text_button_music.setText(game.cache.getJSON('lang')['MusicOn'][0][window.lang]);
          }
          if (sound_on == 0) {
            text_button_sound.setText(game.cache.getJSON('lang')['SFXOff'][0][window.lang]);
          } else {
            text_button_sound.setText(game.cache.getJSON('lang')['SFXOn'][0][window.lang]);
          }
          game.add
            .tween(popup_group)
            .to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true)
            .onComplete.add(function (item) { });
        }
      }

      function magicbean_giveup() {
        if (popup == 0) {
          if (sound_on == 1) {
            play_sound('button_press');
          }
          if (magicbeanStage >= 2) {
            popup_group.y = 0;
            popup_group.y += game.camera.height;
            popup = 1;
            blackf();
            var popup_back = windows_f(game.cache.getJSON('lang')['t488'][0][window.lang], 33);
            var Speech_Bubble = game.add.sprite(0, -180, 'magicbean_atlas', 'Speech_Bubble.png');
            Speech_Bubble.scale.setTo(2);
            Speech_Bubble.anchor.setTo(0.5);
            popup_back.addChild(Speech_Bubble);
            var Speech_Bubble_text = game.add.text(18, 0, game.cache.getJSON('lang')['t489'][0][window.lang], {
              font: '18px RussoOne',
              fill: '#8B3C33',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 300,
            });
            Speech_Bubble_text.anchor.setTo(0.5);
            Speech_Bubble.addChild(Speech_Bubble_text);
            var girl = game.add.sprite(
              game.camera.width / 2 - 1000,
              game.camera.height,
              'char_atlas',
              'Main_Scared.png',
            );
            girl.scale.setTo(2.6);
            girl.anchor.setTo(0.5, 1);
            popup_group.add(girl);
            var items_text = game.add.text(0, -20, game.cache.getJSON('lang')['t490'][0][window.lang], {
              font: '24px RussoOne',
              fill: '#0E6C97',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 500,
            });
            items_text.anchor.setTo(0.5);
            items_text.stroke = '#fff';
            items_text.strokeThickness = 4;
            popup_back.addChild(items_text);
            if (magicbeanStage >= 2) {
              var item_icon = game.add.sprite(-300, 50, 'game_window2_atlas', 'List_Cards.png');
              item_icon.anchor.setTo(0.5);
              popup_back.addChild(item_icon);
              var item_text = game.add.text(-250, 50, game.cache.getJSON('lang')['t499'][0][window.lang], {
                font: '28px RussoOne',
                fill: '#fff',
                align: 'left',
              });
              item_text.anchor.setTo(0, 0.5);
              item_text.stroke = '#0C6993';
              item_text.strokeThickness = 4;
              popup_back.addChild(item_text);
            }
            if (magicbeanStage >= 6) {
              var item_icon = game.add.sprite(50, 50, 'unlimited_energy_atlas', 'Energy.png');
              item_icon.anchor.setTo(0.5);
              item_icon.scale.setTo(0.5);
              popup_back.addChild(item_icon);
              var item_text = game.add.text(100, 50, game.cache.getJSON('lang')['UnlimitedEnergy'][0][window.lang], {
                font: '28px RussoOne',
                fill: '#fff',
                align: 'left',
              });
              item_text.anchor.setTo(0, 0.5);
              item_text.stroke = '#0C6993';
              item_text.strokeThickness = 4;
              popup_back.addChild(item_text);
            }
            if (magicbeanStage >= 12) {
              var item_icon = game.add.sprite(-300, 130, 'game_atlas', 'bullseye_asset.png');
              item_icon.anchor.setTo(0.5);
              item_icon.scale.setTo(0.7);
              popup_back.addChild(item_icon);
              var item_text = game.add.text(-250, 130, game.cache.getJSON('lang')['t501'][0][window.lang], {
                font: '28px RussoOne',
                fill: '#fff',
                align: 'left',
              });
              item_text.anchor.setTo(0, 0.5);
              item_text.stroke = '#0C6993';
              item_text.strokeThickness = 4;
              popup_back.addChild(item_text);
            }
            if (magicbeanStage >= 20) {
              var item_icon = game.add.sprite(50, 130, 'game_atlas', 'card101.png');
              item_icon.scale.setTo(0.45);
              item_icon.anchor.setTo(0.5);
              popup_back.addChild(item_icon);
              var item_text = game.add.text(100, 130, game.cache.getJSON('lang')['t500'][0][window.lang], {
                font: '28px RussoOne',
                fill: '#fff',
                align: 'left',
              });
              item_text.anchor.setTo(0, 0.5);
              item_text.stroke = '#0C6993';
              item_text.strokeThickness = 4;
              popup_back.addChild(item_text);
            }
            var button_green = game.add.sprite(200, 270, 'game_window_atlas', 'Green_Button.png');
            button_green.anchor.setTo(0.5);
            button_animation_f(button_green, 1);
            button_green.events.onInputUp.add(function (item) {
              btnup(item);
              if (popup != 2) {
                if (sound_on == 1) {
                  play_sound('button_press');
                }
                popup = 2;
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                  });
              }
            }, this);
            popup_back.addChild(button_green);
            var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['Continue'][0][window.lang], {
              font: '48px RussoOne',
              fill: '#fff',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 260,
            });
            text_button_green.anchor.setTo(0.5);
            text_button_green.lineSpacing = -10;
            text_button_green.stroke = '#457310';
            text_button_green.strokeThickness = 4;
            text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
            button_green.addChild(text_button_green);
            game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
            var button_green = draw_rect(-200, 270, 408 * 0.9, 135 * 0.9, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
            draw_rect_shadow(0, 0, 374 * 0.9, 102 * 0.9, '#000', '#000', 0, 0, button_green, 500);
            draw_rect(0, 0, 374 * 0.9, 102 * 0.9, '#900108', '#900108', 0, 0, button_green, 0, 500, 0);
            draw_rect(0, 0, 370 * 0.9, 100 * 0.9, '#EE1C25', '#893631', 0, 1, button_green, 0, 500, 0);
            button_animation_f(button_green, 1);
            button_green.events.onInputUp.add(function (item) {
              btnup(item);
              if (popup != 2) {
                magicbeanStage = 0;
                unlimited_lifesDate = 0;
                LifeDate = 0;
                game.setUserDataAndLog({
                  lifes: String(lifes),
                  life_time: String(LifeDate),
                  unlimited_lifesDate: String(unlimited_lifesDate),
                  magicbeanStage: magicbeanStage,
                });
                if (sound_on == 1) {
                  play_sound('button_press');
                }
                game.setCurrentEvent();
                replayed = 1;
                window.eventTrack('level_lost', 1, {
                  nr: level,
                  pre_helper: pre_helper,
                  consumed_5cards_all: consumed_5cards_all,
                  consumed_5Cards: consumed_5Cards,
                  consumed_5Cards_x2: consumed_5Cards_x2,
                  consumed_5Cards_x3: consumed_5Cards_x3,
                  consumed_joker: consumed_joker,
                  consumed_TNT: consumed_TNT,
                  consumed_Shuffle: consumed_Shuffle,
                  consumed_backbutton: consumed_backbutton,
                  consumed_3Helpercards: consumed_3Helpercards,
                  moves_used: moves_used,
                  cards_left: cards_deck_col - 1 - deck_n,
                  p3_cards: p3_cards,
                  user_type: bought,
                  lifetime: lifetime_day,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                popup = 2;
                game.camera.fade(0xffffff, 1000);

                sdkHandler.trigger(
                  'levelFinish',
                  {
                    level: level,
                    score: all_stars,
                    state: 'lose',
                    callback: function (error) { },
                  },
                  this,
                );

              }
            }, this);
            popup_back.addChild(button_green);
            var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t298'][0][window.lang], {
              font: '42px RussoOne',
              fill: '#fff',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 260,
            });
            text_button_green.anchor.setTo(0.5);
            text_button_green.lineSpacing = -10;
            text_button_green.stroke = '#457310';
            text_button_green.strokeThickness = 4;
            text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
            button_green.addChild(text_button_green);
            game.add
              .tween(popup_group)
              .to({ y: '-' + game.world.height }, 500, Phaser.Easing.Exponential.Out, true)
              .onComplete.add(function (item) { });
          } else {
            magicbeanStage = 0;
            game.setUserDataAndLog({ magicbeanStage: magicbeanStage });
            popup = 2;
            game.camera.fade(0xffffff, 1000);
          }
        }
      }

      function baloon_giveup() {
        if (popup == 0) {
          if (sound_on == 1) {
            play_sound('button_press');
          }
          if (
            all_prize_mas[0] != 0 ||
            all_prize_mas[1] != 0 ||
            all_prize_mas[2] != 0 ||
            all_prize_mas[3] != 0 ||
            all_prize_mas[4] != 0 ||
            all_prize_mas[5] != 0 ||
            all_prize_mas[6] != 0
          ) {
            popup_group.y = 0;
            popup_group.y += game.camera.height;
            popup = 1;
            blackf();
            var popup_back = windows_f(game.cache.getJSON('lang')['t488'][0][window.lang], 3);
            var Speech_Bubble = game.add.sprite(0, -180, 'baloon_atlas', 'Speech_Bubble.png');
            Speech_Bubble.scale.setTo(2);
            Speech_Bubble.anchor.setTo(0.5);
            popup_back.addChild(Speech_Bubble);
            var Speech_Bubble_text = game.add.text(18, 0, game.cache.getJSON('lang')['t489'][0][window.lang], {
              font: '18px RussoOne',
              fill: '#8B3C33',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 300,
            });
            Speech_Bubble_text.anchor.setTo(0.5);
            Speech_Bubble.addChild(Speech_Bubble_text);
            var girl = game.add.sprite(
              game.camera.width / 2 - 1000,
              game.camera.height,
              'char_atlas',
              'Main_Scared.png',
            );
            girl.scale.setTo(2.6);
            girl.anchor.setTo(0.5, 1);
            popup_group.add(girl);
            var items_text = game.add.text(0, -20, game.cache.getJSON('lang')['t490'][0][window.lang], {
              font: '24px RussoOne',
              fill: '#0E6C97',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 500,
            });
            items_text.anchor.setTo(0.5);
            items_text.stroke = '#fff';
            items_text.strokeThickness = 4;
            popup_back.addChild(items_text);
            var ppp = 0;
            for (var i = 0; i < all_prize_mas.length; i++) {
              if (all_prize_mas[i] != 0) {
                let spr = 'List_Coin.png';
                let atlas = 'game_window2_atlas';
                let col = 0;
                let scl = 1;
                col = all_prize_mas[i];
                if (i == 0) {
                  spr = 'List_Coin.png';
                } else if (i == 1) {
                  spr = 'List_Energy.png';
                } else if (i == 2) {
                  spr = 'List_Joker.png';
                } else if (i == 3) {
                  spr = 'List_Cards.png';
                } else if (i == 4) {
                  spr = 'List_Card_Back.png';
                } else if (i == 5) {
                  spr = 'tnt_booster.png';
                  atlas = 'game_atlas';
                  scl = 0.5;
                } else if (i == 6) {
                  spr = 'shuffle_booster.png';
                  atlas = 'game_atlas';
                  scl = 0.5;
                } else if (i == 7) {
                  spr = 'bullseye_booster.png';
                  atlas = 'game_atlas';
                  scl = 0.5;
                }
                if (ppp == 0) var item_icon = game.add.sprite(-150, 70, atlas, spr);
                else if (ppp == 1) var item_icon = game.add.sprite(100, 70, atlas, spr);
                else if (ppp == 2) var item_icon = game.add.sprite(-150, 170, atlas, spr);
                else if (ppp == 3) var item_icon = game.add.sprite(100, 170, atlas, spr);
                else if (ppp == 4) var item_icon = game.add.sprite(-350, 70, atlas, spr);
                else if (ppp == 5) var item_icon = game.add.sprite(300, 70, atlas, spr);
                else if (ppp == 6) var item_icon = game.add.sprite(-350, 170, atlas, spr);
                item_icon.anchor.setTo(0.5);
                item_icon.scale.setTo(scl);
                popup_back.addChild(item_icon);
                if (ppp == 0)
                  var item_text = game.add.text(-100, 70, 'x' + col, {
                    font: '32px RussoOne',
                    fill: '#fff',
                    align: 'left',
                  });
                else if (ppp == 1)
                  var item_text = game.add.text(150, 70, 'x' + col, {
                    font: '32px RussoOne',
                    fill: '#fff',
                    align: 'left',
                  });
                else if (ppp == 2)
                  var item_text = game.add.text(-100, 170, 'x' + col, {
                    font: '32px RussoOne',
                    fill: '#fff',
                    align: 'left',
                  });
                else if (ppp == 3)
                  var item_text = game.add.text(150, 170, 'x' + col, {
                    font: '32px RussoOne',
                    fill: '#fff',
                    align: 'left',
                  });
                else if (ppp == 4)
                  var item_text = game.add.text(-300, 70, 'x' + col, {
                    font: '32px RussoOne',
                    fill: '#fff',
                    align: 'left',
                  });
                else if (ppp == 5)
                  var item_text = game.add.text(350, 70, 'x' + col, {
                    font: '32px RussoOne',
                    fill: '#fff',
                    align: 'left',
                  });
                else if (ppp == 6)
                  var item_text = game.add.text(-300, 170, 'x' + col, {
                    font: '32px RussoOne',
                    fill: '#fff',
                    align: 'left',
                  });
                item_text.anchor.setTo(0, 0.5);
                item_text.stroke = '#0C6993';
                item_text.strokeThickness = 4;
                popup_back.addChild(item_text);
                ppp++;
              }
            }
            var button_green = game.add.sprite(200, 270, 'game_window_atlas', 'Green_Button.png');
            button_green.anchor.setTo(0.5);
            button_animation_f(button_green, 1);
            button_green.events.onInputUp.add(function (item) {
              btnup(item);
              if (popup != 2) {
                if (sound_on == 1) {
                  play_sound('button_press');
                }
                popup = 2;
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                  });
              }
            }, this);
            popup_back.addChild(button_green);
            var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['Continue'][0][window.lang], {
              font: '48px RussoOne',
              fill: '#fff',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 260,
            });
            text_button_green.anchor.setTo(0.5);
            text_button_green.lineSpacing = -10;
            text_button_green.stroke = '#457310';
            text_button_green.strokeThickness = 4;
            text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
            button_green.addChild(text_button_green);
            game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
            var button_green = draw_rect(-200, 270, 408 * 0.9, 135 * 0.9, '#FFFFB2', '#EB942D', 0, 0, 0, 5, 500, 0, 0);
            draw_rect_shadow(0, 0, 374 * 0.9, 102 * 0.9, '#000', '#000', 0, 0, button_green, 500);
            draw_rect(0, 0, 374 * 0.9, 102 * 0.9, '#900108', '#900108', 0, 0, button_green, 0, 500, 0);
            draw_rect(0, 0, 370 * 0.9, 100 * 0.9, '#EE1C25', '#893631', 0, 1, button_green, 0, 500, 0);
            button_animation_f(button_green, 1);
            button_green.events.onInputUp.add(function (item) {
              btnup(item);
              if (popup != 2) {
                all_prize_mas = [0, 0, 0, 0, 0, 0, 0];
                if (sound_on == 1) {
                  play_sound('button_press');
                }
                game.setCurrentEvent();
                replayed = 1;
                window.eventTrack('level_lost', 1, {
                  nr: level,
                  pre_helper: pre_helper,
                  consumed_5cards_all: consumed_5cards_all,
                  consumed_5Cards: consumed_5Cards,
                  consumed_5Cards_x2: consumed_5Cards_x2,
                  consumed_5Cards_x3: consumed_5Cards_x3,
                  consumed_joker: consumed_joker,
                  consumed_TNT: consumed_TNT,
                  consumed_Shuffle: consumed_Shuffle,
                  consumed_backbutton: consumed_backbutton,
                  consumed_3Helpercards: consumed_3Helpercards,
                  moves_used: moves_used,
                  cards_left: cards_deck_col - 1 - deck_n,
                  p3_cards: p3_cards,
                  user_type: bought,
                  lifetime: lifetime_day,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                popup = 2;
                game.camera.fade(0xffffff, 1000);

                sdkHandler.trigger(
                  'levelFinish',
                  {
                    level: level,
                    score: all_stars,
                    state: 'lose',
                    callback: function (error) { },
                  },
                  this,
                );

              }
            }, this);
            popup_back.addChild(button_green);
            var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t298'][0][window.lang], {
              font: '42px RussoOne',
              fill: '#fff',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 260,
            });
            text_button_green.anchor.setTo(0.5);
            text_button_green.lineSpacing = -10;
            text_button_green.stroke = '#457310';
            text_button_green.strokeThickness = 4;
            text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
            button_green.addChild(text_button_green);
            game.add
              .tween(popup_group)
              .to({ y: '-' + game.world.height }, 500, Phaser.Easing.Exponential.Out, true)
              .onComplete.add(function (item) { });
          } else {
            popup = 2;
            game.camera.fade(0xffffff, 1000);
          }
        }
      }
      game.camera.onFadeComplete.add(function () {
        if (popup != 111) {
          if (fbv == 1 && level == 6) {
            window.eventTrack('FTUE_11_0Map_loaded');
          }
          if (fbv == 1 && level == 7) {
            window.eventTrack('FTUE_13_0Map_loaded');
          }
          if (fbv == 1 && level == 8) {
            window.eventTrack('FTUE_14_0Map_loaded');
          }
          if (fbv == 1 && level == 9) {
            window.eventTrack('FTUE_15_0Map_loaded');
          }
          if (fbv == 1 && level == 10) {
            window.eventTrack('FTUE_16_0Map_loaded');
          }
          if (fbv == 1 && level == 11) {
            window.eventTrack('FTUE_17_0Map_loaded');
          }
          if (timerId6 != 0) {
            clearInterval(timerId6);
          }
          game.world.removeAll(true);
          game.state.start('Map');
        }
      }, this);
      function sAge(i, ii) {
        if (i['score'] > ii['score']) return -1;
        else if (i['score'] < ii['score']) return 1;
        else return 0;
      }

      function get_popup(type) {
        if (popup == 0) {
          if (type == 1) {
            if (sound_on == 1) {
              play_sound('level_win_music');
            }
          }
          if (type == 2) {
            if (sound_on == 1) {
              play_sound('level_loss_popup_music');
            }
          }
          leader_group.x = 0;
          leader_group.y = 0;
          popup_group.y = game.world.height;
          popup = 1;
          var sss1 = 0;
          var sss2 = 0;
          {
            if (type == 1) {
              if (win_status > 0 && win_status < 10000) {
                if (win_status < 5) win_status += 1;
              }
              if (win_status < 0) win_status -= 1;
            } else {
              if (win_status >= 0) win_status = -1;
              else win_status -= 1;
            }
            if (cards_deck_col - 1 - deck_n == 0 && type == 1) {
              //win_status = 10000;
            }
            var background_share_img = 0;
            var r_text = '';
            if (win_status == 0 && level == 1) {
              win_status++;
            } else if (win_status == 5 && win_status < 1000) {
              r_text = game.cache.getJSON('lang')['t301'][0][window.lang];
              r_text = r_text.replace('[x]', win_status);
              background_share_img = 'FB_POST_Won_X_Levels_In_Row.png';
              win_status++;
              sss1 = 0;
              sss2 = 55;
            } else if (win_status == -3 && level > 1) {
              r_text = game.cache.getJSON('lang')['t302'][0][window.lang];
              r_text = r_text.replace('[x]', level);
              win_status = 1;
              background_share_img = 'FB_POST_Level_Too_Hard.png';
              sss1 = 40;
              sss2 = 80;
            } else if (win_status <= -5 && type == 1) {
              r_text = game.cache.getJSON('lang')['t303'][0][window.lang];
              r_text = r_text.replace('[x]', level);
              r_text = r_text.replace('[Y]', Math.abs(win_status));
              background_share_img = 'FB_POST_Finally_Beat_Level_X.png';
              sss1 = -5;
              sss2 = 50;
            } else if (win_status == 10000) {
              r_text = game.cache.getJSON('lang')['t304'][0][window.lang];
              r_text = r_text.replace('[x]', level);
              background_share_img = 'FB_POST_Match_Last_Card.png';
              win_status = 0;
              sss1 = 5;
              sss2 = 60;
            } else if (win_status < 0 && type == 1) {
              win_status = 1;
            } else if (win_status == 0) {
              win_status++;
            }
            if (background_share_img != 0 && fbv == 1 && baloon == 0 && xmas == 0) {
              if (sound_on == 1) {
                play_sound('share_moment');
              }
              var popup_close = game.add.sprite(game.world.centerX + 600, 100, 'ingame_atlas', 'Close_Button.png');
              popup_close.anchor.setTo(0.5);
              button_animation_f(popup_close, 1);
              popup_close.events.onInputUp.add(function () {
                if (popup != 2) {
                  popup = 2;
                  game.camera.fade(0xffffff, 1000);
                }
              }, this);
              popup_group.add(popup_close);
              var user_avatar = game.add.image(
                game.world.centerX,
                game.world.centerY + sss1,
                'game_atlas',
                'no_avatar.png',
              );
              user_avatar.anchor.setTo(0.5);
              user_avatar.width = user_avatar.height = 220;
              user_avatar.angle = 1;
              popup_group.add(user_avatar);
              if (game.cache.checkImageKey('c_user_avatar') == true) {
                user_avatar.loadTexture('c_user_avatar');
                user_avatar.width = user_avatar.height = 220;
              }
              var background_share = game.add.sprite(
                game.world.centerX,
                game.world.centerY - 80,
                'ingame_atlas',
                background_share_img,
              );
              background_share.anchor.setTo(0.5);
              background_share.scale.setTo(1.5);
              popup_group.add(background_share);
              var result_text = game.add.text(game.world.centerX, game.world.centerY + 250, r_text, {
                font: '34px RussoOne',
                fill: '#fff',
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 1000,
              });
              result_text.anchor.setTo(0.5);
              popup_group.add(result_text);
              result_text.lineSpacing = -10;
              var button_green = game.add.sprite(
                game.world.centerX,
                game.world.centerY + 410,
                'ingame_atlas',
                'Green_Button.png',
              );
              button_green.anchor.setTo(0.5);
              button_green.inputEnabled = true;
              button_green.r_text = r_text;
              button_animation_f(button_green, 1);
              button_green.events.onInputUp.add(function (item) {
                btnup(item);
                if (popup != 2) {
                  popup = 2;
                  let group = game.add.group();
                  group.y = -200;
                  var user_avatar = game.add.image(200, 200 + sss2, 'game_atlas', 'no_avatar.png');
                  user_avatar.anchor.setTo(0.5);
                  user_avatar.width = user_avatar.height = 148;
                  user_avatar.angle = 1;
                  group.add(user_avatar);
                  if (game.cache.checkImageKey('c_user_avatar') == true) {
                    user_avatar.loadTexture('c_user_avatar');
                    user_avatar.width = user_avatar.height = 148;
                  }
                  var message_invite = game.add.sprite(200, 200, 'ingame_atlas', background_share_img);
                  message_invite.anchor.setTo(0.5);
                  group.add(message_invite);
                  var result_text = game.add.text(205, 370, item.r_text, {
                    font: '24px RussoOne',
                    fill: '#fff',
                    align: 'center',
                    wordWrap: true,
                    wordWrapWidth: 360,
                  });
                  result_text.anchor.setTo(0.5);
                  group.add(result_text);
                  result_text.lineSpacing = -10;
                  result_text.stroke = '#000';
                  result_text.strokeThickness = 2;
                  result_text.setShadow(0, 2, 'rgba(0,0,0,0.9)', 0);
                  group.inputEnabled = false;
                  group.y = 0;
                  let group2 = game.add.group();
                  group2.addChild(group);
                  var renderTexture = game.make.renderTexture(400, 400);
                  renderTexture.render(group2);
                  group2.destroy();
                  loading();

                  console.log("%cRemoved share async called!", "color:orange");

                  popup = 2;
                  if (loading_black_sprite != 0) {
                    loading_black_sprite.destroy();
                    loading_black_sprite = 0;
                  }
                  if (loading_text != 0 && loading_text != 1) {
                    loading_text.destroy();
                    loading_text = 0;
                  }
                  loading_text = 1;
                  game.camera.fade(0xffffff, 1000);

                  // shareAsync(
                  //   {
                  //     intent: 'SHARE',
                  //     image: renderTexture.getBase64(),
                  //     text: item.r_text,
                  //     data: {},
                  //   },
                  //   {
                  //     actionLevel: level,
                  //     targetUserID: null,
                  //     socialActionType: DdnaSocialActionType.ShareLevelEnd,
                  //     socialRewardType: DdnaSocialRewardType.No,
                  //   },
                  // )
                  //   .then(function () {
                  //     popup = 2;
                  //     if (loading_black_sprite != 0) {
                  //       loading_black_sprite.destroy();
                  //       loading_black_sprite = 0;
                  //     }
                  //     if (loading_text != 0 && loading_text != 1) {
                  //       loading_text.destroy();
                  //       loading_text = 0;
                  //     }
                  //     loading_text = 1;
                  //     game.camera.fade(0xffffff, 1000);
                  //   })
                  //   .catch(function (error) {
                  //     popup = 2;
                  //     if (loading_black_sprite != 0) {
                  //       loading_black_sprite.destroy();
                  //       loading_black_sprite = 0;
                  //     }
                  //     if (loading_text != 0 && loading_text != 1) {
                  //       loading_text.destroy();
                  //       loading_text = 0;
                  //     }
                  //     loading_text = 1;
                  //     game.camera.fade(0xffffff, 1000);
                  //   });
                }
              });
              popup_group.add(button_green);
              var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t259'][0][window.lang], {
                font: '48px RussoOne',
                fill: '#fff',
                align: 'center',
              });
              text_button_green.anchor.setTo(0.5);
              text_button_green.stroke = '#47740D';
              text_button_green.strokeThickness = 4;
              text_button_green.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
              button_green.addChild(text_button_green);
            } else {
              popup = 2;
              game.camera.fade(0xffffff, 1000);
            }
          }
          game.add
            .tween(popup_group)
            .to({ y: 0 }, 500, Phaser.Easing.Exponential.Out, true)
            .onComplete.add(function (item) { });
        }
      }

      effects_group = game.add.group();
      function ok_message(type, num, text) {
        //1 - lives, 2 - coins
        if (popup == 0) {
          popup_group.y = game.world.height;
          popup = 1;
          blackf();
          var popup_back = game.add.sprite(game.world.centerX, game.world.centerY, 'game_atlas', 'popup_back2.png');
          popup_back.anchor.setTo(0.5);
          popup_group.add(popup_back);
          if (type != 3) {
            var popup_close = game.add.sprite(
              game.world.centerX + 273,
              game.world.centerY - 215,
              'game_atlas',
              'popup_close.png',
            );
            popup_close.anchor.setTo(0.5);
            button_animation_f(popup_close, 1);
            popup_close.events.onInputUp.add(function () {
              if (popup != 2) {
                if (sound_on == 1) {
                  play_sound('button_X');
                }
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.world.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.world.height;
                  });
              }
            }, this);
            popup_group.add(popup_close);
          }
          if (type == 1)
            var ui_lives_icon = game.add.sprite(
              game.world.centerX,
              game.world.centerY - 40,
              'game_atlas',
              'ui_lives_icon.png',
            );
          else
            var ui_lives_icon = game.add.sprite(
              game.world.centerX,
              game.world.centerY - 40,
              'game_atlas',
              'ui_coins_icon.png',
            );
          ui_lives_icon.anchor.setTo(0.5);
          popup_group.add(ui_lives_icon);
          if (text) {
            text_popup_title = game.add.text(game.world.centerX, game.world.centerY - 160, text, {
              font: '34px RussoOne',
              fill: '#9D543D',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 520,
            });
          } else {
            if (type == 1) {
              var p_text = game.cache.getJSON('lang')['GotXLife'][0][window.lang];
              p_text = p_text.replace('[x]', num);
              text_popup_title = game.add.text(game.world.centerX, game.world.centerY - 160, p_text, {
                font: '34px RussoOne',
                fill: '#9D543D',
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 520,
              });
            } else
              text_popup_title = game.add.text(
                game.world.centerX,
                game.world.centerY - 160,
                game.cache.getJSON('lang')['ReceivedCoins'][0][window.lang],
                { font: '34px RussoOne', fill: '#9D543D', align: 'center', wordWrap: true, wordWrapWidth: 520 },
              );
          }
          text_popup_title.lineSpacing = -10;
          text_popup_title.anchor.setTo(0.5);
          popup_group.add(text_popup_title);
          if (type == 2 || type == 3) {
            var p_text = game.cache.getJSON('lang')['GotXCoins'][0][window.lang];
            p_text = p_text.replace('[x]', num);
            text_popup_text = game.add.text(game.world.centerX, game.world.centerY + 70, p_text, {
              font: '26px RussoOne',
              fill: '#9D543D',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 450,
            });
            text_popup_text.anchor.setTo(0.5);
            popup_group.add(text_popup_text);
          }
          var button_green = game.add.sprite(
            game.world.centerX,
            game.world.centerY + 150,
            'game_atlas',
            'button_green.png',
          );
          button_green.anchor.setTo(0.5);
          button_green.scale.setTo(0.75);
          button_green.inputEnabled = true;
          button_green.scl = 0.75;
          button_green.events.onInputOver.add(btnover, this);
          button_green.events.onInputOut.add(btnout, this);
          button_green.events.onInputDown.add(btnclick, this);
          button_green.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              if (sound_on == 1) {
                play_sound('button_X');
              }
              if (type == 3) {
                popup = 2;
                game.camera.fade(0xffffff, 1000);
              } else {
                let coinstext = coins - num;
                coins_text.setText(coinstext);
                var var_coins = 0;
                if (sound_on == 1) {
                  play_sound('coins_add');
                }
                game.time.events.repeat(
                  100,
                  10,
                  function () {
                    var get_coin = game.add.sprite(
                      game.world.centerX + game.rnd.integerInRange(-50, 50),
                      game.world.centerY + game.rnd.integerInRange(-50, 50),
                      'game_atlas',
                      'icon_coins.png',
                    );
                    get_coin.anchor.setTo(0.5);
                    get_coin.scale.setTo(0);
                    get_coin.alpha = 0;
                    effects_group.add(get_coin);
                    game.add.tween(get_coin).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                    game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Linear.None, true);
                    game.add
                      .tween(get_coin)
                      .to({ x: UI_Coins_BG.x, y: UI_Coins_BG.y }, 600, Phaser.Easing.Linear.None, true)
                      .onComplete.add(function (item) {
                        item.destroy();
                        var_coins += num / 10;
                        coins_text.setText(Math.ceil(coinstext + var_coins));
                      });
                  },
                  this,
                );
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.world.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.world.height;
                  });
              }
            }
          }, this);
          popup_group.add(button_green);
          var text_button_green = game.add.text(game.world.centerX, game.world.centerY + 150, 'OK', {
            font: '26px RussoOne',
            fill: '#fff',
            align: 'center',
          });
          text_button_green.anchor.setTo(0.5);
          popup_group.add(text_button_green);
          game.add
            .tween(popup_group)
            .to({ y: '-' + game.world.height }, 500, Phaser.Easing.Exponential.Out, true)
            .onComplete.add(function (item) { });
        }
      }
      if (unlimited_energy_h == 0) {
        unlimited_energy_h = get_random_change([1, 3, 12, 24, 48]);
      }
      function get_message(type) {
        //1 - lives, 2 - coins
        if (popup == 0) {
          popup_group.y = 0;
          popup_group.y += game.camera.height;
          popup = 1;
          blackf();
          console.log(unlimited_lifesDate, type);
          if (unlimited_lifesDate == 0 && type != 2) {
            var buttontimer = setInterval(function () {
              if (payments_catalog.length > 0) {
                clearInterval(buttontimer);
                var p_id = 0;
                var p_price = 0;
                if (bought == 0) {
                  p_id = 'unlimited_energy_' + unlimited_energy_h + 'h_newbuyer';
                } else {
                  p_id = 'unlimited_energy_' + unlimited_energy_h + 'h_buyer';
                }
                p_price =
                  payments_catalog[
                  payments_catalog.findIndex(function (e) {
                    return e['productID'] == p_id;
                  })
                  ]['price'];
                var unlimited_energy_block = game.add.sprite(game.camera.width / 2 + 700, game.camera.height / 2, '');
                unlimited_energy_block.anchor.setTo(0.5);
                unlimited_energy_block.fixedToCamera = true;
                popup_group.add(unlimited_energy_block);
                var unlimited_energy_back = game.add.sprite(0, 0, 'unlimited_energy_atlas', 'Banner_Background.png');
                unlimited_energy_back.anchor.setTo(0.5);
                unlimited_energy_back.scale.setTo(2);
                unlimited_energy_block.addChild(unlimited_energy_back);
                var unlimited_energy_text = game.add.text(
                  0,
                  -260,
                  game.cache.getJSON('lang')['UnlimitedEnergy'][0][window.lang],
                  { font: '40px RussoOne', fill: '#fff', align: 'center', wordWrap: true, wordWrapWidth: 200 },
                );
                unlimited_energy_text.anchor.setTo(0.5);
                unlimited_energy_text.lineSpacing = -10;
                unlimited_energy_text.stroke = '#0f6b97';
                unlimited_energy_text.strokeThickness = 4;
                unlimited_energy_text.setShadow(0, 4, 'rgba(15,107,151,0.7)', 1);
                unlimited_energy_block.addChild(unlimited_energy_text);
                var Energy_Background = game.add.sprite(0, 20, 'unlimited_energy_atlas', 'Energy_Background.png');
                Energy_Background.anchor.setTo(0.5);
                Energy_Background.scale.setTo(2);
                unlimited_energy_block.addChild(Energy_Background);
                var Infinity_Symbol = game.add.sprite(0, -10, 'unlimited_energy_atlas', 'Infinity_Symbol.png');
                Infinity_Symbol.anchor.setTo(0.5);
                Infinity_Symbol.scale.setTo(2);
                unlimited_energy_block.addChild(Infinity_Symbol);
                var Energy = game.add.sprite(0, -10, 'unlimited_energy_atlas', 'Energy.png');
                Energy.anchor.setTo(0.5);
                Energy.scale.setTo(2);
                unlimited_energy_block.addChild(Energy);
                var Time = game.add.sprite(0, 185, 'unlimited_energy_atlas', 'Time.png');
                Time.anchor.setTo(0.5);
                Time.scale.setTo(2);
                unlimited_energy_block.addChild(Time);
                var time_text = game.add.text(50, 185, unlimited_energy_h + 'h', {
                  font: '60px RussoOne',
                  fill: '#fff',
                  align: 'center',
                  wordWrap: true,
                  wordWrapWidth: 200,
                });
                time_text.anchor.setTo(0.5);
                time_text.lineSpacing = -10;
                time_text.stroke = '#0f6b97';
                time_text.strokeThickness = 4;
                time_text.setShadow(0, 4, 'rgba(15,107,151,0.7)', 1);
                unlimited_energy_block.addChild(time_text);
                var button_green = game.add.sprite(0, 310, 'game_window_atlas', 'Green_Button.png');
                button_green.anchor.setTo(0.5);
                button_green.scale.setTo(0.8);
                button_animation_f(button_green, 0.8);
                button_green.events.onInputUp.add(function (item) {
                  btnup(item);
                  if (popup != 2) {
                    popup = 2;
                    if (fbv == 1) {
                      game.setCurrentEvent();
                      window.eventTrack(p_id + '_initiated');
                      window.eventTrack('soga_purchase_initiated', 1, {
                        package_id: p_id,
                        value: p_price,
                        current_level: level_button.n,
                        conversion: 1 - bought,
                        user_type: bought,
                        lifetime: lifetime_day,
                        mission_completed: missioncompleted,
                        c_event: current_event,
                      });
                    }
                    loading();
                    if (animation == 100) {
                      if (unlimited_lifesDate == 0) {
                        unlimited_lifesDate =
                          ddd == 0
                            ? new Date()
                            : new Date(
                              ddd +
                              ' ' +
                              new Date().getHours() +
                              ':' +
                              new Date().getMinutes() +
                              ':' +
                              new Date().getSeconds(),
                            );
                      }
                      unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() + unlimited_energy_h);
                      if (Number(lifes) < Number(max_lifes)) {
                        lifes = Number(max_lifes);
                      }
                      LifeDate = 0;
                      game.setUserDataAndLog({
                        lifes: String(lifes),
                        life_time: String(LifeDate),
                        unlimited_lifesDate: String(unlimited_lifesDate),
                      });
                      if (bought == 0) {
                        bought_f = 1;
                      }
                      if (fbv == 1) {
                        game.setCurrentEvent();
                        window.eventTrack(p_id + '_successfull');
                        window.eventTrack('soga_purchase_successfull', 1, {
                          package_id: p_id,
                          value: p_price,
                          current_level: level_button.n,
                          conversion: 1 - bought,
                          first_purchase: bought_f,
                          lifetime: lifetime_day,
                          highest_lvl: all_level.lastIndexOf(3) + 2,
                          mission_completed: missioncompleted,
                          c_event: current_event,
                        });
                      }
                      if (loading_black_sprite != 0) {
                        loading_black_sprite.destroy();
                        loading_black_sprite = 0;
                      }
                      if (loading_text != 0 && loading_text != 1) {
                        loading_text.destroy();
                        loading_text = 0;
                      }
                      game.add
                        .tween(black_sprite)
                        .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                        .onComplete.add(function (item) {
                          item.destroy();
                        });
                      game.add
                        .tween(popup_group)
                        .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                        .onComplete.add(function (item) {
                          popup_group.removeAll(true);
                          popup = 0;
                          popup_group.y -= game.camera.height;
                          missions_tab_open = 0;
                          animation = 0;
                          bought = 1;
                          bought_f = 0;
                          game.setUserDataAndLog({ bought: bought });
                        });
                    }
                    // else
                    //   purchaseAsync(
                    //     {
                    //       productID: p_id,
                    //       developerPayload: 'Energy Boost',
                    //     },
                    //     is_map == 1 ? DdnaGameArea.Map : DdnaGameArea.Level,
                    //   )
                    //     .then(function (purchase) {
                    //       if (bought == 0) {
                    //         bought_f = 1;
                    //       }
                    //       game.setCurrentEvent();
                    //       window.eventTrack(p_id + '_successfull');
                    //       window.eventTrack('soga_purchase_successfull', 1, {
                    //         package_id: p_id,
                    //         value: p_price,
                    //         current_level: level_button.n,
                    //         conversion: 1 - bought,
                    //         first_purchase: bought_f,
                    //         lifetime: lifetime_day,
                    //         highest_lvl: all_level.lastIndexOf(3) + 2,
                    //         mission_completed: missioncompleted,
                    //         c_event: current_event,
                    //       });
                    //       if (unlimited_lifesDate == 0) {
                    //         unlimited_lifesDate =
                    //           ddd == 0
                    //             ? new Date()
                    //             : new Date(
                    //               ddd +
                    //               ' ' +
                    //               new Date().getHours() +
                    //               ':' +
                    //               new Date().getMinutes() +
                    //               ':' +
                    //               new Date().getSeconds(),
                    //             );
                    //       }
                    //       unlimited_lifesDate.setHours(unlimited_lifesDate.getHours() + unlimited_energy_h);
                    //       if (Number(lifes) < Number(max_lifes)) {
                    //         lifes = Number(max_lifes);
                    //       }
                    //       LifeDate = 0;
                    //       game.setUserDataAndLog({
                    //         lifes: String(lifes),
                    //         life_time: String(LifeDate),
                    //         unlimited_lifesDate: String(unlimited_lifesDate),
                    //       });
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       game.add
                    //         .tween(black_sprite)
                    //         .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    //         .onComplete.add(function (item) {
                    //           item.destroy();
                    //         });
                    //       game.add
                    //         .tween(popup_group)
                    //         .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    //         .onComplete.add(function (item) {
                    //           popup_group.removeAll(true);
                    //           popup = 0;
                    //           popup_group.y -= game.camera.height;
                    //           missions_tab_open = 0;
                    //           bought = 1;
                    //           bought_f = 0;
                    //           game.setUserDataAndLog({ bought: bought });
                    //         });
                    //       // FBInstant.payments
                    //       //   .consumePurchaseAsync(purchase['purchaseToken'])
                    //       //   .then(function () {})
                    //       //   .catch(function (error) {});
                    //     })
                    //     .catch(function (error) {
                    //       if (fbv == 1) {
                    //         game.setCurrentEvent();
                    //         window.eventTrack('soga_purchase_failed', 1, {
                    //           package_id: p_id,
                    //           value: p_price,
                    //           current_level: level_button.n,
                    //           conversion: 1 - bought,
                    //           user_type: bought,
                    //           lifetime: lifetime_day,
                    //           mission_completed: missioncompleted,
                    //           c_event: current_event,
                    //         });
                    //       }
                    //       console.log(error);
                    //       if (loading_black_sprite != 0) {
                    //         loading_black_sprite.destroy();
                    //         loading_black_sprite = 0;
                    //       }
                    //       if (loading_text != 0 && loading_text != 1) {
                    //         loading_text.destroy();
                    //         loading_text = 0;
                    //       }
                    //       button_click = 0;
                    //       popup = 1;
                    //     });
                  }
                });
                unlimited_energy_block.addChild(button_green);
                var text_button_green = game.add.text(0, 0, p_price, {
                  font: '50px RussoOne',
                  fill: '#fff',
                  align: 'center',
                  wordWrap: true,
                  wordWrapWidth: 210,
                });
                text_button_green.anchor.setTo(0.5);
                text_button_green.lineSpacing = -10;
                text_button_green.stroke = '#457310';
                text_button_green.strokeThickness = 4;
                text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
                button_green.addChild(text_button_green);
              }
            });
          }
          if (type == 2) {
            var popup_back = windows_f(game.cache.getJSON('lang')['t331'][0][window.lang], 2);
          } else {
            if (Number(lifes) <= 0) var popup_back = windows_f(game.cache.getJSON('lang')['t332'][0][window.lang], 2);
            else var popup_back = windows_f(game.cache.getJSON('lang')['t333'][0][window.lang], 2);
          }
          if (type == 2) {
            var ui_lives_icon_shine = game.add.sprite(0, -80, 'game_window_atlas', 'Ray_Behind_Energy.png');
            ui_lives_icon_shine.anchor.setTo(0.5);
            popup_back.addChild(ui_lives_icon_shine);
            var ui_lives_icon = game.add.sprite(0, -80, 'game_ui_atlas', 'Coin_Icon.png');
            ui_lives_icon.anchor.setTo(0.5);
            ui_lives_icon.scale.setTo(2);
            popup_back.addChild(ui_lives_icon);
            var ui_lives_icon_no = game.add.sprite(0, -66, 'game_window_atlas', 'No_Sign.png');
            ui_lives_icon_no.anchor.setTo(0.5);
            popup_back.addChild(ui_lives_icon_no);
          } else {
            var ui_lives_icon_shine = game.add.sprite(0, -80, 'game_window_atlas', 'Ray_Behind_Energy.png');
            ui_lives_icon_shine.anchor.setTo(0.5);
            popup_back.addChild(ui_lives_icon_shine);
            var ui_lives_icon = game.add.sprite(0, -80, 'game_ui_atlas', 'Thunder_Icon.png');
            ui_lives_icon.anchor.setTo(0.5);
            ui_lives_icon.scale.setTo(2);
            popup_back.addChild(ui_lives_icon);
            var ui_lives_icon_no = game.add.sprite(0, -80, 'game_window_atlas', 'No_Sign.png');
            ui_lives_icon_no.anchor.setTo(0.5);
            popup_back.addChild(ui_lives_icon_no);
          }
          var girl = game.add.sprite(-250, -60, 'char_atlas', 'Main_Scared.png');
          girl.anchor.setTo(0.5);
          girl.scale.setTo(1.5);
          popup_back.addChild(girl);
          var button_green = game.add.sprite(0, 270, 'game_window_atlas', 'Green_Button.png');
          button_green.anchor.setTo(0.5);
          button_animation_f(button_green, 1);
          button_green.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              if (type == 2) {
                if (shop == 0) {
                  popup = 2;
                  game.add
                    .tween(black_sprite)
                    .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                    .onComplete.add(function (item) {
                      item.destroy();
                    });
                  game.add
                    .tween(popup_group)
                    .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                    .onComplete.add(function (item) {
                      popup_group.removeAll(true);
                      popup = 0;
                      prize_wheel_arrow = 0;
                      popup_group.y -= game.camera.height;
                      wheel_window();
                    });
                } else if (popup != 2) {
                  popup = 2;
                  loading();
                  if (music_on == 1) music.pause();
                  if (sound_on == 1) ambient.pause();
                  sdkHandler.trigger(
                    'rewardedAd',
                    {
                      callback: function (success) {
                        if (music_on == 1) music.play();
                        if (sound_on == 1) ambient.play();

                        if (success) {
                          console.log('Rewarded video watched successfully 6');
                          game.add
                            .tween(black_sprite)
                            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                            .onComplete.add(function (item) {
                              item.destroy();
                            });
                          game.add
                            .tween(popup_group)
                            .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                            .onComplete.add(function (item) {
                              popup_group.removeAll(true);
                              popup = 0;
                              prize_wheel_arrow = 0;
                              popup_group.y -= game.camera.height;
                            });
                          if (loading_black_sprite != 0) {
                            loading_black_sprite.destroy();
                            loading_black_sprite = 0;
                          }
                          if (loading_text != 0 && loading_text != 1) {
                            loading_text.destroy();
                            loading_text = 0;
                          }
                          loading_text = 1;
                          popup = 1;
                          coins += 100;
                          coins_text.setText(coins);
                        } else {
                          console.log('Failed to watch rewarded Ad 6')
                          if (loading_black_sprite != 0) {
                            loading_black_sprite.destroy();
                            loading_black_sprite = 0;
                          }
                          if (loading_text != 0 && loading_text != 1) {
                            loading_text.destroy();
                            loading_text = 0;
                          }
                          loading_text = 1;
                          popup_group.removeAll(true);
                          popup = 0;
                          black_sprite.destroy();
                          popup_group.y -= game.camera.height;
                          no_ad(3, 0);
                        }
                      },
                    },
                    this,
                  );
                }
              } else if (coins >= 800) {
                popup = 2;
                lifes = Number(lifes) + 5;
                if (Number(lifes) > Number(max_max_lifes)) {
                  lifes = Number(max_max_lifes);
                }
                coins -= 800;
                game.setCurrentEvent();
                window.eventTrack('coins_out', 800, {
                  user_type: bought,
                  lifetime: lifetime_day,
                  highest_lvl: all_level.lastIndexOf(3) + 2,
                  amount: 800,
                  source: '5 energy',
                  item_id: 0,
                  mission_completed: missioncompleted,
                  c_event: current_event,
                });
                coins_text.setText(coins);
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    var col = 5;
                    var lifes_text = String(Number(lifes) - Number(col));
                    text_lifes.setText(lifes_text);
                    var var_lifes = 0;
                    if (Number(lifes) >= Number(max_lifes)) {
                      LifeDate = 0;
                      game.setUserDataAndLog({ life_time: String(LifeDate) });
                      lifetextChange();
                      if (lifes_panel_plus != 0) {
                        lifes_panel_plus.destroy();
                        lifes_panel_plus = 0;
                      }
                    }
                    game.time.events.repeat(
                      100,
                      col,
                      function () {
                        var get_lifes = game.add.sprite(
                          game.camera.x + game.camera.width / 2,
                          game.camera.y + game.camera.height / 2,
                          'game_ui_atlas',
                          'Thunder_Icon.png',
                        );
                        get_lifes.anchor.setTo(0.5);
                        get_lifes.scale.setTo(0);
                        get_lifes.alpha = 0;
                        effects_group.add(get_lifes);
                        game.add.tween(get_lifes).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
                        game.add.tween(get_lifes.scale).to({ x: 0.5, y: 0.5 }, 400, Phaser.Easing.Linear.None, true);
                        game.add
                          .tween(get_lifes)
                          .to({ x: text_lifes.world.x, y: text_lifes.world.y }, 600, Phaser.Easing.Linear.None, true)
                          .onComplete.add(function (item) {
                            item.destroy();
                            var_lifes = Number(lifes) + 1;
                            text_lifes.setText(Math.ceil(Number(lifes_text) + Number(var_lifes)));
                          });
                      },
                      this,
                    );
                  });
              } else {
                game.add
                  .tween(black_sprite)
                  .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                  });
                game.add
                  .tween(popup_group)
                  .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                  .onComplete.add(function (item) {
                    popup_group.removeAll(true);
                    popup = 0;
                    popup_group.y -= game.camera.height;
                    if (all_level[8] > 0 || FTUE > 150) {
                      if (shop == 1) {
                        shop_window(
                          0,
                          0,
                          0,
                          [
                            { 0: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Coin.png', col: '250', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '500', atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Coin.png', col: '10 000', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Coin.png', col: '20 000', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Coin.png', col: '30 000', atlas: 'game_window_atlas' }) },
                            { 1: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Energy.png', col: 'x1', atlas: 'unlimited_energy_atlas' } : (newDate.getDay() == 2) ? { type: 'bullseye_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'tnt_booster.png', col: 'x1', atlas: 'game_atlas' } : (newDate.getDay() == 4) ? { type: 'Magnifier_Booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 5) ? { type: 'Three_Cards.png', col: 'x3', atlas: 'game_atlas' } : { type: 'booster_3_prev.png', col: 'x3', atlas: 'game_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Joker.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : (JQKA_offers == 2) ? { type: 'Big_Kit_List_Joker.png', col: 'x15', atlas: 'game_window_atlas' } : { type: 'Big_Kit_List_Joker.png', col: 'x25', atlas: 'game_window_atlas' }) },
                            { 2: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 1) ? { type: 'Big_Kit_List_Energy.png', col: 'x5', atlas: 'game_window_atlas' } : (newDate.getDay() == 2) ? { type: 'shuffle_booster.png', col: 'x3', atlas: 'game_atlas' } : (newDate.getDay() == 3) ? { type: 'Big_Kit_List_Energy.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 4) ? { type: 'Big_Kit_List_Joker.png', col: 'x1', atlas: 'game_window_atlas' } : (newDate.getDay() == 5) ? { type: 'bullseye_booster.png', col: 'x2', atlas: 'game_atlas' } : { type: '5_Cards.png', col: 'x2', atlas: 'game5_atlas' }) : ((JQKA_offers == 0) ? { type: 'Big_Kit_List_Energy.png', col: 'x10', atlas: 'game_window_atlas' } : (JQKA_offers == 1) ? { type: 'Magnifier_Booster.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 2) ? { type: 'tnt_booster.png', col: 'x5', atlas: 'game_atlas' } : { type: 'Energy.png', col: 'x3', atlas: 'unlimited_energy_atlas' }) },
                            { 3: (weekday_offers == -1) ? ({ type: 0, col: 0, atlas: 'game_window_atlas' }) : ((JQKA_offers == 0) ? { type: 'booster_3_prev.png', col: 'x10', atlas: 'game_atlas' } : (JQKA_offers == 1) ? { type: '5_Cards.png', col: 'x5', atlas: 'game5_atlas' } : (JQKA_offers == 2) ? { type: 0, col: 0, atlas: 'game_window_atlas' } : { type: 0, col: 0, atlas: 'game_window_atlas' }) },
                            {
                              4: {
                                id: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? 'sunday_offer' : (newDate.getDay() == 1) ? 'monday_offer' : (newDate.getDay() == 2) ? 'tuesday_offer' : (newDate.getDay() == 3) ? 'wednesday_offer' : (newDate.getDay() == 4) ? 'thursday_offer' : (newDate.getDay() == 5) ? 'friday_offer' : 'saturday_offer') : ((JQKA_offers == 0) ? 'pairofjacks_offer' : (JQKA_offers == 1) ? 'triple_queen_offer' : (JQKA_offers == 2) ? 'four_kings_offer' : 'ace_offer'),
                                packname: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? game.cache.getJSON('lang')['t578'][0][window.lang] : (newDate.getDay() == 1) ? game.cache.getJSON('lang')['t579'][0][window.lang] : (newDate.getDay() == 2) ? game.cache.getJSON('lang')['t580'][0][window.lang] : (newDate.getDay() == 3) ? game.cache.getJSON('lang')['t581'][0][window.lang] : (newDate.getDay() == 4) ? game.cache.getJSON('lang')['t582'][0][window.lang] : (newDate.getDay() == 5) ? game.cache.getJSON('lang')['t583'][0][window.lang] : game.cache.getJSON('lang')['t584'][0][window.lang]) : ((JQKA_offers == 0) ? game.cache.getJSON('lang')['t585'][0][window.lang] : (JQKA_offers == 1) ? game.cache.getJSON('lang')['t586'][0][window.lang] : (JQKA_offers == 2) ? game.cache.getJSON('lang')['t587'][0][window.lang] : game.cache.getJSON('lang')['t588'][0][window.lang]),
                                price: (weekday_offers == -1) ? ('1.99 $') : ((JQKA_offers == 0) ? '18.99 $' : (JQKA_offers == 1) ? '24.99 $' : (JQKA_offers == 2) ? '33.99 $' : '49.99 $'),
                                reward: (weekday_offers == -1) ? ((newDate.getDay() == 0) ? [500, 5, 1, 0, 0, 0, 0, 0] : (newDate.getDay() == 1) ? [500, 5, 0, 0, 0, 0, 0, 0, 0, 0, 1] : (newDate.getDay() == 2) ? [500, 0, 0, 0, 0, 0, 3, 1] : (newDate.getDay() == 3) ? [250, 1, 0, 0, 0, 1, 0, 0] : (newDate.getDay() == 4) ? [500, 0, 1, 0, 0, 0, 0, 0, 3] : (newDate.getDay() == 5) ? [500, 0, 0, 2, 0, 0, 0, 1] : [500, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2]) : ((JQKA_offers == 0) ? [10000, 10, 10, 0, 10, 0, 0, 0] : (JQKA_offers == 1) ? [10000, 0, 15, 0, 0, 0, 0, 0, 10, 0, 0, 0, 5] : (JQKA_offers == 2) ? [20000, 0, 15, 0, 0, 5, 0, 0] : [30000, 0, 25, 0, 0, 0, 0, 0, 0, 0, 3]),
                              },
                            },
                          ],
                          [
                            {
                              0: {
                                type: 'Coins_Pack_1.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '1 000',
                                id: 'coin_package_001',
                                packname: '1,000 Coins',
                                price: '0.99 $',
                                atlas: 'game_window_atlas',
                                reward: [1000],
                              },
                            },
                            {
                              1: {
                                type: 'Coins_Pack_2.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '6 000',
                                id: 'coin_package_02',
                                packname: '6,000 Coins',
                                price: '4.99 $',
                                atlas: 'game_window_atlas',
                                reward: [6000],
                              },
                            },
                            {
                              2: {
                                type: 'Coins_Pack_3.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '13 000',
                                id: 'coin_package_003',
                                packname: '13,000 Coins',
                                price: '9.99 $',
                                atlas: 'game_window_atlas',
                                reward: [13000],
                              },
                            },
                            {
                              3: {
                                type: 'Coins_Pack_4.png',
                                sprite: 'Coins_Kit_Coins_Amount_Coin.png',
                                col: '20 000',
                                id: 'coin_package_004',
                                packname: '20,000 Coins',
                                price: '14.99 $',
                                atlas: 'game_window_atlas',
                                reward: [20000],
                              },
                            },
                          ],
                        );
                      } else if (shop == 0) {
                        get_message(2);
                      }
                    }
                  });
              }
            }
          }, this);
          popup_back.addChild(button_green);
          if (type == 1) {
            var icon_coins = game.add.sprite(-90, -4, 'game_ui_atlas', 'Coin_Icon.png');
            icon_coins.anchor.setTo(0.5);
            icon_coins.scale.setTo(0.7);
            button_green.addChild(icon_coins);
            var text_button_green = game.add.text(28, 0, '800', {
              font: '52px RussoOne',
              fill: '#fff',
              align: 'center',
              wordWrap: true,
              wordWrapWidth: 210,
            });
            text_button_green.anchor.setTo(0.5);
            text_button_green.lineSpacing = -10;
            text_button_green.stroke = '#457310';
            text_button_green.strokeThickness = 4;
            text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
            button_green.addChild(text_button_green);
          } else {
            if (shop == 0) {
              var icon_coins = game.add.sprite(-120, 0, 'game_ui_atlas', 'Wheel_Button_Free_Spin.png');
              icon_coins.anchor.setTo(0.5);
              icon_coins.scale.setTo(0.5);
              button_green.addChild(icon_coins);
              var text_button_green = game.add.text(30, 0, game.cache.getJSON('lang')['t260'][0][window.lang], {
                font: '45px RussoOne',
                fill: '#fff',
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 260,
              });
            } else
              var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t261'][0][window.lang], {
                font: '50px RussoOne',
                fill: '#fff',
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 260,
              });
            text_button_green.anchor.setTo(0.5);
            text_button_green.lineSpacing = -10;
            text_button_green.stroke = '#457310';
            text_button_green.strokeThickness = 4;
            text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
            button_green.addChild(text_button_green);
          }
          game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
        }
      }
      var shop_open = 0;
      // if (fbv == 1) {
      //   FBInstant.payments.getPurchasesAsync().then(function (purchases) {
      //     for (var i = 0; i < purchases.length; i++) {
      //       FBInstant.payments
      //         .consumePurchaseAsync(purchases[i]['purchaseToken'])
      //         .then(function () {})
      //         .catch(function (error) {});
      //     }
      //   });
      // }
      function button_animation_f(item, s) {
        item.inputEnabled = true;
        item.scl = s;
        item.input.useHandCursor = true;
        item.events.onInputOver.add(btnover, this);
        item.events.onInputOut.add(btnout, this);
        item.events.onInputDown.add(btnclick, this);
      }
      function restoreStringifiedJson(key, callback) {
        sdkHandler.trigger('restore', {
          key: key,
          callback: function (error, data) {
            if (error) {
              callback(error, data);
            } else {
              var actualData = typeof data === 'object' && data ? data.value : data;
              callback(error, actualData);
            }
          },
        });
      }
      function restoreDate(k) {
        var cb = 0;
        sdkHandler.trigger(
          'restore',
          {
            key: k,
            callback: function (error, value) {
              if (error) {
                cb = 0;
              } else {
                if (value != null && value != '0' && value !== 'NaN') {
                  cb = new Date(value);
                } else {
                  cb = 0;
                }
              }
            },
          },
          this,
        );
        return cb;
      }
      function restoreJson(k, d) {
        var cb = 0;
        restoreStringifiedJson(k, function (error, value) {
          if (error) {
          } else {
            if (value != null) {
              cb = JSON.parse(value);
            }
          }
        });
        return cb;
      }
      function restoreValue(k, d) {
        var cb = 0;
        sdkHandler.trigger(
          'restore',
          {
            key: k,
            callback: function (error, value) {
              if (error) {
                cb = d;
              } else {
                if (value != null) {
                  cb = Number(value);
                }
                if (value !== 'NaN') {
                } else {
                  cb = d;
                }
              }
            },
          },
          this,
        );
        return cb;
      }

      function scale_tween(sprite, time, powerx, powery, n) {
        if (n > 0 || n == -1) {
          game.add
            .tween(sprite.scale)
            .to({ x: '+' + powerx, y: '+' + powery }, time, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add
                .tween(sprite.scale)
                .to({ x: '-' + powerx, y: '-' + powery }, time, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  if (n > 0) {
                    n -= 1;
                  }
                  scale_tween(sprite, time, powerx, powery, n);
                });
            });
          if (UI_Streak_Present != 0)
            if (sprite == UI_Streak_Present) {
              game.add
                .tween(UI_Streak_Present_bright)
                .to({ alpha: 1 }, time, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add.tween(UI_Streak_Present_bright).to({ alpha: 0 }, time, Phaser.Easing.Linear.None, true);
                });
              game.add
                .tween(UI_Streak_Present_bright.scale)
                .to({ x: '+' + powerx, y: '+' + powery }, time, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  game.add
                    .tween(UI_Streak_Present_bright.scale)
                    .to({ x: '-' + powerx, y: '-' + powery }, time, Phaser.Easing.Linear.None, true);
                });
            }
        }
      }

      function scale_tween_deck(sprite, time, powerx, powery, n) {
        if (n > 0 || n == -1) {
          game.add
            .tween(sprite.scale)
            .to({ x: '+' + powerx, y: '+' + powery }, time, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              game.add
                .tween(sprite.scale)
                .to({ x: '-' + powerx, y: '-' + powery }, time, Phaser.Easing.Linear.None, true)
                .onComplete.add(function (item) {
                  if (n > 0) {
                    n -= 1;
                  }
                  if (cards_deck_col - 1 - deck_n >= 10) {
                    scaletween = 0;
                  }
                  if (gwin == 0) {
                    if (cards_deck_col - 1 - deck_n < 10 && cards_deck_col - 1 - deck_n >= 5)
                      scale_tween_deck(sprite, time, powerx, powery, n);
                    else if (cards_deck_col - 1 - deck_n < 5) scale_tween_deck(sprite, 200, powerx, powery, n);
                  }
                });
            });
        }
      }

      function card_check(n) {
        let obj = 0;
        clearTimeout(TimerCheck);
        TimerCheck = setTimeout(function () {
          card_check();
        }, 6000);
        if (popup == 0 && animation == 0) {
          var check = 1;
          cards_group.children.forEach(function (element1) {
            if (check != 2) {
              check = 1;
              cards_group.children.forEach(function (element2) {
                if (element1.vis != 0) {
                  var points1 = getPoints1(element1);
                  var points2 = getPoints2(element2);
                  if (polygonPolygon(points1, points2) == true && element1.depth < element2.depth) {
                    check = 0;
                  }
                } else {
                  check = 0;
                }
              });
              if (check == 1) {
                if (
                  element1.value != 104 &&
                  element1.hazard_type != 7 &&
                  element1.hazard_type != 9 &&
                  (element1.hazard_type != 10 || (element1.hazard_type == 10 && element1.std != 3))
                ) {
                  if (
                    element1.value == start_card + 1 ||
                    element1.value == start_card - 1 ||
                    (start_card == 13 && element1.value == 1) ||
                    (start_card == 1 && element1.value == 13) ||
                    start_card == 1000 ||
                    element1.value == 101 ||
                    element1.value == 102
                  ) {
                    if (n != 2) {
                      element1.scale.setTo(card_size);
                      scale_tween(element1, 200, 0.1, 0.1, 3);
                      check = 2;
                      card_add_n = 0;
                    }
                    obj = element1;
                  }
                }
              }
            }
          });
          if (n != 1 && n != 2)
            if (check != 2) {
              card_deck.scale.setTo(card_size);
              scale_tween(card_deck, 200, 0.1, 0.1, 3);
              check = 2;
            }
          if (obj == 0) {
            obj = card_deck;
          }
          if (n != 2) {
            return check;
          } else {
            return obj;
          }
        }
      }
      function loading() {
        loading_black_sprite = game.add.sprite(game.world.centerX, game.world.centerY, '');
        loading_black_sprite.anchor.setTo(0.5);
        var loading_black_sprite2 = game.add.sprite(0, 0, 'message_invite_mask');
        loading_black_sprite2.anchor.setTo(0.5);
        loading_black_sprite2.alpha = 0;
        loading_black_sprite2.width = game.world.width;
        loading_black_sprite2.height = game.world.height;
        game.add.tween(loading_black_sprite2).to({ alpha: 0.8 }, 500, Phaser.Easing.Linear.None, true);
        loading_black_sprite.addChild(loading_black_sprite2);
        var loadingCard = game.add.sprite(0, -100, 'game_atlas', 'cards_diamond12.png');
        loadingCard.anchor.setTo(0, 1);
        loadingCard.scale.setTo(1);
        loadingCard.x -= loadingCard.width / 2;
        loading_black_sprite.addChild(loadingCard);
        game.add.tween(loadingCard).to({ angle: '-30' }, 500, Phaser.Easing.Cubic.In, true, 0, -1).yoyo(true, 500);
        var loadingCard = game.add.sprite(0, -100, 'game_atlas', 'cards_cross13.png');
        loadingCard.anchor.setTo(0, 1);
        loadingCard.scale.setTo(1);
        loadingCard.x -= loadingCard.width / 2;
        loading_black_sprite.addChild(loadingCard);
        game.add.tween(loadingCard).to({ angle: '-10' }, 500, Phaser.Easing.Cubic.In, true, 0, -1).yoyo(true, 500);
        var loadingCard = game.add.sprite(0, -100, 'game_atlas', 'cards_heart1.png');
        loadingCard.anchor.setTo(0, 1);
        loadingCard.scale.setTo(1);
        loadingCard.x -= loadingCard.width / 2;
        loading_black_sprite.addChild(loadingCard);
        game.add.tween(loadingCard).to({ angle: '+10' }, 500, Phaser.Easing.Cubic.In, true, 0, -1).yoyo(true, 500);
        loading_text = game.add.text(
          game.world.centerX,
          game.world.centerY,
          game.cache.getJSON('lang')['Loading'][0][window.lang],
          { font: '80px RussoOne', fill: '#fff', align: 'center' },
        );
        loading_text.anchor.setTo(0.5);
        loading_text.stroke = '#a5823d';
        loading_text.strokeThickness = 8;
        var textl = 0;
        game.add
          .tween(loading_text)
          .to({ alpha: 1 }, 500, Phaser.Easing.Cubic.In, true, 0, -1)
          .onLoop.add(function () {
            if (textl < 3) {
              loading_text.setText(loading_text.text + '.');
              textl++;
            } else {
              loading_text.setText(game.cache.getJSON('lang')['Loading'][0][window.lang]);
              textl = 0;
            }
          });
        game.world.bringToTop(loading_black_sprite);
        game.world.bringToTop(loading_text);
      }
      function createColorImage(game, source, x1, y1, color) {
        var color = Phaser.Color.hexToColor(color);
        return game.add.sprite(
          x1,
          y1,
          game.add
            .bitmapData(source.width, source.height)
            .fill(color.r, color.g, color.b)
            .blendDestinationAtop()
            .draw(source, 0, 0, source.width, source.height),
        );
      }
      //if (level > 4 || baloon == 1) {
      var button_setting = game.add.sprite(
        game.world.centerX + 880,
        70,
        'game_ui_atlas',
        'Settings_Button.png',
      );
      button_setting.anchor.setTo(0.5);
      button_setting.scl = 1;
      button_setting.inputEnabled = true;
      button_setting.input.useHandCursor = true;
      button_setting.events.onInputOver.add(btnover, this);
      button_setting.events.onInputOut.add(btnout, this);
      button_setting.events.onInputDown.add(btnclick, this);
      button_setting.events.onInputUp.add(function (item) {
        btnup(item);
        if (animation == 0 && popup == 0 && cards_group.length > 0)
          if (level_complete == 0) {
            setting_window();
          }
      });
      //}
      var white_sprite = game.add.sprite(game.world.centerX, game.world.centerY, black);
      white_sprite.anchor.setTo(0.5);
      white_sprite.alpha = 1;
      game.add
        .tween(white_sprite)
        .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) { });
      if (TimerCheck == 0) {
        TimerCheck = setTimeout(function () {
          card_check();
        }, 6000);
      }
      emitter = game.add.emitter(0, 0, 50);
      emitter.makeParticles('particle');
      emitter.bringToTop = true;
      emitter.setRotation(0, 360, 500);
      emitter.setAlpha(1, 0, 500);
      emitter.setScale(0.1, 1.4, 0.1, 1.4, 500);
      emitter.gravity = 0;
      emitter.minParticleSpeed.set(-500, -500);
      emitter.maxParticleSpeed.set(500, 500);
      emitter.explode = true;
      emitter.blendMode = 1;
      emitter.forEach(function (particle) {
        if (game.rnd.integerInRange(1, 2) == 1) particle.tint = 0xffff00;
        else particle.tint = 0xff0000;
      });
      var inv_friends = 0;
      function no_ad(type, p) {
        if (popup == 0) {
          popup_group.y = 0;
          popup_group.y += game.camera.height;
          popup = 1;
          blackf();
          var popup_back = windows_f(game.cache.getJSON('lang')['NoAD'][0][window.lang], 2);
          var ui_lives_icon_shine = game.add.sprite(0, -80, 'game_window_atlas', 'Ray_Behind_Energy.png');
          ui_lives_icon_shine.anchor.setTo(0.5);
          popup_back.addChild(ui_lives_icon_shine);
          var ui_lives_icon = game.add.sprite(0, -80, 'game_atlas', 'ad_icon.png');
          ui_lives_icon.anchor.setTo(0.5);
          ui_lives_icon.scale.setTo(2);
          popup_back.addChild(ui_lives_icon);
          var ui_lives_icon_no = game.add.sprite(0, -80, 'game_window_atlas', 'No_Sign.png');
          ui_lives_icon_no.anchor.setTo(0.5);
          popup_back.addChild(ui_lives_icon_no);
          var girl = game.add.sprite(-250, -60, 'char_atlas', 'Main_Scared.png');
          girl.anchor.setTo(0.5);
          girl.scale.setTo(1.5);
          popup_back.addChild(girl);
          var button_green = game.add.sprite(0, 270, 'game_window_atlas', 'Green_Button.png');
          button_green.anchor.setTo(0.5);
          button_animation_f(button_green, 1);
          button_green.events.onInputUp.add(function (item) {
            btnup(item);
            if (popup != 2) {
              if (sound_on == 1) {
                play_sound('button_press');
              }
              game.add
                .tween(black_sprite)
                .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
                .onComplete.add(function (item) {
                  item.destroy();
                });
              game.add
                .tween(popup_group)
                .to({ y: '+' + game.camera.height }, 500, Phaser.Easing.Quadratic.Out, true)
                .onComplete.add(function (item) {
                  popup_group.removeAll(true);
                  popup = 0;
                  popup_group.y -= game.camera.height;
                });
            }
          }, this);
          popup_back.addChild(button_green);
          var text_button_green = game.add.text(0, 0, 'OK', {
            font: '50px RussoOne',
            fill: '#fff',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 260,
          });
          text_button_green.anchor.setTo(0.5);
          text_button_green.lineSpacing = -10;
          text_button_green.stroke = '#457310';
          text_button_green.strokeThickness = 4;
          text_button_green.setShadow(0, 4, 'rgba(69,115,16,0.7)', 1);
          button_green.addChild(text_button_green);
          game.add.tween(popup_group).to({ y: '-' + game.camera.height }, 500, Phaser.Easing.Exponential.Out, true);
        }
      }
    }
    function btnover(item) {
      game.add.tween(item.scale).to({ x: item.scl + 0.05, y: item.scl + 0.05 }, 100, Phaser.Easing.Linear.None, true);
    }
    function btnout(item) {
      game.add.tween(item.scale).to({ x: item.scl, y: item.scl }, 100, Phaser.Easing.Linear.None, true);
    }
    function btnclick(item) {
      button_click = 1;
      game.add.tween(item.scale).to({ x: item.scl - 0.05, y: item.scl - 0.05 }, 100, Phaser.Easing.Linear.None, true);
    }
    function btnup(item) {
      button_click = 0;
      game.add.tween(item.scale).to({ x: item.scl, y: item.scl }, 100, Phaser.Easing.Linear.None, true);
    }
    var tap_y = 0;
    var tap_x = 0;
    var map_x = -1;
    var map_y = -1;
    var game_tap = 0;
    var game_move = 0;
    game.input.onDown.add(function () {
      game_tap = 1;
      tap_y = game.input.activePointer.y;
      tap_x = game.input.activePointer.x;
      map_x = game.input.activePointer.x;
      map_y = game.input.activePointer.y;
      if (game.input.activePointer.x < game.world.centerX + 780) {
        if (info_box_9slices1 != 0) {
          info_box_9slices1.destroy();
          info_box_9slices1 = 0;
        }
        if (info_box_9slices2 != 0) {
          info_box_9slices2.destroy();
          info_box_9slices2 = 0;
        }
        if (info_box_9slices3 != 0) {
          info_box_9slices3.destroy();
          info_box_9slices3 = 0;
        }
        if (popup == 3 && ticket_booster_group.t != 1) {
          if (sound_on == 1) {
            play_sound('suitcase_close');
          }
          popup = 30;
          if (close_suitcase_button != 0) {
            close_suitcase_button.destroy();
            close_suitcase_button = 0;
          }
          if (info_button != 0) {
            info_button.destroy();
            info_button = 0;
          }
          game.add
            .tween(black_sprite)
            .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
            .onComplete.add(function (item) {
              item.destroy();
            });
          game.add
            .tween(ticket_booster_group)
            .to({ y: '+' + ticket_booster_group.h }, 500, Phaser.Easing.Quadratic.In, true)
            .onComplete.add(function (item) {
              suitcase_close.loadTexture('game_atlas', 'suitcase_close.png', false);
              game.add
                .tween(suitcase_close)
                .to({ y: '+5' }, 100, Phaser.Easing.Quadratic.In, true)
                .onComplete.add(function (item) {
                  game.add.tween(suitcase_close).to({ y: '-5' }, 100, Phaser.Easing.Quadratic.In, true);
                });
              popup = 0;
            });
        }
      }
      if (
        missions_tab_open >= 50 &&
        missions_tab_open <= 53 &&
        animation == 0 &&
        array222 != 0 &&
        missions_tab_open != 51.51
      ) {
        animation = 1;

        if (missions_tab_open == 51.7) {
          level_end_check = 0;
          popup = 2;
        }

        for (var i = 0; i < array222.length; i++) {
          if (array222[i] > 0 && itm_a[i] != 0) {
            if (i == 0) {
              var x1 = itm_a[i].world.x;
              var y1 = itm_a[i].world.y;
              var col = array222[i];
              var coins_t = coins - col;
              coins_text.setText(coins_t);
              var var_coins = 0;
              if (sound_on == 1) {
                play_sound('coins_add');
              }
              game.time.events.repeat(
                100,
                10,
                function () {
                  var get_coin = game.add.sprite(
                    x1 + game.rnd.integerInRange(-10, 10),
                    y1 + game.rnd.integerInRange(-10, 10),
                    'game_window2_atlas',
                    'List_Coin.png',
                  );
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0);
                  get_coin.alpha = 0;
                  effects_group.add(get_coin);
                  game.world.bringToTop(effects_group);
                  game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                  var tween = game.add
                    .tween(get_coin)
                    .to({ x: coins_text.world.x, y: coins_text.world.y }, 600, Phaser.Easing.Linear.None, true);
                  tween.onComplete.add(function (item) {
                    item.destroy();
                    var_coins += col / 10;
                    coins_text.setText(Math.ceil(coins_t + var_coins));
                  });
                  var star_emitter = game.add.emitter(x1, y1, 100);
                  star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                  star_emitter.setAlpha(1, 0, 800);
                  star_emitter.setScale(3, 0, 3, 0, 800);
                  star_emitter.start(false, 1000, 10);
                  star_emitter.bringToTop = true;
                  game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    star_emitter.destroy();
                  });
                  tween.onUpdateCallback(function () {
                    star_emitter.x = get_coin.x;
                    star_emitter.y = get_coin.y;
                  }, this);
                },
                this,
              );
            } else if (i == 1) {
              var x2 = itm_a[i].world.x;
              var y2 = itm_a[i].world.y;
              var col2 = Number(array222[i]);
              var lifes_text = String(Number(lifes) - Number(col2));
              var var_lifes = 0;
              if (Number(lifes) >= Number(max_lifes)) {
                LifeDate = 0;
                game.setUserDataAndLog({ life_time: String(LifeDate) });
              }
              game.time.events.repeat(
                100,
                col2,
                function () {
                  var get_lifes = game.add.sprite(
                    x2 + game.rnd.integerInRange(-10, 10),
                    y2 + game.rnd.integerInRange(-10, 10),
                    'game_window2_atlas',
                    'List_Energy.png',
                  );
                  get_lifes.anchor.setTo(0.5);
                  get_lifes.scale.setTo(0);
                  get_lifes.alpha = 0;
                  effects_group.add(get_lifes);
                  game.world.bringToTop(effects_group);
                  game.add.tween(get_lifes).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_lifes.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                  var tween = game.add.tween(get_lifes).to({ x: 0, y: 0 }, 600, Phaser.Easing.Linear.None, true);
                  tween.onComplete.add(function (item) {
                    item.destroy();
                    var_lifes += 1;
                  });
                  var star_emitter = game.add.emitter(x2, y2, 100);
                  star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                  star_emitter.setAlpha(1, 0, 800);
                  star_emitter.setScale(3, 0, 3, 0, 800);
                  star_emitter.start(false, 1000, 10);
                  star_emitter.bringToTop = true;
                  game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    star_emitter.destroy();
                  });
                  tween.onUpdateCallback(function () {
                    star_emitter.x = get_lifes.x;
                    star_emitter.y = get_lifes.y;
                  }, this);
                },
                this,
              );
            } else if (i == 2) {
              var x3 = itm_a[i].world.x;
              var y3 = itm_a[i].world.y;
              var col3 = Number(array222[i]);
              free_joker = free_joker - col3;
              game.time.events.repeat(
                100,
                col3,
                function () {
                  var get_coin = game.add.sprite(
                    x3 + game.rnd.integerInRange(-10, 10),
                    y3 + game.rnd.integerInRange(-10, 10),
                    'game_window2_atlas',
                    'List_Joker.png',
                  );
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0);
                  get_coin.alpha = 0;
                  effects_group.add(get_coin);
                  game.world.bringToTop(effects_group);
                  game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                  var tween = game.add
                    .tween(get_coin)
                    .to(
                      { x: booster3_price_text.world.x, y: booster3_price_text.world.y },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    );
                  tween.onComplete.add(function (item) {
                    item.destroy();
                    game.setCurrentEvent();
                    window.eventTrack('booster_in', 1, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: 1,
                      source: 'Joker',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                    free_joker += 1;
                    if (booster3_price_text != 0) {
                      booster3_price_text.destroy();
                    }
                    if (booster3_coin != 0) {
                      booster3_coin.destroy();
                    }
                    if (free_joker > 0 || shop == 0) {
                      if (free_joker > 0)
                        booster3_price_text = game.add.text(
                          game.world.centerX + 560 + booster3.width / 2,
                          game.world.height - 18,
                          game.cache.getJSON('lang')['FREE'][0][window.lang] + ' x' + free_joker,
                          { font: '26px RussoOne', fill: '#fff', align: 'center' },
                        );
                      else
                        booster3_price_text = game.add.text(
                          game.world.centerX + 360 + booster3.width / 2,
                          game.world.height - 18,
                          booster3_price,
                          { font: '26px RussoOne', fill: '#fff', align: 'center' },
                        );
                      booster3_price_text.stroke = '#000';
                      booster3_price_text.strokeThickness = 3;
                      booster3_price_text.anchor.setTo(0.5, 0.5);
                      booster3_coin = game.add.sprite(
                        game.world.centerX + 560 + booster3.width / 2 - booster3_price_text.width / 2 - 16,
                        game.world.height - 20,
                        'game_atlas',
                        'icon_coins.png',
                      );
                      booster3_coin.anchor.setTo(0.5, 0.5);
                      booster3_coin.scale.setTo(0.7);
                    }
                  });
                  var star_emitter = game.add.emitter(x1, y1, 100);
                  star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                  star_emitter.setAlpha(1, 0, 800);
                  star_emitter.setScale(3, 0, 3, 0, 800);
                  star_emitter.start(false, 1000, 10);
                  star_emitter.bringToTop = true;
                  game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    star_emitter.destroy();
                  });
                  tween.onUpdateCallback(function () {
                    star_emitter.x = get_coin.x;
                    star_emitter.y = get_coin.y;
                  }, this);
                },
                this,
              );
            } /*else if (i == 3) {
              if (UI_EndGame_btn != 0) {
                UI_EndGame_btn.destroy();
                UI_EndGame_btn = 0;
              }
              var x4 = itm_a[i].world.x;
              var y4 = itm_a[i].world.y;
              var col4 = Number(array222[i]);
              game.time.events.repeat(
                100,
                col4,
                function () {
                  var get_coin = game.add.sprite(
                    x4 + game.rnd.integerInRange(-10, 10),
                    y4 + game.rnd.integerInRange(-10, 10),
                    'game_window2_atlas',
                    'List_Cards.png',
                  );
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0);
                  get_coin.alpha = 0;
                  effects_group.add(get_coin);
                  game.world.bringToTop(effects_group);
                  game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                  var tween = game.add
                    .tween(get_coin)
                    .to(
                      { x: game.world.centerX + 1 * card_size, y: game.world.height - 90 * card_size },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    );
                  tween.onComplete.add(function (item) {
                    item.destroy();
                    card_deck.alpha = 1;
                    //card_text.alpha = 1;
                    cards_deck_col += 1;
                    card_text.setText(cards_deck_col - 1 - deck_n);
					deck_change();
                  });
                  var star_emitter = game.add.emitter(x1, y1, 100);
                  star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                  star_emitter.setAlpha(1, 0, 800);
                  star_emitter.setScale(3, 0, 3, 0, 800);
                  star_emitter.start(false, 1000, 10);
                  star_emitter.bringToTop = true;
                  game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                      star_emitter.destroy();
                    });
                  tween.onUpdateCallback(function () {
                    star_emitter.x = get_coin.x;
                    star_emitter.y = get_coin.y;
                  }, this);
                },
                this,
              );
            }*/ else if (i == 4) {
              var x5 = itm_a[i].world.x;
              var y5 = itm_a[i].world.y;
              var col5 = Number(array222[i]);
              free_cardback = free_cardback - col5;
              game.time.events.repeat(
                100,
                col5,
                function () {
                  var get_coin = game.add.sprite(
                    x5 + game.rnd.integerInRange(-10, 10),
                    y5 + game.rnd.integerInRange(-10, 10),
                    'game_window2_atlas',
                    'List_Card_Back.png',
                  );
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0);
                  get_coin.alpha = 0;
                  effects_group.add(get_coin);
                  game.world.bringToTop(effects_group);
                  game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                  var tween = game.add
                    .tween(get_coin)
                    .to(
                      { x: booster5_price_text.world.x, y: booster5_price_text.world.y },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    );
                  tween.onComplete.add(function (item) {
                    item.destroy();
                    game.setCurrentEvent();
                    window.eventTrack('booster_in', 1, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: 1,
                      source: 'UndoMove',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                    free_cardback += 1;
                    booster5_price_text.setText(
                      game.cache.getJSON('lang')['FREE'][0][window.lang] + ' x' + free_cardback,
                    );
                  });
                  var star_emitter = game.add.emitter(x1, y1, 100);
                  star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                  star_emitter.setAlpha(1, 0, 800);
                  star_emitter.setScale(3, 0, 3, 0, 800);
                  star_emitter.start(false, 1000, 10);
                  star_emitter.bringToTop = true;
                  game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    star_emitter.destroy();
                  });
                  tween.onUpdateCallback(function () {
                    star_emitter.x = get_coin.x;
                    star_emitter.y = get_coin.y;
                  }, this);
                },
                this,
              );
            } else if (i == 5) {
              var x5 = itm_a[i].world.x;
              var y5 = itm_a[i].world.y;
              var col5 = Number(array222[i]);
              booster_tnt_col = booster_tnt_col - col5;
              game.time.events.repeat(
                100,
                col5,
                function () {
                  var get_coin = game.add.sprite(
                    x5 + game.rnd.integerInRange(-10, 10),
                    y5 + game.rnd.integerInRange(-10, 10),
                    'game_atlas',
                    'tnt_booster.png',
                  );
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0);
                  get_coin.alpha = 0;
                  effects_group.add(get_coin);
                  game.world.bringToTop(effects_group);
                  game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                  var tween = game.add
                    .tween(get_coin)
                    .to(
                      { x: game.world.centerX + 815, y: game.world.height - 164 + 63 },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    );
                  tween.onComplete.add(function (item) {
                    item.destroy();
                    game.setCurrentEvent();
                    window.eventTrack('booster_in', 1, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: 1,
                      source: 'TNT',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                    booster_tnt_col += 1;
                    suitcase_label_text.setText(booster_tnt_col + booster_eye_col + booster_shuffle_col);
                  });
                  var star_emitter = game.add.emitter(x1, y1, 100);
                  star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                  star_emitter.setAlpha(1, 0, 800);
                  star_emitter.setScale(3, 0, 3, 0, 800);
                  star_emitter.start(false, 1000, 10);
                  star_emitter.bringToTop = true;
                  game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    star_emitter.destroy();
                  });
                  tween.onUpdateCallback(function () {
                    star_emitter.x = get_coin.x;
                    star_emitter.y = get_coin.y;
                  }, this);
                },
                this,
              );
            } else if (i == 6) {
              var x5 = itm_a[i].world.x;
              var y5 = itm_a[i].world.y;
              var col5 = Number(array222[i]);
              booster_shuffle_col = booster_shuffle_col - col5;
              game.time.events.repeat(
                100,
                col5,
                function () {
                  var get_coin = game.add.sprite(
                    x5 + game.rnd.integerInRange(-10, 10),
                    y5 + game.rnd.integerInRange(-10, 10),
                    'game_atlas',
                    'shuffle_booster.png',
                  );
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0);
                  get_coin.alpha = 0;
                  effects_group.add(get_coin);
                  game.world.bringToTop(effects_group);
                  game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                  var tween = game.add
                    .tween(get_coin)
                    .to(
                      { x: game.world.centerX + 815, y: game.world.height - 164 + 63 },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    );
                  tween.onComplete.add(function (item) {
                    item.destroy();
                    game.setCurrentEvent();
                    window.eventTrack('booster_in', 1, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: 1,
                      source: 'Shuffle',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                    booster_shuffle_col += 1;
                    suitcase_label_text.setText(booster_tnt_col + booster_eye_col + booster_shuffle_col);
                  });
                  var star_emitter = game.add.emitter(x1, y1, 100);
                  star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                  star_emitter.setAlpha(1, 0, 800);
                  star_emitter.setScale(3, 0, 3, 0, 800);
                  star_emitter.start(false, 1000, 10);
                  star_emitter.bringToTop = true;
                  game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    star_emitter.destroy();
                  });
                  tween.onUpdateCallback(function () {
                    star_emitter.x = get_coin.x;
                    star_emitter.y = get_coin.y;
                  }, this);
                },
                this,
              );
            } else if (i == 7) {
              var x5 = itm_a[i].world.x;
              var y5 = itm_a[i].world.y;
              var col5 = Number(array222[i]);
              booster_eye_col = booster_eye_col - col5;
              game.time.events.repeat(
                100,
                col5,
                function () {
                  var get_coin = game.add.sprite(
                    x5 + game.rnd.integerInRange(-10, 10),
                    y5 + game.rnd.integerInRange(-10, 10),
                    'game_atlas',
                    'bullseye_booster.png',
                  );
                  get_coin.anchor.setTo(0.5);
                  get_coin.scale.setTo(0);
                  get_coin.alpha = 0;
                  effects_group.add(get_coin);
                  game.world.bringToTop(effects_group);
                  game.add.tween(get_coin).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);
                  game.add.tween(get_coin.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
                  var tween = game.add
                    .tween(get_coin)
                    .to(
                      { x: game.world.centerX + 815, y: game.world.height - 164 + 63 },
                      600,
                      Phaser.Easing.Linear.None,
                      true,
                    );
                  tween.onComplete.add(function (item) {
                    item.destroy();
                    game.setCurrentEvent();
                    window.eventTrack('booster_in', 1, {
                      user_type: bought,
                      lifetime: lifetime_day,
                      highest_lvl: all_level.lastIndexOf(3) + 2,
                      amount: 1,
                      source: 'Bullseye',
                      item_id: 0,
                      mission_completed: missioncompleted,
                      c_event: current_event,
                    });
                    booster_eye_col += 1;
                    suitcase_label_text.setText(booster_tnt_col + booster_eye_col + booster_shuffle_col);
                  });
                  var star_emitter = game.add.emitter(x1, y1, 100);
                  star_emitter.makeParticles('game_ui_atlas', 'Sparkle_Mini_Gift.png');
                  star_emitter.setAlpha(1, 0, 800);
                  star_emitter.setScale(3, 0, 3, 0, 800);
                  star_emitter.start(false, 1000, 10);
                  star_emitter.bringToTop = true;
                  game.add.tween(effects_group).to({ alpha: 1 }, 600, Phaser.Easing.Exponential.In, true).onComplete.add(function () {
                    star_emitter.destroy();
                  });
                  tween.onUpdateCallback(function () {
                    star_emitter.x = get_coin.x;
                    star_emitter.y = get_coin.y;
                  }, this);
                },
                this,
              );
            }
          }
        }

        game.add
          .tween(black_sprite)
          .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
          .onComplete.add(function (item) {
            item.destroy();
          });

        game.add
          .tween(popup_group)
          .to({ alpha: 0 }, 1000, Phaser.Easing.Quadratic.Out, true)
          .onComplete.add(function (item) {
            popup_group.removeAll(true);
            popup = 0;
            animation = 0;
            popup_group.alpha = 1;
            popup_group.y -= game.camera.height;
            array222 = 0;
            if (missions_tab_open == 51.7) {
              black_sprite = black_sprite2;
              game.world.bringToTop(popup_group);
              game.world.bringToTop(UI_Coins_BG);
            }
            missions_tab_open = 0;
          });

      } else if (missions_tab_open == 51.51) {
        animation = 1;
        missions_tab_open = 0;
        game.add
          .tween(black_sprite)
          .to({ alpha: 0 }, 500, Phaser.Easing.Exponential.In, true)
          .onComplete.add(function (item) {
            item.destroy();
          });
        game.add
          .tween(popup_group)
          .to({ alpha: 0 }, 1000, Phaser.Easing.Quadratic.Out, true)
          .onComplete.add(function (item) {
            popup_group.removeAll(true);
            popup = 0;
            animation = 0;
            popup_group.alpha = 1;
            popup_group.y -= game.camera.height;
            array222 = 0;
            missions_tab_open = 0;
            gwin = 0;
            console.log('baloon_level_select');
            baloon_level_select(1);
          });
      }
    });
    if (game.cache.checkImageKey('context2_avatar')) {
      game.cache.removeImage('context2_avatar');
    }
    var context2_name = 0;
    var context2_id = 0;
    var context2_avatar = 0;
    async function fetchAndLogScore(_id, _name) {
      return [];

      // if (fbv == 1) {
      //   // var [friends, leaderboardEntries] = await Promise.all([
      //   //   FBInstant.player.getConnectedPlayersAsync(),
      //   //   getFriendsScores({ instanceId: _id, leaderboardName: _name }),
      //   // ]);
      //   var usersByPlayerId = [castPlayerToUser(FBInstant.player), ...friends.map(castPlayerToUser)].reduce(
      //     (m, user) => {
      //       return {
      //         ...m,
      //         [user.id]: user,
      //       };
      //     },
      //   );
      //   var decoratedResults = leaderboardEntries.map((entry) => {
      //     var { user: entryUser } = entry;
      //     var { playerId, handle } = entryUser;
      //     var { name, avatarUrl } = usersByPlayerId[playerId] || {};
      //     return {
      //       ...entry,
      //       user: {
      //         ...entryUser,
      //         handle: name || handle || 'N/A',
      //         avatarUrl,
      //       },
      //     };
      //   });
      // } else {
      //   var decoratedResults = [];
      // }
      // return decoratedResults;
    }
    function castPlayerToUser(player) {
      return {
        id: player.getID(),
        name: player.getName(),
        avatarUrl: player.getPhoto(),
      };
    }
    if (level > 3 && fbv == 1) {
      //&& first_helper == 0
      fetchAndLogScore('default', 'completedLevels').then(function (friends) {
        for (var nnn = 0; nnn < friends.length; nnn++) {
          if (friends[nnn]['user']['playerId'] != CurrentUserId)
            if (helpers_id.indexOf(friends[nnn]['user']['playerId']) == -1) {
              try {
                game.load.image('context2_avatar', friends[nnn]['user']['avatarUrl'], 1);
                game.load.crossOrigin = true;
                game.load.start();
              } catch (err) {
                //console.log('Error detected '+err.name);
              }
              context2_name = friends[nnn]['user']['handle'];
              context2_id = friends[nnn]['user']['playerId'];
              avatar_check_context = setInterval(function () {
                try {
                  if (game.cache.checkImageKey('context2_avatar')) {
                    context2_avatar = 'context2_avatar';
                    clearInterval(avatar_check_context);
                    avatar_check_context = 0;
                  }
                } catch (err) {
                  //console.log('Error detected '+err.name);
                  clearInterval(avatar_check_context);
                  avatar_check_context = 0;
                }
              }, 500);
              break;
            }
        }
      });
    } else {
      context2_name = game.cache.getJSON('lang')['t344_1'][0][window.lang];
      first_helper = 0;
      game.setUserDataAndLog({ first_helper: first_helper });
    }
    var ingameHelp_group = game.add.group();
    var friend_avatar_time = 0;
    function ingameHelp() {
      function loading() {
        loading_black_sprite = game.add.sprite(game.world.centerX, game.world.centerY, '');
        loading_black_sprite.anchor.setTo(0.5);
        var loading_black_sprite2 = game.add.sprite(0, 0, 'message_invite_mask');
        loading_black_sprite2.anchor.setTo(0.5);
        loading_black_sprite2.alpha = 0;
        loading_black_sprite2.width = game.world.width;
        loading_black_sprite2.height = game.world.height;
        game.add.tween(loading_black_sprite2).to({ alpha: 0.8 }, 500, Phaser.Easing.Linear.None, true);
        loading_black_sprite.addChild(loading_black_sprite2);
        var loadingCard = game.add.sprite(0, -100, 'game_atlas', 'cards_diamond12.png');
        loadingCard.anchor.setTo(0, 1);
        loadingCard.scale.setTo(1);
        loadingCard.x -= loadingCard.width / 2;
        loading_black_sprite.addChild(loadingCard);
        game.add.tween(loadingCard).to({ angle: '-30' }, 500, Phaser.Easing.Cubic.In, true, 0, -1).yoyo(true, 500);
        var loadingCard = game.add.sprite(0, -100, 'game_atlas', 'cards_cross13.png');
        loadingCard.anchor.setTo(0, 1);
        loadingCard.scale.setTo(1);
        loadingCard.x -= loadingCard.width / 2;
        loading_black_sprite.addChild(loadingCard);
        game.add.tween(loadingCard).to({ angle: '-10' }, 500, Phaser.Easing.Cubic.In, true, 0, -1).yoyo(true, 500);
        var loadingCard = game.add.sprite(0, -100, 'game_atlas', 'cards_heart1.png');
        loadingCard.anchor.setTo(0, 1);
        loadingCard.scale.setTo(1);
        loadingCard.x -= loadingCard.width / 2;
        loading_black_sprite.addChild(loadingCard);
        game.add.tween(loadingCard).to({ angle: '+10' }, 500, Phaser.Easing.Cubic.In, true, 0, -1).yoyo(true, 500);
        loading_text = game.add.text(
          game.world.centerX,
          game.world.centerY,
          game.cache.getJSON('lang')['Loading'][0][window.lang],
          { font: '80px RussoOne', fill: '#fff', align: 'center' },
        );
        loading_text.anchor.setTo(0.5);
        loading_text.stroke = '#a5823d';
        loading_text.strokeThickness = 8;
        var textl = 0;
        game.add
          .tween(loading_text)
          .to({ alpha: 1 }, 500, Phaser.Easing.Cubic.In, true, 0, -1)
          .onLoop.add(function () {
            if (textl < 3) {
              loading_text.setText(loading_text.text + '.');
              textl++;
            } else {
              loading_text.setText(game.cache.getJSON('lang')['Loading'][0][window.lang]);
              textl = 0;
            }
          });
        game.world.bringToTop(loading_black_sprite);
        game.world.bringToTop(loading_text);
      }
      function rotate_tween(item) {
        game.add
          .tween(item)
          .to({ angle: 360 }, 5000, Phaser.Easing.Linear.None, true)
          .onComplete.add(function (itm) {
            rotate_tween(itm);
          });
      }
      var Background = game.add.sprite(
        game.world.centerX - 480,
        game.world.height - 120 + 600,
        'ingame_atlas',
        'Background.png',
      );
      Background.inputEnabled = true;
      Background.input.useHandCursor = true;
      Background.scl = 1;
      Background.events.onInputOver.add(btnover, this);
      Background.events.onInputOut.add(btnout, this);
      Background.events.onInputDown.add(btnclick, this);
      Background.events.onInputUp.add(function (item) {
        btnup(item);
        if (popup == 0 && animation == 0) {
          if (context2_name != game.cache.getJSON('lang')['t344_1'][0][window.lang]) {
            popup = 1;
            if (context2_name != 0) {
              context2_name = -1;
              // FBInstant.context
              //   .createAsync(context2_id)
              //   .then(function () {
              //     CurrentContext = context2_id;
              //     consumed_3Helpercards = 1;
              //     var d =
              //       ddd == 0
              //         ? new Date()
              //         : new Date(
              //           ddd +
              //           ' ' +
              //           new Date().getHours() +
              //           ':' +
              //           new Date().getMinutes() +
              //           ':' +
              //           new Date().getSeconds(),
              //         );
              //     d.setHours(d.getHours() + 24);
              //     helpers_id.push(context2_id);
              //     helpers_time.push(d);
              //     game.setUserDataAndLog({
              //       helpers_id: JSON.stringify(helpers_id),
              //       helpers_time: JSON.stringify(helpers_time),
              //     });
              //     ingameHelp_group.removeAll(true);
              //     if (sound_on == 1) {
              //       play_sound('Booster_FiveCards_Use');
              //     }
              //     var nnn = 0;

              //     if (FTUE > 30)
              //       for (var i = 0; i < missions.length; i += 4) {
              //         if (missions[i] == -11) {
              //           if (missions[i + 2] < missions[i + 1]) {
              //             missions[i + 2] += 1;
              //           }
              //         }
              //       }

              //     game.time.events.repeat(
              //       100,
              //       3,
              //       function () {
              //         let card_new = game.add.sprite(
              //           game.world.centerX + 1 * card_size - 100 * card_size,
              //           game.world.height - 90 * card_size + 300 * card_size,
              //           'game5_atlas',
              //           backcards_select,
              //         );
              //         card_new.anchor.setTo(0.5, 0.5);
              //         game.add
              //           .tween(card_new)
              //           .to({ x: card_deck.x, y: card_deck.y }, 300, Phaser.Easing.Linear.None, true)
              //           .onComplete.add(function (item) {
              //             item.destroy();
              //             cards_deck_col += 1;
              //             card_text.setText(cards_deck_col - 1 - deck_n);
              //             deck_change();
              //           });
              //         nnn++;
              //         if (nnn == 3) {
              //           popup = 0;
              //         }
              //       },
              //       this,
              //     );
              //     let group = game.add.group();
              //     group.y = -344;
              //     var user_avatar = game.add.image(668 / 2 + 90, 344 / 2 + 20, 'game_atlas', 'no_avatar.png');
              //     user_avatar.anchor.setTo(0.5);
              //     user_avatar.width = user_avatar.height = 200;
              //     user_avatar.angle = 2;
              //     group.add(user_avatar);
              //     if (game.cache.checkImageKey('c_user_avatar') == true) {
              //       user_avatar.loadTexture('c_user_avatar');
              //       user_avatar.width = user_avatar.height = 200;
              //     }
              //     var message_invite = game.add.sprite(668 / 2, 344 / 2, 'message_atlas', 'Friend_Helper_Ingame.png');
              //     message_invite.scale.setTo(2);
              //     message_invite.anchor.setTo(0.5);
              //     group.add(message_invite);
              //     group.inputEnabled = false;
              //     group.y = 0;
              //     let group2 = game.add.group();
              //     group2.addChild(group);
              //     var renderTexture = game.make.renderTexture(668, 344);
              //     renderTexture.render(group2);
              //     group2.destroy();
              //     var mID =
              //       ddd == 0
              //         ? new Date()
              //         : new Date(
              //           ddd +
              //           ' ' +
              //           new Date().getHours() +
              //           ':' +
              //           new Date().getMinutes() +
              //           ':' +
              //           new Date().getSeconds(),
              //         );
              //     updateAsync(
              //       {
              //         action: 'CUSTOM',
              //         image: renderTexture.getBase64(),
              //         text: 'Your free cards really helped me out in Solitaire Garden! Thanks a lot!',
              //         template: 'play_turn',
              //         data: {
              //           userName: CurrentUserName,
              //           userId: CurrentUserId,
              //           messageId: mID.getTime(),
              //           data: 'Helper',
              //         },
              //         strategy: 'IMMEDIATE',
              //         notification: 'NO_PUSH',
              //       },
              //       {
              //         actionLevel: level,
              //         targetUserID: CurrentContext,
              //         socialActionType: DdnaSocialActionType.InLevelThreeCards,
              //         socialRewardType: DdnaSocialRewardType.InLevelThreeCards,
              //       },
              //     );
              //   })
              //   .catch(function (error) {
              //     popup = 0;
              //   });
            } else {
              loading();
              // FBInstant.context
              //   .chooseAsync({
              //     filters: ['NEW_PLAYERS_ONLY'],
              //     minSize: 3,
              //   })
              //   .then(function () {
              //     if (loading_black_sprite != 0) {
              //       loading_black_sprite.destroy();
              //       loading_black_sprite = 0;
              //     }
              //     if (loading_text != 0 && loading_text != 1) {
              //       loading_text.destroy();
              //       loading_text = 0;
              //     }
              //     first_start = -1;
              //     numFriendsInvited += 1;
              //     game.setUserDataAndLog({ first_start: first_start, numFriendsInvited: numFriendsInvited });
              //     if (level_button.n == 4) {
              //       if (fbv == 1) {
              //         window.eventTrack('FTUE_7_6_A_FacebookPopupPlayButtonClicked');
              //       }
              //     } else if (level_button.n == 5) {
              //       if (fbv == 1) {
              //         window.eventTrack('FTUE_9_8_A_FacebookPopupPlayButtonClicked');
              //       }
              //     }
              //     let group = game.add.group();
              //     group.y = -344;
              //     var user_avatar = game.add.image(668 / 2 - 102, 344 / 2 + 20, 'game_atlas', 'no_avatar.png');
              //     user_avatar.anchor.setTo(0.5);
              //     user_avatar.width = user_avatar.height = 180;
              //     user_avatar.angle = 6;
              //     group.add(user_avatar);
              //     if (context_avatar != 0 && game.cache.checkImageKey(context_avatar)) {
              //       user_avatar.loadTexture(context_avatar);
              //       user_avatar.width = user_avatar.height = 180;
              //     }
              //     var user_avatar = game.add.image(668 / 2 + 105, 344 / 2 + 20, 'game_atlas', 'no_avatar.png');
              //     user_avatar.anchor.setTo(0.5);
              //     user_avatar.width = user_avatar.height = 180;
              //     user_avatar.angle = 2;
              //     group.add(user_avatar);
              //     if (game.cache.checkImageKey('c_user_avatar') == true) {
              //       user_avatar.loadTexture('c_user_avatar');
              //       user_avatar.width = user_avatar.height = 180;
              //     }
              //     var message_invite = game.add.sprite(668 / 2, 344 / 2, 'message_atlas', 'Play_Level_With_Friend.png');
              //     message_invite.scale.setTo(2);
              //     message_invite.anchor.setTo(0.5);
              //     group.add(message_invite);
              //     group.inputEnabled = false;
              //     group.y = 0;
              //     let group2 = game.add.group();
              //     group2.addChild(group);
              //     var renderTexture = game.make.renderTexture(668, 344);
              //     renderTexture.render(group2);
              //     group2.destroy();
              //     var mID =
              //       ddd == 0
              //         ? new Date()
              //         : new Date(
              //           ddd +
              //           ' ' +
              //           new Date().getHours() +
              //           ':' +
              //           new Date().getMinutes() +
              //           ':' +
              //           new Date().getSeconds(),
              //         );
              //     updateAsync(
              //       {
              //         action: 'CUSTOM',
              //         image: renderTexture.getBase64(),
              //         text: 'Thank you for helping me beating that level in Solitaire Garden!',
              //         template: 'play_turn',
              //         data: {
              //           userId: CurrentUserId,
              //           messageId: mID.getTime(),
              //           data: 'SetNewFriend',
              //           bonus: 0,
              //         },
              //         strategy: 'IMMEDIATE',
              //         notification: 'NO_PUSH',
              //       },
              //       {
              //         actionLevel: level,
              //         targetUserID: null,
              //         socialActionType: DdnaSocialActionType.InLevelThreeCards,
              //         socialRewardType: DdnaSocialRewardType.No,
              //       },
              //     );
              //     new_life(item);
              //     popup = 0;
              //     if (buildstart == 1) {
              //       buildstart = 2;
              //     }
              //   })
              //   .catch(function (error) {
              //     if (loading_black_sprite != 0) {
              //       loading_black_sprite.destroy();
              //       loading_black_sprite = 0;
              //     }
              //     if (loading_text != 0 && loading_text != 1) {
              //       loading_text.destroy();
              //       loading_text = 0;
              //     }
              //     popup = 0;
              //   });
            }
          } else {
            consumed_3Helpercards = 1;
            context2_name = -1;
            ingameHelp_group.removeAll(true);
            popup = 2;
            if (sound_on == 1) {
              play_sound('Booster_FiveCards_Use');
            }
            let nnn = 0;
            game.time.events.repeat(
              100,
              3,
              function () {
                let card_new = game.add.sprite(
                  game.world.centerX + 1 * card_size - 100 * card_size,
                  game.world.height - 90 * card_size + 300 * card_size,
                  'game5_atlas',
                  backcards_select,
                );
                card_new.anchor.setTo(0.5, 0.5);
                game.add
                  .tween(card_new)
                  .to({ x: card_deck.x, y: card_deck.y }, 300, Phaser.Easing.Linear.None, true)
                  .onComplete.add(function (item) {
                    item.destroy();
                    cards_deck_col += 1;
                    card_text.setText(cards_deck_col - 1 - deck_n);
                    deck_change();
                  });
                nnn++;
                if (nnn == 3) {
                  popup = 0;
                }
              },
              this,
            );
          }
        }
      });
      Background.anchor.setTo(0.5);
      ingameHelp_group.add(Background);
      if (baloon == 1) bottom_game_group.add(ingameHelp_group);
      game.add.tween(Background).to({ y: '-600' }, 500, Phaser.Easing.Linear.None, true);
      if (context2_name != 0) {
        if (context2_name != game.cache.getJSON('lang')['t344_1'][0][window.lang]) {
          if (context2_avatar != 0 && game.cache.checkImageKey('context2_avatar'))
            friend_avatar = game.add.image(-85, -40, 'context2_avatar');
          else friend_avatar = game.add.image(-85, -40, 'game_atlas', 'no_avatar.png');
        } else {
          friend_avatar = game.add.sprite(-85, -40, 'game_ui_atlas', 'lover_small.png');
        }
        friend_avatar.anchor.setTo(0.5);
        friend_avatar.width = friend_avatar.height = 110;
        friend_avatar.angle = -14;
        Background.addChild(friend_avatar);
        var Friend_Frame = game.add.sprite(-85, -40, 'ingame_atlas', 'Friend_Frame.png');
        Friend_Frame.anchor.setTo(0.5);
        Background.addChild(Friend_Frame);
        var Three_Cards = game.add.sprite(85, -40, 'ingame_atlas', 'Three_Cards.png');
        Three_Cards.anchor.setTo(0.5);
        Background.addChild(Three_Cards);
        var Shines_text = game.add.text(100, -30, '+3', { font: '38px RussoOne', fill: '#fff', align: 'center' });
        Shines_text.anchor.setTo(0.5);
        Shines_text.angle = 12;
        Shines_text.stroke = '#1A6383';
        Shines_text.strokeThickness = 4;
        Shines_text.setShadow(0, 3, 'rgba(26,99,131,1)', 1);
        Background.addChild(Shines_text);
        var Shines = game.add.sprite(100, -30, 'ingame_atlas', 'Shines.png');
        Shines.anchor.setTo(0.5);
        Background.addChild(Shines);
        rotate_tween(Shines);
        var Green_Arrow = game.add.sprite(8, -10, 'ingame_atlas', 'Green_Arrow.png');
        Green_Arrow.anchor.setTo(0.5);
        Background.addChild(Green_Arrow);
        var Hat = game.add.sprite(-105, -170, 'ingame_atlas', 'Hat.png');
        Hat.anchor.setTo(0.5, 0.9);
        Hat.alpha = 0;
        Background.addChild(Hat);
        game.add
          .tween(Hat)
          .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 500)
          .onComplete.add(function (item) {
            game.add.tween(Hat).to({ y: '+100' }, 500, Phaser.Easing.Bounce.Out, true);
          });
      } else {
        var ingame_text = game.add.text(0, -40, game.cache.getJSON('lang')['t306'][0][window.lang], {
          font: '24px RussoOne',
          fill: '#fff',
          align: 'center',
        });
        ingame_text.anchor.setTo(0.5);
        ingame_text.lineSpacing = -10;
        Background.addChild(ingame_text);
      }
      var button_green = game.add.sprite(0, 65, 'ingame_atlas', 'Accept_Button.png');
      button_green.anchor.setTo(0.5);
      Background.addChild(button_green);
      if (context2_name != 0)
        var text_button_green = game.add.text(0, 2, game.cache.getJSON('lang')['t307'][0][window.lang], {
          font: '32px RussoOne',
          fill: '#fff',
          align: 'center',
        });
      else
        var text_button_green = game.add.text(0, 0, game.cache.getJSON('lang')['t308'][0][window.lang], {
          font: '26px RussoOne',
          fill: '#fff',
          align: 'center',
        });
      text_button_green.anchor.setTo(0.5);
      text_button_green.lineSpacing = -10;
      text_button_green.stroke = '#47740D';
      text_button_green.strokeThickness = 4;
      text_button_green.setShadow(0, 2, 'rgba(71,116,13,0.5)', 1);
      button_green.addChild(text_button_green);
    }
    function leaves_angle(obj, t, n1, n2) {
      game.add
        .tween(obj)
        .to({ angle: n1 }, t, Phaser.Easing.Linear.None, true)
        .onComplete.add(function (item) {
          game.add
            .tween(item)
            .to({ angle: n2 }, t, Phaser.Easing.Linear.None, true)
            .onComplete.add(function (item) {
              leaves_angle(item, t, n1, n2);
            });
        });
    }
    function buch_create(xxx, yyy, sssx, sssy, tx, ty, r, p, c, i, rnd) {
      var leaves_back = game.add.sprite(xxx, yyy, '');
      leaves_back.anchor.setTo(0.75);
      leaves_back.fixedToCamera = true;
      leaves_back.scale.setTo(sssx, sssy);
      leaves_back.angle = r;
      var leaves3 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-3.png');
      leaves3.anchor.setTo(0.75);
      leaves_back.addChild(leaves3);
      leaves3.tint = c;
      var leaves2 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-2.png');
      leaves2.anchor.setTo(0.75);
      leaves_back.addChild(leaves2);
      leaves2.tint = c;
      var leaves1 = game.add.sprite(0, 0, 'loading_atlas', 'leaves' + rnd + '-1.png');
      leaves1.anchor.setTo(0.75);
      leaves_back.addChild(leaves1);
      leaves1.tint = c;
      var flowers = game.add.sprite(0, 0, 'loading_atlas', 'flowers' + rnd + '-1.png');
      flowers.anchor.setTo(0.75);
      leaves2.addChild(flowers);
      flowers.tint = c;
      leaves3.angle = angl_mas2[0];
      leaves2.angle = angl_mas2[1];
      leaves1.angle = angl_mas2[2];
      leaves_angle(leaves3, 3000, '+2', '-2');
      leaves_angle(leaves2, 2000, '+1', '-1');
      leaves_angle(leaves1, 1000, '+0.5', '-0.5');
      game.add.tween(leaves_back.cameraOffset).to({ x: tx, y: ty }, 800, Phaser.Easing.Exponential.In, true, p + 500);
      game.add
        .tween(leaves_back)
        .to({ alpha: 1 }, 800, Phaser.Easing.Exponential.In, true, p + 500)
        .onComplete.add(function (item) {
          leaves_back.destroy(1);
        });
    }
    var graphics = game.add.graphics(0, 0);
    if (xmas == 0) {
      graphics.beginFill(0x386217);
    } else {
      graphics.beginFill(0x74ADBA);
    }
    graphics.alpha = 1;
    graphics.drawRect(0, 0, game.camera.width, game.camera.height);
    graphics.fixedToCamera = true;
    game.add.tween(graphics).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 500);
    buch_create(game.camera.width / 2 + 150, -100, -2.2, -2.2, '0', '-1000', 45, 800, 0xffffff, 0, buch_rnd);
    buch_create(
      game.camera.width / 2 - 150,
      game.camera.height + 100,
      2.2,
      2.2,
      '0',
      '+1000',
      45,
      800,
      0xffffff,
      3,
      buch_rnd,
    );
    var graphics = game.add.graphics(0, 0);
    if (xmas == 0) {
      graphics.beginFill(0x386217);
    } else {
      graphics.beginFill(0x74ADBA);
    }
    graphics.alpha = 0.5;
    graphics.drawRect(0, 0, game.camera.width, game.camera.height);
    graphics.fixedToCamera = true;
    game.add.tween(graphics).to({ alpha: 0 }, 800, Phaser.Easing.Linear.None, true, 500);
    buch_create(game.camera.width, game.camera.height, 2.2, 2.2, '+1000', '+1000', 0, 0, 0xffffff, 6, buch_rnd);
    buch_create(0, 0, -2.2, 2.2, '-1000', '-1000', 90, 0, 0xffffff, 9, buch_rnd);
    buch_create(game.camera.width, 0, 2.2, -2.2, '+1000', '-1000', 0, 400, 0xffffff, 12, buch_rnd);
    buch_create(0, game.camera.height, -2.2, -2.2, '-1000', '+1000', -90, 400, 0xffffff, 15, buch_rnd);
  },
  update: function () {
    if (suitcase_label != 0) {
      if (booster_tnt_col + booster_eye_col + booster_shuffle_col == 0) {
        suitcase_label.alpha = 0;
      } else {
        suitcase_label.alpha = 1;
        suitcase_label_text.setText(booster_tnt_col + booster_eye_col + booster_shuffle_col);
      }
    }
    if (sound_on == 0) {
      ambient.pause();
    }
    if (music_on == 0) {
      music.pause();
    }
    if (popup == 1) {
      game.world.bringToTop(popup_group);
      if (UI_Coins_BG != 0) { game.world.bringToTop(UI_Coins_BG); }
      if (Safe_Icon != 0) { game.world.bringToTop(Safe_Icon); }
      game.world.bringToTop(emitter);
      game.world.bringToTop(effects_group);
      if (message_text != 0) game.world.bringToTop(message_text);
      if (typeof loading_black_sprite !== 'undefined' && loading_black_sprite != 0) {
        game.world.bringToTop(loading_black_sprite);
      }
      if (typeof loading_text !== 'undefined' && loading_text != 0 && loading_text != 1) {
        game.world.bringToTop(loading_text);
      }
    }
    if (level > 1) {
      if (start_card_mas.length > 0) {
        if (booster5_c == 0) {
          booster5.loadTexture('game_atlas', 'booster_3_prev.png', 1);
          booster5_c = 1;
        }
      } else {
        if (booster5_c == 1) {
          booster5.loadTexture('game_atlas', 'booster_3_prev_off.png', 1);
          booster5_c = 0;
        }
      }
    }
    if (prize_wheel_arrow != 0) {
      if (prize_wheel_arrow.angle > 160 || prize_wheel_arrow.angle < -160) {
        if (bright_area.angle != 135) {
          bright_area.angle = -225;
          if (sound_on == 1) {
            play_sound('Prizewheel_Spin');
          }
        }
      }
      if (prize_wheel_arrow.angle > -10 && prize_wheel_arrow.angle < 10) {
        bright_area.angle = -45;
      }
      if (prize_wheel_arrow.angle > -152 && prize_wheel_arrow.angle < -115) {
        if (bright_area.angle != -180) {
          bright_area.angle = -180;
          if (sound_on == 1) {
            play_sound('Prizewheel_Spin');
          }
        }
      }
      if (prize_wheel_arrow.angle > bright_area.angle + 70 && prize_wheel_arrow.angle >= 0) {
        if (sound_on == 1) {
          play_sound('Prizewheel_Spin');
        }
        bright_area.angle += 45;
      } else if (prize_wheel_arrow.angle > bright_area.angle + 70 && prize_wheel_arrow.angle < 0) {
        if (sound_on == 1) {
          play_sound('Prizewheel_Spin');
        }
        bright_area.angle += 45;
      }
    }
  },
};

setInterval(function () {
  if (!document.hasFocus()) {
    if (loading_text == 1 || loading_complete == 0) {
      window.focus();
      loading_text = 0;
    }
  }
}, 500);

export function getReachedLevel() {
  return all_level.lastIndexOf(3) + 2;
}

// function logStoreValues(str) {
//   var obj = {
//     "all_chests": all_chests,
//     "all_friends_invite": all_friends_invite,
//     "all_stars": all_stars,
//     "backcards": backcards,
//     "backcards_select": backcards_select,
//     "baloonDate": baloonDate,
//     "baloonDate_new": baloonDate_new,
//     "baloonlevel": baloonlevel,
//     "booster_eye_col": booster_eye_col,
//     "booster_shuffle_col": booster_shuffle_col,
//     "booster_timestop_col": booster_timestop_col,
//     "booster_tnt_col": booster_tnt_col,
//     "botopt": botopt,
//     "bought": bought,
//     // "builds_timer": builds_timer | null,
//     // "builds_timer_obj": builds_timer_obj | null,
//     // "builds_timer_time": builds_timer_time | null,
//     // "complete_task_i": complete_task_i | null,
//     "currencies": coins,
//     "dailyday": dailyday,
//     "dailyday_current": dailyday_current,
//     "dailyday_new": dailyday_new,
//     "dailyday_prize": dailyday_prize,
//     "day_prize": day_prize,
//     "dialog_mas": dialog_mas,
//     "fff": fff,
//     "first_helper": first_helper,
//     "first_start": first_start,
//     "free_cardback": free_cardback,
//     "free_joker": free_joker,
//     "free_three": free_three,
//     "FriendPrizeDate": FriendPrizeDate,
//     "friends_invite": friends_invite,
//     "FTUE": FTUE,
//     "FTUEEVENTS": FTUEEVENTS,
//     "GiftDate": GiftDate,
//     "gift_mas": gift_mas,
//     "KeyMissionPrize": KeyMissionPrize,
//     "keys": keys,
//     // "key_mission_time": key_mission_time | null,
//     "last_position": last_position,
//     // "level_star": level_star | null,
//     "lifes": lifes,
//     "lifetime": lifetime,
//     // "life_time": life_time | null,
//     "map_n": map_n,
//     "map_tiled_st": map_tiled_st,
//     "message_id": message_id,
//     "missions": missions,
//     "mission_day_end": mission_day_end,
//     "mission_number": mission_number,
//     "mission_stars_end": mission_stars_end,
//     "mission_task": mission_task,
//     // "mission_time": mission_time | null,
//     // "new_roof": new_roof | null,
//     // "new_walls": new_walls | null,
//     "OfferDate": OfferDate,
//     "ReferralDate": ReferralDate,
//     "shop_free": shop_free,
//     // "shop_time": shop_time | null,
//     "special_object": special_object,
//     "starter_kit": starter_kit,
//     "suitcase_add": suitcase_add,
//     "unlimited_lifesDate": unlimited_lifesDate,
//     "wheelshopDate": wheelshopDate,
//     "wheel_ads": wheel_ads,
//     "wheel_max": wheel_max,
//     "wheel_num": wheel_num,
//     // "wheel_time": wheel_time | null,
//     "music_on": music_on,
//     "sound_on": sound_on,
//     // "sessionId": sessionId | null,
//     // "coinsSpentImprovingGarden": coinsSpentImprovingGarden | null,
//     // "starsUsed": starsUsed | null,
//     // "gardenImprovements": gardenImprovements | null,
//     // "interactedFriends": interactedFriends | null,
//     "free_prebooster1": free_prebooster1,
//     "free_prebooster2": free_prebooster2,
//     "free_prebooster3": free_prebooster3,
//     "weekday_offers": weekday_offers,
//     "JQKA_offers": JQKA_offers,
//     "mis_n": mis_n,
//     "mis_coins": mis_coins,
//     "misDate": misDate,
//     "playadDate": playadDate,
//     "playad_col": playad_col,
//     "xmas_level": xmas_level,
//     "xmas_ticket": xmas_ticket,
//     "retriesIteration": retriesIteration,
//     "offer_mas": offer_mas,
//     "friend_invite": friend_invite,
//     "free_five": free_five,
//     "free_booster_spec": free_booster_spec,
//     "unlimited_lifesDate_old": unlimited_lifesDate_old,
//     "sunflowerDate": sunflowerDate,
//     "xmasDate": xmasDate,
//     "sunflowerDate_new": sunflowerDate_new,
//     "sunflowerStage": sunflowerStage,
//     "numFriendsInvited": numFriendsInvited,
//     "magicbeanStage": magicbeanStage,
//     "magicbeanDate": magicbeanDate,
//     "magicbeanDate_new": magicbeanDate_new,
//     "wheeladsDate": wheeladsDate,
//     "new_options": new_options,
//     "weekday_offersDate": weekday_offersDate,
//   };
//   console.log(">>> STORE VALUES", str, "<<<");
//   console.log(JSON.stringify(obj));
// }

window.startGame = () => { initGame(); };
